var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f33"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f33"] = parcelRequire;
}
parcelRequire.register("fFTr1", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRequire.register("kzGqM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $efa7fd707211b5be$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$efa7fd707211b5be$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($efa7fd707211b5be$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $efa7fd707211b5be$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRequire.register("kWD7b", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $f3f790d06fe816e6$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $f3f790d06fe816e6$var$map($f3f790d06fe816e6$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(k)) + eq;
        if ($f3f790d06fe816e6$var$isArray(obj[k])) return $f3f790d06fe816e6$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(name)) + eq + encodeURIComponent($f3f790d06fe816e6$var$stringifyPrimitive(obj));
};
var $f3f790d06fe816e6$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $f3f790d06fe816e6$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $f3f790d06fe816e6$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});

parcelRequire.register("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRequire.register("824SG", function(module, exports) {
"use strict";
var $5d924be287ea1eb0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Instance = void 0;

var $5ERau = parcelRequire("5ERau");

const $5d924be287ea1eb0$var$LocalState_1 = $5d924be287ea1eb0$var$__importDefault((parcelRequire("7wzgu")));

var $a1Glk = parcelRequire("a1Glk");

var $dnI4a = parcelRequire("dnI4a");

const $5d924be287ea1eb0$var$EntityCache_1 = $5d924be287ea1eb0$var$__importDefault((parcelRequire("7tINK")));

const $5d924be287ea1eb0$var$createSnapshotBufferRefactor_1 = $5d924be287ea1eb0$var$__importDefault((parcelRequire("lq3JV")));

const $5d924be287ea1eb0$var$NQueue_1 = $5d924be287ea1eb0$var$__importDefault((parcelRequire("cWtoF")));
class $5d924be287ea1eb0$var$Instance {
    constructor(context){
        this.context = context;
        this.localState = new $5d924be287ea1eb0$var$LocalState_1.default();
        this.channelId = 1;
        this.channels = new Set();
        this.users = new Map();
        this.queue = new $5d924be287ea1eb0$var$NQueue_1.default();
        this.incrementalUserId = 0;
        this.cache = new $5d924be287ea1eb0$var$EntityCache_1.default();
        this.tick = 1;
        this.responseEndPoints = new Map();
        this.onConnect = (handshake)=>{
            return new Promise((resolve, reject)=>{
                console.log("Please define an instance.onConnect handler that returns a Promise<boolean>. Connection denied.");
                resolve(false);
            });
        };
        this.network = new $a1Glk.InstanceNetwork(this);
    }
    attachEntity(parentNid, child) {
        this.localState.addChild(parentNid, child);
    }
    detachEntity(parentNid, child) {
        this.localState.removeChild(parentNid, child);
    }
    respond(endpoint, callback) {
        this.responseEndPoints.set(endpoint, callback);
    }
    createChannel() {
        const channel = new $5ERau.Channel(this.localState, this.channelId++);
        this.channels.add(channel);
        return channel;
    }
    createSpatialChannel() {
        const channel = new $dnI4a.SpatialChannel(this.localState, this.channelId++);
        this.channels.add(channel);
        return channel;
    }
    step() {
        this.tick++;
        this.cache.createCachesForTick(this.tick);
        this.users.forEach((user)=>{
            // TODO aggregate visible entities and messages
            // demo is instead just sending message from a channel
            const buffer = (0, $5d924be287ea1eb0$var$createSnapshotBufferRefactor_1.default)(user, this);
            user.send(buffer);
        });
        this.cache.deleteCachesForTick(this.tick);
    }
}
module.exports.Instance = $5d924be287ea1eb0$var$Instance;

});
parcelRequire.register("5ERau", function(module, exports) {
"use strict";
var $41e9ee4c3506b397$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Channel = void 0;

const $41e9ee4c3506b397$var$EDictionary_1 = $41e9ee4c3506b397$var$__importDefault((parcelRequire("eVskb")));
class $41e9ee4c3506b397$var$Channel {
    constructor(localState, id){
        this.id = id;
        this.localState = localState;
        this.entities = new $41e9ee4c3506b397$var$EDictionary_1.default();
        this.users = new Map();
        this.destroyed = false;
    }
    addEntity(entity) {
        // TODO
        //if (!entity.protocol) {
        //    throw new Error('Object is missing a protocol or protocol was not supplied via config.')
        //}
        this.localState.registerEntity(entity, this.id);
        this.entities.add(entity);
        //console.log('added', entity)
        return entity;
    }
    removeEntity(entity) {
        //console.log('channel removeEntity', entity[this.config.ID_PROPERTY_NAME])
        this.entities.remove(entity);
        this.localState.unregisterEntity(entity, this.id);
    }
    addMessage(message) {
        //console.log('channel addMessage', message)
        //message[this.config.TYPE_PROPERTY_NAME] = this.instance.protocols.getIndex(message.protocol)
        this.users.forEach((user)=>{
            user.queueMessage(message);
        });
    }
    // TODO
    subscribe(user) {
        this.users.set(user.id, user);
        user.subscribe(this);
    }
    // TODO
    unsubscribe(user) {
        this.users.delete(user);
        user.unsubscribe(this);
    }
    getVisible(userId) {
        const visibleNids = [];
        this.entities.forEach((entity)=>{
            visibleNids.push(entity.nid);
        });
        return visibleNids;
    }
    destroy() {
        this.users.forEach((user)=>this.unsubscribe(user));
        this.entities.forEach((entity)=>this.removeEntity(entity));
        //this.instance.channels.remove(this)
        this.destroyed = true;
    //this.instance.channelCount--
    }
}
module.exports.Channel = $41e9ee4c3506b397$var$Channel;

});
parcelRequire.register("eVskb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $addc5c3bf4d386b4$var$EDictionary {
    constructor(){
        this.object = {};
        this.array = [];
    }
    get size() {
        return this.array.length;
    }
    get(nid) {
        var obj = this.object[nid];
        if (typeof obj !== "undefined") return this.object[nid];
        return null;
    }
    forEach(fn) {
        for(let i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
    toArray() {
        return this.array;
    }
    add(obj) {
        if (typeof obj === "object" && typeof obj.nid !== "undefined") {
            this.object[obj.nid] = obj;
            this.array.push(obj);
        } else throw new Error("EDictionary could not add object, invalid object or object.id.");
    }
    remove(obj) {
        if (typeof obj === "object" && typeof obj.nid !== "undefined") return this.removeById(obj.nid);
    }
    removeById(id) {
        if (typeof id !== "undefined") {
            var index = -1;
            for(var i = 0; i < this.array.length; i++)if (this.array[i].nid === id) {
                index = i;
                break;
            }
            if (index !== -1) this.array.splice(index, 1);
            var temp = this.object[id];
            delete this.object[id];
            return temp;
        }
    }
}
module.exports.default = $addc5c3bf4d386b4$var$EDictionary;

});


parcelRequire.register("7wzgu", function(module, exports) {
"use strict";
var $57a6e0759c3220e5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $57a6e0759c3220e5$var$EDictionary_1 = $57a6e0759c3220e5$var$__importDefault((parcelRequire("eVskb")));

const $57a6e0759c3220e5$var$IdPool_1 = $57a6e0759c3220e5$var$__importDefault((parcelRequire("lK1RY")));
class $57a6e0759c3220e5$var$LocalState {
    constructor(){
        this.idPool = new $57a6e0759c3220e5$var$IdPool_1.default(65535); // TODO pick a real pool size
        this.sources = new Map();
        this.parents = new Map();
        this._entities = new $57a6e0759c3220e5$var$EDictionary_1.default();
    }
    addChild(parentNid, child) {
        let cnid = this.registerEntity(child, parentNid);
        if (!this.parents.get(parentNid)) this.parents.set(parentNid, new Set());
        this.parents.get(parentNid).add(cnid);
    }
    removeChild(parentNid, child) {
        var _a;
        const cnid = child.nid;
        (_a = this.parents.get(parentNid)) === null || _a === void 0 || _a.delete(cnid);
        this.unregisterEntity(child, parentNid);
    }
    registerEntity(entity, sourceId) {
        let nid = entity.nid;
        if (!this.sources.has(nid)) {
            nid = this.idPool.nextId();
            entity.nid = nid;
            this.sources.set(nid, new Set());
            this._entities.add(entity);
        }
        const entitySources = this.sources.get(nid);
        entitySources.add(sourceId);
        return nid;
    }
    unregisterEntity(entity, sourceId) {
        const nid = entity.nid;
        const entitySources = this.sources.get(nid);
        entitySources.delete(sourceId);
        if (entitySources.size === 0) {
            this.sources.delete(nid);
            this._entities.remove(entity);
            this.idPool.returnId(nid);
            entity.nid = 0;
        }
    }
    getByNid(nid) {
        return this._entities.get(nid);
    }
}
module.exports.default = $57a6e0759c3220e5$var$LocalState;

});
parcelRequire.register("lK1RY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $fd3f58142619525a$var$IdPool {
    constructor(max){
        this.min = 1;
        this.max = max;
        this.ids = new Set();
        this.current = this.min - 1;
    }
    nextId() {
        if (this.ids.size >= this.max) throw new Error("IdPool overflow");
        this.current++;
        if (this.current > this.max) this.current = this.min;
        if (!this.ids.has(this.current)) {
            this.ids.add(this.current);
            return this.current;
        } else return this.nextId();
    }
    returnId(id) {
        this.ids.delete(id);
    }
}
module.exports.default = $fd3f58142619525a$var$IdPool;

});


parcelRequire.register("a1Glk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $74cad7d406118054$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $74cad7d406118054$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $74cad7d406118054$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InstanceNetwork = void 0;

var $ezF4f = parcelRequire("ezF4f");

var $ajywS = parcelRequire("ajywS");

var $ahX3I = parcelRequire("ahX3I");

var $8QdZd = parcelRequire("8QdZd");

const $74cad7d406118054$var$readEngineMessage_1 = $74cad7d406118054$var$__importDefault((parcelRequire("9Haao")));

const $74cad7d406118054$var$readMessage_1 = $74cad7d406118054$var$__importDefault((parcelRequire("7y0qA")));
class $74cad7d406118054$var$InstanceNetwork {
    constructor(instance){
        this.instance = instance;
    }
    onRequest() {
    // TODO
    }
    onOpen(user) {
        try {
            user.connectionState = $ajywS.UserConnectionState.OpenPreHandshake;
            user.network = this;
        } catch (e) {
            console.log("error in onCommand. ignoring as its likely the stupid hacker. disconnecting them", e);
            user.disconnect("invalid");
        }
    }
    onCommand(user, command) {
        try {
            this.instance.queue.enqueue({
                type: $ezF4f.NetworkEvent.Command,
                user: user,
                command: command
            });
        } catch (e) {
            console.log("error in onCommand. ignoring as its likely the stupid hacker. disconnecting them", e);
            user.disconnect("invalid");
        }
    }
    onHandshake(user, handshake) {
        return $74cad7d406118054$var$__awaiter(this, void 0, void 0, function*() {
            try {
                try {
                    user.connectionState = $ajywS.UserConnectionState.OpenAwaitingHandshake;
                    const connectionAccepted = yield this.instance.onConnect(handshake);
                    // @ts-ignore ts is wrong that this is always false; the value can change during the
                    // above await
                    if (user.connectionState === $ajywS.UserConnectionState.Closed) throw new Error("Connection closed before handshake completed.");
                    user.connectionState = $ajywS.UserConnectionState.Open;
                    // allow
                    const bw = user.networkAdapter.createBufferWriter(3);
                    bw.writeUInt8($ahX3I.BinarySection.EngineMessages);
                    bw.writeUInt8(1);
                    bw.writeUInt8($8QdZd.EngineMessage.ConnectionAccepted);
                    user.send(bw.buffer);
                    user.instance = this.instance;
                    this.onConnectionAccepted(user, connectionAccepted);
                } catch (err) {
                    //console.log('Handshake catch block', { err, ws: user.socket, foo: user.connectionState })
                    this.onConnectionDenied(user, err);
                    // NOTE: we are keeping the code between these cases duplicated
                    // if these do turn out to be identical in production we will clean it up
                    // but for now I am suspicious that there will be different logic
                    // in each of these later
                    if (user.connectionState === $ajywS.UserConnectionState.OpenAwaitingHandshake) {
                        // developer's code decided to reject this connection (rejected promise)
                        const jsonErr = JSON.stringify(err);
                        const denyReasonByteLength = $74cad7d406118054$require$Buffer.byteLength(jsonErr, "utf8");
                        // deny and send reason
                        const bw = user.networkAdapter.createBufferWriter(7 /* string length 32 bits */  + denyReasonByteLength /* length of actual string*/ );
                        //binaryWriterCtor.create(3 + 4 /* string length 32 bits */ + denyReasonByteLength /* length of actual string*/)
                        bw.writeUInt8($ahX3I.BinarySection.EngineMessages);
                        bw.writeUInt8(1);
                        bw.writeUInt8($8QdZd.EngineMessage.ConnectionDenied);
                        bw.writeString(jsonErr);
                        user.send(bw.buffer);
                    }
                    if (user.connectionState === $ajywS.UserConnectionState.Open) {
                        // a loss of connection after handshake is complete
                        const jsonErr = JSON.stringify(err);
                        const denyReasonByteLength = $74cad7d406118054$require$Buffer.byteLength(jsonErr, "utf8");
                        // deny and send reason
                        // @ts-ignore
                        const bw = user.networkAdapter.createBufferWriter(7 /* string length 32 bits */  + denyReasonByteLength /* length of actual string*/ );
                        bw.writeUInt8($ahX3I.BinarySection.EngineMessages);
                        bw.writeUInt8(1);
                        bw.writeUInt8($8QdZd.EngineMessage.ConnectionDenied);
                        bw.writeString(jsonErr);
                        user.send(bw.buffer);
                    }
                }
            } catch (e) {
                console.log("error in onHandshake. ignoring as its likely the stupid hacker. disconnecting them", e);
                user.disconnect("invalid");
            }
        });
    }
    onMessage(user, buffer) {
        try {
            const binaryReader = user.networkAdapter.createBufferReader(buffer);
            while(binaryReader.offset < binaryReader.byteLength){
                const section = binaryReader.readUInt8();
                switch(section){
                    case $ahX3I.BinarySection.EngineMessages:
                        {
                            const count = binaryReader.readUInt8();
                            for(let i = 0; i < count; i++){
                                const type = binaryReader.readUInt8();
                                if (type === $8QdZd.EngineMessage.ConnectionAttempt) {
                                    const msg = (0, $74cad7d406118054$var$readEngineMessage_1.default)(binaryReader, this.instance.context);
                                    const handshake = JSON.parse(msg.handshake);
                                    this.onHandshake(user, handshake);
                                }
                            }
                            break;
                        }
                    case $ahX3I.BinarySection.Commands:
                        {
                            const count = binaryReader.readUInt8();
                            for(let i = 0; i < count; i++){
                                const msg = (0, $74cad7d406118054$var$readMessage_1.default)(binaryReader, this.instance.context);
                                this.onCommand(user, msg);
                            }
                            break;
                        }
                    case $ahX3I.BinarySection.Requests:
                        {
                            const count = binaryReader.readUInt8();
                            for(let i = 0; i < count; i++){
                                const requestId = binaryReader.readUInt32();
                                const endpoint = binaryReader.readUInt32();
                                const str = binaryReader.readString();
                                const body = JSON.parse(str);
                                const cb = this.instance.responseEndPoints.get(endpoint);
                                if (cb) cb({
                                    user: user,
                                    body: body
                                }, (response)=>{
                                    console.log("supposed to response with", response);
                                    user.responseQueue.push({
                                        requestId: requestId,
                                        response: JSON.stringify(response)
                                    });
                                });
                            }
                            break;
                        }
                    default:
                        console.log("network hit default case while reading; likely the hacker");
                        user.disconnect("invalid");
                        break;
                }
            }
        } catch (e) {
            console.log("error in onMessage. ignoring as its likely the stupid hacker. disconnecting them", e);
            user.disconnect("invalid");
        }
    }
    onConnectionAccepted(user, payload) {
        try {
            user.network = this;
            user.id = ++this.instance.incrementalUserId;
            this.instance.users.set(user.id, user);
            this.instance.queue.enqueue({
                type: $ezF4f.NetworkEvent.UserConnected,
                user: user,
                payload: payload
            });
        } catch (e) {
            console.log("error in onConnectionAccepted. ignoring as its likely the stupid hacker. disconnecting them", e);
            user.disconnect("invalid");
        }
    }
    onConnectionDenied(user, payload) {
        try {
            this.instance.queue.enqueue({
                type: $ezF4f.NetworkEvent.UserConnectionDenied,
                user: user,
                payload: payload
            });
        } catch (e) {
            console.log("error in onConnectionDenied. ignoring as its likely the stupid hacker. disconnecting them", e);
            user.disconnect("invalid");
        }
    }
    onClose(user) {
        try {
            if (user.connectionState === $ajywS.UserConnectionState.Open) {
                this.instance.queue.enqueue({
                    type: $ezF4f.NetworkEvent.UserDisconnected,
                    user: user
                });
                this.instance.users.delete(user.id);
            }
            user.connectionState = $ajywS.UserConnectionState.Closed;
        } catch (e) {
            console.log("error in onClose. ignoring as its likely the stupid hacker. disconnecting them", e);
            user.disconnect("invalid");
        }
    }
}
module.exports.InstanceNetwork = $74cad7d406118054$var$InstanceNetwork;

});
parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("ezF4f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkEvent = void 0;
var $a9c430b7a98c0717$var$NetworkEvent;
(function(NetworkEvent) {
    NetworkEvent[NetworkEvent["Null"] = 0] = "Null";
    NetworkEvent[NetworkEvent["UserConnected"] = 1] = "UserConnected";
    NetworkEvent[NetworkEvent["Command"] = 2] = "Command";
    NetworkEvent[NetworkEvent["UserDisconnected"] = 3] = "UserDisconnected";
    NetworkEvent[NetworkEvent["UserConnectionDenied"] = 4] = "UserConnectionDenied";
})($a9c430b7a98c0717$var$NetworkEvent || ($a9c430b7a98c0717$var$NetworkEvent = {}));
module.exports.NetworkEvent = $a9c430b7a98c0717$var$NetworkEvent;

});

parcelRequire.register("ajywS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UserConnectionState = module.exports.User = void 0;
var $7826768bec286852$var$UserConnectionState;
(function(UserConnectionState) {
    UserConnectionState[UserConnectionState["NULL"] = 0] = "NULL";
    UserConnectionState[UserConnectionState["OpenPreHandshake"] = 1] = "OpenPreHandshake";
    UserConnectionState[UserConnectionState["OpenAwaitingHandshake"] = 2] = "OpenAwaitingHandshake";
    UserConnectionState[UserConnectionState["Open"] = 3] = "Open";
    UserConnectionState[UserConnectionState["Closed"] = 4] = "Closed";
})($7826768bec286852$var$UserConnectionState || ($7826768bec286852$var$UserConnectionState = {}));
module.exports.UserConnectionState = $7826768bec286852$var$UserConnectionState;
class $7826768bec286852$var$User {
    constructor(socket, networkAdapter){
        this.id = 0;
        this.socket = socket;
        this.instance = null;
        this.networkAdapter = networkAdapter;
        this.network = null;
        this.remoteAddress = null;
        this.connectionState = $7826768bec286852$var$UserConnectionState.NULL;
        this.subscriptions = new Map();
        this.engineMessageQueue = [];
        this.messageQueue = [];
        this.responseQueue = [];
        this.cache = {};
        this.cacheArr = [];
    }
    subscribe(channel) {
        this.subscriptions.set(channel.id, channel);
    }
    unsubscribe(channel) {
        this.subscriptions.delete(channel.id);
    }
    queueEngineMessage(engineMessage) {
        this.engineMessageQueue.push(engineMessage);
    }
    queueMessage(message) {
        this.messageQueue.push(message);
    }
    createOrUpdate(id, tick, toCreate, toUpdate) {
        if (!this.cache[id]) {
            //console.log('create push', id)
            toCreate.push(id);
            this.cache[id] = tick;
            this.cacheArr.push(id);
        } else {
            this.cache[id] = tick;
            toUpdate.push(id);
        }
        const children = this.instance.localState.parents.get(id);
        if (children) children.forEach((id)=>this.createOrUpdate(id, tick, toCreate, toUpdate));
    }
    send(buffer) {
        this.networkAdapter.send(this, buffer);
    }
    disconnect(reason) {
        try {
            this.networkAdapter.disconnect(this, reason);
        } catch (e) {
            console.log("error in disconnect. ignoring as its likely the stupid hacker", e);
        }
    }
    checkVisibility(tick) {
        const toCreate = [];
        const toUpdate = [];
        const toDelete = [];
        this.subscriptions.forEach((channel)=>{
            channel.getVisible(this.id).forEach((nid)=>{
                this.createOrUpdate(nid, tick, toCreate, toUpdate);
            });
        });
        for(let i = this.cacheArr.length - 1; i > -1; i--){
            const id = this.cacheArr[i];
            if (this.cache[id] !== tick) {
                //console.log('delete', id)
                toDelete.push(id);
                this.cache[id] = 0;
                //delete this.cache[id]
                this.cacheArr.splice(i, 1);
            }
        }
        return {
            //events: nearby.events,
            noLongerVisible: toDelete,
            stillVisible: toUpdate,
            newlyVisible: toCreate
        };
    }
}
module.exports.User = $7826768bec286852$var$User;

});

parcelRequire.register("ahX3I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BinarySection = void 0;
var $77d94dc5eaf6fb43$var$BinarySection;
(function(BinarySection) {
    BinarySection[BinarySection["Null"] = 0] = "Null";
    BinarySection[BinarySection["EngineMessages"] = 1] = "EngineMessages";
    BinarySection[BinarySection["CreateEntities"] = 2] = "CreateEntities";
    BinarySection[BinarySection["UpdateEntities"] = 3] = "UpdateEntities";
    BinarySection[BinarySection["DeleteEntities"] = 4] = "DeleteEntities";
    BinarySection[BinarySection["Messages"] = 5] = "Messages";
    BinarySection[BinarySection["Commands"] = 6] = "Commands";
    BinarySection[BinarySection["Requests"] = 7] = "Requests";
    BinarySection[BinarySection["Responses"] = 8] = "Responses";
})($77d94dc5eaf6fb43$var$BinarySection || ($77d94dc5eaf6fb43$var$BinarySection = {}));
module.exports.BinarySection = $77d94dc5eaf6fb43$var$BinarySection;

});

parcelRequire.register("8QdZd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EngineMessage = void 0;
var $66fe07793dc33183$var$EngineMessage;
(function(EngineMessage) {
    EngineMessage[EngineMessage["Null"] = 0] = "Null";
    EngineMessage[EngineMessage["ConnectionAccepted"] = 1] = "ConnectionAccepted";
    EngineMessage[EngineMessage["ConnectionDenied"] = 2] = "ConnectionDenied";
    EngineMessage[EngineMessage["ConnectionAttempt"] = 3] = "ConnectionAttempt";
    EngineMessage[EngineMessage["Foo"] = 4] = "Foo";
    EngineMessage[EngineMessage["ChannelJoin"] = 5] = "ChannelJoin";
    EngineMessage[EngineMessage["ChannelLeave"] = 6] = "ChannelLeave";
    EngineMessage[EngineMessage["ChannelAddEntity"] = 7] = "ChannelAddEntity";
    EngineMessage[EngineMessage["ChannelRemoveEntity"] = 8] = "ChannelRemoveEntity";
    EngineMessage[EngineMessage["ConnectionTerminated"] = 9] = "ConnectionTerminated";
})($66fe07793dc33183$var$EngineMessage || ($66fe07793dc33183$var$EngineMessage = {}));
module.exports.EngineMessage = $66fe07793dc33183$var$EngineMessage;

});

parcelRequire.register("9Haao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $99SoP = parcelRequire("99SoP");
function $70f004157cbc4d37$var$readEngineMessage(reader, context) {
    //console.log('entered readMEssage')
    const ntype = reader.readUInt8();
    const nschema = context.getEngineSchema(ntype);
    const obj = {
        ntype: ntype
    };
    for(let i = 1; i < nschema.keys.length; i++){
        const propData = nschema.keys[i];
        const binaryUtil = (0, $99SoP.binaryGet)(propData.type);
        // @ts-ignore
        obj[propData.prop] = binaryUtil.read(reader);
    }
    return obj;
}
module.exports.default = $70f004157cbc4d37$var$readEngineMessage;

});
parcelRequire.register("99SoP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6aaf26ec504846ef$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.declareBinaryType = module.exports.binaryGet = void 0;

var $cPwLs = parcelRequire("cPwLs");
function $6aaf26ec504846ef$var$countByteArray(value) {
    return value.length + 4;
}
function $6aaf26ec504846ef$var$count2ByteArray(value) {
    return value.length * 2 + 4;
}
function $6aaf26ec504846ef$var$count4ByteArray(value) {
    return value.length * 4 + 4;
}
function $6aaf26ec504846ef$var$count8ByteArray(value) {
    return value.length * 8 + 4;
}
function $6aaf26ec504846ef$var$stringByteLength(str) {
    if (typeof $6aaf26ec504846ef$require$Buffer !== "undefined") return $6aaf26ec504846ef$require$Buffer.byteLength(str, "utf8");
    else return new Blob([
        str
    ]).size;
}
function $6aaf26ec504846ef$var$countString(value) {
    const length = $6aaf26ec504846ef$var$stringByteLength(value);
    return length + 4;
}
const $6aaf26ec504846ef$var$data = new Map();
const $6aaf26ec504846ef$var$lerp = function(a, b, t) {
    return a + (b - a) * t;
};
const $6aaf26ec504846ef$var$lerpRot = function(a, b, t) {
    const s = (1 - t) * Math.sin(a) + t * Math.sin(b);
    const c = (1 - t) * Math.cos(a) + t * Math.cos(b);
    return Math.atan2(s, c);
};
function $6aaf26ec504846ef$var$declareBinaryType(binaryIndex, spec) {
    const { write: write , read: read , byteSize: byteSize , compare: compare , pre: pre , post: post , interp: interp , clone: clone  } = spec;
    if (!write) throw new Error("A custom binary type was declared with no write function. Please declare a function write(value: T, bw: IBinaryWirter) => void that writes your custom binary type to an IBinaryWriter.");
    if (!read) throw new Error("A custom binary type was declared with no read function. Please declare a function (readbr: IBinaryReader) => T that reads your custom binary tpe from an IBinaryReader.");
    if (!byteSize) throw new Error("A custom binary type was declared with no byteSize function. Please declare a function byteSize(a: T) => number that returns the byte size of your value.");
    if (!compare) throw new Error("A custom binary type was declared with no compare function. Please declare a function compare(a: T, b: T) => boolean that can compare two values of your binary type.");
    $6aaf26ec504846ef$var$data.set(binaryIndex, {
        write: write,
        read: read,
        byteSize: byteSize,
        compare: compare,
        // use the pre function or create a function that returns the value unchanged
        pre: pre ? pre : (value)=>{
            return value;
        },
        // use the post function or create a function that returns the value unchanged
        post: post ? post : (value)=>{
            return value;
        },
        // use the interp function or create a function that returns the most recent value uninterpolated
        interp: interp ? interp : (a, b, t)=>{
            return b;
        },
        clone: clone ? clone : (value)=>{
            return value;
        }
    });
}
module.exports.declareBinaryType = $6aaf26ec504846ef$var$declareBinaryType;
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.UInt8, {
    write: (value, bw)=>{
        bw.writeUInt8(value);
    },
    read: (br)=>{
        return br.readUInt8();
    },
    byteSize: ()=>{
        return 1;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Int8, {
    write: (value, bw)=>{
        bw.writeInt8(value);
    },
    read: (br)=>{
        return br.readInt8();
    },
    byteSize: ()=>{
        return 1;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.UInt16, {
    write: (value, bw)=>{
        bw.writeUInt16(value);
    },
    read: (br)=>{
        return br.readUInt16();
    },
    byteSize: ()=>{
        return 2;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Int16, {
    write: (value, bw)=>{
        bw.writeInt16(value);
    },
    read: (br)=>{
        return br.readInt16();
    },
    byteSize: ()=>{
        return 2;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.UInt32, {
    write: (value, bw)=>{
        bw.writeUInt32(value);
    },
    read: (br)=>{
        return br.readUInt32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Int32, {
    write: (value, bw)=>{
        bw.writeInt32(value);
    },
    read: (br)=>{
        return br.readInt32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Float32, {
    write: (value, bw)=>{
        bw.writeFloat32(value);
    },
    read: (br)=>{
        return br.readFloat32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Float64, {
    write: (value, bw)=>{
        bw.writeFloat64(value);
    },
    read: (br)=>{
        return br.readFloat64();
    },
    byteSize: ()=>{
        return 8;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerp
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Rotation, {
    write: (value, bw)=>{
        bw.writeFloat64(value);
    },
    read: (br)=>{
        return br.readFloat64();
    },
    byteSize: ()=>{
        return 8;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerpRot
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Rotation32, {
    write: (value, bw)=>{
        bw.writeFloat32(value);
    },
    read: (br)=>{
        return br.readFloat32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $6aaf26ec504846ef$var$lerpRot
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.String, {
    write: (value, bw)=>{
        bw.writeString(value);
    },
    read: (br)=>{
        return br.readString();
    },
    byteSize: $6aaf26ec504846ef$var$countString,
    compare: (a, b)=>{
        return a === b;
    }
});
function $6aaf26ec504846ef$var$compareTypedArray(a, b) {
    if (a.length !== b.length) return false;
    for(let i = a.length; -1 < i; i -= 1){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.UInt8Array, {
    write: (value, bw)=>{
        bw.writeUInt8Array(value);
    },
    read: (br)=>{
        return br.readUInt8Array();
    },
    byteSize: $6aaf26ec504846ef$var$countByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Int8Array, {
    write: (value, bw)=>{
        bw.writeInt8Array(value);
    },
    read: (br)=>{
        return br.readInt8Array();
    },
    byteSize: $6aaf26ec504846ef$var$countByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.UInt16Array, {
    write: (value, bw)=>{
        bw.writeUInt16Array(value);
    },
    read: (br)=>{
        return br.readUInt16Array();
    },
    byteSize: $6aaf26ec504846ef$var$count2ByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Int16Array, {
    write: (value, bw)=>{
        bw.writeInt16Array(value);
    },
    read: (br)=>{
        return br.readInt16Array();
    },
    byteSize: $6aaf26ec504846ef$var$count2ByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.UInt32Array, {
    write: (value, bw)=>{
        bw.writeUInt32Array(value);
    },
    read: (br)=>{
        return br.readUInt32Array();
    },
    byteSize: $6aaf26ec504846ef$var$count4ByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Int32Array, {
    write: (value, bw)=>{
        bw.writeInt32Array(value);
    },
    read: (br)=>{
        return br.readInt32Array();
    },
    byteSize: $6aaf26ec504846ef$var$count4ByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Float32Array, {
    write: (value, bw)=>{
        bw.writeFloat32Array(value);
    },
    read: (br)=>{
        return br.readFloat32Array();
    },
    byteSize: $6aaf26ec504846ef$var$count4ByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Float64Array, {
    write: (value, bw)=>{
        bw.writeFloat64Array(value);
    },
    read: (br)=>{
        return br.readFloat64Array();
    },
    byteSize: $6aaf26ec504846ef$var$count8ByteArray,
    compare: $6aaf26ec504846ef$var$compareTypedArray
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Boolean, {
    write: (value, bw)=>{
        bw.writeUInt8(value);
    },
    read: (br)=>{
        return 1 === br.readUInt8();
    },
    byteSize: ()=>{
        return 1;
    },
    compare: (a, b)=>{
        return a === b;
    }
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Vector2, {
    write: (value, bw)=>{
        const { x: x , y: y  } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        return {
            x: x,
            y: y
        };
    },
    byteSize: (value)=>{
        return 16; // that's 2 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y;
    },
    interp: (a, b, t)=>{
        return {
            x: $6aaf26ec504846ef$var$lerp(a.x, b.x, t),
            y: $6aaf26ec504846ef$var$lerp(a.y, b.y, t)
        };
    },
    clone: (value)=>{
        const { x: x , y: y  } = value;
        return {
            x: x,
            y: y
        };
    }
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Vector3, {
    write: (value, bw)=>{
        const { x: x , y: y , z: z  } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
        bw.writeFloat64(z);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        const z = br.readFloat64();
        return {
            x: x,
            y: y,
            z: z
        };
    },
    byteSize: (value)=>{
        return 24; // that's 3 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y && a.z === b.z;
    },
    interp: (a, b, t)=>{
        return {
            x: $6aaf26ec504846ef$var$lerp(a.x, b.x, t),
            y: $6aaf26ec504846ef$var$lerp(a.y, b.y, t),
            z: $6aaf26ec504846ef$var$lerp(a.z, b.z, t)
        };
    },
    clone: (value)=>{
        const { x: x , y: y , z: z  } = value;
        return {
            x: x,
            y: y,
            z: z
        };
    }
});
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Vector4, {
    write: (value, bw)=>{
        const { x: x , y: y , z: z , w: w  } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
        bw.writeFloat64(z);
        bw.writeFloat64(w);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        const z = br.readFloat64();
        const w = br.readFloat64();
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    },
    byteSize: (value)=>{
        return 32; // that's 4 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y && a.z === b.z && a.w === b.w;
    },
    interp: (a, b, t)=>{
        return {
            x: $6aaf26ec504846ef$var$lerp(a.x, b.x, t),
            y: $6aaf26ec504846ef$var$lerp(a.y, b.y, t),
            z: $6aaf26ec504846ef$var$lerp(a.z, b.z, t),
            w: $6aaf26ec504846ef$var$lerp(a.w, b.w, t)
        };
    },
    clone: (value)=>{
        const { x: x , y: y , z: z , w: w  } = value;
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    }
});
function $6aaf26ec504846ef$var$normalizeQuat(a) {
    let l = Math.sqrt(a.x * a.x + a.y * a.y + a.z * a.z + a.w * a.w);
    if (l === 0) {
        a.x = 0;
        a.y = 0;
        a.z = 0;
        a.w = 1;
    } else {
        l = 1 / l;
        a.x = a.x * l;
        a.y = a.y * l;
        a.z = a.z * l;
        a.w = a.w * l;
    }
}
function $6aaf26ec504846ef$var$quatSlerp(a, b, t) {
    const out = {
        x: 0,
        y: 0,
        z: 0,
        w: 0
    };
    if (t === 0) {
        Object.assign(out, a);
        return out;
    }
    if (t === 0) {
        Object.assign(out, b);
        return out;
    }
    const { x: x , y: y , z: z , w: w  } = a;
    // based off three.js quat slerp which cites this:
    // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
    let cosHalfTheta = w * b.w + x * b.x + y * b.y + z * b.z;
    if (cosHalfTheta < 0) {
        out.w = -b.w;
        out.x = -b.x;
        out.y = -b.y;
        out.z = -b.z;
        cosHalfTheta = -cosHalfTheta;
    } else return {
        x: b.x,
        y: b.y,
        z: b.z,
        w: b.w
    };
    if (cosHalfTheta >= 1.0) {
        out.w = w;
        out.x = x;
        out.y = y;
        out.z = z;
        return out;
    }
    const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
        const s = 1 - t;
        out.w = s * w + t * a.w;
        out.x = s * x + t * a.x;
        out.y = s * y + t * a.y;
        out.z = s * z + t * a.z;
        $6aaf26ec504846ef$var$normalizeQuat(out);
        return out;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta;
    const ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
    out.w = w * ratioA + a.w * ratioB;
    out.x = x * ratioA + a.x * ratioB;
    out.y = y * ratioA + a.y * ratioB;
    out.z = z * ratioA + a.z * ratioB;
    return out;
}
$6aaf26ec504846ef$var$declareBinaryType($cPwLs.Binary.Quaternion, {
    write: (value, bw)=>{
        const { x: x , y: y , z: z , w: w  } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
        bw.writeFloat64(z);
        bw.writeFloat64(w);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        const z = br.readFloat64();
        const w = br.readFloat64();
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    },
    byteSize: (value)=>{
        return 32; // that's 4 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y && a.z === b.z && a.w === b.w;
    },
    interp: $6aaf26ec504846ef$var$quatSlerp,
    clone: (value)=>{
        const { x: x , y: y , z: z , w: w  } = value;
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    }
});
const $6aaf26ec504846ef$var$binaryGet = function(binaryType) {
    const b = $6aaf26ec504846ef$var$data.get(binaryType);
    if (!b) throw new Error("Unknown binaryType used.");
    return b;
};
module.exports.binaryGet = $6aaf26ec504846ef$var$binaryGet;

});
parcelRequire.register("cPwLs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Binary = void 0;
var $9573a9cec9080284$var$Binary;
(function(Binary) {
    Binary[Binary["UInt8"] = 1] = "UInt8";
    Binary[Binary["Int8"] = 2] = "Int8";
    Binary[Binary["UInt16"] = 3] = "UInt16";
    Binary[Binary["Int16"] = 4] = "Int16";
    Binary[Binary["UInt32"] = 5] = "UInt32";
    Binary[Binary["Int32"] = 6] = "Int32";
    Binary[Binary["Float32"] = 7] = "Float32";
    Binary[Binary["Float64"] = 8] = "Float64";
    Binary[Binary["Boolean"] = 9] = "Boolean";
    Binary[Binary["String"] = 10] = "String";
    Binary[Binary["UInt8Array"] = 11] = "UInt8Array";
    Binary[Binary["Int8Array"] = 12] = "Int8Array";
    Binary[Binary["UInt16Array"] = 13] = "UInt16Array";
    Binary[Binary["Int16Array"] = 14] = "Int16Array";
    Binary[Binary["UInt32Array"] = 15] = "UInt32Array";
    Binary[Binary["Int32Array"] = 16] = "Int32Array";
    Binary[Binary["Float32Array"] = 17] = "Float32Array";
    Binary[Binary["Float64Array"] = 18] = "Float64Array";
    Binary[Binary["Vector2"] = 19] = "Vector2";
    Binary[Binary["Vector3"] = 20] = "Vector3";
    Binary[Binary["Vector4"] = 21] = "Vector4";
    Binary[Binary["Quaternion"] = 22] = "Quaternion";
    Binary[Binary["Rotation"] = 23] = "Rotation";
    //Rotation8,
    Binary[Binary["Rotation32"] = 24] = "Rotation32";
    Binary[Binary["LAST_INDEX"] = 25] = "LAST_INDEX";
})($9573a9cec9080284$var$Binary || ($9573a9cec9080284$var$Binary = {}));
module.exports.Binary = $9573a9cec9080284$var$Binary;

});



parcelRequire.register("7y0qA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $99SoP = parcelRequire("99SoP");
function $57ec0a54f45184d9$var$readMessage(reader, context) {
    const ntype = reader.readUInt8();
    const nschema = context.getSchema(ntype);
    const obj = {
        ntype: ntype
    };
    for(let i = 1; i < nschema.keys.length; i++){
        const propData = nschema.keys[i];
        const binaryUtil = (0, $99SoP.binaryGet)(propData.type);
        // @ts-ignore
        obj[propData.prop] = binaryUtil.post(binaryUtil.read(reader));
    }
    return obj;
}
module.exports.default = $57ec0a54f45184d9$var$readMessage;

});


parcelRequire.register("dnI4a", function(module, exports) {
"use strict";
var $9bdf9afc96a450b7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpatialChannel = void 0;

const $9bdf9afc96a450b7$var$EDictionary_1 = $9bdf9afc96a450b7$var$__importDefault((parcelRequire("eVskb")));
class $9bdf9afc96a450b7$var$SpatialChannel {
    constructor(localState, id){
        this.id = id;
        this.localState = localState;
        this.entities = new $9bdf9afc96a450b7$var$EDictionary_1.default();
        this.users = new Map();
        this.views = new Map();
        this.destroyed = false;
    }
    addEntity(entity) {
        // TODO
        //if (!entity.protocol) {
        //    throw new Error('Object is missing a protocol or protocol was not supplied via config.')
        //}
        this.localState.registerEntity(entity, this.id);
        this.entities.add(entity);
        /*
        this.users.forEach(user => {
            user.queueEngineMessage({
                ntype: EngineMessage.ChannelAddEntity,
                cid: this.id,
                eid: entity.id
            })
        })
        */ return entity;
    }
    removeEntity(entity) {
        //console.log('channel removeEntity', entity[this.config.ID_PROPERTY_NAME])
        this.entities.remove(entity);
        /*
        this.users.forEach(user => {
            user.queueEngineMessage({
                ntype: EngineMessage.ChannelRemoveEntity,
                cid: this.id,
                eid: entity.id
            })
        })
        */ this.localState.unregisterEntity(entity, this.id);
    }
    addMessage(message) {
        //console.log('channel addMessage', message)
        //message[this.config.TYPE_PROPERTY_NAME] = this.instance.protocols.getIndex(message.protocol)
        this.users.forEach((user)=>{
            user.queueMessage(message);
        });
    }
    getVisible(userId) {
        const visibleNids = [];
        const view = this.views.get(userId);
        const startX = view.x - view.halfWidth;
        const startY = view.y - view.halfHeight;
        const endX = view.x + view.halfWidth;
        const endY = view.y + view.halfHeight;
        for(let i = 0; i < this.entities.array.length; i++){
            const entity = this.entities.array[i];
            // TODO: how do we know the entities will have spatial data here?
            // @ts-ignore
            if (entity.x >= startX && entity.x <= endX && entity.y >= startY && entity.y <= endY) visibleNids.push(entity.nid);
        }
        return visibleNids;
    }
    // TODO
    subscribe(user, view) {
        this.users.set(user.id, user);
        this.views.set(user.id, view);
        user.subscribe(this);
    /*
        const eids = []
        user.queueEngineMessage({
            ntype: EngineMessage.ChannelJoin,
            cid: this.id,
            eids: entity.id
        })
        */ }
    // TODO
    unsubscribe(user) {
        this.users.delete(user);
        user.unsubscribe(this);
    }
    destroy() {
        this.users.forEach((user)=>this.unsubscribe(user));
        this.entities.forEach((entity)=>this.removeEntity(entity));
        //this.instance.channels.remove(this)
        this.destroyed = true;
    //this.instance.channelCount--
    }
}
module.exports.SpatialChannel = $9bdf9afc96a450b7$var$SpatialChannel;

});

parcelRequire.register("7tINK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $99SoP = parcelRequire("99SoP");
function $571dfe719a4e6a04$var$diff(entity, cache, nschema) {
    if (!cache) {
        console.log("no cache");
        return [];
    }
    const diffs = [];
    for(let i = 0; i < nschema.keys.length; i++){
        const { prop: prop , type: type  } = nschema.keys[i];
        const oldValue = cache[prop];
        const value = entity[prop];
        const binaryUtil = (0, $99SoP.binaryGet)(type);
        if (!binaryUtil.compare(oldValue, value)) {
            diffs.push({
                nid: entity.nid,
                nschema: nschema,
                prop: prop,
                value: value
            });
            cache[prop] = binaryUtil.clone(value);
        }
    }
    return diffs;
}
class $571dfe719a4e6a04$var$EntityCache {
    constructor(){
        this.cache = {};
        this.diffCache = {};
        this.binaryDiffCache = {};
    }
    cacheContains(nid) {
        return !!this.cache[nid];
    }
    createCachesForTick(tick) {
        //this.cache[tick] = {}
        this.diffCache[tick] = {};
        this.binaryDiffCache[tick] = {};
    }
    deleteCachesForTick(tick) {
        //delete this.cache[tick]
        delete this.diffCache[tick];
        delete this.binaryDiffCache[tick];
    }
    getAndDiff(tick, entity, nschema) {
        if (this.diffCache[tick][entity.nid]) return this.diffCache[tick][entity.nid];
        else {
            const cacheObject = this.cache[entity.nid];
            const diffs = $571dfe719a4e6a04$var$diff(entity, cacheObject, nschema);
            this.diffCache[tick][entity.nid] = diffs;
            return diffs;
        }
    }
    cacheify(tick, entity, schema) {
        const cacheObject = {};
        for(let i = 0; i < schema.keys.length; i++){
            const propData = schema.keys[i];
            const value = entity[propData.prop];
            const binaryUtil = (0, $99SoP.binaryGet)(propData.type);
            // @ts-ignore
            cacheObject[propData.prop] = binaryUtil.clone(value);
        }
        this.cache[entity.nid] = cacheObject;
    }
    updateCache(tick, entity, schema) {
        const cacheObject = this.cache[entity.nid];
        for(let i = 0; i < schema.keys.length; i++){
            const propData = schema.keys[i];
            const value = entity[propData.prop];
            const binaryUtil = (0, $99SoP.binaryGet)(propData.type);
            // @ts-ignore
            cacheObject[propData.prop] = binaryUtil.clone(value);
        }
    }
}
module.exports.default = $571dfe719a4e6a04$var$EntityCache;

});

parcelRequire.register("lq3JV", function(module, exports) {
"use strict";
var $f97eed55d3fe0bdc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f97eed55d3fe0bdc$var$count_1 = $f97eed55d3fe0bdc$var$__importDefault((parcelRequire("lbV2D")));

const $f97eed55d3fe0bdc$var$countDiff_1 = $f97eed55d3fe0bdc$var$__importDefault((parcelRequire("gtFoB")));

var $ahX3I = parcelRequire("ahX3I");

var $gMx7w = parcelRequire("gMx7w");

const $f97eed55d3fe0bdc$var$writeDiff_1 = $f97eed55d3fe0bdc$var$__importDefault((parcelRequire("lhcBQ")));

var $99SoP = parcelRequire("99SoP");

var $cPwLs = parcelRequire("cPwLs");
const $f97eed55d3fe0bdc$var$getVisibleState = (user, instance)=>{
    const vis = user.checkVisibility(instance.tick);
    const createEntities = [];
    for(let i = 0; i < vis.newlyVisible.length; i++){
        const nid = vis.newlyVisible[i];
        const entity = instance.localState.getByNid(nid);
        const nschema = instance.context.getSchema(entity.ntype);
        if (nschema) {
            if (!instance.cache.cacheContains(nid)) instance.cache.cacheify(instance.tick, entity, nschema);
            createEntities.push(entity);
        } else throw new Error(`Entity [nid ${nid}] [ntype ${entity.ntype}] is missing a network schema.`);
    }
    const messages = user.messageQueue;
    // empty the queue
    user.messageQueue = [];
    const deleteEntities = vis.noLongerVisible;
    const updateEntities = [];
    //console.log('stillVisible', vis.stillVisible.length)
    for(let i = 0; i < vis.stillVisible.length; i++){
        const nid = vis.stillVisible[i];
        const entity = instance.localState.getByNid(nid);
        const nschema = instance.context.getSchema(entity.ntype);
        if (nschema) {
            const diffs = instance.cache.getAndDiff(instance.tick, entity, nschema);
            diffs.forEach((diff)=>{
                updateEntities.push(diff);
            });
        }
    }
    //console.log('getVisibleState', instance.tick, createEntities.length, updateEntities.length, deleteEntities.length)
    return {
        createEntities: createEntities,
        updateEntities: updateEntities,
        deleteEntities: deleteEntities,
        messages: messages
    };
};
const $f97eed55d3fe0bdc$var$createSnapshotBufferRefactor = (user, instance)=>{
    let bytes = 0;
    bytes += 1; // section BinarySection.EngineMessages
    bytes += 1; // quantity of engine messages
    bytes += 1; // section BinarySection.Messages
    bytes += 4; // quantity of messages
    bytes += 1; // delete entities
    bytes += 4; // quantity of entities to delete
    const { createEntities: createEntities , updateEntities: updateEntities , deleteEntities: deleteEntities , messages: messages  } = $f97eed55d3fe0bdc$var$getVisibleState(user, instance);
    for(let i = 0; i < messages.length; i++){
        const message = messages[i];
        const nschema = instance.context.getSchema(message.ntype);
        //console.log('counting', message, nschema)
        bytes += (0, $f97eed55d3fe0bdc$var$count_1.default)(nschema, message);
    }
    if (user.responseQueue.length > 0) {
        bytes += 1;
        bytes += 4;
        for(let i = 0; i < user.responseQueue.length; i++){
            bytes += 4; // requestId
            // @ts-ignore
            bytes += (0, $99SoP.binaryGet)($cPwLs.Binary.String).byteSize(user.responseQueue[i].response);
        }
    }
    if (createEntities.length > 0) {
        // section create
        bytes += 1;
        bytes += 4;
        for(let i = 0; i < createEntities.length; i++){
            const nid = createEntities[i].nid;
            const entity = instance.localState.getByNid(nid);
            const nschema = instance.context.getSchema(entity.ntype);
            bytes += (0, $f97eed55d3fe0bdc$var$count_1.default)(nschema, entity);
        }
    }
    if (updateEntities.length > 0) {
        // section update
        bytes += 1;
        bytes += 4;
        for(let i = 0; i < updateEntities.length; i++){
            const diff = updateEntities[i];
            bytes += (0, $f97eed55d3fe0bdc$var$countDiff_1.default)(diff, diff.nschema);
        }
    }
    for(let i = 0; i < deleteEntities.length; i++)bytes += 4;
    const bw = user.networkAdapter.createBufferWriter(bytes);
    bw.writeUInt8($ahX3I.BinarySection.EngineMessages);
    bw.writeUInt8(0);
    bw.writeUInt8($ahX3I.BinarySection.Messages);
    bw.writeUInt32(messages.length);
    for(let i = 0; i < messages.length; i++){
        const message = messages[i];
        const nschema = instance.context.getSchema(message.ntype);
        (0, $gMx7w.writeMessage)(message, nschema, bw);
    }
    if (user.responseQueue.length > 0) {
        bw.writeUInt8($ahX3I.BinarySection.Responses);
        bw.writeUInt32(user.responseQueue.length);
        for(let i = 0; i < user.responseQueue.length; i++){
            bw.writeUInt32(user.responseQueue[i].requestId);
            bw.writeString(user.responseQueue[i].response);
        // @ts-ignore
        //bw[BinaryExt(Binary.String).write](user.responseQueue[i].response)
        }
    }
    if (createEntities.length > 0) {
        bw.writeUInt8($ahX3I.BinarySection.CreateEntities);
        bw.writeUInt32(createEntities.length);
        for(let i = 0; i < createEntities.length; i++){
            const entity = createEntities[i];
            const nschema = instance.context.getSchema(entity.ntype);
            (0, $gMx7w.writeMessage)(entity, nschema, bw);
        }
    }
    if (updateEntities.length > 0) {
        bw.writeUInt8($ahX3I.BinarySection.UpdateEntities);
        bw.writeUInt32(updateEntities.length);
        //console.log('updates', updateEntities.length)
        for(let i = 0; i < updateEntities.length; i++){
            const diff = updateEntities[i];
            (0, $f97eed55d3fe0bdc$var$writeDiff_1.default)(diff.nid, diff, diff.nschema, bw);
        }
    }
    bw.writeUInt8($ahX3I.BinarySection.DeleteEntities);
    bw.writeUInt32(deleteEntities.length);
    for(let i = 0; i < deleteEntities.length; i++)bw.writeUInt32(deleteEntities[i]);
    user.responseQueue = [];
    return bw.buffer;
};
module.exports.default = $f97eed55d3fe0bdc$var$createSnapshotBufferRefactor;

});
parcelRequire.register("lbV2D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $99SoP = parcelRequire("99SoP");
function $f6d6df54dd031d3b$var$count(schema, entity) {
    let bytes = 0;
    schema.keys.forEach((propData)=>{
        const spec = (0, $99SoP.binaryGet)(propData.type);
        // @ts-ignore
        bytes += spec.byteSize(entity[propData.prop]);
    });
    return bytes;
}
module.exports.default = $f6d6df54dd031d3b$var$count;

});

parcelRequire.register("gtFoB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $99SoP = parcelRequire("99SoP");
function $bfef77205359f1e5$var$countDiff(diff, nschema) {
    let bytes = 0;
    // add id, prop, value
    bytes += 5;
    const prop = diff.prop;
    const propData = nschema.props[prop];
    bytes += (0, $99SoP.binaryGet)(propData.type).byteSize(diff.value);
    return bytes;
}
module.exports.default = $bfef77205359f1e5$var$countDiff;

});

parcelRequire.register("gMx7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.writeMessage = void 0;

var $99SoP = parcelRequire("99SoP");
function $c37ad20fc25baf87$var$writeMessage(obj, nschema, bufferWriter) {
    for(let i = 0; i < nschema.keys.length; i++){
        const propData = nschema.keys[i];
        const binaryUtil = (0, $99SoP.binaryGet)(propData.type);
        const value = obj[propData.prop];
        binaryUtil.write(value, bufferWriter);
    }
}
module.exports.writeMessage = $c37ad20fc25baf87$var$writeMessage;

});

parcelRequire.register("lhcBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $99SoP = parcelRequire("99SoP");
function $f7d4f77dc8f97335$var$writeDiff(nid, diff, nschema, bufferWriter) {
    const propData = nschema.props[diff.prop];
    const binaryUtil = (0, $99SoP.binaryGet)(propData.type);
    bufferWriter.writeUInt32(nid);
    bufferWriter.writeUInt8(propData.key);
    binaryUtil.write(diff.value, bufferWriter);
}
module.exports.default = $f7d4f77dc8f97335$var$writeDiff;

});


parcelRequire.register("cWtoF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $96c1b46c4c0e796d$var$NQueue {
    constructor(){
        this.arr = [];
    }
    isEmpty() {
        return this.arr.length === 0;
    }
    enqueue(item) {
        this.arr.unshift(item);
    }
    dequeue() {
        return this.arr.pop();
    }
    peekNext() {
        return this.arr[this.arr.length - 1];
    }
    get length() {
        return this.arr.length;
    }
    next() {
        return this.dequeue();
    }
}
module.exports.default = $96c1b46c4c0e796d$var$NQueue;

});


parcelRequire.register("hJuLK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ViewAABB = void 0;
class $ce8e81bb3014ec37$var$ViewAABB {
    constructor(x, y, halfWidth, halfHeight){
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
}
module.exports.ViewAABB = $ce8e81bb3014ec37$var$ViewAABB;

});

parcelRequire.register("bmjqg", function(module, exports) {
"use strict";
var $8450d0b15524a04b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MockServerSocket = module.exports.MockClientSocket = module.exports.MockClientAdapter = module.exports.MockInstanceAdapter = void 0;

var $ajywS = parcelRequire("ajywS");

const $8450d0b15524a04b$var$NQueue_1 = $8450d0b15524a04b$var$__importDefault((parcelRequire("cWtoF")));
/**
 * Not a real network adapter, data is passed without using a real socket.
 * Used for mixing a server and client together in one application
 * such as for a single player mode or automated testing
 */ class $8450d0b15524a04b$var$MockInstanceAdapter {
    constructor(network, config){
        this.network = network;
        this.serverSockets = [];
        if (!config || !config.bufferCtor || !config.binaryWriterCtor) throw new Error("MockAdapter requires a config.bufferCtor and config.binaryWriterCtor to be created.");
        this.bufferCtor = config.bufferCtor;
        this.binaryWriterCtor = config.binaryWriterCtor;
        this.binaryReaderCtor = config.binaryReaderCtor;
    }
    listen(port, ready) {
        console.log("MockAdapter listen is fake! No need to invoke it.");
    }
    createMockConnect() {
        const socket = new $8450d0b15524a04b$var$MockServerSocket(this.network);
        this.open(socket);
        return socket;
    }
    open(socket) {
        const user = new $ajywS.User(socket, this);
        socket.user = user;
        this.network.onOpen(user);
    }
    message(socket, message) {
        socket.user;
    }
    close(socket) {
        if (socket.user) this.network.onClose(socket.user);
    }
    disconnect(user, reason) {
        user.socket.end(1000, JSON.stringify(reason));
    }
    send(user, buffer) {
        user.socket.send(buffer, true);
    }
    createBuffer(lengthInBytes) {
        return new this.bufferCtor(lengthInBytes);
    }
    createBufferWriter(lengthInBytes) {
        return new this.binaryWriterCtor(this.createBuffer(lengthInBytes));
    }
    createBufferReader(buffer) {
        return new this.binaryReaderCtor(buffer);
    }
}
module.exports.MockInstanceAdapter = $8450d0b15524a04b$var$MockInstanceAdapter;
class $8450d0b15524a04b$var$MockClientAdapter {
    constructor(network, config){
        this.network = network;
        this.bufferCtor = config.bufferCtor;
        this.binaryWriterCtor = config.binaryWriterCtor;
        this.binaryReaderCtor = config.binaryReaderCtor;
    }
    createBuffer(lengthInBytes) {
        return new this.bufferCtor(lengthInBytes);
    }
    createBufferWriter(lengthInBytes) {
        return new this.binaryWriterCtor(this.createBuffer(lengthInBytes));
    }
    createBufferReader(buffer) {
        return new this.binaryReaderCtor(buffer);
    }
    onMessage(buffer) {
        const br = this.createBufferReader(buffer);
        this.network.readSnapshot(br);
    }
    connect(wsUrl, handshake) {
        return new Promise((resolve, reject)=>{
            resolve(true);
        });
    }
    flush() {}
}
module.exports.MockClientAdapter = $8450d0b15524a04b$var$MockClientAdapter;
var $8450d0b15524a04b$var$MockSocketReadyState;
(function(MockSocketReadyState) {
    MockSocketReadyState[MockSocketReadyState["CONNECTING"] = 0] = "CONNECTING";
    MockSocketReadyState[MockSocketReadyState["OPEN"] = 1] = "OPEN";
    MockSocketReadyState[MockSocketReadyState["CLOSING"] = 2] = "CLOSING";
    MockSocketReadyState[MockSocketReadyState["CLOSED"] = 3] = "CLOSED";
})($8450d0b15524a04b$var$MockSocketReadyState || ($8450d0b15524a04b$var$MockSocketReadyState = {}));
class $8450d0b15524a04b$var$MockServerSocket {
    constructor(network){
        this.inboundQueue = new $8450d0b15524a04b$var$NQueue_1.default();
        this.readyState = $8450d0b15524a04b$var$MockSocketReadyState.CONNECTING;
        this.clientSocket = new $8450d0b15524a04b$var$MockClientSocket(this);
        this.user = null;
        this.network = network;
        this.readyState = $8450d0b15524a04b$var$MockSocketReadyState.OPEN;
    }
    end() {}
    receive(buffer) {
        //this.inboundQueue.enqueue(buffer)
        this.network.onMessage(this.user, buffer);
    }
    send(buffer) {
        if (this.clientSocket) this.clientSocket.receive(buffer);
    }
}
module.exports.MockServerSocket = $8450d0b15524a04b$var$MockServerSocket;
class $8450d0b15524a04b$var$MockClientSocket {
    constructor(serverSocket){
        this.inboundQueue = new $8450d0b15524a04b$var$NQueue_1.default();
        this.readyState = $8450d0b15524a04b$var$MockSocketReadyState.CONNECTING;
        this.serverSocket = serverSocket;
        this.readyState = $8450d0b15524a04b$var$MockSocketReadyState.OPEN;
    }
    close() {
        this.readyState = $8450d0b15524a04b$var$MockSocketReadyState.CLOSED;
    }
    send(buffer) {
        this.serverSocket.receive(buffer);
    }
    receive(buffer) {
        this.inboundQueue.enqueue(buffer);
    }
}
module.exports.MockClientSocket = $8450d0b15524a04b$var$MockClientSocket;

});

parcelRequire.register("5pnqf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Client = void 0;

var $47cup = parcelRequire("47cup");
class $3f0174c441d93a8e$var$Client {
    constructor(context, adapterCtor){
        this.context = context;
        this.network = new $47cup.ClientNetwork(this);
        this.adapter = new adapterCtor(this.network);
        this.disconnectHandler = (reason, event)=>{
            console.log("Disconnected!", reason, event);
        };
        this.websocketErrorHandler = (event)=>{
            console.log("Websocket Error", event);
        };
    }
    connect(wsUrl, handshake) {
        return this.adapter.connect(wsUrl, handshake);
    }
    setDisconnectHandler(handler) {
        this.disconnectHandler = handler;
    }
    setWebsocketErrorHandler(handler) {
        this.websocketErrorHandler = handler;
    }
    flush() {
        this.adapter.flush();
    }
    addCommand(command) {
        this.network.addCommand(command);
    }
}
module.exports.Client = $3f0174c441d93a8e$var$Client;

});
parcelRequire.register("47cup", function(module, exports) {
"use strict";
var $2ff1810650c8db8e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientNetwork = void 0;

const $2ff1810650c8db8e$var$NQueue_1 = $2ff1810650c8db8e$var$__importDefault((parcelRequire("cWtoF")));

var $gMx7w = parcelRequire("gMx7w");

var $i5UMv = parcelRequire("i5UMv");

const $2ff1810650c8db8e$var$readMessage_1 = $2ff1810650c8db8e$var$__importDefault((parcelRequire("7y0qA")));

const $2ff1810650c8db8e$var$readDiff_1 = $2ff1810650c8db8e$var$__importDefault((parcelRequire("1zB7F")));

var $8QdZd = parcelRequire("8QdZd");

var $ahX3I = parcelRequire("ahX3I");

const $2ff1810650c8db8e$var$count_1 = $2ff1810650c8db8e$var$__importDefault((parcelRequire("lbV2D")));

const $2ff1810650c8db8e$var$readEngineMessage_1 = $2ff1810650c8db8e$var$__importDefault((parcelRequire("9Haao")));
class $2ff1810650c8db8e$var$ClientNetwork {
    constructor(client){
        this.client = client;
        this.entities = new Map();
        this.snapshots = [];
        this.messages = [];
        this.outbound = new $2ff1810650c8db8e$var$NQueue_1.default();
        this.socket = null;
        this.requestId = 1;
        this.requestQueue = new $2ff1810650c8db8e$var$NQueue_1.default();
        this.requests = new Map();
        this.onDisconnect = (reason, event)=>{
            this.client.disconnectHandler(reason, event);
        };
        this.onSocketError = (event)=>{
            this.client.websocketErrorHandler(event);
        };
    }
    addCommand(command) {
        this.outbound.enqueue(command);
    }
    request(endpoint, payload, callback) {
        const obj = {
            endpoint: endpoint,
            requestId: this.requestId++,
            body: JSON.stringify(payload),
            callback: callback
        };
        //console.log(obj)
        this.requestQueue.enqueue(obj);
        this.requests.set(obj.requestId, obj);
    }
    createHandshakeBuffer(handshake, binaryWriterCtor) {
        const handshakeMessage = {
            ntype: $8QdZd.EngineMessage.ConnectionAttempt,
            handshake: JSON.stringify(handshake)
        };
        const handshakeByteLength = (0, $2ff1810650c8db8e$var$count_1.default)($i5UMv.connectionAttemptSchema, handshakeMessage);
        // @ts-ignore
        const dw = binaryWriterCtor.create(handshakeByteLength + 3);
        dw.writeUInt8($ahX3I.BinarySection.EngineMessages);
        dw.writeUInt8(1);
        dw.writeUInt8($8QdZd.EngineMessage.ConnectionAttempt);
        (0, $gMx7w.writeMessage)(handshakeMessage, $i5UMv.connectionAttemptSchema, dw);
        return dw.buffer;
    }
    createOutboundBuffer(binaryWriterCtor) {
        let bytes = 0;
        bytes += 1; // commands!
        bytes += 1; // number of commands
        this.outbound.arr.forEach((command)=>{
            bytes += (0, $2ff1810650c8db8e$var$count_1.default)(this.client.context.getSchema(command.ntype), command);
        });
        bytes += 1; // requests
        bytes += 1; // number of requests
        this.requestQueue.arr.forEach((request)=>{
            bytes += 12 + request.body.length;
        });
        // @ts-ignore
        const dw = binaryWriterCtor.create(bytes);
        dw.writeUInt8($ahX3I.BinarySection.Commands);
        dw.writeUInt8(this.outbound.arr.length);
        this.outbound.arr.forEach((command)=>{
            (0, $gMx7w.writeMessage)(command, this.client.context.getSchema(command.ntype), dw);
        });
        this.outbound.arr = [];
        dw.writeUInt8($ahX3I.BinarySection.Requests);
        dw.writeUInt8(this.requestQueue.arr.length);
        this.requestQueue.arr.forEach((request)=>{
            dw.writeUInt32(request.requestId);
            dw.writeUInt32(request.endpoint);
            dw.writeString(request.body);
        });
        this.requestQueue.arr = [];
        return dw.buffer;
    }
    readSnapshot(dr) {
        const snapshot = {
            messages: [],
            createEntities: [],
            updateEntities: [],
            deleteEntities: []
        };
        while(dr.offset < dr.byteLength){
            const section = dr.readUInt8();
            switch(section){
                case $ahX3I.BinarySection.EngineMessages:
                    {
                        const count = dr.readUInt8();
                        for(let i = 0; i < count; i++){
                            const engineMessage = (0, $2ff1810650c8db8e$var$readEngineMessage_1.default)(dr, this.client.context);
                            //console.log(engineMessage)
                            if (engineMessage.ntype === $8QdZd.EngineMessage.ConnectionTerminated) // @ts-ignore
                            console.log("connection terminated reason!", engineMessage.reason);
                        }
                        break;
                    }
                case $ahX3I.BinarySection.Messages:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const message = (0, $2ff1810650c8db8e$var$readMessage_1.default)(dr, this.client.context);
                            this.messages.push(message);
                        }
                        break;
                    }
                case $ahX3I.BinarySection.Responses:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const requestId = dr.readUInt32();
                            const response = dr.readString();
                            const request = this.requests.get(requestId);
                            if (request) {
                                request.callback(response);
                                this.requests.delete(requestId);
                            }
                        }
                        break;
                    }
                case $ahX3I.BinarySection.CreateEntities:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            //const entity = readEntity(dr, this.client.context)
                            const entity = (0, $2ff1810650c8db8e$var$readMessage_1.default)(dr, this.client.context);
                            this.entities.set(entity.nid, entity);
                            snapshot.createEntities.push(entity);
                        }
                        break;
                    }
                case $ahX3I.BinarySection.UpdateEntities:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const diff = (0, $2ff1810650c8db8e$var$readDiff_1.default)(dr, this.client.context, this.entities);
                            snapshot.updateEntities.push(diff);
                        }
                        break;
                    }
                case $ahX3I.BinarySection.DeleteEntities:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const nid = dr.readUInt32();
                            snapshot.deleteEntities.push(nid);
                        }
                        break;
                    }
                default:
                    console.log("hit unknown section while readding binary");
                    break;
            }
        }
        this.snapshots.push(snapshot);
    }
}
module.exports.ClientNetwork = $2ff1810650c8db8e$var$ClientNetwork;

});
parcelRequire.register("i5UMv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionAttemptSchema = void 0;

var $2ROiR = parcelRequire("2ROiR");

var $cPwLs = parcelRequire("cPwLs");
const $d2c4bd35eb9abe64$var$connectionAttemptSchema = (0, $2ROiR.defineSchema)({
    handshake: $cPwLs.Binary.String
});
module.exports.connectionAttemptSchema = $d2c4bd35eb9abe64$var$connectionAttemptSchema;

});
parcelRequire.register("2ROiR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defineSchema = void 0;

var $cPwLs = parcelRequire("cPwLs");

var $5GmkY = parcelRequire("5GmkY");
function $21678d2757694286$var$defineSchema(schema) {
    //console.log('parsing', schema)
    const compiled = new $5GmkY.Schema();
    let index = 0;
    {
        const prop = "ntype";
        const entry = {
            key: index,
            prop: prop,
            type: $cPwLs.Binary.UInt8,
            interp: false
        };
        compiled.keys.push(entry);
        compiled.props[prop] = entry;
        index++;
    }
    {
        const prop = "nid";
        const entry = {
            key: index,
            prop: prop,
            type: $cPwLs.Binary.UInt16,
            interp: false
        };
        compiled.keys.push(entry);
        compiled.props[prop] = entry;
        index++;
    }
    for(const prop in schema){
        if (prop === "nid") throw new Error("No need to define `nid` in a schema, this is added by default.");
        if (prop === "ntype") throw new Error("No need to define `ntype` in a schema, this is added by default.");
        // @ts-ignore
        if (schema[prop].type) {
            // probably the syntax x: { type: Binary.Float32, interp: true }
            // @ts-ignore
            const entry = {
                key: index,
                prop: prop,
                type: schema[prop].type,
                interp: schema[prop].interp
            };
            compiled.keys.push(entry);
            compiled.props[prop] = entry;
            index++;
        } else {
            // probably the syntax x: Binary.Float32
            const entry = {
                key: index,
                prop: prop,
                type: schema[prop],
                interp: false
            };
            compiled.keys.push(entry);
            compiled.props[prop] = entry;
            index++;
        }
    }
    return compiled;
}
module.exports.defineSchema = $21678d2757694286$var$defineSchema;

});
parcelRequire.register("5GmkY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Schema = void 0;
class $423233b3ac772bec$var$Schema {
    constructor(){
        this.keys = [];
        this.props = {};
    }
}
module.exports.Schema = $423233b3ac772bec$var$Schema;

});



parcelRequire.register("1zB7F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $99SoP = parcelRequire("99SoP");
function $1255db23d748c818$var$readDiff(reader, context, entities) {
    const nid = reader.readUInt32();
    const propKey = reader.readUInt8();
    const ntype = entities.get(nid).ntype;
    const nschema = context.getSchema(ntype);
    const propData = nschema.keys[propKey];
    const binaryUtil = (0, $99SoP.binaryGet)(propData.type);
    const value = binaryUtil.read(reader);
    return {
        nid: nid,
        prop: propData.prop,
        value: value
    };
}
module.exports.default = $1255db23d748c818$var$readDiff;

});



parcelRequire.register("9fOWK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findSubsequentFrame = module.exports.findInitialFrame = module.exports.Interpolator = void 0;

var $8lIff = parcelRequire("8lIff");

var $99SoP = parcelRequire("99SoP");
const $6bcd08ae2793f1fb$var$findInitialFrame = (frames, renderTime)=>{
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame.timestamp < renderTime) return frame;
    }
    return null;
};
module.exports.findInitialFrame = $6bcd08ae2793f1fb$var$findInitialFrame;
const $6bcd08ae2793f1fb$var$findSubsequentFrame = (frames, previousTick)=>{
    for(var i = 0; i < frames.length; i++){
        if (frames[i].tick === previousTick + 1) return frames[i];
    }
    return null;
};
module.exports.findSubsequentFrame = $6bcd08ae2793f1fb$var$findSubsequentFrame;
class $6bcd08ae2793f1fb$var$Interpolator {
    constructor(client){
        this.client = client;
        //this.snapshots = []
        this.frames = [];
        this.latestFrame = null;
    }
    // TODO add all the creates and deletes
    getInterpolatedState(interpDelay) {
        while(this.client.network.snapshots.length > 0){
            const snapshot = this.client.network.snapshots.shift();
            if (snapshot) {
                const frame = new $8lIff.Frame(snapshot, this.latestFrame);
                this.frames.push(frame);
                this.latestFrame = frame;
            }
        }
        const now = performance.now();
        const renderTime = now - interpDelay;
        const frameA = $6bcd08ae2793f1fb$var$findInitialFrame(this.frames, renderTime);
        const frames = [];
        if (frameA) {
            const frameB = $6bcd08ae2793f1fb$var$findSubsequentFrame(this.frames, frameA.tick);
            //console.log('this.frames.length', frameA.tick, this.frames.length, renderTime)
            // late frames (frames before frameA)
            // TODO this.frames.length keeps growing! we need to free memory
            for(let i = this.frames.length - 1; i > -1; i--){
                const frame = this.frames[i];
                if (frame.tick < frameA.tick && !frame.processed) {
                    //console.log('late', frame)
                    if (!frame.processed) {
                        frames.push(frame);
                        frame.processed = true;
                        this.frames.splice(i, 1);
                    } else this.frames.splice(i, 1);
                }
            }
            frames.reverse();
            frameB;
            if (frameB && !frameB.processed) {
                const total = frameB.timestamp - frameA.timestamp;
                const portion = renderTime - frameA.timestamp;
                const interpAmount = portion / total;
                // TODO type
                const interpState = {
                    createEntities: [],
                    updateEntities: [],
                    deleteEntities: []
                };
                if (!frameA.processed) {
                    //console.log('processing frameA', frameA)
                    interpState.createEntities = frameA.createEntities.slice();
                    interpState.deleteEntities = frameA.deleteEntities.slice();
                    frameA.processed = true;
                }
                for(let i = 0; i < frameA.updateEntities.length; i++){
                    const { nid: nid , prop: prop , value: value  } = frameA.updateEntities[i];
                    // if no update in frameB, then entity's correct state is update.value
                    if (frameB.updateEntities.findIndex((x)=>x.nid === nid && x.prop === prop) === -1) interpState.updateEntities.push({
                        nid: nid,
                        prop: prop,
                        value: value
                    });
                }
                for(let i = 0; i < frameB.updateEntities.length; i++){
                    const { nid: nid , prop: prop  } = frameB.updateEntities[i];
                    const entityA = frameA.entities.get(nid);
                    const entityB = frameB.entities.get(nid);
                    if (entityA && entityB) {
                        const nschema = this.client.context.getSchema(entityA.ntype);
                        const binarySpec = nschema.props[prop];
                        const binaryUtil = (0, $99SoP.binaryGet)(binarySpec.type);
                        if (binarySpec.interp) {
                            // interpolated
                            const valueA = entityA[prop];
                            const valueB = entityB[prop];
                            const value = binaryUtil.interp(valueA, valueB, interpAmount);
                            interpState.updateEntities.push({
                                nid: nid,
                                prop: prop,
                                value: value
                            });
                        } else // not interpolated
                        interpState.updateEntities.push({
                            nid: nid,
                            prop: prop,
                            value: entityB[prop]
                        });
                    }
                }
                frames.push(interpState);
            }
        }
        return frames;
    }
}
module.exports.Interpolator = $6bcd08ae2793f1fb$var$Interpolator;

});
parcelRequire.register("8lIff", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Frame = void 0;
let $61429b028b11c1c5$var$tick = 0; // TODO this should be the server tick not a client based count
class $61429b028b11c1c5$var$Frame {
    constructor(snapshot, previousFrame){
        this.tick = $61429b028b11c1c5$var$tick++;
        this.timestamp = performance.now();
        this.processed = false;
        this.entities = new Map();
        this.createEntities = [];
        this.updateEntities = [];
        this.deleteEntities = [];
        if (previousFrame) // this.timestamp = previousFrame.timestamp + 50
        previousFrame.entities.forEach((entity)=>{
            const clone = Object.assign({}, entity);
            this.entities.set(clone.nid, clone);
        });
        snapshot.createEntities.forEach((entity)=>{
            const clone = Object.assign({}, entity);
            this.entities.set(clone.nid, clone);
            this.createEntities.push(clone);
        });
        snapshot.updateEntities.forEach((update)=>{
            const entity = this.entities.get(update.nid);
            entity[update.prop] = update.value;
            const clone = Object.assign({}, update);
            this.updateEntities.push(clone);
        });
        snapshot.deleteEntities.forEach((nid)=>{
            this.entities.delete(nid);
            this.deleteEntities.push(nid);
        });
    }
}
module.exports.Frame = $61429b028b11c1c5$var$Frame;

});


parcelRequire.register("cXATR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Context = void 0;

var $i5UMv = parcelRequire("i5UMv");

var $8QdZd = parcelRequire("8QdZd");

var $lncsc = parcelRequire("lncsc");

var $dnkho = parcelRequire("dnkho");

var $dSFqn = parcelRequire("dSFqn");
class $96f79e4fbfda130b$var$Context {
    constructor(){
        this.schemas = new Map();
        this.engineSchemas = new Map();
        // setup the engine schemas
        this.engineSchemas.set($8QdZd.EngineMessage.ConnectionAttempt, $i5UMv.connectionAttemptSchema);
        this.engineSchemas.set($8QdZd.EngineMessage.ConnectionAccepted, $lncsc.connectionAcceptedSchema);
        this.engineSchemas.set($8QdZd.EngineMessage.ConnectionDenied, $dnkho.connectionDeniedSchema);
        this.engineSchemas.set($8QdZd.EngineMessage.ConnectionTerminated, $dSFqn.connectionTerminatedSchema);
    }
    register(ntype, schema) {
        this.schemas.set(ntype, schema);
    }
    getSchema(ntype) {
        return this.schemas.get(ntype);
    }
    getEngineSchema(ntype) {
        return this.engineSchemas.get(ntype);
    }
}
module.exports.Context = $96f79e4fbfda130b$var$Context;

});
parcelRequire.register("lncsc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionAcceptedSchema = void 0;

var $2ROiR = parcelRequire("2ROiR");
const $f8f5680a6bde147b$var$connectionAcceptedSchema = (0, $2ROiR.defineSchema)({
});
module.exports.connectionAcceptedSchema = $f8f5680a6bde147b$var$connectionAcceptedSchema;

});

parcelRequire.register("dnkho", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionDeniedSchema = void 0;

var $2ROiR = parcelRequire("2ROiR");
const $9bcd27765f5cfcb3$var$connectionDeniedSchema = (0, $2ROiR.defineSchema)({
});
module.exports.connectionDeniedSchema = $9bcd27765f5cfcb3$var$connectionDeniedSchema;

});

parcelRequire.register("dSFqn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionTerminatedSchema = void 0;

var $2ROiR = parcelRequire("2ROiR");

var $cPwLs = parcelRequire("cPwLs");
const $a1b0738610bdd444$var$connectionTerminatedSchema = (0, $2ROiR.defineSchema)({
    reason: $cPwLs.Binary.String
});
module.exports.connectionTerminatedSchema = $a1b0738610bdd444$var$connectionTerminatedSchema;

});


parcelRequire.register("5kAXU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("aW80P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("8qllu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("i1GLq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("lKMGf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataViewReader = void 0;
class $fd63a7cb1a1af534$var$DataViewReader {
    constructor(arrayBuffer, offset){
        this.view = new DataView(arrayBuffer);
        this.offset = offset;
    }
    get byteLength() {
        return this.view.buffer.byteLength;
    }
    readUInt8() {
        const value = this.view.getUint8(this.offset);
        this.offset += 1;
        return value;
    }
    readInt8() {
        const value = this.view.getInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readUInt16() {
        const value = this.view.getUint16(this.offset);
        this.offset += 2;
        return value;
    }
    readInt16() {
        const value = this.view.getInt16(this.offset);
        this.offset += 2;
        return value;
    }
    readUInt32() {
        const value = this.view.getUint32(this.offset);
        this.offset += 4;
        return value;
    }
    readInt32() {
        const value = this.view.getInt32(this.offset);
        this.offset += 4;
        return value;
    }
    readFloat32() {
        const value = this.view.getFloat32(this.offset);
        this.offset += 4;
        return value;
    }
    readFloat64() {
        const value = this.view.getFloat64(this.offset);
        this.offset += 8;
        return value;
    }
    readString() {
        const length = this.readUInt32();
        const value = new TextDecoder().decode(this.view.buffer.slice(this.offset, this.offset + length));
        //const value = this.buffer.toString('utf8', this.offset, this.offset + length)
        this.offset += length;
        return value;
    }
    readUInt8Array() {
        const length = this.readUInt32();
        const arr = new Uint8Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readUInt8();
        return arr;
    }
    readInt8Array() {
        const length = this.readUInt32();
        const arr = new Int8Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readInt8();
        return arr;
    }
    readUInt16Array() {
        const length = this.readUInt32();
        const arr = new Uint16Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readUInt16();
        return arr;
    }
    readInt16Array() {
        const length = this.readUInt32();
        const arr = new Int16Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readInt16();
        return arr;
    }
    readUInt32Array() {
        const length = this.readUInt32();
        const arr = new Uint32Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readUInt32();
        return arr;
    }
    readInt32Array() {
        const length = this.readUInt32();
        const arr = new Int32Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readInt32();
        return arr;
    }
    readFloat32Array() {
        const length = this.readUInt32();
        const arr = new Float32Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readFloat32();
        return arr;
    }
    readFloat64Array() {
        const length = this.readUInt32();
        const arr = new Float64Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readFloat64();
        return arr;
    }
}
module.exports.DataViewReader = $fd63a7cb1a1af534$var$DataViewReader;

});

parcelRequire.register("cjSum", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataViewWriter = void 0;
class $8f8186b1f443d230$var$DataViewWriter {
    constructor(arrayBuffer, offset){
        this.view = new DataView(arrayBuffer);
        this.offset = offset || 0;
    }
    get buffer() {
        return this.view.buffer;
    }
    static create(byteLength) {
        return new $8f8186b1f443d230$var$DataViewWriter(new ArrayBuffer(byteLength));
    }
    writeUInt8(value) {
        this.view.setUint8(this.offset, value);
        this.offset += 1;
    }
    writeInt8(value) {
        this.view.setInt8(this.offset, value);
        this.offset += 1;
    }
    writeUInt16(value) {
        this.view.setUint16(this.offset, value);
        this.offset += 2;
    }
    writeInt16(value) {
        this.view.setInt16(this.offset, value);
        this.offset += 2;
    }
    writeUInt32(value) {
        this.view.setUint32(this.offset, value);
        this.offset += 4;
    }
    writeInt32(value) {
        this.view.setInt32(this.offset, value);
        this.offset += 4;
    }
    writeFloat32(value) {
        this.view.setFloat32(this.offset, value);
        this.offset += 4;
    }
    writeFloat64(value) {
        this.view.setFloat64(this.offset, value);
        this.offset += 8;
    }
    writeString(value) {
        const uint8arr = new TextEncoder().encode(value);
        this.writeUInt32(uint8arr.byteLength);
        uint8arr.forEach((byte)=>{
            this.writeUInt8(byte);
        });
    }
    writeUInt8Array(value) {
        const length = value.byteLength;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeUInt8(value[i]);
    }
    writeInt8Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeInt8(value[i]);
    }
    writeUInt16Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeUInt16(value[i]);
    }
    writeInt16Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeInt16(value[i]);
    }
    writeUInt32Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeUInt32(value[i]);
    }
    writeInt32Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeInt32(value[i]);
    }
    writeFloat32Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeFloat32(value[i]);
    }
    writeFloat64Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeFloat64(value[i]);
    }
}
module.exports.DataViewWriter = $8f8186b1f443d230$var$DataViewWriter;

});

parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRequire.register("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.2.0";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});


parcelRequire.register("3y30c", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2956e04298bc31b1$export$ae55be85d98224ed, (v) => $2956e04298bc31b1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2956e04298bc31b1$export$882461b6382ed46c, (v) => $2956e04298bc31b1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2956e04298bc31b1$export$466bfc07425424d5, (v) => $2956e04298bc31b1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2956e04298bc31b1$export$fa8d919ba61d84db, (v) => $2956e04298bc31b1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2956e04298bc31b1$export$757ceba2d55c277e, (v) => $2956e04298bc31b1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2956e04298bc31b1$export$b3890eb0ae9dca99, (v) => $2956e04298bc31b1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2956e04298bc31b1$export$502457920280e6be, (v) => $2956e04298bc31b1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2956e04298bc31b1$export$dc54d992c10e8a18, (v) => $2956e04298bc31b1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$ae55be85d98224ed;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$882461b6382ed46c;
var $2956e04298bc31b1$export$466bfc07425424d5;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$fa8d919ba61d84db;
var $2956e04298bc31b1$export$757ceba2d55c277e;
var $2956e04298bc31b1$export$b3890eb0ae9dca99;
var $2956e04298bc31b1$export$502457920280e6be;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$dc54d992c10e8a18;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var Scheduler = (parcelRequire("fO90s"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = false; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {}; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = resolvedInst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.2.0";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $2956e04298bc31b1$export$ae55be85d98224ed = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = createPortal$1;
    $2956e04298bc31b1$export$882461b6382ed46c = createRoot$1;
    $2956e04298bc31b1$export$466bfc07425424d5 = findDOMNode;
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = flushSync$1;
    $2956e04298bc31b1$export$fa8d919ba61d84db = hydrate;
    $2956e04298bc31b1$export$757ceba2d55c277e = hydrateRoot$1;
    $2956e04298bc31b1$export$b3890eb0ae9dca99 = render;
    $2956e04298bc31b1$export$502457920280e6be = unmountComponentAtNode;
    $2956e04298bc31b1$export$c78a37762a8d58e1 = batchedUpdates$1;
    $2956e04298bc31b1$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $2956e04298bc31b1$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRequire.register("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $553b3f9a1c62156e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = forceFrameRate;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRequire.register("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = jsx;
    $587db01302e19550$export$25062201e9e25d76 = jsxs;
})();

});

var $28edd11f6c7e9f5f$exports = {};
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


var $551209d754b5b429$export$83401e34d5e11bf4 = /* @__PURE__ */ ((ENV2)=>{
    ENV2[ENV2["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV2[ENV2["WEBGL"] = 1] = "WEBGL";
    ENV2[ENV2["WEBGL2"] = 2] = "WEBGL2";
    return ENV2;
})($551209d754b5b429$export$83401e34d5e11bf4 || {});
var $551209d754b5b429$export$747c566515e2a1d9 = /* @__PURE__ */ ((RENDERER_TYPE2)=>{
    RENDERER_TYPE2[RENDERER_TYPE2["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE2[RENDERER_TYPE2["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE2[RENDERER_TYPE2["CANVAS"] = 2] = "CANVAS";
    return RENDERER_TYPE2;
})($551209d754b5b429$export$747c566515e2a1d9 || {});
var $551209d754b5b429$export$c07ea8ac66dac49 = /* @__PURE__ */ ((BUFFER_BITS2)=>{
    BUFFER_BITS2[BUFFER_BITS2["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS2[BUFFER_BITS2["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS2[BUFFER_BITS2["STENCIL"] = 1024] = "STENCIL";
    return BUFFER_BITS2;
})($551209d754b5b429$export$c07ea8ac66dac49 || {});
var $551209d754b5b429$export$f821c68fe9beaecf = /* @__PURE__ */ ((BLEND_MODES2)=>{
    BLEND_MODES2[BLEND_MODES2["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES2[BLEND_MODES2["ADD"] = 1] = "ADD";
    BLEND_MODES2[BLEND_MODES2["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES2[BLEND_MODES2["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES2[BLEND_MODES2["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES2[BLEND_MODES2["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES2[BLEND_MODES2["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES2[BLEND_MODES2["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES2[BLEND_MODES2["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES2[BLEND_MODES2["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES2[BLEND_MODES2["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES2[BLEND_MODES2["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES2[BLEND_MODES2["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES2[BLEND_MODES2["HUE"] = 13] = "HUE";
    BLEND_MODES2[BLEND_MODES2["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES2[BLEND_MODES2["COLOR"] = 15] = "COLOR";
    BLEND_MODES2[BLEND_MODES2["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES2[BLEND_MODES2["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES2[BLEND_MODES2["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES2[BLEND_MODES2["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES2[BLEND_MODES2["NONE"] = 20] = "NONE";
    BLEND_MODES2[BLEND_MODES2["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES2[BLEND_MODES2["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES2[BLEND_MODES2["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES2[BLEND_MODES2["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES2[BLEND_MODES2["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES2[BLEND_MODES2["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES2[BLEND_MODES2["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES2[BLEND_MODES2["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES2[BLEND_MODES2["ERASE"] = 26] = "ERASE";
    BLEND_MODES2[BLEND_MODES2["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES2[BLEND_MODES2["XOR"] = 29] = "XOR";
    return BLEND_MODES2;
})($551209d754b5b429$export$f821c68fe9beaecf || {});
var $551209d754b5b429$export$91100badd8469338 = /* @__PURE__ */ ((DRAW_MODES2)=>{
    DRAW_MODES2[DRAW_MODES2["POINTS"] = 0] = "POINTS";
    DRAW_MODES2[DRAW_MODES2["LINES"] = 1] = "LINES";
    DRAW_MODES2[DRAW_MODES2["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES2[DRAW_MODES2["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES2[DRAW_MODES2["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES2[DRAW_MODES2["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES2[DRAW_MODES2["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
    return DRAW_MODES2;
})($551209d754b5b429$export$91100badd8469338 || {});
var $551209d754b5b429$export$e9c4b7b466aa8274 = /* @__PURE__ */ ((FORMATS2)=>{
    FORMATS2[FORMATS2["RGBA"] = 6408] = "RGBA";
    FORMATS2[FORMATS2["RGB"] = 6407] = "RGB";
    FORMATS2[FORMATS2["RG"] = 33319] = "RG";
    FORMATS2[FORMATS2["RED"] = 6403] = "RED";
    FORMATS2[FORMATS2["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS2[FORMATS2["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS2[FORMATS2["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS2[FORMATS2["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS2[FORMATS2["ALPHA"] = 6406] = "ALPHA";
    FORMATS2[FORMATS2["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS2[FORMATS2["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS2[FORMATS2["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS2[FORMATS2["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
    return FORMATS2;
})($551209d754b5b429$export$e9c4b7b466aa8274 || {});
var $551209d754b5b429$export$d1ff3caf57547dc5 = /* @__PURE__ */ ((TARGETS2)=>{
    TARGETS2[TARGETS2["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS2[TARGETS2["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS2[TARGETS2["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS2[TARGETS2["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS2[TARGETS2["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS2[TARGETS2["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS2[TARGETS2["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS2[TARGETS2["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS2[TARGETS2["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
    return TARGETS2;
})($551209d754b5b429$export$d1ff3caf57547dc5 || {});
var $551209d754b5b429$export$426db7a6155b7a80 = /* @__PURE__ */ ((TYPES2)=>{
    TYPES2[TYPES2["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES2[TYPES2["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES2[TYPES2["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES2[TYPES2["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES2[TYPES2["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES2[TYPES2["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES2[TYPES2["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES2[TYPES2["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES2[TYPES2["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES2[TYPES2["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES2[TYPES2["BYTE"] = 5120] = "BYTE";
    TYPES2[TYPES2["SHORT"] = 5122] = "SHORT";
    TYPES2[TYPES2["INT"] = 5124] = "INT";
    TYPES2[TYPES2["FLOAT"] = 5126] = "FLOAT";
    TYPES2[TYPES2["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES2[TYPES2["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
    return TYPES2;
})($551209d754b5b429$export$426db7a6155b7a80 || {});
var $551209d754b5b429$export$8ee8af3637d728f5 = /* @__PURE__ */ ((SAMPLER_TYPES2)=>{
    SAMPLER_TYPES2[SAMPLER_TYPES2["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES2[SAMPLER_TYPES2["INT"] = 1] = "INT";
    SAMPLER_TYPES2[SAMPLER_TYPES2["UINT"] = 2] = "UINT";
    return SAMPLER_TYPES2;
})($551209d754b5b429$export$8ee8af3637d728f5 || {});
var $551209d754b5b429$export$6b734c6a0bba8473 = /* @__PURE__ */ ((SCALE_MODES2)=>{
    SCALE_MODES2[SCALE_MODES2["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES2[SCALE_MODES2["LINEAR"] = 1] = "LINEAR";
    return SCALE_MODES2;
})($551209d754b5b429$export$6b734c6a0bba8473 || {});
var $551209d754b5b429$export$2ab395cfb0dd2f0f = /* @__PURE__ */ ((WRAP_MODES2)=>{
    WRAP_MODES2[WRAP_MODES2["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES2[WRAP_MODES2["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES2[WRAP_MODES2["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
    return WRAP_MODES2;
})($551209d754b5b429$export$2ab395cfb0dd2f0f || {});
var $551209d754b5b429$export$16f6fb5da874bbfd = /* @__PURE__ */ ((MIPMAP_MODES2)=>{
    MIPMAP_MODES2[MIPMAP_MODES2["OFF"] = 0] = "OFF";
    MIPMAP_MODES2[MIPMAP_MODES2["POW2"] = 1] = "POW2";
    MIPMAP_MODES2[MIPMAP_MODES2["ON"] = 2] = "ON";
    MIPMAP_MODES2[MIPMAP_MODES2["ON_MANUAL"] = 3] = "ON_MANUAL";
    return MIPMAP_MODES2;
})($551209d754b5b429$export$16f6fb5da874bbfd || {});
var $551209d754b5b429$export$d56550d454401b73 = /* @__PURE__ */ ((ALPHA_MODES2)=>{
    ALPHA_MODES2[ALPHA_MODES2["NPM"] = 0] = "NPM";
    ALPHA_MODES2[ALPHA_MODES2["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES2[ALPHA_MODES2["PMA"] = 2] = "PMA";
    ALPHA_MODES2[ALPHA_MODES2["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES2[ALPHA_MODES2["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES2[ALPHA_MODES2["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
    return ALPHA_MODES2;
})($551209d754b5b429$export$d56550d454401b73 || {});
var $551209d754b5b429$export$784901839554cbc3 = /* @__PURE__ */ ((CLEAR_MODES2)=>{
    CLEAR_MODES2[CLEAR_MODES2["NO"] = 0] = "NO";
    CLEAR_MODES2[CLEAR_MODES2["YES"] = 1] = "YES";
    CLEAR_MODES2[CLEAR_MODES2["AUTO"] = 2] = "AUTO";
    CLEAR_MODES2[CLEAR_MODES2["BLEND"] = 0] = "BLEND";
    CLEAR_MODES2[CLEAR_MODES2["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES2[CLEAR_MODES2["BLIT"] = 2] = "BLIT";
    return CLEAR_MODES2;
})($551209d754b5b429$export$784901839554cbc3 || {});
var $551209d754b5b429$export$5c6ba89c1f52b344 = /* @__PURE__ */ ((GC_MODES2)=>{
    GC_MODES2[GC_MODES2["AUTO"] = 0] = "AUTO";
    GC_MODES2[GC_MODES2["MANUAL"] = 1] = "MANUAL";
    return GC_MODES2;
})($551209d754b5b429$export$5c6ba89c1f52b344 || {});
var $551209d754b5b429$export$d6d3992f3becc879 = /* @__PURE__ */ ((PRECISION2)=>{
    PRECISION2["LOW"] = "lowp";
    PRECISION2["MEDIUM"] = "mediump";
    PRECISION2["HIGH"] = "highp";
    return PRECISION2;
})($551209d754b5b429$export$d6d3992f3becc879 || {});
var $551209d754b5b429$export$dbbea138c5d144 = /* @__PURE__ */ ((MASK_TYPES2)=>{
    MASK_TYPES2[MASK_TYPES2["NONE"] = 0] = "NONE";
    MASK_TYPES2[MASK_TYPES2["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES2[MASK_TYPES2["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES2[MASK_TYPES2["SPRITE"] = 3] = "SPRITE";
    MASK_TYPES2[MASK_TYPES2["COLOR"] = 4] = "COLOR";
    return MASK_TYPES2;
})($551209d754b5b429$export$dbbea138c5d144 || {});
var $551209d754b5b429$export$c306f8e81b8d1ca7 = /* @__PURE__ */ ((COLOR_MASK_BITS2)=>{
    COLOR_MASK_BITS2[COLOR_MASK_BITS2["RED"] = 1] = "RED";
    COLOR_MASK_BITS2[COLOR_MASK_BITS2["GREEN"] = 2] = "GREEN";
    COLOR_MASK_BITS2[COLOR_MASK_BITS2["BLUE"] = 4] = "BLUE";
    COLOR_MASK_BITS2[COLOR_MASK_BITS2["ALPHA"] = 8] = "ALPHA";
    return COLOR_MASK_BITS2;
})($551209d754b5b429$export$c306f8e81b8d1ca7 || {});
var $551209d754b5b429$export$1eadd657d5acc2f2 = /* @__PURE__ */ ((MSAA_QUALITY2)=>{
    MSAA_QUALITY2[MSAA_QUALITY2["NONE"] = 0] = "NONE";
    MSAA_QUALITY2[MSAA_QUALITY2["LOW"] = 2] = "LOW";
    MSAA_QUALITY2[MSAA_QUALITY2["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY2[MSAA_QUALITY2["HIGH"] = 8] = "HIGH";
    return MSAA_QUALITY2;
})($551209d754b5b429$export$1eadd657d5acc2f2 || {});
var $551209d754b5b429$export$b595a7e482202b96 = /* @__PURE__ */ ((BUFFER_TYPE2)=>{
    BUFFER_TYPE2[BUFFER_TYPE2["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE2[BUFFER_TYPE2["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    BUFFER_TYPE2[BUFFER_TYPE2["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
    return BUFFER_TYPE2;
})($551209d754b5b429$export$b595a7e482202b96 || {});


const $d86b9bbbe9c4fcd0$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};







const $fcbcf105ed644495$export$a5a6e0b888b2c992 = {
    ADAPTER: (0, $d86b9bbbe9c4fcd0$export$e467cc3399500025),
    RESOLUTION: 1,
    CREATE_IMAGE_BITMAP: false,
    ROUND_PIXELS: false
};


var $b891a30d1336f1e9$var$appleIphone = /iPhone/i;
var $b891a30d1336f1e9$var$appleIpod = /iPod/i;
var $b891a30d1336f1e9$var$appleTablet = /iPad/i;
var $b891a30d1336f1e9$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $b891a30d1336f1e9$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $b891a30d1336f1e9$var$androidTablet = /Android/i;
var $b891a30d1336f1e9$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $b891a30d1336f1e9$var$amazonTablet = /Silk/i;
var $b891a30d1336f1e9$var$windowsPhone = /Windows Phone/i;
var $b891a30d1336f1e9$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $b891a30d1336f1e9$var$otherBlackBerry = /BlackBerry/i;
var $b891a30d1336f1e9$var$otherBlackBerry10 = /BB10/i;
var $b891a30d1336f1e9$var$otherOpera = /Opera Mini/i;
var $b891a30d1336f1e9$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $b891a30d1336f1e9$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $b891a30d1336f1e9$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== "undefined" && navigator1.platform === "MacIntel" && typeof navigator1.maxTouchPoints === "number" && navigator1.maxTouchPoints > 1 && typeof MSStream === "undefined";
};
function $b891a30d1336f1e9$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $b891a30d1336f1e9$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: "",
        platform: "",
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== "undefined") nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === "string") nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split("[FBAN");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    tmp = userAgent.split("Twitter");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    var match = $b891a30d1336f1e9$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($b891a30d1336f1e9$var$appleIphone) && !match($b891a30d1336f1e9$var$windowsPhone),
            ipod: match($b891a30d1336f1e9$var$appleIpod),
            tablet: !match($b891a30d1336f1e9$var$appleIphone) && (match($b891a30d1336f1e9$var$appleTablet) || $b891a30d1336f1e9$var$isAppleTabletOnIos13(nav)) && !match($b891a30d1336f1e9$var$windowsPhone),
            universal: match($b891a30d1336f1e9$var$appleUniversal),
            device: (match($b891a30d1336f1e9$var$appleIphone) || match($b891a30d1336f1e9$var$appleIpod) || match($b891a30d1336f1e9$var$appleTablet) || match($b891a30d1336f1e9$var$appleUniversal) || $b891a30d1336f1e9$var$isAppleTabletOnIos13(nav)) && !match($b891a30d1336f1e9$var$windowsPhone)
        },
        amazon: {
            phone: match($b891a30d1336f1e9$var$amazonPhone),
            tablet: !match($b891a30d1336f1e9$var$amazonPhone) && match($b891a30d1336f1e9$var$amazonTablet),
            device: match($b891a30d1336f1e9$var$amazonPhone) || match($b891a30d1336f1e9$var$amazonTablet)
        },
        android: {
            phone: !match($b891a30d1336f1e9$var$windowsPhone) && match($b891a30d1336f1e9$var$amazonPhone) || !match($b891a30d1336f1e9$var$windowsPhone) && match($b891a30d1336f1e9$var$androidPhone),
            tablet: !match($b891a30d1336f1e9$var$windowsPhone) && !match($b891a30d1336f1e9$var$amazonPhone) && !match($b891a30d1336f1e9$var$androidPhone) && (match($b891a30d1336f1e9$var$amazonTablet) || match($b891a30d1336f1e9$var$androidTablet)),
            device: !match($b891a30d1336f1e9$var$windowsPhone) && (match($b891a30d1336f1e9$var$amazonPhone) || match($b891a30d1336f1e9$var$amazonTablet) || match($b891a30d1336f1e9$var$androidPhone) || match($b891a30d1336f1e9$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($b891a30d1336f1e9$var$windowsPhone),
            tablet: match($b891a30d1336f1e9$var$windowsTablet),
            device: match($b891a30d1336f1e9$var$windowsPhone) || match($b891a30d1336f1e9$var$windowsTablet)
        },
        other: {
            blackberry: match($b891a30d1336f1e9$var$otherBlackBerry),
            blackberry10: match($b891a30d1336f1e9$var$otherBlackBerry10),
            opera: match($b891a30d1336f1e9$var$otherOpera),
            firefox: match($b891a30d1336f1e9$var$otherFirefox),
            chrome: match($b891a30d1336f1e9$var$otherChrome),
            device: match($b891a30d1336f1e9$var$otherBlackBerry) || match($b891a30d1336f1e9$var$otherBlackBerry10) || match($b891a30d1336f1e9$var$otherOpera) || match($b891a30d1336f1e9$var$otherFirefox) || match($b891a30d1336f1e9$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}




const $cb209844fab531da$var$isMobileCall = (0, $b891a30d1336f1e9$export$2e2bcd8739ae039).default ?? (0, $b891a30d1336f1e9$export$2e2bcd8739ae039);
const $cb209844fab531da$export$d0a8044dce8ff2fc = $cb209844fab531da$var$isMobileCall(globalThis.navigator);




var $5d808cc4b6a3c326$exports = {};

$parcel$export($5d808cc4b6a3c326$exports, "isMobile", () => $cb209844fab531da$export$d0a8044dce8ff2fc);
$parcel$export($5d808cc4b6a3c326$exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault($f08921b7a62a95d1$exports)));
$parcel$export($5d808cc4b6a3c326$exports, "earcut", () => (/*@__PURE__*/$parcel$interopDefault($1b0c9f6ca9bef72e$exports)));
$parcel$export($5d808cc4b6a3c326$exports, "url", () => $149c28eb351207a9$export$128fa18b7194ef);
$parcel$export($5d808cc4b6a3c326$exports, "path", () => $e535525d266072b6$export$bb654e07daaf8c3a);
$parcel$export($5d808cc4b6a3c326$exports, "sayHello", () => $eecbcc1f01f3f84b$export$2c6a96c059a06e7c);
$parcel$export($5d808cc4b6a3c326$exports, "skipHello", () => $eecbcc1f01f3f84b$export$702210f86367d7ed);
$parcel$export($5d808cc4b6a3c326$exports, "isWebGLSupported", () => $cd44038b470b5fa0$export$83dc396b76015322);
$parcel$export($5d808cc4b6a3c326$exports, "hex2rgb", () => $74eb97447ee7d711$export$858a46ce014e0e87);
$parcel$export($5d808cc4b6a3c326$exports, "hex2string", () => $74eb97447ee7d711$export$7a57339af2222169);
$parcel$export($5d808cc4b6a3c326$exports, "rgb2hex", () => $74eb97447ee7d711$export$883528fb0afa7177);
$parcel$export($5d808cc4b6a3c326$exports, "string2hex", () => $74eb97447ee7d711$export$f6a774610dbc2f6);
$parcel$export($5d808cc4b6a3c326$exports, "correctBlendMode", () => $640150753d863d84$export$3d793623cb0d1905);
$parcel$export($5d808cc4b6a3c326$exports, "premultiplyBlendMode", () => $640150753d863d84$export$799d0d31e2f4c737);
$parcel$export($5d808cc4b6a3c326$exports, "premultiplyRgba", () => $640150753d863d84$export$4fa4eaa2922d1869);
$parcel$export($5d808cc4b6a3c326$exports, "premultiplyTint", () => $640150753d863d84$export$1ddadce6229d3efd);
$parcel$export($5d808cc4b6a3c326$exports, "premultiplyTintToRgba", () => $640150753d863d84$export$c75351d34304eb8c);
$parcel$export($5d808cc4b6a3c326$exports, "DATA_URI", () => $6798a7276a625d8d$export$dbafa72958753fce);
$parcel$export($5d808cc4b6a3c326$exports, "createIndicesForQuads", () => $86e5217de37d16a2$export$c56148e1bec42281);
$parcel$export($5d808cc4b6a3c326$exports, "getBufferType", () => $585981d92cbec445$export$adf72b506413cb57);
$parcel$export($5d808cc4b6a3c326$exports, "interleaveTypedArrays", () => $987548fb1dcc0a88$export$1ce3e224e969bb24);
$parcel$export($5d808cc4b6a3c326$exports, "isPow2", () => $5728f69a05940f94$export$eb50b9c078eb6ae7);
$parcel$export($5d808cc4b6a3c326$exports, "log2", () => $5728f69a05940f94$export$b9fae0bba9d9094d);
$parcel$export($5d808cc4b6a3c326$exports, "nextPow2", () => $5728f69a05940f94$export$f0d90cf68bd426eb);
$parcel$export($5d808cc4b6a3c326$exports, "removeItems", () => $c5d3b3fba0229ba7$export$8d47c0e1ce445404);
$parcel$export($5d808cc4b6a3c326$exports, "sign", () => $0014382434d06333$export$c5552dfdbc7cec71);
$parcel$export($5d808cc4b6a3c326$exports, "uid", () => $a8272ede630bda06$export$e2a22331486dcca0);
$parcel$export($5d808cc4b6a3c326$exports, "deprecation", () => $5d432cd6d6627298$export$afd31d834b512e89);
$parcel$export($5d808cc4b6a3c326$exports, "BoundingBox", () => $d323195083f71445$export$63080c4de6cfc362);
$parcel$export($5d808cc4b6a3c326$exports, "BaseTextureCache", () => $db4392de79d671a3$export$cec649a143d060b1);
$parcel$export($5d808cc4b6a3c326$exports, "ProgramCache", () => $db4392de79d671a3$export$d47c7e291d8b6e2c);
$parcel$export($5d808cc4b6a3c326$exports, "TextureCache", () => $db4392de79d671a3$export$4254ab7c0971430e);
$parcel$export($5d808cc4b6a3c326$exports, "clearTextureCache", () => $db4392de79d671a3$export$3ee9cef7c9878d34);
$parcel$export($5d808cc4b6a3c326$exports, "destroyTextureCache", () => $db4392de79d671a3$export$b5c9bc385f713d5a);
$parcel$export($5d808cc4b6a3c326$exports, "CanvasRenderTarget", () => $b3f5765e626c2910$export$525943d4c7cdfa38);
$parcel$export($5d808cc4b6a3c326$exports, "getCanvasBoundingBox", () => $588f8c05547daa75$export$550eedf6c679837d);
$parcel$export($5d808cc4b6a3c326$exports, "trimCanvas", () => $04b74dc1ecafd70d$export$658947b9914dd428);
$parcel$export($5d808cc4b6a3c326$exports, "decomposeDataUri", () => $cda2bae04bf264cb$export$672224f9983ff723);
$parcel$export($5d808cc4b6a3c326$exports, "determineCrossOrigin", () => $f01e55b6e1f6f3d8$export$292083da55c5b406);
$parcel$export($5d808cc4b6a3c326$exports, "getResolutionOfUrl", () => $b264b48efa69e862$export$8695ab2f322d2637);

(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RETINA_PREFIX = /@([0-9\.]+)x/;
(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;



var $f08921b7a62a95d1$exports = {};
"use strict";
var $f08921b7a62a95d1$var$has = Object.prototype.hasOwnProperty, $f08921b7a62a95d1$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $f08921b7a62a95d1$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $f08921b7a62a95d1$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $f08921b7a62a95d1$var$Events().__proto__) $f08921b7a62a95d1$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $f08921b7a62a95d1$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $f08921b7a62a95d1$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $f08921b7a62a95d1$var$EE(fn, context || emitter, once), evt = $f08921b7a62a95d1$var$prefix ? $f08921b7a62a95d1$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $f08921b7a62a95d1$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $f08921b7a62a95d1$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $f08921b7a62a95d1$var$EventEmitter() {
    this._events = new $f08921b7a62a95d1$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($f08921b7a62a95d1$var$has.call(events, name)) names.push($f08921b7a62a95d1$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $f08921b7a62a95d1$var$prefix ? $f08921b7a62a95d1$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $f08921b7a62a95d1$var$prefix ? $f08921b7a62a95d1$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $f08921b7a62a95d1$var$prefix ? $f08921b7a62a95d1$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $f08921b7a62a95d1$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $f08921b7a62a95d1$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $f08921b7a62a95d1$var$prefix ? $f08921b7a62a95d1$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $f08921b7a62a95d1$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $f08921b7a62a95d1$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $f08921b7a62a95d1$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f08921b7a62a95d1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $f08921b7a62a95d1$var$prefix ? $f08921b7a62a95d1$var$prefix + event : event;
        if (this._events[evt]) $f08921b7a62a95d1$var$clearEvent(this, evt);
    } else {
        this._events = new $f08921b7a62a95d1$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$f08921b7a62a95d1$var$EventEmitter.prototype.off = $f08921b7a62a95d1$var$EventEmitter.prototype.removeListener;
$f08921b7a62a95d1$var$EventEmitter.prototype.addListener = $f08921b7a62a95d1$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$f08921b7a62a95d1$var$EventEmitter.prefixed = $f08921b7a62a95d1$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$f08921b7a62a95d1$var$EventEmitter.EventEmitter = $f08921b7a62a95d1$var$EventEmitter;
$f08921b7a62a95d1$exports = $f08921b7a62a95d1$var$EventEmitter;


var $1b0c9f6ca9bef72e$exports = {};
"use strict";
$1b0c9f6ca9bef72e$exports = $1b0c9f6ca9bef72e$var$earcut;
$1b0c9f6ca9bef72e$exports.default = $1b0c9f6ca9bef72e$var$earcut;
function $1b0c9f6ca9bef72e$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $1b0c9f6ca9bef72e$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $1b0c9f6ca9bef72e$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $1b0c9f6ca9bef72e$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $1b0c9f6ca9bef72e$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $1b0c9f6ca9bef72e$var$equals(last, last.next)) {
        $1b0c9f6ca9bef72e$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $1b0c9f6ca9bef72e$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($1b0c9f6ca9bef72e$var$equals(p, p.next) || $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) === 0)) {
            $1b0c9f6ca9bef72e$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $1b0c9f6ca9bef72e$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) : $1b0c9f6ca9bef72e$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $1b0c9f6ca9bef72e$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $1b0c9f6ca9bef72e$var$earcutLinked($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $1b0c9f6ca9bef72e$var$cureLocalIntersections($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim);
                $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $1b0c9f6ca9bef72e$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $1b0c9f6ca9bef72e$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $1b0c9f6ca9bef72e$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $1b0c9f6ca9bef72e$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $1b0c9f6ca9bef72e$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$intersects(a, p, p.next, b) && $1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $1b0c9f6ca9bef72e$var$removeNode(p);
            $1b0c9f6ca9bef72e$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $1b0c9f6ca9bef72e$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $1b0c9f6ca9bef72e$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $1b0c9f6ca9bef72e$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $1b0c9f6ca9bef72e$var$filterPoints(a, a.next);
                c = $1b0c9f6ca9bef72e$var$filterPoints(c, c.next);
                // run earcut on each half
                $1b0c9f6ca9bef72e$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $1b0c9f6ca9bef72e$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($1b0c9f6ca9bef72e$var$getLeftmost(list));
    }
    queue.sort($1b0c9f6ca9bef72e$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $1b0c9f6ca9bef72e$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $1b0c9f6ca9bef72e$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $1b0c9f6ca9bef72e$var$eliminateHole(hole, outerNode) {
    var bridge = $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $1b0c9f6ca9bef72e$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $1b0c9f6ca9bef72e$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $1b0c9f6ca9bef72e$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $1b0c9f6ca9bef72e$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($1b0c9f6ca9bef72e$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p) {
    return $1b0c9f6ca9bef72e$var$area(m.prev, m, p.prev) < 0 && $1b0c9f6ca9bef72e$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $1b0c9f6ca9bef72e$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $1b0c9f6ca9bef72e$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $1b0c9f6ca9bef72e$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $1b0c9f6ca9bef72e$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $1b0c9f6ca9bef72e$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $1b0c9f6ca9bef72e$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a) && $1b0c9f6ca9bef72e$var$middleInside(a, b) && // locally visible
    ($1b0c9f6ca9bef72e$var$area(a.prev, a, b.prev) || $1b0c9f6ca9bef72e$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) > 0 && $1b0c9f6ca9bef72e$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $1b0c9f6ca9bef72e$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $1b0c9f6ca9bef72e$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $1b0c9f6ca9bef72e$var$intersects(p1, q1, p2, q2) {
    var o1 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, p2));
    var o2 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, q2));
    var o3 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, p1));
    var o4 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $1b0c9f6ca9bef72e$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $1b0c9f6ca9bef72e$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $1b0c9f6ca9bef72e$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $1b0c9f6ca9bef72e$var$locallyInside(a, b) {
    return $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) < 0 ? $1b0c9f6ca9bef72e$var$area(a, b, a.next) >= 0 && $1b0c9f6ca9bef72e$var$area(a, a.prev, b) >= 0 : $1b0c9f6ca9bef72e$var$area(a, b, a.prev) < 0 || $1b0c9f6ca9bef72e$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $1b0c9f6ca9bef72e$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $1b0c9f6ca9bef72e$var$splitPolygon(a, b) {
    var a2 = new $1b0c9f6ca9bef72e$var$Node(a.i, a.x, a.y), b2 = new $1b0c9f6ca9bef72e$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $1b0c9f6ca9bef72e$var$insertNode(i, x, y, last) {
    var p = new $1b0c9f6ca9bef72e$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $1b0c9f6ca9bef72e$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $1b0c9f6ca9bef72e$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$1b0c9f6ca9bef72e$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$1b0c9f6ca9bef72e$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};


// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $839926bed9943d91$export$98e6a39c04603d36;
var $839926bed9943d91$export$f7ad0328861e2f03;
var $839926bed9943d91$export$7daf1a5d2f4dd018;
var $839926bed9943d91$export$d9468344d3651243;
var $839926bed9943d91$export$59d795186a5d3f58;
"use strict";

var $fFTr1 = parcelRequire("fFTr1");
var $580eeb5fe210d44a$exports = {};
"use strict";
$580eeb5fe210d44a$exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};


$839926bed9943d91$export$98e6a39c04603d36 = $839926bed9943d91$var$urlParse;
$839926bed9943d91$export$f7ad0328861e2f03 = $839926bed9943d91$var$urlResolve;
$839926bed9943d91$export$7daf1a5d2f4dd018 = $839926bed9943d91$var$urlResolveObject;
$839926bed9943d91$export$d9468344d3651243 = $839926bed9943d91$var$urlFormat;
$839926bed9943d91$export$59d795186a5d3f58 = $839926bed9943d91$var$Url;
function $839926bed9943d91$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $839926bed9943d91$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $839926bed9943d91$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$839926bed9943d91$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$839926bed9943d91$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$839926bed9943d91$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($839926bed9943d91$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$839926bed9943d91$var$autoEscape = [
    "'"
].concat($839926bed9943d91$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$839926bed9943d91$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($839926bed9943d91$var$autoEscape), $839926bed9943d91$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $839926bed9943d91$var$hostnameMaxLen = 255, $839926bed9943d91$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $839926bed9943d91$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$839926bed9943d91$var$unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
$839926bed9943d91$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$839926bed9943d91$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
var $6fccb246f9bde9ce$export$2f872c0f2117be69;
var $6fccb246f9bde9ce$export$98e6a39c04603d36;
var $6fccb246f9bde9ce$export$c564cdbbe6da493;
var $6fccb246f9bde9ce$export$fac44ee5b035f737;
"use strict";

$6fccb246f9bde9ce$export$2f872c0f2117be69 = $6fccb246f9bde9ce$export$98e6a39c04603d36 = (parcelRequire("kzGqM"));

$6fccb246f9bde9ce$export$c564cdbbe6da493 = $6fccb246f9bde9ce$export$fac44ee5b035f737 = (parcelRequire("kWD7b"));


function $839926bed9943d91$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $580eeb5fe210d44a$exports.isObject(url) && url instanceof $839926bed9943d91$var$Url) return url;
    var u = new $839926bed9943d91$var$Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$839926bed9943d91$var$Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$580eeb5fe210d44a$exports.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $839926bed9943d91$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $6fccb246f9bde9ce$export$98e6a39c04603d36(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = $839926bed9943d91$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $839926bed9943d91$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$839926bed9943d91$var$hostlessProtocol[proto] && (slashes || proto && !$839926bed9943d91$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < $839926bed9943d91$var$hostEndingChars.length; i++){
            var hec = rest.indexOf($839926bed9943d91$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < $839926bed9943d91$var$nonHostChars.length; i++){
            var hec = rest.indexOf($839926bed9943d91$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($839926bed9943d91$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($839926bed9943d91$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($839926bed9943d91$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $839926bed9943d91$var$hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $fFTr1.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!$839926bed9943d91$var$unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = $839926bed9943d91$var$autoEscape.length; i < l; i++){
        var ae = $839926bed9943d91$var$autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $6fccb246f9bde9ce$export$98e6a39c04603d36(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if ($839926bed9943d91$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function $839926bed9943d91$var$urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($580eeb5fe210d44a$exports.isString(obj)) obj = $839926bed9943d91$var$urlParse(obj);
    if (!(obj instanceof $839926bed9943d91$var$Url)) return $839926bed9943d91$var$Url.prototype.format.call(obj);
    return obj.format();
}
$839926bed9943d91$var$Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $580eeb5fe210d44a$exports.isObject(this.query) && Object.keys(this.query).length) query = $6fccb246f9bde9ce$export$fac44ee5b035f737(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || $839926bed9943d91$var$slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function $839926bed9943d91$var$urlResolve(source, relative) {
    return $839926bed9943d91$var$urlParse(source, false, true).resolve(relative);
}
$839926bed9943d91$var$Url.prototype.resolve = function(relative) {
    return this.resolveObject($839926bed9943d91$var$urlParse(relative, false, true)).format();
};
function $839926bed9943d91$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $839926bed9943d91$var$urlParse(source, false, true).resolveObject(relative);
}
$839926bed9943d91$var$Url.prototype.resolveObject = function(relative) {
    if ($580eeb5fe210d44a$exports.isString(relative)) {
        var rel = new $839926bed9943d91$var$Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $839926bed9943d91$var$Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if ($839926bed9943d91$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!$839926bed9943d91$var$slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$839926bed9943d91$var$hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !$839926bed9943d91$var$slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$580eeb5fe210d44a$exports.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$580eeb5fe210d44a$exports.isNull(result.pathname) || !$580eeb5fe210d44a$exports.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$580eeb5fe210d44a$exports.isNull(result.pathname) || !$580eeb5fe210d44a$exports.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$839926bed9943d91$var$Url.prototype.parseHost = function() {
    var host = this.host;
    var port = $839926bed9943d91$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};


const $149c28eb351207a9$export$128fa18b7194ef = {
    parse: (0, $839926bed9943d91$export$98e6a39c04603d36),
    format: (0, $839926bed9943d91$export$d9468344d3651243),
    resolve: (0, $839926bed9943d91$export$f7ad0328861e2f03)
};



function $e535525d266072b6$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $e535525d266072b6$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $e535525d266072b6$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $e535525d266072b6$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($e535525d266072b6$var$escapeRegExp(find), "g"), replace);
}
function $e535525d266072b6$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $e535525d266072b6$export$bb654e07daaf8c3a = {
    toPosix (path2) {
        return $e535525d266072b6$var$replaceAll(path2, "\\", "/");
    },
    isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    hasProtocol (path2) {
        return /^[^/:]+:\//.test(this.toPosix(path2));
    },
    getProtocol (path2) {
        $e535525d266072b6$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let protocol = "";
        const isFile = /^file:\/\/\//.exec(path2);
        const isHttp = /^[^/:]+:\/\//.exec(path2);
        const isWindows = /^[^/:]+:\//.exec(path2);
        if (isFile || isHttp || isWindows) {
            const arr = isFile?.[0] || isHttp?.[0] || isWindows?.[0];
            protocol = arr;
            path2 = path2.slice(arr.length);
        }
        return protocol;
    },
    toAbsolute (url, customBaseUrl, customRootUrl) {
        if (this.isDataUrl(url)) return url;
        const baseUrl = $e535525d266072b6$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getBaseUrl()));
        const rootUrl = $e535525d266072b6$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        $e535525d266072b6$var$assertPath(url);
        url = this.toPosix(url);
        if (url.startsWith("/")) return $e535525d266072b6$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    normalize (path2) {
        path2 = this.toPosix(path2);
        $e535525d266072b6$var$assertPath(path2);
        if (path2.length === 0) return ".";
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $e535525d266072b6$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    isAbsolute (path2) {
        $e535525d266072b6$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $e535525d266072b6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.extname(prevArg)) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    dirname (path2) {
        $e535525d266072b6$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    rootname (path2) {
        $e535525d266072b6$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    basename (path2, ext) {
        $e535525d266072b6$var$assertPath(path2);
        if (ext) $e535525d266072b6$var$assertPath(ext);
        path2 = $e535525d266072b6$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    extname (path2) {
        $e535525d266072b6$var$assertPath(path2);
        path2 = $e535525d266072b6$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    parse (path2) {
        $e535525d266072b6$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $e535525d266072b6$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":"
};


const $5d432cd6d6627298$var$warnings = {};
function $5d432cd6d6627298$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($5d432cd6d6627298$var$warnings[message]) return;
    let stack = new Error().stack;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (console.groupCollapsed) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
            console.warn(stack);
        }
    }
    $5d432cd6d6627298$var$warnings[message] = true;
}


function $eecbcc1f01f3f84b$export$702210f86367d7ed() {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "skipHello is deprecated, please use settings.RENDER_OPTIONS.hello");
}
function $eecbcc1f01f3f84b$export$2c6a96c059a06e7c() {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", `sayHello is deprecated, please use Renderer's "hello" option`);
}




let $cd44038b470b5fa0$var$supported;
function $cd44038b470b5fa0$export$83dc396b76015322() {
    if (typeof $cd44038b470b5fa0$var$supported === "undefined") $cd44038b470b5fa0$var$supported = function supported2() {
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
        };
        try {
            if (!(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext()) return false;
            const canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            let gl = canvas.getContext("webgl", contextOptions) || canvas.getContext("experimental-webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (e) {
            return false;
        }
    }();
    return $cd44038b470b5fa0$var$supported;
}


var $00fdc0fdfd66324b$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $00fdc0fdfd66324b$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $00fdc0fdfd66324b$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $00fdc0fdfd66324b$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $00fdc0fdfd66324b$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $00fdc0fdfd66324b$var$a = function(r) {
    return {
        r: $00fdc0fdfd66324b$var$e(r.r, 0, 255),
        g: $00fdc0fdfd66324b$var$e(r.g, 0, 255),
        b: $00fdc0fdfd66324b$var$e(r.b, 0, 255),
        a: $00fdc0fdfd66324b$var$e(r.a)
    };
}, $00fdc0fdfd66324b$var$o = function(r) {
    return {
        r: $00fdc0fdfd66324b$var$n(r.r),
        g: $00fdc0fdfd66324b$var$n(r.g),
        b: $00fdc0fdfd66324b$var$n(r.b),
        a: $00fdc0fdfd66324b$var$n(r.a, 3)
    };
}, $00fdc0fdfd66324b$var$i = /^#([0-9a-f]{3,8})$/i, $00fdc0fdfd66324b$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $00fdc0fdfd66324b$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $00fdc0fdfd66324b$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $00fdc0fdfd66324b$var$g = function(r) {
    return {
        h: $00fdc0fdfd66324b$var$u(r.h),
        s: $00fdc0fdfd66324b$var$e(r.s, 0, 100),
        l: $00fdc0fdfd66324b$var$e(r.l, 0, 100),
        a: $00fdc0fdfd66324b$var$e(r.a)
    };
}, $00fdc0fdfd66324b$var$d = function(r) {
    return {
        h: $00fdc0fdfd66324b$var$n(r.h),
        s: $00fdc0fdfd66324b$var$n(r.s),
        l: $00fdc0fdfd66324b$var$n(r.l),
        a: $00fdc0fdfd66324b$var$n(r.a, 3)
    };
}, $00fdc0fdfd66324b$var$f = function(r) {
    var t, n, e;
    return $00fdc0fdfd66324b$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $00fdc0fdfd66324b$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $00fdc0fdfd66324b$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $00fdc0fdfd66324b$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$y = {
    string: [
        [
            function(r) {
                var t = $00fdc0fdfd66324b$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $00fdc0fdfd66324b$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $00fdc0fdfd66324b$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $00fdc0fdfd66324b$var$v.exec(r) || $00fdc0fdfd66324b$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $00fdc0fdfd66324b$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $00fdc0fdfd66324b$var$l.exec(t) || $00fdc0fdfd66324b$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $00fdc0fdfd66324b$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($00fdc0fdfd66324b$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $00fdc0fdfd66324b$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $00fdc0fdfd66324b$var$t(n) && $00fdc0fdfd66324b$var$t(e) && $00fdc0fdfd66324b$var$t(u) ? $00fdc0fdfd66324b$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$00fdc0fdfd66324b$var$t(n) || !$00fdc0fdfd66324b$var$t(e) || !$00fdc0fdfd66324b$var$t(u)) return null;
                var i = $00fdc0fdfd66324b$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $00fdc0fdfd66324b$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$00fdc0fdfd66324b$var$t(n) || !$00fdc0fdfd66324b$var$t(a) || !$00fdc0fdfd66324b$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $00fdc0fdfd66324b$var$u(r.h),
                        s: $00fdc0fdfd66324b$var$e(r.s, 0, 100),
                        v: $00fdc0fdfd66324b$var$e(r.v, 0, 100),
                        a: $00fdc0fdfd66324b$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $00fdc0fdfd66324b$var$b(h);
            },
            "hsv"
        ]
    ]
}, $00fdc0fdfd66324b$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $00fdc0fdfd66324b$var$x = function(r) {
    return "string" == typeof r ? $00fdc0fdfd66324b$var$N(r.trim(), $00fdc0fdfd66324b$var$y.string) : "object" == typeof r && null !== r ? $00fdc0fdfd66324b$var$N(r, $00fdc0fdfd66324b$var$y.object) : [
        null,
        void 0
    ];
}, $00fdc0fdfd66324b$export$f61ac8b6f1f46202 = function(r) {
    return $00fdc0fdfd66324b$var$x(r)[1];
}, $00fdc0fdfd66324b$var$M = function(r, t) {
    var n = $00fdc0fdfd66324b$var$c(r);
    return {
        h: n.h,
        s: $00fdc0fdfd66324b$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $00fdc0fdfd66324b$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $00fdc0fdfd66324b$var$$ = function(r, t) {
    var n = $00fdc0fdfd66324b$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $00fdc0fdfd66324b$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $00fdc0fdfd66324b$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $00fdc0fdfd66324b$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $00fdc0fdfd66324b$var$n($00fdc0fdfd66324b$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $00fdc0fdfd66324b$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $00fdc0fdfd66324b$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $00fdc0fdfd66324b$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $00fdc0fdfd66324b$var$s($00fdc0fdfd66324b$var$n(255 * a)) : "", "#" + $00fdc0fdfd66324b$var$s(t) + $00fdc0fdfd66324b$var$s(e) + $00fdc0fdfd66324b$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $00fdc0fdfd66324b$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $00fdc0fdfd66324b$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $00fdc0fdfd66324b$var$d($00fdc0fdfd66324b$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $00fdc0fdfd66324b$var$d($00fdc0fdfd66324b$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $00fdc0fdfd66324b$var$h(this.rgba), {
            h: $00fdc0fdfd66324b$var$n(r.h),
            s: $00fdc0fdfd66324b$var$n(r.s),
            v: $00fdc0fdfd66324b$var$n(r.v),
            a: $00fdc0fdfd66324b$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $00fdc0fdfd66324b$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $00fdc0fdfd66324b$var$c(this.rgba);
        return "number" == typeof r ? $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $00fdc0fdfd66324b$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $00fdc0fdfd66324b$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $00fdc0fdfd66324b$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $00fdc0fdfd66324b$export$4d30ed660ff08d0 ? r : new $00fdc0fdfd66324b$export$4d30ed660ff08d0(r);
}, $00fdc0fdfd66324b$var$S = [], $00fdc0fdfd66324b$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $00fdc0fdfd66324b$var$S.indexOf(r) < 0 && (r($00fdc0fdfd66324b$export$4d30ed660ff08d0, $00fdc0fdfd66324b$var$y), $00fdc0fdfd66324b$var$S.push(r));
    });
}, $00fdc0fdfd66324b$export$4385e60b38654f68 = function() {
    return new $00fdc0fdfd66324b$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};


function $5eb410ed4620676c$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}


(0, $00fdc0fdfd66324b$export$8b58be045bf06082)([
    (0, $5eb410ed4620676c$export$2e2bcd8739ae039)
]);
const $6c0bc7edac0d7e9d$var$_Color = class {
    constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    get red() {
        return this._components[0];
    }
    get green() {
        return this._components[1];
    }
    get blue() {
        return this._components[2];
    }
    get alpha() {
        return this._components[3];
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    set value(value) {
        if (value instanceof $6c0bc7edac0d7e9d$var$_Color) {
            this._value = this.cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set PIXI.Color#value to null");
        else if (this._value === null || !this.isSourceEqual(this._value, value)) {
            this.normalize(value);
            this._value = this.cloneSource(value);
        }
    }
    get value() {
        return this._value;
    }
    cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        out = out ?? [];
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    toRgbArray(out) {
        out = out ?? [];
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    toNumber() {
        return this._int;
    }
    toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    multiply(value) {
        const [r, g, b, a] = $6c0bc7edac0d7e9d$var$_Color.temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this.refreshInt();
        this._value = null;
        return this;
    }
    premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this.refreshInt();
        this._value = null;
        return this;
    }
    toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        return this;
    }
    round(steps) {
        const [r, g, b] = this._components;
        this._components[0] = Math.round(r * steps) / steps;
        this._components[1] = Math.round(g * steps) / steps;
        this._components[2] = Math.round(b * steps) / steps;
        this.refreshInt();
        this._value = null;
        return this;
    }
    toArray(out) {
        out = out ?? [];
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = $6c0bc7edac0d7e9d$var$_Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(value);
            if (color.isValid()) {
                ({ r: r , g: g , b: b , a: a  } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this.refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
};
let $6c0bc7edac0d7e9d$export$892596cec99bc70e = $6c0bc7edac0d7e9d$var$_Color;
$6c0bc7edac0d7e9d$export$892596cec99bc70e.shared = new $6c0bc7edac0d7e9d$var$_Color();
$6c0bc7edac0d7e9d$export$892596cec99bc70e.temp = new $6c0bc7edac0d7e9d$var$_Color();
$6c0bc7edac0d7e9d$export$892596cec99bc70e.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;





function $74eb97447ee7d711$export$858a46ce014e0e87(hex, out = []) {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.2.0", "utils.hex2rgb is deprecated, use Color#toRgbArray instead");
    return (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(hex).toRgbArray(out);
}
function $74eb97447ee7d711$export$7a57339af2222169(hex) {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.2.0", "utils.hex2string is deprecated, use Color#toHex instead");
    return (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(hex).toHex();
}
function $74eb97447ee7d711$export$f6a774610dbc2f6(string) {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.2.0", "utils.string2hex is deprecated, use Color#toNumber instead");
    return (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(string).toNumber();
}
function $74eb97447ee7d711$export$883528fb0afa7177(rgb) {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.2.0", "utils.rgb2hex is deprecated, use Color#toNumber instead");
    return (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(rgb).toNumber();
}





function $640150753d863d84$var$mapPremultipliedBlendModes() {
    const pm = [];
    const npm = [];
    for(let i = 0; i < 32; i++){
        pm[i] = i;
        npm[i] = i;
    }
    pm[(0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL_NPM] = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL;
    pm[(0, $551209d754b5b429$export$f821c68fe9beaecf).ADD_NPM] = (0, $551209d754b5b429$export$f821c68fe9beaecf).ADD;
    pm[(0, $551209d754b5b429$export$f821c68fe9beaecf).SCREEN_NPM] = (0, $551209d754b5b429$export$f821c68fe9beaecf).SCREEN;
    npm[(0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL] = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL_NPM;
    npm[(0, $551209d754b5b429$export$f821c68fe9beaecf).ADD] = (0, $551209d754b5b429$export$f821c68fe9beaecf).ADD_NPM;
    npm[(0, $551209d754b5b429$export$f821c68fe9beaecf).SCREEN] = (0, $551209d754b5b429$export$f821c68fe9beaecf).SCREEN_NPM;
    const array = [];
    array.push(npm);
    array.push(pm);
    return array;
}
const $640150753d863d84$export$799d0d31e2f4c737 = $640150753d863d84$var$mapPremultipliedBlendModes();
function $640150753d863d84$export$3d793623cb0d1905(blendMode, premultiplied) {
    return $640150753d863d84$export$799d0d31e2f4c737[premultiplied ? 1 : 0][blendMode];
}
function $640150753d863d84$export$4fa4eaa2922d1869(rgb, alpha, out, premultiply = true) {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.2.0", `utils.premultiplyRgba has moved to Color.premultiply`);
    return (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(rgb).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}
function $640150753d863d84$export$1ddadce6229d3efd(tint, alpha) {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.2.0", `utils.premultiplyTint has moved to Color.toPremultiplied`);
    return (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(tint).toPremultiplied(alpha);
}
function $640150753d863d84$export$c75351d34304eb8c(tint, alpha, out, premultiply = true) {
    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.2.0", `utils.premultiplyTintToRgba has moved to Color.premultiply`);
    return (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(tint).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}


const $6798a7276a625d8d$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;


function $86e5217de37d16a2$export$c56148e1bec42281(size, outBuffer = null) {
    const totalIndices = size * 6;
    outBuffer = outBuffer || new Uint16Array(totalIndices);
    if (outBuffer.length !== totalIndices) throw new Error(`Out buffer length is incorrect, got ${outBuffer.length} and expected ${totalIndices}`);
    for(let i = 0, j = 0; i < totalIndices; i += 6, j += 4){
        outBuffer[i + 0] = j + 0;
        outBuffer[i + 1] = j + 1;
        outBuffer[i + 2] = j + 2;
        outBuffer[i + 3] = j + 0;
        outBuffer[i + 4] = j + 2;
        outBuffer[i + 5] = j + 3;
    }
    return outBuffer;
}


function $585981d92cbec445$export$adf72b506413cb57(array) {
    if (array.BYTES_PER_ELEMENT === 4) {
        if (array instanceof Float32Array) return "Float32Array";
        else if (array instanceof Uint32Array) return "Uint32Array";
        return "Int32Array";
    } else if (array.BYTES_PER_ELEMENT === 2) {
        if (array instanceof Uint16Array) return "Uint16Array";
    } else if (array.BYTES_PER_ELEMENT === 1) {
        if (array instanceof Uint8Array) return "Uint8Array";
    }
    return null;
}



const $987548fb1dcc0a88$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $987548fb1dcc0a88$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0;
    let stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++){
        stride += sizes[i];
        outSize += arrays[i].length;
    }
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null;
    let littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i];
        const array = arrays[i];
        const type = (0, $585981d92cbec445$export$adf72b506413cb57)(array);
        if (!views[type]) views[type] = new $987548fb1dcc0a88$var$map[type](buffer);
        out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset;
            const index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}


function $5728f69a05940f94$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $5728f69a05940f94$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $5728f69a05940f94$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}


function $c5d3b3fba0229ba7$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}


function $0014382434d06333$export$c5552dfdbc7cec71(n) {
    if (n === 0) return 0;
    return n < 0 ? -1 : 1;
}


let $a8272ede630bda06$var$nextUid = 0;
function $a8272ede630bda06$export$e2a22331486dcca0() {
    return ++$a8272ede630bda06$var$nextUid;
}



const $d323195083f71445$var$_BoundingBox = class {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
    get width() {
        return this.right - this.left;
    }
    get height() {
        return this.bottom - this.top;
    }
    isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
};
let $d323195083f71445$export$63080c4de6cfc362 = $d323195083f71445$var$_BoundingBox;
$d323195083f71445$export$63080c4de6cfc362.EMPTY = new $d323195083f71445$var$_BoundingBox(0, 0, 0, 0);


const $db4392de79d671a3$export$d47c7e291d8b6e2c = {};
const $db4392de79d671a3$export$4254ab7c0971430e = /* @__PURE__ */ Object.create(null);
const $db4392de79d671a3$export$cec649a143d060b1 = /* @__PURE__ */ Object.create(null);
function $db4392de79d671a3$export$b5c9bc385f713d5a() {
    let key;
    for(key in $db4392de79d671a3$export$4254ab7c0971430e)$db4392de79d671a3$export$4254ab7c0971430e[key].destroy();
    for(key in $db4392de79d671a3$export$cec649a143d060b1)$db4392de79d671a3$export$cec649a143d060b1[key].destroy();
}
function $db4392de79d671a3$export$3ee9cef7c9878d34() {
    let key;
    for(key in $db4392de79d671a3$export$4254ab7c0971430e)delete $db4392de79d671a3$export$4254ab7c0971430e[key];
    for(key in $db4392de79d671a3$export$cec649a143d060b1)delete $db4392de79d671a3$export$cec649a143d060b1[key];
}



class $b3f5765e626c2910$export$525943d4c7cdfa38 {
    constructor(width, height, resolution){
        this._canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
        this._context = this._canvas.getContext("2d");
        this.resolution = resolution || (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
        this.resize(width, height);
    }
    clear() {
        this._checkDestroyed();
        this._context.setTransform(1, 0, 0, 1, 0, 0);
        this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    }
    resize(desiredWidth, desiredHeight) {
        this._checkDestroyed();
        this._canvas.width = Math.round(desiredWidth * this.resolution);
        this._canvas.height = Math.round(desiredHeight * this.resolution);
    }
    destroy() {
        this._context = null;
        this._canvas = null;
    }
    get width() {
        this._checkDestroyed();
        return this._canvas.width;
    }
    set width(val) {
        this._checkDestroyed();
        this._canvas.width = Math.round(val);
    }
    get height() {
        this._checkDestroyed();
        return this._canvas.height;
    }
    set height(val) {
        this._checkDestroyed();
        this._canvas.height = Math.round(val);
    }
    get canvas() {
        this._checkDestroyed();
        return this._canvas;
    }
    get context() {
        this._checkDestroyed();
        return this._context;
    }
    _checkDestroyed() {
        if (this._canvas === null) throw new TypeError("The CanvasRenderTarget has already been destroyed");
    }
}



function $588f8c05547daa75$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $588f8c05547daa75$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $588f8c05547daa75$export$550eedf6c679837d(canvas) {
    const { width: width , height: height  } = canvas;
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    if (context === null) throw new TypeError("Failed to get canvas 2D context");
    const imageData = context.getImageData(0, 0, width, height);
    const data = imageData.data;
    let left = 0;
    let top = 0;
    let right = width - 1;
    let bottom = height - 1;
    while(top < height && $588f8c05547daa75$var$checkRow(data, width, top))++top;
    if (top === height) return (0, $d323195083f71445$export$63080c4de6cfc362).EMPTY;
    while($588f8c05547daa75$var$checkRow(data, width, bottom))--bottom;
    while($588f8c05547daa75$var$checkColumn(data, width, left, top, bottom))++left;
    while($588f8c05547daa75$var$checkColumn(data, width, right, top, bottom))--right;
    ++right;
    ++bottom;
    return new (0, $d323195083f71445$export$63080c4de6cfc362)(left, top, right, bottom);
}



function $04b74dc1ecafd70d$export$658947b9914dd428(canvas) {
    const boundingBox = (0, $588f8c05547daa75$export$550eedf6c679837d)(canvas);
    const { width: width , height: height  } = boundingBox;
    let data = null;
    if (!boundingBox.isEmpty()) {
        const context = canvas.getContext("2d");
        if (context === null) throw new TypeError("Failed to get canvas 2D context");
        data = context.getImageData(boundingBox.left, boundingBox.top, width, height);
    }
    return {
        width: width,
        height: height,
        data: data
    };
}



function $cda2bae04bf264cb$export$672224f9983ff723(dataUri) {
    const dataUriMatch = (0, $6798a7276a625d8d$export$dbafa72958753fce).exec(dataUri);
    if (dataUriMatch) return {
        mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : void 0,
        subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : void 0,
        charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : void 0,
        encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : void 0,
        data: dataUriMatch[5]
    };
    return void 0;
}



let $f01e55b6e1f6f3d8$var$tempAnchor;
function $f01e55b6e1f6f3d8$export$292083da55c5b406(url$1, loc = globalThis.location) {
    if (url$1.startsWith("data:")) return "";
    loc = loc || globalThis.location;
    if (!$f01e55b6e1f6f3d8$var$tempAnchor) $f01e55b6e1f6f3d8$var$tempAnchor = document.createElement("a");
    $f01e55b6e1f6f3d8$var$tempAnchor.href = url$1;
    const parsedUrl = (0, $149c28eb351207a9$export$128fa18b7194ef).parse($f01e55b6e1f6f3d8$var$tempAnchor.href);
    const samePort = !parsedUrl.port && loc.port === "" || parsedUrl.port === loc.port;
    if (parsedUrl.hostname !== loc.hostname || !samePort || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}




function $b264b48efa69e862$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}








var $0fcbd3e56b89a698$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Renderer"] = "renderer";
    ExtensionType2["Application"] = "application";
    ExtensionType2["RendererSystem"] = "renderer-webgl-system";
    ExtensionType2["RendererPlugin"] = "renderer-webgl-plugin";
    ExtensionType2["CanvasRendererSystem"] = "renderer-canvas-system";
    ExtensionType2["CanvasRendererPlugin"] = "renderer-canvas-plugin";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    return ExtensionType2;
})($0fcbd3e56b89a698$export$4f037c6ec2da4eeb || {});
const $0fcbd3e56b89a698$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $0fcbd3e56b89a698$var$normalizePriority = (ext, defaultPriority)=>$0fcbd3e56b89a698$var$normalizeExtension(ext).priority ?? defaultPriority;
const $0fcbd3e56b89a698$export$cc3e2d3244e01b7f = {
    _addHandlers: {},
    _removeHandlers: {},
    _queue: {},
    remove (...extensions2) {
        extensions2.map($0fcbd3e56b89a698$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    add (...extensions2) {
        extensions2.map($0fcbd3e56b89a698$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type].push(ext);
                } else handlers[type](ext);
            });
        });
        return this;
    },
    handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type].forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            map[extension.name] = extension.ref;
        }, (extension)=>{
            delete map[extension.name];
        });
    },
    handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$0fcbd3e56b89a698$var$normalizePriority(b, defaultPriority) - $0fcbd3e56b89a698$var$normalizePriority(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    }
};




class $847a0d28fb79d582$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
    }
    get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    get uint16View() {
        if (!this._uint16View) this._uint16View = new Uint16Array(this.rawBinaryData);
        return this._uint16View;
    }
    get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    view(type) {
        return this[`${type}View`];
    }
    destroy() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this._uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    }
    static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}


const $4b083c03bd574f03$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join("\n");
function $4b083c03bd574f03$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i){
        if (i > 0) src += "\nelse ";
        if (i < maxIfs - 1) src += `if(test == ${i}.0){}`;
    }
    return src;
}
function $4b083c03bd574f03$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    while(true){
        const fragmentSrc = $4b083c03bd574f03$var$fragTemplate.replace(/%forloop%/gi, $4b083c03bd574f03$var$generateIfTestSrc(maxIfs));
        gl.shaderSource(shader, fragmentSrc);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
        else break;
    }
    return maxIfs;
}



const $15a50e9cd387ae21$var$BLEND = 0;
const $15a50e9cd387ae21$var$OFFSET = 1;
const $15a50e9cd387ae21$var$CULLING = 2;
const $15a50e9cd387ae21$var$DEPTH_TEST = 3;
const $15a50e9cd387ae21$var$WINDING = 4;
const $15a50e9cd387ae21$var$DEPTH_MASK = 5;
class $15a50e9cd387ae21$export$7254cc27399e90bd {
    constructor(){
        this.data = 0;
        this.blendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL;
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    }
    get blend() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$BLEND);
    }
    set blend(value) {
        if (!!(this.data & 1 << $15a50e9cd387ae21$var$BLEND) !== value) this.data ^= 1 << $15a50e9cd387ae21$var$BLEND;
    }
    get offsets() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$OFFSET);
    }
    set offsets(value) {
        if (!!(this.data & 1 << $15a50e9cd387ae21$var$OFFSET) !== value) this.data ^= 1 << $15a50e9cd387ae21$var$OFFSET;
    }
    get culling() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$CULLING);
    }
    set culling(value) {
        if (!!(this.data & 1 << $15a50e9cd387ae21$var$CULLING) !== value) this.data ^= 1 << $15a50e9cd387ae21$var$CULLING;
    }
    get depthTest() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_TEST);
    }
    set depthTest(value) {
        if (!!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_TEST) !== value) this.data ^= 1 << $15a50e9cd387ae21$var$DEPTH_TEST;
    }
    get depthMask() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_MASK);
    }
    set depthMask(value) {
        if (!!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_MASK) !== value) this.data ^= 1 << $15a50e9cd387ae21$var$DEPTH_MASK;
    }
    get clockwiseFrontFace() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        if (!!(this.data & 1 << $15a50e9cd387ae21$var$WINDING) !== value) this.data ^= 1 << $15a50e9cd387ae21$var$WINDING;
    }
    get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== (0, $551209d754b5b429$export$f821c68fe9beaecf).NONE;
        this._blendMode = value;
    }
    get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value;
        this._polygonOffset = value;
    }
    toString() {
        return `[@pixi/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
    }
    static for2d() {
        const state = new $15a50e9cd387ae21$export$7254cc27399e90bd();
        state.depthTest = false;
        state.blend = true;
        return state;
    }
}





const $992246b926b958eb$export$7db5d8a07d9761e1 = [];
function $992246b926b958eb$export$5eb9e949a7ff46a7(source, options) {
    if (!source) return null;
    let extension = "";
    if (typeof source === "string") {
        const result = /\.(\w{3,4})(?:$|\?|#)/i.exec(source);
        if (result) extension = result[1].toLowerCase();
    }
    for(let i = $992246b926b958eb$export$7db5d8a07d9761e1.length - 1; i >= 0; --i){
        const ResourcePlugin = $992246b926b958eb$export$7db5d8a07d9761e1[i];
        if (ResourcePlugin.test && ResourcePlugin.test(source, extension)) return new ResourcePlugin(source, options);
    }
    throw new Error("Unrecognized source type to auto-detect Resource");
}



class $e008d4155c799e69$export$571ad3bcba5a0c45 {
    constructor(name){
        this.items = [];
        this._name = name;
        this._aliasCount = 0;
    }
    emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        if (arguments.length > 8) throw new Error("max arguments reached");
        const { name: name , items: items  } = this;
        this._aliasCount++;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        if (items === this.items) this._aliasCount--;
        return this;
    }
    ensureNonAliasedItems() {
        if (this._aliasCount > 0 && this.items.length > 1) {
            this._aliasCount = 0;
            this.items = this.items.slice(0);
        }
    }
    add(item) {
        if (item[this._name]) {
            this.ensureNonAliasedItems();
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.ensureNonAliasedItems();
            this.items.splice(index, 1);
        }
        return this;
    }
    contains(item) {
        return this.items.includes(item);
    }
    removeAll() {
        this.ensureNonAliasedItems();
        this.items.length = 0;
        return this;
    }
    destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    get empty() {
        return this.items.length === 0;
    }
    get name() {
        return this._name;
    }
}
Object.defineProperties($e008d4155c799e69$export$571ad3bcba5a0c45.prototype, {
    dispatch: {
        value: $e008d4155c799e69$export$571ad3bcba5a0c45.prototype.emit
    },
    run: {
        value: $e008d4155c799e69$export$571ad3bcba5a0c45.prototype.emit
    }
});




class $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63 {
    constructor(width = 0, height = 0){
        this._width = width;
        this._height = height;
        this.destroyed = false;
        this.internal = false;
        this.onResize = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("setRealSize");
        this.onUpdate = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("update");
        this.onError = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("onError");
    }
    bind(baseTexture) {
        this.onResize.add(baseTexture);
        this.onUpdate.add(baseTexture);
        this.onError.add(baseTexture);
        if (this._width || this._height) this.onResize.emit(this._width, this._height);
    }
    unbind(baseTexture) {
        this.onResize.remove(baseTexture);
        this.onUpdate.remove(baseTexture);
        this.onError.remove(baseTexture);
    }
    resize(width, height) {
        if (width !== this._width || height !== this._height) {
            this._width = width;
            this._height = height;
            this.onResize.emit(width, height);
        }
    }
    get valid() {
        return !!this._width && !!this._height;
    }
    update() {
        if (!this.destroyed) this.onUpdate.emit();
    }
    load() {
        return Promise.resolve(this);
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    style(_renderer, _baseTexture, _glTexture) {
        return false;
    }
    dispose() {}
    destroy() {
        if (!this.destroyed) {
            this.destroyed = true;
            this.dispose();
            this.onError.removeAll();
            this.onError = null;
            this.onResize.removeAll();
            this.onResize = null;
            this.onUpdate.removeAll();
            this.onUpdate = null;
        }
    }
    static test(_source, _extension) {
        return false;
    }
}


class $ad9971bad38b5f89$export$a79ef781de624449 extends (0, $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63) {
    constructor(source, options){
        const { width: width , height: height  } = options || {};
        if (!width || !height) throw new Error("BufferResource width or height invalid");
        super(width, height);
        this.data = source;
    }
    upload(renderer, baseTexture, glTexture) {
        const gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $551209d754b5b429$export$d56550d454401b73).UNPACK);
        const width = baseTexture.realWidth;
        const height = baseTexture.realHeight;
        if (glTexture.width === width && glTexture.height === height) gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data);
        }
        return true;
    }
    dispose() {
        this.data = null;
    }
    static test(source) {
        return source instanceof Float32Array || source instanceof Uint8Array || source instanceof Uint32Array;
    }
}



const $2d8d497fce3a4092$var$defaultBufferOptions = {
    scaleMode: (0, $551209d754b5b429$export$6b734c6a0bba8473).NEAREST,
    format: (0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA,
    alphaMode: (0, $551209d754b5b429$export$d56550d454401b73).NPM
};
const $2d8d497fce3a4092$var$_BaseTexture = class extends (0, (/*@__PURE__*/$parcel$interopDefault($f08921b7a62a95d1$exports))) {
    constructor(resource = null, options = null){
        super();
        options = Object.assign({}, $2d8d497fce3a4092$var$_BaseTexture.defaultOptions, options);
        const { alphaMode: alphaMode , mipmap: mipmap , anisotropicLevel: anisotropicLevel , scaleMode: scaleMode , width: width , height: height , wrapMode: wrapMode , format: format , type: type , target: target , resolution: resolution , resourceOptions: resourceOptions  } = options;
        if (resource && !(resource instanceof (0, $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63))) {
            resource = (0, $992246b926b958eb$export$5eb9e949a7ff46a7)(resource, resourceOptions);
            resource.internal = true;
        }
        this.resolution = resolution || (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
        this.width = Math.round((width || 0) * this.resolution) / this.resolution;
        this.height = Math.round((height || 0) * this.resolution) / this.resolution;
        this._mipmap = mipmap;
        this.anisotropicLevel = anisotropicLevel;
        this._wrapMode = wrapMode;
        this._scaleMode = scaleMode;
        this.format = format;
        this.type = type;
        this.target = target;
        this.alphaMode = alphaMode;
        this.uid = (0, $a8272ede630bda06$export$e2a22331486dcca0)();
        this.touched = 0;
        this.isPowerOfTwo = false;
        this._refreshPOT();
        this._glTextures = {};
        this.dirtyId = 0;
        this.dirtyStyleId = 0;
        this.cacheId = null;
        this.valid = width > 0 && height > 0;
        this.textureCacheIds = [];
        this.destroyed = false;
        this.resource = null;
        this._batchEnabled = 0;
        this._batchLocation = 0;
        this.parentTextureArray = null;
        this.setResource(resource);
    }
    get realWidth() {
        return Math.round(this.width * this.resolution);
    }
    get realHeight() {
        return Math.round(this.height * this.resolution);
    }
    get mipmap() {
        return this._mipmap;
    }
    set mipmap(value) {
        if (this._mipmap !== value) {
            this._mipmap = value;
            this.dirtyStyleId++;
        }
    }
    get scaleMode() {
        return this._scaleMode;
    }
    set scaleMode(value) {
        if (this._scaleMode !== value) {
            this._scaleMode = value;
            this.dirtyStyleId++;
        }
    }
    get wrapMode() {
        return this._wrapMode;
    }
    set wrapMode(value) {
        if (this._wrapMode !== value) {
            this._wrapMode = value;
            this.dirtyStyleId++;
        }
    }
    setStyle(scaleMode, mipmap) {
        let dirty;
        if (scaleMode !== void 0 && scaleMode !== this.scaleMode) {
            this.scaleMode = scaleMode;
            dirty = true;
        }
        if (mipmap !== void 0 && mipmap !== this.mipmap) {
            this.mipmap = mipmap;
            dirty = true;
        }
        if (dirty) this.dirtyStyleId++;
        return this;
    }
    setSize(desiredWidth, desiredHeight, resolution) {
        resolution = resolution || this.resolution;
        return this.setRealSize(desiredWidth * resolution, desiredHeight * resolution, resolution);
    }
    setRealSize(realWidth, realHeight, resolution) {
        this.resolution = resolution || this.resolution;
        this.width = Math.round(realWidth) / this.resolution;
        this.height = Math.round(realHeight) / this.resolution;
        this._refreshPOT();
        this.update();
        return this;
    }
    _refreshPOT() {
        this.isPowerOfTwo = (0, $5728f69a05940f94$export$eb50b9c078eb6ae7)(this.realWidth) && (0, $5728f69a05940f94$export$eb50b9c078eb6ae7)(this.realHeight);
    }
    setResolution(resolution) {
        const oldResolution = this.resolution;
        if (oldResolution === resolution) return this;
        this.resolution = resolution;
        if (this.valid) {
            this.width = Math.round(this.width * oldResolution) / resolution;
            this.height = Math.round(this.height * oldResolution) / resolution;
            this.emit("update", this);
        }
        this._refreshPOT();
        return this;
    }
    setResource(resource) {
        if (this.resource === resource) return this;
        if (this.resource) throw new Error("Resource can be set only once");
        resource.bind(this);
        this.resource = resource;
        return this;
    }
    update() {
        if (!this.valid) {
            if (this.width > 0 && this.height > 0) {
                this.valid = true;
                this.emit("loaded", this);
                this.emit("update", this);
            }
        } else {
            this.dirtyId++;
            this.dirtyStyleId++;
            this.emit("update", this);
        }
    }
    onError(event) {
        this.emit("error", this, event);
    }
    destroy() {
        if (this.resource) {
            this.resource.unbind(this);
            if (this.resource.internal) this.resource.destroy();
            this.resource = null;
        }
        if (this.cacheId) {
            delete (0, $db4392de79d671a3$export$cec649a143d060b1)[this.cacheId];
            delete (0, $db4392de79d671a3$export$4254ab7c0971430e)[this.cacheId];
            this.cacheId = null;
        }
        this.dispose();
        $2d8d497fce3a4092$var$_BaseTexture.removeFromCache(this);
        this.textureCacheIds = null;
        this.destroyed = true;
    }
    dispose() {
        this.emit("dispose", this);
    }
    castToBaseTexture() {
        return this;
    }
    static from(source, options, strict = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source === "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $a8272ede630bda06$export$e2a22331486dcca0)()}`;
            }
            cacheId = source._pixiId;
        }
        let baseTexture = (0, $db4392de79d671a3$export$cec649a143d060b1)[cacheId];
        if (isFrame && strict && !baseTexture) throw new Error(`The cacheId "${cacheId}" does not exist in BaseTextureCache.`);
        if (!baseTexture) {
            baseTexture = new $2d8d497fce3a4092$var$_BaseTexture(source, options);
            baseTexture.cacheId = cacheId;
            $2d8d497fce3a4092$var$_BaseTexture.addToCache(baseTexture, cacheId);
        }
        return baseTexture;
    }
    static fromBuffer(buffer, width, height, options) {
        buffer = buffer || new Float32Array(width * height * 4);
        const resource = new (0, $ad9971bad38b5f89$export$a79ef781de624449)(buffer, {
            width: width,
            height: height
        });
        const type = buffer instanceof Float32Array ? (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT : (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE;
        return new $2d8d497fce3a4092$var$_BaseTexture(resource, Object.assign({}, $2d8d497fce3a4092$var$defaultBufferOptions, {
            type: type
        }, options));
    }
    static addToCache(baseTexture, id) {
        if (id) {
            if (!baseTexture.textureCacheIds.includes(id)) baseTexture.textureCacheIds.push(id);
            if ((0, $db4392de79d671a3$export$cec649a143d060b1)[id] && (0, $db4392de79d671a3$export$cec649a143d060b1)[id] !== baseTexture) console.warn(`BaseTexture added to the cache with an id [${id}] that already had an entry`);
            (0, $db4392de79d671a3$export$cec649a143d060b1)[id] = baseTexture;
        }
    }
    static removeFromCache(baseTexture) {
        if (typeof baseTexture === "string") {
            const baseTextureFromCache = (0, $db4392de79d671a3$export$cec649a143d060b1)[baseTexture];
            if (baseTextureFromCache) {
                const index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
                if (index > -1) baseTextureFromCache.textureCacheIds.splice(index, 1);
                delete (0, $db4392de79d671a3$export$cec649a143d060b1)[baseTexture];
                return baseTextureFromCache;
            }
        } else if (baseTexture?.textureCacheIds) {
            for(let i = 0; i < baseTexture.textureCacheIds.length; ++i)delete (0, $db4392de79d671a3$export$cec649a143d060b1)[baseTexture.textureCacheIds[i]];
            baseTexture.textureCacheIds.length = 0;
            return baseTexture;
        }
        return null;
    }
};
let $2d8d497fce3a4092$export$d6306e508f184154 = $2d8d497fce3a4092$var$_BaseTexture;
$2d8d497fce3a4092$export$d6306e508f184154.defaultOptions = {
    mipmap: (0, $551209d754b5b429$export$16f6fb5da874bbfd).POW2,
    anisotropicLevel: 0,
    scaleMode: (0, $551209d754b5b429$export$6b734c6a0bba8473).LINEAR,
    wrapMode: (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).CLAMP,
    alphaMode: (0, $551209d754b5b429$export$d56550d454401b73).UNPACK,
    target: (0, $551209d754b5b429$export$d1ff3caf57547dc5).TEXTURE_2D,
    format: (0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA,
    type: (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE
};
$2d8d497fce3a4092$export$d6306e508f184154._globalBatch = 0;



class $27210fb05180b1cb$export$664fd198634fda29 {
    constructor(){
        this.texArray = null;
        this.blend = 0;
        this.type = (0, $551209d754b5b429$export$91100badd8469338).TRIANGLES;
        this.start = 0;
        this.size = 0;
        this.data = null;
    }
}





let $ff838791b3783858$var$UID = 0;
class $ff838791b3783858$export$a143d493d941bafc {
    constructor(data, _static = true, index = false){
        this.data = data || new Float32Array(1);
        this._glBuffers = {};
        this._updateID = 0;
        this.index = index;
        this.static = _static;
        this.id = $ff838791b3783858$var$UID++;
        this.disposeRunner = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("disposeBuffer");
    }
    update(data) {
        if (data instanceof Array) data = new Float32Array(data);
        this.data = data || this.data;
        this._updateID++;
    }
    dispose() {
        this.disposeRunner.emit(this, false);
    }
    destroy() {
        this.dispose();
        this.data = null;
    }
    set index(value) {
        this.type = value ? (0, $551209d754b5b429$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER : (0, $551209d754b5b429$export$b595a7e482202b96).ARRAY_BUFFER;
    }
    get index() {
        return this.type === (0, $551209d754b5b429$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
    }
    static from(data) {
        if (data instanceof Array) data = new Float32Array(data);
        return new $ff838791b3783858$export$a143d493d941bafc(data);
    }
}






class $911c13171714eb21$export$ab9c25261cd8c720 {
    constructor(buffer, size = 0, normalized = false, type = (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT, stride, start, instance, divisor = 1){
        this.buffer = buffer;
        this.size = size;
        this.normalized = normalized;
        this.type = type;
        this.stride = stride;
        this.start = start;
        this.instance = instance;
        this.divisor = divisor;
    }
    destroy() {
        this.buffer = null;
    }
    static from(buffer, size, normalized, type, stride) {
        return new $911c13171714eb21$export$ab9c25261cd8c720(buffer, size, normalized, type, stride);
    }
}




const $41444b6bc9e675bd$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $41444b6bc9e675bd$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0;
    let stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++){
        stride += sizes[i];
        outSize += arrays[i].length;
    }
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null;
    let littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i];
        const array = arrays[i];
        const type = (0, $585981d92cbec445$export$adf72b506413cb57)(array);
        if (!views[type]) views[type] = new $41444b6bc9e675bd$var$map[type](buffer);
        out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset;
            const index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}


const $18b317c5775068cf$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
let $18b317c5775068cf$var$UID = 0;
const $18b317c5775068cf$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array,
    Uint16Array: Uint16Array
};
class $18b317c5775068cf$export$2db6c17465f94a2 {
    constructor(buffers = [], attributes = {}){
        this.buffers = buffers;
        this.indexBuffer = null;
        this.attributes = attributes;
        this.glVertexArrayObjects = {};
        this.id = $18b317c5775068cf$var$UID++;
        this.instanced = false;
        this.instanceCount = 1;
        this.disposeRunner = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("disposeGeometry");
        this.refCount = 0;
    }
    addAttribute(id, buffer, size = 0, normalized = false, type, stride, start, instance = false) {
        if (!buffer) throw new Error("You must pass a buffer when creating an attribute");
        if (!(buffer instanceof (0, $ff838791b3783858$export$a143d493d941bafc))) {
            if (buffer instanceof Array) buffer = new Float32Array(buffer);
            buffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(buffer);
        }
        const ids = id.split("|");
        if (ids.length > 1) {
            for(let i = 0; i < ids.length; i++)this.addAttribute(ids[i], buffer, size, normalized, type);
            return this;
        }
        let bufferIndex = this.buffers.indexOf(buffer);
        if (bufferIndex === -1) {
            this.buffers.push(buffer);
            bufferIndex = this.buffers.length - 1;
        }
        this.attributes[id] = new (0, $911c13171714eb21$export$ab9c25261cd8c720)(bufferIndex, size, normalized, type, stride, start, instance);
        this.instanced = this.instanced || instance;
        return this;
    }
    getAttribute(id) {
        return this.attributes[id];
    }
    getBuffer(id) {
        return this.buffers[this.getAttribute(id).buffer];
    }
    addIndex(buffer) {
        if (!(buffer instanceof (0, $ff838791b3783858$export$a143d493d941bafc))) {
            if (buffer instanceof Array) buffer = new Uint16Array(buffer);
            buffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(buffer);
        }
        buffer.type = (0, $551209d754b5b429$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
        this.indexBuffer = buffer;
        if (!this.buffers.includes(buffer)) this.buffers.push(buffer);
        return this;
    }
    getIndex() {
        return this.indexBuffer;
    }
    interleave() {
        if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer) return this;
        const arrays = [];
        const sizes = [];
        const interleavedBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)();
        let i;
        for(i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = this.buffers[attribute.buffer];
            arrays.push(buffer.data);
            sizes.push(attribute.size * $18b317c5775068cf$var$byteSizeMap[attribute.type] / 4);
            attribute.buffer = 0;
        }
        interleavedBuffer.data = (0, $41444b6bc9e675bd$export$1ce3e224e969bb24)(arrays, sizes);
        for(i = 0; i < this.buffers.length; i++)if (this.buffers[i] !== this.indexBuffer) this.buffers[i].destroy();
        this.buffers = [
            interleavedBuffer
        ];
        if (this.indexBuffer) this.buffers.push(this.indexBuffer);
        return this;
    }
    getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = this.buffers[attribute.buffer];
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    dispose() {
        this.disposeRunner.emit(this, false);
    }
    destroy() {
        this.dispose();
        this.buffers = null;
        this.indexBuffer = null;
        this.attributes = null;
    }
    clone() {
        const geometry = new $18b317c5775068cf$export$2db6c17465f94a2();
        for(let i = 0; i < this.buffers.length; i++)geometry.buffers[i] = new (0, $ff838791b3783858$export$a143d493d941bafc)(this.buffers[i].data.slice(0));
        for(const i in this.attributes){
            const attrib = this.attributes[i];
            geometry.attributes[i] = new (0, $911c13171714eb21$export$ab9c25261cd8c720)(attrib.buffer, attrib.size, attrib.normalized, attrib.type, attrib.stride, attrib.start, attrib.instance);
        }
        if (this.indexBuffer) {
            geometry.indexBuffer = geometry.buffers[this.buffers.indexOf(this.indexBuffer)];
            geometry.indexBuffer.type = (0, $551209d754b5b429$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
        }
        return geometry;
    }
    static merge(geometries) {
        const geometryOut = new $18b317c5775068cf$export$2db6c17465f94a2();
        const arrays = [];
        const sizes = [];
        const offsets = [];
        let geometry;
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++){
                sizes[j] = sizes[j] || 0;
                sizes[j] += geometry.buffers[j].data.length;
                offsets[j] = 0;
            }
        }
        for(let i = 0; i < geometry.buffers.length; i++){
            arrays[i] = new $18b317c5775068cf$var$map[(0, $585981d92cbec445$export$adf72b506413cb57)(geometry.buffers[i].data)](sizes[i]);
            geometryOut.buffers[i] = new (0, $ff838791b3783858$export$a143d493d941bafc)(arrays[i]);
        }
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++){
                arrays[j].set(geometry.buffers[j].data, offsets[j]);
                offsets[j] += geometry.buffers[j].data.length;
            }
        }
        geometryOut.attributes = geometry.attributes;
        if (geometry.indexBuffer) {
            geometryOut.indexBuffer = geometryOut.buffers[geometry.buffers.indexOf(geometry.indexBuffer)];
            geometryOut.indexBuffer.type = (0, $551209d754b5b429$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
            let offset = 0;
            let stride = 0;
            let offset2 = 0;
            let bufferIndexToCount = 0;
            for(let i = 0; i < geometry.buffers.length; i++)if (geometry.buffers[i] !== geometry.indexBuffer) {
                bufferIndexToCount = i;
                break;
            }
            for(const i in geometry.attributes){
                const attribute = geometry.attributes[i];
                if ((attribute.buffer | 0) === bufferIndexToCount) stride += attribute.size * $18b317c5775068cf$var$byteSizeMap[attribute.type] / 4;
            }
            for(let i = 0; i < geometries.length; i++){
                const indexBufferData = geometries[i].indexBuffer.data;
                for(let j = 0; j < indexBufferData.length; j++)geometryOut.indexBuffer.data[j + offset2] += offset;
                offset += geometries[i].buffers[bufferIndexToCount].data.length / stride;
                offset2 += indexBufferData.length;
            }
        }
        return geometryOut;
    }
}


class $93dcf2ad94a668bf$export$449e8d355fd68e43 extends (0, $18b317c5775068cf$export$2db6c17465f94a2) {
    constructor(_static = false){
        super();
        this._buffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(null, _static, false);
        this._indexBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(null, _static, true);
        this.addAttribute("aVertexPosition", this._buffer, 2, false, (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT).addAttribute("aTextureCoord", this._buffer, 2, false, (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT).addAttribute("aColor", this._buffer, 4, true, (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE).addAttribute("aTextureId", this._buffer, 1, true, (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT).addIndex(this._indexBuffer);
    }
}


const $07142e085c72c7cc$export$59ed0a0a5de1084b = Math.PI * 2;
const $07142e085c72c7cc$export$3f91627dc85c5d57 = 180 / Math.PI;
const $07142e085c72c7cc$export$870617f62e3187f1 = Math.PI / 180;
var $07142e085c72c7cc$export$511e1d54a4a8684e = /* @__PURE__ */ ((SHAPES2)=>{
    SHAPES2[SHAPES2["POLY"] = 0] = "POLY";
    SHAPES2[SHAPES2["RECT"] = 1] = "RECT";
    SHAPES2[SHAPES2["CIRC"] = 2] = "CIRC";
    SHAPES2[SHAPES2["ELIP"] = 3] = "ELIP";
    SHAPES2[SHAPES2["RREC"] = 4] = "RREC";
    return SHAPES2;
})($07142e085c72c7cc$export$511e1d54a4a8684e || {});



class $88931fa1c0809be8$export$baf26146a414f24a {
    constructor(x = 0, y = 0){
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    clone() {
        return new $88931fa1c0809be8$export$baf26146a414f24a(this.x, this.y);
    }
    copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[@pixi/math:Point x=${this.x} y=${this.y}]`;
    }
}


const $340a428aa13511cc$var$tempPoints = [
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)(),
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)(),
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)(),
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)()
];
class $340a428aa13511cc$export$4617fb02663045ef {
    constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
        this.type = (0, $07142e085c72c7cc$export$511e1d54a4a8684e).RECT;
    }
    get left() {
        return this.x;
    }
    get right() {
        return this.x + this.width;
    }
    get top() {
        return this.y;
    }
    get bottom() {
        return this.y + this.height;
    }
    static get EMPTY() {
        return new $340a428aa13511cc$export$4617fb02663045ef(0, 0, 0, 0);
    }
    clone() {
        return new $340a428aa13511cc$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    copyTo(rectangle) {
        rectangle.x = this.x;
        rectangle.y = this.y;
        rectangle.width = this.width;
        rectangle.height = this.height;
        return rectangle;
    }
    contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $340a428aa13511cc$var$tempPoints[0].set(other.left, other.top);
        const lb = $340a428aa13511cc$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $340a428aa13511cc$var$tempPoints[2].set(other.right, other.top);
        const rb = $340a428aa13511cc$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    toString() {
        return `[@pixi/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}


class $224e00dc89bc3e26$export$c89a927ffc67e6fa {
    constructor(x = 0, y = 0, radius = 0){
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.type = (0, $07142e085c72c7cc$export$511e1d54a4a8684e).CIRC;
    }
    clone() {
        return new $224e00dc89bc3e26$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    getBounds() {
        return new (0, $340a428aa13511cc$export$4617fb02663045ef)(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
    }
    toString() {
        return `[@pixi/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}




class $07416f9533a1f100$export$80b0269ab108fa11 {
    constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        this.x = x;
        this.y = y;
        this.width = halfWidth;
        this.height = halfHeight;
        this.type = (0, $07142e085c72c7cc$export$511e1d54a4a8684e).ELIP;
    }
    clone() {
        return new $07416f9533a1f100$export$80b0269ab108fa11(this.x, this.y, this.width, this.height);
    }
    contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        let normx = (x - this.x) / this.width;
        let normy = (y - this.y) / this.height;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    getBounds() {
        return new (0, $340a428aa13511cc$export$4617fb02663045ef)(this.x - this.width, this.y - this.height, this.width, this.height);
    }
    toString() {
        return `[@pixi/math:Ellipse x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}



class $173c2dfd36fd3f4f$export$7d31b617c820d435 {
    constructor(...points){
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.type = (0, $07142e085c72c7cc$export$511e1d54a4a8684e).POLY;
        this.closeStroke = true;
    }
    clone() {
        const points = this.points.slice();
        const polygon = new $173c2dfd36fd3f4f$export$7d31b617c820d435(points);
        polygon.closeStroke = this.closeStroke;
        return polygon;
    }
    contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    toString() {
        return `[@pixi/math:PolygoncloseStroke=${this.closeStroke}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
}




class $cfa2d28b786e5ab9$export$d55ab2e3dc5a4263 {
    constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
        this.type = (0, $07142e085c72c7cc$export$511e1d54a4a8684e).RREC;
    }
    clone() {
        return new $cfa2d28b786e5ab9$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    toString() {
        return `[@pixi/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}




class $414c7fb9dda367fe$export$5b12bf1653c0dd85 {
    constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    apply(pos, newPos) {
        newPos = newPos || new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    applyInverse(pos, newPos) {
        newPos = newPos || new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        const id = 1 / (this.a * this.d + this.c * -this.b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
        return newPos;
    }
    translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $07142e085c72c7cc$export$59ed0a0a5de1084b) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    clone() {
        const matrix = new $414c7fb9dda367fe$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    toString() {
        return `[@pixi/math:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    static get IDENTITY() {
        return new $414c7fb9dda367fe$export$5b12bf1653c0dd85();
    }
    static get TEMP_MATRIX() {
        return new $414c7fb9dda367fe$export$5b12bf1653c0dd85();
    }
}


const $c91a285233559d80$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $c91a285233559d80$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $c91a285233559d80$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $c91a285233559d80$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $c91a285233559d80$var$rotationCayley = [];
const $c91a285233559d80$var$rotationMatrices = [];
const $c91a285233559d80$var$signum = Math.sign;
function $c91a285233559d80$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $c91a285233559d80$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $c91a285233559d80$var$signum($c91a285233559d80$var$ux[i] * $c91a285233559d80$var$ux[j] + $c91a285233559d80$var$vx[i] * $c91a285233559d80$var$uy[j]);
            const _uy = $c91a285233559d80$var$signum($c91a285233559d80$var$uy[i] * $c91a285233559d80$var$ux[j] + $c91a285233559d80$var$vy[i] * $c91a285233559d80$var$uy[j]);
            const _vx = $c91a285233559d80$var$signum($c91a285233559d80$var$ux[i] * $c91a285233559d80$var$vx[j] + $c91a285233559d80$var$vx[i] * $c91a285233559d80$var$vy[j]);
            const _vy = $c91a285233559d80$var$signum($c91a285233559d80$var$uy[i] * $c91a285233559d80$var$vx[j] + $c91a285233559d80$var$vy[i] * $c91a285233559d80$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($c91a285233559d80$var$ux[k] === _ux && $c91a285233559d80$var$uy[k] === _uy && $c91a285233559d80$var$vx[k] === _vx && $c91a285233559d80$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
        mat.set($c91a285233559d80$var$ux[i], $c91a285233559d80$var$uy[i], $c91a285233559d80$var$vx[i], $c91a285233559d80$var$vy[i], 0, 0);
        $c91a285233559d80$var$rotationMatrices.push(mat);
    }
}
$c91a285233559d80$var$init();
const $c91a285233559d80$export$b7bb6a2a8d203102 = {
    E: 0,
    SE: 1,
    S: 2,
    SW: 3,
    W: 4,
    NW: 5,
    N: 6,
    NE: 7,
    MIRROR_VERTICAL: 8,
    MAIN_DIAGONAL: 10,
    MIRROR_HORIZONTAL: 12,
    REVERSE_DIAGONAL: 14,
    uX: (ind)=>$c91a285233559d80$var$ux[ind],
    uY: (ind)=>$c91a285233559d80$var$uy[ind],
    vX: (ind)=>$c91a285233559d80$var$vx[ind],
    vY: (ind)=>$c91a285233559d80$var$vy[ind],
    inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    add: (rotationSecond, rotationFirst)=>$c91a285233559d80$var$rotationCayley[rotationSecond][rotationFirst],
    sub: (rotationSecond, rotationFirst)=>$c91a285233559d80$var$rotationCayley[rotationSecond][$c91a285233559d80$export$b7bb6a2a8d203102.inv(rotationFirst)],
    rotate180: (rotation)=>rotation ^ 4,
    isVertical: (rotation)=>(rotation & 3) === 2,
    byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $c91a285233559d80$export$b7bb6a2a8d203102.S;
            return $c91a285233559d80$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $c91a285233559d80$export$b7bb6a2a8d203102.E;
            return $c91a285233559d80$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $c91a285233559d80$export$b7bb6a2a8d203102.SE;
            return $c91a285233559d80$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $c91a285233559d80$export$b7bb6a2a8d203102.NE;
        return $c91a285233559d80$export$b7bb6a2a8d203102.NW;
    },
    matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $c91a285233559d80$var$rotationMatrices[$c91a285233559d80$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};







class $e3200063c3e77fce$export$3755aaad3fd42e52 {
    constructor(cb, scope, x = 0, y = 0){
        this._x = x;
        this._y = y;
        this.cb = cb;
        this.scope = scope;
    }
    clone(cb = this.cb, scope = this.scope) {
        return new $e3200063c3e77fce$export$3755aaad3fd42e52(cb, scope, this._x, this._y);
    }
    set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this.cb.call(this.scope);
        }
        return this;
    }
    copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this.cb.call(this.scope);
        }
        return this;
    }
    copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[@pixi/math:ObservablePoint x=${0} y=${0} scope=${this.scope}]`;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this.cb.call(this.scope);
        }
    }
    get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this.cb.call(this.scope);
        }
    }
}





const $83f2cf09d03bb7ff$var$_Transform = class {
    constructor(){
        this.worldTransform = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
        this.localTransform = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
        this.position = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(this.onChange, this, 0, 0);
        this.scale = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(this.onChange, this, 1, 1);
        this.pivot = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(this.onChange, this, 0, 0);
        this.skew = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(this.updateSkew, this, 0, 0);
        this._rotation = 0;
        this._cx = 1;
        this._sx = 0;
        this._cy = 0;
        this._sy = 1;
        this._localID = 0;
        this._currentLocalID = 0;
        this._worldID = 0;
        this._parentID = 0;
    }
    onChange() {
        this._localID++;
    }
    updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew.y);
        this._sx = Math.sin(this._rotation + this.skew.y);
        this._cy = -Math.sin(this._rotation - this.skew.x);
        this._sy = Math.cos(this._rotation - this.skew.x);
        this._localID++;
    }
    toString() {
        return `[@pixi/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
    }
    updateLocalTransform() {
        const lt = this.localTransform;
        if (this._localID !== this._currentLocalID) {
            lt.a = this._cx * this.scale.x;
            lt.b = this._sx * this.scale.x;
            lt.c = this._cy * this.scale.y;
            lt.d = this._sy * this.scale.y;
            lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
            lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
            this._currentLocalID = this._localID;
            this._parentID = -1;
        }
    }
    updateTransform(parentTransform) {
        const lt = this.localTransform;
        if (this._localID !== this._currentLocalID) {
            lt.a = this._cx * this.scale.x;
            lt.b = this._sx * this.scale.x;
            lt.c = this._cy * this.scale.y;
            lt.d = this._sy * this.scale.y;
            lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
            lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
            this._currentLocalID = this._localID;
            this._parentID = -1;
        }
        if (this._parentID !== parentTransform._worldID) {
            const pt = parentTransform.worldTransform;
            const wt = this.worldTransform;
            wt.a = lt.a * pt.a + lt.b * pt.c;
            wt.b = lt.a * pt.b + lt.b * pt.d;
            wt.c = lt.c * pt.a + lt.d * pt.c;
            wt.d = lt.c * pt.b + lt.d * pt.d;
            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
            this._parentID = parentTransform._worldID;
            this._worldID++;
        }
    }
    setFromMatrix(matrix) {
        matrix.decompose(this);
        this._localID++;
    }
    get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this.updateSkew();
        }
    }
};
let $83f2cf09d03bb7ff$export$563a914cafbdc389 = $83f2cf09d03bb7ff$var$_Transform;
$83f2cf09d03bb7ff$export$563a914cafbdc389.IDENTITY = new $83f2cf09d03bb7ff$var$_Transform();







var $f0b0c30504841b2a$export$2e2bcd8739ae039 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor *= texture2D(uSampler, vTextureCoord);\n}";


var $9f0fae5dc88499b7$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void){\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vTextureCoord = aTextureCoord;\n}\n";



function $0dc4dba3c84abd75$export$9b5304f4eb007cf0(gl, type, src) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, src);
    gl.compileShader(shader);
    return shader;
}


function $103a179a1bbbbc0b$var$booleanArray(size) {
    const array = new Array(size);
    for(let i = 0; i < array.length; i++)array[i] = false;
    return array;
}
function $103a179a1bbbbc0b$export$1a01ae0705bafd37(type, size) {
    switch(type){
        case "float":
            return 0;
        case "vec2":
            return new Float32Array(2 * size);
        case "vec3":
            return new Float32Array(3 * size);
        case "vec4":
            return new Float32Array(4 * size);
        case "int":
        case "uint":
        case "sampler2D":
        case "sampler2DArray":
            return 0;
        case "ivec2":
            return new Int32Array(2 * size);
        case "ivec3":
            return new Int32Array(3 * size);
        case "ivec4":
            return new Int32Array(4 * size);
        case "uvec2":
            return new Uint32Array(2 * size);
        case "uvec3":
            return new Uint32Array(3 * size);
        case "uvec4":
            return new Uint32Array(4 * size);
        case "bool":
            return false;
        case "bvec2":
            return $103a179a1bbbbc0b$var$booleanArray(2 * size);
        case "bvec3":
            return $103a179a1bbbbc0b$var$booleanArray(3 * size);
        case "bvec4":
            return $103a179a1bbbbc0b$var$booleanArray(4 * size);
        case "mat2":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}


const $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2 = [
    {
        test: (data)=>data.type === "float" && data.size === 1 && !data.isArray,
        code: (name)=>`
            if(uv["${name}"] !== ud["${name}"].value)
            {
                ud["${name}"].value = uv["${name}"]
                gl.uniform1f(ud["${name}"].location, uv["${name}"])
            }
            `
    },
    {
        test: (data, uniform)=>(data.type === "sampler2D" || data.type === "samplerCube" || data.type === "sampler2DArray") && data.size === 1 && !data.isArray && (uniform == null || uniform.castToBaseTexture !== void 0),
        code: (name)=>`t = syncData.textureCount++;

            renderer.texture.bind(uv["${name}"], t);

            if(ud["${name}"].value !== t)
            {
                ud["${name}"].value = t;
                gl.uniform1i(ud["${name}"].location, t);
; // eslint-disable-line max-len
            }`
    },
    {
        test: (data, uniform)=>data.type === "mat3" && data.size === 1 && !data.isArray && uniform.a !== void 0,
        code: (name)=>`
            gl.uniformMatrix3fv(ud["${name}"].location, false, uv["${name}"].toArray(true));
            `,
        codeUbo: (name)=>`
                var ${name}_matrix = uv.${name}.toArray(true);

                data[offset] = ${name}_matrix[0];
                data[offset+1] = ${name}_matrix[1];
                data[offset+2] = ${name}_matrix[2];
        
                data[offset + 4] = ${name}_matrix[3];
                data[offset + 5] = ${name}_matrix[4];
                data[offset + 6] = ${name}_matrix[5];
        
                data[offset + 8] = ${name}_matrix[6];
                data[offset + 9] = ${name}_matrix[7];
                data[offset + 10] = ${name}_matrix[8];
            `
    },
    {
        test: (data, uniform)=>data.type === "vec2" && data.size === 1 && !data.isArray && uniform.x !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    gl.uniform2f(ud["${name}"].location, v.x, v.y);
                }`,
        codeUbo: (name)=>`
                v = uv.${name};

                data[offset] = v.x;
                data[offset+1] = v.y;
            `
    },
    {
        test: (data)=>data.type === "vec2" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    gl.uniform2f(ud["${name}"].location, v[0], v[1]);
                }
            `
    },
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.width !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    cv[2] = v.width;
                    cv[3] = v.height;
                    gl.uniform4f(ud["${name}"].location, v.x, v.y, v.width, v.height)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.x;
                    data[offset+1] = v.y;
                    data[offset+2] = v.width;
                    data[offset+3] = v.height;
                `
    },
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
                    cv[3] = v.alpha;
                    gl.uniform4f(ud["${name}"].location, v.red, v.green, v.blue, v.alpha)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                    data[offset+3] = v.alpha;
                `
    },
    {
        test: (data, uniform)=>data.type === "vec3" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.a)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
    
                    gl.uniform3f(ud["${name}"].location, v.red, v.green, v.blue)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                `
    },
    {
        test: (data)=>data.type === "vec4" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    cv[2] = v[2];
                    cv[3] = v[3];

                    gl.uniform4f(ud["${name}"].location, v[0], v[1], v[2], v[3])
                }`
    }
];


const $fa25b17d2653b481$var$GLSL_TO_SINGLE_SETTERS_CACHED = {
    float: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1f(location, v);
    }`,
    vec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2f(location, v[0], v[1])
    }`,
    vec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3f(location, v[0], v[1], v[2])
    }`,
    vec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4f(location, v[0], v[1], v[2], v[3]);
    }`,
    int: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    ivec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    ivec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    ivec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    uint: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1ui(location, v);
    }`,
    uvec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2ui(location, v[0], v[1]);
    }`,
    uvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3ui(location, v[0], v[1], v[2]);
    }`,
    uvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
    }`,
    bool: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1i(location, v);
    }`,
    bvec2: `
    if (cv[0] != v[0] || cv[1] != v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    bvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    bvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    sampler2D: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    samplerCube: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    sampler2DArray: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`
};
const $fa25b17d2653b481$var$GLSL_TO_ARRAY_SETTERS = {
    float: `gl.uniform1fv(location, v)`,
    vec2: `gl.uniform2fv(location, v)`,
    vec3: `gl.uniform3fv(location, v)`,
    vec4: "gl.uniform4fv(location, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    int: "gl.uniform1iv(location, v)",
    ivec2: "gl.uniform2iv(location, v)",
    ivec3: "gl.uniform3iv(location, v)",
    ivec4: "gl.uniform4iv(location, v)",
    uint: "gl.uniform1uiv(location, v)",
    uvec2: "gl.uniform2uiv(location, v)",
    uvec3: "gl.uniform3uiv(location, v)",
    uvec4: "gl.uniform4uiv(location, v)",
    bool: "gl.uniform1iv(location, v)",
    bvec2: "gl.uniform2iv(location, v)",
    bvec3: "gl.uniform3iv(location, v)",
    bvec4: "gl.uniform4iv(location, v)",
    sampler2D: "gl.uniform1iv(location, v)",
    samplerCube: "gl.uniform1iv(location, v)",
    sampler2DArray: "gl.uniform1iv(location, v)"
};
function $fa25b17d2653b481$export$20c95d1c2d5a6828(group, uniformData) {
    const funcFragments = [
        `
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
    `
    ];
    for(const i in group.uniforms){
        const data = uniformData[i];
        if (!data) {
            if (group.uniforms[i]?.group) {
                if (group.uniforms[i].ubo) funcFragments.push(`
                        renderer.shader.syncUniformBufferGroup(uv.${i}, '${i}');
                    `);
                else funcFragments.push(`
                        renderer.shader.syncUniformGroup(uv.${i}, syncData);
                    `);
            }
            continue;
        }
        const uniform = group.uniforms[i];
        let parsed = false;
        for(let j = 0; j < (0, $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2).length; j++)if ((0, $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2)[j].test(data, uniform)) {
            funcFragments.push((0, $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2)[j].code(i, uniform));
            parsed = true;
            break;
        }
        if (!parsed) {
            const templateType = data.size === 1 && !data.isArray ? $fa25b17d2653b481$var$GLSL_TO_SINGLE_SETTERS_CACHED : $fa25b17d2653b481$var$GLSL_TO_ARRAY_SETTERS;
            const template = templateType[data.type].replace("location", `ud["${i}"].location`);
            funcFragments.push(`
            cu = ud["${i}"];
            cv = cu.value;
            v = uv["${i}"];
            ${template};`);
        }
    }
    return new Function("ud", "uv", "renderer", "syncData", funcFragments.join("\n"));
}





const $1093824982d9e538$var$unknownContext = {};
let $1093824982d9e538$var$context = $1093824982d9e538$var$unknownContext;
function $1093824982d9e538$export$f034b2d55f8df08b() {
    if ($1093824982d9e538$var$context === $1093824982d9e538$var$unknownContext || $1093824982d9e538$var$context?.isContextLost()) {
        const canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
        let gl;
        if ((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).PREFER_ENV >= (0, $551209d754b5b429$export$83401e34d5e11bf4).WEBGL2) gl = canvas.getContext("webgl2", {});
        if (!gl) {
            gl = canvas.getContext("webgl", {}) || canvas.getContext("experimental-webgl", {});
            if (!gl) gl = null;
            else gl.getExtension("WEBGL_draw_buffers");
        }
        $1093824982d9e538$var$context = gl;
    }
    return $1093824982d9e538$var$context;
}


let $d666f932fb92fed4$var$maxFragmentPrecision;
function $d666f932fb92fed4$export$428c38e64838140() {
    if (!$d666f932fb92fed4$var$maxFragmentPrecision) {
        $d666f932fb92fed4$var$maxFragmentPrecision = (0, $551209d754b5b429$export$d6d3992f3becc879).MEDIUM;
        const gl = (0, $1093824982d9e538$export$f034b2d55f8df08b)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $d666f932fb92fed4$var$maxFragmentPrecision = shaderFragment.precision ? (0, $551209d754b5b429$export$d6d3992f3becc879).HIGH : (0, $551209d754b5b429$export$d6d3992f3becc879).MEDIUM;
            }
        }
    }
    return $d666f932fb92fed4$var$maxFragmentPrecision;
}



function $393c6798ea1ed6a4$var$logPrettyShaderError(gl, shader) {
    const shaderSrc = gl.getShaderSource(shader).split("\n").map((line, index)=>`${index}: ${line}`);
    const shaderLog = gl.getShaderInfoLog(shader);
    const splitShader = shaderLog.split("\n");
    const dedupe = {};
    const lineNumbers = splitShader.map((line)=>parseFloat(line.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((n)=>{
        if (n && !dedupe[n]) {
            dedupe[n] = true;
            return true;
        }
        return false;
    });
    const logArgs = [
        ""
    ];
    lineNumbers.forEach((number)=>{
        shaderSrc[number - 1] = `%c${shaderSrc[number - 1]}%c`;
        logArgs.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
    });
    const fragmentSourceToLog = shaderSrc.join("\n");
    logArgs[0] = fragmentSourceToLog;
    console.error(shaderLog);
    console.groupCollapsed("click to view full shader code");
    console.warn(...logArgs);
    console.groupEnd();
}
function $393c6798ea1ed6a4$export$4b35d6c62dc992b0(gl, program, vertexShader, fragmentShader) {
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) $393c6798ea1ed6a4$var$logPrettyShaderError(gl, vertexShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) $393c6798ea1ed6a4$var$logPrettyShaderError(gl, fragmentShader);
        console.error("PixiJS Error: Could not initialize shader.");
        if (gl.getProgramInfoLog(program) !== "") console.warn("PixiJS Warning: gl.getProgramInfoLog()", gl.getProgramInfoLog(program));
    }
}


const $6ce3ebb6f0d94afe$var$GLSL_TO_SIZE = {
    float: 1,
    vec2: 2,
    vec3: 3,
    vec4: 4,
    int: 1,
    ivec2: 2,
    ivec3: 3,
    ivec4: 4,
    uint: 1,
    uvec2: 2,
    uvec3: 3,
    uvec4: 4,
    bool: 1,
    bvec2: 2,
    bvec3: 3,
    bvec4: 4,
    mat2: 4,
    mat3: 9,
    mat4: 16,
    sampler2D: 1
};
function $6ce3ebb6f0d94afe$export$50ee69a11aa2abdb(type) {
    return $6ce3ebb6f0d94afe$var$GLSL_TO_SIZE[type];
}


let $d1f0673787d44f4c$var$GL_TABLE = null;
const $d1f0673787d44f4c$var$GL_TO_GLSL_TYPES = {
    FLOAT: "float",
    FLOAT_VEC2: "vec2",
    FLOAT_VEC3: "vec3",
    FLOAT_VEC4: "vec4",
    INT: "int",
    INT_VEC2: "ivec2",
    INT_VEC3: "ivec3",
    INT_VEC4: "ivec4",
    UNSIGNED_INT: "uint",
    UNSIGNED_INT_VEC2: "uvec2",
    UNSIGNED_INT_VEC3: "uvec3",
    UNSIGNED_INT_VEC4: "uvec4",
    BOOL: "bool",
    BOOL_VEC2: "bvec2",
    BOOL_VEC3: "bvec3",
    BOOL_VEC4: "bvec4",
    FLOAT_MAT2: "mat2",
    FLOAT_MAT3: "mat3",
    FLOAT_MAT4: "mat4",
    SAMPLER_2D: "sampler2D",
    INT_SAMPLER_2D: "sampler2D",
    UNSIGNED_INT_SAMPLER_2D: "sampler2D",
    SAMPLER_CUBE: "samplerCube",
    INT_SAMPLER_CUBE: "samplerCube",
    UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
    SAMPLER_2D_ARRAY: "sampler2DArray",
    INT_SAMPLER_2D_ARRAY: "sampler2DArray",
    UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
function $d1f0673787d44f4c$export$4de3a94418d86ca7(gl, type) {
    if (!$d1f0673787d44f4c$var$GL_TABLE) {
        const typeNames = Object.keys($d1f0673787d44f4c$var$GL_TO_GLSL_TYPES);
        $d1f0673787d44f4c$var$GL_TABLE = {};
        for(let i = 0; i < typeNames.length; ++i){
            const tn = typeNames[i];
            $d1f0673787d44f4c$var$GL_TABLE[gl[tn]] = $d1f0673787d44f4c$var$GL_TO_GLSL_TYPES[tn];
        }
    }
    return $d1f0673787d44f4c$var$GL_TABLE[type];
}



function $7b6ee34bdcbe09f4$export$c4b85a3b3361e135(src, requestedPrecision, maxSupportedPrecision) {
    if (src.substring(0, 9) !== "precision") {
        let precision = requestedPrecision;
        if (requestedPrecision === (0, $551209d754b5b429$export$d6d3992f3becc879).HIGH && maxSupportedPrecision !== (0, $551209d754b5b429$export$d6d3992f3becc879).HIGH) precision = (0, $551209d754b5b429$export$d6d3992f3becc879).MEDIUM;
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== (0, $551209d754b5b429$export$d6d3992f3becc879).HIGH && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}



let $62249037d7b2f875$var$unsafeEval;
function $62249037d7b2f875$export$70c0711f29adc5cf() {
    if (typeof $62249037d7b2f875$var$unsafeEval === "boolean") return $62249037d7b2f875$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $62249037d7b2f875$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (e) {
        $62249037d7b2f875$var$unsafeEval = false;
    }
    return $62249037d7b2f875$var$unsafeEval;
}






let $52e5734958fc1bae$var$UID = 0;
const $52e5734958fc1bae$var$nameCache = {};
const $52e5734958fc1bae$var$_Program = class {
    constructor(vertexSrc, fragmentSrc, name = "pixi-shader", extra = {}){
        this.extra = {};
        this.id = $52e5734958fc1bae$var$UID++;
        this.vertexSrc = vertexSrc || $52e5734958fc1bae$var$_Program.defaultVertexSrc;
        this.fragmentSrc = fragmentSrc || $52e5734958fc1bae$var$_Program.defaultFragmentSrc;
        this.vertexSrc = this.vertexSrc.trim();
        this.fragmentSrc = this.fragmentSrc.trim();
        this.extra = extra;
        if (this.vertexSrc.substring(0, 8) !== "#version") {
            name = name.replace(/\s+/g, "-");
            if ($52e5734958fc1bae$var$nameCache[name]) {
                $52e5734958fc1bae$var$nameCache[name]++;
                name += `-${$52e5734958fc1bae$var$nameCache[name]}`;
            } else $52e5734958fc1bae$var$nameCache[name] = 1;
            this.vertexSrc = `#define SHADER_NAME ${name}
${this.vertexSrc}`;
            this.fragmentSrc = `#define SHADER_NAME ${name}
${this.fragmentSrc}`;
            this.vertexSrc = (0, $7b6ee34bdcbe09f4$export$c4b85a3b3361e135)(this.vertexSrc, $52e5734958fc1bae$var$_Program.defaultVertexPrecision, (0, $551209d754b5b429$export$d6d3992f3becc879).HIGH);
            this.fragmentSrc = (0, $7b6ee34bdcbe09f4$export$c4b85a3b3361e135)(this.fragmentSrc, $52e5734958fc1bae$var$_Program.defaultFragmentPrecision, (0, $d666f932fb92fed4$export$428c38e64838140)());
        }
        this.glPrograms = {};
        this.syncUniforms = null;
    }
    static get defaultVertexSrc() {
        return 0, $9f0fae5dc88499b7$export$2e2bcd8739ae039;
    }
    static get defaultFragmentSrc() {
        return 0, $f0b0c30504841b2a$export$2e2bcd8739ae039;
    }
    static from(vertexSrc, fragmentSrc, name) {
        const key = vertexSrc + fragmentSrc;
        let program = (0, $db4392de79d671a3$export$d47c7e291d8b6e2c)[key];
        if (!program) (0, $db4392de79d671a3$export$d47c7e291d8b6e2c)[key] = program = new $52e5734958fc1bae$var$_Program(vertexSrc, fragmentSrc, name);
        return program;
    }
};
let $52e5734958fc1bae$export$b6c59b989905b650 = $52e5734958fc1bae$var$_Program;
$52e5734958fc1bae$export$b6c59b989905b650.defaultVertexPrecision = (0, $551209d754b5b429$export$d6d3992f3becc879).HIGH;
$52e5734958fc1bae$export$b6c59b989905b650.defaultFragmentPrecision = (0, $cb209844fab531da$export$d0a8044dce8ff2fc).apple.device ? (0, $551209d754b5b429$export$d6d3992f3becc879).HIGH : (0, $551209d754b5b429$export$d6d3992f3becc879).MEDIUM;






let $d21ea31dd94e9628$var$UID = 0;
class $d21ea31dd94e9628$export$6601a7a2dcf79bf5 {
    constructor(uniforms, isStatic, isUbo){
        this.group = true;
        this.syncUniforms = {};
        this.dirtyId = 0;
        this.id = $d21ea31dd94e9628$var$UID++;
        this.static = !!isStatic;
        this.ubo = !!isUbo;
        if (uniforms instanceof (0, $ff838791b3783858$export$a143d493d941bafc)) {
            this.buffer = uniforms;
            this.buffer.type = (0, $551209d754b5b429$export$b595a7e482202b96).UNIFORM_BUFFER;
            this.autoManage = false;
            this.ubo = true;
        } else {
            this.uniforms = uniforms;
            if (this.ubo) {
                this.buffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(new Float32Array(1));
                this.buffer.type = (0, $551209d754b5b429$export$b595a7e482202b96).UNIFORM_BUFFER;
                this.autoManage = true;
            }
        }
    }
    update() {
        this.dirtyId++;
        if (!this.autoManage && this.buffer) this.buffer.update();
    }
    add(name, uniforms, _static) {
        if (!this.ubo) this.uniforms[name] = new $d21ea31dd94e9628$export$6601a7a2dcf79bf5(uniforms, _static);
        else throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
    }
    static from(uniforms, _static, _ubo) {
        return new $d21ea31dd94e9628$export$6601a7a2dcf79bf5(uniforms, _static, _ubo);
    }
    static uboFrom(uniforms, _static) {
        return new $d21ea31dd94e9628$export$6601a7a2dcf79bf5(uniforms, _static ?? true, true);
    }
}


class $b78f65cdcfbb9b3c$export$462bb059fed9d9e5 {
    constructor(program, uniforms){
        this.uniformBindCount = 0;
        this.program = program;
        if (uniforms) {
            if (uniforms instanceof (0, $d21ea31dd94e9628$export$6601a7a2dcf79bf5)) this.uniformGroup = uniforms;
            else this.uniformGroup = new (0, $d21ea31dd94e9628$export$6601a7a2dcf79bf5)(uniforms);
        } else this.uniformGroup = new (0, $d21ea31dd94e9628$export$6601a7a2dcf79bf5)({});
        this.disposeRunner = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("disposeShader");
    }
    checkUniformExists(name, group) {
        if (group.uniforms[name]) return true;
        for(const i in group.uniforms){
            const uniform = group.uniforms[i];
            if (uniform.group) {
                if (this.checkUniformExists(name, uniform)) return true;
            }
        }
        return false;
    }
    destroy() {
        this.uniformGroup = null;
        this.disposeRunner.emit(this);
        this.disposeRunner.destroy();
    }
    get uniforms() {
        return this.uniformGroup.uniforms;
    }
    static from(vertexSrc, fragmentSrc, uniforms) {
        const program = (0, $52e5734958fc1bae$export$b6c59b989905b650).from(vertexSrc, fragmentSrc);
        return new $b78f65cdcfbb9b3c$export$462bb059fed9d9e5(program, uniforms);
    }
}



class $8ba5966bcff4e5b1$export$9a4c4943b6fad72e {
    constructor(vertexSrc, fragTemplate){
        this.vertexSrc = vertexSrc;
        this.fragTemplate = fragTemplate;
        this.programCache = {};
        this.defaultGroupCache = {};
        if (!fragTemplate.includes("%count%")) throw new Error('Fragment template must contain "%count%".');
        if (!fragTemplate.includes("%forloop%")) throw new Error('Fragment template must contain "%forloop%".');
    }
    generateShader(maxTextures) {
        if (!this.programCache[maxTextures]) {
            const sampleValues = new Int32Array(maxTextures);
            for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
            this.defaultGroupCache[maxTextures] = (0, $d21ea31dd94e9628$export$6601a7a2dcf79bf5).from({
                uSamplers: sampleValues
            }, true);
            let fragmentSrc = this.fragTemplate;
            fragmentSrc = fragmentSrc.replace(/%count%/gi, `${maxTextures}`);
            fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures));
            this.programCache[maxTextures] = new (0, $52e5734958fc1bae$export$b6c59b989905b650)(this.vertexSrc, fragmentSrc);
        }
        const uniforms = {
            tint: new Float32Array([
                1,
                1,
                1,
                1
            ]),
            translationMatrix: new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)(),
            default: this.defaultGroupCache[maxTextures]
        };
        return new (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5)(this.programCache[maxTextures], uniforms);
    }
    generateSampleSrc(maxTextures) {
        let src = "";
        src += "\n";
        src += "\n";
        for(let i = 0; i < maxTextures; i++){
            if (i > 0) src += "\nelse ";
            if (i < maxTextures - 1) src += `if(vTextureId < ${i}.5)`;
            src += "\n{";
            src += `
	color = texture2D(uSamplers[${i}], vTextureCoord);`;
            src += "\n}";
        }
        src += "\n";
        src += "\n";
        return src;
    }
}


class $f453ad575c2dc61d$export$aa760e0febf1a758 {
    constructor(){
        this.elements = [];
        this.ids = [];
        this.count = 0;
    }
    clear() {
        for(let i = 0; i < this.count; i++)this.elements[i] = null;
        this.count = 0;
    }
}



function $796efb3af7ab4d6c$export$b839fdc6a85f84de() {
    return !(0, $cb209844fab531da$export$d0a8044dce8ff2fc).apple.device;
}



function $8a6b3c42f69f7e66$export$d7a652ff592da4b4(max) {
    let allowMax = true;
    const navigator = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getNavigator();
    if ((0, $cb209844fab531da$export$d0a8044dce8ff2fc).tablet || (0, $cb209844fab531da$export$d0a8044dce8ff2fc).phone) {
        if ((0, $cb209844fab531da$export$d0a8044dce8ff2fc).apple.device) {
            const match = navigator.userAgent.match(/OS (\d+)_(\d+)?/);
            if (match) {
                const majorVersion = parseInt(match[1], 10);
                if (majorVersion < 11) allowMax = false;
            }
        }
        if ((0, $cb209844fab531da$export$d0a8044dce8ff2fc).android.device) {
            const match = navigator.userAgent.match(/Android\s([0-9.]*)/);
            if (match) {
                const majorVersion = parseInt(match[1], 10);
                if (majorVersion < 7) allowMax = false;
            }
        }
    }
    return allowMax ? max : 4;
}


class $ec9c34a32f35795b$export$ca67b0b0fa758253 {
    constructor(renderer){
        this.renderer = renderer;
    }
    flush() {}
    destroy() {
        this.renderer = null;
    }
    start() {}
    stop() {
        this.flush();
    }
    render(_object) {}
}


var $644858e5723948fa$export$2e2bcd8739ae039 = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\nuniform sampler2D uSamplers[%count%];\n\nvoid main(void){\n    vec4 color;\n    %forloop%\n    gl_FragColor = color * vColor;\n}\n";


var $0493cb72e93bc5fe$export$2e2bcd8739ae039 = "precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform vec4 tint;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor * tint;\n}\n";


const $e9a7bfc7edf84428$var$_BatchRenderer = class extends (0, $ec9c34a32f35795b$export$ca67b0b0fa758253) {
    constructor(renderer){
        super(renderer);
        this.setShaderGenerator();
        this.geometryClass = (0, $93dcf2ad94a668bf$export$449e8d355fd68e43);
        this.vertexSize = 6;
        this.state = (0, $15a50e9cd387ae21$export$7254cc27399e90bd).for2d();
        this.size = $e9a7bfc7edf84428$var$_BatchRenderer.defaultBatchSize * 4;
        this._vertexCount = 0;
        this._indexCount = 0;
        this._bufferedElements = [];
        this._bufferedTextures = [];
        this._bufferSize = 0;
        this._shader = null;
        this._packedGeometries = [];
        this._packedGeometryPoolSize = 2;
        this._flushId = 0;
        this._aBuffers = {};
        this._iBuffers = {};
        this.maxTextures = 1;
        this.renderer.on("prerender", this.onPrerender, this);
        renderer.runners.contextChange.add(this);
        this._dcIndex = 0;
        this._aIndex = 0;
        this._iIndex = 0;
        this._attributeBuffer = null;
        this._indexBuffer = null;
        this._tempBoundTextures = [];
    }
    static get defaultMaxTextures() {
        this._defaultMaxTextures = this._defaultMaxTextures ?? (0, $8a6b3c42f69f7e66$export$d7a652ff592da4b4)(32);
        return this._defaultMaxTextures;
    }
    static set defaultMaxTextures(value) {
        this._defaultMaxTextures = value;
    }
    static get canUploadSameBuffer() {
        this._canUploadSameBuffer = this._canUploadSameBuffer ?? (0, $796efb3af7ab4d6c$export$b839fdc6a85f84de)();
        return this._canUploadSameBuffer;
    }
    static set canUploadSameBuffer(value) {
        this._canUploadSameBuffer = value;
    }
    get MAX_TEXTURES() {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "BatchRenderer#MAX_TEXTURES renamed to BatchRenderer#maxTextures");
        return this.maxTextures;
    }
    static get defaultVertexSrc() {
        return 0, $0493cb72e93bc5fe$export$2e2bcd8739ae039;
    }
    static get defaultFragmentTemplate() {
        return 0, $644858e5723948fa$export$2e2bcd8739ae039;
    }
    setShaderGenerator({ vertex: vertex = $e9a7bfc7edf84428$var$_BatchRenderer.defaultVertexSrc , fragment: fragment = $e9a7bfc7edf84428$var$_BatchRenderer.defaultFragmentTemplate  } = {}) {
        this.shaderGenerator = new (0, $8ba5966bcff4e5b1$export$9a4c4943b6fad72e)(vertex, fragment);
    }
    contextChange() {
        const gl = this.renderer.gl;
        if ((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).PREFER_ENV === (0, $551209d754b5b429$export$83401e34d5e11bf4).WEBGL_LEGACY) this.maxTextures = 1;
        else {
            this.maxTextures = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), $e9a7bfc7edf84428$var$_BatchRenderer.defaultMaxTextures);
            this.maxTextures = (0, $4b083c03bd574f03$export$fb6ad4e758d74cc0)(this.maxTextures, gl);
        }
        this._shader = this.shaderGenerator.generateShader(this.maxTextures);
        for(let i = 0; i < this._packedGeometryPoolSize; i++)this._packedGeometries[i] = new this.geometryClass();
        this.initFlushBuffers();
    }
    initFlushBuffers() {
        const { _drawCallPool: _drawCallPool , _textureArrayPool: _textureArrayPool  } = $e9a7bfc7edf84428$var$_BatchRenderer;
        const MAX_SPRITES = this.size / 4;
        const MAX_TA = Math.floor(MAX_SPRITES / this.maxTextures) + 1;
        while(_drawCallPool.length < MAX_SPRITES)_drawCallPool.push(new (0, $27210fb05180b1cb$export$664fd198634fda29)());
        while(_textureArrayPool.length < MAX_TA)_textureArrayPool.push(new (0, $f453ad575c2dc61d$export$aa760e0febf1a758)());
        for(let i = 0; i < this.maxTextures; i++)this._tempBoundTextures[i] = null;
    }
    onPrerender() {
        this._flushId = 0;
    }
    render(element) {
        if (!element._texture.valid) return;
        if (this._vertexCount + element.vertexData.length / 2 > this.size) this.flush();
        this._vertexCount += element.vertexData.length / 2;
        this._indexCount += element.indices.length;
        this._bufferedTextures[this._bufferSize] = element._texture.baseTexture;
        this._bufferedElements[this._bufferSize++] = element;
    }
    buildTexturesAndDrawCalls() {
        const { _bufferedTextures: textures , maxTextures: maxTextures  } = this;
        const textureArrays = $e9a7bfc7edf84428$var$_BatchRenderer._textureArrayPool;
        const batch = this.renderer.batch;
        const boundTextures = this._tempBoundTextures;
        const touch = this.renderer.textureGC.count;
        let TICK = ++(0, $2d8d497fce3a4092$export$d6306e508f184154)._globalBatch;
        let countTexArrays = 0;
        let texArray = textureArrays[0];
        let start = 0;
        batch.copyBoundTextures(boundTextures, maxTextures);
        for(let i = 0; i < this._bufferSize; ++i){
            const tex = textures[i];
            textures[i] = null;
            if (tex._batchEnabled === TICK) continue;
            if (texArray.count >= maxTextures) {
                batch.boundArray(texArray, boundTextures, TICK, maxTextures);
                this.buildDrawCalls(texArray, start, i);
                start = i;
                texArray = textureArrays[++countTexArrays];
                ++TICK;
            }
            tex._batchEnabled = TICK;
            tex.touched = touch;
            texArray.elements[texArray.count++] = tex;
        }
        if (texArray.count > 0) {
            batch.boundArray(texArray, boundTextures, TICK, maxTextures);
            this.buildDrawCalls(texArray, start, this._bufferSize);
            ++countTexArrays;
            ++TICK;
        }
        for(let i = 0; i < boundTextures.length; i++)boundTextures[i] = null;
        (0, $2d8d497fce3a4092$export$d6306e508f184154)._globalBatch = TICK;
    }
    buildDrawCalls(texArray, start, finish) {
        const { _bufferedElements: elements , _attributeBuffer: _attributeBuffer , _indexBuffer: _indexBuffer , vertexSize: vertexSize  } = this;
        const drawCalls = $e9a7bfc7edf84428$var$_BatchRenderer._drawCallPool;
        let dcIndex = this._dcIndex;
        let aIndex = this._aIndex;
        let iIndex = this._iIndex;
        let drawCall = drawCalls[dcIndex];
        drawCall.start = this._iIndex;
        drawCall.texArray = texArray;
        for(let i = start; i < finish; ++i){
            const sprite = elements[i];
            const tex = sprite._texture.baseTexture;
            const spriteBlendMode = (0, $640150753d863d84$export$799d0d31e2f4c737)[tex.alphaMode ? 1 : 0][sprite.blendMode];
            elements[i] = null;
            if (start < i && drawCall.blend !== spriteBlendMode) {
                drawCall.size = iIndex - drawCall.start;
                start = i;
                drawCall = drawCalls[++dcIndex];
                drawCall.texArray = texArray;
                drawCall.start = iIndex;
            }
            this.packInterleavedGeometry(sprite, _attributeBuffer, _indexBuffer, aIndex, iIndex);
            aIndex += sprite.vertexData.length / 2 * vertexSize;
            iIndex += sprite.indices.length;
            drawCall.blend = spriteBlendMode;
        }
        if (start < finish) {
            drawCall.size = iIndex - drawCall.start;
            ++dcIndex;
        }
        this._dcIndex = dcIndex;
        this._aIndex = aIndex;
        this._iIndex = iIndex;
    }
    bindAndClearTexArray(texArray) {
        const textureSystem = this.renderer.texture;
        for(let j = 0; j < texArray.count; j++){
            textureSystem.bind(texArray.elements[j], texArray.ids[j]);
            texArray.elements[j] = null;
        }
        texArray.count = 0;
    }
    updateGeometry() {
        const { _packedGeometries: packedGeometries , _attributeBuffer: attributeBuffer , _indexBuffer: indexBuffer  } = this;
        if (!$e9a7bfc7edf84428$var$_BatchRenderer.canUploadSameBuffer) {
            if (this._packedGeometryPoolSize <= this._flushId) {
                this._packedGeometryPoolSize++;
                packedGeometries[this._flushId] = new this.geometryClass();
            }
            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
            this.renderer.geometry.bind(packedGeometries[this._flushId]);
            this.renderer.geometry.updateBuffers();
            this._flushId++;
        } else {
            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
            this.renderer.geometry.updateBuffers();
        }
    }
    drawBatches() {
        const dcCount = this._dcIndex;
        const { gl: gl , state: stateSystem  } = this.renderer;
        const drawCalls = $e9a7bfc7edf84428$var$_BatchRenderer._drawCallPool;
        let curTexArray = null;
        for(let i = 0; i < dcCount; i++){
            const { texArray: texArray , type: type , size: size , start: start , blend: blend  } = drawCalls[i];
            if (curTexArray !== texArray) {
                curTexArray = texArray;
                this.bindAndClearTexArray(texArray);
            }
            this.state.blendMode = blend;
            stateSystem.set(this.state);
            gl.drawElements(type, size, gl.UNSIGNED_SHORT, start * 2);
        }
    }
    flush() {
        if (this._vertexCount === 0) return;
        this._attributeBuffer = this.getAttributeBuffer(this._vertexCount);
        this._indexBuffer = this.getIndexBuffer(this._indexCount);
        this._aIndex = 0;
        this._iIndex = 0;
        this._dcIndex = 0;
        this.buildTexturesAndDrawCalls();
        this.updateGeometry();
        this.drawBatches();
        this._bufferSize = 0;
        this._vertexCount = 0;
        this._indexCount = 0;
    }
    start() {
        this.renderer.state.set(this.state);
        this.renderer.texture.ensureSamplerType(this.maxTextures);
        this.renderer.shader.bind(this._shader);
        if ($e9a7bfc7edf84428$var$_BatchRenderer.canUploadSameBuffer) this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
    }
    stop() {
        this.flush();
    }
    destroy() {
        for(let i = 0; i < this._packedGeometryPoolSize; i++)if (this._packedGeometries[i]) this._packedGeometries[i].destroy();
        this.renderer.off("prerender", this.onPrerender, this);
        this._aBuffers = null;
        this._iBuffers = null;
        this._packedGeometries = null;
        this._attributeBuffer = null;
        this._indexBuffer = null;
        if (this._shader) {
            this._shader.destroy();
            this._shader = null;
        }
        super.destroy();
    }
    getAttributeBuffer(size) {
        const roundedP2 = (0, $5728f69a05940f94$export$f0d90cf68bd426eb)(Math.ceil(size / 8));
        const roundedSizeIndex = (0, $5728f69a05940f94$export$b9fae0bba9d9094d)(roundedP2);
        const roundedSize = roundedP2 * 8;
        if (this._aBuffers.length <= roundedSizeIndex) this._iBuffers.length = roundedSizeIndex + 1;
        let buffer = this._aBuffers[roundedSize];
        if (!buffer) this._aBuffers[roundedSize] = buffer = new (0, $847a0d28fb79d582$export$4fdbf0662aa3047a)(roundedSize * this.vertexSize * 4);
        return buffer;
    }
    getIndexBuffer(size) {
        const roundedP2 = (0, $5728f69a05940f94$export$f0d90cf68bd426eb)(Math.ceil(size / 12));
        const roundedSizeIndex = (0, $5728f69a05940f94$export$b9fae0bba9d9094d)(roundedP2);
        const roundedSize = roundedP2 * 12;
        if (this._iBuffers.length <= roundedSizeIndex) this._iBuffers.length = roundedSizeIndex + 1;
        let buffer = this._iBuffers[roundedSizeIndex];
        if (!buffer) this._iBuffers[roundedSizeIndex] = buffer = new Uint16Array(roundedSize);
        return buffer;
    }
    packInterleavedGeometry(element, attributeBuffer, indexBuffer, aIndex, iIndex) {
        const { uint32View: uint32View , float32View: float32View  } = attributeBuffer;
        const packedVertices = aIndex / this.vertexSize;
        const uvs = element.uvs;
        const indicies = element.indices;
        const vertexData = element.vertexData;
        const textureId = element._texture.baseTexture._batchLocation;
        const alpha = Math.min(element.worldAlpha, 1);
        const argb = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(element._tintRGB).toPremultiplied(alpha, element._texture.baseTexture.alphaMode > 0);
        for(let i = 0; i < vertexData.length; i += 2){
            float32View[aIndex++] = vertexData[i];
            float32View[aIndex++] = vertexData[i + 1];
            float32View[aIndex++] = uvs[i];
            float32View[aIndex++] = uvs[i + 1];
            uint32View[aIndex++] = argb;
            float32View[aIndex++] = textureId;
        }
        for(let i = 0; i < indicies.length; i++)indexBuffer[iIndex++] = packedVertices + indicies[i];
    }
};
let $e9a7bfc7edf84428$export$c6a34b759a134e1d = $e9a7bfc7edf84428$var$_BatchRenderer;
$e9a7bfc7edf84428$export$c6a34b759a134e1d.defaultBatchSize = 4096;
$e9a7bfc7edf84428$export$c6a34b759a134e1d.extension = {
    name: "batch",
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererPlugin
};
$e9a7bfc7edf84428$export$c6a34b759a134e1d._drawCallPool = [];
$e9a7bfc7edf84428$export$c6a34b759a134e1d._textureArrayPool = [];
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($e9a7bfc7edf84428$export$c6a34b759a134e1d);






var $1e66c0fd7b8ead90$export$2e2bcd8739ae039 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor = texture2D(uSampler, vTextureCoord);\n}\n";


var $f2d3581bee163f5a$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";


const $fa5f1d0edfe7960b$var$_Filter = class extends (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5) {
    constructor(vertexSrc, fragmentSrc, uniforms){
        const program = (0, $52e5734958fc1bae$export$b6c59b989905b650).from(vertexSrc || $fa5f1d0edfe7960b$var$_Filter.defaultVertexSrc, fragmentSrc || $fa5f1d0edfe7960b$var$_Filter.defaultFragmentSrc);
        super(program, uniforms);
        this.padding = 0;
        this.resolution = $fa5f1d0edfe7960b$var$_Filter.defaultResolution;
        this.multisample = $fa5f1d0edfe7960b$var$_Filter.defaultMultisample;
        this.enabled = true;
        this.autoFit = true;
        this.state = new (0, $15a50e9cd387ae21$export$7254cc27399e90bd)();
    }
    apply(filterManager, input, output, clearMode, _currentState) {
        filterManager.applyFilter(this, input, output, clearMode);
    }
    get blendMode() {
        return this.state.blendMode;
    }
    set blendMode(value) {
        this.state.blendMode = value;
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._resolution = value;
    }
    static get defaultVertexSrc() {
        return 0, $f2d3581bee163f5a$export$2e2bcd8739ae039;
    }
    static get defaultFragmentSrc() {
        return 0, $1e66c0fd7b8ead90$export$2e2bcd8739ae039;
    }
};
let $fa5f1d0edfe7960b$export$ec91da630f36d5ea = $fa5f1d0edfe7960b$var$_Filter;
$fa5f1d0edfe7960b$export$ec91da630f36d5ea.defaultResolution = 1;
$fa5f1d0edfe7960b$export$ec91da630f36d5ea.defaultMultisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE;





class $7443fcf12643cbe1$export$c69cd65c8827ac23 {
    constructor(){
        this.clearBeforeRender = true;
        this._backgroundColor = new (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e)(0);
        this.alpha = 1;
    }
    init(options) {
        this.clearBeforeRender = options.clearBeforeRender;
        const { backgroundColor: backgroundColor , background: background , backgroundAlpha: backgroundAlpha  } = options;
        const color = background ?? backgroundColor;
        if (color !== void 0) this.color = color;
        this.alpha = backgroundAlpha;
    }
    get color() {
        return this._backgroundColor.value;
    }
    set color(value) {
        this._backgroundColor.setValue(value);
    }
    get alpha() {
        return this._backgroundColor.alpha;
    }
    set alpha(value) {
        this._backgroundColor.setAlpha(value);
    }
    get backgroundColor() {
        return this._backgroundColor;
    }
    destroy() {}
}
$7443fcf12643cbe1$export$c69cd65c8827ac23.defaultOptions = {
    backgroundAlpha: 1,
    backgroundColor: 0,
    clearBeforeRender: true
};
$7443fcf12643cbe1$export$c69cd65c8827ac23.extension = {
    type: [
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "background"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($7443fcf12643cbe1$export$c69cd65c8827ac23);




class $b80e39c4131cc29b$export$beb481275b7bcccc {
    constructor(renderer){
        this.renderer = renderer;
        this.emptyRenderer = new (0, $ec9c34a32f35795b$export$ca67b0b0fa758253)(renderer);
        this.currentRenderer = this.emptyRenderer;
    }
    setObjectRenderer(objectRenderer) {
        if (this.currentRenderer === objectRenderer) return;
        this.currentRenderer.stop();
        this.currentRenderer = objectRenderer;
        this.currentRenderer.start();
    }
    flush() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    reset() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    copyBoundTextures(arr, maxTextures) {
        const { boundTextures: boundTextures  } = this.renderer.texture;
        for(let i = maxTextures - 1; i >= 0; --i){
            arr[i] = boundTextures[i] || null;
            if (arr[i]) arr[i]._batchLocation = i;
        }
    }
    boundArray(texArray, boundTextures, batchId, maxTextures) {
        const { elements: elements , ids: ids , count: count  } = texArray;
        let j = 0;
        for(let i = 0; i < count; i++){
            const tex = elements[i];
            const loc = tex._batchLocation;
            if (loc >= 0 && loc < maxTextures && boundTextures[loc] === tex) {
                ids[i] = loc;
                continue;
            }
            while(j < maxTextures){
                const bound = boundTextures[j];
                if (bound && bound._batchEnabled === batchId && bound._batchLocation === j) {
                    j++;
                    continue;
                }
                ids[i] = j;
                tex._batchLocation = j;
                boundTextures[j] = tex;
                break;
            }
        }
    }
    destroy() {
        this.renderer = null;
    }
}
$b80e39c4131cc29b$export$beb481275b7bcccc.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "batch"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($b80e39c4131cc29b$export$beb481275b7bcccc);





let $2d30752d87b0cf51$var$CONTEXT_UID_COUNTER = 0;
class $2d30752d87b0cf51$export$fedaac80f6f9518c {
    constructor(renderer){
        this.renderer = renderer;
        this.webGLVersion = 1;
        this.extensions = {};
        this.supports = {
            uint32Indices: false
        };
        this.handleContextLost = this.handleContextLost.bind(this);
        this.handleContextRestored = this.handleContextRestored.bind(this);
    }
    get isLost() {
        return !this.gl || this.gl.isContextLost();
    }
    contextChange(gl) {
        this.gl = gl;
        this.renderer.gl = gl;
        this.renderer.CONTEXT_UID = $2d30752d87b0cf51$var$CONTEXT_UID_COUNTER++;
    }
    init(options) {
        if (options.context) this.initFromContext(options.context);
        else {
            const alpha = this.renderer.background.alpha < 1;
            const premultipliedAlpha = options.premultipliedAlpha;
            this.preserveDrawingBuffer = options.preserveDrawingBuffer;
            this.useContextAlpha = options.useContextAlpha;
            this.powerPreference = options.powerPreference;
            this.initFromOptions({
                alpha: alpha,
                premultipliedAlpha: premultipliedAlpha,
                antialias: options.antialias,
                stencil: true,
                preserveDrawingBuffer: options.preserveDrawingBuffer,
                powerPreference: options.powerPreference
            });
        }
    }
    initFromContext(gl) {
        this.gl = gl;
        this.validateContext(gl);
        this.renderer.gl = gl;
        this.renderer.CONTEXT_UID = $2d30752d87b0cf51$var$CONTEXT_UID_COUNTER++;
        this.renderer.runners.contextChange.emit(gl);
        const view = this.renderer.view;
        if (view.addEventListener !== void 0) {
            view.addEventListener("webglcontextlost", this.handleContextLost, false);
            view.addEventListener("webglcontextrestored", this.handleContextRestored, false);
        }
    }
    initFromOptions(options) {
        const gl = this.createContext(this.renderer.view, options);
        this.initFromContext(gl);
    }
    createContext(canvas, options) {
        let gl;
        if ((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).PREFER_ENV >= (0, $551209d754b5b429$export$83401e34d5e11bf4).WEBGL2) gl = canvas.getContext("webgl2", options);
        if (gl) this.webGLVersion = 2;
        else {
            this.webGLVersion = 1;
            gl = canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options);
            if (!gl) throw new Error("This browser does not support WebGL. Try using the canvas renderer");
        }
        this.gl = gl;
        this.getExtensions();
        return this.gl;
    }
    getExtensions() {
        const { gl: gl  } = this;
        const common = {
            loseContext: gl.getExtension("WEBGL_lose_context"),
            anisotropicFiltering: gl.getExtension("EXT_texture_filter_anisotropic"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            s3tc: gl.getExtension("WEBGL_compressed_texture_s3tc"),
            s3tc_sRGB: gl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
            etc: gl.getExtension("WEBGL_compressed_texture_etc"),
            etc1: gl.getExtension("WEBGL_compressed_texture_etc1"),
            pvrtc: gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            atc: gl.getExtension("WEBGL_compressed_texture_atc"),
            astc: gl.getExtension("WEBGL_compressed_texture_astc")
        };
        if (this.webGLVersion === 1) Object.assign(this.extensions, common, {
            drawBuffers: gl.getExtension("WEBGL_draw_buffers"),
            depthTexture: gl.getExtension("WEBGL_depth_texture"),
            vertexArrayObject: gl.getExtension("OES_vertex_array_object") || gl.getExtension("MOZ_OES_vertex_array_object") || gl.getExtension("WEBKIT_OES_vertex_array_object"),
            uint32ElementIndex: gl.getExtension("OES_element_index_uint"),
            floatTexture: gl.getExtension("OES_texture_float"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            textureHalfFloat: gl.getExtension("OES_texture_half_float"),
            textureHalfFloatLinear: gl.getExtension("OES_texture_half_float_linear")
        });
        else if (this.webGLVersion === 2) Object.assign(this.extensions, common, {
            colorBufferFloat: gl.getExtension("EXT_color_buffer_float")
        });
    }
    handleContextLost(event) {
        event.preventDefault();
        setTimeout(()=>{
            if (this.gl.isContextLost() && this.extensions.loseContext) this.extensions.loseContext.restoreContext();
        }, 0);
    }
    handleContextRestored() {
        this.renderer.runners.contextChange.emit(this.gl);
    }
    destroy() {
        const view = this.renderer.view;
        this.renderer = null;
        if (view.removeEventListener !== void 0) {
            view.removeEventListener("webglcontextlost", this.handleContextLost);
            view.removeEventListener("webglcontextrestored", this.handleContextRestored);
        }
        this.gl.useProgram(null);
        if (this.extensions.loseContext) this.extensions.loseContext.loseContext();
    }
    postrender() {
        if (this.renderer.objectRenderer.renderingToScreen) this.gl.flush();
    }
    validateContext(gl) {
        const attributes = gl.getContextAttributes();
        const isWebGl2 = "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext;
        if (isWebGl2) this.webGLVersion = 2;
        if (attributes && !attributes.stencil) console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
        const hasuint32 = isWebGl2 || !!gl.getExtension("OES_element_index_uint");
        this.supports.uint32Indices = hasuint32;
        if (!hasuint32) console.warn("Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly");
    }
}
$2d30752d87b0cf51$export$fedaac80f6f9518c.defaultOptions = {
    context: null,
    antialias: false,
    premultipliedAlpha: true,
    preserveDrawingBuffer: false,
    powerPreference: "default"
};
$2d30752d87b0cf51$export$fedaac80f6f9518c.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "context"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($2d30752d87b0cf51$export$fedaac80f6f9518c);














class $f2a1ec923771a384$export$bc6830851440b885 extends (0, $ad9971bad38b5f89$export$a79ef781de624449) {
    upload(renderer, baseTexture, glTexture) {
        const gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $551209d754b5b429$export$d56550d454401b73).UNPACK);
        const width = baseTexture.realWidth;
        const height = baseTexture.realHeight;
        if (glTexture.width === width && glTexture.height === height) gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data);
        }
        return true;
    }
}


class $2a038313609da7f8$export$eff95f126aa67cfb {
    constructor(width, height){
        this.width = Math.round(width || 100);
        this.height = Math.round(height || 100);
        this.stencil = false;
        this.depth = false;
        this.dirtyId = 0;
        this.dirtyFormat = 0;
        this.dirtySize = 0;
        this.depthTexture = null;
        this.colorTextures = [];
        this.glFramebuffers = {};
        this.disposeRunner = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("disposeFramebuffer");
        this.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE;
    }
    get colorTexture() {
        return this.colorTextures[0];
    }
    addColorTexture(index = 0, texture) {
        this.colorTextures[index] = texture || new (0, $2d8d497fce3a4092$export$d6306e508f184154)(null, {
            scaleMode: (0, $551209d754b5b429$export$6b734c6a0bba8473).NEAREST,
            resolution: 1,
            mipmap: (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF,
            width: this.width,
            height: this.height
        });
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    }
    addDepthTexture(texture) {
        this.depthTexture = texture || new (0, $2d8d497fce3a4092$export$d6306e508f184154)(new (0, $f2a1ec923771a384$export$bc6830851440b885)(null, {
            width: this.width,
            height: this.height
        }), {
            scaleMode: (0, $551209d754b5b429$export$6b734c6a0bba8473).NEAREST,
            resolution: 1,
            width: this.width,
            height: this.height,
            mipmap: (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF,
            format: (0, $551209d754b5b429$export$e9c4b7b466aa8274).DEPTH_COMPONENT,
            type: (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT
        });
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    }
    enableDepth() {
        this.depth = true;
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    }
    enableStencil() {
        this.stencil = true;
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    }
    resize(width, height) {
        width = Math.round(width);
        height = Math.round(height);
        if (width === this.width && height === this.height) return;
        this.width = width;
        this.height = height;
        this.dirtyId++;
        this.dirtySize++;
        for(let i = 0; i < this.colorTextures.length; i++){
            const texture = this.colorTextures[i];
            const resolution = texture.resolution;
            texture.setSize(width / resolution, height / resolution);
        }
        if (this.depthTexture) {
            const resolution = this.depthTexture.resolution;
            this.depthTexture.setSize(width / resolution, height / resolution);
        }
    }
    dispose() {
        this.disposeRunner.emit(this, false);
    }
    destroyDepthTexture() {
        if (this.depthTexture) {
            this.depthTexture.destroy();
            this.depthTexture = null;
            ++this.dirtyId;
            ++this.dirtyFormat;
        }
    }
}



class $7511dacad386c8be$export$18d268c71e34cf2c extends (0, $2d8d497fce3a4092$export$d6306e508f184154) {
    constructor(options = {}){
        if (typeof options === "number") {
            const width = arguments[0];
            const height = arguments[1];
            const scaleMode = arguments[2];
            const resolution = arguments[3];
            options = {
                width: width,
                height: height,
                scaleMode: scaleMode,
                resolution: resolution
            };
        }
        options.width = options.width || 100;
        options.height = options.height || 100;
        options.multisample ?? (options.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE);
        super(null, options);
        this.mipmap = (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF;
        this.valid = true;
        this._clear = new (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e)([
            0,
            0,
            0,
            0
        ]);
        this.framebuffer = new (0, $2a038313609da7f8$export$eff95f126aa67cfb)(this.realWidth, this.realHeight).addColorTexture(0, this);
        this.framebuffer.multisample = options.multisample;
        this.maskStack = [];
        this.filterStack = [
            {}
        ];
    }
    set clearColor(value) {
        this._clear.setValue(value);
    }
    get clearColor() {
        return this._clear.value;
    }
    get clear() {
        return this._clear;
    }
    resize(desiredWidth, desiredHeight) {
        this.framebuffer.resize(desiredWidth * this.resolution, desiredHeight * this.resolution);
        this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    }
    dispose() {
        this.framebuffer.dispose();
        super.dispose();
    }
    destroy() {
        super.destroy();
        this.framebuffer.destroyDepthTexture();
        this.framebuffer = null;
    }
}











class $9909c4093f866353$export$c87b2a1e7e3bb4a6 extends (0, $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63) {
    constructor(source){
        const sourceAny = source;
        const width = sourceAny.naturalWidth || sourceAny.videoWidth || sourceAny.width;
        const height = sourceAny.naturalHeight || sourceAny.videoHeight || sourceAny.height;
        super(width, height);
        this.source = source;
        this.noSubImage = false;
    }
    static crossOrigin(element, url, crossorigin) {
        if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = (0, $f01e55b6e1f6f3d8$export$292083da55c5b406)(url);
        else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
    }
    upload(renderer, baseTexture, glTexture, source) {
        const gl = renderer.gl;
        const width = baseTexture.realWidth;
        const height = baseTexture.realHeight;
        source = source || this.source;
        if (typeof HTMLImageElement !== "undefined" && source instanceof HTMLImageElement) {
            if (!source.complete || source.naturalWidth === 0) return false;
        } else if (typeof HTMLVideoElement !== "undefined" && source instanceof HTMLVideoElement) {
            if (source.readyState <= 1 && source.buffered.length === 0) return false;
        }
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $551209d754b5b429$export$d56550d454401b73).UNPACK);
        if (!this.noSubImage && baseTexture.target === gl.TEXTURE_2D && glTexture.width === width && glTexture.height === height) gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, baseTexture.format, glTexture.type, source);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, baseTexture.format, glTexture.type, source);
        }
        return true;
    }
    update() {
        if (this.destroyed) return;
        const source = this.source;
        const width = source.naturalWidth || source.videoWidth || source.width;
        const height = source.naturalHeight || source.videoHeight || source.height;
        this.resize(width, height);
        super.update();
    }
    dispose() {
        this.source = null;
    }
}


class $8d0497df0f10e502$export$6d0d25e6e731a9a2 extends (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6) {
    constructor(source, options){
        options = options || {};
        if (typeof source === "string") {
            const imageElement = new Image();
            (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6).crossOrigin(imageElement, source, options.crossorigin);
            imageElement.src = source;
            source = imageElement;
        }
        super(source);
        if (!source.complete && !!this._width && !!this._height) {
            this._width = 0;
            this._height = 0;
        }
        this.url = source.src;
        this._process = null;
        this.preserveBitmap = false;
        this.createBitmap = (options.createBitmap ?? (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap;
        this.alphaMode = typeof options.alphaMode === "number" ? options.alphaMode : null;
        this.bitmap = null;
        this._load = null;
        if (options.autoLoad !== false) this.load();
    }
    load(createBitmap) {
        if (this._load) return this._load;
        if (createBitmap !== void 0) this.createBitmap = createBitmap;
        this._load = new Promise((resolve, reject)=>{
            const source = this.source;
            this.url = source.src;
            const completed = ()=>{
                if (this.destroyed) return;
                source.onload = null;
                source.onerror = null;
                this.resize(source.width, source.height);
                this._load = null;
                if (this.createBitmap) resolve(this.process());
                else resolve(this);
            };
            if (source.complete && source.src) completed();
            else {
                source.onload = completed;
                source.onerror = (event)=>{
                    reject(event);
                    this.onError.emit(event);
                };
            }
        });
        return this._load;
    }
    process() {
        const source = this.source;
        if (this._process !== null) return this._process;
        if (this.bitmap !== null || !globalThis.createImageBitmap) return Promise.resolve(this);
        const createImageBitmap = globalThis.createImageBitmap;
        const cors = !source.crossOrigin || source.crossOrigin === "anonymous";
        this._process = fetch(source.src, {
            mode: cors ? "cors" : "no-cors"
        }).then((r)=>r.blob()).then((blob)=>createImageBitmap(blob, 0, 0, source.width, source.height, {
                premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $551209d754b5b429$export$d56550d454401b73).UNPACK ? "premultiply" : "none"
            })).then((bitmap)=>{
            if (this.destroyed) return Promise.reject();
            this.bitmap = bitmap;
            this.update();
            this._process = null;
            return Promise.resolve(this);
        });
        return this._process;
    }
    upload(renderer, baseTexture, glTexture) {
        if (typeof this.alphaMode === "number") baseTexture.alphaMode = this.alphaMode;
        if (!this.createBitmap) return super.upload(renderer, baseTexture, glTexture);
        if (!this.bitmap) {
            this.process();
            if (!this.bitmap) return false;
        }
        super.upload(renderer, baseTexture, glTexture, this.bitmap);
        if (!this.preserveBitmap) {
            let flag = true;
            const glTextures = baseTexture._glTextures;
            for(const key in glTextures){
                const otherTex = glTextures[key];
                if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
                    flag = false;
                    break;
                }
            }
            if (flag) {
                if (this.bitmap.close) this.bitmap.close();
                this.bitmap = null;
            }
        }
        return true;
    }
    dispose() {
        this.source.onload = null;
        this.source.onerror = null;
        super.dispose();
        if (this.bitmap) {
            this.bitmap.close();
            this.bitmap = null;
        }
        this._process = null;
        this._load = null;
    }
    static test(source) {
        return typeof HTMLImageElement !== "undefined" && (typeof source === "string" || source instanceof HTMLImageElement);
    }
}



class $eea3d7b0746979d2$export$4efdf5c542d7171e {
    constructor(){
        this.x0 = 0;
        this.y0 = 0;
        this.x1 = 1;
        this.y1 = 0;
        this.x2 = 1;
        this.y2 = 1;
        this.x3 = 0;
        this.y3 = 1;
        this.uvsFloat32 = new Float32Array(8);
    }
    set(frame, baseFrame, rotate) {
        const tw = baseFrame.width;
        const th = baseFrame.height;
        if (rotate) {
            const w2 = frame.width / 2 / tw;
            const h2 = frame.height / 2 / th;
            const cX = frame.x / tw + w2;
            const cY = frame.y / th + h2;
            rotate = (0, $c91a285233559d80$export$b7bb6a2a8d203102).add(rotate, (0, $c91a285233559d80$export$b7bb6a2a8d203102).NW);
            this.x0 = cX + w2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uX(rotate);
            this.y0 = cY + h2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uY(rotate);
            rotate = (0, $c91a285233559d80$export$b7bb6a2a8d203102).add(rotate, 2);
            this.x1 = cX + w2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uX(rotate);
            this.y1 = cY + h2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uY(rotate);
            rotate = (0, $c91a285233559d80$export$b7bb6a2a8d203102).add(rotate, 2);
            this.x2 = cX + w2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uX(rotate);
            this.y2 = cY + h2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uY(rotate);
            rotate = (0, $c91a285233559d80$export$b7bb6a2a8d203102).add(rotate, 2);
            this.x3 = cX + w2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uX(rotate);
            this.y3 = cY + h2 * (0, $c91a285233559d80$export$b7bb6a2a8d203102).uY(rotate);
        } else {
            this.x0 = frame.x / tw;
            this.y0 = frame.y / th;
            this.x1 = (frame.x + frame.width) / tw;
            this.y1 = frame.y / th;
            this.x2 = (frame.x + frame.width) / tw;
            this.y2 = (frame.y + frame.height) / th;
            this.x3 = frame.x / tw;
            this.y3 = (frame.y + frame.height) / th;
        }
        this.uvsFloat32[0] = this.x0;
        this.uvsFloat32[1] = this.y0;
        this.uvsFloat32[2] = this.x1;
        this.uvsFloat32[3] = this.y1;
        this.uvsFloat32[4] = this.x2;
        this.uvsFloat32[5] = this.y2;
        this.uvsFloat32[6] = this.x3;
        this.uvsFloat32[7] = this.y3;
    }
    toString() {
        return `[@pixi/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
    }
}


const $6ac4ad2139942545$var$DEFAULT_UVS = new (0, $eea3d7b0746979d2$export$4efdf5c542d7171e)();
function $6ac4ad2139942545$var$removeAllHandlers(tex) {
    tex.destroy = function _emptyDestroy() {};
    tex.on = function _emptyOn() {};
    tex.once = function _emptyOnce() {};
    tex.emit = function _emptyEmit() {};
}
class $6ac4ad2139942545$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($f08921b7a62a95d1$exports))) {
    constructor(baseTexture, frame, orig, trim, rotate, anchor, borders){
        super();
        this.noFrame = false;
        if (!frame) {
            this.noFrame = true;
            frame = new (0, $340a428aa13511cc$export$4617fb02663045ef)(0, 0, 1, 1);
        }
        if (baseTexture instanceof $6ac4ad2139942545$export$5431306cf43de24a) baseTexture = baseTexture.baseTexture;
        this.baseTexture = baseTexture;
        this._frame = frame;
        this.trim = trim;
        this.valid = false;
        this._uvs = $6ac4ad2139942545$var$DEFAULT_UVS;
        this.uvMatrix = null;
        this.orig = orig || frame;
        this._rotate = Number(rotate || 0);
        if (rotate === true) this._rotate = 2;
        else if (this._rotate % 2 !== 0) throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
        this.defaultAnchor = anchor ? new (0, $88931fa1c0809be8$export$baf26146a414f24a)(anchor.x, anchor.y) : new (0, $88931fa1c0809be8$export$baf26146a414f24a)(0, 0);
        this.defaultBorders = borders;
        this._updateID = 0;
        this.textureCacheIds = [];
        if (!baseTexture.valid) baseTexture.once("loaded", this.onBaseTextureUpdated, this);
        else if (this.noFrame) {
            if (baseTexture.valid) this.onBaseTextureUpdated(baseTexture);
        } else this.frame = frame;
        if (this.noFrame) baseTexture.on("update", this.onBaseTextureUpdated, this);
    }
    update() {
        if (this.baseTexture.resource) this.baseTexture.resource.update();
    }
    onBaseTextureUpdated(baseTexture) {
        if (this.noFrame) {
            if (!this.baseTexture.valid) return;
            this._frame.width = baseTexture.width;
            this._frame.height = baseTexture.height;
            this.valid = true;
            this.updateUvs();
        } else this.frame = this._frame;
        this.emit("update", this);
    }
    destroy(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                const { resource: resource  } = this.baseTexture;
                if (resource?.url && (0, $db4392de79d671a3$export$4254ab7c0971430e)[resource.url]) $6ac4ad2139942545$export$5431306cf43de24a.removeFromCache(resource.url);
                this.baseTexture.destroy();
            }
            this.baseTexture.off("loaded", this.onBaseTextureUpdated, this);
            this.baseTexture.off("update", this.onBaseTextureUpdated, this);
            this.baseTexture = null;
        }
        this._frame = null;
        this._uvs = null;
        this.trim = null;
        this.orig = null;
        this.valid = false;
        $6ac4ad2139942545$export$5431306cf43de24a.removeFromCache(this);
        this.textureCacheIds = null;
    }
    clone() {
        const clonedFrame = this._frame.clone();
        const clonedOrig = this._frame === this.orig ? clonedFrame : this.orig.clone();
        const clonedTexture = new $6ac4ad2139942545$export$5431306cf43de24a(this.baseTexture, !this.noFrame && clonedFrame, clonedOrig, this.trim?.clone(), this.rotate, this.defaultAnchor, this.defaultBorders);
        if (this.noFrame) clonedTexture._frame = clonedFrame;
        return clonedTexture;
    }
    updateUvs() {
        if (this._uvs === $6ac4ad2139942545$var$DEFAULT_UVS) this._uvs = new (0, $eea3d7b0746979d2$export$4efdf5c542d7171e)();
        this._uvs.set(this._frame, this.baseTexture, this.rotate);
        this._updateID++;
    }
    static from(source, options = {}, strict = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source === "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else if (source instanceof (0, $2d8d497fce3a4092$export$d6306e508f184154)) {
            if (!source.cacheId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source.cacheId = `${prefix}-${(0, $a8272ede630bda06$export$e2a22331486dcca0)()}`;
                (0, $2d8d497fce3a4092$export$d6306e508f184154).addToCache(source, source.cacheId);
            }
            cacheId = source.cacheId;
        } else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $a8272ede630bda06$export$e2a22331486dcca0)()}`;
            }
            cacheId = source._pixiId;
        }
        let texture = (0, $db4392de79d671a3$export$4254ab7c0971430e)[cacheId];
        if (isFrame && strict && !texture) throw new Error(`The cacheId "${cacheId}" does not exist in TextureCache.`);
        if (!texture && !(source instanceof (0, $2d8d497fce3a4092$export$d6306e508f184154))) {
            if (!options.resolution) options.resolution = (0, $b264b48efa69e862$export$8695ab2f322d2637)(source);
            texture = new $6ac4ad2139942545$export$5431306cf43de24a(new (0, $2d8d497fce3a4092$export$d6306e508f184154)(source, options));
            texture.baseTexture.cacheId = cacheId;
            (0, $2d8d497fce3a4092$export$d6306e508f184154).addToCache(texture.baseTexture, cacheId);
            $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, cacheId);
        } else if (!texture && source instanceof (0, $2d8d497fce3a4092$export$d6306e508f184154)) {
            texture = new $6ac4ad2139942545$export$5431306cf43de24a(source);
            $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, cacheId);
        }
        return texture;
    }
    static fromURL(url, options) {
        const resourceOptions = Object.assign({
            autoLoad: false
        }, options?.resourceOptions);
        const texture = $6ac4ad2139942545$export$5431306cf43de24a.from(url, Object.assign({
            resourceOptions: resourceOptions
        }, options), false);
        const resource = texture.baseTexture.resource;
        if (texture.baseTexture.valid) return Promise.resolve(texture);
        return resource.load().then(()=>Promise.resolve(texture));
    }
    static fromBuffer(buffer, width, height, options) {
        return new $6ac4ad2139942545$export$5431306cf43de24a((0, $2d8d497fce3a4092$export$d6306e508f184154).fromBuffer(buffer, width, height, options));
    }
    static fromLoader(source, imageUrl, name, options) {
        const baseTexture = new (0, $2d8d497fce3a4092$export$d6306e508f184154)(source, Object.assign({
            scaleMode: (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.scaleMode,
            resolution: (0, $b264b48efa69e862$export$8695ab2f322d2637)(imageUrl)
        }, options));
        const { resource: resource  } = baseTexture;
        if (resource instanceof (0, $8d0497df0f10e502$export$6d0d25e6e731a9a2)) resource.url = imageUrl;
        const texture = new $6ac4ad2139942545$export$5431306cf43de24a(baseTexture);
        if (!name) name = imageUrl;
        (0, $2d8d497fce3a4092$export$d6306e508f184154).addToCache(texture.baseTexture, name);
        $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, name);
        if (name !== imageUrl) {
            (0, $2d8d497fce3a4092$export$d6306e508f184154).addToCache(texture.baseTexture, imageUrl);
            $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, imageUrl);
        }
        if (texture.baseTexture.valid) return Promise.resolve(texture);
        return new Promise((resolve)=>{
            texture.baseTexture.once("loaded", ()=>resolve(texture));
        });
    }
    static addToCache(texture, id) {
        if (id) {
            if (!texture.textureCacheIds.includes(id)) texture.textureCacheIds.push(id);
            if ((0, $db4392de79d671a3$export$4254ab7c0971430e)[id] && (0, $db4392de79d671a3$export$4254ab7c0971430e)[id] !== texture) console.warn(`Texture added to the cache with an id [${id}] that already had an entry`);
            (0, $db4392de79d671a3$export$4254ab7c0971430e)[id] = texture;
        }
    }
    static removeFromCache(texture) {
        if (typeof texture === "string") {
            const textureFromCache = (0, $db4392de79d671a3$export$4254ab7c0971430e)[texture];
            if (textureFromCache) {
                const index = textureFromCache.textureCacheIds.indexOf(texture);
                if (index > -1) textureFromCache.textureCacheIds.splice(index, 1);
                delete (0, $db4392de79d671a3$export$4254ab7c0971430e)[texture];
                return textureFromCache;
            }
        } else if (texture?.textureCacheIds) {
            for(let i = 0; i < texture.textureCacheIds.length; ++i)if ((0, $db4392de79d671a3$export$4254ab7c0971430e)[texture.textureCacheIds[i]] === texture) delete (0, $db4392de79d671a3$export$4254ab7c0971430e)[texture.textureCacheIds[i]];
            texture.textureCacheIds.length = 0;
            return texture;
        }
        return null;
    }
    get resolution() {
        return this.baseTexture.resolution;
    }
    get frame() {
        return this._frame;
    }
    set frame(frame) {
        this._frame = frame;
        this.noFrame = false;
        const { x: x , y: y , width: width , height: height  } = frame;
        const xNotFit = x + width > this.baseTexture.width;
        const yNotFit = y + height > this.baseTexture.height;
        if (xNotFit || yNotFit) {
            const relationship = xNotFit && yNotFit ? "and" : "or";
            const errorX = `X: ${x} + ${width} = ${x + width} > ${this.baseTexture.width}`;
            const errorY = `Y: ${y} + ${height} = ${y + height} > ${this.baseTexture.height}`;
            throw new Error(`Texture Error: frame does not fit inside the base Texture dimensions: ${errorX} ${relationship} ${errorY}`);
        }
        this.valid = width && height && this.baseTexture.valid;
        if (!this.trim && !this.rotate) this.orig = frame;
        if (this.valid) this.updateUvs();
    }
    get rotate() {
        return this._rotate;
    }
    set rotate(rotate) {
        this._rotate = rotate;
        if (this.valid) this.updateUvs();
    }
    get width() {
        return this.orig.width;
    }
    get height() {
        return this.orig.height;
    }
    castToBaseTexture() {
        return this.baseTexture;
    }
    static get EMPTY() {
        if (!$6ac4ad2139942545$export$5431306cf43de24a._EMPTY) {
            $6ac4ad2139942545$export$5431306cf43de24a._EMPTY = new $6ac4ad2139942545$export$5431306cf43de24a(new (0, $2d8d497fce3a4092$export$d6306e508f184154)());
            $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._EMPTY);
            $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._EMPTY.baseTexture);
        }
        return $6ac4ad2139942545$export$5431306cf43de24a._EMPTY;
    }
    static get WHITE() {
        if (!$6ac4ad2139942545$export$5431306cf43de24a._WHITE) {
            const canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas(16, 16);
            const context = canvas.getContext("2d");
            canvas.width = 16;
            canvas.height = 16;
            context.fillStyle = "white";
            context.fillRect(0, 0, 16, 16);
            $6ac4ad2139942545$export$5431306cf43de24a._WHITE = new $6ac4ad2139942545$export$5431306cf43de24a((0, $2d8d497fce3a4092$export$d6306e508f184154).from(canvas));
            $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._WHITE);
            $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._WHITE.baseTexture);
        }
        return $6ac4ad2139942545$export$5431306cf43de24a._WHITE;
    }
}



class $952e32ce616eaf78$export$813984f7330b4d72 extends (0, $6ac4ad2139942545$export$5431306cf43de24a) {
    constructor(baseRenderTexture, frame){
        super(baseRenderTexture, frame);
        this.valid = true;
        this.filterFrame = null;
        this.filterPoolKey = null;
        this.updateUvs();
    }
    get framebuffer() {
        return this.baseTexture.framebuffer;
    }
    get multisample() {
        return this.framebuffer.multisample;
    }
    set multisample(value) {
        this.framebuffer.multisample = value;
    }
    resize(desiredWidth, desiredHeight, resizeBaseTexture = true) {
        const resolution = this.baseTexture.resolution;
        const width = Math.round(desiredWidth * resolution) / resolution;
        const height = Math.round(desiredHeight * resolution) / resolution;
        this.valid = width > 0 && height > 0;
        this._frame.width = this.orig.width = width;
        this._frame.height = this.orig.height = height;
        if (resizeBaseTexture) this.baseTexture.resize(width, height);
        this.updateUvs();
    }
    setResolution(resolution) {
        const { baseTexture: baseTexture  } = this;
        if (baseTexture.resolution === resolution) return;
        baseTexture.setResolution(resolution);
        this.resize(baseTexture.width, baseTexture.height, false);
    }
    static create(options) {
        return new $952e32ce616eaf78$export$813984f7330b4d72(new (0, $7511dacad386c8be$export$18d268c71e34cf2c)(options));
    }
}


class $3a228e82a25656e0$export$1a441d2b5f37dfd7 {
    constructor(textureOptions){
        this.texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this._pixelsWidth = 0;
        this._pixelsHeight = 0;
    }
    createTexture(realWidth, realHeight, multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE) {
        const baseRenderTexture = new (0, $7511dacad386c8be$export$18d268c71e34cf2c)(Object.assign({
            width: realWidth,
            height: realHeight,
            resolution: 1,
            multisample: multisample
        }, this.textureOptions));
        return new (0, $952e32ce616eaf78$export$813984f7330b4d72)(baseRenderTexture);
    }
    getOptimalTexture(minWidth, minHeight, resolution = 1, multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE) {
        let key;
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        if (!this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight) {
            minWidth = (0, $5728f69a05940f94$export$f0d90cf68bd426eb)(minWidth);
            minHeight = (0, $5728f69a05940f94$export$f0d90cf68bd426eb)(minHeight);
            key = ((minWidth & 65535) << 16 | minHeight & 65535) >>> 0;
            if (multisample > 1) key += multisample * 4294967296;
        } else key = multisample > 1 ? -multisample : -1;
        if (!this.texturePool[key]) this.texturePool[key] = [];
        let renderTexture = this.texturePool[key].pop();
        if (!renderTexture) renderTexture = this.createTexture(minWidth, minHeight, multisample);
        renderTexture.filterPoolKey = key;
        renderTexture.setResolution(resolution);
        return renderTexture;
    }
    getFilterTexture(input, resolution, multisample) {
        const filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE);
        filterTexture.filterFrame = input.filterFrame;
        return filterTexture;
    }
    returnTexture(renderTexture) {
        const key = renderTexture.filterPoolKey;
        renderTexture.filterFrame = null;
        this.texturePool[key].push(renderTexture);
    }
    returnFilterTexture(renderTexture) {
        this.returnTexture(renderTexture);
    }
    clear(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(const i in this.texturePool){
            const textures = this.texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this.texturePool = {};
    }
    setScreenSize(size) {
        if (size.width === this._pixelsWidth && size.height === this._pixelsHeight) return;
        this.enableFullScreen = size.width > 0 && size.height > 0;
        for(const i in this.texturePool){
            if (!(Number(i) < 0)) continue;
            const textures = this.texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
            this.texturePool[i] = [];
        }
        this._pixelsWidth = size.width;
        this._pixelsHeight = size.height;
    }
}
$3a228e82a25656e0$export$1a441d2b5f37dfd7.SCREEN_KEY = -1;




class $c9042951808e8305$export$7005c9eb6671414d extends (0, $18b317c5775068cf$export$2db6c17465f94a2) {
    constructor(){
        super();
        this.addAttribute("aVertexPosition", new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ])).addIndex([
            0,
            1,
            3,
            2
        ]);
    }
}




class $279feea3d3a65b2d$export$4f70783f37e4ec0b extends (0, $18b317c5775068cf$export$2db6c17465f94a2) {
    constructor(){
        super();
        this.vertices = new Float32Array([
            -1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1
        ]);
        this.uvs = new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]);
        this.vertexBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(this.vertices);
        this.uvBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(this.uvs);
        this.addAttribute("aVertexPosition", this.vertexBuffer).addAttribute("aTextureCoord", this.uvBuffer).addIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
    }
    map(targetTextureFrame, destinationFrame) {
        let x = 0;
        let y = 0;
        this.uvs[0] = x;
        this.uvs[1] = y;
        this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[3] = y;
        this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;
        this.uvs[6] = x;
        this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;
        x = destinationFrame.x;
        y = destinationFrame.y;
        this.vertices[0] = x;
        this.vertices[1] = y;
        this.vertices[2] = x + destinationFrame.width;
        this.vertices[3] = y;
        this.vertices[4] = x + destinationFrame.width;
        this.vertices[5] = y + destinationFrame.height;
        this.vertices[6] = x;
        this.vertices[7] = y + destinationFrame.height;
        this.invalidate();
        return this;
    }
    invalidate() {
        this.vertexBuffer._updateID++;
        this.uvBuffer._updateID++;
        return this;
    }
}




class $748540a892ffb32c$export$ac6e0205a419d6d6 {
    constructor(){
        this.renderTexture = null;
        this.target = null;
        this.legacy = false;
        this.resolution = 1;
        this.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE;
        this.sourceFrame = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.destinationFrame = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.bindingSourceFrame = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.bindingDestinationFrame = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.filters = [];
        this.transform = null;
    }
    clear() {
        this.target = null;
        this.filters = null;
        this.renderTexture = null;
    }
}


const $a52a4a592a10e8d1$var$tempPoints = [
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)(),
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)(),
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)(),
    new (0, $88931fa1c0809be8$export$baf26146a414f24a)()
];
const $a52a4a592a10e8d1$var$tempMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
class $a52a4a592a10e8d1$export$e94225c0dfac29cf {
    constructor(renderer){
        this.renderer = renderer;
        this.defaultFilterStack = [
            {}
        ];
        this.texturePool = new (0, $3a228e82a25656e0$export$1a441d2b5f37dfd7)();
        this.statePool = [];
        this.quad = new (0, $c9042951808e8305$export$7005c9eb6671414d)();
        this.quadUv = new (0, $279feea3d3a65b2d$export$4f70783f37e4ec0b)();
        this.tempRect = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.activeState = {};
        this.globalUniforms = new (0, $d21ea31dd94e9628$export$6601a7a2dcf79bf5)({
            outputFrame: new (0, $340a428aa13511cc$export$4617fb02663045ef)(),
            inputSize: new Float32Array(4),
            inputPixel: new Float32Array(4),
            inputClamp: new Float32Array(4),
            resolution: 1,
            filterArea: new Float32Array(4),
            filterClamp: new Float32Array(4)
        }, true);
        this.forceClear = false;
        this.useMaxPadding = false;
    }
    init() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    push(target, filters) {
        const renderer = this.renderer;
        const filterStack = this.defaultFilterStack;
        const state = this.statePool.pop() || new (0, $748540a892ffb32c$export$ac6e0205a419d6d6)();
        const renderTextureSystem = this.renderer.renderTexture;
        let resolution = filters[0].resolution;
        let multisample = filters[0].multisample;
        let padding = filters[0].padding;
        let autoFit = filters[0].autoFit;
        let legacy = filters[0].legacy ?? true;
        for(let i = 1; i < filters.length; i++){
            const filter = filters[i];
            resolution = Math.min(resolution, filter.resolution);
            multisample = Math.min(multisample, filter.multisample);
            padding = this.useMaxPadding ? Math.max(padding, filter.padding) : padding + filter.padding;
            autoFit = autoFit && filter.autoFit;
            legacy = legacy || (filter.legacy ?? true);
        }
        if (filterStack.length === 1) this.defaultFilterStack[0].renderTexture = renderTextureSystem.current;
        filterStack.push(state);
        state.resolution = resolution;
        state.multisample = multisample;
        state.legacy = legacy;
        state.target = target;
        state.sourceFrame.copyFrom(target.filterArea || target.getBounds(true));
        state.sourceFrame.pad(padding);
        const sourceFrameProjected = this.tempRect.copyFrom(renderTextureSystem.sourceFrame);
        if (renderer.projection.transform) this.transformAABB($a52a4a592a10e8d1$var$tempMatrix.copyFrom(renderer.projection.transform).invert(), sourceFrameProjected);
        if (autoFit) {
            state.sourceFrame.fit(sourceFrameProjected);
            if (state.sourceFrame.width <= 0 || state.sourceFrame.height <= 0) {
                state.sourceFrame.width = 0;
                state.sourceFrame.height = 0;
            }
        } else if (!state.sourceFrame.intersects(sourceFrameProjected)) {
            state.sourceFrame.width = 0;
            state.sourceFrame.height = 0;
        }
        this.roundFrame(state.sourceFrame, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform);
        state.renderTexture = this.getOptimalFilterTexture(state.sourceFrame.width, state.sourceFrame.height, resolution, multisample);
        state.filters = filters;
        state.destinationFrame.width = state.renderTexture.width;
        state.destinationFrame.height = state.renderTexture.height;
        const destinationFrame = this.tempRect;
        destinationFrame.x = 0;
        destinationFrame.y = 0;
        destinationFrame.width = state.sourceFrame.width;
        destinationFrame.height = state.sourceFrame.height;
        state.renderTexture.filterFrame = state.sourceFrame;
        state.bindingSourceFrame.copyFrom(renderTextureSystem.sourceFrame);
        state.bindingDestinationFrame.copyFrom(renderTextureSystem.destinationFrame);
        state.transform = renderer.projection.transform;
        renderer.projection.transform = null;
        renderTextureSystem.bind(state.renderTexture, state.sourceFrame, destinationFrame);
        renderer.framebuffer.clear(0, 0, 0, 0);
    }
    pop() {
        const filterStack = this.defaultFilterStack;
        const state = filterStack.pop();
        const filters = state.filters;
        this.activeState = state;
        const globalUniforms = this.globalUniforms.uniforms;
        globalUniforms.outputFrame = state.sourceFrame;
        globalUniforms.resolution = state.resolution;
        const inputSize = globalUniforms.inputSize;
        const inputPixel = globalUniforms.inputPixel;
        const inputClamp = globalUniforms.inputClamp;
        inputSize[0] = state.destinationFrame.width;
        inputSize[1] = state.destinationFrame.height;
        inputSize[2] = 1 / inputSize[0];
        inputSize[3] = 1 / inputSize[1];
        inputPixel[0] = Math.round(inputSize[0] * state.resolution);
        inputPixel[1] = Math.round(inputSize[1] * state.resolution);
        inputPixel[2] = 1 / inputPixel[0];
        inputPixel[3] = 1 / inputPixel[1];
        inputClamp[0] = 0.5 * inputPixel[2];
        inputClamp[1] = 0.5 * inputPixel[3];
        inputClamp[2] = state.sourceFrame.width * inputSize[2] - 0.5 * inputPixel[2];
        inputClamp[3] = state.sourceFrame.height * inputSize[3] - 0.5 * inputPixel[3];
        if (state.legacy) {
            const filterArea = globalUniforms.filterArea;
            filterArea[0] = state.destinationFrame.width;
            filterArea[1] = state.destinationFrame.height;
            filterArea[2] = state.sourceFrame.x;
            filterArea[3] = state.sourceFrame.y;
            globalUniforms.filterClamp = globalUniforms.inputClamp;
        }
        this.globalUniforms.update();
        const lastState = filterStack[filterStack.length - 1];
        this.renderer.framebuffer.blit();
        if (filters.length === 1) {
            filters[0].apply(this, state.renderTexture, lastState.renderTexture, (0, $551209d754b5b429$export$784901839554cbc3).BLEND, state);
            this.returnFilterTexture(state.renderTexture);
        } else {
            let flip = state.renderTexture;
            let flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
            flop.filterFrame = flip.filterFrame;
            let i = 0;
            for(i = 0; i < filters.length - 1; ++i){
                if (i === 1 && state.multisample > 1) {
                    flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
                    flop.filterFrame = flip.filterFrame;
                }
                filters[i].apply(this, flip, flop, (0, $551209d754b5b429$export$784901839554cbc3).CLEAR, state);
                const t = flip;
                flip = flop;
                flop = t;
            }
            filters[i].apply(this, flip, lastState.renderTexture, (0, $551209d754b5b429$export$784901839554cbc3).BLEND, state);
            if (i > 1 && state.multisample > 1) this.returnFilterTexture(state.renderTexture);
            this.returnFilterTexture(flip);
            this.returnFilterTexture(flop);
        }
        state.clear();
        this.statePool.push(state);
    }
    bindAndClear(filterTexture, clearMode = (0, $551209d754b5b429$export$784901839554cbc3).CLEAR) {
        const { renderTexture: renderTextureSystem , state: stateSystem  } = this.renderer;
        if (filterTexture === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture) this.renderer.projection.transform = this.activeState.transform;
        else this.renderer.projection.transform = null;
        if (filterTexture?.filterFrame) {
            const destinationFrame = this.tempRect;
            destinationFrame.x = 0;
            destinationFrame.y = 0;
            destinationFrame.width = filterTexture.filterFrame.width;
            destinationFrame.height = filterTexture.filterFrame.height;
            renderTextureSystem.bind(filterTexture, filterTexture.filterFrame, destinationFrame);
        } else if (filterTexture !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture) renderTextureSystem.bind(filterTexture);
        else this.renderer.renderTexture.bind(filterTexture, this.activeState.bindingSourceFrame, this.activeState.bindingDestinationFrame);
        const autoClear = stateSystem.stateId & 1 || this.forceClear;
        if (clearMode === (0, $551209d754b5b429$export$784901839554cbc3).CLEAR || clearMode === (0, $551209d754b5b429$export$784901839554cbc3).BLIT && autoClear) this.renderer.framebuffer.clear(0, 0, 0, 0);
    }
    applyFilter(filter, input, output, clearMode) {
        const renderer = this.renderer;
        renderer.state.set(filter.state);
        this.bindAndClear(output, clearMode);
        filter.uniforms.uSampler = input;
        filter.uniforms.filterGlobals = this.globalUniforms;
        renderer.shader.bind(filter);
        filter.legacy = !!filter.program.attributeData.aTextureCoord;
        if (filter.legacy) {
            this.quadUv.map(input._frame, input.filterFrame);
            renderer.geometry.bind(this.quadUv);
            renderer.geometry.draw((0, $551209d754b5b429$export$91100badd8469338).TRIANGLES);
        } else {
            renderer.geometry.bind(this.quad);
            renderer.geometry.draw((0, $551209d754b5b429$export$91100badd8469338).TRIANGLE_STRIP);
        }
    }
    calculateSpriteMatrix(outputMatrix, sprite) {
        const { sourceFrame: sourceFrame , destinationFrame: destinationFrame  } = this.activeState;
        const { orig: orig  } = sprite._texture;
        const mappedMatrix = outputMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y);
        const worldTransform = sprite.worldTransform.copyTo((0, $414c7fb9dda367fe$export$5b12bf1653c0dd85).TEMP_MATRIX);
        worldTransform.invert();
        mappedMatrix.prepend(worldTransform);
        mappedMatrix.scale(1 / orig.width, 1 / orig.height);
        mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
        return mappedMatrix;
    }
    destroy() {
        this.renderer = null;
        this.texturePool.clear(false);
    }
    getOptimalFilterTexture(minWidth, minHeight, resolution = 1, multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE) {
        return this.texturePool.getOptimalTexture(minWidth, minHeight, resolution, multisample);
    }
    getFilterTexture(input, resolution, multisample) {
        if (typeof input === "number") {
            const swap = input;
            input = resolution;
            resolution = swap;
        }
        input = input || this.activeState.renderTexture;
        const filterTexture = this.texturePool.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE);
        filterTexture.filterFrame = input.filterFrame;
        return filterTexture;
    }
    returnFilterTexture(renderTexture) {
        this.texturePool.returnTexture(renderTexture);
    }
    emptyPool() {
        this.texturePool.clear(true);
    }
    resize() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    transformAABB(matrix, rect) {
        const lt = $a52a4a592a10e8d1$var$tempPoints[0];
        const lb = $a52a4a592a10e8d1$var$tempPoints[1];
        const rt = $a52a4a592a10e8d1$var$tempPoints[2];
        const rb = $a52a4a592a10e8d1$var$tempPoints[3];
        lt.set(rect.left, rect.top);
        lb.set(rect.left, rect.bottom);
        rt.set(rect.right, rect.top);
        rb.set(rect.right, rect.bottom);
        matrix.apply(lt, lt);
        matrix.apply(lb, lb);
        matrix.apply(rt, rt);
        matrix.apply(rb, rb);
        const x0 = Math.min(lt.x, lb.x, rt.x, rb.x);
        const y0 = Math.min(lt.y, lb.y, rt.y, rb.y);
        const x1 = Math.max(lt.x, lb.x, rt.x, rb.x);
        const y1 = Math.max(lt.y, lb.y, rt.y, rb.y);
        rect.x = x0;
        rect.y = y0;
        rect.width = x1 - x0;
        rect.height = y1 - y0;
    }
    roundFrame(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (frame.width <= 0 || frame.height <= 0 || bindingSourceFrame.width <= 0 || bindingSourceFrame.height <= 0) return;
        if (transform) {
            const { a: a , b: b , c: c , d: d  } = transform;
            if ((Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4)) return;
        }
        transform = transform ? $a52a4a592a10e8d1$var$tempMatrix.copyFrom(transform) : $a52a4a592a10e8d1$var$tempMatrix.identity();
        transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y);
        this.transformAABB(transform, frame);
        frame.ceil(resolution);
        this.transformAABB(transform.invert(), frame);
    }
}
$a52a4a592a10e8d1$export$e94225c0dfac29cf.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "filter"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($a52a4a592a10e8d1$export$e94225c0dfac29cf);








class $10597bbb7318c4cd$export$47f6dbf489220e22 {
    constructor(framebuffer){
        this.framebuffer = framebuffer;
        this.stencil = null;
        this.dirtyId = -1;
        this.dirtyFormat = -1;
        this.dirtySize = -1;
        this.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE;
        this.msaaBuffer = null;
        this.blitFramebuffer = null;
        this.mipLevel = 0;
    }
}


const $00885252945baa09$var$tempRectangle = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
class $00885252945baa09$export$3f472331251297cd {
    constructor(renderer){
        this.renderer = renderer;
        this.managedFramebuffers = [];
        this.unknownFramebuffer = new (0, $2a038313609da7f8$export$eff95f126aa67cfb)(10, 10);
        this.msaaSamples = null;
    }
    contextChange() {
        this.disposeAll(true);
        const gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.current = this.unknownFramebuffer;
        this.viewport = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.hasMRT = true;
        this.writeDepthTexture = true;
        if (this.renderer.context.webGLVersion === 1) {
            let nativeDrawBuffersExtension = this.renderer.context.extensions.drawBuffers;
            let nativeDepthTextureExtension = this.renderer.context.extensions.depthTexture;
            if ((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).PREFER_ENV === (0, $551209d754b5b429$export$83401e34d5e11bf4).WEBGL_LEGACY) {
                nativeDrawBuffersExtension = null;
                nativeDepthTextureExtension = null;
            }
            if (nativeDrawBuffersExtension) gl.drawBuffers = (activeTextures)=>nativeDrawBuffersExtension.drawBuffersWEBGL(activeTextures);
            else {
                this.hasMRT = false;
                gl.drawBuffers = ()=>{};
            }
            if (!nativeDepthTextureExtension) this.writeDepthTexture = false;
        } else this.msaaSamples = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.RGBA8, gl.SAMPLES);
    }
    bind(framebuffer, frame, mipLevel = 0) {
        const { gl: gl  } = this;
        if (framebuffer) {
            const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(framebuffer);
            if (this.current !== framebuffer) {
                this.current = framebuffer;
                gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.framebuffer);
            }
            if (fbo.mipLevel !== mipLevel) {
                framebuffer.dirtyId++;
                framebuffer.dirtyFormat++;
                fbo.mipLevel = mipLevel;
            }
            if (fbo.dirtyId !== framebuffer.dirtyId) {
                fbo.dirtyId = framebuffer.dirtyId;
                if (fbo.dirtyFormat !== framebuffer.dirtyFormat) {
                    fbo.dirtyFormat = framebuffer.dirtyFormat;
                    fbo.dirtySize = framebuffer.dirtySize;
                    this.updateFramebuffer(framebuffer, mipLevel);
                } else if (fbo.dirtySize !== framebuffer.dirtySize) {
                    fbo.dirtySize = framebuffer.dirtySize;
                    this.resizeFramebuffer(framebuffer);
                }
            }
            for(let i = 0; i < framebuffer.colorTextures.length; i++){
                const tex = framebuffer.colorTextures[i];
                this.renderer.texture.unbind(tex.parentTextureArray || tex);
            }
            if (framebuffer.depthTexture) this.renderer.texture.unbind(framebuffer.depthTexture);
            if (frame) {
                const mipWidth = frame.width >> mipLevel;
                const mipHeight = frame.height >> mipLevel;
                const scale = mipWidth / frame.width;
                this.setViewport(frame.x * scale, frame.y * scale, mipWidth, mipHeight);
            } else {
                const mipWidth = framebuffer.width >> mipLevel;
                const mipHeight = framebuffer.height >> mipLevel;
                this.setViewport(0, 0, mipWidth, mipHeight);
            }
        } else {
            if (this.current) {
                this.current = null;
                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            }
            if (frame) this.setViewport(frame.x, frame.y, frame.width, frame.height);
            else this.setViewport(0, 0, this.renderer.width, this.renderer.height);
        }
    }
    setViewport(x, y, width, height) {
        const v = this.viewport;
        x = Math.round(x);
        y = Math.round(y);
        width = Math.round(width);
        height = Math.round(height);
        if (v.width !== width || v.height !== height || v.x !== x || v.y !== y) {
            v.x = x;
            v.y = y;
            v.width = width;
            v.height = height;
            this.gl.viewport(x, y, width, height);
        }
    }
    get size() {
        if (this.current) return {
            x: 0,
            y: 0,
            width: this.current.width,
            height: this.current.height
        };
        return {
            x: 0,
            y: 0,
            width: this.renderer.width,
            height: this.renderer.height
        };
    }
    clear(r, g, b, a, mask = (0, $551209d754b5b429$export$c07ea8ac66dac49).COLOR | (0, $551209d754b5b429$export$c07ea8ac66dac49).DEPTH) {
        const { gl: gl  } = this;
        gl.clearColor(r, g, b, a);
        gl.clear(mask);
    }
    initFramebuffer(framebuffer) {
        const { gl: gl  } = this;
        const fbo = new (0, $10597bbb7318c4cd$export$47f6dbf489220e22)(gl.createFramebuffer());
        fbo.multisample = this.detectSamples(framebuffer.multisample);
        framebuffer.glFramebuffers[this.CONTEXT_UID] = fbo;
        this.managedFramebuffers.push(framebuffer);
        framebuffer.disposeRunner.add(this);
        return fbo;
    }
    resizeFramebuffer(framebuffer) {
        const { gl: gl  } = this;
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (fbo.stencil) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, framebuffer.width, framebuffer.height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
        }
        const colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        if (!gl.drawBuffers) count = Math.min(count, 1);
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i];
            const parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0);
            if (i === 0 && fbo.msaaBuffer) {
                gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height);
            }
        }
        if (framebuffer.depthTexture && this.writeDepthTexture) this.renderer.texture.bind(framebuffer.depthTexture, 0);
    }
    updateFramebuffer(framebuffer, mipLevel) {
        const { gl: gl  } = this;
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        const colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        if (!gl.drawBuffers) count = Math.min(count, 1);
        if (fbo.multisample > 1 && this.canMultisampleFramebuffer(framebuffer)) fbo.msaaBuffer = fbo.msaaBuffer || gl.createRenderbuffer();
        else if (fbo.msaaBuffer) {
            gl.deleteRenderbuffer(fbo.msaaBuffer);
            fbo.msaaBuffer = null;
            if (fbo.blitFramebuffer) {
                fbo.blitFramebuffer.dispose();
                fbo.blitFramebuffer = null;
            }
        }
        const activeTextures = [];
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i];
            const parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0);
            if (i === 0 && fbo.msaaBuffer) {
                gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height);
                gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, fbo.msaaBuffer);
            } else {
                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture.target, parentTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
                activeTextures.push(gl.COLOR_ATTACHMENT0 + i);
            }
        }
        if (activeTextures.length > 1) gl.drawBuffers(activeTextures);
        if (framebuffer.depthTexture) {
            const writeDepthTexture = this.writeDepthTexture;
            if (writeDepthTexture) {
                const depthTexture = framebuffer.depthTexture;
                this.renderer.texture.bind(depthTexture, 0);
                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, depthTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
            }
        }
        if ((framebuffer.stencil || framebuffer.depth) && !(framebuffer.depthTexture && this.writeDepthTexture)) {
            fbo.stencil = fbo.stencil || gl.createRenderbuffer();
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, framebuffer.width, framebuffer.height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, fbo.stencil);
        } else if (fbo.stencil) {
            gl.deleteRenderbuffer(fbo.stencil);
            fbo.stencil = null;
        }
    }
    canMultisampleFramebuffer(framebuffer) {
        return this.renderer.context.webGLVersion !== 1 && framebuffer.colorTextures.length <= 1 && !framebuffer.depthTexture;
    }
    detectSamples(samples) {
        const { msaaSamples: msaaSamples  } = this;
        let res = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE;
        if (samples <= 1 || msaaSamples === null) return res;
        for(let i = 0; i < msaaSamples.length; i++)if (msaaSamples[i] <= samples) {
            res = msaaSamples[i];
            break;
        }
        if (res === 1) res = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE;
        return res;
    }
    blit(framebuffer, sourcePixels, destPixels) {
        const { current: current , renderer: renderer , gl: gl , CONTEXT_UID: CONTEXT_UID  } = this;
        if (renderer.context.webGLVersion !== 2) return;
        if (!current) return;
        const fbo = current.glFramebuffers[CONTEXT_UID];
        if (!fbo) return;
        if (!framebuffer) {
            if (!fbo.msaaBuffer) return;
            const colorTexture = current.colorTextures[0];
            if (!colorTexture) return;
            if (!fbo.blitFramebuffer) {
                fbo.blitFramebuffer = new (0, $2a038313609da7f8$export$eff95f126aa67cfb)(current.width, current.height);
                fbo.blitFramebuffer.addColorTexture(0, colorTexture);
            }
            framebuffer = fbo.blitFramebuffer;
            if (framebuffer.colorTextures[0] !== colorTexture) {
                framebuffer.colorTextures[0] = colorTexture;
                framebuffer.dirtyId++;
                framebuffer.dirtyFormat++;
            }
            if (framebuffer.width !== current.width || framebuffer.height !== current.height) {
                framebuffer.width = current.width;
                framebuffer.height = current.height;
                framebuffer.dirtyId++;
                framebuffer.dirtySize++;
            }
        }
        if (!sourcePixels) {
            sourcePixels = $00885252945baa09$var$tempRectangle;
            sourcePixels.width = current.width;
            sourcePixels.height = current.height;
        }
        if (!destPixels) destPixels = sourcePixels;
        const sameSize = sourcePixels.width === destPixels.width && sourcePixels.height === destPixels.height;
        this.bind(framebuffer);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fbo.framebuffer);
        gl.blitFramebuffer(sourcePixels.left, sourcePixels.top, sourcePixels.right, sourcePixels.bottom, destPixels.left, destPixels.top, destPixels.right, destPixels.bottom, gl.COLOR_BUFFER_BIT, sameSize ? gl.NEAREST : gl.LINEAR);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, framebuffer.glFramebuffers[this.CONTEXT_UID].framebuffer);
    }
    disposeFramebuffer(framebuffer, contextLost) {
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        const gl = this.gl;
        if (!fbo) return;
        delete framebuffer.glFramebuffers[this.CONTEXT_UID];
        const index = this.managedFramebuffers.indexOf(framebuffer);
        if (index >= 0) this.managedFramebuffers.splice(index, 1);
        framebuffer.disposeRunner.remove(this);
        if (!contextLost) {
            gl.deleteFramebuffer(fbo.framebuffer);
            if (fbo.msaaBuffer) gl.deleteRenderbuffer(fbo.msaaBuffer);
            if (fbo.stencil) gl.deleteRenderbuffer(fbo.stencil);
        }
        if (fbo.blitFramebuffer) this.disposeFramebuffer(fbo.blitFramebuffer, contextLost);
    }
    disposeAll(contextLost) {
        const list = this.managedFramebuffers;
        this.managedFramebuffers = [];
        for(let i = 0; i < list.length; i++)this.disposeFramebuffer(list[i], contextLost);
    }
    forceStencil() {
        const framebuffer = this.current;
        if (!framebuffer) return;
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (!fbo || fbo.stencil) return;
        framebuffer.stencil = true;
        const w = framebuffer.width;
        const h = framebuffer.height;
        const gl = this.gl;
        const stencil = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, stencil);
        if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, w, h);
        else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, w, h);
        fbo.stencil = stencil;
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, stencil);
    }
    reset() {
        this.current = this.unknownFramebuffer;
        this.viewport = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
    }
    destroy() {
        this.renderer = null;
    }
}
$00885252945baa09$export$3f472331251297cd.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "framebuffer"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($00885252945baa09$export$3f472331251297cd);





const $fcc43430a275f613$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
class $fcc43430a275f613$export$c83da0f390a7459c {
    constructor(renderer){
        this.renderer = renderer;
        this._activeGeometry = null;
        this._activeVao = null;
        this.hasVao = true;
        this.hasInstance = true;
        this.canUseUInt32ElementIndex = false;
        this.managedGeometries = {};
    }
    contextChange() {
        this.disposeAll(true);
        const gl = this.gl = this.renderer.gl;
        const context = this.renderer.context;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        if (context.webGLVersion !== 2) {
            let nativeVaoExtension = this.renderer.context.extensions.vertexArrayObject;
            if ((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).PREFER_ENV === (0, $551209d754b5b429$export$83401e34d5e11bf4).WEBGL_LEGACY) nativeVaoExtension = null;
            if (nativeVaoExtension) {
                gl.createVertexArray = ()=>nativeVaoExtension.createVertexArrayOES();
                gl.bindVertexArray = (vao)=>nativeVaoExtension.bindVertexArrayOES(vao);
                gl.deleteVertexArray = (vao)=>nativeVaoExtension.deleteVertexArrayOES(vao);
            } else {
                this.hasVao = false;
                gl.createVertexArray = ()=>null;
                gl.bindVertexArray = ()=>null;
                gl.deleteVertexArray = ()=>null;
            }
        }
        if (context.webGLVersion !== 2) {
            const instanceExt = gl.getExtension("ANGLE_instanced_arrays");
            if (instanceExt) {
                gl.vertexAttribDivisor = (a, b)=>instanceExt.vertexAttribDivisorANGLE(a, b);
                gl.drawElementsInstanced = (a, b, c, d, e)=>instanceExt.drawElementsInstancedANGLE(a, b, c, d, e);
                gl.drawArraysInstanced = (a, b, c, d)=>instanceExt.drawArraysInstancedANGLE(a, b, c, d);
            } else this.hasInstance = false;
        }
        this.canUseUInt32ElementIndex = context.webGLVersion === 2 || !!context.extensions.uint32ElementIndex;
    }
    bind(geometry, shader) {
        shader = shader || this.renderer.shader.shader;
        const { gl: gl  } = this;
        let vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        let incRefCount = false;
        if (!vaos) {
            this.managedGeometries[geometry.id] = geometry;
            geometry.disposeRunner.add(this);
            geometry.glVertexArrayObjects[this.CONTEXT_UID] = vaos = {};
            incRefCount = true;
        }
        const vao = vaos[shader.program.id] || this.initGeometryVao(geometry, shader, incRefCount);
        this._activeGeometry = geometry;
        if (this._activeVao !== vao) {
            this._activeVao = vao;
            if (this.hasVao) gl.bindVertexArray(vao);
            else this.activateVao(geometry, shader.program);
        }
        this.updateBuffers();
    }
    reset() {
        this.unbind();
    }
    updateBuffers() {
        const geometry = this._activeGeometry;
        const bufferSystem = this.renderer.buffer;
        for(let i = 0; i < geometry.buffers.length; i++){
            const buffer = geometry.buffers[i];
            bufferSystem.update(buffer);
        }
    }
    checkCompatibility(geometry, program) {
        const geometryAttributes = geometry.attributes;
        const shaderAttributes = program.attributeData;
        for(const j in shaderAttributes){
            if (!geometryAttributes[j]) throw new Error(`shader and geometry incompatible, geometry missing the "${j}" attribute`);
        }
    }
    getSignature(geometry, program) {
        const attribs = geometry.attributes;
        const shaderAttributes = program.attributeData;
        const strings = [
            "g",
            geometry.id
        ];
        for(const i in attribs)if (shaderAttributes[i]) strings.push(i, shaderAttributes[i].location);
        return strings.join("-");
    }
    initGeometryVao(geometry, shader, incRefCount = true) {
        const gl = this.gl;
        const CONTEXT_UID = this.CONTEXT_UID;
        const bufferSystem = this.renderer.buffer;
        const program = shader.program;
        if (!program.glPrograms[CONTEXT_UID]) this.renderer.shader.generateProgram(shader);
        this.checkCompatibility(geometry, program);
        const signature = this.getSignature(geometry, program);
        const vaoObjectHash = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        let vao = vaoObjectHash[signature];
        if (vao) {
            vaoObjectHash[program.id] = vao;
            return vao;
        }
        const buffers = geometry.buffers;
        const attributes = geometry.attributes;
        const tempStride = {};
        const tempStart = {};
        for(const j in buffers){
            tempStride[j] = 0;
            tempStart[j] = 0;
        }
        for(const j in attributes){
            if (!attributes[j].size && program.attributeData[j]) attributes[j].size = program.attributeData[j].size;
            else if (!attributes[j].size) console.warn(`PIXI Geometry attribute '${j}' size cannot be determined (likely the bound shader does not have the attribute)`);
            tempStride[attributes[j].buffer] += attributes[j].size * $fcc43430a275f613$var$byteSizeMap[attributes[j].type];
        }
        for(const j in attributes){
            const attribute = attributes[j];
            const attribSize = attribute.size;
            if (attribute.stride === void 0) {
                if (tempStride[attribute.buffer] === attribSize * $fcc43430a275f613$var$byteSizeMap[attribute.type]) attribute.stride = 0;
                else attribute.stride = tempStride[attribute.buffer];
            }
            if (attribute.start === void 0) {
                attribute.start = tempStart[attribute.buffer];
                tempStart[attribute.buffer] += attribSize * $fcc43430a275f613$var$byteSizeMap[attribute.type];
            }
        }
        vao = gl.createVertexArray();
        gl.bindVertexArray(vao);
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            bufferSystem.bind(buffer);
            if (incRefCount) buffer._glBuffers[CONTEXT_UID].refCount++;
        }
        this.activateVao(geometry, program);
        vaoObjectHash[program.id] = vao;
        vaoObjectHash[signature] = vao;
        gl.bindVertexArray(null);
        bufferSystem.unbind((0, $551209d754b5b429$export$b595a7e482202b96).ARRAY_BUFFER);
        return vao;
    }
    disposeGeometry(geometry, contextLost) {
        if (!this.managedGeometries[geometry.id]) return;
        delete this.managedGeometries[geometry.id];
        const vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        const gl = this.gl;
        const buffers = geometry.buffers;
        const bufferSystem = this.renderer?.buffer;
        geometry.disposeRunner.remove(this);
        if (!vaos) return;
        if (bufferSystem) for(let i = 0; i < buffers.length; i++){
            const buf = buffers[i]._glBuffers[this.CONTEXT_UID];
            if (buf) {
                buf.refCount--;
                if (buf.refCount === 0 && !contextLost) bufferSystem.dispose(buffers[i], contextLost);
            }
        }
        if (!contextLost) {
            for(const vaoId in vaos)if (vaoId[0] === "g") {
                const vao = vaos[vaoId];
                if (this._activeVao === vao) this.unbind();
                gl.deleteVertexArray(vao);
            }
        }
        delete geometry.glVertexArrayObjects[this.CONTEXT_UID];
    }
    disposeAll(contextLost) {
        const all = Object.keys(this.managedGeometries);
        for(let i = 0; i < all.length; i++)this.disposeGeometry(this.managedGeometries[all[i]], contextLost);
    }
    activateVao(geometry, program) {
        const gl = this.gl;
        const CONTEXT_UID = this.CONTEXT_UID;
        const bufferSystem = this.renderer.buffer;
        const buffers = geometry.buffers;
        const attributes = geometry.attributes;
        if (geometry.indexBuffer) bufferSystem.bind(geometry.indexBuffer);
        let lastBuffer = null;
        for(const j in attributes){
            const attribute = attributes[j];
            const buffer = buffers[attribute.buffer];
            const glBuffer = buffer._glBuffers[CONTEXT_UID];
            if (program.attributeData[j]) {
                if (lastBuffer !== glBuffer) {
                    bufferSystem.bind(buffer);
                    lastBuffer = glBuffer;
                }
                const location = program.attributeData[j].location;
                gl.enableVertexAttribArray(location);
                gl.vertexAttribPointer(location, attribute.size, attribute.type || gl.FLOAT, attribute.normalized, attribute.stride, attribute.start);
                if (attribute.instance) {
                    if (this.hasInstance) gl.vertexAttribDivisor(location, attribute.divisor);
                    else throw new Error("geometry error, GPU Instancing is not supported on this device");
                }
            }
        }
    }
    draw(type, size, start, instanceCount) {
        const { gl: gl  } = this;
        const geometry = this._activeGeometry;
        if (geometry.indexBuffer) {
            const byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT;
            const glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
            if (byteSize === 2 || byteSize === 4 && this.canUseUInt32ElementIndex) {
                if (geometry.instanced) gl.drawElementsInstanced(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount || 1);
                else gl.drawElements(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize);
            } else console.warn("unsupported index buffer type: uint32");
        } else if (geometry.instanced) gl.drawArraysInstanced(type, start, size || geometry.getSize(), instanceCount || 1);
        else gl.drawArrays(type, start, size || geometry.getSize());
        return this;
    }
    unbind() {
        this.gl.bindVertexArray(null);
        this._activeVao = null;
        this._activeGeometry = null;
    }
    destroy() {
        this.renderer = null;
    }
}
$fcc43430a275f613$export$c83da0f390a7459c.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "geometry"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($fcc43430a275f613$export$c83da0f390a7459c);






const $8da561ec6e817bba$var$tempMat = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
class $8da561ec6e817bba$export$dbea3135e9da48cb {
    constructor(texture, clampMargin){
        this._texture = texture;
        this.mapCoord = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        this.clampMargin = typeof clampMargin === "undefined" ? 0.5 : clampMargin;
        this.isSimple = false;
    }
    get texture() {
        return this._texture;
    }
    set texture(value) {
        this._texture = value;
        this._textureID = -1;
    }
    multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    update(forceUpdate) {
        const tex = this._texture;
        if (!tex || !tex.valid) return false;
        if (!forceUpdate && this._textureID === tex._updateID) return false;
        this._textureID = tex._updateID;
        this._updateID++;
        const uvs = tex._uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $8da561ec6e817bba$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($8da561ec6e817bba$var$tempMat);
        }
        const texBase = tex.baseTexture;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase.resolution;
        const offset = this.clampOffset;
        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = offset / texBase.realWidth;
        this.uClampOffset[1] = offset / texBase.realHeight;
        this.isSimple = tex._frame.width === texBase.width && tex._frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}



var $36e28df3949f4453$export$2e2bcd8739ae039 = "varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform float npmAlpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);\n\n    original *= (alphaMul * masky.r * alpha * clip);\n\n    gl_FragColor = original;\n}\n";


var $965354a8712506ec$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n";


class $771a97de5f15aae9$export$6b66f8c14dea0d0 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(vertexSrc, fragmentSrc, uniforms){
        let sprite = null;
        if (typeof vertexSrc !== "string" && fragmentSrc === void 0 && uniforms === void 0) {
            sprite = vertexSrc;
            vertexSrc = void 0;
            fragmentSrc = void 0;
            uniforms = void 0;
        }
        super(vertexSrc || (0, $965354a8712506ec$export$2e2bcd8739ae039), fragmentSrc || (0, $36e28df3949f4453$export$2e2bcd8739ae039), uniforms);
        this.maskSprite = sprite;
        this.maskMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
    }
    get maskSprite() {
        return this._maskSprite;
    }
    set maskSprite(value) {
        this._maskSprite = value;
        if (this._maskSprite) this._maskSprite.renderable = false;
    }
    apply(filterManager, input, output, clearMode) {
        const maskSprite = this._maskSprite;
        const tex = maskSprite._texture;
        if (!tex.valid) return;
        if (!tex.uvMatrix) tex.uvMatrix = new (0, $8da561ec6e817bba$export$dbea3135e9da48cb)(tex, 0);
        tex.uvMatrix.update();
        this.uniforms.npmAlpha = tex.baseTexture.alphaMode ? 0 : 1;
        this.uniforms.mask = tex;
        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.uvMatrix.mapCoord);
        this.uniforms.alpha = maskSprite.worldAlpha;
        this.uniforms.maskClamp = tex.uvMatrix.uClampFrame;
        filterManager.applyFilter(this, input, output, clearMode);
    }
}




class $ad086241daacc652$export$c75dec3795e98612 {
    constructor(maskObject = null){
        this.type = (0, $551209d754b5b429$export$dbbea138c5d144).NONE;
        this.autoDetect = true;
        this.maskObject = maskObject || null;
        this.pooled = false;
        this.isMaskData = true;
        this.resolution = null;
        this.multisample = (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea).defaultMultisample;
        this.enabled = true;
        this.colorMask = 15;
        this._filters = null;
        this._stencilCounter = 0;
        this._scissorCounter = 0;
        this._scissorRect = null;
        this._scissorRectLocal = null;
        this._colorMask = 15;
        this._target = null;
    }
    get filter() {
        return this._filters ? this._filters[0] : null;
    }
    set filter(value) {
        if (value) {
            if (this._filters) this._filters[0] = value;
            else this._filters = [
                value
            ];
        } else this._filters = null;
    }
    reset() {
        if (this.pooled) {
            this.maskObject = null;
            this.type = (0, $551209d754b5b429$export$dbbea138c5d144).NONE;
            this.autoDetect = true;
        }
        this._target = null;
        this._scissorRectLocal = null;
    }
    copyCountersOrReset(maskAbove) {
        if (maskAbove) {
            this._stencilCounter = maskAbove._stencilCounter;
            this._scissorCounter = maskAbove._scissorCounter;
            this._scissorRect = maskAbove._scissorRect;
        } else {
            this._stencilCounter = 0;
            this._scissorCounter = 0;
            this._scissorRect = null;
        }
    }
}


class $3c77e5f209e855e8$export$a1fbfb1b9cf60ed0 {
    constructor(renderer){
        this.renderer = renderer;
        this.enableScissor = true;
        this.alphaMaskPool = [];
        this.maskDataPool = [];
        this.maskStack = [];
        this.alphaMaskIndex = 0;
    }
    setMaskStack(maskStack) {
        this.maskStack = maskStack;
        this.renderer.scissor.setMaskStack(maskStack);
        this.renderer.stencil.setMaskStack(maskStack);
    }
    push(target, maskDataOrTarget) {
        let maskData = maskDataOrTarget;
        if (!maskData.isMaskData) {
            const d = this.maskDataPool.pop() || new (0, $ad086241daacc652$export$c75dec3795e98612)();
            d.pooled = true;
            d.maskObject = maskDataOrTarget;
            maskData = d;
        }
        const maskAbove = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
        maskData.copyCountersOrReset(maskAbove);
        maskData._colorMask = maskAbove ? maskAbove._colorMask : 15;
        if (maskData.autoDetect) this.detect(maskData);
        maskData._target = target;
        if (maskData.type !== (0, $551209d754b5b429$export$dbbea138c5d144).SPRITE) this.maskStack.push(maskData);
        if (maskData.enabled) switch(maskData.type){
            case (0, $551209d754b5b429$export$dbbea138c5d144).SCISSOR:
                this.renderer.scissor.push(maskData);
                break;
            case (0, $551209d754b5b429$export$dbbea138c5d144).STENCIL:
                this.renderer.stencil.push(maskData);
                break;
            case (0, $551209d754b5b429$export$dbbea138c5d144).SPRITE:
                maskData.copyCountersOrReset(null);
                this.pushSpriteMask(maskData);
                break;
            case (0, $551209d754b5b429$export$dbbea138c5d144).COLOR:
                this.pushColorMask(maskData);
                break;
            default:
                break;
        }
        if (maskData.type === (0, $551209d754b5b429$export$dbbea138c5d144).SPRITE) this.maskStack.push(maskData);
    }
    pop(target) {
        const maskData = this.maskStack.pop();
        if (!maskData || maskData._target !== target) return;
        if (maskData.enabled) switch(maskData.type){
            case (0, $551209d754b5b429$export$dbbea138c5d144).SCISSOR:
                this.renderer.scissor.pop(maskData);
                break;
            case (0, $551209d754b5b429$export$dbbea138c5d144).STENCIL:
                this.renderer.stencil.pop(maskData.maskObject);
                break;
            case (0, $551209d754b5b429$export$dbbea138c5d144).SPRITE:
                this.popSpriteMask(maskData);
                break;
            case (0, $551209d754b5b429$export$dbbea138c5d144).COLOR:
                this.popColorMask(maskData);
                break;
            default:
                break;
        }
        maskData.reset();
        if (maskData.pooled) this.maskDataPool.push(maskData);
        if (this.maskStack.length !== 0) {
            const maskCurrent = this.maskStack[this.maskStack.length - 1];
            if (maskCurrent.type === (0, $551209d754b5b429$export$dbbea138c5d144).SPRITE && maskCurrent._filters) maskCurrent._filters[0].maskSprite = maskCurrent.maskObject;
        }
    }
    detect(maskData) {
        const maskObject = maskData.maskObject;
        if (!maskObject) maskData.type = (0, $551209d754b5b429$export$dbbea138c5d144).COLOR;
        else if (maskObject.isSprite) maskData.type = (0, $551209d754b5b429$export$dbbea138c5d144).SPRITE;
        else if (this.enableScissor && this.renderer.scissor.testScissor(maskData)) maskData.type = (0, $551209d754b5b429$export$dbbea138c5d144).SCISSOR;
        else maskData.type = (0, $551209d754b5b429$export$dbbea138c5d144).STENCIL;
    }
    pushSpriteMask(maskData) {
        const { maskObject: maskObject  } = maskData;
        const target = maskData._target;
        let alphaMaskFilter = maskData._filters;
        if (!alphaMaskFilter) {
            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];
            if (!alphaMaskFilter) alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [
                new (0, $771a97de5f15aae9$export$6b66f8c14dea0d0)()
            ];
        }
        const renderer = this.renderer;
        const renderTextureSystem = renderer.renderTexture;
        let resolution;
        let multisample;
        if (renderTextureSystem.current) {
            const renderTexture = renderTextureSystem.current;
            resolution = maskData.resolution || renderTexture.resolution;
            multisample = maskData.multisample ?? renderTexture.multisample;
        } else {
            resolution = maskData.resolution || renderer.resolution;
            multisample = maskData.multisample ?? renderer.multisample;
        }
        alphaMaskFilter[0].resolution = resolution;
        alphaMaskFilter[0].multisample = multisample;
        alphaMaskFilter[0].maskSprite = maskObject;
        const stashFilterArea = target.filterArea;
        target.filterArea = maskObject.getBounds(true);
        renderer.filter.push(target, alphaMaskFilter);
        target.filterArea = stashFilterArea;
        if (!maskData._filters) this.alphaMaskIndex++;
    }
    popSpriteMask(maskData) {
        this.renderer.filter.pop();
        if (maskData._filters) maskData._filters[0].maskSprite = null;
        else {
            this.alphaMaskIndex--;
            this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null;
        }
    }
    pushColorMask(maskData) {
        const currColorMask = maskData._colorMask;
        const nextColorMask = maskData._colorMask = currColorMask & maskData.colorMask;
        if (nextColorMask !== currColorMask) this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    popColorMask(maskData) {
        const currColorMask = maskData._colorMask;
        const nextColorMask = this.maskStack.length > 0 ? this.maskStack[this.maskStack.length - 1]._colorMask : 15;
        if (nextColorMask !== currColorMask) this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    destroy() {
        this.renderer = null;
    }
}
$3c77e5f209e855e8$export$a1fbfb1b9cf60ed0.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "mask"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($3c77e5f209e855e8$export$a1fbfb1b9cf60ed0);





class $f09bb6797a33b232$export$c83199503f0366e9 {
    constructor(renderer){
        this.renderer = renderer;
        this.maskStack = [];
        this.glConst = 0;
    }
    getStackLength() {
        return this.maskStack.length;
    }
    setMaskStack(maskStack) {
        const { gl: gl  } = this.renderer;
        const curStackLen = this.getStackLength();
        this.maskStack = maskStack;
        const newStackLen = this.getStackLength();
        if (newStackLen !== curStackLen) {
            if (newStackLen === 0) gl.disable(this.glConst);
            else {
                gl.enable(this.glConst);
                this._useCurrent();
            }
        }
    }
    _useCurrent() {}
    destroy() {
        this.renderer = null;
        this.maskStack = null;
    }
}


const $1d5edd4fe0f05794$var$tempMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
const $1d5edd4fe0f05794$var$rectPool = [];
const $1d5edd4fe0f05794$var$_ScissorSystem = class extends (0, $f09bb6797a33b232$export$c83199503f0366e9) {
    constructor(renderer){
        super(renderer);
        this.glConst = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext().SCISSOR_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        if (maskData) return maskData._scissorCounter;
        return 0;
    }
    calcScissorRect(maskData) {
        if (maskData._scissorRectLocal) return;
        const prevData = maskData._scissorRect;
        const { maskObject: maskObject  } = maskData;
        const { renderer: renderer  } = this;
        const renderTextureSystem = renderer.renderTexture;
        const rect = maskObject.getBounds(true, $1d5edd4fe0f05794$var$rectPool.pop() ?? new (0, $340a428aa13511cc$export$4617fb02663045ef)());
        this.roundFrameToPixels(rect, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform);
        if (prevData) rect.fit(prevData);
        maskData._scissorRectLocal = rect;
    }
    static isMatrixRotated(matrix) {
        if (!matrix) return false;
        const { a: a , b: b , c: c , d: d  } = matrix;
        return (Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4);
    }
    testScissor(maskData) {
        const { maskObject: maskObject  } = maskData;
        if (!maskObject.isFastRect || !maskObject.isFastRect()) return false;
        if ($1d5edd4fe0f05794$var$_ScissorSystem.isMatrixRotated(maskObject.worldTransform)) return false;
        if ($1d5edd4fe0f05794$var$_ScissorSystem.isMatrixRotated(this.renderer.projection.transform)) return false;
        this.calcScissorRect(maskData);
        const rect = maskData._scissorRectLocal;
        return rect.width > 0 && rect.height > 0;
    }
    roundFrameToPixels(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if ($1d5edd4fe0f05794$var$_ScissorSystem.isMatrixRotated(transform)) return;
        transform = transform ? $1d5edd4fe0f05794$var$tempMatrix.copyFrom(transform) : $1d5edd4fe0f05794$var$tempMatrix.identity();
        transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y);
        this.renderer.filter.transformAABB(transform, frame);
        frame.fit(bindingDestinationFrame);
        frame.x = Math.round(frame.x * resolution);
        frame.y = Math.round(frame.y * resolution);
        frame.width = Math.round(frame.width * resolution);
        frame.height = Math.round(frame.height * resolution);
    }
    push(maskData) {
        if (!maskData._scissorRectLocal) this.calcScissorRect(maskData);
        const { gl: gl  } = this.renderer;
        if (!maskData._scissorRect) gl.enable(gl.SCISSOR_TEST);
        maskData._scissorCounter++;
        maskData._scissorRect = maskData._scissorRectLocal;
        this._useCurrent();
    }
    pop(maskData) {
        const { gl: gl  } = this.renderer;
        if (maskData) $1d5edd4fe0f05794$var$rectPool.push(maskData._scissorRectLocal);
        if (this.getStackLength() > 0) this._useCurrent();
        else gl.disable(gl.SCISSOR_TEST);
    }
    _useCurrent() {
        const rect = this.maskStack[this.maskStack.length - 1]._scissorRect;
        let y;
        if (this.renderer.renderTexture.current) y = rect.y;
        else y = this.renderer.height - rect.height - rect.y;
        this.renderer.gl.scissor(rect.x, y, rect.width, rect.height);
    }
};
let $1d5edd4fe0f05794$export$1851870585e6357f = $1d5edd4fe0f05794$var$_ScissorSystem;
$1d5edd4fe0f05794$export$1851870585e6357f.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "scissor"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($1d5edd4fe0f05794$export$1851870585e6357f);





class $465a5eb10e7d2e5e$export$d3824b839b1639a2 extends (0, $f09bb6797a33b232$export$c83199503f0366e9) {
    constructor(renderer){
        super(renderer);
        this.glConst = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext().STENCIL_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        if (maskData) return maskData._stencilCounter;
        return 0;
    }
    push(maskData) {
        const maskObject = maskData.maskObject;
        const { gl: gl  } = this.renderer;
        const prevMaskCount = maskData._stencilCounter;
        if (prevMaskCount === 0) {
            this.renderer.framebuffer.forceStencil();
            gl.clearStencil(0);
            gl.clear(gl.STENCIL_BUFFER_BIT);
            gl.enable(gl.STENCIL_TEST);
        }
        maskData._stencilCounter++;
        const colorMask = maskData._colorMask;
        if (colorMask !== 0) {
            maskData._colorMask = 0;
            gl.colorMask(false, false, false, false);
        }
        gl.stencilFunc(gl.EQUAL, prevMaskCount, 4294967295);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
        maskObject.renderable = true;
        maskObject.render(this.renderer);
        this.renderer.batch.flush();
        maskObject.renderable = false;
        if (colorMask !== 0) {
            maskData._colorMask = colorMask;
            gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0);
        }
        this._useCurrent();
    }
    pop(maskObject) {
        const gl = this.renderer.gl;
        if (this.getStackLength() === 0) gl.disable(gl.STENCIL_TEST);
        else {
            const maskData = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
            const colorMask = maskData ? maskData._colorMask : 15;
            if (colorMask !== 0) {
                maskData._colorMask = 0;
                gl.colorMask(false, false, false, false);
            }
            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
            maskObject.renderable = true;
            maskObject.render(this.renderer);
            this.renderer.batch.flush();
            maskObject.renderable = false;
            if (colorMask !== 0) {
                maskData._colorMask = colorMask;
                gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0);
            }
            this._useCurrent();
        }
    }
    _useCurrent() {
        const gl = this.renderer.gl;
        gl.stencilFunc(gl.EQUAL, this.getStackLength(), 4294967295);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    }
}
$465a5eb10e7d2e5e$export$d3824b839b1639a2.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "stencil"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($465a5eb10e7d2e5e$export$d3824b839b1639a2);




class $f182bcab91789d6c$export$b037d01b38347d8b {
    constructor(renderer){
        this.renderer = renderer;
        this.plugins = {};
        Object.defineProperties(this.plugins, {
            extract: {
                enumerable: false,
                get () {
                    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.plugins.extract has moved to renderer.extract");
                    return renderer.extract;
                }
            },
            prepare: {
                enumerable: false,
                get () {
                    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.plugins.prepare has moved to renderer.prepare");
                    return renderer.prepare;
                }
            },
            interaction: {
                enumerable: false,
                get () {
                    (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.plugins.interaction has been deprecated, use renderer.events");
                    return renderer.events;
                }
            }
        });
    }
    init() {
        const staticMap = this.rendererPlugins;
        for(const o in staticMap)this.plugins[o] = new staticMap[o](this.renderer);
    }
    destroy() {
        for(const o in this.plugins){
            this.plugins[o].destroy();
            this.plugins[o] = null;
        }
    }
}
$f182bcab91789d6c$export$b037d01b38347d8b.extension = {
    type: [
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "_plugin"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($f182bcab91789d6c$export$b037d01b38347d8b);




class $ff9e21dfc196d981$export$84be2be6fb3066d2 {
    constructor(renderer){
        this.renderer = renderer;
        this.destinationFrame = null;
        this.sourceFrame = null;
        this.defaultFrame = null;
        this.projectionMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
        this.transform = null;
    }
    update(destinationFrame, sourceFrame, resolution, root) {
        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
        this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame;
        this.calculateProjection(this.destinationFrame, this.sourceFrame, resolution, root);
        if (this.transform) this.projectionMatrix.append(this.transform);
        const renderer = this.renderer;
        renderer.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix;
        renderer.globalUniforms.update();
        if (renderer.shader.shader) renderer.shader.syncUniformGroup(renderer.shader.shader.uniforms.globals);
    }
    calculateProjection(_destinationFrame, sourceFrame, _resolution, root) {
        const pm = this.projectionMatrix;
        const sign = !root ? 1 : -1;
        pm.identity();
        pm.a = 1 / sourceFrame.width * 2;
        pm.d = sign * (1 / sourceFrame.height * 2);
        pm.tx = -1 - sourceFrame.x * pm.a;
        pm.ty = -sign - sourceFrame.y * pm.d;
    }
    setTransform(_matrix) {}
    destroy() {
        this.renderer = null;
    }
}
$ff9e21dfc196d981$export$84be2be6fb3066d2.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "projection"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($ff9e21dfc196d981$export$84be2be6fb3066d2);





const $77b4b0fc4afd1be0$var$tempTransform = new (0, $83f2cf09d03bb7ff$export$563a914cafbdc389)();
class $77b4b0fc4afd1be0$export$690776504ee197a6 {
    constructor(renderer){
        this.renderer = renderer;
        this._tempMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
    }
    generateTexture(displayObject, options) {
        const { region: manualRegion , ...textureOptions } = options || {};
        const region = manualRegion || displayObject.getLocalBounds(null, true);
        if (region.width === 0) region.width = 1;
        if (region.height === 0) region.height = 1;
        const renderTexture = (0, $952e32ce616eaf78$export$813984f7330b4d72).create({
            width: region.width,
            height: region.height,
            ...textureOptions
        });
        this._tempMatrix.tx = -region.x;
        this._tempMatrix.ty = -region.y;
        const transform = displayObject.transform;
        displayObject.transform = $77b4b0fc4afd1be0$var$tempTransform;
        this.renderer.render(displayObject, {
            renderTexture: renderTexture,
            transform: this._tempMatrix,
            skipUpdateTransform: !!displayObject.parent,
            blit: true
        });
        displayObject.transform = transform;
        return renderTexture;
    }
    destroy() {}
}
$77b4b0fc4afd1be0$export$690776504ee197a6.extension = {
    type: [
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "textureGenerator"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($77b4b0fc4afd1be0$export$690776504ee197a6);





const $79c9affe69f86737$var$tempRect = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
const $79c9affe69f86737$var$tempRect2 = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
class $79c9affe69f86737$export$5fd756363f54136f {
    constructor(renderer){
        this.renderer = renderer;
        this.defaultMaskStack = [];
        this.current = null;
        this.sourceFrame = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.destinationFrame = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.viewportFrame = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
    }
    contextChange() {
        const attributes = this.renderer?.gl.getContextAttributes();
        this._rendererPremultipliedAlpha = !!(attributes && attributes.alpha && attributes.premultipliedAlpha);
    }
    bind(renderTexture = null, sourceFrame, destinationFrame) {
        const renderer = this.renderer;
        this.current = renderTexture;
        let baseTexture;
        let framebuffer;
        let resolution;
        if (renderTexture) {
            baseTexture = renderTexture.baseTexture;
            resolution = baseTexture.resolution;
            if (!sourceFrame) {
                $79c9affe69f86737$var$tempRect.width = renderTexture.frame.width;
                $79c9affe69f86737$var$tempRect.height = renderTexture.frame.height;
                sourceFrame = $79c9affe69f86737$var$tempRect;
            }
            if (!destinationFrame) {
                $79c9affe69f86737$var$tempRect2.x = renderTexture.frame.x;
                $79c9affe69f86737$var$tempRect2.y = renderTexture.frame.y;
                $79c9affe69f86737$var$tempRect2.width = sourceFrame.width;
                $79c9affe69f86737$var$tempRect2.height = sourceFrame.height;
                destinationFrame = $79c9affe69f86737$var$tempRect2;
            }
            framebuffer = baseTexture.framebuffer;
        } else {
            resolution = renderer.resolution;
            if (!sourceFrame) {
                $79c9affe69f86737$var$tempRect.width = renderer._view.screen.width;
                $79c9affe69f86737$var$tempRect.height = renderer._view.screen.height;
                sourceFrame = $79c9affe69f86737$var$tempRect;
            }
            if (!destinationFrame) {
                destinationFrame = $79c9affe69f86737$var$tempRect;
                destinationFrame.width = sourceFrame.width;
                destinationFrame.height = sourceFrame.height;
            }
        }
        const viewportFrame = this.viewportFrame;
        viewportFrame.x = destinationFrame.x * resolution;
        viewportFrame.y = destinationFrame.y * resolution;
        viewportFrame.width = destinationFrame.width * resolution;
        viewportFrame.height = destinationFrame.height * resolution;
        if (!renderTexture) viewportFrame.y = renderer.view.height - (viewportFrame.y + viewportFrame.height);
        viewportFrame.ceil();
        this.renderer.framebuffer.bind(framebuffer, viewportFrame);
        this.renderer.projection.update(destinationFrame, sourceFrame, resolution, !framebuffer);
        if (renderTexture) this.renderer.mask.setMaskStack(baseTexture.maskStack);
        else this.renderer.mask.setMaskStack(this.defaultMaskStack);
        this.sourceFrame.copyFrom(sourceFrame);
        this.destinationFrame.copyFrom(destinationFrame);
    }
    clear(clearColor, mask) {
        const fallbackColor = this.current ? this.current.baseTexture.clear : this.renderer.background.backgroundColor;
        const color = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(clearColor ? clearColor : fallbackColor);
        if (this.current && this.current.baseTexture.alphaMode > 0 || !this.current && this._rendererPremultipliedAlpha) color.premultiply(color.alpha);
        const destinationFrame = this.destinationFrame;
        const baseFrame = this.current ? this.current.baseTexture : this.renderer._view.screen;
        const clearMask = destinationFrame.width !== baseFrame.width || destinationFrame.height !== baseFrame.height;
        if (clearMask) {
            let { x: x , y: y , width: width , height: height  } = this.viewportFrame;
            x = Math.round(x);
            y = Math.round(y);
            width = Math.round(width);
            height = Math.round(height);
            this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);
            this.renderer.gl.scissor(x, y, width, height);
        }
        this.renderer.framebuffer.clear(color.red, color.green, color.blue, color.alpha, mask);
        if (clearMask) this.renderer.scissor.pop();
    }
    resize() {
        this.bind(null);
    }
    reset() {
        this.bind(null);
    }
    destroy() {
        this.renderer = null;
    }
}
$79c9affe69f86737$export$5fd756363f54136f.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "renderTexture"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($79c9affe69f86737$export$5fd756363f54136f);




class $a954c32aab7911f1$export$181be621ce68aec5 {
}
class $a954c32aab7911f1$export$bf1479c8ce91afd5 {
    constructor(program, uniformData){
        this.program = program;
        this.uniformData = uniformData;
        this.uniformGroups = {};
        this.uniformDirtyGroups = {};
        this.uniformBufferBindings = {};
    }
    destroy() {
        this.uniformData = null;
        this.uniformGroups = null;
        this.uniformDirtyGroups = null;
        this.uniformBufferBindings = null;
        this.program = null;
    }
}






function $271d5c07039add3c$export$c73f9ceeec70bdfb(program, gl) {
    const attributes = {};
    const totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < totalAttributes; i++){
        const attribData = gl.getActiveAttrib(program, i);
        if (attribData.name.startsWith("gl_")) continue;
        const type = (0, $d1f0673787d44f4c$export$4de3a94418d86ca7)(gl, attribData.type);
        const data = {
            type: type,
            name: attribData.name,
            size: (0, $6ce3ebb6f0d94afe$export$50ee69a11aa2abdb)(type),
            location: gl.getAttribLocation(program, attribData.name)
        };
        attributes[attribData.name] = data;
    }
    return attributes;
}




function $97365b23c596420b$export$d38fd6033d9429a5(program, gl) {
    const uniforms = {};
    const totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for(let i = 0; i < totalUniforms; i++){
        const uniformData = gl.getActiveUniform(program, i);
        const name = uniformData.name.replace(/\[.*?\]$/, "");
        const isArray = !!uniformData.name.match(/\[.*?\]$/);
        const type = (0, $d1f0673787d44f4c$export$4de3a94418d86ca7)(gl, uniformData.type);
        uniforms[name] = {
            name: name,
            index: i,
            type: type,
            size: uniformData.size,
            isArray: isArray,
            value: (0, $103a179a1bbbbc0b$export$1a01ae0705bafd37)(type, uniformData.size)
        };
    }
    return uniforms;
}



function $d148e901bd50f006$export$44c84e8c8e54bce9(gl, program) {
    const glVertShader = (0, $0dc4dba3c84abd75$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, program.vertexSrc);
    const glFragShader = (0, $0dc4dba3c84abd75$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, program.fragmentSrc);
    const webGLProgram = gl.createProgram();
    gl.attachShader(webGLProgram, glVertShader);
    gl.attachShader(webGLProgram, glFragShader);
    const transformFeedbackVaryings = program.extra?.transformFeedbackVaryings;
    if (transformFeedbackVaryings) {
        if (typeof gl.transformFeedbackVaryings !== "function") console.warn(`TransformFeedback is not supported but TransformFeedbackVaryings are given.`);
        else gl.transformFeedbackVaryings(webGLProgram, transformFeedbackVaryings.names, transformFeedbackVaryings.bufferMode === "separate" ? gl.SEPARATE_ATTRIBS : gl.INTERLEAVED_ATTRIBS);
    }
    gl.linkProgram(webGLProgram);
    if (!gl.getProgramParameter(webGLProgram, gl.LINK_STATUS)) (0, $393c6798ea1ed6a4$export$4b35d6c62dc992b0)(gl, webGLProgram, glVertShader, glFragShader);
    program.attributeData = (0, $271d5c07039add3c$export$c73f9ceeec70bdfb)(webGLProgram, gl);
    program.uniformData = (0, $97365b23c596420b$export$d38fd6033d9429a5)(webGLProgram, gl);
    if (!/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(program.vertexSrc)) {
        const keys = Object.keys(program.attributeData);
        keys.sort((a, b)=>a > b ? 1 : -1);
        for(let i = 0; i < keys.length; i++){
            program.attributeData[keys[i]].location = i;
            gl.bindAttribLocation(webGLProgram, i, keys[i]);
        }
        gl.linkProgram(webGLProgram);
    }
    gl.deleteShader(glVertShader);
    gl.deleteShader(glFragShader);
    const uniformData = {};
    for(const i in program.uniformData){
        const data = program.uniformData[i];
        uniformData[i] = {
            location: gl.getUniformLocation(webGLProgram, i),
            value: (0, $103a179a1bbbbc0b$export$1a01ae0705bafd37)(data.type, data.size)
        };
    }
    const glProgram = new (0, $a954c32aab7911f1$export$bf1479c8ce91afd5)(webGLProgram, uniformData);
    return glProgram;
}





function $bd6ea98358c3af52$var$uboUpdate(_ud, _uv, _renderer, _syncData, buffer) {
    _renderer.buffer.update(buffer);
}
const $bd6ea98358c3af52$var$UBO_TO_SINGLE_SETTERS = {
    float: `
        data[offset] = v;
    `,
    vec2: `
        data[offset] = v[0];
        data[offset+1] = v[1];
    `,
    vec3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

    `,
    vec4: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];
        data[offset+3] = v[3];
    `,
    mat2: `
        data[offset] = v[0];
        data[offset+1] = v[1];

        data[offset+4] = v[2];
        data[offset+5] = v[3];
    `,
    mat3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];

        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];
    `,
    mat4: `
        for(var i = 0; i < 16; i++)
        {
            data[offset + i] = v[i];
        }
    `
};
const $bd6ea98358c3af52$var$GLSL_TO_STD40_SIZE = {
    float: 4,
    vec2: 8,
    vec3: 12,
    vec4: 16,
    int: 4,
    ivec2: 8,
    ivec3: 12,
    ivec4: 16,
    uint: 4,
    uvec2: 8,
    uvec3: 12,
    uvec4: 16,
    bool: 4,
    bvec2: 8,
    bvec3: 12,
    bvec4: 16,
    mat2: 32,
    mat3: 48,
    mat4: 64
};
function $bd6ea98358c3af52$export$3c4fb828fecb3ead(uniformData) {
    const uboElements = uniformData.map((data)=>({
            data: data,
            offset: 0,
            dataLen: 0,
            dirty: 0
        }));
    let size = 0;
    let chunkSize = 0;
    let offset = 0;
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        size = $bd6ea98358c3af52$var$GLSL_TO_STD40_SIZE[uboElement.data.type];
        if (uboElement.data.size > 1) size = Math.max(size, 16) * uboElement.data.size;
        uboElement.dataLen = size;
        if (chunkSize % size !== 0 && chunkSize < 16) {
            const lineUpValue = chunkSize % size % 16;
            chunkSize += lineUpValue;
            offset += lineUpValue;
        }
        if (chunkSize + size > 16) {
            offset = Math.ceil(offset / 16) * 16;
            uboElement.offset = offset;
            offset += size;
            chunkSize = size;
        } else {
            uboElement.offset = offset;
            chunkSize += size;
            offset += size;
        }
    }
    offset = Math.ceil(offset / 16) * 16;
    return {
        uboElements: uboElements,
        size: offset
    };
}
function $bd6ea98358c3af52$export$56f32278ebf30ea0(uniforms, uniformData) {
    const usedUniformDatas = [];
    for(const i in uniforms)if (uniformData[i]) usedUniformDatas.push(uniformData[i]);
    usedUniformDatas.sort((a, b)=>a.index - b.index);
    return usedUniformDatas;
}
function $bd6ea98358c3af52$export$39fbc1d5b3f112e4(group, uniformData) {
    if (!group.autoManage) return {
        size: 0,
        syncFunc: $bd6ea98358c3af52$var$uboUpdate
    };
    const usedUniformDatas = $bd6ea98358c3af52$export$56f32278ebf30ea0(group.uniforms, uniformData);
    const { uboElements: uboElements , size: size  } = $bd6ea98358c3af52$export$3c4fb828fecb3ead(usedUniformDatas);
    const funcFragments = [
        `
    var v = null;
    var v2 = null;
    var cv = null;
    var t = 0;
    var gl = renderer.gl
    var index = 0;
    var data = buffer.data;
    `
    ];
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        const uniform = group.uniforms[uboElement.data.name];
        const name = uboElement.data.name;
        let parsed = false;
        for(let j = 0; j < (0, $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2).length; j++){
            const uniformParser = (0, $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2)[j];
            if (uniformParser.codeUbo && uniformParser.test(uboElement.data, uniform)) {
                funcFragments.push(`offset = ${uboElement.offset / 4};`, (0, $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2)[j].codeUbo(uboElement.data.name, uniform));
                parsed = true;
                break;
            }
        }
        if (!parsed) {
            if (uboElement.data.size > 1) {
                const size2 = (0, $6ce3ebb6f0d94afe$export$50ee69a11aa2abdb)(uboElement.data.type);
                const rowSize = Math.max($bd6ea98358c3af52$var$GLSL_TO_STD40_SIZE[uboElement.data.type] / 16, 1);
                const elementSize = size2 / rowSize;
                const remainder = (4 - elementSize % 4) % 4;
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};

                t = 0;

                for(var i=0; i < ${uboElement.data.size * rowSize}; i++)
                {
                    for(var j = 0; j < ${elementSize}; j++)
                    {
                        data[offset++] = v[t++];
                    }
                    offset += ${remainder};
                }

                `);
            } else {
                const template = $bd6ea98358c3af52$var$UBO_TO_SINGLE_SETTERS[uboElement.data.type];
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};
                ${template};
                `);
            }
        }
    }
    funcFragments.push(`
       renderer.buffer.update(buffer);
    `);
    return {
        size: size,
        syncFunc: new Function("ud", "uv", "renderer", "syncData", "buffer", funcFragments.join("\n"))
    };
}




let $42ad742ac3d50c23$var$UID = 0;
const $42ad742ac3d50c23$var$defaultSyncData = {
    textureCount: 0,
    uboCount: 0
};
class $42ad742ac3d50c23$export$d91933f5c44096f4 {
    constructor(renderer){
        this.destroyed = false;
        this.renderer = renderer;
        this.systemCheck();
        this.gl = null;
        this.shader = null;
        this.program = null;
        this.cache = {};
        this._uboCache = {};
        this.id = $42ad742ac3d50c23$var$UID++;
    }
    systemCheck() {
        if (!(0, $62249037d7b2f875$export$70c0711f29adc5cf)()) throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
    }
    contextChange(gl) {
        this.gl = gl;
        this.reset();
    }
    bind(shader, dontSync) {
        shader.disposeRunner.add(this);
        shader.uniforms.globals = this.renderer.globalUniforms;
        const program = shader.program;
        const glProgram = program.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(shader);
        this.shader = shader;
        if (this.program !== program) {
            this.program = program;
            this.gl.useProgram(glProgram.program);
        }
        if (!dontSync) {
            $42ad742ac3d50c23$var$defaultSyncData.textureCount = 0;
            $42ad742ac3d50c23$var$defaultSyncData.uboCount = 0;
            this.syncUniformGroup(shader.uniformGroup, $42ad742ac3d50c23$var$defaultSyncData);
        }
        return glProgram;
    }
    setUniforms(uniforms) {
        const shader = this.shader.program;
        const glProgram = shader.glPrograms[this.renderer.CONTEXT_UID];
        shader.syncUniforms(glProgram.uniformData, uniforms, this.renderer);
    }
    syncUniformGroup(group, syncData) {
        const glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== glProgram.uniformDirtyGroups[group.id]) {
            glProgram.uniformDirtyGroups[group.id] = group.dirtyId;
            this.syncUniforms(group, glProgram, syncData);
        }
    }
    syncUniforms(group, glProgram, syncData) {
        const syncFunc = group.syncUniforms[this.shader.program.id] || this.createSyncGroups(group);
        syncFunc(glProgram.uniformData, group.uniforms, this.renderer, syncData);
    }
    createSyncGroups(group) {
        const id = this.getSignature(group, this.shader.program.uniformData, "u");
        if (!this.cache[id]) this.cache[id] = (0, $fa25b17d2653b481$export$20c95d1c2d5a6828)(group, this.shader.program.uniformData);
        group.syncUniforms[this.shader.program.id] = this.cache[id];
        return group.syncUniforms[this.shader.program.id];
    }
    syncUniformBufferGroup(group, name) {
        const glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== 0 || !glProgram.uniformGroups[group.id]) {
            group.dirtyId = 0;
            const syncFunc = glProgram.uniformGroups[group.id] || this.createSyncBufferGroup(group, glProgram, name);
            group.buffer.update();
            syncFunc(glProgram.uniformData, group.uniforms, this.renderer, $42ad742ac3d50c23$var$defaultSyncData, group.buffer);
        }
        this.renderer.buffer.bindBufferBase(group.buffer, glProgram.uniformBufferBindings[name]);
    }
    createSyncBufferGroup(group, glProgram, name) {
        const { gl: gl  } = this.renderer;
        this.renderer.buffer.bind(group.buffer);
        const uniformBlockIndex = this.gl.getUniformBlockIndex(glProgram.program, name);
        glProgram.uniformBufferBindings[name] = this.shader.uniformBindCount;
        gl.uniformBlockBinding(glProgram.program, uniformBlockIndex, this.shader.uniformBindCount);
        this.shader.uniformBindCount++;
        const id = this.getSignature(group, this.shader.program.uniformData, "ubo");
        let uboData = this._uboCache[id];
        if (!uboData) uboData = this._uboCache[id] = (0, $bd6ea98358c3af52$export$39fbc1d5b3f112e4)(group, this.shader.program.uniformData);
        if (group.autoManage) {
            const data = new Float32Array(uboData.size / 4);
            group.buffer.update(data);
        }
        glProgram.uniformGroups[group.id] = uboData.syncFunc;
        return glProgram.uniformGroups[group.id];
    }
    getSignature(group, uniformData, preFix) {
        const uniforms = group.uniforms;
        const strings = [
            `${preFix}-`
        ];
        for(const i in uniforms){
            strings.push(i);
            if (uniformData[i]) strings.push(uniformData[i].type);
        }
        return strings.join("-");
    }
    getGlProgram() {
        if (this.shader) return this.shader.program.glPrograms[this.renderer.CONTEXT_UID];
        return null;
    }
    generateProgram(shader) {
        const gl = this.gl;
        const program = shader.program;
        const glProgram = (0, $d148e901bd50f006$export$44c84e8c8e54bce9)(gl, program);
        program.glPrograms[this.renderer.CONTEXT_UID] = glProgram;
        return glProgram;
    }
    reset() {
        this.program = null;
        this.shader = null;
    }
    disposeShader(shader) {
        if (this.shader === shader) this.shader = null;
    }
    destroy() {
        this.renderer = null;
        this.destroyed = true;
    }
}
$42ad742ac3d50c23$export$d91933f5c44096f4.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "shader"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($42ad742ac3d50c23$export$d91933f5c44096f4);



class $e7a42a553978e370$export$8b298d2bda604a05 {
    constructor(renderer){
        this.renderer = renderer;
    }
    run(options) {
        const { renderer: renderer  } = this;
        renderer.runners.init.emit(renderer.options);
        if (options.hello) console.log(`PixiJS ${"7.2.4"} - ${renderer.rendererLogId} - https://pixijs.com`);
        renderer.resize(renderer.screen.width, renderer.screen.height);
    }
    destroy() {}
}
$e7a42a553978e370$export$8b298d2bda604a05.defaultOptions = {
    hello: false
};
$e7a42a553978e370$export$8b298d2bda604a05.extension = {
    type: [
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "startup"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($e7a42a553978e370$export$8b298d2bda604a05);






function $4a5ded39d0179802$export$57ed86928a8d2aa1(gl, array = []) {
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).ADD] = [
        gl.ONE,
        gl.ONE
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).MULTIPLY] = [
        gl.DST_COLOR,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SCREEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).OVERLAY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).DARKEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).LIGHTEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).COLOR_DODGE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).COLOR_BURN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).HARD_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SOFT_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).DIFFERENCE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).EXCLUSION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).HUE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SATURATION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).COLOR] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).LUMINOSITY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).NONE] = [
        0,
        0
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).ADD_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE,
        gl.ONE,
        gl.ONE
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SCREEN_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SRC_IN] = [
        gl.DST_ALPHA,
        gl.ZERO
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SRC_OUT] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ZERO
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SRC_ATOP] = [
        gl.DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).DST_OVER] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).DST_IN] = [
        gl.ZERO,
        gl.SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).DST_OUT] = [
        gl.ZERO,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).DST_ATOP] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).XOR] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $551209d754b5b429$export$f821c68fe9beaecf).SUBTRACT] = [
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.FUNC_REVERSE_SUBTRACT,
        gl.FUNC_ADD
    ];
    return array;
}


const $cbce3595b7947a2e$var$BLEND = 0;
const $cbce3595b7947a2e$var$OFFSET = 1;
const $cbce3595b7947a2e$var$CULLING = 2;
const $cbce3595b7947a2e$var$DEPTH_TEST = 3;
const $cbce3595b7947a2e$var$WINDING = 4;
const $cbce3595b7947a2e$var$DEPTH_MASK = 5;
const $cbce3595b7947a2e$var$_StateSystem = class {
    constructor(){
        this.gl = null;
        this.stateId = 0;
        this.polygonOffset = 0;
        this.blendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).NONE;
        this._blendEq = false;
        this.map = [];
        this.map[$cbce3595b7947a2e$var$BLEND] = this.setBlend;
        this.map[$cbce3595b7947a2e$var$OFFSET] = this.setOffset;
        this.map[$cbce3595b7947a2e$var$CULLING] = this.setCullFace;
        this.map[$cbce3595b7947a2e$var$DEPTH_TEST] = this.setDepthTest;
        this.map[$cbce3595b7947a2e$var$WINDING] = this.setFrontFace;
        this.map[$cbce3595b7947a2e$var$DEPTH_MASK] = this.setDepthMask;
        this.checks = [];
        this.defaultState = new (0, $15a50e9cd387ae21$export$7254cc27399e90bd)();
        this.defaultState.blend = true;
    }
    contextChange(gl) {
        this.gl = gl;
        this.blendModes = (0, $4a5ded39d0179802$export$57ed86928a8d2aa1)(gl);
        this.set(this.defaultState);
        this.reset();
    }
    set(state) {
        state = state || this.defaultState;
        if (this.stateId !== state.data) {
            let diff = this.stateId ^ state.data;
            let i = 0;
            while(diff){
                if (diff & 1) this.map[i].call(this, !!(state.data & 1 << i));
                diff = diff >> 1;
                i++;
            }
            this.stateId = state.data;
        }
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
    }
    forceState(state) {
        state = state || this.defaultState;
        for(let i = 0; i < this.map.length; i++)this.map[i].call(this, !!(state.data & 1 << i));
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
        this.stateId = state.data;
    }
    setBlend(value) {
        this.updateCheck($cbce3595b7947a2e$var$_StateSystem.checkBlendMode, value);
        this.gl[value ? "enable" : "disable"](this.gl.BLEND);
    }
    setOffset(value) {
        this.updateCheck($cbce3595b7947a2e$var$_StateSystem.checkPolygonOffset, value);
        this.gl[value ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
    }
    setDepthTest(value) {
        this.gl[value ? "enable" : "disable"](this.gl.DEPTH_TEST);
    }
    setDepthMask(value) {
        this.gl.depthMask(value);
    }
    setCullFace(value) {
        this.gl[value ? "enable" : "disable"](this.gl.CULL_FACE);
    }
    setFrontFace(value) {
        this.gl.frontFace(this.gl[value ? "CW" : "CCW"]);
    }
    setBlendMode(value) {
        if (value === this.blendMode) return;
        this.blendMode = value;
        const mode = this.blendModes[value];
        const gl = this.gl;
        if (mode.length === 2) gl.blendFunc(mode[0], mode[1]);
        else gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
        if (mode.length === 6) {
            this._blendEq = true;
            gl.blendEquationSeparate(mode[4], mode[5]);
        } else if (this._blendEq) {
            this._blendEq = false;
            gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
        }
    }
    setPolygonOffset(value, scale) {
        this.gl.polygonOffset(value, scale);
    }
    reset() {
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
        this.forceState(this.defaultState);
        this._blendEq = true;
        this.blendMode = -1;
        this.setBlendMode(0);
    }
    updateCheck(func, value) {
        const index = this.checks.indexOf(func);
        if (value && index === -1) this.checks.push(func);
        else if (!value && index !== -1) this.checks.splice(index, 1);
    }
    static checkBlendMode(system, state) {
        system.setBlendMode(state.blendMode);
    }
    static checkPolygonOffset(system, state) {
        system.setPolygonOffset(1, state.polygonOffset);
    }
    destroy() {
        this.gl = null;
    }
};
let $cbce3595b7947a2e$export$d47ea6626863db49 = $cbce3595b7947a2e$var$_StateSystem;
$cbce3595b7947a2e$export$d47ea6626863db49.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "state"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($cbce3595b7947a2e$export$d47ea6626863db49);




class $64ffa2d81765c4cc$export$a12e67a4b4590901 extends (0, (/*@__PURE__*/$parcel$interopDefault($f08921b7a62a95d1$exports))) {
    constructor(){
        super(...arguments);
        this.runners = {};
        this._systemsHash = {};
    }
    setup(config) {
        this.addRunners(...config.runners);
        const priority = (config.priority ?? []).filter((key)=>config.systems[key]);
        const orderByPriority = [
            ...priority,
            ...Object.keys(config.systems).filter((key)=>!priority.includes(key))
        ];
        for (const i of orderByPriority)this.addSystem(config.systems[i], i);
    }
    addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)(runnerId);
        });
    }
    addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    emitWithCustomOptions(runner, options) {
        const systemHashKeys = Object.keys(this._systemsHash);
        runner.items.forEach((system)=>{
            const systemName = systemHashKeys.find((systemId)=>this._systemsHash[systemId] === system);
            system[runner.name](options[systemName]);
        });
    }
    destroy() {
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = {};
    }
}




const $e0f99544b0c3a894$var$_TextureGCSystem = class {
    constructor(renderer){
        this.renderer = renderer;
        this.count = 0;
        this.checkCount = 0;
        this.maxIdle = $e0f99544b0c3a894$var$_TextureGCSystem.defaultMaxIdle;
        this.checkCountMax = $e0f99544b0c3a894$var$_TextureGCSystem.defaultCheckCountMax;
        this.mode = $e0f99544b0c3a894$var$_TextureGCSystem.defaultMode;
    }
    postrender() {
        if (!this.renderer.objectRenderer.renderingToScreen) return;
        this.count++;
        if (this.mode === (0, $551209d754b5b429$export$5c6ba89c1f52b344).MANUAL) return;
        this.checkCount++;
        if (this.checkCount > this.checkCountMax) {
            this.checkCount = 0;
            this.run();
        }
    }
    run() {
        const tm = this.renderer.texture;
        const managedTextures = tm.managedTextures;
        let wasRemoved = false;
        for(let i = 0; i < managedTextures.length; i++){
            const texture = managedTextures[i];
            if (!texture.framebuffer && this.count - texture.touched > this.maxIdle) {
                tm.destroyTexture(texture, true);
                managedTextures[i] = null;
                wasRemoved = true;
            }
        }
        if (wasRemoved) {
            let j = 0;
            for(let i = 0; i < managedTextures.length; i++)if (managedTextures[i] !== null) managedTextures[j++] = managedTextures[i];
            managedTextures.length = j;
        }
    }
    unload(displayObject) {
        const tm = this.renderer.texture;
        const texture = displayObject._texture;
        if (texture && !texture.framebuffer) tm.destroyTexture(texture);
        for(let i = displayObject.children.length - 1; i >= 0; i--)this.unload(displayObject.children[i]);
    }
    destroy() {
        this.renderer = null;
    }
};
let $e0f99544b0c3a894$export$a47b032752d8e393 = $e0f99544b0c3a894$var$_TextureGCSystem;
$e0f99544b0c3a894$export$a47b032752d8e393.defaultMode = (0, $551209d754b5b429$export$5c6ba89c1f52b344).AUTO;
$e0f99544b0c3a894$export$a47b032752d8e393.defaultMaxIdle = 3600;
$e0f99544b0c3a894$export$a47b032752d8e393.defaultCheckCountMax = 600;
$e0f99544b0c3a894$export$a47b032752d8e393.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "textureGC"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($e0f99544b0c3a894$export$a47b032752d8e393);







class $02f6e5532fa8cd9d$export$6c73c2a4561c07a2 {
    constructor(texture){
        this.texture = texture;
        this.width = -1;
        this.height = -1;
        this.dirtyId = -1;
        this.dirtyStyleId = -1;
        this.mipmap = false;
        this.wrapMode = 33071;
        this.type = (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE;
        this.internalFormat = (0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA;
        this.samplerType = 0;
    }
}



function $987f2e0338d2f6f0$export$af038b9b93a51a84(gl) {
    let table;
    if ("WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext) table = {
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA8,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB8,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG]: gl.RG8,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED]: gl.R8,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA8UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB8UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG8UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R8UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).ALPHA]: gl.ALPHA,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).LUMINANCE]: gl.LUMINANCE,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).BYTE]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA8_SNORM,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB8_SNORM,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG]: gl.RG8_SNORM,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED]: gl.R8_SNORM,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA8I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB8I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG8I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R8I
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA16UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB16UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG16UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R16UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT16
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).SHORT]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA16I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB16I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG16I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R16I
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_INT]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA32UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB32UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG32UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R32UI,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT24
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).INT]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA32I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB32I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG32I,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R32I
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA32F,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB32F,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG]: gl.RG32F,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED]: gl.R32F,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT32F
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).HALF_FLOAT]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA16F,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB16F,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG]: gl.RG16F,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED]: gl.R16F
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB565
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA4
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGB5_A1
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_INT_2_10_10_10_REV]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGB10_A2,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGB10_A2UI
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_INT_10F_11F_11F_REV]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.R11F_G11F_B10F
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_INT_5_9_9_9_REV]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB9_E5
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_INT_24_8]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).DEPTH_STENCIL]: gl.DEPTH24_STENCIL8
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT_32_UNSIGNED_INT_24_8_REV]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).DEPTH_STENCIL]: gl.DEPTH32F_STENCIL8
        }
    };
    else table = {
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).ALPHA]: gl.ALPHA,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).LUMINANCE]: gl.LUMINANCE,
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: gl.RGB
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA
        },
        [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: gl.RGBA
        }
    };
    return table;
}


class $e8141bbe5864ec6f$export$6312da36f198968 {
    constructor(renderer){
        this.renderer = renderer;
        this.boundTextures = [];
        this.currentLocation = -1;
        this.managedTextures = [];
        this._unknownBoundTextures = false;
        this.unknownTexture = new (0, $2d8d497fce3a4092$export$d6306e508f184154)();
        this.hasIntegerTextures = false;
    }
    contextChange() {
        const gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.webGLVersion = this.renderer.context.webGLVersion;
        this.internalFormats = (0, $987f2e0338d2f6f0$export$af038b9b93a51a84)(gl);
        const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
        this.boundTextures.length = maxTextures;
        for(let i = 0; i < maxTextures; i++)this.boundTextures[i] = null;
        this.emptyTextures = {};
        const emptyTexture2D = new (0, $02f6e5532fa8cd9d$export$6c73c2a4561c07a2)(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_2D, emptyTexture2D.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(4));
        this.emptyTextures[gl.TEXTURE_2D] = emptyTexture2D;
        this.emptyTextures[gl.TEXTURE_CUBE_MAP] = new (0, $02f6e5532fa8cd9d$export$6c73c2a4561c07a2)(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.emptyTextures[gl.TEXTURE_CUBE_MAP].texture);
        for(let i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        for(let i = 0; i < this.boundTextures.length; i++)this.bind(null, i);
    }
    bind(texture, location = 0) {
        const { gl: gl  } = this;
        texture = texture?.castToBaseTexture();
        if (texture?.valid && !texture.parentTextureArray) {
            texture.touched = this.renderer.textureGC.count;
            const glTexture = texture._glTextures[this.CONTEXT_UID] || this.initTexture(texture);
            if (this.boundTextures[location] !== texture) {
                if (this.currentLocation !== location) {
                    this.currentLocation = location;
                    gl.activeTexture(gl.TEXTURE0 + location);
                }
                gl.bindTexture(texture.target, glTexture.texture);
            }
            if (glTexture.dirtyId !== texture.dirtyId) {
                if (this.currentLocation !== location) {
                    this.currentLocation = location;
                    gl.activeTexture(gl.TEXTURE0 + location);
                }
                this.updateTexture(texture);
            } else if (glTexture.dirtyStyleId !== texture.dirtyStyleId) this.updateTextureStyle(texture);
            this.boundTextures[location] = texture;
        } else {
            if (this.currentLocation !== location) {
                this.currentLocation = location;
                gl.activeTexture(gl.TEXTURE0 + location);
            }
            gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[gl.TEXTURE_2D].texture);
            this.boundTextures[location] = null;
        }
    }
    reset() {
        this._unknownBoundTextures = true;
        this.hasIntegerTextures = false;
        this.currentLocation = -1;
        for(let i = 0; i < this.boundTextures.length; i++)this.boundTextures[i] = this.unknownTexture;
    }
    unbind(texture) {
        const { gl: gl , boundTextures: boundTextures  } = this;
        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = false;
            for(let i = 0; i < boundTextures.length; i++)if (boundTextures[i] === this.unknownTexture) this.bind(null, i);
        }
        for(let i = 0; i < boundTextures.length; i++)if (boundTextures[i] === texture) {
            if (this.currentLocation !== i) {
                gl.activeTexture(gl.TEXTURE0 + i);
                this.currentLocation = i;
            }
            gl.bindTexture(texture.target, this.emptyTextures[texture.target].texture);
            boundTextures[i] = null;
        }
    }
    ensureSamplerType(maxTextures) {
        const { boundTextures: boundTextures , hasIntegerTextures: hasIntegerTextures , CONTEXT_UID: CONTEXT_UID  } = this;
        if (!hasIntegerTextures) return;
        for(let i = maxTextures - 1; i >= 0; --i){
            const tex = boundTextures[i];
            if (tex) {
                const glTexture = tex._glTextures[CONTEXT_UID];
                if (glTexture.samplerType !== (0, $551209d754b5b429$export$8ee8af3637d728f5).FLOAT) this.renderer.texture.unbind(tex);
            }
        }
    }
    initTexture(texture) {
        const glTexture = new (0, $02f6e5532fa8cd9d$export$6c73c2a4561c07a2)(this.gl.createTexture());
        glTexture.dirtyId = -1;
        texture._glTextures[this.CONTEXT_UID] = glTexture;
        this.managedTextures.push(texture);
        texture.on("dispose", this.destroyTexture, this);
        return glTexture;
    }
    initTextureType(texture, glTexture) {
        glTexture.internalFormat = this.internalFormats[texture.type]?.[texture.format] ?? texture.format;
        if (this.webGLVersion === 2 && texture.type === (0, $551209d754b5b429$export$426db7a6155b7a80).HALF_FLOAT) glTexture.type = this.gl.HALF_FLOAT;
        else glTexture.type = texture.type;
    }
    updateTexture(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        const renderer = this.renderer;
        this.initTextureType(texture, glTexture);
        if (texture.resource?.upload(renderer, texture, glTexture)) {
            if (glTexture.samplerType !== (0, $551209d754b5b429$export$8ee8af3637d728f5).FLOAT) this.hasIntegerTextures = true;
        } else {
            const width = texture.realWidth;
            const height = texture.realHeight;
            const gl = renderer.gl;
            if (glTexture.width !== width || glTexture.height !== height || glTexture.dirtyId < 0) {
                glTexture.width = width;
                glTexture.height = height;
                gl.texImage2D(texture.target, 0, glTexture.internalFormat, width, height, 0, texture.format, glTexture.type, null);
            }
        }
        if (texture.dirtyStyleId !== glTexture.dirtyStyleId) this.updateTextureStyle(texture);
        glTexture.dirtyId = texture.dirtyId;
    }
    destroyTexture(texture, skipRemove) {
        const { gl: gl  } = this;
        texture = texture.castToBaseTexture();
        if (texture._glTextures[this.CONTEXT_UID]) {
            this.unbind(texture);
            gl.deleteTexture(texture._glTextures[this.CONTEXT_UID].texture);
            texture.off("dispose", this.destroyTexture, this);
            delete texture._glTextures[this.CONTEXT_UID];
            if (!skipRemove) {
                const i = this.managedTextures.indexOf(texture);
                if (i !== -1) (0, $c5d3b3fba0229ba7$export$8d47c0e1ce445404)(this.managedTextures, i, 1);
            }
        }
    }
    updateTextureStyle(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        if ((texture.mipmap === (0, $551209d754b5b429$export$16f6fb5da874bbfd).POW2 || this.webGLVersion !== 2) && !texture.isPowerOfTwo) glTexture.mipmap = false;
        else glTexture.mipmap = texture.mipmap >= 1;
        if (this.webGLVersion !== 2 && !texture.isPowerOfTwo) glTexture.wrapMode = (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).CLAMP;
        else glTexture.wrapMode = texture.wrapMode;
        if (texture.resource?.style(this.renderer, texture, glTexture)) ;
        else this.setStyle(texture, glTexture);
        glTexture.dirtyStyleId = texture.dirtyStyleId;
    }
    setStyle(texture, glTexture) {
        const gl = this.gl;
        if (glTexture.mipmap && texture.mipmap !== (0, $551209d754b5b429$export$16f6fb5da874bbfd).ON_MANUAL) gl.generateMipmap(texture.target);
        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_S, glTexture.wrapMode);
        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_T, glTexture.wrapMode);
        if (glTexture.mipmap) {
            gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $551209d754b5b429$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
            const anisotropicExt = this.renderer.context.extensions.anisotropicFiltering;
            if (anisotropicExt && texture.anisotropicLevel > 0 && texture.scaleMode === (0, $551209d754b5b429$export$6b734c6a0bba8473).LINEAR) {
                const level = Math.min(texture.anisotropicLevel, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
                gl.texParameterf(texture.target, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
            }
        } else gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $551209d754b5b429$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR : gl.NEAREST);
        gl.texParameteri(texture.target, gl.TEXTURE_MAG_FILTER, texture.scaleMode === (0, $551209d754b5b429$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR : gl.NEAREST);
    }
    destroy() {
        this.renderer = null;
    }
}
$e8141bbe5864ec6f$export$6312da36f198968.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "texture"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($e8141bbe5864ec6f$export$6312da36f198968);



class $c42839d5a3281933$export$82410eeab0646070 {
    constructor(renderer){
        this.renderer = renderer;
    }
    contextChange() {
        this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    bind(transformFeedback) {
        const { gl: gl , CONTEXT_UID: CONTEXT_UID  } = this;
        const glTransformFeedback = transformFeedback._glTransformFeedbacks[CONTEXT_UID] || this.createGLTransformFeedback(transformFeedback);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
    }
    unbind() {
        const { gl: gl  } = this;
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
    }
    beginTransformFeedback(drawMode, shader) {
        const { gl: gl , renderer: renderer  } = this;
        if (shader) renderer.shader.bind(shader);
        gl.beginTransformFeedback(drawMode);
    }
    endTransformFeedback() {
        const { gl: gl  } = this;
        gl.endTransformFeedback();
    }
    createGLTransformFeedback(tf) {
        const { gl: gl , renderer: renderer , CONTEXT_UID: CONTEXT_UID  } = this;
        const glTransformFeedback = gl.createTransformFeedback();
        tf._glTransformFeedbacks[CONTEXT_UID] = glTransformFeedback;
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
        for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            if (!buffer) continue;
            renderer.buffer.update(buffer);
            buffer._glBuffers[CONTEXT_UID].refCount++;
            gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, buffer._glBuffers[CONTEXT_UID].buffer || null);
        }
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        tf.disposeRunner.add(this);
        return glTransformFeedback;
    }
    disposeTransformFeedback(tf, contextLost) {
        const glTF = tf._glTransformFeedbacks[this.CONTEXT_UID];
        const gl = this.gl;
        tf.disposeRunner.remove(this);
        const bufferSystem = this.renderer.buffer;
        if (bufferSystem) for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            if (!buffer) continue;
            const buf = buffer._glBuffers[this.CONTEXT_UID];
            if (buf) {
                buf.refCount--;
                if (buf.refCount === 0 && !contextLost) bufferSystem.dispose(buffer, contextLost);
            }
        }
        if (!glTF) return;
        if (!contextLost) gl.deleteTransformFeedback(glTF);
        delete tf._glTransformFeedbacks[this.CONTEXT_UID];
    }
    destroy() {
        this.renderer = null;
    }
}
$c42839d5a3281933$export$82410eeab0646070.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "transformFeedback"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($c42839d5a3281933$export$82410eeab0646070);





class $6755ee9eebd00dbb$export$6f21c3d5af6602af {
    constructor(renderer){
        this.renderer = renderer;
    }
    init(options) {
        this.screen = new (0, $340a428aa13511cc$export$4617fb02663045ef)(0, 0, options.width, options.height);
        this.element = options.view || (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
        this.resolution = options.resolution || (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
        this.autoDensity = !!options.autoDensity;
    }
    resizeView(desiredScreenWidth, desiredScreenHeight) {
        this.element.width = Math.round(desiredScreenWidth * this.resolution);
        this.element.height = Math.round(desiredScreenHeight * this.resolution);
        const screenWidth = this.element.width / this.resolution;
        const screenHeight = this.element.height / this.resolution;
        this.screen.width = screenWidth;
        this.screen.height = screenHeight;
        if (this.autoDensity) {
            this.element.style.width = `${screenWidth}px`;
            this.element.style.height = `${screenHeight}px`;
        }
        this.renderer.emit("resize", screenWidth, screenHeight);
        this.renderer.runners.resize.emit(this.screen.width, this.screen.height);
    }
    destroy(removeView) {
        if (removeView) this.element.parentNode?.removeChild(this.element);
        this.renderer = null;
        this.element = null;
        this.screen = null;
    }
}
$6755ee9eebd00dbb$export$6f21c3d5af6602af.defaultOptions = {
    width: 800,
    height: 600,
    resolution: (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION,
    autoDensity: false
};
$6755ee9eebd00dbb$export$6f21c3d5af6602af.extension = {
    type: [
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "_view"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($6755ee9eebd00dbb$export$6f21c3d5af6602af);










(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).PREFER_ENV = (0, $551209d754b5b429$export$83401e34d5e11bf4).WEBGL2;
(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE = false;
(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RENDER_OPTIONS = {
    ...(0, $2d30752d87b0cf51$export$fedaac80f6f9518c).defaultOptions,
    ...(0, $7443fcf12643cbe1$export$c69cd65c8827ac23).defaultOptions,
    ...(0, $6755ee9eebd00dbb$export$6f21c3d5af6602af).defaultOptions,
    ...(0, $e7a42a553978e370$export$8b298d2bda604a05).defaultOptions
};
Object.defineProperties((0, $fcbcf105ed644495$export$a5a6e0b888b2c992), {
    WRAP_MODE: {
        get () {
            return (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.wrapMode;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.WRAP_MODE is deprecated, use BaseTexture.defaultOptions.wrapMode");
            (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.wrapMode = value;
        }
    },
    SCALE_MODE: {
        get () {
            return (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.scaleMode;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.SCALE_MODE is deprecated, use BaseTexture.defaultOptions.scaleMode");
            (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.scaleMode = value;
        }
    },
    MIPMAP_TEXTURES: {
        get () {
            return (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.mipmap;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.MIPMAP_TEXTURES is deprecated, use BaseTexture.defaultOptions.mipmap");
            (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.mipmap = value;
        }
    },
    ANISOTROPIC_LEVEL: {
        get () {
            return (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.anisotropicLevel;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.ANISOTROPIC_LEVEL is deprecated, use BaseTexture.defaultOptions.anisotropicLevel");
            (0, $2d8d497fce3a4092$export$d6306e508f184154).defaultOptions.anisotropicLevel = value;
        }
    },
    FILTER_RESOLUTION: {
        get () {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.FILTER_RESOLUTION is deprecated, use Filter.defaultResolution");
            return (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea).defaultResolution;
        },
        set (value) {
            (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea).defaultResolution = value;
        }
    },
    FILTER_MULTISAMPLE: {
        get () {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.FILTER_MULTISAMPLE is deprecated, use Filter.defaultMultisample");
            return (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea).defaultMultisample;
        },
        set (value) {
            (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea).defaultMultisample = value;
        }
    },
    SPRITE_MAX_TEXTURES: {
        get () {
            return (0, $e9a7bfc7edf84428$export$c6a34b759a134e1d).defaultMaxTextures;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.SPRITE_MAX_TEXTURES is deprecated, use BatchRenderer.defaultMaxTextures");
            (0, $e9a7bfc7edf84428$export$c6a34b759a134e1d).defaultMaxTextures = value;
        }
    },
    SPRITE_BATCH_SIZE: {
        get () {
            return (0, $e9a7bfc7edf84428$export$c6a34b759a134e1d).defaultBatchSize;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.SPRITE_BATCH_SIZE is deprecated, use BatchRenderer.defaultBatchSize");
            (0, $e9a7bfc7edf84428$export$c6a34b759a134e1d).defaultBatchSize = value;
        }
    },
    CAN_UPLOAD_SAME_BUFFER: {
        get () {
            return (0, $e9a7bfc7edf84428$export$c6a34b759a134e1d).canUploadSameBuffer;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.CAN_UPLOAD_SAME_BUFFER is deprecated, use BatchRenderer.canUploadSameBuffer");
            (0, $e9a7bfc7edf84428$export$c6a34b759a134e1d).canUploadSameBuffer = value;
        }
    },
    GC_MODE: {
        get () {
            return (0, $e0f99544b0c3a894$export$a47b032752d8e393).defaultMode;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.GC_MODE is deprecated, use TextureGCSystem.defaultMode");
            (0, $e0f99544b0c3a894$export$a47b032752d8e393).defaultMode = value;
        }
    },
    GC_MAX_IDLE: {
        get () {
            return (0, $e0f99544b0c3a894$export$a47b032752d8e393).defaultMaxIdle;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.GC_MAX_IDLE is deprecated, use TextureGCSystem.defaultMaxIdle");
            (0, $e0f99544b0c3a894$export$a47b032752d8e393).defaultMaxIdle = value;
        }
    },
    GC_MAX_CHECK_COUNT: {
        get () {
            return (0, $e0f99544b0c3a894$export$a47b032752d8e393).defaultCheckCountMax;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.GC_MAX_CHECK_COUNT is deprecated, use TextureGCSystem.defaultCheckCountMax");
            (0, $e0f99544b0c3a894$export$a47b032752d8e393).defaultCheckCountMax = value;
        }
    },
    PRECISION_VERTEX: {
        get () {
            return (0, $52e5734958fc1bae$export$b6c59b989905b650).defaultVertexPrecision;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.PRECISION_VERTEX is deprecated, use Program.defaultVertexPrecision");
            (0, $52e5734958fc1bae$export$b6c59b989905b650).defaultVertexPrecision = value;
        }
    },
    PRECISION_FRAGMENT: {
        get () {
            return (0, $52e5734958fc1bae$export$b6c59b989905b650).defaultFragmentPrecision;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.PRECISION_FRAGMENT is deprecated, use Program.defaultFragmentPrecision");
            (0, $52e5734958fc1bae$export$b6c59b989905b650).defaultFragmentPrecision = value;
        }
    }
});










var $bc7ed83ac944008c$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($bc7ed83ac944008c$export$688aaf132ba9b379 || {});


class $fd623a44f80dcf2b$export$579021a5759a260f {
    constructor(fn, context = null, priority = 0, once = false){
        this.next = null;
        this.previous = null;
        this._destroyed = false;
        this.fn = fn;
        this.context = context;
        this.priority = priority;
        this.once = once;
    }
    match(fn, context = null) {
        return this.fn === fn && this.context === context;
    }
    emit(deltaTime) {
        if (this.fn) {
            if (this.context) this.fn.call(this.context, deltaTime);
            else this.fn(deltaTime);
        }
        const redirect = this.next;
        if (this.once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    destroy(hard = false) {
        this._destroyed = true;
        this.fn = null;
        this.context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}


const $ad2665272528cf94$var$_Ticker = class {
    constructor(){
        this.autoStart = false;
        this.deltaTime = 1;
        this.lastTime = -1;
        this.speed = 1;
        this.started = false;
        this._requestId = null;
        this._maxElapsedMS = 100;
        this._minElapsedMS = 0;
        this._protected = false;
        this._lastFrame = -1;
        this._head = new (0, $fd623a44f80dcf2b$export$579021a5759a260f)(null, null, Infinity);
        this.deltaMS = 1 / $ad2665272528cf94$var$_Ticker.targetFPMS;
        this.elapsedMS = 1 / $ad2665272528cf94$var$_Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    add(fn, context, priority = (0, $bc7ed83ac944008c$export$688aaf132ba9b379).NORMAL) {
        return this._addListener(new (0, $fd623a44f80dcf2b$export$579021a5759a260f)(fn, context, priority));
    }
    addOnce(fn, context, priority = (0, $bc7ed83ac944008c$export$688aaf132ba9b379).NORMAL) {
        return this._addListener(new (0, $fd623a44f80dcf2b$export$579021a5759a260f)(fn, context, priority, true));
    }
    _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * $ad2665272528cf94$var$_Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this.deltaTime);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    get FPS() {
        return 1e3 / this.elapsedMS;
    }
    get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps);
        const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, $ad2665272528cf94$var$_Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    static get shared() {
        if (!$ad2665272528cf94$var$_Ticker._shared) {
            const shared = $ad2665272528cf94$var$_Ticker._shared = new $ad2665272528cf94$var$_Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return $ad2665272528cf94$var$_Ticker._shared;
    }
    static get system() {
        if (!$ad2665272528cf94$var$_Ticker._system) {
            const system = $ad2665272528cf94$var$_Ticker._system = new $ad2665272528cf94$var$_Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return $ad2665272528cf94$var$_Ticker._system;
    }
};
let $ad2665272528cf94$export$39c54bcc89dcee11 = $ad2665272528cf94$var$_Ticker;
$ad2665272528cf94$export$39c54bcc89dcee11.targetFPMS = 0.06;


Object.defineProperties((0, $fcbcf105ed644495$export$a5a6e0b888b2c992), {
    TARGET_FPMS: {
        get () {
            return (0, $ad2665272528cf94$export$39c54bcc89dcee11).targetFPMS;
        },
        set (value) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.1.0", "settings.TARGET_FPMS is deprecated, use Ticker.targetFPMS");
            (0, $ad2665272528cf94$export$39c54bcc89dcee11).targetFPMS = value;
        }
    }
});







class $32faba04e5b02ede$export$50c361ceb4e2f4f0 {
    static init(options) {
        options = Object.assign({
            autoStart: true,
            sharedTicker: false
        }, options);
        Object.defineProperty(this, "ticker", {
            set (ticker) {
                if (this._ticker) this._ticker.remove(this.render, this);
                this._ticker = ticker;
                if (ticker) ticker.add(this.render, this, (0, $bc7ed83ac944008c$export$688aaf132ba9b379).LOW);
            },
            get () {
                return this._ticker;
            }
        });
        this.stop = ()=>{
            this._ticker.stop();
        };
        this.start = ()=>{
            this._ticker.start();
        };
        this._ticker = null;
        this.ticker = options.sharedTicker ? (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared : new (0, $ad2665272528cf94$export$39c54bcc89dcee11)();
        if (options.autoStart) this.start();
    }
    static destroy() {
        if (this._ticker) {
            const oldTicker = this._ticker;
            this.ticker = null;
            oldTicker.destroy();
        }
    }
}
$32faba04e5b02ede$export$50c361ceb4e2f4f0.extension = (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).Application;
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($32faba04e5b02ede$export$50c361ceb4e2f4f0);






const $562052ee832f105e$var$renderers = [];
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).handleByList((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).Renderer, $562052ee832f105e$var$renderers);
function $562052ee832f105e$export$3583b92ab8150eb6(options) {
    for (const RendererType of $562052ee832f105e$var$renderers){
        if (RendererType.test(options)) return new RendererType(options);
    }
    throw new Error("Unable to auto-detect a suitable renderer.");
}

















var $e9803c9da8f9caa2$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}";


var $8b8bf32bdd5568e5$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";


const $bf6b256f229604e1$export$4a1a95006fc6b0f1 = (0, $e9803c9da8f9caa2$export$2e2bcd8739ae039);
const $bf6b256f229604e1$export$198627d10d1d088f = (0, $8b8bf32bdd5568e5$export$2e2bcd8739ae039);







class $daced018becfbfdd$export$714ab7ecf6d70c30 {
    constructor(renderer){
        this.renderer = renderer;
    }
    contextChange(gl) {
        let samples;
        if (this.renderer.context.webGLVersion === 1) {
            const framebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            samples = gl.getParameter(gl.SAMPLES);
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        } else {
            const framebuffer = gl.getParameter(gl.DRAW_FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            samples = gl.getParameter(gl.SAMPLES);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, framebuffer);
        }
        if (samples >= (0, $551209d754b5b429$export$1eadd657d5acc2f2).HIGH) this.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).HIGH;
        else if (samples >= (0, $551209d754b5b429$export$1eadd657d5acc2f2).MEDIUM) this.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).MEDIUM;
        else if (samples >= (0, $551209d754b5b429$export$1eadd657d5acc2f2).LOW) this.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).LOW;
        else this.multisample = (0, $551209d754b5b429$export$1eadd657d5acc2f2).NONE;
    }
    destroy() {}
}
$daced018becfbfdd$export$714ab7ecf6d70c30.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "_multisample"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($daced018becfbfdd$export$714ab7ecf6d70c30);





class $43ed1bca3de125db$export$5185dfb57661e267 {
    constructor(buffer){
        this.buffer = buffer || null;
        this.updateID = -1;
        this.byteLength = -1;
        this.refCount = 0;
    }
}


class $e3b730536031b0e1$export$4010e50dab7d72d0 {
    constructor(renderer){
        this.renderer = renderer;
        this.managedBuffers = {};
        this.boundBufferBases = {};
    }
    destroy() {
        this.renderer = null;
    }
    contextChange() {
        this.disposeAll(true);
        this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    bind(buffer) {
        const { gl: gl , CONTEXT_UID: CONTEXT_UID  } = this;
        const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBuffer(buffer.type, glBuffer.buffer);
    }
    unbind(type) {
        const { gl: gl  } = this;
        gl.bindBuffer(type, null);
    }
    bindBufferBase(buffer, index) {
        const { gl: gl , CONTEXT_UID: CONTEXT_UID  } = this;
        if (this.boundBufferBases[index] !== buffer) {
            const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
            this.boundBufferBases[index] = buffer;
            gl.bindBufferBase(gl.UNIFORM_BUFFER, index, glBuffer.buffer);
        }
    }
    bindBufferRange(buffer, index, offset) {
        const { gl: gl , CONTEXT_UID: CONTEXT_UID  } = this;
        offset = offset || 0;
        const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBufferRange(gl.UNIFORM_BUFFER, index || 0, glBuffer.buffer, offset * 256, 256);
    }
    update(buffer) {
        const { gl: gl , CONTEXT_UID: CONTEXT_UID  } = this;
        const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        if (buffer._updateID === glBuffer.updateID) return;
        glBuffer.updateID = buffer._updateID;
        gl.bindBuffer(buffer.type, glBuffer.buffer);
        if (glBuffer.byteLength >= buffer.data.byteLength) gl.bufferSubData(buffer.type, 0, buffer.data);
        else {
            const drawType = buffer.static ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
            glBuffer.byteLength = buffer.data.byteLength;
            gl.bufferData(buffer.type, buffer.data, drawType);
        }
    }
    dispose(buffer, contextLost) {
        if (!this.managedBuffers[buffer.id]) return;
        delete this.managedBuffers[buffer.id];
        const glBuffer = buffer._glBuffers[this.CONTEXT_UID];
        const gl = this.gl;
        buffer.disposeRunner.remove(this);
        if (!glBuffer) return;
        if (!contextLost) gl.deleteBuffer(glBuffer.buffer);
        delete buffer._glBuffers[this.CONTEXT_UID];
    }
    disposeAll(contextLost) {
        const all = Object.keys(this.managedBuffers);
        for(let i = 0; i < all.length; i++)this.dispose(this.managedBuffers[all[i]], contextLost);
    }
    createGLBuffer(buffer) {
        const { CONTEXT_UID: CONTEXT_UID , gl: gl  } = this;
        buffer._glBuffers[CONTEXT_UID] = new (0, $43ed1bca3de125db$export$5185dfb57661e267)(gl.createBuffer());
        this.managedBuffers[buffer.id] = buffer;
        buffer.disposeRunner.add(this);
        return buffer._glBuffers[CONTEXT_UID];
    }
}
$e3b730536031b0e1$export$4010e50dab7d72d0.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "buffer"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($e3b730536031b0e1$export$4010e50dab7d72d0);














class $94f9cba4ce7df9fc$export$50cc3c4d71ad3547 {
    constructor(renderer){
        this.renderer = renderer;
    }
    render(displayObject, options) {
        const renderer = this.renderer;
        let renderTexture;
        let clear;
        let transform;
        let skipUpdateTransform;
        if (options) {
            renderTexture = options.renderTexture;
            clear = options.clear;
            transform = options.transform;
            skipUpdateTransform = options.skipUpdateTransform;
        }
        this.renderingToScreen = !renderTexture;
        renderer.runners.prerender.emit();
        renderer.emit("prerender");
        renderer.projection.transform = transform;
        if (renderer.context.isLost) return;
        if (!renderTexture) this.lastObjectRendered = displayObject;
        if (!skipUpdateTransform) {
            const cacheParent = displayObject.enableTempParent();
            displayObject.updateTransform();
            displayObject.disableTempParent(cacheParent);
        }
        renderer.renderTexture.bind(renderTexture);
        renderer.batch.currentRenderer.start();
        if (clear ?? renderer.background.clearBeforeRender) renderer.renderTexture.clear();
        displayObject.render(renderer);
        renderer.batch.currentRenderer.flush();
        if (renderTexture) {
            if (options.blit) renderer.framebuffer.blit();
            renderTexture.baseTexture.update();
        }
        renderer.runners.postrender.emit();
        renderer.projection.transform = null;
        renderer.emit("postrender");
    }
    destroy() {
        this.renderer = null;
        this.lastObjectRendered = null;
    }
}
$94f9cba4ce7df9fc$export$50cc3c4d71ad3547.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
    name: "objectRenderer"
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($94f9cba4ce7df9fc$export$50cc3c4d71ad3547);









const $985e2622e576b51b$var$_Renderer = class extends (0, $64ffa2d81765c4cc$export$a12e67a4b4590901) {
    constructor(options){
        super();
        this.type = (0, $551209d754b5b429$export$747c566515e2a1d9).WEBGL;
        options = Object.assign({}, (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RENDER_OPTIONS, options);
        this.gl = null;
        this.CONTEXT_UID = 0;
        this.globalUniforms = new (0, $d21ea31dd94e9628$export$6601a7a2dcf79bf5)({
            projectionMatrix: new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)()
        }, true);
        const systemConfig = {
            runners: [
                "init",
                "destroy",
                "contextChange",
                "resolutionChange",
                "reset",
                "update",
                "postrender",
                "prerender",
                "resize"
            ],
            systems: $985e2622e576b51b$var$_Renderer.__systems,
            priority: [
                "_view",
                "textureGenerator",
                "background",
                "_plugin",
                "startup",
                "context",
                "state",
                "texture",
                "buffer",
                "geometry",
                "framebuffer",
                "transformFeedback",
                "mask",
                "scissor",
                "stencil",
                "projection",
                "textureGC",
                "filter",
                "renderTexture",
                "batch",
                "objectRenderer",
                "_multisample"
            ]
        };
        this.setup(systemConfig);
        if ("useContextAlpha" in options) {
            (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "options.useContextAlpha is deprecated, use options.premultipliedAlpha and options.backgroundAlpha instead");
            options.premultipliedAlpha = options.useContextAlpha && options.useContextAlpha !== "notMultiplied";
            options.backgroundAlpha = options.useContextAlpha === false ? 1 : options.backgroundAlpha;
        }
        this._plugin.rendererPlugins = $985e2622e576b51b$var$_Renderer.__plugins;
        this.options = options;
        this.startup.run(this.options);
    }
    static test(options) {
        if (options?.forceCanvas) return false;
        return (0, $cd44038b470b5fa0$export$83dc396b76015322)();
    }
    render(displayObject, options) {
        this.objectRenderer.render(displayObject, options);
    }
    resize(desiredScreenWidth, desiredScreenHeight) {
        this._view.resizeView(desiredScreenWidth, desiredScreenHeight);
    }
    reset() {
        this.runners.reset.emit();
        return this;
    }
    clear() {
        this.renderTexture.bind();
        this.renderTexture.clear();
    }
    destroy(removeView = false) {
        this.runners.destroy.items.reverse();
        this.emitWithCustomOptions(this.runners.destroy, {
            _view: removeView
        });
        super.destroy();
    }
    get plugins() {
        return this._plugin.plugins;
    }
    get multisample() {
        return this._multisample.multisample;
    }
    get width() {
        return this._view.element.width;
    }
    get height() {
        return this._view.element.height;
    }
    get resolution() {
        return this._view.resolution;
    }
    set resolution(value) {
        this._view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    get autoDensity() {
        return this._view.autoDensity;
    }
    get view() {
        return this._view.element;
    }
    get screen() {
        return this._view.screen;
    }
    get lastObjectRendered() {
        return this.objectRenderer.lastObjectRendered;
    }
    get renderingToScreen() {
        return this.objectRenderer.renderingToScreen;
    }
    get rendererLogId() {
        return `WebGL ${this.context.webGLVersion}`;
    }
    get clearBeforeRender() {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.clearBeforeRender has been deprecated, please use renderer.background.clearBeforeRender instead.");
        return this.background.clearBeforeRender;
    }
    get useContextAlpha() {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.useContextAlpha has been deprecated, please use renderer.context.premultipliedAlpha instead.");
        return this.context.useContextAlpha;
    }
    get preserveDrawingBuffer() {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.preserveDrawingBuffer has been deprecated, we cannot truly know this unless pixi created the context");
        return this.context.preserveDrawingBuffer;
    }
    get backgroundColor() {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead.");
        return this.background.color;
    }
    set backgroundColor(value) {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead.");
        this.background.color = value;
    }
    get backgroundAlpha() {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead.");
        return this.background.alpha;
    }
    set backgroundAlpha(value) {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead.");
        this.background.alpha = value;
    }
    get powerPreference() {
        (0, $5d432cd6d6627298$export$afd31d834b512e89)("7.0.0", "renderer.powerPreference has been deprecated, we can only know this if pixi creates the context");
        return this.context.powerPreference;
    }
    generateTexture(displayObject, options) {
        return this.textureGenerator.generateTexture(displayObject, options);
    }
};
let $985e2622e576b51b$export$88530751e3977073 = $985e2622e576b51b$var$_Renderer;
$985e2622e576b51b$export$88530751e3977073.extension = {
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).Renderer,
    priority: 1
};
$985e2622e576b51b$export$88530751e3977073.__plugins = {};
$985e2622e576b51b$export$88530751e3977073.__systems = {};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).handleByMap((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererPlugin, $985e2622e576b51b$export$88530751e3977073.__plugins);
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).handleByMap((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem, $985e2622e576b51b$export$88530751e3977073.__systems);
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($985e2622e576b51b$export$88530751e3977073);






























class $d45090b58c98cadf$export$195275694901de82 extends (0, $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63) {
    constructor(length, options){
        const { width: width , height: height  } = options || {};
        super(width, height);
        this.items = [];
        this.itemDirtyIds = [];
        for(let i = 0; i < length; i++){
            const partTexture = new (0, $2d8d497fce3a4092$export$d6306e508f184154)();
            this.items.push(partTexture);
            this.itemDirtyIds.push(-2);
        }
        this.length = length;
        this._load = null;
        this.baseTexture = null;
    }
    initFromArray(resources, options) {
        for(let i = 0; i < this.length; i++){
            if (!resources[i]) continue;
            if (resources[i].castToBaseTexture) this.addBaseTextureAt(resources[i].castToBaseTexture(), i);
            else if (resources[i] instanceof (0, $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63)) this.addResourceAt(resources[i], i);
            else this.addResourceAt((0, $992246b926b958eb$export$5eb9e949a7ff46a7)(resources[i], options), i);
        }
    }
    dispose() {
        for(let i = 0, len = this.length; i < len; i++)this.items[i].destroy();
        this.items = null;
        this.itemDirtyIds = null;
        this._load = null;
    }
    addResourceAt(resource, index) {
        if (!this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        if (resource.valid && !this.valid) this.resize(resource.width, resource.height);
        this.items[index].setResource(resource);
        return this;
    }
    bind(baseTexture) {
        if (this.baseTexture !== null) throw new Error("Only one base texture per TextureArray is allowed");
        super.bind(baseTexture);
        for(let i = 0; i < this.length; i++){
            this.items[i].parentTextureArray = baseTexture;
            this.items[i].on("update", baseTexture.update, baseTexture);
        }
    }
    unbind(baseTexture) {
        super.unbind(baseTexture);
        for(let i = 0; i < this.length; i++){
            this.items[i].parentTextureArray = null;
            this.items[i].off("update", baseTexture.update, baseTexture);
        }
    }
    load() {
        if (this._load) return this._load;
        const resources = this.items.map((item)=>item.resource).filter((item)=>item);
        const promises = resources.map((item)=>item.load());
        this._load = Promise.all(promises).then(()=>{
            const { realWidth: realWidth , realHeight: realHeight  } = this.items[0];
            this.resize(realWidth, realHeight);
            return Promise.resolve(this);
        });
        return this._load;
    }
}


class $5f43ecabe92b03ae$export$aa0af7255ee278f1 extends (0, $d45090b58c98cadf$export$195275694901de82) {
    constructor(source, options){
        const { width: width , height: height  } = options || {};
        let urls;
        let length;
        if (Array.isArray(source)) {
            urls = source;
            length = source.length;
        } else length = source;
        super(length, {
            width: width,
            height: height
        });
        if (urls) this.initFromArray(urls, options);
    }
    addBaseTextureAt(baseTexture, index) {
        if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
        else throw new Error("ArrayResource does not support RenderTexture");
        return this;
    }
    bind(baseTexture) {
        super.bind(baseTexture);
        baseTexture.target = (0, $551209d754b5b429$export$d1ff3caf57547dc5).TEXTURE_2D_ARRAY;
    }
    upload(renderer, texture, glTexture) {
        const { length: length , itemDirtyIds: itemDirtyIds , items: items  } = this;
        const { gl: gl  } = renderer;
        if (glTexture.dirtyId < 0) gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, this._width, this._height, length, 0, texture.format, glTexture.type, null);
        for(let i = 0; i < length; i++){
            const item = items[i];
            if (itemDirtyIds[i] < item.dirtyId) {
                itemDirtyIds[i] = item.dirtyId;
                if (item.valid) gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, i, item.resource.width, item.resource.height, 1, texture.format, glTexture.type, item.resource.source);
            }
        }
        return true;
    }
}





class $26a888edbd80a69d$export$3bea879ce3e5cb51 extends (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6) {
    constructor(source){
        super(source);
    }
    static test(source) {
        const { OffscreenCanvas: OffscreenCanvas  } = globalThis;
        if (OffscreenCanvas && source instanceof OffscreenCanvas) return true;
        return globalThis.HTMLCanvasElement && source instanceof HTMLCanvasElement;
    }
}




const $4679a086338ac699$var$_CubeResource = class extends (0, $d45090b58c98cadf$export$195275694901de82) {
    constructor(source, options){
        const { width: width , height: height , autoLoad: autoLoad , linkBaseTexture: linkBaseTexture  } = options || {};
        if (source && source.length !== $4679a086338ac699$var$_CubeResource.SIDES) throw new Error(`Invalid length. Got ${source.length}, expected 6`);
        super(6, {
            width: width,
            height: height
        });
        for(let i = 0; i < $4679a086338ac699$var$_CubeResource.SIDES; i++)this.items[i].target = (0, $551209d754b5b429$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP_POSITIVE_X + i;
        this.linkBaseTexture = linkBaseTexture !== false;
        if (source) this.initFromArray(source, options);
        if (autoLoad !== false) this.load();
    }
    bind(baseTexture) {
        super.bind(baseTexture);
        baseTexture.target = (0, $551209d754b5b429$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP;
    }
    addBaseTextureAt(baseTexture, index, linkBaseTexture) {
        if (linkBaseTexture === void 0) linkBaseTexture = this.linkBaseTexture;
        if (!this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        if (!this.linkBaseTexture || baseTexture.parentTextureArray || Object.keys(baseTexture._glTextures).length > 0) {
            if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
            else throw new Error(`CubeResource does not support copying of renderTexture.`);
        } else {
            baseTexture.target = (0, $551209d754b5b429$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP_POSITIVE_X + index;
            baseTexture.parentTextureArray = this.baseTexture;
            this.items[index] = baseTexture;
        }
        if (baseTexture.valid && !this.valid) this.resize(baseTexture.realWidth, baseTexture.realHeight);
        this.items[index] = baseTexture;
        return this;
    }
    upload(renderer, _baseTexture, glTexture) {
        const dirty = this.itemDirtyIds;
        for(let i = 0; i < $4679a086338ac699$var$_CubeResource.SIDES; i++){
            const side = this.items[i];
            if (dirty[i] < side.dirtyId || glTexture.dirtyId < _baseTexture.dirtyId) {
                if (side.valid && side.resource) {
                    side.resource.upload(renderer, side, glTexture);
                    dirty[i] = side.dirtyId;
                } else if (dirty[i] < -1) {
                    renderer.gl.texImage2D(side.target, 0, glTexture.internalFormat, _baseTexture.realWidth, _baseTexture.realHeight, 0, _baseTexture.format, glTexture.type, null);
                    dirty[i] = -1;
                }
            }
        }
        return true;
    }
    static test(source) {
        return Array.isArray(source) && source.length === $4679a086338ac699$var$_CubeResource.SIDES;
    }
};
let $4679a086338ac699$export$c786bc8247db64cb = $4679a086338ac699$var$_CubeResource;
$4679a086338ac699$export$c786bc8247db64cb.SIDES = 6;





class $cc1514b15a03e989$export$422084391f3a58a3 extends (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6) {
    constructor(source, options){
        options = options || {};
        let baseSource;
        let url;
        if (typeof source === "string") {
            baseSource = $cc1514b15a03e989$export$422084391f3a58a3.EMPTY;
            url = source;
        } else {
            baseSource = source;
            url = null;
        }
        super(baseSource);
        this.url = url;
        this.crossOrigin = options.crossOrigin ?? true;
        this.alphaMode = typeof options.alphaMode === "number" ? options.alphaMode : null;
        this._load = null;
        if (options.autoLoad !== false) this.load();
    }
    load() {
        if (this._load) return this._load;
        this._load = new Promise(async (resolve, reject)=>{
            if (this.url === null) {
                resolve(this);
                return;
            }
            try {
                const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(this.url, {
                    mode: this.crossOrigin ? "cors" : "no-cors"
                });
                if (this.destroyed) return;
                const imageBlob = await response.blob();
                if (this.destroyed) return;
                const imageBitmap = await createImageBitmap(imageBlob, {
                    premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $551209d754b5b429$export$d56550d454401b73).UNPACK ? "premultiply" : "none"
                });
                if (this.destroyed) return;
                this.source = imageBitmap;
                this.update();
                resolve(this);
            } catch (e) {
                if (this.destroyed) return;
                reject(e);
                this.onError.emit(e);
            }
        });
        return this._load;
    }
    upload(renderer, baseTexture, glTexture) {
        if (!(this.source instanceof ImageBitmap)) {
            this.load();
            return false;
        }
        if (typeof this.alphaMode === "number") baseTexture.alphaMode = this.alphaMode;
        return super.upload(renderer, baseTexture, glTexture);
    }
    dispose() {
        if (this.source instanceof ImageBitmap) this.source.close();
        super.dispose();
        this._load = null;
    }
    static test(source) {
        return !!globalThis.createImageBitmap && typeof ImageBitmap !== "undefined" && (typeof source === "string" || source instanceof ImageBitmap);
    }
    static get EMPTY() {
        $cc1514b15a03e989$export$422084391f3a58a3._EMPTY = $cc1514b15a03e989$export$422084391f3a58a3._EMPTY ?? (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas(0, 0);
        return $cc1514b15a03e989$export$422084391f3a58a3._EMPTY;
    }
}






const $e1c52b915095bad3$var$_SVGResource = class extends (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6) {
    constructor(sourceBase64, options){
        options = options || {};
        super((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas());
        this._width = 0;
        this._height = 0;
        this.svg = sourceBase64;
        this.scale = options.scale || 1;
        this._overrideWidth = options.width;
        this._overrideHeight = options.height;
        this._resolve = null;
        this._crossorigin = options.crossorigin;
        this._load = null;
        if (options.autoLoad !== false) this.load();
    }
    load() {
        if (this._load) return this._load;
        this._load = new Promise((resolve)=>{
            this._resolve = ()=>{
                this.resize(this.source.width, this.source.height);
                resolve(this);
            };
            if ($e1c52b915095bad3$var$_SVGResource.SVG_XML.test(this.svg.trim())) {
                if (!btoa) throw new Error("Your browser doesn't support base64 conversions.");
                this.svg = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(this.svg)))}`;
            }
            this._loadSvg();
        });
        return this._load;
    }
    _loadSvg() {
        const tempImage = new Image();
        (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6).crossOrigin(tempImage, this.svg, this._crossorigin);
        tempImage.src = this.svg;
        tempImage.onerror = (event)=>{
            if (!this._resolve) return;
            tempImage.onerror = null;
            this.onError.emit(event);
        };
        tempImage.onload = ()=>{
            if (!this._resolve) return;
            const svgWidth = tempImage.width;
            const svgHeight = tempImage.height;
            if (!svgWidth || !svgHeight) throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
            let width = svgWidth * this.scale;
            let height = svgHeight * this.scale;
            if (this._overrideWidth || this._overrideHeight) {
                width = this._overrideWidth || this._overrideHeight / svgHeight * svgWidth;
                height = this._overrideHeight || this._overrideWidth / svgWidth * svgHeight;
            }
            width = Math.round(width);
            height = Math.round(height);
            const canvas = this.source;
            canvas.width = width;
            canvas.height = height;
            canvas._pixiId = `canvas_${(0, $a8272ede630bda06$export$e2a22331486dcca0)()}`;
            canvas.getContext("2d").drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height);
            this._resolve();
            this._resolve = null;
        };
    }
    static getSize(svgString) {
        const sizeMatch = $e1c52b915095bad3$var$_SVGResource.SVG_SIZE.exec(svgString);
        const size = {};
        if (sizeMatch) {
            size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
            size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
        }
        return size;
    }
    dispose() {
        super.dispose();
        this._resolve = null;
        this._crossorigin = null;
    }
    static test(source, extension) {
        return extension === "svg" || typeof source === "string" && source.startsWith("data:image/svg+xml") || typeof source === "string" && $e1c52b915095bad3$var$_SVGResource.SVG_XML.test(source);
    }
};
let $e1c52b915095bad3$export$aeb8ac9a3d5d46a0 = $e1c52b915095bad3$var$_SVGResource;
$e1c52b915095bad3$export$aeb8ac9a3d5d46a0.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m;
$e1c52b915095bad3$export$aeb8ac9a3d5d46a0.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i;




const $fad0aab3ecec357f$var$_VideoResource = class extends (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6) {
    constructor(source, options){
        options = options || {};
        if (!(source instanceof HTMLVideoElement)) {
            const videoElement = document.createElement("video");
            videoElement.setAttribute("preload", "auto");
            videoElement.setAttribute("webkit-playsinline", "");
            videoElement.setAttribute("playsinline", "");
            if (typeof source === "string") source = [
                source
            ];
            const firstSrc = source[0].src || source[0];
            (0, $9909c4093f866353$export$c87b2a1e7e3bb4a6).crossOrigin(videoElement, firstSrc, options.crossorigin);
            for(let i = 0; i < source.length; ++i){
                const sourceElement = document.createElement("source");
                let { src: src , mime: mime  } = source[i];
                src = src || source[i];
                const baseSrc = src.split("?").shift().toLowerCase();
                const ext = baseSrc.slice(baseSrc.lastIndexOf(".") + 1);
                mime = mime || $fad0aab3ecec357f$var$_VideoResource.MIME_TYPES[ext] || `video/${ext}`;
                sourceElement.src = src;
                sourceElement.type = mime;
                videoElement.appendChild(sourceElement);
            }
            source = videoElement;
        }
        super(source);
        this.noSubImage = true;
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this._load = null;
        this._resolve = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onError = this._onError.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    update(_deltaTime = 0) {
        if (!this.destroyed) {
            const elapsedMS = (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.elapsedMS * this.source.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
            if (!this._updateFPS || this._msToNextUpdate <= 0) {
                super.update();
                this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
            }
        }
    }
    load() {
        if (this._load) return this._load;
        const source = this.source;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart.bind(this));
        source.addEventListener("pause", this._onPlayStop.bind(this));
        if (!this._isSourceReady()) {
            source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlay);
            source.addEventListener("error", this._onError, true);
        } else this._onCanPlay();
        this._load = new Promise((resolve)=>{
            if (this.valid) resolve(this);
            else {
                this._resolve = resolve;
                source.load();
            }
        });
        return this._load;
    }
    _onError(event) {
        this.source.removeEventListener("error", this._onError, true);
        this.onError.emit(event);
    }
    _isSourcePlaying() {
        const source = this.source;
        return !source.paused && !source.ended && this._isSourceReady();
    }
    _isSourceReady() {
        const source = this.source;
        return source.readyState > 2;
    }
    _onPlayStart() {
        if (!this.valid) this._onCanPlay();
        if (this.autoUpdate && !this._isConnectedToTicker) {
            (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.add(this.update, this);
            this._isConnectedToTicker = true;
        }
    }
    _onPlayStop() {
        if (this._isConnectedToTicker) {
            (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    }
    _onCanPlay() {
        const source = this.source;
        source.removeEventListener("canplay", this._onCanPlay);
        source.removeEventListener("canplaythrough", this._onCanPlay);
        const valid = this.valid;
        this.resize(source.videoWidth, source.videoHeight);
        if (!valid && this._resolve) {
            this._resolve(this);
            this._resolve = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) source.play();
    }
    dispose() {
        if (this._isConnectedToTicker) {
            (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
        const source = this.source;
        if (source) {
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.dispose();
    }
    get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            if (!this._autoUpdate && this._isConnectedToTicker) {
                (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.remove(this.update, this);
                this._isConnectedToTicker = false;
            } else if (this._autoUpdate && !this._isConnectedToTicker && this._isSourcePlaying()) {
                (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.add(this.update, this);
                this._isConnectedToTicker = true;
            }
        }
    }
    get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) this._updateFPS = value;
    }
    static test(source, extension) {
        return globalThis.HTMLVideoElement && source instanceof HTMLVideoElement || $fad0aab3ecec357f$var$_VideoResource.TYPES.includes(extension);
    }
};
let $fad0aab3ecec357f$export$f7dd53bb53e9c0d7 = $fad0aab3ecec357f$var$_VideoResource;
$fad0aab3ecec357f$export$f7dd53bb53e9c0d7.TYPES = [
    "mp4",
    "m4v",
    "webm",
    "ogg",
    "ogv",
    "h264",
    "avi",
    "mov"
];
$fad0aab3ecec357f$export$f7dd53bb53e9c0d7.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};





(0, $992246b926b958eb$export$7db5d8a07d9761e1).push((0, $cc1514b15a03e989$export$422084391f3a58a3), (0, $8d0497df0f10e502$export$6d0d25e6e731a9a2), (0, $26a888edbd80a69d$export$3bea879ce3e5cb51), (0, $fad0aab3ecec357f$export$f7dd53bb53e9c0d7), (0, $e1c52b915095bad3$export$aeb8ac9a3d5d46a0), (0, $ad9971bad38b5f89$export$a79ef781de624449), (0, $4679a086338ac699$export$c786bc8247db64cb), (0, $5f43ecabe92b03ae$export$aa0af7255ee278f1));








class $672d45308dd1e677$export$1f7c70f8d6979c19 {
    constructor(){
        this._glTransformFeedbacks = {};
        this.buffers = [];
        this.disposeRunner = new (0, $e008d4155c799e69$export$571ad3bcba5a0c45)("disposeTransformFeedback");
    }
    bindBuffer(index, buffer) {
        this.buffers[index] = buffer;
    }
    destroy() {
        this.disposeRunner.emit(this, false);
    }
}



















const $e870c5b5c5473fba$export$a4ad2735b021c132 = "7.2.4";






class $51558a611c79ce5a$export$c4e9d269599ab4b4 {
    constructor(){
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.rect = null;
        this.updateID = -1;
    }
    isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
    }
    getRectangle(rect) {
        if (this.minX > this.maxX || this.minY > this.maxY) return (0, $340a428aa13511cc$export$4617fb02663045ef).EMPTY;
        rect = rect || new (0, $340a428aa13511cc$export$4617fb02663045ef)(0, 0, 1, 1);
        rect.x = this.minX;
        rect.y = this.minY;
        rect.width = this.maxX - this.minX;
        rect.height = this.maxY - this.minY;
        return rect;
    }
    addPoint(point) {
        this.minX = Math.min(this.minX, point.x);
        this.maxX = Math.max(this.maxX, point.x);
        this.minY = Math.min(this.minY, point.y);
        this.maxY = Math.max(this.maxY, point.y);
    }
    addPointMatrix(matrix, point) {
        const { a: a , b: b , c: c , d: d , tx: tx , ty: ty  } = matrix;
        const x = a * point.x + c * point.y + tx;
        const y = b * point.x + d * point.y + ty;
        this.minX = Math.min(this.minX, x);
        this.maxX = Math.max(this.maxX, x);
        this.minY = Math.min(this.minY, y);
        this.maxY = Math.max(this.maxY, y);
    }
    addQuad(vertices) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = vertices[0];
        let y = vertices[1];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[2];
        y = vertices[3];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[4];
        y = vertices[5];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[6];
        y = vertices[7];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    addFrame(transform, x0, y0, x1, y1) {
        this.addFrameMatrix(transform.worldTransform, x0, y0, x1, y1);
    }
    addFrameMatrix(matrix, x0, y0, x1, y1) {
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    addVertexData(vertexData, beginOffset, endOffset) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const x = vertexData[i];
            const y = vertexData[i + 1];
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    addVertices(transform, vertices, beginOffset, endOffset) {
        this.addVerticesMatrix(transform.worldTransform, vertices, beginOffset, endOffset);
    }
    addVerticesMatrix(matrix, vertices, beginOffset, endOffset, padX = 0, padY = padX) {
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const rawX = vertices[i];
            const rawY = vertices[i + 1];
            const x = a * rawX + c * rawY + tx;
            const y = d * rawY + b * rawX + ty;
            minX = Math.min(minX, x - padX);
            maxX = Math.max(maxX, x + padX);
            minY = Math.min(minY, y - padY);
            maxY = Math.max(maxY, y + padY);
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    addBounds(bounds) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        this.minX = bounds.minX < minX ? bounds.minX : minX;
        this.minY = bounds.minY < minY ? bounds.minY : minY;
        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    }
    addBoundsMask(bounds, mask) {
        const _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
        const _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
        const _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
        const _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX;
            const minY = this.minY;
            const maxX = this.maxX;
            const maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    addBoundsMatrix(bounds, matrix) {
        this.addFrameMatrix(matrix, bounds.minX, bounds.minY, bounds.maxX, bounds.maxY);
    }
    addBoundsArea(bounds, area) {
        const _minX = bounds.minX > area.x ? bounds.minX : area.x;
        const _minY = bounds.minY > area.y ? bounds.minY : area.y;
        const _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
        const _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX;
            const minY = this.minY;
            const maxX = this.maxX;
            const maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    pad(paddingX = 0, paddingY = paddingX) {
        if (!this.isEmpty()) {
            this.minX -= paddingX;
            this.maxX += paddingX;
            this.minY -= paddingY;
            this.maxY += paddingY;
        }
    }
    addFramePad(x0, y0, x1, y1, padX, padY) {
        x0 -= padX;
        y0 -= padY;
        x1 += padX;
        y1 += padY;
        this.minX = this.minX < x0 ? this.minX : x0;
        this.maxX = this.maxX > x1 ? this.maxX : x1;
        this.minY = this.minY < y0 ? this.minY : y0;
        this.maxY = this.maxY > y1 ? this.maxY : y1;
    }
}


class $93bf10443ce4ab2c$export$1f679544f90d7d7c extends (0, $5d808cc4b6a3c326$exports).EventEmitter {
    constructor(){
        super();
        this.tempDisplayObjectParent = null;
        this.transform = new (0, $83f2cf09d03bb7ff$export$563a914cafbdc389)();
        this.alpha = 1;
        this.visible = true;
        this.renderable = true;
        this.cullable = false;
        this.cullArea = null;
        this.parent = null;
        this.worldAlpha = 1;
        this._lastSortedIndex = 0;
        this._zIndex = 0;
        this.filterArea = null;
        this.filters = null;
        this._enabledFilters = null;
        this._bounds = new (0, $51558a611c79ce5a$export$c4e9d269599ab4b4)();
        this._localBounds = null;
        this._boundsID = 0;
        this._boundsRect = null;
        this._localBoundsRect = null;
        this._mask = null;
        this._maskRefCount = 0;
        this._destroyed = false;
        this.isSprite = false;
        this.isMask = false;
    }
    static mixin(source) {
        const keys = Object.keys(source);
        for(let i = 0; i < keys.length; ++i){
            const propertyName = keys[i];
            Object.defineProperty($93bf10443ce4ab2c$export$1f679544f90d7d7c.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
        }
    }
    get destroyed() {
        return this._destroyed;
    }
    _recursivePostUpdateTransform() {
        if (this.parent) {
            this.parent._recursivePostUpdateTransform();
            this.transform.updateTransform(this.parent.transform);
        } else this.transform.updateTransform(this._tempDisplayObjectParent.transform);
    }
    updateTransform() {
        this._boundsID++;
        this.transform.updateTransform(this.parent.transform);
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
    }
    getBounds(skipUpdate, rect) {
        if (!skipUpdate) {
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.updateTransform();
                this.parent = null;
            } else {
                this._recursivePostUpdateTransform();
                this.updateTransform();
            }
        }
        if (this._bounds.updateID !== this._boundsID) {
            this.calculateBounds();
            this._bounds.updateID = this._boundsID;
        }
        if (!rect) {
            if (!this._boundsRect) this._boundsRect = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
            rect = this._boundsRect;
        }
        return this._bounds.getRectangle(rect);
    }
    getLocalBounds(rect) {
        if (!rect) {
            if (!this._localBoundsRect) this._localBoundsRect = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
            rect = this._localBoundsRect;
        }
        if (!this._localBounds) this._localBounds = new (0, $51558a611c79ce5a$export$c4e9d269599ab4b4)();
        const transformRef = this.transform;
        const parentRef = this.parent;
        this.parent = null;
        this.transform = this._tempDisplayObjectParent.transform;
        const worldBounds = this._bounds;
        const worldBoundsID = this._boundsID;
        this._bounds = this._localBounds;
        const bounds = this.getBounds(false, rect);
        this.parent = parentRef;
        this.transform = transformRef;
        this._bounds = worldBounds;
        this._bounds.updateID += this._boundsID - worldBoundsID;
        return bounds;
    }
    toGlobal(position, point, skipUpdate = false) {
        if (!skipUpdate) {
            this._recursivePostUpdateTransform();
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else this.displayObjectUpdateTransform();
        }
        return this.worldTransform.apply(position, point);
    }
    toLocal(position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        if (!skipUpdate) {
            this._recursivePostUpdateTransform();
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else this.displayObjectUpdateTransform();
        }
        return this.worldTransform.applyInverse(position, point);
    }
    setParent(container) {
        if (!container || !container.addChild) throw new Error("setParent: Argument must be a Container");
        container.addChild(this);
        return container;
    }
    removeFromParent() {
        this.parent?.removeChild(this);
    }
    setTransform(x = 0, y = 0, scaleX = 1, scaleY = 1, rotation = 0, skewX = 0, skewY = 0, pivotX = 0, pivotY = 0) {
        this.position.x = x;
        this.position.y = y;
        this.scale.x = !scaleX ? 1 : scaleX;
        this.scale.y = !scaleY ? 1 : scaleY;
        this.rotation = rotation;
        this.skew.x = skewX;
        this.skew.y = skewY;
        this.pivot.x = pivotX;
        this.pivot.y = pivotY;
        return this;
    }
    destroy(_options) {
        this.removeFromParent();
        this._destroyed = true;
        this.transform = null;
        this.parent = null;
        this._bounds = null;
        this.mask = null;
        this.cullArea = null;
        this.filters = null;
        this.filterArea = null;
        this.hitArea = null;
        this.eventMode = "auto";
        this.interactiveChildren = false;
        this.emit("destroyed");
        this.removeAllListeners();
    }
    get _tempDisplayObjectParent() {
        if (this.tempDisplayObjectParent === null) this.tempDisplayObjectParent = new $93bf10443ce4ab2c$export$a35515d77cade20d();
        return this.tempDisplayObjectParent;
    }
    enableTempParent() {
        const myParent = this.parent;
        this.parent = this._tempDisplayObjectParent;
        return myParent;
    }
    disableTempParent(cacheParent) {
        this.parent = cacheParent;
    }
    get x() {
        return this.position.x;
    }
    set x(value) {
        this.transform.position.x = value;
    }
    get y() {
        return this.position.y;
    }
    set y(value) {
        this.transform.position.y = value;
    }
    get worldTransform() {
        return this.transform.worldTransform;
    }
    get localTransform() {
        return this.transform.localTransform;
    }
    get position() {
        return this.transform.position;
    }
    set position(value) {
        this.transform.position.copyFrom(value);
    }
    get scale() {
        return this.transform.scale;
    }
    set scale(value) {
        this.transform.scale.copyFrom(value);
    }
    get pivot() {
        return this.transform.pivot;
    }
    set pivot(value) {
        this.transform.pivot.copyFrom(value);
    }
    get skew() {
        return this.transform.skew;
    }
    set skew(value) {
        this.transform.skew.copyFrom(value);
    }
    get rotation() {
        return this.transform.rotation;
    }
    set rotation(value) {
        this.transform.rotation = value;
    }
    get angle() {
        return this.transform.rotation * (0, $07142e085c72c7cc$export$3f91627dc85c5d57);
    }
    set angle(value) {
        this.transform.rotation = value * (0, $07142e085c72c7cc$export$870617f62e3187f1);
    }
    get zIndex() {
        return this._zIndex;
    }
    set zIndex(value) {
        this._zIndex = value;
        if (this.parent) this.parent.sortDirty = true;
    }
    get worldVisible() {
        let item = this;
        do {
            if (!item.visible) return false;
            item = item.parent;
        }while (item);
        return true;
    }
    get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask === value) return;
        if (this._mask) {
            const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
            if (maskObject) {
                maskObject._maskRefCount--;
                if (maskObject._maskRefCount === 0) {
                    maskObject.renderable = true;
                    maskObject.isMask = false;
                }
            }
        }
        this._mask = value;
        if (this._mask) {
            const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
            if (maskObject) {
                if (maskObject._maskRefCount === 0) {
                    maskObject.renderable = false;
                    maskObject.isMask = true;
                }
                maskObject._maskRefCount++;
            }
        }
    }
}
class $93bf10443ce4ab2c$export$a35515d77cade20d extends $93bf10443ce4ab2c$export$1f679544f90d7d7c {
    constructor(){
        super(...arguments);
        this.sortDirty = null;
    }
}
$93bf10443ce4ab2c$export$1f679544f90d7d7c.prototype.displayObjectUpdateTransform = $93bf10443ce4ab2c$export$1f679544f90d7d7c.prototype.updateTransform;


const $823fbc2c4ae841df$var$tempMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
function $823fbc2c4ae841df$var$sortChildren(a, b) {
    if (a.zIndex === b.zIndex) return a._lastSortedIndex - b._lastSortedIndex;
    return a.zIndex - b.zIndex;
}
const $823fbc2c4ae841df$var$_Container = class extends (0, $93bf10443ce4ab2c$export$1f679544f90d7d7c) {
    constructor(){
        super();
        this.children = [];
        this.sortableChildren = $823fbc2c4ae841df$var$_Container.defaultSortableChildren;
        this.sortDirty = false;
    }
    onChildrenChange(_length) {}
    addChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.addChild(children[i]);
        else {
            const child = children[0];
            if (child.parent) child.parent.removeChild(child);
            child.parent = this;
            this.sortDirty = true;
            child.transform._parentID = -1;
            this.children.push(child);
            this._boundsID++;
            this.onChildrenChange(this.children.length - 1);
            this.emit("childAdded", child, this, this.children.length - 1);
            child.emit("added", this);
        }
        return children[0];
    }
    addChildAt(child, index) {
        if (index < 0 || index > this.children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${this.children.length}`);
        if (child.parent) child.parent.removeChild(child);
        child.parent = this;
        this.sortDirty = true;
        child.transform._parentID = -1;
        this.children.splice(index, 0, child);
        this._boundsID++;
        this.onChildrenChange(index);
        child.emit("added", this);
        this.emit("childAdded", child, this, index);
        return child;
    }
    swapChildren(child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        this.onChildrenChange(index1 < index2 ? index1 : index2);
    }
    getChildIndex(child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied DisplayObject must be a child of the caller");
        return index;
    }
    setChildIndex(child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        const currentIndex = this.getChildIndex(child);
        (0, $5d808cc4b6a3c326$exports).removeItems(this.children, currentIndex, 1);
        this.children.splice(index, 0, child);
        this.onChildrenChange(index);
    }
    getChildAt(index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    }
    removeChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
        else {
            const child = children[0];
            const index = this.children.indexOf(child);
            if (index === -1) return null;
            child.parent = null;
            child.transform._parentID = -1;
            (0, $5d808cc4b6a3c326$exports).removeItems(this.children, index, 1);
            this._boundsID++;
            this.onChildrenChange(index);
            child.emit("removed", this);
            this.emit("childRemoved", child, this, index);
        }
        return children[0];
    }
    removeChildAt(index) {
        const child = this.getChildAt(index);
        child.parent = null;
        child.transform._parentID = -1;
        (0, $5d808cc4b6a3c326$exports).removeItems(this.children, index, 1);
        this._boundsID++;
        this.onChildrenChange(index);
        child.emit("removed", this);
        this.emit("childRemoved", child, this, index);
        return child;
    }
    removeChildren(beginIndex = 0, endIndex = this.children.length) {
        const begin = beginIndex;
        const end = endIndex;
        const range = end - begin;
        let removed;
        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);
            for(let i = 0; i < removed.length; ++i){
                removed[i].parent = null;
                if (removed[i].transform) removed[i].transform._parentID = -1;
            }
            this._boundsID++;
            this.onChildrenChange(beginIndex);
            for(let i = 0; i < removed.length; ++i){
                removed[i].emit("removed", this);
                this.emit("childRemoved", removed[i], this, i);
            }
            return removed;
        } else if (range === 0 && this.children.length === 0) return [];
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    }
    sortChildren() {
        let sortRequired = false;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child._lastSortedIndex = i;
            if (!sortRequired && child.zIndex !== 0) sortRequired = true;
        }
        if (sortRequired && this.children.length > 1) this.children.sort($823fbc2c4ae841df$var$sortChildren);
        this.sortDirty = false;
    }
    updateTransform() {
        if (this.sortableChildren && this.sortDirty) this.sortChildren();
        this._boundsID++;
        this.transform.updateTransform(this.parent.transform);
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            if (child.visible) child.updateTransform();
        }
    }
    calculateBounds() {
        this._bounds.clear();
        this._calculateBounds();
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (!child.visible || !child.renderable) continue;
            child.calculateBounds();
            if (child._mask) {
                const maskObject = child._mask.isMaskData ? child._mask.maskObject : child._mask;
                if (maskObject) {
                    maskObject.calculateBounds();
                    this._bounds.addBoundsMask(child._bounds, maskObject._bounds);
                } else this._bounds.addBounds(child._bounds);
            } else if (child.filterArea) this._bounds.addBoundsArea(child._bounds, child.filterArea);
            else this._bounds.addBounds(child._bounds);
        }
        this._bounds.updateID = this._boundsID;
    }
    getLocalBounds(rect, skipChildrenUpdate = false) {
        const result = super.getLocalBounds(rect);
        if (!skipChildrenUpdate) for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            if (child.visible) child.updateTransform();
        }
        return result;
    }
    _calculateBounds() {}
    _renderWithCulling(renderer) {
        const sourceFrame = renderer.renderTexture.sourceFrame;
        if (!(sourceFrame.width > 0 && sourceFrame.height > 0)) return;
        let bounds;
        let transform;
        if (this.cullArea) {
            bounds = this.cullArea;
            transform = this.worldTransform;
        } else if (this._render !== $823fbc2c4ae841df$var$_Container.prototype._render) bounds = this.getBounds(true);
        const projectionTransform = renderer.projection.transform;
        if (projectionTransform) {
            if (transform) {
                transform = $823fbc2c4ae841df$var$tempMatrix.copyFrom(transform);
                transform.prepend(projectionTransform);
            } else transform = projectionTransform;
        }
        if (bounds && sourceFrame.intersects(bounds, transform)) this._render(renderer);
        else if (this.cullArea) return;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            const childCullable = child.cullable;
            child.cullable = childCullable || !this.cullArea;
            child.render(renderer);
            child.cullable = childCullable;
        }
    }
    render(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        if (this._mask || this.filters?.length) this.renderAdvanced(renderer);
        else if (this.cullable) this._renderWithCulling(renderer);
        else {
            this._render(renderer);
            for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
        }
    }
    renderAdvanced(renderer) {
        const filters = this.filters;
        const mask = this._mask;
        if (filters) {
            if (!this._enabledFilters) this._enabledFilters = [];
            this._enabledFilters.length = 0;
            for(let i = 0; i < filters.length; i++)if (filters[i].enabled) this._enabledFilters.push(filters[i]);
        }
        const flush = filters && this._enabledFilters?.length || mask && (!mask.isMaskData || mask.enabled && (mask.autoDetect || mask.type !== (0, $551209d754b5b429$export$dbbea138c5d144).NONE));
        if (flush) renderer.batch.flush();
        if (filters && this._enabledFilters?.length) renderer.filter.push(this, this._enabledFilters);
        if (mask) renderer.mask.push(this, this._mask);
        if (this.cullable) this._renderWithCulling(renderer);
        else {
            this._render(renderer);
            for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
        }
        if (flush) renderer.batch.flush();
        if (mask) renderer.mask.pop(this);
        if (filters && this._enabledFilters?.length) renderer.filter.pop();
    }
    _render(_renderer) {}
    destroy(options) {
        super.destroy();
        this.sortDirty = false;
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        const oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    }
    get width() {
        return this.scale.x * this.getLocalBounds().width;
    }
    set width(value) {
        const width = this.getLocalBounds().width;
        if (width !== 0) this.scale.x = value / width;
        else this.scale.x = 1;
        this._width = value;
    }
    get height() {
        return this.scale.y * this.getLocalBounds().height;
    }
    set height(value) {
        const height = this.getLocalBounds().height;
        if (height !== 0) this.scale.y = value / height;
        else this.scale.y = 1;
        this._height = value;
    }
};
let $823fbc2c4ae841df$export$42a852a2b6b56249 = $823fbc2c4ae841df$var$_Container;
$823fbc2c4ae841df$export$42a852a2b6b56249.defaultSortableChildren = false;
$823fbc2c4ae841df$export$42a852a2b6b56249.prototype.containerUpdateTransform = $823fbc2c4ae841df$export$42a852a2b6b56249.prototype.updateTransform;


Object.defineProperties((0, $fcbcf105ed644495$export$a5a6e0b888b2c992), {
    SORTABLE_CHILDREN: {
        get () {
            return (0, $823fbc2c4ae841df$export$42a852a2b6b56249).defaultSortableChildren;
        },
        set (value) {
            (0, $5d808cc4b6a3c326$exports).deprecation("7.1.0", "settings.SORTABLE_CHILDREN is deprecated, use Container.defaultSortableChildren");
            (0, $823fbc2c4ae841df$export$42a852a2b6b56249).defaultSortableChildren = value;
        }
    }
});









const $28766cd6a31d5ed8$var$tempPoint = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
const $28766cd6a31d5ed8$var$indices = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3
]);
class $28766cd6a31d5ed8$export$3075603db8e6204c extends (0, $823fbc2c4ae841df$export$42a852a2b6b56249) {
    constructor(texture){
        super();
        this._anchor = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(this._onAnchorUpdate, this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0);
        this._texture = null;
        this._width = 0;
        this._height = 0;
        this._tintColor = new (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e)(16777215);
        this._tintRGB = null;
        this.tint = 16777215;
        this.blendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL;
        this._cachedTint = 16777215;
        this.uvs = null;
        this.texture = texture || (0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY;
        this.vertexData = new Float32Array(8);
        this.vertexTrimmedData = null;
        this._transformID = -1;
        this._textureID = -1;
        this._transformTrimmedID = -1;
        this._textureTrimmedID = -1;
        this.indices = $28766cd6a31d5ed8$var$indices;
        this.pluginName = "batch";
        this.isSprite = true;
        this._roundPixels = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ROUND_PIXELS;
    }
    _onTextureUpdate() {
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this._cachedTint = 16777215;
        if (this._width) this.scale.x = (0, $5d808cc4b6a3c326$exports).sign(this.scale.x) * this._width / this._texture.orig.width;
        if (this._height) this.scale.y = (0, $5d808cc4b6a3c326$exports).sign(this.scale.y) * this._height / this._texture.orig.height;
    }
    _onAnchorUpdate() {
        this._transformID = -1;
        this._transformTrimmedID = -1;
    }
    calculateVertices() {
        const texture = this._texture;
        if (this._transformID === this.transform._worldID && this._textureID === texture._updateID) return;
        if (this._textureID !== texture._updateID) this.uvs = this._texture._uvs.uvsFloat32;
        this._transformID = this.transform._worldID;
        this._textureID = texture._updateID;
        const wt = this.transform.worldTransform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const vertexData = this.vertexData;
        const trim = texture.trim;
        const orig = texture.orig;
        const anchor = this._anchor;
        let w0 = 0;
        let w1 = 0;
        let h0 = 0;
        let h1 = 0;
        if (trim) {
            w1 = trim.x - anchor._x * orig.width;
            w0 = w1 + trim.width;
            h1 = trim.y - anchor._y * orig.height;
            h0 = h1 + trim.height;
        } else {
            w1 = -anchor._x * orig.width;
            w0 = w1 + orig.width;
            h1 = -anchor._y * orig.height;
            h0 = h1 + orig.height;
        }
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
        if (this._roundPixels) {
            const resolution = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
    }
    calculateTrimmedVertices() {
        if (!this.vertexTrimmedData) this.vertexTrimmedData = new Float32Array(8);
        else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) return;
        this._transformTrimmedID = this.transform._worldID;
        this._textureTrimmedID = this._texture._updateID;
        const texture = this._texture;
        const vertexData = this.vertexTrimmedData;
        const orig = texture.orig;
        const anchor = this._anchor;
        const wt = this.transform.worldTransform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const w1 = -anchor._x * orig.width;
        const w0 = w1 + orig.width;
        const h1 = -anchor._y * orig.height;
        const h0 = h1 + orig.height;
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
    }
    _render(renderer) {
        this.calculateVertices();
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    }
    _calculateBounds() {
        const trim = this._texture.trim;
        const orig = this._texture.orig;
        if (!trim || trim.width === orig.width && trim.height === orig.height) {
            this.calculateVertices();
            this._bounds.addQuad(this.vertexData);
        } else {
            this.calculateTrimmedVertices();
            this._bounds.addQuad(this.vertexTrimmedData);
        }
    }
    getLocalBounds(rect) {
        if (this.children.length === 0) {
            if (!this._localBounds) this._localBounds = new (0, $51558a611c79ce5a$export$c4e9d269599ab4b4)();
            this._localBounds.minX = this._texture.orig.width * -this._anchor._x;
            this._localBounds.minY = this._texture.orig.height * -this._anchor._y;
            this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
            this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y);
            if (!rect) {
                if (!this._localBoundsRect) this._localBoundsRect = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
                rect = this._localBoundsRect;
            }
            return this._localBounds.getRectangle(rect);
        }
        return super.getLocalBounds.call(this, rect);
    }
    containsPoint(point) {
        this.worldTransform.applyInverse(point, $28766cd6a31d5ed8$var$tempPoint);
        const width = this._texture.orig.width;
        const height = this._texture.orig.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if ($28766cd6a31d5ed8$var$tempPoint.x >= x1 && $28766cd6a31d5ed8$var$tempPoint.x < x1 + width) {
            y1 = -height * this.anchor.y;
            if ($28766cd6a31d5ed8$var$tempPoint.y >= y1 && $28766cd6a31d5ed8$var$tempPoint.y < y1 + height) return true;
        }
        return false;
    }
    destroy(options) {
        super.destroy(options);
        this._texture.off("update", this._onTextureUpdate, this);
        this._anchor = null;
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyBaseTexture = typeof options === "boolean" ? options : options?.baseTexture;
            this._texture.destroy(!!destroyBaseTexture);
        }
        this._texture = null;
    }
    static from(source, options) {
        const texture = source instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a) ? source : (0, $6ac4ad2139942545$export$5431306cf43de24a).from(source, options);
        return new $28766cd6a31d5ed8$export$3075603db8e6204c(texture);
    }
    set roundPixels(value) {
        if (this._roundPixels !== value) this._transformID = -1;
        this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        const s = (0, $5d808cc4b6a3c326$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width;
        this._width = value;
    }
    get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        const s = (0, $5d808cc4b6a3c326$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height;
        this._height = value;
    }
    get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        this._anchor.copyFrom(value);
    }
    get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value);
        this._tintRGB = this._tintColor.toLittleEndianNumber();
    }
    get tintValue() {
        return this._tintColor.toNumber();
    }
    get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this._texture === value) return;
        if (this._texture) this._texture.off("update", this._onTextureUpdate, this);
        this._texture = value || (0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY;
        this._cachedTint = 16777215;
        this._textureID = -1;
        this._textureTrimmedID = -1;
        if (value) {
            if (value.baseTexture.valid) this._onTextureUpdate();
            else value.once("update", this._onTextureUpdate, this);
        }
    }
}




const $7d41d0b4ce1f40f2$var$_tempMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._cacheAsBitmap = false;
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._cacheData = null;
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._cacheAsBitmapResolution = null;
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._cacheAsBitmapMultisample = null;
class $7d41d0b4ce1f40f2$export$3e19bdfd927f283c {
    constructor(){
        this.textureCacheId = null;
        this.originalRender = null;
        this.originalRenderCanvas = null;
        this.originalCalculateBounds = null;
        this.originalGetLocalBounds = null;
        this.originalUpdateTransform = null;
        this.originalDestroy = null;
        this.originalMask = null;
        this.originalFilterArea = null;
        this.originalContainsPoint = null;
        this.sprite = null;
    }
}
Object.defineProperties((0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype, {
    cacheAsBitmapResolution: {
        get () {
            return this._cacheAsBitmapResolution;
        },
        set (resolution) {
            if (resolution === this._cacheAsBitmapResolution) return;
            this._cacheAsBitmapResolution = resolution;
            if (this.cacheAsBitmap) {
                this.cacheAsBitmap = false;
                this.cacheAsBitmap = true;
            }
        }
    },
    cacheAsBitmapMultisample: {
        get () {
            return this._cacheAsBitmapMultisample;
        },
        set (multisample) {
            if (multisample === this._cacheAsBitmapMultisample) return;
            this._cacheAsBitmapMultisample = multisample;
            if (this.cacheAsBitmap) {
                this.cacheAsBitmap = false;
                this.cacheAsBitmap = true;
            }
        }
    },
    cacheAsBitmap: {
        get () {
            return this._cacheAsBitmap;
        },
        set (value) {
            if (this._cacheAsBitmap === value) return;
            this._cacheAsBitmap = value;
            let data;
            if (value) {
                if (!this._cacheData) this._cacheData = new $7d41d0b4ce1f40f2$export$3e19bdfd927f283c();
                data = this._cacheData;
                data.originalRender = this.render;
                data.originalRenderCanvas = this.renderCanvas;
                data.originalUpdateTransform = this.updateTransform;
                data.originalCalculateBounds = this.calculateBounds;
                data.originalGetLocalBounds = this.getLocalBounds;
                data.originalDestroy = this.destroy;
                data.originalContainsPoint = this.containsPoint;
                data.originalMask = this._mask;
                data.originalFilterArea = this.filterArea;
                this.render = this._renderCached;
                this.renderCanvas = this._renderCachedCanvas;
                this.destroy = this._cacheAsBitmapDestroy;
            } else {
                data = this._cacheData;
                if (data.sprite) this._destroyCachedDisplayObject();
                this.render = data.originalRender;
                this.renderCanvas = data.originalRenderCanvas;
                this.calculateBounds = data.originalCalculateBounds;
                this.getLocalBounds = data.originalGetLocalBounds;
                this.destroy = data.originalDestroy;
                this.updateTransform = data.originalUpdateTransform;
                this.containsPoint = data.originalContainsPoint;
                this._mask = data.originalMask;
                this.filterArea = data.originalFilterArea;
            }
        }
    }
});
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._renderCached = function _renderCached(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
    this._initCachedDisplayObject(renderer);
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._render(renderer);
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
    if (this._cacheData?.sprite) return;
    const cacheAlpha = this.alpha;
    this.alpha = 1;
    renderer.batch.flush();
    const bounds = this.getLocalBounds(null, true).clone();
    if (this.filters?.length) {
        const padding = this.filters[0].padding;
        bounds.pad(padding);
    }
    bounds.ceil((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION);
    const cachedRenderTexture = renderer.renderTexture.current;
    const cachedSourceFrame = renderer.renderTexture.sourceFrame.clone();
    const cachedDestinationFrame = renderer.renderTexture.destinationFrame.clone();
    const cachedProjectionTransform = renderer.projection.transform;
    const renderTexture = (0, $952e32ce616eaf78$export$813984f7330b4d72).create({
        width: bounds.width,
        height: bounds.height,
        resolution: this.cacheAsBitmapResolution || renderer.resolution,
        multisample: this.cacheAsBitmapMultisample ?? renderer.multisample
    });
    const textureCacheId = `cacheAsBitmap_${(0, $5d808cc4b6a3c326$exports).uid()}`;
    this._cacheData.textureCacheId = textureCacheId;
    (0, $2d8d497fce3a4092$export$d6306e508f184154).addToCache(renderTexture.baseTexture, textureCacheId);
    (0, $6ac4ad2139942545$export$5431306cf43de24a).addToCache(renderTexture, textureCacheId);
    const m = this.transform.localTransform.copyTo($7d41d0b4ce1f40f2$var$_tempMatrix).invert().translate(-bounds.x, -bounds.y);
    this.render = this._cacheData.originalRender;
    renderer.render(this, {
        renderTexture: renderTexture,
        clear: true,
        transform: m,
        skipUpdateTransform: false
    });
    renderer.framebuffer.blit();
    renderer.projection.transform = cachedProjectionTransform;
    renderer.renderTexture.bind(cachedRenderTexture, cachedSourceFrame, cachedDestinationFrame);
    this.render = this._renderCached;
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;
    this._mask = null;
    this.filterArea = null;
    this.alpha = cacheAlpha;
    const cachedSprite = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;
    this._cacheData.sprite = cachedSprite;
    this.transform._parentID = -1;
    if (!this.parent) {
        this.enableTempParent();
        this.updateTransform();
        this.disableTempParent(null);
    } else this.updateTransform();
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
    this._initCachedDisplayObjectCanvas(renderer);
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._renderCanvas(renderer);
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
    if (this._cacheData?.sprite) return;
    const bounds = this.getLocalBounds(null, true);
    const cacheAlpha = this.alpha;
    this.alpha = 1;
    const cachedRenderTarget = renderer.canvasContext.activeContext;
    const cachedProjectionTransform = renderer._projTransform;
    bounds.ceil((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION);
    const renderTexture = (0, $952e32ce616eaf78$export$813984f7330b4d72).create({
        width: bounds.width,
        height: bounds.height
    });
    const textureCacheId = `cacheAsBitmap_${(0, $5d808cc4b6a3c326$exports).uid()}`;
    this._cacheData.textureCacheId = textureCacheId;
    (0, $2d8d497fce3a4092$export$d6306e508f184154).addToCache(renderTexture.baseTexture, textureCacheId);
    (0, $6ac4ad2139942545$export$5431306cf43de24a).addToCache(renderTexture, textureCacheId);
    const m = $7d41d0b4ce1f40f2$var$_tempMatrix;
    this.transform.localTransform.copyTo(m);
    m.invert();
    m.tx -= bounds.x;
    m.ty -= bounds.y;
    this.renderCanvas = this._cacheData.originalRenderCanvas;
    renderer.render(this, {
        renderTexture: renderTexture,
        clear: true,
        transform: m,
        skipUpdateTransform: false
    });
    renderer.canvasContext.activeContext = cachedRenderTarget;
    renderer._projTransform = cachedProjectionTransform;
    this.renderCanvas = this._renderCachedCanvas;
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;
    this._mask = null;
    this.filterArea = null;
    this.alpha = cacheAlpha;
    const cachedSprite = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;
    this._cacheData.sprite = cachedSprite;
    this.transform._parentID = -1;
    if (!this.parent) {
        this.parent = renderer._tempDisplayObjectParent;
        this.updateTransform();
        this.parent = null;
    } else this.updateTransform();
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._calculateCachedBounds = function _calculateCachedBounds() {
    this._bounds.clear();
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite._calculateBounds();
    this._bounds.updateID = this._boundsID;
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
    return this._cacheData.sprite.getLocalBounds(null);
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
    this._cacheData.sprite._texture.destroy(true);
    this._cacheData.sprite = null;
    (0, $2d8d497fce3a4092$export$d6306e508f184154).removeFromCache(this._cacheData.textureCacheId);
    (0, $6ac4ad2139942545$export$5431306cf43de24a).removeFromCache(this._cacheData.textureCacheId);
    this._cacheData.textureCacheId = null;
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
    this.cacheAsBitmap = false;
    this.destroy(options);
};



(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype.name = null;
(0, $823fbc2c4ae841df$export$42a852a2b6b56249).prototype.getChildByName = function getChildByName(name, deep) {
    for(let i = 0, j = this.children.length; i < j; i++){
        if (this.children[i].name === name) return this.children[i];
    }
    if (deep) for(let i = 0, j = this.children.length; i < j; i++){
        const child = this.children[i];
        if (!child.getChildByName) continue;
        const target = child.getChildByName(name, true);
        if (target) return target;
    }
    return null;
};




(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).prototype.getGlobalPosition = function getGlobalPosition(point = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(), skipUpdate = false) {
    if (this.parent) this.parent.toGlobal(this.position, point, skipUpdate);
    else {
        point.x = this.position.x;
        point.y = this.position.y;
    }
    return point;
};




var $c1b3afe7e410b0eb$export$2e2bcd8739ae039 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n";


class $eb46baeaa5184069$export$adbaa0de008b0d7a extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(alpha = 1){
        super((0, $bf6b256f229604e1$export$4a1a95006fc6b0f1), (0, $c1b3afe7e410b0eb$export$2e2bcd8739ae039), {
            uAlpha: 1
        });
        this.alpha = alpha;
    }
    get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}






const $1bd88149b4277eef$var$GAUSSIAN_VALUES = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        93e-4,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        2406e-6,
        9255e-6,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        489e-6,
        2403e-6,
        9246e-6,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
};
const $1bd88149b4277eef$var$fragTemplate = [
    "varying vec2 vBlurTexCoords[%size%];",
    "uniform sampler2D uSampler;",
    "void main(void)",
    "{",
    "    gl_FragColor = vec4(0.0);",
    "    %blur%",
    "}"
].join("\n");
function $1bd88149b4277eef$export$1b0dcf101eb6a1c9(kernelSize) {
    const kernel = $1bd88149b4277eef$var$GAUSSIAN_VALUES[kernelSize];
    const halfLength = kernel.length;
    let fragSource = $1bd88149b4277eef$var$fragTemplate;
    let blurLoop = "";
    const template = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;";
    let value;
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        value = i;
        if (i >= halfLength) value = kernelSize - i - 1;
        blur = blur.replace("%value%", kernel[value].toString());
        blurLoop += blur;
        blurLoop += "\n";
    }
    fragSource = fragSource.replace("%blur%", blurLoop);
    fragSource = fragSource.replace("%size%", kernelSize.toString());
    return fragSource;
}


const $47d860a0465411a8$var$vertTemplate = `
    attribute vec2 aVertexPosition;

    uniform mat3 projectionMatrix;

    uniform float strength;

    varying vec2 vBlurTexCoords[%size%];

    uniform vec4 inputSize;
    uniform vec4 outputFrame;

    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }

    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function $47d860a0465411a8$export$7a7fb9d9d09c33af(kernelSize, x) {
    const halfLength = Math.ceil(kernelSize / 2);
    let vertSource = $47d860a0465411a8$var$vertTemplate;
    let blurLoop = "";
    let template;
    if (x) template = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);";
    else template = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        blur = blur.replace("%sampleIndex%", `${i - (halfLength - 1)}.0`);
        blurLoop += blur;
        blurLoop += "\n";
    }
    vertSource = vertSource.replace("%blur%", blurLoop);
    vertSource = vertSource.replace("%size%", kernelSize.toString());
    return vertSource;
}


class $e02eb7d1be82cd90$export$b100a8e8116621cf extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(horizontal, strength = 8, quality = 4, resolution = (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea).defaultResolution, kernelSize = 5){
        const vertSrc = (0, $47d860a0465411a8$export$7a7fb9d9d09c33af)(kernelSize, horizontal);
        const fragSrc = (0, $1bd88149b4277eef$export$1b0dcf101eb6a1c9)(kernelSize);
        super(vertSrc, fragSrc);
        this.horizontal = horizontal;
        this.resolution = resolution;
        this._quality = 0;
        this.quality = quality;
        this.blur = strength;
    }
    apply(filterManager, input, output, clearMode) {
        if (output) {
            if (this.horizontal) this.uniforms.strength = 1 / output.width * (output.width / input.width);
            else this.uniforms.strength = 1 / output.height * (output.height / input.height);
        } else if (this.horizontal) this.uniforms.strength = 1 / filterManager.renderer.width * (filterManager.renderer.width / input.width);
        else this.uniforms.strength = 1 / filterManager.renderer.height * (filterManager.renderer.height / input.height);
        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes;
        if (this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            const renderTarget = filterManager.getFilterTexture();
            const renderer = filterManager.renderer;
            let flip = input;
            let flop = renderTarget;
            this.state.blend = false;
            filterManager.applyFilter(this, flip, flop, (0, $551209d754b5b429$export$784901839554cbc3).CLEAR);
            for(let i = 1; i < this.passes - 1; i++){
                filterManager.bindAndClear(flip, (0, $551209d754b5b429$export$784901839554cbc3).BLIT);
                this.uniforms.uSampler = flop;
                const temp = flop;
                flop = flip;
                flip = temp;
                renderer.shader.bind(this);
                renderer.geometry.draw(5);
            }
            this.state.blend = true;
            filterManager.applyFilter(this, flop, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        }
    }
    get blur() {
        return this.strength;
    }
    set blur(value) {
        this.padding = 1 + Math.abs(value) * 2;
        this.strength = value;
    }
    get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value;
        this.passes = value;
    }
}


class $d646b7e94dfd28fa$export$424348d09d827f49 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(strength = 8, quality = 4, resolution = (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea).defaultResolution, kernelSize = 5){
        super();
        this._repeatEdgePixels = false;
        this.blurXFilter = new (0, $e02eb7d1be82cd90$export$b100a8e8116621cf)(true, strength, quality, resolution, kernelSize);
        this.blurYFilter = new (0, $e02eb7d1be82cd90$export$b100a8e8116621cf)(false, strength, quality, resolution, kernelSize);
        this.resolution = resolution;
        this.quality = quality;
        this.blur = strength;
        this.repeatEdgePixels = false;
    }
    apply(filterManager, input, output, clearMode) {
        const xStrength = Math.abs(this.blurXFilter.strength);
        const yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            const renderTarget = filterManager.getFilterTexture();
            this.blurXFilter.apply(filterManager, input, renderTarget, (0, $551209d754b5b429$export$784901839554cbc3).CLEAR);
            this.blurYFilter.apply(filterManager, renderTarget, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        } else if (yStrength) this.blurYFilter.apply(filterManager, input, output, clearMode);
        else this.blurXFilter.apply(filterManager, input, output, clearMode);
    }
    updatePadding() {
        if (this._repeatEdgePixels) this.padding = 0;
        else this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
    }
    get blur() {
        return this.blurXFilter.blur;
    }
    set blur(value) {
        this.blurXFilter.blur = this.blurYFilter.blur = value;
        this.updatePadding();
    }
    get quality() {
        return this.blurXFilter.quality;
    }
    set quality(value) {
        this.blurXFilter.quality = this.blurYFilter.quality = value;
    }
    get blurX() {
        return this.blurXFilter.blur;
    }
    set blurX(value) {
        this.blurXFilter.blur = value;
        this.updatePadding();
    }
    get blurY() {
        return this.blurYFilter.blur;
    }
    set blurY(value) {
        this.blurYFilter.blur = value;
        this.updatePadding();
    }
    get blendMode() {
        return this.blurYFilter.blendMode;
    }
    set blendMode(value) {
        this.blurYFilter.blendMode = value;
    }
    get repeatEdgePixels() {
        return this._repeatEdgePixels;
    }
    set repeatEdgePixels(value) {
        this._repeatEdgePixels = value;
        this.updatePadding();
    }
}






var $9ebb605082bf901a$export$2e2bcd8739ae039 = "varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n";


class $9783b70fe428f333$export$6547db23997fcec5 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(){
        const uniforms = {
            m: new Float32Array([
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]),
            uAlpha: 1
        };
        super((0, $bf6b256f229604e1$export$198627d10d1d088f), (0, $9ebb605082bf901a$export$2e2bcd8739ae039), uniforms);
        this.alpha = 1;
    }
    _loadMatrix(matrix, multiply = false) {
        let newMatrix = matrix;
        if (multiply) {
            this._multiply(newMatrix, this.uniforms.m, matrix);
            newMatrix = this._colorMatrix(newMatrix);
        }
        this.uniforms.m = newMatrix;
    }
    _multiply(out, a, b) {
        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
        return out;
    }
    _colorMatrix(matrix) {
        const m = new Float32Array(matrix);
        m[4] /= 255;
        m[9] /= 255;
        m[14] /= 255;
        m[19] /= 255;
        return m;
    }
    brightness(b, multiply) {
        const matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    tint(color, multiply) {
        const [r, g, b] = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(color).toArray();
        const matrix = [
            r,
            0,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    greyscale(scale, multiply) {
        const matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    blackAndWhite(multiply) {
        const matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        const cosR = Math.cos(rotation);
        const sinR = Math.sin(rotation);
        const sqrt = Math.sqrt;
        const w = 1 / 3;
        const sqrW = sqrt(w);
        const a00 = cosR + (1 - cosR) * w;
        const a01 = w * (1 - cosR) - sqrW * sinR;
        const a02 = w * (1 - cosR) + sqrW * sinR;
        const a10 = w * (1 - cosR) + sqrW * sinR;
        const a11 = cosR + w * (1 - cosR);
        const a12 = w * (1 - cosR) - sqrW * sinR;
        const a20 = w * (1 - cosR) - sqrW * sinR;
        const a21 = w * (1 - cosR) + sqrW * sinR;
        const a22 = cosR + w * (1 - cosR);
        const matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    contrast(amount, multiply) {
        const v = (amount || 0) + 1;
        const o = -0.5 * (v - 1);
        const matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    saturate(amount = 0, multiply) {
        const x = amount * 2 / 3 + 1;
        const y = (x - 1) * -0.5;
        const matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    desaturate() {
        this.saturate(-1);
    }
    negative(multiply) {
        const matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    sepia(multiply) {
        const matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    technicolor(multiply) {
        const matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    polaroid(multiply) {
        const matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    toBGR(multiply) {
        const matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    kodachrome(multiply) {
        const matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    browni(multiply) {
        const matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    vintage(multiply) {
        const matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2;
        toned = toned || 0.15;
        lightColor = lightColor || 16770432;
        darkColor = darkColor || 3375104;
        const temp = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared;
        const [lR, lG, lB] = temp.setValue(lightColor).toArray();
        const [dR, dG, dB] = temp.setValue(darkColor).toArray();
        const matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    night(intensity, multiply) {
        intensity = intensity || 0.1;
        const matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    predator(amount, multiply) {
        const matrix = [
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    lsd(multiply) {
        const matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    reset() {
        const matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, false);
    }
    get matrix() {
        return this.uniforms.m;
    }
    set matrix(value) {
        this.uniforms.m = value;
    }
    get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}
$9783b70fe428f333$export$6547db23997fcec5.prototype.grayscale = $9783b70fe428f333$export$6547db23997fcec5.prototype.greyscale;





var $e011a4b15d8eeda6$export$2e2bcd8739ae039 = "varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\nuniform mat2 rotation;\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform highp vec4 inputSize;\nuniform vec4 inputClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy = scale * inputSize.zw * (rotation * map.xy);\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));\n}\n";


var $b52456c01a4e7c80$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n	gl_Position = filterVertexPosition();\n	vTextureCoord = filterTextureCoord();\n	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;\n}\n";


class $4065793d8789428d$export$8ebf3229158e2895 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(sprite, scale){
        const maskMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
        sprite.renderable = false;
        super((0, $b52456c01a4e7c80$export$2e2bcd8739ae039), (0, $e011a4b15d8eeda6$export$2e2bcd8739ae039), {
            mapSampler: sprite._texture,
            filterMatrix: maskMatrix,
            scale: {
                x: 1,
                y: 1
            },
            rotation: new Float32Array([
                1,
                0,
                0,
                1
            ])
        });
        this.maskSprite = sprite;
        this.maskMatrix = maskMatrix;
        if (scale === null || scale === void 0) scale = 20;
        this.scale = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(scale, scale);
    }
    apply(filterManager, input, output, clearMode) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        this.uniforms.scale.x = this.scale.x;
        this.uniforms.scale.y = this.scale.y;
        const wt = this.maskSprite.worldTransform;
        const lenX = Math.sqrt(wt.a * wt.a + wt.b * wt.b);
        const lenY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
        if (lenX !== 0 && lenY !== 0) {
            this.uniforms.rotation[0] = wt.a / lenX;
            this.uniforms.rotation[1] = wt.b / lenX;
            this.uniforms.rotation[2] = wt.c / lenY;
            this.uniforms.rotation[3] = wt.d / lenY;
        }
        filterManager.applyFilter(this, input, output, clearMode);
    }
    get map() {
        return this.uniforms.mapSampler;
    }
    set map(value) {
        this.uniforms.mapSampler = value;
    }
}





var $6b89a6e21456114f$export$2e2bcd8739ae039 = 'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\nuniform sampler2D uSampler;\nuniform highp vec4 inputSize;\n\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n\n --\n\n From:\n https://github.com/mitsuhiko/webgl-meincraft\n\n Copyright (c) 2011 by Armin Ronacher.\n\n Some rights reserved.\n\n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n\n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n\n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n\n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n\n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n\n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n\n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n\n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n\n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n\n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec4 color;\n\n      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n';


var $13a34f619821fcca$export$2e2bcd8739ae039 = "\nattribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvoid texcoords(vec2 fragCoord, vec2 inverseVP,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = filterVertexPosition();\n\n   vFragCoord = aVertexPosition * outputFrame.zw;\n\n   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}\n";


class $a543331795166beb$export$86086ddb5389b795 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(){
        super((0, $13a34f619821fcca$export$2e2bcd8739ae039), (0, $6b89a6e21456114f$export$2e2bcd8739ae039));
    }
}





var $87b51e60ed5bce9f$export$2e2bcd8739ae039 = "precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n";


class $f5d4fea5824ab477$export$2d7a5b72233a5183 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(noise = 0.5, seed = Math.random()){
        super((0, $bf6b256f229604e1$export$198627d10d1d088f), (0, $87b51e60ed5bce9f$export$2e2bcd8739ae039), {
            uNoise: 0,
            uSeed: 0
        });
        this.noise = noise;
        this.seed = seed;
    }
    get noise() {
        return this.uniforms.uNoise;
    }
    set noise(value) {
        this.uniforms.uNoise = value;
    }
    get seed() {
        return this.uniforms.uSeed;
    }
    set seed(value) {
        this.uniforms.uSeed = value;
    }
}




const $1df130f681e90bc6$export$82462a21aead86ed = {
    AlphaFilter: $eb46baeaa5184069$export$adbaa0de008b0d7a,
    BlurFilter: $d646b7e94dfd28fa$export$424348d09d827f49,
    BlurFilterPass: $e02eb7d1be82cd90$export$b100a8e8116621cf,
    ColorMatrixFilter: $9783b70fe428f333$export$6547db23997fcec5,
    DisplacementFilter: $4065793d8789428d$export$8ebf3229158e2895,
    FXAAFilter: $a543331795166beb$export$86086ddb5389b795,
    NoiseFilter: $f5d4fea5824ab477$export$2d7a5b72233a5183
};
Object.entries($1df130f681e90bc6$export$82462a21aead86ed).forEach(([key, FilterClass])=>{
    Object.defineProperty($1df130f681e90bc6$export$82462a21aead86ed, key, {
        get () {
            (0, $5d808cc4b6a3c326$exports).deprecation("7.1.0", `filters.${key} has moved to ${key}`);
            return FilterClass;
        }
    });
});






class $81dd01f9e812b7d3$var$EventsTickerClass {
    constructor(){
        this.interactionFrequency = 10;
        this._deltaTime = 0;
        this._didMove = false;
        this.tickerAdded = false;
        this._pauseUpdate = true;
    }
    init(events) {
        this.removeTickerListener();
        this.events = events;
        this.interactionFrequency = 10;
        this._deltaTime = 0;
        this._didMove = false;
        this.tickerAdded = false;
        this._pauseUpdate = true;
    }
    get pauseUpdate() {
        return this._pauseUpdate;
    }
    set pauseUpdate(paused) {
        this._pauseUpdate = paused;
    }
    addTickerListener() {
        if (this.tickerAdded || !this.domElement) return;
        (0, $ad2665272528cf94$export$39c54bcc89dcee11).system.add(this.tickerUpdate, this, (0, $bc7ed83ac944008c$export$688aaf132ba9b379).INTERACTION);
        this.tickerAdded = true;
    }
    removeTickerListener() {
        if (!this.tickerAdded) return;
        (0, $ad2665272528cf94$export$39c54bcc89dcee11).system.remove(this.tickerUpdate, this);
        this.tickerAdded = false;
    }
    pointerMoved() {
        this._didMove = true;
    }
    update() {
        if (!this.domElement || this._pauseUpdate) return;
        if (this._didMove) {
            this._didMove = false;
            return;
        }
        const rootPointerEvent = this.events["rootPointerEvent"];
        if (this.events.supportsTouchEvents && rootPointerEvent.pointerType === "touch") return;
        globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
            clientX: rootPointerEvent.clientX,
            clientY: rootPointerEvent.clientY
        }));
    }
    tickerUpdate(deltaTime) {
        this._deltaTime += deltaTime;
        if (this._deltaTime < this.interactionFrequency) return;
        this._deltaTime = 0;
        this.update();
    }
}
const $81dd01f9e812b7d3$export$57a493ed609e53ea = new $81dd01f9e812b7d3$var$EventsTickerClass();




class $26b8e1b052f7f249$export$5d10db92bb959d8a {
    constructor(manager){
        this.bubbles = true;
        this.cancelBubble = true;
        this.cancelable = false;
        this.composed = false;
        this.defaultPrevented = false;
        this.eventPhase = $26b8e1b052f7f249$export$5d10db92bb959d8a.prototype.NONE;
        this.propagationStopped = false;
        this.propagationImmediatelyStopped = false;
        this.layer = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        this.page = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        this.NONE = 0;
        this.CAPTURING_PHASE = 1;
        this.AT_TARGET = 2;
        this.BUBBLING_PHASE = 3;
        this.manager = manager;
    }
    get layerX() {
        return this.layer.x;
    }
    get layerY() {
        return this.layer.y;
    }
    get pageX() {
        return this.page.x;
    }
    get pageY() {
        return this.page.y;
    }
    get data() {
        return this;
    }
    composedPath() {
        if (this.manager && (!this.path || this.path[this.path.length - 1] !== this.target)) this.path = this.target ? this.manager.propagationPath(this.target) : [];
        return this.path;
    }
    initEvent(_type, _bubbles, _cancelable) {
        throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    initUIEvent(_typeArg, _bubblesArg, _cancelableArg, _viewArg, _detailArg) {
        throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    preventDefault() {
        if (this.nativeEvent instanceof Event && this.nativeEvent.cancelable) this.nativeEvent.preventDefault();
        this.defaultPrevented = true;
    }
    stopImmediatePropagation() {
        this.propagationImmediatelyStopped = true;
    }
    stopPropagation() {
        this.propagationStopped = true;
    }
}


class $d3ec2a7353cfb785$export$aeb79caab92d155a extends (0, $26b8e1b052f7f249$export$5d10db92bb959d8a) {
    constructor(){
        super(...arguments);
        this.client = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        this.movement = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        this.offset = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        this.global = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        this.screen = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
    }
    get clientX() {
        return this.client.x;
    }
    get clientY() {
        return this.client.y;
    }
    get x() {
        return this.clientX;
    }
    get y() {
        return this.clientY;
    }
    get movementX() {
        return this.movement.x;
    }
    get movementY() {
        return this.movement.y;
    }
    get offsetX() {
        return this.offset.x;
    }
    get offsetY() {
        return this.offset.y;
    }
    get globalX() {
        return this.global.x;
    }
    get globalY() {
        return this.global.y;
    }
    get screenX() {
        return this.screen.x;
    }
    get screenY() {
        return this.screen.y;
    }
    getLocalPosition(displayObject, point, globalPos) {
        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
    }
    getModifierState(key) {
        return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(key);
    }
    initMouseEvent(_typeArg, _canBubbleArg, _cancelableArg, _viewArg, _detailArg, _screenXArg, _screenYArg, _clientXArg, _clientYArg, _ctrlKeyArg, _altKeyArg, _shiftKeyArg, _metaKeyArg, _buttonArg, _relatedTargetArg) {
        throw new Error("Method not implemented.");
    }
}



class $52ba6cd103d3e195$export$44ac16aa0ab81db6 extends (0, $d3ec2a7353cfb785$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments);
        this.width = 0;
        this.height = 0;
        this.isPrimary = false;
    }
    getCoalescedEvents() {
        if (this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove") return [
            this
        ];
        return [];
    }
    getPredictedEvents() {
        throw new Error("getPredictedEvents is not supported!");
    }
}



class $7893cac0982b7958$export$1fd8b94eb532974d extends (0, $d3ec2a7353cfb785$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments);
        this.DOM_DELTA_PIXEL = 0;
        this.DOM_DELTA_LINE = 1;
        this.DOM_DELTA_PAGE = 2;
    }
}
$7893cac0982b7958$export$1fd8b94eb532974d.DOM_DELTA_PIXEL = 0;
$7893cac0982b7958$export$1fd8b94eb532974d.DOM_DELTA_LINE = 1;
$7893cac0982b7958$export$1fd8b94eb532974d.DOM_DELTA_PAGE = 2;


const $9fbf6b8539eddb2c$var$PROPAGATION_LIMIT = 2048;
const $9fbf6b8539eddb2c$var$tempHitLocation = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
const $9fbf6b8539eddb2c$var$tempLocalMapping = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
class $9fbf6b8539eddb2c$export$532e8c243078d2cd {
    constructor(rootTarget){
        this.dispatch = new (0, $5d808cc4b6a3c326$exports).EventEmitter();
        this.moveOnAll = false;
        this.enableGlobalMoveEvents = true;
        this.mappingState = {
            trackingData: {}
        };
        this.eventPool = /* @__PURE__ */ new Map();
        this._allInteractiveElements = [];
        this._hitElements = [];
        this._isPointerMoveEvent = false;
        this.rootTarget = rootTarget;
        this.hitPruneFn = this.hitPruneFn.bind(this);
        this.hitTestFn = this.hitTestFn.bind(this);
        this.mapPointerDown = this.mapPointerDown.bind(this);
        this.mapPointerMove = this.mapPointerMove.bind(this);
        this.mapPointerOut = this.mapPointerOut.bind(this);
        this.mapPointerOver = this.mapPointerOver.bind(this);
        this.mapPointerUp = this.mapPointerUp.bind(this);
        this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this);
        this.mapWheel = this.mapWheel.bind(this);
        this.mappingTable = {};
        this.addEventMapping("pointerdown", this.mapPointerDown);
        this.addEventMapping("pointermove", this.mapPointerMove);
        this.addEventMapping("pointerout", this.mapPointerOut);
        this.addEventMapping("pointerleave", this.mapPointerOut);
        this.addEventMapping("pointerover", this.mapPointerOver);
        this.addEventMapping("pointerup", this.mapPointerUp);
        this.addEventMapping("pointerupoutside", this.mapPointerUpOutside);
        this.addEventMapping("wheel", this.mapWheel);
    }
    addEventMapping(type, fn) {
        if (!this.mappingTable[type]) this.mappingTable[type] = [];
        this.mappingTable[type].push({
            fn: fn,
            priority: 0
        });
        this.mappingTable[type].sort((a, b)=>a.priority - b.priority);
    }
    dispatchEvent(e, type) {
        e.propagationStopped = false;
        e.propagationImmediatelyStopped = false;
        this.propagate(e, type);
        this.dispatch.emit(type || e.type, e);
    }
    mapEvent(e) {
        if (!this.rootTarget) return;
        const mappers = this.mappingTable[e.type];
        if (mappers) for(let i = 0, j = mappers.length; i < j; i++)mappers[i].fn(e);
        else console.warn(`[EventBoundary]: Event mapping not defined for ${e.type}`);
    }
    hitTest(x, y) {
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pauseUpdate = true;
        const useMove = this._isPointerMoveEvent && this.enableGlobalMoveEvents;
        const fn = useMove ? "hitTestMoveRecursive" : "hitTestRecursive";
        const invertedPath = this[fn](this.rootTarget, this.rootTarget.eventMode, $9fbf6b8539eddb2c$var$tempHitLocation.set(x, y), this.hitTestFn, this.hitPruneFn);
        return invertedPath && invertedPath[0];
    }
    propagate(e, type) {
        if (!e.target) return;
        const composedPath = e.composedPath();
        e.eventPhase = e.CAPTURING_PHASE;
        for(let i = 0, j = composedPath.length - 1; i < j; i++){
            e.currentTarget = composedPath[i];
            this.notifyTarget(e, type);
            if (e.propagationStopped || e.propagationImmediatelyStopped) return;
        }
        e.eventPhase = e.AT_TARGET;
        e.currentTarget = e.target;
        this.notifyTarget(e, type);
        if (e.propagationStopped || e.propagationImmediatelyStopped) return;
        e.eventPhase = e.BUBBLING_PHASE;
        for(let i = composedPath.length - 2; i >= 0; i--){
            e.currentTarget = composedPath[i];
            this.notifyTarget(e, type);
            if (e.propagationStopped || e.propagationImmediatelyStopped) return;
        }
    }
    all(e, type, targets = this._allInteractiveElements) {
        if (targets.length === 0) return;
        e.eventPhase = e.BUBBLING_PHASE;
        const events = Array.isArray(type) ? type : [
            type
        ];
        for(let i = targets.length - 1; i >= 0; i--)events.forEach((event)=>{
            e.currentTarget = targets[i];
            this.notifyTarget(e, event);
        });
    }
    propagationPath(target) {
        const propagationPath = [
            target
        ];
        for(let i = 0; i < $9fbf6b8539eddb2c$var$PROPAGATION_LIMIT && target !== this.rootTarget; i++){
            if (!target.parent) throw new Error("Cannot find propagation path to disconnected target");
            propagationPath.push(target.parent);
            target = target.parent;
        }
        propagationPath.reverse();
        return propagationPath;
    }
    hitTestMoveRecursive(currentTarget, eventMode, location, testFn, pruneFn, ignore = false) {
        let shouldReturn = false;
        if (this._interactivePrune(currentTarget)) return null;
        if (currentTarget.eventMode === "dynamic" || eventMode === "dynamic") (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pauseUpdate = false;
        if (currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i];
                const nestedHit = this.hitTestMoveRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn, ignore || pruneFn(currentTarget, location));
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    if (nestedHit.length > 0 || isInteractive) {
                        if (isInteractive) this._allInteractiveElements.push(currentTarget);
                        nestedHit.push(currentTarget);
                    }
                    if (this._hitElements.length === 0) this._hitElements = nestedHit;
                    shouldReturn = true;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode);
        const isInteractiveTarget = currentTarget.isInteractive();
        if (isInteractiveTarget && isInteractiveTarget) this._allInteractiveElements.push(currentTarget);
        if (ignore || this._hitElements.length > 0) return null;
        if (shouldReturn) return this._hitElements;
        if (isInteractiveMode && !pruneFn(currentTarget, location) && testFn(currentTarget, location)) return isInteractiveTarget ? [
            currentTarget
        ] : [];
        return null;
    }
    hitTestRecursive(currentTarget, eventMode, location, testFn, pruneFn) {
        if (this._interactivePrune(currentTarget) || pruneFn(currentTarget, location)) return null;
        if (currentTarget.eventMode === "dynamic" || eventMode === "dynamic") (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pauseUpdate = false;
        if (currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i];
                const nestedHit = this.hitTestRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn);
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    if (nestedHit.length > 0 || isInteractive) nestedHit.push(currentTarget);
                    return nestedHit;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode);
        const isInteractiveTarget = currentTarget.isInteractive();
        if (isInteractiveMode && testFn(currentTarget, location)) return isInteractiveTarget ? [
            currentTarget
        ] : [];
        return null;
    }
    _isInteractive(int) {
        return int === "static" || int === "dynamic";
    }
    _interactivePrune(displayObject) {
        if (!displayObject || displayObject.isMask || !displayObject.visible || !displayObject.renderable) return true;
        if (displayObject.eventMode === "none") return true;
        if (displayObject.eventMode === "passive" && !displayObject.interactiveChildren) return true;
        if (displayObject.isMask) return true;
        return false;
    }
    hitPruneFn(displayObject, location) {
        if (displayObject.hitArea) {
            displayObject.worldTransform.applyInverse(location, $9fbf6b8539eddb2c$var$tempLocalMapping);
            if (!displayObject.hitArea.contains($9fbf6b8539eddb2c$var$tempLocalMapping.x, $9fbf6b8539eddb2c$var$tempLocalMapping.y)) return true;
        }
        if (displayObject._mask) {
            const maskObject = displayObject._mask.isMaskData ? displayObject._mask.maskObject : displayObject._mask;
            if (maskObject && !maskObject.containsPoint?.(location)) return true;
        }
        return false;
    }
    hitTestFn(displayObject, location) {
        if (displayObject.eventMode === "passive") return false;
        if (displayObject.hitArea) return true;
        if (displayObject.containsPoint) return displayObject.containsPoint(location);
        return false;
    }
    notifyTarget(e, type) {
        type = type ?? e.type;
        const handlerKey = `on${type}`;
        e.currentTarget[handlerKey]?.(e);
        const key = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${type}capture` : type;
        this.notifyListeners(e, key);
        if (e.eventPhase === e.AT_TARGET) this.notifyListeners(e, type);
    }
    mapPointerDown(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const e = this.createPointerEvent(from);
        this.dispatchEvent(e, "pointerdown");
        if (e.pointerType === "touch") this.dispatchEvent(e, "touchstart");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightdown" : "mousedown");
        }
        const trackingData = this.trackingData(from.pointerId);
        trackingData.pressTargetsByButton[from.button] = e.composedPath();
        this.freeEvent(e);
    }
    mapPointerMove(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        this._allInteractiveElements.length = 0;
        this._hitElements.length = 0;
        this._isPointerMoveEvent = true;
        const e = this.createPointerEvent(from);
        this._isPointerMoveEvent = false;
        const isMouse = e.pointerType === "mouse" || e.pointerType === "pen";
        const trackingData = this.trackingData(from.pointerId);
        const outTarget = this.findMountedTarget(trackingData.overTargets);
        if (trackingData.overTargets?.length > 0 && outTarget !== e.target) {
            const outType = from.type === "mousemove" ? "mouseout" : "pointerout";
            const outEvent = this.createPointerEvent(from, outType, outTarget);
            this.dispatchEvent(outEvent, "pointerout");
            if (isMouse) this.dispatchEvent(outEvent, "mouseout");
            if (!e.composedPath().includes(outTarget)) {
                const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
                leaveEvent.eventPhase = leaveEvent.AT_TARGET;
                while(leaveEvent.target && !e.composedPath().includes(leaveEvent.target)){
                    leaveEvent.currentTarget = leaveEvent.target;
                    this.notifyTarget(leaveEvent);
                    if (isMouse) this.notifyTarget(leaveEvent, "mouseleave");
                    leaveEvent.target = leaveEvent.target.parent;
                }
                this.freeEvent(leaveEvent);
            }
            this.freeEvent(outEvent);
        }
        if (outTarget !== e.target) {
            const overType = from.type === "mousemove" ? "mouseover" : "pointerover";
            const overEvent = this.clonePointerEvent(e, overType);
            this.dispatchEvent(overEvent, "pointerover");
            if (isMouse) this.dispatchEvent(overEvent, "mouseover");
            let overTargetAncestor = outTarget?.parent;
            while(overTargetAncestor && overTargetAncestor !== this.rootTarget.parent){
                if (overTargetAncestor === e.target) break;
                overTargetAncestor = overTargetAncestor.parent;
            }
            const didPointerEnter = !overTargetAncestor || overTargetAncestor === this.rootTarget.parent;
            if (didPointerEnter) {
                const enterEvent = this.clonePointerEvent(e, "pointerenter");
                enterEvent.eventPhase = enterEvent.AT_TARGET;
                while(enterEvent.target && enterEvent.target !== outTarget && enterEvent.target !== this.rootTarget.parent){
                    enterEvent.currentTarget = enterEvent.target;
                    this.notifyTarget(enterEvent);
                    if (isMouse) this.notifyTarget(enterEvent, "mouseenter");
                    enterEvent.target = enterEvent.target.parent;
                }
                this.freeEvent(enterEvent);
            }
            this.freeEvent(overEvent);
        }
        const allMethods = [];
        const allowGlobalPointerEvents = this.enableGlobalMoveEvents ?? true;
        this.moveOnAll ? allMethods.push("pointermove") : this.dispatchEvent(e, "pointermove");
        allowGlobalPointerEvents && allMethods.push("globalpointermove");
        if (e.pointerType === "touch") {
            this.moveOnAll ? allMethods.splice(1, 0, "touchmove") : this.dispatchEvent(e, "touchmove");
            allowGlobalPointerEvents && allMethods.push("globaltouchmove");
        }
        if (isMouse) {
            this.moveOnAll ? allMethods.splice(1, 0, "mousemove") : this.dispatchEvent(e, "mousemove");
            allowGlobalPointerEvents && allMethods.push("globalmousemove");
            this.cursor = e.target?.cursor;
        }
        if (allMethods.length > 0) this.all(e, allMethods);
        this._allInteractiveElements.length = 0;
        this._hitElements.length = 0;
        trackingData.overTargets = e.composedPath();
        this.freeEvent(e);
    }
    mapPointerOver(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        const e = this.createPointerEvent(from);
        const isMouse = e.pointerType === "mouse" || e.pointerType === "pen";
        this.dispatchEvent(e, "pointerover");
        if (isMouse) this.dispatchEvent(e, "mouseover");
        if (e.pointerType === "mouse") this.cursor = e.target?.cursor;
        const enterEvent = this.clonePointerEvent(e, "pointerenter");
        enterEvent.eventPhase = enterEvent.AT_TARGET;
        while(enterEvent.target && enterEvent.target !== this.rootTarget.parent){
            enterEvent.currentTarget = enterEvent.target;
            this.notifyTarget(enterEvent);
            if (isMouse) this.notifyTarget(enterEvent, "mouseenter");
            enterEvent.target = enterEvent.target.parent;
        }
        trackingData.overTargets = e.composedPath();
        this.freeEvent(e);
        this.freeEvent(enterEvent);
    }
    mapPointerOut(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        if (trackingData.overTargets) {
            const isMouse = from.pointerType === "mouse" || from.pointerType === "pen";
            const outTarget = this.findMountedTarget(trackingData.overTargets);
            const outEvent = this.createPointerEvent(from, "pointerout", outTarget);
            this.dispatchEvent(outEvent);
            if (isMouse) this.dispatchEvent(outEvent, "mouseout");
            const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
            leaveEvent.eventPhase = leaveEvent.AT_TARGET;
            while(leaveEvent.target && leaveEvent.target !== this.rootTarget.parent){
                leaveEvent.currentTarget = leaveEvent.target;
                this.notifyTarget(leaveEvent);
                if (isMouse) this.notifyTarget(leaveEvent, "mouseleave");
                leaveEvent.target = leaveEvent.target.parent;
            }
            trackingData.overTargets = null;
            this.freeEvent(outEvent);
            this.freeEvent(leaveEvent);
        }
        this.cursor = null;
    }
    mapPointerUp(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const now = performance.now();
        const e = this.createPointerEvent(from);
        this.dispatchEvent(e, "pointerup");
        if (e.pointerType === "touch") this.dispatchEvent(e, "touchend");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightup" : "mouseup");
        }
        const trackingData = this.trackingData(from.pointerId);
        const pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
        let clickTarget = pressTarget;
        if (pressTarget && !e.composedPath().includes(pressTarget)) {
            let currentTarget = pressTarget;
            while(currentTarget && !e.composedPath().includes(currentTarget)){
                e.currentTarget = currentTarget;
                this.notifyTarget(e, "pointerupoutside");
                if (e.pointerType === "touch") this.notifyTarget(e, "touchendoutside");
                else if (e.pointerType === "mouse" || e.pointerType === "pen") {
                    const isRightButton = e.button === 2;
                    this.notifyTarget(e, isRightButton ? "rightupoutside" : "mouseupoutside");
                }
                currentTarget = currentTarget.parent;
            }
            delete trackingData.pressTargetsByButton[from.button];
            clickTarget = currentTarget;
        }
        if (clickTarget) {
            const clickEvent = this.clonePointerEvent(e, "click");
            clickEvent.target = clickTarget;
            clickEvent.path = null;
            if (!trackingData.clicksByButton[from.button]) trackingData.clicksByButton[from.button] = {
                clickCount: 0,
                target: clickEvent.target,
                timeStamp: now
            };
            const clickHistory = trackingData.clicksByButton[from.button];
            if (clickHistory.target === clickEvent.target && now - clickHistory.timeStamp < 200) ++clickHistory.clickCount;
            else clickHistory.clickCount = 1;
            clickHistory.target = clickEvent.target;
            clickHistory.timeStamp = now;
            clickEvent.detail = clickHistory.clickCount;
            if (clickEvent.pointerType === "mouse") {
                const isRightButton = clickEvent.button === 2;
                this.dispatchEvent(clickEvent, isRightButton ? "rightclick" : "click");
            } else if (clickEvent.pointerType === "touch") this.dispatchEvent(clickEvent, "tap");
            this.dispatchEvent(clickEvent, "pointertap");
            this.freeEvent(clickEvent);
        }
        this.freeEvent(e);
    }
    mapPointerUpOutside(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        const pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
        const e = this.createPointerEvent(from);
        if (pressTarget) {
            let currentTarget = pressTarget;
            while(currentTarget){
                e.currentTarget = currentTarget;
                this.notifyTarget(e, "pointerupoutside");
                if (e.pointerType === "touch") this.notifyTarget(e, "touchendoutside");
                else if (e.pointerType === "mouse" || e.pointerType === "pen") this.notifyTarget(e, e.button === 2 ? "rightupoutside" : "mouseupoutside");
                currentTarget = currentTarget.parent;
            }
            delete trackingData.pressTargetsByButton[from.button];
        }
        this.freeEvent(e);
    }
    mapWheel(from) {
        if (!(from instanceof (0, $7893cac0982b7958$export$1fd8b94eb532974d))) {
            console.warn("EventBoundary cannot map a non-wheel event as a wheel event");
            return;
        }
        const wheelEvent = this.createWheelEvent(from);
        this.dispatchEvent(wheelEvent);
        this.freeEvent(wheelEvent);
    }
    findMountedTarget(propagationPath) {
        if (!propagationPath) return null;
        let currentTarget = propagationPath[0];
        for(let i = 1; i < propagationPath.length; i++){
            if (propagationPath[i].parent === currentTarget) currentTarget = propagationPath[i];
            else break;
        }
        return currentTarget;
    }
    createPointerEvent(from, type, target) {
        const event = this.allocateEvent((0, $52ba6cd103d3e195$export$44ac16aa0ab81db6));
        this.copyPointerData(from, event);
        this.copyMouseData(from, event);
        this.copyData(from, event);
        event.nativeEvent = from.nativeEvent;
        event.originalEvent = from;
        event.target = target ?? this.hitTest(event.global.x, event.global.y) ?? this._hitElements[0];
        if (typeof type === "string") event.type = type;
        return event;
    }
    createWheelEvent(from) {
        const event = this.allocateEvent((0, $7893cac0982b7958$export$1fd8b94eb532974d));
        this.copyWheelData(from, event);
        this.copyMouseData(from, event);
        this.copyData(from, event);
        event.nativeEvent = from.nativeEvent;
        event.originalEvent = from;
        event.target = this.hitTest(event.global.x, event.global.y);
        return event;
    }
    clonePointerEvent(from, type) {
        const event = this.allocateEvent((0, $52ba6cd103d3e195$export$44ac16aa0ab81db6));
        event.nativeEvent = from.nativeEvent;
        event.originalEvent = from.originalEvent;
        this.copyPointerData(from, event);
        this.copyMouseData(from, event);
        this.copyData(from, event);
        event.target = from.target;
        event.path = from.composedPath().slice();
        event.type = type ?? event.type;
        return event;
    }
    copyWheelData(from, to) {
        to.deltaMode = from.deltaMode;
        to.deltaX = from.deltaX;
        to.deltaY = from.deltaY;
        to.deltaZ = from.deltaZ;
    }
    copyPointerData(from, to) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6) && to instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) return;
        to.pointerId = from.pointerId;
        to.width = from.width;
        to.height = from.height;
        to.isPrimary = from.isPrimary;
        to.pointerType = from.pointerType;
        to.pressure = from.pressure;
        to.tangentialPressure = from.tangentialPressure;
        to.tiltX = from.tiltX;
        to.tiltY = from.tiltY;
        to.twist = from.twist;
    }
    copyMouseData(from, to) {
        if (!(from instanceof (0, $d3ec2a7353cfb785$export$aeb79caab92d155a) && to instanceof (0, $d3ec2a7353cfb785$export$aeb79caab92d155a))) return;
        to.altKey = from.altKey;
        to.button = from.button;
        to.buttons = from.buttons;
        to.client.copyFrom(from.client);
        to.ctrlKey = from.ctrlKey;
        to.metaKey = from.metaKey;
        to.movement.copyFrom(from.movement);
        to.screen.copyFrom(from.screen);
        to.shiftKey = from.shiftKey;
        to.global.copyFrom(from.global);
    }
    copyData(from, to) {
        to.isTrusted = from.isTrusted;
        to.srcElement = from.srcElement;
        to.timeStamp = performance.now();
        to.type = from.type;
        to.detail = from.detail;
        to.view = from.view;
        to.which = from.which;
        to.layer.copyFrom(from.layer);
        to.page.copyFrom(from.page);
    }
    trackingData(id) {
        if (!this.mappingState.trackingData[id]) this.mappingState.trackingData[id] = {
            pressTargetsByButton: {},
            clicksByButton: {},
            overTarget: null
        };
        return this.mappingState.trackingData[id];
    }
    allocateEvent(constructor) {
        if (!this.eventPool.has(constructor)) this.eventPool.set(constructor, []);
        const event = this.eventPool.get(constructor).pop() || new constructor(this);
        event.eventPhase = event.NONE;
        event.currentTarget = null;
        event.path = null;
        event.target = null;
        return event;
    }
    freeEvent(event) {
        if (event.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
        const constructor = event.constructor;
        if (!this.eventPool.has(constructor)) this.eventPool.set(constructor, []);
        this.eventPool.get(constructor).push(event);
    }
    notifyListeners(e, type) {
        const listeners = e.currentTarget._events[type];
        if (!listeners) return;
        if (!e.currentTarget.isInteractive()) return;
        if ("fn" in listeners) {
            if (listeners.once) e.currentTarget.removeListener(type, listeners.fn, void 0, true);
            listeners.fn.call(listeners.context, e);
        } else for(let i = 0, j = listeners.length; i < j && !e.propagationImmediatelyStopped; i++){
            if (listeners[i].once) e.currentTarget.removeListener(type, listeners[i].fn, void 0, true);
            listeners[i].fn.call(listeners[i].context, e);
        }
    }
}







const $8e6543b2c08741df$var$MOUSE_POINTER_ID = 1;
const $8e6543b2c08741df$var$TOUCH_TO_POINTER = {
    touchstart: "pointerdown",
    touchend: "pointerup",
    touchendoutside: "pointerupoutside",
    touchmove: "pointermove",
    touchcancel: "pointercancel"
};
const $8e6543b2c08741df$var$_EventSystem = class {
    constructor(renderer){
        this.supportsTouchEvents = "ontouchstart" in globalThis;
        this.supportsPointerEvents = !!globalThis.PointerEvent;
        this.domElement = null;
        this.resolution = 1;
        this.renderer = renderer;
        this.rootBoundary = new (0, $9fbf6b8539eddb2c$export$532e8c243078d2cd)(null);
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).init(this);
        this.autoPreventDefault = true;
        this.eventsAdded = false;
        this.rootPointerEvent = new (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6)(null);
        this.rootWheelEvent = new (0, $7893cac0982b7958$export$1fd8b94eb532974d)(null);
        this.cursorStyles = {
            default: "inherit",
            pointer: "pointer"
        };
        this.features = new Proxy({
            ...$8e6543b2c08741df$var$_EventSystem.defaultEventFeatures
        }, {
            set: (target, key, value)=>{
                if (key === "globalMove") this.rootBoundary.enableGlobalMoveEvents = value;
                target[key] = value;
                return true;
            }
        });
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onPointerOverOut = this.onPointerOverOut.bind(this);
        this.onWheel = this.onWheel.bind(this);
    }
    static get defaultEventMode() {
        return this._defaultEventMode;
    }
    init(options) {
        const { view: view , resolution: resolution  } = this.renderer;
        this.setTargetElement(view);
        this.resolution = resolution;
        $8e6543b2c08741df$var$_EventSystem._defaultEventMode = options.eventMode ?? "auto";
        Object.assign(this.features, options.eventFeatures ?? {});
        this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
    }
    resolutionChange(resolution) {
        this.resolution = resolution;
    }
    destroy() {
        this.setTargetElement(null);
        this.renderer = null;
    }
    setCursor(mode) {
        mode = mode || "default";
        let applyStyles = true;
        if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas) applyStyles = false;
        if (this.currentCursor === mode) return;
        this.currentCursor = mode;
        const style = this.cursorStyles[mode];
        if (style) switch(typeof style){
            case "string":
                if (applyStyles) this.domElement.style.cursor = style;
                break;
            case "function":
                style(mode);
                break;
            case "object":
                if (applyStyles) Object.assign(this.domElement.style, style);
                break;
        }
        else if (applyStyles && typeof mode === "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) this.domElement.style.cursor = mode;
    }
    get pointer() {
        return this.rootPointerEvent;
    }
    onPointerDown(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        if (this.supportsTouchEvents && nativeEvent.pointerType === "touch") return;
        const events = this.normalizeToPointerData(nativeEvent);
        if (this.autoPreventDefault && events[0].isNormalized) {
            const cancelable = nativeEvent.cancelable || !("cancelable" in nativeEvent);
            if (cancelable) nativeEvent.preventDefault();
        }
        for(let i = 0, j = events.length; i < j; i++){
            const nativeEvent2 = events[i];
            const federatedEvent = this.bootstrapEvent(this.rootPointerEvent, nativeEvent2);
            this.rootBoundary.mapEvent(federatedEvent);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    onPointerMove(nativeEvent) {
        if (!this.features.move) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        if (this.supportsTouchEvents && nativeEvent.pointerType === "touch") return;
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pointerMoved();
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    onPointerUp(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        if (this.supportsTouchEvents && nativeEvent.pointerType === "touch") return;
        let target = nativeEvent.target;
        if (nativeEvent.composedPath && nativeEvent.composedPath().length > 0) target = nativeEvent.composedPath()[0];
        const outside = target !== this.domElement ? "outside" : "";
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            event.type += outside;
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    onPointerOverOut(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        if (this.supportsTouchEvents && nativeEvent.pointerType === "touch") return;
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    onWheel(nativeEvent) {
        if (!this.features.wheel) return;
        const wheelEvent = this.normalizeWheelEvent(nativeEvent);
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        this.rootBoundary.mapEvent(wheelEvent);
    }
    setTargetElement(element) {
        this.removeEvents();
        this.domElement = element;
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).domElement = element;
        this.addEvents();
    }
    addEvents() {
        if (this.eventsAdded || !this.domElement) return;
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).addTickerListener();
        const style = this.domElement.style;
        if (style) {
            if (globalThis.navigator.msPointerEnabled) {
                style.msContentZooming = "none";
                style.msTouchAction = "none";
            } else if (this.supportsPointerEvents) style.touchAction = "none";
        }
        if (this.supportsPointerEvents) {
            globalThis.document.addEventListener("pointermove", this.onPointerMove, true);
            this.domElement.addEventListener("pointerdown", this.onPointerDown, true);
            this.domElement.addEventListener("pointerleave", this.onPointerOverOut, true);
            this.domElement.addEventListener("pointerover", this.onPointerOverOut, true);
            globalThis.addEventListener("pointerup", this.onPointerUp, true);
        } else {
            globalThis.document.addEventListener("mousemove", this.onPointerMove, true);
            this.domElement.addEventListener("mousedown", this.onPointerDown, true);
            this.domElement.addEventListener("mouseout", this.onPointerOverOut, true);
            this.domElement.addEventListener("mouseover", this.onPointerOverOut, true);
            globalThis.addEventListener("mouseup", this.onPointerUp, true);
        }
        if (this.supportsTouchEvents) {
            this.domElement.addEventListener("touchstart", this.onPointerDown, true);
            this.domElement.addEventListener("touchend", this.onPointerUp, true);
            this.domElement.addEventListener("touchmove", this.onPointerMove, true);
        }
        this.domElement.addEventListener("wheel", this.onWheel, {
            passive: true,
            capture: true
        });
        this.eventsAdded = true;
    }
    removeEvents() {
        if (!this.eventsAdded || !this.domElement) return;
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).removeTickerListener();
        const style = this.domElement.style;
        if (globalThis.navigator.msPointerEnabled) {
            style.msContentZooming = "";
            style.msTouchAction = "";
        } else if (this.supportsPointerEvents) style.touchAction = "";
        if (this.supportsPointerEvents) {
            globalThis.document.removeEventListener("pointermove", this.onPointerMove, true);
            this.domElement.removeEventListener("pointerdown", this.onPointerDown, true);
            this.domElement.removeEventListener("pointerleave", this.onPointerOverOut, true);
            this.domElement.removeEventListener("pointerover", this.onPointerOverOut, true);
            globalThis.removeEventListener("pointerup", this.onPointerUp, true);
        } else {
            globalThis.document.removeEventListener("mousemove", this.onPointerMove, true);
            this.domElement.removeEventListener("mousedown", this.onPointerDown, true);
            this.domElement.removeEventListener("mouseout", this.onPointerOverOut, true);
            this.domElement.removeEventListener("mouseover", this.onPointerOverOut, true);
            globalThis.removeEventListener("mouseup", this.onPointerUp, true);
        }
        if (this.supportsTouchEvents) {
            this.domElement.removeEventListener("touchstart", this.onPointerDown, true);
            this.domElement.removeEventListener("touchend", this.onPointerUp, true);
            this.domElement.removeEventListener("touchmove", this.onPointerMove, true);
        }
        this.domElement.removeEventListener("wheel", this.onWheel, true);
        this.domElement = null;
        this.eventsAdded = false;
    }
    mapPositionToPoint(point, x, y) {
        let rect;
        if (!this.domElement.parentElement) rect = {
            x: 0,
            y: 0,
            width: this.domElement.width,
            height: this.domElement.height,
            left: 0,
            top: 0
        };
        else rect = this.domElement.getBoundingClientRect();
        const resolutionMultiplier = 1 / this.resolution;
        point.x = (x - rect.left) * (this.domElement.width / rect.width) * resolutionMultiplier;
        point.y = (y - rect.top) * (this.domElement.height / rect.height) * resolutionMultiplier;
    }
    normalizeToPointerData(event) {
        const normalizedEvents = [];
        if (this.supportsTouchEvents && event instanceof TouchEvent) for(let i = 0, li = event.changedTouches.length; i < li; i++){
            const touch = event.changedTouches[i];
            if (typeof touch.button === "undefined") touch.button = 0;
            if (typeof touch.buttons === "undefined") touch.buttons = 1;
            if (typeof touch.isPrimary === "undefined") touch.isPrimary = event.touches.length === 1 && event.type === "touchstart";
            if (typeof touch.width === "undefined") touch.width = touch.radiusX || 1;
            if (typeof touch.height === "undefined") touch.height = touch.radiusY || 1;
            if (typeof touch.tiltX === "undefined") touch.tiltX = 0;
            if (typeof touch.tiltY === "undefined") touch.tiltY = 0;
            if (typeof touch.pointerType === "undefined") touch.pointerType = "touch";
            if (typeof touch.pointerId === "undefined") touch.pointerId = touch.identifier || 0;
            if (typeof touch.pressure === "undefined") touch.pressure = touch.force || 0.5;
            if (typeof touch.twist === "undefined") touch.twist = 0;
            if (typeof touch.tangentialPressure === "undefined") touch.tangentialPressure = 0;
            if (typeof touch.layerX === "undefined") touch.layerX = touch.offsetX = touch.clientX;
            if (typeof touch.layerY === "undefined") touch.layerY = touch.offsetY = touch.clientY;
            touch.isNormalized = true;
            touch.type = event.type;
            normalizedEvents.push(touch);
        }
        else if (!globalThis.MouseEvent || event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof globalThis.PointerEvent))) {
            const tempEvent = event;
            if (typeof tempEvent.isPrimary === "undefined") tempEvent.isPrimary = true;
            if (typeof tempEvent.width === "undefined") tempEvent.width = 1;
            if (typeof tempEvent.height === "undefined") tempEvent.height = 1;
            if (typeof tempEvent.tiltX === "undefined") tempEvent.tiltX = 0;
            if (typeof tempEvent.tiltY === "undefined") tempEvent.tiltY = 0;
            if (typeof tempEvent.pointerType === "undefined") tempEvent.pointerType = "mouse";
            if (typeof tempEvent.pointerId === "undefined") tempEvent.pointerId = $8e6543b2c08741df$var$MOUSE_POINTER_ID;
            if (typeof tempEvent.pressure === "undefined") tempEvent.pressure = 0.5;
            if (typeof tempEvent.twist === "undefined") tempEvent.twist = 0;
            if (typeof tempEvent.tangentialPressure === "undefined") tempEvent.tangentialPressure = 0;
            tempEvent.isNormalized = true;
            normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    }
    normalizeWheelEvent(nativeEvent) {
        const event = this.rootWheelEvent;
        this.transferMouseData(event, nativeEvent);
        event.deltaX = nativeEvent.deltaX;
        event.deltaY = nativeEvent.deltaY;
        event.deltaZ = nativeEvent.deltaZ;
        event.deltaMode = nativeEvent.deltaMode;
        this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY);
        event.global.copyFrom(event.screen);
        event.offset.copyFrom(event.screen);
        event.nativeEvent = nativeEvent;
        event.type = nativeEvent.type;
        return event;
    }
    bootstrapEvent(event, nativeEvent) {
        event.originalEvent = null;
        event.nativeEvent = nativeEvent;
        event.pointerId = nativeEvent.pointerId;
        event.width = nativeEvent.width;
        event.height = nativeEvent.height;
        event.isPrimary = nativeEvent.isPrimary;
        event.pointerType = nativeEvent.pointerType;
        event.pressure = nativeEvent.pressure;
        event.tangentialPressure = nativeEvent.tangentialPressure;
        event.tiltX = nativeEvent.tiltX;
        event.tiltY = nativeEvent.tiltY;
        event.twist = nativeEvent.twist;
        this.transferMouseData(event, nativeEvent);
        this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY);
        event.global.copyFrom(event.screen);
        event.offset.copyFrom(event.screen);
        event.isTrusted = nativeEvent.isTrusted;
        if (event.type === "pointerleave") event.type = "pointerout";
        if (event.type.startsWith("mouse")) event.type = event.type.replace("mouse", "pointer");
        if (event.type.startsWith("touch")) event.type = $8e6543b2c08741df$var$TOUCH_TO_POINTER[event.type] || event.type;
        return event;
    }
    transferMouseData(event, nativeEvent) {
        event.isTrusted = nativeEvent.isTrusted;
        event.srcElement = nativeEvent.srcElement;
        event.timeStamp = performance.now();
        event.type = nativeEvent.type;
        event.altKey = nativeEvent.altKey;
        event.button = nativeEvent.button;
        event.buttons = nativeEvent.buttons;
        event.client.x = nativeEvent.clientX;
        event.client.y = nativeEvent.clientY;
        event.ctrlKey = nativeEvent.ctrlKey;
        event.metaKey = nativeEvent.metaKey;
        event.movement.x = nativeEvent.movementX;
        event.movement.y = nativeEvent.movementY;
        event.page.x = nativeEvent.pageX;
        event.page.y = nativeEvent.pageY;
        event.relatedTarget = null;
        event.shiftKey = nativeEvent.shiftKey;
    }
};
let $8e6543b2c08741df$export$bf477d624b56bf15 = $8e6543b2c08741df$var$_EventSystem;
$8e6543b2c08741df$export$bf477d624b56bf15.extension = {
    name: "events",
    type: [
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ]
};
$8e6543b2c08741df$export$bf477d624b56bf15.defaultEventFeatures = {
    move: true,
    globalMove: true,
    click: true,
    wheel: true
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($8e6543b2c08741df$export$bf477d624b56bf15);









function $603ddb200f76e809$var$convertEventModeToInteractiveMode(mode) {
    return mode === "dynamic" || mode === "static";
}
const $603ddb200f76e809$export$6a5b99a7f30af1d9 = {
    onclick: null,
    onmousedown: null,
    onmouseenter: null,
    onmouseleave: null,
    onmousemove: null,
    onglobalmousemove: null,
    onmouseout: null,
    onmouseover: null,
    onmouseup: null,
    onmouseupoutside: null,
    onpointercancel: null,
    onpointerdown: null,
    onpointerenter: null,
    onpointerleave: null,
    onpointermove: null,
    onglobalpointermove: null,
    onpointerout: null,
    onpointerover: null,
    onpointertap: null,
    onpointerup: null,
    onpointerupoutside: null,
    onrightclick: null,
    onrightdown: null,
    onrightup: null,
    onrightupoutside: null,
    ontap: null,
    ontouchcancel: null,
    ontouchend: null,
    ontouchendoutside: null,
    ontouchmove: null,
    onglobaltouchmove: null,
    ontouchstart: null,
    onwheel: null,
    _internalInteractive: void 0,
    get interactive () {
        return this._internalInteractive ?? $603ddb200f76e809$var$convertEventModeToInteractiveMode((0, $8e6543b2c08741df$export$bf477d624b56bf15).defaultEventMode);
    },
    set interactive (value){
        (0, $5d808cc4b6a3c326$exports).deprecation("7.2.0", `Setting interactive is deprecated, use eventMode = 'none'/'passive'/'auto'/'static'/'dynamic' instead.`);
        this._internalInteractive = value;
        this.eventMode = value ? "static" : "auto";
    },
    _internalEventMode: void 0,
    get eventMode () {
        return this._internalEventMode ?? (0, $8e6543b2c08741df$export$bf477d624b56bf15).defaultEventMode;
    },
    set eventMode (value){
        this._internalInteractive = $603ddb200f76e809$var$convertEventModeToInteractiveMode(value);
        this._internalEventMode = value;
    },
    isInteractive () {
        return this.eventMode === "static" || this.eventMode === "dynamic";
    },
    interactiveChildren: true,
    hitArea: null,
    addEventListener (type, listener, options) {
        const capture = typeof options === "boolean" && options || typeof options === "object" && options.capture;
        const context = typeof listener === "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type;
        listener = typeof listener === "function" ? listener : listener.handleEvent;
        this.on(type, listener, context);
    },
    removeEventListener (type, listener, options) {
        const capture = typeof options === "boolean" && options || typeof options === "object" && options.capture;
        const context = typeof listener === "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type;
        listener = typeof listener === "function" ? listener : listener.handleEvent;
        this.off(type, listener, context);
    },
    dispatchEvent (e) {
        if (!(e instanceof (0, $26b8e1b052f7f249$export$5d10db92bb959d8a))) throw new Error("DisplayObject cannot propagate events outside of the Federated Events API");
        e.defaultPrevented = false;
        e.path = null;
        e.target = this;
        e.manager.dispatchEvent(e);
        return !e.defaultPrevented;
    }
};
(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).mixin($603ddb200f76e809$export$6a5b99a7f30af1d9);







const $3164dd00f6aa85db$export$2c6c5fc5694bba8e = {
    accessible: false,
    accessibleTitle: null,
    accessibleHint: null,
    tabIndex: 0,
    _accessibleActive: false,
    _accessibleDiv: null,
    accessibleType: "button",
    accessiblePointerEvents: "auto",
    accessibleChildren: true,
    renderId: -1
};


(0, $93bf10443ce4ab2c$export$1f679544f90d7d7c).mixin((0, $3164dd00f6aa85db$export$2c6c5fc5694bba8e));
const $cd5971328eee02ab$var$KEY_CODE_TAB = 9;
const $cd5971328eee02ab$var$DIV_TOUCH_SIZE = 100;
const $cd5971328eee02ab$var$DIV_TOUCH_POS_X = 0;
const $cd5971328eee02ab$var$DIV_TOUCH_POS_Y = 0;
const $cd5971328eee02ab$var$DIV_TOUCH_ZINDEX = 2;
const $cd5971328eee02ab$var$DIV_HOOK_SIZE = 1;
const $cd5971328eee02ab$var$DIV_HOOK_POS_X = -1000;
const $cd5971328eee02ab$var$DIV_HOOK_POS_Y = -1000;
const $cd5971328eee02ab$var$DIV_HOOK_ZINDEX = 2;
class $cd5971328eee02ab$export$a2c2de1efa8671eb {
    constructor(renderer){
        this.debug = false;
        this._isActive = false;
        this._isMobileAccessibility = false;
        this.pool = [];
        this.renderId = 0;
        this.children = [];
        this.androidUpdateCount = 0;
        this.androidUpdateFrequency = 500;
        this._hookDiv = null;
        if ((0, $5d808cc4b6a3c326$exports).isMobile.tablet || (0, $5d808cc4b6a3c326$exports).isMobile.phone) this.createTouchHook();
        const div = document.createElement("div");
        div.style.width = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`;
        div.style.height = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`;
        div.style.position = "absolute";
        div.style.top = `${$cd5971328eee02ab$var$DIV_TOUCH_POS_X}px`;
        div.style.left = `${$cd5971328eee02ab$var$DIV_TOUCH_POS_Y}px`;
        div.style.zIndex = $cd5971328eee02ab$var$DIV_TOUCH_ZINDEX.toString();
        this.div = div;
        this.renderer = renderer;
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onMouseMove = this._onMouseMove.bind(this);
        globalThis.addEventListener("keydown", this._onKeyDown, false);
    }
    get isActive() {
        return this._isActive;
    }
    get isMobileAccessibility() {
        return this._isMobileAccessibility;
    }
    createTouchHook() {
        const hookDiv = document.createElement("button");
        hookDiv.style.width = `${$cd5971328eee02ab$var$DIV_HOOK_SIZE}px`;
        hookDiv.style.height = `${$cd5971328eee02ab$var$DIV_HOOK_SIZE}px`;
        hookDiv.style.position = "absolute";
        hookDiv.style.top = `${$cd5971328eee02ab$var$DIV_HOOK_POS_X}px`;
        hookDiv.style.left = `${$cd5971328eee02ab$var$DIV_HOOK_POS_Y}px`;
        hookDiv.style.zIndex = $cd5971328eee02ab$var$DIV_HOOK_ZINDEX.toString();
        hookDiv.style.backgroundColor = "#FF0000";
        hookDiv.title = "select to enable accessibility for this content";
        hookDiv.addEventListener("focus", ()=>{
            this._isMobileAccessibility = true;
            this.activate();
            this.destroyTouchHook();
        });
        document.body.appendChild(hookDiv);
        this._hookDiv = hookDiv;
    }
    destroyTouchHook() {
        if (!this._hookDiv) return;
        document.body.removeChild(this._hookDiv);
        this._hookDiv = null;
    }
    activate() {
        if (this._isActive) return;
        this._isActive = true;
        globalThis.document.addEventListener("mousemove", this._onMouseMove, true);
        globalThis.removeEventListener("keydown", this._onKeyDown, false);
        this.renderer.on("postrender", this.update, this);
        this.renderer.view.parentNode?.appendChild(this.div);
    }
    deactivate() {
        if (!this._isActive || this._isMobileAccessibility) return;
        this._isActive = false;
        globalThis.document.removeEventListener("mousemove", this._onMouseMove, true);
        globalThis.addEventListener("keydown", this._onKeyDown, false);
        this.renderer.off("postrender", this.update);
        this.div.parentNode?.removeChild(this.div);
    }
    updateAccessibleObjects(displayObject) {
        if (!displayObject.visible || !displayObject.accessibleChildren) return;
        if (displayObject.accessible && displayObject.isInteractive()) {
            if (!displayObject._accessibleActive) this.addChild(displayObject);
            displayObject.renderId = this.renderId;
        }
        const children = displayObject.children;
        if (children) for(let i = 0; i < children.length; i++)this.updateAccessibleObjects(children[i]);
    }
    update() {
        const now = performance.now();
        if ((0, $5d808cc4b6a3c326$exports).isMobile.android.device && now < this.androidUpdateCount) return;
        this.androidUpdateCount = now + this.androidUpdateFrequency;
        if (!this.renderer.renderingToScreen) return;
        if (this.renderer.lastObjectRendered) this.updateAccessibleObjects(this.renderer.lastObjectRendered);
        const { x: x , y: y , width: width , height: height  } = this.renderer.view.getBoundingClientRect();
        const { width: viewWidth , height: viewHeight , resolution: resolution  } = this.renderer;
        const sx = width / viewWidth * resolution;
        const sy = height / viewHeight * resolution;
        let div = this.div;
        div.style.left = `${x}px`;
        div.style.top = `${y}px`;
        div.style.width = `${viewWidth}px`;
        div.style.height = `${viewHeight}px`;
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (child.renderId !== this.renderId) {
                child._accessibleActive = false;
                (0, $5d808cc4b6a3c326$exports).removeItems(this.children, i, 1);
                this.div.removeChild(child._accessibleDiv);
                this.pool.push(child._accessibleDiv);
                child._accessibleDiv = null;
                i--;
            } else {
                div = child._accessibleDiv;
                let hitArea = child.hitArea;
                const wt = child.worldTransform;
                if (child.hitArea) {
                    div.style.left = `${(wt.tx + hitArea.x * wt.a) * sx}px`;
                    div.style.top = `${(wt.ty + hitArea.y * wt.d) * sy}px`;
                    div.style.width = `${hitArea.width * wt.a * sx}px`;
                    div.style.height = `${hitArea.height * wt.d * sy}px`;
                } else {
                    hitArea = child.getBounds();
                    this.capHitArea(hitArea);
                    div.style.left = `${hitArea.x * sx}px`;
                    div.style.top = `${hitArea.y * sy}px`;
                    div.style.width = `${hitArea.width * sx}px`;
                    div.style.height = `${hitArea.height * sy}px`;
                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) div.title = child.accessibleTitle;
                    if (div.getAttribute("aria-label") !== child.accessibleHint && child.accessibleHint !== null) div.setAttribute("aria-label", child.accessibleHint);
                }
                if (child.accessibleTitle !== div.title || child.tabIndex !== div.tabIndex) {
                    div.title = child.accessibleTitle;
                    div.tabIndex = child.tabIndex;
                    if (this.debug) this.updateDebugHTML(div);
                }
            }
        }
        this.renderId++;
    }
    updateDebugHTML(div) {
        div.innerHTML = `type: ${div.type}</br> title : ${div.title}</br> tabIndex: ${div.tabIndex}`;
    }
    capHitArea(hitArea) {
        if (hitArea.x < 0) {
            hitArea.width += hitArea.x;
            hitArea.x = 0;
        }
        if (hitArea.y < 0) {
            hitArea.height += hitArea.y;
            hitArea.y = 0;
        }
        const { width: viewWidth , height: viewHeight  } = this.renderer;
        if (hitArea.x + hitArea.width > viewWidth) hitArea.width = viewWidth - hitArea.x;
        if (hitArea.y + hitArea.height > viewHeight) hitArea.height = viewHeight - hitArea.y;
    }
    addChild(displayObject) {
        let div = this.pool.pop();
        if (!div) {
            div = document.createElement("button");
            div.style.width = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`;
            div.style.height = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`;
            div.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent";
            div.style.position = "absolute";
            div.style.zIndex = $cd5971328eee02ab$var$DIV_TOUCH_ZINDEX.toString();
            div.style.borderStyle = "none";
            if (navigator.userAgent.toLowerCase().includes("chrome")) div.setAttribute("aria-live", "off");
            else div.setAttribute("aria-live", "polite");
            if (navigator.userAgent.match(/rv:.*Gecko\//)) div.setAttribute("aria-relevant", "additions");
            else div.setAttribute("aria-relevant", "text");
            div.addEventListener("click", this._onClick.bind(this));
            div.addEventListener("focus", this._onFocus.bind(this));
            div.addEventListener("focusout", this._onFocusOut.bind(this));
        }
        div.style.pointerEvents = displayObject.accessiblePointerEvents;
        div.type = displayObject.accessibleType;
        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) div.title = displayObject.accessibleTitle;
        else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) div.title = `displayObject ${displayObject.tabIndex}`;
        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) div.setAttribute("aria-label", displayObject.accessibleHint);
        if (this.debug) this.updateDebugHTML(div);
        displayObject._accessibleActive = true;
        displayObject._accessibleDiv = div;
        div.displayObject = displayObject;
        this.children.push(displayObject);
        this.div.appendChild(displayObject._accessibleDiv);
        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    }
    _dispatchEvent(e, type) {
        const { displayObject: target  } = e.target;
        const boundry = this.renderer.events.rootBoundary;
        const event = Object.assign(new (0, $26b8e1b052f7f249$export$5d10db92bb959d8a)(boundry), {
            target: target
        });
        boundry.rootTarget = this.renderer.lastObjectRendered;
        type.forEach((type2)=>boundry.dispatchEvent(event, type2));
    }
    _onClick(e) {
        this._dispatchEvent(e, [
            "click",
            "pointertap",
            "tap"
        ]);
    }
    _onFocus(e) {
        if (!e.target.getAttribute("aria-live")) e.target.setAttribute("aria-live", "assertive");
        this._dispatchEvent(e, [
            "mouseover"
        ]);
    }
    _onFocusOut(e) {
        if (!e.target.getAttribute("aria-live")) e.target.setAttribute("aria-live", "polite");
        this._dispatchEvent(e, [
            "mouseout"
        ]);
    }
    _onKeyDown(e) {
        if (e.keyCode !== $cd5971328eee02ab$var$KEY_CODE_TAB) return;
        this.activate();
    }
    _onMouseMove(e) {
        if (e.movementX === 0 && e.movementY === 0) return;
        this.deactivate();
    }
    destroy() {
        this.destroyTouchHook();
        this.div = null;
        globalThis.document.removeEventListener("mousemove", this._onMouseMove, true);
        globalThis.removeEventListener("keydown", this._onKeyDown);
        this.pool = null;
        this.children = null;
        this.renderer = null;
    }
}
$cd5971328eee02ab$export$a2c2de1efa8671eb.extension = {
    name: "accessibility",
    type: [
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererPlugin,
        (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CanvasRendererPlugin
    ]
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($cd5971328eee02ab$export$a2c2de1efa8671eb);







const $1495858258e0a7a4$var$_Application = class {
    constructor(options){
        this.stage = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        options = Object.assign({
            forceCanvas: false
        }, options);
        this.renderer = (0, $562052ee832f105e$export$3583b92ab8150eb6)(options);
        $1495858258e0a7a4$var$_Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    render() {
        this.renderer.render(this.stage);
    }
    get view() {
        return this.renderer.view;
    }
    get screen() {
        return this.renderer.screen;
    }
    destroy(removeView, stageOptions) {
        const plugins = $1495858258e0a7a4$var$_Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(stageOptions);
        this.stage = null;
        this.renderer.destroy(removeView);
        this.renderer = null;
    }
};
let $1495858258e0a7a4$export$16975c34e60e1e61 = $1495858258e0a7a4$var$_Application;
$1495858258e0a7a4$export$16975c34e60e1e61._plugins = [];
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).handleByList((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).Application, $1495858258e0a7a4$export$16975c34e60e1e61._plugins);



class $57d95d4aa6d373bc$export$6453cd852defe94a {
    static init(options) {
        Object.defineProperty(this, "resizeTo", {
            set (dom) {
                globalThis.removeEventListener("resize", this.queueResize);
                this._resizeTo = dom;
                if (dom) {
                    globalThis.addEventListener("resize", this.queueResize);
                    this.resize();
                }
            },
            get () {
                return this._resizeTo;
            }
        });
        this.queueResize = ()=>{
            if (!this._resizeTo) return;
            this.cancelResize();
            this._resizeId = requestAnimationFrame(()=>this.resize());
        };
        this.cancelResize = ()=>{
            if (this._resizeId) {
                cancelAnimationFrame(this._resizeId);
                this._resizeId = null;
            }
        };
        this.resize = ()=>{
            if (!this._resizeTo) return;
            this.cancelResize();
            let width;
            let height;
            if (this._resizeTo === globalThis.window) {
                width = globalThis.innerWidth;
                height = globalThis.innerHeight;
            } else {
                const { clientWidth: clientWidth , clientHeight: clientHeight  } = this._resizeTo;
                width = clientWidth;
                height = clientHeight;
            }
            this.renderer.resize(width, height);
            this.render();
        };
        this._resizeId = null;
        this._resizeTo = null;
        this.resizeTo = options.resizeTo || null;
    }
    static destroy() {
        globalThis.removeEventListener("resize", this.queueResize);
        this.cancelResize();
        this.cancelResize = null;
        this.queueResize = null;
        this.resizeTo = null;
        this.resize = null;
    }
}
$57d95d4aa6d373bc$export$6453cd852defe94a.extension = (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).Application;
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($57d95d4aa6d373bc$export$6453cd852defe94a);





const $aee7f73704b4a19b$var$assetKeyMap = {
    loader: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
    resolver: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).ResolveParser,
    cache: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CacheParser,
    detection: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).DetectionParser
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).handle((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($aee7f73704b4a19b$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add(Object.assign(ref[key], {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($aee7f73704b4a19b$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).remove(ref[key]));
});



class $03657013a007ba43$export$1949379a83b843d5 {
    constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}



function $01f89dbef8de9e38$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}



function $ff6950007d6649ba$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $5d808cc4b6a3c326$exports).path.extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}


const $b425d552371a586b$export$b01be8e180bf3d9b = (input, transform)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string") return transform(item);
        return item;
    });
};


const $2636f2efcd018458$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};


function $aa3b11c502ba406c$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $aa3b11c502ba406c$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $aa3b11c502ba406c$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $aa3b11c502ba406c$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}


const $84f3227467e1a576$export$16a80d27953452d4 = (item)=>!Array.isArray(item);





class $ebbad49d08847d0d$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    has(key) {
        return this._cache.has(key);
    }
    get(key) {
        const result = this._cache.get(key);
        if (!result) console.warn(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    set(key, value) {
        const keys = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        if (!cacheableAssets) {
            cacheableAssets = {};
            keys.forEach((key2)=>{
                cacheableAssets[key2] = value;
            });
        }
        const cacheKeys = Object.keys(cacheableAssets);
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            if (this._cache.has(key2) && this._cache.get(key2) !== value) console.warn("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableAssets[key2]);
        });
        if (value instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a)) {
            const texture = value;
            keys.forEach((key2)=>{
                if (texture.baseTexture !== (0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY.baseTexture) (0, $2d8d497fce3a4092$export$d6306e508f184154).addToCache(texture.baseTexture, key2);
                (0, $6ac4ad2139942545$export$5431306cf43de24a).addToCache(texture, key2);
            });
        }
    }
    remove(key) {
        this._cacheMap.get(key);
        if (!this._cacheMap.has(key)) {
            console.warn(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    get parsers() {
        return this._parsers;
    }
}
const $ebbad49d08847d0d$export$94affb487e701bf2 = new $ebbad49d08847d0d$var$CacheClass();






class $d079125e54a74d6d$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [];
        this._parsersValidated = false;
        this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        this.promiseCache = {};
    }
    reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.loadParser) {
                parser = this._parserHash[data.loadParser];
                if (!parser) console.warn(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    console.warn(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgress) {
        if (!this._parsersValidated) this._validateParsers();
        let count = 0;
        const assets = {};
        const singleAsset = (0, $84f3227467e1a576$export$16a80d27953452d4)(assetsToLoadIn);
        const assetsToLoad = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(assetsToLoadIn, (item)=>({
                src: item
            }));
        const total = assetsToLoad.length;
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $5d808cc4b6a3c326$exports).path.toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
                assets[asset.src] = await this.promiseCache[url].promise;
                if (onProgress) onProgress(++count / total);
            } catch (e) {
                delete this.promiseCache[url];
                delete assets[asset.src];
                throw new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(assetsToUnloadIn, (item)=>({
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $5d808cc4b6a3c326$exports).path.toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                loadPromise.parser?.unload?.(loadedAsset, asset, this);
                delete this.promiseCache[url];
            }
        });
        await Promise.all(promises);
    }
    _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>{
            if (hash[parser.name]) console.warn(`[Assets] loadParser name conflict "${parser.name}"`);
            return {
                ...hash,
                [parser.name]: parser
            };
        }, {});
    }
}


var $dc037be75324b6bc$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($dc037be75324b6bc$export$820ed6348c4f2750 || {});






const $f37d43d286635a8a$var$validJSONExtension = ".json";
const $f37d43d286635a8a$var$validJSONMIME = "application/json";
const $f37d43d286635a8a$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $01f89dbef8de9e38$export$7ff8b059fb914323)(url, $f37d43d286635a8a$var$validJSONMIME) || (0, $ff6950007d6649ba$export$fd0180357b95b812)(url, $f37d43d286635a8a$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
        const json = await response.json();
        return json;
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($f37d43d286635a8a$export$e7c8553478f3aac7);






const $26ed7903994a77a8$var$validTXTExtension = ".txt";
const $26ed7903994a77a8$var$validTXTMIME = "text/plain";
const $26ed7903994a77a8$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).Low
    },
    test (url) {
        return (0, $01f89dbef8de9e38$export$7ff8b059fb914323)(url, $26ed7903994a77a8$var$validTXTMIME) || (0, $ff6950007d6649ba$export$fd0180357b95b812)(url, $26ed7903994a77a8$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
        const txt = await response.text();
        return txt;
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($26ed7903994a77a8$export$3835b7ee6dbebde8);






const $845b8a71df894867$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $845b8a71df894867$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $845b8a71df894867$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $845b8a71df894867$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $845b8a71df894867$export$c461ca8f39d93d9b(url) {
    const ext = (0, $5d808cc4b6a3c326$exports).path.extname(url);
    const name = (0, $5d808cc4b6a3c326$exports).path.basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($845b8a71df894867$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $845b8a71df894867$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $01f89dbef8de9e38$export$7ff8b059fb914323)(url, $845b8a71df894867$var$validFontMIMEs) || (0, $ff6950007d6649ba$export$fd0180357b95b812)(url, $845b8a71df894867$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $845b8a71df894867$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$845b8a71df894867$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url(${encodeURI(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        console.warn("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getFontFaceSet().delete(t));
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($845b8a71df894867$export$129ed93ad26b0298);










let $09980339795616d9$var$UUID = 0;
let $09980339795616d9$var$MAX_WORKERS;
const $09980339795616d9$var$WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
const $09980339795616d9$var$checkImageBitmapCode = {
    id: "checkImageBitmap",
    code: `
    async function checkImageBitmap()
    {
        try
        {
            if (typeof createImageBitmap !== 'function') return false;

            const response = await fetch('${$09980339795616d9$var$WHITE_PNG}');
            const imageBlob =  await response.blob();
            const imageBitmap = await createImageBitmap(imageBlob);

            return imageBitmap.width === 1 && imageBitmap.height === 1;
        }
        catch (e)
        {
            return false;
        }
    }
    checkImageBitmap().then((result) => { self.postMessage(result); });
    `
};
const $09980339795616d9$var$workerCode = {
    id: "loadImageBitmap",
    code: `
    async function loadImageBitmap(url)
    {
        const response = await fetch(url);

        if (!response.ok)
        {
            throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \`
                + \`\${response.status} \${response.statusText}\`);
        }

        const imageBlob =  await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);

        return imageBitmap;
    }
    self.onmessage = async (event) =>
    {
        try
        {
            const imageBitmap = await loadImageBitmap(event.data.data[0]);

            self.postMessage({
                data: imageBitmap,
                uuid: event.data.uuid,
                id: event.data.id,
            }, [imageBitmap]);
        }
        catch(e)
        {
            self.postMessage({
                error: e,
                uuid: event.data.uuid,
                id: event.data.id,
            });
        }
    };`
};
let $09980339795616d9$var$workerURL;
class $09980339795616d9$var$WorkerManagerClass {
    constructor(){
        this._initialized = false;
        this._createdWorkers = 0;
        this.workerPool = [];
        this.queue = [];
        this.resolveHash = {};
    }
    isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const workerURL2 = URL.createObjectURL(new Blob([
                $09980339795616d9$var$checkImageBitmapCode.code
            ], {
                type: "application/javascript"
            }));
            const worker = new Worker(workerURL2);
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                URL.revokeObjectURL(workerURL2);
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    loadImageBitmap(src) {
        return this._run("loadImageBitmap", [
            src
        ]);
    }
    async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    getWorker() {
        if ($09980339795616d9$var$MAX_WORKERS === void 0) $09980339795616d9$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this.workerPool.pop();
        if (!worker && this._createdWorkers < $09980339795616d9$var$MAX_WORKERS) {
            if (!$09980339795616d9$var$workerURL) $09980339795616d9$var$workerURL = URL.createObjectURL(new Blob([
                $09980339795616d9$var$workerCode.code
            ], {
                type: "application/javascript"
            }));
            this._createdWorkers++;
            worker = new Worker($09980339795616d9$var$workerURL);
            worker.addEventListener("message", (event)=>{
                this.complete(event.data);
                this.returnWorker(event.target);
                this.next();
            });
        }
        return worker;
    }
    returnWorker(worker) {
        this.workerPool.push(worker);
    }
    complete(data) {
        if (data.error !== void 0) this.resolveHash[data.uuid].reject(data.error);
        else this.resolveHash[data.uuid].resolve(data.data);
        this.resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this.queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this.next();
        return promise;
    }
    next() {
        if (!this.queue.length) return;
        const worker = this.getWorker();
        if (!worker) return;
        const toDo = this.queue.pop();
        const id = toDo.id;
        this.resolveHash[$09980339795616d9$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $09980339795616d9$var$UUID++,
            id: id
        });
    }
}
const $09980339795616d9$export$bcff6015853c67ce = new $09980339795616d9$var$WorkerManagerClass();



function $a814436d95267d74$export$37b981a8c575f415(base, loader, url) {
    const texture = new (0, $6ac4ad2139942545$export$5431306cf43de24a)(base);
    texture.baseTexture.on("dispose", ()=>{
        delete loader.promiseCache[url];
    });
    return texture;
}


const $9a4512606444f5fc$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $9a4512606444f5fc$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $9a4512606444f5fc$export$c614e6247302006d(url) {
    const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    const imageBitmap = await createImageBitmap(imageBlob);
    return imageBitmap;
}
const $9a4512606444f5fc$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).High
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $01f89dbef8de9e38$export$7ff8b059fb914323)(url, $9a4512606444f5fc$var$validImageMIMEs) || (0, $ff6950007d6649ba$export$fd0180357b95b812)(url, $9a4512606444f5fc$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $09980339795616d9$export$bcff6015853c67ce).isImageBitmapSupported()) src = await (0, $09980339795616d9$export$bcff6015853c67ce).loadImageBitmap(url);
            else src = await $9a4512606444f5fc$export$c614e6247302006d(url);
        } else src = await new Promise((resolve)=>{
            src = new Image();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else src.onload = ()=>{
                resolve(src);
            };
        });
        const base = new (0, $2d8d497fce3a4092$export$d6306e508f184154)(src, {
            resolution: (0, $5d808cc4b6a3c326$exports).getResolutionOfUrl(url),
            ...asset.data
        });
        base.resource.src = url;
        return (0, $a814436d95267d74$export$37b981a8c575f415)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($9a4512606444f5fc$export$897b113ee8307cd0);



const $194887c81fec4258$var$validSVGExtension = ".svg";
const $194887c81fec4258$var$validSVGMIME = "image/svg+xml";
const $194887c81fec4258$export$c32505ea942c7f01 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).High
    },
    name: "loadSVG",
    test (url) {
        return (0, $01f89dbef8de9e38$export$7ff8b059fb914323)(url, $194887c81fec4258$var$validSVGMIME) || (0, $ff6950007d6649ba$export$fd0180357b95b812)(url, $194887c81fec4258$var$validSVGExtension);
    },
    async testParse (data) {
        return (0, $e1c52b915095bad3$export$aeb8ac9a3d5d46a0).test(data);
    },
    async parse (asset, data, loader) {
        const src = new (0, $e1c52b915095bad3$export$aeb8ac9a3d5d46a0)(asset, data?.data?.resourceOptions);
        await src.load();
        const base = new (0, $2d8d497fce3a4092$export$d6306e508f184154)(src, {
            resolution: (0, $5d808cc4b6a3c326$exports).getResolutionOfUrl(asset),
            ...data?.data
        });
        base.resource.src = asset;
        const texture = (0, $a814436d95267d74$export$37b981a8c575f415)(base, loader, asset);
        return texture;
    },
    async load (url, _options) {
        const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
        return response.text();
    },
    unload: (0, $9a4512606444f5fc$export$897b113ee8307cd0).unload
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($194887c81fec4258$export$c32505ea942c7f01);














class $d2913503a1b01b63$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    get parsers() {
        return this._parsers;
    }
    reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    addManifest(manifest) {
        if (this._manifest) console.warn("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    addBundle(bundleId, assets) {
        const assetNames = [];
        if (Array.isArray(assets)) assets.forEach((asset)=>{
            if (typeof asset.name === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, asset.name);
                assetNames.push(bundleAssetId);
                this.add([
                    asset.name,
                    bundleAssetId
                ], asset.srcs, asset.data);
            } else {
                const bundleIds = asset.name.map((name)=>this._createBundleAssetId(bundleId, name));
                bundleIds.forEach((bundleId2)=>{
                    assetNames.push(bundleId2);
                });
                this.add([
                    ...asset.name,
                    ...bundleIds
                ], asset.srcs);
            }
        });
        else Object.keys(assets).forEach((key)=>{
            assetNames.push(this._createBundleAssetId(bundleId, key));
            this.add([
                key,
                this._createBundleAssetId(bundleId, key)
            ], assets[key]);
        });
        this._bundles[bundleId] = assetNames;
    }
    add(keysIn, assetsIn, data) {
        const keys = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(keysIn);
        keys.forEach((key)=>{
            if (this.hasKey(key)) console.warn(`[Resolver] already has key: ${key} overwriting`);
        });
        if (!Array.isArray(assetsIn)) {
            if (typeof assetsIn === "string") assetsIn = (0, $aa3b11c502ba406c$export$738117acc6638004)(assetsIn);
            else assetsIn = [
                assetsIn
            ];
        }
        const assetMap = assetsIn.map((asset)=>{
            let formattedAsset = asset;
            if (typeof asset === "string") {
                let parsed = false;
                for(let i = 0; i < this._parsers.length; i++){
                    const parser = this._parsers[i];
                    if (parser.test(asset)) {
                        formattedAsset = parser.parse(asset);
                        parsed = true;
                        break;
                    }
                }
                if (!parsed) formattedAsset = {
                    src: asset
                };
            }
            if (!formattedAsset.format) formattedAsset.format = formattedAsset.src.split(".").pop();
            if (!formattedAsset.alias) formattedAsset.alias = keys;
            if (this._basePath || this._rootPath) formattedAsset.src = (0, $5d808cc4b6a3c326$exports).path.toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
            formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
            formattedAsset.data = formattedAsset.data ?? data;
            return formattedAsset;
        });
        keys.forEach((key)=>{
            this._assetMap[key] = assetMap;
        });
    }
    resolveBundle(bundleIds) {
        const singleAsset = (0, $84f3227467e1a576$export$16a80d27953452d4)(bundleIds);
        bundleIds = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $84f3227467e1a576$export$16a80d27953452d4)(keys);
        keys = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    const bestAsset = assets[0];
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0] ?? bestAsset;
                } else {
                    let src = key;
                    if (this._basePath || this._rootPath) src = (0, $5d808cc4b6a3c326$exports).path.toAbsolute(src, this._basePath, this._rootPath);
                    src = this._appendDefaultSearchParams(src);
                    this._resolverHash[key] = {
                        src: src
                    };
                }
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    hasKey(key) {
        return !!this._assetMap[key];
    }
    hasBundle(key) {
        return !!this._bundles[key];
    }
    _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[0];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
}





class $fff9e028a285d5fa$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $d2913503a1b01b63$export$8b4c839865b08288)();
        this.loader = new (0, $d079125e54a74d6d$export$3b0d6d7590275603)();
        this.cache = (0, $ebbad49d08847d0d$export$94affb487e701bf2);
        this._backgroundLoader = new (0, $03657013a007ba43$export$1949379a83b843d5)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    async init(options = {}) {
        if (this._initialized) {
            console.warn("[Assets]AssetManager already initialized, did you load before calling this Asset.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        let formats = [];
        if (options.texturePreference?.format) {
            const formatPref = options.texturePreference?.format;
            formats = typeof formatPref === "string" ? [
                formatPref
            ] : formatPref;
            for (const detection of this._detections)if (!await detection.test()) formats = await detection.remove(formats);
        } else {
            for (const detection of this._detections)if (await detection.test()) formats = await detection.add(formats);
        }
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
    }
    add(keysIn, assetsIn, data) {
        this.resolver.add(keysIn, assetsIn, data);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $84f3227467e1a576$export$16a80d27953452d4)(urls);
        const urlArray = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(urls).map((url)=>{
            if (typeof url !== "string") {
                this.resolver.add(url.src, url);
                return url.src;
            }
            if (!this.resolver.hasKey(url)) this.resolver.add(url, url);
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let count = 0;
        let total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        };
        const promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            total += Object.keys(resolveResult).length;
            return this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $ebbad49d08847d0d$export$94affb487e701bf2).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $ebbad49d08847d0d$export$94affb487e701bf2).get(keys[i]);
        return assets;
    }
    async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = Object.values(resolveResults);
        const resolveKeys = Object.keys(resolveResults);
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult, i)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            out[resolveKeys[i]] = asset;
            (0, $ebbad49d08847d0d$export$94affb487e701bf2).set(keys, asset);
        });
        return out;
    }
    async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $b425d552371a586b$export$b01be8e180bf3d9b)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $ebbad49d08847d0d$export$94affb487e701bf2).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    get detections() {
        return this._detections;
    }
    get preferWorkers() {
        return (0, $9a4512606444f5fc$export$897b113ee8307cd0).config.preferWorkers;
    }
    set preferWorkers(value) {
        (0, $5d808cc4b6a3c326$exports).deprecation("7.2.0", "Assets.prefersWorkers is deprecated, use Assets.setPreferences({ preferWorkers: true }) instead.");
        this.setPreferences({
            preferWorkers: value
        });
    }
    setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $fff9e028a285d5fa$export$c8eca95e306f7116 = new $fff9e028a285d5fa$export$137d4dd907afac85();
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).handleByList((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser, $fff9e028a285d5fa$export$c8eca95e306f7116.loader.parsers).handleByList((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).ResolveParser, $fff9e028a285d5fa$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CacheParser, $fff9e028a285d5fa$export$c8eca95e306f7116.cache.parsers).handleByList((0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).DetectionParser, $fff9e028a285d5fa$export$c8eca95e306f7116.detections);






const $ffd3214dbdb21d7c$export$407b4625a915919d = {
    extension: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).CacheParser,
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($ffd3214dbdb21d7c$export$407b4625a915919d);







const $4b526ee52401fd1d$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 1
    },
    test: async ()=>{
        if (!globalThis.createImageBitmap) return false;
        const avifData = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
        const blob = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(avifData).then((r)=>r.blob());
        return createImageBitmap(blob).then(()=>true, ()=>false);
    },
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($4b526ee52401fd1d$export$a60d2d4a3c570783);



const $b39729af2811f70e$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>{
        if (!globalThis.createImageBitmap) return false;
        const webpData = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
        const blob = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(webpData).then((r)=>r.blob());
        return createImageBitmap(blob).then(()=>true, ()=>false);
    },
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($b39729af2811f70e$export$d19529a9ed9823d4);



const $0e08f90975e7958b$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $0e08f90975e7958b$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$0e08f90975e7958b$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$0e08f90975e7958b$var$imageFormats.includes(f))
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($0e08f90975e7958b$export$b106d7c2de3b4d89);














const $a86b2a0d6960d0dc$export$cc356fa83de02bea = {
    extension: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).ResolveParser,
    test: (0, $9a4512606444f5fc$export$897b113ee8307cd0).test,
    parse: (value)=>({
            resolution: parseFloat((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($a86b2a0d6960d0dc$export$cc356fa83de02bea);






























var $53c3f918f15a2feb$export$9a3c57b95f3e5f5d = /* @__PURE__ */ ((INTERNAL_FORMATS2)=>{
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_S3TC_DXT1_EXT"] = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_S3TC_DXT3_EXT"] = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT"] = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT"] = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT"] = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SRGB_S3TC_DXT1_EXT"] = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_R11_EAC"] = 37488] = "COMPRESSED_R11_EAC";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SIGNED_R11_EAC"] = 37489] = "COMPRESSED_SIGNED_R11_EAC";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RG11_EAC"] = 37490] = "COMPRESSED_RG11_EAC";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SIGNED_RG11_EAC"] = 37491] = "COMPRESSED_SIGNED_RG11_EAC";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA8_ETC2_EAC"] = 37496] = "COMPRESSED_RGBA8_ETC2_EAC";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SRGB8_ETC2"] = 37493] = "COMPRESSED_SRGB8_ETC2";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SRGB8_ALPHA8_ETC2_EAC"] = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGB_PVRTC_2BPPV1_IMG"] = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_PVRTC_2BPPV1_IMG"] = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGB_ATC_WEBGL"] = 35986] = "COMPRESSED_RGB_ATC_WEBGL";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL"] = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL"] = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL";
    INTERNAL_FORMATS2[INTERNAL_FORMATS2["COMPRESSED_RGBA_ASTC_4x4_KHR"] = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR";
    return INTERNAL_FORMATS2;
})($53c3f918f15a2feb$export$9a3c57b95f3e5f5d || {});
const $53c3f918f15a2feb$export$fb888e587c979eee = {
    [33776 /* COMPRESSED_RGB_S3TC_DXT1_EXT */ ]: 0.5,
    [33777 /* COMPRESSED_RGBA_S3TC_DXT1_EXT */ ]: 0.5,
    [33778 /* COMPRESSED_RGBA_S3TC_DXT3_EXT */ ]: 1,
    [33779 /* COMPRESSED_RGBA_S3TC_DXT5_EXT */ ]: 1,
    [35916 /* COMPRESSED_SRGB_S3TC_DXT1_EXT */ ]: 0.5,
    [35917 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT */ ]: 0.5,
    [35918 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT */ ]: 1,
    [35919 /* COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT */ ]: 1,
    [37488 /* COMPRESSED_R11_EAC */ ]: 0.5,
    [37489 /* COMPRESSED_SIGNED_R11_EAC */ ]: 0.5,
    [37490 /* COMPRESSED_RG11_EAC */ ]: 1,
    [37491 /* COMPRESSED_SIGNED_RG11_EAC */ ]: 1,
    [37492 /* COMPRESSED_RGB8_ETC2 */ ]: 0.5,
    [37496 /* COMPRESSED_RGBA8_ETC2_EAC */ ]: 1,
    [37493 /* COMPRESSED_SRGB8_ETC2 */ ]: 0.5,
    [37497 /* COMPRESSED_SRGB8_ALPHA8_ETC2_EAC */ ]: 1,
    [37494 /* COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 */ ]: 0.5,
    [37495 /* COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 */ ]: 0.5,
    [35840 /* COMPRESSED_RGB_PVRTC_4BPPV1_IMG */ ]: 0.5,
    [35842 /* COMPRESSED_RGBA_PVRTC_4BPPV1_IMG */ ]: 0.5,
    [35841 /* COMPRESSED_RGB_PVRTC_2BPPV1_IMG */ ]: 0.25,
    [35843 /* COMPRESSED_RGBA_PVRTC_2BPPV1_IMG */ ]: 0.25,
    [36196 /* COMPRESSED_RGB_ETC1_WEBGL */ ]: 0.5,
    [35986 /* COMPRESSED_RGB_ATC_WEBGL */ ]: 0.5,
    [35986 /* COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL */ ]: 1,
    [34798 /* COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL */ ]: 1,
    [37808 /* COMPRESSED_RGBA_ASTC_4x4_KHR */ ]: 1
};





let $03749dee05caaa30$var$storedGl;
let $03749dee05caaa30$var$extensions;
function $03749dee05caaa30$var$getCompressedTextureExtensions() {
    $03749dee05caaa30$var$extensions = {
        s3tc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc"),
        s3tc_sRGB: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
        etc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_etc"),
        etc1: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_etc1"),
        pvrtc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_pvrtc") || $03749dee05caaa30$var$storedGl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
        atc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_atc"),
        astc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_astc")
    };
}
const $03749dee05caaa30$export$82cf9629b7380430 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 2
    },
    test: async ()=>{
        const canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
        const gl = canvas.getContext("webgl");
        if (!gl) {
            console.warn("WebGL not available for compressed textures.");
            return false;
        }
        $03749dee05caaa30$var$storedGl = gl;
        return true;
    },
    add: async (formats)=>{
        if (!$03749dee05caaa30$var$extensions) $03749dee05caaa30$var$getCompressedTextureExtensions();
        const textureFormats = [];
        for(const extensionName in $03749dee05caaa30$var$extensions){
            const extension = $03749dee05caaa30$var$extensions[extensionName];
            if (!extension) continue;
            textureFormats.push(extensionName);
        }
        return [
            ...textureFormats,
            ...formats
        ];
    },
    remove: async (formats)=>{
        if (!$03749dee05caaa30$var$extensions) $03749dee05caaa30$var$getCompressedTextureExtensions();
        return formats.filter((f)=>!(f in $03749dee05caaa30$var$extensions));
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($03749dee05caaa30$export$82cf9629b7380430);






class $420f108efb900a3c$export$f257f839012584a2 extends (0, $ad9971bad38b5f89$export$a79ef781de624449) {
    constructor(source, options = {
        width: 1,
        height: 1,
        autoLoad: true
    }){
        let origin;
        let data;
        if (typeof source === "string") {
            origin = source;
            data = new Uint8Array();
        } else {
            origin = null;
            data = source;
        }
        super(data, options);
        this.origin = origin;
        this.buffer = data ? new (0, $847a0d28fb79d582$export$4fdbf0662aa3047a)(data) : null;
        this._load = null;
        this.loaded = false;
        if (this.origin !== null && options.autoLoad !== false) this.load();
        if (this.origin === null && this.buffer) {
            this._load = Promise.resolve(this);
            this.loaded = true;
            this.onBlobLoaded(this.buffer.rawBinaryData);
        }
    }
    onBlobLoaded(_data) {}
    load() {
        if (this._load) return this._load;
        this._load = fetch(this.origin).then((response)=>response.blob()).then((blob)=>blob.arrayBuffer()).then((arrayBuffer)=>{
            this.data = new Uint32Array(arrayBuffer);
            this.buffer = new (0, $847a0d28fb79d582$export$4fdbf0662aa3047a)(arrayBuffer);
            this.loaded = true;
            this.onBlobLoaded(arrayBuffer);
            this.update();
            return this;
        });
        return this._load;
    }
}




class $fa0cb104b4c002be$export$1982af6892f05657 extends (0, $420f108efb900a3c$export$f257f839012584a2) {
    constructor(source, options){
        super(source, options);
        this.format = options.format;
        this.levels = options.levels || 1;
        this._width = options.width;
        this._height = options.height;
        this._extension = $fa0cb104b4c002be$export$1982af6892f05657._formatToExtension(this.format);
        if (options.levelBuffers || this.buffer) this._levelBuffers = options.levelBuffers || $fa0cb104b4c002be$export$1982af6892f05657._createLevelBuffers(source instanceof Uint8Array ? source : this.buffer.uint8View, this.format, this.levels, 4, 4, this.width, this.height);
    }
    upload(renderer, _texture, _glTexture) {
        const gl = renderer.gl;
        const extension = renderer.context.extensions[this._extension];
        if (!extension) throw new Error(`${this._extension} textures are not supported on the current machine`);
        if (!this._levelBuffers) return false;
        for(let i = 0, j = this.levels; i < j; i++){
            const { levelID: levelID , levelWidth: levelWidth , levelHeight: levelHeight , levelBuffer: levelBuffer  } = this._levelBuffers[i];
            gl.compressedTexImage2D(gl.TEXTURE_2D, levelID, this.format, levelWidth, levelHeight, 0, levelBuffer);
        }
        return true;
    }
    onBlobLoaded() {
        this._levelBuffers = $fa0cb104b4c002be$export$1982af6892f05657._createLevelBuffers(this.buffer.uint8View, this.format, this.levels, 4, 4, this.width, this.height);
    }
    static _formatToExtension(format) {
        if (format >= 33776 && format <= 33779) return "s3tc";
        else if (format >= 37488 && format <= 37497) return "etc";
        else if (format >= 35840 && format <= 35843) return "pvrtc";
        else if (format >= 36196) return "etc1";
        else if (format >= 35986 && format <= 34798) return "atc";
        throw new Error("Invalid (compressed) texture format given!");
    }
    static _createLevelBuffers(buffer, format, levels, blockWidth, blockHeight, imageWidth, imageHeight) {
        const buffers = new Array(levels);
        let offset = buffer.byteOffset;
        let levelWidth = imageWidth;
        let levelHeight = imageHeight;
        let alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
        let alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
        let levelSize = alignedLevelWidth * alignedLevelHeight * (0, $53c3f918f15a2feb$export$fb888e587c979eee)[format];
        for(let i = 0; i < levels; i++){
            buffers[i] = {
                levelID: i,
                levelWidth: levels > 1 ? levelWidth : alignedLevelWidth,
                levelHeight: levels > 1 ? levelHeight : alignedLevelHeight,
                levelBuffer: new Uint8Array(buffer.buffer, offset, levelSize)
            };
            offset += levelSize;
            levelWidth = levelWidth >> 1 || 1;
            levelHeight = levelHeight >> 1 || 1;
            alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
            alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
            levelSize = alignedLevelWidth * alignedLevelHeight * (0, $53c3f918f15a2feb$export$fb888e587c979eee)[format];
        }
        return buffers;
    }
}





const $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE = 4;
const $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE = 124;
const $9d3d2e1a107c7be2$var$DDS_HEADER_PF_SIZE = 32;
const $9d3d2e1a107c7be2$var$DDS_HEADER_DX10_SIZE = 20;
const $9d3d2e1a107c7be2$var$DDS_MAGIC = 542327876;
const $9d3d2e1a107c7be2$var$DDS_FIELDS = {
    SIZE: 1,
    FLAGS: 2,
    HEIGHT: 3,
    WIDTH: 4,
    MIPMAP_COUNT: 7,
    PIXEL_FORMAT: 19
};
const $9d3d2e1a107c7be2$var$DDS_PF_FIELDS = {
    SIZE: 0,
    FLAGS: 1,
    FOURCC: 2,
    RGB_BITCOUNT: 3,
    R_BIT_MASK: 4,
    G_BIT_MASK: 5,
    B_BIT_MASK: 6,
    A_BIT_MASK: 7
};
const $9d3d2e1a107c7be2$var$DDS_DX10_FIELDS = {
    DXGI_FORMAT: 0,
    RESOURCE_DIMENSION: 1,
    MISC_FLAG: 2,
    ARRAY_SIZE: 3,
    MISC_FLAGS2: 4
};
var $9d3d2e1a107c7be2$var$DXGI_FORMAT = /* @__PURE__ */ ((DXGI_FORMAT2)=>{
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_UNKNOWN"] = 0] = "DXGI_FORMAT_UNKNOWN";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_TYPELESS"] = 1] = "DXGI_FORMAT_R32G32B32A32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_FLOAT"] = 2] = "DXGI_FORMAT_R32G32B32A32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_UINT"] = 3] = "DXGI_FORMAT_R32G32B32A32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32A32_SINT"] = 4] = "DXGI_FORMAT_R32G32B32A32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_TYPELESS"] = 5] = "DXGI_FORMAT_R32G32B32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_FLOAT"] = 6] = "DXGI_FORMAT_R32G32B32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_UINT"] = 7] = "DXGI_FORMAT_R32G32B32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32B32_SINT"] = 8] = "DXGI_FORMAT_R32G32B32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_TYPELESS"] = 9] = "DXGI_FORMAT_R16G16B16A16_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_FLOAT"] = 10] = "DXGI_FORMAT_R16G16B16A16_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_UNORM"] = 11] = "DXGI_FORMAT_R16G16B16A16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_UINT"] = 12] = "DXGI_FORMAT_R16G16B16A16_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_SNORM"] = 13] = "DXGI_FORMAT_R16G16B16A16_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16B16A16_SINT"] = 14] = "DXGI_FORMAT_R16G16B16A16_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_TYPELESS"] = 15] = "DXGI_FORMAT_R32G32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_FLOAT"] = 16] = "DXGI_FORMAT_R32G32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_UINT"] = 17] = "DXGI_FORMAT_R32G32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G32_SINT"] = 18] = "DXGI_FORMAT_R32G32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32G8X24_TYPELESS"] = 19] = "DXGI_FORMAT_R32G8X24_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D32_FLOAT_S8X24_UINT"] = 20] = "DXGI_FORMAT_D32_FLOAT_S8X24_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS"] = 21] = "DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_X32_TYPELESS_G8X24_UINT"] = 22] = "DXGI_FORMAT_X32_TYPELESS_G8X24_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10A2_TYPELESS"] = 23] = "DXGI_FORMAT_R10G10B10A2_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10A2_UNORM"] = 24] = "DXGI_FORMAT_R10G10B10A2_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10A2_UINT"] = 25] = "DXGI_FORMAT_R10G10B10A2_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R11G11B10_FLOAT"] = 26] = "DXGI_FORMAT_R11G11B10_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_TYPELESS"] = 27] = "DXGI_FORMAT_R8G8B8A8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_UNORM"] = 28] = "DXGI_FORMAT_R8G8B8A8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_UNORM_SRGB"] = 29] = "DXGI_FORMAT_R8G8B8A8_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_UINT"] = 30] = "DXGI_FORMAT_R8G8B8A8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_SNORM"] = 31] = "DXGI_FORMAT_R8G8B8A8_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8B8A8_SINT"] = 32] = "DXGI_FORMAT_R8G8B8A8_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_TYPELESS"] = 33] = "DXGI_FORMAT_R16G16_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_FLOAT"] = 34] = "DXGI_FORMAT_R16G16_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_UNORM"] = 35] = "DXGI_FORMAT_R16G16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_UINT"] = 36] = "DXGI_FORMAT_R16G16_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_SNORM"] = 37] = "DXGI_FORMAT_R16G16_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16G16_SINT"] = 38] = "DXGI_FORMAT_R16G16_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_TYPELESS"] = 39] = "DXGI_FORMAT_R32_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D32_FLOAT"] = 40] = "DXGI_FORMAT_D32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_FLOAT"] = 41] = "DXGI_FORMAT_R32_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_UINT"] = 42] = "DXGI_FORMAT_R32_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R32_SINT"] = 43] = "DXGI_FORMAT_R32_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R24G8_TYPELESS"] = 44] = "DXGI_FORMAT_R24G8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D24_UNORM_S8_UINT"] = 45] = "DXGI_FORMAT_D24_UNORM_S8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R24_UNORM_X8_TYPELESS"] = 46] = "DXGI_FORMAT_R24_UNORM_X8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_X24_TYPELESS_G8_UINT"] = 47] = "DXGI_FORMAT_X24_TYPELESS_G8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_TYPELESS"] = 48] = "DXGI_FORMAT_R8G8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_UNORM"] = 49] = "DXGI_FORMAT_R8G8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_UINT"] = 50] = "DXGI_FORMAT_R8G8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_SNORM"] = 51] = "DXGI_FORMAT_R8G8_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_SINT"] = 52] = "DXGI_FORMAT_R8G8_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_TYPELESS"] = 53] = "DXGI_FORMAT_R16_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_FLOAT"] = 54] = "DXGI_FORMAT_R16_FLOAT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_D16_UNORM"] = 55] = "DXGI_FORMAT_D16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_UNORM"] = 56] = "DXGI_FORMAT_R16_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_UINT"] = 57] = "DXGI_FORMAT_R16_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_SNORM"] = 58] = "DXGI_FORMAT_R16_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R16_SINT"] = 59] = "DXGI_FORMAT_R16_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_TYPELESS"] = 60] = "DXGI_FORMAT_R8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_UNORM"] = 61] = "DXGI_FORMAT_R8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_UINT"] = 62] = "DXGI_FORMAT_R8_UINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_SNORM"] = 63] = "DXGI_FORMAT_R8_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8_SINT"] = 64] = "DXGI_FORMAT_R8_SINT";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_A8_UNORM"] = 65] = "DXGI_FORMAT_A8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R1_UNORM"] = 66] = "DXGI_FORMAT_R1_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R9G9B9E5_SHAREDEXP"] = 67] = "DXGI_FORMAT_R9G9B9E5_SHAREDEXP";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R8G8_B8G8_UNORM"] = 68] = "DXGI_FORMAT_R8G8_B8G8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_G8R8_G8B8_UNORM"] = 69] = "DXGI_FORMAT_G8R8_G8B8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC1_TYPELESS"] = 70] = "DXGI_FORMAT_BC1_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC1_UNORM"] = 71] = "DXGI_FORMAT_BC1_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC1_UNORM_SRGB"] = 72] = "DXGI_FORMAT_BC1_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC2_TYPELESS"] = 73] = "DXGI_FORMAT_BC2_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC2_UNORM"] = 74] = "DXGI_FORMAT_BC2_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC2_UNORM_SRGB"] = 75] = "DXGI_FORMAT_BC2_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC3_TYPELESS"] = 76] = "DXGI_FORMAT_BC3_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC3_UNORM"] = 77] = "DXGI_FORMAT_BC3_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC3_UNORM_SRGB"] = 78] = "DXGI_FORMAT_BC3_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC4_TYPELESS"] = 79] = "DXGI_FORMAT_BC4_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC4_UNORM"] = 80] = "DXGI_FORMAT_BC4_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC4_SNORM"] = 81] = "DXGI_FORMAT_BC4_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC5_TYPELESS"] = 82] = "DXGI_FORMAT_BC5_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC5_UNORM"] = 83] = "DXGI_FORMAT_BC5_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC5_SNORM"] = 84] = "DXGI_FORMAT_BC5_SNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B5G6R5_UNORM"] = 85] = "DXGI_FORMAT_B5G6R5_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B5G5R5A1_UNORM"] = 86] = "DXGI_FORMAT_B5G5R5A1_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8A8_UNORM"] = 87] = "DXGI_FORMAT_B8G8R8A8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8X8_UNORM"] = 88] = "DXGI_FORMAT_B8G8R8X8_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM"] = 89] = "DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8A8_TYPELESS"] = 90] = "DXGI_FORMAT_B8G8R8A8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8A8_UNORM_SRGB"] = 91] = "DXGI_FORMAT_B8G8R8A8_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8X8_TYPELESS"] = 92] = "DXGI_FORMAT_B8G8R8X8_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B8G8R8X8_UNORM_SRGB"] = 93] = "DXGI_FORMAT_B8G8R8X8_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC6H_TYPELESS"] = 94] = "DXGI_FORMAT_BC6H_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC6H_UF16"] = 95] = "DXGI_FORMAT_BC6H_UF16";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC6H_SF16"] = 96] = "DXGI_FORMAT_BC6H_SF16";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC7_TYPELESS"] = 97] = "DXGI_FORMAT_BC7_TYPELESS";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC7_UNORM"] = 98] = "DXGI_FORMAT_BC7_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_BC7_UNORM_SRGB"] = 99] = "DXGI_FORMAT_BC7_UNORM_SRGB";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_AYUV"] = 100] = "DXGI_FORMAT_AYUV";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y410"] = 101] = "DXGI_FORMAT_Y410";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y416"] = 102] = "DXGI_FORMAT_Y416";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_NV12"] = 103] = "DXGI_FORMAT_NV12";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P010"] = 104] = "DXGI_FORMAT_P010";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P016"] = 105] = "DXGI_FORMAT_P016";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_420_OPAQUE"] = 106] = "DXGI_FORMAT_420_OPAQUE";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_YUY2"] = 107] = "DXGI_FORMAT_YUY2";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y210"] = 108] = "DXGI_FORMAT_Y210";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_Y216"] = 109] = "DXGI_FORMAT_Y216";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_NV11"] = 110] = "DXGI_FORMAT_NV11";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_AI44"] = 111] = "DXGI_FORMAT_AI44";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_IA44"] = 112] = "DXGI_FORMAT_IA44";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P8"] = 113] = "DXGI_FORMAT_P8";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_A8P8"] = 114] = "DXGI_FORMAT_A8P8";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_B4G4R4A4_UNORM"] = 115] = "DXGI_FORMAT_B4G4R4A4_UNORM";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_P208"] = 116] = "DXGI_FORMAT_P208";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_V208"] = 117] = "DXGI_FORMAT_V208";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_V408"] = 118] = "DXGI_FORMAT_V408";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE"] = 119] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE"] = 120] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE";
    DXGI_FORMAT2[DXGI_FORMAT2["DXGI_FORMAT_FORCE_UINT"] = 121] = "DXGI_FORMAT_FORCE_UINT";
    return DXGI_FORMAT2;
})($9d3d2e1a107c7be2$var$DXGI_FORMAT || {});
var $9d3d2e1a107c7be2$var$D3D10_RESOURCE_DIMENSION = /* @__PURE__ */ ((D3D10_RESOURCE_DIMENSION2)=>{
    D3D10_RESOURCE_DIMENSION2[D3D10_RESOURCE_DIMENSION2["DDS_DIMENSION_TEXTURE1D"] = 2] = "DDS_DIMENSION_TEXTURE1D";
    D3D10_RESOURCE_DIMENSION2[D3D10_RESOURCE_DIMENSION2["DDS_DIMENSION_TEXTURE2D"] = 3] = "DDS_DIMENSION_TEXTURE2D";
    D3D10_RESOURCE_DIMENSION2[D3D10_RESOURCE_DIMENSION2["DDS_DIMENSION_TEXTURE3D"] = 6] = "DDS_DIMENSION_TEXTURE3D";
    return D3D10_RESOURCE_DIMENSION2;
})($9d3d2e1a107c7be2$var$D3D10_RESOURCE_DIMENSION || {});
const $9d3d2e1a107c7be2$var$PF_FLAGS = 1;
const $9d3d2e1a107c7be2$var$DDPF_ALPHA = 2;
const $9d3d2e1a107c7be2$var$DDPF_FOURCC = 4;
const $9d3d2e1a107c7be2$var$DDPF_RGB = 64;
const $9d3d2e1a107c7be2$var$DDPF_YUV = 512;
const $9d3d2e1a107c7be2$var$DDPF_LUMINANCE = 131072;
const $9d3d2e1a107c7be2$var$FOURCC_DXT1 = 827611204;
const $9d3d2e1a107c7be2$var$FOURCC_DXT3 = 861165636;
const $9d3d2e1a107c7be2$var$FOURCC_DXT5 = 894720068;
const $9d3d2e1a107c7be2$var$FOURCC_DX10 = 808540228;
const $9d3d2e1a107c7be2$var$DDS_RESOURCE_MISC_TEXTURECUBE = 4;
const $9d3d2e1a107c7be2$var$FOURCC_TO_FORMAT = {
    [$9d3d2e1a107c7be2$var$FOURCC_DXT1]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    [$9d3d2e1a107c7be2$var$FOURCC_DXT3]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    [$9d3d2e1a107c7be2$var$FOURCC_DXT5]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT
};
const $9d3d2e1a107c7be2$var$DXGI_TO_FORMAT = {
    [70 /* DXGI_FORMAT_BC1_TYPELESS */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    [71 /* DXGI_FORMAT_BC1_UNORM */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    [73 /* DXGI_FORMAT_BC2_TYPELESS */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    [74 /* DXGI_FORMAT_BC2_UNORM */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    [76 /* DXGI_FORMAT_BC3_TYPELESS */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    [77 /* DXGI_FORMAT_BC3_UNORM */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    [72 /* DXGI_FORMAT_BC1_UNORM_SRGB */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
    [75 /* DXGI_FORMAT_BC2_UNORM_SRGB */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
    [78 /* DXGI_FORMAT_BC3_UNORM_SRGB */ ]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
};
function $9d3d2e1a107c7be2$export$cddc4925efe88ac(arrayBuffer) {
    const data = new Uint32Array(arrayBuffer);
    const magicWord = data[0];
    if (magicWord !== $9d3d2e1a107c7be2$var$DDS_MAGIC) throw new Error("Invalid DDS file magic word");
    const header = new Uint32Array(arrayBuffer, 0, $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT);
    const height = header[$9d3d2e1a107c7be2$var$DDS_FIELDS.HEIGHT];
    const width = header[$9d3d2e1a107c7be2$var$DDS_FIELDS.WIDTH];
    const mipmapCount = header[$9d3d2e1a107c7be2$var$DDS_FIELDS.MIPMAP_COUNT];
    const pixelFormat = new Uint32Array(arrayBuffer, $9d3d2e1a107c7be2$var$DDS_FIELDS.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT, $9d3d2e1a107c7be2$var$DDS_HEADER_PF_SIZE / Uint32Array.BYTES_PER_ELEMENT);
    const formatFlags = pixelFormat[$9d3d2e1a107c7be2$var$PF_FLAGS];
    if (formatFlags & $9d3d2e1a107c7be2$var$DDPF_FOURCC) {
        const fourCC = pixelFormat[$9d3d2e1a107c7be2$var$DDS_PF_FIELDS.FOURCC];
        if (fourCC !== $9d3d2e1a107c7be2$var$FOURCC_DX10) {
            const internalFormat2 = $9d3d2e1a107c7be2$var$FOURCC_TO_FORMAT[fourCC];
            const dataOffset2 = $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE;
            const texData = new Uint8Array(arrayBuffer, dataOffset2);
            const resource = new (0, $fa0cb104b4c002be$export$1982af6892f05657)(texData, {
                format: internalFormat2,
                width: width,
                height: height,
                levels: mipmapCount
            });
            return [
                resource
            ];
        }
        const dx10Offset = $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE;
        const dx10Header = new Uint32Array(data.buffer, dx10Offset, $9d3d2e1a107c7be2$var$DDS_HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT);
        const dxgiFormat = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.DXGI_FORMAT];
        const resourceDimension = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.RESOURCE_DIMENSION];
        const miscFlag = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.MISC_FLAG];
        const arraySize = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.ARRAY_SIZE];
        const internalFormat = $9d3d2e1a107c7be2$var$DXGI_TO_FORMAT[dxgiFormat];
        if (internalFormat === void 0) throw new Error(`DDSParser cannot parse texture data with DXGI format ${dxgiFormat}`);
        if (miscFlag === $9d3d2e1a107c7be2$var$DDS_RESOURCE_MISC_TEXTURECUBE) throw new Error("DDSParser does not support cubemap textures");
        if (resourceDimension === 6 /* DDS_DIMENSION_TEXTURE3D */ ) throw new Error("DDSParser does not supported 3D texture data");
        const imageBuffers = new Array();
        const dataOffset = $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_DX10_SIZE;
        if (arraySize === 1) imageBuffers.push(new Uint8Array(arrayBuffer, dataOffset));
        else {
            const pixelSize = (0, $53c3f918f15a2feb$export$fb888e587c979eee)[internalFormat];
            let imageSize = 0;
            let levelWidth = width;
            let levelHeight = height;
            for(let i = 0; i < mipmapCount; i++){
                const alignedLevelWidth = Math.max(1, levelWidth + 3 & -4);
                const alignedLevelHeight = Math.max(1, levelHeight + 3 & -4);
                const levelSize = alignedLevelWidth * alignedLevelHeight * pixelSize;
                imageSize += levelSize;
                levelWidth = levelWidth >>> 1;
                levelHeight = levelHeight >>> 1;
            }
            let imageOffset = dataOffset;
            for(let i = 0; i < arraySize; i++){
                imageBuffers.push(new Uint8Array(arrayBuffer, imageOffset, imageSize));
                imageOffset += imageSize;
            }
        }
        return imageBuffers.map((buffer)=>new (0, $fa0cb104b4c002be$export$1982af6892f05657)(buffer, {
                format: internalFormat,
                width: width,
                height: height,
                levels: mipmapCount
            }));
    }
    if (formatFlags & $9d3d2e1a107c7be2$var$DDPF_RGB) throw new Error("DDSParser does not support uncompressed texture data.");
    if (formatFlags & $9d3d2e1a107c7be2$var$DDPF_YUV) throw new Error("DDSParser does not supported YUV uncompressed texture data.");
    if (formatFlags & $9d3d2e1a107c7be2$var$DDPF_LUMINANCE) throw new Error("DDSParser does not support single-channel (lumninance) texture data!");
    if (formatFlags & $9d3d2e1a107c7be2$var$DDPF_ALPHA) throw new Error("DDSParser does not support single-channel (alpha) texture data!");
    throw new Error("DDSParser failed to load a texture file due to an unknown reason!");
}






const $40970c6d4881ef4f$var$FILE_IDENTIFIER = [
    171,
    75,
    84,
    88,
    32,
    49,
    49,
    187,
    13,
    10,
    26,
    10
];
const $40970c6d4881ef4f$var$ENDIANNESS = 67305985;
const $40970c6d4881ef4f$var$KTX_FIELDS = {
    FILE_IDENTIFIER: 0,
    ENDIANNESS: 12,
    GL_TYPE: 16,
    GL_TYPE_SIZE: 20,
    GL_FORMAT: 24,
    GL_INTERNAL_FORMAT: 28,
    GL_BASE_INTERNAL_FORMAT: 32,
    PIXEL_WIDTH: 36,
    PIXEL_HEIGHT: 40,
    PIXEL_DEPTH: 44,
    NUMBER_OF_ARRAY_ELEMENTS: 48,
    NUMBER_OF_FACES: 52,
    NUMBER_OF_MIPMAP_LEVELS: 56,
    BYTES_OF_KEY_VALUE_DATA: 60
};
const $40970c6d4881ef4f$var$FILE_HEADER_SIZE = 64;
const $40970c6d4881ef4f$export$96c88eb9c7372a0b = {
    [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE]: 1,
    [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT]: 2,
    [(0, $551209d754b5b429$export$426db7a6155b7a80).INT]: 4,
    [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_INT]: 4,
    [(0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT]: 4,
    [(0, $551209d754b5b429$export$426db7a6155b7a80).HALF_FLOAT]: 8
};
const $40970c6d4881ef4f$export$ace48b1390b9b0c2 = {
    [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA]: 4,
    [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB]: 3,
    [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RG]: 2,
    [(0, $551209d754b5b429$export$e9c4b7b466aa8274).RED]: 1,
    [(0, $551209d754b5b429$export$e9c4b7b466aa8274).LUMINANCE]: 1,
    [(0, $551209d754b5b429$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: 2,
    [(0, $551209d754b5b429$export$e9c4b7b466aa8274).ALPHA]: 1
};
const $40970c6d4881ef4f$export$2ca26443044e8798 = {
    [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: 2,
    [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: 2,
    [(0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: 2
};
function $40970c6d4881ef4f$export$58a6abed7fd55190(url, arrayBuffer, loadKeyValueData = false) {
    const dataView = new DataView(arrayBuffer);
    if (!$40970c6d4881ef4f$var$validate(url, dataView)) return null;
    const littleEndian = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.ENDIANNESS, true) === $40970c6d4881ef4f$var$ENDIANNESS;
    const glType = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.GL_TYPE, littleEndian);
    const glFormat = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.GL_FORMAT, littleEndian);
    const glInternalFormat = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.GL_INTERNAL_FORMAT, littleEndian);
    const pixelWidth = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.PIXEL_WIDTH, littleEndian);
    const pixelHeight = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.PIXEL_HEIGHT, littleEndian) || 1;
    const pixelDepth = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.PIXEL_DEPTH, littleEndian) || 1;
    const numberOfArrayElements = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.NUMBER_OF_ARRAY_ELEMENTS, littleEndian) || 1;
    const numberOfFaces = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.NUMBER_OF_FACES, littleEndian);
    const numberOfMipmapLevels = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.NUMBER_OF_MIPMAP_LEVELS, littleEndian);
    const bytesOfKeyValueData = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.BYTES_OF_KEY_VALUE_DATA, littleEndian);
    if (pixelHeight === 0 || pixelDepth !== 1) throw new Error("Only 2D textures are supported");
    if (numberOfFaces !== 1) throw new Error("CubeTextures are not supported by KTXLoader yet!");
    if (numberOfArrayElements !== 1) throw new Error("WebGL does not support array textures");
    const blockWidth = 4;
    const blockHeight = 4;
    const alignedWidth = pixelWidth + 3 & -4;
    const alignedHeight = pixelHeight + 3 & -4;
    const imageBuffers = new Array(numberOfArrayElements);
    let imagePixels = pixelWidth * pixelHeight;
    if (glType === 0) imagePixels = alignedWidth * alignedHeight;
    let imagePixelByteSize;
    if (glType !== 0) {
        if ($40970c6d4881ef4f$export$96c88eb9c7372a0b[glType]) imagePixelByteSize = $40970c6d4881ef4f$export$96c88eb9c7372a0b[glType] * $40970c6d4881ef4f$export$ace48b1390b9b0c2[glFormat];
        else imagePixelByteSize = $40970c6d4881ef4f$export$2ca26443044e8798[glType];
    } else imagePixelByteSize = (0, $53c3f918f15a2feb$export$fb888e587c979eee)[glInternalFormat];
    if (imagePixelByteSize === void 0) throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
    const kvData = loadKeyValueData ? $40970c6d4881ef4f$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) : null;
    const imageByteSize = imagePixels * imagePixelByteSize;
    let mipByteSize = imageByteSize;
    let mipWidth = pixelWidth;
    let mipHeight = pixelHeight;
    let alignedMipWidth = alignedWidth;
    let alignedMipHeight = alignedHeight;
    let imageOffset = $40970c6d4881ef4f$var$FILE_HEADER_SIZE + bytesOfKeyValueData;
    for(let mipmapLevel = 0; mipmapLevel < numberOfMipmapLevels; mipmapLevel++){
        const imageSize = dataView.getUint32(imageOffset, littleEndian);
        let elementOffset = imageOffset + 4;
        for(let arrayElement = 0; arrayElement < numberOfArrayElements; arrayElement++){
            let mips = imageBuffers[arrayElement];
            if (!mips) mips = imageBuffers[arrayElement] = new Array(numberOfMipmapLevels);
            mips[mipmapLevel] = {
                levelID: mipmapLevel,
                levelWidth: numberOfMipmapLevels > 1 || glType !== 0 ? mipWidth : alignedMipWidth,
                levelHeight: numberOfMipmapLevels > 1 || glType !== 0 ? mipHeight : alignedMipHeight,
                levelBuffer: new Uint8Array(arrayBuffer, elementOffset, mipByteSize)
            };
            elementOffset += mipByteSize;
        }
        imageOffset += imageSize + 4;
        imageOffset = imageOffset % 4 !== 0 ? imageOffset + 4 - imageOffset % 4 : imageOffset;
        mipWidth = mipWidth >> 1 || 1;
        mipHeight = mipHeight >> 1 || 1;
        alignedMipWidth = mipWidth + blockWidth - 1 & ~(blockWidth - 1);
        alignedMipHeight = mipHeight + blockHeight - 1 & ~(blockHeight - 1);
        mipByteSize = alignedMipWidth * alignedMipHeight * imagePixelByteSize;
    }
    if (glType !== 0) return {
        uncompressed: imageBuffers.map((levelBuffers)=>{
            let buffer = levelBuffers[0].levelBuffer;
            let convertToInt = false;
            if (glType === (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT) buffer = new Float32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4);
            else if (glType === (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_INT) {
                convertToInt = true;
                buffer = new Uint32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4);
            } else if (glType === (0, $551209d754b5b429$export$426db7a6155b7a80).INT) {
                convertToInt = true;
                buffer = new Int32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4);
            }
            return {
                resource: new (0, $ad9971bad38b5f89$export$a79ef781de624449)(buffer, {
                    width: levelBuffers[0].levelWidth,
                    height: levelBuffers[0].levelHeight
                }),
                type: glType,
                format: convertToInt ? $40970c6d4881ef4f$var$convertFormatToInteger(glFormat) : glFormat
            };
        }),
        kvData: kvData
    };
    return {
        compressed: imageBuffers.map((levelBuffers)=>new (0, $fa0cb104b4c002be$export$1982af6892f05657)(null, {
                format: glInternalFormat,
                width: pixelWidth,
                height: pixelHeight,
                levels: numberOfMipmapLevels,
                levelBuffers: levelBuffers
            })),
        kvData: kvData
    };
}
function $40970c6d4881ef4f$var$validate(url, dataView) {
    for(let i = 0; i < $40970c6d4881ef4f$var$FILE_IDENTIFIER.length; i++)if (dataView.getUint8(i) !== $40970c6d4881ef4f$var$FILE_IDENTIFIER[i]) {
        console.error(`${url} is not a valid *.ktx file!`);
        return false;
    }
    return true;
}
function $40970c6d4881ef4f$var$convertFormatToInteger(format) {
    switch(format){
        case (0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA:
            return (0, $551209d754b5b429$export$e9c4b7b466aa8274).RGBA_INTEGER;
        case (0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB:
            return (0, $551209d754b5b429$export$e9c4b7b466aa8274).RGB_INTEGER;
        case (0, $551209d754b5b429$export$e9c4b7b466aa8274).RG:
            return (0, $551209d754b5b429$export$e9c4b7b466aa8274).RG_INTEGER;
        case (0, $551209d754b5b429$export$e9c4b7b466aa8274).RED:
            return (0, $551209d754b5b429$export$e9c4b7b466aa8274).RED_INTEGER;
        default:
            return format;
    }
}
function $40970c6d4881ef4f$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) {
    const kvData = /* @__PURE__ */ new Map();
    let bytesIntoKeyValueData = 0;
    while(bytesIntoKeyValueData < bytesOfKeyValueData){
        const keyAndValueByteSize = dataView.getUint32($40970c6d4881ef4f$var$FILE_HEADER_SIZE + bytesIntoKeyValueData, littleEndian);
        const keyAndValueByteOffset = $40970c6d4881ef4f$var$FILE_HEADER_SIZE + bytesIntoKeyValueData + 4;
        const valuePadding = 3 - (keyAndValueByteSize + 3) % 4;
        if (keyAndValueByteSize === 0 || keyAndValueByteSize > bytesOfKeyValueData - bytesIntoKeyValueData) {
            console.error("KTXLoader: keyAndValueByteSize out of bounds");
            break;
        }
        let keyNulByte = 0;
        for(; keyNulByte < keyAndValueByteSize; keyNulByte++){
            if (dataView.getUint8(keyAndValueByteOffset + keyNulByte) === 0) break;
        }
        if (keyNulByte === -1) {
            console.error("KTXLoader: Failed to find null byte terminating kvData key");
            break;
        }
        const key = new TextDecoder().decode(new Uint8Array(dataView.buffer, keyAndValueByteOffset, keyNulByte));
        const value = new DataView(dataView.buffer, keyAndValueByteOffset + keyNulByte + 1, keyAndValueByteSize - keyNulByte - 1);
        kvData.set(key, value);
        bytesIntoKeyValueData += 4 + keyAndValueByteSize + valuePadding;
    }
    return kvData;
}





const $2e30c16540495b19$export$20ea358dd867fe3e = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).High
    },
    name: "loadDDS",
    test (url) {
        return (0, $ff6950007d6649ba$export$fd0180357b95b812)(url, ".dds");
    },
    async load (url, asset, loader) {
        const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const resources = (0, $9d3d2e1a107c7be2$export$cddc4925efe88ac)(arrayBuffer);
        const textures = resources.map((resource)=>{
            const base = new (0, $2d8d497fce3a4092$export$d6306e508f184154)(resource, {
                mipmap: (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF,
                alphaMode: (0, $551209d754b5b429$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA,
                resolution: (0, $5d808cc4b6a3c326$exports).getResolutionOfUrl(url),
                ...asset.data
            });
            return (0, $a814436d95267d74$export$37b981a8c575f415)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        if (Array.isArray(texture)) texture.forEach((t)=>t.destroy(true));
        else texture.destroy(true);
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($2e30c16540495b19$export$20ea358dd867fe3e);






const $b0cbe9b13f3b8229$export$e59f5413434dd0e3 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).High
    },
    name: "loadKTX",
    test (url) {
        return (0, $ff6950007d6649ba$export$fd0180357b95b812)(url, ".ktx");
    },
    async load (url, asset, loader) {
        const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const { compressed: compressed , uncompressed: uncompressed , kvData: kvData  } = (0, $40970c6d4881ef4f$export$58a6abed7fd55190)(url, arrayBuffer);
        const resources = compressed ?? uncompressed;
        const options = {
            mipmap: (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF,
            alphaMode: (0, $551209d754b5b429$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA,
            resolution: (0, $5d808cc4b6a3c326$exports).getResolutionOfUrl(url),
            ...asset.data
        };
        const textures = resources.map((resource)=>{
            if (resources === uncompressed) Object.assign(options, {
                type: resource.type,
                format: resource.format
            });
            const base = new (0, $2d8d497fce3a4092$export$d6306e508f184154)(resource, options);
            base.ktxKeyValueData = kvData;
            return (0, $a814436d95267d74$export$37b981a8c575f415)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        if (Array.isArray(texture)) texture.forEach((t)=>t.destroy(true));
        else texture.destroy(true);
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($b0cbe9b13f3b8229$export$e59f5413434dd0e3);



const $fcae4a18c6a3896e$export$513de45dc484f3ba = {
    extension: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).ResolveParser,
    test: (value)=>{
        const temp = value.split("?")[0];
        const extension = temp.split(".").pop();
        return [
            "basis",
            "ktx",
            "dds"
        ].includes(extension);
    },
    parse: (value)=>{
        const temp = value.split("?")[0];
        const extension = temp.split(".").pop();
        if (extension === "ktx") {
            const extensions2 = [
                ".s3tc.ktx",
                ".s3tc_sRGB.ktx",
                ".etc.ktx",
                ".etc1.ktx",
                ".pvrt.ktx",
                ".atc.ktx",
                ".astc.ktx"
            ];
            if (extensions2.some((ext)=>value.endsWith(ext))) return {
                resolution: parseFloat((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: extensions2.find((ext)=>value.endsWith(ext)),
                src: value
            };
        }
        return {
            resolution: parseFloat((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        };
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($fcae4a18c6a3896e$export$513de45dc484f3ba);




















const $96f2638534891602$var$TEMP_RECT = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
const $96f2638534891602$var$BYTES_PER_PIXEL = 4;
const $96f2638534891602$var$_Extract = class {
    constructor(renderer){
        this.renderer = renderer;
    }
    async image(target, format, quality) {
        const image = new Image();
        image.src = await this.base64(target, format, quality);
        return image;
    }
    async base64(target, format, quality) {
        const canvas = this.canvas(target);
        if (canvas.toBlob !== void 0) return new Promise((resolve, reject)=>{
            canvas.toBlob((blob)=>{
                if (!blob) {
                    reject(new Error("ICanvas.toBlob failed!"));
                    return;
                }
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            }, format, quality);
        });
        if (canvas.toDataURL !== void 0) return canvas.toDataURL(format, quality);
        if (canvas.convertToBlob !== void 0) {
            const blob = await canvas.convertToBlob({
                type: format,
                quality: quality
            });
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        }
        throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
    }
    canvas(target, frame) {
        const { pixels: pixels , width: width , height: height , flipY: flipY  } = this._rawPixels(target, frame);
        if (flipY) $96f2638534891602$var$_Extract._flipY(pixels, width, height);
        $96f2638534891602$var$_Extract._unpremultiplyAlpha(pixels);
        const canvasBuffer = new (0, $5d808cc4b6a3c326$exports).CanvasRenderTarget(width, height, 1);
        const imageData = new ImageData(new Uint8ClampedArray(pixels.buffer), width, height);
        canvasBuffer.context.putImageData(imageData, 0, 0);
        return canvasBuffer.canvas;
    }
    pixels(target, frame) {
        const { pixels: pixels , width: width , height: height , flipY: flipY  } = this._rawPixels(target, frame);
        if (flipY) $96f2638534891602$var$_Extract._flipY(pixels, width, height);
        $96f2638534891602$var$_Extract._unpremultiplyAlpha(pixels);
        return pixels;
    }
    _rawPixels(target, frame) {
        const renderer = this.renderer;
        if (!renderer) throw new Error("The Extract has already been destroyed");
        let resolution;
        let flipY = false;
        let renderTexture;
        let generated = false;
        if (target) {
            if (target instanceof (0, $952e32ce616eaf78$export$813984f7330b4d72)) renderTexture = target;
            else {
                renderTexture = renderer.generateTexture(target, {
                    resolution: renderer.resolution,
                    multisample: renderer.multisample
                });
                generated = true;
            }
        }
        if (renderTexture) {
            resolution = renderTexture.baseTexture.resolution;
            frame = frame ?? renderTexture.frame;
            flipY = false;
            if (!generated) {
                renderer.renderTexture.bind(renderTexture);
                const fbo = renderTexture.framebuffer.glFramebuffers[renderer.CONTEXT_UID];
                if (fbo.blitFramebuffer) renderer.framebuffer.bind(fbo.blitFramebuffer);
            }
        } else {
            resolution = renderer.resolution;
            if (!frame) {
                frame = $96f2638534891602$var$TEMP_RECT;
                frame.width = renderer.width / resolution;
                frame.height = renderer.height / resolution;
            }
            flipY = true;
            renderer.renderTexture.bind();
        }
        const width = Math.round(frame.width * resolution);
        const height = Math.round(frame.height * resolution);
        const pixels = new Uint8Array($96f2638534891602$var$BYTES_PER_PIXEL * width * height);
        const gl = renderer.gl;
        gl.readPixels(Math.round(frame.x * resolution), Math.round(frame.y * resolution), width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
        if (generated) renderTexture?.destroy(true);
        return {
            pixels: pixels,
            width: width,
            height: height,
            flipY: flipY
        };
    }
    destroy() {
        this.renderer = null;
    }
    static _flipY(pixels, width, height) {
        const w = width << 2;
        const h = height >> 1;
        const temp = new Uint8Array(w);
        for(let y = 0; y < h; y++){
            const t = y * w;
            const b = (height - y - 1) * w;
            temp.set(pixels.subarray(t, t + w));
            pixels.copyWithin(t, b, b + w);
            pixels.set(temp, b);
        }
    }
    static _unpremultiplyAlpha(pixels) {
        if (pixels instanceof Uint8ClampedArray) pixels = new Uint8Array(pixels.buffer);
        const n = pixels.length;
        for(let i = 0; i < n; i += 4){
            const alpha = pixels[i + 3];
            if (alpha !== 0) {
                const a = 255.001 / alpha;
                pixels[i] = pixels[i] * a + 0.5;
                pixels[i + 1] = pixels[i + 1] * a + 0.5;
                pixels[i + 2] = pixels[i + 2] * a + 0.5;
            }
        }
    }
};
let $96f2638534891602$export$296daa4fd2384194 = $96f2638534891602$var$_Extract;
$96f2638534891602$export$296daa4fd2384194.extension = {
    name: "extract",
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($96f2638534891602$export$296daa4fd2384194);












const $4c913faac15604fc$export$a3541b2d8ecbfcf2 = {
    build (graphicsData) {
        const points = graphicsData.points;
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (graphicsData.type === (0, $07142e085c72c7cc$export$511e1d54a4a8684e).CIRC) {
            const circle = graphicsData.shape;
            x = circle.x;
            y = circle.y;
            rx = ry = circle.radius;
            dx = dy = 0;
        } else if (graphicsData.type === (0, $07142e085c72c7cc$export$511e1d54a4a8684e).ELIP) {
            const ellipse = graphicsData.shape;
            x = ellipse.x;
            y = ellipse.y;
            rx = ellipse.width;
            ry = ellipse.height;
            dx = dy = 0;
        } else {
            const roundedRect = graphicsData.shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) {
            points.length = 0;
            return;
        }
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        points.length = m;
        if (m === 0) return;
        if (n === 0) {
            points.length = 8;
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        {
            const x0 = dx + rx;
            const y0 = dy;
            const x1 = x + x0;
            const x2 = x - x0;
            const y1 = y + y0;
            points[j1++] = x1;
            points[j1++] = y1;
            points[--j2] = y1;
            points[--j2] = x2;
            if (dy) {
                const y2 = y - y0;
                points[j3++] = x2;
                points[j3++] = y2;
                points[--j4] = y2;
                points[--j4] = x1;
            }
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x0 = dx + Math.cos(a) * rx;
            const y0 = dy + Math.sin(a) * ry;
            const x1 = x + x0;
            const x2 = x - x0;
            const y1 = y + y0;
            const y2 = y - y0;
            points[j1++] = x1;
            points[j1++] = y1;
            points[--j2] = y1;
            points[--j2] = x2;
            points[j3++] = x2;
            points[j3++] = y2;
            points[--j4] = y2;
            points[--j4] = x1;
        }
        {
            const x0 = dx;
            const y0 = dy + ry;
            const x1 = x + x0;
            const x2 = x - x0;
            const y1 = y + y0;
            const y2 = y - y0;
            points[j1++] = x1;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x1;
            if (dx) {
                points[j1++] = x2;
                points[j1++] = y1;
                points[--j4] = y2;
                points[--j4] = x2;
            }
        }
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points;
        const verts = graphicsGeometry.points;
        const indices = graphicsGeometry.indices;
        if (points.length === 0) return;
        let vertPos = verts.length / 2;
        const center = vertPos;
        let x;
        let y;
        if (graphicsData.type !== (0, $07142e085c72c7cc$export$511e1d54a4a8684e).RREC) {
            const circle = graphicsData.shape;
            x = circle.x;
            y = circle.y;
        } else {
            const roundedRect = graphicsData.shape;
            x = roundedRect.x + roundedRect.width / 2;
            y = roundedRect.y + roundedRect.height / 2;
        }
        const matrix = graphicsData.matrix;
        verts.push(graphicsData.matrix ? matrix.a * x + matrix.c * y + matrix.tx : x, graphicsData.matrix ? matrix.b * x + matrix.d * y + matrix.ty : y);
        vertPos++;
        verts.push(points[0], points[1]);
        for(let i = 2; i < points.length; i += 2){
            verts.push(points[i], points[i + 1]);
            indices.push(vertPos++, center, vertPos);
        }
        indices.push(center + 1, center, vertPos);
    }
};



function $cd9134e2b709ce53$var$fixOrientation(points, hole = false) {
    const m = points.length;
    if (m < 6) return;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (!hole && area > 0 || hole && area <= 0) {
        const n = m / 2;
        for(let i = n + n % 2; i < m; i += 2){
            const i1 = m - i - 2;
            const i2 = m - i - 1;
            const i3 = i;
            const i4 = i + 1;
            [points[i1], points[i3]] = [
                points[i3],
                points[i1]
            ];
            [points[i2], points[i4]] = [
                points[i4],
                points[i2]
            ];
        }
    }
}
const $cd9134e2b709ce53$export$7de1a57618f21e1f = {
    build (graphicsData) {
        graphicsData.points = graphicsData.shape.points.slice();
    },
    triangulate (graphicsData, graphicsGeometry) {
        let points = graphicsData.points;
        const holes = graphicsData.holes;
        const verts = graphicsGeometry.points;
        const indices = graphicsGeometry.indices;
        if (points.length >= 6) {
            $cd9134e2b709ce53$var$fixOrientation(points, false);
            const holeArray = [];
            for(let i = 0; i < holes.length; i++){
                const hole = holes[i];
                $cd9134e2b709ce53$var$fixOrientation(hole.points, true);
                holeArray.push(points.length / 2);
                points = points.concat(hole.points);
            }
            const triangles = (0, $5d808cc4b6a3c326$exports).earcut(points, holeArray, 2);
            if (!triangles) return;
            const vertPos = verts.length / 2;
            for(let i = 0; i < triangles.length; i += 3){
                indices.push(triangles[i] + vertPos);
                indices.push(triangles[i + 1] + vertPos);
                indices.push(triangles[i + 2] + vertPos);
            }
            for(let i = 0; i < points.length; i++)verts.push(points[i]);
        }
    }
};


const $7ae504b9c1c43240$export$cbe813d11f2192b2 = {
    build (graphicsData) {
        const rectData = graphicsData.shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        const points = graphicsData.points;
        points.length = 0;
        if (!(width >= 0 && height >= 0)) return;
        points.push(x, y, x + width, y, x + width, y + height, x, y + height);
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points;
        const verts = graphicsGeometry.points;
        if (points.length === 0) return;
        const vertPos = verts.length / 2;
        verts.push(points[0], points[1], points[2], points[3], points[6], points[7], points[4], points[5]);
        graphicsGeometry.indices.push(vertPos, vertPos + 1, vertPos + 2, vertPos + 1, vertPos + 2, vertPos + 3);
    }
};



const $b622a5b3f0138217$export$4b54fce47d2ae7f4 = {
    build (graphicsData) {
        (0, $4c913faac15604fc$export$a3541b2d8ecbfcf2).build(graphicsData);
    },
    triangulate (graphicsData, graphicsGeometry) {
        (0, $4c913faac15604fc$export$a3541b2d8ecbfcf2).triangulate(graphicsData, graphicsGeometry);
    }
};



var $e40ae4992b898c4e$export$c6a6e344be1302e7 = /* @__PURE__ */ ((LINE_JOIN2)=>{
    LINE_JOIN2["MITER"] = "miter";
    LINE_JOIN2["BEVEL"] = "bevel";
    LINE_JOIN2["ROUND"] = "round";
    return LINE_JOIN2;
})($e40ae4992b898c4e$export$c6a6e344be1302e7 || {});
var $e40ae4992b898c4e$export$b113e22c48c75d2e = /* @__PURE__ */ ((LINE_CAP2)=>{
    LINE_CAP2["BUTT"] = "butt";
    LINE_CAP2["ROUND"] = "round";
    LINE_CAP2["SQUARE"] = "square";
    return LINE_CAP2;
})($e40ae4992b898c4e$export$b113e22c48c75d2e || {});
const $e40ae4992b898c4e$export$6894093bf294bea5 = {
    adaptive: true,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048,
    epsilon: 1e-4,
    _segmentsCount (length, defaultSegments = 20) {
        if (!this.adaptive || !length || isNaN(length)) return defaultSegments;
        let result = Math.ceil(length / this.maxLength);
        if (result < this.minSegments) result = this.minSegments;
        else if (result > this.maxSegments) result = this.maxSegments;
        return result;
    }
};
const $e40ae4992b898c4e$export$8331f8d2be429f2c = $e40ae4992b898c4e$export$6894093bf294bea5;


class $8118a95e17addabb$export$e6c43ec4db262573 {
    static curveTo(x1, y1, x2, y2, radius, points) {
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        const a1 = fromY - y1;
        const b1 = fromX - x1;
        const a2 = y2 - y1;
        const b2 = x2 - x1;
        const mm = Math.abs(a1 * b2 - b1 * a2);
        if (mm < 1e-8 || radius === 0) {
            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
            return null;
        }
        const dd = a1 * a1 + b1 * b1;
        const cc = a2 * a2 + b2 * b2;
        const tt = a1 * a2 + b1 * b2;
        const k1 = radius * Math.sqrt(dd) / mm;
        const k2 = radius * Math.sqrt(cc) / mm;
        const j1 = k1 * tt / dd;
        const j2 = k2 * tt / cc;
        const cx = k1 * b2 + k2 * b1;
        const cy = k1 * a2 + k2 * a1;
        const px = b1 * (k2 + j1);
        const py = a1 * (k2 + j1);
        const qx = b2 * (k1 + j2);
        const qy = a2 * (k1 + j2);
        const startAngle = Math.atan2(py - cy, px - cx);
        const endAngle = Math.atan2(qy - cy, qx - cx);
        return {
            cx: cx + x1,
            cy: cy + y1,
            radius: radius,
            startAngle: startAngle,
            endAngle: endAngle,
            anticlockwise: b1 * a2 > b2 * a1
        };
    }
    static arc(_startX, _startY, cx, cy, radius, startAngle, endAngle, _anticlockwise, points) {
        const sweep = endAngle - startAngle;
        const n = (0, $e40ae4992b898c4e$export$6894093bf294bea5)._segmentsCount(Math.abs(sweep) * radius, Math.ceil(Math.abs(sweep) / (0, $07142e085c72c7cc$export$59ed0a0a5de1084b)) * 40);
        const theta = sweep / (n * 2);
        const theta2 = theta * 2;
        const cTheta = Math.cos(theta);
        const sTheta = Math.sin(theta);
        const segMinus = n - 1;
        const remainder = segMinus % 1 / segMinus;
        for(let i = 0; i <= segMinus; ++i){
            const real = i + remainder * i;
            const angle = theta + startAngle + theta2 * real;
            const c = Math.cos(angle);
            const s = -Math.sin(angle);
            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }
    }
}


class $d744c4657ef5cdc9$export$3abbb88a93faeec2 {
    constructor(){
        this.reset();
    }
    begin(style, startIndex, attribStart) {
        this.reset();
        this.style = style;
        this.start = startIndex;
        this.attribStart = attribStart;
    }
    end(endIndex, endAttrib) {
        this.attribSize = endAttrib - this.attribStart;
        this.size = endIndex - this.start;
    }
    reset() {
        this.style = null;
        this.size = 0;
        this.start = 0;
        this.attribStart = 0;
        this.attribSize = 0;
    }
}



class $8b8420ad498966ee$export$994e59e1556c01e9 {
    static curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        const n = 10;
        let result = 0;
        let t = 0;
        let t2 = 0;
        let t3 = 0;
        let nt = 0;
        let nt2 = 0;
        let nt3 = 0;
        let x = 0;
        let y = 0;
        let dx = 0;
        let dy = 0;
        let prevX = fromX;
        let prevY = fromY;
        for(let i = 1; i <= n; ++i){
            t = i / n;
            t2 = t * t;
            t3 = t2 * t;
            nt = 1 - t;
            nt2 = nt * nt;
            nt3 = nt2 * nt;
            x = nt3 * fromX + 3 * nt2 * t * cpX + 3 * nt * t2 * cpX2 + t3 * toX;
            y = nt3 * fromY + 3 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
            dx = prevX - x;
            dy = prevY - y;
            prevX = x;
            prevY = y;
            result += Math.sqrt(dx * dx + dy * dy);
        }
        return result;
    }
    static curveTo(cpX, cpY, cpX2, cpY2, toX, toY, points) {
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        points.length -= 2;
        const n = (0, $e40ae4992b898c4e$export$6894093bf294bea5)._segmentsCount($8b8420ad498966ee$export$994e59e1556c01e9.curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY));
        let dt = 0;
        let dt2 = 0;
        let dt3 = 0;
        let t2 = 0;
        let t3 = 0;
        points.push(fromX, fromY);
        for(let i = 1, j = 0; i <= n; ++i){
            j = i / n;
            dt = 1 - j;
            dt2 = dt * dt;
            dt3 = dt2 * dt;
            t2 = j * j;
            t3 = t2 * j;
            points.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
        }
    }
}




function $869154e3d7cd998d$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy, eox, eoy);
    return 2;
}
function $869154e3d7cd998d$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy, sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx, cy, cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        verts.push(cx, cy, ex, ey);
    } else {
        verts.push(sx, sy, cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius, cx, cy);
        verts.push(ex, ey, cx, cy);
    }
    return segCount * 2;
}
function $869154e3d7cd998d$var$buildNonNativeLine(graphicsData, graphicsGeometry) {
    const shape = graphicsData.shape;
    let points = graphicsData.points || shape.points.slice();
    const eps = graphicsGeometry.closePointEps;
    if (points.length === 0) return;
    const style = graphicsData.lineStyle;
    const firstPoint = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(points[0], points[1]);
    const lastPoint = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(points[points.length - 2], points[points.length - 1]);
    const closedShape = shape.type !== (0, $07142e085c72c7cc$export$511e1d54a4a8684e).POLY || shape.closeStroke;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = graphicsGeometry.points;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpx = -(y0 - y1);
    let perpy = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;
    const ratio = style.alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === (0, $e40ae4992b898c4e$export$b113e22c48c75d2e).ROUND) indexCount += $869154e3d7cd998d$var$round(x0 - perpx * (innerWeight - outerWeight) * 0.5, y0 - perpy * (innerWeight - outerWeight) * 0.5, x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight, verts, true) + 2;
        else if (style.cap === (0, $e40ae4992b898c4e$export$b113e22c48c75d2e).SQUARE) indexCount += $869154e3d7cd998d$var$square(x0, y0, perpx, perpy, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpx = -(y0 - y1);
        perpy = x0 - x1;
        dist = Math.sqrt(perpx * perpx + perpy * perpy);
        perpx /= dist;
        perpy /= dist;
        perpx *= width;
        perpy *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight);
            if (dot >= 0) {
                if (style.join === (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).ROUND) indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight, x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpx + x0) * (-perpy + y1) - (-perpx + x1) * (-perpy + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pdist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pdist <= smallerInsideDiagonalSq;
        let join = style.join;
        if (join === (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).MITER && pdist / widthSquared > miterLimitSquared) join = (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).BEVEL;
        if (insideMiterOk) switch(join){
            case (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).MITER:
                verts.push(imx, imy, omx, omy);
                break;
            case (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).BEVEL:
                if (clockwise) verts.push(imx, imy, x1 + perpx * outerWeight, y1 + perpy * outerWeight, imx, imy, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                else verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, omx, omy, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, omx, omy);
                indexCount += 2;
                break;
            case (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).ROUND:
                if (clockwise) {
                    verts.push(imx, imy, x1 + perpx * outerWeight, y1 + perpy * outerWeight);
                    indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, omx, omy);
                    indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, omx, omy);
                }
                break;
        }
        else {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight);
            switch(join){
                case (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).MITER:
                    if (clockwise) verts.push(omx, omy, omx, omy);
                    else verts.push(imx, imy, imx, imy);
                    indexCount += 2;
                    break;
                case (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).ROUND:
                    if (clockwise) indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                    else indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
                    break;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpx = -(y0 - y1);
    perpy = x0 - x1;
    dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;
    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight);
    if (!closedShape) {
        if (style.cap === (0, $e40ae4992b898c4e$export$b113e22c48c75d2e).ROUND) indexCount += $869154e3d7cd998d$var$round(x1 - perpx * (innerWeight - outerWeight) * 0.5, y1 - perpy * (innerWeight - outerWeight) * 0.5, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight, verts, false) + 2;
        else if (style.cap === (0, $e40ae4992b898c4e$export$b113e22c48c75d2e).SQUARE) indexCount += $869154e3d7cd998d$var$square(x1, y1, perpx, perpy, innerWeight, outerWeight, false, verts);
    }
    const indices = graphicsGeometry.indices;
    const eps2 = (0, $e40ae4992b898c4e$export$6894093bf294bea5).epsilon * (0, $e40ae4992b898c4e$export$6894093bf294bea5).epsilon;
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}
function $869154e3d7cd998d$var$buildNativeLine(graphicsData, graphicsGeometry) {
    let i = 0;
    const shape = graphicsData.shape;
    const points = graphicsData.points || shape.points;
    const closedShape = shape.type !== (0, $07142e085c72c7cc$export$511e1d54a4a8684e).POLY || shape.closeStroke;
    if (points.length === 0) return;
    const verts = graphicsGeometry.points;
    const indices = graphicsGeometry.indices;
    const length = points.length / 2;
    const startIndex = verts.length / 2;
    let currentIndex = startIndex;
    verts.push(points[0], points[1]);
    for(i = 1; i < length; i++){
        verts.push(points[i * 2], points[i * 2 + 1]);
        indices.push(currentIndex, currentIndex + 1);
        currentIndex++;
    }
    if (closedShape) indices.push(currentIndex, startIndex);
}
function $869154e3d7cd998d$export$45986ccf08e93b0b(graphicsData, graphicsGeometry) {
    if (graphicsData.lineStyle.native) $869154e3d7cd998d$var$buildNativeLine(graphicsData, graphicsGeometry);
    else $869154e3d7cd998d$var$buildNonNativeLine(graphicsData, graphicsGeometry);
}



class $3eaaf9b529e8eeec$export$616649c7d4fcacf2 {
    static curveLength(fromX, fromY, cpX, cpY, toX, toY) {
        const ax = fromX - 2 * cpX + toX;
        const ay = fromY - 2 * cpY + toY;
        const bx = 2 * cpX - 2 * fromX;
        const by = 2 * cpY - 2 * fromY;
        const a = 4 * (ax * ax + ay * ay);
        const b = 4 * (ax * bx + ay * by);
        const c = bx * bx + by * by;
        const s = 2 * Math.sqrt(a + b + c);
        const a2 = Math.sqrt(a);
        const a32 = 2 * a * a2;
        const c2 = 2 * Math.sqrt(c);
        const ba = b / a2;
        return (a32 * s + a2 * b * (s - c2) + (4 * c * a - b * b) * Math.log((2 * a2 + ba + s) / (ba + c2))) / (4 * a32);
    }
    static curveTo(cpX, cpY, toX, toY, points) {
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        const n = (0, $e40ae4992b898c4e$export$6894093bf294bea5)._segmentsCount($3eaaf9b529e8eeec$export$616649c7d4fcacf2.curveLength(fromX, fromY, cpX, cpY, toX, toY));
        let xa = 0;
        let ya = 0;
        for(let i = 1; i <= n; ++i){
            const j = i / n;
            xa = fromX + (cpX - fromX) * j;
            ya = fromY + (cpY - fromY) * j;
            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }
    }
}


const $880f99c2e54bc0a5$export$b738057f7c88a634 = {
    [(0, $07142e085c72c7cc$export$511e1d54a4a8684e).POLY]: (0, $cd9134e2b709ce53$export$7de1a57618f21e1f),
    [(0, $07142e085c72c7cc$export$511e1d54a4a8684e).CIRC]: (0, $4c913faac15604fc$export$a3541b2d8ecbfcf2),
    [(0, $07142e085c72c7cc$export$511e1d54a4a8684e).ELIP]: (0, $4c913faac15604fc$export$a3541b2d8ecbfcf2),
    [(0, $07142e085c72c7cc$export$511e1d54a4a8684e).RECT]: (0, $7ae504b9c1c43240$export$cbe813d11f2192b2),
    [(0, $07142e085c72c7cc$export$511e1d54a4a8684e).RREC]: (0, $b622a5b3f0138217$export$4b54fce47d2ae7f4)
};
const $880f99c2e54bc0a5$export$78aca0cfc72b8d6 = [];
const $880f99c2e54bc0a5$export$e520c68c6872beed = [];








class $77ac160306b47509$export$94accce0eb494446 {
    constructor(shape, fillStyle = null, lineStyle = null, matrix = null){
        this.points = [];
        this.holes = [];
        this.shape = shape;
        this.lineStyle = lineStyle;
        this.fillStyle = fillStyle;
        this.matrix = matrix;
        this.type = shape.type;
    }
    clone() {
        return new $77ac160306b47509$export$94accce0eb494446(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    }
    destroy() {
        this.shape = null;
        this.holes.length = 0;
        this.holes = null;
        this.points.length = 0;
        this.points = null;
        this.lineStyle = null;
        this.fillStyle = null;
    }
}






const $62d06b90af230081$var$tmpPoint = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
const $62d06b90af230081$var$_GraphicsGeometry = class extends (0, $93dcf2ad94a668bf$export$449e8d355fd68e43) {
    constructor(){
        super();
        this.closePointEps = 1e-4;
        this.boundsPadding = 0;
        this.uvsFloat32 = null;
        this.indicesUint16 = null;
        this.batchable = false;
        this.points = [];
        this.colors = [];
        this.uvs = [];
        this.indices = [];
        this.textureIds = [];
        this.graphicsData = [];
        this.drawCalls = [];
        this.batchDirty = -1;
        this.batches = [];
        this.dirty = 0;
        this.cacheDirty = -1;
        this.clearDirty = 0;
        this.shapeIndex = 0;
        this._bounds = new (0, $51558a611c79ce5a$export$c4e9d269599ab4b4)();
        this.boundsDirty = -1;
    }
    get bounds() {
        this.updateBatches();
        if (this.boundsDirty !== this.dirty) {
            this.boundsDirty = this.dirty;
            this.calculateBounds();
        }
        return this._bounds;
    }
    invalidate() {
        this.boundsDirty = -1;
        this.dirty++;
        this.batchDirty++;
        this.shapeIndex = 0;
        this.points.length = 0;
        this.colors.length = 0;
        this.uvs.length = 0;
        this.indices.length = 0;
        this.textureIds.length = 0;
        for(let i = 0; i < this.drawCalls.length; i++){
            this.drawCalls[i].texArray.clear();
            (0, $880f99c2e54bc0a5$export$e520c68c6872beed).push(this.drawCalls[i]);
        }
        this.drawCalls.length = 0;
        for(let i = 0; i < this.batches.length; i++){
            const batchPart = this.batches[i];
            batchPart.reset();
            (0, $880f99c2e54bc0a5$export$78aca0cfc72b8d6).push(batchPart);
        }
        this.batches.length = 0;
    }
    clear() {
        if (this.graphicsData.length > 0) {
            this.invalidate();
            this.clearDirty++;
            this.graphicsData.length = 0;
        }
        return this;
    }
    drawShape(shape, fillStyle = null, lineStyle = null, matrix = null) {
        const data = new (0, $77ac160306b47509$export$94accce0eb494446)(shape, fillStyle, lineStyle, matrix);
        this.graphicsData.push(data);
        this.dirty++;
        return this;
    }
    drawHole(shape, matrix = null) {
        if (!this.graphicsData.length) return null;
        const data = new (0, $77ac160306b47509$export$94accce0eb494446)(shape, null, null, matrix);
        const lastShape = this.graphicsData[this.graphicsData.length - 1];
        data.lineStyle = lastShape.lineStyle;
        lastShape.holes.push(data);
        this.dirty++;
        return this;
    }
    destroy() {
        super.destroy();
        for(let i = 0; i < this.graphicsData.length; ++i)this.graphicsData[i].destroy();
        this.points.length = 0;
        this.points = null;
        this.colors.length = 0;
        this.colors = null;
        this.uvs.length = 0;
        this.uvs = null;
        this.indices.length = 0;
        this.indices = null;
        this.indexBuffer.destroy();
        this.indexBuffer = null;
        this.graphicsData.length = 0;
        this.graphicsData = null;
        this.drawCalls.length = 0;
        this.drawCalls = null;
        this.batches.length = 0;
        this.batches = null;
        this._bounds = null;
    }
    containsPoint(point) {
        const graphicsData = this.graphicsData;
        for(let i = 0; i < graphicsData.length; ++i){
            const data = graphicsData[i];
            if (!data.fillStyle.visible) continue;
            if (data.shape) {
                if (data.matrix) data.matrix.applyInverse(point, $62d06b90af230081$var$tmpPoint);
                else $62d06b90af230081$var$tmpPoint.copyFrom(point);
                if (data.shape.contains($62d06b90af230081$var$tmpPoint.x, $62d06b90af230081$var$tmpPoint.y)) {
                    let hitHole = false;
                    if (data.holes) for(let i2 = 0; i2 < data.holes.length; i2++){
                        const hole = data.holes[i2];
                        if (hole.shape.contains($62d06b90af230081$var$tmpPoint.x, $62d06b90af230081$var$tmpPoint.y)) {
                            hitHole = true;
                            break;
                        }
                    }
                    if (!hitHole) return true;
                }
            }
        }
        return false;
    }
    updateBatches() {
        if (!this.graphicsData.length) {
            this.batchable = true;
            return;
        }
        if (!this.validateBatching()) return;
        this.cacheDirty = this.dirty;
        const uvs = this.uvs;
        const graphicsData = this.graphicsData;
        let batchPart = null;
        let currentStyle = null;
        if (this.batches.length > 0) {
            batchPart = this.batches[this.batches.length - 1];
            currentStyle = batchPart.style;
        }
        for(let i = this.shapeIndex; i < graphicsData.length; i++){
            this.shapeIndex++;
            const data = graphicsData[i];
            const fillStyle = data.fillStyle;
            const lineStyle = data.lineStyle;
            const command = (0, $880f99c2e54bc0a5$export$b738057f7c88a634)[data.type];
            command.build(data);
            if (data.matrix) this.transformPoints(data.points, data.matrix);
            if (fillStyle.visible || lineStyle.visible) this.processHoles(data.holes);
            for(let j = 0; j < 2; j++){
                const style = j === 0 ? fillStyle : lineStyle;
                if (!style.visible) continue;
                const nextTexture = style.texture.baseTexture;
                const index2 = this.indices.length;
                const attribIndex = this.points.length / 2;
                nextTexture.wrapMode = (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).REPEAT;
                if (j === 0) this.processFill(data);
                else this.processLine(data);
                const size = this.points.length / 2 - attribIndex;
                if (size === 0) continue;
                if (batchPart && !this._compareStyles(currentStyle, style)) {
                    batchPart.end(index2, attribIndex);
                    batchPart = null;
                }
                if (!batchPart) {
                    batchPart = (0, $880f99c2e54bc0a5$export$78aca0cfc72b8d6).pop() || new (0, $d744c4657ef5cdc9$export$3abbb88a93faeec2)();
                    batchPart.begin(style, index2, attribIndex);
                    this.batches.push(batchPart);
                    currentStyle = style;
                }
                this.addUvs(this.points, uvs, style.texture, attribIndex, size, style.matrix);
            }
        }
        const index = this.indices.length;
        const attrib = this.points.length / 2;
        if (batchPart) batchPart.end(index, attrib);
        if (this.batches.length === 0) {
            this.batchable = true;
            return;
        }
        const need32 = attrib > 65535;
        if (this.indicesUint16 && this.indices.length === this.indicesUint16.length && need32 === this.indicesUint16.BYTES_PER_ELEMENT > 2) this.indicesUint16.set(this.indices);
        else this.indicesUint16 = need32 ? new Uint32Array(this.indices) : new Uint16Array(this.indices);
        this.batchable = this.isBatchable();
        if (this.batchable) this.packBatches();
        else this.buildDrawCalls();
    }
    _compareStyles(styleA, styleB) {
        if (!styleA || !styleB) return false;
        if (styleA.texture.baseTexture !== styleB.texture.baseTexture) return false;
        if (styleA.color + styleA.alpha !== styleB.color + styleB.alpha) return false;
        if (!!styleA.native !== !!styleB.native) return false;
        return true;
    }
    validateBatching() {
        if (this.dirty === this.cacheDirty || !this.graphicsData.length) return false;
        for(let i = 0, l = this.graphicsData.length; i < l; i++){
            const data = this.graphicsData[i];
            const fill = data.fillStyle;
            const line = data.lineStyle;
            if (fill && !fill.texture.baseTexture.valid) return false;
            if (line && !line.texture.baseTexture.valid) return false;
        }
        return true;
    }
    packBatches() {
        this.batchDirty++;
        this.uvsFloat32 = new Float32Array(this.uvs);
        const batches = this.batches;
        for(let i = 0, l = batches.length; i < l; i++){
            const batch = batches[i];
            for(let j = 0; j < batch.size; j++){
                const index = batch.start + j;
                this.indicesUint16[index] = this.indicesUint16[index] - batch.attribStart;
            }
        }
    }
    isBatchable() {
        if (this.points.length > 131070) return false;
        const batches = this.batches;
        for(let i = 0; i < batches.length; i++){
            if (batches[i].style.native) return false;
        }
        return this.points.length < $62d06b90af230081$var$_GraphicsGeometry.BATCHABLE_SIZE * 2;
    }
    buildDrawCalls() {
        let TICK = ++(0, $2d8d497fce3a4092$export$d6306e508f184154)._globalBatch;
        for(let i = 0; i < this.drawCalls.length; i++){
            this.drawCalls[i].texArray.clear();
            (0, $880f99c2e54bc0a5$export$e520c68c6872beed).push(this.drawCalls[i]);
        }
        this.drawCalls.length = 0;
        const colors = this.colors;
        const textureIds = this.textureIds;
        let currentGroup = (0, $880f99c2e54bc0a5$export$e520c68c6872beed).pop();
        if (!currentGroup) {
            currentGroup = new (0, $27210fb05180b1cb$export$664fd198634fda29)();
            currentGroup.texArray = new (0, $f453ad575c2dc61d$export$aa760e0febf1a758)();
        }
        currentGroup.texArray.count = 0;
        currentGroup.start = 0;
        currentGroup.size = 0;
        currentGroup.type = (0, $551209d754b5b429$export$91100badd8469338).TRIANGLES;
        let textureCount = 0;
        let currentTexture = null;
        let textureId = 0;
        let native = false;
        let drawMode = (0, $551209d754b5b429$export$91100badd8469338).TRIANGLES;
        let index = 0;
        this.drawCalls.push(currentGroup);
        for(let i = 0; i < this.batches.length; i++){
            const data = this.batches[i];
            const maxTextures = 8;
            const style = data.style;
            const nextTexture = style.texture.baseTexture;
            if (native !== !!style.native) {
                native = !!style.native;
                drawMode = native ? (0, $551209d754b5b429$export$91100badd8469338).LINES : (0, $551209d754b5b429$export$91100badd8469338).TRIANGLES;
                currentTexture = null;
                textureCount = maxTextures;
                TICK++;
            }
            if (currentTexture !== nextTexture) {
                currentTexture = nextTexture;
                if (nextTexture._batchEnabled !== TICK) {
                    if (textureCount === maxTextures) {
                        TICK++;
                        textureCount = 0;
                        if (currentGroup.size > 0) {
                            currentGroup = (0, $880f99c2e54bc0a5$export$e520c68c6872beed).pop();
                            if (!currentGroup) {
                                currentGroup = new (0, $27210fb05180b1cb$export$664fd198634fda29)();
                                currentGroup.texArray = new (0, $f453ad575c2dc61d$export$aa760e0febf1a758)();
                            }
                            this.drawCalls.push(currentGroup);
                        }
                        currentGroup.start = index;
                        currentGroup.size = 0;
                        currentGroup.texArray.count = 0;
                        currentGroup.type = drawMode;
                    }
                    nextTexture.touched = 1;
                    nextTexture._batchEnabled = TICK;
                    nextTexture._batchLocation = textureCount;
                    nextTexture.wrapMode = (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).REPEAT;
                    currentGroup.texArray.elements[currentGroup.texArray.count++] = nextTexture;
                    textureCount++;
                }
            }
            currentGroup.size += data.size;
            index += data.size;
            textureId = nextTexture._batchLocation;
            this.addColors(colors, style.color, style.alpha, data.attribSize, data.attribStart);
            this.addTextureIds(textureIds, textureId, data.attribSize, data.attribStart);
        }
        (0, $2d8d497fce3a4092$export$d6306e508f184154)._globalBatch = TICK;
        this.packAttributes();
    }
    packAttributes() {
        const verts = this.points;
        const uvs = this.uvs;
        const colors = this.colors;
        const textureIds = this.textureIds;
        const glPoints = new ArrayBuffer(verts.length * 12);
        const f32 = new Float32Array(glPoints);
        const u32 = new Uint32Array(glPoints);
        let p = 0;
        for(let i = 0; i < verts.length / 2; i++){
            f32[p++] = verts[i * 2];
            f32[p++] = verts[i * 2 + 1];
            f32[p++] = uvs[i * 2];
            f32[p++] = uvs[i * 2 + 1];
            u32[p++] = colors[i];
            f32[p++] = textureIds[i];
        }
        this._buffer.update(glPoints);
        this._indexBuffer.update(this.indicesUint16);
    }
    processFill(data) {
        if (data.holes.length) (0, $cd9134e2b709ce53$export$7de1a57618f21e1f).triangulate(data, this);
        else {
            const command = (0, $880f99c2e54bc0a5$export$b738057f7c88a634)[data.type];
            command.triangulate(data, this);
        }
    }
    processLine(data) {
        (0, $869154e3d7cd998d$export$45986ccf08e93b0b)(data, this);
        for(let i = 0; i < data.holes.length; i++)(0, $869154e3d7cd998d$export$45986ccf08e93b0b)(data.holes[i], this);
    }
    processHoles(holes) {
        for(let i = 0; i < holes.length; i++){
            const hole = holes[i];
            const command = (0, $880f99c2e54bc0a5$export$b738057f7c88a634)[hole.type];
            command.build(hole);
            if (hole.matrix) this.transformPoints(hole.points, hole.matrix);
        }
    }
    calculateBounds() {
        const bounds = this._bounds;
        bounds.clear();
        bounds.addVertexData(this.points, 0, this.points.length);
        bounds.pad(this.boundsPadding, this.boundsPadding);
    }
    transformPoints(points, matrix) {
        for(let i = 0; i < points.length / 2; i++){
            const x = points[i * 2];
            const y = points[i * 2 + 1];
            points[i * 2] = matrix.a * x + matrix.c * y + matrix.tx;
            points[i * 2 + 1] = matrix.b * x + matrix.d * y + matrix.ty;
        }
    }
    addColors(colors, color, alpha, size, offset = 0) {
        const bgr = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(color).toLittleEndianNumber();
        const result = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(bgr).toPremultiplied(alpha);
        colors.length = Math.max(colors.length, offset + size);
        for(let i = 0; i < size; i++)colors[offset + i] = result;
    }
    addTextureIds(textureIds, id, size, offset = 0) {
        textureIds.length = Math.max(textureIds.length, offset + size);
        for(let i = 0; i < size; i++)textureIds[offset + i] = id;
    }
    addUvs(verts, uvs, texture, start, size, matrix = null) {
        let index = 0;
        const uvsStart = uvs.length;
        const frame = texture.frame;
        while(index < size){
            let x = verts[(start + index) * 2];
            let y = verts[(start + index) * 2 + 1];
            if (matrix) {
                const nx = matrix.a * x + matrix.c * y + matrix.tx;
                y = matrix.b * x + matrix.d * y + matrix.ty;
                x = nx;
            }
            index++;
            uvs.push(x / frame.width, y / frame.height);
        }
        const baseTexture = texture.baseTexture;
        if (frame.width < baseTexture.width || frame.height < baseTexture.height) this.adjustUvs(uvs, texture, uvsStart, size);
    }
    adjustUvs(uvs, texture, start, size) {
        const baseTexture = texture.baseTexture;
        const eps = 1e-6;
        const finish = start + size * 2;
        const frame = texture.frame;
        const scaleX = frame.width / baseTexture.width;
        const scaleY = frame.height / baseTexture.height;
        let offsetX = frame.x / frame.width;
        let offsetY = frame.y / frame.height;
        let minX = Math.floor(uvs[start] + eps);
        let minY = Math.floor(uvs[start + 1] + eps);
        for(let i = start + 2; i < finish; i += 2){
            minX = Math.min(minX, Math.floor(uvs[i] + eps));
            minY = Math.min(minY, Math.floor(uvs[i + 1] + eps));
        }
        offsetX -= minX;
        offsetY -= minY;
        for(let i = start; i < finish; i += 2){
            uvs[i] = (uvs[i] + offsetX) * scaleX;
            uvs[i + 1] = (uvs[i + 1] + offsetY) * scaleY;
        }
    }
};
let $62d06b90af230081$export$c707987b44ce3a12 = $62d06b90af230081$var$_GraphicsGeometry;
$62d06b90af230081$export$c707987b44ce3a12.BATCHABLE_SIZE = 100;



class $077009b4f19b9a33$export$c42b166860ccdbd8 {
    constructor(){
        this.color = 16777215;
        this.alpha = 1;
        this.texture = (0, $6ac4ad2139942545$export$5431306cf43de24a).WHITE;
        this.matrix = null;
        this.visible = false;
        this.reset();
    }
    clone() {
        const obj = new $077009b4f19b9a33$export$c42b166860ccdbd8();
        obj.color = this.color;
        obj.alpha = this.alpha;
        obj.texture = this.texture;
        obj.matrix = this.matrix;
        obj.visible = this.visible;
        return obj;
    }
    reset() {
        this.color = 16777215;
        this.alpha = 1;
        this.texture = (0, $6ac4ad2139942545$export$5431306cf43de24a).WHITE;
        this.matrix = null;
        this.visible = false;
    }
    destroy() {
        this.texture = null;
        this.matrix = null;
    }
}




class $be79a60131aa6380$export$5d24e00cfde59887 extends (0, $077009b4f19b9a33$export$c42b166860ccdbd8) {
    constructor(){
        super(...arguments);
        this.width = 0;
        this.alignment = 0.5;
        this.native = false;
        this.cap = (0, $e40ae4992b898c4e$export$b113e22c48c75d2e).BUTT;
        this.join = (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).MITER;
        this.miterLimit = 10;
    }
    clone() {
        const obj = new $be79a60131aa6380$export$5d24e00cfde59887();
        obj.color = this.color;
        obj.alpha = this.alpha;
        obj.texture = this.texture;
        obj.matrix = this.matrix;
        obj.visible = this.visible;
        obj.width = this.width;
        obj.alignment = this.alignment;
        obj.native = this.native;
        obj.cap = this.cap;
        obj.join = this.join;
        obj.miterLimit = this.miterLimit;
        return obj;
    }
    reset() {
        super.reset();
        this.color = 0;
        this.alignment = 0.5;
        this.width = 0;
        this.native = false;
    }
}






const $680a5efca7e434a6$var$DEFAULT_SHADERS = {};
const $680a5efca7e434a6$var$_Graphics = class extends (0, $823fbc2c4ae841df$export$42a852a2b6b56249) {
    constructor(geometry = null){
        super();
        this.shader = null;
        this.pluginName = "batch";
        this.currentPath = null;
        this.batches = [];
        this.batchTint = -1;
        this.batchDirty = -1;
        this.vertexData = null;
        this._fillStyle = new (0, $077009b4f19b9a33$export$c42b166860ccdbd8)();
        this._lineStyle = new (0, $be79a60131aa6380$export$5d24e00cfde59887)();
        this._matrix = null;
        this._holeMode = false;
        this.state = (0, $15a50e9cd387ae21$export$7254cc27399e90bd).for2d();
        this._geometry = geometry || new (0, $62d06b90af230081$export$c707987b44ce3a12)();
        this._geometry.refCount++;
        this._transformID = -1;
        this._tintColor = new (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e)(16777215);
        this.blendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL;
    }
    get geometry() {
        return this._geometry;
    }
    clone() {
        this.finishPoly();
        return new $680a5efca7e434a6$var$_Graphics(this._geometry);
    }
    set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value);
    }
    get fill() {
        return this._fillStyle;
    }
    get line() {
        return this._lineStyle;
    }
    lineStyle(options = null, color = 0, alpha, alignment = 0.5, native = false) {
        if (typeof options === "number") options = {
            width: options,
            color: color,
            alpha: alpha,
            alignment: alignment,
            native: native
        };
        return this.lineTextureStyle(options);
    }
    lineTextureStyle(options) {
        const defaultLineStyleOptions = {
            width: 0,
            texture: (0, $6ac4ad2139942545$export$5431306cf43de24a).WHITE,
            color: options?.texture ? 16777215 : 0,
            matrix: null,
            alignment: 0.5,
            native: false,
            cap: (0, $e40ae4992b898c4e$export$b113e22c48c75d2e).BUTT,
            join: (0, $e40ae4992b898c4e$export$c6a6e344be1302e7).MITER,
            miterLimit: 10
        };
        options = Object.assign(defaultLineStyleOptions, options);
        this.normalizeColor(options);
        if (this.currentPath) this.startPoly();
        const visible = options.width > 0 && options.alpha > 0;
        if (!visible) this._lineStyle.reset();
        else {
            if (options.matrix) {
                options.matrix = options.matrix.clone();
                options.matrix.invert();
            }
            Object.assign(this._lineStyle, {
                visible: visible
            }, options);
        }
        return this;
    }
    startPoly() {
        if (this.currentPath) {
            const points = this.currentPath.points;
            const len = this.currentPath.points.length;
            if (len > 2) {
                this.drawShape(this.currentPath);
                this.currentPath = new (0, $173c2dfd36fd3f4f$export$7d31b617c820d435)();
                this.currentPath.closeStroke = false;
                this.currentPath.points.push(points[len - 2], points[len - 1]);
            }
        } else {
            this.currentPath = new (0, $173c2dfd36fd3f4f$export$7d31b617c820d435)();
            this.currentPath.closeStroke = false;
        }
    }
    finishPoly() {
        if (this.currentPath) {
            if (this.currentPath.points.length > 2) {
                this.drawShape(this.currentPath);
                this.currentPath = null;
            } else this.currentPath.points.length = 0;
        }
    }
    moveTo(x, y) {
        this.startPoly();
        this.currentPath.points[0] = x;
        this.currentPath.points[1] = y;
        return this;
    }
    lineTo(x, y) {
        if (!this.currentPath) this.moveTo(0, 0);
        const points = this.currentPath.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    _initCurve(x = 0, y = 0) {
        if (this.currentPath) {
            if (this.currentPath.points.length === 0) this.currentPath.points = [
                x,
                y
            ];
        } else this.moveTo(x, y);
    }
    quadraticCurveTo(cpX, cpY, toX, toY) {
        this._initCurve();
        const points = this.currentPath.points;
        if (points.length === 0) this.moveTo(0, 0);
        (0, $3eaaf9b529e8eeec$export$616649c7d4fcacf2).curveTo(cpX, cpY, toX, toY, points);
        return this;
    }
    bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
        this._initCurve();
        (0, $8b8420ad498966ee$export$994e59e1556c01e9).curveTo(cpX, cpY, cpX2, cpY2, toX, toY, this.currentPath.points);
        return this;
    }
    arcTo(x1, y1, x2, y2, radius) {
        this._initCurve(x1, y1);
        const points = this.currentPath.points;
        const result = (0, $8118a95e17addabb$export$e6c43ec4db262573).curveTo(x1, y1, x2, y2, radius, points);
        if (result) {
            const { cx: cx , cy: cy , radius: radius2 , startAngle: startAngle , endAngle: endAngle , anticlockwise: anticlockwise  } = result;
            this.arc(cx, cy, radius2, startAngle, endAngle, anticlockwise);
        }
        return this;
    }
    arc(cx, cy, radius, startAngle, endAngle, anticlockwise = false) {
        if (startAngle === endAngle) return this;
        if (!anticlockwise && endAngle <= startAngle) endAngle += (0, $07142e085c72c7cc$export$59ed0a0a5de1084b);
        else if (anticlockwise && startAngle <= endAngle) startAngle += (0, $07142e085c72c7cc$export$59ed0a0a5de1084b);
        const sweep = endAngle - startAngle;
        if (sweep === 0) return this;
        const startX = cx + Math.cos(startAngle) * radius;
        const startY = cy + Math.sin(startAngle) * radius;
        const eps = this._geometry.closePointEps;
        let points = this.currentPath ? this.currentPath.points : null;
        if (points) {
            const xDiff = Math.abs(points[points.length - 2] - startX);
            const yDiff = Math.abs(points[points.length - 1] - startY);
            if (xDiff < eps && yDiff < eps) ;
            else points.push(startX, startY);
        } else {
            this.moveTo(startX, startY);
            points = this.currentPath.points;
        }
        (0, $8118a95e17addabb$export$e6c43ec4db262573).arc(startX, startY, cx, cy, radius, startAngle, endAngle, anticlockwise, points);
        return this;
    }
    beginFill(color = 0, alpha) {
        return this.beginTextureFill({
            texture: (0, $6ac4ad2139942545$export$5431306cf43de24a).WHITE,
            color: color,
            alpha: alpha
        });
    }
    normalizeColor(options) {
        const temp = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(options.color ?? 0);
        options.color = temp.toNumber();
        options.alpha ?? (options.alpha = temp.alpha);
    }
    beginTextureFill(options) {
        const defaultOptions = {
            texture: (0, $6ac4ad2139942545$export$5431306cf43de24a).WHITE,
            color: 16777215,
            matrix: null
        };
        options = Object.assign(defaultOptions, options);
        this.normalizeColor(options);
        if (this.currentPath) this.startPoly();
        const visible = options.alpha > 0;
        if (!visible) this._fillStyle.reset();
        else {
            if (options.matrix) {
                options.matrix = options.matrix.clone();
                options.matrix.invert();
            }
            Object.assign(this._fillStyle, {
                visible: visible
            }, options);
        }
        return this;
    }
    endFill() {
        this.finishPoly();
        this._fillStyle.reset();
        return this;
    }
    drawRect(x, y, width, height) {
        return this.drawShape(new (0, $340a428aa13511cc$export$4617fb02663045ef)(x, y, width, height));
    }
    drawRoundedRect(x, y, width, height, radius) {
        return this.drawShape(new (0, $cfa2d28b786e5ab9$export$d55ab2e3dc5a4263)(x, y, width, height, radius));
    }
    drawCircle(x, y, radius) {
        return this.drawShape(new (0, $224e00dc89bc3e26$export$c89a927ffc67e6fa)(x, y, radius));
    }
    drawEllipse(x, y, width, height) {
        return this.drawShape(new (0, $07416f9533a1f100$export$80b0269ab108fa11)(x, y, width, height));
    }
    drawPolygon(...path) {
        let points;
        let closeStroke = true;
        const poly = path[0];
        if (poly.points) {
            closeStroke = poly.closeStroke;
            points = poly.points;
        } else if (Array.isArray(path[0])) points = path[0];
        else points = path;
        const shape = new (0, $173c2dfd36fd3f4f$export$7d31b617c820d435)(points);
        shape.closeStroke = closeStroke;
        this.drawShape(shape);
        return this;
    }
    drawShape(shape) {
        if (!this._holeMode) this._geometry.drawShape(shape, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix);
        else this._geometry.drawHole(shape, this._matrix);
        return this;
    }
    clear() {
        this._geometry.clear();
        this._lineStyle.reset();
        this._fillStyle.reset();
        this._boundsID++;
        this._matrix = null;
        this._holeMode = false;
        this.currentPath = null;
        return this;
    }
    isFastRect() {
        const data = this._geometry.graphicsData;
        return data.length === 1 && data[0].shape.type === (0, $07142e085c72c7cc$export$511e1d54a4a8684e).RECT && !data[0].matrix && !data[0].holes.length && !(data[0].lineStyle.visible && data[0].lineStyle.width);
    }
    _render(renderer) {
        this.finishPoly();
        const geometry = this._geometry;
        geometry.updateBatches();
        if (geometry.batchable) {
            if (this.batchDirty !== geometry.batchDirty) this._populateBatches();
            this._renderBatched(renderer);
        } else {
            renderer.batch.flush();
            this._renderDirect(renderer);
        }
    }
    _populateBatches() {
        const geometry = this._geometry;
        const blendMode = this.blendMode;
        const len = geometry.batches.length;
        this.batchTint = -1;
        this._transformID = -1;
        this.batchDirty = geometry.batchDirty;
        this.batches.length = len;
        this.vertexData = new Float32Array(geometry.points);
        for(let i = 0; i < len; i++){
            const gI = geometry.batches[i];
            const color = gI.style.color;
            const vertexData = new Float32Array(this.vertexData.buffer, gI.attribStart * 8, gI.attribSize * 2);
            const uvs = new Float32Array(geometry.uvsFloat32.buffer, gI.attribStart * 8, gI.attribSize * 2);
            const indices = new Uint16Array(geometry.indicesUint16.buffer, gI.start * 2, gI.size);
            const batch = {
                vertexData: vertexData,
                blendMode: blendMode,
                indices: indices,
                uvs: uvs,
                _batchRGB: (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(color).toRgbArray(),
                _tintRGB: color,
                _texture: gI.style.texture,
                alpha: gI.style.alpha,
                worldAlpha: 1
            };
            this.batches[i] = batch;
        }
    }
    _renderBatched(renderer) {
        if (!this.batches.length) return;
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        this.calculateVertices();
        this.calculateTints();
        for(let i = 0, l = this.batches.length; i < l; i++){
            const batch = this.batches[i];
            batch.worldAlpha = this.worldAlpha * batch.alpha;
            renderer.plugins[this.pluginName].render(batch);
        }
    }
    _renderDirect(renderer) {
        const shader = this._resolveDirectShader(renderer);
        const geometry = this._geometry;
        const worldAlpha = this.worldAlpha;
        const uniforms = shader.uniforms;
        const drawCalls = geometry.drawCalls;
        uniforms.translationMatrix = this.transform.worldTransform;
        (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(this._tintColor).premultiply(worldAlpha).toArray(uniforms.tint);
        renderer.shader.bind(shader);
        renderer.geometry.bind(geometry, shader);
        renderer.state.set(this.state);
        for(let i = 0, l = drawCalls.length; i < l; i++)this._renderDrawCallDirect(renderer, geometry.drawCalls[i]);
    }
    _renderDrawCallDirect(renderer, drawCall) {
        const { texArray: texArray , type: type , size: size , start: start  } = drawCall;
        const groupTextureCount = texArray.count;
        for(let j = 0; j < groupTextureCount; j++)renderer.texture.bind(texArray.elements[j], j);
        renderer.geometry.draw(type, size, start);
    }
    _resolveDirectShader(renderer) {
        let shader = this.shader;
        const pluginName = this.pluginName;
        if (!shader) {
            if (!$680a5efca7e434a6$var$DEFAULT_SHADERS[pluginName]) {
                const { maxTextures: maxTextures  } = renderer.plugins[pluginName];
                const sampleValues = new Int32Array(maxTextures);
                for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
                const uniforms = {
                    tint: new Float32Array([
                        1,
                        1,
                        1,
                        1
                    ]),
                    translationMatrix: new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)(),
                    default: (0, $d21ea31dd94e9628$export$6601a7a2dcf79bf5).from({
                        uSamplers: sampleValues
                    }, true)
                };
                const program = renderer.plugins[pluginName]._shader.program;
                $680a5efca7e434a6$var$DEFAULT_SHADERS[pluginName] = new (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5)(program, uniforms);
            }
            shader = $680a5efca7e434a6$var$DEFAULT_SHADERS[pluginName];
        }
        return shader;
    }
    _calculateBounds() {
        this.finishPoly();
        const geometry = this._geometry;
        if (!geometry.graphicsData.length) return;
        const { minX: minX , minY: minY , maxX: maxX , maxY: maxY  } = geometry.bounds;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    containsPoint(point) {
        this.worldTransform.applyInverse(point, $680a5efca7e434a6$var$_Graphics._TEMP_POINT);
        return this._geometry.containsPoint($680a5efca7e434a6$var$_Graphics._TEMP_POINT);
    }
    calculateTints() {
        if (this.batchTint !== this.tint) {
            this.batchTint = this._tintColor.toNumber();
            for(let i = 0; i < this.batches.length; i++){
                const batch = this.batches[i];
                batch._tintRGB = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(this._tintColor).multiply(batch._batchRGB).toLittleEndianNumber();
            }
        }
    }
    calculateVertices() {
        const wtID = this.transform._worldID;
        if (this._transformID === wtID) return;
        this._transformID = wtID;
        const wt = this.transform.worldTransform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const data = this._geometry.points;
        const vertexData = this.vertexData;
        let count = 0;
        for(let i = 0; i < data.length; i += 2){
            const x = data[i];
            const y = data[i + 1];
            vertexData[count++] = a * x + c * y + tx;
            vertexData[count++] = d * y + b * x + ty;
        }
    }
    closePath() {
        const currentPath = this.currentPath;
        if (currentPath) {
            currentPath.closeStroke = true;
            this.finishPoly();
        }
        return this;
    }
    setMatrix(matrix) {
        this._matrix = matrix;
        return this;
    }
    beginHole() {
        this.finishPoly();
        this._holeMode = true;
        return this;
    }
    endHole() {
        this.finishPoly();
        this._holeMode = false;
        return this;
    }
    destroy(options) {
        this._geometry.refCount--;
        if (this._geometry.refCount === 0) this._geometry.dispose();
        this._matrix = null;
        this.currentPath = null;
        this._lineStyle.destroy();
        this._lineStyle = null;
        this._fillStyle.destroy();
        this._fillStyle = null;
        this._geometry = null;
        this.shader = null;
        this.vertexData = null;
        this.batches.length = 0;
        this.batches = null;
        super.destroy(options);
    }
};
let $680a5efca7e434a6$export$29d3e417456abdad = $680a5efca7e434a6$var$_Graphics;
$680a5efca7e434a6$export$29d3e417456abdad.curves = (0, $e40ae4992b898c4e$export$6894093bf294bea5);
$680a5efca7e434a6$export$29d3e417456abdad._TEMP_POINT = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();















const $827f57ff8261ea1c$export$efc72ad5bf88689 = {
    buildPoly: $cd9134e2b709ce53$export$7de1a57618f21e1f,
    buildCircle: $4c913faac15604fc$export$a3541b2d8ecbfcf2,
    buildRectangle: $7ae504b9c1c43240$export$cbe813d11f2192b2,
    buildRoundedRectangle: $b622a5b3f0138217$export$4b54fce47d2ae7f4,
    buildLine: $869154e3d7cd998d$export$45986ccf08e93b0b,
    ArcUtils: $8118a95e17addabb$export$e6c43ec4db262573,
    BezierUtils: $8b8420ad498966ee$export$994e59e1556c01e9,
    QuadraticUtils: $3eaaf9b529e8eeec$export$616649c7d4fcacf2,
    BatchPart: $d744c4657ef5cdc9$export$3abbb88a93faeec2,
    FILL_COMMANDS: $880f99c2e54bc0a5$export$b738057f7c88a634,
    BATCH_POOL: $880f99c2e54bc0a5$export$78aca0cfc72b8d6,
    DRAW_CALL_POOL: $880f99c2e54bc0a5$export$e520c68c6872beed
};




class $542b7ebdc02069ec$export$49cc356fa6ba0e7b {
    constructor(uvBuffer, uvMatrix){
        this.uvBuffer = uvBuffer;
        this.uvMatrix = uvMatrix;
        this.data = null;
        this._bufferUpdateId = -1;
        this._textureUpdateId = -1;
        this._updateID = 0;
    }
    update(forceUpdate) {
        if (!forceUpdate && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID) return;
        this._bufferUpdateId = this.uvBuffer._updateID;
        this._textureUpdateId = this.uvMatrix._updateID;
        const data = this.uvBuffer.data;
        if (!this.data || this.data.length !== data.length) this.data = new Float32Array(data.length);
        this.uvMatrix.multiplyUvs(data, this.data);
        this._updateID++;
    }
}


const $568baf8681eacf07$var$tempPoint = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
const $568baf8681eacf07$var$tempPolygon = new (0, $173c2dfd36fd3f4f$export$7d31b617c820d435)();
const $568baf8681eacf07$var$_Mesh = class extends (0, $823fbc2c4ae841df$export$42a852a2b6b56249) {
    constructor(geometry, shader, state, drawMode = (0, $551209d754b5b429$export$91100badd8469338).TRIANGLES){
        super();
        this.geometry = geometry;
        this.shader = shader;
        this.state = state || (0, $15a50e9cd387ae21$export$7254cc27399e90bd).for2d();
        this.drawMode = drawMode;
        this.start = 0;
        this.size = 0;
        this.uvs = null;
        this.indices = null;
        this.vertexData = new Float32Array(1);
        this.vertexDirty = -1;
        this._transformID = -1;
        this._roundPixels = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ROUND_PIXELS;
        this.batchUvs = null;
    }
    get geometry() {
        return this._geometry;
    }
    set geometry(value) {
        if (this._geometry === value) return;
        if (this._geometry) {
            this._geometry.refCount--;
            if (this._geometry.refCount === 0) this._geometry.dispose();
        }
        this._geometry = value;
        if (this._geometry) this._geometry.refCount++;
        this.vertexDirty = -1;
    }
    get uvBuffer() {
        return this.geometry.buffers[1];
    }
    get verticesBuffer() {
        return this.geometry.buffers[0];
    }
    set material(value) {
        this.shader = value;
    }
    get material() {
        return this.shader;
    }
    set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    set roundPixels(value) {
        if (this._roundPixels !== value) this._transformID = -1;
        this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    get tint() {
        return "tint" in this.shader ? this.shader.tint : null;
    }
    set tint(value) {
        this.shader.tint = value;
    }
    get tintValue() {
        return this.shader.tintValue;
    }
    get texture() {
        return "texture" in this.shader ? this.shader.texture : null;
    }
    set texture(value) {
        this.shader.texture = value;
    }
    _render(renderer) {
        const vertices = this.geometry.buffers[0].data;
        const shader = this.shader;
        if (shader.batchable && this.drawMode === (0, $551209d754b5b429$export$91100badd8469338).TRIANGLES && vertices.length < $568baf8681eacf07$var$_Mesh.BATCHABLE_SIZE * 2) this._renderToBatch(renderer);
        else this._renderDefault(renderer);
    }
    _renderDefault(renderer) {
        const shader = this.shader;
        shader.alpha = this.worldAlpha;
        if (shader.update) shader.update();
        renderer.batch.flush();
        shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(true);
        renderer.shader.bind(shader);
        renderer.state.set(this.state);
        renderer.geometry.bind(this.geometry, shader);
        renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    }
    _renderToBatch(renderer) {
        const geometry = this.geometry;
        const shader = this.shader;
        if (shader.uvMatrix) {
            shader.uvMatrix.update();
            this.calculateUvs();
        }
        this.calculateVertices();
        this.indices = geometry.indexBuffer.data;
        this._tintRGB = shader._tintRGB;
        this._texture = shader.texture;
        const pluginName = this.material.pluginName;
        renderer.batch.setObjectRenderer(renderer.plugins[pluginName]);
        renderer.plugins[pluginName].render(this);
    }
    calculateVertices() {
        const geometry = this.geometry;
        const verticesBuffer = geometry.buffers[0];
        const vertices = verticesBuffer.data;
        const vertexDirtyId = verticesBuffer._updateID;
        if (vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) return;
        this._transformID = this.transform._worldID;
        if (this.vertexData.length !== vertices.length) this.vertexData = new Float32Array(vertices.length);
        const wt = this.transform.worldTransform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const vertexData = this.vertexData;
        for(let i = 0; i < vertexData.length / 2; i++){
            const x = vertices[i * 2];
            const y = vertices[i * 2 + 1];
            vertexData[i * 2] = a * x + c * y + tx;
            vertexData[i * 2 + 1] = b * x + d * y + ty;
        }
        if (this._roundPixels) {
            const resolution = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
        this.vertexDirty = vertexDirtyId;
    }
    calculateUvs() {
        const geomUvs = this.geometry.buffers[1];
        const shader = this.shader;
        if (!shader.uvMatrix.isSimple) {
            if (!this.batchUvs) this.batchUvs = new (0, $542b7ebdc02069ec$export$49cc356fa6ba0e7b)(geomUvs, shader.uvMatrix);
            this.batchUvs.update();
            this.uvs = this.batchUvs.data;
        } else this.uvs = geomUvs.data;
    }
    _calculateBounds() {
        this.calculateVertices();
        this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    }
    containsPoint(point) {
        if (!this.getBounds().contains(point.x, point.y)) return false;
        this.worldTransform.applyInverse(point, $568baf8681eacf07$var$tempPoint);
        const vertices = this.geometry.getBuffer("aVertexPosition").data;
        const points = $568baf8681eacf07$var$tempPolygon.points;
        const indices = this.geometry.getIndex().data;
        const len = indices.length;
        const step = this.drawMode === 4 ? 3 : 1;
        for(let i = 0; i + 2 < len; i += step){
            const ind0 = indices[i] * 2;
            const ind1 = indices[i + 1] * 2;
            const ind2 = indices[i + 2] * 2;
            points[0] = vertices[ind0];
            points[1] = vertices[ind0 + 1];
            points[2] = vertices[ind1];
            points[3] = vertices[ind1 + 1];
            points[4] = vertices[ind2];
            points[5] = vertices[ind2 + 1];
            if ($568baf8681eacf07$var$tempPolygon.contains($568baf8681eacf07$var$tempPoint.x, $568baf8681eacf07$var$tempPoint.y)) return true;
        }
        return false;
    }
    destroy(options) {
        super.destroy(options);
        if (this._cachedTexture) {
            this._cachedTexture.destroy();
            this._cachedTexture = null;
        }
        this.geometry = null;
        this.shader = null;
        this.state = null;
        this.uvs = null;
        this.indices = null;
        this.vertexData = null;
    }
};
let $568baf8681eacf07$export$e176487c05830cc5 = $568baf8681eacf07$var$_Mesh;
$568baf8681eacf07$export$e176487c05830cc5.BATCHABLE_SIZE = 100;




class $6a3195e011b88f16$export$8d075a36a73d54bc extends (0, $18b317c5775068cf$export$2db6c17465f94a2) {
    constructor(vertices, uvs, index){
        super();
        const verticesBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(vertices);
        const uvsBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(uvs, true);
        const indexBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(index, true, true);
        this.addAttribute("aVertexPosition", verticesBuffer, 2, false, (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT).addAttribute("aTextureCoord", uvsBuffer, 2, false, (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT).addIndex(indexBuffer);
        this._updateId = -1;
    }
    get vertexDirtyId() {
        return this.buffers[0]._updateID;
    }
}



var $31df547a931b2ea7$export$2e2bcd8739ae039 = "varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n";


var $a92140c6d9c7a18b$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTextureMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\n}\n";


class $dad6142c5ef6c8cb$export$d552dadfd66cc650 extends (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5) {
    constructor(uSampler, options){
        const uniforms = {
            uSampler: uSampler,
            alpha: 1,
            uTextureMatrix: (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85).IDENTITY,
            uColor: new Float32Array([
                1,
                1,
                1,
                1
            ])
        };
        options = Object.assign({
            tint: 16777215,
            alpha: 1,
            pluginName: "batch"
        }, options);
        if (options.uniforms) Object.assign(uniforms, options.uniforms);
        super(options.program || (0, $52e5734958fc1bae$export$b6c59b989905b650).from((0, $a92140c6d9c7a18b$export$2e2bcd8739ae039), (0, $31df547a931b2ea7$export$2e2bcd8739ae039)), uniforms);
        this._colorDirty = false;
        this.uvMatrix = new (0, $8da561ec6e817bba$export$dbea3135e9da48cb)(uSampler);
        this.batchable = options.program === void 0;
        this.pluginName = options.pluginName;
        this._tintColor = new (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e)(options.tint);
        this._tintRGB = this._tintColor.toLittleEndianNumber();
        this._colorDirty = true;
        this.alpha = options.alpha;
    }
    get texture() {
        return this.uniforms.uSampler;
    }
    set texture(value) {
        if (this.uniforms.uSampler !== value) {
            if (!this.uniforms.uSampler.baseTexture.alphaMode !== !value.baseTexture.alphaMode) this._colorDirty = true;
            this.uniforms.uSampler = value;
            this.uvMatrix.texture = value;
        }
    }
    set alpha(value) {
        if (value === this._alpha) return;
        this._alpha = value;
        this._colorDirty = true;
    }
    get alpha() {
        return this._alpha;
    }
    set tint(value) {
        if (value === this.tint) return;
        this._tintColor.setValue(value);
        this._tintRGB = this._tintColor.toLittleEndianNumber();
        this._colorDirty = true;
    }
    get tint() {
        return this._tintColor.value;
    }
    get tintValue() {
        return this._tintColor.toNumber();
    }
    update() {
        if (this._colorDirty) {
            this._colorDirty = false;
            const baseTexture = this.texture.baseTexture;
            const applyToChannels = baseTexture.alphaMode;
            (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(this._tintColor).premultiply(this._alpha, applyToChannels).toArray(this.uniforms.uColor);
        }
        if (this.uvMatrix.update()) this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord;
    }
}





class $9a4f9bc03d69f278$export$967d831af31f69ce extends (0, $6a3195e011b88f16$export$8d075a36a73d54bc) {
    constructor(width = 100, height = 100, segWidth = 10, segHeight = 10){
        super();
        this.segWidth = segWidth;
        this.segHeight = segHeight;
        this.width = width;
        this.height = height;
        this.build();
    }
    build() {
        const total = this.segWidth * this.segHeight;
        const verts = [];
        const uvs = [];
        const indices = [];
        const segmentsX = this.segWidth - 1;
        const segmentsY = this.segHeight - 1;
        const sizeX = this.width / segmentsX;
        const sizeY = this.height / segmentsY;
        for(let i = 0; i < total; i++){
            const x = i % this.segWidth;
            const y = i / this.segWidth | 0;
            verts.push(x * sizeX, y * sizeY);
            uvs.push(x / segmentsX, y / segmentsY);
        }
        const totalSub = segmentsX * segmentsY;
        for(let i = 0; i < totalSub; i++){
            const xpos = i % segmentsX;
            const ypos = i / segmentsX | 0;
            const value = ypos * this.segWidth + xpos;
            const value2 = ypos * this.segWidth + xpos + 1;
            const value3 = (ypos + 1) * this.segWidth + xpos;
            const value4 = (ypos + 1) * this.segWidth + xpos + 1;
            indices.push(value, value2, value3, value2, value4, value3);
        }
        this.buffers[0].data = new Float32Array(verts);
        this.buffers[1].data = new Float32Array(uvs);
        this.indexBuffer.data = new Uint16Array(indices);
        this.buffers[0].update();
        this.buffers[1].update();
        this.indexBuffer.update();
    }
}



class $b196529af8f08f50$export$6a9827483976bf64 extends (0, $6a3195e011b88f16$export$8d075a36a73d54bc) {
    constructor(width = 200, points, textureScale = 0){
        super(new Float32Array(points.length * 4), new Float32Array(points.length * 4), new Uint16Array((points.length - 1) * 6));
        this.points = points;
        this._width = width;
        this.textureScale = textureScale;
        this.build();
    }
    get width() {
        return this._width;
    }
    build() {
        const points = this.points;
        if (!points) return;
        const vertexBuffer = this.getBuffer("aVertexPosition");
        const uvBuffer = this.getBuffer("aTextureCoord");
        const indexBuffer = this.getIndex();
        if (points.length < 1) return;
        if (vertexBuffer.data.length / 4 !== points.length) {
            vertexBuffer.data = new Float32Array(points.length * 4);
            uvBuffer.data = new Float32Array(points.length * 4);
            indexBuffer.data = new Uint16Array((points.length - 1) * 6);
        }
        const uvs = uvBuffer.data;
        const indices = indexBuffer.data;
        uvs[0] = 0;
        uvs[1] = 0;
        uvs[2] = 0;
        uvs[3] = 1;
        let amount = 0;
        let prev = points[0];
        const textureWidth = this._width * this.textureScale;
        const total = points.length;
        for(let i = 0; i < total; i++){
            const index = i * 4;
            if (this.textureScale > 0) {
                const dx = prev.x - points[i].x;
                const dy = prev.y - points[i].y;
                const distance = Math.sqrt(dx * dx + dy * dy);
                prev = points[i];
                amount += distance / textureWidth;
            } else amount = i / (total - 1);
            uvs[index] = amount;
            uvs[index + 1] = 0;
            uvs[index + 2] = amount;
            uvs[index + 3] = 1;
        }
        let indexCount = 0;
        for(let i = 0; i < total - 1; i++){
            const index = i * 2;
            indices[indexCount++] = index;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 3;
        }
        uvBuffer.update();
        indexBuffer.update();
        this.updateVertices();
    }
    updateVertices() {
        const points = this.points;
        if (points.length < 1) return;
        let lastPoint = points[0];
        let nextPoint;
        let perpX = 0;
        let perpY = 0;
        const vertices = this.buffers[0].data;
        const total = points.length;
        const halfWidth = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
        for(let i = 0; i < total; i++){
            const point = points[i];
            const index = i * 4;
            if (i < points.length - 1) nextPoint = points[i + 1];
            else nextPoint = point;
            perpY = -(nextPoint.x - lastPoint.x);
            perpX = nextPoint.y - lastPoint.y;
            let ratio = (1 - i / (total - 1)) * 10;
            if (ratio > 1) ratio = 1;
            const perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            if (perpLength < 1e-6) {
                perpX = 0;
                perpY = 0;
            } else {
                perpX /= perpLength;
                perpY /= perpLength;
                perpX *= halfWidth;
                perpY *= halfWidth;
            }
            vertices[index] = point.x + perpX;
            vertices[index + 1] = point.y + perpY;
            vertices[index + 2] = point.x - perpX;
            vertices[index + 3] = point.y - perpY;
            lastPoint = point;
        }
        this.buffers[0].update();
    }
    update() {
        if (this.textureScale > 0) this.build();
        else this.updateVertices();
    }
}






class $e8a1fdf736ff3b7e$export$d47c1aa7111669b9 extends (0, $568baf8681eacf07$export$e176487c05830cc5) {
    constructor(texture, verticesX, verticesY){
        const planeGeometry = new (0, $9a4f9bc03d69f278$export$967d831af31f69ce)(texture.width, texture.height, verticesX, verticesY);
        const meshMaterial = new (0, $dad6142c5ef6c8cb$export$d552dadfd66cc650)((0, $6ac4ad2139942545$export$5431306cf43de24a).WHITE);
        super(planeGeometry, meshMaterial);
        this.texture = texture;
        this.autoResize = true;
    }
    textureUpdated() {
        this._textureID = this.shader.texture._updateID;
        const geometry = this.geometry;
        const { width: width , height: height  } = this.shader.texture;
        if (this.autoResize && (geometry.width !== width || geometry.height !== height)) {
            geometry.width = this.shader.texture.width;
            geometry.height = this.shader.texture.height;
            geometry.build();
        }
    }
    set texture(value) {
        if (this.shader.texture === value) return;
        this.shader.texture = value;
        this._textureID = -1;
        if (value.baseTexture.valid) this.textureUpdated();
        else value.once("update", this.textureUpdated, this);
    }
    get texture() {
        return this.shader.texture;
    }
    _render(renderer) {
        if (this._textureID !== this.shader.texture._updateID) this.textureUpdated();
        super._render(renderer);
    }
    destroy(options) {
        this.shader.texture.off("update", this.textureUpdated, this);
        super.destroy(options);
    }
}


const $88c2e82640367c08$var$DEFAULT_BORDER_SIZE = 10;
class $88c2e82640367c08$export$acdf4cb3f489544e extends (0, $e8a1fdf736ff3b7e$export$d47c1aa7111669b9) {
    constructor(texture, leftWidth, topHeight, rightWidth, bottomHeight){
        super((0, $6ac4ad2139942545$export$5431306cf43de24a).WHITE, 4, 4);
        this._origWidth = texture.orig.width;
        this._origHeight = texture.orig.height;
        this._width = this._origWidth;
        this._height = this._origHeight;
        this._leftWidth = leftWidth ?? texture.defaultBorders?.left ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE;
        this._rightWidth = rightWidth ?? texture.defaultBorders?.right ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE;
        this._topHeight = topHeight ?? texture.defaultBorders?.top ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE;
        this._bottomHeight = bottomHeight ?? texture.defaultBorders?.bottom ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE;
        this.texture = texture;
    }
    textureUpdated() {
        this._textureID = this.shader.texture._updateID;
        this._refresh();
    }
    get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    updateHorizontalVertices() {
        const vertices = this.vertices;
        const scale = this._getMinScale();
        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    }
    updateVerticalVertices() {
        const vertices = this.vertices;
        const scale = this._getMinScale();
        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    }
    _getMinScale() {
        const w = this._leftWidth + this._rightWidth;
        const scaleW = this._width > w ? 1 : this._width / w;
        const h = this._topHeight + this._bottomHeight;
        const scaleH = this._height > h ? 1 : this._height / h;
        const scale = Math.min(scaleW, scaleH);
        return scale;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        this._refresh();
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        this._refresh();
    }
    get leftWidth() {
        return this._leftWidth;
    }
    set leftWidth(value) {
        this._leftWidth = value;
        this._refresh();
    }
    get rightWidth() {
        return this._rightWidth;
    }
    set rightWidth(value) {
        this._rightWidth = value;
        this._refresh();
    }
    get topHeight() {
        return this._topHeight;
    }
    set topHeight(value) {
        this._topHeight = value;
        this._refresh();
    }
    get bottomHeight() {
        return this._bottomHeight;
    }
    set bottomHeight(value) {
        this._bottomHeight = value;
        this._refresh();
    }
    _refresh() {
        const texture = this.texture;
        const uvs = this.geometry.buffers[1].data;
        this._origWidth = texture.orig.width;
        this._origHeight = texture.orig.height;
        const _uvw = 1 / this._origWidth;
        const _uvh = 1 / this._origHeight;
        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;
        this.updateHorizontalVertices();
        this.updateVerticalVertices();
        this.geometry.buffers[0].update();
        this.geometry.buffers[1].update();
    }
}




class $5d2a721396597310$export$81b9e78682e7feca extends (0, $568baf8681eacf07$export$e176487c05830cc5) {
    constructor(texture = (0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY, vertices, uvs, indices, drawMode){
        const geometry = new (0, $6a3195e011b88f16$export$8d075a36a73d54bc)(vertices, uvs, indices);
        geometry.getBuffer("aVertexPosition").static = false;
        const meshMaterial = new (0, $dad6142c5ef6c8cb$export$d552dadfd66cc650)(texture);
        super(geometry, meshMaterial, null, drawMode);
        this.autoUpdate = true;
    }
    get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    _render(renderer) {
        if (this.autoUpdate) this.geometry.getBuffer("aVertexPosition").update();
        super._render(renderer);
    }
}






class $5e2c2c0f9415086c$export$f009a14c3f00879e extends (0, $568baf8681eacf07$export$e176487c05830cc5) {
    constructor(texture, points, textureScale = 0){
        const ropeGeometry = new (0, $b196529af8f08f50$export$6a9827483976bf64)(texture.height, points, textureScale);
        const meshMaterial = new (0, $dad6142c5ef6c8cb$export$d552dadfd66cc650)(texture);
        if (textureScale > 0) texture.baseTexture.wrapMode = (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).REPEAT;
        super(ropeGeometry, meshMaterial);
        this.autoUpdate = true;
    }
    _render(renderer) {
        const geometry = this.geometry;
        if (this.autoUpdate || geometry._width !== this.shader.texture.height) {
            geometry._width = this.shader.texture.height;
            geometry.update();
        }
        super._render(renderer);
    }
}






class $1c7533c0d731277b$export$e63bf72b2cfda112 extends (0, $823fbc2c4ae841df$export$42a852a2b6b56249) {
    constructor(maxSize = 1500, properties, batchSize = 16384, autoResize = false){
        super();
        const maxBatchSize = 16384;
        if (batchSize > maxBatchSize) batchSize = maxBatchSize;
        this._properties = [
            false,
            true,
            false,
            false,
            false
        ];
        this._maxSize = maxSize;
        this._batchSize = batchSize;
        this._buffers = null;
        this._bufferUpdateIDs = [];
        this._updateID = 0;
        this.interactiveChildren = false;
        this.blendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL;
        this.autoResize = autoResize;
        this.roundPixels = true;
        this.baseTexture = null;
        this.setProperties(properties);
        this._tintColor = new (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e)(0);
        this.tintRgb = new Float32Array(3);
        this.tint = 16777215;
    }
    setProperties(properties) {
        if (properties) {
            this._properties[0] = "vertices" in properties || "scale" in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
            this._properties[1] = "position" in properties ? !!properties.position : this._properties[1];
            this._properties[2] = "rotation" in properties ? !!properties.rotation : this._properties[2];
            this._properties[3] = "uvs" in properties ? !!properties.uvs : this._properties[3];
            this._properties[4] = "tint" in properties || "alpha" in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
        }
    }
    updateTransform() {
        this.displayObjectUpdateTransform();
    }
    get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value);
        this._tintColor.toRgbArray(this.tintRgb);
    }
    render(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) return;
        if (!this.baseTexture) {
            this.baseTexture = this.children[0]._texture.baseTexture;
            if (!this.baseTexture.valid) this.baseTexture.once("update", ()=>this.onChildrenChange(0));
        }
        renderer.batch.setObjectRenderer(renderer.plugins.particle);
        renderer.plugins.particle.render(this);
    }
    onChildrenChange(smallestChildIndex) {
        const bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
        while(this._bufferUpdateIDs.length < bufferIndex)this._bufferUpdateIDs.push(0);
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    }
    dispose() {
        if (this._buffers) {
            for(let i = 0; i < this._buffers.length; ++i)this._buffers[i].destroy();
            this._buffers = null;
        }
    }
    destroy(options) {
        super.destroy(options);
        this.dispose();
        this._properties = null;
        this._buffers = null;
        this._bufferUpdateIDs = null;
    }
}




class $c64915fffe94164d$export$ef6bb3c375ab2229 {
    constructor(properties, dynamicPropertyFlags, size){
        this.geometry = new (0, $18b317c5775068cf$export$2db6c17465f94a2)();
        this.indexBuffer = null;
        this.size = size;
        this.dynamicProperties = [];
        this.staticProperties = [];
        for(let i = 0; i < properties.length; ++i){
            let property = properties[i];
            property = {
                attributeName: property.attributeName,
                size: property.size,
                uploadFunction: property.uploadFunction,
                type: property.type || (0, $551209d754b5b429$export$426db7a6155b7a80).FLOAT,
                offset: property.offset
            };
            if (dynamicPropertyFlags[i]) this.dynamicProperties.push(property);
            else this.staticProperties.push(property);
        }
        this.staticStride = 0;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
        this.dynamicStride = 0;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;
        this._updateID = 0;
        this.initBuffers();
    }
    initBuffers() {
        const geometry = this.geometry;
        let dynamicOffset = 0;
        this.indexBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)((0, $5d808cc4b6a3c326$exports).createIndicesForQuads(this.size), true, true);
        geometry.addIndex(this.indexBuffer);
        this.dynamicStride = 0;
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            property.offset = dynamicOffset;
            dynamicOffset += property.size;
            this.dynamicStride += property.size;
        }
        const dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 16);
        this.dynamicData = new Float32Array(dynBuffer);
        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
        this.dynamicBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(this.dynamicData, false, false);
        let staticOffset = 0;
        this.staticStride = 0;
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            property.offset = staticOffset;
            staticOffset += property.size;
            this.staticStride += property.size;
        }
        const statBuffer = new ArrayBuffer(this.size * this.staticStride * 16);
        this.staticData = new Float32Array(statBuffer);
        this.staticDataUint32 = new Uint32Array(statBuffer);
        this.staticBuffer = new (0, $ff838791b3783858$export$a143d493d941bafc)(this.staticData, true, false);
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            geometry.addAttribute(property.attributeName, this.dynamicBuffer, 0, property.type === (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE, property.type, this.dynamicStride * 4, property.offset * 4);
        }
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            geometry.addAttribute(property.attributeName, this.staticBuffer, 0, property.type === (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE, property.type, this.staticStride * 4, property.offset * 4);
        }
    }
    uploadDynamic(children, startIndex, amount) {
        for(let i = 0; i < this.dynamicProperties.length; i++){
            const property = this.dynamicProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }
        this.dynamicBuffer._updateID++;
    }
    uploadStatic(children, startIndex, amount) {
        for(let i = 0; i < this.staticProperties.length; i++){
            const property = this.staticProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }
        this.staticBuffer._updateID++;
    }
    destroy() {
        this.indexBuffer = null;
        this.dynamicProperties = null;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;
        this.staticProperties = null;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
        this.geometry.destroy();
    }
}


var $3bc765fb8a01e763$export$2e2bcd8739ae039 = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n    gl_FragColor = color;\n}";


var $e51b43d24e6b359f$export$2e2bcd8739ae039 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\n\nattribute vec2 aPositionCoord;\nattribute float aRotation;\n\nuniform mat3 translationMatrix;\nuniform vec4 uColor;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nvoid main(void){\n    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);\n    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);\n\n    vec2 v = vec2(x, y);\n    v = v + aPositionCoord;\n\n    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vColor = aColor * uColor;\n}\n";


class $e973c60d525888ad$export$42cbb08a275c7ff9 extends (0, $ec9c34a32f35795b$export$ca67b0b0fa758253) {
    constructor(renderer){
        super(renderer);
        this.shader = null;
        this.properties = null;
        this.tempMatrix = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
        this.properties = [
            {
                attributeName: "aVertexPosition",
                size: 2,
                uploadFunction: this.uploadVertices,
                offset: 0
            },
            {
                attributeName: "aPositionCoord",
                size: 2,
                uploadFunction: this.uploadPosition,
                offset: 0
            },
            {
                attributeName: "aRotation",
                size: 1,
                uploadFunction: this.uploadRotation,
                offset: 0
            },
            {
                attributeName: "aTextureCoord",
                size: 2,
                uploadFunction: this.uploadUvs,
                offset: 0
            },
            {
                attributeName: "aColor",
                size: 1,
                type: (0, $551209d754b5b429$export$426db7a6155b7a80).UNSIGNED_BYTE,
                uploadFunction: this.uploadTint,
                offset: 0
            }
        ];
        this.shader = (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5).from((0, $e51b43d24e6b359f$export$2e2bcd8739ae039), (0, $3bc765fb8a01e763$export$2e2bcd8739ae039), {});
        this.state = (0, $15a50e9cd387ae21$export$7254cc27399e90bd).for2d();
    }
    render(container) {
        const children = container.children;
        const maxSize = container._maxSize;
        const batchSize = container._batchSize;
        const renderer = this.renderer;
        let totalChildren = children.length;
        if (totalChildren === 0) return;
        else if (totalChildren > maxSize && !container.autoResize) totalChildren = maxSize;
        let buffers = container._buffers;
        if (!buffers) buffers = container._buffers = this.generateBuffers(container);
        const baseTexture = children[0]._texture.baseTexture;
        const premultiplied = baseTexture.alphaMode > 0;
        this.state.blendMode = (0, $5d808cc4b6a3c326$exports).correctBlendMode(container.blendMode, premultiplied);
        renderer.state.set(this.state);
        const gl = renderer.gl;
        const m = container.worldTransform.copyTo(this.tempMatrix);
        m.prepend(renderer.globalUniforms.uniforms.projectionMatrix);
        this.shader.uniforms.translationMatrix = m.toArray(true);
        this.shader.uniforms.uColor = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(container.tintRgb).premultiply(container.worldAlpha, premultiplied).toArray(this.shader.uniforms.uColor);
        this.shader.uniforms.uSampler = baseTexture;
        this.renderer.shader.bind(this.shader);
        let updateStatic = false;
        for(let i = 0, j = 0; i < totalChildren; i += batchSize, j += 1){
            let amount = totalChildren - i;
            if (amount > batchSize) amount = batchSize;
            if (j >= buffers.length) buffers.push(this._generateOneMoreBuffer(container));
            const buffer = buffers[j];
            buffer.uploadDynamic(children, i, amount);
            const bid = container._bufferUpdateIDs[j] || 0;
            updateStatic = updateStatic || buffer._updateID < bid;
            if (updateStatic) {
                buffer._updateID = container._updateID;
                buffer.uploadStatic(children, i, amount);
            }
            renderer.geometry.bind(buffer.geometry);
            gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
        }
    }
    generateBuffers(container) {
        const buffers = [];
        const size = container._maxSize;
        const batchSize = container._batchSize;
        const dynamicPropertyFlags = container._properties;
        for(let i = 0; i < size; i += batchSize)buffers.push(new (0, $c64915fffe94164d$export$ef6bb3c375ab2229)(this.properties, dynamicPropertyFlags, batchSize));
        return buffers;
    }
    _generateOneMoreBuffer(container) {
        const batchSize = container._batchSize;
        const dynamicPropertyFlags = container._properties;
        return new (0, $c64915fffe94164d$export$ef6bb3c375ab2229)(this.properties, dynamicPropertyFlags, batchSize);
    }
    uploadVertices(children, startIndex, amount, array, stride, offset) {
        let w0 = 0;
        let w1 = 0;
        let h0 = 0;
        let h1 = 0;
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i];
            const texture = sprite._texture;
            const sx = sprite.scale.x;
            const sy = sprite.scale.y;
            const trim = texture.trim;
            const orig = texture.orig;
            if (trim) {
                w1 = trim.x - sprite.anchor.x * orig.width;
                w0 = w1 + trim.width;
                h1 = trim.y - sprite.anchor.y * orig.height;
                h0 = h1 + trim.height;
            } else {
                w0 = orig.width * (1 - sprite.anchor.x);
                w1 = orig.width * -sprite.anchor.x;
                h0 = orig.height * (1 - sprite.anchor.y);
                h1 = orig.height * -sprite.anchor.y;
            }
            array[offset] = w1 * sx;
            array[offset + 1] = h1 * sy;
            array[offset + stride] = w0 * sx;
            array[offset + stride + 1] = h1 * sy;
            array[offset + stride * 2] = w0 * sx;
            array[offset + stride * 2 + 1] = h0 * sy;
            array[offset + stride * 3] = w1 * sx;
            array[offset + stride * 3 + 1] = h0 * sy;
            offset += stride * 4;
        }
    }
    uploadPosition(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spritePosition = children[startIndex + i].position;
            array[offset] = spritePosition.x;
            array[offset + 1] = spritePosition.y;
            array[offset + stride] = spritePosition.x;
            array[offset + stride + 1] = spritePosition.y;
            array[offset + stride * 2] = spritePosition.x;
            array[offset + stride * 2 + 1] = spritePosition.y;
            array[offset + stride * 3] = spritePosition.x;
            array[offset + stride * 3 + 1] = spritePosition.y;
            offset += stride * 4;
        }
    }
    uploadRotation(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spriteRotation = children[startIndex + i].rotation;
            array[offset] = spriteRotation;
            array[offset + stride] = spriteRotation;
            array[offset + stride * 2] = spriteRotation;
            array[offset + stride * 3] = spriteRotation;
            offset += stride * 4;
        }
    }
    uploadUvs(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const textureUvs = children[startIndex + i]._texture._uvs;
            if (textureUvs) {
                array[offset] = textureUvs.x0;
                array[offset + 1] = textureUvs.y0;
                array[offset + stride] = textureUvs.x1;
                array[offset + stride + 1] = textureUvs.y1;
                array[offset + stride * 2] = textureUvs.x2;
                array[offset + stride * 2 + 1] = textureUvs.y2;
                array[offset + stride * 3] = textureUvs.x3;
                array[offset + stride * 3 + 1] = textureUvs.y3;
                offset += stride * 4;
            } else {
                array[offset] = 0;
                array[offset + 1] = 0;
                array[offset + stride] = 0;
                array[offset + stride + 1] = 0;
                array[offset + stride * 2] = 0;
                array[offset + stride * 2 + 1] = 0;
                array[offset + stride * 3] = 0;
                array[offset + stride * 3 + 1] = 0;
                offset += stride * 4;
            }
        }
    }
    uploadTint(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i];
            const result = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(sprite._tintRGB).toPremultiplied(sprite.alpha, sprite.texture.baseTexture.alphaMode > 0);
            array[offset] = result;
            array[offset + stride] = result;
            array[offset + stride * 2] = result;
            array[offset + stride * 3] = result;
            offset += stride * 4;
        }
    }
    destroy() {
        super.destroy();
        if (this.shader) {
            this.shader.destroy();
            this.shader = null;
        }
        this.tempMatrix = null;
    }
}
$e973c60d525888ad$export$42cbb08a275c7ff9.extension = {
    name: "particle",
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererPlugin
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($e973c60d525888ad$export$42cbb08a275c7ff9);







var $105b32f38e43c61b$export$131daa784848984 = /* @__PURE__ */ ((TEXT_GRADIENT2)=>{
    TEXT_GRADIENT2[TEXT_GRADIENT2["LINEAR_VERTICAL"] = 0] = "LINEAR_VERTICAL";
    TEXT_GRADIENT2[TEXT_GRADIENT2["LINEAR_HORIZONTAL"] = 1] = "LINEAR_HORIZONTAL";
    return TEXT_GRADIENT2;
})($105b32f38e43c61b$export$131daa784848984 || {});






const $d1d36a3f61276665$var$contextSettings = {
    willReadFrequently: true
};
const $d1d36a3f61276665$var$_TextMetrics = class {
    static get experimentalLetterSpacingSupported() {
        let result = $d1d36a3f61276665$var$_TextMetrics._experimentalLetterSpacingSupported;
        if (result !== void 0) {
            const proto = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getCanvasRenderingContext2D().prototype;
            result = $d1d36a3f61276665$var$_TextMetrics._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties){
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }
    static measureText(text, style, wordWrap, canvas = $d1d36a3f61276665$var$_TextMetrics._canvas) {
        wordWrap = wordWrap === void 0 || wordWrap === null ? style.wordWrap : wordWrap;
        const font = style.toFontString();
        const fontProperties = $d1d36a3f61276665$var$_TextMetrics.measureFont(font);
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
        }
        const context = canvas.getContext("2d", $d1d36a3f61276665$var$contextSettings);
        context.font = font;
        const outputText = wordWrap ? $d1d36a3f61276665$var$_TextMetrics.wordWrap(text, style, canvas) : text;
        const lines = outputText.split(/(?:\r\n|\r|\n)/);
        const lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = $d1d36a3f61276665$var$_TextMetrics._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        let width = maxLineWidth + style.strokeThickness;
        if (style.dropShadow) width += style.dropShadowDistance;
        const lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        let height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness * 2) + (lines.length - 1) * (lineHeight + style.leading);
        if (style.dropShadow) height += style.dropShadowDistance;
        return new $d1d36a3f61276665$var$_TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    }
    static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = false;
        if ($d1d36a3f61276665$var$_TextMetrics.experimentalLetterSpacingSupported) {
            if ($d1d36a3f61276665$var$_TextMetrics.experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        let width = context.measureText(text).width;
        if (width > 0) {
            if (useExperimentalLetterSpacing) width -= letterSpacing;
            else width += ($d1d36a3f61276665$var$_TextMetrics.graphemeSegmenter(text).length - 1) * letterSpacing;
        }
        return width;
    }
    static wordWrap(text, style, canvas = $d1d36a3f61276665$var$_TextMetrics._canvas) {
        const context = canvas.getContext("2d", $d1d36a3f61276665$var$contextSettings);
        let width = 0;
        let line = "";
        let lines = "";
        const cache = /* @__PURE__ */ Object.create(null);
        const { letterSpacing: letterSpacing , whiteSpace: whiteSpace  } = style;
        const collapseSpaces = $d1d36a3f61276665$var$_TextMetrics.collapseSpaces(whiteSpace);
        const collapseNewlines = $d1d36a3f61276665$var$_TextMetrics.collapseNewlines(whiteSpace);
        let canPrependSpaces = !collapseSpaces;
        const wordWrapWidth = style.wordWrapWidth + letterSpacing;
        const tokens = $d1d36a3f61276665$var$_TextMetrics.tokenize(text);
        for(let i = 0; i < tokens.length; i++){
            let token = tokens[i];
            if ($d1d36a3f61276665$var$_TextMetrics.isNewline(token)) {
                if (!collapseNewlines) {
                    lines += $d1d36a3f61276665$var$_TextMetrics.addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = "";
                    width = 0;
                    continue;
                }
                token = " ";
            }
            if (collapseSpaces) {
                const currIsBreakingSpace = $d1d36a3f61276665$var$_TextMetrics.isBreakingSpace(token);
                const lastIsBreakingSpace = $d1d36a3f61276665$var$_TextMetrics.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            const tokenWidth = $d1d36a3f61276665$var$_TextMetrics.getFromCache(token, letterSpacing, cache, context);
            if (tokenWidth > wordWrapWidth) {
                if (line !== "") {
                    lines += $d1d36a3f61276665$var$_TextMetrics.addLine(line);
                    line = "";
                    width = 0;
                }
                if ($d1d36a3f61276665$var$_TextMetrics.canBreakWords(token, style.breakWords)) {
                    const characters = $d1d36a3f61276665$var$_TextMetrics.wordWrapSplit(token);
                    for(let j = 0; j < characters.length; j++){
                        let char = characters[j];
                        let lastChar = char;
                        let k = 1;
                        while(characters[j + k]){
                            const nextChar = characters[j + k];
                            if (!$d1d36a3f61276665$var$_TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) char += nextChar;
                            else break;
                            lastChar = nextChar;
                            k++;
                        }
                        j += k - 1;
                        const characterWidth = $d1d36a3f61276665$var$_TextMetrics.getFromCache(char, letterSpacing, cache, context);
                        if (characterWidth + width > wordWrapWidth) {
                            lines += $d1d36a3f61276665$var$_TextMetrics.addLine(line);
                            canPrependSpaces = false;
                            line = "";
                            width = 0;
                        }
                        line += char;
                        width += characterWidth;
                    }
                } else {
                    if (line.length > 0) {
                        lines += $d1d36a3f61276665$var$_TextMetrics.addLine(line);
                        line = "";
                        width = 0;
                    }
                    const isLastToken = i === tokens.length - 1;
                    lines += $d1d36a3f61276665$var$_TextMetrics.addLine(token, !isLastToken);
                    canPrependSpaces = false;
                    line = "";
                    width = 0;
                }
            } else {
                if (tokenWidth + width > wordWrapWidth) {
                    canPrependSpaces = false;
                    lines += $d1d36a3f61276665$var$_TextMetrics.addLine(line);
                    line = "";
                    width = 0;
                }
                if (line.length > 0 || !$d1d36a3f61276665$var$_TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                    line += token;
                    width += tokenWidth;
                }
            }
        }
        lines += $d1d36a3f61276665$var$_TextMetrics.addLine(line, false);
        return lines;
    }
    static addLine(line, newLine = true) {
        line = $d1d36a3f61276665$var$_TextMetrics.trimRight(line);
        line = newLine ? `${line}
` : line;
        return line;
    }
    static getFromCache(key, letterSpacing, cache, context) {
        let width = cache[key];
        if (typeof width !== "number") {
            width = $d1d36a3f61276665$var$_TextMetrics._measureText(key, letterSpacing, context) + letterSpacing;
            cache[key] = width;
        }
        return width;
    }
    static collapseSpaces(whiteSpace) {
        return whiteSpace === "normal" || whiteSpace === "pre-line";
    }
    static collapseNewlines(whiteSpace) {
        return whiteSpace === "normal";
    }
    static trimRight(text) {
        if (typeof text !== "string") return "";
        for(let i = text.length - 1; i >= 0; i--){
            const char = text[i];
            if (!$d1d36a3f61276665$var$_TextMetrics.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    }
    static isNewline(char) {
        if (typeof char !== "string") return false;
        return $d1d36a3f61276665$var$_TextMetrics._newlines.includes(char.charCodeAt(0));
    }
    static isBreakingSpace(char, _nextChar) {
        if (typeof char !== "string") return false;
        return $d1d36a3f61276665$var$_TextMetrics._breakingSpaces.includes(char.charCodeAt(0));
    }
    static tokenize(text) {
        const tokens = [];
        let token = "";
        if (typeof text !== "string") return tokens;
        for(let i = 0; i < text.length; i++){
            const char = text[i];
            const nextChar = text[i + 1];
            if ($d1d36a3f61276665$var$_TextMetrics.isBreakingSpace(char, nextChar) || $d1d36a3f61276665$var$_TextMetrics.isNewline(char)) {
                if (token !== "") {
                    tokens.push(token);
                    token = "";
                }
                tokens.push(char);
                continue;
            }
            token += char;
        }
        if (token !== "") tokens.push(token);
        return tokens;
    }
    static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    }
    static wordWrapSplit(token) {
        return $d1d36a3f61276665$var$_TextMetrics.graphemeSegmenter(token);
    }
    static measureFont(font) {
        if ($d1d36a3f61276665$var$_TextMetrics._fonts[font]) return $d1d36a3f61276665$var$_TextMetrics._fonts[font];
        const properties = {
            ascent: 0,
            descent: 0,
            fontSize: 0
        };
        const canvas = $d1d36a3f61276665$var$_TextMetrics._canvas;
        const context = $d1d36a3f61276665$var$_TextMetrics._context;
        context.font = font;
        const metricsString = $d1d36a3f61276665$var$_TextMetrics.METRICS_STRING + $d1d36a3f61276665$var$_TextMetrics.BASELINE_SYMBOL;
        const width = Math.ceil(context.measureText(metricsString).width);
        let baseline = Math.ceil(context.measureText($d1d36a3f61276665$var$_TextMetrics.BASELINE_SYMBOL).width);
        const height = Math.ceil($d1d36a3f61276665$var$_TextMetrics.HEIGHT_MULTIPLIER * baseline);
        baseline = baseline * $d1d36a3f61276665$var$_TextMetrics.BASELINE_MULTIPLIER | 0;
        if (width === 0 || height === 0) {
            $d1d36a3f61276665$var$_TextMetrics._fonts[font] = properties;
            return properties;
        }
        canvas.width = width;
        canvas.height = height;
        context.fillStyle = "#f00";
        context.fillRect(0, 0, width, height);
        context.font = font;
        context.textBaseline = "alphabetic";
        context.fillStyle = "#000";
        context.fillText(metricsString, 0, baseline);
        const imagedata = context.getImageData(0, 0, width, height).data;
        const pixels = imagedata.length;
        const line = width * 4;
        let i = 0;
        let idx = 0;
        let stop = false;
        for(i = 0; i < baseline; ++i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = true;
                break;
            }
            if (!stop) idx += line;
            else break;
        }
        properties.ascent = baseline - i;
        idx = pixels - line;
        stop = false;
        for(i = height; i > baseline; --i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = true;
                break;
            }
            if (!stop) idx -= line;
            else break;
        }
        properties.descent = i - baseline;
        properties.fontSize = properties.ascent + properties.descent;
        $d1d36a3f61276665$var$_TextMetrics._fonts[font] = properties;
        return properties;
    }
    static clearMetrics(font = "") {
        if (font) delete $d1d36a3f61276665$var$_TextMetrics._fonts[font];
        else $d1d36a3f61276665$var$_TextMetrics._fonts = {};
    }
    static get _canvas() {
        if (!$d1d36a3f61276665$var$_TextMetrics.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                const context = c.getContext("2d", $d1d36a3f61276665$var$contextSettings);
                if (context?.measureText) {
                    $d1d36a3f61276665$var$_TextMetrics.__canvas = c;
                    return c;
                }
                canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            } catch (ex) {
                canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            }
            canvas.width = canvas.height = 10;
            $d1d36a3f61276665$var$_TextMetrics.__canvas = canvas;
        }
        return $d1d36a3f61276665$var$_TextMetrics.__canvas;
    }
    static get _context() {
        if (!$d1d36a3f61276665$var$_TextMetrics.__context) $d1d36a3f61276665$var$_TextMetrics.__context = $d1d36a3f61276665$var$_TextMetrics._canvas.getContext("2d", $d1d36a3f61276665$var$contextSettings);
        return $d1d36a3f61276665$var$_TextMetrics.__context;
    }
};
let $d1d36a3f61276665$export$4c5a129a59e1ef34 = $d1d36a3f61276665$var$_TextMetrics;
$d1d36a3f61276665$export$4c5a129a59e1ef34.METRICS_STRING = "|\xc9q\xc5";
$d1d36a3f61276665$export$4c5a129a59e1ef34.BASELINE_SYMBOL = "M";
$d1d36a3f61276665$export$4c5a129a59e1ef34.BASELINE_MULTIPLIER = 1.4;
$d1d36a3f61276665$export$4c5a129a59e1ef34.HEIGHT_MULTIPLIER = 2;
$d1d36a3f61276665$export$4c5a129a59e1ef34.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter === "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>[
                ...segmenter.segment(s)
            ].map((x)=>x.segment);
    }
    return (s)=>[
            ...s
        ];
})();
$d1d36a3f61276665$export$4c5a129a59e1ef34.experimentalLetterSpacing = false;
$d1d36a3f61276665$export$4c5a129a59e1ef34._fonts = {};
$d1d36a3f61276665$export$4c5a129a59e1ef34._newlines = [
    10,
    13
];
$d1d36a3f61276665$export$4c5a129a59e1ef34._breakingSpaces = [
    9,
    32,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8200,
    8201,
    8202,
    8287,
    12288
];




const $56d58ce84c72d9ac$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
];
const $56d58ce84c72d9ac$var$_TextStyle = class {
    constructor(style){
        this.styleID = 0;
        this.reset();
        $56d58ce84c72d9ac$var$deepCopyProperties(this, style, style);
    }
    clone() {
        const clonedProperties = {};
        $56d58ce84c72d9ac$var$deepCopyProperties(clonedProperties, this, $56d58ce84c72d9ac$var$_TextStyle.defaultStyle);
        return new $56d58ce84c72d9ac$var$_TextStyle(clonedProperties);
    }
    reset() {
        $56d58ce84c72d9ac$var$deepCopyProperties(this, $56d58ce84c72d9ac$var$_TextStyle.defaultStyle, $56d58ce84c72d9ac$var$_TextStyle.defaultStyle);
    }
    get align() {
        return this._align;
    }
    set align(align) {
        if (this._align !== align) {
            this._align = align;
            this.styleID++;
        }
    }
    get breakWords() {
        return this._breakWords;
    }
    set breakWords(breakWords) {
        if (this._breakWords !== breakWords) {
            this._breakWords = breakWords;
            this.styleID++;
        }
    }
    get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(dropShadow) {
        if (this._dropShadow !== dropShadow) {
            this._dropShadow = dropShadow;
            this.styleID++;
        }
    }
    get dropShadowAlpha() {
        return this._dropShadowAlpha;
    }
    set dropShadowAlpha(dropShadowAlpha) {
        if (this._dropShadowAlpha !== dropShadowAlpha) {
            this._dropShadowAlpha = dropShadowAlpha;
            this.styleID++;
        }
    }
    get dropShadowAngle() {
        return this._dropShadowAngle;
    }
    set dropShadowAngle(dropShadowAngle) {
        if (this._dropShadowAngle !== dropShadowAngle) {
            this._dropShadowAngle = dropShadowAngle;
            this.styleID++;
        }
    }
    get dropShadowBlur() {
        return this._dropShadowBlur;
    }
    set dropShadowBlur(dropShadowBlur) {
        if (this._dropShadowBlur !== dropShadowBlur) {
            this._dropShadowBlur = dropShadowBlur;
            this.styleID++;
        }
    }
    get dropShadowColor() {
        return this._dropShadowColor;
    }
    set dropShadowColor(dropShadowColor) {
        const outputColor = $56d58ce84c72d9ac$var$getColor(dropShadowColor);
        if (this._dropShadowColor !== outputColor) {
            this._dropShadowColor = outputColor;
            this.styleID++;
        }
    }
    get dropShadowDistance() {
        return this._dropShadowDistance;
    }
    set dropShadowDistance(dropShadowDistance) {
        if (this._dropShadowDistance !== dropShadowDistance) {
            this._dropShadowDistance = dropShadowDistance;
            this.styleID++;
        }
    }
    get fill() {
        return this._fill;
    }
    set fill(fill) {
        const outputColor = $56d58ce84c72d9ac$var$getColor(fill);
        if (this._fill !== outputColor) {
            this._fill = outputColor;
            this.styleID++;
        }
    }
    get fillGradientType() {
        return this._fillGradientType;
    }
    set fillGradientType(fillGradientType) {
        if (this._fillGradientType !== fillGradientType) {
            this._fillGradientType = fillGradientType;
            this.styleID++;
        }
    }
    get fillGradientStops() {
        return this._fillGradientStops;
    }
    set fillGradientStops(fillGradientStops) {
        if (!$56d58ce84c72d9ac$var$areArraysEqual(this._fillGradientStops, fillGradientStops)) {
            this._fillGradientStops = fillGradientStops;
            this.styleID++;
        }
    }
    get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(fontFamily) {
        if (this.fontFamily !== fontFamily) {
            this._fontFamily = fontFamily;
            this.styleID++;
        }
    }
    get fontSize() {
        return this._fontSize;
    }
    set fontSize(fontSize) {
        if (this._fontSize !== fontSize) {
            this._fontSize = fontSize;
            this.styleID++;
        }
    }
    get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(fontStyle) {
        if (this._fontStyle !== fontStyle) {
            this._fontStyle = fontStyle;
            this.styleID++;
        }
    }
    get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(fontVariant) {
        if (this._fontVariant !== fontVariant) {
            this._fontVariant = fontVariant;
            this.styleID++;
        }
    }
    get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(fontWeight) {
        if (this._fontWeight !== fontWeight) {
            this._fontWeight = fontWeight;
            this.styleID++;
        }
    }
    get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(letterSpacing) {
        if (this._letterSpacing !== letterSpacing) {
            this._letterSpacing = letterSpacing;
            this.styleID++;
        }
    }
    get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(lineHeight) {
        if (this._lineHeight !== lineHeight) {
            this._lineHeight = lineHeight;
            this.styleID++;
        }
    }
    get leading() {
        return this._leading;
    }
    set leading(leading) {
        if (this._leading !== leading) {
            this._leading = leading;
            this.styleID++;
        }
    }
    get lineJoin() {
        return this._lineJoin;
    }
    set lineJoin(lineJoin) {
        if (this._lineJoin !== lineJoin) {
            this._lineJoin = lineJoin;
            this.styleID++;
        }
    }
    get miterLimit() {
        return this._miterLimit;
    }
    set miterLimit(miterLimit) {
        if (this._miterLimit !== miterLimit) {
            this._miterLimit = miterLimit;
            this.styleID++;
        }
    }
    get padding() {
        return this._padding;
    }
    set padding(padding) {
        if (this._padding !== padding) {
            this._padding = padding;
            this.styleID++;
        }
    }
    get stroke() {
        return this._stroke;
    }
    set stroke(stroke) {
        const outputColor = $56d58ce84c72d9ac$var$getColor(stroke);
        if (this._stroke !== outputColor) {
            this._stroke = outputColor;
            this.styleID++;
        }
    }
    get strokeThickness() {
        return this._strokeThickness;
    }
    set strokeThickness(strokeThickness) {
        if (this._strokeThickness !== strokeThickness) {
            this._strokeThickness = strokeThickness;
            this.styleID++;
        }
    }
    get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(textBaseline) {
        if (this._textBaseline !== textBaseline) {
            this._textBaseline = textBaseline;
            this.styleID++;
        }
    }
    get trim() {
        return this._trim;
    }
    set trim(trim) {
        if (this._trim !== trim) {
            this._trim = trim;
            this.styleID++;
        }
    }
    get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(whiteSpace) {
        if (this._whiteSpace !== whiteSpace) {
            this._whiteSpace = whiteSpace;
            this.styleID++;
        }
    }
    get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(wordWrap) {
        if (this._wordWrap !== wordWrap) {
            this._wordWrap = wordWrap;
            this.styleID++;
        }
    }
    get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(wordWrapWidth) {
        if (this._wordWrapWidth !== wordWrapWidth) {
            this._wordWrapWidth = wordWrapWidth;
            this.styleID++;
        }
    }
    toFontString() {
        const fontSizeString = typeof this.fontSize === "number" ? `${this.fontSize}px` : this.fontSize;
        let fontFamilies = this.fontFamily;
        if (!Array.isArray(this.fontFamily)) fontFamilies = this.fontFamily.split(",");
        for(let i = fontFamilies.length - 1; i >= 0; i--){
            let fontFamily = fontFamilies[i].trim();
            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$56d58ce84c72d9ac$var$genericFontFamilies.includes(fontFamily)) fontFamily = `"${fontFamily}"`;
            fontFamilies[i] = fontFamily;
        }
        return `${this.fontStyle} ${this.fontVariant} ${this.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
    }
};
let $56d58ce84c72d9ac$export$1df879243bf2e42d = $56d58ce84c72d9ac$var$_TextStyle;
$56d58ce84c72d9ac$export$1df879243bf2e42d.defaultStyle = {
    align: "left",
    breakWords: false,
    dropShadow: false,
    dropShadowAlpha: 1,
    dropShadowAngle: Math.PI / 6,
    dropShadowBlur: 0,
    dropShadowColor: "black",
    dropShadowDistance: 5,
    fill: "black",
    fillGradientType: (0, $105b32f38e43c61b$export$131daa784848984).LINEAR_VERTICAL,
    fillGradientStops: [],
    fontFamily: "Arial",
    fontSize: 26,
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    leading: 0,
    letterSpacing: 0,
    lineHeight: 0,
    lineJoin: "miter",
    miterLimit: 10,
    padding: 0,
    stroke: "black",
    strokeThickness: 0,
    textBaseline: "alphabetic",
    trim: false,
    whiteSpace: "pre",
    wordWrap: false,
    wordWrapWidth: 100
};
function $56d58ce84c72d9ac$var$getColor(color) {
    const temp = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared;
    if (!Array.isArray(color)) return temp.setValue(color).toHex();
    else return color.map((c)=>temp.setValue(c).toHex());
}
function $56d58ce84c72d9ac$var$areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) return false;
    if (array1.length !== array2.length) return false;
    for(let i = 0; i < array1.length; ++i){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
function $56d58ce84c72d9ac$var$deepCopyProperties(target, source, propertyObj) {
    for(const prop in propertyObj)if (Array.isArray(source[prop])) target[prop] = source[prop].slice();
    else target[prop] = source[prop];
}


const $cd9bcb4d5b9d0264$var$defaultDestroyOptions = {
    texture: true,
    children: false,
    baseTexture: true
};
const $cd9bcb4d5b9d0264$var$_Text = class extends (0, $28766cd6a31d5ed8$export$3075603db8e6204c) {
    constructor(text, style, canvas){
        let ownCanvas = false;
        if (!canvas) {
            canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            ownCanvas = true;
        }
        canvas.width = 3;
        canvas.height = 3;
        const texture = (0, $6ac4ad2139942545$export$5431306cf43de24a).from(canvas);
        texture.orig = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        texture.trim = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        super(texture);
        this._ownCanvas = ownCanvas;
        this.canvas = canvas;
        this.context = canvas.getContext("2d", {
            willReadFrequently: true
        });
        this._resolution = $cd9bcb4d5b9d0264$var$_Text.defaultResolution ?? (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
        this._autoResolution = $cd9bcb4d5b9d0264$var$_Text.defaultAutoResolution;
        this._text = null;
        this._style = null;
        this._styleListener = null;
        this._font = "";
        this.text = text;
        this.style = style;
        this.localStyleID = -1;
    }
    static get experimentalLetterSpacing() {
        return (0, $d1d36a3f61276665$export$4c5a129a59e1ef34).experimentalLetterSpacing;
    }
    static set experimentalLetterSpacing(value) {
        (0, $5d808cc4b6a3c326$exports).deprecation("7.1.0", "Text.experimentalLetterSpacing is deprecated, use TextMetrics.experimentalLetterSpacing");
        (0, $d1d36a3f61276665$export$4c5a129a59e1ef34).experimentalLetterSpacing = value;
    }
    updateText(respectDirty) {
        const style = this._style;
        if (this.localStyleID !== style.styleID) {
            this.dirty = true;
            this.localStyleID = style.styleID;
        }
        if (!this.dirty && respectDirty) return;
        this._font = this._style.toFontString();
        const context = this.context;
        const measured = (0, $d1d36a3f61276665$export$4c5a129a59e1ef34).measureText(this._text || " ", this._style, this._style.wordWrap, this.canvas);
        const width = measured.width;
        const height = measured.height;
        const lines = measured.lines;
        const lineHeight = measured.lineHeight;
        const lineWidths = measured.lineWidths;
        const maxLineWidth = measured.maxLineWidth;
        const fontProperties = measured.fontProperties;
        this.canvas.width = Math.ceil(Math.ceil(Math.max(1, width) + style.padding * 2) * this._resolution);
        this.canvas.height = Math.ceil(Math.ceil(Math.max(1, height) + style.padding * 2) * this._resolution);
        context.scale(this._resolution, this._resolution);
        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        context.font = this._font;
        context.lineWidth = style.strokeThickness;
        context.textBaseline = style.textBaseline;
        context.lineJoin = style.lineJoin;
        context.miterLimit = style.miterLimit;
        let linePositionX;
        let linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + style.padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * this._resolution;
            if (isShadowPass) {
                context.fillStyle = "black";
                context.strokeStyle = "black";
                const dropShadowColor = style.dropShadowColor;
                const dropShadowBlur = style.dropShadowBlur * this._resolution;
                const dropShadowDistance = style.dropShadowDistance * this._resolution;
                context.shadowColor = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString();
                context.shadowBlur = dropShadowBlur;
                context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance;
                context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance + dsOffsetShadow;
            } else {
                context.fillStyle = this._generateFillStyle(style, lines, measured);
                context.strokeStyle = style.stroke;
                context.shadowColor = "black";
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
            if (lineHeight - fontProperties.fontSize < 0) linePositionYShift = 0;
            for(let i2 = 0; i2 < lines.length; i2++){
                linePositionX = style.strokeThickness / 2;
                linePositionY = style.strokeThickness / 2 + i2 * lineHeight + fontProperties.ascent + linePositionYShift;
                if (style.align === "right") linePositionX += maxLineWidth - lineWidths[i2];
                else if (style.align === "center") linePositionX += (maxLineWidth - lineWidths[i2]) / 2;
                if (style.stroke && style.strokeThickness) this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText, true);
                if (style.fill) this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText);
            }
        }
        this.updateTexture();
    }
    drawLetterSpacing(text, x, y, isStroke = false) {
        const style = this._style;
        const letterSpacing = style.letterSpacing;
        let useExperimentalLetterSpacing = false;
        if ((0, $d1d36a3f61276665$export$4c5a129a59e1ef34).experimentalLetterSpacingSupported) {
            if ((0, $d1d36a3f61276665$export$4c5a129a59e1ef34).experimentalLetterSpacing) {
                this.context.letterSpacing = `${letterSpacing}px`;
                this.context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                this.context.letterSpacing = "0px";
                this.context.textLetterSpacing = "0px";
            }
        }
        if (letterSpacing === 0 || useExperimentalLetterSpacing) {
            if (isStroke) this.context.strokeText(text, x, y);
            else this.context.fillText(text, x, y);
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $d1d36a3f61276665$export$4c5a129a59e1ef34).graphemeSegmenter(text);
        let previousWidth = this.context.measureText(text).width;
        let currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            if (isStroke) this.context.strokeText(currentChar, currentPosition, y);
            else this.context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = this.context.measureText(textStr).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            previousWidth = currentWidth;
        }
    }
    updateTexture() {
        const canvas = this.canvas;
        if (this._style.trim) {
            const trimmed = (0, $5d808cc4b6a3c326$exports).trimCanvas(canvas);
            if (trimmed.data) {
                canvas.width = trimmed.width;
                canvas.height = trimmed.height;
                this.context.putImageData(trimmed.data, 0, 0);
            }
        }
        const texture = this._texture;
        const style = this._style;
        const padding = style.trim ? 0 : style.padding;
        const baseTexture = texture.baseTexture;
        texture.trim.width = texture._frame.width = canvas.width / this._resolution;
        texture.trim.height = texture._frame.height = canvas.height / this._resolution;
        texture.trim.x = -padding;
        texture.trim.y = -padding;
        texture.orig.width = texture._frame.width - padding * 2;
        texture.orig.height = texture._frame.height - padding * 2;
        this._onTextureUpdate();
        baseTexture.setRealSize(canvas.width, canvas.height, this._resolution);
        texture.updateUvs();
        this.dirty = false;
    }
    _render(renderer) {
        if (this._autoResolution && this._resolution !== renderer.resolution) {
            this._resolution = renderer.resolution;
            this.dirty = true;
        }
        this.updateText(true);
        super._render(renderer);
    }
    updateTransform() {
        this.updateText(true);
        super.updateTransform();
    }
    getBounds(skipUpdate, rect) {
        this.updateText(true);
        if (this._textureID === -1) skipUpdate = false;
        return super.getBounds(skipUpdate, rect);
    }
    getLocalBounds(rect) {
        this.updateText(true);
        return super.getLocalBounds.call(this, rect);
    }
    _calculateBounds() {
        this.calculateVertices();
        this._bounds.addQuad(this.vertexData);
    }
    _generateFillStyle(style, lines, metrics) {
        const fillStyle = style.fill;
        if (!Array.isArray(fillStyle)) return fillStyle;
        else if (fillStyle.length === 1) return fillStyle[0];
        let gradient;
        const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0;
        const padding = style.padding || 0;
        const width = this.canvas.width / this._resolution - dropShadowCorrection - padding * 2;
        const height = this.canvas.height / this._resolution - dropShadowCorrection - padding * 2;
        const fill = fillStyle.slice();
        const fillGradientStops = style.fillGradientStops.slice();
        if (!fillGradientStops.length) {
            const lengthPlus1 = fill.length + 1;
            for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
        }
        fill.unshift(fillStyle[0]);
        fillGradientStops.unshift(0);
        fill.push(fillStyle[fillStyle.length - 1]);
        fillGradientStops.push(1);
        if (style.fillGradientType === (0, $105b32f38e43c61b$export$131daa784848984).LINEAR_VERTICAL) {
            gradient = this.context.createLinearGradient(width / 2, padding, width / 2, height + padding);
            const textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
            for(let i = 0; i < lines.length; i++){
                const lastLineBottom = metrics.lineHeight * (i - 1) + textHeight;
                const thisLineTop = metrics.lineHeight * i;
                let thisLineGradientStart = thisLineTop;
                if (i > 0 && lastLineBottom > thisLineTop) thisLineGradientStart = (thisLineTop + lastLineBottom) / 2;
                const thisLineBottom = thisLineTop + textHeight;
                const nextLineTop = metrics.lineHeight * (i + 1);
                let thisLineGradientEnd = thisLineBottom;
                if (i + 1 < lines.length && nextLineTop < thisLineBottom) thisLineGradientEnd = (thisLineBottom + nextLineTop) / 2;
                const gradStopLineHeight = (thisLineGradientEnd - thisLineGradientStart) / height;
                for(let j = 0; j < fill.length; j++){
                    let lineStop = 0;
                    if (typeof fillGradientStops[j] === "number") lineStop = fillGradientStops[j];
                    else lineStop = j / fill.length;
                    let globalStop = Math.min(1, Math.max(0, thisLineGradientStart / height + lineStop * gradStopLineHeight));
                    globalStop = Number(globalStop.toFixed(5));
                    gradient.addColorStop(globalStop, fill[j]);
                }
            }
        } else {
            gradient = this.context.createLinearGradient(padding, height / 2, width + padding, height / 2);
            const totalIterations = fill.length + 1;
            let currentIteration = 1;
            for(let i = 0; i < fill.length; i++){
                let stop;
                if (typeof fillGradientStops[i] === "number") stop = fillGradientStops[i];
                else stop = currentIteration / totalIterations;
                gradient.addColorStop(stop, fill[i]);
                currentIteration++;
            }
        }
        return gradient;
    }
    destroy(options) {
        if (typeof options === "boolean") options = {
            children: options
        };
        options = Object.assign({}, $cd9bcb4d5b9d0264$var$defaultDestroyOptions, options);
        super.destroy(options);
        if (this._ownCanvas) this.canvas.height = this.canvas.width = 0;
        this.context = null;
        this.canvas = null;
        this._style = null;
    }
    get width() {
        this.updateText(true);
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this.updateText(true);
        const s = (0, $5d808cc4b6a3c326$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width;
        this._width = value;
    }
    get height() {
        this.updateText(true);
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this.updateText(true);
        const s = (0, $5d808cc4b6a3c326$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height;
        this._height = value;
    }
    get style() {
        return this._style;
    }
    set style(style) {
        style = style || {};
        if (style instanceof (0, $56d58ce84c72d9ac$export$1df879243bf2e42d)) this._style = style;
        else this._style = new (0, $56d58ce84c72d9ac$export$1df879243bf2e42d)(style);
        this.localStyleID = -1;
        this.dirty = true;
    }
    get text() {
        return this._text;
    }
    set text(text) {
        text = String(text === null || text === void 0 ? "" : text);
        if (this._text === text) return;
        this._text = text;
        this.dirty = true;
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = false;
        if (this._resolution === value) return;
        this._resolution = value;
        this.dirty = true;
    }
};
let $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6 = $cd9bcb4d5b9d0264$var$_Text;
$cd9bcb4d5b9d0264$export$5f1af8db9871e1d6.defaultAutoResolution = true;






class $b161dc9bc0b15cb6$export$29966907153718d8 {
    constructor(maxItemsPerFrame){
        this.maxItemsPerFrame = maxItemsPerFrame;
        this.itemsLeft = 0;
    }
    beginFrame() {
        this.itemsLeft = this.maxItemsPerFrame;
    }
    allowedToUpload() {
        return this.itemsLeft-- > 0;
    }
}


function $4944834e6b82ba49$var$findMultipleBaseTextures(item, queue) {
    let result = false;
    if (item?._textures?.length) {
        for(let i = 0; i < item._textures.length; i++)if (item._textures[i] instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a)) {
            const baseTexture = item._textures[i].baseTexture;
            if (!queue.includes(baseTexture)) {
                queue.push(baseTexture);
                result = true;
            }
        }
    }
    return result;
}
function $4944834e6b82ba49$var$findBaseTexture(item, queue) {
    if (item.baseTexture instanceof (0, $2d8d497fce3a4092$export$d6306e508f184154)) {
        const texture = item.baseTexture;
        if (!queue.includes(texture)) queue.push(texture);
        return true;
    }
    return false;
}
function $4944834e6b82ba49$var$findTexture(item, queue) {
    if (item._texture && item._texture instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a)) {
        const texture = item._texture.baseTexture;
        if (!queue.includes(texture)) queue.push(texture);
        return true;
    }
    return false;
}
function $4944834e6b82ba49$var$drawText(_helper, item) {
    if (item instanceof (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)) {
        item.updateText(true);
        return true;
    }
    return false;
}
function $4944834e6b82ba49$var$calculateTextStyle(_helper, item) {
    if (item instanceof (0, $56d58ce84c72d9ac$export$1df879243bf2e42d)) {
        const font = item.toFontString();
        (0, $d1d36a3f61276665$export$4c5a129a59e1ef34).measureFont(font);
        return true;
    }
    return false;
}
function $4944834e6b82ba49$var$findText(item, queue) {
    if (item instanceof (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)) {
        if (!queue.includes(item.style)) queue.push(item.style);
        if (!queue.includes(item)) queue.push(item);
        const texture = item._texture.baseTexture;
        if (!queue.includes(texture)) queue.push(texture);
        return true;
    }
    return false;
}
function $4944834e6b82ba49$var$findTextStyle(item, queue) {
    if (item instanceof (0, $56d58ce84c72d9ac$export$1df879243bf2e42d)) {
        if (!queue.includes(item)) queue.push(item);
        return true;
    }
    return false;
}
const $4944834e6b82ba49$var$_BasePrepare = class {
    constructor(renderer){
        this.limiter = new (0, $b161dc9bc0b15cb6$export$29966907153718d8)($4944834e6b82ba49$var$_BasePrepare.uploadsPerFrame);
        this.renderer = renderer;
        this.uploadHookHelper = null;
        this.queue = [];
        this.addHooks = [];
        this.uploadHooks = [];
        this.completes = [];
        this.ticking = false;
        this.delayedTick = ()=>{
            if (!this.queue) return;
            this.prepareItems();
        };
        this.registerFindHook($4944834e6b82ba49$var$findText);
        this.registerFindHook($4944834e6b82ba49$var$findTextStyle);
        this.registerFindHook($4944834e6b82ba49$var$findMultipleBaseTextures);
        this.registerFindHook($4944834e6b82ba49$var$findBaseTexture);
        this.registerFindHook($4944834e6b82ba49$var$findTexture);
        this.registerUploadHook($4944834e6b82ba49$var$drawText);
        this.registerUploadHook($4944834e6b82ba49$var$calculateTextStyle);
    }
    upload(item) {
        return new Promise((resolve)=>{
            if (item) this.add(item);
            if (this.queue.length) {
                this.completes.push(resolve);
                if (!this.ticking) {
                    this.ticking = true;
                    (0, $ad2665272528cf94$export$39c54bcc89dcee11).system.addOnce(this.tick, this, (0, $bc7ed83ac944008c$export$688aaf132ba9b379).UTILITY);
                }
            } else resolve();
        });
    }
    tick() {
        setTimeout(this.delayedTick, 0);
    }
    prepareItems() {
        this.limiter.beginFrame();
        while(this.queue.length && this.limiter.allowedToUpload()){
            const item = this.queue[0];
            let uploaded = false;
            if (item && !item._destroyed) {
                for(let i = 0, len = this.uploadHooks.length; i < len; i++)if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                    this.queue.shift();
                    uploaded = true;
                    break;
                }
            }
            if (!uploaded) this.queue.shift();
        }
        if (!this.queue.length) {
            this.ticking = false;
            const completes = this.completes.slice(0);
            this.completes.length = 0;
            for(let i = 0, len = completes.length; i < len; i++)completes[i]();
        } else (0, $ad2665272528cf94$export$39c54bcc89dcee11).system.addOnce(this.tick, this, (0, $bc7ed83ac944008c$export$688aaf132ba9b379).UTILITY);
    }
    registerFindHook(addHook) {
        if (addHook) this.addHooks.push(addHook);
        return this;
    }
    registerUploadHook(uploadHook) {
        if (uploadHook) this.uploadHooks.push(uploadHook);
        return this;
    }
    add(item) {
        for(let i = 0, len = this.addHooks.length; i < len; i++){
            if (this.addHooks[i](item, this.queue)) break;
        }
        if (item instanceof (0, $823fbc2c4ae841df$export$42a852a2b6b56249)) for(let i = item.children.length - 1; i >= 0; i--)this.add(item.children[i]);
        return this;
    }
    destroy() {
        if (this.ticking) (0, $ad2665272528cf94$export$39c54bcc89dcee11).system.remove(this.tick, this);
        this.ticking = false;
        this.addHooks = null;
        this.uploadHooks = null;
        this.renderer = null;
        this.completes = null;
        this.queue = null;
        this.limiter = null;
        this.uploadHookHelper = null;
    }
};
let $4944834e6b82ba49$export$189fb89547161769 = $4944834e6b82ba49$var$_BasePrepare;
$4944834e6b82ba49$export$189fb89547161769.uploadsPerFrame = 4;


Object.defineProperties((0, $fcbcf105ed644495$export$a5a6e0b888b2c992), {
    UPLOADS_PER_FRAME: {
        get () {
            return (0, $4944834e6b82ba49$export$189fb89547161769).uploadsPerFrame;
        },
        set (value) {
            (0, $5d808cc4b6a3c326$exports).deprecation("7.1.0", "settings.UPLOADS_PER_FRAME is deprecated, use prepare.BasePrepare.uploadsPerFrame");
            (0, $4944834e6b82ba49$export$189fb89547161769).uploadsPerFrame = value;
        }
    }
});







function $579cb64853a88e92$var$uploadBaseTextures(renderer, item) {
    if (item instanceof (0, $2d8d497fce3a4092$export$d6306e508f184154)) {
        if (!item._glTextures[renderer.CONTEXT_UID]) renderer.texture.bind(item);
        return true;
    }
    return false;
}
function $579cb64853a88e92$var$uploadGraphics(renderer, item) {
    if (!(item instanceof (0, $680a5efca7e434a6$export$29d3e417456abdad))) return false;
    const { geometry: geometry  } = item;
    item.finishPoly();
    geometry.updateBatches();
    const { batches: batches  } = geometry;
    for(let i = 0; i < batches.length; i++){
        const { texture: texture  } = batches[i].style;
        if (texture) $579cb64853a88e92$var$uploadBaseTextures(renderer, texture.baseTexture);
    }
    if (!geometry.batchable) renderer.geometry.bind(geometry, item._resolveDirectShader(renderer));
    return true;
}
function $579cb64853a88e92$var$findGraphics(item, queue) {
    if (item instanceof (0, $680a5efca7e434a6$export$29d3e417456abdad)) {
        queue.push(item);
        return true;
    }
    return false;
}
class $579cb64853a88e92$export$6475b8f46e7e39d6 extends (0, $4944834e6b82ba49$export$189fb89547161769) {
    constructor(renderer){
        super(renderer);
        this.uploadHookHelper = this.renderer;
        this.registerFindHook($579cb64853a88e92$var$findGraphics);
        this.registerUploadHook($579cb64853a88e92$var$uploadBaseTextures);
        this.registerUploadHook($579cb64853a88e92$var$uploadGraphics);
    }
}
$579cb64853a88e92$export$6475b8f46e7e39d6.extension = {
    name: "prepare",
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererSystem
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($579cb64853a88e92$export$6475b8f46e7e39d6);


class $d076eb8502ef5e66$export$82e43921ff85c600 {
    constructor(maxMilliseconds){
        this.maxMilliseconds = maxMilliseconds;
        this.frameStart = 0;
    }
    beginFrame() {
        this.frameStart = Date.now();
    }
    allowedToUpload() {
        return Date.now() - this.frameStart < this.maxMilliseconds;
    }
}







class $bef80d21b8b0b6b2$export$dae599798687ad3c extends (0, $28766cd6a31d5ed8$export$3075603db8e6204c) {
    constructor(textures, autoUpdate = true){
        super(textures[0] instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a) ? textures[0] : textures[0].texture);
        this._textures = null;
        this._durations = null;
        this._autoUpdate = autoUpdate;
        this._isConnectedToTicker = false;
        this.animationSpeed = 1;
        this.loop = true;
        this.updateAnchor = false;
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
        this._currentTime = 0;
        this._playing = false;
        this._previousFrame = null;
        this.textures = textures;
    }
    stop() {
        if (!this._playing) return;
        this._playing = false;
        if (this._autoUpdate && this._isConnectedToTicker) {
            (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    }
    play() {
        if (this._playing) return;
        this._playing = true;
        if (this._autoUpdate && !this._isConnectedToTicker) {
            (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.add(this.update, this, (0, $bc7ed83ac944008c$export$688aaf132ba9b379).HIGH);
            this._isConnectedToTicker = true;
        }
    }
    gotoAndStop(frameNumber) {
        this.stop();
        this.currentFrame = frameNumber;
    }
    gotoAndPlay(frameNumber) {
        this.currentFrame = frameNumber;
        this.play();
    }
    update(deltaTime) {
        if (!this._playing) return;
        const elapsed = this.animationSpeed * deltaTime;
        const previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1e3;
            while(lag < 0){
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            const sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while(lag >= this._durations[this.currentFrame]){
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) this.onComplete();
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) this.onComplete();
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame || this.animationSpeed < 0 && this.currentFrame > previousFrame) this.onLoop();
            }
            this.updateTexture();
        }
    }
    updateTexture() {
        const currentFrame = this.currentFrame;
        if (this._previousFrame === currentFrame) return;
        this._previousFrame = currentFrame;
        this._texture = this._textures[currentFrame];
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this._cachedTint = 16777215;
        this.uvs = this._texture._uvs.uvsFloat32;
        if (this.updateAnchor) this._anchor.copyFrom(this._texture.defaultAnchor);
        if (this.onFrameChange) this.onFrameChange(this.currentFrame);
    }
    destroy(options) {
        this.stop();
        super.destroy(options);
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
    }
    static fromFrames(frames) {
        const textures = [];
        for(let i = 0; i < frames.length; ++i)textures.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(frames[i]));
        return new $bef80d21b8b0b6b2$export$dae599798687ad3c(textures);
    }
    static fromImages(images) {
        const textures = [];
        for(let i = 0; i < images.length; ++i)textures.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(images[i]));
        return new $bef80d21b8b0b6b2$export$dae599798687ad3c(textures);
    }
    get totalFrames() {
        return this._textures.length;
    }
    get textures() {
        return this._textures;
    }
    set textures(value) {
        if (value[0] instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a)) {
            this._textures = value;
            this._durations = null;
        } else {
            this._textures = [];
            this._durations = [];
            for(let i = 0; i < value.length; i++){
                this._textures.push(value[i].texture);
                this._durations.push(value[i].time);
            }
        }
        this._previousFrame = null;
        this.gotoAndStop(0);
        this.updateTexture();
    }
    get currentFrame() {
        let currentFrame = Math.floor(this._currentTime) % this._textures.length;
        if (currentFrame < 0) currentFrame += this._textures.length;
        return currentFrame;
    }
    set currentFrame(value) {
        if (value < 0 || value > this.totalFrames - 1) throw new Error(`[AnimatedSprite]: Invalid frame index value ${value}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
        const previousFrame = this.currentFrame;
        this._currentTime = value;
        if (previousFrame !== this.currentFrame) this.updateTexture();
    }
    get playing() {
        return this._playing;
    }
    get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            if (!this._autoUpdate && this._isConnectedToTicker) {
                (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.remove(this.update, this);
                this._isConnectedToTicker = false;
            } else if (this._autoUpdate && !this._isConnectedToTicker && this._playing) {
                (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared.add(this.update, this);
                this._isConnectedToTicker = true;
            }
        }
    }
}






const $8bf7721c1d1425f3$var$tempPoint = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
class $8bf7721c1d1425f3$export$db8370cd1ebcc819 extends (0, $28766cd6a31d5ed8$export$3075603db8e6204c) {
    constructor(texture, width = 100, height = 100){
        super(texture);
        this.tileTransform = new (0, $83f2cf09d03bb7ff$export$563a914cafbdc389)();
        this._width = width;
        this._height = height;
        this.uvMatrix = this.texture.uvMatrix || new (0, $8da561ec6e817bba$export$dbea3135e9da48cb)(texture);
        this.pluginName = "tilingSprite";
        this.uvRespectAnchor = false;
    }
    get clampMargin() {
        return this.uvMatrix.clampMargin;
    }
    set clampMargin(value) {
        this.uvMatrix.clampMargin = value;
        this.uvMatrix.update(true);
    }
    get tileScale() {
        return this.tileTransform.scale;
    }
    set tileScale(value) {
        this.tileTransform.scale.copyFrom(value);
    }
    get tilePosition() {
        return this.tileTransform.position;
    }
    set tilePosition(value) {
        this.tileTransform.position.copyFrom(value);
    }
    _onTextureUpdate() {
        if (this.uvMatrix) this.uvMatrix.texture = this._texture;
        this._cachedTint = 16777215;
    }
    _render(renderer) {
        const texture = this._texture;
        if (!texture || !texture.valid) return;
        this.tileTransform.updateLocalTransform();
        this.uvMatrix.update();
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    }
    _calculateBounds() {
        const minX = this._width * -this._anchor._x;
        const minY = this._height * -this._anchor._y;
        const maxX = this._width * (1 - this._anchor._x);
        const maxY = this._height * (1 - this._anchor._y);
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    getLocalBounds(rect) {
        if (this.children.length === 0) {
            this._bounds.minX = this._width * -this._anchor._x;
            this._bounds.minY = this._height * -this._anchor._y;
            this._bounds.maxX = this._width * (1 - this._anchor._x);
            this._bounds.maxY = this._height * (1 - this._anchor._y);
            if (!rect) {
                if (!this._localBoundsRect) this._localBoundsRect = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
                rect = this._localBoundsRect;
            }
            return this._bounds.getRectangle(rect);
        }
        return super.getLocalBounds.call(this, rect);
    }
    containsPoint(point) {
        this.worldTransform.applyInverse(point, $8bf7721c1d1425f3$var$tempPoint);
        const width = this._width;
        const height = this._height;
        const x1 = -width * this.anchor._x;
        if ($8bf7721c1d1425f3$var$tempPoint.x >= x1 && $8bf7721c1d1425f3$var$tempPoint.x < x1 + width) {
            const y1 = -height * this.anchor._y;
            if ($8bf7721c1d1425f3$var$tempPoint.y >= y1 && $8bf7721c1d1425f3$var$tempPoint.y < y1 + height) return true;
        }
        return false;
    }
    destroy(options) {
        super.destroy(options);
        this.tileTransform = null;
        this.uvMatrix = null;
    }
    static from(source, options) {
        const texture = source instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a) ? source : (0, $6ac4ad2139942545$export$5431306cf43de24a).from(source, options);
        return new $8bf7721c1d1425f3$export$db8370cd1ebcc819(texture, options.width, options.height);
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
    }
}



var $e78278356bc20bf3$export$2e2bcd8739ae039 = "#version 300 es\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nin vec2 vTextureCoord;\n\nout vec4 fragmentColor;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    vec2 unclamped = coord;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0\n\n    fragmentColor = texSample * uColor;\n}\n";


var $3c43f17f556aec1f$export$2e2bcd8739ae039 = "#version 300 es\n#define SHADER_NAME Tiling-Sprite-300\n\nprecision lowp float;\n\nin vec2 aVertexPosition;\nin vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nout vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n";


var $40250159f82efcc2$export$2e2bcd8739ae039 = "#version 100\n#ifdef GL_EXT_shader_texture_lod\n    #extension GL_EXT_shader_texture_lod : enable\n#endif\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    vec2 unclamped = coord;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    #ifdef GL_EXT_shader_texture_lod\n        vec4 texSample = unclamped == coord\n            ? texture2D(uSampler, coord) \n            : texture2DLodEXT(uSampler, coord, 0);\n    #else\n        vec4 texSample = texture2D(uSampler, coord);\n    #endif\n\n    gl_FragColor = texSample * uColor;\n}\n";


var $83a4ca74627add33$export$2e2bcd8739ae039 = "#version 100\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n";


var $30d53873d783fd14$export$2e2bcd8739ae039 = "#version 100\n#define SHADER_NAME Tiling-Sprite-Simple-100\n\nprecision lowp float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 texSample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = texSample * uColor;\n}\n";


const $f9ed358e281ad51c$var$tempMat = new (0, $414c7fb9dda367fe$export$5b12bf1653c0dd85)();
class $f9ed358e281ad51c$export$8b7f6ad84090f14c extends (0, $ec9c34a32f35795b$export$ca67b0b0fa758253) {
    constructor(renderer){
        super(renderer);
        renderer.runners.contextChange.add(this);
        this.quad = new (0, $279feea3d3a65b2d$export$4f70783f37e4ec0b)();
        this.state = (0, $15a50e9cd387ae21$export$7254cc27399e90bd).for2d();
    }
    contextChange() {
        const renderer = this.renderer;
        const uniforms = {
            globals: renderer.globalUniforms
        };
        this.simpleShader = (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5).from((0, $83a4ca74627add33$export$2e2bcd8739ae039), (0, $30d53873d783fd14$export$2e2bcd8739ae039), uniforms);
        this.shader = renderer.context.webGLVersion > 1 ? (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5).from((0, $3c43f17f556aec1f$export$2e2bcd8739ae039), (0, $e78278356bc20bf3$export$2e2bcd8739ae039), uniforms) : (0, $b78f65cdcfbb9b3c$export$462bb059fed9d9e5).from((0, $83a4ca74627add33$export$2e2bcd8739ae039), (0, $40250159f82efcc2$export$2e2bcd8739ae039), uniforms);
    }
    render(ts) {
        const renderer = this.renderer;
        const quad = this.quad;
        let vertices = quad.vertices;
        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;
        vertices[2] = vertices[4] = ts._width * (1 - ts.anchor.x);
        vertices[5] = vertices[7] = ts._height * (1 - ts.anchor.y);
        const anchorX = ts.uvRespectAnchor ? ts.anchor.x : 0;
        const anchorY = ts.uvRespectAnchor ? ts.anchor.y : 0;
        vertices = quad.uvs;
        vertices[0] = vertices[6] = -anchorX;
        vertices[1] = vertices[3] = -anchorY;
        vertices[2] = vertices[4] = 1 - anchorX;
        vertices[5] = vertices[7] = 1 - anchorY;
        quad.invalidate();
        const tex = ts._texture;
        const baseTex = tex.baseTexture;
        const premultiplied = baseTex.alphaMode > 0;
        const lt = ts.tileTransform.localTransform;
        const uv = ts.uvMatrix;
        let isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
        if (isSimple) {
            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
                if (baseTex.wrapMode === (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).CLAMP) baseTex.wrapMode = (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).REPEAT;
            } else isSimple = baseTex.wrapMode !== (0, $551209d754b5b429$export$2ab395cfb0dd2f0f).CLAMP;
        }
        const shader = isSimple ? this.simpleShader : this.shader;
        const w = tex.width;
        const h = tex.height;
        const W = ts._width;
        const H = ts._height;
        $f9ed358e281ad51c$var$tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);
        $f9ed358e281ad51c$var$tempMat.invert();
        if (isSimple) $f9ed358e281ad51c$var$tempMat.prepend(uv.mapCoord);
        else {
            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
            shader.uniforms.uClampFrame = uv.uClampFrame;
            shader.uniforms.uClampOffset = uv.uClampOffset;
        }
        shader.uniforms.uTransform = $f9ed358e281ad51c$var$tempMat.toArray(true);
        shader.uniforms.uColor = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(ts.tint).premultiply(ts.worldAlpha, premultiplied).toArray(shader.uniforms.uColor);
        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);
        shader.uniforms.uSampler = tex;
        renderer.shader.bind(shader);
        renderer.geometry.bind(quad);
        this.state.blendMode = (0, $5d808cc4b6a3c326$exports).correctBlendMode(ts.blendMode, premultiplied);
        renderer.state.set(this.state);
        renderer.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
    }
}
$f9ed358e281ad51c$export$8b7f6ad84090f14c.extension = {
    name: "tilingSprite",
    type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).RendererPlugin
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($f9ed358e281ad51c$export$8b7f6ad84090f14c);





const $97057afd52e3cedd$var$_Spritesheet = class {
    constructor(texture, data, resolutionFilename = null){
        this.linkedSheets = [];
        this._texture = texture instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a) ? texture : null;
        this.baseTexture = texture instanceof (0, $2d8d497fce3a4092$export$d6306e508f184154) ? texture : this._texture.baseTexture;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const resource = this.baseTexture.resource;
        this.resolution = this._updateResolution(resolutionFilename || (resource ? resource.url : null));
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    _updateResolution(resolutionFilename = null) {
        const { scale: scale  } = this.data.meta;
        let resolution = (0, $5d808cc4b6a3c326$exports).getResolutionOfUrl(resolutionFilename, null);
        if (resolution === null) resolution = parseFloat(scale ?? "1");
        if (resolution !== 1) this.baseTexture.setResolution(resolution);
        return resolution;
    }
    parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= $97057afd52e3cedd$var$_Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = $97057afd52e3cedd$var$_Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $340a428aa13511cc$export$4617fb02663045ef)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $340a428aa13511cc$export$4617fb02663045ef)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $340a428aa13511cc$export$4617fb02663045ef)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $340a428aa13511cc$export$4617fb02663045ef)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $6ac4ad2139942545$export$5431306cf43de24a)(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor, data.borders);
                (0, $6ac4ad2139942545$export$5431306cf43de24a).addToCache(this.textures[i], i);
            }
            frameIndex++;
        }
    }
    _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    _nextBatch() {
        this._processFrames(this._batchIndex * $97057afd52e3cedd$var$_Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * $97057afd52e3cedd$var$_Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.baseTexture.destroy();
        }
        this._texture = null;
        this.baseTexture = null;
        this.linkedSheets = [];
    }
};
let $97057afd52e3cedd$export$674d2eb4debbef0c = $97057afd52e3cedd$var$_Spritesheet;
$97057afd52e3cedd$export$674d2eb4debbef0c.BATCH_SIZE = 1e3;





const $d8b4dd1dcb929507$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp"
];
function $d8b4dd1dcb929507$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[key] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $5d808cc4b6a3c326$exports).path.dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $d8b4dd1dcb929507$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $d8b4dd1dcb929507$export$46dcda4f1cdd80fe = {
    extension: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).Asset,
    cache: {
        test: (asset)=>asset instanceof (0, $97057afd52e3cedd$export$674d2eb4debbef0c),
        getCacheableAssets: (keys, asset)=>$d8b4dd1dcb929507$var$getCacheableAssets(keys, asset, false)
    },
    resolver: {
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $d8b4dd1dcb929507$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
            priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).Normal
        },
        async testParse (asset, options) {
            return (0, $5d808cc4b6a3c326$exports).path.extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            let basePath = (0, $5d808cc4b6a3c326$exports).path.dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let imagePath = basePath + asset.meta.image;
            imagePath = (0, $2636f2efcd018458$export$f57b97ef8be10dda)(imagePath, options.src);
            const assets = await loader.load([
                imagePath
            ]);
            const texture = assets[imagePath];
            const spritesheet = new (0, $97057afd52e3cedd$export$674d2eb4debbef0c)(texture.baseTexture, asset, options.src);
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $2636f2efcd018458$export$f57b97ef8be10dda)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        unload (spritesheet) {
            spritesheet.destroy(true);
        }
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($d8b4dd1dcb929507$export$46dcda4f1cdd80fe);







class $7ab50fe3972ed646$export$2fb2a0e272ba703b {
    constructor(){
        this.info = [];
        this.common = [];
        this.page = [];
        this.char = [];
        this.kerning = [];
        this.distanceField = [];
    }
}



class $880895278b852cc3$export$ff5bf922eba68a09 {
    static test(data) {
        return typeof data === "string" && data.startsWith("info face=");
    }
    static parse(txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0];
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            const itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("=");
                const key = split[0];
                const strValue = split[1].replace(/"/gm, "");
                const floatValue = parseFloat(strValue);
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = new (0, $7ab50fe3972ed646$export$2fb2a0e272ba703b)();
        rawData.info.forEach((info)=>font.info.push({
                face: info.face,
                size: parseInt(info.size, 10)
            }));
        rawData.common.forEach((common)=>font.common.push({
                lineHeight: parseInt(common.lineHeight, 10)
            }));
        rawData.page.forEach((page)=>font.page.push({
                id: parseInt(page.id, 10),
                file: page.file
            }));
        rawData.char.forEach((char)=>font.char.push({
                id: parseInt(char.id, 10),
                page: parseInt(char.page, 10),
                x: parseInt(char.x, 10),
                y: parseInt(char.y, 10),
                width: parseInt(char.width, 10),
                height: parseInt(char.height, 10),
                xoffset: parseInt(char.xoffset, 10),
                yoffset: parseInt(char.yoffset, 10),
                xadvance: parseInt(char.xadvance, 10)
            }));
        rawData.kerning.forEach((kerning)=>font.kerning.push({
                first: parseInt(kerning.first, 10),
                second: parseInt(kerning.second, 10),
                amount: parseInt(kerning.amount, 10)
            }));
        rawData.distanceField.forEach((df)=>font.distanceField.push({
                distanceRange: parseInt(df.distanceRange, 10),
                fieldType: df.fieldType
            }));
        return font;
    }
}



class $608a1d5fe1df2eb9$export$4e1527335cae8d18 {
    static test(data) {
        const xml = data;
        return "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    }
    static parse(xml) {
        const data = new (0, $7ab50fe3972ed646$export$2fb2a0e272ba703b)();
        const info = xml.getElementsByTagName("info");
        const common = xml.getElementsByTagName("common");
        const page = xml.getElementsByTagName("page");
        const char = xml.getElementsByTagName("char");
        const kerning = xml.getElementsByTagName("kerning");
        const distanceField = xml.getElementsByTagName("distanceField");
        for(let i = 0; i < info.length; i++)data.info.push({
            face: info[i].getAttribute("face"),
            size: parseInt(info[i].getAttribute("size"), 10)
        });
        for(let i = 0; i < common.length; i++)data.common.push({
            lineHeight: parseInt(common[i].getAttribute("lineHeight"), 10)
        });
        for(let i = 0; i < page.length; i++)data.page.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        for(let i = 0; i < char.length; i++){
            const letter = char[i];
            data.char.push({
                id: parseInt(letter.getAttribute("id"), 10),
                page: parseInt(letter.getAttribute("page"), 10) || 0,
                x: parseInt(letter.getAttribute("x"), 10),
                y: parseInt(letter.getAttribute("y"), 10),
                width: parseInt(letter.getAttribute("width"), 10),
                height: parseInt(letter.getAttribute("height"), 10),
                xoffset: parseInt(letter.getAttribute("xoffset"), 10),
                yoffset: parseInt(letter.getAttribute("yoffset"), 10),
                xadvance: parseInt(letter.getAttribute("xadvance"), 10)
            });
        }
        for(let i = 0; i < kerning.length; i++)data.kerning.push({
            first: parseInt(kerning[i].getAttribute("first"), 10),
            second: parseInt(kerning[i].getAttribute("second"), 10),
            amount: parseInt(kerning[i].getAttribute("amount"), 10)
        });
        for(let i = 0; i < distanceField.length; i++)data.distanceField.push({
            fieldType: distanceField[i].getAttribute("fieldType"),
            distanceRange: parseInt(distanceField[i].getAttribute("distanceRange"), 10)
        });
        return data;
    }
}




class $d0e7dc1b70c5e522$export$9322acbf234f5703 {
    static test(data) {
        if (typeof data === "string" && data.includes("<font>")) return (0, $608a1d5fe1df2eb9$export$4e1527335cae8d18).test((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.parseXML(data));
        return false;
    }
    static parse(xmlTxt) {
        return (0, $608a1d5fe1df2eb9$export$4e1527335cae8d18).parse((0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.parseXML(xmlTxt));
    }
}


const $23cf94aebde1cdac$var$formats = [
    (0, $880895278b852cc3$export$ff5bf922eba68a09),
    (0, $608a1d5fe1df2eb9$export$4e1527335cae8d18),
    (0, $d0e7dc1b70c5e522$export$9322acbf234f5703)
];
function $23cf94aebde1cdac$export$260d11d424c8eebd(data) {
    for(let i = 0; i < $23cf94aebde1cdac$var$formats.length; i++){
        if ($23cf94aebde1cdac$var$formats[i].test(data)) return $23cf94aebde1cdac$var$formats[i];
    }
    return null;
}




function $5fdf9fe3771f7673$export$f6a80096f20930c(canvas, context, style, resolution, lines, metrics) {
    const fillStyle = style.fill;
    if (!Array.isArray(fillStyle)) return fillStyle;
    else if (fillStyle.length === 1) return fillStyle[0];
    let gradient;
    const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0;
    const padding = style.padding || 0;
    const width = canvas.width / resolution - dropShadowCorrection - padding * 2;
    const height = canvas.height / resolution - dropShadowCorrection - padding * 2;
    const fill = fillStyle.slice();
    const fillGradientStops = style.fillGradientStops.slice();
    if (!fillGradientStops.length) {
        const lengthPlus1 = fill.length + 1;
        for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
    }
    fill.unshift(fillStyle[0]);
    fillGradientStops.unshift(0);
    fill.push(fillStyle[fillStyle.length - 1]);
    fillGradientStops.push(1);
    if (style.fillGradientType === (0, $105b32f38e43c61b$export$131daa784848984).LINEAR_VERTICAL) {
        gradient = context.createLinearGradient(width / 2, padding, width / 2, height + padding);
        let lastIterationStop = 0;
        const textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
        const gradStopLineHeight = textHeight / height;
        for(let i = 0; i < lines.length; i++){
            const thisLineTop = metrics.lineHeight * i;
            for(let j = 0; j < fill.length; j++){
                let lineStop = 0;
                if (typeof fillGradientStops[j] === "number") lineStop = fillGradientStops[j];
                else lineStop = j / fill.length;
                const globalStop = thisLineTop / height + lineStop * gradStopLineHeight;
                let clampedStop = Math.max(lastIterationStop, globalStop);
                clampedStop = Math.min(clampedStop, 1);
                gradient.addColorStop(clampedStop, fill[j]);
                lastIterationStop = clampedStop;
            }
        }
    } else {
        gradient = context.createLinearGradient(padding, height / 2, width + padding, height / 2);
        const totalIterations = fill.length + 1;
        let currentIteration = 1;
        for(let i = 0; i < fill.length; i++){
            let stop;
            if (typeof fillGradientStops[i] === "number") stop = fillGradientStops[i];
            else stop = currentIteration / totalIterations;
            gradient.addColorStop(stop, fill[i]);
            currentIteration++;
        }
    }
    return gradient;
}


function $d39e7a070f556cbe$export$d41775f6694ba493(canvas, context, metrics, x, y, resolution, style) {
    const char = metrics.text;
    const fontProperties = metrics.fontProperties;
    context.translate(x, y);
    context.scale(resolution, resolution);
    const tx = style.strokeThickness / 2;
    const ty = -(style.strokeThickness / 2);
    context.font = style.toFontString();
    context.lineWidth = style.strokeThickness;
    context.textBaseline = style.textBaseline;
    context.lineJoin = style.lineJoin;
    context.miterLimit = style.miterLimit;
    context.fillStyle = (0, $5fdf9fe3771f7673$export$f6a80096f20930c)(canvas, context, style, resolution, [
        char
    ], metrics);
    context.strokeStyle = style.stroke;
    if (style.dropShadow) {
        const dropShadowColor = style.dropShadowColor;
        const dropShadowBlur = style.dropShadowBlur * resolution;
        const dropShadowDistance = style.dropShadowDistance * resolution;
        context.shadowColor = (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString();
        context.shadowBlur = dropShadowBlur;
        context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance;
        context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance;
    } else {
        context.shadowColor = "black";
        context.shadowBlur = 0;
        context.shadowOffsetX = 0;
        context.shadowOffsetY = 0;
    }
    if (style.stroke && style.strokeThickness) context.strokeText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
    if (style.fill) context.fillText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.fillStyle = "rgba(0, 0, 0, 0)";
}


function $a28181c76879c374$export$ee42a04f33018f4b(str) {
    return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}



function $523bc67796b60bc3$export$b2c801ee49e0a334(text) {
    return Array.from ? Array.from(text) : text.split("");
}


function $0efb8d895299f556$export$221291e5031b03d8(chars) {
    if (typeof chars === "string") chars = [
        chars
    ];
    const result = [];
    for(let i = 0, j = chars.length; i < j; i++){
        const item = chars[i];
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
            const startCode = item[0].charCodeAt(0);
            const endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error("[BitmapFont]: Invalid character range.");
            for(let i2 = startCode, j2 = endCode; i2 <= j2; i2++)result.push(String.fromCharCode(i2));
        } else result.push(...(0, $523bc67796b60bc3$export$b2c801ee49e0a334)(item));
    }
    if (result.length === 0) throw new Error("[BitmapFont]: Empty set when resolving characters.");
    return result;
}








const $e993cd57c9c1db6e$var$_BitmapFont = class {
    constructor(data, textures, ownsTextures){
        const [info] = data.info;
        const [common] = data.common;
        const [page] = data.page;
        const [distanceField] = data.distanceField;
        const res = (0, $5d808cc4b6a3c326$exports).getResolutionOfUrl(page.file);
        const pageTextures = {};
        this._ownsTextures = ownsTextures;
        this.font = info.face;
        this.size = info.size;
        this.lineHeight = common.lineHeight / res;
        this.chars = {};
        this.pageTextures = pageTextures;
        for(let i = 0; i < data.page.length; i++){
            const { id: id , file: file  } = data.page[i];
            pageTextures[id] = textures instanceof Array ? textures[i] : textures[file];
            if (distanceField?.fieldType && distanceField.fieldType !== "none") {
                pageTextures[id].baseTexture.alphaMode = (0, $551209d754b5b429$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA;
                pageTextures[id].baseTexture.mipmap = (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF;
            }
        }
        for(let i = 0; i < data.char.length; i++){
            const { id: id , page: page2  } = data.char[i];
            let { x: x , y: y , width: width , height: height , xoffset: xoffset , yoffset: yoffset , xadvance: xadvance  } = data.char[i];
            x /= res;
            y /= res;
            width /= res;
            height /= res;
            xoffset /= res;
            yoffset /= res;
            xadvance /= res;
            const rect = new (0, $340a428aa13511cc$export$4617fb02663045ef)(x + pageTextures[page2].frame.x / res, y + pageTextures[page2].frame.y / res, width, height);
            this.chars[id] = {
                xOffset: xoffset,
                yOffset: yoffset,
                xAdvance: xadvance,
                kerning: {},
                texture: new (0, $6ac4ad2139942545$export$5431306cf43de24a)(pageTextures[page2].baseTexture, rect),
                page: page2
            };
        }
        for(let i = 0; i < data.kerning.length; i++){
            let { first: first , second: second , amount: amount  } = data.kerning[i];
            first /= res;
            second /= res;
            amount /= res;
            if (this.chars[second]) this.chars[second].kerning[first] = amount;
        }
        this.distanceFieldRange = distanceField?.distanceRange;
        this.distanceFieldType = distanceField?.fieldType?.toLowerCase() ?? "none";
    }
    destroy() {
        for(const id in this.chars){
            this.chars[id].texture.destroy();
            this.chars[id].texture = null;
        }
        for(const id in this.pageTextures){
            if (this._ownsTextures) this.pageTextures[id].destroy(true);
            this.pageTextures[id] = null;
        }
        this.chars = null;
        this.pageTextures = null;
    }
    static install(data, textures, ownsTextures) {
        let fontData;
        if (data instanceof (0, $7ab50fe3972ed646$export$2fb2a0e272ba703b)) fontData = data;
        else {
            const format = (0, $23cf94aebde1cdac$export$260d11d424c8eebd)(data);
            if (!format) throw new Error("Unrecognized data format for font.");
            fontData = format.parse(data);
        }
        if (textures instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a)) textures = [
            textures
        ];
        const font = new $e993cd57c9c1db6e$var$_BitmapFont(fontData, textures, ownsTextures);
        $e993cd57c9c1db6e$var$_BitmapFont.available[font.font] = font;
        return font;
    }
    static uninstall(name) {
        const font = $e993cd57c9c1db6e$var$_BitmapFont.available[name];
        if (!font) throw new Error(`No font found named '${name}'`);
        font.destroy();
        delete $e993cd57c9c1db6e$var$_BitmapFont.available[name];
    }
    static from(name, textStyle, options) {
        if (!name) throw new Error("[BitmapFont] Property `name` is required.");
        const { chars: chars , padding: padding , resolution: resolution , textureWidth: textureWidth , textureHeight: textureHeight , ...baseOptions } = Object.assign({}, $e993cd57c9c1db6e$var$_BitmapFont.defaultOptions, options);
        const charsList = (0, $0efb8d895299f556$export$221291e5031b03d8)(chars);
        const style = textStyle instanceof (0, $56d58ce84c72d9ac$export$1df879243bf2e42d) ? textStyle : new (0, $56d58ce84c72d9ac$export$1df879243bf2e42d)(textStyle);
        const lineWidth = textureWidth;
        const fontData = new (0, $7ab50fe3972ed646$export$2fb2a0e272ba703b)();
        fontData.info[0] = {
            face: style.fontFamily,
            size: style.fontSize
        };
        fontData.common[0] = {
            lineHeight: style.fontSize
        };
        let positionX = 0;
        let positionY = 0;
        let canvas;
        let context;
        let baseTexture;
        let maxCharHeight = 0;
        const baseTextures = [];
        const textures = [];
        for(let i = 0; i < charsList.length; i++){
            if (!canvas) {
                canvas = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
                canvas.width = textureWidth;
                canvas.height = textureHeight;
                context = canvas.getContext("2d");
                baseTexture = new (0, $2d8d497fce3a4092$export$d6306e508f184154)(canvas, {
                    resolution: resolution,
                    ...baseOptions
                });
                baseTextures.push(baseTexture);
                textures.push(new (0, $6ac4ad2139942545$export$5431306cf43de24a)(baseTexture));
                fontData.page.push({
                    id: textures.length - 1,
                    file: ""
                });
            }
            const character = charsList[i];
            const metrics = (0, $d1d36a3f61276665$export$4c5a129a59e1ef34).measureText(character, style, false, canvas);
            const width = metrics.width;
            const height = Math.ceil(metrics.height);
            const textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
            if (positionY >= textureHeight - height * resolution) {
                if (positionY === 0) throw new Error(`[BitmapFont] textureHeight ${textureHeight}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i;
                canvas = null;
                context = null;
                baseTexture = null;
                positionY = 0;
                positionX = 0;
                maxCharHeight = 0;
                continue;
            }
            maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight);
            if (textureGlyphWidth * resolution + positionX >= lineWidth) {
                if (positionX === 0) throw new Error(`[BitmapFont] textureWidth ${textureWidth}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i;
                positionY += maxCharHeight * resolution;
                positionY = Math.ceil(positionY);
                positionX = 0;
                maxCharHeight = 0;
                continue;
            }
            (0, $d39e7a070f556cbe$export$d41775f6694ba493)(canvas, context, metrics, positionX, positionY, resolution, style);
            const id = (0, $a28181c76879c374$export$ee42a04f33018f4b)(metrics.text);
            fontData.char.push({
                id: id,
                page: textures.length - 1,
                x: positionX / resolution,
                y: positionY / resolution,
                width: textureGlyphWidth,
                height: height,
                xoffset: 0,
                yoffset: 0,
                xadvance: width - (style.dropShadow ? style.dropShadowDistance : 0) - (style.stroke ? style.strokeThickness : 0)
            });
            positionX += (textureGlyphWidth + 2 * padding) * resolution;
            positionX = Math.ceil(positionX);
        }
        for(let i = 0, len = charsList.length; i < len; i++){
            const first = charsList[i];
            for(let j = 0; j < len; j++){
                const second = charsList[j];
                const c1 = context.measureText(first).width;
                const c2 = context.measureText(second).width;
                const total = context.measureText(first + second).width;
                const amount = total - (c1 + c2);
                if (amount) fontData.kerning.push({
                    first: (0, $a28181c76879c374$export$ee42a04f33018f4b)(first),
                    second: (0, $a28181c76879c374$export$ee42a04f33018f4b)(second),
                    amount: amount
                });
            }
        }
        const font = new $e993cd57c9c1db6e$var$_BitmapFont(fontData, textures, true);
        if ($e993cd57c9c1db6e$var$_BitmapFont.available[name] !== void 0) $e993cd57c9c1db6e$var$_BitmapFont.uninstall(name);
        $e993cd57c9c1db6e$var$_BitmapFont.available[name] = font;
        return font;
    }
};
let $e993cd57c9c1db6e$export$17957a09927cadc7 = $e993cd57c9c1db6e$var$_BitmapFont;
$e993cd57c9c1db6e$export$17957a09927cadc7.ALPHA = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    " "
];
$e993cd57c9c1db6e$export$17957a09927cadc7.NUMERIC = [
    [
        "0",
        "9"
    ]
];
$e993cd57c9c1db6e$export$17957a09927cadc7.ALPHANUMERIC = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    [
        "0",
        "9"
    ],
    " "
];
$e993cd57c9c1db6e$export$17957a09927cadc7.ASCII = [
    [
        " ",
        "~"
    ]
];
$e993cd57c9c1db6e$export$17957a09927cadc7.defaultOptions = {
    resolution: 1,
    textureWidth: 512,
    textureHeight: 512,
    padding: 4,
    chars: $e993cd57c9c1db6e$var$_BitmapFont.ALPHANUMERIC
};
$e993cd57c9c1db6e$export$17957a09927cadc7.available = {};







var $98df67e963175c24$export$2e2bcd8739ae039 = "// Pixi texture info\r\nvarying vec2 vTextureCoord;\r\nuniform sampler2D uSampler;\r\n\r\n// Tint\r\nuniform vec4 uColor;\r\n\r\n// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r\nuniform float uFWidth;\r\n\r\nvoid main(void) {\r\n\r\n  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r\n  vec4 texColor = texture2D(uSampler, vTextureCoord);\r\n\r\n  // MSDF\r\n  float median = texColor.r + texColor.g + texColor.b -\r\n                  min(texColor.r, min(texColor.g, texColor.b)) -\r\n                  max(texColor.r, max(texColor.g, texColor.b));\r\n  // SDF\r\n  median = min(median, texColor.a);\r\n\r\n  float screenPxDistance = uFWidth * (median - 0.5);\r\n  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r\n  if (median < 0.01) {\r\n    alpha = 0.0;\r\n  } else if (median > 0.99) {\r\n    alpha = 1.0;\r\n  }\r\n\r\n  // Gamma correction for coverage-like alpha\r\n  float luma = dot(uColor.rgb, vec3(0.299, 0.587, 0.114));\r\n  float gamma = mix(1.0, 1.0 / 2.2, luma);\r\n  float coverage = pow(uColor.a * alpha, gamma);  \r\n\r\n  // NPM Textures, NPM outputs\r\n  gl_FragColor = vec4(uColor.rgb, coverage);\r\n}\r\n";


var $4a5ac9abfcba2362$export$2e2bcd8739ae039 = "// Mesh material default fragment\r\nattribute vec2 aVertexPosition;\r\nattribute vec2 aTextureCoord;\r\n\r\nuniform mat3 projectionMatrix;\r\nuniform mat3 translationMatrix;\r\nuniform mat3 uTextureMatrix;\r\n\r\nvarying vec2 vTextureCoord;\r\n\r\nvoid main(void)\r\n{\r\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r\n\r\n    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r\n}\r\n";





const $6e64abdaf6d4c15a$var$pageMeshDataDefaultPageMeshData = [];
const $6e64abdaf6d4c15a$var$pageMeshDataMSDFPageMeshData = [];
const $6e64abdaf6d4c15a$var$charRenderDataPool = [];
const $6e64abdaf6d4c15a$var$_BitmapText = class extends (0, $823fbc2c4ae841df$export$42a852a2b6b56249) {
    constructor(text, style = {}){
        super();
        const { align: align , tint: tint , maxWidth: maxWidth , letterSpacing: letterSpacing , fontName: fontName , fontSize: fontSize  } = Object.assign({}, $6e64abdaf6d4c15a$var$_BitmapText.styleDefaults, style);
        if (!(0, $e993cd57c9c1db6e$export$17957a09927cadc7).available[fontName]) throw new Error(`Missing BitmapFont "${fontName}"`);
        this._activePagesMeshData = [];
        this._textWidth = 0;
        this._textHeight = 0;
        this._align = align;
        this._tintColor = new (0, $6c0bc7edac0d7e9d$export$892596cec99bc70e)(tint);
        this._font = void 0;
        this._fontName = fontName;
        this._fontSize = fontSize;
        this.text = text;
        this._maxWidth = maxWidth;
        this._maxLineHeight = 0;
        this._letterSpacing = letterSpacing;
        this._anchor = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(()=>{
            this.dirty = true;
        }, this, 0, 0);
        this._roundPixels = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ROUND_PIXELS;
        this.dirty = true;
        this._resolution = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
        this._autoResolution = true;
        this._textureCache = {};
    }
    updateText() {
        const data = (0, $e993cd57c9c1db6e$export$17957a09927cadc7).available[this._fontName];
        const fontSize = this.fontSize;
        const scale = fontSize / data.size;
        const pos = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        const chars = [];
        const lineWidths = [];
        const lineSpaces = [];
        const text = this._text.replace(/(?:\r\n|\r)/g, "\n") || " ";
        const charsInput = (0, $523bc67796b60bc3$export$b2c801ee49e0a334)(text);
        const maxWidth = this._maxWidth * data.size / fontSize;
        const pageMeshDataPool = data.distanceFieldType === "none" ? $6e64abdaf6d4c15a$var$pageMeshDataDefaultPageMeshData : $6e64abdaf6d4c15a$var$pageMeshDataMSDFPageMeshData;
        let prevCharCode = null;
        let lastLineWidth = 0;
        let maxLineWidth = 0;
        let line = 0;
        let lastBreakPos = -1;
        let lastBreakWidth = 0;
        let spacesRemoved = 0;
        let maxLineHeight = 0;
        let spaceCount = 0;
        for(let i = 0; i < charsInput.length; i++){
            const char = charsInput[i];
            const charCode = (0, $a28181c76879c374$export$ee42a04f33018f4b)(char);
            if (/(?:\s)/.test(char)) {
                lastBreakPos = i;
                lastBreakWidth = lastLineWidth;
                spaceCount++;
            }
            if (char === "\r" || char === "\n") {
                lineWidths.push(lastLineWidth);
                lineSpaces.push(-1);
                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
                ++line;
                ++spacesRemoved;
                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                spaceCount = 0;
                continue;
            }
            const charData = data.chars[charCode];
            if (!charData) continue;
            if (prevCharCode && charData.kerning[prevCharCode]) pos.x += charData.kerning[prevCharCode];
            const charRenderData = $6e64abdaf6d4c15a$var$charRenderDataPool.pop() || {
                texture: (0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY,
                line: 0,
                charCode: 0,
                prevSpaces: 0,
                position: new (0, $88931fa1c0809be8$export$baf26146a414f24a)()
            };
            charRenderData.texture = charData.texture;
            charRenderData.line = line;
            charRenderData.charCode = charCode;
            charRenderData.position.x = Math.round(pos.x + charData.xOffset + this._letterSpacing / 2);
            charRenderData.position.y = Math.round(pos.y + charData.yOffset);
            charRenderData.prevSpaces = spaceCount;
            chars.push(charRenderData);
            lastLineWidth = charRenderData.position.x + Math.max(charData.xAdvance - charData.xOffset, charData.texture.orig.width);
            pos.x += charData.xAdvance + this._letterSpacing;
            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
            prevCharCode = charCode;
            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
                ++spacesRemoved;
                (0, $5d808cc4b6a3c326$exports).removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
                i = lastBreakPos;
                lastBreakPos = -1;
                lineWidths.push(lastBreakWidth);
                lineSpaces.push(chars.length > 0 ? chars[chars.length - 1].prevSpaces : 0);
                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
                line++;
                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                spaceCount = 0;
            }
        }
        const lastChar = charsInput[charsInput.length - 1];
        if (lastChar !== "\r" && lastChar !== "\n") {
            if (/(?:\s)/.test(lastChar)) lastLineWidth = lastBreakWidth;
            lineWidths.push(lastLineWidth);
            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
            lineSpaces.push(-1);
        }
        const lineAlignOffsets = [];
        for(let i = 0; i <= line; i++){
            let alignOffset = 0;
            if (this._align === "right") alignOffset = maxLineWidth - lineWidths[i];
            else if (this._align === "center") alignOffset = (maxLineWidth - lineWidths[i]) / 2;
            else if (this._align === "justify") alignOffset = lineSpaces[i] < 0 ? 0 : (maxLineWidth - lineWidths[i]) / lineSpaces[i];
            lineAlignOffsets.push(alignOffset);
        }
        const lenChars = chars.length;
        const pagesMeshData = {};
        const newPagesMeshData = [];
        const activePagesMeshData = this._activePagesMeshData;
        pageMeshDataPool.push(...activePagesMeshData);
        for(let i = 0; i < lenChars; i++){
            const texture = chars[i].texture;
            const baseTextureUid = texture.baseTexture.uid;
            if (!pagesMeshData[baseTextureUid]) {
                let pageMeshData = pageMeshDataPool.pop();
                if (!pageMeshData) {
                    const geometry = new (0, $6a3195e011b88f16$export$8d075a36a73d54bc)();
                    let material;
                    let meshBlendMode;
                    if (data.distanceFieldType === "none") {
                        material = new (0, $dad6142c5ef6c8cb$export$d552dadfd66cc650)((0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY);
                        meshBlendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL;
                    } else {
                        material = new (0, $dad6142c5ef6c8cb$export$d552dadfd66cc650)((0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY, {
                            program: (0, $52e5734958fc1bae$export$b6c59b989905b650).from((0, $4a5ac9abfcba2362$export$2e2bcd8739ae039), (0, $98df67e963175c24$export$2e2bcd8739ae039)),
                            uniforms: {
                                uFWidth: 0
                            }
                        });
                        meshBlendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).NORMAL_NPM;
                    }
                    const mesh = new (0, $568baf8681eacf07$export$e176487c05830cc5)(geometry, material);
                    mesh.blendMode = meshBlendMode;
                    pageMeshData = {
                        index: 0,
                        indexCount: 0,
                        vertexCount: 0,
                        uvsCount: 0,
                        total: 0,
                        mesh: mesh,
                        vertices: null,
                        uvs: null,
                        indices: null
                    };
                }
                pageMeshData.index = 0;
                pageMeshData.indexCount = 0;
                pageMeshData.vertexCount = 0;
                pageMeshData.uvsCount = 0;
                pageMeshData.total = 0;
                const { _textureCache: _textureCache  } = this;
                _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new (0, $6ac4ad2139942545$export$5431306cf43de24a)(texture.baseTexture);
                pageMeshData.mesh.texture = _textureCache[baseTextureUid];
                pageMeshData.mesh.tint = this._tintColor.value;
                newPagesMeshData.push(pageMeshData);
                pagesMeshData[baseTextureUid] = pageMeshData;
            }
            pagesMeshData[baseTextureUid].total++;
        }
        for(let i = 0; i < activePagesMeshData.length; i++)if (!newPagesMeshData.includes(activePagesMeshData[i])) this.removeChild(activePagesMeshData[i].mesh);
        for(let i = 0; i < newPagesMeshData.length; i++)if (newPagesMeshData[i].mesh.parent !== this) this.addChild(newPagesMeshData[i].mesh);
        this._activePagesMeshData = newPagesMeshData;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i];
            const total = pageMeshData.total;
            if (!(pageMeshData.indices?.length > 6 * total) || pageMeshData.vertices.length < (0, $568baf8681eacf07$export$e176487c05830cc5).BATCHABLE_SIZE * 2) {
                pageMeshData.vertices = new Float32Array(8 * total);
                pageMeshData.uvs = new Float32Array(8 * total);
                pageMeshData.indices = new Uint16Array(6 * total);
            } else {
                const total2 = pageMeshData.total;
                const vertices = pageMeshData.vertices;
                for(let i2 = total2 * 8; i2 < vertices.length; i2++)vertices[i2] = 0;
            }
            pageMeshData.mesh.size = 6 * total;
        }
        for(let i = 0; i < lenChars; i++){
            const char = chars[i];
            let offset = char.position.x + lineAlignOffsets[char.line] * (this._align === "justify" ? char.prevSpaces : 1);
            if (this._roundPixels) offset = Math.round(offset);
            const xPos = offset * scale;
            const yPos = char.position.y * scale;
            const texture = char.texture;
            const pageMesh = pagesMeshData[texture.baseTexture.uid];
            const textureFrame = texture.frame;
            const textureUvs = texture._uvs;
            const index = pageMesh.index++;
            pageMesh.indices[index * 6 + 0] = 0 + index * 4;
            pageMesh.indices[index * 6 + 1] = 1 + index * 4;
            pageMesh.indices[index * 6 + 2] = 2 + index * 4;
            pageMesh.indices[index * 6 + 3] = 0 + index * 4;
            pageMesh.indices[index * 6 + 4] = 2 + index * 4;
            pageMesh.indices[index * 6 + 5] = 3 + index * 4;
            pageMesh.vertices[index * 8 + 0] = xPos;
            pageMesh.vertices[index * 8 + 1] = yPos;
            pageMesh.vertices[index * 8 + 2] = xPos + textureFrame.width * scale;
            pageMesh.vertices[index * 8 + 3] = yPos;
            pageMesh.vertices[index * 8 + 4] = xPos + textureFrame.width * scale;
            pageMesh.vertices[index * 8 + 5] = yPos + textureFrame.height * scale;
            pageMesh.vertices[index * 8 + 6] = xPos;
            pageMesh.vertices[index * 8 + 7] = yPos + textureFrame.height * scale;
            pageMesh.uvs[index * 8 + 0] = textureUvs.x0;
            pageMesh.uvs[index * 8 + 1] = textureUvs.y0;
            pageMesh.uvs[index * 8 + 2] = textureUvs.x1;
            pageMesh.uvs[index * 8 + 3] = textureUvs.y1;
            pageMesh.uvs[index * 8 + 4] = textureUvs.x2;
            pageMesh.uvs[index * 8 + 5] = textureUvs.y2;
            pageMesh.uvs[index * 8 + 6] = textureUvs.x3;
            pageMesh.uvs[index * 8 + 7] = textureUvs.y3;
        }
        this._textWidth = maxLineWidth * scale;
        this._textHeight = (pos.y + data.lineHeight) * scale;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i];
            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
                let vertexCount = 0;
                const anchorOffsetX = this._textWidth * this.anchor.x;
                const anchorOffsetY = this._textHeight * this.anchor.y;
                for(let i2 = 0; i2 < pageMeshData.total; i2++){
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                }
            }
            this._maxLineHeight = maxLineHeight * scale;
            const vertexBuffer = pageMeshData.mesh.geometry.getBuffer("aVertexPosition");
            const textureBuffer = pageMeshData.mesh.geometry.getBuffer("aTextureCoord");
            const indexBuffer = pageMeshData.mesh.geometry.getIndex();
            vertexBuffer.data = pageMeshData.vertices;
            textureBuffer.data = pageMeshData.uvs;
            indexBuffer.data = pageMeshData.indices;
            vertexBuffer.update();
            textureBuffer.update();
            indexBuffer.update();
        }
        for(let i = 0; i < chars.length; i++)$6e64abdaf6d4c15a$var$charRenderDataPool.push(chars[i]);
        this._font = data;
        this.dirty = false;
    }
    updateTransform() {
        this.validate();
        this.containerUpdateTransform();
    }
    _render(renderer) {
        if (this._autoResolution && this._resolution !== renderer.resolution) {
            this._resolution = renderer.resolution;
            this.dirty = true;
        }
        const { distanceFieldRange: distanceFieldRange , distanceFieldType: distanceFieldType , size: size  } = (0, $e993cd57c9c1db6e$export$17957a09927cadc7).available[this._fontName];
        if (distanceFieldType !== "none") {
            const { a: a , b: b , c: c , d: d  } = this.worldTransform;
            const dx = Math.sqrt(a * a + b * b);
            const dy = Math.sqrt(c * c + d * d);
            const worldScale = (Math.abs(dx) + Math.abs(dy)) / 2;
            const fontScale = this.fontSize / size;
            const resolution = renderer._view.resolution;
            for (const mesh of this._activePagesMeshData)mesh.mesh.shader.uniforms.uFWidth = worldScale * distanceFieldRange * fontScale * resolution;
        }
        super._render(renderer);
    }
    getLocalBounds() {
        this.validate();
        return super.getLocalBounds();
    }
    validate() {
        const font = (0, $e993cd57c9c1db6e$export$17957a09927cadc7).available[this._fontName];
        if (!font) throw new Error(`Missing BitmapFont "${this._fontName}"`);
        if (this._font !== font) this.dirty = true;
        if (this.dirty) this.updateText();
    }
    get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        if (this.tint === value) return;
        this._tintColor.setValue(value);
        for(let i = 0; i < this._activePagesMeshData.length; i++)this._activePagesMeshData[i].mesh.tint = value;
    }
    get align() {
        return this._align;
    }
    set align(value) {
        if (this._align !== value) {
            this._align = value;
            this.dirty = true;
        }
    }
    get fontName() {
        return this._fontName;
    }
    set fontName(value) {
        if (!(0, $e993cd57c9c1db6e$export$17957a09927cadc7).available[value]) throw new Error(`Missing BitmapFont "${value}"`);
        if (this._fontName !== value) {
            this._fontName = value;
            this.dirty = true;
        }
    }
    get fontSize() {
        return this._fontSize ?? (0, $e993cd57c9c1db6e$export$17957a09927cadc7).available[this._fontName].size;
    }
    set fontSize(value) {
        if (this._fontSize !== value) {
            this._fontSize = value;
            this.dirty = true;
        }
    }
    get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        if (typeof value === "number") this._anchor.set(value);
        else this._anchor.copyFrom(value);
    }
    get text() {
        return this._text;
    }
    set text(text) {
        text = String(text === null || text === void 0 ? "" : text);
        if (this._text === text) return;
        this._text = text;
        this.dirty = true;
    }
    get maxWidth() {
        return this._maxWidth;
    }
    set maxWidth(value) {
        if (this._maxWidth === value) return;
        this._maxWidth = value;
        this.dirty = true;
    }
    get maxLineHeight() {
        this.validate();
        return this._maxLineHeight;
    }
    get textWidth() {
        this.validate();
        return this._textWidth;
    }
    get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        if (this._letterSpacing !== value) {
            this._letterSpacing = value;
            this.dirty = true;
        }
    }
    get roundPixels() {
        return this._roundPixels;
    }
    set roundPixels(value) {
        if (value !== this._roundPixels) {
            this._roundPixels = value;
            this.dirty = true;
        }
    }
    get textHeight() {
        this.validate();
        return this._textHeight;
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = false;
        if (this._resolution === value) return;
        this._resolution = value;
        this.dirty = true;
    }
    destroy(options) {
        const { _textureCache: _textureCache  } = this;
        const data = (0, $e993cd57c9c1db6e$export$17957a09927cadc7).available[this._fontName];
        const pageMeshDataPool = data.distanceFieldType === "none" ? $6e64abdaf6d4c15a$var$pageMeshDataDefaultPageMeshData : $6e64abdaf6d4c15a$var$pageMeshDataMSDFPageMeshData;
        pageMeshDataPool.push(...this._activePagesMeshData);
        for (const pageMeshData of this._activePagesMeshData)this.removeChild(pageMeshData.mesh);
        this._activePagesMeshData = [];
        pageMeshDataPool.filter((page)=>_textureCache[page.mesh.texture.baseTexture.uid]).forEach((page)=>{
            page.mesh.texture = (0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY;
        });
        for(const id in _textureCache){
            const texture = _textureCache[id];
            texture.destroy();
            delete _textureCache[id];
        }
        this._font = null;
        this._tintColor = null;
        this._textureCache = null;
        super.destroy(options);
    }
};
let $6e64abdaf6d4c15a$export$ae0da96467efdba0 = $6e64abdaf6d4c15a$var$_BitmapText;
$6e64abdaf6d4c15a$export$ae0da96467efdba0.styleDefaults = {
    align: "left",
    tint: 16777215,
    maxWidth: 0,
    letterSpacing: 0
};











const $1d74f06b3531e0d3$var$validExtensions = [
    ".xml",
    ".fnt"
];
const $1d74f06b3531e0d3$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).Normal
    },
    name: "loadBitmapFont",
    test (url) {
        return $1d74f06b3531e0d3$var$validExtensions.includes((0, $5d808cc4b6a3c326$exports).path.extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $880895278b852cc3$export$ff5bf922eba68a09).test(data) || (0, $d0e7dc1b70c5e522$export$9322acbf234f5703).test(data);
    },
    async parse (asset, data, loader) {
        const fontData = (0, $880895278b852cc3$export$ff5bf922eba68a09).test(asset) ? (0, $880895278b852cc3$export$ff5bf922eba68a09).parse(asset) : (0, $d0e7dc1b70c5e522$export$9322acbf234f5703).parse(asset);
        const { src: src  } = data;
        const { page: pages  } = fontData;
        const textureUrls = [];
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $5d808cc4b6a3c326$exports).path.join((0, $5d808cc4b6a3c326$exports).path.dirname(src), pageFile);
            imagePath = (0, $2636f2efcd018458$export$f57b97ef8be10dda)(imagePath, src);
            textureUrls.push(imagePath);
        }
        const loadedTextures = await loader.load(textureUrls);
        const textures = textureUrls.map((url)=>loadedTextures[url]);
        return (0, $e993cd57c9c1db6e$export$17957a09927cadc7).install(fontData, textures, true);
    },
    async load (url, _options) {
        const response = await (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
        return response.text();
    },
    unload (bitmapFont) {
        bitmapFont.destroy();
    }
};
(0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add($1d74f06b3531e0d3$export$402edee29ac8bed4);












const $22c9c55821653bbc$var$_HTMLTextStyle = class extends (0, $56d58ce84c72d9ac$export$1df879243bf2e42d) {
    constructor(){
        super(...arguments);
        this._fonts = [];
        this._overrides = [];
        this._stylesheet = "";
        this.fontsDirty = false;
    }
    static from(originalStyle) {
        return new $22c9c55821653bbc$var$_HTMLTextStyle(Object.keys($22c9c55821653bbc$var$_HTMLTextStyle.defaultOptions).reduce((obj, prop)=>({
                ...obj,
                [prop]: originalStyle[prop]
            }), {}));
    }
    cleanFonts() {
        if (this._fonts.length > 0) {
            this._fonts.forEach((font)=>{
                URL.revokeObjectURL(font.src);
                font.refs--;
                if (font.refs === 0) {
                    if (font.fontFace) document.fonts.delete(font.fontFace);
                    delete $22c9c55821653bbc$var$_HTMLTextStyle.availableFonts[font.originalUrl];
                }
            });
            this.fontFamily = "Arial";
            this._fonts.length = 0;
            this.styleID++;
            this.fontsDirty = true;
        }
    }
    loadFont(url, options = {}) {
        const { availableFonts: availableFonts  } = $22c9c55821653bbc$var$_HTMLTextStyle;
        if (availableFonts[url]) {
            const font = availableFonts[url];
            this._fonts.push(font);
            font.refs++;
            this.styleID++;
            this.fontsDirty = true;
            return Promise.resolve();
        }
        return (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.fetch(url).then((response)=>response.blob()).then(async (blob)=>new Promise((resolve, reject)=>{
                const src = URL.createObjectURL(blob);
                const reader = new FileReader();
                reader.onload = ()=>resolve([
                        src,
                        reader.result
                    ]);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            })).then(async ([src, dataSrc])=>{
            const font = Object.assign({
                family: (0, $5d808cc4b6a3c326$exports).path.basename(url, (0, $5d808cc4b6a3c326$exports).path.extname(url)),
                weight: "normal",
                style: "normal",
                src: src,
                dataSrc: dataSrc,
                refs: 1,
                originalUrl: url,
                fontFace: null
            }, options);
            availableFonts[url] = font;
            this._fonts.push(font);
            this.styleID++;
            const fontFace = new FontFace(font.family, `url(${font.src})`, {
                weight: font.weight,
                style: font.style
            });
            font.fontFace = fontFace;
            await fontFace.load();
            document.fonts.add(fontFace);
            await document.fonts.ready;
            this.styleID++;
            this.fontsDirty = true;
        });
    }
    addOverride(...value) {
        const toAdd = value.filter((v)=>!this._overrides.includes(v));
        if (toAdd.length > 0) {
            this._overrides.push(...toAdd);
            this.styleID++;
        }
    }
    removeOverride(...value) {
        const toRemove = value.filter((v)=>this._overrides.includes(v));
        if (toRemove.length > 0) {
            this._overrides = this._overrides.filter((v)=>!toRemove.includes(v));
            this.styleID++;
        }
    }
    toCSS(scale) {
        return [
            `transform: scale(${scale})`,
            `transform-origin: top left`,
            "display: inline-block",
            `color: ${this.normalizeColor(this.fill)}`,
            `font-size: ${this.fontSize}px`,
            `font-family: ${this.fontFamily}`,
            `font-weight: ${this.fontWeight}`,
            `font-style: ${this.fontStyle}`,
            `font-variant: ${this.fontVariant}`,
            `letter-spacing: ${this.letterSpacing}px`,
            `text-align: ${this.align}`,
            `padding: ${this.padding}px`,
            `white-space: ${this.whiteSpace}`,
            ...this.lineHeight ? [
                `line-height: ${this.lineHeight}px`
            ] : [],
            ...this.wordWrap ? [
                `word-wrap: ${this.breakWords ? "break-all" : "break-word"}`,
                `max-width: ${this.wordWrapWidth}px`
            ] : [],
            ...this.strokeThickness ? [
                `-webkit-text-stroke-width: ${this.strokeThickness}px`,
                `-webkit-text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                `text-stroke-width: ${this.strokeThickness}px`,
                `text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                "paint-order: stroke"
            ] : [],
            ...this.dropShadow ? [
                this.dropShadowToCSS()
            ] : [],
            ...this._overrides
        ].join(";");
    }
    toGlobalCSS() {
        return this._fonts.reduce((result, font)=>`${result}
            @font-face {
                font-family: "${font.family}";
                src: url('${font.dataSrc}');
                font-weight: ${font.weight};
                font-style: ${font.style}; 
            }`, this._stylesheet);
    }
    get stylesheet() {
        return this._stylesheet;
    }
    set stylesheet(value) {
        if (this._stylesheet !== value) {
            this._stylesheet = value;
            this.styleID++;
        }
    }
    normalizeColor(color) {
        if (Array.isArray(color)) color = (0, $5d808cc4b6a3c326$exports).rgb2hex(color);
        if (typeof color === "number") return (0, $5d808cc4b6a3c326$exports).hex2string(color);
        return color;
    }
    dropShadowToCSS() {
        let color = this.normalizeColor(this.dropShadowColor);
        const alpha = this.dropShadowAlpha;
        const x = Math.round(Math.cos(this.dropShadowAngle) * this.dropShadowDistance);
        const y = Math.round(Math.sin(this.dropShadowAngle) * this.dropShadowDistance);
        if (color.startsWith("#") && alpha < 1) color += (alpha * 255 | 0).toString(16).padStart(2, "0");
        const position = `${x}px ${y}px`;
        if (this.dropShadowBlur > 0) return `text-shadow: ${position} ${this.dropShadowBlur}px ${color}`;
        return `text-shadow: ${position} ${color}`;
    }
    reset() {
        Object.assign(this, $22c9c55821653bbc$var$_HTMLTextStyle.defaultOptions);
    }
    onBeforeDraw() {
        const { fontsDirty: prevFontsDirty  } = this;
        this.fontsDirty = false;
        if (this.isSafari && this._fonts.length > 0 && prevFontsDirty) return new Promise((resolve)=>setTimeout(resolve, 100));
        return Promise.resolve();
    }
    get isSafari() {
        const { userAgent: userAgent  } = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).ADAPTER.getNavigator();
        return /^((?!chrome|android).)*safari/i.test(userAgent);
    }
    set fillGradientStops(_value) {
        console.warn("[HTMLTextStyle] fillGradientStops is not supported by HTMLText");
    }
    get fillGradientStops() {
        return super.fillGradientStops;
    }
    set fillGradientType(_value) {
        console.warn("[HTMLTextStyle] fillGradientType is not supported by HTMLText");
    }
    get fillGradientType() {
        return super.fillGradientType;
    }
    set miterLimit(_value) {
        console.warn("[HTMLTextStyle] miterLimit is not supported by HTMLText");
    }
    get miterLimit() {
        return super.miterLimit;
    }
    set trim(_value) {
        console.warn("[HTMLTextStyle] trim is not supported by HTMLText");
    }
    get trim() {
        return super.trim;
    }
    set textBaseline(_value) {
        console.warn("[HTMLTextStyle] textBaseline is not supported by HTMLText");
    }
    get textBaseline() {
        return super.textBaseline;
    }
    set leading(_value) {
        console.warn("[HTMLTextStyle] leading is not supported by HTMLText");
    }
    get leading() {
        return super.leading;
    }
    set lineJoin(_value) {
        console.warn("[HTMLTextStyle] lineJoin is not supported by HTMLText");
    }
    get lineJoin() {
        return super.lineJoin;
    }
};
let $22c9c55821653bbc$export$a2664b42ece43c6c = $22c9c55821653bbc$var$_HTMLTextStyle;
$22c9c55821653bbc$export$a2664b42ece43c6c.availableFonts = {};
$22c9c55821653bbc$export$a2664b42ece43c6c.defaultOptions = {
    align: "left",
    breakWords: false,
    dropShadow: false,
    dropShadowAlpha: 1,
    dropShadowAngle: Math.PI / 6,
    dropShadowBlur: 0,
    dropShadowColor: "black",
    dropShadowDistance: 5,
    fill: "black",
    fontFamily: "Arial",
    fontSize: 26,
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    letterSpacing: 0,
    lineHeight: 0,
    padding: 0,
    stroke: "black",
    strokeThickness: 0,
    whiteSpace: "normal",
    wordWrap: false,
    wordWrapWidth: 100
};


const $cbb5421a0d904a7e$var$_HTMLText = class extends (0, $28766cd6a31d5ed8$export$3075603db8e6204c) {
    constructor(text = "", style = {}){
        super((0, $6ac4ad2139942545$export$5431306cf43de24a).EMPTY);
        this._text = null;
        this._style = null;
        this._autoResolution = true;
        this._loading = false;
        this.localStyleID = -1;
        this.dirty = false;
        this.ownsStyle = false;
        const image = new Image();
        const texture = (0, $6ac4ad2139942545$export$5431306cf43de24a).from(image, {
            scaleMode: (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).SCALE_MODE,
            resourceOptions: {
                autoLoad: false
            }
        });
        texture.orig = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        texture.trim = new (0, $340a428aa13511cc$export$4617fb02663045ef)();
        this.texture = texture;
        const nssvg = "http://www.w3.org/2000/svg";
        const nsxhtml = "http://www.w3.org/1999/xhtml";
        const svgRoot = document.createElementNS(nssvg, "svg");
        const foreignObject = document.createElementNS(nssvg, "foreignObject");
        const domElement = document.createElementNS(nsxhtml, "div");
        const styleElement = document.createElementNS(nsxhtml, "style");
        foreignObject.setAttribute("width", "10000");
        foreignObject.setAttribute("height", "10000");
        foreignObject.style.overflow = "hidden";
        svgRoot.appendChild(foreignObject);
        this.maxWidth = $cbb5421a0d904a7e$var$_HTMLText.defaultMaxWidth;
        this.maxHeight = $cbb5421a0d904a7e$var$_HTMLText.defaultMaxHeight;
        this._domElement = domElement;
        this._styleElement = styleElement;
        this._svgRoot = svgRoot;
        this._foreignObject = foreignObject;
        this._foreignObject.appendChild(styleElement);
        this._foreignObject.appendChild(domElement);
        this._image = image;
        this._loadImage = new Image();
        this._autoResolution = $cbb5421a0d904a7e$var$_HTMLText.defaultAutoResolution;
        this._resolution = $cbb5421a0d904a7e$var$_HTMLText.defaultResolution ?? (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).RESOLUTION;
        this.text = text;
        this.style = style;
    }
    measureText(overrides) {
        const { text: text , style: style , resolution: resolution  } = Object.assign({
            text: this._text,
            style: this._style,
            resolution: this._resolution
        }, overrides);
        Object.assign(this._domElement, {
            innerHTML: text,
            style: style.toCSS(resolution)
        });
        this._styleElement.textContent = style.toGlobalCSS();
        document.body.appendChild(this._svgRoot);
        const contentBounds = this._domElement.getBoundingClientRect();
        this._svgRoot.remove();
        const contentWidth = Math.min(this.maxWidth, Math.ceil(contentBounds.width));
        const contentHeight = Math.min(this.maxHeight, Math.ceil(contentBounds.height));
        this._svgRoot.setAttribute("width", contentWidth.toString());
        this._svgRoot.setAttribute("height", contentHeight.toString());
        if (text !== this._text) this._domElement.innerHTML = this._text;
        if (style !== this._style) {
            Object.assign(this._domElement, {
                style: this._style?.toCSS(resolution)
            });
            this._styleElement.textContent = this._style?.toGlobalCSS();
        }
        return {
            width: contentWidth + style.padding * 2,
            height: contentHeight + style.padding * 2
        };
    }
    async updateText(respectDirty = true) {
        const { style: style , _image: image , _loadImage: loadImage  } = this;
        if (this.localStyleID !== style.styleID) {
            this.dirty = true;
            this.localStyleID = style.styleID;
        }
        if (!this.dirty && respectDirty) return;
        const { width: width , height: height  } = this.measureText();
        image.width = loadImage.width = Math.ceil(Math.max(1, width));
        image.height = loadImage.height = Math.ceil(Math.max(1, height));
        if (!this._loading) {
            this._loading = true;
            await new Promise((resolve)=>{
                loadImage.onload = async ()=>{
                    await style.onBeforeDraw();
                    this._loading = false;
                    image.src = loadImage.src;
                    loadImage.onload = null;
                    loadImage.src = "";
                    this.updateTexture();
                    resolve();
                };
                const svgURL = new XMLSerializer().serializeToString(this._svgRoot);
                loadImage.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(svgURL)}`;
            });
        }
    }
    get source() {
        return this._image;
    }
    updateTexture() {
        const { style: style , texture: texture , _image: image , resolution: resolution  } = this;
        const { padding: padding  } = style;
        const { baseTexture: baseTexture  } = texture;
        texture.trim.width = texture._frame.width = image.width / resolution;
        texture.trim.height = texture._frame.height = image.height / resolution;
        texture.trim.x = -padding;
        texture.trim.y = -padding;
        texture.orig.width = texture._frame.width - padding * 2;
        texture.orig.height = texture._frame.height - padding * 2;
        this._onTextureUpdate();
        baseTexture.setRealSize(image.width, image.height, resolution);
        this.dirty = false;
    }
    _render(renderer) {
        if (this._autoResolution && this._resolution !== renderer.resolution) {
            this._resolution = renderer.resolution;
            this.dirty = true;
        }
        this.updateText(true);
        super._render(renderer);
    }
    _renderCanvas(renderer) {
        if (this._autoResolution && this._resolution !== renderer.resolution) {
            this._resolution = renderer.resolution;
            this.dirty = true;
        }
        this.updateText(true);
        super._renderCanvas(renderer);
    }
    getLocalBounds(rect) {
        this.updateText(true);
        return super.getLocalBounds(rect);
    }
    _calculateBounds() {
        this.updateText(true);
        this.calculateVertices();
        this._bounds.addQuad(this.vertexData);
    }
    _onStyleChange() {
        this.dirty = true;
    }
    destroy(options) {
        if (typeof options === "boolean") options = {
            children: options
        };
        options = Object.assign({}, $cbb5421a0d904a7e$var$_HTMLText.defaultDestroyOptions, options);
        super.destroy(options);
        const forceClear = null;
        if (this.ownsStyle) this._style?.cleanFonts();
        this._style = forceClear;
        this._svgRoot?.remove();
        this._svgRoot = forceClear;
        this._domElement?.remove();
        this._domElement = forceClear;
        this._foreignObject?.remove();
        this._foreignObject = forceClear;
        this._styleElement?.remove();
        this._styleElement = forceClear;
        this._loadImage.src = "";
        this._loadImage.onload = null;
        this._loadImage = forceClear;
        this._image.src = "";
        this._image = forceClear;
    }
    get width() {
        this.updateText(true);
        return Math.abs(this.scale.x) * this._image.width / this.resolution;
    }
    set width(value) {
        this.updateText(true);
        const s = (0, $5d808cc4b6a3c326$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._image.width / this.resolution;
        this._width = value;
    }
    get height() {
        this.updateText(true);
        return Math.abs(this.scale.y) * this._image.height / this.resolution;
    }
    set height(value) {
        this.updateText(true);
        const s = (0, $5d808cc4b6a3c326$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._image.height / this.resolution;
        this._height = value;
    }
    get style() {
        return this._style;
    }
    set style(style) {
        if (this._style === style) return;
        style = style || {};
        if (style instanceof (0, $22c9c55821653bbc$export$a2664b42ece43c6c)) {
            this.ownsStyle = false;
            this._style = style;
        } else if (style instanceof (0, $56d58ce84c72d9ac$export$1df879243bf2e42d)) {
            console.warn("[HTMLText] Cloning TextStyle, if this is not what you want, use HTMLTextStyle");
            this.ownsStyle = true;
            this._style = (0, $22c9c55821653bbc$export$a2664b42ece43c6c).from(style);
        } else {
            this.ownsStyle = true;
            this._style = new (0, $22c9c55821653bbc$export$a2664b42ece43c6c)(style);
        }
        this.localStyleID = -1;
        this.dirty = true;
    }
    get text() {
        return this._text;
    }
    set text(text) {
        text = String(text === "" || text === null || text === void 0 ? " " : text);
        text = this.sanitiseText(text);
        if (this._text === text) return;
        this._text = text;
        this.dirty = true;
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = false;
        if (this._resolution === value) return;
        this._resolution = value;
        this.dirty = true;
    }
    sanitiseText(text) {
        return text.replace(/<br>/gi, "<br/>").replace(/<hr>/gi, "<hr/>").replace(/&nbsp;/gi, "&#160;");
    }
};
let $cbb5421a0d904a7e$export$4b42bbc5a42896a1 = $cbb5421a0d904a7e$var$_HTMLText;
$cbb5421a0d904a7e$export$4b42bbc5a42896a1.defaultDestroyOptions = {
    texture: true,
    children: false,
    baseTexture: true
};
$cbb5421a0d904a7e$export$4b42bbc5a42896a1.defaultMaxWidth = 2024;
$cbb5421a0d904a7e$export$4b42bbc5a42896a1.defaultMaxHeight = 2024;
$cbb5421a0d904a7e$export$4b42bbc5a42896a1.defaultAutoResolution = true;







const $b669a0efa944a1c4$export$af5f8d68aad3cd3a = 4;
const $b669a0efa944a1c4$export$397f5285b920487e = 50 * $b669a0efa944a1c4$export$af5f8d68aad3cd3a;
const $b669a0efa944a1c4$export$809d2b099693a9a8 = 30 * $b669a0efa944a1c4$export$af5f8d68aad3cd3a;
const $b669a0efa944a1c4$export$f3bf37caa3b0771e = 7;
const $b669a0efa944a1c4$export$841f9b33d19fc9b2 = 7;
const $b669a0efa944a1c4$export$674d94f2d6ce26a6 = $b669a0efa944a1c4$export$f3bf37caa3b0771e;
const $b669a0efa944a1c4$export$306b9e34fb186dbb = 20; // tested @ 120.0 FPS (120~120)
const $b669a0efa944a1c4$export$4778e8ff6b6f313 = $b669a0efa944a1c4$export$306b9e34fb186dbb + $b669a0efa944a1c4$export$841f9b33d19fc9b2;
const $b669a0efa944a1c4$export$1c1f001b168ce8d8 = $b669a0efa944a1c4$export$397f5285b920487e - $b669a0efa944a1c4$export$674d94f2d6ce26a6 * 2;
const $b669a0efa944a1c4$export$27b44cadcf674f77 = $b669a0efa944a1c4$export$809d2b099693a9a8 - $b669a0efa944a1c4$export$674d94f2d6ce26a6 - $b669a0efa944a1c4$export$4778e8ff6b6f313;



class $148a2d600b65f879$export$2ddb90ad54e5f587 {
    constructor(name, fg, bg){
        this.values = [];
        this.snapshotSize = 30; // min~max of X frames total
        const canvas = document.createElement("canvas");
        canvas.width = (0, $b669a0efa944a1c4$export$397f5285b920487e);
        canvas.height = (0, $b669a0efa944a1c4$export$809d2b099693a9a8);
        const context = canvas.getContext("2d");
        if (!context) throw new Error("Cant get context on canvas");
        context.font = `bold ${0, $b669a0efa944a1c4$export$306b9e34fb186dbb}px ${getComputedStyle(document.body).fontFamily}`;
        context.textBaseline = "top";
        context.fillStyle = bg;
        context.fillRect(0, 0, (0, $b669a0efa944a1c4$export$397f5285b920487e), (0, $b669a0efa944a1c4$export$809d2b099693a9a8));
        context.fillStyle = fg;
        context.fillText(name, (0, $b669a0efa944a1c4$export$f3bf37caa3b0771e), (0, $b669a0efa944a1c4$export$841f9b33d19fc9b2));
        context.fillRect((0, $b669a0efa944a1c4$export$674d94f2d6ce26a6), (0, $b669a0efa944a1c4$export$4778e8ff6b6f313), (0, $b669a0efa944a1c4$export$1c1f001b168ce8d8), (0, $b669a0efa944a1c4$export$27b44cadcf674f77));
        context.fillStyle = bg;
        context.globalAlpha = 0.8;
        context.fillRect((0, $b669a0efa944a1c4$export$674d94f2d6ce26a6), (0, $b669a0efa944a1c4$export$4778e8ff6b6f313), (0, $b669a0efa944a1c4$export$1c1f001b168ce8d8), (0, $b669a0efa944a1c4$export$27b44cadcf674f77));
        this.name = name;
        this.dom = canvas;
        this.context = context;
        this.fg = fg;
        this.bg = bg;
    }
    get min() {
        return this.values.reduce((min, value)=>Math.min(min, value), Infinity).toFixed();
    }
    get max() {
        return this.values.reduce((max, value)=>Math.max(max, value), 0).toFixed();
    }
    get averageValue() {
        return (this.values.reduce((sum, value)=>sum + value, 0) / this.values.length).toFixed(1);
    }
    pushValue(value) {
        this.values.push(value);
        if (this.values.length > this.snapshotSize) this.values = this.values.slice(-this.snapshotSize);
    }
    update(value, maxValue) {
        const context = this.context;
        this.pushValue(value);
        context.fillStyle = this.bg;
        context.globalAlpha = 1;
        context.fillRect(0, 0, (0, $b669a0efa944a1c4$export$397f5285b920487e), (0, $b669a0efa944a1c4$export$4778e8ff6b6f313));
        context.fillStyle = this.fg;
        context.font = `bold ${0, $b669a0efa944a1c4$export$306b9e34fb186dbb}px ${getComputedStyle(document.body).fontFamily}`;
        context.fillText(`${this.averageValue} ${this.name} (${this.min}-${this.max})`, (0, $b669a0efa944a1c4$export$f3bf37caa3b0771e), (0, $b669a0efa944a1c4$export$841f9b33d19fc9b2));
        context.drawImage(this.dom, (0, $b669a0efa944a1c4$export$674d94f2d6ce26a6) + (0, $b669a0efa944a1c4$export$af5f8d68aad3cd3a), (0, $b669a0efa944a1c4$export$4778e8ff6b6f313), (0, $b669a0efa944a1c4$export$1c1f001b168ce8d8) - (0, $b669a0efa944a1c4$export$af5f8d68aad3cd3a), (0, $b669a0efa944a1c4$export$27b44cadcf674f77), (0, $b669a0efa944a1c4$export$674d94f2d6ce26a6), (0, $b669a0efa944a1c4$export$4778e8ff6b6f313), (0, $b669a0efa944a1c4$export$1c1f001b168ce8d8) - (0, $b669a0efa944a1c4$export$af5f8d68aad3cd3a), (0, $b669a0efa944a1c4$export$27b44cadcf674f77));
        context.fillRect((0, $b669a0efa944a1c4$export$674d94f2d6ce26a6) + (0, $b669a0efa944a1c4$export$1c1f001b168ce8d8) - (0, $b669a0efa944a1c4$export$af5f8d68aad3cd3a), (0, $b669a0efa944a1c4$export$4778e8ff6b6f313), (0, $b669a0efa944a1c4$export$af5f8d68aad3cd3a), (0, $b669a0efa944a1c4$export$27b44cadcf674f77));
        context.fillStyle = this.bg;
        context.globalAlpha = 0.8;
        context.fillRect((0, $b669a0efa944a1c4$export$674d94f2d6ce26a6) + (0, $b669a0efa944a1c4$export$1c1f001b168ce8d8) - (0, $b669a0efa944a1c4$export$af5f8d68aad3cd3a), (0, $b669a0efa944a1c4$export$4778e8ff6b6f313), 2 * (0, $b669a0efa944a1c4$export$af5f8d68aad3cd3a), Math.round((1 - value / maxValue) * (0, $b669a0efa944a1c4$export$27b44cadcf674f77)));
    }
}


class $94effc703a69634e$export$2e2bcd8739ae039 {
    constructor(_gl){
        this.drawPasses = 0;
        this.isInit = false;
        this.realGLDrawElements = function() {};
        if (_gl) {
            if (_gl.__proto__.drawElements) {
                this.gl = _gl;
                this.realGLDrawElements = _gl.__proto__.drawElements;
                //replace to new function
                _gl.__proto__.drawElements = this.fakeGLdrawElements.bind(this);
                this.isInit = true;
                console.log("[GLHook] GL was Hooked!");
            }
        } else console.error("[GLHook] GL can't be NULL");
    }
    fakeGLdrawElements(mode, count, type, offset) {
        this.drawPasses++;
        this.realGLDrawElements.call(this.gl, mode, count, type, offset);
    }
    reset() {
        this.drawPasses = 0;
    }
    release() {
        if (this.isInit) {
            this.gl.__proto__.drawElements = this.realGLDrawElements;
            console.log("[GLHook] Hook was removed!");
        }
        this.isInit = false;
    }
}


class $d4213100683c9dd3$export$2e2bcd8739ae039 {
    constructor(_gl){
        this.createdTextures = new Array();
        this.maxTexturesCount = 0;
        this.isInit = false;
        this.realGLCreateTexture = function() {};
        this.realGLDeleteTexture = function() {};
        if (_gl) {
            if (_gl.__proto__.createTexture) {
                this.gl = _gl;
                this.realGLCreateTexture = _gl.__proto__.createTexture;
                this.realGLDeleteTexture = _gl.__proto__.deleteTexture;
                //replace to new function
                _gl.__proto__.createTexture = this.fakeGLCreateTexture.bind(this);
                _gl.__proto__.deleteTexture = this.fakeGLDeleteTexture.bind(this);
                this.isInit = true;
                console.log("[TextureHook] GL was Hooked!");
            }
        } else console.error("[TextureHook] GL can't be NULL");
    }
    get currentTextureCount() {
        return this.createdTextures.length;
    }
    registerTexture(texture) {
        this.createdTextures.push(texture); // ++;
        this.maxTexturesCount = Math.max(this.createdTextures.length, this.maxTexturesCount);
    }
    fakeGLCreateTexture() {
        var texture = this.realGLCreateTexture.call(this.gl);
        this.registerTexture(texture);
        return texture;
    }
    fakeGLDeleteTexture(texture) {
        var index = this.createdTextures.indexOf(texture);
        if (index > -1) this.createdTextures.splice(index, 1);
        this.realGLDeleteTexture.call(this.gl, texture);
    }
    reset() {
        this.createdTextures = new Array();
        this.maxTexturesCount = 0;
    }
    release() {
        if (this.isInit) {
            this.gl.__proto__.createTexture = this.realGLCreateTexture;
            this.gl.__proto__.deleteTexture = this.realGLDeleteTexture;
            console.log("[TextureHook] Hook was removed!");
        }
        this.isInit = false;
    }
}


class $8c2c472ac7fb640b$export$2e2bcd8739ae039 {
    constructor(){
        this._drawCalls = -1;
        this._maxDeltaDrawCalls = -1;
    }
    attach(gl) {
        this.glhook = new (0, $94effc703a69634e$export$2e2bcd8739ae039)(gl);
        this.texturehook = new (0, $d4213100683c9dd3$export$2e2bcd8739ae039)(gl);
    }
    get drawCalls() {
        if (this.glhook && this.glhook.isInit) return this.glhook.drawPasses;
        return -1;
    }
    get maxDeltaDrawCalls() {
        return this._maxDeltaDrawCalls;
    }
    get deltaDrawCalls() {
        if (this._drawCalls == -1) {
            this._drawCalls = this.drawCalls;
            return 0;
        }
        var dc = this.drawCalls;
        var delta = dc - this._drawCalls;
        this._drawCalls = dc;
        this._maxDeltaDrawCalls = Math.max(this._maxDeltaDrawCalls, delta);
        return delta;
    }
    get maxTextureCount() {
        if (this.texturehook && this.texturehook.isInit) return this.texturehook.maxTexturesCount;
        return 0;
    }
    get texturesCount() {
        if (this.texturehook && this.texturehook.isInit) return this.texturehook.currentTextureCount;
        return 0;
    }
    reset() {
        this._maxDeltaDrawCalls = -1;
        this._drawCalls = -1;
        if (this.glhook) this.glhook.reset();
        if (this.texturehook) this.texturehook.reset();
    }
    release() {
        if (this.glhook) this.glhook.release();
        if (this.texturehook) this.texturehook.release();
    }
}



class $f7e22f55d532ee2b$export$4ae6efeca91e8403 {
    constructor(hook, stats){
        this.hook = hook;
        if (stats) this.stats = stats;
        else if (window.Stats) this.stats = new window.Stats();
        if (this.stats) {
            this.dcPanel = this.stats.addPanel(new (0, $148a2d600b65f879$export$2ddb90ad54e5f587)("DC", "#f60", "#300"));
            this.tcPanel = this.stats.addPanel(new (0, $148a2d600b65f879$export$2ddb90ad54e5f587)("TC", "#0c6", "#033"));
            this.stats.showPanel(0);
        } else throw new Error("Stats can't found in window, pass instance of Stats.js as second param");
    }
    update() {
        if (this.stats) {
            if (this.hook) {
                this.dcPanel.update(this.hook.deltaDrawCalls, Math.max(50, this.hook.maxDeltaDrawCalls));
                this.tcPanel.update(this.hook.texturesCount, Math.max(20, this.hook.maxTextureCount));
            }
            this.stats.update();
        }
    }
    reset() {
        if (this.hook) this.hook.reset();
    }
}
class $f7e22f55d532ee2b$export$1938b5e59b19b0f1 extends (0, $8c2c472ac7fb640b$export$2e2bcd8739ae039) {
    constructor(app){
        super();
        if (!app) {
            console.error("[PIXI Hooks] missing PIXI.Application");
            return;
        }
        const renderer = app.renderer;
        if (renderer.gl) {
            this.attach(renderer.gl);
            const startTextures = renderer.texture.managedTextures;
            if (!startTextures || !this.texturehook) console.error("[PIXI Hooks] !startTextures || !this.texturehook");
            else {
                console.log("[PIXI Hooks] Collect used textures:", startTextures.length);
                for(let i = 0; i < startTextures.length; i++){
                    const txr = startTextures[i];
                    const gltextures = txr._glTextures;
                    Object.values(gltextures).forEach((glTexture)=>{
                        if (glTexture.gl === app.renderer.gl) this.texturehook.registerTexture(glTexture.texture);
                    });
                }
            }
        } else console.error("[PIXI Hook] Canvas renderer is not allowed");
    }
}



class $d83e58a633e2e1c1$export$3cdec2bba15e3523 {
    constructor(){
        this.setMode = this.showPanel;
        this.mode = 0;
        this.domElement = document.createElement("div");
        this.domElement.id = "stats";
        this.domElement.addEventListener("click", (event)=>{
            event.preventDefault();
            this.showPanel(++this.mode % this.domElement.children.length);
        }, false);
        this.beginTime = (performance || Date).now();
        this.prevTime = this.beginTime;
        this.frames = 0;
        this.fpsPanel = this.addPanel(new $d83e58a633e2e1c1$export$3cdec2bba15e3523.Panel("FPS", "#3ff", "#002"));
        this.msPanel = this.addPanel(new $d83e58a633e2e1c1$export$3cdec2bba15e3523.Panel("MS", "#0f0", "#020"));
        if (performance && performance.memory) this.memPanel = this.addPanel(new $d83e58a633e2e1c1$export$3cdec2bba15e3523.Panel("MB", "#f08", "#200"));
    }
    addPanel(panel) {
        this.domElement.appendChild(panel.dom);
        return panel;
    }
    showPanel(id) {
        for(let index = 0; index < this.domElement.children.length; index++){
            const element = this.domElement.children[index];
            element.style.display = index === id ? "block" : "none";
        }
        this.mode = id;
    }
    begin() {
        this.beginTime = (performance || Date).now();
    }
    end() {
        this.frames++;
        const time = (performance || Date).now();
        this.msPanel.update(time - this.beginTime, 200);
        if (time > this.prevTime + 1000) {
            this.fpsPanel.update(this.frames * 1000 / (time - this.prevTime), 100);
            this.prevTime = time;
            this.frames = 0;
            if (this.memPanel) {
                const memory = performance.memory;
                this.memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
            }
        }
        return time;
    }
    update() {
        this.beginTime = this.end();
    }
}
$d83e58a633e2e1c1$export$3cdec2bba15e3523.Panel = (0, $148a2d600b65f879$export$2ddb90ad54e5f587);
function $d83e58a633e2e1c1$export$f2b48b4cd11b43fc(document1, app) {
    const stats = new $d83e58a633e2e1c1$export$3cdec2bba15e3523();
    const pixiHooks = new (0, $f7e22f55d532ee2b$export$1938b5e59b19b0f1)(app);
    const adapter = new (0, $f7e22f55d532ee2b$export$4ae6efeca91e8403)(pixiHooks, stats);
    document1.body.appendChild(adapter.stats.domElement);
    return adapter;
}







var $867beeb89be92199$var$S = Object.defineProperty;
var $867beeb89be92199$var$M = (c, r, t)=>r in c ? $867beeb89be92199$var$S(c, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : c[r] = t;
var $867beeb89be92199$var$o = (c, r, t)=>($867beeb89be92199$var$M(c, typeof r != "symbol" ? r + "" : r, t), t);
class $867beeb89be92199$export$901cf72dabf2112a {
    constructor(r){
        $867beeb89be92199$var$o(this, "parent");
        $867beeb89be92199$var$o(this, "paused");
        this.parent = r, this.paused = !1;
    }
    destroy() {}
    down(r) {
        return !1;
    }
    move(r) {
        return !1;
    }
    up(r) {
        return !1;
    }
    wheel(r) {
        return !1;
    }
    update(r) {}
    resize() {}
    reset() {}
    pause() {
        this.paused = !0;
    }
    resume() {
        this.paused = !1;
    }
}
var $867beeb89be92199$var$C = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $867beeb89be92199$var$H = {
    exports: {}
};
(function(c, r) {
    (function() {
        var t, i;
        i = function(e) {
            return c.exports = e;
        }, t = {
            linear: function(e, n, s, h) {
                return s * e / h + n;
            },
            easeInQuad: function(e, n, s, h) {
                return s * (e /= h) * e + n;
            },
            easeOutQuad: function(e, n, s, h) {
                return -s * (e /= h) * (e - 2) + n;
            },
            easeInOutQuad: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e + n : -s / 2 * (--e * (e - 2) - 1) + n;
            },
            easeInCubic: function(e, n, s, h) {
                return s * (e /= h) * e * e + n;
            },
            easeOutCubic: function(e, n, s, h) {
                return s * ((e = e / h - 1) * e * e + 1) + n;
            },
            easeInOutCubic: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e * e + n : s / 2 * ((e -= 2) * e * e + 2) + n;
            },
            easeInQuart: function(e, n, s, h) {
                return s * (e /= h) * e * e * e + n;
            },
            easeOutQuart: function(e, n, s, h) {
                return -s * ((e = e / h - 1) * e * e * e - 1) + n;
            },
            easeInOutQuart: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e * e * e + n : -s / 2 * ((e -= 2) * e * e * e - 2) + n;
            },
            easeInQuint: function(e, n, s, h) {
                return s * (e /= h) * e * e * e * e + n;
            },
            easeOutQuint: function(e, n, s, h) {
                return s * ((e = e / h - 1) * e * e * e * e + 1) + n;
            },
            easeInOutQuint: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e * e * e * e + n : s / 2 * ((e -= 2) * e * e * e * e + 2) + n;
            },
            easeInSine: function(e, n, s, h) {
                return -s * Math.cos(e / h * (Math.PI / 2)) + s + n;
            },
            easeOutSine: function(e, n, s, h) {
                return s * Math.sin(e / h * (Math.PI / 2)) + n;
            },
            easeInOutSine: function(e, n, s, h) {
                return -s / 2 * (Math.cos(Math.PI * e / h) - 1) + n;
            },
            easeInExpo: function(e, n, s, h) {
                return e === 0 ? n : s * Math.pow(2, 10 * (e / h - 1)) + n;
            },
            easeOutExpo: function(e, n, s, h) {
                return e === h ? n + s : s * (-Math.pow(2, -10 * e / h) + 1) + n;
            },
            easeInOutExpo: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * Math.pow(2, 10 * (e - 1)) + n : s / 2 * (-Math.pow(2, -10 * --e) + 2) + n;
            },
            easeInCirc: function(e, n, s, h) {
                return -s * (Math.sqrt(1 - (e /= h) * e) - 1) + n;
            },
            easeOutCirc: function(e, n, s, h) {
                return s * Math.sqrt(1 - (e = e / h - 1) * e) + n;
            },
            easeInOutCirc: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? -s / 2 * (Math.sqrt(1 - e * e) - 1) + n : s / 2 * (Math.sqrt(1 - (e -= 2) * e) + 1) + n;
            },
            easeInElastic: function(e, n, s, h) {
                var a, p, l;
                return l = 1.70158, p = 0, a = s, e === 0 || (e /= h), p || (p = h * 0.3), a < Math.abs(s) ? (a = s, l = p / 4) : l = p / (2 * Math.PI) * Math.asin(s / a), -(a * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * h - l) * (2 * Math.PI) / p)) + n;
            },
            easeOutElastic: function(e, n, s, h) {
                var a, p, l;
                return l = 1.70158, p = 0, a = s, e === 0 || (e /= h), p || (p = h * 0.3), a < Math.abs(s) ? (a = s, l = p / 4) : l = p / (2 * Math.PI) * Math.asin(s / a), a * Math.pow(2, -10 * e) * Math.sin((e * h - l) * (2 * Math.PI) / p) + s + n;
            },
            easeInOutElastic: function(e, n, s, h) {
                var a, p, l;
                return l = 1.70158, p = 0, a = s, e === 0 || (e /= h / 2), p || (p = h * (0.3 * 1.5)), a < Math.abs(s) ? (a = s, l = p / 4) : l = p / (2 * Math.PI) * Math.asin(s / a), e < 1 ? -0.5 * (a * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * h - l) * (2 * Math.PI) / p)) + n : a * Math.pow(2, -10 * (e -= 1)) * Math.sin((e * h - l) * (2 * Math.PI) / p) * 0.5 + s + n;
            },
            easeInBack: function(e, n, s, h, a) {
                return a === void 0 && (a = 1.70158), s * (e /= h) * e * ((a + 1) * e - a) + n;
            },
            easeOutBack: function(e, n, s, h, a) {
                return a === void 0 && (a = 1.70158), s * ((e = e / h - 1) * e * ((a + 1) * e + a) + 1) + n;
            },
            easeInOutBack: function(e, n, s, h, a) {
                return a === void 0 && (a = 1.70158), (e /= h / 2) < 1 ? s / 2 * (e * e * (((a *= 1.525) + 1) * e - a)) + n : s / 2 * ((e -= 2) * e * (((a *= 1.525) + 1) * e + a) + 2) + n;
            },
            easeInBounce: function(e, n, s, h) {
                var a;
                return a = t.easeOutBounce(h - e, 0, s, h), s - a + n;
            },
            easeOutBounce: function(e, n, s, h) {
                return (e /= h) < 1 / 2.75 ? s * (7.5625 * e * e) + n : e < 2 / 2.75 ? s * (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) + n : e < 2.5 / 2.75 ? s * (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) + n : s * (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375) + n;
            },
            easeInOutBounce: function(e, n, s, h) {
                var a;
                return e < h / 2 ? (a = t.easeInBounce(e * 2, 0, s, h), a * 0.5 + n) : (a = t.easeOutBounce(e * 2 - h, 0, s, h), a * 0.5 + s * 0.5 + n);
            }
        }, i(t);
    }).call($867beeb89be92199$var$C);
})($867beeb89be92199$var$H);
const $867beeb89be92199$var$b = $867beeb89be92199$var$H.exports;
function $867beeb89be92199$var$W(c, r) {
    if (c) {
        if (typeof c == "function") return c;
        if (typeof c == "string") return $867beeb89be92199$var$b[c];
    } else return $867beeb89be92199$var$b[r];
}
const $867beeb89be92199$var$I = {
    removeOnInterrupt: !1,
    ease: "linear",
    time: 1e3
};
class $867beeb89be92199$export$83a1293bbde53b95 extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "startX");
        $867beeb89be92199$var$o(this, "startY");
        $867beeb89be92199$var$o(this, "deltaX");
        $867beeb89be92199$var$o(this, "deltaY");
        $867beeb89be92199$var$o(this, "keepCenter");
        $867beeb89be92199$var$o(this, "startWidth", null);
        $867beeb89be92199$var$o(this, "startHeight", null);
        $867beeb89be92199$var$o(this, "deltaWidth", null);
        $867beeb89be92199$var$o(this, "deltaHeight", null);
        $867beeb89be92199$var$o(this, "width", null);
        $867beeb89be92199$var$o(this, "height", null);
        $867beeb89be92199$var$o(this, "time", 0);
        this.options = Object.assign({}, $867beeb89be92199$var$I, i), this.options.ease = $867beeb89be92199$var$W(this.options.ease), this.setupPosition(), this.setupZoom(), this.time = 0;
    }
    setupPosition() {
        typeof this.options.position < "u" ? (this.startX = this.parent.center.x, this.startY = this.parent.center.y, this.deltaX = this.options.position.x - this.parent.center.x, this.deltaY = this.options.position.y - this.parent.center.y, this.keepCenter = !1) : this.keepCenter = !0;
    }
    setupZoom() {
        this.width = null, this.height = null, typeof this.options.scale < "u" ? this.width = this.parent.screenWidth / this.options.scale : typeof this.options.scaleX < "u" || typeof this.options.scaleY < "u" ? (typeof this.options.scaleX < "u" && (this.width = this.parent.screenWidth / this.options.scaleX), typeof this.options.scaleY < "u" && (this.height = this.parent.screenHeight / this.options.scaleY)) : (typeof this.options.width < "u" && (this.width = this.options.width), typeof this.options.height < "u" && (this.height = this.options.height)), this.width !== null && (this.startWidth = this.parent.screenWidthInWorldPixels, this.deltaWidth = this.width - this.startWidth), this.height !== null && (this.startHeight = this.parent.screenHeightInWorldPixels, this.deltaHeight = this.height - this.startHeight);
    }
    down() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("animate"), !1;
    }
    complete() {
        this.parent.plugins.remove("animate"), this.width !== null && this.parent.fitWidth(this.width, this.keepCenter, this.height === null), this.height !== null && this.parent.fitHeight(this.height, this.keepCenter, this.width === null), !this.keepCenter && this.options.position && this.parent.moveCenter(this.options.position), this.parent.emit("animate-end", this.parent), this.options.callbackOnComplete && this.options.callbackOnComplete(this.parent);
    }
    update(t) {
        if (this.paused) return;
        this.time += t;
        const i = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.parent.scale.x, this.parent.scale.y);
        if (this.time >= this.options.time) {
            const e = this.parent.width, n = this.parent.height;
            this.complete(), (e !== this.parent.width || n !== this.parent.height) && this.parent.emit("zoomed", {
                viewport: this.parent,
                original: i,
                type: "animate"
            });
        } else {
            const e = this.options.ease(this.time, 0, 1, this.options.time);
            if (this.width !== null) {
                const n = this.startWidth, s = this.deltaWidth;
                this.parent.fitWidth(n + s * e, this.keepCenter, this.height === null);
            }
            if (this.height !== null) {
                const n = this.startHeight, s = this.deltaHeight;
                this.parent.fitHeight(n + s * e, this.keepCenter, this.width === null);
            }
            if (this.width === null ? this.parent.scale.x = this.parent.scale.y : this.height === null && (this.parent.scale.y = this.parent.scale.x), !this.keepCenter) {
                const n = this.startX, s = this.startY, h = this.deltaX, a = this.deltaY, p = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.parent.x, this.parent.y);
                this.parent.moveCenter(n + h * e, s + a * e), this.parent.emit("moved", {
                    viewport: this.parent,
                    original: p,
                    type: "animate"
                });
            }
            (this.width || this.height) && this.parent.emit("zoomed", {
                viewport: this.parent,
                original: i,
                type: "animate"
            });
        }
    }
}
const $867beeb89be92199$var$Y = {
    sides: "all",
    friction: 0.5,
    time: 150,
    ease: "easeInOutSine",
    underflow: "center",
    bounceBox: null
};
class $867beeb89be92199$export$d20e79fdc3899e95 extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "left");
        $867beeb89be92199$var$o(this, "top");
        $867beeb89be92199$var$o(this, "right");
        $867beeb89be92199$var$o(this, "bottom");
        $867beeb89be92199$var$o(this, "underflowX");
        $867beeb89be92199$var$o(this, "underflowY");
        $867beeb89be92199$var$o(this, "ease");
        $867beeb89be92199$var$o(this, "toX");
        $867beeb89be92199$var$o(this, "toY");
        this.options = Object.assign({}, $867beeb89be92199$var$Y, i), this.ease = $867beeb89be92199$var$W(this.options.ease, "easeInOutSine"), this.options.sides ? this.options.sides === "all" ? this.top = this.bottom = this.left = this.right = !0 : this.options.sides === "horizontal" ? (this.right = this.left = !0, this.top = this.bottom = !1) : this.options.sides === "vertical" ? (this.left = this.right = !1, this.top = this.bottom = !0) : (this.top = this.options.sides.indexOf("top") !== -1, this.bottom = this.options.sides.indexOf("bottom") !== -1, this.left = this.options.sides.indexOf("left") !== -1, this.right = this.options.sides.indexOf("right") !== -1) : this.left = this.top = this.right = this.bottom = !1;
        const e = this.options.underflow.toLowerCase();
        e === "center" ? (this.underflowX = 0, this.underflowY = 0) : (this.underflowX = e.indexOf("left") !== -1 ? -1 : e.indexOf("right") !== -1 ? 1 : 0, this.underflowY = e.indexOf("top") !== -1 ? -1 : e.indexOf("bottom") !== -1 ? 1 : 0), this.reset();
    }
    isActive() {
        return this.toX !== null || this.toY !== null;
    }
    down() {
        return this.toX = this.toY = null, !1;
    }
    up() {
        return this.bounce(), !1;
    }
    update(t) {
        if (!this.paused) {
            if (this.bounce(), this.toX) {
                const i = this.toX;
                i.time += t, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "bounce-x"
                }), i.time >= this.options.time ? (this.parent.x = i.end, this.toX = null, this.parent.emit("bounce-x-end", this.parent)) : this.parent.x = this.ease(i.time, i.start, i.delta, this.options.time);
            }
            if (this.toY) {
                const i = this.toY;
                i.time += t, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "bounce-y"
                }), i.time >= this.options.time ? (this.parent.y = i.end, this.toY = null, this.parent.emit("bounce-y-end", this.parent)) : this.parent.y = this.ease(i.time, i.start, i.delta, this.options.time);
            }
        }
    }
    calcUnderflowX() {
        let t;
        switch(this.underflowX){
            case -1:
                t = 0;
                break;
            case 1:
                t = this.parent.screenWidth - this.parent.screenWorldWidth;
                break;
            default:
                t = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
        }
        return t;
    }
    calcUnderflowY() {
        let t;
        switch(this.underflowY){
            case -1:
                t = 0;
                break;
            case 1:
                t = this.parent.screenHeight - this.parent.screenWorldHeight;
                break;
            default:
                t = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
        }
        return t;
    }
    oob() {
        const t = this.options.bounceBox;
        if (t) {
            const i = typeof t.x > "u" ? 0 : t.x, e = typeof t.y > "u" ? 0 : t.y, n = typeof t.width > "u" ? this.parent.worldWidth : t.width, s = typeof t.height > "u" ? this.parent.worldHeight : t.height;
            return {
                left: this.parent.left < i,
                right: this.parent.right > n,
                top: this.parent.top < e,
                bottom: this.parent.bottom > s,
                topLeft: new (0, $88931fa1c0809be8$export$baf26146a414f24a)(i * this.parent.scale.x, e * this.parent.scale.y),
                bottomRight: new (0, $88931fa1c0809be8$export$baf26146a414f24a)(n * this.parent.scale.x - this.parent.screenWidth, s * this.parent.scale.y - this.parent.screenHeight)
            };
        }
        return {
            left: this.parent.left < 0,
            right: this.parent.right > this.parent.worldWidth,
            top: this.parent.top < 0,
            bottom: this.parent.bottom > this.parent.worldHeight,
            topLeft: new (0, $88931fa1c0809be8$export$baf26146a414f24a)(0, 0),
            bottomRight: new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.parent.worldWidth * this.parent.scale.x - this.parent.screenWidth, this.parent.worldHeight * this.parent.scale.y - this.parent.screenHeight)
        };
    }
    bounce() {
        var s, h;
        if (this.paused) return;
        let t, i = this.parent.plugins.get("decelerate", !0);
        i && (i.x || i.y) && (i.x && i.percentChangeX === ((s = i.options) == null ? void 0 : s.friction) || i.y && i.percentChangeY === ((h = i.options) == null ? void 0 : h.friction)) && (t = this.oob(), (t.left && this.left || t.right && this.right) && (i.percentChangeX = this.options.friction), (t.top && this.top || t.bottom && this.bottom) && (i.percentChangeY = this.options.friction));
        const e = this.parent.plugins.get("drag", !0) || {}, n = this.parent.plugins.get("pinch", !0) || {};
        if (i = i || {}, !(e != null && e.active) && !(n != null && n.active) && (!this.toX || !this.toY) && (!i.x || !i.y)) {
            t = t || this.oob();
            const a = t.topLeft, p = t.bottomRight;
            if (!this.toX && !i.x) {
                let l = null;
                t.left && this.left ? l = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -a.x : t.right && this.right && (l = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -p.x), l !== null && this.parent.x !== l && (this.toX = {
                    time: 0,
                    start: this.parent.x,
                    delta: l - this.parent.x,
                    end: l
                }, this.parent.emit("bounce-x-start", this.parent));
            }
            if (!this.toY && !i.y) {
                let l = null;
                t.top && this.top ? l = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -a.y : t.bottom && this.bottom && (l = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -p.y), l !== null && this.parent.y !== l && (this.toY = {
                    time: 0,
                    start: this.parent.y,
                    delta: l - this.parent.y,
                    end: l
                }, this.parent.emit("bounce-y-start", this.parent));
            }
        }
    }
    reset() {
        this.toX = this.toY = null, this.bounce();
    }
}
const $867beeb89be92199$var$z = {
    left: !1,
    right: !1,
    top: !1,
    bottom: !1,
    direction: null,
    underflow: "center"
};
class $867beeb89be92199$export$90534cad35a14134 extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "last");
        $867beeb89be92199$var$o(this, "noUnderflow");
        $867beeb89be92199$var$o(this, "underflowX");
        $867beeb89be92199$var$o(this, "underflowY");
        this.options = Object.assign({}, $867beeb89be92199$var$z, i), this.options.direction && (this.options.left = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.right = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.top = this.options.direction === "y" || this.options.direction === "all" ? !0 : null, this.options.bottom = this.options.direction === "y" || this.options.direction === "all" ? !0 : null), this.parseUnderflow(), this.last = {
            x: null,
            y: null,
            scaleX: null,
            scaleY: null
        }, this.update();
    }
    parseUnderflow() {
        const t = this.options.underflow.toLowerCase();
        t === "none" ? this.noUnderflow = !0 : t === "center" ? (this.underflowX = this.underflowY = 0, this.noUnderflow = !1) : (this.underflowX = t.indexOf("left") !== -1 ? -1 : t.indexOf("right") !== -1 ? 1 : 0, this.underflowY = t.indexOf("top") !== -1 ? -1 : t.indexOf("bottom") !== -1 ? 1 : 0, this.noUnderflow = !1);
    }
    move() {
        return this.update(), !1;
    }
    update() {
        if (this.paused || this.parent.x === this.last.x && this.parent.y === this.last.y && this.parent.scale.x === this.last.scaleX && this.parent.scale.y === this.last.scaleY) return;
        const t = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.parent.x, this.parent.y), i = this.parent.plugins.decelerate || {};
        if (this.options.left !== null || this.options.right !== null) {
            let e = !1;
            if (!this.noUnderflow && this.parent.screenWorldWidth < this.parent.screenWidth) switch(this.underflowX){
                case -1:
                    this.parent.x !== 0 && (this.parent.x = 0, e = !0);
                    break;
                case 1:
                    this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth && (this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth, e = !0);
                    break;
                default:
                    this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2 && (this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2, e = !0);
            }
            else this.options.left !== null && this.parent.left < (this.options.left === !0 ? 0 : this.options.left) && (this.parent.x = -(this.options.left === !0 ? 0 : this.options.left) * this.parent.scale.x, i.x = 0, e = !0), this.options.right !== null && this.parent.right > (this.options.right === !0 ? this.parent.worldWidth : this.options.right) && (this.parent.x = -(this.options.right === !0 ? this.parent.worldWidth : this.options.right) * this.parent.scale.x + this.parent.screenWidth, i.x = 0, e = !0);
            e && this.parent.emit("moved", {
                viewport: this.parent,
                original: t,
                type: "clamp-x"
            });
        }
        if (this.options.top !== null || this.options.bottom !== null) {
            let e = !1;
            if (!this.noUnderflow && this.parent.screenWorldHeight < this.parent.screenHeight) switch(this.underflowY){
                case -1:
                    this.parent.y !== 0 && (this.parent.y = 0, e = !0);
                    break;
                case 1:
                    this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight && (this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight, e = !0);
                    break;
                default:
                    this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2 && (this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2, e = !0);
            }
            else this.options.top !== null && this.parent.top < (this.options.top === !0 ? 0 : this.options.top) && (this.parent.y = -(this.options.top === !0 ? 0 : this.options.top) * this.parent.scale.y, i.y = 0, e = !0), this.options.bottom !== null && this.parent.bottom > (this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) && (this.parent.y = -(this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) * this.parent.scale.y + this.parent.screenHeight, i.y = 0, e = !0);
            e && this.parent.emit("moved", {
                viewport: this.parent,
                original: t,
                type: "clamp-y"
            });
        }
        this.last.x = this.parent.x, this.last.y = this.parent.y, this.last.scaleX = this.parent.scale.x, this.last.scaleY = this.parent.scale.y;
    }
    reset() {
        this.update();
    }
}
const $867beeb89be92199$var$_ = {
    minWidth: null,
    minHeight: null,
    maxWidth: null,
    maxHeight: null,
    minScale: null,
    maxScale: null
};
class $867beeb89be92199$export$220d7a3461bca2df extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        this.options = Object.assign({}, $867beeb89be92199$var$_, i), this.clamp();
    }
    resize() {
        this.clamp();
    }
    clamp() {
        if (!this.paused) {
            if (this.options.minWidth || this.options.minHeight || this.options.maxWidth || this.options.maxHeight) {
                let t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight;
                if (this.options.minWidth !== null && t < this.options.minWidth) {
                    const e = this.parent.scale.x;
                    this.parent.fitWidth(this.options.minWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / e, t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.maxWidth !== null && t > this.options.maxWidth) {
                    const e = this.parent.scale.x;
                    this.parent.fitWidth(this.options.maxWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / e, t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.minHeight !== null && i < this.options.minHeight) {
                    const e = this.parent.scale.y;
                    this.parent.fitHeight(this.options.minHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / e, t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.maxHeight !== null && i > this.options.maxHeight) {
                    const e = this.parent.scale.y;
                    this.parent.fitHeight(this.options.maxHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / e, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
            } else if (this.options.minScale || this.options.maxScale) {
                const t = {
                    x: null,
                    y: null
                }, i = {
                    x: null,
                    y: null
                };
                if (typeof this.options.minScale == "number") t.x = this.options.minScale, t.y = this.options.minScale;
                else if (this.options.minScale !== null) {
                    const s = this.options.minScale;
                    t.x = typeof s.x > "u" ? null : s.x, t.y = typeof s.y > "u" ? null : s.y;
                }
                if (typeof this.options.maxScale == "number") i.x = this.options.maxScale, i.y = this.options.maxScale;
                else if (this.options.maxScale !== null) {
                    const s = this.options.maxScale;
                    i.x = typeof s.x > "u" ? null : s.x, i.y = typeof s.y > "u" ? null : s.y;
                }
                let e = this.parent.scale.x, n = this.parent.scale.y;
                t.x !== null && e < t.x && (e = t.x), i.x !== null && e > i.x && (e = i.x), t.y !== null && n < t.y && (n = t.y), i.y !== null && n > i.y && (n = i.y), (e !== this.parent.scale.x || n !== this.parent.scale.y) && (this.parent.scale.set(e, n), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "clamp-zoom"
                }));
            }
        }
    }
    reset() {
        this.clamp();
    }
}
const $867beeb89be92199$var$D = {
    friction: 0.98,
    bounce: 0.8,
    minSpeed: 0.01
}, $867beeb89be92199$var$g = 16;
class $867beeb89be92199$export$4bbb5144deae3118 extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "x");
        $867beeb89be92199$var$o(this, "y");
        $867beeb89be92199$var$o(this, "percentChangeX");
        $867beeb89be92199$var$o(this, "percentChangeY");
        $867beeb89be92199$var$o(this, "saved");
        $867beeb89be92199$var$o(this, "timeSinceRelease");
        this.options = Object.assign({}, $867beeb89be92199$var$D, i), this.saved = [], this.timeSinceRelease = 0, this.reset(), this.parent.on("moved", (e)=>this.handleMoved(e));
    }
    down() {
        return this.saved = [], this.x = this.y = null, !1;
    }
    isActive() {
        return !!(this.x || this.y);
    }
    move() {
        if (this.paused) return !1;
        const t = this.parent.input.count();
        return (t === 1 || t > 1 && !this.parent.plugins.get("pinch", !0)) && (this.saved.push({
            x: this.parent.x,
            y: this.parent.y,
            time: performance.now()
        }), this.saved.length > 60 && this.saved.splice(0, 30)), !1;
    }
    handleMoved(t) {
        if (this.saved.length) {
            const i = this.saved[this.saved.length - 1];
            t.type === "clamp-x" && t.original ? i.x === t.original.x && (i.x = this.parent.x) : t.type === "clamp-y" && t.original && i.y === t.original.y && (i.y = this.parent.y);
        }
    }
    up() {
        if (this.parent.input.count() === 0 && this.saved.length) {
            const t = performance.now();
            for (const i of this.saved)if (i.time >= t - 100) {
                const e = t - i.time;
                this.x = (this.parent.x - i.x) / e, this.y = (this.parent.y - i.y) / e, this.percentChangeX = this.percentChangeY = this.options.friction, this.timeSinceRelease = 0;
                break;
            }
        }
        return !1;
    }
    activate(t) {
        t = t || {}, typeof t.x < "u" && (this.x = t.x, this.percentChangeX = this.options.friction), typeof t.y < "u" && (this.y = t.y, this.percentChangeY = this.options.friction);
    }
    update(t) {
        if (this.paused) return;
        const i = this.x || this.y, e = this.timeSinceRelease, n = this.timeSinceRelease + t;
        if (this.x) {
            const s = this.percentChangeX, h = Math.log(s);
            this.parent.x += this.x * $867beeb89be92199$var$g / h * (Math.pow(s, n / $867beeb89be92199$var$g) - Math.pow(s, e / $867beeb89be92199$var$g)), this.x *= Math.pow(this.percentChangeX, t / $867beeb89be92199$var$g);
        }
        if (this.y) {
            const s = this.percentChangeY, h = Math.log(s);
            this.parent.y += this.y * $867beeb89be92199$var$g / h * (Math.pow(s, n / $867beeb89be92199$var$g) - Math.pow(s, e / $867beeb89be92199$var$g)), this.y *= Math.pow(this.percentChangeY, t / $867beeb89be92199$var$g);
        }
        this.timeSinceRelease += t, this.x && this.y ? Math.abs(this.x) < this.options.minSpeed && Math.abs(this.y) < this.options.minSpeed && (this.x = 0, this.y = 0) : (Math.abs(this.x || 0) < this.options.minSpeed && (this.x = 0), Math.abs(this.y || 0) < this.options.minSpeed && (this.y = 0)), i && this.parent.emit("moved", {
            viewport: this.parent,
            type: "decelerate"
        });
    }
    reset() {
        this.x = this.y = null;
    }
}
const $867beeb89be92199$var$L = {
    direction: "all",
    pressDrag: !0,
    wheel: !0,
    wheelScroll: 1,
    reverse: !1,
    clampWheel: !1,
    underflow: "center",
    factor: 1,
    mouseButtons: "all",
    keyToPress: null,
    ignoreKeyToPressOnTouch: !1,
    lineHeight: 20,
    wheelSwapAxes: !1
};
class $867beeb89be92199$export$b48985bba8f530f5 extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "moved");
        $867beeb89be92199$var$o(this, "reverse");
        $867beeb89be92199$var$o(this, "xDirection");
        $867beeb89be92199$var$o(this, "yDirection");
        $867beeb89be92199$var$o(this, "keyIsPressed");
        $867beeb89be92199$var$o(this, "mouse");
        $867beeb89be92199$var$o(this, "underflowX");
        $867beeb89be92199$var$o(this, "underflowY");
        $867beeb89be92199$var$o(this, "last");
        $867beeb89be92199$var$o(this, "current");
        $867beeb89be92199$var$o(this, "windowEventHandlers", []);
        this.options = Object.assign({}, $867beeb89be92199$var$L, i), this.moved = !1, this.reverse = this.options.reverse ? 1 : -1, this.xDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "x", this.yDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "y", this.keyIsPressed = !1, this.parseUnderflow(), this.mouseButtons(this.options.mouseButtons), this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
    }
    handleKeyPresses(t) {
        const i = (n)=>{
            t.includes(n.code) && (this.keyIsPressed = !0);
        }, e = (n)=>{
            t.includes(n.code) && (this.keyIsPressed = !1);
        };
        this.addWindowEventHandler("keyup", e), this.addWindowEventHandler("keydown", i);
    }
    addWindowEventHandler(t, i) {
        window.addEventListener(t, i), this.windowEventHandlers.push({
            event: t,
            handler: i
        });
    }
    destroy() {
        this.windowEventHandlers.forEach(({ event: t , handler: i  })=>{
            window.removeEventListener(t, i);
        });
    }
    mouseButtons(t) {
        !t || t === "all" ? this.mouse = [
            !0,
            !0,
            !0
        ] : this.mouse = [
            t.indexOf("left") !== -1,
            t.indexOf("middle") !== -1,
            t.indexOf("right") !== -1
        ];
    }
    parseUnderflow() {
        const t = this.options.underflow.toLowerCase();
        t === "center" ? (this.underflowX = 0, this.underflowY = 0) : (t.includes("left") ? this.underflowX = -1 : t.includes("right") ? this.underflowX = 1 : this.underflowX = 0, t.includes("top") ? this.underflowY = -1 : t.includes("bottom") ? this.underflowY = 1 : this.underflowY = 0);
    }
    checkButtons(t) {
        const i = t.pointerType === "mouse", e = this.parent.input.count();
        return !!((e === 1 || e > 1 && !this.parent.plugins.get("pinch", !0)) && (!i || this.mouse[t.button]));
    }
    checkKeyPress(t) {
        return !this.options.keyToPress || this.keyIsPressed || this.options.ignoreKeyToPressOnTouch && t.data.pointerType === "touch";
    }
    down(t) {
        return this.paused || !this.options.pressDrag ? !1 : this.checkButtons(t) && this.checkKeyPress(t) ? (this.last = {
            x: t.global.x,
            y: t.global.y
        }, this.current = t.pointerId, !0) : (this.last = null, !1);
    }
    get active() {
        return this.moved;
    }
    move(t) {
        if (this.paused || !this.options.pressDrag) return !1;
        if (this.last && this.current === t.data.pointerId) {
            const i = t.global.x, e = t.global.y, n = this.parent.input.count();
            if (n === 1 || n > 1 && !this.parent.plugins.get("pinch", !0)) {
                const s = i - this.last.x, h = e - this.last.y;
                if (this.moved || this.xDirection && this.parent.input.checkThreshold(s) || this.yDirection && this.parent.input.checkThreshold(h)) {
                    const a = {
                        x: i,
                        y: e
                    };
                    return this.xDirection && (this.parent.x += (a.x - this.last.x) * this.options.factor), this.yDirection && (this.parent.y += (a.y - this.last.y) * this.options.factor), this.last = a, this.moved || this.parent.emit("drag-start", {
                        event: t,
                        screen: new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.last.x, this.last.y),
                        world: this.parent.toWorld(new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.last.x, this.last.y)),
                        viewport: this.parent
                    }), this.moved = !0, this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "drag"
                    }), !0;
                }
            } else this.moved = !1;
        }
        return !1;
    }
    up(t) {
        if (this.paused) return !1;
        const i = this.parent.input.touches;
        if (i.length === 1) {
            const e = i[0];
            return e.last && (this.last = {
                x: e.last.x,
                y: e.last.y
            }, this.current = e.id), this.moved = !1, !0;
        } else if (this.last && this.moved) {
            const e = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.last.x, this.last.y);
            return this.parent.emit("drag-end", {
                event: t,
                screen: e,
                world: this.parent.toWorld(e),
                viewport: this.parent
            }), this.last = null, this.moved = !1, !0;
        }
        return !1;
    }
    wheel(t) {
        if (this.paused) return !1;
        if (this.options.wheel) {
            const i = this.parent.plugins.get("wheel", !0);
            if (!i || !i.options.wheelZoom && !t.ctrlKey) {
                const e = t.deltaMode ? this.options.lineHeight : 1, n = [
                    t.deltaX,
                    t.deltaY
                ], [s, h] = this.options.wheelSwapAxes ? n.reverse() : n;
                return this.xDirection && (this.parent.x += s * e * this.options.wheelScroll * this.reverse), this.yDirection && (this.parent.y += h * e * this.options.wheelScroll * this.reverse), this.options.clampWheel && this.clamp(), this.parent.emit("wheel-scroll", this.parent), this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "wheel"
                }), this.parent.options.passiveWheel || t.preventDefault(), this.parent.options.stopPropagation && t.stopPropagation(), !0;
            }
        }
        return !1;
    }
    resume() {
        this.last = null, this.paused = !1;
    }
    clamp() {
        const t = this.parent.plugins.get("decelerate", !0) || {};
        if (this.options.clampWheel !== "y") {
            if (this.parent.screenWorldWidth < this.parent.screenWidth) switch(this.underflowX){
                case -1:
                    this.parent.x = 0;
                    break;
                case 1:
                    this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
                    break;
                default:
                    this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
            }
            else this.parent.left < 0 ? (this.parent.x = 0, t.x = 0) : this.parent.right > this.parent.worldWidth && (this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth, t.x = 0);
        }
        if (this.options.clampWheel !== "x") {
            if (this.parent.screenWorldHeight < this.parent.screenHeight) switch(this.underflowY){
                case -1:
                    this.parent.y = 0;
                    break;
                case 1:
                    this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
                    break;
                default:
                    this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
            }
            else this.parent.top < 0 && (this.parent.y = 0, t.y = 0), this.parent.bottom > this.parent.worldHeight && (this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight, t.y = 0);
        }
    }
}
const $867beeb89be92199$var$V = {
    speed: 0,
    acceleration: null,
    radius: null
};
class $867beeb89be92199$export$455f05776f1ba8ba extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i, e = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "target");
        $867beeb89be92199$var$o(this, "velocity");
        this.target = i, this.options = Object.assign({}, $867beeb89be92199$var$V, e), this.velocity = {
            x: 0,
            y: 0
        };
    }
    update(t) {
        if (this.paused) return;
        const i = this.parent.center;
        let e = this.target.x, n = this.target.y;
        if (this.options.radius) {
            if (Math.sqrt(Math.pow(this.target.y - i.y, 2) + Math.pow(this.target.x - i.x, 2)) > this.options.radius) {
                const p = Math.atan2(this.target.y - i.y, this.target.x - i.x);
                e = this.target.x - Math.cos(p) * this.options.radius, n = this.target.y - Math.sin(p) * this.options.radius;
            } else return;
        }
        const s = e - i.x, h = n - i.y;
        if (s || h) {
            if (this.options.speed) {
                if (this.options.acceleration) {
                    const a = Math.atan2(n - i.y, e - i.x), p = Math.sqrt(Math.pow(s, 2) + Math.pow(h, 2));
                    if (p) {
                        const l = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.options.acceleration);
                        p > l ? this.velocity = {
                            x: Math.min(this.velocity.x + (this.options.acceleration * t, this.options.speed)),
                            y: Math.min(this.velocity.y + (this.options.acceleration * t, this.options.speed))
                        } : this.velocity = {
                            x: Math.max(this.velocity.x - this.options.acceleration * this.options.speed, 0),
                            y: Math.max(this.velocity.y - this.options.acceleration * this.options.speed, 0)
                        };
                        const d = Math.cos(a) * this.velocity.x, m = Math.sin(a) * this.velocity.y, y = Math.abs(d) > Math.abs(s) ? e : i.x + d, x = Math.abs(m) > Math.abs(h) ? n : i.y + m;
                        this.parent.moveCenter(y, x), this.parent.emit("moved", {
                            viewport: this.parent,
                            type: "follow"
                        });
                    }
                } else {
                    const a = Math.atan2(n - i.y, e - i.x), p = Math.cos(a) * this.options.speed, l = Math.sin(a) * this.options.speed, d = Math.abs(p) > Math.abs(s) ? e : i.x + p, m = Math.abs(l) > Math.abs(h) ? n : i.y + l;
                    this.parent.moveCenter(d, m), this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "follow"
                    });
                }
            } else this.parent.moveCenter(e, n), this.parent.emit("moved", {
                viewport: this.parent,
                type: "follow"
            });
        }
    }
}
const $867beeb89be92199$var$B = {
    radius: null,
    distance: null,
    top: null,
    bottom: null,
    left: null,
    right: null,
    speed: 8,
    reverse: !1,
    noDecelerate: !1,
    linear: !1,
    allowButtons: !1
};
class $867beeb89be92199$export$dd505d2e20e3eaaf extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "reverse");
        $867beeb89be92199$var$o(this, "radiusSquared");
        $867beeb89be92199$var$o(this, "left");
        $867beeb89be92199$var$o(this, "top");
        $867beeb89be92199$var$o(this, "right");
        $867beeb89be92199$var$o(this, "bottom");
        $867beeb89be92199$var$o(this, "horizontal");
        $867beeb89be92199$var$o(this, "vertical");
        this.options = Object.assign({}, $867beeb89be92199$var$B, i), this.reverse = this.options.reverse ? 1 : -1, this.radiusSquared = typeof this.options.radius == "number" ? Math.pow(this.options.radius, 2) : null, this.resize();
    }
    resize() {
        const t = this.options.distance;
        t !== null ? (this.left = t, this.top = t, this.right = this.parent.screenWidth - t, this.bottom = this.parent.screenHeight - t) : this.options.radius || (this.left = this.options.left, this.top = this.options.top, this.right = this.options.right === null ? null : this.parent.screenWidth - this.options.right, this.bottom = this.options.bottom === null ? null : this.parent.screenHeight - this.options.bottom);
    }
    down() {
        return this.paused || this.options.allowButtons || (this.horizontal = this.vertical = null), !1;
    }
    move(t) {
        if (this.paused || t.pointerType !== "mouse" && t.pointerId !== 1 || !this.options.allowButtons && t.buttons !== 0) return !1;
        const i = t.global.x, e = t.global.y;
        if (this.radiusSquared) {
            const n = this.parent.toScreen(this.parent.center);
            if (Math.pow(n.x - i, 2) + Math.pow(n.y - e, 2) >= this.radiusSquared) {
                const h = Math.atan2(n.y - e, n.x - i);
                this.options.linear ? (this.horizontal = Math.round(Math.cos(h)) * this.options.speed * this.reverse * 0.06, this.vertical = Math.round(Math.sin(h)) * this.options.speed * this.reverse * 0.06) : (this.horizontal = Math.cos(h) * this.options.speed * this.reverse * 0.06, this.vertical = Math.sin(h) * this.options.speed * this.reverse * 0.06);
            } else this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = 0;
        } else this.left !== null && i < this.left ? this.horizontal = Number(this.reverse) * this.options.speed * 0.06 : this.right !== null && i > this.right ? this.horizontal = -1 * this.reverse * this.options.speed * 0.06 : (this.decelerateHorizontal(), this.horizontal = 0), this.top !== null && e < this.top ? this.vertical = Number(this.reverse) * this.options.speed * 0.06 : this.bottom !== null && e > this.bottom ? this.vertical = -1 * this.reverse * this.options.speed * 0.06 : (this.decelerateVertical(), this.vertical = 0);
        return !1;
    }
    decelerateHorizontal() {
        const t = this.parent.plugins.get("decelerate", !0);
        this.horizontal && t && !this.options.noDecelerate && t.activate({
            x: this.horizontal * this.options.speed * this.reverse / (1e3 / 60)
        });
    }
    decelerateVertical() {
        const t = this.parent.plugins.get("decelerate", !0);
        this.vertical && t && !this.options.noDecelerate && t.activate({
            y: this.vertical * this.options.speed * this.reverse / (1e3 / 60)
        });
    }
    up() {
        return this.paused || (this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = null), !1;
    }
    update() {
        if (!this.paused && (this.horizontal || this.vertical)) {
            const t = this.parent.center;
            this.horizontal && (t.x += this.horizontal * this.options.speed), this.vertical && (t.y += this.vertical * this.options.speed), this.parent.moveCenter(t), this.parent.emit("moved", {
                viewport: this.parent,
                type: "mouse-edges"
            });
        }
    }
}
const $867beeb89be92199$var$Z = {
    noDrag: !1,
    percent: 1,
    center: null,
    factor: 1,
    axis: "all"
};
class $867beeb89be92199$export$826ae541ddf1527b extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "active", !1);
        $867beeb89be92199$var$o(this, "pinching", !1);
        $867beeb89be92199$var$o(this, "moved", !1);
        $867beeb89be92199$var$o(this, "lastCenter");
        this.options = Object.assign({}, $867beeb89be92199$var$Z, i);
    }
    down() {
        return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
    }
    isAxisX() {
        return [
            "all",
            "x"
        ].includes(this.options.axis);
    }
    isAxisY() {
        return [
            "all",
            "y"
        ].includes(this.options.axis);
    }
    move(t) {
        if (this.paused || !this.active) return !1;
        const i = t.global.x, e = t.global.y, n = this.parent.input.touches;
        if (n.length >= 2) {
            const s = n[0], h = n[1], a = s.last && h.last ? Math.sqrt(Math.pow(h.last.x - s.last.x, 2) + Math.pow(h.last.y - s.last.y, 2)) : null;
            if (s.id === t.pointerId ? s.last = {
                x: i,
                y: e,
                data: t
            } : h.id === t.pointerId && (h.last = {
                x: i,
                y: e,
                data: t
            }), a) {
                let p;
                const l = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(s.last.x + (h.last.x - s.last.x) / 2, s.last.y + (h.last.y - s.last.y) / 2);
                this.options.center || (p = this.parent.toLocal(l));
                let d = Math.sqrt(Math.pow(h.last.x - s.last.x, 2) + Math.pow(h.last.y - s.last.y, 2));
                d = d === 0 ? d = 1e-10 : d;
                const m = (1 - a / d) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
                this.isAxisX() && (this.parent.scale.x += m), this.isAxisY() && (this.parent.scale.y += m), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "pinch",
                    center: l
                });
                const y = this.parent.plugins.get("clamp-zoom", !0);
                if (y && y.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
                else {
                    const x = this.parent.toGlobal(p);
                    this.parent.x += (l.x - x.x) * this.options.factor, this.parent.y += (l.y - x.y) * this.options.factor, this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "pinch"
                    });
                }
                !this.options.noDrag && this.lastCenter && (this.parent.x += (l.x - this.lastCenter.x) * this.options.factor, this.parent.y += (l.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "pinch"
                })), this.lastCenter = l, this.moved = !0;
            } else this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
            return !0;
        }
        return !1;
    }
    up() {
        return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = null, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
    }
}
const $867beeb89be92199$var$j = {
    topLeft: !1,
    friction: 0.8,
    time: 1e3,
    ease: "easeInOutSine",
    interrupt: !0,
    removeOnComplete: !1,
    removeOnInterrupt: !1,
    forceStart: !1
};
class $867beeb89be92199$export$4dbf1f67c012298b extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i, e, n = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "ease");
        $867beeb89be92199$var$o(this, "x");
        $867beeb89be92199$var$o(this, "y");
        $867beeb89be92199$var$o(this, "percent");
        $867beeb89be92199$var$o(this, "snapping");
        $867beeb89be92199$var$o(this, "deltaX");
        $867beeb89be92199$var$o(this, "deltaY");
        $867beeb89be92199$var$o(this, "startX");
        $867beeb89be92199$var$o(this, "startY");
        this.options = Object.assign({}, $867beeb89be92199$var$j, n), this.ease = $867beeb89be92199$var$W(n.ease, "easeInOutSine"), this.x = i, this.y = e, this.options.forceStart && this.snapStart();
    }
    snapStart() {
        this.percent = 0, this.snapping = {
            time: 0
        };
        const t = this.options.topLeft ? this.parent.corner : this.parent.center;
        this.deltaX = this.x - t.x, this.deltaY = this.y - t.y, this.startX = t.x, this.startY = t.y, this.parent.emit("snap-start", this.parent);
    }
    wheel() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("snap"), !1;
    }
    down() {
        return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap") : this.options.interrupt && (this.snapping = null), !1;
    }
    up() {
        if (this.parent.input.count() === 0) {
            const t = this.parent.plugins.get("decelerate", !0);
            t && (t.x || t.y) && (t.percentChangeX = t.percentChangeY = this.options.friction);
        }
        return !1;
    }
    update(t) {
        if (!this.paused && !(this.options.interrupt && this.parent.input.count() !== 0)) {
            if (this.snapping) {
                const i = this.snapping;
                i.time += t;
                let e, n, s;
                const h = this.startX, a = this.startY, p = this.deltaX, l = this.deltaY;
                if (i.time > this.options.time) e = !0, n = h + p, s = a + l;
                else {
                    const d = this.ease(i.time, 0, 1, this.options.time);
                    n = h + p * d, s = a + l * d;
                }
                this.options.topLeft ? this.parent.moveCorner(n, s) : this.parent.moveCenter(n, s), this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "snap"
                }), e && (this.options.removeOnComplete && this.parent.plugins.remove("snap"), this.parent.emit("snap-end", this.parent), this.snapping = null);
            } else {
                const i = this.options.topLeft ? this.parent.corner : this.parent.center;
                (i.x !== this.x || i.y !== this.y) && this.snapStart();
            }
        }
    }
}
const $867beeb89be92199$var$K = {
    width: 0,
    height: 0,
    time: 1e3,
    ease: "easeInOutSine",
    center: null,
    interrupt: !0,
    removeOnComplete: !1,
    removeOnInterrupt: !1,
    forceStart: !1,
    noMove: !1
};
class $867beeb89be92199$export$8d3b89b6e4db7cd0 extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "ease");
        $867beeb89be92199$var$o(this, "xScale");
        $867beeb89be92199$var$o(this, "yScale");
        $867beeb89be92199$var$o(this, "xIndependent");
        $867beeb89be92199$var$o(this, "yIndependent");
        $867beeb89be92199$var$o(this, "snapping");
        this.options = Object.assign({}, $867beeb89be92199$var$K, i), this.ease = $867beeb89be92199$var$W(this.options.ease), this.xIndependent = !1, this.yIndependent = !1, this.xScale = 0, this.yScale = 0, this.options.width > 0 && (this.xScale = t.screenWidth / this.options.width, this.xIndependent = !0), this.options.height > 0 && (this.yScale = t.screenHeight / this.options.height, this.yIndependent = !0), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale, this.options.time === 0 ? (t.container.scale.x = this.xScale, t.container.scale.y = this.yScale, this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom")) : i.forceStart && this.createSnapping();
    }
    createSnapping() {
        const t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, e = this.parent.screenWidth / this.xScale, n = this.parent.screenHeight / this.yScale;
        this.snapping = {
            time: 0,
            startX: t,
            startY: i,
            deltaX: e - t,
            deltaY: n - i
        }, this.parent.emit("snap-zoom-start", this.parent);
    }
    resize() {
        this.snapping = null, this.options.width > 0 && (this.xScale = this.parent.screenWidth / this.options.width), this.options.height > 0 && (this.yScale = this.parent.screenHeight / this.options.height), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale;
    }
    wheel() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("snap-zoom"), !1;
    }
    down() {
        return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap-zoom") : this.options.interrupt && (this.snapping = null), !1;
    }
    update(t) {
        if (this.paused || this.options.interrupt && this.parent.input.count() !== 0) return;
        let i;
        if (!this.options.center && !this.options.noMove && (i = this.parent.center), !this.snapping) (this.parent.scale.x !== this.xScale || this.parent.scale.y !== this.yScale) && this.createSnapping();
        else if (this.snapping) {
            const e = this.snapping;
            if (e.time += t, e.time >= this.options.time) this.parent.scale.set(this.xScale, this.yScale), this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom"), this.parent.emit("snap-zoom-end", this.parent), this.snapping = null;
            else {
                const s = this.snapping, h = this.ease(s.time, s.startX, s.deltaX, this.options.time), a = this.ease(s.time, s.startY, s.deltaY, this.options.time);
                this.parent.scale.x = this.parent.screenWidth / h, this.parent.scale.y = this.parent.screenHeight / a;
            }
            const n = this.parent.plugins.get("clamp-zoom", !0);
            n && n.clamp(), this.options.noMove || (this.options.center ? this.parent.moveCenter(this.options.center) : this.parent.moveCenter(i));
        }
    }
    resume() {
        this.snapping = null, super.resume();
    }
}
const $867beeb89be92199$var$Q = {
    percent: 0.1,
    smooth: !1,
    interrupt: !0,
    reverse: !1,
    center: null,
    lineHeight: 20,
    axis: "all",
    keyToPress: null,
    trackpadPinch: !1,
    wheelZoom: !0
};
class $867beeb89be92199$export$ae16e1bcb40d6793 extends $867beeb89be92199$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "smoothing");
        $867beeb89be92199$var$o(this, "smoothingCenter");
        $867beeb89be92199$var$o(this, "smoothingCount");
        $867beeb89be92199$var$o(this, "keyIsPressed");
        this.options = Object.assign({}, $867beeb89be92199$var$Q, i), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
    }
    handleKeyPresses(t) {
        window.addEventListener("keydown", (i)=>{
            t.includes(i.code) && (this.keyIsPressed = !0);
        }), window.addEventListener("keyup", (i)=>{
            t.includes(i.code) && (this.keyIsPressed = !1);
        });
    }
    checkKeyPress() {
        return !this.options.keyToPress || this.keyIsPressed;
    }
    down() {
        return this.options.interrupt && (this.smoothing = null), !1;
    }
    isAxisX() {
        return [
            "all",
            "x"
        ].includes(this.options.axis);
    }
    isAxisY() {
        return [
            "all",
            "y"
        ].includes(this.options.axis);
    }
    update() {
        if (this.smoothing) {
            const t = this.smoothingCenter, i = this.smoothing;
            let e;
            this.options.center || (e = this.parent.toLocal(t)), this.isAxisX() && (this.parent.scale.x += i.x), this.isAxisY() && (this.parent.scale.y += i.y), this.parent.emit("zoomed", {
                viewport: this.parent,
                type: "wheel"
            });
            const n = this.parent.plugins.get("clamp-zoom", !0);
            if (n && n.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
            else {
                const s = this.parent.toGlobal(e);
                this.parent.x += t.x - s.x, this.parent.y += t.y - s.y;
            }
            this.parent.emit("moved", {
                viewport: this.parent,
                type: "wheel"
            }), this.smoothingCount++, this.smoothingCount >= this.options.smooth && (this.smoothing = null);
        }
    }
    pinch(t) {
        if (this.paused) return;
        const i = this.parent.input.getPointerPosition(t), e = -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 200, n = Math.pow(2, (1 + this.options.percent) * e);
        let s;
        this.options.center || (s = this.parent.toLocal(i)), this.isAxisX() && (this.parent.scale.x *= n), this.isAxisY() && (this.parent.scale.y *= n), this.parent.emit("zoomed", {
            viewport: this.parent,
            type: "wheel"
        });
        const h = this.parent.plugins.get("clamp-zoom", !0);
        if (h && h.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
        else {
            const a = this.parent.toGlobal(s);
            this.parent.x += i.x - a.x, this.parent.y += i.y - a.y;
        }
        this.parent.emit("moved", {
            viewport: this.parent,
            type: "wheel"
        }), this.parent.emit("wheel-start", {
            event: t,
            viewport: this.parent
        });
    }
    wheel(t) {
        if (this.paused || !this.checkKeyPress()) return !1;
        if (t.ctrlKey && this.options.trackpadPinch) this.pinch(t);
        else if (this.options.wheelZoom) {
            const i = this.parent.input.getPointerPosition(t), n = (this.options.reverse ? -1 : 1) * -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 500, s = Math.pow(2, (1 + this.options.percent) * n);
            if (this.options.smooth) {
                const h = {
                    x: this.smoothing ? this.smoothing.x * (this.options.smooth - this.smoothingCount) : 0,
                    y: this.smoothing ? this.smoothing.y * (this.options.smooth - this.smoothingCount) : 0
                };
                this.smoothing = {
                    x: ((this.parent.scale.x + h.x) * s - this.parent.scale.x) / this.options.smooth,
                    y: ((this.parent.scale.y + h.y) * s - this.parent.scale.y) / this.options.smooth
                }, this.smoothingCount = 0, this.smoothingCenter = i;
            } else {
                let h;
                this.options.center || (h = this.parent.toLocal(i)), this.isAxisX() && (this.parent.scale.x *= s), this.isAxisY() && (this.parent.scale.y *= s), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "wheel"
                });
                const a = this.parent.plugins.get("clamp-zoom", !0);
                if (a && a.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
                else {
                    const p = this.parent.toGlobal(h);
                    this.parent.x += i.x - p.x, this.parent.y += i.y - p.y;
                }
            }
            this.parent.emit("moved", {
                viewport: this.parent,
                type: "wheel"
            }), this.parent.emit("wheel-start", {
                event: t,
                viewport: this.parent
            });
        }
        return !this.parent.options.passiveWheel;
    }
}
class $867beeb89be92199$export$2da2653229140a6c {
    constructor(r){
        $867beeb89be92199$var$o(this, "viewport");
        $867beeb89be92199$var$o(this, "clickedAvailable");
        $867beeb89be92199$var$o(this, "isMouseDown");
        $867beeb89be92199$var$o(this, "last");
        $867beeb89be92199$var$o(this, "wheelFunction");
        $867beeb89be92199$var$o(this, "touches");
        this.viewport = r, this.touches = [], this.addListeners();
    }
    addListeners() {
        this.viewport.interactive = !0, this.viewport.forceHitArea || (this.viewport.hitArea = new (0, $340a428aa13511cc$export$4617fb02663045ef)(0, 0, this.viewport.worldWidth, this.viewport.worldHeight)), this.viewport.on("pointerdown", this.down, this), this.viewport.options.allowPreserveDragOutside ? this.viewport.on("globalpointermove", this.move, this) : this.viewport.on("pointermove", this.move, this), this.viewport.on("pointerup", this.up, this), this.viewport.on("pointerupoutside", this.up, this), this.viewport.on("pointercancel", this.up, this), this.viewport.options.allowPreserveDragOutside || this.viewport.on("pointerleave", this.up, this), this.wheelFunction = (r)=>this.handleWheel(r), this.viewport.options.events.domElement.addEventListener("wheel", this.wheelFunction, {
            passive: this.viewport.options.passiveWheel
        }), this.isMouseDown = !1;
    }
    destroy() {
        this.viewport.options.events.domElement.removeEventListener("wheel", this.wheelFunction);
    }
    down(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        if (r.pointerType === "mouse" ? this.isMouseDown = !0 : this.get(r.pointerId) || this.touches.push({
            id: r.pointerId,
            last: null
        }), this.count() === 1) {
            this.last = r.global.clone();
            const i = this.viewport.plugins.get("decelerate", !0), e = this.viewport.plugins.get("bounce", !0);
            (!i || !i.isActive()) && (!e || !e.isActive()) ? this.clickedAvailable = !0 : this.clickedAvailable = !1;
        } else this.clickedAvailable = !1;
        this.viewport.plugins.down(r) && this.viewport.options.stopPropagation && r.stopPropagation();
    }
    clear() {
        this.isMouseDown = !1, this.touches = [], this.last = null;
    }
    checkThreshold(r) {
        return Math.abs(r) >= this.viewport.threshold;
    }
    move(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        const t = this.viewport.plugins.move(r);
        if (this.clickedAvailable && this.last) {
            const i = r.global.x - this.last.x, e = r.global.y - this.last.y;
            (this.checkThreshold(i) || this.checkThreshold(e)) && (this.clickedAvailable = !1);
        }
        t && this.viewport.options.stopPropagation && r.stopPropagation();
    }
    up(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        r.pointerType === "mouse" && (this.isMouseDown = !1), r.pointerType !== "mouse" && this.remove(r.pointerId);
        const t = this.viewport.plugins.up(r);
        this.clickedAvailable && this.count() === 0 && this.last && (this.viewport.emit("clicked", {
            event: r,
            screen: this.last,
            world: this.viewport.toWorld(this.last),
            viewport: this.viewport
        }), this.clickedAvailable = !1), t && this.viewport.options.stopPropagation && r.stopPropagation();
    }
    getPointerPosition(r) {
        const t = new (0, $88931fa1c0809be8$export$baf26146a414f24a)();
        return this.viewport.options.events.mapPositionToPoint(t, r.clientX, r.clientY), t;
    }
    handleWheel(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        const t = this.viewport.toLocal(this.getPointerPosition(r));
        this.viewport.left <= t.x && t.x <= this.viewport.right && this.viewport.top <= t.y && t.y <= this.viewport.bottom && this.viewport.plugins.wheel(r) && !this.viewport.options.passiveWheel && r.preventDefault();
    }
    pause() {
        this.touches = [], this.isMouseDown = !1;
    }
    get(r) {
        for (const t of this.touches)if (t.id === r) return t;
        return null;
    }
    remove(r) {
        for(let t = 0; t < this.touches.length; t++)if (this.touches[t].id === r) {
            this.touches.splice(t, 1);
            return;
        }
    }
    count() {
        return (this.isMouseDown ? 1 : 0) + this.touches.length;
    }
}
const $867beeb89be92199$var$w = [
    "drag",
    "pinch",
    "wheel",
    "follow",
    "mouse-edges",
    "decelerate",
    "animate",
    "bounce",
    "snap-zoom",
    "clamp-zoom",
    "snap",
    "clamp"
];
class $867beeb89be92199$export$f2c0a16002429d72 {
    constructor(r){
        $867beeb89be92199$var$o(this, "plugins");
        $867beeb89be92199$var$o(this, "list");
        $867beeb89be92199$var$o(this, "viewport");
        this.viewport = r, this.list = [], this.plugins = {};
    }
    add(r, t, i = $867beeb89be92199$var$w.length) {
        const e = this.plugins[r];
        e && e.destroy(), this.plugins[r] = t;
        const n = $867beeb89be92199$var$w.indexOf(r);
        n !== -1 && $867beeb89be92199$var$w.splice(n, 1), $867beeb89be92199$var$w.splice(i, 0, r), this.sort();
    }
    get(r, t) {
        var i;
        return t && (i = this.plugins[r]) != null && i.paused ? null : this.plugins[r];
    }
    update(r) {
        for (const t of this.list)t.update(r);
    }
    resize() {
        for (const r of this.list)r.resize();
    }
    reset() {
        for (const r of this.list)r.reset();
    }
    removeAll() {
        this.list.forEach((r)=>{
            r.destroy();
        }), this.plugins = {}, this.sort();
    }
    remove(r) {
        var t;
        this.plugins[r] && ((t = this.plugins[r]) == null || t.destroy(), delete this.plugins[r], this.viewport.emit("plugin-remove", r), this.sort());
    }
    pause(r) {
        var t;
        (t = this.plugins[r]) == null || t.pause();
    }
    resume(r) {
        var t;
        (t = this.plugins[r]) == null || t.resume();
    }
    sort() {
        this.list = [];
        for (const r of $867beeb89be92199$var$w)this.plugins[r] && this.list.push(this.plugins[r]);
    }
    down(r) {
        let t = !1;
        for (const i of this.list)i.down(r) && (t = !0);
        return t;
    }
    move(r) {
        let t = !1;
        for (const i of this.viewport.plugins.list)i.move(r) && (t = !0);
        return t;
    }
    up(r) {
        let t = !1;
        for (const i of this.list)i.up(r) && (t = !0);
        return t;
    }
    wheel(r) {
        let t = !1;
        for (const i of this.list)i.wheel(r) && (t = !0);
        return t;
    }
}
const $867beeb89be92199$var$et = {
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    worldWidth: null,
    worldHeight: null,
    threshold: 5,
    passiveWheel: !0,
    stopPropagation: !1,
    forceHitArea: null,
    noTicker: !1,
    disableOnContextMenu: !1,
    ticker: (0, $ad2665272528cf94$export$39c54bcc89dcee11).shared,
    allowPreserveDragOutside: !1
};
class $867beeb89be92199$export$d5c6c08dc2d3ca7 extends (0, $823fbc2c4ae841df$export$42a852a2b6b56249) {
    constructor(t){
        super();
        $867beeb89be92199$var$o(this, "moving");
        $867beeb89be92199$var$o(this, "screenWidth");
        $867beeb89be92199$var$o(this, "screenHeight");
        $867beeb89be92199$var$o(this, "threshold");
        $867beeb89be92199$var$o(this, "input");
        $867beeb89be92199$var$o(this, "plugins");
        $867beeb89be92199$var$o(this, "zooming");
        $867beeb89be92199$var$o(this, "lastViewport");
        $867beeb89be92199$var$o(this, "options");
        $867beeb89be92199$var$o(this, "_dirty");
        $867beeb89be92199$var$o(this, "_forceHitArea");
        $867beeb89be92199$var$o(this, "_hitAreaDefault");
        $867beeb89be92199$var$o(this, "_pause");
        $867beeb89be92199$var$o(this, "tickerFunction");
        $867beeb89be92199$var$o(this, "_worldWidth");
        $867beeb89be92199$var$o(this, "_worldHeight");
        $867beeb89be92199$var$o(this, "_disableOnContextMenu", (t)=>t.preventDefault());
        this.options = {
            ...$867beeb89be92199$var$et,
            ...t
        }, this.screenWidth = this.options.screenWidth, this.screenHeight = this.options.screenHeight, this._worldWidth = this.options.worldWidth, this._worldHeight = this.options.worldHeight, this.forceHitArea = this.options.forceHitArea, this.threshold = this.options.threshold, this.options.disableOnContextMenu && this.options.events.domElement.addEventListener("contextmenu", this._disableOnContextMenu), this.options.noTicker || (this.tickerFunction = ()=>this.update(this.options.ticker.elapsedMS), this.options.ticker.add(this.tickerFunction)), this.input = new $867beeb89be92199$export$2da2653229140a6c(this), this.plugins = new $867beeb89be92199$export$f2c0a16002429d72(this);
    }
    destroy(t) {
        !this.options.noTicker && this.tickerFunction && this.options.ticker.remove(this.tickerFunction), this.options.disableOnContextMenu && this.options.events.domElement.removeEventListener("contextmenu", this._disableOnContextMenu), this.input.destroy(), super.destroy(t);
    }
    update(t) {
        this.pause || (this.plugins.update(t), this.lastViewport && (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y ? this.moving = !0 : this.moving && (this.emit("moved-end", this), this.moving = !1), this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y ? this.zooming = !0 : this.zooming && (this.emit("zoomed-end", this), this.zooming = !1)), this.forceHitArea || (this._hitAreaDefault = new (0, $340a428aa13511cc$export$4617fb02663045ef)(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight), this.hitArea = this._hitAreaDefault), this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y, this.lastViewport = {
            x: this.x,
            y: this.y,
            scaleX: this.scale.x,
            scaleY: this.scale.y
        }, this.emit("frame-end", this));
    }
    resize(t = window.innerWidth, i = window.innerHeight, e, n) {
        this.screenWidth = t, this.screenHeight = i, typeof e < "u" && (this._worldWidth = e), typeof n < "u" && (this._worldHeight = n), this.plugins.resize(), this.dirty = !0;
    }
    get worldWidth() {
        return this._worldWidth ? this._worldWidth : this.width / this.scale.x;
    }
    set worldWidth(t) {
        this._worldWidth = t, this.plugins.resize();
    }
    get worldHeight() {
        return this._worldHeight ? this._worldHeight : this.height / this.scale.y;
    }
    set worldHeight(t) {
        this._worldHeight = t, this.plugins.resize();
    }
    getVisibleBounds() {
        return new (0, $340a428aa13511cc$export$4617fb02663045ef)(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight);
    }
    toWorld(t, i) {
        return arguments.length === 2 ? this.toLocal(new (0, $88931fa1c0809be8$export$baf26146a414f24a)(t, i)) : this.toLocal(t);
    }
    toScreen(t, i) {
        return arguments.length === 2 ? this.toGlobal(new (0, $88931fa1c0809be8$export$baf26146a414f24a)(t, i)) : this.toGlobal(t);
    }
    get worldScreenWidth() {
        return this.screenWidth / this.scale.x;
    }
    get worldScreenHeight() {
        return this.screenHeight / this.scale.y;
    }
    get screenWorldWidth() {
        return this.worldWidth * this.scale.x;
    }
    get screenWorldHeight() {
        return this.worldHeight * this.scale.y;
    }
    get center() {
        return new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.worldScreenWidth / 2 - this.x / this.scale.x, this.worldScreenHeight / 2 - this.y / this.scale.y);
    }
    set center(t) {
        this.moveCenter(t);
    }
    moveCenter(...t) {
        let i, e;
        typeof t[0] == "number" ? (i = t[0], e = t[1]) : (i = t[0].x, e = t[0].y);
        const n = (this.worldScreenWidth / 2 - i) * this.scale.x, s = (this.worldScreenHeight / 2 - e) * this.scale.y;
        return (this.x !== n || this.y !== s) && (this.position.set(n, s), this.plugins.reset(), this.dirty = !0), this;
    }
    get corner() {
        return new (0, $88931fa1c0809be8$export$baf26146a414f24a)(-this.x / this.scale.x, -this.y / this.scale.y);
    }
    set corner(t) {
        this.moveCorner(t);
    }
    moveCorner(...t) {
        let i, e;
        return t.length === 1 ? (i = -t[0].x * this.scale.x, e = -t[0].y * this.scale.y) : (i = -t[0] * this.scale.x, e = -t[1] * this.scale.y), (i !== this.x || e !== this.y) && (this.position.set(i, e), this.plugins.reset(), this.dirty = !0), this;
    }
    get screenWidthInWorldPixels() {
        return this.screenWidth / this.scale.x;
    }
    get screenHeightInWorldPixels() {
        return this.screenHeight / this.scale.y;
    }
    findFitWidth(t) {
        return this.screenWidth / t;
    }
    findFitHeight(t) {
        return this.screenHeight / t;
    }
    findFit(t, i) {
        const e = this.screenWidth / t, n = this.screenHeight / i;
        return Math.min(e, n);
    }
    findCover(t, i) {
        const e = this.screenWidth / t, n = this.screenHeight / i;
        return Math.max(e, n);
    }
    fitWidth(t = this.worldWidth, i, e = !0, n) {
        let s;
        i && (s = this.center), this.scale.x = this.screenWidth / t, e && (this.scale.y = this.scale.x);
        const h = this.plugins.get("clamp-zoom", !0);
        return !n && h && h.clamp(), i && s && this.moveCenter(s), this;
    }
    fitHeight(t = this.worldHeight, i, e = !0, n) {
        let s;
        i && (s = this.center), this.scale.y = this.screenHeight / t, e && (this.scale.x = this.scale.y);
        const h = this.plugins.get("clamp-zoom", !0);
        return !n && h && h.clamp(), i && s && this.moveCenter(s), this;
    }
    fitWorld(t) {
        let i;
        t && (i = this.center), this.scale.x = this.screenWidth / this.worldWidth, this.scale.y = this.screenHeight / this.worldHeight, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
        const e = this.plugins.get("clamp-zoom", !0);
        return e && e.clamp(), t && i && this.moveCenter(i), this;
    }
    fit(t, i = this.worldWidth, e = this.worldHeight) {
        let n;
        t && (n = this.center), this.scale.x = this.screenWidth / i, this.scale.y = this.screenHeight / e, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
        const s = this.plugins.get("clamp-zoom", !0);
        return s && s.clamp(), t && n && this.moveCenter(n), this;
    }
    setZoom(t, i) {
        let e;
        i && (e = this.center), this.scale.set(t);
        const n = this.plugins.get("clamp-zoom", !0);
        return n && n.clamp(), i && e && this.moveCenter(e), this;
    }
    zoomPercent(t, i) {
        return this.setZoom(this.scale.x + this.scale.x * t, i);
    }
    zoom(t, i) {
        return this.fitWidth(t + this.worldScreenWidth, i), this;
    }
    get scaled() {
        return this.scale.x;
    }
    set scaled(t) {
        this.setZoom(t, !0);
    }
    snapZoom(t) {
        return this.plugins.add("snap-zoom", new $867beeb89be92199$export$8d3b89b6e4db7cd0(this, t)), this;
    }
    OOB() {
        return {
            left: this.left < 0,
            right: this.right > this.worldWidth,
            top: this.top < 0,
            bottom: this.bottom > this.worldHeight,
            cornerPoint: new (0, $88931fa1c0809be8$export$baf26146a414f24a)(this.worldWidth * this.scale.x - this.screenWidth, this.worldHeight * this.scale.y - this.screenHeight)
        };
    }
    get right() {
        return -this.x / this.scale.x + this.worldScreenWidth;
    }
    set right(t) {
        this.x = -t * this.scale.x + this.screenWidth, this.plugins.reset();
    }
    get left() {
        return -this.x / this.scale.x;
    }
    set left(t) {
        this.x = -t * this.scale.x, this.plugins.reset();
    }
    get top() {
        return -this.y / this.scale.y;
    }
    set top(t) {
        this.y = -t * this.scale.y, this.plugins.reset();
    }
    get bottom() {
        return -this.y / this.scale.y + this.worldScreenHeight;
    }
    set bottom(t) {
        this.y = -t * this.scale.y + this.screenHeight, this.plugins.reset();
    }
    get dirty() {
        return !!this._dirty;
    }
    set dirty(t) {
        this._dirty = t;
    }
    get forceHitArea() {
        return this._forceHitArea;
    }
    set forceHitArea(t) {
        t ? (this._forceHitArea = t, this.hitArea = t) : (this._forceHitArea = null, this.hitArea = new (0, $340a428aa13511cc$export$4617fb02663045ef)(0, 0, this.worldWidth, this.worldHeight));
    }
    drag(t) {
        return this.plugins.add("drag", new $867beeb89be92199$export$b48985bba8f530f5(this, t)), this;
    }
    clamp(t) {
        return this.plugins.add("clamp", new $867beeb89be92199$export$90534cad35a14134(this, t)), this;
    }
    decelerate(t) {
        return this.plugins.add("decelerate", new $867beeb89be92199$export$4bbb5144deae3118(this, t)), this;
    }
    bounce(t) {
        return this.plugins.add("bounce", new $867beeb89be92199$export$d20e79fdc3899e95(this, t)), this;
    }
    pinch(t) {
        return this.plugins.add("pinch", new $867beeb89be92199$export$826ae541ddf1527b(this, t)), this;
    }
    snap(t, i, e) {
        return this.plugins.add("snap", new $867beeb89be92199$export$4dbf1f67c012298b(this, t, i, e)), this;
    }
    follow(t, i) {
        return this.plugins.add("follow", new $867beeb89be92199$export$455f05776f1ba8ba(this, t, i)), this;
    }
    wheel(t) {
        return this.plugins.add("wheel", new $867beeb89be92199$export$ae16e1bcb40d6793(this, t)), this;
    }
    animate(t) {
        return this.plugins.add("animate", new $867beeb89be92199$export$83a1293bbde53b95(this, t)), this;
    }
    clampZoom(t) {
        return this.plugins.add("clamp-zoom", new $867beeb89be92199$export$220d7a3461bca2df(this, t)), this;
    }
    mouseEdges(t) {
        return this.plugins.add("mouse-edges", new $867beeb89be92199$export$dd505d2e20e3eaaf(this, t)), this;
    }
    get pause() {
        return !!this._pause;
    }
    set pause(t) {
        this._pause = t, this.lastViewport = null, this.moving = !1, this.zooming = !1, t && this.input.pause();
    }
    ensureVisible(t, i, e, n, s) {
        s && (e > this.worldScreenWidth || n > this.worldScreenHeight) && (this.fit(!0, e, n), this.emit("zoomed", {
            viewport: this,
            type: "ensureVisible"
        }));
        let h = !1;
        t < this.left ? (this.left = t, h = !0) : t + e > this.right && (this.right = t + e, h = !0), i < this.top ? (this.top = i, h = !0) : i + n > this.bottom && (this.bottom = i + n, h = !0), h && this.emit("moved", {
            viewport: this,
            type: "ensureVisible"
        });
    }
}


const $7b75c553cab94ef4$export$95f6a03511c31b06 = {
    DEBUG: {
        ALWAYS_LOG_LONG_FRAMES: true,
        LOG_TICK_METADATA_EVERY_SERVER_FRAME: false,
        ONLY_DISPLAY_ONE_FRAME_LOG_AT_A_TIME: false
    }
};



var $f1q41 = parcelRequire("f1q41");
const $952fbb3f4cef768a$export$b9c5bbe98d67049c = {
    WORLD_SIZE: 4000,
    TILE_SIZE: 16,
    WORLD_TILE_DIMENSIONS: 250
};


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


const $276f03d77ac4b507$export$bc0290abd606d45b = ()=>{
    const time = $cfae44f0dfdf62c0$exports.hrtime.bigint();
    return Number(time) / 1e6;
};
const $276f03d77ac4b507$export$7c99b80db23920e1 = typeof BigInt !== "undefined" ? typeof $cfae44f0dfdf62c0$exports !== "undefined" && typeof $cfae44f0dfdf62c0$exports.hrtime !== "undefined" && typeof $cfae44f0dfdf62c0$exports.hrtime.bigint === "function" ? ()=>$cfae44f0dfdf62c0$exports.hrtime.bigint() : ()=>BigInt(Date.now() * 1e6) : ()=>Date.now() * 1e6;
const $276f03d77ac4b507$export$976c37132e9c6a10 = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ 	]|(\\[	 -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[	 -Z^-~]*])");
const $276f03d77ac4b507$export$b646210dbab6d1e3 = ()=>Date.now();
const $276f03d77ac4b507$export$2e015b6955893291 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $276f03d77ac4b507$export$acf2935d58de9402 = ()=>{
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
const $276f03d77ac4b507$export$307b18b61172f7ed = (caller)=>{
    const proto = Object.getPrototypeOf(caller);
    if (proto.constructor && proto.constructor.name) return proto.constructor.name;
    return "";
};
const $276f03d77ac4b507$export$6888749eed104596 = (v)=>{
    return (0, $f1q41.isNil)(v) || v === "";
};
const $276f03d77ac4b507$export$7d15b64cf5a3a4c4 = (val, min = 0, max = 1)=>Math.max(min, Math.min(max, val));
const $276f03d77ac4b507$export$b13c16d22ae33620 = (xOrY)=>{
    return $276f03d77ac4b507$export$7d15b64cf5a3a4c4(xOrY, 0, (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_SIZE - 1); // minus one to prevent entities from going into the next non-existent columns or grids in the collision grid
// something something off by 1 error
};
const $276f03d77ac4b507$export$ec7b30d06d4fb38 = (rads)=>{
    return rads > Math.PI / 2 || rads < -Math.PI / 2;
};
const $276f03d77ac4b507$export$b59117efbc9c7af = (x1, y1, x2, y2)=>{
    const xDiff = x1 - x2;
    const yDiff = y1 - y2;
    return Math.sqrt(xDiff * xDiff + yDiff * yDiff);
};
const $276f03d77ac4b507$export$e772c8ff12451969 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $276f03d77ac4b507$export$cba01ba138429a1d(degrees) {
    return degrees * (Math.PI / 180);
}
function $276f03d77ac4b507$export$56cb859c01fa134d(radians) {
    return radians * (180 / Math.PI);
}
function $276f03d77ac4b507$export$5c945887f38dcb4b(angleInRadians, percentage) {
    const range = Math.PI * 2 * percentage;
    const offset = Math.random() * range - range / 2;
    let newAngle = angleInRadians + offset;
    if (newAngle < -Math.PI) newAngle += 2 * Math.PI;
    else if (newAngle > Math.PI) newAngle -= 2 * Math.PI;
    return newAngle;
}
const $276f03d77ac4b507$export$8568ce53486579b5 = (chance)=>Math.random() < chance;
const $276f03d77ac4b507$export$f4cddbd81b5f2a5c = ()=>Math.random() >= 0.5;
const $276f03d77ac4b507$export$d65d87575fa7ad6c = ()=>Math.random() * 2 * Math.PI;
const $276f03d77ac4b507$export$3acfa4651e1e404d = (seconds, shorterFormat)=>{
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    if (shorterFormat) {
        const paddedMinutes = minutes.toString().padStart(2, "0");
        const paddedSeconds = remainingSeconds.toString().padStart(2, "0");
        return `${paddedMinutes}:${paddedSeconds}`;
    } else return `${minutes < 1 ? "" : `${minutes}m`}${remainingSeconds}${remainingSeconds > 1 ? "s" : ""}`;
};
const $276f03d77ac4b507$export$67128de51a301bf0 = (seconds)=>{
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}h ${paddedMinutes}m`;
};


var $5f41b2ce7dbc35bf$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["VERBOSE"] = 0] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})($5f41b2ce7dbc35bf$export$243e62d78d3b544d || ($5f41b2ce7dbc35bf$export$243e62d78d3b544d = {}));
const $5f41b2ce7dbc35bf$export$7fd96f818dd6e623 = (str, length)=>{
    const diff = length - str.length;
    if (diff <= 0) return str;
    const leftPadding = Math.floor(diff / 2);
    const rightPadding = diff - leftPadding;
    const paddedStr = " ".repeat(leftPadding) + str + " ".repeat(rightPadding);
    return paddedStr;
};


class $17b9955c103c9892$export$20d83fe2bd9e0e3d {
    constructor(level = (0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).INFO){
        this.level = level;
    }
    setLogLevel(newLogLevel) {
        this.level = newLogLevel;
    }
    getSystemName() {
        return (0, $276f03d77ac4b507$export$307b18b61172f7ed)(this);
    }
    log(level, message) {
        if (level >= this.level) {
            let logFn;
            const frameNumberSegment = "[" + (0, $5f41b2ce7dbc35bf$export$7fd96f818dd6e623)(globalThis.currentFrameNumber.toString(), 7) + "]";
            const systemSegment = "[" + (0, $5f41b2ce7dbc35bf$export$7fd96f818dd6e623)(this.getSystemName(), 13) + "]";
            const logLevelSegment = "[" + (0, $5f41b2ce7dbc35bf$export$7fd96f818dd6e623)((0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d)[level], 9) + "]";
            const fullString = `%c ${frameNumberSegment} ${logLevelSegment} ${systemSegment} ${message}`;
            if (level === (0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).ERROR) logFn = console.error.bind(console, fullString, "color: red");
            else if (level === (0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).WARNING) logFn = console.warn.bind(console, fullString, "color: orange");
            else if (level === (0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).VERBOSE) logFn = console.debug.bind(console, fullString, "color: white");
            else logFn = console.log.bind(console, fullString, "color: green");
            logFn();
        }
    }
    ConditionallyLogTickMsg(msg, level = (0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).INFO) {
        if ((0, $7b75c553cab94ef4$export$95f6a03511c31b06).DEBUG.LOG_TICK_METADATA_EVERY_SERVER_FRAME === true) this.log(level, msg);
    }
    LogVerbose(message) {
        this.log((0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).VERBOSE, message);
    }
    LogInfo(message) {
        this.log((0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).INFO, message);
    }
    LogWarning(message) {
        this.log((0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).WARNING, message);
    }
    LogError(message) {
        this.log((0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).ERROR, message);
    }
}


class $d5fe2eff33d101be$export$5d53140180d567a1 extends (0, $17b9955c103c9892$export$20d83fe2bd9e0e3d) {
}





class $e6a89d1e24ad5bef$export$1ab9f6b591c1e54 {
    constructor(spawnPositionX, spawnPositionY, pfxSpriteId, pfxSpriteScale, rotation, overrideAnimationSpeed){
        this.animationSpeed = 1 / 4;
        this.RenderedEntity = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        // console.log("playing one-off pfx at location with parameters");
        // console.log("spawnPositionX: ", spawnPositionX);
        // console.log("spawnPositionY: ", spawnPositionY);
        // console.log("pfxSpriteId: ", pfxSpriteId);
        // console.log("pfxSpriteScale: ", pfxSpriteScale);
        // console.log("rotation: ", rotation);
        this.spriteId = pfxSpriteId;
        this.spriteScale = pfxSpriteScale;
        this.RenderedEntity.x = spawnPositionX;
        this.RenderedEntity.y = spawnPositionY;
        this.RenderedEntity.zIndex = spawnPositionY;
        // console.log("rotation in ClientOneOffPfx constructor: ", rotation);
        if (overrideAnimationSpeed) this.overrideAnimationSpeed = overrideAnimationSpeed;
        try {
            this._setupPfxVisuals();
        } catch (e) {
            console.error("Caught error trying to set up pfx visuals in ClientOneOffPfx constructor: ", e);
        }
        if (rotation) {
            if ((0, $276f03d77ac4b507$export$ec7b30d06d4fb38)(rotation)) this.RenderedEntity.scale.x = -1;
        }
    }
    _setupPfxVisuals() {
        const pfxAnimation = Game.Loader.GetAnimation(this.spriteId);
        this.pfxSprite = (0, $bef80d21b8b0b6b2$export$dae599798687ad3c).fromFrames(pfxAnimation);
        this.pfxSprite.loop = false;
        this.pfxSprite.onComplete = this._destroy.bind(this);
        this.pfxSprite.scale.set(this.spriteScale);
        this.pfxSprite.anchor.set(0.5, 0.5);
        if (this.overrideAnimationSpeed) this.pfxSprite.animationSpeed = this.overrideAnimationSpeed;
        else this.pfxSprite.animationSpeed = this.animationSpeed;
        this.pfxSprite.play();
        this.RenderedEntity.addChild(this.pfxSprite);
    }
    _destroy() {
        Game.Renderer.RemoveRenderedEntity(this);
    }
    Update(__deltaTime) {}
}



var $cee99d2008daa3ee$export$b3cdd2c2676dcd8c;
(function(CharacterSkin) {
    CharacterSkin[CharacterSkin["None"] = -1] = "None";
    CharacterSkin[CharacterSkin["Wizard_Apprentice"] = 0] = "Wizard_Apprentice";
    CharacterSkin[CharacterSkin["Wizard_Corrupted"] = 1] = "Wizard_Corrupted";
    CharacterSkin[CharacterSkin["Wizard_Veteran"] = 2] = "Wizard_Veteran";
    CharacterSkin[CharacterSkin["Boltman"] = 3] = "Boltman";
    CharacterSkin[CharacterSkin["Knight"] = 4] = "Knight";
    CharacterSkin[CharacterSkin["Thief"] = 5] = "Thief";
    CharacterSkin[CharacterSkin["NobleKnight"] = 6] = "NobleKnight";
    CharacterSkin[CharacterSkin["Assassin"] = 7] = "Assassin";
    CharacterSkin[CharacterSkin["AdeptArcher"] = 8] = "AdeptArcher";
    CharacterSkin[CharacterSkin["ForestArcher"] = 9] = "ForestArcher";
    CharacterSkin[CharacterSkin["CherryBlossomBoltman"] = 10] = "CherryBlossomBoltman";
    CharacterSkin[CharacterSkin["Coldsteel_Knight"] = 11] = "Coldsteel_Knight";
    CharacterSkin[CharacterSkin["CursedCorruptedWizard"] = 12] = "CursedCorruptedWizard";
    CharacterSkin[CharacterSkin["FallenWizardsApprentice"] = 13] = "FallenWizardsApprentice";
    CharacterSkin[CharacterSkin["HeroicKnight"] = 14] = "HeroicKnight";
    CharacterSkin[CharacterSkin["MidnightThief"] = 15] = "MidnightThief";
    CharacterSkin[CharacterSkin["RadiantKnight"] = 16] = "RadiantKnight";
    CharacterSkin[CharacterSkin["VengefulKnight"] = 17] = "VengefulKnight";
    CharacterSkin[CharacterSkin["WealthyAssassin"] = 18] = "WealthyAssassin";
    CharacterSkin[CharacterSkin["Estranged_Wizard"] = 19] = "Estranged_Wizard";
})($cee99d2008daa3ee$export$b3cdd2c2676dcd8c || ($cee99d2008daa3ee$export$b3cdd2c2676dcd8c = {}));
const $cee99d2008daa3ee$export$e6a74437b70b4a6d = ()=>{
    return (0, $276f03d77ac4b507$export$2e015b6955893291)([
        $cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Wizard_Apprentice,
        $cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Wizard_Corrupted,
        $cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Wizard_Veteran,
        $cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Boltman,
        $cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Knight,
        $cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Thief
    ]);
};
const $cee99d2008daa3ee$export$183400f7af0e3a3c = new Map();
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Wizard_Apprentice, {
    friendlyName: "Wizards Apprentice",
    staticSpriteId: "sprites/player_skins/ANIM_wiz001_base.png",
    idleFramesSpriteId: "player_skins/ANIM_wiz001_idle",
    walkFramesSpriteId: "player_skins/ANIM_wiz001_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Wizard_Corrupted, {
    friendlyName: "Corrupted Wizard",
    staticSpriteId: "sprites/player_skins/ANIM_wiz002_base.png",
    idleFramesSpriteId: "player_skins/ANIM_wiz002_idle",
    walkFramesSpriteId: "player_skins/ANIM_wiz002_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Wizard_Veteran, {
    friendlyName: "Veteran Scholar",
    staticSpriteId: "sprites/player_skins/ANIM_wiz003_base.png",
    idleFramesSpriteId: "player_skins/ANIM_wiz003_idle",
    walkFramesSpriteId: "player_skins/ANIM_wiz003_walk",
    spriteYOffset: -4
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Boltman, {
    friendlyName: "Boltman",
    staticSpriteId: "sprites/player_skins/ANIM_boltmanGreen_base.png",
    idleFramesSpriteId: "player_skins/ANIM_boltmanGreen_idle",
    walkFramesSpriteId: "player_skins/ANIM_boltmanGreen_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Knight, {
    friendlyName: "Knight",
    staticSpriteId: "sprites/player_skins/ANIM_knightSteel_base.png",
    idleFramesSpriteId: "player_skins/ANIM_knightSteel_idle",
    walkFramesSpriteId: "player_skins/ANIM_knightSteel_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Thief, {
    friendlyName: "Thief",
    staticSpriteId: "sprites/player_skins/ANIM_thiefBlack_base.png",
    idleFramesSpriteId: "player_skins/ANIM_thiefBlack_idle",
    walkFramesSpriteId: "player_skins/ANIM_thiefBlack_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.NobleKnight, {
    friendlyName: "Noble Knight",
    staticSpriteId: "sprites/player_skins/newknight_idle1.png",
    idleFramesSpriteId: "player_skins/newknight_idle",
    walkFramesSpriteId: "player_skins/newknight_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.AdeptArcher, {
    friendlyName: "Adept Archer",
    staticSpriteId: "sprites/player_skins/ANIM_AdeptArcher_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_AdeptArcher_idle",
    walkFramesSpriteId: "player_skins/ANIM_AdeptArcher_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.ForestArcher, {
    friendlyName: "Forest Archer",
    staticSpriteId: "sprites/player_skins/ANIM_Archer_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_Archer_idle",
    walkFramesSpriteId: "player_skins/ANIM_Archer_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Assassin, {
    friendlyName: "Assassin",
    staticSpriteId: "sprites/player_skins/ANIM_Assassin_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_Assassin_idle",
    walkFramesSpriteId: "player_skins/ANIM_Assassin_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.CherryBlossomBoltman, {
    friendlyName: "Cherry Blossom Boltman",
    staticSpriteId: "sprites/player_skins/ANIM_boltmanCherryBlossom_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_boltmanCherryBlossom_idle",
    walkFramesSpriteId: "player_skins/ANIM_boltmanCherryBlossom_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Coldsteel_Knight, {
    friendlyName: "Coldsteel Knight",
    staticSpriteId: "sprites/player_skins/ANIM_ColdsteelKnight_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_ColdsteelKnight_idle",
    walkFramesSpriteId: "player_skins/ANIM_ColdsteelKnight_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.CursedCorruptedWizard, {
    friendlyName: "Cursed Corrupted Wizard",
    staticSpriteId: "sprites/player_skins/ANIM_CursedCorruptedWizard_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_CursedCorruptedWizard_idle",
    walkFramesSpriteId: "player_skins/ANIM_CursedCorruptedWizard_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.FallenWizardsApprentice, {
    friendlyName: "Fallen Wizards Apprentice",
    staticSpriteId: "sprites/player_skins/ANIM_FallenWizardsApprentice_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_FallenWizardsApprentice_idle",
    walkFramesSpriteId: "player_skins/ANIM_FallenWizardsApprentice_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.HeroicKnight, {
    friendlyName: "Heroic Knight",
    staticSpriteId: "sprites/player_skins/ANIM_HeroicKnight_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_HeroicKnight_idle",
    walkFramesSpriteId: "player_skins/ANIM_HeroicKnight_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.MidnightThief, {
    friendlyName: "Midnight Thief",
    staticSpriteId: "sprites/player_skins/ANIM_MidnightThief_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_MidnightThief_idle",
    walkFramesSpriteId: "player_skins/ANIM_MidnightThief_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.RadiantKnight, {
    friendlyName: "Radiant Knight",
    staticSpriteId: "sprites/player_skins/ANIM_RadiantKnight_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_RadiantKnight_idle",
    walkFramesSpriteId: "player_skins/ANIM_RadiantKnight_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.VengefulKnight, {
    friendlyName: "Vengeful Knight",
    staticSpriteId: "sprites/player_skins/ANIM_VengefulKnight_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_VengefulKnight_idle",
    walkFramesSpriteId: "player_skins/ANIM_VengefulKnight_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.WealthyAssassin, {
    friendlyName: "Wealthy Assassin",
    staticSpriteId: "sprites/player_skins/ANIM_WealthyAssassin_idle001.png",
    idleFramesSpriteId: "player_skins/ANIM_WealthyAssassin_idle",
    walkFramesSpriteId: "player_skins/ANIM_WealthyAssassin_walk",
    spriteYOffset: 0
});
$cee99d2008daa3ee$export$183400f7af0e3a3c.set($cee99d2008daa3ee$export$b3cdd2c2676dcd8c.Estranged_Wizard, {
    friendlyName: "Estranged Wizard",
    staticSpriteId: "sprites/player_skins/Wizard_idle1.png",
    idleFramesSpriteId: "player_skins/Wizard_idle",
    walkFramesSpriteId: "player_skins/Wizard_walk",
    spriteYOffset: 0
});



var $f1q41 = parcelRequire("f1q41");
var $28c2942e73cfea29$exports = {};
$28c2942e73cfea29$exports = JSON.parse('{"main_menu__shop_btn":"Shop","shop__title":"Shop","loadout_menu__no_slot_selected_insurance_text_2":"No slot is insured! Spend an insurance token to insure 1 item.","adblock_detected_failed_to_insure":"Something went wrong insuring that item. Please ensure your adblock is disabled!","ability_type_active":"Active","ability_type_passive":"Passive","change_username__back":"Back","change_username__cant_be_empty_error":"Username cannot be empty","change_username__current_prompt":"Your current username","change_username__enter_new":"Enter a new username","change_username__header":"Username","change_username__save":"Save","change_username__too_long_error":"Username cannot be longer than 20 characters.","character_already_on_run_menu__abondon_run_button":"Abandon Run","character_already_on_run_menu__back_to_main_menu_button":"Back","character_already_on_run_menu__bolded_header":"Your character is already on a run!","character_already_on_run_menu__paragraph_one":"Your character has not yet returned from their previous run. If you start a new run now, all of your items from the prior run (minus your insured items) will be lost!","character_already_on_run_menu__paragraph_two":"If you think this is a bug, or if you intentionally want to abandon your run, you can forcibly abandon your run using the button below.","character_already_on_run_menu__title":"WARNING!","connection_error__back_to_main_menu":"Return to main menu","connection_error__error_reason":"Reason","connection_error__oof":"Oof","connection_error__server_error_header":"Server connection error!","death_menu__back_to_main_menu_button":"Back To Menu","death_menu__gear_lost":"Lost Gear","death_menu__gold_lost":"Gold Lost","death_menu__insured_items":"Insured Items","death_menu__loot_lost":"Lost Loot","death_menu__nothing_insured":"No items were insured!","death_menu__saving_your_run_button":"Saving...","death_menu__spectate_button":"Spectate Killer","death_menu__survived_for":"Survived For","death_menu__title":"R.I.P","death_menu__weapons_lost":"Lost Weapons","death_menu__your_killer":"Your Killer","extracted_menu__back_to_main_menu_button":"Back To Menu","extracted_menu__gold_looted":"Gold Looted","extracted_menu__loot_acquired":"Loot Acquired","extracted_menu__run_duration":"Run Duration","extracted_menu__title":"Extracted!","game_hud__cooldown":"Cooldown","game_hud__find_an_extraction_point":"Find an extraction point!","game_hud__inventory_extract_prompt":"You have to extract to use this loot!","game_hud__inventory_hud":"Open Inventory","game_hud__leaderboard":"Leaderboard","game_hud__leaderboard_current_world":"Current World","game_hud__leaderboard_hide":"Hide","game_hud__leaderboard_show":"Show","game_hud__looted_container_close":"Close","game_hud__spectating":"Spectating","game_hud__time_left_to_extract":"left to extract","game_hud__your_inventory_header":"Your Inventory!","game_hud__your_inventory_hide":"to close","game_transition__finding_match":"Finding Match","hotkey_interact":"E","hotkey_open_inventory":"i","hotkey_toggle_leaderboard":"L","how_to_play__ability_one_key":"Ability #1","how_to_play__ability_three_key":"Ability #3","how_to_play__ability_two_key":"Ability #2","how_to_play__back_to_main_menu_button":"Back","how_to_play__chat_key":"Chat","how_to_play__extraction":"Find an extraction point!","how_to_play__inventory_key":"Inventory","how_to_play__leaderboard_key":"Leaderboard","how_to_play__mouse_aim_controls":": Aim","how_to_play__mouse_shoot_controls":": Shoot","how_to_play__move_down_key":"Move Down","how_to_play__move_left_key":"Move Left","how_to_play__move_right_key":"Move Right","how_to_play__move_up_key":"Move Up","how_to_play__small_paragraph_one":"If you fail to extract in time, you lose all of the items you brought with you (unless you have insurance!) and all the items you looted on your run. Extracting is very important. You must EXTRACT with your loot to keep it and use it.","how_to_play__small_paragraph_three":"Kill or be killed, may the best adventurer win!","how_to_play__small_paragraph_two":" ","how_to_play__test_keys_header":"Test the keys!","how_to_play__title":"PvPz.io","how_to_play__top_big_paragraph":"Kill other players, find loot, and extract!","how_to_play__weapon_one_key":"Weapon #1","how_to_play__weapon_two_key":"Weapon #2","in_game__extracting":"Extracting...","in_game__time_remaining":"Time Remaining...","in_game__warning_time_almost_up":"Find an extraction point!","insured_item_nothing":"Nothing","item__AG_AmuletOfCursedFate__gameplay":"+10% Attack Speed | REVIVE with 40% HP when you die (does not stack with other revive items)","item__AG_AmuletOfCursedFate__lore":"A malevolent amulet that twists destinies and brings forth dark omens.","item__AG_AmuletOfCursedFate__name":"Amulet of Cursed Fate","item__AG_MagicBoots__gameplay":"Become invisible for 9 seconds on use (2 Uses) | Your health regenerates all the time | Extract 10% slower","item__AG_MagicBoots__lore":"These boots make no noise and invigorate their wearer","item__AG_MagicBoots__name":"Magic Boots","item__AG_Boros__gameplay":"Become invisible for 7 seconds on use | -12% Damage to NPCs | +12% Leech from all damage you deal to players","item__AG_Boros__lore":"Its gem is rumored to be created from the eye of a shapeshifter.","item__AG_Boros__name":"Boros","item__AG_DarkPustulesRing__gameplay":"Take 5% less damage while extracting | Extract 5% faster","item__AG_DarkPustulesRing__lore":"This ring can be used to magically procure a days worth of sweet, dark liquid.","item__AG_DarkPustulesRing__name":"Dark Pustules Ring","item__AG_DreamWeaversEmbrace__gameplay":"Become invisible for 4 seconds on use | -5% Damage to Players | Extract 10% faster | INCOGNITO: Hides your loot and location messages from the rest of the world","item__AG_DreamWeaversEmbrace__lore":"The stones on this ring change color around areas where the veil is thin.","item__AG_DreamWeaversEmbrace__name":"DreamWeaver\'s Embrace","item__AG_ForestsHaven__gameplay":"Heals 20HP when used | Extract 10% faster | INCOGNITO: Hides your loot and location messages from the rest of the world | +20% Ethereal","item__AG_ForestsHaven__lore":"To those who wear this ring, seek the grove of trees hidden amongst dreams.","item__AG_ForestsHaven__name":"Forest\'s Haven","item__AG_MysteriousRing__gameplay":"Adds 30 seconds to your extraction timer on use | +10 Maximum Health | +7% Movement Speed while walking in water","item__AG_MysteriousRing__lore":"???","item__AG_MysteriousRing__name":"Mysterious Ring","item__AG_ObsidianEcho__gameplay":"EXTRACT when used, no matter where you are | +12% Movement Speed | REVIVE with 70% HP when you die (does not stack with other revive items) | -30 Maximum Health | This item is destroyed when fully used","item__AG_ObsidianEcho__lore":"Forged from a shard of Malachi\'s blade. If you listen closely, you can hear the echo of souls from those he killed","item__AG_ObsidianEcho__name":"Obsidian Echo","item__AG_PepperedCollar__gameplay":"Grants 4 seconds of +25% movement speed when used (1 Use) | -3% Projectile Distance","item__AG_PepperedCollar__lore":"A collar necklace created as a tribute to a famous feline beast.","item__AG_PepperedCollar__name":"Peppered Collar","item__AG_RingOfAnOceanMan__gameplay":"Grants 2 seconds of +20% movement speed when used | Extract 5% faster | +5% Movement Speed while walking in water","item__AG_RingOfAnOceanMan__lore":"It feels as though it is trying to take your hand and lead you to a land only it understands.","item__AG_RingOfAnOceanMan__name":"Ring of an Ocean Man","item__AG_StuddedNecklace__gameplay":"Become invisible for 4 seconds on use (3 Charges) | -3% Movement Speed","item__AG_StuddedNecklace__lore":"I should probably get this insured","item__AG_StuddedNecklace__name":"Studded Necklace","item__AG_TheDarkLordsEmbrace__gameplay":"+30 Maximum Health","item__AG_TheDarkLordsEmbrace__lore":"Cursed by the various atrocities commited by its wielder.","item__AG_TheDarkLordsEmbrace__name":"The Dark Lord\'s Embrace","item__AG_TimeHerosRing__gameplay":"Adds 45 seconds to your extraction timer on use | +7% Attack Speed | +7% Movement Speed while walking in water | -5% Movement Speed | +9% Nature Defence | +7% Nature Damage","item__AG_TimeHerosRing__lore":"Worn by an elvish boy who could travel through time.","item__AG_TimeHerosRing__name":"Time Hero\'s Ring","item__AG_VestiasSoothingSignet__gameplay":"Heals 30HP when used | INCOGNITO: Hides your loot and location messages from the rest of the world","item__AG_VestiasSoothingSignet__lore":"A ring that enables the wearer to soothe both injuries and party tensions alike.","item__AG_VestiasSoothingSignet__name":"Vestia\'s Soothing Signet","item__AG_ViolasDinnerReminder__gameplay":"+8.5% Nature Defence | +8.5% Frost Defence | Take 7% less damage while extracting | Your projectiles travel 5% shorter","item__AG_ViolasDinnerReminder__lore":"A ring that lets everyone around you know when you\'re hungry.","item__AG_ViolasDinnerReminder__name":"Viola\'s Dinner Reminder","item__AG_WolfMedallion__gameplay":"Heals 10HP when used | +10% Attack Speed | +10% Leech from all damage you deal to players","item__AG_WolfMedallion__lore":"Attuned to magic this can detect nearby places of power.","item__AG_WolfMedallion__name":"Wolf Medallion","item__CI_AlloyedBend__gameplay":"","item__CI_AlloyedBend__lore":"A ring made from a number of rare metals that have been roughly fused together.","item__CI_AlloyedBend__name":"Alloyed Bend","item__CI_ApposSignet__gameplay":"","item__CI_ApposSignet__lore":"Rumored to belong to a half-dragon, half-human hybrid who had the ability to control and speak to ducks.","item__CI_ApposSignet__name":"Appo\'s Signet","item__CI_BloodhuntersRing__gameplay":"","item__CI_BloodhuntersRing__lore":"The bloodhunter seeks her kin, and you as well.","item__CI_BloodhuntersRing__name":"Bloodhunter\'s Ring","item__CI_CelestialEternity__gameplay":"","item__CI_CelestialEternity__lore":"Those who rose up against Malachi were gifted this ring by the gods.","item__CI_CelestialEternity__name":"Celestial Eternity","item__CI_EbonstarBand__gameplay":"","item__CI_EbonstarBand__lore":"This ring holds part of the fallen star that changed everything.","item__CI_EbonstarBand__name":"Ebonstar Band","item__CI_EchoingWhisperNecklace__gameplay":"","item__CI_EchoingWhisperNecklace__lore":"A necklace that captures and echoes the murmurs of lost souls.","item__CI_EchoingWhisperNecklace__name":"Echoing Whisper Necklace","item__CI_FeyEnchantmentLocket__gameplay":"","item__CI_FeyEnchantmentLocket__lore":"A locket infused with enchantments from the Fey realm, granting beguiling allure.","item__CI_FeyEnchantmentLocket__name":"Fey Enchantment Locket","item__CI_FragmentOfFate__gameplay":"","item__CI_FragmentOfFate__lore":"Once whole, now shattered. Once united, now divided. Once eternal, now obsolete.","item__CI_FragmentOfFate__name":"Fragment of Fate","item__CI_LatrosKnavishBand__gameplay":"","item__CI_LatrosKnavishBand__lore":"A ring that only the vilest of thieves with moral certainty would wear.","item__CI_LatrosKnavishBand__name":"Latro\'s Knavish Band","item__CI_LifesSimpleRing__gameplay":"","item__CI_LifesSimpleRing__lore":"Live simply so others may simply live.","item__CI_LifesSimpleRing__name":"Life\'s Simple Ring","item__CI_LuminousEnigma__gameplay":"","item__CI_LuminousEnigma__lore":"I hold the key to knowledge vast, providing answers, unsurpassed.","item__CI_LuminousEnigma__name":"Luminous Enigma","item__CI_Ouro__gameplay":"","item__CI_Ouro__lore":"It is reportedly the key to unlocking the knowledge of all living creatures.","item__CI_Ouro__name":"Ouro","item__CI_PeachRing__gameplay":"","item__CI_PeachRing__lore":"It tastes sweet","item__CI_PeachRing__name":"Peach Ring","item__CI_PlayerSoulFragment__gameplay":"A soul harvester would be interested in this.","item__CI_PlayerSoulFragment__lore":"A fragment of a lost adventurers soul.","item__CI_PlayerSoulFragment__name":"Player Soul Fragment","item__CI_ProudlyPinkRing__gameplay":"","item__CI_ProudlyPinkRing__lore":"This ring is a stunning fashion accessory that will definitely drawn the attention of others.","item__CI_ProudlyPinkRing__name":"Proudly Pink Ring","item__CI_RadiantSunstoneBand__gameplay":"","item__CI_RadiantSunstoneBand__lore":"A paradoxical creation, this ring symbolizes a delicate balance between illumination and destruction.","item__CI_RadiantSunstoneBand__name":"Radiant Sunstone Band","item__CI_RingOfDelerium__gameplay":"","item__CI_RingOfDelerium__lore":"If you listen closely you can hear the voices of the past owners of this ring.","item__CI_RingOfDelerium__name":"Ring of Delerium","item__CI_RoyalBrooch__gameplay":"","item__CI_RoyalBrooch__lore":"The symbol of the royal family. Worth a pretty penny.","item__CI_RoyalBrooch__name":"Royal Brooch","item__CI_SuperStar__gameplay":"","item__CI_SuperStar__lore":"The remnant of a tall tale about a Mushroom filled kingdom.","item__CI_SuperStar__name":"Super Star","item__CI_SwampOgresRing__gameplay":"","item__CI_SwampOgresRing__lore":"Once belonged to a green ogre who was very protective of his swamp.","item__CI_SwampOgresRing__name":"Swamp Ogre\'s Ring","item__CI_WeddingRing__gameplay":"","item__CI_WeddingRing__lore":"This is worth a lot, I should return it to the original owner","item__CI_WeddingRing__name":"Wedding Ring","item__PG_AngelistasPotionPopper__gameplay":"Your health regenerates all the time","item__PG_AngelistasPotionPopper__lore":"A ring you wear when your healer forbids you from drinking healing potions.","item__PG_AngelistasPotionPopper__name":"Angelista\'s Potion Popper","item__PG_AquamoorsBlessing__gameplay":"Grants 3 seconds of +25% movement speed when used (3 Charges) | Your health regenerates all the time | -20 Maximum Health","item__PG_AquamoorsBlessing__lore":"Said to be blessed by the spirit of the lake before the corruption of the lands.","item__PG_AquamoorsBlessing__name":"Aquamoor\'s Blessing","item__PG_ArcaneEmber__gameplay":"-6.5% Damage to NPCs | +5.6% Damage to players","item__PG_ArcaneEmber__lore":"A small ember can be seen still glowing in this ring\'s gem.","item__PG_ArcaneEmber__name":"Arcane Ember","item__PG_ArcaneSigilCollar__gameplay":"Grants 4 seconds of +30% movement speed when used | -8.5% Damage to NPCs | +9.5% Damage to Players","item__PG_ArcaneSigilCollar__lore":"Etched with powerful symbols, it amplifies the wearer\'s arcane abilities.","item__PG_ArcaneSigilCollar__name":"Arcane Sigil Collar","item__PG_AssassinSignet__gameplay":"Become invisible for 5 seconds on use (2 Charges) | -3% Movement Speed | -3% Projectile Distance","item__PG_AssassinSignet__lore":"A signet held by an infamous assassin who fought with her hair.","item__PG_AssassinSignet__name":"Assassin Signet","item__PG_BellsShiningRing__gameplay":"Adds 60 seconds to your extraction timer on use | -9.5% Damage to players | +15.5% Damage to NPCs | +40 Maximum Health | Your health regenerates all the time","item__PG_BellsShiningRing__lore":"Known to many as the best healer in the realm.","item__PG_BellsShiningRing__name":"Belle\'s Shining Ring","item__PG_BloodGemRing__gameplay":"REVIVE with 50% HP when you die | -20 Maximum Health","item__PG_BloodGemRing__lore":"Those who were in the temple at the time of the ritual fell into a frenzy of bloodshed. This ring symbolizes desperate times.","item__PG_BloodGemRing__name":"Blood Gem Ring","item__PG_BloodiedVitality__gameplay":"EXTRACT when used, no matter where you are | Your health regenerates all the time | +30 Maximum Health | -8% Player Damage | You take 10% more damage from ALL damage types when extracting | This item is destroyed when fully used","item__PG_BloodiedVitality__lore":"Your connection to reality and life itself feels stronger with this around your body.","item__PG_BloodiedVitality__name":"Bloodied Vitality","item__PG_BloodmoonLoop__gameplay":"Heals 5HP when used (3 Charges) | +5% Bleed Damage","item__PG_BloodmoonLoop__lore":"Linked to lunar cycles. This heightens physical prowess during a blood moon.","item__PG_BloodmoonLoop__name":"Bloodmoon Armor","item__PG_CapeOfPureDarkness__gameplay":"Grants 4 seconds of +25% movement speed when used | +9% Shadow Defence | +9% Toxic Defence | +7% Toxic Damage | Your health drains all the time","item__PG_CapeOfPureDarkness__lore":"No one dared question him out of fear. For the Dark Ruler was not to be questioned.","item__PG_CapeOfPureDarkness__name":"Cape of Pure Darkness","item__PG_CelestialSolaceBand__gameplay":"Heals 7HP when used | INSPECTION: Reveals information about your opponents | +6.5% Shadow Damage","item__PG_CelestialSolaceBand__lore":"Forged by the gods themselves, this ring offers solace amidst the darkness.","item__PG_CelestialSolaceBand__name":"Celestial Solace Band","item__PG_CelestialStarfallPendant__gameplay":"Become invisible for 3 seconds on use | +6.5% Damage to NPCs | +5% Holy Damage","item__PG_CelestialStarfallPendant__lore":"A pendant adorned with a celestial gem, summoning celestial energy.","item__PG_CelestialStarfallPendant__name":"Celestial Starfall Pendant","item__PG_CultistsMask__name":"Cultist\'s Mask","item__PG_CultistsMask__lore":"Those who fell victim to the corruption saught to hide their appearance as the corruption changed their very being.","item__PG_CultistsMask__gameplay":"Become invisible for 6 seconds on use | INCOGNITO: Hides your loot and location messages from the rest of the world | +15% Attack Speed","item__PG_DepthStrider__name":"Depth Strider","item__PG_DepthStrider__lore":"A weak enchantment clings to this cloak making walking in water easier.","item__PG_DepthStrider__gameplay":"+5% Movement speed while walking in water","item__PG_GoldenGauntlets__name":"Golden Gauntlets","item__PG_GoldenGauntlets__lore":"Fit for looters, these gauntlets seem to help you find extra gold.","item__PG_GoldenGauntlets__gameplay":"+10% gold from chests","item__PG_BeastVanquisherBoots__name":"Beast Vanquisher Boots","item__PG_BeastVanquisherBoots__lore":"Worn by those on the frontlines of battle. These boots enabled the enemy\'s swift demise.","item__PG_BeastVanquisherBoots__gameplay":"+12% Movement Speed | +45 Maximum Health | +25% NPC Damage | -12% Player Damage | -12% Projectile Distance","item__PG_CloakOfModestApproachability__gameplay":"Your projectiles travel 6% farther | Adds 30 seconds to your extraction timer on use","item__PG_CloakOfModestApproachability__lore":"Others seem drawn to you and are unsure why.","item__PG_CloakOfModestApproachability__name":"Cloak of Modest Approachability","item__PG_CloudedDarkness__gameplay":"+20% Ethereal | +10% Shadow Damage | +13% Shadow Defence","item__PG_CloudedDarkness__lore":"When the time came and the deed was done, a cloud of darkness washed over Malachi and was imbued into this ring.","item__PG_CloudedDarkness__name":"Clouded Darkness","item__PG_CompactedLimeGreenRing__gameplay":"Your projectiles travel 5% farther | +7% Toxic Damage","item__PG_CompactedLimeGreenRing__lore":"Held by the successor to a dragon\'s throne.","item__PG_CompactedLimeGreenRing__name":"Compacted Lime Green Ring","item__PG_CopperWristband__gameplay":"+6.5% Physical Defence","item__PG_CopperWristband__lore":"A comically large ring that fits better as a wristband... One can only imagine the size of the creature that wore this as a ring.","item__PG_CopperWristband__name":"Copper Wristband","item__PG_CoralReef__gameplay":"+8.5% Movement Speed while walking in water | Extract 10% slower","item__PG_CoralReef__lore":"Created as a gift for the mermaid princess.","item__PG_CoralReef__name":"Coral Reef","item__PG_CorruptedTearRing__gameplay":"Become invisible for 5 seconds on use | +7% Leech from all damage you deal to players | -7% Chaos Defence | +9% Chaos Damage | +9% Lightning Damage","item__PG_CorruptedTearRing__lore":"A single tear was shed before the corruption took hold... \\"Wha-what have I become!?\\".","item__PG_CorruptedTearRing__name":"Corrupted Tear Ring","item__PG_CursedEternityRing__gameplay":"Grants 5 seconds of +30% movement speed when used | REVIVE with 48% HP when you die (does not stack with other revive items) | +12% Gold from chests | +8.5% leech from all damage dealth to players | Your health drains all the time","item__PG_CursedEternityRing__lore":"A symbol of eternal damnation. It binds to its wearing, cursing them for eternity but giving them great power.","item__PG_CursedEternityRing__name":"Cursed Eternity Ring","item__PG_CursedSignet__gameplay":"+20% Leech from all damage you deal to players","item__PG_CursedSignet__lore":"A malevolent presence emanates from this ring, bringing misfortune to all who wear it.","item__PG_CursedSignet__name":"Cursed Signet","item__PG_DeathwhisperWrap__gameplay":"+13% Damage to NPCs | +13% Chaos Defence | +10% Toxic Damage","item__PG_DeathwhisperWrap__lore":"As the blade plunged into his heart and all become black, a faint whisper was heard: \'It is not yet time for me to claim your soul.\'","item__PG_DeathwhisperWrap__name":"Deathwhisper Wrap","item__PG_DreadmorneLoop__gameplay":"Grants 3 seconds of +30% movement speed when used (5 Charges) | -5% Attack Speed | -6.5% Holy Defence | +10% Chaos Damage","item__PG_DreadmorneLoop__lore":"This ring instills fear in the hearts of enemies, inspiring terror and causing dread.","item__PG_DreadmorneLoop__name":"Dreadmorne Loop","item__PG_DreamcasterDrapery__gameplay":"+6.5% Damage to NPCs | +6.5% Chaos Damage","item__PG_DreamcasterDrapery__lore":"Born of nightmares, this vestment is said to manipulate the subsconcious","item__PG_DreamcasterDrapery__name":"Dreamcaster Drapery","item__PG_EbonfireRobelet__gameplay":"Your projectiles travel 6% further","item__PG_EbonfireRobelet__lore":"Engulfs its wearer in an aura of smoldering shadows, granting protection against elemental harm.","item__PG_EbonfireRobelet__name":"Ebonfire Robelet","item__PG_ElvenGildedGuardian__gameplay":"Extract 5% faster","item__PG_ElvenGildedGuardian__lore":"A beautifully-crafted, golden ivy-adorned belt that enhances the wearer\'s nimbleness and repels adversaries with elven finesse.","item__PG_ElvenGildedGuardian__name":"Elven Gilded Guardian","item__PG_EmbergraspRing__gameplay":"+10 Maximum Health","item__PG_EmbergraspRing__lore":"Flames dance and flicker upon your touch, scorching your enemies.","item__PG_EmbergraspRing__name":"Embergrasp Ring","item__PG_EnchantedElixirNecklace__gameplay":"Adds 60 seconds to your extraction timer on use | REVIVE with 60% HP when you die (does not stack with other revive items)","item__PG_EnchantedElixirNecklace__lore":"A necklace containing a vial of enchanted elixir, enhancing magical potency.","item__PG_EnchantedElixirNecklace__name":"Enchanted Elixir Necklace","item__PG_EnigmaLoop__gameplay":"INCOGNITO: Hides your loot and location messages from the rest of the world | +5% Chaos Damage","item__PG_EnigmaLoop__lore":"An enigmatic ring that confounds foes, twisting reality in your favor.","item__PG_EnigmaLoop__name":"Enigma Loop","item__PG_EnigmaticShadowweaveRing__gameplay":"Heals 20HP on use (1 Charge) | +5.5% Damage to Players | -9% Damage to NPCs","item__PG_EnigmaticShadowweaveRing__lore":"Infused with enigmatic enchantments, this ring weaves together threads of darkness.","item__PG_EnigmaticShadowweaveRing__name":"Enigmatic Shadowweave Ring","item__PG_EssenceConduit__gameplay":"+9% Damage to NPCs | -4% Damage to players","item__PG_EssenceConduit__lore":"Grants power to those who tend to nature.","item__PG_EssenceConduit__name":"Essence Conduit","item__PG_EverlastingSpiritCircle__gameplay":"Grants 3 seconds of +25% movement speed when used (2 Charges) | +10% Gold from chests","item__PG_EverlastingSpiritCircle__lore":"Crafted by ancient sorcery, this ring acts as a conduit for spiritual energy.","item__PG_EverlastingSpiritCircle__name":"Everlasting Spirit Circle","item__PG_FrostFireRing__gameplay":"+7% Fire Damage | +8.5% Frost Defense | -6.5% Fire Defense","item__PG_FrostFireRing__lore":"A ring inset with elemental stones, that can imbue attacks with additional power -\\"Cause you\'re hot then you\'re cold\\"","item__PG_FrostFireRing__name":"Frostfire Ring","item__PG_FrostbiteLoop__gameplay":"+6% Movement Speed","item__PG_FrostbiteLoop__lore":"A chilling aura surrounds this ring, freezing the hearts of foes with a touch.","item__PG_FrostbiteLoop__name":"Frostbite Loop","item__PG_FrostfireShardPendant__gameplay":"Take 10% less damage while extracting | +8% Damage to Players","item__PG_FrostfireShardPendant__lore":"A pendant housing a shard infused with both icy and fiery energies.","item__PG_FrostfireShardPendant__name":"Frostfire Shard Pendant","item__PG_GineshsBottleOpener__gameplay":"Your health drains all the time | +12% Damage to ALL damage types | +8.5% Movement Speed | Your projectiles travel 8.5% farther","item__PG_GineshsBottleOpener__lore":"A ring that unlocks both the cause of, and solution to, all of life\'s problems.","item__PG_GineshsBottleOpener__name":"Ginesh\'s Bottle Opener","item__PG_GirdleOfTheGoldenNecromancer__gameplay":"Heals 10HP when used | +6% Movement Speed","item__PG_GirdleOfTheGoldenNecromancer__lore":"An opulent, gold-encrusted belt that confers a gilded aura of necromantic protection, warding off injury.","item__PG_GirdleOfTheGoldenNecromancer__name":"Girdle of the Golden Necromancer","item__PG_GoldPlatedCape__gameplay":"+4% Damage to players","item__PG_GoldPlatedCape__lore":"This somehow counts as armor","item__PG_GoldPlatedCape__name":"Gold Plated Cape","item__PG_GolemsGrasp__gameplay":"+30 Maximum Health | -6% Movement Speed | -6% Movement Speed while walking in water","item__PG_GolemsGrasp__lore":"The power of stone surges through this ring, turning your skin into armor.","item__PG_GolemsGrasp__name":"Golem\'s Grasp","item__PG_GuardiansChainmailCollar__gameplay":"Heals 15HP when used ( 3 Uses)| -5% Attack Speed","item__PG_GuardiansChainmailCollar__lore":"A sturdy collar of interlocking chainmail, providing stalwart protection.","item__PG_GuardiansChainmailCollar__name":"Guardian\'s Chainmail Collar","item__PG_HeirloomCloak__gameplay":"Grants 2 seconds of +20% movement speed on use (3 Uses).","item__PG_HeirloomCloak__lore":"A simple cloak passed down through your family for generations.","item__PG_HeirloomCloak__name":"Heirloom Cloak","item__PG_IceQueensEarrings__gameplay":"Grants 3 seconds of +20% movement speed on use | +4% Damage to players | +6.5% Frost Defence | +5% Frost Damage","item__PG_IceQueensEarrings__lore":"Earrings befitting of the Queen of Ice herself. Cold to the touch.","item__PG_IceQueensEarrings__name":"Ice Queen\'s Earrings","item__PG_InfiniteLoop__gameplay":"Adds 45 seconds to your extraction timer on use | -10 Maximum Health | Your health regenerates all the time","item__PG_InfiniteLoop__lore":"Able to convert life energy to mana, and mana into life energy.","item__PG_InfiniteLoop__name":"Infinite Loop","item__PG_IronFoxLocket__gameplay":"INSPECTION: Reveals information about your opponents | +13% Defence to ALL damage types | +30 Maximum Health","item__PG_IronFoxLocket__lore":"Legends speak of a fox, donning iron armor, renowned for outwitting even the cleverest hunters.","item__PG_IronFoxLocket__name":"Iron Fox Locket","item__PG_JaysesRing__gameplay":"+9.5% Damage to players | -9% Damage to NPCs | +15% Ethereal | +12% Lightning Damage | +12% Fire Damage","item__PG_JaysesRing__lore":"The ring of the famous mage Jayse.","item__PG_JaysesRing__name":"Jayse\'s Ring","item__PG_LittleCompactedLimeGreenRing__gameplay":"Your projectiles travel 6% further | +13% Toxic Defence","item__PG_LittleCompactedLimeGreenRing__lore":"Once belonged to a luxourious dragon kin.","item__PG_LittleCompactedLimeGreenRing__name":"Little Compacted Lime Green Ring","item__PG_MementoMoriLocket__gameplay":"-6.5% Chaos Defence | +8.5% Shadow Defence","item__PG_MementoMoriLocket__lore":"A haunting locket that serves as a reminder of mortality, strengthening resolve.","item__PG_MementoMoriLocket__name":"Memento Mori Locket","item__PG_MidnightsVeilBand__gameplay":"Become Invisible for 5 seconds on use (2 Charges)","item__PG_MidnightsVeilBand__lore":"Worn with strands of shadow, this cloak enhances its wearer stealth.","item__PG_MidnightsVeilBand__name":"Midnight\'s Veil","item__PG_MunchkinsRing__gameplay":"+7% Movement Speed | -10 Max Health","item__PG_MunchkinsRing__lore":"Its previous owner had stubby little legs but they never slowed him down.","item__PG_MunchkinsRing__name":"Munchkin\'s Ring","item__PG_NaturesAureateBarrier__gameplay":"Adds 30 seconds to your extraction timer on use (2 Uses) | -5.5% Damage to Players | INCOGNITO: Hides your loot and location messages from the rest of the world","item__PG_NaturesAureateBarrier__lore":"A robust, gold-woven belt infused with the fortitude of ancient trees, granting the wearer a shield of gleaming natural force.","item__PG_NaturesAureateBarrier__name":"Nature\'s Aureate Barrier","item__PG_NecroticGraspTalisman__gameplay":"Grants 5 seconds of +30% movement speed when used | Your health drains all the time | +12% Shadow Damage","item__PG_NecroticGraspTalisman__lore":"A talisman pulsating with necromantic power, commanding the forces of the undead.","item__PG_NecroticGraspTalisman__name":"Necrotic Grasp Talisman","item__PG_NecroticSignet__gameplay":"Adds 45 seconds to your extraction timer on use | +13% Holy Defence","item__PG_NecroticSignet__lore":"A macabre symbol of death and decay, it drains vitality from your foes.","item__PG_NecroticSignet__name":"Necrotic Gambeson","item__PG_PendantOfAncientWisdom__gameplay":"-7% Damage to Players | +8.75% Damage to NPCs | +8.5% Arcane Defence | +7% Arcane Damage","item__PG_PendantOfAncientWisdom__lore":"An age-old pendant that imparts profound knowledge to the one who wears it.","item__PG_PendantOfAncientWisdom__name":"Pendant of Ancient Wisdom","item__PG_PhantomBand__gameplay":"+30% Ethereal","item__PG_PhantomBand__lore":"Wearing this ethereal ring allows you to walk unseen among the living.","item__PG_PhantomBand__name":"Phantom Band","item__PG_PhoenixFeatherTorque__gameplay":"REVIVE with 60% HP when you die (does not stack with other revive items) | +60 Maximum Health | +19.5% Fire Defence | +19.5% Frost Defence | -19.5% Toxic Defence | -15% Attack Speed","item__PG_PhoenixFeatherTorque__lore":"A majestic torque adorned with a phoenix feather, granting rebirth and renewal.","item__PG_PhoenixFeatherTorque__name":"Phoenix Feather Torque","item__PG_PhoenixsRespite__gameplay":"Become invisible for 3 seconds on use | +6.5% Fire Defence | +5% Fire Damage","item__PG_PhoenixsRespite__lore":"They who willingly threw themselves upon the flame were reborn with greater power than before.","item__PG_PhoenixsRespite__name":"Phoenix\'s Respite","item__PG_PurpletratorsRing__gameplay":"+3% Leech from all damage you deal to players","item__PG_PurpletratorsRing__lore":"Those who dared laugh at this ring\'s name were often killed by its wearer.","item__PG_PurpletratorsRing__name":"Purpletrator\'s Ring","item__PG_QuintsFishingGarb__gameplay":"+5% Attack Speed","item__PG_QuintsFishingGarb__lore":"A ring that creates an endless amount of fishing grubs, often distributed unwittingly to party members.","item__PG_QuintsFishingGarb__name":"Quint\'s Fishing Garb ","item__PG_ResilientHeartstone__gameplay":"Heals 10HP when used | +5% Gold from chests | Take 5% less damage while extracting | INSPECTION: Reveals information about your opponents","item__PG_ResilientHeartstone__lore":"A heart-shaped gem that instills unwavering fortitude in the wearer.","item__PG_ResilientHeartstone__name":"Resilient Heartstone","item__PG_RingOfConstellations__gameplay":"Your projectiles travel 6% farther","item__PG_RingOfConstellations__lore":"Rumor has it a warrior of the night owned this and it provided guidance under the dark of night.","item__PG_RingOfConstellations__name":"Ring of Constellations","item__PG_RingOfTheOneHandedWarrior__gameplay":"-10 Maximum Health | +12% Physical Damage | +12% Bleed Damage","item__PG_RingOfTheOneHandedWarrior__lore":"You only need one hand to wear a ring.","item__PG_RingOfTheOneHandedWarrior__name":"Ring of the One Handed Warrior","item__PG_RingOfViolentViolet__gameplay":"+30 Maximum Health | +17% Damage to ALL damage types | -15% Defence to ALL damage types","item__PG_RingOfViolentViolet__lore":"You feel a sudden surge of power and bloodlust as you equip this ring.","item__PG_RingOfViolentViolet__name":"Ring of Violent Violet","item__PG_RuneboundRing__gameplay":"+5% Movement Speed while walking in water | +7% Arcane Damage","item__PG_RuneboundRing__lore":"Etched with ancient runes, it channels arcane energies to empower the wearer.","item__PG_RuneboundRing__name":"Runebound Ring","item__PG_SerpentsCoilChoker__gameplay":"INSPECTION: Reveals information about your opponents","item__PG_SerpentsCoilChoker__lore":"Coiling around the neck, it imbues the wearer with serpentine grace and cunning.","item__PG_SerpentsCoilChoker__name":"Serpent\'s Coil Choker","item__PG_SerpentsRing__gameplay":"+6.5% Toxic Resistance","item__PG_SerpentsRing__lore":"A ring made from the scales of a serpent, enchanged to protect the wearer from poison.","item__PG_SerpentsRing__name":"Serpent\'s Ring","item__PG_ShieldbearersAmulet__gameplay":"Heals 10HP when used (1 Charge) | +6.5% damage to NPCs","item__PG_ShieldbearersAmulet__lore":"Emblazoned with a heraldic crest, it bolsters the wearer\'s defenses.","item__PG_ShieldbearersAmulet__name":"Shieldbearer\'s Amulet","item__PG_SoulBindingRing__gameplay":"REVIVE with 40% HP when you die | +10% Holy Damage","item__PG_SoulBindingRing__lore":"This ring has three stones. One is clear and see through. The other two contain an odd, golden swirling mist.","item__PG_SoulBindingRing__name":"Soul Binding Ring","item__PG_SoulforgeRing__gameplay":"EXTRACT when used, no matter where you are | Extract 10% slower | This item is destroyed when fully used","item__PG_SoulforgeRing__lore":"Infused with the essence of tormented souls, this ring increases your physical and mystical prowess.","item__PG_SoulforgeRing__name":"Soulforge Ring","item__PG_SoulshackleVeil__gameplay":"Grants 3 seconds of +25% movement speed when used (3 Charges) | +8.5% Ethereal | -5% Movement Speed","item__PG_SoulshackleVeil__lore":"Bound by dark magic, it ensnares the souls of the fallen, connecting you to the spirit world.","item__PG_SoulshackleVeil__name":"Soulshackle Veil","item__PG_SoulstoneReliquary__gameplay":"Become invisible for 4 seconds on use | Take 5% less damage while extracting | REVIVE with 20% HP when you die (does not stack with other revive items) | +5% Leech from all damage you deal to players","item__PG_SoulstoneReliquary__lore":"A relic necklace that allows the wearer to harness and control captured souls.","item__PG_SoulstoneReliquary__name":"Soulstone Reliquary","item__PG_StormweaverCloak__gameplay":"INCOGNITO: Hides your loot and location messages from the rest of the world","item__PG_StormweaverCloak__lore":"Harness the fury of thunderstorms, commanding the wrath of the skies.","item__PG_StormweaverCloak__name":"Stormweaver Loop","item__PG_SummonersSign__gameplay":"+10 Maximum Health","item__PG_SummonersSign__lore":"Used by summoners to gather mana from the land.","item__PG_SummonersSign__name":"Summoner\'s Sign","item__PG_TalismanOfVeiledShadows__gameplay":"Become invisible for 3 seconds on use | -5% Movement Speed | +8.5% Chaos Defence | +8.5% Shadow Defence","item__PG_TalismanOfVeiledShadows__lore":"A mystical talisman that cloaks the wearer in ephemeral darkness.","item__PG_TalismanOfVeiledShadows__name":"Talisman of Veiled Shadows","item__PG_TantrumsLuckyLoop__gameplay":"+3% Movement Speed","item__PG_TantrumsLuckyLoop__lore":"A ring that makes you as fast as a greyhound, and just as lazy.","item__PG_TantrumsLuckyLoop__name":"Tantrum\'s Lucky Loop","item__PG_VampiricSeal__gameplay":"Heals 7HP when used (2 Charges) | +3% Leech from all damage you deal to players","item__PG_VampiricSeal__lore":"Feeding on the life force of your enemies, it grants vitality with every strike.","item__PG_VampiricSeal__name":"Vampiric Vestement","item__PG_VeilstormCirclet__gameplay":"Heals 30HP when used | -10% Attack Speed | +12% Nature Damage","item__PG_VeilstormCirclet__lore":"Holds the power of a raging tempest. Grants its wearer control over wind and lightning.","item__PG_VeilstormCirclet__name":"Veilstorm Cape","item__PG_VenomousBite__gameplay":"Adds 30 seconds to your extraction timer on use | Your health drains all the time | +10% Toxic Damage","item__PG_VenomousBite__lore":"Armor worn by ancient plague doctors","item__PG_VenomousBite__name":"Venomous Bite","item__PG_WindspeakersRing__gameplay":"INSPECTION: Reveals information about your opponents | +7% Nature Damage","item__PG_WindspeakersRing__lore":"Once owned by a powerful mage who was pursued around the world by his own shadow, this ring is said to have the power to control the winds.","item__PG_WindspeakersRing__name":"Windspeaker\'s Ring","item__PG_Wraithband__gameplay":"+8.5% Ethereal | 7% Holy Damage | -10 Maximum Health","item__PG_Wraithband__lore":"Phantasmal energy courses through this ring, granting spectral powers.","item__PG_Wraithband__name":"Wraithband","item__VT_AbyssalShard__gameplay":"","item__VT_AbyssalShard__lore":"A black chunk of stone gathered from the underworld.","item__VT_AbyssalShard__name":"Abyssal Shard","item__VT_Amber__gameplay":"","item__VT_Amber__lore":"This stone has a deep orange tinge to it.","item__VT_Amber__name":"Amber","item__VT_BardsDiary__gameplay":"","item__VT_BardsDiary__lore":"This song is scribbled with poetry and musical scores.","item__VT_BardsDiary__name":"Bard\'s Songbook","item__VT_BrokenIronBand__gameplay":"","item__VT_BrokenIronBand__lore":"A simple iron ring, that has lost its lusture.","item__VT_BrokenIronBand__name":"Broken Iron Band","item__VT_BrokenSword__gameplay":"","item__VT_BrokenSword__lore":"This sword has seen better days.","item__VT_BrokenSword__name":"Broken Iron Sword","item__VT_Cabbage__gameplay":"","item__VT_Cabbage__lore":"You\'re cabbage, you\'ll always be cabbage.","item__VT_Cabbage__name":"Cabbage","item__VT_ChunkOfIron__gameplay":"","item__VT_ChunkOfIron__lore":"A small chunk of iron, a blacksmith might be able to make something with this.","item__VT_ChunkOfIron__name":"Chunk of Iron","item__VT_CubicZirconia__gameplay":"","item__VT_CubicZirconia__lore":"A square chunk of a Zirconia","item__VT_CubicZirconia__name":"Cubic Zirconia","item__VT_Diamond__gameplay":"A rare goods collector would probably be interested in this.","item__VT_Diamond__lore":"A precious gemstone.","item__VT_Diamond__name":"Diamond","item__VT_DukesDiary__gameplay":"","item__VT_DukesDiary__lore":"The musings of a once powerful Duke.","item__VT_DukesDiary__name":"Duke of Ert\'s Diary","item__VT_EmeraldDust__gameplay":"","item__VT_EmeraldDust__lore":"An emerald that has been turned into a fine powder","item__VT_EmeraldDust__name":"Emerald Dust","item__VT_Emerald__gameplay":"","item__VT_Emerald__lore":"A chunk of an Emerald.","item__VT_Emerald__name":"Emerald","item__VT_EverlastingCandle__gameplay":"","item__VT_EverlastingCandle__lore":"This candle mysteriously will burn forever.","item__VT_EverlastingCandle__name":"Everlasting Candle","item__VT_Eyeball__gameplay":"","item__VT_Eyeball__lore":"The eye of a slain beast.","item__VT_Eyeball__name":"Eyeball","item__VT_FangOfTheBloodMoon__gameplay":"","item__VT_FangOfTheBloodMoon__lore":"This blood covered fang is from a creature that prowls only when the sky is bleeding.","item__VT_FangOfTheBloodMoon__name":"Fang of the Blood Moon","item__VT_Fossil__gameplay":"","item__VT_Fossil__lore":"The remains of an ancient being is permanently imprinted on this rock.","item__VT_Fossil__name":"Fossil","item__VT_GhostPlasma__gameplay":"","item__VT_GhostPlasma__lore":"This viscous liquid glows with etheral energies.","item__VT_GhostPlasma__name":"Ghost Plasma","item__VT_GoblinCloth__gameplay":"","item__VT_GoblinCloth__lore":"This cloth is very dirty and has some blood on it.","item__VT_GoblinCloth__name":"Goblin\'s Loin Cloth","item__VT_GoldNugget__gameplay":"","item__VT_GoldNugget__lore":"A small chunk of gold. Probably worth a lot.","item__VT_GoldNugget__name":"Gold Nugget","item__VT_OgreEntrails__gameplay":"","item__VT_OgreEntrails__lore":"Entrails from the insides of an Ogre.","item__VT_OgreEntrails__name":"Ogre Entrails","item__VT_OnyxGem__gameplay":"A jewel expert might be interested in this.","item__VT_OnyxGem__lore":"A rare gem made of onyx.","item__VT_OnyxGem__name":"Onyx Gem","item__VT_PileOfAsh__gameplay":"","item__VT_PileOfAsh__lore":"Just a small pile of ashes.","item__VT_PileOfAsh__name":"Pile of Ashes","item__VT_Potato__gameplay":"Boil \'em, Mash\'em, Stick \'em in a stew.","item__VT_Potato__lore":"You\'ve probably never heard of them.","item__VT_Potato__name":"Potato","item__VT_QuartzRing__gameplay":"","item__VT_QuartzRing__lore":"Inlaid with a chunck of polished quartz. Not worth much but at least it\'s something.","item__VT_QuartzRing__name":"Quartz Ring","item__VT_RatFur__gameplay":"","item__VT_RatFur__lore":"A gross clump of hair, probably ridden with diseases.","item__VT_RatFur__name":"Clump of Rat Fur","item__VT_RedMushroom__gameplay":"","item__VT_RedMushroom__lore":"This mushroom is commonly dried and turned into a powder used for helping illness.","item__VT_RedMushroom__name":"Red Mushroom","item__VT_RingOfNearPerfection__gameplay":"","item__VT_RingOfNearPerfection__lore":"It\'d be better if it had magic.","item__VT_RingOfNearPerfection__name":"Ring of Near Perfection","item__VT_RubyDust__gameplay":"","item__VT_RubyDust__lore":"A ruby that has been crushed into a fine powder.","item__VT_RubyDust__name":"Ruby Dust","item__VT_Ruby__gameplay":"","item__VT_Ruby__lore":"A chunk of a deep red ruby.","item__VT_Ruby__name":"Ruby","item__VT_SapphireDust__gameplay":"","item__VT_SapphireDust__lore":"A sapphire that has been turned into a fine powder","item__VT_SapphireDust__name":"Sapphire Dust","item__VT_Sapphire__gameplay":"","item__VT_Sapphire__lore":"A deep blue chunk of a sapphire","item__VT_Sapphire__name":"Sapphire","item__VT_SkeletonFemur__gameplay":"","item__VT_SkeletonFemur__lore":"I guess there is a skeleton with one leg somewhere.","item__VT_SkeletonFemur__name":"Skeleton\'s Femur","item__VT_Skull__gameplay":"","item__VT_Skull__lore":"A skull. Probably from ones of these roaming skeletons.","item__VT_Skull__name":"Skull","item__VT_StellarWeaveRing__gameplay":"","item__VT_StellarWeaveRing__lore":"A ring made of woven branches. It\'s unremarkable.","item__VT_StellarWeaveRing__name":"Stellar Weave Ring","item__VT_TreantBranch__gameplay":"","item__VT_TreantBranch__lore":"This piece of wood is wriggling a little bit. Weird","item__VT_TreantBranch__name":"Treant Branch","item__VT_WellWornRing__gameplay":"","item__VT_WellWornRing__lore":"This simple ring has a number of scuffs and scratches visible on its surface.","item__VT_WellWornRing__name":"Well Worn Ring","item__VT_WhispersOfTheVoid__gameplay":"","item__VT_WhispersOfTheVoid__lore":"Madness is common amongst those who hear his voice. And who doesn\'t in this time of crisis?","item__VT_WhispersOfTheVoid__name":"Whispers of the Void Vol. 1","item__W_ApprenticesStaff__gameplay":"Places a visible trap near your feet that deals physical damage.","item__W_ApprenticesStaff__lore":"A novice wizards staff commonly used for training.","item__W_ApprenticesStaff__name":"Apprentice\'s Staff","item__W_ArchmagesSidekick__gameplay":"Places a visible trap near your feet that deals arcane damage.","item__W_ArchmagesSidekick__lore":"Little is known about this staff, other than it was transmuted into existence by the Archmage of the Arcane Order.","item__W_ArchmagesSidekick__name":"Archmage\'s Sidekick","item__W_BeesOnAStick__gameplay":"Places a visible trap near your feet that deals nature damage.","item__W_BeesOnAStick__lore":"A staff adorned with a beehive, buzzing with the power of swarming bees, delivering stinging spells to adversaries.","item__W_BeesOnAStick__name":"Bee\'s On A Stick","item__W_BlackDahliaWand__gameplay":"Fires shadow projectiles.","item__W_BlackDahliaWand__lore":"Its dark nature corrupts the hearts of those who dare to wield it.","item__W_BlackDahliaWand__name":"Black Dahlia Wand","item__W_BlazeRod__gameplay":"Fires blazes!","item__W_BlazeRod__lore":"Found in the depths of the nether, this rod is imbued with the soul of a Blaze.","item__W_BlazeRod__name":"Blaze Rod","item__W_Bloodrider__gameplay":"Shoots arrows that cause heavy bleeding damage.","item__W_Bloodrider__lore":"Fashioned from fallen warriors\' bones, this malevolent bow drains life with each arrow, leaving behind a trail of crimson despair.","item__W_Bloodrider__name":"Bloodrider","item__W_BrokenDeathstick__gameplay":"Fires chaos bolts that deal moderate damage.","item__W_BrokenDeathstick__lore":"It would be deadly... if it wasn\'t broken.","item__W_BrokenDeathstick__name":"Broken Death Stick","item__W_CandlelightStaff__gameplay":"Places a visible trap near your feet that deals fire damage.","item__W_CandlelightStaff__lore":"A staff that emits a soft glow, illuminating the darkness.","item__W_CandlelightStaff__name":"Candlelight Staff","item__W_CelestialBow__gameplay":"A celestial emissary has infused these arrows with the cold of the void.","item__W_CelestialBow__lore":"Gifted by ancient deities, this radiant bow channels divine blessings, piercing even the most formidable defenses.","item__W_CelestialBow__name":"Celestial Bow","item__W_CrudeCrossbow__gameplay":"Fires a basic low damage bolt that deals physical damage.","item__W_CrudeCrossbow__lore":"A crude crossbow crafted from wood scraps and twine. It is not very powerful, but it will do.","item__W_CrudeCrossbow__name":"Crude Crossbow","item__W_DarylsInstinct__gameplay":"Fires powerful bolts that inflict bleed damage.","item__W_DarylsInstinct__lore":"A crossbow used by the legendary hunter Daryl.","item__W_DarylsInstinct__name":"Daryl\'s Instinct","item__W_DavidBowie__gameplay":"Shoots weak physical projectiles.","item__W_DavidBowie__lore":"Transforms you into an instant star!","item__W_DavidBowie__name":"David Bowie","item__W_DemonsEye__gameplay":"Places a visible trap near your feet that deals shadow damage.","item__W_DemonsEye__lore":"this staff invokes the ominous whispers of the nether realm, allowing wielders to pierce through illusions and reveal the hidden truths that lie in the shadows.","item__W_DemonsEye__name":"Demon\'s Eye","item__W_DivineWind__gameplay":"Shoots powerful holy arrows.","item__W_DivineWind__lore":"Forged in sacred mountain sanctuaries, this ethereal bow propels arrows with otherworldly gusts, tearing through obstacles and foes.","item__W_DivineWind__name":"Divine Wind","item__W_DragonsBreath__gameplay":"Creates a torrent of flames in front of the caster.","item__W_DragonsBreath__lore":"I cast... Fireball?","item__W_DragonsBreath__name":"Dragon\'s Breath","item__W_EldritchBlasters__gameplay":"Rapidly shoots shadow bolts.","item__W_EldritchBlasters__lore":"Dual crossbows imbued with the power of shadow.","item__W_EldritchBlasters__name":"Eldritch Blasters","item__W_Emberstrike__gameplay":"Shoots powerful fire arrows.","item__W_Emberstrike__lore":"Forged in the heart of a volcano, this obsidian bow unleashes scorching arrows, leaving behind trails of smoldering devastation.","item__W_Emberstrike__name":"Emberstrike","item__W_FairyBow__gameplay":"Shoots arrows infused with fairy magic.","item__W_FairyBow__lore":"Infuses the arrows fired from this bow with random powerful energy","item__W_FairyBow__name":"Fairy Bow","item__W_FairyStaff__gameplay":"Places a visible trap near your feet that deals nature damage.","item__W_FairyStaff__lore":"Belonged to a fairy queen.","item__W_FairyStaff__name":"Fairy Staff","item__W_FathersBane__gameplay":"Rapidly shoots weak, poison-tipped bolts.","item__W_FathersBane__lore":"Used by a mournful son who had no choice but to slay his father.","item__W_FathersBane__name":"Father\'s Bane","item__W_FlamespitterStaff__gameplay":"Places a visible trap near your feet that deals fire damage.","item__W_FlamespitterStaff__lore":"Furious flames burst forth from this staff.","item__W_FlamespitterStaff__name":"Flamespitter Staff","item__W_FrostedTips__gameplay":"Deals frost damage.","item__W_FrostedTips__lore":"Holy moly, Stromboli!","item__W_FrostedTips__name":"Frosted Tips","item__W_GuardsCrossbow__gameplay":"Easier and faster to load than a normal crossbow.","item__W_GuardsCrossbow__lore":"Crossbow used by the city guards of the Arcane Order.","item__W_GuardsCrossbow__name":"Guards Crossbow","item__W_HibidyKibity__gameplay":"Shoots deadly chaos projectiles","item__W_HibidyKibity__lore":"A wand embedded with the fel energy of the killing curse.","item__W_HibidyKibity__name":"Hibidy Kibity","item__W_IcewindWand__gameplay":"Create a torrent of freezing clouds in front of the caster.","item__W_IcewindWand__lore":"Is able to create the absolute worst weather.","item__W_IcewindWand__name":"Ice Wind Wand","item__W_IronStaff__gameplay":"Places a visible trap near your feet that deals physical damage.","item__W_IronStaff__lore":"A staff made of iron, used by the guards of the Arcane Order.","item__W_IronStaff__name":"Iron Staff","item__W_KingBible__gameplay":"Launch powerful holy bibles at your opponents.","item__W_KingBible__lore":"A revered, gilded tome holding sacred words of ancient monarchs, granting authority and shaping destinies.","item__W_KingBible__name":"King Bible","item__W_Deathstick__gameplay":"Brings death by shooting rapid short ranged projectiles, at the cost of slowing the user.","item__W_Deathstick__lore":"Legend has it that this powerful weapon was dropped by a mysterious figure centuries ago.","item__W_Deathstick__name":"Deathstick","item__W_BookOfTongues__gameplay":"Shoots the strongest fire from the depths of hell. Has a VERY long cooldown","item__W_BookOfTongues__lore":"An illegible name can be seen etched upon its pages. All you can make out is the letter \\"M\\".","item__W_BookOfTongues__name":"Book of Tongues","item__W_LichsStaff__gameplay":"Places a visible trap near your feet that deals shadow damage.","item__W_LichsStaff__lore":"Wielded by dark necromancers, this staff harnesses the unholy powers of the undead, bringing death and decay to all it touches.","item__W_LichsStaff__name":"Lich\'s Staff","item__W_FrostFlicker__gameplay":"Places a visible trap near your feet that deals frost damage.","item__W_FrostFlicker__lore":"A staff with the ability to freeze water in the surrounding area. A weaker version of this is often used during a holiday season.","item__W_FrostFlicker__name":"Frost Flicker","item__W_MagicalWand__gameplay":"Fires magical arcane bolts.","item__W_MagicalWand__lore":"In the name of the moon, I\'ll punish you!","item__W_MagicalWand__name":"Magical Wand","item__W_MidasStaff__gameplay":"Places a visible trap near your feet that deals lightning damage.","item__W_MidasStaff__lore":"The staff of the legendary King Midas.","item__W_MidasStaff__name":"Midas Staff","item__W_MoonShadow__gameplay":"Rapidly shoots shadow arrows.","item__W_MoonShadow__lore":"Bestowed by moon spirits, this mystical bow shoots arrows that travel through shadows, striking from unexpected angles.","item__W_MoonShadow__name":"Moon Shadow","item__W_NaturesReturn__gameplay":"Harness the power of the forest to deal large amounts of nature damage to your opponents.","item__W_NaturesReturn__lore":"A tome adorned with foliage, channeling the forces of nature for growth, healing, and storms.","item__W_NaturesReturn__name":"Nature\'s Return","item__W_NightStick__gameplay":"Fires projectiles colder than the night.","item__W_NightStick__lore":"Used by those who intend to keep the peace.","item__W_NightStick__name":"Night Stick","item__W_PharaohsStaff__gameplay":"Places a visible trap near your feet that deals holy damage.","item__W_PharaohsStaff__lore":"Excavated from the tomb of an ancient Pharaoh, this staff is said to have been used to summon the dead.","item__W_PharaohsStaff__name":"Pharaoh\'s Staff","item__W_PhoenixWing__gameplay":"Shoots arrows infused with the flames of a fallen phoenix.","item__W_PhoenixWing__lore":"Crafted from phoenix feathers, this radiant bow channels fiery rebirth, igniting arrows with searing flames.","item__W_PhoenixWing__name":"Phoenix Wing","item__W_PoseidonsWand__gameplay":"Shoots fish.","item__W_PoseidonsWand__lore":"FIIIIIIIIIIIIIIIISH!","item__W_PoseidonsWand__name":"Poseidon\'s Wand","item__W_QuincyBow__gameplay":"Fires arrows infused with electrical energy.","item__W_QuincyBow__lore":"Shoots arrows made from the spirit energy of the wielder.","item__W_QuincyBow__name":"Quincy Bow","item__W_SilentShadow__gameplay":"Fires arrows imbued with shadow energy.","item__W_SilentShadow__lore":"\\"They came without warning and took us by suprise. We managed to fend them off but lost many in the process.\\"","item__W_SilentShadow__name":"Silent Shadow","item__W_RangersGuillotine__gameplay":"Shoots poisoned arrows.","item__W_RangersGuillotine__lore":"With deadly precision this brutal bow slices through defenses, embedding its victim with poisoned arrows.","item__W_RangersGuillotine__name":"Ranger\'s Guillotine","item__W_ReapersEmbrace__gameplay":"Shoots powerful chaos projectiles.","item__W_ReapersEmbrace__lore":"A spectral bow that drains life with each arrow, ensnaring foes in the icy embrace of the Reaper.","item__W_ReapersEmbrace__name":"Reaper\'s Embrace","item__W_RelicWand__gameplay":"Manifests physical projectiles that deal high damage.","item__W_RelicWand__lore":"Channels the essence of lost civilizations and forgotten magic.","item__W_RelicWand__name":"Relic Wand","item__W_ReliqueryCrossbow__gameplay":"Shoots high damage chaos bolts.","item__W_ReliqueryCrossbow__lore":"Crossbow used by the priests of the Vampiric Reliquary.","item__W_ReliqueryCrossbow__name":"Reliquary Crossbow","item__W_SamsStirringStick__gameplay":"Places a visible trap near your feet that deals arcane damage.","item__W_SamsStirringStick__lore":"A legendary chef\'s stirring stick, imbued with the power of the (cooking) elements.","item__W_SamsStirringStick__name":"Sam\'s Stirring Stick","item__W_SlimeStaff__gameplay":"Places a visible trap near your feet that deals nature damage.","item__W_SlimeStaff__lore":"A staff pulsating with the essence of slimes, it allows the wielder to summon and command these gelatinous creatures.","item__W_SlimeStaff__name":"Slime Staff","item__W_SpellbindersTome__gameplay":"Emit arcane projectiles at your opponents.","item__W_SpellbindersTome__lore":"A mystical leather-bound book that ensnares minds with intricate spells of enchantment.","item__W_SpellbindersTome__name":"Spellbinder\'s Tome","item__W_SpiraledWand__gameplay":"Shoots bolts of kinetic magic energy.","item__W_SpiraledWand__lore":"Really, it\'s just a fancier stick.","item__W_SpiraledWand__name":"Spiraled Wand","item__W_StaffOfTheSnake__gameplay":"Places a visible trap near your feet that deals toxic damage.","item__W_StaffOfTheSnake__lore":"A staff adorned with the head of a cobra, chiseled in Emerald. It is said to be able to spit venom at foes.","item__W_StaffOfTheSnake__name":"Staff of the Snake","item__W_StarShot__gameplay":"Shoots strong arcane arrows infused with star energy.","item__W_StarShot__lore":"Carved from celestial fragments, this bow releases a cascade of sparkling projectiles, a celestial spectacle of destruction.","item__W_StarShot__name":"Star Shot","item__W_StarWand__gameplay":"Emit the power of the stars at your opponents.","item__W_StarWand__lore":"A whimsical and glittery instrument.","item__W_StarWand__name":"Star Wand","item__W_SteelCrossbow__gameplay":"Shoots crossbow bolts that pierce even the thickest of hides.","item__W_SteelCrossbow__lore":"A standard crossbow made of steel.","item__W_SteelCrossbow__name":"Steel Crossbow","item__W_Stick__gameplay":"Shoots sparks of magic energy.","item__W_Stick__lore":"There are many like it, but this one is mine!","item__W_Stick__name":"Stick","item__W_TheCrossBow__gameplay":"Shoots holy projectiles at a fast pace.","item__W_TheCrossBow__lore":"Deliver the lords justice with this legendary crossbow.","item__W_TheCrossBow__name":"The Cross Bow","item__W_ToxicWand__gameplay":"Fires a toxic orb.","item__W_ToxicWand__lore":"It may be addicting but you should know that its toxic.","item__W_ToxicWand__name":"Toxic Wand","item__W_Triforce__gameplay":"Emit the power of the triforce at your opponents.","item__W_Triforce__lore":"A radiant tome that unlocks the divine powers of courage, wisdom, and power.","item__W_Triforce__name":"Triforce","item__W_TwistedBranch__gameplay":"Places a visible trap near your feet that deals physical damage.","item__W_TwistedBranch__lore":"A crude walking stick that has been enchanted by a late wizard.","item__W_TwistedBranch__name":"Twisted Branch","item__W_WitchHuntersRepeaters__gameplay":"Shoots bolts infused with a holy radiance.","item__W_WitchHuntersRepeaters__lore":"Common crossbows used by the Witch Hunters of the Arcane Order.","item__W_WitchHuntersRepeaters__name":"Witch Hunter\'s Repeater","item__W_WizardsLedger__gameplay":"RAPIDLY fires coins. Yes, coins.","item__W_WizardsLedger__lore":"Is this pay to win?","item__W_WizardsLedger__name":"Wizard\'s Ledger","item__W_WyvernsTalon__gameplay":"Shoots powerful bolts that deal bleed damage.","item__W_WyvernsTalon__lore":"Crossbow crafted from the talons of a great wyvern.","item__W_WyvernsTalon__name":"Wyvern\'s Talon","item__W_ZappingWand__gameplay":"Fires lightning projectiles.","item__W_ZappingWand__lore":"Brings a surge of electrifying might to your magical repertoire.","item__W_ZappingWand__name":"Zapping Wand","item_container__loot_chest":"Loot Chest","item_container__loot_drop":"Loot Drop","item_rarity__common":"Common","item_rarity__epic":"Epic","item_rarity__legendary":"Legendary","item_rarity__rare":"Rare","item_rarity__uncommon":"Uncommon","common":"Common","uncommon":"Uncommon","rare":"Rare","epic":"Epic","legendary":"Legendary","item_slot__damage":"damage","item_slot__equip_prompt":"Left click to equip!","item_slot__extract_prompt":"Extract to use this item!","item_slot__grants_ability":"Grants Ability","item_slot__grants_passive":"Passive Effect","item_slot__loot_prompt":"Left click to loot!","loadout_menu__abilities_header":"Abilities","loadout_menu__back_to_main_menu_button":"Back","loadout_menu__damage":"Damage","loadout_menu__defence":"Defence","loadout_menu__gear_header":"Gear","loadout_menu__health":"Health","loadout_menu__insurance_button":"Insure","loadout_menu__no_abilities":"Your loadout does not contain any abilities.","loadout_menu__no_slot_selected_insurance_text":"\uD83D\uDEA8 Nothing is insured! \uD83D\uDEA8","loadout_menu__no_slot_selected_scrollbox":" Select a slot to change your loadout","loadout_menu__scrollbox_with_gear_text":"Choose some gear","loadout_menu__scrollbox_with_skins_text":"Choose a skin","loadout_menu__scrollbox_with_weapons_text":"Choose a weapon","loadout_menu__skin_header":"Choose A Skin","loadout_menu__slot_insured_text":"✅ You have insurance! ✅","loadout_menu__start_run_button":"Play","loadout_menu__stat":"Stat","loadout_menu__title":"Loadout","loadout_menu__undo":"Undo","loadout_menu__weapons_header":"Weapons","loadout_menu__will_be_safe":"will be safe if you die.","loadout_menu__your":"Your","login__header":"Log In","fullscreen":"Full Screen","exit_fullscreen":"Quit Full Screen","loot_prompt":"[ E ] to loot","leaderboard__player_kills":"PK","leaderboard__loot":"Loot","leaderboard__npc_kills":"NPCK","main_menu__patch_notes_btn":"Patch Notes","main_menu__change_username_btn":"Change Username","main_menu__create_account_btn":"Create Account","main_menu__collection_log_btn":"Collection Log","collection_log__header":"Collection Log","main_menu__discord_btn_tooltip":"Find friends and join us on Discord!","main_menu__game_is_in_maintenance_mode":"PvPz.io is being updated! The new update will be deployed soon, try again in a few minutes","main_menu__how_to_play_btn":"How to play","main_menu__identity_error_title":"Uh Oh","main_menu__loading_bar_text":"Loading...","main_menu__logout_btn":"Log Out","main_menu__partners":"Partners","main_menu__partners_and_credits":"All partners & credits","main_menu__patch_prefix":"Patch","main_menu__patch_suffix":"coming June 1st!","main_menu__play_btn":"Play","main_menu__rankings_btn":"Rankings","main_menu__settings_btn":"Settings","main_menu__sign_in_btn":"Sign In","main_menu__sign_in_with_discord_btn":"Sign in with Discord","main_menu__sign_in_with_facebook_btn":"Sign in with Facebook","main_menu__sign_in_with_google_btn":"Sign in with Google","main_menu__twitter_btn_tooltip":"Follow us on twitter!","main_menu__vendors_btn":"Vendors","main_menu__view_inventory_btn":"Inventory","main_menu__view_your_stats_btn":"Your Stats","main_menu__website_btn_tooltip":"Visit our website!","main_menu__welcome_panel_title":"Welcome","main_menu__welcome_panel_title_suffix":" back,","main_menu__welcome_sign_in_cta":"Want to change your username? Sign In!","main_menu_stash__collectors_items":"Collectors Items","main_menu_stash__discovered":"Discovered","main_menu_stash__gear":"Gear","main_menu_stash__header":"Stash","main_menu_stash__total_items_discovered":"Items Discovered","main_menu_stash__vendor_items":"Vendor Items","main_menu_stash__weapons":"Weapons","player_skins__boltman":"Ranger","player_skins__corrupted_wizard":"Corrupted Wizard","player_skins__knight":"Knight","player_skins__red_wizard":"Wizard\'s Apprentice","player_skins__thief":"Thief","player_skins__veteran_wizard":"Dragon School Wizard","rankings__back_to_main_menu_button":"Back","rankings__coming_soon":"Coming Soon!","rankings__title":"Rankings","region__dreamers_forest":"Dreamers Forest","region__ert_lich":"Ert Lich","region__erthel":"Erthel","region__forgotten_temple":"Forgotten Temple","region__skull_lake":"Skull Lake","region__swamp_of_sorrows":"Swamp of Sorrows","region__the_edgelands":"Edgelands","region__wilderness":"Wilderness","dreamers forest":"Dreamers Forest","ert lich":"Ert Lich","erthel":"Erthel","forgotten temple":"Forgotten Temple","skull lake":"Skull Lake","swamp of sorrows":"Swamp of Sorrows","edgelands":"Edgelands","wilderness":"Wilderness","register__terms_label_1":"By registering an account with PvPz.io & Second Monitor Games, you are agreeing to our","register__terms_label_2":"Terms of Service","register__terms_label_3":"Privacy Policy","register__promo_label":"It\'s OK for Second Monitor Games to email me about promotions and game updates","register__delete_account_cta":"You are an anonymous user so your account will be deleted in 2 weeks! If you want to keep your items and stats, and change your username, please register!","register__delete_account_cta_2":"You are an anonymous user so you cannot see stats! If you want to see your stats, change your username, and unlock special skins, please register!","register__delete_account_cta_less_aggressive":"If you want to save your items and stats forever, and change your username, please register!","register__email":"Enter your email address","register__email_confirm":"Confirm email address","register__email_placeholder":"Email Address","register__email_placeholder_confirm":"Confirm Email Address","register__header":"Register","register__or":"Or","register__password":"Enter a password","register__password_confirm":"Confirm your password","register__register":"Register","register__register_with_discord_btn":"Register with Discord","register__register_with_google_btn":"Register with Google","register__username":"Choose a username","runprep__skin_not_unlocked_registered":"Only REGISTERED USERS can use that skin!","settings__back_to_main_menu_button":"Back","settings__enable_music":"Enable Music","settings__enable_sfx":"Enable Sound Effects","settings__language":"Language","settings__language_dropdown_english":"English","settings__language_dropdown_portuguese":"Portuguese / Portugu\xeas","settings__language_dropdown_russian":"Russian / русский","settings__language_dropdown_spanish":"Spanish / Espa\xf1ol","settings__matchmaking_region":"Matchmaking Region","settings__matchmaking_region_dropdown_africa":"Africa","settings__matchmaking_region_dropdown_any":"Any Region (fastest)","settings__matchmaking_region_dropdown_asia":"Asia","settings__matchmaking_region_dropdown_australia_oceania":"Australia/Oceania","settings__matchmaking_region_dropdown_eu":"Europe","settings__matchmaking_region_dropdown_middle_east":"Middle East","settings__matchmaking_region_dropdown_na_east":"North America (East)","settings__matchmaking_region_dropdown_na_west":"North America (West)","settings__matchmaking_region_dropdown_south_america":"South America","settings__save_button":"Save","settings__title":"Settings","settings__settings_saved":"Settings Saved!","signin_sign_in":"Sign In","signin_sign_in_with_discord_btn":"Sign In with Discord","signin_sign_in_with_google_btn":"Sign In with Google","item_type__weapon":"Weapon","item_type__gear":"Gear","item_type__vendor":"Vendor Trash","item_type__collector":"Special Item","item_type__unknown":"Unknown","stat_type_arcane":"Arcane","stat_type_bleed":"Bleed","stat_type_chaos":"Chaos","stat_type_fire":"Fire","stat_type_frost":"Frost","stat_type_holy":"Holy","stat_type_lightning":"Lightning","stat_type_nature":"Nature","stat_type_physical":"Physical","stat_type_shadow":"Shadow","stat_type_toxic":"Toxic","stats__back_btn":"Back","stats__boss_kills":"Boss kills","stats__common_items_looted":"common items looted","stats__distanced_travelled":"distance travelled","stats__epic_items_looted":"epic items looted","stats__failed_runs":"failed runs","stats__global_rank":"global rank","stats__gold_looted":"gold looted","stats__gold_lost_to_deaths":"gold lost to deaths","stats__header":"Stats","stats__items_looted":"items looted","stats__items_lost_to_deaths":"items lost to deaths","stats__legendary_items_looted":"legendary items looted","stats__npc_kills":"NPC kills","stats__player_kills":"player kills","stats__rare_items_looted":"rare items looted","stats__run_success_percentage":"run success percentage","stats__runs":"runs","stats__successful_runs":"successful runs","stats__time_played":"time played","stats__uncommon_items_looted":"uncommon items looted","toast__email_doesnt_match":"Email addresses dont match!","toast__email_not_long_enough":"Email address isn\'t long enough!","toast__gods_granted_you_items":"The gods granted you some basic equipment!","toast__not_an_email_address":"That doesnt look like a real email address!","toast__password_not_long_enough":"Password isnt long enough!","toast__passwords_dont_match":"Passwords dont match!","toast__username_changed":"Username changed successfully!","toast__username_too_short":"Username too short!","vendors__back_to_main_menu_button":"Back","vendors__coming_soon":"Coming Soon!","vendors__title":"Vendors","event_feed__looted_a":"looted a","event_feed__in_the":"in the","event_feed__at":"at","event_feed__killed":"killed","event_feed__boss":"boss","event_feed__is_extracting":"is extracting","event_feed__has_extracted":"has successfully extracted!","event_feed__has_spawned":"has spawned at","event_feed__under_attack":"is under attack at"}');


var $213f335c3e834aa0$exports = {};
$213f335c3e834aa0$exports = JSON.parse('{"register__terms_label_1":"Регистрируя учетную запись в PvPz.io & Second Monitor Games, вы соглашаетесь с нашими","register__terms_label_2":"Условиями использования","register__terms_label_3":"Политикой конфиденциальности","register__promo_label":"Мне не против получать электронные письма о акциях и обновлениях игр от Second Monitor Games","adblock_detected_failed_to_insure":"Что-то пошло не так при страховании этого предмета. Пожалуйста, убедитесь, что ваш блокировщик рекламы отключен!","ability_type_active":"Активный","ability_type_passive":"Пассивный","change_username__back":"Назад","change_username__cant_be_empty_error":"Имя пользователя не может быть пустым","change_username__current_prompt":"Ваше текущее имя пользователя","change_username__enter_new":"Введите новое имя пользователя","change_username__header":"Имя пользователя","change_username__save":"Сохранить","change_username__too_long_error":"Имя пользователя не может превышать 20 символов.","character_already_on_run_menu__abondon_run_button":"Отменить прохождение","character_already_on_run_menu__back_to_main_menu_button":"Назад","character_already_on_run_menu__bolded_header":"Ваш персонаж уже находится в процессе прохождения!","character_already_on_run_menu__paragraph_one":"Ваш персонаж ещё не вернулся с предыдущего прохождения. Если вы начнёте новое прохождение сейчас, все предметы из предыдущего прохождения (за исключением застрахованных предметов) будут потеряны!","character_already_on_run_menu__paragraph_two":"Если вы считаете, что это ошибка, или если вы намеренно хотите отменить прохождение, вы можете принудительно отменить прохождение, используя кнопку ниже.","character_already_on_run_menu__title":"ПРЕДУПРЕЖДЕНИЕ!","connection_error__back_to_main_menu":"Вернуться в главное меню","connection_error__error_reason":"Причина ошибки","connection_error__oof":"Ой","connection_error__server_error_header":"Ошибка подключения к серверу!","death_menu__back_to_main_menu_button":"Вернуться в меню","death_menu__gear_lost":"Потерянное снаряжение","death_menu__gold_lost":"Потерянное золото","death_menu__insured_items":"Застрахованные предметы","death_menu__loot_lost":"Потерянная добыча","death_menu__nothing_insured":"Ни один предмет не был застрахован!","death_menu__saving_your_run_button":"Сохранение...","death_menu__spectate_button":"Смотреть убийцу","death_menu__survived_for":"Продержались","death_menu__title":"R.I.P","death_menu__weapons_lost":"Потерянное оружие","death_menu__your_killer":"Ваш убийца","extracted_menu__back_to_main_menu_button":"Вернуться в меню","extracted_menu__gold_looted":"Добыто золота","extracted_menu__loot_acquired":"Добыча получена","extracted_menu__run_duration":"Продолжительность прохождения","extracted_menu__title":"Извлечено!","game_hud__cooldown":"Перезарядка","game_hud__find_an_extraction_point":"Найдите точку извлечения!","game_hud__inventory_extract_prompt":"Вы должны извлечься, чтобы использовать эту добычу!","game_hud__inventory_hud":"Открыть инвентарь","game_hud__leaderboard":"Таблица лидеров","game_hud__leaderboard_current_world":"Текущий мир","game_hud__leaderboard_hide":"Скрыть","game_hud__leaderboard_show":"Показать","game_hud__looted_container_close":"Закрыть","game_hud__spectating":"Наблюдение","game_hud__time_left_to_extract":"осталось для извлечения","game_hud__your_inventory_header":"Ваш инвентарь!","game_hud__your_inventory_hide":"для закрытия","game_transition__finding_match":"Поиск матча","hotkey_interact":"E","hotkey_open_inventory":"i","hotkey_toggle_leaderboard":"L","how_to_play__ability_one_key":"Навык #1","how_to_play__ability_three_key":"Навык #3","how_to_play__ability_two_key":"Навык #2","how_to_play__back_to_main_menu_button":"Назад","how_to_play__chat_key":"Чат","how_to_play__extraction":"Найдите точку извлечения!","how_to_play__inventory_key":"Инвентарь","how_to_play__leaderboard_key":"Таблица лидеров","how_to_play__mouse_aim_controls":" : Прицеливание","how_to_play__mouse_shoot_controls":" : Выстрел","how_to_play__move_down_key":"Движение вниз","how_to_play__move_left_key":"Движение влево","how_to_play__move_right_key":"Движение вправо","how_to_play__move_up_key":"Движение вверх","how_to_play__small_paragraph_one":"Если вы не успеете извлечься вовремя, вы потеряете все предметы, которые взяли с собой (если у вас нет страховки!) и все предметы, которые вы добыли во время прохождения. Извлечение очень важно. Вы должны ИЗВЛЕЧЬСЯ со своей добычей, чтобы сохранить ее и использовать.","how_to_play__small_paragraph_three":"Убивайте или будьте убитыми, пусть победит лучший искатель приключений!","how_to_play__small_paragraph_two":"Убивайте других игроков, находите добычу и извлекайтесь!","how_to_play__test_keys_header":"Проверьте клавиши!","how_to_play__title":"PvPz.io","how_to_play__top_big_paragraph":"Убивайте других игроков, находите добычу и извлекайтесь!","how_to_play__weapon_one_key":"Оружие #1","how_to_play__weapon_two_key":"Оружие #2","in_game__extracting":"Извлечение...","in_game__time_remaining":"Оставшееся время...","in_game__warning_time_almost_up":"Найдите точку извлечения!","insured_item_nothing":"Ничего","item__AG_AmuletOfCursedFate__gameplay":"+10% скорость атаки | ВОЗРОЖДАЕТСЯ с 40% Здоровья, когда вы умираете (не суммируется с другими предметами возрождения)","item__AG_AmuletOfCursedFate__lore":"Зловещий амулет, искривляющий судьбы и приносящий зловещие предзнаменования.","item__AG_AmuletOfCursedFate__name":"Амулет Зловещей Судьбы","item__AG_MagicBoots__name":"Магические Сапоги","item__AG_MagicBoots__gameplay":"Сделать невидимым на 9 секунд при использовании (2 раза) | Ваше здоровье постоянно восстанавливается | Извлечение замедлено на 10%.","item__AG_MagicBoots__lore":"Эти сапоги не издают никакого шума и бодрят своего обладателя.","item__AG_Boros__gameplay":"На 7 секунд становитесь невидимыми при использовании | -12% Урон против NPC | +12% Поглощение урона от всего урона, который вы наносите игрокам","item__AG_Boros__lore":"Говорят, что его камень создан из глаза оборотня.","item__AG_Boros__name":"Борос","item__AG_DarkPustulesRing__gameplay":"Принимайте на 5% меньше урона во время извлечения | Извлекайтесь на 5% быстрее","item__AG_DarkPustulesRing__lore":"Это кольцо можно использовать для магического получения темной сладкой жидкости на целый день.","item__AG_DarkPustulesRing__name":"Кольцо Темных Пузырей","item__AG_DreamWeaversEmbrace__gameplay":"На 4 секунд становитесь невидимыми при использовании | -5% Урон игрокам | Извлекайтесь на 10% быстрее | ИНКОГНИТО: Скрывает ваши предметы и сообщения о местоположении от остального мира","item__AG_DreamWeaversEmbrace__lore":"Камни на этом кольце меняют цвет в областях, где завеса тонкая.","item__AG_DreamWeaversEmbrace__name":"Объятия Сновидцев","item__AG_ForestsHaven__gameplay":"Исцеляет на 20 ЗДОРОВЬЯ при использовании | Извлекайтесь на 10% быстрее | ИНКОГНИТО: Скрывает ваши предметы и сообщения о местоположении от остального мира | +20% Эфирное","item__AG_ForestsHaven__lore":"Тем, кто носит это кольцо, ищите рощу деревьев, скрытую среди снов.","item__AG_ForestsHaven__name":"Убежище Леса","item__AG_MysteriousRing__gameplay":"Добавляет 30 секунд к вашему таймеру извлечения при использовании | +10 максимального здоровья | +7% к скорости передвижения при ходьбе по воде","item__AG_MysteriousRing__lore":"???","item__AG_MysteriousRing__name":"Таинственное Кольцо","item__AG_ObsidianEcho__gameplay":"ИЗВЛЕЧЕНИЕ при использовании, независимо от вашего местоположения | +12% к скорости передвижения | ВОЗРОЖДАЕТСЯ с 70% Здоровья, когда вы умираете (не суммируется с другими предметами возрождения) | -30 максимального здоровья | Этот предмет уничтожается при полном использовании","item__AG_ObsidianEcho__lore":"Скованное из осколка клинка Малахая. Если вы внимательно слушаете, вы можете услышать эхо душ тех, кого он убил.","item__AG_ObsidianEcho__name":"Обсидиановое Эхо","item__AG_PepperedCollar__gameplay":"Предоставляет увеличение скорости передвижения на 25% на 4 секунды при использовании (1 раз) | -3% Дальность полета снаряда","item__AG_PepperedCollar__lore":"Ошейник-ожерелье, созданное в честь знаменитого кошачьего зверя.","item__AG_PepperedCollar__name":"Ошейник с перцем","item__AG_RingOfAnOceanMan__gameplay":"Даёт 2 секунды +20% скорости передвижения при использовании | Извлечение ускорено на 5% | +5% к скорости передвижения при ходьбе по воде","item__AG_RingOfAnOceanMan__lore":"Кажется, что оно пытается взять вас за руку и провести в место, которое понимает только оно.","item__AG_RingOfAnOceanMan__name":"Кольцо Океана","item__AG_StuddedNecklace__gameplay":"Становится невидимым на 4 секунды при использовании (3 заряда) | -3% скорости передвижения","item__AG_StuddedNecklace__lore":"Мне, наверное, стоит застраховать это","item__AG_StuddedNecklace__name":"Заколка с шипами","item__AG_TheDarkLordsEmbrace__gameplay":"+30 Максимальное Здоровье","item__AG_TheDarkLordsEmbrace__lore":"Проклято всеми различными злодеяниями, совершенными его обладателем.","item__AG_TheDarkLordsEmbrace__name":"Объятия Тёмного Лорда","item__AG_TimeHerosRing__gameplay":"Добавляет 45 секунд к вашему таймеру извлечения при использовании | +7% скорость атаки | +7% скорость передвижения при ходьбе по воде | -5% скорость передвижения | +9% защита от Природы | +7% урон Природой","item__AG_TimeHerosRing__lore":"Носился эльфийским мальчиком, который мог путешествовать во времени.","item__AG_TimeHerosRing__name":"Кольцо Героя Времени","item__AG_VestiasSoothingSignet__gameplay":"Восстанавливает 30 ОЗ при использовании | INCOGNITO: Скрывает ваши сообщения о добыче и местоположении от остального мира","item__AG_VestiasSoothingSignet__lore":"Кольцо, которое позволяет владельцу успокаивать и травмы, и напряжение в группе.","item__AG_VestiasSoothingSignet__name":"Успокаивающий Знак Вестии","item__AG_ViolasDinnerReminder__gameplay":"+8,5% защиты от Природы | +8,5% защиты от Мороза | Получаете на 7% меньше урона во время извлечения | Ваши снаряды летят на 5% короче","item__AG_ViolasDinnerReminder__lore":"Кольцо, которое позволяет всем вокруг знать, когда вы голодны.","item__AG_ViolasDinnerReminder__name":"Напоминание о Ужине Виолы","item__AG_WolfMedallion__gameplay":"Восстанавливает 10 ед. здоровья при использовании | +10% скорость атаки | +10% Leech от всего урона, который вы наносите игрокам","item__AG_WolfMedallion__lore":"Настроенный на магию, он может обнаружить близлежащие места силы.","item__AG_WolfMedallion__name":"Волчий Медальон","item__CI_AlloyedBend__gameplay":"","item__CI_AlloyedBend__lore":"Кольцо, изготовленное из нескольких редких металлов, грубо сплавленных вместе.","item__CI_AlloyedBend__name":"Сплавленный Изгиб","item__CI_ApposSignet__gameplay":"","item__CI_ApposSignet__lore":"Говорят, что принадлежало полу-дракону, полу-человеку, который обладал способностью контролировать и разговаривать с утками.","item__CI_ApposSignet__name":"Сигнет Аппо","item__CI_BloodhuntersRing__gameplay":"","item__CI_BloodhuntersRing__lore":"Охотница за кровью ищет своих сородичей, а также вас.","item__CI_BloodhuntersRing__name":"Кольцо Охотника за Кровью","item__CI_CelestialEternity__gameplay":"","item__CI_CelestialEternity__lore":"Те, кто восстал против Малакая, были одарены богами этим кольцом.","item__CI_CelestialEternity__name":"Небесная Вечность","item__CI_EbonstarBand__gameplay":"","item__CI_EbonstarBand__lore":"Это кольцо хранит часть упавшей звезды, изменившей все.","item__CI_EbonstarBand__name":"Кольцо Звезды Полуночи","item__CI_EchoingWhisperNecklace__gameplay":"","item__CI_EchoingWhisperNecklace__lore":"Ожерелье, которое запечатывает и эхом отражает шепот потерянных душ.","item__CI_EchoingWhisperNecklace__name":"Ожерелье Эха Шепота","item__CI_FeyEnchantmentLocket__gameplay":"","item__CI_FeyEnchantmentLocket__lore":"Медальон, пропитанный чарами из мира Фей, придавая обольстительную привлекательность.","item__CI_FeyEnchantmentLocket__name":"Медальон Очарования Фей","item__CI_FragmentOfFate__gameplay":"","item__CI_FragmentOfFate__lore":"Однажды целое, теперь разбитое. Однажды объединенное, теперь разделенное. Однажды вечное, теперь устаревшее.","item__CI_FragmentOfFate__name":"Фрагмент Судьбы","item__CI_LatrosKnavishBand__gameplay":"","item__CI_LatrosKnavishBand__lore":"Кольцо, которое носили только самые злобные воры с непоколебимой уверенностью в своей морали.","item__CI_LatrosKnavishBand__name":"Коварное Кольцо Латроса","item__CI_LifesSimpleRing__gameplay":"","item__CI_LifesSimpleRing__lore":"Живи просто, чтобы другим было проще жить.","item__CI_LifesSimpleRing__name":"Простое Кольцо Жизни","item__CI_LuminousEnigma__gameplay":"","item__CI_LuminousEnigma__lore":"Я храню ключ к обширному знанию, предоставляя непревзойденные ответы.","item__CI_LuminousEnigma__name":"Светящаяся Загадка","item__CI_Ouro__gameplay":"","item__CI_Ouro__lore":"Сообщается, что это ключ к разгадке знания всех живых существ.","item__CI_Ouro__name":"Оуро","item__CI_PeachRing__gameplay":"","item__CI_PeachRing__lore":"Вкусно сладкий","item__CI_PeachRing__name":"Персиковое Кольцо","item__CI_PlayerSoulFragment__gameplay":"Это может заинтересовать собирателя душ.","item__CI_PlayerSoulFragment__lore":"Фрагмент души потерянного искателя приключений.","item__CI_PlayerSoulFragment__name":"Фрагмент Души Игрока","item__CI_ProudlyPinkRing__gameplay":"","item__CI_ProudlyPinkRing__lore":"Это кольцо — потрясающий аксессуар, который определенно привлечет внимание других.","item__CI_ProudlyPinkRing__name":"Гордо Розовое Кольцо","item__CI_RadiantSunstoneBand__gameplay":"","item__CI_RadiantSunstoneBand__lore":"Парадоксальное создание, это кольцо символизирует хрупкое равновесие между просвещением и разрушением.","item__CI_RadiantSunstoneBand__name":"Сияющее Кольцо Солнечного Камня","item__CI_RingOfDelerium__gameplay":"","item__CI_RingOfDelerium__lore":"Если вы прислушаетесь, вы можете услышать голоса прежних владельцев этого кольца.","item__CI_RingOfDelerium__name":"Кольцо Безумия","item__CI_RoyalBrooch__gameplay":"","item__CI_RoyalBrooch__lore":"Символ королевской семьи. Стоит целое состояние.","item__CI_RoyalBrooch__name":"Королевская Брошь","item__CI_SuperStar__gameplay":"","item__CI_SuperStar__lore":"Остаток выдуманной истории о королевстве, заполненном грибами.","item__CI_SuperStar__name":"Суперзвезда","item__CI_SwampOgresRing__gameplay":"","item__CI_SwampOgresRing__lore":"Принадлежал зеленому огру, который очень берег свою трясину.","item__CI_SwampOgresRing__name":"Кольцо Болотного Огра","item__CI_WeddingRing__gameplay":"","item__CI_WeddingRing__lore":"Это стоит немало, я должен вернуть его правильному владельцу","item__CI_WeddingRing__name":"Обручальное Кольцо","item__PG_AngelistasPotionPopper__gameplay":"Ваше здоровье восстанавливается постоянно","item__PG_AngelistasPotionPopper__lore":"Кольцо, которое вы носите, когда ваш лекарь запрещает вам пить лечебные зелья.","item__PG_AngelistasPotionPopper__name":"Затыкалка для Зелий Ангелисты","item__PG_AquamoorsBlessing__gameplay":"Даёт 3 секунды +25% скорости передвижения при использовании (3 зарядов) | Ваше здоровье восстанавливается постоянно | -20 максимального здоровья","item__PG_AquamoorsBlessing__lore":"Говорят, что оно благословлено духом озера перед коррупцией земли.","item__PG_AquamoorsBlessing__name":"Благословение Аквамура","item__PG_ArcaneEmber__gameplay":"-6.5% Урон по НИПам | +5.6% Урон по игрокам","item__PG_ArcaneEmber__lore":"В этом кольце видно маленький тлеющий уголь.","item__PG_ArcaneEmber__name":"Таинственный Уголь","item__PG_ArcaneSigilCollar__gameplay":"Предоставляет 4 секунды +30% скорости передвижения при использовании | -8.5% урона по НИПам | +9.5% урона по игрокам","item__PG_ArcaneSigilCollar__lore":"Гравированный мощными символами, он усиливает арканную мощь владельца.","item__PG_ArcaneSigilCollar__name":"Ошейник Арканного Символа","item__PG_AssassinSignet__gameplay":"Становитесь невидимым на 5 секунд при использовании (2 заряда) | -3% Скорость передвижения | -3% Дальность полета снаряда","item__PG_AssassinSignet__lore":"Печать, принадлежавшая печально известному убийце, сражавшемуся с помощью своих волос.","item__PG_AssassinSignet__name":"Печать Убийцы","item__PG_BellsShiningRing__gameplay":"Добавляет 60 секунд к вашему таймеру извлечения при использовании | -9,5% к урону по игрокам | +15,5% к урону по НПК | +40 максимального здоровья | Ваше здоровье восстанавливается постоянно","item__PG_BellsShiningRing__lore":"Известен многим как лучший целитель в царстве.","item__PG_BellsShiningRing__name":"Сияющее Кольцо Беллы","item__PG_BloodGemRing__gameplay":"Возрождает с 50% здоровья после смерти | -20 максимального здоровья","item__PG_BloodGemRing__lore":"Те, кто находились в храме во время ритуала, пали в ярость кровавого бойня. Это кольцо символизирует отчаянные времена.","item__PG_BloodGemRing__name":"Кровавое Каменное Кольцо","item__PG_BloodiedVitality__gameplay":"ИЗВЛЕЧЕНИЕ при использовании, независимо от вашего местоположения | Ваше здоровье восстанавливается постоянно | +30 максимального здоровья | -8% урона по игрокам | Вы получаете на 10% больше урона от ВСЕХ типов урона при извлечении | Этот предмет уничтожается при полном использовании","item__PG_BloodiedVitality__lore":"Ваша связь с реальностью и самой жизнью кажется крепче с этим предметом у вас на теле.","item__PG_BloodiedVitality__name":"Кровавая Жизненная Сила","item__PG_BloodmoonLoop__gameplay":"Исцеляет 5HP при использовании (3 заряда) | +5% урона кровотечением","item__PG_BloodmoonLoop__lore":"Связан с лунными циклами. Это повышает физическую мощь во время кровавой луны.","item__PG_BloodmoonLoop__name":"Броня Кровавой Луны","item__PG_CapeOfPureDarkness__gameplay":"Дарует 4 секунды +25% скорости передвижения при использовании | +9% Защиты Тени | +9% Защиты от Токсинов | +7% Урона от Токсинов | Ваше здоровье постоянно уменьшается.","item__PG_CapeOfPureDarkness__lore":"Никто не осмеливался задавать ему вопросы из страха. Темный Правитель не подлежал опросу.","item__PG_CapeOfPureDarkness__name":"Плащ Абсолютной Тьмы","item__PG_CelestialSolaceBand__gameplay":"Восстанавливает 7 здоровья при использовании | ОСМОТР: Раскрывает информацию о ваших оппонентах | +6.5% урона от тени","item__PG_CelestialSolaceBand__lore":"Выковано самими богами, это кольцо приносит утешение среди тьмы.","item__PG_CelestialSolaceBand__name":"Кольцо Небесного Утешения","item__PG_CelestialStarfallPendant__gameplay":"Становитесь невидимым на 3 секунды при использовании | +6.5% урона НИП | +5% урона Светом","item__PG_CelestialStarfallPendant__lore":"Подвеска, украшенная небесным камнем, вызывающая небесную энергию.","item__PG_CelestialStarfallPendant__name":"Подвеска Небесного Звездопада","item__PG_CultistsMask__name":"Маска культиста","item__PG_CultistsMask__lore":"Те, кто стал жертвами порчи, стремились скрыть свою внешность, поскольку порча изменила их самое существо.","item__PG_CultistsMask__gameplay":"Становится невидимым на 6 секунд при использовании | ИНКОГНИТО: Скрывает ваши сообщения о добыче и местоположении от остального мира | +15% скорость атаки","item__PG_DepthStrider__name":"Глубокий Странник","item__PG_DepthStrider__lore":"На этом плаще есть слабое заклинание, облегчающее ходьбу по воде.","item__PG_DepthStrider__gameplay":"+5% к скорости передвижения при ходьбе по воде.","item__PG_GoldenGauntlets__name":"Золотые Наручи","item__PG_GoldenGauntlets__lore":"Подходят для ограблений, эти наручи кажется, помогают найти дополнительное золото.","item__PG_GoldenGauntlets__gameplay":"+10% к золоту из сундуков.","item__PG_BeastVanquisherBoots__name":"Сапоги покорителя зверей","item__PG_BeastVanquisherBoots__lore":"Носились теми, кто находился на передовой битвы. Эти сапоги обеспечивали быструю гибель врага.","item__PG_BeastVanquisherBoots__gameplay":"+12% к скорости передвижения | +45 максимального здоровья | +25% к урону по НПК | -12% к урону по игрокам | -12% к дальности снарядов","item__PG_CloakOfModestApproachability__gameplay":"Ваши снаряды летят на 6% дальше | Добавляет 30 секунд к вашему времени извлечения при использовании","item__PG_CloakOfModestApproachability__lore":"Другие кажутся притянутыми к вам и не уверены, почему.","item__PG_CloakOfModestApproachability__name":"Плащ Скромной Привлекательности","item__PG_CloudedDarkness__gameplay":"+20% Эфирности | +10% урона Тьмой | +13% защиты от Тьмы","item__PG_CloudedDarkness__lore":"Когда пришло время и дело было сделано, тьма окутала Малакая и воплотилась в этом кольце.","item__PG_CloudedDarkness__name":"Темная Пелена","item__PG_CompactedLimeGreenRing__gameplay":"Ваши снаряды летят на 5% дальше | +7% урона от яда","item__PG_CompactedLimeGreenRing__lore":"Держалось преемником трона дракона.","item__PG_CompactedLimeGreenRing__name":"Скомпонованное известью зеленое кольцо","item__PG_CopperWristband__gameplay":"+6.5% Физической защиты","item__PG_CopperWristband__lore":"Смешно большое кольцо, которое лучше подходит в качестве браслета... Можно только представить, какого размера было существо, которое носило это как кольцо.","item__PG_CopperWristband__name":"Медный Браслет","item__PG_CoralReef__gameplay":"+8,5% к скорости передвижения при ходьбе по воде | Извлечение замедлено на 10%","item__PG_CoralReef__lore":"Создан в подарок русалочьей принцессе.","item__PG_CoralReef__name":"Коралловый риф","item__PG_CorruptedTearRing__gameplay":"Становитесь невидимым на 5 секунд при использовании | +7% Поглощение всего наносимого вами урона игрокам | -7% Защита от Хаоса | +9% Хаотический урон | +9% Урон молнией","item__PG_CorruptedTearRing__lore":"Прежде чем коррупция овладела им, была пролита одна слеза... \\"Ч-что я стал?!\\"","item__PG_CorruptedTearRing__name":"Искаженное Слезное Кольцо","item__PG_CursedEternityRing__gameplay":"Даёт 5 секунд +30% скорости передвижения при использовании | ВОЗРОЖДАЕТСЯ с 48% Здоровья, когда вы умираете (не суммируется с другими предметами возрождения) | +12% Золота из сундуков | +8,5% Похищение Жизни от всего урона, нанесенного игрокам | Ваше здоровье уменьшается постоянно","item__PG_CursedEternityRing__lore":"Символ вечного проклятия. Он привязывает своего носителя, проклиная его навсегда, но даруя ему великую силу.","item__PG_CursedEternityRing__name":"Проклятое Кольцо Вечности","item__PG_CursedSignet__gameplay":"+20% Поглощение здоровья из всего урона, который вы наносите игрокам","item__PG_CursedSignet__lore":"Из этого кольца исходит зловещая энергия, приносящая несчастье всем, кто его носит.","item__PG_CursedSignet__name":"Проклятое Печати","item__PG_DeathwhisperWrap__gameplay":"+13% Урон по НИП | +13% Защита от Хаоса | +10% Токсический урон","item__PG_DeathwhisperWrap__lore":"Когда клинок пронзил его сердце и все погрузилось во тьму, прозвучал слабый шепот: \'Еще не пришло время для меня, чтобы взять твою душу\'.","item__PG_DeathwhisperWrap__name":"Обертка Смертного Шепота","item__PG_DreadmorneLoop__gameplay":"Даёт 3 секунды +30% скорости передвижения при использовании (5 зарядов) | -5% скорости атаки | -6,5% защиты от Святого урона | +10% урона Хаоса","item__PG_DreadmorneLoop__lore":"Это кольцо внушает страх в сердцах врагов, наводя ужас и вызывая трепет.","item__PG_DreadmorneLoop__name":"Петля Мрачной Долины","item__PG_DreamcasterDrapery__gameplay":"+6.5% урона НИП | +6.5% урона Хаосом","item__PG_DreamcasterDrapery__lore":"Рожденный из кошмаров, говорят, что этот облачный плащ управляет подсознанием.","item__PG_DreamcasterDrapery__name":"Облачение Сновидцев","item__PG_EbonfireRobelet__gameplay":"Ваши снаряды летят на 6% дальше","item__PG_EbonfireRobelet__lore":"Окутывает своего владельца аурой тлеющих теней, предоставляя защиту от элементарных вредителей.","item__PG_EbonfireRobelet__name":"Полурукав из Эбонитового Огня","item__PG_ElvenGildedGuardian__gameplay":"Извлекайте на 5% быстрее","item__PG_ElvenGildedGuardian__lore":"Красиво изготовленный золотой пояс, украшенный плющом, который повышает проворность владельца и отталкивает противников эльфийской изящностью.","item__PG_ElvenGildedGuardian__name":"Эльфийский Позолоченный Страж","item__PG_EmbergraspRing__gameplay":"+10 Максимального здоровья","item__PG_EmbergraspRing__lore":"Пламя танцует и мерцает при вашем касании, жгучих ваших врагов.","item__PG_EmbergraspRing__name":"Кольцо Пламенного Схвата","item__PG_EnchantedElixirNecklace__gameplay":"Добавляет 60 секунд к таймеру извлечения при использовании | ВОСКРЕШЕНИЕ с 60% HP при смерти (не суммируется с другими предметами воскрешения)","item__PG_EnchantedElixirNecklace__lore":"Ожерелье, содержащее флакон с волшебным эликсиром, усиливающим магическую силу.","item__PG_EnchantedElixirNecklace__name":"Ожерелье Волшебного Эликсира","item__PG_EnigmaLoop__gameplay":"ИНКОГНИТО: Скрывает ваш добычу и сообщения о местоположении от остального мира | +5% урона Хаосом","item__PG_EnigmaLoop__lore":"Загадочное кольцо, запутывающее врагов, искажая реальность в вашу пользу.","item__PG_EnigmaLoop__name":"Кольцо Загадки","item__PG_EnigmaticShadowweaveRing__gameplay":"Исцеляет 20HP при использовании (1 заряд) | +5,5% урона по игрокам | -9% урона по НПК","item__PG_EnigmaticShadowweaveRing__lore":"Пропитанное загадочными очарованиями, это кольцо сплетает вместе нити тьмы.","item__PG_EnigmaticShadowweaveRing__name":"Загадочное Кольцо Теней","item__PG_EssenceConduit__gameplay":"+9% Урон по НИПам | -4% Урон по игрокам","item__PG_EssenceConduit__lore":"Дарует силу тем, кто заботится о природе.","item__PG_EssenceConduit__name":"Кондуктор Сущности","item__PG_EverlastingSpiritCircle__gameplay":"Даёт 3 секунды +25% скорости передвижения при использовании (2 заряда) | +10% Золота из сундуков","item__PG_EverlastingSpiritCircle__lore":"Созданное древними заклинаниями, это кольцо действует как проводник духовной энергии.","item__PG_EverlastingSpiritCircle__name":"Вечный Круг Духа","item__PG_FrostFireRing__gameplay":"+7% Урон Огнем | +8,5% Защита от Холода | -6,5% Защита от Огня","item__PG_FrostFireRing__lore":"Кольцо, украшенное элементарными камнями, которое может наделять атаки дополнительной силой - \\"Cause you\'re hot then you\'re cold\\"","item__PG_FrostFireRing__name":"Кольцо Ледяного Пламени","item__PG_FrostbiteLoop__gameplay":"+6% Скорость передвижения","item__PG_FrostbiteLoop__lore":"Вокруг этого кольца царит холодный воздух, замораживающий сердца врагов при касании.","item__PG_FrostbiteLoop__name":"Петля Морозного Укуса","item__PG_FrostfireShardPendant__gameplay":"Получайте на 10% меньше урона во время извлечения | +8% Урон игрокам","item__PG_FrostfireShardPendant__lore":"Подвеска, в которой содержится осколок, пропитанный и ледяными и огненными энергиями.","item__PG_FrostfireShardPendant__name":"Подвеска Ледяного Пламени","item__PG_GineshsBottleOpener__gameplay":"Ваше здоровье постоянно уменьшается | +12% Урон всем видам урона | +8.5% Скорость передвижения | Ваши снаряды летят на 8.5% дальше","item__PG_GineshsBottleOpener__lore":"Кольцо, открывающее как причину, так и решение всех проблем жизни.","item__PG_GineshsBottleOpener__name":"Открывалка для бутылок Гинеша","item__PG_GirdleOfTheGoldenNecromancer__gameplay":"Исцеляет 10HP при использовании | +6% Скорость передвижения","item__PG_GirdleOfTheGoldenNecromancer__lore":"Пышный золотом покрытый пояс, наделяющий своего владельца позолоченной аурой некромантической защиты, отталкивающей травмы.","item__PG_GirdleOfTheGoldenNecromancer__name":"Пояс Золотого Некроманта","item__PG_GoldPlatedCape__gameplay":"+4% Урон игрокам","item__PG_GoldPlatedCape__lore":"Почему-то считается доспехом","item__PG_GoldPlatedCape__name":"Золотой Плащ","item__PG_GolemsGrasp__gameplay":"+30 максимального здоровья | -6% скорость передвижения | -6% скорость передвижения при ходьбе по воде","item__PG_GolemsGrasp__lore":"Сила камня пронизывает это кольцо, превращая вашу кожу в броню.","item__PG_GolemsGrasp__name":"Хватка Голема","item__PG_GuardiansChainmailCollar__gameplay":"Исцеляет 15HP при использовании (3 раза) | -5% Скорость атаки","item__PG_GuardiansChainmailCollar__lore":"Прочный воротник из переплетенных кольчуг, обеспечивающий надежную защиту.","item__PG_GuardiansChainmailCollar__name":"Воротник Цепной Кольчуги Хранителя","item__PG_HeirloomCloak__gameplay":"Предоставляет 2 секунды увеличения скорости передвижения на 20% при использовании (3 раза).","item__PG_HeirloomCloak__lore":"Простой плащ, передаваемый в вашей семье из поколения в поколение.","item__PG_HeirloomCloak__name":"Наследный Плащ","item__PG_IceQueensEarrings__gameplay":"Предоставляет 5 секунд +20% скорости передвижения при использовании | +4% Урон игрокам | +6.5% Защита от Мороза | +5% Урон Морозом","item__PG_IceQueensEarrings__lore":"Серьги, достойные Снежной Королевы. Холодные на ощупь.","item__PG_IceQueensEarrings__name":"Серьги Ледяной Королевы","item__PG_InfiniteLoop__gameplay":"Добавляет 45 секунд к таймеру извлечения при использовании | -10 Здоровья максимума | Ваше здоровье постоянно восстанавливается","item__PG_InfiniteLoop__lore":"Способен преобразовывать жизненную энергию в ману и ману в жизненную энергию.","item__PG_InfiniteLoop__name":"Бесконечное Замкнутое Кольцо","item__PG_IronFoxLocket__gameplay":"ОСМОТР: Раскрывает информацию о ваших противниках | +13% защита от ВСЕХ видов урона | +30 максимального здоровья","item__PG_IronFoxLocket__lore":"Легенды рассказывают о лисе, облаченной в железную броню, известной своей способностью обмануть даже самых хитрых охотников.","item__PG_IronFoxLocket__name":"Железный Замочек Лисы","item__PG_JaysesRing__gameplay":"+9,5% к урону по игрокам | -9% к урону по НПК | +15% к Эфиру | +12% к урону молнией | +12% к урону огнем","item__PG_JaysesRing__lore":"Кольцо знаменитого мага Джейса.","item__PG_JaysesRing__name":"Кольцо Джейса","item__PG_LittleCompactedLimeGreenRing__gameplay":"Ваши снаряды летят на 6% дальше | +13% Защиты от Токсинов.","item__PG_LittleCompactedLimeGreenRing__lore":"Когда-то принадлежало роскошному драконьему роду.","item__PG_LittleCompactedLimeGreenRing__name":"Маленькое Сжатое Лаймово-Зеленое Кольцо","item__PG_MementoMoriLocket__gameplay":"-6.5% Защита от Хаоса | +8.5% Защита от теней","item__PG_MementoMoriLocket__lore":"Пугающий медальон, напоминающий о смертности и укрепляющий решимость.","item__PG_MementoMoriLocket__name":"Медальон Memento Mori","item__PG_MidnightsVeilBand__gameplay":"Становится невидимым на 5 секунд при использовании (2 заряда)","item__PG_MidnightsVeilBand__lore":"Носимый с тенями, этот плащ усиливает скрытность его владельца.","item__PG_MidnightsVeilBand__name":"Полуночный Вуаль","item__PG_MunchkinsRing__gameplay":"+7% Скорость передвижения | -10 Максимальное Здоровье","item__PG_MunchkinsRing__lore":"Его предыдущий владелец имел короткие ножки, но они никогда его не замедляли.","item__PG_MunchkinsRing__name":"Кольцо Манчкина","item__PG_NaturesAureateBarrier__gameplay":"Добавляет 30 секунд к вашему таймеру извлечения при использовании (2 раза) | -5,5% урона по игрокам | INCOGNITO: Скрывает ваши сообщения о добыче и местоположении от остального мира.","item__PG_NaturesAureateBarrier__lore":"Прочный, связанный золотом пояс, пропитанный стойкостью древних деревьев, дарующий владельцу щит блестящей природной силы.","item__PG_NaturesAureateBarrier__name":"Природный Золотистый Барьер","item__PG_NecroticGraspTalisman__gameplay":"Дает 5 секунд +30% скорость передвижения при использовании | Ваше здоровье постоянно падает | +12% Урон Тенями","item__PG_NecroticGraspTalisman__lore":"Талисман, пульсирующий некромантической силой, подчиняющий силы нежити.","item__PG_NecroticGraspTalisman__name":"Талисман Некротического Ухвата","item__PG_NecroticSignet__gameplay":"Добавляет 45 секунд к вашему таймеру извлечения при использовании | +13% Защита от Святости","item__PG_NecroticSignet__lore":"Макабрный символ смерти и разложения, он истощает жизненные силы ваших врагов.","item__PG_NecroticSignet__name":"Некротический Гамбезон","item__PG_PendantOfAncientWisdom__gameplay":"-7% Урон игрокам | +8.75% Урон НИП | +8.5% Аркана Защита | +7% Аркана Урон","item__PG_PendantOfAncientWisdom__lore":"Древний кулон, передающий глубокие знания тому, кто его носит.","item__PG_PendantOfAncientWisdom__name":"Кулон Древней Мудрости","item__PG_PhantomBand__gameplay":"+30% Эфирное","item__PG_PhantomBand__lore":"Ношение этого эфирного кольца позволяет вам незаметно ходить среди живых.","item__PG_PhantomBand__name":"Фантомное кольцо","item__PG_PhoenixFeatherTorque__gameplay":"ВОЗРОЖДАЕТСЯ с 60% Здоровья, когда вы умираете (не суммируется с другими предметами возрождения) | +60 максимального здоровья | +19,5% защита от Огня | +19,5% защита от Мороза | -19,5% защита от Токсинов | -15% скорость атаки","item__PG_PhoenixFeatherTorque__lore":"Величественный торк, украшенный пером феникса, дарующий возрождение и обновление.","item__PG_PhoenixFeatherTorque__name":"Торк из пера феникса","item__PG_PhoenixsRespite__gameplay":"Становитесь невидимыми на 3 секунд при использовании | +6.5% Огненная защита | +5% Огненный урон","item__PG_PhoenixsRespite__lore":"Те, кто добровольно бросали себя на пламя, возрождались с большей силой, чем прежде.","item__PG_PhoenixsRespite__name":"Отдых Феникса","item__PG_PurpletratorsRing__gameplay":"+3% Поглощение от всего урона, который вы наносите игрокам","item__PG_PurpletratorsRing__lore":"Те, кто осмеливался смеяться над названием этого кольца, часто погибали от его владельца.","item__PG_PurpletratorsRing__name":"Фиолетовое кольцо","item__PG_QuintsFishingGarb__gameplay":"+5% Скорость атаки","item__PG_QuintsFishingGarb__lore":"Кольцо, создающее бесконечное количество рыбацких червей, часто непреднамеренно распространяемых между участниками группы.","item__PG_QuintsFishingGarb__name":"Рыбацкий наряд Квинта","item__PG_ResilientHeartstone__gameplay":"Исцеляет 10HP при использовании | +5% Золота из сундуков | Получаете на 5% меньше урона во время извлечения | ОСМОТР: Раскрывает информацию о ваших оппонентах","item__PG_ResilientHeartstone__lore":"Сердцевидный драгоценный камень, внушающий несгибаемую силу владельцу.","item__PG_ResilientHeartstone__name":"Сопротивляющийся камень сердца","item__PG_RingOfConstellations__gameplay":"Ваши снаряды летят на 6% дальше","item__PG_RingOfConstellations__lore":"Ходят слухи, что этим обладал воин ночи, и кольцо предоставляло ему руководство во тьме ночи.","item__PG_RingOfConstellations__name":"Кольцо созвездий","item__PG_RingOfTheOneHandedWarrior__gameplay":"-10 максимального здоровья | +12% физического урона | +12% урона кровотечением","item__PG_RingOfTheOneHandedWarrior__lore":"Вам нужна только одна рука, чтобы носить кольцо.","item__PG_RingOfTheOneHandedWarrior__name":"Кольцо одноручного воина","item__PG_RingOfViolentViolet__gameplay":"+30 максимального здоровья | +17% Урон всем типам урона | -15% Защита от всех типов урона","item__PG_RingOfViolentViolet__lore":"Вы чувствуете внезапное всплеск силы и жажды крови, когда надеваете это кольцо.","item__PG_RingOfViolentViolet__name":"Кольцо яростного фиолетового","item__PG_RuneboundRing__gameplay":"+5% Скорость передвижения при ходьбе в воде | +7% Аркана урон","item__PG_RuneboundRing__lore":"Выгравированное древними рунами, оно канализирует арканную энергию, даруя силу владельцу.","item__PG_RuneboundRing__name":"Кольцо рунной связи","item__PG_SerpentsCoilChoker__gameplay":"ИНСПЕКЦИЯ: Раскрывает информацию о ваших противниках","item__PG_SerpentsCoilChoker__lore":"Обвиваясь вокруг шеи, оно наделяет владельца змеиной грацией и хитростью.","item__PG_SerpentsCoilChoker__name":"Ожерелье Серпента","item__PG_SerpentsRing__gameplay":"+6.5% защита от яда","item__PG_SerpentsRing__lore":"Кольцо, изготовленное из чешуи змеи и околдованное для защиты владельца от яда.","item__PG_SerpentsRing__name":"Кольцо Змеи","item__PG_ShieldbearersAmulet__gameplay":"Исцеляет 10HP при использовании (1 заряд) | +6,5% урона по НПК","item__PG_ShieldbearersAmulet__lore":"Украшенный гербовым гербом, он укрепляет защиту владельца.","item__PG_ShieldbearersAmulet__name":"Амулет Щитоносца","item__PG_SoulBindingRing__gameplay":"Воскресните с 40% здоровья после смерти | +10% Священный урон","item__PG_SoulBindingRing__lore":"Это кольцо имеет три камня. Один прозрачный и просвечивающий. В других двух находится странная золотистая кружащаяся мгла.","item__PG_SoulBindingRing__name":"Кольцо Связывания Души","item__PG_SoulforgeRing__gameplay":"ИЗВЛЕЧЕНИЕ при использовании, независимо от вашего местоположения | Извлечение замедлено на 10% | Этот предмет уничтожается при полном использовании","item__PG_SoulforgeRing__lore":"Пропитанная сущностью мученых душ, это кольцо повышает вашу физическую и мистическую силу.","item__PG_SoulforgeRing__name":"Кольцо Кузни Душ","item__PG_SoulshackleVeil__gameplay":"Даёт 3 секунды +25% скорости передвижения при использовании (3 заряда) | +8,5% К эфиру | -5% скорости передвижения","item__PG_SoulshackleVeil__lore":"Связанный темной магией, он запутывает души павших, связывая вас с миром духов.","item__PG_SoulshackleVeil__name":"Вуаль Душевных Оков","item__PG_SoulstoneReliquary__gameplay":"Становится невидимым на 4 секунды при использовании | Получаете на 5% меньше урона во время извлечения | ВОЗРОЖДАЕТСЯ с 20% Здоровья, когда вы умираете (не суммируется с другими предметами возрождения) | +5% Похищение Жизни от всего урона, который вы наносите игрокам","item__PG_SoulstoneReliquary__lore":"Реликвия на ожерелье, позволяющая владельцу управлять пойманными душами.","item__PG_SoulstoneReliquary__name":"Реликварий Душекамня","item__PG_StormweaverCloak__gameplay":"ИНКОГНИТО: Скрывает ваш добычу и сообщения о местонахождении от остального мира","item__PG_StormweaverCloak__lore":"Овладевайте яростью грозовых бурь, повелевая гневом небес.","item__PG_StormweaverCloak__name":"Плащ Штормовика","item__PG_SummonersSign__gameplay":"+10 Максимальное здоровье","item__PG_SummonersSign__lore":"Используется призывателями для сбора маны с земли.","item__PG_SummonersSign__name":"Знак Призывателя","item__PG_TalismanOfVeiledShadows__gameplay":"Становитесь невидимым на 3 секунд при использовании | -5% скорость передвижения | +8.5% защита от хаоса | +8.5% Защита от Теней","item__PG_TalismanOfVeiledShadows__lore":"Мистический талисман, покрывающий обладателя эфемерной тьмой.","item__PG_TalismanOfVeiledShadows__name":"Талисман Закрытых Теней","item__PG_TantrumsLuckyLoop__gameplay":"+3% скорости передвижения","item__PG_TantrumsLuckyLoop__lore":"Кольцо, которое делает вас быстрым как гончую собаку, но таким же ленивым.","item__PG_TantrumsLuckyLoop__name":"Счастливая Петля Тантрума","item__PG_VampiricSeal__gameplay":"Исцеляет 7HP при использовании (2 заряда) | +3% Похищение Жизни от всего урона, который вы наносите игрокам","item__PG_VampiricSeal__lore":"Питаясь жизненной силой ваших врагов, оно дарует жизненные силы с каждым ударом.","item__PG_VampiricSeal__name":"Вампирское Одеяние","item__PG_VeilstormCirclet__gameplay":"Исцеляет на 30 ед. здоровья при использовании | -10% скорость атаки | +12% Природный урон","item__PG_VeilstormCirclet__lore":"Хранит в себе мощь неистового шторма. Предоставляет обладателю контроль над ветром и молнией.","item__PG_VeilstormCirclet__name":"Вуальштормовая Мантия","item__PG_VenomousBite__gameplay":"Добавляет 30 секунд к вашему времени извлечения при использовании | Ваше здоровье постоянно падает | +10% Токсический урон","item__PG_VenomousBite__lore":"Доспехи, носимые древними чумными врачами","item__PG_VenomousBite__name":"Ядовитый Укус","item__PG_WindspeakersRing__gameplay":"INSPECTION: Раскрывает информацию о ваших оппонентах | +7% Природный урон","item__PG_WindspeakersRing__lore":"Когда-то принадлежало могущественному магу, который был преследован по всему миру своей собственной тенью, говорят, что это кольцо обладает способностью контролировать ветры.","item__PG_WindspeakersRing__name":"Кольцо Ветроговорца","item__PG_Wraithband__gameplay":"+8,5% к Эфиру | 7% Святой Урон | -10 Максимального Здоровья","item__PG_Wraithband__lore":"Фантомная энергия пронизывает это кольцо, даруя спектральные силы.","item__PG_Wraithband__name":"Пояс Вурдалака","item__VT_AbyssalShard__gameplay":"","item__VT_AbyssalShard__lore":"Черный кусок камня, добытый из подземного мира.","item__VT_AbyssalShard__name":"Абиссальный осколок","item__VT_Amber__gameplay":"","item__VT_Amber__lore":"Этот камень имеет глубокий оранжевый оттенок.","item__VT_Amber__name":"Янтарь","item__VT_BardsDiary__gameplay":"","item__VT_BardsDiary__lore":"На этой книге запечатлены стихи и ноты музыки.","item__VT_BardsDiary__name":"Песенник Барда","item__VT_BrokenIronBand__gameplay":"","item__VT_BrokenIronBand__lore":"Простое железное кольцо, потерявшее свой блеск.","item__VT_BrokenIronBand__name":"Сломанное железное кольцо","item__VT_BrokenSword__gameplay":"","item__VT_BrokenSword__lore":"Этот меч видел лучшие дни.","item__VT_BrokenSword__name":"Сломанный железный меч","item__VT_Cabbage__gameplay":"","item__VT_Cabbage__lore":"Ты капуста, ты всегда будешь капустой.","item__VT_Cabbage__name":"Капуста","item__VT_ChunkOfIron__gameplay":"","item__VT_ChunkOfIron__lore":"Небольшой кусок железа, кузнец мог бы что-то сделать с этим.","item__VT_ChunkOfIron__name":"Кусок железа","item__VT_CubicZirconia__gameplay":"","item__VT_CubicZirconia__lore":"Квадратный осколок циркония","item__VT_CubicZirconia__name":"Кубический цирконий","item__VT_Diamond__gameplay":"Редкий коллекционер, возможно, проявит интерес к этому.","item__VT_Diamond__lore":"Драгоценный самоцвет.","item__VT_Diamond__name":"Алмаз","item__VT_DukesDiary__gameplay":"","item__VT_DukesDiary__lore":"Заметки некогда могущественного герцога.","item__VT_DukesDiary__name":"Дневник Герцога Эрта","item__VT_EmeraldDust__gameplay":"","item__VT_EmeraldDust__lore":"Изумруд, превращенный в мелкую пыль.","item__VT_EmeraldDust__name":"Изумрудная пыль","item__VT_Emerald__gameplay":"","item__VT_Emerald__lore":"Кусок изумруда.","item__VT_Emerald__name":"Изумруд","item__VT_EverlastingCandle__gameplay":"","item__VT_EverlastingCandle__lore":"Эта свеча таинственным образом будет гореть вечно.","item__VT_EverlastingCandle__name":"Вечная свеча","item__VT_Eyeball__gameplay":"","item__VT_Eyeball__lore":"Глаз убитого зверя.","item__VT_Eyeball__name":"Глазное яблоко","item__VT_FangOfTheBloodMoon__gameplay":"","item__VT_FangOfTheBloodMoon__lore":"Этот кровавый клык принадлежит существу, охотящемуся только тогда, когда небо кровоточит.","item__VT_FangOfTheBloodMoon__name":"Клык Кровавой Луны","item__VT_Fossil__gameplay":"","item__VT_Fossil__lore":"Останки древнего существа навсегда впечатлены в этой скале.","item__VT_Fossil__name":"Ископаемое","item__VT_GhostPlasma__gameplay":"","item__VT_GhostPlasma__lore":"Эта вязкая жидкость светится эфирной энергией.","item__VT_GhostPlasma__name":"Призрачная плазма","item__VT_GoblinCloth__gameplay":"","item__VT_GoblinCloth__lore":"Эта ткань очень грязная и на ней есть кровь.","item__VT_GoblinCloth__name":"Гоблинская повязка","item__VT_GoldNugget__gameplay":"","item__VT_GoldNugget__lore":"Небольшой кусок золота. Возможно, стоит много.","item__VT_GoldNugget__name":"Золотая самородная","item__VT_OgreEntrails__gameplay":"","item__VT_OgreEntrails__lore":"Внутренности огра.","item__VT_OgreEntrails__name":"Внутренности огра","item__VT_OnyxGem__gameplay":"Этим может заинтересоваться эксперт по драгоценным камням.","item__VT_OnyxGem__lore":"Редкий драгоценный камень из оникса.","item__VT_OnyxGem__name":"Ониксовый камень","item__VT_PileOfAsh__gameplay":"","item__VT_PileOfAsh__lore":"Просто небольшая кучка пепла.","item__VT_PileOfAsh__name":"Кучка пепла","item__VT_Potato__gameplay":"Вари, толчи, клади их в похлебку.","item__VT_Potato__lore":"Вероятно, вы никогда о них не слышали.","item__VT_Potato__name":"Картофель","item__VT_QuartzRing__gameplay":"","item__VT_QuartzRing__lore":"Вставленный полированный кусок кварца. Не стоит много, но хоть что-то.","item__VT_QuartzRing__name":"Кварцевое кольцо","item__VT_RatFur__gameplay":"","item__VT_RatFur__lore":"Отвратительный комок шерсти, возможно, полный болезней.","item__VT_RatFur__name":"Комок шерсти крысы","item__VT_RedMushroom__gameplay":"","item__VT_RedMushroom__lore":"Этот гриб обычно сушат и превращают в порошок, который помогает при болезнях.","item__VT_RedMushroom__name":"Красный гриб","item__VT_RingOfNearPerfection__gameplay":"","item__VT_RingOfNearPerfection__lore":"Было бы лучше, если бы у него была магия.","item__VT_RingOfNearPerfection__name":"Кольцо почти идеальности","item__VT_RubyDust__gameplay":"","item__VT_RubyDust__lore":"Рубин, размолотый в мелкую пыль.","item__VT_RubyDust__name":"Пыль рубина","item__VT_Ruby__gameplay":"","item__VT_Ruby__lore":"Кусок глубоко красного рубина.","item__VT_Ruby__name":"Рубин","item__VT_SapphireDust__gameplay":"","item__VT_SapphireDust__lore":"Сапфир, превращенный в мелкую пыль.","item__VT_SapphireDust__name":"Пыль сапфира","item__VT_Sapphire__gameplay":"","item__VT_Sapphire__lore":"Глубоко синий кусок сапфира.","item__VT_Sapphire__name":"Сапфир","item__VT_SkeletonFemur__gameplay":"","item__VT_SkeletonFemur__lore":"Предполагаю, что где-то есть скелет с одной ногой.","item__VT_SkeletonFemur__name":"Бедро скелета","item__VT_Skull__gameplay":"","item__VT_Skull__lore":"Череп. Вероятно, от одного из этих бродячих скелетов.","item__VT_Skull__name":"Череп","item__VT_StellarWeaveRing__gameplay":"","item__VT_StellarWeaveRing__lore":"Кольцо из сплетенных ветвей. Оно ничем не примечательно.","item__VT_StellarWeaveRing__name":"Кольцо звездной плетки","item__VT_TreantBranch__gameplay":"","item__VT_TreantBranch__lore":"Этот кусок дерева немного шевелится. Странно.","item__VT_TreantBranch__name":"Ветка тренты","item__VT_WellWornRing__gameplay":"","item__VT_WellWornRing__lore":"На поверхности этого простого кольца видны несколько потертостей и царапин.","item__VT_WellWornRing__name":"Изношенное кольцо","item__VT_WhispersOfTheVoid__gameplay":"","item__VT_WhispersOfTheVoid__lore":"Безумие распространено среди тех, кто слышит его голос. И кто не слышит его в этот кризисный период?","item__VT_WhispersOfTheVoid__name":"Шепоты Пустоты. Том 1","item__W_ApprenticesStaff__gameplay":"Устанавливает видимую ловушку возле ваших ног, наносящую физический урон.","item__W_ApprenticesStaff__lore":"Посох начинающего волшебника, часто используемый для тренировок.","item__W_ApprenticesStaff__name":"Посох ученика","item__W_ArchmagesSidekick__gameplay":"Устанавливает видимую ловушку возле ваших ног, наносящую урон арканой магией.","item__W_ArchmagesSidekick__lore":"Мало что известно об этом посохе, кроме того, что его сотворил Архимаг Арканного Ордена.","item__W_ArchmagesSidekick__name":"Помощник Архимага","item__W_BeesOnAStick__gameplay":"Размещает видимую ловушку возле ваших ног, наносящую природный урон.","item__W_BeesOnAStick__lore":"Посох, украшенный ульем, жужжащим от силы роя пчел и наносящим жгучие заклинания противникам.","item__W_BeesOnAStick__name":"Пчелы на палочке","item__W_BlackDahliaWand__gameplay":"Выстреливает теневыми снарядами.","item__W_BlackDahliaWand__lore":"Его темная природа порабощает сердца тех, кто осмеливается держать его в руках.","item__W_BlackDahliaWand__name":"Посох Чёрной Далии","item__W_BlazeRod__gameplay":"Выстреливает огненными шарами!","item__W_BlazeRod__lore":"Найденный в глубинах Нижнего мира, этот жезл наделен душой Блейза.","item__W_BlazeRod__name":"Жезл Блейза","item__W_Bloodrider__gameplay":"Выстреливает стрелами, наносящими сильный кровоточивый урон.","item__W_Bloodrider__lore":"Изготовленный из костей павших воинов, этот зловещий лук поглощает жизнь с каждой стрелой, оставляя за собой след карминного отчаяния.","item__W_Bloodrider__name":"Кровавый всадник","item__W_BrokenDeathstick__gameplay":"Выстреливает хаотическими снарядами, наносящими умеренный урон.","item__W_BrokenDeathstick__lore":"Был бы смертельным... если бы не был сломан.","item__W_BrokenDeathstick__name":"Сломанный жезл смерти","item__W_CandlelightStaff__gameplay":"Устанавливает видимую ловушку возле ваших ног, наносящую огненный урон.","item__W_CandlelightStaff__lore":"Посох, излучающий мягкий свет, освещающий тьму.","item__W_CandlelightStaff__name":"Посох Света","item__W_CelestialBow__gameplay":"Небесный посланник наполнил эти стрелы холодом пустоты.","item__W_CelestialBow__lore":"Дарованный древними богами, этот сияющий лук направляет божественные благословения, пронзая даже самую стойкую защиту.","item__W_CelestialBow__name":"Небесный Лук","item__W_CrudeCrossbow__gameplay":"Выстреливает базовыми болтами, наносящими физический урон.","item__W_CrudeCrossbow__lore":"Грубый арбалет, изготовленный из обрезков дерева и веревки. Он не очень мощный, но сойдет.","item__W_CrudeCrossbow__name":"Грубый Арбалет","item__W_DarylsInstinct__gameplay":"Выстреливает мощными болтами, наносящими урон кровотечением.","item__W_DarylsInstinct__lore":"Арбалет, использованный легендарным охотником Дэрилом.","item__W_DarylsInstinct__name":"Инстинкт Дэрила","item__W_DavidBowie__gameplay":"Выстреливает слабыми физическими снарядами.","item__W_DavidBowie__lore":"Превращает вас в мгновенную звезду!","item__W_DavidBowie__name":"Дэвид Боуи","item__W_DemonsEye__gameplay":"Устанавливает видимую ловушку у ваших ног, наносящую теневой урон.","item__W_DemonsEye__lore":"Этот посох призывает зловещие шепоты пустоты, позволяя владельцу проникать сквозь иллюзии и раскрывать скрытые правды, которые скрываются в тени.","item__W_DemonsEye__name":"Глаз Демона","item__W_DivineWind__gameplay":"Выстреливает мощными святыми стрелами.","item__W_DivineWind__lore":"Выкованный в священных горных убежищах, этот эфирный лук приводит стрелы в движение с помощью потустороннего порыва, проникая сквозь препятствия и врагов.","item__W_DivineWind__name":"Божественный Ветер","item__W_DragonsBreath__gameplay":"Создает поток огня перед заклинателем.","item__W_DragonsBreath__lore":"Я кастую... Огненный шар?","item__W_DragonsBreath__name":"Дыхание Дракона","item__W_EldritchBlasters__gameplay":"Быстро выстреливает теневыми болтами.","item__W_EldritchBlasters__lore":"Двойные арбалеты, наполненные силой тьмы.","item__W_EldritchBlasters__name":"Эльдрические Бластеры","item__W_Emberstrike__gameplay":"Выстреливает мощными огненными стрелами.","item__W_Emberstrike__lore":"Выкованный в сердце вулкана, этот обсидиановый лук выпускает палящие стрелы, оставляя за собой следы тлеющего опустошения.","item__W_Emberstrike__name":"Пылающий Удар","item__W_FairyBow__gameplay":"Выстреливает стрелами, наполненными феерической магией.","item__W_FairyBow__lore":"Наполняет стрелы, выпущенные из этого лука, случайной мощной энергией.","item__W_FairyBow__name":"Феерический Лук","item__W_FairyStaff__gameplay":"Размещает видимую ловушку возле ваших ног, наносящую природный урон.","item__W_FairyStaff__lore":"Принадлежал феерической королеве.","item__W_FairyStaff__name":"Феерический Посох","item__W_FathersBane__gameplay":"Быстро стреляет слабыми болтами с ядовитыми наконечниками.","item__W_FathersBane__lore":"Использовался печальным сыном, которому не оставалось выбора, кроме как убить своего отца.","item__W_FathersBane__name":"Погибель Отца","item__W_FlamespitterStaff__gameplay":"Устанавливает видимую ловушку возле ваших ног, наносящую урон арканой магией.","item__W_FlamespitterStaff__lore":"Яростные пламена вырываются из этого посоха.","item__W_FlamespitterStaff__name":"Посох Огненного Вихря","item__W_FrostedTips__gameplay":"Наносит урон морозом.","item__W_FrostedTips__lore":"Святая вакханалия, Стромболи!","item__W_FrostedTips__name":"Застывшие Наконечники","item__W_GuardsCrossbow__gameplay":"Более простой и быстрый в использовании, чем обычный арбалет.","item__W_GuardsCrossbow__lore":"Арбалет, используемый стражами Арканного Ордена.","item__W_GuardsCrossbow__name":"Арбалет Стражей","item__W_HibidyKibity__gameplay":"Выстреливает смертоносными хаотическими снарядами.","item__W_HibidyKibity__lore":"Волшебная палочка, пропитанная темной энергией убийственного проклятия.","item__W_HibidyKibity__name":"Хибиди Кибити","item__W_IcewindWand__gameplay":"Создает поток замерзающих облаков перед заклинателем.","item__W_IcewindWand__lore":"Способен создавать самую неприятную погоду.","item__W_IcewindWand__name":"Посох Ледяного Ветра","item__W_IronStaff__gameplay":"Устанавливает видимую ловушку возле ваших ног, наносящую физический урон.","item__W_IronStaff__lore":"Посох из железа, используемый стражами Арканного Ордена.","item__W_IronStaff__name":"Железный Посох","item__W_KingBible__gameplay":"Запускает мощные святые библии в сторону ваших противников.","item__W_KingBible__lore":"Почтенный, золоченый том, хранящий священные слова древних монархов, дарующих власть и формирующих судьбы.","item__W_KingBible__name":"Королевская Библия","item__W_Deathstick__gameplay":"Приносит смерть, выпуская быстрые короткодальностные снаряды, за счет замедления пользователя.","item__W_Deathstick__lore":"Легенда гласит, что эта мощная оружия была уронена загадочной фигурой века назад.","item__W_Deathstick__name":"Дэтстик","item__W_BookOfTongues__gameplay":"Выстреливает самым могучим огнем из глубин ада. Имеет ОЧЕНЬ долгое время восстановления.","item__W_BookOfTongues__lore":"На его страницах видно неразборчивое имя. Вы можете разглядеть только букву \\"М\\".","item__W_BookOfTongues__name":"Книга Языков","item__W_LichsStaff__gameplay":"Устанавливает видимую ловушку у ваших ног, наносящую теневой урон.","item__W_LichsStaff__lore":"Используется темными некромантами, этот посох оснащен нечестивой силой нежити, принося смерть и разложение всему, что касается.","item__W_LichsStaff__name":"Посох Лича","item__W_FrostFlicker__gameplay":"Устанавливает видимую ловушку рядом с вашими ногами, наносящую урон морозом.","item__W_FrostFlicker__lore":"Посох с возможностью замораживать воду в окружающей области. Слабая версия этого часто используется в праздничный сезон.","item__W_FrostFlicker__name":"Мерцающий Мороз","item__W_MagicalWand__gameplay":"Выстреливает магическими арканскими снарядами.","item__W_MagicalWand__lore":"Во имя Луны, я накажу тебя!","item__W_MagicalWand__name":"Магическая Палочка","item__W_MidasStaff__gameplay":"Размещает видимую ловушку у ваших ног, наносящую урон молнией.","item__W_MidasStaff__lore":"Посох легендарного Короля Мидаса.","item__W_MidasStaff__name":"Посох Мидаса","item__W_MoonShadow__gameplay":"Быстро стреляет теневыми стрелами.","item__W_MoonShadow__lore":"Подаренный лунными духами, этот мистический лук стреляет стрелами, проникающими сквозь тени и поражающими с неожиданных углов.","item__W_MoonShadow__name":"Лунная Тень","item__W_NaturesReturn__gameplay":"Используйте силу леса, чтобы нанести большой урон природы вашим противникам.","item__W_NaturesReturn__lore":"Том, украшенный листвой, канализующий силы природы для роста, исцеления и бурь.","item__W_NaturesReturn__name":"Возвращение Природы","item__W_NightStick__gameplay":"Выстреливает снарядами холоднее ночи.","item__W_NightStick__lore":"Используется теми, кто стремится поддерживать мир.","item__W_NightStick__name":"Ночной Дубинка","item__W_PharaohsStaff__gameplay":"Размещает видимую ловушку у ваших ног, наносящую святой урон.","item__W_PharaohsStaff__lore":"Извлечен из гробницы древнего фараона, этот посох, как говорят, использовался для призыва мертвых.","item__W_PharaohsStaff__name":"Посох фараона","item__W_PhoenixWing__gameplay":"Выстреливает стрелами, пропитанными пламенем павшего феникса.","item__W_PhoenixWing__lore":"Изготовлен из перьев феникса, этот светящийся лук канализирует огненное возрождение, поджигая стрелы пылающими пламенем.","item__W_PhoenixWing__name":"Крыло Феникса","item__W_PoseidonsWand__gameplay":"Выстреливает рыбой.","item__W_PoseidonsWand__lore":"РЫБААААААААА!","item__W_PoseidonsWand__name":"Посох Посейдона","item__W_QuincyBow__gameplay":"Выстреливает стрелами, пропитанными электрической энергией.","item__W_QuincyBow__lore":"Стреляет стрелами, созданными из духовной энергии обладателя.","item__W_QuincyBow__name":"Лук Куинси","item__W_SilentShadow__gameplay":"Выстреливает стрелами, пропитанными теневой энергией.","item__W_SilentShadow__lore":"\\"Они пришли без предупреждения и застали нас врасплох. Мы сумели отразить их, но потеряли многих в процессе.\\"","item__W_SilentShadow__name":"Тихая Тень","item__W_RangersGuillotine__gameplay":"Выстреливает отравленными стрелами.","item__W_RangersGuillotine__lore":"Смертоносный и точный, этот жестокий лук проникает сквозь защиту, заполняя жертву отравленными стрелами.","item__W_RangersGuillotine__name":"Гильотина Рейнджера","item__W_ReapersEmbrace__gameplay":"Выстреливает мощными хаосными снарядами.","item__W_ReapersEmbrace__lore":"Призрачный лук, который высасывает жизнь с каждой стрелой, запутывая врагов в ледяном объятии Жнеца.","item__W_ReapersEmbrace__name":"Объятия Жнеца","item__W_RelicWand__gameplay":"Создает физические снаряды, наносящие большой урон.","item__W_RelicWand__lore":"Канализует сущность потерянных цивилизаций и забытой магии.","item__W_RelicWand__name":"Реликвийная Палочка","item__W_ReliqueryCrossbow__gameplay":"Выстреливает хаосными снарядами, наносящими большой урон.","item__W_ReliqueryCrossbow__lore":"Арбалет, используемый священниками Вампирской Реликварии.","item__W_ReliqueryCrossbow__name":"Арбалет Реликвария","item__W_SamsStirringStick__gameplay":"Устанавливает видимую ловушку возле ваших ног, наносящую урон арканой магией.","item__W_SamsStirringStick__lore":"Легендарная варежка шеф-повара, наделенная силой (кулинарных) элементов.","item__W_SamsStirringStick__name":"Варежка Сэма","item__W_SlimeStaff__gameplay":"Размещает видимую ловушку возле ваших ног, наносящую природный урон.","item__W_SlimeStaff__lore":"Посох, пульсирующий сущностью слизней, позволяет владельцу призывать и командовать этими желеобразными существами.","item__W_SlimeStaff__name":"Посох Слизней","item__W_SpellbindersTome__gameplay":"Излучает арканную магическую энергию в сторону противников.","item__W_SpellbindersTome__lore":"Мистическая кожаная книга, запутывающая разум своими сложными заклинаниями чародейства.","item__W_SpellbindersTome__name":"Том Чародея","item__W_SpiraledWand__gameplay":"Выстреливает магической энергией в виде магических снарядов.","item__W_SpiraledWand__lore":"На самом деле, это всего лишь более изысканный палочка.","item__W_SpiraledWand__name":"Витая Палочка","item__W_StaffOfTheSnake__gameplay":"Устанавливает видимую ловушку возле ваших ног, наносящую токсический урон.","item__W_StaffOfTheSnake__lore":"Посох, украшенный головой кобры, высеченной из изумруда. Говорят, что он способен плевать ядом на врагов.","item__W_StaffOfTheSnake__name":"Посох Змеи","item__W_StarShot__gameplay":"Выстреливает сильными арканными стрелами, пропитанными энергией звезд.","item__W_StarShot__lore":"Вырезанный из небесных фрагментов, этот лук выпускает каскад искрящихся снарядов, небесное зрелище разрушения.","item__W_StarShot__name":"Звездный Выстрел","item__W_StarWand__gameplay":"Излучает мощь звезд на ваших оппонентов.","item__W_StarWand__lore":"Капризный и блестящий инструмент.","item__W_StarWand__name":"Звездная Палочка","item__W_SteelCrossbow__gameplay":"Выстреливает арбалетными болтами, проникающими даже сквозь самые толстые шкуры.","item__W_SteelCrossbow__lore":"Стандартный арбалет, сделанный из стали.","item__W_SteelCrossbow__name":"Стальной Арбалет","item__W_Stick__gameplay":"Выстреливает искрами магической энергии.","item__W_Stick__lore":"Их много, но этот - мой!","item__W_Stick__name":"Палка","item__W_TheCrossBow__gameplay":"Выстреливает священными снарядами с высокой скоростью.","item__W_TheCrossBow__lore":"Доставьте правосудие лорду с помощью этого легендарного арбалета.","item__W_TheCrossBow__name":"Перекрестный Арбалет","item__W_ToxicWand__gameplay":"Выстреливает токсичным шаром.","item__W_ToxicWand__lore":"Это может вызвать привыкание, но вы должны знать, что это токсично.","item__W_ToxicWand__name":"Токсичная Палочка","item__W_Triforce__gameplay":"Излучает силу Треугольника на ваших оппонентов.","item__W_Triforce__lore":"Сияющий том, открывающий божественные силы мужества, мудрости и силы.","item__W_Triforce__name":"Треугольник","item__W_TwistedBranch__gameplay":"Размещает видимую ловушку у ваших ног, наносящую урон молнией.","item__W_TwistedBranch__lore":"Грубая трость, которую очаровал покойный волшебник.","item__W_TwistedBranch__name":"Изогнутая Ветка","item__W_WitchHuntersRepeaters__gameplay":"Выстреливает болтами, пропитанными святым сиянием.","item__W_WitchHuntersRepeaters__lore":"Обычные арбалеты, используемые Охотниками на Ведьм из Арканного Ордена.","item__W_WitchHuntersRepeaters__name":"Арбалет Охотника на Ведьм","item__W_WizardsLedger__gameplay":"БЫСТРО стреляет монетами. Да, монетами.","item__W_WizardsLedger__lore":"Это платная победа?","item__W_WizardsLedger__name":"Записи Волшебника","item__W_WyvernsTalon__gameplay":"Выстреливает мощными болтами, наносящими кровотечение.","item__W_WyvernsTalon__lore":"Арбалет, созданный из когтей великого виверна.","item__W_WyvernsTalon__name":"Коготь Виверны","item__W_ZappingWand__gameplay":"Выстреливает молниями.","item__W_ZappingWand__lore":"Принесите взрыв электрической мощи в свой магический арсенал.","item__W_ZappingWand__name":"Палочка Записи","item_container__loot_chest":"Сундук добычи","item_container__loot_drop":"Падение добычи","item_rarity__common":"Обычный","item_rarity__epic":"Эпический","item_rarity__legendary":"Легендарный","item_rarity__rare":"Редкий","item_rarity__uncommon":"Необычный","common":"Обычный","uncommon":"Необычный","rare":"Редкий","epic":"Эпический","legendary":"Легендарный","item_slot__damage":"урон","item_slot__equip_prompt":"Нажмите левой кнопкой мыши, чтобы экипировать!","item_slot__extract_prompt":"Извлеките, чтобы использовать этот предмет!","item_slot__grants_ability":"Предоставляет способность","item_slot__grants_passive":"Пассивный эффект","item_slot__loot_prompt":"Нажмите левой кнопкой мыши, чтобы собрать добычу!","loadout_menu__abilities_header":"Способности","loadout_menu__back_to_main_menu_button":"Назад","loadout_menu__damage":"Урон","loadout_menu__defence":"Защита","loadout_menu__gear_header":"Снаряжение","loadout_menu__health":"Здоровье","loadout_menu__insurance_button":"Страховка","loadout_menu__no_abilities":"В вашем наборе отсутствуют способности.","loadout_menu__no_slot_selected_insurance_text":"\uD83D\uDEA8 Ничто не застраховано! \uD83D\uDEA8","loadout_menu__no_slot_selected_insurance_text_2":"Ни один слот не застрахован! Посмотрите рекламу, чтобы защитить 1 предмет.","loadout_menu__no_slot_selected_scrollbox":"Выберите слот, чтобы изменить набор","loadout_menu__scrollbox_with_gear_text":"Выберите снаряжение","loadout_menu__scrollbox_with_skins_text":"Выберите скин","loadout_menu__scrollbox_with_weapons_text":"Выберите оружие","loadout_menu__skin_header":"Выберите скин","loadout_menu__slot_insured_text":"✅ У вас есть страховка! ✅","loadout_menu__start_run_button":"Играть","loadout_menu__stat":"Статистика","loadout_menu__title":"Набор","loadout_menu__undo":"Отменить","loadout_menu__weapons_header":"Оружие","loadout_menu__will_be_safe":"будет защищен, если вы умрете.","loadout_menu__your":"Ваш","login__header":"Войти","fullscreen":"Полноэкранный режим","exit_fullscreen":"Выйти из полноэкранного режима","loot_prompt":"[ E ] чтобы собрать добычу","leaderboard__player_kills":"PK","leaderboard__loot":"Добыча","leaderboard__npc_kills":"NPCK","main_menu__patch_notes_btn":"Заметки об обновлении","main_menu__change_username_btn":"Изменить имя пользователя","main_menu__create_account_btn":"Создать аккаунт","main_menu__collection_log_btn":"Журнал коллекций","collection_log__header":"Журнал коллекций","main_menu__discord_btn_tooltip":"Находите друзей и присоединяйтесь к нам в Discord!","main_menu__game_is_in_maintenance_mode":"PvPz.io обновляется! Новое обновление будет установлено в ближайшее время, попробуйте еще раз через несколько минут","main_menu__how_to_play_btn":"Как играть","main_menu__identity_error_title":"Упс","main_menu__loading_bar_text":"Загрузка...","main_menu__logout_btn":"Выйти","main_menu__partners":"Партнеры","main_menu__partners_and_credits":"Все партнеры и заслуги","main_menu__patch_prefix":"Обновление","main_menu__patch_suffix":"выходит 1 июня!","main_menu__play_btn":"Играть","main_menu__rankings_btn":"Рейтинги","main_menu__settings_btn":"Настройки","main_menu__sign_in_btn":"Войти","main_menu__sign_in_with_discord_btn":"Войти через Discord","main_menu__sign_in_with_facebook_btn":"Войти через Facebook","main_menu__sign_in_with_google_btn":"Войти через Google","main_menu__twitter_btn_tooltip":"Подпишитесь на нас в Twitter!","main_menu__vendors_btn":"Торговцы","main_menu__view_inventory_btn":"Инвентарь","main_menu__view_your_stats_btn":"Ваша статистика","main_menu__website_btn_tooltip":"Посетите наш вебсайт!","main_menu__welcome_panel_title":"Добро пожаловать","main_menu__welcome_panel_title_suffix":",","main_menu__welcome_sign_in_cta":"Хотите изменить имя пользователя? Войдите!","main_menu_stash__collectors_items":"Предметы коллекционера","main_menu_stash__discovered":"Обнаружено","main_menu_stash__gear":"Снаряжение","main_menu_stash__header":"Склад","main_menu_stash__total_items_discovered":"Обнаруженные предметы","main_menu_stash__vendor_items":"Предметы торговцев","main_menu_stash__weapons":"Оружие","player_skins__boltman":"Лучник","player_skins__corrupted_wizard":"Искаженный волшебник","player_skins__knight":"Рыцарь","player_skins__red_wizard":"Ученик волшебника","player_skins__thief":"Вор","player_skins__veteran_wizard":"Волшебник Драконьей Школы","rankings__back_to_main_menu_button":"Назад","rankings__coming_soon":"Скоро!","rankings__title":"Рейтинги","region__dreamers_forest":"Лес Мечтателей","region__ert_lich":"Ирт Лич","region__erthel":"Эртель","region__forgotten_temple":"Забытый храм","region__skull_lake":"Озеро Черепов","region__swamp_of_sorrows":"Болото Печали","region__the_edgelands":"Граничные земли","region__wilderness":"Дикая местность","dreamers forest":"Лес Мечтателей","ert lich":"Ирт Лич","erthel":"Эртель","forgotten temple":"Забытый храм","skull lake":"Озеро Черепов","swamp of sorrows":"Болото Печали","edgelands":"Граничные земли","wilderness":"Дикая местность","register__delete_account_cta":"Вы являетесь анонимным пользователем, поэтому ваша учетная запись будет удалена через 2 недели! Если вы хотите сохранить свои предметы и статистику, а также изменить имя пользователя, пожалуйста, зарегистрируйтесь!","register__delete_account_cta_2":"Вы являетесь анонимным пользователем, поэтому вы не можете просматривать статистику! Если вы хотите увидеть свою статистику, изменить имя пользователя и разблокировать особые скины, пожалуйста, зарегистрируйтесь!","register__delete_account_cta_less_aggressive":"Если вы хотите сохранить свои предметы и статистику навсегда, а также изменить имя пользователя, пожалуйста, зарегистрируйтесь!","register__email":"Введите адрес электронной почты","register__email_confirm":"Подтвердите адрес электронной почты","register__email_placeholder":"Адрес электронной почты","register__email_placeholder_confirm":"Подтвердите адрес электронной почты","register__header":"Регистрация","register__or":"Или","register__password":"Введите пароль","register__password_confirm":"Подтвердите пароль","register__register":"Зарегистрироваться","register__register_with_discord_btn":"Зарегистрироваться через Discord","register__register_with_google_btn":"Зарегистрироваться через Google","register__username":"Выберите имя пользователя","runprep__skin_not_unlocked_registered":"Только ЗАРЕГИСТРИРОВАННЫЕ ПОЛЬЗОВАТЕЛИ могут использовать этот скин!","settings__back_to_main_menu_button":"Назад","settings__enable_music":"Включить музыку","settings__enable_sfx":"Включить звуковые эффекты","settings__language":"Язык / LANGUAGE","settings__language_dropdown_english":"Английский / English","settings__language_dropdown_portuguese":"Португальский / Portuguese / Portugu\xeas","settings__language_dropdown_russian":"Русский / Russian","settings__language_dropdown_spanish":"Испанский / Spanish / Espa\xf1ol","settings__matchmaking_region":"Регион подбора игроков","settings__matchmaking_region_dropdown_africa":"Африка","settings__matchmaking_region_dropdown_any":"Любой регион (самый быстрый)","settings__matchmaking_region_dropdown_asia":"Азия","settings__matchmaking_region_dropdown_australia_oceania":"Австралия/Океания","settings__matchmaking_region_dropdown_eu":"Европа","settings__matchmaking_region_dropdown_middle_east":"Ближний Восток","settings__matchmaking_region_dropdown_na_east":"Северная Америка (Восток)","settings__matchmaking_region_dropdown_na_west":"Северная Америка (Запад)","settings__matchmaking_region_dropdown_south_america":"Южная Америка","settings__save_button":"Сохранить","settings__title":"Настройки","settings__settings_saved":"Настройки сохранены!","signin_sign_in":"Войти","signin_sign_in_with_discord_btn":"Войти через Discord","signin_sign_in_with_google_btn":"Войти через Google","item_type__weapon":"Оружие","item_type__gear":"Снаряжение","item_type__vendor":"Предмет для торговцев","item_type__collector":"Специальный предмет","item_type__unknown":"Неизвестно","stat_type_arcane":"Магия","stat_type_bleed":"Кровотечение","stat_type_chaos":"Хаос","stat_type_fire":"Огонь","stat_type_frost":"Мороз","stat_type_holy":"Святость","stat_type_lightning":"Молния","stat_type_nature":"Природа","stat_type_physical":"Физический","stat_type_shadow":"Тень","stat_type_toxic":"Токсичность","stats__back_btn":"Назад","stats__boss_kills":"Убийства боссов","stats__common_items_looted":"обычные предметы собраны","stats__distanced_travelled":"пройденное расстояние","stats__epic_items_looted":"эпические предметы собраны","stats__failed_runs":"неудачные попытки","stats__global_rank":"глобальное место","stats__gold_looted":"собрано золота","stats__gold_lost_to_deaths":"потеряно золота при смерти","stats__header":"Статистика","stats__items_looted":"собранные предметы","stats__items_lost_to_deaths":"потерянные предметы при смерти","stats__legendary_items_looted":"собранные легендарные предметы","stats__npc_kills":"убийства NPC","stats__player_kills":"убийства игроков","stats__rare_items_looted":"собранные редкие предметы","stats__run_success_percentage":"процент успешных попыток","stats__runs":"попытки","stats__successful_runs":"успешные попытки","stats__time_played":"время игры","stats__uncommon_items_looted":"собранные необычные предметы","toast__email_doesnt_match":"Адреса электронной почты не совпадают!","toast__email_not_long_enough":"Адрес электронной почты слишком короткий!","toast__gods_granted_you_items":"Боги дали вам некоторое базовое снаряжение!","toast__not_an_email_address":"Похоже, это не настоящий адрес электронной почты!","toast__password_not_long_enough":"Пароль слишком короткий!","toast__passwords_dont_match":"Пароли не совпадают!","toast__username_changed":"Имя пользователя успешно изменено!","toast__username_too_short":"Имя пользователя слишком короткое!","vendors__back_to_main_menu_button":"Назад","vendors__coming_soon":"Скоро!","vendors__title":"Торговцы","event_feed__looted_a":"получил(а)","event_feed__in_the":"в","event_feed__at":"на","event_feed__killed":"убил","event_feed__boss":"босса","event_feed__is_extracting":"извлекает","event_feed__has_extracted":"успешно извлёк!","event_feed__has_spawned":"появился в","event_feed__under_attack":"атакуют в"}');


var $93d73e6cae807cfd$exports = {};
$93d73e6cae807cfd$exports = JSON.parse('{"register__terms_label_1":"Al registrarte en PvPz.io & Second Monitor Games, est\xe1s aceptando nuestros","register__terms_label_2":"T\xe9rminos de Servicio","register__terms_label_3":"Pol\xedtica de Privacidad","register__promo_label":"Est\xe1 bien que Second Monitor Games me env\xede correos electr\xf3nicos sobre promociones y actualizaciones del juego","adblock_detected_failed_to_insure":"Algo sali\xf3 mal al asegurar ese art\xedculo. \xa1Por favor, aseg\xfarate de que tu bloqueador de anuncios est\xe9 desactivado!","ability_type_active":"Activo","ability_type_passive":"Pasivo","change_username__back":"Volver","change_username__cant_be_empty_error":"El nombre de usuario no puede estar vac\xedo","change_username__current_prompt":"Tu nombre de usuario actual","change_username__enter_new":"Ingresa un nuevo nombre de usuario","change_username__header":"Nombre de usuario","change_username__save":"Guardar","change_username__too_long_error":"El nombre de usuario no puede tener m\xe1s de 20 caracteres.","character_already_on_run_menu__abondon_run_button":"Abandonar ejecuci\xf3n","character_already_on_run_menu__back_to_main_menu_button":"Volver","character_already_on_run_menu__bolded_header":"\xa1Tu personaje ya est\xe1 en una ejecuci\xf3n!","character_already_on_run_menu__paragraph_one":"Tu personaje a\xfan no ha regresado de su ejecuci\xf3n anterior. \xa1Si comienzas una nueva ejecuci\xf3n ahora, todos tus objetos de la ejecuci\xf3n anterior (excepto los objetos asegurados) se perder\xe1n!","character_already_on_run_menu__paragraph_two":"Si crees que esto es un error, o si deseas abandonar intencionalmente tu ejecuci\xf3n, puedes abandonarla forzosamente utilizando el bot\xf3n de abajo.","character_already_on_run_menu__title":"\xa1ADVERTENCIA!","connection_error__back_to_main_menu":"Volver al men\xfa principal","connection_error__error_reason":"Motivo del error","connection_error__oof":"\xa1Vaya!","connection_error__server_error_header":"\xa1Error de conexi\xf3n al servidor!","death_menu__back_to_main_menu_button":"Volver al men\xfa","death_menu__gear_lost":"Objetos perdidos","death_menu__gold_lost":"Oro perdido","death_menu__insured_items":"Objetos asegurados","death_menu__loot_lost":"Bot\xedn perdido","death_menu__nothing_insured":"\xa1No se aseguraron objetos!","death_menu__saving_your_run_button":"Guardando...","death_menu__spectate_button":"Observar al asesino","death_menu__survived_for":"Sobreviviste durante","death_menu__title":"R.I.P.","death_menu__weapons_lost":"Armas perdidas","death_menu__your_killer":"Tu asesino","extracted_menu__back_to_main_menu_button":"Volver al men\xfa","extracted_menu__gold_looted":"Oro saqueado","extracted_menu__loot_acquired":"Bot\xedn adquirido","extracted_menu__run_duration":"Duraci\xf3n de la ejecuci\xf3n","extracted_menu__title":"\xa1Extra\xeddo!","game_hud__cooldown":"Tiempo de espera","game_hud__find_an_extraction_point":"\xa1Encuentra un punto de extracci\xf3n!","game_hud__inventory_extract_prompt":"\xa1Debes extraerte para usar este bot\xedn!","game_hud__inventory_hud":"Abrir inventario","game_hud__leaderboard":"Tabla de clasificaci\xf3n","game_hud__leaderboard_current_world":"Mundo actual","game_hud__leaderboard_hide":"Ocultar","game_hud__leaderboard_show":"Mostrar","game_hud__looted_container_close":"Cerrar","game_hud__spectating":"Observando","game_hud__time_left_to_extract":"tiempo restante para extraer","game_hud__your_inventory_header":"\xa1Tu inventario!","game_hud__your_inventory_hide":"para cerrar","game_transition__finding_match":"Buscando partida","hotkey_interact":"E","hotkey_open_inventory":"i","hotkey_toggle_leaderboard":"L","how_to_play__ability_one_key":"Habilidad #1","how_to_play__ability_three_key":"Habilidad #3","how_to_play__ability_two_key":"Habilidad #2","how_to_play__back_to_main_menu_button":"Volver","how_to_play__chat_key":"Chat","how_to_play__extraction":"\xa1Encuentra un punto de extracci\xf3n!","how_to_play__inventory_key":"Inventario","how_to_play__leaderboard_key":"Tabla de clasificaci\xf3n","how_to_play__mouse_aim_controls":": Apuntar","how_to_play__mouse_shoot_controls":": Disparar","how_to_play__move_down_key":"Mover hacia abajo","how_to_play__move_left_key":"Mover hacia la izquierda","how_to_play__move_right_key":"Mover hacia la derecha","how_to_play__move_up_key":"Mover hacia arriba","how_to_play__small_paragraph_one":"Si no logras extraerte a tiempo, perder\xe1s todos los objetos que llevas contigo (\xa1a menos que los hayas asegurado!) y todos los objetos que hayas saqueado en tu ejecuci\xf3n. Extraer es muy importante. Debes EXTRAER con tu bot\xedn para conservarlo y usarlo.","how_to_play__small_paragraph_three":"\xa1Mata o s\xe9 asesinado, que gane el mejor aventurero!","how_to_play__small_paragraph_two":" ","how_to_play__test_keys_header":"\xa1Prueba las teclas!","how_to_play__title":"PvPz.io","how_to_play__top_big_paragraph":"\xa1Mata a otros jugadores, encuentra bot\xedn y extrae!","how_to_play__weapon_one_key":"Arma #1","how_to_play__weapon_two_key":"Arma #2","in_game__extracting":"Extrayendo...","in_game__time_remaining":"Tiempo restante...","in_game__warning_time_almost_up":"\xa1Encuentra un punto de extracci\xf3n!","insured_item_nothing":"Nada","item__AG_AmuletOfCursedFate__gameplay":"+10% de Velocidad de Ataque | REANIMA con 40% de Salud cuando mueres (no se acumula con otros objetos de resurrecci\xf3n)","item__AG_AmuletOfCursedFate__lore":"Un amuleto mal\xe9volo que retuerce los destinos y trae consigo oscuros presagios.","item__AG_AmuletOfCursedFate__name":"Amuleto del Destino Maldito","item__AG_MagicBoots__name":"Botas M\xe1gicas","item__AG_MagicBoots__gameplay":"Vuelve invisible durante 9 segundos al usarlo (2 usos) | Tu salud se regenera todo el tiempo | Extracci\xf3n 10% m\xe1s lenta.","item__AG_MagicBoots__lore":"Estas botas no hacen ruido y revitalizan a quien las lleva puestas.","item__AG_Boros__gameplay":"Vuelve invisible durante 7 segundos al usarlo | -12% de Da\xf1o a PNJ | +12% de Robo de vida por todo el da\xf1o que infliges a jugadores","item__AG_Boros__lore":"Se rumorea que su gema fue creada a partir del ojo de un cambiaformas.","item__AG_Boros__name":"Boros","item__AG_DarkPustulesRing__gameplay":"Recibes 5% menos de da\xf1o mientras te extraes | Extraes 5% m\xe1s r\xe1pido","item__AG_DarkPustulesRing__lore":"Este anillo se puede usar para obtener m\xe1gicamente l\xedquido oscuro y dulce durante un d\xeda.","item__AG_DarkPustulesRing__name":"Anillo de P\xfastulas Oscuras","item__AG_DreamWeaversEmbrace__gameplay":"Vuelve invisible durante 4 segundos al usarlo | -5% de Da\xf1o a jugadores | Extrae un 10% m\xe1s r\xe1pido | INCOGNITO: Oculta tu bot\xedn y los mensajes de tu ubicaci\xf3n al resto del mundo","item__AG_DreamWeaversEmbrace__lore":"Las piedras de este anillo cambian de color en \xe1reas donde el velo es delgado.","item__AG_DreamWeaversEmbrace__name":"Abrazo del Tejedor de Sue\xf1os","item__AG_ForestsHaven__gameplay":"Cura 20 de HP al usarlo | Extrae un 10% m\xe1s r\xe1pido | INCOGNITO: Oculta tu bot\xedn y los mensajes de tu ubicaci\xf3n al resto del mundo | +20% de Et\xe9reo","item__AG_ForestsHaven__lore":"Para aquellos que llevan este anillo, busquen el bosque de \xe1rboles escondido entre los sue\xf1os.","item__AG_ForestsHaven__name":"Refugio del Bosque","item__AG_MysteriousRing__gameplay":"Agrega 30 segundos a tu temporizador de extracci\xf3n al usarlo | +10 de Salud M\xe1xima | +7% de Velocidad de Movimiento al caminar en el agua","item__AG_MysteriousRing__lore":"???","item__AG_MysteriousRing__name":"Anillo Misterioso","item__AG_ObsidianEcho__gameplay":"EXTRACCI\xd3N al usarlo, sin importar d\xf3nde te encuentres | +12% de Velocidad de Movimiento | REANIMA con 70% de Salud cuando mueres (no se acumula con otros objetos de resurrecci\xf3n) | -30 de Salud M\xe1xima | Este objeto se destruye cuando se usa completamente","item__AG_ObsidianEcho__lore":"Forjado a partir de un fragmento de la espada de Malachi. Si escuchas atentamente, puedes o\xedr el eco de las almas de aquellos a quienes \xe9l mat\xf3.","item__AG_ObsidianEcho__name":"Eco de Obsidiana","item__AG_PepperedCollar__gameplay":"Otorga 4 segundos de aumento del 25% en la velocidad de movimiento al usarlo (1 uso) | -3% Distancia del Proyectil","item__AG_PepperedCollar__lore":"Un collar creado como tributo a una famosa bestia felina.","item__AG_PepperedCollar__name":"Collar Condimentado","item__AG_RingOfAnOceanMan__gameplay":"Concede 2 segundos de +20% de velocidad de movimiento al usarlo | Extracci\xf3n 5% m\xe1s r\xe1pida | +5% de Velocidad de Movimiento al caminar en el agua","item__AG_RingOfAnOceanMan__lore":"Da la sensaci\xf3n de que intenta tomar tu mano y llevarte a una tierra que solo \xe9l comprende.","item__AG_RingOfAnOceanMan__name":"Anillo del Hombre del Oc\xe9ano","item__AG_StuddedNecklace__gameplay":"Vuelve invisible durante 4 segundos al usarlo (3 cargas) | -3% de Velocidad de Movimiento","item__AG_StuddedNecklace__lore":"Deber\xeda asegurarme de esto","item__AG_StuddedNecklace__name":"Collar con Tachuelas","item__AG_TheDarkLordsEmbrace__gameplay":"+30 Salud M\xe1xima","item__AG_TheDarkLordsEmbrace__lore":"Maldito por las diversas atrocidades cometidas por su portador.","item__AG_TheDarkLordsEmbrace__name":"El Abrazo del Se\xf1or Oscuro","item__AG_TimeHerosRing__gameplay":"Agrega 45 segundos a tu temporizador de extracci\xf3n al usarlo | +7% de Velocidad de Ataque | +7% de Velocidad de Movimiento al caminar en el agua | -5% de Velocidad de Movimiento | +9% de Defensa contra Naturaleza | +7% de Da\xf1o de Naturaleza","item__AG_TimeHerosRing__lore":"Usado por un ni\xf1o elfo que pod\xeda viajar en el tiempo.","item__AG_TimeHerosRing__name":"Anillo del H\xe9roe del Tiempo","item__AG_VestiasSoothingSignet__gameplay":"Cura 30PS cuando se usa | INCOGNITO: Oculta tus mensajes de bot\xedn y ubicaci\xf3n al resto del mundo","item__AG_VestiasSoothingSignet__lore":"Un anillo que permite al portador calmar tanto heridas como tensiones en el grupo.","item__AG_VestiasSoothingSignet__name":"Sello Calmante de Vestia","item__AG_ViolasDinnerReminder__gameplay":"+8,5% de Defensa contra Naturaleza | +8,5% de Defensa contra Escarcha | Recibes 7% menos da\xf1o mientras te extraes | Tus proyectiles viajan un 5% menos","item__AG_ViolasDinnerReminder__lore":"Un anillo que le permite a todos a tu alrededor saber cu\xe1ndo tienes hambre.","item__AG_ViolasDinnerReminder__name":"Recordatorio de Cena de Viola","item__AG_WolfMedallion__gameplay":"Cura 10HP al usarlo | +10% de velocidad de ataque | +10% de absorci\xf3n de todo el da\xf1o que infliges a los jugadores","item__AG_WolfMedallion__lore":"Sintonizado con la magia, este medall\xf3n puede detectar lugares cercanos de poder.","item__AG_WolfMedallion__name":"Medall\xf3n del Lobo","item__CI_AlloyedBend__gameplay":"","item__CI_AlloyedBend__lore":"Un anillo hecho de varios metales raros que han sido fusionados aproximadamente.","item__CI_AlloyedBend__name":"Curva Aleada","item__CI_ApposSignet__gameplay":"","item__CI_ApposSignet__lore":"Se rumorea que pertenec\xeda a un h\xedbrido medio drag\xf3n, medio humano que ten\xeda la capacidad de controlar y hablar con los patos.","item__CI_ApposSignet__name":"Sello de Appo","item__CI_BloodhuntersRing__gameplay":"","item__CI_BloodhuntersRing__lore":"El cazasangre busca a su linaje, y tambi\xe9n a ti.","item__CI_BloodhuntersRing__name":"Anillo del Cazasangre","item__CI_CelestialEternity__gameplay":"","item__CI_CelestialEternity__lore":"Aquellos que se levantaron contra Malachi recibieron este anillo de los dioses.","item__CI_CelestialEternity__name":"Eternidad Celestial","item__CI_EbonstarBand__gameplay":"","item__CI_EbonstarBand__lore":"Este anillo contiene parte de la estrella ca\xedda que lo cambi\xf3 todo.","item__CI_EbonstarBand__name":"Banda Estrella de \xc9bano","item__CI_EchoingWhisperNecklace__gameplay":"","item__CI_EchoingWhisperNecklace__lore":"Un collar que captura y hace eco de los murmullos de las almas perdidas.","item__CI_EchoingWhisperNecklace__name":"Collar de Murmullo Ecoante","item__CI_FeyEnchantmentLocket__gameplay":"","item__CI_FeyEnchantmentLocket__lore":"Un medall\xf3n impregnado con encantamientos del reino de las Hadas, otorgando un atractivo seductor.","item__CI_FeyEnchantmentLocket__name":"Medall\xf3n de Encantamiento Fe\xe9rico","item__CI_FragmentOfFate__gameplay":"","item__CI_FragmentOfFate__lore":"Una vez completo, ahora hecho a\xf1icos. Una vez unido, ahora dividido. Una vez eterno, ahora obsoleto.","item__CI_FragmentOfFate__name":"Fragmento del Destino","item__CI_LatrosKnavishBand__gameplay":"","item__CI_LatrosKnavishBand__lore":"Un anillo que solo los m\xe1s viles ladrones con certeza moral usar\xedan.","item__CI_LatrosKnavishBand__name":"Banda Latros de Malhechor","item__CI_LifesSimpleRing__gameplay":"","item__CI_LifesSimpleRing__lore":"Vive de forma sencilla para que otros puedan vivir de forma sencilla.","item__CI_LifesSimpleRing__name":"Anillo de la Vida Simple","item__CI_LuminousEnigma__gameplay":"","item__CI_LuminousEnigma__lore":"Poseo la llave de un vasto conocimiento, proporcionando respuestas inigualables.","item__CI_LuminousEnigma__name":"Enigma Luminoso","item__CI_Ouro__gameplay":"","item__CI_Ouro__lore":"Se dice que es la clave para desbloquear el conocimiento de todas las criaturas vivientes.","item__CI_Ouro__name":"Ouro","item__CI_PeachRing__gameplay":"","item__CI_PeachRing__lore":"Tiene un sabor dulce.","item__CI_PeachRing__name":"Anillo de Durazno","item__CI_PlayerSoulFragment__gameplay":"Un recolector de almas estar\xeda interesado en esto.","item__CI_PlayerSoulFragment__lore":"Un fragmento del alma de un aventurero perdido.","item__CI_PlayerSoulFragment__name":"Fragmento de Alma de Jugador","item__CI_ProudlyPinkRing__gameplay":"","item__CI_ProudlyPinkRing__lore":"Este anillo es un impresionante accesorio de moda que sin duda llamar\xe1 la atenci\xf3n de los dem\xe1s.","item__CI_ProudlyPinkRing__name":"Anillo Orgullosamente Rosa","item__CI_RadiantSunstoneBand__gameplay":"","item__CI_RadiantSunstoneBand__lore":"Una creaci\xf3n parad\xf3jica, este anillo simboliza un delicado equilibrio entre la iluminaci\xf3n y la destrucci\xf3n.","item__CI_RadiantSunstoneBand__name":"Banda de Radiante Piedra Solar","item__CI_RingOfDelerium__gameplay":"","item__CI_RingOfDelerium__lore":"Si escuchas atentamente, puedes o\xedr las voces de los antiguos due\xf1os de este anillo.","item__CI_RingOfDelerium__name":"Anillo de Delirio","item__CI_RoyalBrooch__gameplay":"","item__CI_RoyalBrooch__lore":"El s\xedmbolo de la familia real. Vale una buena cantidad.","item__CI_RoyalBrooch__name":"Broche Real","item__CI_SuperStar__gameplay":"","item__CI_SuperStar__lore":"El remanente de una gran historia sobre un reino lleno de setas.","item__CI_SuperStar__name":"Super Estrella","item__CI_SwampOgresRing__gameplay":"","item__CI_SwampOgresRing__lore":"Perteneci\xf3 alguna vez a un ogro verde que proteg\xeda mucho su pantano.","item__CI_SwampOgresRing__name":"Anillo del Ogro del Pantano","item__CI_WeddingRing__gameplay":"","item__CI_WeddingRing__lore":"Esto vale mucho, deber\xeda devolv\xe9rselo al due\xf1o original.","item__CI_WeddingRing__name":"Anillo de Boda","item__PG_AngelistasPotionPopper__gameplay":"Tu salud se regenera constantemente.","item__PG_AngelistasPotionPopper__lore":"Un anillo que usas cuando tu sanador te proh\xedbe beber pociones de curaci\xf3n.","item__PG_AngelistasPotionPopper__name":"Poci\xf3n Estalladora de Angelista","item__PG_AquamoorsBlessing__gameplay":"Concede 3 segundos de +25% de velocidad de movimiento al usarlo (3 cargas) | Tu salud se regenera todo el tiempo | -20 de Salud M\xe1xima","item__PG_AquamoorsBlessing__lore":"Se dice que est\xe1 bendecido por el esp\xedritu del lago antes de la corrupci\xf3n de las tierras.","item__PG_AquamoorsBlessing__name":"Bendici\xf3n de Aquamoor","item__PG_ArcaneEmber__gameplay":"-6.5% de Da\xf1o a PNJ | +5.6% de Da\xf1o a jugadores","item__PG_ArcaneEmber__lore":"Se puede ver una peque\xf1a brasa que sigue brillando en la gema de este anillo.","item__PG_ArcaneEmber__name":"Ascua Arcana","item__PG_ArcaneSigilCollar__gameplay":"Concede 4 segundos de velocidad de movimiento +30% al usarlo | -8.5% de da\xf1o a PNJ | +9.5% de da\xf1o a jugadores","item__PG_ArcaneSigilCollar__lore":"Grabado con s\xedmbolos poderosos, amplifica las habilidades arcanas del portador.","item__PG_ArcaneSigilCollar__name":"Collar del S\xedmbolo Arcano","item__PG_AssassinSignet__gameplay":"Vuelve invisible durante 5 segundos al usarlo (2 cargas) | -3% Velocidad de movimiento | -3% Distancia de proyectil","item__PG_AssassinSignet__lore":"Un sello sostenido por una infame asesina que luchaba con su cabello.","item__PG_AssassinSignet__name":"Sello del Asesino","item__PG_BellsShiningRing__gameplay":"Agrega 60 segundos a tu temporizador de extracci\xf3n al usarlo | -9,5% de Da\xf1o a jugadores | +15,5% de Da\xf1o a PNJs | +40 de Salud M\xe1xima | Tu salud se regenera todo el tiempo","item__PG_BellsShiningRing__lore":"Conocida por muchos como la mejor sanadora del reino.","item__PG_BellsShiningRing__name":"Anillo Brillante de Belle","item__PG_BloodGemRing__gameplay":"REVIVE con 50% de salud cuando mueras | -20 Salud m\xe1xima","item__PG_BloodGemRing__lore":"Aquellos que estaban en el templo durante el ritual cayeron en una frenes\xed de derramamiento de sangre. Este anillo simboliza tiempos desesperados.","item__PG_BloodGemRing__name":"Anillo de Gema de Sangre","item__PG_BloodiedVitality__gameplay":"EXTRACCI\xd3N al usarlo, sin importar d\xf3nde te encuentres | Tu salud se regenera todo el tiempo | +30 de Salud M\xe1xima | -8% de Da\xf1o a Jugadores | Recibes un 10% m\xe1s de da\xf1o de TODOS los tipos de da\xf1o al extraer | Este objeto se destruye cuando se usa completamente","item__PG_BloodiedVitality__lore":"Tu conexi\xf3n con la realidad y la vida misma se siente m\xe1s fuerte con esto alrededor de tu cuerpo.","item__PG_BloodiedVitality__name":"Vitalidad Ensangrentada","item__PG_BloodmoonLoop__gameplay":"Restaura 5HP al usarlo (3 cargas) | +5% de Da\xf1o por Sangrado","item__PG_BloodmoonLoop__lore":"Relacionado con los ciclos lunares. Esto aumenta la destreza f\xedsica durante una luna de sangre.","item__PG_BloodmoonLoop__name":"Armadura de Luna de Sangre","item__PG_CapeOfPureDarkness__gameplay":"Otorga 4 segundos de velocidad de movimiento +25% cuando se usa | +9% de Defensa de Sombras | +9% de Defensa T\xf3xica | +7% de Da\xf1o T\xf3xico | Tu salud disminuye constantemente.","item__PG_CapeOfPureDarkness__lore":"Nadie se atrev\xeda a cuestionarlo por miedo. Porque el Gobernante Oscuro no deb\xeda ser cuestionado.","item__PG_CapeOfPureDarkness__name":"Capa de Pura Oscuridad","item__PG_CelestialSolaceBand__gameplay":"Cura 7PV al usarlo | INSPECCI\xd3N: Revela informaci\xf3n sobre tus oponentes | Da\xf1o sombr\xedo +6.5%","item__PG_CelestialSolaceBand__lore":"Forjado por los propios dioses, este anillo ofrece consuelo en medio de la oscuridad.","item__PG_CelestialSolaceBand__name":"Banda de Solaz Celestial","item__PG_CelestialStarfallPendant__gameplay":"Vuelve invisible durante 3 segundos al usarlo | +6.5% de da\xf1o a PNJ | Da\xf1o sagrado +5%","item__PG_CelestialStarfallPendant__lore":"Un colgante adornado con una gema celestial, invocando energ\xeda celestial.","item__PG_CelestialStarfallPendant__name":"Colgante de Estrella Celestial","item__PG_CultistsMask__name":"M\xe1scara del Cultista","item__PG_CultistsMask__lore":"Aquellos que cayeron v\xedctimas de la corrupci\xf3n buscaron ocultar su apariencia, ya que la corrupci\xf3n cambi\xf3 su ser por completo.","item__PG_CultistsMask__gameplay":"Vuelve invisible durante 6 segundos al usarlo | INCOGNITO: Oculta tus mensajes de bot\xedn y ubicaci\xf3n del resto del mundo | +15% de Velocidad de Ataque","item__PG_DepthStrider__name":"Andarivel de las Profundidades","item__PG_DepthStrider__lore":"Un encantamiento d\xe9bil se aferra a esta capa, facilitando caminar sobre el agua.","item__PG_DepthStrider__gameplay":"+5% de velocidad de movimiento mientras caminas sobre el agua.","item__PG_GoldenGauntlets__name":"Guanteletes Dorados","item__PG_GoldenGauntlets__lore":"Adecuados para saqueadores, estos guanteletes parecen ayudarte a encontrar m\xe1s oro.","item__PG_GoldenGauntlets__gameplay":"+10% de oro de los cofres.","item__PG_BeastVanquisherBoots__name":"Botas del Vencedor de Bestias","item__PG_BeastVanquisherBoots__lore":"Usadas por aquellos en la primera l\xednea de batalla. Estas botas permitieron la r\xe1pida derrota del enemigo.","item__PG_BeastVanquisherBoots__gameplay":"+12% de Velocidad de Movimiento | +45 de Salud M\xe1xima | +25% de Da\xf1o a PNJs | -12% de Da\xf1o a Jugadores | -12% de Distancia de Proyectiles","item__PG_CloakOfModestApproachability__gameplay":"Tus proyectiles viajan un 6% m\xe1s lejos | Agrega 30 segundos a tu temporizador de extracci\xf3n al usarlo","item__PG_CloakOfModestApproachability__lore":"Los dem\xe1s parecen atra\xeddos hacia ti y no est\xe1n seguros de por qu\xe9.","item__PG_CloakOfModestApproachability__name":"Capa de Modesta Aproximaci\xf3n","item__PG_CloudedDarkness__gameplay":"+20% Et\xe9reo | Da\xf1o sombr\xedo +10% | Defensa sombr\xeda +13%","item__PG_CloudedDarkness__lore":"Cuando lleg\xf3 el momento y se hizo la acci\xf3n, una nube de oscuridad envolvi\xf3 a Malachi y se imbui\xf3 en este anillo.","item__PG_CloudedDarkness__name":"Oscuridad Nublada","item__PG_CompactedLimeGreenRing__gameplay":"Tus proyectiles viajan un 5% m\xe1s lejos | +7% de da\xf1o t\xf3xico","item__PG_CompactedLimeGreenRing__lore":"Sostenido por el heredero del trono de un drag\xf3n.","item__PG_CompactedLimeGreenRing__name":"Anillo Verde Lima Compacto","item__PG_CopperWristband__gameplay":"+6.5% de defensa f\xedsica","item__PG_CopperWristband__lore":"Un anillo c\xf3micamente grande que encaja mejor como una pulsera... Solo se puede imaginar el tama\xf1o de la criatura que usaba esto como anillo.","item__PG_CopperWristband__name":"Pulsera de Cobre","item__PG_CoralReef__gameplay":"+8,5% de Velocidad de Movimiento al caminar en el agua | Extracci\xf3n 10% m\xe1s lenta","item__PG_CoralReef__lore":"Creado como un regalo para la princesa sirena.","item__PG_CoralReef__name":"Arrecife de Coral","item__PG_CorruptedTearRing__gameplay":"Vuelve invisible durante 5 segundos al usarlo | +7% Absorci\xf3n de todo el da\xf1o que infliges a jugadores | -7% Defensa contra Caos | +9% Da\xf1o Ca\xf3tico | +9% Da\xf1o de Rayos","item__PG_CorruptedTearRing__lore":"Una sola l\xe1grima se derram\xf3 antes de que la corrupci\xf3n se apoderara... \\"\xbf\xa1Qu\xe9 he llegado a ser!?\\"","item__PG_CorruptedTearRing__name":"Anillo de L\xe1grima Corrupta","item__PG_CursedEternityRing__gameplay":"Concede 5 segundos de +30% de velocidad de movimiento al usarlo | REANIMA con 48% de Salud cuando mueres (no se acumula con otros objetos de resurrecci\xf3n) | +12% de Oro de los cofres | +8,5% de Absorci\xf3n de Vida de todo el da\xf1o infligido a los jugadores | Tu salud disminuye todo el tiempo","item__PG_CursedEternityRing__lore":"Un s\xedmbolo de condenaci\xf3n eterna. Se adhiere a quien lo lleva, maldici\xe9ndolos por la eternidad pero otorg\xe1ndoles un gran poder.","item__PG_CursedEternityRing__name":"Anillo de Eternidad Maldita","item__PG_CursedSignet__gameplay":"+20% de absorci\xf3n de todo el da\xf1o que infliges a jugadores","item__PG_CursedSignet__lore":"Una presencia mal\xe9vola emana de este anillo, trayendo desgracia a todos los que lo llevan.","item__PG_CursedSignet__name":"Anillo Maldito","item__PG_DeathwhisperWrap__gameplay":"+13% Da\xf1o a NPC | +13% Defensa contra Caos | +10% Da\xf1o T\xf3xico","item__PG_DeathwhisperWrap__lore":"Cuando la hoja se hundi\xf3 en su coraz\xf3n y todo se volvi\xf3 negro, se escuch\xf3 un susurro tenue: \'A\xfan no es tiempo de reclamar tu alma\'.","item__PG_DeathwhisperWrap__name":"Envoltura Susurro Mortal","item__PG_DreadmorneLoop__gameplay":"Concede 3 segundos de +30% de velocidad de movimiento al usarlo (5 cargas) | -5% de Velocidad de Ataque | -6,5% de Defensa Sagrada | +10% de Da\xf1o de Caos","item__PG_DreadmorneLoop__lore":"Este anillo infunde miedo en el coraz\xf3n de los enemigos, inspirando terror y causando temor.","item__PG_DreadmorneLoop__name":"Bucle Pesadumbral","item__PG_DreamcasterDrapery__gameplay":"+6.5% de da\xf1o a NPC | +6.5% de da\xf1o ca\xf3tico","item__PG_DreamcasterDrapery__lore":"Nacido de pesadillas, se dice que esta vestidura manipula el subconsciente.","item__PG_DreamcasterDrapery__name":"Manto del Encantador de Sue\xf1os","item__PG_EbonfireRobelet__gameplay":"Tus proyectiles viajan un 6% m\xe1s lejos","item__PG_EbonfireRobelet__lore":"Envuelve a su portador en una aura de sombras humeantes, otorgando protecci\xf3n contra el da\xf1o elemental.","item__PG_EbonfireRobelet__name":"Brazaletes de Fuego Oscuro","item__PG_ElvenGildedGuardian__gameplay":"Extrae un 5% m\xe1s r\xe1pido","item__PG_ElvenGildedGuardian__lore":"Un cintur\xf3n bellamente elaborado, adornado con hiedra dorada, que mejora la agilidad del portador y repele a los adversarios con la destreza \xe9lfica.","item__PG_ElvenGildedGuardian__name":"Guardi\xe1n Dorado \xc9lfico","item__PG_EmbergraspRing__gameplay":"+10 Salud m\xe1xima","item__PG_EmbergraspRing__lore":"Las llamas danzan y titilan al tocarlo, quemando a tus enemigos.","item__PG_EmbergraspRing__name":"Anillo de Agarre de Brasa","item__PG_EnchantedElixirNecklace__name":"Collar de Elixir Encantado","item__PG_EnchantedElixirNecklace__gameplay":"Agrega 60 segundos a tu temporizador de extracci\xf3n al usarlo | REVIVE con un 60% de HP cuando mueras (no se acumula con otros objetos de revivir)","item__PG_EnchantedElixirNecklace__lore":"Un collar que contiene una ampolla de elixir encantado, aumentando la potencia m\xe1gica.","item__PG_EnigmaLoop__name":"Bucle Enigma","item__PG_EnigmaLoop__gameplay":"INCOGNITO: Oculta tus mensajes de bot\xedn y ubicaci\xf3n al resto del mundo | +5% de da\xf1o ca\xf3tico","item__PG_EnigmaLoop__lore":"Un anillo enigm\xe1tico que confunde a los enemigos, retorciendo la realidad a tu favor.","item__PG_EnigmaticShadowweaveRing__name":"Anillo Tejido de Sombras Enigm\xe1ticas","item__PG_EnigmaticShadowweaveRing__gameplay":"Restaura 20HP al usarlo (1 carga) | +5,5% de Da\xf1o a Jugadores | -9% de Da\xf1o a PNJs","item__PG_EnigmaticShadowweaveRing__lore":"Infundido con encantamientos enigm\xe1ticos, este anillo entrelaza hilos de oscuridad.","item__PG_EssenceConduit__name":"Conducto de Esencia","item__PG_EssenceConduit__gameplay":"+9% de Da\xf1o a PNJ | -4% de Da\xf1o a jugadores","item__PG_EssenceConduit__lore":"Otorga poder a aquellos que cuidan de la naturaleza.","item__PG_EverlastingSpiritCircle__name":"C\xedrculo de Esp\xedritu Eterno","item__PG_EverlastingSpiritCircle__gameplay":"Concede 3 segundos de +25% de velocidad de movimiento al usarlo (2 cargas) | +10% de Oro de los cofres","item__PG_EverlastingSpiritCircle__lore":"Elaborado mediante la antigua magia, este anillo act\xfaa como un conducto de energ\xeda espiritual.","item__PG_FrostFireRing__gameplay":"+7% de Da\xf1o de Fuego | +8,5% de Defensa contra Hielo | -6,5% de Defensa contra Fuego","item__PG_FrostFireRing__lore":"Un anillo incrustado con piedras elementales que puede imbuir los ataques con poder adicional: \\"Porque primero eres ardiente y luego eres fr\xedo\\".","item__PG_FrostFireRing__name":"Anillo Fuego Helado","item__PG_FrostbiteLoop__gameplay":"+6% Velocidad de movimiento","item__PG_FrostbiteLoop__lore":"Un anillo rodeado de un aura g\xe9lida, congela los corazones de los enemigos con un toque.","item__PG_FrostbiteLoop__name":"Bucle Escarchado","item__PG_FrostfireShardPendant__gameplay":"Recibes un 10% menos de da\xf1o mientras extraes | +8% Da\xf1o a jugadores","item__PG_FrostfireShardPendant__lore":"Un colgante que alberga un fragmento impregnado de energ\xedas g\xe9lidas y llameantes.","item__PG_FrostfireShardPendant__name":"Colgante de Fragmento Fuego Helado","item__PG_GineshsBottleOpener__gameplay":"Tu salud se drena constantemente | +12% Da\xf1o a TODOS los tipos de da\xf1o | +8.5% Velocidad de movimiento | Tus proyectiles viajan un 8.5% m\xe1s lejos","item__PG_GineshsBottleOpener__lore":"Un anillo que desbloquea tanto la causa como la soluci\xf3n a todos los problemas de la vida.","item__PG_GineshsBottleOpener__name":"Abrebotellas de Ginesh","item__PG_GirdleOfTheGoldenNecromancer__gameplay":"Cura 10 HP al usarlo | +6% Velocidad de movimiento","item__PG_GirdleOfTheGoldenNecromancer__lore":"Un cintur\xf3n opulento con incrustaciones de oro que confiere una aureola dorada de protecci\xf3n necrom\xe1ntica, alejando las lesiones.","item__PG_GirdleOfTheGoldenNecromancer__name":"Faja del Nigromante Dorado","item__PG_GoldPlatedCape__gameplay":"+4% Da\xf1o a jugadores","item__PG_GoldPlatedCape__lore":"De alguna manera esto cuenta como armadura","item__PG_GoldPlatedCape__name":"Capa Chapada en Oro","item__PG_GolemsGrasp__gameplay":"+30 de Salud M\xe1xima | -6% de Velocidad de Movimiento | -6% de Velocidad de Movimiento al caminar en el agua","item__PG_GolemsGrasp__lore":"El poder de la piedra surge a trav\xe9s de este anillo, convirtiendo tu piel en armadura.","item__PG_GolemsGrasp__name":"Garra del G\xf3lem","item__PG_GuardiansChainmailCollar__gameplay":"Cura 15 puntos de vida al usarlo (3 usos) | -5% Velocidad de Ataque","item__PG_GuardiansChainmailCollar__lore":"Un collar resistente de malla encadenada que proporciona una protecci\xf3n firme.","item__PG_GuardiansChainmailCollar__name":"Collar de Malla Encadenada del Guardi\xe1n","item__PG_HeirloomCloak__gameplay":"Concede 2 segundos de aumento del 20% en la velocidad de movimiento al usarlo (3 usos).","item__PG_HeirloomCloak__lore":"Una capa sencilla transmitida a trav\xe9s de tu familia durante generaciones.","item__PG_HeirloomCloak__name":"Capa de Herencia","item__PG_IceQueensEarrings__gameplay":"Concede 5 segundos de +20% de velocidad de movimiento al usarlo | +4% Da\xf1o a jugadores | +6.5% Defensa de escarcha | +5% Da\xf1o de escarcha","item__PG_IceQueensEarrings__lore":"Unos pendientes adecuados para la Reina de Hielo misma. Fr\xedos al tacto.","item__PG_IceQueensEarrings__name":"Pendientes de la Reina de Hielo","item__PG_InfiniteLoop__gameplay":"Agrega 45 segundos a tu temporizador de extracci\xf3n al usarlo | -10 de Salud m\xe1xima | Tu salud se regenera constantemente","item__PG_InfiniteLoop__lore":"Capaz de convertir la energ\xeda vital en man\xe1 y el man\xe1 en energ\xeda vital.","item__PG_InfiniteLoop__name":"Bucle Infinito","item__PG_IronFoxLocket__gameplay":"INSPECCI\xd3N: Revela informaci\xf3n sobre tus oponentes | +13% de defensa para TODOS los tipos de da\xf1o | +30 de salud m\xe1xima","item__PG_IronFoxLocket__lore":"Las leyendas hablan de un zorro, enfundado en una armadura de hierro, famoso por superar incluso a los cazadores m\xe1s astutos.","item__PG_IronFoxLocket__name":"Colgante del Zorro de Hierro","item__PG_JaysesRing__gameplay":"+9,5% de Da\xf1o a jugadores | -9% de Da\xf1o a PNJs | +15% Et\xe9reo | +12% de Da\xf1o El\xe9ctrico | +12% de Da\xf1o de Fuego","item__PG_JaysesRing__lore":"El anillo del famoso mago Jayse.","item__PG_JaysesRing__name":"Anillo de Jayse","item__PG_LittleCompactedLimeGreenRing__gameplay":"Tus proyectiles viajan un 6% m\xe1s lejos | +13% de Defensa T\xf3xica.","item__PG_LittleCompactedLimeGreenRing__lore":"Perteneci\xf3 alguna vez a un linaje de dragones lujosos.","item__PG_LittleCompactedLimeGreenRing__name":"Anillo Peque\xf1o Compacto de Color Verde Lima","item__PG_MementoMoriLocket__gameplay":"-6.5% Defensa contra el Caos | Defensa contra Sombras del +8.5%","item__PG_MementoMoriLocket__lore":"Un medall\xf3n inquietante que sirve como recordatorio de la mortalidad, fortaleciendo la determinaci\xf3n.","item__PG_MementoMoriLocket__name":"Medall\xf3n Memento Mori","item__PG_MidnightsVeilBand__gameplay":"Vuelve invisible durante 5 segundos al usarlo (2 cargas)","item__PG_MidnightsVeilBand__lore":"Usada con hebras de sombra, esta capa mejora el sigilo de quien la lleva.","item__PG_MidnightsVeilBand__name":"Velo de Medianoche","item__PG_MunchkinsRing__gameplay":"+7% Velocidad de Movimiento | -10 Salud M\xe1xima","item__PG_MunchkinsRing__lore":"Su due\xf1o anterior ten\xeda patitas peque\xf1as, pero eso nunca lo fren\xf3.","item__PG_MunchkinsRing__name":"Anillo del Munchkin","item__PG_NaturesAureateBarrier__gameplay":"Agrega 30 segundos a tu temporizador de extracci\xf3n al usarlo (2 usos) | -5,5% de da\xf1o a jugadores | INCOGNITO: Oculta tus mensajes de bot\xedn y ubicaci\xf3n al resto del mundo.","item__PG_NaturesAureateBarrier__lore":"Un cintur\xf3n robusto tejido en oro, impregnado con la fortaleza de los \xe1rboles antiguos, otorgando al portador un escudo de fuerza natural resplandeciente.","item__PG_NaturesAureateBarrier__name":"Barrera Aureada de la Naturaleza","item__PG_NecroticGraspTalisman__gameplay":"Concede 5 segundos de +30% de velocidad de movimiento al usarlo | Tu salud se drena constantemente | +12% Da\xf1o de sombra","item__PG_NecroticGraspTalisman__lore":"Un talism\xe1n pulsante con poder necrom\xe1ntico, que comanda las fuerzas de los muertos vivientes.","item__PG_NecroticGraspTalisman__name":"Talism\xe1n de Agarre Necr\xf3tico","item__PG_NecroticSignet__gameplay":"Agrega 45 segundos a tu temporizador de extracci\xf3n al usarlo | +13% Defensa sagrada","item__PG_NecroticSignet__lore":"Un s\xedmbolo macabro de muerte y decadencia que drena la vitalidad de tus enemigos.","item__PG_NecroticSignet__name":"Gambes\xf3n Necr\xf3tico","item__PG_PendantOfAncientWisdom__gameplay":"-7% Da\xf1o a jugadores | +8.75% Da\xf1o a PNJ | +8.5% Defensa arcana | +7% Da\xf1o arcana","item__PG_PendantOfAncientWisdom__lore":"Un antiguo colgante que otorga un conocimiento profundo a quien lo lleva.","item__PG_PendantOfAncientWisdom__name":"Colgante de Sabidur\xeda Ancestral","item__PG_PhantomBand__gameplay":"+30% Et\xe9reo","item__PG_PhantomBand__lore":"Al usar este anillo et\xe9reo, puedes caminar sin ser visto entre los vivos.","item__PG_PhantomBand__name":"Banda del Fantasma","item__PG_PhoenixFeatherTorque__gameplay":"REANIMA con 60% de Salud cuando mueres (no se acumula con otros objetos de resurrecci\xf3n) | +60 de Salud M\xe1xima | +19,5% de Defensa contra Fuego | +19,5% de Defensa contra Escarcha | -19,5% de Defensa contra T\xf3xicos | -15% de Velocidad de Ataque","item__PG_PhoenixFeatherTorque__lore":"Un majestuoso torque adornado con una pluma de f\xe9nix, que otorga renacimiento y renovaci\xf3n.","item__PG_PhoenixFeatherTorque__name":"Torque de Pluma de F\xe9nix","item__PG_PhoenixsRespite__gameplay":"Vuelve invisible durante 3 segundos al usarlo | +6.5% Defensa de Fuego | +5% Da\xf1o de Fuego","item__PG_PhoenixsRespite__lore":"Aquellos que se atrevieron a re\xedrse del nombre de este anillo a menudo eran asesinados por su portador.","item__PG_PhoenixsRespite__name":"Alivio del F\xe9nix","item__PG_PurpletratorsRing__gameplay":"+3% Robo de vida de todo el da\xf1o que infliges a jugadores","item__PG_PurpletratorsRing__lore":"Aquellos que se atrevieron a re\xedrse del nombre de este anillo a menudo eran asesinados por su portador.","item__PG_PurpletratorsRing__name":"Anillo del Intruso P\xfarpura","item__PG_QuintsFishingGarb__gameplay":"+5% Velocidad de ataque","item__PG_QuintsFishingGarb__lore":"Un anillo que crea una cantidad infinita de gusanos de pesca, a menudo distribuidos sin saberlo a los miembros del grupo.","item__PG_QuintsFishingGarb__name":"Atuendo de Pesca de Quint","item__PG_ResilientHeartstone__gameplay":"Restaura 10HP al usarlo | +5% de Oro de los cofres | Recibes un 5% menos de da\xf1o mientras te extraes | INSPECCI\xd3N: Revela informaci\xf3n sobre tus oponentes","item__PG_ResilientHeartstone__lore":"Una gema en forma de coraz\xf3n que infunde fortaleza inquebrantable en quien la lleva.","item__PG_ResilientHeartstone__name":"Coraz\xf3n Resistente","item__PG_RingOfConstellations__gameplay":"Tus proyectiles viajan un 6% m\xe1s lejos","item__PG_RingOfConstellations__lore":"Se rumorea que un guerrero de la noche pose\xeda este anillo y brindaba orientaci\xf3n en la oscuridad de la noche.","item__PG_RingOfConstellations__name":"Anillo de Constelaciones","item__PG_RingOfTheOneHandedWarrior__gameplay":"-10 de Salud M\xe1xima | +12% de Da\xf1o F\xedsico | +12% de Da\xf1o de Sangrado","item__PG_RingOfTheOneHandedWarrior__lore":"Solo necesitas una mano para llevar un anillo.","item__PG_RingOfTheOneHandedWarrior__name":"Anillo del Guerrero de una Mano","item__PG_RingOfViolentViolet__gameplay":"+30 Salud m\xe1xima | +17% Da\xf1o a TODOS los tipos de da\xf1o | -15% Defensa contra TODOS los tipos de da\xf1o","item__PG_RingOfViolentViolet__lore":"Sientes una repentina oleada de poder y sed de sangre al equipar este anillo.","item__PG_RingOfViolentViolet__name":"Anillo de Violeta Violenta","item__PG_RuneboundRing__gameplay":"+5% Velocidad de movimiento al caminar en el agua | +7% Da\xf1o Arcano","item__PG_RuneboundRing__lore":"Grabado con antiguas runas, canaliza energ\xedas arcanas para potenciar al portador.","item__PG_RuneboundRing__name":"Anillo Vinculado a Runas","item__PG_SerpentsCoilChoker__gameplay":"INSPECCI\xd3N: Revela informaci\xf3n sobre tus oponentes","item__PG_SerpentsCoilChoker__lore":"Enrosc\xe1ndose alrededor del cuello, imparte al portador la gracia y astucia de una serpiente.","item__PG_SerpentsCoilChoker__name":"Collar de la Serpiente Enroscada","item__PG_SerpentsRing__gameplay":"+6.5% Resistencia T\xf3xica","item__PG_SerpentsRing__lore":"Un anillo hecho de las escamas de una serpiente, encantado para proteger al portador del veneno.","item__PG_SerpentsRing__name":"Anillo de la Serpiente","item__PG_ShieldbearersAmulet__gameplay":"Restaura 10HP al usarlo (1 carga) | +6,5% de da\xf1o a PNJs","item__PG_ShieldbearersAmulet__lore":"Con un escudo de armas grabado, fortalece las defensas del portador.","item__PG_ShieldbearersAmulet__name":"Amuleto del Portador del Escudo","item__PG_SoulBindingRing__gameplay":"REVIVE con un 40% de HP cuando mueras | +10% Da\xf1o Sagrado","item__PG_SoulBindingRing__lore":"Este anillo tiene tres piedras. Una es clara y transparente. Las otras dos contienen una extra\xf1a neblina dorada.","item__PG_SoulBindingRing__name":"Anillo de Vinculaci\xf3n de Almas","item__PG_SoulforgeRing__gameplay":"EXTRACCI\xd3N al usarlo, sin importar d\xf3nde te encuentres | Extracci\xf3n 10% m\xe1s lenta | Este objeto se destruye cuando se usa completamente","item__PG_SoulforgeRing__lore":"Infundido con la esencia de almas atormentadas, este anillo aumenta tu destreza f\xedsica y m\xedstica.","item__PG_SoulforgeRing__name":"Anillo de Forja de Almas","item__PG_SoulshackleVeil__gameplay":"Concede 3 segundos de +25% de velocidad de movimiento al usarlo (3 cargas) | +8,5% Et\xe9reo | -5% de Velocidad de Movimiento","item__PG_SoulshackleVeil__lore":"Atado por magia oscura, atrapa las almas de los ca\xeddos, conect\xe1ndote con el mundo espiritual.","item__PG_SoulshackleVeil__name":"Velo de Esclavo de Almas","item__PG_SoulstoneReliquary__gameplay":"Vuelve invisible durante 4 segundos al usarlo | Recibes un 5% menos de da\xf1o mientras te extraes | REANIMA con 20% de Salud cuando mueres (no se acumula con otros objetos de resurrecci\xf3n) | +5% de Absorci\xf3n de Vida de todo el da\xf1o que infliges a los jugadores","item__PG_SoulstoneReliquary__lore":"Un collar reliquia que permite al portador aprovechar y controlar almas capturadas.","item__PG_SoulstoneReliquary__name":"Relicario de Piedra de Almas","item__PG_StormweaverCloak__gameplay":"INCOGNITO: Oculta tus mensajes de bot\xedn y ubicaci\xf3n del resto del mundo","item__PG_StormweaverCloak__lore":"Domina la furia de las tormentas el\xe9ctricas, comandando la ira de los cielos.","item__PG_StormweaverCloak__name":"Capa del Tejedor de Tormentas","item__PG_SummonersSign__gameplay":"+10 Salud m\xe1xima","item__PG_SummonersSign__lore":"Utilizado por los invocadores para recolectar man\xe1 de la tierra.","item__PG_SummonersSign__name":"Sello del Invocador","item__PG_TalismanOfVeiledShadows__gameplay":"Vuelve invisible durante 3 segundos al usarlo | -5% Velocidad de movimiento | +8.5% Defensa del Caos | +8.5% Defensa contra Sombras","item__PG_TalismanOfVeiledShadows__lore":"Un talism\xe1n m\xedstico que envuelve al portador en una oscuridad ef\xedmera.","item__PG_TalismanOfVeiledShadows__name":"Talism\xe1n de Sombras Veladas","item__PG_TantrumsLuckyLoop__gameplay":"+3% Velocidad de movimiento","item__PG_TantrumsLuckyLoop__lore":"Un anillo que te hace tan r\xe1pido como un galgo, y tan perezoso.","item__PG_TantrumsLuckyLoop__name":"Anillo de la Suerte de Tantrum","item__PG_VampiricSeal__gameplay":"Restaura 7HP al usarlo (2 cargas) | +3% de Absorci\xf3n de Vida de todo el da\xf1o que infliges a los jugadores","item__PG_VampiricSeal__lore":"Aliment\xe1ndose de la fuerza vital de tus enemigos, otorga vitalidad con cada golpe.","item__PG_VampiricSeal__name":"Vestidura Vamp\xedrica","item__PG_VeilstormCirclet__gameplay":"Cura 30 HP al usarlo | -10% Velocidad de Ataque | +12% Da\xf1o de Naturaleza","item__PG_VeilstormCirclet__lore":"Posee el poder de una tormenta furiosa. Otorga a su portador el control sobre el viento y los rel\xe1mpagos.","item__PG_VeilstormCirclet__name":"Capa de la Tormenta Velada","item__PG_VenomousBite__gameplay":"A\xf1ade 30 segundos a tu temporizador de extracci\xf3n al usarlo | Tu salud disminuye constantemente | +10% Da\xf1o T\xf3xico","item__PG_VenomousBite__lore":"Armadura usada por los antiguos m\xe9dicos de la peste.","item__PG_VenomousBite__name":"Mordedura Venenosa","item__PG_WindspeakersRing__gameplay":"INSPECCI\xd3N: Revela informaci\xf3n sobre tus oponentes | +7% Da\xf1o de Naturaleza","item__PG_WindspeakersRing__lore":"Una vez fue propiedad de un poderoso mago que fue perseguido por todo el mundo por su propia sombra. Se dice que este anillo tiene el poder de controlar los vientos.","item__PG_WindspeakersRing__name":"Anillo del Hablante de los Vientos","item__PG_Wraithband__gameplay":"+8,5% Et\xe9reo | 7% de Da\xf1o Sagrado | -10 de Salud M\xe1xima","item__PG_Wraithband__lore":"Una energ\xeda fantasmal recorre este anillo, otorgando poderes espectrales.","item__PG_Wraithband__name":"Banda Espectral","item__VT_AbyssalShard__gameplay":"","item__VT_AbyssalShard__lore":"Un trozo de piedra negra recolectado del inframundo.","item__VT_AbyssalShard__name":"Fragmento Abisal","item__VT_Amber__gameplay":"","item__VT_Amber__lore":"Esta piedra tiene un tono anaranjado profundo.","item__VT_Amber__name":"\xc1mbar","item__VT_BardsDiary__gameplay":"","item__VT_BardsDiary__lore":"Esta canci\xf3n est\xe1 llena de poes\xeda y partituras musicales.","item__VT_BardsDiary__name":"Cuaderno del Bardo","item__VT_BrokenIronBand__gameplay":"","item__VT_BrokenIronBand__lore":"Un simple anillo de hierro que ha perdido su brillo.","item__VT_BrokenIronBand__name":"Anillo de Hierro Roto","item__VT_BrokenSword__gameplay":"","item__VT_BrokenSword__lore":"Esta espada ha visto d\xedas mejores.","item__VT_BrokenSword__name":"Espada de Hierro Rota","item__VT_Cabbage__gameplay":"","item__VT_Cabbage__lore":"Eres un repollo, siempre ser\xe1s un repollo.","item__VT_Cabbage__name":"Repollo","item__VT_ChunkOfIron__gameplay":"","item__VT_ChunkOfIron__lore":"Un peque\xf1o trozo de hierro. Un herrero podr\xeda hacer algo con esto.","item__VT_ChunkOfIron__name":"Trozo de Hierro","item__VT_CubicZirconia__gameplay":"","item__VT_CubicZirconia__lore":"Un trozo cuadrado de circ\xf3n c\xfabico.","item__VT_CubicZirconia__name":"Circ\xf3n C\xfabico","item__VT_Diamond__gameplay":"A un coleccionista de objetos raros probablemente le interesar\xeda esto.","item__VT_Diamond__lore":"Una gema preciosa.","item__VT_Diamond__name":"Diamante","item__VT_DukesDiary__gameplay":"","item__VT_DukesDiary__lore":"Los pensamientos de un duque una vez poderoso.","item__VT_DukesDiary__name":"Diario del Duque de Ert","item__VT_EmeraldDust__gameplay":"","item__VT_EmeraldDust__lore":"Un esmeralda convertida en un fino polvo.","item__VT_EmeraldDust__name":"Polvo de Esmeralda","item__VT_Emerald__gameplay":"","item__VT_Emerald__lore":"Un trozo de una esmeralda.","item__VT_Emerald__name":"Esmeralda","item__VT_EverlastingCandle__gameplay":"","item__VT_EverlastingCandle__lore":"Esta vela misteriosamente arder\xe1 para siempre.","item__VT_EverlastingCandle__name":"Vela Eterna","item__VT_Eyeball__gameplay":"","item__VT_Eyeball__lore":"El ojo de una bestia abatida.","item__VT_Eyeball__name":"Ojo","item__VT_FangOfTheBloodMoon__gameplay":"","item__VT_FangOfTheBloodMoon__lore":"Este colmillo cubierto de sangre proviene de una criatura que acecha solo cuando el cielo est\xe1 sangrando.","item__VT_FangOfTheBloodMoon__name":"Colmillo de la Luna Sangrienta","item__VT_Fossil__gameplay":"","item__VT_Fossil__lore":"Los restos de un ser antiguo est\xe1n permanentemente impresos en esta roca.","item__VT_Fossil__name":"F\xf3sil","item__VT_GhostPlasma__gameplay":"","item__VT_GhostPlasma__lore":"Este l\xedquido viscoso brilla con energ\xedas et\xe9reas.","item__VT_GhostPlasma__name":"Plasma Fantasmal","item__VT_GoblinCloth__gameplay":"","item__VT_GoblinCloth__lore":"Esta tela est\xe1 muy sucia y tiene algo de sangre.","item__VT_GoblinCloth__name":"Taparrabos de Goblin","item__VT_GoldNugget__gameplay":"","item__VT_GoldNugget__lore":"Un peque\xf1o trozo de oro. Probablemente valga mucho.","item__VT_GoldNugget__name":"Pepita de Oro","item__VT_OgreEntrails__gameplay":"","item__VT_OgreEntrails__lore":"Entra\xf1as del interior de un ogro.","item__VT_OgreEntrails__name":"Entra\xf1as de Ogro","item__VT_OnyxGem__gameplay":"Un experto en joyas podr\xeda estar interesado en esto.","item__VT_OnyxGem__lore":"Una gema rara hecha de \xf3nix.","item__VT_OnyxGem__name":"Gema de \xd3nix","item__VT_PileOfAsh__gameplay":"","item__VT_PileOfAsh__lore":"Solo un peque\xf1o mont\xf3n de cenizas.","item__VT_PileOfAsh__name":"Mont\xf3n de Cenizas","item__VT_Potato__gameplay":"Coc\xednelos, trit\xfarelos, m\xe9talos en un guiso.","item__VT_Potato__lore":"Probablemente nunca has o\xeddo hablar de ellas.","item__VT_Potato__name":"Papa","item__VT_QuartzRing__gameplay":"","item__VT_QuartzRing__lore":"Engastado con un trozo de cuarzo pulido. No vale mucho, pero al menos es algo.","item__VT_QuartzRing__name":"Anillo de Cuarzo","item__VT_RatFur__gameplay":"","item__VT_RatFur__lore":"Un mont\xf3n repugnante de pelo, probablemente lleno de enfermedades.","item__VT_RatFur__name":"Mont\xf3n de Pelo de Rata","item__VT_RedMushroom__gameplay":"","item__VT_RedMushroom__lore":"Este hongo se seca com\xfanmente y se convierte en un polvo que se utiliza para ayudar en las enfermedades.","item__VT_RedMushroom__name":"Hongo Rojo","item__VT_RingOfNearPerfection__gameplay":"","item__VT_RingOfNearPerfection__lore":"Ser\xeda mejor si tuviera magia.","item__VT_RingOfNearPerfection__name":"Anillo de Casi Perfecci\xf3n","item__VT_RubyDust__gameplay":"","item__VT_RubyDust__lore":"Un rub\xed que ha sido triturado en un fino polvo.","item__VT_RubyDust__name":"Polvo de Rub\xed","item__VT_Ruby__gameplay":"","item__VT_Ruby__lore":"Un trozo de rub\xed rojo intenso.","item__VT_Ruby__name":"Rub\xed","item__VT_SapphireDust__gameplay":"","item__VT_SapphireDust__lore":"Un zafiro que ha sido convertido en un fino polvo.","item__VT_SapphireDust__name":"Polvo de Zafiro","item__VT_Sapphire__gameplay":"","item__VT_Sapphire__lore":"Un trozo profundo y azul de un zafiro.","item__VT_Sapphire__name":"Zafiro","item__VT_SkeletonFemur__gameplay":"","item__VT_SkeletonFemur__lore":"Supongo que hay un esqueleto con una pierna en alg\xfan lugar.","item__VT_SkeletonFemur__name":"F\xe9mur de Esqueleto","item__VT_Skull__gameplay":"","item__VT_Skull__lore":"Un cr\xe1neo. Probablemente de uno de estos esqueletos errantes.","item__VT_Skull__name":"Cr\xe1neo","item__VT_StellarWeaveRing__gameplay":"","item__VT_StellarWeaveRing__lore":"Un anillo hecho de ramas tejidas. No tiene nada especial.","item__VT_StellarWeaveRing__name":"Anillo de Tejido Estelar","item__VT_TreantBranch__gameplay":"","item__VT_TreantBranch__lore":"Este trozo de madera se mueve un poco. Extra\xf1o.","item__VT_TreantBranch__name":"Rama de Treant","item__VT_WellWornRing__gameplay":"","item__VT_WellWornRing__lore":"Este anillo sencillo tiene varios ara\xf1azos y marcas visibles en su superficie.","item__VT_WellWornRing__name":"Anillo Muy Usado","item__VT_WhispersOfTheVoid__gameplay":"","item__VT_WhispersOfTheVoid__lore":"La locura es com\xfan entre aquellos que escuchan su voz. \xbfY qui\xe9n no lo hace en estos tiempos de crisis?","item__VT_WhispersOfTheVoid__name":"Susurros del Vac\xedo Vol. 1","item__W_ApprenticesStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o f\xedsico.","item__W_ApprenticesStaff__lore":"Un b\xe1culo de mago novato com\xfanmente utilizado para entrenamiento.","item__W_ApprenticesStaff__name":"B\xe1culo del Aprendiz","item__W_ArchmagesSidekick__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o arcano.","item__W_ArchmagesSidekick__lore":"Poco se sabe sobre este b\xe1culo, excepto que fue transmutado a la existencia por el Archimago de la Orden Arcana.","item__W_ArchmagesSidekick__name":"Compa\xf1ero del Archimago","item__W_BeesOnAStick__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de naturaleza.","item__W_BeesOnAStick__lore":"Un b\xe1culo adornado con una colmena, zumbando con el poder de las abejas enjambre, entregando hechizos punzantes a los adversarios.","item__W_BeesOnAStick__name":"Abejas en un Palo","item__W_BlackDahliaWand__gameplay":"Dispara proyectiles de sombras.","item__W_BlackDahliaWand__lore":"Su naturaleza oscura corrompe los corazones de aquellos que se atreven a empu\xf1arlo.","item__W_BlackDahliaWand__name":"Varita Black Dahlia","item__W_BlazeRod__gameplay":"\xa1Dispara llamas!","item__W_BlazeRod__lore":"Encontrada en las profundidades del Nether, esta varilla est\xe1 imbuida con el alma de un Blaze.","item__W_BlazeRod__name":"Varilla Blaze","item__W_Bloodrider__gameplay":"Dispara flechas que causan un fuerte da\xf1o por sangrado.","item__W_Bloodrider__lore":"Hecho a partir de huesos de guerreros ca\xeddos, este arco mal\xe9volo drena vida con cada flecha, dejando a su paso un rastro de desesperaci\xf3n carmes\xed.","item__W_Bloodrider__name":"Bloodrider","item__W_BrokenDeathstick__gameplay":"Dispara proyectiles ca\xf3ticos que infligen un da\xf1o moderado.","item__W_BrokenDeathstick__lore":"Ser\xeda mortal... si no estuviera roto.","item__W_BrokenDeathstick__name":"Bast\xf3n de la Muerte Roto","item__W_CandlelightStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de fuego.","item__W_CandlelightStaff__lore":"Un b\xe1culo que emite una suave luz, iluminando la oscuridad.","item__W_CandlelightStaff__name":"B\xe1culo de Luz de Vela","item__W_CelestialBow__gameplay":"Un emisario celestial ha infundido estas flechas con el fr\xedo del vac\xedo.","item__W_CelestialBow__lore":"Regalado por antiguas deidades, este arco radiante canaliza bendiciones divinas, atravesando incluso las defensas m\xe1s formidables.","item__W_CelestialBow__name":"Arco Celestial","item__W_CrudeCrossbow__gameplay":"Dispara un perno b\xe1sico de baja potencia que inflige da\xf1o f\xedsico.","item__W_CrudeCrossbow__lore":"Una ballesta rudimentaria hecha de restos de madera y cuerda. No es muy poderosa, pero servir\xe1.","item__W_CrudeCrossbow__name":"Ballesta Rudimentaria","item__W_DarylsInstinct__gameplay":"Dispara poderosos pernos que infligen da\xf1o por sangrado.","item__W_DarylsInstinct__lore":"Una ballesta utilizada por el legendario cazador Daryl.","item__W_DarylsInstinct__name":"Instinto de Daryl","item__W_DavidBowie__gameplay":"Dispara proyectiles f\xedsicos d\xe9biles.","item__W_DavidBowie__lore":"\xa1Te transforma en una estrella instant\xe1nea!","item__W_DavidBowie__name":"David Bowie","item__W_DemonsEye__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de sombras.","item__W_DemonsEye__lore":"Este b\xe1culo invoca los susurros ominosos del reino del abismo, permitiendo a los portadores atravesar ilusiones y revelar las verdades ocultas que se esconden en las sombras.","item__W_DemonsEye__name":"Ojo del Demonio","item__W_DivineWind__gameplay":"Dispara poderosas flechas sagradas","item__W_DivineWind__lore":"Forjado en santuarios de monta\xf1as sagradas, este arco et\xe9reo impulsa flechas con r\xe1fagas de otro mundo, destrozando obst\xe1culos y enemigos.","item__W_DivineWind__name":"Viento Divino","item__W_DragonsBreath__gameplay":"Crea un torrente de llamas frente al conjurador.","item__W_DragonsBreath__lore":"\xa1Lanzo... \xbfBola de Fuego?","item__W_DragonsBreath__name":"Aliento de Drag\xf3n","item__W_EldritchBlasters__gameplay":"Dispara r\xe1pidamente proyectiles de sombra.","item__W_EldritchBlasters__lore":"Dos ballestas duales imbuidas con el poder de la sombra.","item__W_EldritchBlasters__name":"Pistolas Eldritch","item__W_Emberstrike__gameplay":"Dispara potentes flechas de fuego.","item__W_Emberstrike__lore":"Forjado en el coraz\xf3n de un volc\xe1n, este arco de obsidiana libera flechas ardientes, dejando tras de s\xed rastros de devastaci\xf3n humeante.","item__W_Emberstrike__name":"Emberstrike","item__W_FairyBow__gameplay":"Dispara flechas impregnadas de magia de las hadas.","item__W_FairyBow__lore":"Impregna las flechas disparadas desde este arco con energ\xeda poderosa aleatoria.","item__W_FairyBow__name":"Arco de Hada","item__W_FairyStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de naturaleza.","item__W_FairyStaff__lore":"Perteneci\xf3 a una reina hada.","item__W_FairyStaff__name":"B\xe1culo de Hada","item__W_FathersBane__gameplay":"Dispara r\xe1pidamente pernos d\xe9biles con punta venenosa.","item__W_FathersBane__lore":"Utilizado por un hijo dolorido que no tuvo otra opci\xf3n que matar a su padre.","item__W_FathersBane__name":"Ruina del Padre","item__W_FlamespitterStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de fuego.","item__W_FlamespitterStaff__lore":"Furiosas llamas brotan de este b\xe1culo.","item__W_FlamespitterStaff__name":"B\xe1culo Escupidor de Llamas","item__W_FrostedTips__gameplay":"Inflige da\xf1o de escarcha.","item__W_FrostedTips__lore":"\xa1Ay, caramba, Stromboli!","item__W_FrostedTips__name":"Puntas Escarchadas","item__W_GuardsCrossbow__gameplay":"M\xe1s f\xe1cil y r\xe1pido de cargar que una ballesta normal.","item__W_GuardsCrossbow__lore":"Ballesta utilizada por los guardias de la Orden Arcana.","item__W_GuardsCrossbow__name":"Ballesta de los Guardias","item__W_HibidyKibity__gameplay":"Dispara mortales proyectiles ca\xf3ticos.","item__W_HibidyKibity__lore":"Una varita empapada con la energ\xeda vil de la maldici\xf3n asesina.","item__W_HibidyKibity__name":"Hibidy Kibity","item__W_IcewindWand__gameplay":"Crea un torrente de nubes congelantes frente al conjurador.","item__W_IcewindWand__lore":"Capaz de crear el peor clima absoluto.","item__W_IcewindWand__name":"Varita Viento de Hielo","item__W_IronStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o f\xedsico.","item__W_IronStaff__lore":"Un b\xe1culo hecho de hierro, utilizado por los guardias de la Orden Arcana.","item__W_IronStaff__name":"B\xe1culo de Hierro","item__W_KingBible__gameplay":"Lanza poderosas biblias sagradas a tus oponentes.","item__W_KingBible__lore":"Un venerado y dorado tomo que contiene palabras sagradas de antiguos monarcas, otorgando autoridad y moldeando destinos.","item__W_KingBible__name":"Biblia del Rey","item__W_Deathstick__gameplay":"Trae la muerte disparando proyectiles r\xe1pidos de corto alcance, a costa de ralentizar al usuario.","item__W_Deathstick__lore":"La leyenda cuenta que esta poderosa arma fue dejada caer por una figura misteriosa hace siglos.","item__W_Deathstick__name":"Deathstick","item__W_BookOfTongues__gameplay":"Dispara el fuego m\xe1s poderoso desde las profundidades del infierno. Tiene un tiempo de reutilizaci\xf3n MUY largo.","item__W_BookOfTongues__lore":"Se puede ver un nombre ilegible grabado en sus p\xe1ginas. Lo \xfanico que se distingue es la letra \\"M\\".","item__W_BookOfTongues__name":"Libro de las Lenguas","item__W_LichsStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de sombras.","item__W_LichsStaff__lore":"Empu\xf1ado por nigromantes oscuros, este b\xe1culo aprovecha los poderes imp\xedos de los muertos vivientes, llevando muerte y decadencia a todo lo que toca.","item__W_LichsStaff__name":"B\xe1culo del Lich","item__W_FrostFlicker__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de hielo.","item__W_FrostFlicker__lore":"Un bast\xf3n con la habilidad de congelar el agua en el \xe1rea circundante. Una versi\xf3n m\xe1s d\xe9bil de esto se usa a menudo durante la temporada de vacaciones.","item__W_FrostFlicker__name":"Destello Helado","item__W_MagicalWand__gameplay":"Dispara proyectiles m\xe1gicos arcanos.","item__W_MagicalWand__lore":"\xa1En el nombre de la luna, te castigar\xe9!","item__W_MagicalWand__name":"Varita M\xe1gica","item__W_MidasStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de rel\xe1mpago.","item__W_MidasStaff__lore":"El b\xe1culo del legendario Rey Midas.","item__W_MidasStaff__name":"B\xe1culo de Midas","item__W_MoonShadow__gameplay":"Dispara flechas de sombra r\xe1pidamente.","item__W_MoonShadow__lore":"Otorgado por los esp\xedritus de la luna, este arco m\xedstico dispara flechas que atraviesan las sombras, golpeando desde \xe1ngulos inesperados.","item__W_MoonShadow__name":"Sombra Lunar","item__W_NaturesReturn__gameplay":"Aprovecha el poder del bosque para infligir grandes cantidades de da\xf1o de naturaleza a tus oponentes.","item__W_NaturesReturn__lore":"Un tomo adornado con follaje, canalizando las fuerzas de la naturaleza para el crecimiento, la curaci\xf3n y las tormentas.","item__W_NaturesReturn__name":"Regreso de la Naturaleza","item__W_NightStick__gameplay":"Dispara proyectiles m\xe1s fr\xedos que la noche.","item__W_NightStick__lore":"Utilizado por aquellos que tienen la intenci\xf3n de mantener la paz.","item__W_NightStick__name":"Porra Nocturna","item__W_PharaohsStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o sagrado.","item__W_PharaohsStaff__lore":"Excavado de la tumba de un antiguo fara\xf3n, se dice que este b\xe1culo se utilizaba para convocar a los muertos.","item__W_PharaohsStaff__name":"B\xe1culo del Fara\xf3n","item__W_PhoenixWing__gameplay":"Dispara flechas impregnadas con las llamas de un f\xe9nix ca\xeddo.","item__W_PhoenixWing__lore":"Elaborado con plumas de f\xe9nix, este arco radiante canaliza el renacimiento ardiente, encendiendo las flechas con llamas abrasadoras.","item__W_PhoenixWing__name":"Ala de F\xe9nix","item__W_PoseidonsWand__gameplay":"Dispara peces.","item__W_PoseidonsWand__lore":"\xa1PEEEEEEEEEEEEEEZ!","item__W_PoseidonsWand__name":"Varita de Poseid\xf3n","item__W_QuincyBow__gameplay":"Dispara flechas impregnadas de energ\xeda el\xe9ctrica.","item__W_QuincyBow__lore":"Dispara flechas hechas de la energ\xeda espiritual del portador.","item__W_QuincyBow__name":"Arco Quincy","item__W_SilentShadow__gameplay":"Dispara flechas imbuidas con energ\xeda de sombra.","item__W_SilentShadow__lore":"\\"Vinieron sin previo aviso y nos tomaron por sorpresa. Logramos defendernos, pero perdimos a muchos en el proceso.\\"","item__W_SilentShadow__name":"Sombra Silenciosa","item__W_RangersGuillotine__gameplay":"Dispara flechas envenenadas.","item__W_RangersGuillotine__lore":"Con una precisi\xf3n letal, este brutal arco atraviesa las defensas, incrustando a su v\xedctima con flechas envenenadas.","item__W_RangersGuillotine__name":"Guillotina del Guardabosques","item__W_ReapersEmbrace__gameplay":"Dispara poderosos proyectiles de caos.","item__W_ReapersEmbrace__lore":"Un arco espectral que drena vida con cada flecha, atrapando a los enemigos en el abrazo g\xe9lido del Segador.","item__W_ReapersEmbrace__name":"Abrazo del Segador","item__W_RelicWand__gameplay":"Manifiesta proyectiles f\xedsicos que infligen un alto da\xf1o.","item__W_RelicWand__lore":"Canaliza la esencia de civilizaciones perdidas y magia olvidada.","item__W_RelicWand__name":"Varita de Reliquia","item__W_ReliqueryCrossbow__gameplay":"Dispara pernos de caos de alto da\xf1o.","item__W_ReliqueryCrossbow__lore":"Ballesta utilizada por los sacerdotes del Relicario Vamp\xedrico.","item__W_ReliqueryCrossbow__name":"Ballesta de Relicario","item__W_SamsStirringStick__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o arcano.","item__W_SamsStirringStick__lore":"La cuchara de un chef legendario, impregnada con el poder de los elementos (culinarios).","item__W_SamsStirringStick__name":"Cuchara de Agitaci\xf3n de Sam","item__W_SlimeStaff__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de naturaleza.","item__W_SlimeStaff__lore":"Un b\xe1culo que palpita con la esencia de los limos, permite al portador convocar y controlar a estas criaturas gelatinosas.","item__W_SlimeStaff__name":"B\xe1culo de Limo","item__W_SpellbindersTome__gameplay":"Emite proyectiles arcanos hacia tus oponentes.","item__W_SpellbindersTome__lore":"Un m\xedstico libro encuadernado en cuero que atrapa mentes con intrincados hechizos de encantamiento.","item__W_SpellbindersTome__name":"Tomo del Encantador","item__W_SpiraledWand__gameplay":"Dispara r\xe1fagas de energ\xeda m\xe1gica cin\xe9tica.","item__W_SpiraledWand__lore":"En realidad, es solo un palo m\xe1s elegante.","item__W_SpiraledWand__name":"Varita Espiral","item__W_StaffOfTheSnake__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o t\xf3xico.","item__W_StaffOfTheSnake__lore":"Un b\xe1culo adornado con la cabeza de una cobra, esculpida en esmeralda. Se dice que puede escupir veneno a los enemigos.","item__W_StaffOfTheSnake__name":"B\xe1culo de la Serpiente","item__W_StarShot__gameplay":"Dispara potentes flechas arcanas impregnadas de energ\xeda estelar.","item__W_StarShot__lore":"Elaborado a partir de fragmentos celestiales, este arco libera una cascada de proyectiles brillantes, un espect\xe1culo celestial de destrucci\xf3n.","item__W_StarShot__name":"Disparo Estelar","item__W_StarWand__gameplay":"Emite el poder de las estrellas hacia tus oponentes.","item__W_StarWand__lore":"Un instrumento caprichoso y brillante.","item__W_StarWand__name":"Varita Estelar","item__W_SteelCrossbow__gameplay":"Dispara pernos de ballesta que atraviesan incluso las pieles m\xe1s gruesas.","item__W_SteelCrossbow__lore":"Una ballesta est\xe1ndar hecha de acero.","item__W_SteelCrossbow__name":"Ballesta de Acero","item__W_Stick__gameplay":"Dispara chispas de energ\xeda m\xe1gica.","item__W_Stick__lore":"Hay muchos como \xe9l, \xa1pero este es m\xedo!","item__W_Stick__name":"Palo","item__W_TheCrossBow__gameplay":"Dispara proyectiles sagrados a gran velocidad.","item__W_TheCrossBow__lore":"Administra la justicia divina con esta legendaria ballesta.","item__W_TheCrossBow__name":"La Ballesta Cruzada","item__W_ToxicWand__gameplay":"Dispara un orbe t\xf3xico.","item__W_ToxicWand__lore":"Puede ser adictivo, pero debes saber que es t\xf3xico.","item__W_ToxicWand__name":"Varita T\xf3xica","item__W_Triforce__gameplay":"Emite el poder de la Trifuerza hacia tus oponentes.","item__W_Triforce__lore":"Un radiante tomo que desbloquea los poderes divinos del coraje, la sabidur\xeda y el poder.","item__W_Triforce__name":"Trifuerza","item__W_TwistedBranch__gameplay":"Coloca una trampa visible cerca de tus pies que inflige da\xf1o de rel\xe1mpago.","item__W_TwistedBranch__lore":"Un bast\xf3n rudimentario que ha sido encantado por un difunto mago.","item__W_TwistedBranch__name":"Rama Retorcida","item__W_WitchHuntersRepeaters__gameplay":"Dispara pernos imbuidos de una radiante santidad.","item__W_WitchHuntersRepeaters__lore":"Ballestas comunes utilizadas por los Cazadores de Brujas de la Orden Arcana.","item__W_WitchHuntersRepeaters__name":"Repeticiones del Cazador de Brujas","item__W_WizardsLedger__gameplay":"DISPARA R\xc1PIDAMENTE monedas. S\xed, monedas.","item__W_WizardsLedger__lore":"\xbfEsto es pagar para ganar?","item__W_WizardsLedger__name":"Libro del Mago","item__W_WyvernsTalon__gameplay":"Dispara potentes pernos que infligen da\xf1o por sangrado.","item__W_WyvernsTalon__lore":"Ballesta fabricada a partir de las garras de un gran wyvern.","item__W_WyvernsTalon__name":"Garra del Wyvern","item__W_ZappingWand__gameplay":"Dispara proyectiles de rel\xe1mpagos.","item__W_ZappingWand__lore":"Aporta una oleada de poder electrizante a tu repertorio m\xe1gico.","item__W_ZappingWand__name":"Varita Electrizante","item_container__loot_chest":"Cofre de Bot\xedn","item_container__loot_drop":"Ca\xedda de Bot\xedn","item_rarity__common":"Com\xfan","item_rarity__epic":"\xc9pico","item_rarity__legendary":"Legendario","item_rarity__rare":"Raro","item_rarity__uncommon":"Poco com\xfan","common":"Com\xfan","uncommon":"Poco Com\xfan","rare":"Raro","epic":"\xc9pico","legendary":"Legendario","item_slot__damage":"da\xf1o","item_slot__equip_prompt":"\xa1Haz clic izquierdo para equipar!","item_slot__extract_prompt":"\xa1Extrae para usar este objeto!","item_slot__grants_ability":"Concede una habilidad","item_slot__grants_passive":"Efecto pasivo","item_slot__loot_prompt":"\xa1Haz clic izquierdo para saquear!","loadout_menu__abilities_header":"Habilidades","loadout_menu__back_to_main_menu_button":"Volver","loadout_menu__damage":"Da\xf1o","loadout_menu__defence":"Defensa","loadout_menu__gear_header":"Equipo","loadout_menu__health":"Salud","loadout_menu__insurance_button":"Asegurar","loadout_menu__no_abilities":"Tu carga no contiene habilidades.","loadout_menu__no_slot_selected_insurance_text":"\uD83D\uDEA8 \xa1Nada est\xe1 asegurado! \uD83D\uDEA8","loadout_menu__no_slot_selected_insurance_text_2":"\xa1Ning\xfan espacio est\xe1 asegurado! Mira un anuncio para proteger 1 objeto.","loadout_menu__no_slot_selected_scrollbox":"Selecciona un espacio para cambiar tu carga","loadout_menu__scrollbox_with_gear_text":"Elige algo de equipo","loadout_menu__scrollbox_with_skins_text":"Elige una apariencia","loadout_menu__scrollbox_with_weapons_text":"Elige un arma","loadout_menu__skin_header":"Elige una Apariencia","loadout_menu__slot_insured_text":"✅ \xa1Tienes seguro! ✅","loadout_menu__start_run_button":"Jugar","loadout_menu__stat":"Estad\xedstica","loadout_menu__title":"Carga","loadout_menu__undo":"Deshacer","loadout_menu__weapons_header":"Armas","loadout_menu__will_be_safe":"estar\xe1 a salvo si mueres.","loadout_menu__your":"Tu","login__header":"Iniciar Sesi\xf3n","fullscreen":"Pantalla Completa","exit_fullscreen":"Salir de pantalla completa","loot_prompt":"[ E ] para saquear","leaderboard__player_kills":"PK","leaderboard__loot":"Bot\xedn","leaderboard__npc_kills":"NPCK","main_menu__patch_notes_btn":"Notas del Parche","main_menu__change_username_btn":"Cambiar Nombre de Usuario","main_menu__create_account_btn":"Crear Cuenta","main_menu__collection_log_btn":"Registro de Colecci\xf3n","collection_log__header":"Registro de Colecci\xf3n","main_menu__discord_btn_tooltip":"\xa1Encuentra amigos y \xfanete a nosotros en Discord!","main_menu__game_is_in_maintenance_mode":"\xa1PvPz.io est\xe1 siendo actualizado! La nueva actualizaci\xf3n se implementar\xe1 pronto, vuelve a intentarlo en unos minutos","main_menu__how_to_play_btn":"C\xf3mo Jugar","main_menu__identity_error_title":"Ups","main_menu__loading_bar_text":"Cargando...","main_menu__logout_btn":"Cerrar Sesi\xf3n","main_menu__partners":"Socios","main_menu__partners_and_credits":"Todos los colaboradores y cr\xe9ditos","main_menu__patch_prefix":"Parche","main_menu__patch_suffix":"llega el 1 de junio","main_menu__play_btn":"Jugar","main_menu__rankings_btn":"Clasificaciones","main_menu__settings_btn":"Configuraci\xf3n","main_menu__sign_in_btn":"Iniciar Sesi\xf3n","main_menu__sign_in_with_discord_btn":"Iniciar sesi\xf3n con Discord","main_menu__sign_in_with_facebook_btn":"Iniciar sesi\xf3n con Facebook","main_menu__sign_in_with_google_btn":"Iniciar sesi\xf3n con Google","main_menu__twitter_btn_tooltip":"\xa1S\xedguenos en Twitter!","main_menu__vendors_btn":"Vendedores","main_menu__view_inventory_btn":"Inventario","main_menu__view_your_stats_btn":"Tus Estad\xedsticas","main_menu__website_btn_tooltip":"\xa1Visita nuestro sitio web!","main_menu__welcome_panel_title":"Bienvenido","main_menu__welcome_panel_title_suffix":" de nuevo,","main_menu__welcome_sign_in_cta":"\xbfQuieres cambiar tu nombre de usuario? \xa1Inicia sesi\xf3n!","main_menu_stash__collectors_items":"Objetos de Colecci\xf3n","main_menu_stash__discovered":"Descubierto","main_menu_stash__gear":"Equipo","main_menu_stash__header":"Almac\xe9n","main_menu_stash__total_items_discovered":"Objetos Descubiertos","main_menu_stash__vendor_items":"Objetos de Vendedor","main_menu_stash__weapons":"Armas","player_skins__boltman":"Arquero","player_skins__corrupted_wizard":"Mago Corrupto","player_skins__knight":"Caballero","player_skins__red_wizard":"Aprendiz de Mago","player_skins__thief":"Ladr\xf3n","player_skins__veteran_wizard":"Mago de la Escuela del Drag\xf3n","rankings__back_to_main_menu_button":"Volver","rankings__coming_soon":"\xa1Pr\xf3ximamente!","rankings__title":"Clasificaciones","region__dreamers_forest":"Bosque de los So\xf1adores","region__ert_lich":"Ert Lich","region__erthel":"Erthel","region__forgotten_temple":"Templo Olvidado","region__skull_lake":"Lago del Cr\xe1neo","region__swamp_of_sorrows":"Pantano de los Lamentos","region__the_edgelands":"Tierras del Borde","region__wilderness":"Tierras Salvajes","dreamers forest":"Bosque de los So\xf1adores","ert lich":"Ert Lich","erthel":"Erthel","forgotten temple":"Templo Olvidado","skull lake":"Lago del Cr\xe1neo","swamp of sorrows":"Pantano de los Lamentos","edgelands":"Tierras del Borde","wilderness":"Tierras Salvajes","register__delete_account_cta":"\xa1Eres un usuario an\xf3nimo, por lo que tu cuenta se eliminar\xe1 en 2 semanas! Si deseas conservar tus objetos y estad\xedsticas, y cambiar tu nombre de usuario, \xa1reg\xedstrate!","register__delete_account_cta_2":"\xa1Eres un usuario an\xf3nimo, por lo que no puedes ver estad\xedsticas! Si deseas ver tus estad\xedsticas, cambiar tu nombre de usuario y desbloquear aspectos especiales, \xa1reg\xedstrate!","register__delete_account_cta_less_aggressive":"Si deseas guardar tus objetos y estad\xedsticas para siempre y cambiar tu nombre de usuario, \xa1reg\xedstrate!","register__email":"Ingresa tu direcci\xf3n de correo electr\xf3nico","register__email_confirm":"Confirma tu direcci\xf3n de correo electr\xf3nico","register__email_placeholder":"Direcci\xf3n de Correo Electr\xf3nico","register__email_placeholder_confirm":"Confirmar Direcci\xf3n de Correo Electr\xf3nico","register__header":"Registro","register__or":"O","register__password":"Ingresa una contrase\xf1a","register__password_confirm":"Confirma tu contrase\xf1a","register__register":"Registrarse","register__register_with_discord_btn":"Registrarse con Discord","register__register_with_google_btn":"Registrarse con Google","register__username":"Elige un nombre de usuario","runprep__skin_not_unlocked_registered":"\xa1Solo los USUARIOS REGISTRADOS pueden usar ese aspecto!","settings__back_to_main_menu_button":"Volver","settings__enable_music":"Activar M\xfasica","settings__enable_sfx":"Activar Efectos de Sonido","settings__language":"Idioma / LANGUAGE","settings__language_dropdown_english":"Ingl\xe9s / English","settings__language_dropdown_portuguese":"Portugu\xe9s / Portuguese / Portugu\xeas","settings__language_dropdown_russian":"Ruso / Russian / Русский","settings__language_dropdown_spanish":"Espa\xf1ol / Spanish","settings__matchmaking_region":"Regi\xf3n de Matchmaking","settings__matchmaking_region_dropdown_africa":"\xc1frica","settings__matchmaking_region_dropdown_any":"Cualquier regi\xf3n (la m\xe1s r\xe1pida)","settings__matchmaking_region_dropdown_asia":"Asia","settings__matchmaking_region_dropdown_australia_oceania":"Australia/Ocean\xeda","settings__matchmaking_region_dropdown_eu":"Europa","settings__matchmaking_region_dropdown_middle_east":"Oriente Medio","settings__matchmaking_region_dropdown_na_east":"Am\xe9rica del Norte (Este)","settings__matchmaking_region_dropdown_na_west":"Am\xe9rica del Norte (Oeste)","settings__matchmaking_region_dropdown_south_america":"Sudam\xe9rica","settings__save_button":"Guardar","settings__title":"Configuraci\xf3n","settings__settings_saved":"\xa1Configuraci\xf3n guardada!","signin_sign_in":"Iniciar sesi\xf3n","signin_sign_in_with_discord_btn":"Iniciar sesi\xf3n con Discord","signin_sign_in_with_google_btn":"Iniciar sesi\xf3n con Google","item_type__weapon":"Arma","item_type__gear":"Equipo","item_type__vendor":"Objeto para Vendedor","item_type__collector":"Objeto Especial","item_type__unknown":"Desconocido","stat_type_arcane":"Arcano","stat_type_bleed":"Sangrado","stat_type_chaos":"Caos","stat_type_fire":"Fuego","stat_type_frost":"Escarcha","stat_type_holy":"Sagrado","stat_type_lightning":"Rayo","stat_type_nature":"Naturaleza","stat_type_physical":"F\xedsico","stat_type_shadow":"Sombra","stat_type_toxic":"T\xf3xico","stats__back_btn":"Volver","stats__boss_kills":"Muertes de Jefes","stats__common_items_looted":"objetos comunes saqueados","stats__distanced_travelled":"distancia recorrida","stats__epic_items_looted":"objetos \xe9picos saqueados","stats__failed_runs":"intentos fallidos","stats__global_rank":"rango global","stats__gold_looted":"oro saqueado","stats__gold_lost_to_deaths":"oro perdido por muertes","stats__header":"Estad\xedsticas","stats__items_looted":"objetos saqueados","stats__items_lost_to_deaths":"objetos perdidos por muertes","stats__legendary_items_looted":"objetos legendarios saqueados","stats__npc_kills":"Muertes de PNJ","stats__player_kills":"muertes de jugadores","stats__rare_items_looted":"objetos raros saqueados","stats__run_success_percentage":"porcentaje de \xe9xito de la partida","stats__runs":"partidas","stats__successful_runs":"partidas exitosas","stats__time_played":"tiempo jugado","stats__uncommon_items_looted":"objetos poco comunes saqueados","toast__email_doesnt_match":"\xa1Las direcciones de correo electr\xf3nico no coinciden!","toast__email_not_long_enough":"\xa1La direcci\xf3n de correo electr\xf3nico no es lo suficientemente larga!","toast__gods_granted_you_items":"\xa1Los dioses te han otorgado un equipo b\xe1sico!","toast__not_an_email_address":"\xa1Eso no parece ser una direcci\xf3n de correo electr\xf3nico v\xe1lida!","toast__password_not_long_enough":"\xa1La contrase\xf1a no es lo suficientemente larga!","toast__passwords_dont_match":"\xa1Las contrase\xf1as no coinciden!","toast__username_changed":"\xa1Nombre de usuario cambiado exitosamente!","toast__username_too_short":"\xa1El nombre de usuario es demasiado corto!","vendors__back_to_main_menu_button":"Volver","vendors__coming_soon":"\xa1Pr\xf3ximamente!","vendors__title":"Vendedores","event_feed__looted_a":"saque\xf3 un","event_feed__in_the":"en","event_feed__at":"en","event_feed__killed":"mat\xf3 a","event_feed__boss":"jefe","event_feed__is_extracting":"est\xe1 extrayendo","event_feed__has_extracted":"\xa1ha extra\xeddo con \xe9xito!","event_feed__has_spawned":"ha aparecido en","event_feed__under_attack":"est\xe1 siendo atacado en"}');


var $28eb7c6fa89c3759$exports = {};
$28eb7c6fa89c3759$exports = JSON.parse('{"register__terms_label_1":"Ao se registrar em PvPz.io & Second Monitor Games, voc\xea concorda com nossos","register__terms_label_2":"Termos de Servi\xe7o","register__terms_label_3":"Pol\xedtica de Privacidade","register__promo_label":"Est\xe1 OK para Second Monitor Games me enviar emails sobre promo\xe7\xf5es e atualiza\xe7\xf5es de jogos","adblock_detected_failed_to_insure":"Algo deu errado ao segurar esse item. Por favor, certifique-se de que seu adblock est\xe1 desativado!","ability_type_active":"Ativo","ability_type_passive":"Passivo","change_username__back":"Voltar","change_username__cant_be_empty_error":"O nome de usu\xe1rio n\xe3o pode ficar em branco","change_username__current_prompt":"Seu nome de usu\xe1rio atual","change_username__enter_new":"Digite um novo nome de usu\xe1rio","change_username__header":"Nome de usu\xe1rio","change_username__save":"Salvar","change_username__too_long_error":"O nome de usu\xe1rio n\xe3o pode ter mais de 20 caracteres.","character_already_on_run_menu__abondon_run_button":"Abandonar Execu\xe7\xe3o","character_already_on_run_menu__back_to_main_menu_button":"Voltar","character_already_on_run_menu__bolded_header":"Seu personagem j\xe1 est\xe1 em uma execu\xe7\xe3o!","character_already_on_run_menu__paragraph_one":"Seu personagem ainda n\xe3o retornou de sua execu\xe7\xe3o anterior. Se voc\xea iniciar uma nova execu\xe7\xe3o agora, todos os seus itens da execu\xe7\xe3o anterior (exceto os itens segurados) ser\xe3o perdidos!","character_already_on_run_menu__paragraph_two":"Se voc\xea acredita que isso \xe9 um erro, ou se deseja abandonar intencionalmente sua execu\xe7\xe3o, voc\xea pode abandon\xe1-la for\xe7adamente usando o bot\xe3o abaixo.","character_already_on_run_menu__title":"ATEN\xc7\xc3O!","connection_error__back_to_main_menu":"Voltar ao menu principal","connection_error__error_reason":"Motivo do erro","connection_error__oof":"Ops","connection_error__server_error_header":"Erro de conex\xe3o com o servidor!","death_menu__back_to_main_menu_button":"Voltar ao Menu","death_menu__gear_lost":"Itens Perdidos","death_menu__gold_lost":"Ouro Perdido","death_menu__insured_items":"Itens Segurados","death_menu__loot_lost":"Saque Perdido","death_menu__nothing_insured":"Nenhum item foi segurado!","death_menu__saving_your_run_button":"Salvando...","death_menu__spectate_button":"Espectar o Assassino","death_menu__survived_for":"Sobreviveu Por","death_menu__title":"R.I.P","death_menu__weapons_lost":"Armas Perdidas","death_menu__your_killer":"Seu Assassino","extracted_menu__back_to_main_menu_button":"Voltar ao Menu","extracted_menu__gold_looted":"Ouro Saqueado","extracted_menu__loot_acquired":"Loot Obtido","extracted_menu__run_duration":"Dura\xe7\xe3o da Execu\xe7\xe3o","extracted_menu__title":"Extra\xeddo!","game_hud__cooldown":"Tempo de Recarga","game_hud__find_an_extraction_point":"Encontre um ponto de extra\xe7\xe3o!","game_hud__inventory_extract_prompt":"Voc\xea precisa extrair para usar esse loot!","game_hud__inventory_hud":"Abrir Invent\xe1rio","game_hud__leaderboard":"Classifica\xe7\xe3o","game_hud__leaderboard_current_world":"Mundo Atual","game_hud__leaderboard_hide":"Esconder","game_hud__leaderboard_show":"Mostrar","game_hud__looted_container_close":"Fechar","game_hud__spectating":"Observando","game_hud__time_left_to_extract":"restantes para extrair","game_hud__your_inventory_header":"Seu Invent\xe1rio!","game_hud__your_inventory_hide":"para fechar","game_transition__finding_match":"Procurando Partida","hotkey_interact":"E","hotkey_open_inventory":"i","hotkey_toggle_leaderboard":"L","how_to_play__ability_one_key":"Habilidade #1","how_to_play__ability_three_key":"Habilidade #3","how_to_play__ability_two_key":"Habilidade #2","how_to_play__back_to_main_menu_button":"Voltar","how_to_play__chat_key":"Chat","how_to_play__extraction":"Encontre um ponto de extra\xe7\xe3o!","how_to_play__inventory_key":"Invent\xe1rio","how_to_play__leaderboard_key":"Classifica\xe7\xe3o","how_to_play__mouse_aim_controls":": Mirar","how_to_play__mouse_shoot_controls":": Atirar","how_to_play__move_down_key":"Mover para Baixo","how_to_play__move_left_key":"Mover para a Esquerda","how_to_play__move_right_key":"Mover para a Direita","how_to_play__move_up_key":"Mover para Cima","how_to_play__small_paragraph_one":"Se voc\xea n\xe3o conseguir extrair a tempo, perder\xe1 todos os itens que trouxe consigo (a menos que tenha seguro!) e todos os itens que saqueou em sua execu\xe7\xe3o. A extra\xe7\xe3o \xe9 muito importante. Voc\xea deve EXTRAIR com seu loot para mant\xea-lo e us\xe1-lo.","how_to_play__small_paragraph_three":"Mate ou seja morto, que o melhor aventureiro ven\xe7a!","how_to_play__small_paragraph_two":" ","how_to_play__test_keys_header":"Teste as teclas!","how_to_play__title":"PvPz.io","how_to_play__top_big_paragraph":"Mate outros jogadores, encontre loot e extraia!","how_to_play__weapon_one_key":"Arma #1","how_to_play__weapon_two_key":"Arma #2","in_game__extracting":"Extraindo...","in_game__time_remaining":"Tempo Restante...","in_game__warning_time_almost_up":"Encontre um ponto de extra\xe7\xe3o!","insured_item_nothing":"Nada","item__AG_AmuletOfCursedFate__gameplay":"+10% de Velocidade de Ataque | RESSUSCITA com 40% de Vida quando voc\xea morre (n\xe3o acumula com outros itens de ressurrei\xe7\xe3o)","item__AG_AmuletOfCursedFate__lore":"Um amuleto maligno que distorce destinos e traz press\xe1gios sombrios.","item__AG_AmuletOfCursedFate__name":"Amuleto do Destino Amaldi\xe7oado","item__AG_MagicBoots__name":"Botas M\xe1gicas","item__AG_MagicBoots__gameplay":"Fica invis\xedvel por 9 segundos ao ser usado (2 usos) | Sua sa\xfade se regenera o tempo todo | Extra\xe7\xe3o 10% mais lenta.","item__AG_MagicBoots__lore":"Essas botas n\xe3o fazem barulho e revigoram quem as usa.","item__AG_Boros__gameplay":"Fique invis\xedvel por 7 segundos ao usar | -12% de Dano a NPCs | +12% de Roubo de Vida de todo o dano que voc\xea causa aos jogadores","item__AG_Boros__lore":"Dizem que sua gema \xe9 criada a partir do olho de um metamorfo.","item__AG_Boros__name":"Boros","item__AG_DarkPustulesRing__gameplay":"Receba 5% menos dano ao extrair | Extraia 5% mais r\xe1pido","item__AG_DarkPustulesRing__lore":"Este anel pode ser usado para obter magicamente um dia inteiro de um l\xedquido doce e escuro.","item__AG_DarkPustulesRing__name":"Anel de P\xfastulas Negras","item__AG_DreamWeaversEmbrace__gameplay":"Fique invis\xedvel por 4 segundos ao usar | -5% de Dano a Jogadores | Extraia 10% mais r\xe1pido | INCOGNITO: Esconde seu loot e mensagens de localiza\xe7\xe3o do resto do mundo","item__AG_DreamWeaversEmbrace__lore":"As pedras neste anel mudam de cor ao redor de \xe1reas onde o v\xe9u \xe9 fino.","item__AG_DreamWeaversEmbrace__name":"Abra\xe7o do Tecel\xe3o dos Sonhos","item__AG_ForestsHaven__gameplay":"Cura 20HP ao ser usado | Extraia 10% mais r\xe1pido | INCOGNITO: Esconde seu loot e mensagens de localiza\xe7\xe3o do resto do mundo | +20% Et\xe9reo","item__AG_ForestsHaven__lore":"Para aqueles que usam este anel, procurem o bosque de \xe1rvores escondido entre os sonhos.","item__AG_ForestsHaven__name":"Ref\xfagio da Floresta","item__AG_MysteriousRing__gameplay":"Adiciona 30 segundos ao seu temporizador de extra\xe7\xe3o ao ser usado | +10 de Vida M\xe1xima | +7% de Velocidade de Movimento ao caminhar na \xe1gua","item__AG_MysteriousRing__lore":"???","item__AG_MysteriousRing__name":"Anel Misterioso","item__AG_ObsidianEcho__gameplay":"EXTRAI ao ser usado, n\xe3o importa onde voc\xea esteja | +12% de Velocidade de Movimento | RESSUSCITA com 70% de Vida quando voc\xea morre (n\xe3o acumula com outros itens de ressurrei\xe7\xe3o) | -30 de Vida M\xe1xima | Este item \xe9 destru\xeddo quando totalmente usado","item__AG_ObsidianEcho__lore":"Forjado a partir de um fragmento da l\xe2mina de Malachi. Se voc\xea ouvir atentamente, pode ouvir o eco das almas daqueles que ele matou","item__AG_ObsidianEcho__name":"Eco Obsidiano","item__AG_PepperedCollar__gameplay":"Concede 4 segundos de aumento de velocidade de movimento em 25% quando usado (1 uso) | -3% Dist\xe2ncia do Proj\xe9til","item__AG_PepperedCollar__lore":"Uma coleira criada em homenagem a uma famosa besta felina.","item__AG_PepperedCollar__name":"Coleira Temperada","item__AG_RingOfAnOceanMan__gameplay":"Concede 2 segundos de +20% de velocidade de movimento ao ser usado | Extrai 5% mais r\xe1pido | +5% de Velocidade de Movimento ao caminhar na \xe1gua","item__AG_RingOfAnOceanMan__lore":"Parece que est\xe1 tentando pegar sua m\xe3o e lev\xe1-lo para uma terra que apenas ele entende.","item__AG_RingOfAnOceanMan__name":"Anel de um Homem do Oceano","item__AG_StuddedNecklace__gameplay":"Torne-se invis\xedvel por 4 segundos ao ser usado (3 cargas) | -3% de Velocidade de Movimento","item__AG_StuddedNecklace__lore":"Provavelmente devo fazer um seguro para isso","item__AG_StuddedNecklace__name":"Colar com Tachas","item__AG_TheDarkLordsEmbrace__gameplay":"+30 Sa\xfade M\xe1xima","item__AG_TheDarkLordsEmbrace__lore":"Amaldi\xe7oado pelas v\xe1rias atrocidades cometidas por seu portador.","item__AG_TheDarkLordsEmbrace__name":"O Abra\xe7o do Senhor das Trevas","item__AG_TimeHerosRing__gameplay":"Adiciona 45 segundos ao seu temporizador de extra\xe7\xe3o ao ser usado | +7% de Velocidade de Ataque | +7% de Velocidade de Movimento ao caminhar na \xe1gua | -5% de Velocidade de Movimento | +9% de Defesa contra Natureza | +7% de Dano da Natureza","item__AG_TimeHerosRing__lore":"Usado por um garoto \xe9lfico que podia viajar no tempo.","item__AG_TimeHerosRing__name":"Anel do Her\xf3i do Tempo","item__AG_VestiasSoothingSignet__gameplay":"Cura 30 PV ao ser usado | INCOGNITO: Esconde suas mensagens de saque e localiza\xe7\xe3o do restante do mundo","item__AG_VestiasSoothingSignet__lore":"Um anel que permite ao usu\xe1rio acalmar tanto ferimentos quanto tens\xf5es em grupo.","item__AG_VestiasSoothingSignet__name":"Selo Calmante de Vestia","item__AG_ViolasDinnerReminder__gameplay":"+8,5% de Defesa contra Natureza | +8,5% de Defesa contra Gelo | Recebe 7% menos dano durante a extra\xe7\xe3o | Seus proj\xe9teis viajam 5% menos","item__AG_ViolasDinnerReminder__lore":"Um anel que avisa a todos ao seu redor quando voc\xea est\xe1 com fome.","item__AG_ViolasDinnerReminder__name":"Lembrete de Jantar da Viola","item__AG_WolfMedallion__gameplay":"Cura 10HP ao usar | +10% de Velocidade de Ataque | +10% de Drenagem de todo o dano que voc\xea causa a jogadores","item__AG_WolfMedallion__lore":"Sintonizado \xe0 magia, pode detectar lugares de poder pr\xf3ximos.","item__AG_WolfMedallion__name":"Medalh\xe3o do Lobo","item__CI_AlloyedBend__gameplay":"","item__CI_AlloyedBend__lore":"Um anel feito de v\xe1rios metais raros que foram fundidos de forma grosseira.","item__CI_AlloyedBend__name":"Curva Ligada","item__CI_ApposSignet__gameplay":"","item__CI_ApposSignet__lore":"Rumor diz que pertence a um h\xedbrido meio-drag\xe3o, meio-humano que tinha a habilidade de controlar e falar com patos.","item__CI_ApposSignet__name":"Selo de Appo","item__CI_BloodhuntersRing__gameplay":"","item__CI_BloodhuntersRing__lore":"A ca\xe7adora de sangue procura seus semelhantes e tamb\xe9m voc\xea.","item__CI_BloodhuntersRing__name":"Anel da Ca\xe7adora de Sangue","item__CI_CelestialEternity__gameplay":"","item__CI_CelestialEternity__lore":"Aqueles que se levantaram contra Malachi foram presenteados com este anel pelos deuses.","item__CI_CelestialEternity__name":"Eternidade Celestial","item__CI_EbonstarBand__gameplay":"","item__CI_EbonstarBand__lore":"Este anel cont\xe9m parte da estrela ca\xedda que mudou tudo.","item__CI_EbonstarBand__name":"Banda Estrela de \xc9bano","item__CI_EchoingWhisperNecklace__gameplay":"","item__CI_EchoingWhisperNecklace__lore":"Um colar que captura e ecoa os sussurros das almas perdidas.","item__CI_EchoingWhisperNecklace__name":"Colar de Sussurro Ecoante","item__CI_FeyEnchantmentLocket__gameplay":"","item__CI_FeyEnchantmentLocket__lore":"Um medalh\xe3o infundido com encantamentos do reino das Fadas, conferindo um encanto sedutor.","item__CI_FeyEnchantmentLocket__name":"Medalh\xe3o de Encantamento das Fadas","item__CI_FragmentOfFate__gameplay":"","item__CI_FragmentOfFate__lore":"Antes inteiro, agora despeda\xe7ado. Antes unido, agora dividido. Antes eterno, agora obsoleto.","item__CI_FragmentOfFate__name":"Fragmento do Destino","item__CI_LatrosKnavishBand__gameplay":"","item__CI_LatrosKnavishBand__lore":"Um anel que apenas os mais vis ladr\xf5es com certeza moral usariam.","item__CI_LatrosKnavishBand__name":"Banda Desonesta de Latro","item__CI_LifesSimpleRing__gameplay":"","item__CI_LifesSimpleRing__lore":"Viva de forma simples para que outros possam viver de forma simples.","item__CI_LifesSimpleRing__name":"Anel Simples da Vida","item__CI_LuminousEnigma__gameplay":"","item__CI_LuminousEnigma__lore":"Eu possuo a chave de um conhecimento vasto, fornecendo respostas inigual\xe1veis.","item__CI_LuminousEnigma__name":"Enigma Luminoso","item__CI_Ouro__gameplay":"","item__CI_Ouro__lore":"Diz-se que \xe9 a chave para desvendar o conhecimento de todas as criaturas vivas.","item__CI_Ouro__name":"Ouro","item__CI_PeachRing__gameplay":"","item__CI_PeachRing__lore":"Tem um sabor doce.","item__CI_PeachRing__name":"Anel de P\xeassego","item__CI_PlayerSoulFragment__gameplay":"Um ceifador de almas ficaria interessado nisso.","item__CI_PlayerSoulFragment__lore":"Um fragmento da alma perdida de um aventureiro.","item__CI_PlayerSoulFragment__name":"Fragmento da Alma do Jogador","item__CI_ProudlyPinkRing__gameplay":"","item__CI_ProudlyPinkRing__lore":"Este anel \xe9 um impressionante acess\xf3rio de moda que certamente chamar\xe1 a aten\xe7\xe3o dos outros.","item__CI_ProudlyPinkRing__name":"Anel Orgulhosamente Rosa","item__CI_RadiantSunstoneBand__gameplay":"","item__CI_RadiantSunstoneBand__lore":"Uma cria\xe7\xe3o paradoxal, este anel simboliza um delicado equil\xedbrio entre ilumina\xe7\xe3o e destrui\xe7\xe3o.","item__CI_RadiantSunstoneBand__name":"Anel Radiante de Pedra do Sol","item__CI_RingOfDelerium__gameplay":"","item__CI_RingOfDelerium__lore":"Se voc\xea ouvir atentamente, poder\xe1 ouvir as vozes dos antigos donos deste anel.","item__CI_RingOfDelerium__name":"Anel do Del\xedrio","item__CI_RoyalBrooch__gameplay":"","item__CI_RoyalBrooch__lore":"O s\xedmbolo da fam\xedlia real. Vale uma boa quantia.","item__CI_RoyalBrooch__name":"Broche Real","item__CI_SuperStar__gameplay":"","item__CI_SuperStar__lore":"O resqu\xedcio de uma grande hist\xf3ria sobre um reino cheio de cogumelos.","item__CI_SuperStar__name":"Super Estrela","item__CI_SwampOgresRing__gameplay":"","item__CI_SwampOgresRing__lore":"J\xe1 pertenceu a um ogro verde que era muito protetor de seu p\xe2ntano.","item__CI_SwampOgresRing__name":"Anel do Ogro do P\xe2ntano","item__CI_WeddingRing__gameplay":"","item__CI_WeddingRing__lore":"Isso vale muito, eu deveria devolv\xea-lo ao dono original.","item__CI_WeddingRing__name":"Anel de Casamento","item__PG_AngelistasPotionPopper__gameplay":"Sua sa\xfade se regenera o tempo todo","item__PG_AngelistasPotionPopper__lore":"Um anel que voc\xea usa quando seu curandeiro pro\xedbe voc\xea de beber po\xe7\xf5es de cura.","item__PG_AngelistasPotionPopper__name":"Estourador de Po\xe7\xf5es de Angelista","item__PG_AquamoorsBlessing__gameplay":"Concede 3 segundos de +25% de velocidade de movimento quando usado (3 cargas) | Sua sa\xfade se regenera o tempo todo | -20 de Vida M\xe1xima","item__PG_AquamoorsBlessing__lore":"Dizem ser aben\xe7oado pelo esp\xedrito do lago antes da corrup\xe7\xe3o das terras.","item__PG_AquamoorsBlessing__name":"Ben\xe7\xe3o de Aquamoor","item__PG_ArcaneEmber__gameplay":"-6.5% de Dano contra NPCs | +5.6% de Dano contra jogadores","item__PG_ArcaneEmber__lore":"Um pequeno braseiro pode ser visto ainda brilhando na gema deste anel.","item__PG_ArcaneEmber__name":"Braseiro Arcano","item__PG_ArcaneSigilCollar__gameplay":"Concede 4 segundos de +30% de velocidade de movimento quando usado | -8.5% de dano a NPCs | +9.5% de dano a jogadores","item__PG_ArcaneSigilCollar__lore":"Gravado com s\xedmbolos poderosos, amplifica as habilidades arcanas do usu\xe1rio.","item__PG_ArcaneSigilCollar__name":"Coleira de S\xedmbolo Arcano","item__PG_AssassinSignet__gameplay":"Torne-se invis\xedvel por 5 segundos ao usar (2 cargas) | -3% Velocidade de Movimento | -3% Dist\xe2ncia de Proj\xe9til","item__PG_AssassinSignet__lore":"Um sinete segurado por uma assassina infame que lutava com seu cabelo.","item__PG_AssassinSignet__name":"Sinete do Assassino","item__PG_BellsShiningRing__gameplay":"Adiciona 60 segundos ao seu temporizador de extra\xe7\xe3o ao ser usado | -9,5% de Dano a jogadores | +15,5% de Dano a NPCs | +40 de Vida M\xe1xima | Sua sa\xfade se regenera o tempo todo","item__PG_BellsShiningRing__lore":"Conhecida por muitos como a melhor curandeira do reino.","item__PG_BellsShiningRing__name":"Anel Brilhante de Belle","item__PG_BloodGemRing__gameplay":"REVIVE com 50% de HP quando voc\xea morrer | -20 de sa\xfade m\xe1xima","item__PG_BloodGemRing__lore":"Aqueles que estavam no templo durante o ritual ca\xedram em um frenesi de derramamento de sangue. Este anel simboliza tempos desesperados.","item__PG_BloodGemRing__name":"Anel de Gema de Sangue","item__PG_BloodiedVitality__gameplay":"EXTRAI ao ser usado, n\xe3o importa onde voc\xea esteja | Sua sa\xfade se regenera o tempo todo | +30 de Vida M\xe1xima | -8% de Dano a Jogadores | Voc\xea recebe 10% mais dano de TODOS os tipos de dano ao extrair | Este item \xe9 destru\xeddo quando totalmente usado","item__PG_BloodiedVitality__lore":"Sua conex\xe3o com a realidade e a vida em si parece mais forte com isso em seu corpo.","item__PG_BloodiedVitality__name":"Vitalidade Manchada de Sangue","item__PG_BloodmoonLoop__gameplay":"Cura 5HP ao ser usado (3 cargas) | +5% de Dano por Sangramento","item__PG_BloodmoonLoop__lore":"Ligado aos ciclos lunares. Isso aumenta a destreza f\xedsica durante uma lua de sangue.","item__PG_BloodmoonLoop__name":"Bloodmoon Armor","item__PG_CapeOfPureDarkness__gameplay":"Concede 4 segundos de velocidade de movimento +25% quando usado | +9% de Defesa das Sombras | +9% de Defesa T\xf3xica | +7% de Dano T\xf3xico | Sua sa\xfade drena o tempo todo.","item__PG_CapeOfPureDarkness__lore":"Ningu\xe9m ousava question\xe1-lo por medo. Pois o Governante das Trevas n\xe3o era para ser questionado.","item__PG_CapeOfPureDarkness__name":"Capa das Trevas Puras","item__PG_CelestialSolaceBand__gameplay":"Cura 7HP quando usado | INSPE\xc7\xc3O: Revela informa\xe7\xf5es sobre seus oponentes | +6.5% de dano das sombras","item__PG_CelestialSolaceBand__lore":"Forjado pelos pr\xf3prios deuses, este anel oferece consolo em meio \xe0 escurid\xe3o.","item__PG_CelestialSolaceBand__name":"Anel de Consolo Celestial","item__PG_CelestialStarfallPendant__gameplay":"Fica invis\xedvel por 3 segundos ao ser usado | +6.5% de dano a NPCs | +5% de dano sagrado","item__PG_CelestialStarfallPendant__lore":"Um pingente adornado com uma gema celestial, invocando energia celestial.","item__PG_CelestialStarfallPendant__name":"Pingente de Queda Estelar Celestial","item__PG_CultistsMask__name":"M\xe1scara do Cultista","item__PG_CultistsMask__lore":"Aqueles que ca\xedram v\xedtimas da corrup\xe7\xe3o buscaram ocultar sua apar\xeancia, pois a corrup\xe7\xe3o mudou sua pr\xf3pria ess\xeancia.","item__PG_CultistsMask__gameplay":"Fique invis\xedvel por 6 segundos ao ser usado | INCOGNITO: Esconde suas mensagens de saque e localiza\xe7\xe3o do restante do mundo | +15% de Velocidade de Ataque","item__PG_DepthStrider__name":"Andarilho das Profundezas","item__PG_DepthStrider__lore":"Um encantamento fraco est\xe1 presente nesta capa, tornando a caminhada na \xe1gua mais f\xe1cil.","item__PG_DepthStrider__gameplay":"+5% de velocidade de movimento ao caminhar na \xe1gua.","item__PG_GoldenGauntlets__name":"Manoplas Douradas","item__PG_GoldenGauntlets__lore":"Apropriadas para saqueadores, essas manoplas parecem ajud\xe1-lo a encontrar mais ouro.","item__PG_GoldenGauntlets__gameplay":"+10% de ouro obtido de ba\xfas.","item__PG_BeastVanquisherBoots__name":"Botas do Vencedor das Feras","item__PG_BeastVanquisherBoots__lore":"Usado por aqueles na linha de frente da batalha. Essas botas possibilitaram a r\xe1pida derrota do inimigo.","item__PG_BeastVanquisherBoots__gameplay":"+12% de Velocidade de Movimento | +45 de Vida M\xe1xima | +25% de Dano a NPCs | -12% de Dano a Jogadores | -12% de Dist\xe2ncia de Proj\xe9teis","item__PG_CloakOfModestApproachability__gameplay":"Seus proj\xe9teis percorrem 6% a mais de dist\xe2ncia | Adiciona 30 segundos ao seu temporizador de extra\xe7\xe3o ao ser usado","item__PG_CloakOfModestApproachability__lore":"Os outros parecem atra\xeddos por voc\xea e n\xe3o t\xeam certeza do porqu\xea.","item__PG_CloakOfModestApproachability__name":"Manto da Aproxima\xe7\xe3o Modesta","item__PG_CloudedDarkness__gameplay":"+20% de Eteralidade | +10% de dano das sombras | +13% de defesa das sombras","item__PG_CloudedDarkness__lore":"Quando chegou a hora e o ato foi conclu\xeddo, uma nuvem de escurid\xe3o envolveu Malachi e foi imbu\xedda neste anel.","item__PG_CloudedDarkness__name":"Escurid\xe3o Nublada","item__PG_CompactedLimeGreenRing__gameplay":"Seus proj\xe9teis percorrem 5% a mais de dist\xe2ncia | +7% de dano t\xf3xico","item__PG_CompactedLimeGreenRing__lore":"Segurado pelo sucessor do trono de um drag\xe3o.","item__PG_CompactedLimeGreenRing__name":"Anel Verde-Lim\xe3o Compactado","item__PG_CopperWristband__gameplay":"+6.5% de defesa f\xedsica","item__PG_CopperWristband__lore":"Um anel absurdamente grande que se encaixa melhor como uma pulseira... S\xf3 se pode imaginar o tamanho da criatura que usava isso como anel.","item__PG_CopperWristband__name":"Pulseira de Cobre","item__PG_CoralReef__gameplay":"+8,5% de Velocidade de Movimento ao caminhar na \xe1gua | Extrai 10% mais devagar","item__PG_CoralReef__lore":"Criado como um presente para a princesa sereia.","item__PG_CoralReef__name":"Recife de Coral","item__PG_CorruptedTearRing__gameplay":"Fique invis\xedvel por 5 segundos ao ser usado | +7% Roubo de vida de todo o dano que voc\xea causa a jogadores | -7% Defesa contra Caos | +9% Dano Ca\xf3tico | +9% Dano de Raios","item__PG_CorruptedTearRing__lore":"Uma \xfanica l\xe1grima foi derramada antes que a corrup\xe7\xe3o se instalasse... \\"O que eu me tornei!?\\".","item__PG_CorruptedTearRing__name":"Anel da L\xe1grima Corrompida","item__PG_CursedEternityRing__gameplay":"Concede 5 segundos de +30% de velocidade de movimento ao ser usado | RESSUSCITA com 48% de Vida quando voc\xea morre (n\xe3o acumula com outros itens de ressurrei\xe7\xe3o) | +12% de Ouro de ba\xfas | +8,5% de Roubo de Vida de todo o dano causado aos jogadores | Sua sa\xfade diminui o tempo todo","item__PG_CursedEternityRing__lore":"Um s\xedmbolo de condena\xe7\xe3o eterna. Ele se prende a quem o usa, amaldi\xe7oando-os pela eternidade, mas concedendo-lhes grande poder.","item__PG_CursedEternityRing__name":"Anel da Eternidade Amaldi\xe7oada","item__PG_CursedSignet__gameplay":"+20% de Dreno de todo o dano que voc\xea causa a jogadores","item__PG_CursedSignet__lore":"Uma presen\xe7a maligna emana deste anel, trazendo infort\xfanio a todos que o usam.","item__PG_CursedSignet__name":"Anel Amaldi\xe7oado","item__PG_DeathwhisperWrap__gameplay":"+13% Dano a NPCs | +13% Defesa contra Caos | +10% Dano T\xf3xico","item__PG_DeathwhisperWrap__lore":"Enquanto a l\xe2mina mergulhava em seu cora\xe7\xe3o e tudo ficava negro, um sussurro fraco foi ouvido: \'Ainda n\xe3o \xe9 hora de eu reivindicar sua alma.\'","item__PG_DeathwhisperWrap__name":"Envolt\xf3rio do Sussurro da Morte","item__PG_DreadmorneLoop__gameplay":"Concede 3 segundos de +30% de velocidade de movimento ao ser usado (5 cargas) | -5% de Velocidade de Ataque | -6,5% de Defesa Sagrada | +10% de Dano Ca\xf3tico","item__PG_DreadmorneLoop__lore":"Este anel instila medo nos cora\xe7\xf5es dos inimigos, inspirando terror e causando pavor.","item__PG_DreadmorneLoop__name":"Dreadmorne Loop","item__PG_DreamcasterDrapery__gameplay":"+6.5% de dano contra NPCs | +6.5% de dano do caos","item__PG_DreamcasterDrapery__lore":"Nascido de pesadelos, esta veste diz-se manipular o subconsciente.","item__PG_DreamcasterDrapery__name":"Dreamcaster Drapery","item__PG_EbonfireRobelet__gameplay":"Seus proj\xe9teis viajam 6% mais longe","item__PG_EbonfireRobelet__lore":"Envolve o usu\xe1rio em uma aura de sombras fumegantes, concedendo prote\xe7\xe3o contra danos elementais.","item__PG_EbonfireRobelet__name":"Ebonfire Robelet","item__PG_ElvenGildedGuardian__gameplay":"Extra\xe7\xe3o 5% mais r\xe1pida","item__PG_ElvenGildedGuardian__lore":"Um cinto lindamente trabalhado, adornado com heras douradas, que aprimora a agilidade do usu\xe1rio e repele advers\xe1rios com fineza \xe9lfica.","item__PG_ElvenGildedGuardian__name":"Elven Gilded Guardian","item__PG_EmbergraspRing__gameplay":"+10 de Vida M\xe1xima","item__PG_EmbergraspRing__lore":"As chamas dan\xe7am e crepitam ao seu toque, queimando seus inimigos.","item__PG_EmbergraspRing__name":"Embergrasp Ring","item__PG_EnchantedElixirNecklace__gameplay":"Adiciona 60 segundos ao seu cron\xf4metro de extra\xe7\xe3o ao usar | REVIVA com 60% de HP quando morrer (n\xe3o acumula com outros itens de revive)","item__PG_EnchantedElixirNecklace__lore":"Um colar contendo um frasco de elixir encantado, aumentando a pot\xeancia m\xe1gica.","item__PG_EnchantedElixirNecklace__name":"Enchanted Elixir Necklace","item__PG_EnigmaLoop__gameplay":"INCOGNITO: Esconde suas mensagens de loot e localiza\xe7\xe3o do restante do mundo | +5% de dano do caos","item__PG_EnigmaLoop__lore":"Um anel enigm\xe1tico que confunde os inimigos, distorcendo a realidade a seu favor.","item__PG_EnigmaLoop__name":"Enigma Loop","item__PG_EnigmaticShadowweaveRing__gameplay":"Cura 20HP ao ser usado (1 carga) | +5,5% de Dano a Jogadores | -9% de Dano a NPCs","item__PG_EnigmaticShadowweaveRing__lore":"Impregnado de encantamentos enigm\xe1ticos, este anel tece fios de escurid\xe3o juntos.","item__PG_EnigmaticShadowweaveRing__name":"Anel de Tecelagem das Sombras Enigm\xe1ticas","item__PG_EssenceConduit__gameplay":"+9% de Dano contra NPCs | -4% de Dano contra jogadores","item__PG_EssenceConduit__lore":"Concede poder \xe0queles que cuidam da natureza.","item__PG_EssenceConduit__name":"Condu\xedte da Ess\xeancia","item__PG_EverlastingSpiritCircle__gameplay":"Concede 3 segundos de +25% de velocidade de movimento ao ser usado (2 cargas) | +10% de Ouro de ba\xfas","item__PG_EverlastingSpiritCircle__lore":"Forjado por feiti\xe7aria antiga, este anel atua como um condutor de energia espiritual.","item__PG_EverlastingSpiritCircle__name":"C\xedrculo Espiritual Eterno","item__PG_FrostFireRing__gameplay":"+7% de Dano de Fogo | +8,5% de Defesa contra Gelo | -6,5% de Defesa contra Fogo","item__PG_FrostFireRing__lore":"Um anel com pedras elementais, capaz de infundir ataques com poder adicional - \\"Porque voc\xea \xe9 quente e depois frio\\"","item__PG_FrostFireRing__name":"Anel Gelo de Fogo","item__PG_FrostbiteLoop__gameplay":"+6% de Velocidade de Movimento","item__PG_FrostbiteLoop__lore":"Uma aura g\xe9lida envolve este anel, congelando os cora\xe7\xf5es dos inimigos com um toque.","item__PG_FrostbiteLoop__name":"Anel Mordida do Gelo","item__PG_FrostfireShardPendant__gameplay":"Receba 10% menos dano durante a extra\xe7\xe3o | +8% de Dano a Jogadores","item__PG_FrostfireShardPendant__lore":"Um pingente que abriga um fragmento infundido com energias g\xe9lidas e flamejantes.","item__PG_FrostfireShardPendant__name":"Pingente de Fragmento Gelo de Fogo","item__PG_GineshsBottleOpener__gameplay":"Sua sa\xfade diminui constantemente | +12% de Dano para TODOS os tipos de dano | +8.5% de Velocidade de Movimento | Seus proj\xe9teis percorrem 8.5% a mais de dist\xe2ncia","item__PG_GineshsBottleOpener__lore":"Um anel que desvenda tanto a causa quanto a solu\xe7\xe3o de todos os problemas da vida.","item__PG_GineshsBottleOpener__name":"Abridor de Garrafas de Ginesh","item__PG_GirdleOfTheGoldenNecromancer__gameplay":"Cura 10HP quando usado | +6% de Velocidade de Movimento","item__PG_GirdleOfTheGoldenNecromancer__lore":"Um cinto opulento com incrusta\xe7\xf5es de ouro que confere uma aura dourada de prote\xe7\xe3o necrom\xe2ntica, afastando ferimentos.","item__PG_GirdleOfTheGoldenNecromancer__name":"Cintur\xe3o do Necromante Dourado","item__PG_GoldPlatedCape__gameplay":"+4% de Dano a jogadores","item__PG_GoldPlatedCape__lore":"Por algum motivo, isso conta como armadura.","item__PG_GoldPlatedCape__name":"Capa Banhada a Ouro","item__PG_GolemsGrasp__gameplay":"+30 de Vida M\xe1xima | -6% de Velocidade de Movimento | -6% de Velocidade de Movimento ao caminhar na \xe1gua","item__PG_GolemsGrasp__lore":"O poder da pedra irrompe neste anel, transformando sua pele em armadura.","item__PG_GolemsGrasp__name":"Garra do Golem","item__PG_GuardiansChainmailCollar__gameplay":"Cura 15 pontos de vida ao ser usado (3 utiliza\xe7\xf5es) | -5% Velocidade de Ataque","item__PG_GuardiansChainmailCollar__lore":"Uma resistente coleira de malha entrela\xe7ada, proporcionando prote\xe7\xe3o constante.","item__PG_GuardiansChainmailCollar__name":"Colar de Malha do Guardi\xe3o","item__PG_HeirloomCloak__gameplay":"Concede 2 segundos de aumento de velocidade de movimento em 20% quando utilizado (3 usos).","item__PG_HeirloomCloak__lore":"Uma simples capa passada por sua fam\xedlia por gera\xe7\xf5es.","item__PG_HeirloomCloak__name":"Capa de Heran\xe7a","item__PG_IceQueensEarrings__gameplay":"Concede 5 segundos de velocidade de movimento +20% ao usar | +4% de Dano a jogadores | +6.5% de Defesa contra Gelo | +5% de Dano G\xe9lido","item__PG_IceQueensEarrings__lore":"Brincos adequados para a pr\xf3pria Rainha do Gelo. Frios ao toque.","item__PG_IceQueensEarrings__name":"Brincos da Rainha do Gelo","item__PG_InfiniteLoop__gameplay":"Adiciona 45 segundos ao seu cron\xf4metro de extra\xe7\xe3o ao usar | -10 de Vida M\xe1xima | Sua sa\xfade se regenera constantemente","item__PG_InfiniteLoop__lore":"Capaz de converter energia vital em mana e mana em energia vital.","item__PG_InfiniteLoop__name":"Loop Infinito","item__PG_IronFoxLocket__gameplay":"INSPE\xc7\xc3O: Revela informa\xe7\xf5es sobre seus oponentes | +13% de defesa para TODOS os tipos de dano | +30 de sa\xfade m\xe1xima","item__PG_IronFoxLocket__lore":"As lendas falam de uma raposa, vestindo armadura de ferro, famosa por superar at\xe9 mesmo os ca\xe7adores mais espertos.","item__PG_IronFoxLocket__name":"Camafeu da Raposa de Ferro","item__PG_JaysesRing__gameplay":"+9,5% de Dano a jogadores | -9% de Dano a NPCs | +15% Et\xe9reo | +12% de Dano El\xe9trico | +12% de Dano de Fogo","item__PG_JaysesRing__lore":"O anel do famoso mago Jayse.","item__PG_JaysesRing__name":"Anel de Jayse","item__PG_LittleCompactedLimeGreenRing__gameplay":"Seus proj\xe9teis viajam 6% mais longe | +13% de Defesa T\xf3xica.","item__PG_LittleCompactedLimeGreenRing__lore":"Um dia pertenceu a um luxuoso drag\xe3o.","item__PG_LittleCompactedLimeGreenRing__name":"Anel Pequeno Verde-Lim\xe3o Compactado","item__PG_MementoMoriLocket__gameplay":"-6.5% de Defesa Ca\xf3tica | Defesa contra Sombras de +8.5%","item__PG_MementoMoriLocket__lore":"Um camafeu assombrado que serve como lembrete da mortalidade, fortalecendo a determina\xe7\xe3o.","item__PG_MementoMoriLocket__name":"Camafeu Memento Mori","item__PG_MidnightsVeilBand__gameplay":"Torne-se invis\xedvel por 5 segundos ao ser usado (2 cargas)","item__PG_MidnightsVeilBand__lore":"Usado com fios de sombra, esta capa aprimora a furtividade de quem a usa.","item__PG_MidnightsVeilBand__name":"V\xe9u da Meia-Noite","item__PG_MunchkinsRing__gameplay":"+7% Velocidade de Movimento | -10 de Vida M\xe1xima","item__PG_MunchkinsRing__lore":"Seu antigo dono tinha pernas curtas, mas elas nunca o desaceleraram.","item__PG_MunchkinsRing__name":"Anel do Munchkin","item__PG_NaturesAureateBarrier__gameplay":"Adiciona 30 segundos ao seu temporizador de extra\xe7\xe3o ao ser usado (2 usos) | -5,5% de dano a jogadores | INCOGNITO: Esconde suas mensagens de loot e localiza\xe7\xe3o do resto do mundo.","item__PG_NaturesAureateBarrier__lore":"Um robusto cinto tran\xe7ado em ouro, infundido com a fortitude de \xe1rvores antigas, concedendo ao usu\xe1rio um escudo de for\xe7a natural brilhante.","item__PG_NaturesAureateBarrier__name":"Barreira \xc1urea da Natureza","item__PG_NecroticGraspTalisman__gameplay":"Concede 5 segundos de velocidade de movimento +30% ao usar | Sua sa\xfade drena continuamente | +12% de Dano Sombrio","item__PG_NecroticGraspTalisman__lore":"Um talism\xe3 pulsante com poder necrom\xe2ntico, comandando as for\xe7as dos mortos-vivos.","item__PG_NecroticGraspTalisman__name":"Talism\xe3 do Aperto Necr\xf3tico","item__PG_NecroticSignet__gameplay":"Adiciona 45 segundos ao seu cron\xf4metro de extra\xe7\xe3o ao usar | +13% de Defesa Sagrada","item__PG_NecroticSignet__lore":"Um s\xedmbolo macabro de morte e decomposi\xe7\xe3o, que drena a vitalidade de seus inimigos.","item__PG_NecroticSignet__name":"Anel Necr\xf3tico","item__PG_PendantOfAncientWisdom__gameplay":"-7% de Dano a Jogadores | +8.75% de Dano a NPCs | +8.5% de Defesa Arcana | +7% de Dano Arcano","item__PG_PendantOfAncientWisdom__lore":"Um pingente ancestral que transmite conhecimento profundo para aquele que o usa.","item__PG_PendantOfAncientWisdom__name":"Pingente da Sabedoria Antiga","item__PG_PhantomBand__gameplay":"+30% de Et\xe9reo","item__PG_PhantomBand__lore":"Usar este anel et\xe9reo permite que voc\xea caminhe despercebido entre os vivos.","item__PG_PhantomBand__name":"Anel Fantasma","item__PG_PhoenixFeatherTorque__gameplay":"RESSUSCITA com 60% de Vida quando voc\xea morre (n\xe3o acumula com outros itens de ressurrei\xe7\xe3o) | +60 de Vida M\xe1xima | +19,5% de Defesa contra Fogo | +19,5% de Defesa contra Gelo | -19,5% de Defesa contra T\xf3xicos | -15% de Velocidade de Ataque","item__PG_PhoenixFeatherTorque__lore":"Um majestoso torque adornado com uma pena de f\xeanix, concedendo renascimento e renova\xe7\xe3o.","item__PG_PhoenixFeatherTorque__name":"Torque de Pluma de F\xeanix","item__PG_PhoenixsRespite__gameplay":"Fique invis\xedvel por 3 segundos ao usar | +6.5% de Defesa contra Fogo | +5% de Dano de Fogo","item__PG_PhoenixsRespite__lore":"Aqueles que se lan\xe7aram voluntariamente sobre as chamas renasciam com poder ainda maior.","item__PG_PhoenixsRespite__name":"Al\xedvio da F\xeanix","item__PG_PurpletratorsRing__gameplay":"+3% de Roubo de Vida de todo o dano causado a jogadores","item__PG_PurpletratorsRing__lore":"Aqueles que ousavam rir do nome deste anel muitas vezes eram mortos por seu usu\xe1rio.","item__PG_PurpletratorsRing__name":"Anel do Assassino Roxo","item__PG_QuintsFishingGarb__gameplay":"+5% de Velocidade de Ataque","item__PG_QuintsFishingGarb__lore":"Um anel que cria uma quantidade infinita de iscas para pesca, muitas vezes distribu\xeddas inadvertidamente aos membros do grupo.","item__PG_QuintsFishingGarb__name":"Traje de Pesca do Quint","item__PG_ResilientHeartstone__gameplay":"Cura 10HP ao ser usado | +5% de Ouro de ba\xfas | Recebe 5% menos dano durante a extra\xe7\xe3o | INSPE\xc7\xc3O: Revela informa\xe7\xf5es sobre seus oponentes","item__PG_ResilientHeartstone__lore":"Uma gema em forma de cora\xe7\xe3o que infunde fortaleza inabal\xe1vel no usu\xe1rio.","item__PG_ResilientHeartstone__name":"Cora\xe7\xe3o Resiliente","item__PG_RingOfConstellations__gameplay":"Seus proj\xe9teis viajam 6% mais longe","item__PG_RingOfConstellations__lore":"Dizem que um guerreiro da noite possu\xeda este anel e ele fornecia orienta\xe7\xe3o sob a escurid\xe3o da noite.","item__PG_RingOfConstellations__name":"Anel das Constela\xe7\xf5es","item__PG_RingOfTheOneHandedWarrior__gameplay":"-10 de Vida M\xe1xima | +12% de Dano F\xedsico | +12% de Dano de Sangramento","item__PG_RingOfTheOneHandedWarrior__lore":"Voc\xea s\xf3 precisa de uma m\xe3o para usar um anel.","item__PG_RingOfTheOneHandedWarrior__name":"Anel do Guerreiro de Uma M\xe3o","item__PG_RingOfViolentViolet__gameplay":"+30 de Vida M\xe1xima | +17% de Dano para TODOS os tipos de dano | -15% de Defesa para TODOS os tipos de dano","item__PG_RingOfViolentViolet__lore":"Voc\xea sente uma s\xfabita onda de poder e sede de sangue ao equipar este anel.","item__PG_RingOfViolentViolet__name":"Anel da Violeta Violenta","item__PG_RuneboundRing__gameplay":"+5% de Velocidade de Movimento ao andar na \xe1gua | +7% de Dano Arcano","item__PG_RuneboundRing__lore":"Gravado com runas antigas, ele canaliza energias arcanas para fortalecer o usu\xe1rio.","item__PG_RuneboundRing__name":"Anel Encantado de Runas","item__PG_SerpentsCoilChoker__gameplay":"INSPE\xc7\xc3O: Revela informa\xe7\xf5es sobre seus oponentes","item__PG_SerpentsCoilChoker__lore":"Enroscando-se no pesco\xe7o, ele confere ao usu\xe1rio gra\xe7a e ast\xfacia serpentinas.","item__PG_SerpentsCoilChoker__name":"Coleira de Serpente","item__PG_SerpentsRing__gameplay":"+6.5% de Resist\xeancia a Toxinas","item__PG_SerpentsRing__lore":"Um anel feito das escamas de uma serpente, encantado para proteger o usu\xe1rio do veneno.","item__PG_SerpentsRing__name":"Anel da Serpente","item__PG_ShieldbearersAmulet__gameplay":"Cura 10HP ao ser usado (1 carga) | +6,5% de dano a NPCs","item__PG_ShieldbearersAmulet__lore":"Estampado com um bras\xe3o her\xe1ldico, ele fortalece as defesas do usu\xe1rio.","item__PG_ShieldbearersAmulet__name":"Amuleto do Portador de Escudo","item__PG_SoulBindingRing__gameplay":"REVIVE com 40% de HP quando voc\xea morrer | +10% de Dano Sagrado","item__PG_SoulBindingRing__lore":"Este anel possui tr\xeas pedras. Uma \xe9 clara e transparente. As outras duas cont\xeam uma estranha n\xe9voa dourada e turbilhante.","item__PG_SoulBindingRing__name":"Anel de Liga\xe7\xe3o da Alma","item__PG_SoulforgeRing__gameplay":"EXTRAI quando usado, n\xe3o importa onde voc\xea esteja | Extrai 10% mais devagar | Este item \xe9 destru\xeddo quando totalmente usado","item__PG_SoulforgeRing__lore":"Infundido com a ess\xeancia de almas atormentadas, este anel aumenta sua destreza f\xedsica e m\xedstica.","item__PG_SoulforgeRing__name":"Anel da Forja da Alma","item__PG_SoulshackleVeil__gameplay":"Concede 3 segundos de +25% de velocidade de movimento ao ser usado (3 cargas) | +8,5% de Et\xe9reo | -5% de Velocidade de Movimento","item__PG_SoulshackleVeil__lore":"Preso pela magia negra, ele enreda as almas dos ca\xeddos, conectando voc\xea ao mundo espiritual.","item__PG_SoulshackleVeil__name":"V\xe9u do Encadeamento da Alma","item__PG_SoulstoneReliquary__gameplay":"Fique invis\xedvel por 4 segundos ao ser usado | Recebe 5% menos dano durante a extra\xe7\xe3o | RESSUSCITA com 20% de Vida quando voc\xea morre (n\xe3o acumula com outros itens de ressurrei\xe7\xe3o) | +5% de Roubo de Vida de todo o dano que voc\xea causa aos jogadores","item__PG_SoulstoneReliquary__lore":"Um colar relic\xe1rio que permite ao usu\xe1rio controlar e aproveitar almas capturadas.","item__PG_SoulstoneReliquary__name":"Relic\xe1rio de Pedra da Alma","item__PG_StormweaverCloak__gameplay":"INCOGNITO: Esconde suas mensagens de saque e localiza\xe7\xe3o do resto do mundo","item__PG_StormweaverCloak__lore":"Domine a f\xfaria das tempestades, comandando a ira dos c\xe9us.","item__PG_StormweaverCloak__name":"Capa do Invocador de Tempestades","item__PG_SummonersSign__gameplay":"+10 de Vida M\xe1xima","item__PG_SummonersSign__lore":"Usado pelos invocadores para reunir mana da terra.","item__PG_SummonersSign__name":"Sinal do Invocador","item__PG_TalismanOfVeiledShadows__gameplay":"Torna-se invis\xedvel por 3 segundos ao usar | -5% de Velocidade de Movimento | +8.5% de Defesa do Caos | +8.5% Defesa contra Sombras","item__PG_TalismanOfVeiledShadows__lore":"Um talism\xe3 m\xedstico que envolve o usu\xe1rio em trevas ef\xeameras.","item__PG_TalismanOfVeiledShadows__name":"Talism\xe3 das Sombras Veladas","item__PG_TantrumsLuckyLoop__gameplay":"+3% de Velocidade de Movimento","item__PG_TantrumsLuckyLoop__lore":"Um anel que faz voc\xea t\xe3o r\xe1pido quanto um galgo, e t\xe3o pregui\xe7oso quanto ele.","item__PG_TantrumsLuckyLoop__name":"La\xe7o da Sorte de Tantrum","item__PG_VampiricSeal__gameplay":"Cura 7HP ao ser usado (2 cargas) | +3% de Roubo de Vida de todo o dano que voc\xea causa aos jogadores","item__PG_VampiricSeal__lore":"Alimentando-se da for\xe7a vital de seus inimigos, concede vitalidade a cada golpe.","item__PG_VampiricSeal__name":"Vestimenta Vamp\xedrica","item__PG_VeilstormCirclet__gameplay":"Cura 30HP ao usar | -10% de Velocidade de Ataque | +12% de Dano da Natureza","item__PG_VeilstormCirclet__lore":"Det\xe9m o poder de uma tempestade furiosa. Concede ao usu\xe1rio controle sobre vento e rel\xe2mpago.","item__PG_VeilstormCirclet__name":"Capa da Tempestade Velada","item__PG_VenomousBite__gameplay":"Adiciona 30 segundos ao seu cron\xf4metro de extra\xe7\xe3o ao usar | Sua vida drena o tempo todo | +10% de Dano T\xf3xico","item__PG_VenomousBite__lore":"Armadura usada por antigos m\xe9dicos da peste.","item__PG_VenomousBite__name":"Mordida Venenosa","item__PG_WindspeakersRing__gameplay":"INSPE\xc7\xc3O: Revela informa\xe7\xf5es sobre seus oponentes | +7% de Dano da Natureza","item__PG_WindspeakersRing__lore":"J\xe1 pertenceu a um poderoso mago que foi perseguido ao redor do mundo por sua pr\xf3pria sombra. Dizem que este anel tem o poder de controlar os ventos.","item__PG_WindspeakersRing__name":"Anel do Ventos","item__PG_Wraithband__gameplay":"+8,5% Et\xe9reo | 7% de Dano Sagrado | -10 de Vida M\xe1xima","item__PG_Wraithband__lore":"Energia fantasmag\xf3rica percorre este anel, concedendo poderes espectrais.","item__PG_Wraithband__name":"Faixa Espectral","item__VT_AbyssalShard__gameplay":"","item__VT_AbyssalShard__lore":"Um peda\xe7o de pedra negra coletado do submundo.","item__VT_AbyssalShard__name":"Fragmento Abissal","item__VT_Amber__gameplay":"","item__VT_Amber__lore":"Esta pedra tem um tom alaranjado profundo.","item__VT_Amber__name":"\xc2mbar","item__VT_BardsDiary__gameplay":"","item__VT_BardsDiary__lore":"Esta can\xe7\xe3o est\xe1 repleta de poesia e partituras musicais.","item__VT_BardsDiary__name":"Livro de Can\xe7\xf5es do Bardo","item__VT_BrokenIronBand__gameplay":"","item__VT_BrokenIronBand__lore":"Um simples anel de ferro que perdeu seu brilho.","item__VT_BrokenIronBand__name":"Anel de Ferro Quebrado","item__VT_BrokenSword__gameplay":"","item__VT_BrokenSword__lore":"Esta espada j\xe1 viu dias melhores.","item__VT_BrokenSword__name":"Espada de Ferro Quebrada","item__VT_Cabbage__gameplay":"","item__VT_Cabbage__lore":"Voc\xea \xe9 repolho, sempre ser\xe1 repolho.","item__VT_Cabbage__name":"Repolho","item__VT_ChunkOfIron__gameplay":"","item__VT_ChunkOfIron__lore":"Um pequeno peda\xe7o de ferro, um ferreiro pode ser capaz de fazer algo com isso.","item__VT_ChunkOfIron__name":"Peda\xe7o de Ferro","item__VT_CubicZirconia__gameplay":"","item__VT_CubicZirconia__lore":"Um peda\xe7o quadrado de uma Zirc\xf4nia.","item__VT_CubicZirconia__name":"Zirc\xf4nia C\xfabica","item__VT_Diamond__gameplay":"Um colecionador de objetos raros provavelmente se interessaria por isso.","item__VT_Diamond__lore":"Uma pedra preciosa.","item__VT_Diamond__name":"Diamante","item__VT_DukesDiary__gameplay":"","item__VT_DukesDiary__lore":"As divaga\xe7\xf5es de um antigo Duque poderoso.","item__VT_DukesDiary__name":"Di\xe1rio do Duque de Ert","item__VT_EmeraldDust__gameplay":"","item__VT_EmeraldDust__lore":"Um esmeralda que foi transformada em um p\xf3 fino.","item__VT_EmeraldDust__name":"P\xf3 de Esmeralda","item__VT_Emerald__gameplay":"","item__VT_Emerald__lore":"Um peda\xe7o de uma esmeralda.","item__VT_Emerald__name":"Esmeralda","item__VT_EverlastingCandle__gameplay":"","item__VT_EverlastingCandle__lore":"Esta vela misteriosamente queimar\xe1 para sempre.","item__VT_EverlastingCandle__name":"Vela Eterna","item__VT_Eyeball__gameplay":"","item__VT_Eyeball__lore":"O olho de uma besta morta.","item__VT_Eyeball__name":"Olho de Besta","item__VT_FangOfTheBloodMoon__gameplay":"","item__VT_FangOfTheBloodMoon__lore":"Esta presa coberta de sangue \xe9 de uma criatura que vagueia apenas quando o c\xe9u est\xe1 sangrando.","item__VT_FangOfTheBloodMoon__name":"Presa da Lua Sangrenta","item__VT_Fossil__gameplay":"","item__VT_Fossil__lore":"Os restos de um ser antigo est\xe3o permanentemente impressos nesta rocha.","item__VT_Fossil__name":"F\xf3ssil","item__VT_GhostPlasma__gameplay":"","item__VT_GhostPlasma__lore":"Este l\xedquido viscoso brilha com energias et\xe9reas.","item__VT_GhostPlasma__name":"Plasma Fantasmag\xf3rico","item__VT_GoblinCloth__gameplay":"","item__VT_GoblinCloth__lore":"Este tecido est\xe1 muito sujo e tem um pouco de sangue nele.","item__VT_GoblinCloth__name":"Pano do Loin do Goblin","item__VT_GoldNugget__gameplay":"","item__VT_GoldNugget__lore":"Um pequeno peda\xe7o de ouro. Provavelmente vale muito.","item__VT_GoldNugget__name":"Pepita de Ouro","item__VT_OgreEntrails__gameplay":"","item__VT_OgreEntrails__lore":"V\xedsceras do interior de um Ogro.","item__VT_OgreEntrails__name":"V\xedsceras de Ogro","item__VT_OnyxGem__gameplay":"Um especialista em joias pode se interessar por isso.","item__VT_OnyxGem__lore":"Uma gema rara feita de \xf4nix.","item__VT_OnyxGem__name":"Gema de \xd4nix","item__VT_PileOfAsh__gameplay":"","item__VT_PileOfAsh__lore":"Apenas um pequeno monte de cinzas.","item__VT_PileOfAsh__name":"Monte de Cinzas","item__VT_Potato__gameplay":"Cozinhe-os, amasse-os, coloque-os em um ensopado.","item__VT_Potato__lore":"Voc\xea provavelmente nunca ouviu falar deles.","item__VT_Potato__name":"Batata","item__VT_QuartzRing__gameplay":"","item__VT_QuartzRing__lore":"Incrustado com um peda\xe7o de quartzo polido. N\xe3o vale muito, mas pelo menos \xe9 algo.","item__VT_QuartzRing__name":"Anel de Quartzo","item__VT_RatFur__gameplay":"","item__VT_RatFur__lore":"Um aglomerado nojento de pelos, provavelmente cheio de doen\xe7as.","item__VT_RatFur__name":"Aglomerado de Pelos de Rato","item__VT_RedMushroom__gameplay":"","item__VT_RedMushroom__lore":"Este cogumelo \xe9 comumente seco e transformado em p\xf3 usado para ajudar em doen\xe7as.","item__VT_RedMushroom__name":"Cogumelo Vermelho","item__VT_RingOfNearPerfection__gameplay":"","item__VT_RingOfNearPerfection__lore":"Seria melhor se tivesse magia.","item__VT_RingOfNearPerfection__name":"Anel de Quase Perfei\xe7\xe3o","item__VT_RubyDust__gameplay":"","item__VT_RubyDust__lore":"Um rubi que foi triturado em um p\xf3 fino.","item__VT_RubyDust__name":"P\xf3 de Rubi","item__VT_Ruby__gameplay":"","item__VT_Ruby__lore":"Um peda\xe7o de um rubi vermelho profundo.","item__VT_Ruby__name":"Rubi","item__VT_SapphireDust__gameplay":"","item__VT_SapphireDust__lore":"Um safira que foi transformada em um p\xf3 fino","item__VT_SapphireDust__name":"P\xf3 de Safira","item__VT_Sapphire__gameplay":"","item__VT_Sapphire__lore":"Um peda\xe7o azul profundo de uma safira","item__VT_Sapphire__name":"Safira","item__VT_SkeletonFemur__gameplay":"","item__VT_SkeletonFemur__lore":"Acho que h\xe1 um esqueleto com uma perna em algum lugar.","item__VT_SkeletonFemur__name":"F\xeamur de Esqueleto","item__VT_Skull__gameplay":"","item__VT_Skull__lore":"Um cr\xe2nio. Provavelmente de um desses esqueletos vagantes.","item__VT_Skull__name":"Cr\xe2nio","item__VT_StellarWeaveRing__gameplay":"","item__VT_StellarWeaveRing__lore":"Um anel feito de ramos tecidos. \xc9 comum.","item__VT_StellarWeaveRing__name":"Anel de Tecido Estelar","item__VT_TreantBranch__gameplay":"","item__VT_TreantBranch__lore":"Este peda\xe7o de madeira est\xe1 se contorcendo um pouco. Estranho","item__VT_TreantBranch__name":"Galho de Treant","item__VT_WellWornRing__gameplay":"","item__VT_WellWornRing__lore":"Este anel simples tem v\xe1rias marcas e arranh\xf5es vis\xedveis em sua superf\xedcie.","item__VT_WellWornRing__name":"Anel Desgastado","item__VT_WhispersOfTheVoid__gameplay":"","item__VT_WhispersOfTheVoid__lore":"A loucura \xe9 comum entre aqueles que ouvem sua voz. E quem n\xe3o ouve nesta \xe9poca de crise?","item__VT_WhispersOfTheVoid__name":"Sussurros do Vazio Vol. 1","item__W_ApprenticesStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano f\xedsico.","item__W_ApprenticesStaff__lore":"O cajado de um aprendiz de feiticeiro comumente usado para treinamento.","item__W_ApprenticesStaff__name":"Cajado do Aprendiz","item__W_ArchmagesSidekick__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano arcano.","item__W_ArchmagesSidekick__lore":"Pouco se sabe sobre este cajado, exceto que foi transmutado \xe0 exist\xeancia pelo Arquimago da Ordem Arcana.","item__W_ArchmagesSidekick__name":"Ajudante do Arquimago","item__W_BeesOnAStick__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano de natureza.","item__W_BeesOnAStick__lore":"Um cajado adornado com uma colmeia, zumbindo com o poder de abelhas enxameadoras, lan\xe7ando feiti\xe7os picantes aos advers\xe1rios.","item__W_BeesOnAStick__name":"Abelhas em um Pau","item__W_BlackDahliaWand__gameplay":"Dispara proj\xe9teis sombrios.","item__W_BlackDahliaWand__lore":"Sua natureza sombria corrompe os cora\xe7\xf5es daqueles que ousam empunh\xe1-lo.","item__W_BlackDahliaWand__name":"Varinha D\xe1lia Negra","item__W_BlazeRod__gameplay":"Dispara chamas!","item__W_BlazeRod__lore":"Encontrado nas profundezas do Nether, este bast\xe3o \xe9 impregnado com a alma de uma Blaze.","item__W_BlazeRod__name":"Bast\xe3o Flamejante","item__W_Bloodrider__gameplay":"Dispara flechas que causam dano sanguinolento pesado.","item__W_Bloodrider__lore":"Fabricado a partir dos ossos de guerreiros ca\xeddos, este arco mal\xe9volo drena a vida a cada flecha, deixando para tr\xe1s um rastro de desespero carmesim.","item__W_Bloodrider__name":"Cavaleiro Sanguin\xe1rio","item__W_BrokenDeathstick__gameplay":"Dispara proj\xe9teis do caos que causam dano moderado.","item__W_BrokenDeathstick__lore":"Seria mortal... se n\xe3o estivesse quebrado.","item__W_BrokenDeathstick__name":"Bast\xe3o da Morte Quebrado","item__W_CandlelightStaff__gameplay":"Dispara um proj\xe9til m\xe1gico que causa dano de fogo.","item__W_CandlelightStaff__lore":"Um cajado que emite uma luz suave, iluminando a escurid\xe3o.","item__W_CandlelightStaff__name":"Cajado de Luz de Velas","item__W_CelestialBow__gameplay":"Um emiss\xe1rio celestial infundiu essas flechas com o frio do vazio.","item__W_CelestialBow__lore":"Presenteado por deidades antigas, este arco radiante canaliza b\xean\xe7\xe3os divinas, perfurando at\xe9 as defesas mais formid\xe1veis.","item__W_CelestialBow__name":"Arco Celestial","item__W_CrudeCrossbow__gameplay":"Dispara um parafuso b\xe1sico de baixo dano que causa dano f\xedsico.","item__W_CrudeCrossbow__lore":"Uma besta rudimentar feita de retalhos de madeira e barbante. N\xe3o \xe9 muito poderosa, mas serve.","item__W_CrudeCrossbow__name":"Besta Rudimentar","item__W_DarylsInstinct__gameplay":"Dispara parafusos poderosos que causam dano de sangramento.","item__W_DarylsInstinct__lore":"Uma besta usada pelo lend\xe1rio ca\xe7ador Daryl.","item__W_DarylsInstinct__name":"Instinto de Daryl","item__W_DavidBowie__gameplay":"Dispara proj\xe9teis f\xedsicos fracos.","item__W_DavidBowie__lore":"Transforma voc\xea em uma estrela instant\xe2nea!","item__W_DavidBowie__name":"David Bowie","item__W_DemonsEye__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano de sombra.","item__W_DemonsEye__lore":"Este cajado evoca os sussurros sinistros do reino nefasto, permitindo que os portadores perfurem ilus\xf5es e revelem as verdades ocultas que se escondem nas sombras.","item__W_DemonsEye__name":"Olho do Dem\xf4nio","item__W_DivineWind__gameplay":"Dispara flechas poderosas sagradas.","item__W_DivineWind__lore":"Forjado em santu\xe1rios de montanhas sagradas, este arco et\xe9reo impulsiona flechas com ventos de outro mundo, rasgando obst\xe1culos e inimigos.","item__W_DivineWind__name":"Vento Divino","item__W_DragonsBreath__gameplay":"Cria um turbilh\xe3o de chamas \xe0 frente do conjurador.","item__W_DragonsBreath__lore":"Eu conjuro... Bola de Fogo?","item__W_DragonsBreath__name":"Bafo do Drag\xe3o","item__W_EldritchBlasters__gameplay":"Dispara rapidamente parafusos de sombra.","item__W_EldritchBlasters__lore":"Bestas duplas imbuidas com o poder das sombras.","item__W_EldritchBlasters__name":"Canh\xf5es Eldritch","item__W_Emberstrike__gameplay":"Dispara poderosas flechas de fogo.","item__W_Emberstrike__lore":"Forjado no cora\xe7\xe3o de um vulc\xe3o, este arco de obsidiana libera flechas ardentes, deixando para tr\xe1s trilhas de devasta\xe7\xe3o em brasa.","item__W_Emberstrike__name":"Golpe das Brasas","item__W_FairyBow__gameplay":"Dispara flechas infundidas com magia de fadas.","item__W_FairyBow__lore":"Infunde as flechas disparadas por este arco com energia poderosa e aleat\xf3ria.","item__W_FairyBow__name":"Arco das Fadas","item__W_FairyStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano de natureza.","item__W_FairyStaff__lore":"Pertenceu a uma rainha das fadas.","item__W_FairyStaff__name":"Cajado das Fadas","item__W_FathersBane__gameplay":"Dispara rapidamente parafusos fracos com ponta envenenada.","item__W_FathersBane__lore":"Usado por um filho enlutado que n\xe3o teve escolha sen\xe3o matar seu pai.","item__W_FathersBane__name":"Flagelo do Pai","item__W_FlamespitterStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano arcano.","item__W_FlamespitterStaff__lore":"Chamas furiosas irrompem deste cajado.","item__W_FlamespitterStaff__name":"Cajado Esguicho de Chamas","item__W_FrostedTips__gameplay":"Causa dano de gelo.","item__W_FrostedTips__lore":"Santa Maria, Stromboli!","item__W_FrostedTips__name":"Ponta Gelada","item__W_GuardsCrossbow__gameplay":"Mais f\xe1cil e r\xe1pido de carregar do que uma besta normal.","item__W_GuardsCrossbow__lore":"Besta usada pelos guardas da Ordem Arcana.","item__W_GuardsCrossbow__name":"Besta dos Guardas","item__W_HibidyKibity__gameplay":"Dispara proj\xe9teis mortais de caos.","item__W_HibidyKibity__lore":"Uma varinha incrustada com a energia vil da maldi\xe7\xe3o assassina.","item__W_HibidyKibity__name":"Hibidy Kibity","item__W_IcewindWand__gameplay":"Cria uma torrente de nuvens congelantes \xe0 frente do conjurador.","item__W_IcewindWand__lore":"Capaz de criar o pior clima poss\xedvel.","item__W_IcewindWand__name":"Varinha Vento G\xe9lido","item__W_IronStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano f\xedsico.","item__W_IronStaff__lore":"Um cajado feito de ferro, usado pelos guardas da Ordem Arcana.","item__W_IronStaff__name":"Cajado de Ferro","item__W_KingBible__gameplay":"Lan\xe7a poderosas b\xedblias sagradas em seus oponentes.","item__W_KingBible__lore":"Um tomo venerado e dourado que cont\xe9m palavras sagradas de antigos monarcas, concedendo autoridade e moldando destinos.","item__W_KingBible__name":"B\xedblia do Rei","item__W_Deathstick__gameplay":"Causa a morte ao disparar proj\xe9teis de curto alcance rapidamente, ao custo de desacelerar o usu\xe1rio.","item__W_Deathstick__lore":"A lenda diz que essa poderosa arma foi deixada cair por uma figura misteriosa h\xe1 s\xe9culos.","item__W_Deathstick__name":"Deathstick","item__W_BookOfTongues__gameplay":"Dispara o fogo mais poderoso das profundezas do inferno. Possui um tempo de recarga MUITO longo.","item__W_BookOfTongues__lore":"Um nome ileg\xedvel pode ser visto gravado em suas p\xe1ginas. Tudo o que voc\xea consegue identificar \xe9 a letra \\"M\\".","item__W_BookOfTongues__name":"Livro das L\xednguas","item__W_LichsStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano de sombra.","item__W_LichsStaff__lore":"Empunhado por necromantes sombrios, este cajado aproveita os poderes profanos dos mortos-vivos, trazendo morte e decomposi\xe7\xe3o a tudo que toca.","item__W_LichsStaff__name":"Cajado do Lich","item__W_FrostFlicker__gameplay":"Coloca uma armadilha vis\xedvel perto de seus p\xe9s que causa dano de gelo.","item__W_FrostFlicker__lore":"Um cajado com a habilidade de congelar a \xe1gua na \xe1rea circundante. Uma vers\xe3o mais fraca disso \xe9 frequentemente usada durante a temporada de f\xe9rias.","item__W_FrostFlicker__name":"Brilho G\xe9lido","item__W_MagicalWand__gameplay":"Dispara proj\xe9teis m\xe1gicos arcanos.","item__W_MagicalWand__lore":"Em nome da lua, eu te punirei!","item__W_MagicalWand__name":"Varinha M\xe1gica","item__W_MidasStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano de raio.","item__W_MidasStaff__lore":"O cajado do lend\xe1rio Rei Midas.","item__W_MidasStaff__name":"Cajado de Midas","item__W_MoonShadow__gameplay":"Dispara flechas das sombras rapidamente.","item__W_MoonShadow__lore":"Conferido pelas esp\xedritos da lua, este arco m\xedstico dispara flechas que atravessam as sombras, atingindo de \xe2ngulos inesperados.","item__W_MoonShadow__name":"Sombra da Lua","item__W_NaturesReturn__gameplay":"Utiliza o poder da floresta para causar grandes quantidades de dano de natureza aos seus oponentes.","item__W_NaturesReturn__lore":"Um tomo adornado com folhagens, canalizando as for\xe7as da natureza para crescimento, cura e tempestades.","item__W_NaturesReturn__name":"Retorno da Natureza","item__W_NightStick__gameplay":"Dispara proj\xe9teis mais frios que a noite.","item__W_NightStick__lore":"Usado por aqueles que pretendem manter a paz.","item__W_NightStick__name":"Cacetete Noturno","item__W_PharaohsStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano sagrado.","item__W_PharaohsStaff__lore":"Escavado do t\xfamulo de um antigo Fara\xf3, diz-se que este cajado foi usado para invocar os mortos.","item__W_PharaohsStaff__name":"Cajado do Fara\xf3","item__W_PhoenixWing__gameplay":"Dispara flechas infundidas com as chamas de uma f\xeanix ca\xedda.","item__W_PhoenixWing__lore":"Feito de penas de f\xeanix, este arco radiante canaliza o renascimento flamejante, inflamando as flechas com chamas ardentes.","item__W_PhoenixWing__name":"Asa da F\xeanix","item__W_PoseidonsWand__gameplay":"Dispara peixes.","item__W_PoseidonsWand__lore":"PEIXEEEEEEEEEEEEE!","item__W_PoseidonsWand__name":"Varinha de Poseidon","item__W_QuincyBow__gameplay":"Dispara flechas infundidas com energia el\xe9trica.","item__W_QuincyBow__lore":"Dispara flechas feitas da energia espiritual do portador.","item__W_QuincyBow__name":"Arco de Quincy","item__W_SilentShadow__gameplay":"Dispara flechas impregnadas de energia das sombras.","item__W_SilentShadow__lore":"\\"Eles chegaram sem aviso e nos pegaram de surpresa. Conseguimos nos defender, mas perdemos muitos no processo.\\"","item__W_SilentShadow__name":"Sombra Silenciosa","item__W_RangersGuillotine__gameplay":"Dispara flechas envenenadas.","item__W_RangersGuillotine__lore":"Com precis\xe3o mortal, este arco brutal corta defesas, cravando suas v\xedtimas com flechas envenenadas.","item__W_RangersGuillotine__name":"Guilhotina do Ranger","item__W_ReapersEmbrace__gameplay":"Dispara proj\xe9teis poderosos do caos.","item__W_ReapersEmbrace__lore":"Um arco espectral que drena vida a cada flecha, envolvendo os inimigos no abra\xe7o g\xe9lido do Ceifador.","item__W_ReapersEmbrace__name":"Abra\xe7o do Ceifador","item__W_RelicWand__gameplay":"Manifesta proj\xe9teis f\xedsicos que causam alto dano.","item__W_RelicWand__lore":"Canaliza a ess\xeancia de civiliza\xe7\xf5es perdidas e magias esquecidas.","item__W_RelicWand__name":"Varinha Relic\xe1ria","item__W_ReliqueryCrossbow__gameplay":"Dispara parafusos do caos de alto dano.","item__W_ReliqueryCrossbow__lore":"Besta usada pelos sacerdotes do Relic\xe1rio Vamp\xedrico.","item__W_ReliqueryCrossbow__name":"Besta do Relic\xe1rio","item__W_SamsStirringStick__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano arcano.","item__W_SamsStirringStick__lore":"A colher de um chef lend\xe1rio, imbuida com o poder dos elementos (culin\xe1rios).","item__W_SamsStirringStick__name":"Colher de Sam","item__W_SlimeStaff__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano de natureza.","item__W_SlimeStaff__lore":"Um cajado pulsante com a ess\xeancia dos slimes, permitindo ao portador invocar e comandar essas criaturas gelatinosas.","item__W_SlimeStaff__name":"Cajado de Slime","item__W_SpellbindersTome__gameplay":"Emite proj\xe9teis arcanos contra seus oponentes.","item__W_SpellbindersTome__lore":"Um m\xedstico livro encadernado em couro que captura mentes com feiti\xe7os intricados de encantamento.","item__W_SpellbindersTome__name":"Tomo do Encantador","item__W_SpiraledWand__gameplay":"Dispara raios de energia m\xe1gica cin\xe9tica.","item__W_SpiraledWand__lore":"Na verdade, \xe9 apenas um bast\xe3o mais elegante.","item__W_SpiraledWand__name":"Bast\xe3o Espiralado","item__W_StaffOfTheSnake__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano t\xf3xico.","item__W_StaffOfTheSnake__lore":"Um cajado adornado com a cabe\xe7a de uma cobra, esculpida em Esmeralda. Dizem que ele pode cuspir veneno nos inimigos.","item__W_StaffOfTheSnake__name":"Cajado da Serpente","item__W_StarShot__gameplay":"Dispara flechas arcanas fortes infundidas com energia estelar.","item__W_StarShot__lore":"Esculpido a partir de fragmentos celestiais, este arco libera uma cascata de proj\xe9teis brilhantes, um espet\xe1culo celestial de destrui\xe7\xe3o.","item__W_StarShot__name":"Tiro Estelar","item__W_StarWand__gameplay":"Emite o poder das estrelas contra seus oponentes.","item__W_StarWand__lore":"Um instrumento extravagante e brilhante.","item__W_StarWand__name":"Varinha Estelar","item__W_SteelCrossbow__gameplay":"Dispara parafusos de besta que perfuram at\xe9 mesmo as peles mais espessas.","item__W_SteelCrossbow__lore":"Uma besta padr\xe3o feita de a\xe7o.","item__W_SteelCrossbow__name":"Besta de A\xe7o","item__W_Stick__gameplay":"Dispara fa\xedscas de energia m\xe1gica.","item__W_Stick__lore":"Existem muitos como ele, mas este \xe9 meu!","item__W_Stick__name":"Bast\xe3o","item__W_TheCrossBow__gameplay":"Dispara proj\xe9teis sagrados em alta velocidade.","item__W_TheCrossBow__lore":"Entregue a justi\xe7a dos senhores com esta lend\xe1ria besta.","item__W_TheCrossBow__name":"A Besta Cruzada","item__W_ToxicWand__gameplay":"Dispara uma esfera t\xf3xica.","item__W_ToxicWand__lore":"Pode ser viciante, mas voc\xea deve saber que \xe9 t\xf3xico.","item__W_ToxicWand__name":"Varinha T\xf3xica","item__W_Triforce__gameplay":"Emite o poder da Triforce contra seus oponentes.","item__W_Triforce__lore":"Um tomo radiante que desbloqueia os poderes divinos da coragem, sabedoria e poder.","item__W_Triforce__name":"Triforce","item__W_TwistedBranch__gameplay":"Coloca uma armadilha vis\xedvel perto dos seus p\xe9s que causa dano de fogo.","item__W_TwistedBranch__lore":"Um bast\xe3o rudimentar que foi encantado por um feiticeiro tardio.","item__W_TwistedBranch__name":"Ramo Torcido","item__W_WitchHuntersRepeaters__gameplay":"Dispara parafusos infundidos com uma radi\xe2ncia sagrada.","item__W_WitchHuntersRepeaters__lore":"Bestas comuns usadas pelos Ca\xe7adores de Bruxas da Ordem Arcana.","item__W_WitchHuntersRepeaters__name":"Repetidor dos Ca\xe7adores de Bruxas","item__W_WizardsLedger__gameplay":"Dispara MOEDAS rapidamente. Sim, moedas.","item__W_WizardsLedger__lore":"Isso \xe9 pagar para ganhar?","item__W_WizardsLedger__name":"Livro de Contabilidade do Mago","item__W_WyvernsTalon__gameplay":"Dispara parafusos poderosos que causam dano de sangramento.","item__W_WyvernsTalon__lore":"Besta feita das garras de um grande wyvern.","item__W_WyvernsTalon__name":"Garra do Wyvern","item__W_ZappingWand__gameplay":"Dispara proj\xe9teis de rel\xe2mpago.","item__W_ZappingWand__lore":"Traz uma onda de poder eletrizante para o seu repert\xf3rio m\xe1gico.","item__W_ZappingWand__name":"Varinha de Choque","item_container__loot_chest":"Ba\xfa de Saque","item_container__loot_drop":"Queda de Saque","item_rarity__common":"Comum","item_rarity__epic":"\xc9pico","item_rarity__legendary":"Lend\xe1rio","item_rarity__rare":"Raro","item_rarity__uncommon":"Incomum","common":"Comum","uncommon":"Incomum","rare":"Raro","epic":"\xc9pico","legendary":"Lend\xe1rio","item_slot__damage":"dano","item_slot__equip_prompt":"Clique esquerdo para equipar!","item_slot__extract_prompt":"Extrair para usar este item!","item_slot__grants_ability":"Concede Habilidade","item_slot__grants_passive":"Efeito Passivo","item_slot__loot_prompt":"Clique esquerdo para saquear!","loadout_menu__abilities_header":"Habilidades","loadout_menu__back_to_main_menu_button":"Voltar","loadout_menu__damage":"Dano","loadout_menu__defence":"Defesa","loadout_menu__gear_header":"Equipamento","loadout_menu__health":"Vida","loadout_menu__insurance_button":"Segurar","loadout_menu__no_abilities":"Seu loadout n\xe3o cont\xe9m nenhuma habilidade.","loadout_menu__no_slot_selected_insurance_text":"\uD83D\uDEA8 Nada est\xe1 segurado! \uD83D\uDEA8","loadout_menu__no_slot_selected_insurance_text_2":"Nenhum slot est\xe1 segurado! Assista a um an\xfancio para proteger 1 item.","loadout_menu__no_slot_selected_scrollbox":"Selecione um slot para alterar seu loadout","loadout_menu__scrollbox_with_gear_text":"Escolha algum equipamento","loadout_menu__scrollbox_with_skins_text":"Escolha uma skin","loadout_menu__scrollbox_with_weapons_text":"Escolha uma arma","loadout_menu__skin_header":"Escolha uma Skin","loadout_menu__slot_insured_text":"✅ Voc\xea est\xe1 segurado! ✅","loadout_menu__start_run_button":"Jogar","loadout_menu__stat":"Estat\xedstica","loadout_menu__title":"Loadout","loadout_menu__undo":"Desfazer","loadout_menu__weapons_header":"Armas","loadout_menu__will_be_safe":"ficar\xe1 seguro se voc\xea morrer.","loadout_menu__your":"Seu","login__header":"Fazer Login","fullscreen":"Tela Cheia","exit_fullscreen":"Sair da Tela Cheia","loot_prompt":"[ E ] para saquear","leaderboard__player_kills":"PK","leaderboard__loot":"Itens","leaderboard__npc_kills":"NPCK","main_menu__patch_notes_btn":"Notas do Patch","main_menu__change_username_btn":"Alterar Nome de Usu\xe1rio","main_menu__create_account_btn":"Criar Conta","main_menu__collection_log_btn":"Registro de Cole\xe7\xe3o","collection_log__header":"Registro de Cole\xe7\xe3o","main_menu__discord_btn_tooltip":"Encontre amigos e junte-se a n\xf3s no Discord!","main_menu__game_is_in_maintenance_mode":"PvPz.io est\xe1 sendo atualizado! A nova atualiza\xe7\xe3o ser\xe1 implantada em breve, tente novamente em alguns minutos","main_menu__how_to_play_btn":"Como Jogar","main_menu__identity_error_title":"Ops","main_menu__loading_bar_text":"Carregando...","main_menu__logout_btn":"Sair","main_menu__partners":"Parceiros","main_menu__partners_and_credits":"Todos os parceiros e cr\xe9ditos","main_menu__patch_prefix":"Atualiza\xe7\xe3o","main_menu__patch_suffix":"chegando em 1\xba de junho!","main_menu__play_btn":"Jogar","main_menu__rankings_btn":"Classifica\xe7\xf5es","main_menu__settings_btn":"Configura\xe7\xf5es","main_menu__sign_in_btn":"Entrar","main_menu__sign_in_with_discord_btn":"Entrar com o Discord","main_menu__sign_in_with_facebook_btn":"Entrar com o Facebook","main_menu__sign_in_with_google_btn":"Entrar com o Google","main_menu__twitter_btn_tooltip":"Siga-nos no Twitter!","main_menu__vendors_btn":"Vendedores","main_menu__view_inventory_btn":"Invent\xe1rio","main_menu__view_your_stats_btn":"Suas Estat\xedsticas","main_menu__website_btn_tooltip":"Visite nosso site!","main_menu__welcome_panel_title":"Bem-vindo","main_menu__welcome_panel_title_suffix":" de volta,","main_menu__welcome_sign_in_cta":"Quer mudar seu nome de usu\xe1rio? Fa\xe7a login!","main_menu_stash__collectors_items":"Itens de Colecionador","main_menu_stash__discovered":"Descobertos","main_menu_stash__gear":"Equipamento","main_menu_stash__header":"Ba\xfa","main_menu_stash__total_items_discovered":"Itens Descobertos","main_menu_stash__vendor_items":"Itens de Vendedor","main_menu_stash__weapons":"Armas","player_skins__boltman":"Ranger","player_skins__corrupted_wizard":"Mago Corrompido","player_skins__knight":"Cavaleiro","player_skins__red_wizard":"Aprendiz de Mago","player_skins__thief":"Ladr\xe3o","player_skins__veteran_wizard":"Mago da Escola do Drag\xe3o","rankings__back_to_main_menu_button":"Voltar","rankings__coming_soon":"Em Breve!","rankings__title":"Classifica\xe7\xf5es","region__dreamers_forest":"Floresta dos Sonhadores","region__ert_lich":"Ert Lich","region__erthel":"Erthel","region__forgotten_temple":"Templo Esquecido","region__skull_lake":"Lago do Cr\xe2nio","region__swamp_of_sorrows":"P\xe2ntano das Tristezas","region__the_edgelands":"Terras Lim\xedtrofes","region__wilderness":"Selva","dreamers forest":"Floresta dos Sonhadores","ert lich":"Ert Lich","erthel":"Erthel","forgotten temple":"Templo Esquecido","skull lake":"Lago do Cr\xe2nio","swamp of sorrows":"P\xe2ntano das Tristezas","edgelands":"Terras Lim\xedtrofes","wilderness":"Selva","register__delete_account_cta":"Voc\xea \xe9 um usu\xe1rio an\xf4nimo, portanto, sua conta ser\xe1 exclu\xedda em 2 semanas! Se voc\xea deseja manter seus itens e estat\xedsticas e alterar seu nome de usu\xe1rio, registre-se!","register__delete_account_cta_2":"Voc\xea \xe9 um usu\xe1rio an\xf4nimo, portanto, n\xe3o pode ver estat\xedsticas! Se voc\xea deseja ver suas estat\xedsticas, alterar seu nome de usu\xe1rio e desbloquear skins especiais, registre-se!","register__delete_account_cta_less_aggressive":"Se voc\xea deseja salvar seus itens e estat\xedsticas para sempre e alterar seu nome de usu\xe1rio, registre-se!","register__email":"Digite seu endere\xe7o de e-mail","register__email_confirm":"Confirme o endere\xe7o de e-mail","register__email_placeholder":"Endere\xe7o de E-mail","register__email_placeholder_confirm":"Confirmar Endere\xe7o de E-mail","register__header":"Registrar","register__or":"Ou","register__password":"Digite uma senha","register__password_confirm":"Confirme sua senha","register__register":"Registrar","register__register_with_discord_btn":"Registrar com o Discord","register__register_with_google_btn":"Registrar com o Google","register__username":"Escolha um nome de usu\xe1rio","runprep__skin_not_unlocked_registered":"Apenas USU\xc1RIOS REGISTRADOS podem usar essa skin!","settings__back_to_main_menu_button":"Voltar","settings__enable_music":"Ativar M\xfasica","settings__enable_sfx":"Ativar Efeitos Sonoros","settings__language":"Idioma / LANGUAGE","settings__language_dropdown_english":"Ingl\xeas / English","settings__language_dropdown_portuguese":"Portugu\xeas / Portuguese","settings__language_dropdown_russian":"Russo / Russian / Русский","settings__language_dropdown_spanish":"Espanhol / Spanish / Espa\xf1ol","settings__matchmaking_region":"Regi\xe3o de Matchmaking","settings__matchmaking_region_dropdown_africa":"\xc1frica","settings__matchmaking_region_dropdown_any":"Qualquer Regi\xe3o (mais r\xe1pido)","settings__matchmaking_region_dropdown_asia":"\xc1sia","settings__matchmaking_region_dropdown_australia_oceania":"Austr\xe1lia/Oceania","settings__matchmaking_region_dropdown_eu":"Europa","settings__matchmaking_region_dropdown_middle_east":"Oriente M\xe9dio","settings__matchmaking_region_dropdown_na_east":"Am\xe9rica do Norte (Leste)","settings__matchmaking_region_dropdown_na_west":"Am\xe9rica do Norte (Oeste)","settings__matchmaking_region_dropdown_south_america":"Am\xe9rica do Sul","settings__save_button":"Salvar","settings__title":"Configura\xe7\xf5es","settings__settings_saved":"Configura\xe7\xf5es Salvas!","signin_sign_in":"Fazer login","signin_sign_in_with_discord_btn":"Entrar com o Discord","signin_sign_in_with_google_btn":"Entrar com o Google","item_type__weapon":"Arma","item_type__gear":"Equipamento","item_type__vendor":"Item para Vendedor","item_type__collector":"Item Especial","item_type__unknown":"Desconhecido","stat_type_arcane":"Arcano","stat_type_bleed":"Sangramento","stat_type_chaos":"Caos","stat_type_fire":"Fogo","stat_type_frost":"Gelo","stat_type_holy":"Divino","stat_type_lightning":"Rel\xe2mpago","stat_type_nature":"Natureza","stat_type_physical":"F\xedsico","stat_type_shadow":"Sombra","stat_type_toxic":"T\xf3xico","stats__back_btn":"Voltar","stats__boss_kills":"Derrotas de Chefes","stats__common_items_looted":"itens comuns saqueados","stats__distanced_travelled":"dist\xe2ncia percorrida","stats__epic_items_looted":"itens \xe9picos saqueados","stats__failed_runs":"corridas fracassadas","stats__global_rank":"classifica\xe7\xe3o global","stats__gold_looted":"ouro saqueado","stats__gold_lost_to_deaths":"ouro perdido para mortes","stats__header":"Estat\xedsticas","stats__items_looted":"itens saqueados","stats__items_lost_to_deaths":"itens perdidos para mortes","stats__legendary_items_looted":"itens lend\xe1rios saqueados","stats__npc_kills":"mortes de NPC","stats__player_kills":"mortes de jogadores","stats__rare_items_looted":"itens raros saqueados","stats__run_success_percentage":"percentual de sucesso das corridas","stats__runs":"corridas","stats__successful_runs":"corridas bem-sucedidas","stats__time_played":"tempo jogado","stats__uncommon_items_looted":"itens incomuns saqueados","toast__email_doesnt_match":"Os endere\xe7os de email n\xe3o correspondem!","toast__email_not_long_enough":"O endere\xe7o de email n\xe3o \xe9 longo o suficiente!","toast__gods_granted_you_items":"Os deuses concederam a voc\xea algum equipamento b\xe1sico!","toast__not_an_email_address":"Isso n\xe3o parece ser um endere\xe7o de email v\xe1lido!","toast__password_not_long_enough":"A senha n\xe3o \xe9 longa o suficiente!","toast__passwords_dont_match":"As senhas n\xe3o correspondem!","toast__username_changed":"Nome de usu\xe1rio alterado com sucesso!","toast__username_too_short":"Nome de usu\xe1rio muito curto!","vendors__back_to_main_menu_button":"Voltar","vendors__coming_soon":"Em Breve!","vendors__title":"Vendedores","event_feed__looted_a":"saqueou um","event_feed__in_the":"em","event_feed__at":"em","event_feed__killed":"matou","event_feed__boss":"boss","event_feed__is_extracting":"est\xe1 extraindo","event_feed__has_extracted":"extraiu com sucesso!","event_feed__has_spawned":"apareceu em","event_feed__under_attack":"est\xe1 sob ataque em"}');


const $4bbe42650164e1e5$export$e0b46b07fd1bee3a = {
    en: (0, (/*@__PURE__*/$parcel$interopDefault($28c2942e73cfea29$exports))),
    ru: (0, (/*@__PURE__*/$parcel$interopDefault($213f335c3e834aa0$exports))),
    es: (0, (/*@__PURE__*/$parcel$interopDefault($93d73e6cae807cfd$exports))),
    pt: (0, (/*@__PURE__*/$parcel$interopDefault($28eb7c6fa89c3759$exports)))
};
const $4bbe42650164e1e5$export$625550452a3fa3ec = (key)=>{
    let language;
    // @ts-ignore
    if (Lang === undefined) // @ts-ignore
    Lang = "en";
    // @ts-ignore
    if ($4bbe42650164e1e5$export$e0b46b07fd1bee3a[Lang]) // @ts-ignore
    language = Lang;
    else language = "en";
    let string;
    if ($4bbe42650164e1e5$export$e0b46b07fd1bee3a[language][key] || $4bbe42650164e1e5$export$e0b46b07fd1bee3a[language][key] === "") string = $4bbe42650164e1e5$export$e0b46b07fd1bee3a[language][key];
    else string = $4bbe42650164e1e5$export$e0b46b07fd1bee3a["en"][key];
    return string;
};
const $4bbe42650164e1e5$export$7c92b501c50b26dd = (key)=>{
    const language = "en";
    let string;
    if ($4bbe42650164e1e5$export$e0b46b07fd1bee3a[language][key] || $4bbe42650164e1e5$export$e0b46b07fd1bee3a[language][key] === "") string = $4bbe42650164e1e5$export$e0b46b07fd1bee3a[language][key];
    else string = "{{ MISSING TRANSLATION }}";
    return string;
};


var $faa1b3449016497b$export$1fc8f52ad1810e52;
(function(ItemType) {
    ItemType[ItemType["Weapon"] = 0] = "Weapon";
    ItemType[ItemType["ActiveGear"] = 1] = "ActiveGear";
    ItemType[ItemType["PassiveGear"] = 2] = "PassiveGear";
    ItemType[ItemType["VendorTrash"] = 3] = "VendorTrash";
    ItemType[ItemType["CollectorsItem"] = 4] = "CollectorsItem";
})($faa1b3449016497b$export$1fc8f52ad1810e52 || ($faa1b3449016497b$export$1fc8f52ad1810e52 = {}));
var $faa1b3449016497b$export$b8f9e8b7bac978d5;
(function(DamageType) {
    DamageType[DamageType["None"] = -1] = "None";
    DamageType[DamageType["Physical"] = 0] = "Physical";
    DamageType[DamageType["Fire"] = 1] = "Fire";
    DamageType[DamageType["Toxic"] = 2] = "Toxic";
    DamageType[DamageType["Arcane"] = 3] = "Arcane";
    DamageType[DamageType["Frost"] = 4] = "Frost";
    DamageType[DamageType["Lightning"] = 5] = "Lightning";
    DamageType[DamageType["Holy"] = 6] = "Holy";
    DamageType[DamageType["Shadow"] = 7] = "Shadow";
    DamageType[DamageType["Chaos"] = 8] = "Chaos";
    DamageType[DamageType["Nature"] = 9] = "Nature";
    DamageType[DamageType["Bleed"] = 10] = "Bleed";
})($faa1b3449016497b$export$b8f9e8b7bac978d5 || ($faa1b3449016497b$export$b8f9e8b7bac978d5 = {}));
const $faa1b3449016497b$export$2ba163ce473c71fd = (itemContainerMap)=>{
    return Object.values(itemContainerMap).reduce((acc, cur)=>acc + cur, 0);
};
const $faa1b3449016497b$export$3d208edac0e62a11 = (itemType)=>{
    switch(itemType){
        case $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon:
            return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_type__weapon");
        case $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear:
            return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_type__gear");
        case $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear:
            return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_type__gear");
        case $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash:
            return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_type__vendor");
        case $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem:
            return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_type__collector");
        default:
            return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_type__unknown");
    }
};
var $faa1b3449016497b$export$d2ffa9ea74cc769f;
(function(ItemRarity) {
    ItemRarity[ItemRarity["Common"] = 0] = "Common";
    ItemRarity[ItemRarity["Uncommon"] = 1] = "Uncommon";
    ItemRarity[ItemRarity["Rare"] = 2] = "Rare";
    ItemRarity[ItemRarity["Epic"] = 3] = "Epic";
    ItemRarity[ItemRarity["Legendary"] = 4] = "Legendary";
})($faa1b3449016497b$export$d2ffa9ea74cc769f || ($faa1b3449016497b$export$d2ffa9ea74cc769f = {}));
var $faa1b3449016497b$export$e352ec3d384e8c44;
(function(LootSources) {
    LootSources[LootSources["None"] = -1] = "None";
    LootSources[LootSources["Ghost"] = 0] = "Ghost";
    LootSources[LootSources["Skeleton"] = 1] = "Skeleton";
    LootSources[LootSources["Ogre"] = 2] = "Ogre";
    LootSources[LootSources["GiantRat"] = 3] = "GiantRat";
    LootSources[LootSources["Treant"] = 4] = "Treant";
    LootSources[LootSources["GRONK"] = 5] = "GRONK";
    LootSources[LootSources["AllLootChests"] = 6] = "AllLootChests";
    LootSources[LootSources["IronFox"] = 7] = "IronFox";
    LootSources[LootSources["DarkWizard"] = 8] = "DarkWizard";
    LootSources[LootSources["AllEnemies"] = 9] = "AllEnemies";
})($faa1b3449016497b$export$e352ec3d384e8c44 || ($faa1b3449016497b$export$e352ec3d384e8c44 = {}));
var $faa1b3449016497b$export$6d08773d2e66f8f2;
(function(Item) {
    Item[Item["None"] = -1] = "None";
    Item[Item[/*******************/ /*     Staves      */ /* IDs 0-99        */ /*******************/ "W_ApprenticesStaff"] = 0] = "W_ApprenticesStaff";
    Item[Item["W_FlamespitterStaff"] = 1] = "W_FlamespitterStaff";
    Item[Item["W_StaffOfTheSnake"] = 2] = "W_StaffOfTheSnake";
    Item[Item["W_ArchmagesSidekick"] = 3] = "W_ArchmagesSidekick";
    Item[Item["W_SamsStirringStick"] = 4] = "W_SamsStirringStick";
    Item[Item["W_CandlelightStaff"] = 5] = "W_CandlelightStaff";
    Item[Item["W_TwistedBranch"] = 6] = "W_TwistedBranch";
    Item[Item["W_IronStaff"] = 7] = "W_IronStaff";
    Item[Item["W_PharaohsStaff"] = 8] = "W_PharaohsStaff";
    Item[Item["W_FairyStaff"] = 9] = "W_FairyStaff";
    Item[Item["W_MidasStaff"] = 10] = "W_MidasStaff";
    Item[Item["W_DemonsEye"] = 11] = "W_DemonsEye";
    Item[Item["W_SlimeStaff"] = 12] = "W_SlimeStaff";
    Item[Item["W_BeesOnAStick"] = 13] = "W_BeesOnAStick";
    Item[Item["W_LichsStaff"] = 14] = "W_LichsStaff";
    Item[Item["W_FrostFlicker"] = 15] = "W_FrostFlicker";
    Item[Item[/**********************/ /*     Crossbows      */ /* IDs 100-199        */ /**********************/ "W_CrudeCrossbow"] = 100] = "W_CrudeCrossbow";
    Item[Item["W_GuardsCrossbow"] = 101] = "W_GuardsCrossbow";
    Item[Item["W_SteelCrossbow"] = 102] = "W_SteelCrossbow";
    Item[Item["W_ReliqueryCrossbow"] = 103] = "W_ReliqueryCrossbow";
    Item[Item["W_EldritchBlasters"] = 104] = "W_EldritchBlasters";
    Item[Item["W_DarylsInstinct"] = 105] = "W_DarylsInstinct";
    Item[Item["W_FathersBane"] = 106] = "W_FathersBane";
    Item[Item["W_WitchHuntersRepeaters"] = 107] = "W_WitchHuntersRepeaters";
    Item[Item["W_WyvernsTalon"] = 108] = "W_WyvernsTalon";
    Item[Item["W_TheCrossBow"] = 109] = "W_TheCrossBow";
    Item[Item[/**********************/ /*       Bows         */ /* IDs 200-299        */ /**********************/ "W_RangersGuillotine"] = 200] = "W_RangersGuillotine";
    Item[Item["W_DavidBowie"] = 201] = "W_DavidBowie";
    Item[Item["W_Emberstrike"] = 202] = "W_Emberstrike";
    Item[Item["W_MoonShadow"] = 203] = "W_MoonShadow";
    Item[Item["W_FairyBow"] = 204] = "W_FairyBow";
    Item[Item["W_Bloodrider"] = 205] = "W_Bloodrider";
    Item[Item["W_PhoenixWing"] = 206] = "W_PhoenixWing";
    Item[Item["W_DivineWind"] = 207] = "W_DivineWind";
    Item[Item["W_StarShot"] = 208] = "W_StarShot";
    Item[Item["W_CelestialBow"] = 209] = "W_CelestialBow";
    Item[Item["W_ReapersEmbrace"] = 210] = "W_ReapersEmbrace";
    Item[Item["W_QuincyBow"] = 211] = "W_QuincyBow";
    Item[Item["W_SilentShadow"] = 212] = "W_SilentShadow";
    Item[Item[/**********************/ /*    Wands           */ /* IDs 300-399        */ /**********************/ "W_Stick"] = 300] = "W_Stick";
    Item[Item["W_SpiraledWand"] = 301] = "W_SpiraledWand";
    Item[Item["W_NightStick"] = 302] = "W_NightStick";
    Item[Item["W_DragonsBreath"] = 303] = "W_DragonsBreath";
    Item[Item["W_PoseidonsWand"] = 304] = "W_PoseidonsWand";
    Item[Item["W_BrokenDeathstick"] = 305] = "W_BrokenDeathstick";
    Item[Item["W_HibidyKibity"] = 306] = "W_HibidyKibity";
    Item[Item["W_MagicalWand"] = 307] = "W_MagicalWand";
    Item[Item["W_BlackDahliaWand"] = 308] = "W_BlackDahliaWand";
    Item[Item["W_FrostedTips"] = 309] = "W_FrostedTips";
    Item[Item["W_RelicWand"] = 310] = "W_RelicWand";
    Item[Item["W_ZappingWand"] = 311] = "W_ZappingWand";
    Item[Item["W_IcewindWand"] = 312] = "W_IcewindWand";
    Item[Item["W_BlazeRod"] = 313] = "W_BlazeRod";
    Item[Item["W_ToxicWand"] = 314] = "W_ToxicWand";
    Item[Item["W_StarWand"] = 315] = "W_StarWand";
    Item[Item["W_Deathstick"] = 316] = "W_Deathstick";
    Item[Item[/**********************/ /*     Spellbooks     */ /* IDs 400-499        */ /**********************/ "W_SpellbindersTome"] = 400] = "W_SpellbindersTome";
    Item[Item["W_Triforce"] = 401] = "W_Triforce";
    Item[Item["W_WizardsLedger"] = 402] = "W_WizardsLedger";
    Item[Item["W_NaturesReturn"] = 403] = "W_NaturesReturn";
    Item[Item["W_KingBible"] = 404] = "W_KingBible";
    Item[Item["W_BookOfTongues"] = 405] = "W_BookOfTongues";
    Item[Item[/*******************/ /*  Passive Gear   */ /* IDs 1000-1999   */ /*******************/ "PG_SerpentsRing"] = 1000] = "PG_SerpentsRing";
    Item[Item["PG_WindspeakersRing"] = 1001] = "PG_WindspeakersRing";
    Item[Item["PG_IronFoxLocket"] = 1002] = "PG_IronFoxLocket";
    Item[Item["PG_HeirloomCloak"] = 1003] = "PG_HeirloomCloak";
    Item[Item["PG_ElvenGildedGuardian"] = 1004] = "PG_ElvenGildedGuardian";
    Item[Item["PG_FrostFireRing"] = 1005] = "PG_FrostFireRing";
    Item[Item["PG_GirdleOfTheGoldenNecromancer"] = 1006] = "PG_GirdleOfTheGoldenNecromancer";
    Item[Item["PG_RingOfConstellations"] = 1007] = "PG_RingOfConstellations";
    Item[Item["PG_TantrumsLuckyLoop"] = 1008] = "PG_TantrumsLuckyLoop";
    Item[Item["PG_GoldPlatedCape"] = 1009] = "PG_GoldPlatedCape";
    Item[Item["PG_AssassinSignet"] = 1010] = "PG_AssassinSignet";
    Item[Item["PG_CopperWristband"] = 1011] = "PG_CopperWristband";
    Item[Item["PG_GolemsGrasp"] = 1012] = "PG_GolemsGrasp";
    Item[Item["PG_ShieldbearersAmulet"] = 1013] = "PG_ShieldbearersAmulet";
    Item[Item["PG_MementoMoriLocket"] = 1014] = "PG_MementoMoriLocket";
    Item[Item["PG_GuardiansChainmailCollar"] = 1015] = "PG_GuardiansChainmailCollar";
    Item[Item["PG_NaturesAureateBarrier"] = 1016] = "PG_NaturesAureateBarrier";
    Item[Item["PG_QuintsFishingGarb"] = 1017] = "PG_QuintsFishingGarb";
    Item[Item["PG_GineshsBottleOpener"] = 1018] = "PG_GineshsBottleOpener";
    Item[Item["PG_AngelistasPotionPopper"] = 1019] = "PG_AngelistasPotionPopper";
    Item[Item["PG_MunchkinsRing"] = 1020] = "PG_MunchkinsRing";
    Item[Item["PG_CloakOfModestApproachability"] = 1021] = "PG_CloakOfModestApproachability";
    Item[Item["PG_SummonersSign"] = 1022] = "PG_SummonersSign";
    Item[Item["PG_CoralReef"] = 1023] = "PG_CoralReef";
    Item[Item["PG_IceQueensEarrings"] = 1024] = "PG_IceQueensEarrings";
    Item[Item["PG_RingOfTheOneHandedWarrior"] = 1025] = "PG_RingOfTheOneHandedWarrior";
    Item[Item["PG_CompactedLimeGreenRing"] = 1026] = "PG_CompactedLimeGreenRing";
    Item[Item["PG_LittleCompactedLimeGreenRing"] = 1027] = "PG_LittleCompactedLimeGreenRing";
    Item[Item["PG_InfiniteLoop"] = 1028] = "PG_InfiniteLoop";
    Item[Item["PG_JaysesRing"] = 1029] = "PG_JaysesRing";
    Item[Item["PG_BellsShiningRing"] = 1030] = "PG_BellsShiningRing";
    Item[Item["PG_RingOfViolentViolet"] = 1031] = "PG_RingOfViolentViolet";
    Item[Item["PG_CloudedDarkness"] = 1032] = "PG_CloudedDarkness";
    Item[Item["PG_CapeOfPureDarkness"] = 1033] = "PG_CapeOfPureDarkness";
    Item[Item["PG_BloodGemRing"] = 1034] = "PG_BloodGemRing";
    Item[Item["PG_PurpletratorsRing"] = 1035] = "PG_PurpletratorsRing";
    Item[Item["PG_AquamoorsBlessing"] = 1036] = "PG_AquamoorsBlessing";
    Item[Item["PG_EssenceConduit"] = 1037] = "PG_EssenceConduit";
    Item[Item["PG_ArcaneEmber"] = 1038] = "PG_ArcaneEmber";
    Item[Item["PG_PhoenixsRespite"] = 1039] = "PG_PhoenixsRespite";
    Item[Item["PG_SoulBindingRing"] = 1040] = "PG_SoulBindingRing";
    Item[Item["PG_BloodiedVitality"] = 1041] = "PG_BloodiedVitality";
    Item[Item["PG_VenomousBite"] = 1042] = "PG_VenomousBite";
    Item[Item["PG_RuneboundRing"] = 1043] = "PG_RuneboundRing";
    Item[Item["PG_FrostbiteLoop"] = 1044] = "PG_FrostbiteLoop";
    Item[Item["PG_PhantomBand"] = 1045] = "PG_PhantomBand";
    Item[Item["PG_EmbergraspRing"] = 1046] = "PG_EmbergraspRing";
    Item[Item["PG_SoulshackleVeil"] = 1047] = "PG_SoulshackleVeil";
    Item[Item["PG_StormweaverCloak"] = 1048] = "PG_StormweaverCloak";
    Item[Item["PG_CursedSignet"] = 1049] = "PG_CursedSignet";
    Item[Item["PG_EnigmaLoop"] = 1050] = "PG_EnigmaLoop";
    Item[Item["PG_VampiricSeal"] = 1051] = "PG_VampiricSeal";
    Item[Item["PG_Wraithband"] = 1052] = "PG_Wraithband";
    Item[Item["PG_NecroticSignet"] = 1053] = "PG_NecroticSignet";
    Item[Item["PG_CorruptedTearRing"] = 1054] = "PG_CorruptedTearRing";
    Item[Item["PG_DeathwhisperWrap"] = 1055] = "PG_DeathwhisperWrap";
    Item[Item["PG_VeilstormCirclet"] = 1056] = "PG_VeilstormCirclet";
    Item[Item["PG_SoulforgeRing"] = 1057] = "PG_SoulforgeRing";
    Item[Item["PG_CursedEternityRing"] = 1058] = "PG_CursedEternityRing";
    Item[Item["PG_MidnightsVeilBand"] = 1059] = "PG_MidnightsVeilBand";
    Item[Item["PG_DreadmorneLoop"] = 1060] = "PG_DreadmorneLoop";
    Item[Item["PG_EbonfireRobelet"] = 1061] = "PG_EbonfireRobelet";
    Item[Item["PG_EverlastingSpiritCircle"] = 1062] = "PG_EverlastingSpiritCircle";
    Item[Item["PG_EnigmaticShadowweaveRing"] = 1063] = "PG_EnigmaticShadowweaveRing";
    Item[Item["PG_BloodmoonLoop"] = 1064] = "PG_BloodmoonLoop";
    Item[Item["PG_DreamcasterDrapery"] = 1065] = "PG_DreamcasterDrapery";
    Item[Item["PG_CelestialSolaceBand"] = 1066] = "PG_CelestialSolaceBand";
    Item[Item["PG_TalismanOfVeiledShadows"] = 1067] = "PG_TalismanOfVeiledShadows";
    Item[Item["PG_PendantOfAncientWisdom"] = 1068] = "PG_PendantOfAncientWisdom";
    Item[Item["PG_SerpentsCoilChoker"] = 1069] = "PG_SerpentsCoilChoker";
    Item[Item["PG_ArcaneSigilCollar"] = 1070] = "PG_ArcaneSigilCollar";
    Item[Item["PG_ResilientHeartstone"] = 1071] = "PG_ResilientHeartstone";
    Item[Item["PG_FrostfireShardPendant"] = 1072] = "PG_FrostfireShardPendant";
    Item[Item["PG_PhoenixFeatherTorque"] = 1073] = "PG_PhoenixFeatherTorque";
    Item[Item["PG_SoulstoneReliquary"] = 1074] = "PG_SoulstoneReliquary";
    Item[Item["PG_EnchantedElixirNecklace"] = 1075] = "PG_EnchantedElixirNecklace";
    Item[Item["PG_NecroticGraspTalisman"] = 1076] = "PG_NecroticGraspTalisman";
    Item[Item["PG_CelestialStarfallPendant"] = 1077] = "PG_CelestialStarfallPendant";
    Item[Item["PG_CultistsMask"] = 1078] = "PG_CultistsMask";
    Item[Item["PG_DepthStrider"] = 1079] = "PG_DepthStrider";
    Item[Item["PG_GoldenGauntlets"] = 1080] = "PG_GoldenGauntlets";
    Item[Item["PG_BeastVanquisherBoots"] = 1081] = "PG_BeastVanquisherBoots";
    Item[Item[// PG_SamsTestItem = 1999,
    /*******************/ /*  Active Gear   */ /* IDs 2000-2999   */ /*******************/ "AG_VestiasSoothingSignet"] = 2000] = "AG_VestiasSoothingSignet";
    Item[Item["AG_ViolasDinnerReminder"] = 2001] = "AG_ViolasDinnerReminder";
    Item[Item["AG_WolfMedallion"] = 2002] = "AG_WolfMedallion";
    Item[Item["AG_PepperedCollar"] = 2003] = "AG_PepperedCollar";
    Item[Item["AG_StuddedNecklace"] = 2004] = "AG_StuddedNecklace";
    Item[Item["AG_TimeHerosRing"] = 2005] = "AG_TimeHerosRing";
    Item[Item["AG_TheDarkLordsEmbrace"] = 2006] = "AG_TheDarkLordsEmbrace";
    Item[Item["AG_Boros"] = 2007] = "AG_Boros";
    Item[Item["AG_MysteriousRing"] = 2008] = "AG_MysteriousRing";
    Item[Item["AG_DarkPustulesRing"] = 2009] = "AG_DarkPustulesRing";
    Item[Item["AG_RingOfAnOceanMan"] = 2010] = "AG_RingOfAnOceanMan";
    Item[Item["AG_ForestsHaven"] = 2011] = "AG_ForestsHaven";
    Item[Item["AG_DreamWeaversEmbrace"] = 2012] = "AG_DreamWeaversEmbrace";
    Item[Item["AG_ObsidianEcho"] = 2013] = "AG_ObsidianEcho";
    Item[Item["AG_AmuletOfCursedFate"] = 2014] = "AG_AmuletOfCursedFate";
    Item[Item["AG_MagicBoots"] = 2015] = "AG_MagicBoots";
    Item[Item[/*******************/ /*  Vendor Trash   */ /* IDs 3000-3999   */ /*******************/ "VT_OnyxGem"] = 3000] = "VT_OnyxGem";
    Item[Item["VT_GhostPlasma"] = 3001] = "VT_GhostPlasma";
    Item[Item["VT_GoblinCloth"] = 3002] = "VT_GoblinCloth";
    Item[Item["VT_WellWornRing"] = 3003] = "VT_WellWornRing";
    Item[Item["VT_RingOfNearPerfection"] = 3004] = "VT_RingOfNearPerfection";
    Item[Item["VT_CubicZirconia"] = 3005] = "VT_CubicZirconia";
    Item[Item["VT_QuartzRing"] = 3006] = "VT_QuartzRing";
    Item[Item["VT_DukesDiary"] = 3007] = "VT_DukesDiary";
    Item[Item["VT_Potato"] = 3008] = "VT_Potato";
    Item[Item["VT_Fossil"] = 3009] = "VT_Fossil";
    Item[Item["VT_Sapphire"] = 3010] = "VT_Sapphire";
    Item[Item["VT_AbyssalShard"] = 3011] = "VT_AbyssalShard";
    Item[Item["VT_RedMushroom"] = 3013] = "VT_RedMushroom";
    Item[Item["VT_SkeletonFemur"] = 3012] = "VT_SkeletonFemur";
    Item[Item["VT_BardsDiary"] = 3014] = "VT_BardsDiary";
    Item[Item["VT_EverlastingCandle"] = 3015] = "VT_EverlastingCandle";
    Item[Item["VT_Diamond"] = 3016] = "VT_Diamond";
    Item[Item["VT_WhispersOfTheVoid"] = 3017] = "VT_WhispersOfTheVoid";
    Item[Item["VT_EmeraldDust"] = 3018] = "VT_EmeraldDust";
    Item[Item["VT_RubyDust"] = 3019] = "VT_RubyDust";
    Item[Item["VT_StellarWeaveRing"] = 3020] = "VT_StellarWeaveRing";
    Item[Item["VT_Eyeball"] = 3021] = "VT_Eyeball";
    Item[Item["VT_TreantBranch"] = 3022] = "VT_TreantBranch";
    Item[Item["VT_SapphireDust"] = 3023] = "VT_SapphireDust";
    Item[Item["VT_PileOfAsh"] = 3024] = "VT_PileOfAsh";
    Item[Item["VT_Amber"] = 3025] = "VT_Amber";
    Item[Item["VT_Skull"] = 3026] = "VT_Skull";
    Item[Item["VT_GoldNugget"] = 3027] = "VT_GoldNugget";
    Item[Item["VT_BrokenSword"] = 3028] = "VT_BrokenSword";
    Item[Item["VT_Cabbage"] = 3029] = "VT_Cabbage";
    Item[Item["VT_BrokenIronBand"] = 3030] = "VT_BrokenIronBand";
    Item[Item["VT_RatFur"] = 3031] = "VT_RatFur";
    Item[Item["VT_Ruby"] = 3032] = "VT_Ruby";
    Item[Item["VT_ChunkOfIron"] = 3033] = "VT_ChunkOfIron";
    Item[Item["VT_FangOfTheBloodMoon"] = 3034] = "VT_FangOfTheBloodMoon";
    Item[Item["VT_OgreEntrails"] = 3035] = "VT_OgreEntrails";
    Item[Item["VT_Emerald"] = 3036] = "VT_Emerald";
    Item[Item[/*********************/ /*  Collectors Items */ /* IDs 4000-4999     */ /*********************/ "CI_FragmentOfFate"] = 4000] = "CI_FragmentOfFate";
    Item[Item["CI_PlayerSoulFragment"] = 4001] = "CI_PlayerSoulFragment";
    Item[Item["CI_LatrosKnavishBand"] = 4002] = "CI_LatrosKnavishBand";
    Item[Item["CI_WeddingRing"] = 4003] = "CI_WeddingRing";
    Item[Item["CI_PeachRing"] = 4004] = "CI_PeachRing";
    Item[Item["CI_RingOfDelerium"] = 4005] = "CI_RingOfDelerium";
    Item[Item["CI_LifesSimpleRing"] = 4006] = "CI_LifesSimpleRing";
    Item[Item["CI_SwampOgresRing"] = 4007] = "CI_SwampOgresRing";
    Item[Item["CI_RoyalBrooch"] = 4008] = "CI_RoyalBrooch";
    Item[Item["CI_SuperStar"] = 4009] = "CI_SuperStar";
    Item[Item["CI_Ouro"] = 4010] = "CI_Ouro";
    Item[Item["CI_AlloyedBend"] = 4011] = "CI_AlloyedBend";
    Item[Item["CI_ProudlyPinkRing"] = 4012] = "CI_ProudlyPinkRing";
    Item[Item["CI_ApposSignet"] = 4013] = "CI_ApposSignet";
    Item[Item["CI_CelestialEternity"] = 4014] = "CI_CelestialEternity";
    Item[Item["CI_BloodhuntersRing"] = 4015] = "CI_BloodhuntersRing";
    Item[Item["CI_EbonstarBand"] = 4016] = "CI_EbonstarBand";
    Item[Item["CI_LuminousEnigma"] = 4017] = "CI_LuminousEnigma";
    Item[Item["CI_RadiantSunstoneBand"] = 4018] = "CI_RadiantSunstoneBand";
    Item[Item["CI_EchoingWhisperNecklace"] = 4019] = "CI_EchoingWhisperNecklace";
    Item[Item["CI_FeyEnchantmentLocket"] = 4020] = "CI_FeyEnchantmentLocket";
})($faa1b3449016497b$export$6d08773d2e66f8f2 || ($faa1b3449016497b$export$6d08773d2e66f8f2 = {}));
const $faa1b3449016497b$export$59e95ec639a00e0 = ()=>{
    return Object.values($faa1b3449016497b$export$6d08773d2e66f8f2).filter((0, $f1q41.isNumber)).filter((v)=>v !== -1);
};
const $faa1b3449016497b$export$c23e01eb11268785 = (defaultItemQuantities = 0)=>{
    return {
        [$faa1b3449016497b$export$6d08773d2e66f8f2.None]: 0,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_ApprenticesStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_FlamespitterStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_StaffOfTheSnake]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_ArchmagesSidekick]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_SamsStirringStick]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_CandlelightStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_TwistedBranch]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_IronStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_PharaohsStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_FairyStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_MidasStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_DemonsEye]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_SlimeStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_BeesOnAStick]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_LichsStaff]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_FrostFlicker]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_CrudeCrossbow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_GuardsCrossbow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_SteelCrossbow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_ReliqueryCrossbow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_EldritchBlasters]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_DarylsInstinct]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_FathersBane]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_WitchHuntersRepeaters]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_WyvernsTalon]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_TheCrossBow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_RangersGuillotine]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_DavidBowie]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_Emberstrike]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_MoonShadow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_FairyBow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_Bloodrider]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_PhoenixWing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_DivineWind]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_StarShot]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_CelestialBow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_ReapersEmbrace]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_QuincyBow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_SilentShadow]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_Stick]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_SpiraledWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_NightStick]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_DragonsBreath]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_PoseidonsWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_BrokenDeathstick]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_HibidyKibity]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_MagicalWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_BlackDahliaWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_FrostedTips]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_RelicWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_ZappingWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_IcewindWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_BlazeRod]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_ToxicWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_StarWand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_Deathstick]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_SpellbindersTome]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_Triforce]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_WizardsLedger]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_NaturesReturn]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_KingBible]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.W_BookOfTongues]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_SerpentsRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_WindspeakersRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_IronFoxLocket]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_HeirloomCloak]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_ElvenGildedGuardian]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_FrostFireRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_GirdleOfTheGoldenNecromancer]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_RingOfConstellations]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_TantrumsLuckyLoop]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_GoldPlatedCape]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_AssassinSignet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CopperWristband]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_GolemsGrasp]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_ShieldbearersAmulet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_MementoMoriLocket]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_GuardiansChainmailCollar]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_NaturesAureateBarrier]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_QuintsFishingGarb]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_GineshsBottleOpener]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_AngelistasPotionPopper]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_MunchkinsRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CloakOfModestApproachability]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_SummonersSign]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CoralReef]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_IceQueensEarrings]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_RingOfTheOneHandedWarrior]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CompactedLimeGreenRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_LittleCompactedLimeGreenRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_InfiniteLoop]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_JaysesRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_BellsShiningRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_RingOfViolentViolet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CloudedDarkness]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CapeOfPureDarkness]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_BloodGemRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_PurpletratorsRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_AquamoorsBlessing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_EssenceConduit]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_ArcaneEmber]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_PhoenixsRespite]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulBindingRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_BloodiedVitality]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_VenomousBite]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_RuneboundRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_FrostbiteLoop]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_PhantomBand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_EmbergraspRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulshackleVeil]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_StormweaverCloak]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CursedSignet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_EnigmaLoop]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_VampiricSeal]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_Wraithband]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_NecroticSignet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CorruptedTearRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_DeathwhisperWrap]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_VeilstormCirclet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulforgeRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CursedEternityRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_MidnightsVeilBand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_DreadmorneLoop]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_EbonfireRobelet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_EverlastingSpiritCircle]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_EnigmaticShadowweaveRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_BloodmoonLoop]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_DreamcasterDrapery]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CelestialSolaceBand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_TalismanOfVeiledShadows]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_PendantOfAncientWisdom]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_SerpentsCoilChoker]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_ArcaneSigilCollar]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_ResilientHeartstone]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_FrostfireShardPendant]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_PhoenixFeatherTorque]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulstoneReliquary]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_EnchantedElixirNecklace]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_NecroticGraspTalisman]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CelestialStarfallPendant]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_CultistsMask]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_DepthStrider]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_GoldenGauntlets]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.PG_BeastVanquisherBoots]: defaultItemQuantities,
        // [Item.PG_SamsTestItem]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_VestiasSoothingSignet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_ViolasDinnerReminder]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_WolfMedallion]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_PepperedCollar]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_StuddedNecklace]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_TimeHerosRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_TheDarkLordsEmbrace]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_Boros]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_MysteriousRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_DarkPustulesRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_RingOfAnOceanMan]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_ForestsHaven]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_DreamWeaversEmbrace]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_ObsidianEcho]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_AmuletOfCursedFate]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.AG_MagicBoots]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_OnyxGem]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_GhostPlasma]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_GoblinCloth]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_WellWornRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_RingOfNearPerfection]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_CubicZirconia]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_QuartzRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_DukesDiary]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Potato]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_SkeletonFemur]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_RedMushroom]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_AbyssalShard]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Sapphire]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Fossil]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_BardsDiary]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_EverlastingCandle]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Diamond]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_WhispersOfTheVoid]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_EmeraldDust]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_RubyDust]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_StellarWeaveRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Eyeball]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_TreantBranch]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_SapphireDust]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_PileOfAsh]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Amber]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Skull]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_GoldNugget]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_BrokenSword]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_BrokenIronBand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_RatFur]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Ruby]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_ChunkOfIron]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_FangOfTheBloodMoon]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_OgreEntrails]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Emerald]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.VT_Cabbage]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_FragmentOfFate]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_PlayerSoulFragment]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_LatrosKnavishBand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_WeddingRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_PeachRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_RingOfDelerium]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_LifesSimpleRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_SwampOgresRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_RoyalBrooch]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_SuperStar]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_Ouro]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_AlloyedBend]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_ProudlyPinkRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_ApposSignet]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_CelestialEternity]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_BloodhuntersRing]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_EbonstarBand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_LuminousEnigma]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_RadiantSunstoneBand]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_EchoingWhisperNecklace]: defaultItemQuantities,
        [$faa1b3449016497b$export$6d08773d2e66f8f2.CI_FeyEnchantmentLocket]: defaultItemQuantities
    };
};
const $faa1b3449016497b$export$86ba917eb87cda3c = ()=>{
    return $faa1b3449016497b$export$59e95ec639a00e0().filter((itemId)=>$faa1b3449016497b$export$dc0c4ec5c1198760(itemId).itemType === $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon).length;
};
const $faa1b3449016497b$export$6978f0e6036e3b20 = ()=>{
    return $faa1b3449016497b$export$59e95ec639a00e0().filter((itemId)=>$faa1b3449016497b$export$dc0c4ec5c1198760(itemId).itemType === $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear || $faa1b3449016497b$export$dc0c4ec5c1198760(itemId).itemType === $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear).length;
};
const $faa1b3449016497b$export$ca5102cbd15a68f5 = ()=>{
    return $faa1b3449016497b$export$59e95ec639a00e0().filter((itemId)=>$faa1b3449016497b$export$dc0c4ec5c1198760(itemId).itemType === $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash).length;
};
const $faa1b3449016497b$export$a03459053fefb51d = ()=>{
    return $faa1b3449016497b$export$59e95ec639a00e0().filter((itemId)=>$faa1b3449016497b$export$dc0c4ec5c1198760(itemId).itemType === $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem).length;
};
const $faa1b3449016497b$var$ItemData = new Map();
const $faa1b3449016497b$var$setItemData = (itemConfig)=>{
    const existingEntryWithId = $faa1b3449016497b$var$ItemData.get(itemConfig.itemId);
    if (existingEntryWithId) throw new Error(`ItemConfig with id ${itemConfig.itemId} already exists! Error in Item data file.`);
    $faa1b3449016497b$var$ItemData.set(itemConfig.itemId, itemConfig);
};
const $faa1b3449016497b$export$dc0c4ec5c1198760 = (id)=>{
    const ItemConfig = $faa1b3449016497b$var$ItemData.get(id);
    if (!ItemConfig) throw new Error(`ItemConfig with id ${id} does not exist! Error in Item data file.`);
    return ItemConfig;
};
var $faa1b3449016497b$export$6df8f823269939c6;
(function(PassiveStatType) {
    PassiveStatType[PassiveStatType["Defence"] = 0] = "Defence";
    PassiveStatType[PassiveStatType["DamageBoost"] = 1] = "DamageBoost";
})($faa1b3449016497b$export$6df8f823269939c6 || ($faa1b3449016497b$export$6df8f823269939c6 = {}));
const $faa1b3449016497b$export$797b6866e8905776 = (queriedStatType, queriedDamageType, items, returnAsFriendlyPercentageString = false)=>{
    let statResult = 0.0;
    // console.log({ queriedStatType, queriedDamageType });
    for(let i = 0; i < items.length; i++){
        if (items[i] === -1) continue;
        const itemConfig = $faa1b3449016497b$export$dc0c4ec5c1198760(items[i]);
        const { passiveStats: passiveStats  } = itemConfig;
        for(let j = 0; j < passiveStats.length; j++){
            const { passiveStatType: passiveStatType , damageType: damageType , statAmount: statAmount  } = passiveStats[j];
            if (damageType === queriedDamageType && passiveStatType === queriedStatType) statResult += statAmount;
        }
    }
    if (returnAsFriendlyPercentageString) return `${statResult > 0 ? "+" : statResult < 0 ? "-" : ""}${Math.floor(statResult * 100)}%`;
    else return statResult;
};
var $faa1b3449016497b$export$f81ad329d1573de4;
(function(PassiveAbility) {
    PassiveAbility[PassiveAbility["MoveSpeedUp"] = 0] = "MoveSpeedUp";
    PassiveAbility[PassiveAbility["MoveSpeedDown"] = 1] = "MoveSpeedDown";
    PassiveAbility[PassiveAbility["GainHealthOverTime"] = 2] = "GainHealthOverTime";
    PassiveAbility[PassiveAbility["LoseHealthOverTime"] = 3] = "LoseHealthOverTime";
    PassiveAbility[PassiveAbility["ProjectileDistanceUp"] = 5] = "ProjectileDistanceUp";
    PassiveAbility[PassiveAbility["ProjectileDistanceDown"] = 6] = "ProjectileDistanceDown";
    PassiveAbility[PassiveAbility["MaxHealthIncrease"] = 7] = "MaxHealthIncrease";
    PassiveAbility[PassiveAbility["MaxHealthDecrease"] = 8] = "MaxHealthDecrease";
    PassiveAbility[PassiveAbility["GoldRush"] = 9] = "GoldRush";
    PassiveAbility[PassiveAbility["PlayerDamageLeech"] = 10] = "PlayerDamageLeech";
    PassiveAbility[PassiveAbility[// WeaponCooldownReset = 11, // TODO LATER
    "WaterWalking"] = 12] = "WaterWalking";
    PassiveAbility[PassiveAbility[// CorpseExplosion = 13, // TODO LATER
    "Ethereal"] = 14] = "Ethereal";
    PassiveAbility[PassiveAbility["Revive"] = 15] = "Revive";
    PassiveAbility[PassiveAbility["AttackSpeedUp"] = 16] = "AttackSpeedUp";
    PassiveAbility[PassiveAbility["AttackSpeedDown"] = 17] = "AttackSpeedDown";
    PassiveAbility[PassiveAbility["Information"] = 18] = "Information";
    PassiveAbility[PassiveAbility["ExtractionProtection"] = 19] = "ExtractionProtection";
    PassiveAbility[PassiveAbility[// ScavMode = 20, // TODO LATER
    "ExtractionSpeedUp"] = 21] = "ExtractionSpeedUp";
    PassiveAbility[PassiveAbility[// SmolMode = 22, // TODO LATER
    // BigMode = 23, // TODO LATER
    "PlayerDamageUp"] = 24] = "PlayerDamageUp";
    PassiveAbility[PassiveAbility["PlayerDamageDown"] = 25] = "PlayerDamageDown";
    PassiveAbility[PassiveAbility["NPCDamageUp"] = 26] = "NPCDamageUp";
    PassiveAbility[PassiveAbility["NPCDamageDown"] = 27] = "NPCDamageDown";
    PassiveAbility[PassiveAbility["Incognito"] = 28] = "Incognito";
})($faa1b3449016497b$export$f81ad329d1573de4 || ($faa1b3449016497b$export$f81ad329d1573de4 = {}));
var $faa1b3449016497b$export$259a6f5d817ae02e;
(function(ActiveAbility) {
    ActiveAbility[ActiveAbility["None"] = 0] = "None";
    ActiveAbility[ActiveAbility[// Relocation = 1, // TODO LATER
    "Invisibility"] = 2] = "Invisibility";
    ActiveAbility[ActiveAbility[// ZoomOut = 3, // TODO LATER
    // DamageReduction = 4, // TODO LATER
    // DamageBoost = 5, // TODO LATER
    // ProjectilePierce = 6, // TODO LATER
    "TimerExtender"] = 7] = "TimerExtender";
    ActiveAbility[ActiveAbility["Suicide"] = 8] = "Suicide";
    ActiveAbility[ActiveAbility[// Random = 9, // TODO LATER
    "Heal"] = 10] = "Heal";
    ActiveAbility[ActiveAbility["Dash"] = 11] = "Dash";
    ActiveAbility[ActiveAbility["Extract"] = 12] = "Extract";
})($faa1b3449016497b$export$259a6f5d817ae02e || ($faa1b3449016497b$export$259a6f5d817ae02e = {}));
const $faa1b3449016497b$var$NoneActiveAbility = {
    ability: $faa1b3449016497b$export$259a6f5d817ae02e.None,
    abilityParameter: 0,
    abilityCharges: -1,
    abilityCooldownInSeconds: 0,
    abilityDurationInSeconds: 0
};
const $faa1b3449016497b$export$65f9a86fc3e52a6a = (items)=>{
    let statResult = 0;
    // console.log({ queriedStatType, queriedDamageType });
    for(let i = 0; i < items.length; i++){
        if (items[i] === -1) continue;
        const itemConfig = $faa1b3449016497b$export$dc0c4ec5c1198760(items[i]);
        const { passiveAbilities: passiveAbilities  } = itemConfig;
        for(let j = 0; j < passiveAbilities.length; j++){
            const { passiveAbility: passiveAbility , abilityParameter: abilityParameter  } = passiveAbilities[j];
            if (passiveAbility === $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease) statResult -= abilityParameter;
            if (passiveAbility === $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease) statResult += abilityParameter;
        }
    }
    return statResult;
};
//#endregion
//#region Item Rolling
/****************************************************/ /*                                                  */ /*               Item Rolling                       */ /*                                                  */ /****************************************************/ // How rare is it to get an item of a particular quality?
const $faa1b3449016497b$var$commonRarity = 1;
const $faa1b3449016497b$var$uncommonRarity = 0.2;
const $faa1b3449016497b$var$rareRarity = 0.04;
const $faa1b3449016497b$var$epicRarity = 1 / 115;
const $faa1b3449016497b$var$legendaryRarity = 1 / 325;
const $faa1b3449016497b$export$a217d44792dfbdcb = [
    {
        rarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
        threshold: 1 - $faa1b3449016497b$var$commonRarity
    },
    {
        rarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
        threshold: 1 - $faa1b3449016497b$var$uncommonRarity
    },
    {
        rarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
        threshold: 1 - $faa1b3449016497b$var$rareRarity
    },
    {
        rarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
        threshold: 1 - $faa1b3449016497b$var$epicRarity
    },
    {
        rarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
        threshold: 1 - $faa1b3449016497b$var$legendaryRarity
    }
];
// How many items should you get based on a roll? i.e. how rare should it be to roll 10 items vs 1 item and everywhere in between
const $faa1b3449016497b$var$chanceOfOneItemInChest = 1;
const $faa1b3449016497b$var$chanceOfTwoItemsInChest = 1 / 3;
const $faa1b3449016497b$var$chanceOfThreeItemsInChest = 1 / 4;
const $faa1b3449016497b$var$chanceOfFourItemsInChest = 1 / 6;
const $faa1b3449016497b$var$chanceOfFiveItemsInChest = 1 / 7;
const $faa1b3449016497b$var$chanceOfTenItemsInChest = 0.01;
const $faa1b3449016497b$export$9dad127c748f1430 = [
    {
        quantity: 1,
        threshold: 1 - $faa1b3449016497b$var$chanceOfOneItemInChest
    },
    {
        quantity: 2,
        threshold: 1 - $faa1b3449016497b$var$chanceOfTwoItemsInChest
    },
    {
        quantity: 3,
        threshold: 1 - $faa1b3449016497b$var$chanceOfThreeItemsInChest
    },
    {
        quantity: 4,
        threshold: 1 - $faa1b3449016497b$var$chanceOfFourItemsInChest
    },
    {
        quantity: 5,
        threshold: 1 - $faa1b3449016497b$var$chanceOfFiveItemsInChest
    },
    {
        quantity: 10,
        threshold: 1 - $faa1b3449016497b$var$chanceOfTenItemsInChest
    }
];
const $faa1b3449016497b$var$chanceOfOneItemInEnemyDrop = 1;
const $faa1b3449016497b$var$chanceOfTwoItemsInEnemyDrop = 0.1;
const $faa1b3449016497b$var$chanceOfThreeItemsInEnemyDrop = 0.02;
const $faa1b3449016497b$export$25e85be123c718ac = [
    {
        quantity: 1,
        threshold: 1 - $faa1b3449016497b$var$chanceOfOneItemInEnemyDrop
    },
    {
        quantity: 2,
        threshold: 1 - $faa1b3449016497b$var$chanceOfTwoItemsInEnemyDrop
    },
    {
        quantity: 3,
        threshold: 1 - $faa1b3449016497b$var$chanceOfThreeItemsInEnemyDrop
    }
];
const $faa1b3449016497b$export$17c43a4595495431 = (randomNumber)=>{
    let numberOfItems = 0;
    for (const quantityThreshold of $faa1b3449016497b$export$25e85be123c718ac)if (randomNumber >= quantityThreshold.threshold) // console.log(`Threshold met! Giving player at least ${quantityThreshold.quantity} items due to roll (${quantityThreshold.threshold} threshold was met)`);
    numberOfItems = quantityThreshold.quantity;
    // console.log(`Rolled ${numberOfItems} items in enemy drop due to roll ${randomNumber}`);
    return numberOfItems;
};
const $faa1b3449016497b$export$5f5c805d7201a63b = (randomNumber)=>{
    let numberOfItems = 0;
    for (const quantityThreshold of $faa1b3449016497b$export$9dad127c748f1430)if (randomNumber >= quantityThreshold.threshold) // console.log(`Threshold met! Giving player at least ${quantityThreshold.quantity} items due to roll (${quantityThreshold.threshold} threshold was met)`);
    numberOfItems = quantityThreshold.quantity;
    // console.log(`Rolled ${numberOfItems} items in loot chest due to roll ${randomNumber}`);
    return numberOfItems;
};
const $faa1b3449016497b$export$b09c948834ffda90 = (itemRarityRoll, lootTable)=>{
    // console.log("\n");
    let item;
    let itemRarity = $faa1b3449016497b$export$d2ffa9ea74cc769f.Common;
    for (const rarity of $faa1b3449016497b$export$a217d44792dfbdcb)if (itemRarityRoll >= rarity.threshold) itemRarity = rarity.rarity;
    // console.log(`This items rarity resulted in a roll against the table ${ItemRarity[itemRarity]} due to roll ${itemRarityRoll}`);
    switch(itemRarity){
        case $faa1b3449016497b$export$d2ffa9ea74cc769f.Common:
            item = lootTable.CommonItems[Math.floor(Math.random() * lootTable.CommonItems.length)];
            break;
        case $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon:
            item = lootTable.UncommonItems[Math.floor(Math.random() * lootTable.UncommonItems.length)];
            break;
        case $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare:
            item = lootTable.RareItems[Math.floor(Math.random() * lootTable.RareItems.length)];
            break;
        case $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic:
            item = lootTable.EpicItems[Math.floor(Math.random() * lootTable.EpicItems.length)];
            break;
        case $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary:
            item = lootTable.LegendaryItems[Math.floor(Math.random() * lootTable.LegendaryItems.length)];
            break;
    }
    return item;
};
const $faa1b3449016497b$export$4f1fbbe8bd3f234c = (lootTable, numberOfItems, overrideDropRoll = 0)=>{
    const rolledItems = [];
    const rolledQuantityMultipliers = [];
    for(let i = 0; i < numberOfItems; i++){
        let itemRoll = Math.random();
        // console.log("item roll before", itemRoll);
        if (overrideDropRoll !== 0) itemRoll = overrideDropRoll;
        // console.log("item roll after", itemRoll);
        const rolledItem = $faa1b3449016497b$export$b09c948834ffda90(itemRoll, lootTable);
        if (rolledItem === undefined) continue;
        // console.log("Item rolled as a result of boost:", getItemData(rolledItem).itemRarity, rolledItem, Item[rolledItem]);
        // console.log("Rolled item: " + Item[rolledItem] + ` of ID ${rolledItem} (rarity: ${ItemRarity[getItemData(rolledItem).itemRarity]} due to roll ${itemRoll})`);
        if (rolledItems.includes(rolledItem)) {
            // console.log(`Item ${Item[rolledItem]} is not unique so far in this roll! Incrementing quantity multiplier..`);
            const index = rolledItems.indexOf(rolledItem);
            rolledQuantityMultipliers[index] += 1;
        } else {
            // console.log(`Item ${Item[rolledItem]} is unique so far in this roll! Adding..`);
            rolledItems.push(rolledItem);
            rolledQuantityMultipliers.push(1);
        }
    }
    // console.log({ rolledItems, rolledQuantityMultipliers });
    const rolledQuantities = [];
    for(let i = 0; i < rolledItems.length; i++){
        const { maxItemQuantityPerRoll: maxItemQuantityPerRoll  } = $faa1b3449016497b$export$dc0c4ec5c1198760(rolledItems[i]);
        rolledQuantities.push(maxItemQuantityPerRoll * rolledQuantityMultipliers[i]);
    }
    return {
        rolledItems: rolledItems,
        rolledQuantities: rolledQuantities
    };
};
const $faa1b3449016497b$export$497d425d969e36cb = (lootTableId)=>{
    const lootTable = $faa1b3449016497b$var$lootTableData.get(lootTableId);
    if (!lootTable) throw new Error(`LootTable with id ${lootTableId} does not exist! Error in Item data file.`);
    const numberOfItems = $faa1b3449016497b$export$5f5c805d7201a63b(Math.random());
    return $faa1b3449016497b$export$4f1fbbe8bd3f234c(lootTable, numberOfItems);
};
//#endregion
//#region Item Definitions!
/****************************************************/ /*                                                  */ /*             Item Definitions                     */ /*                                                  */ /****************************************************/ /*****************************/ /* STAVES! Item IDs 0 -> 99  */ /*****************************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_ApprenticesStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_ApprenticesStaff__name",
    loreText: "item__W_ApprenticesStaff__lore",
    gameplayText: "item__W_ApprenticesStaff__gameplay",
    inventorySpriteId: "weapons/Apprentices_Staff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_FlamespitterStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_FlamespitterStaff__name",
    loreText: "item__W_FlamespitterStaff__lore",
    gameplayText: "item__W_FlamespitterStaff__gameplay",
    inventorySpriteId: "weapons/Flamespitter_Staff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_StaffOfTheSnake,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_StaffOfTheSnake__name",
    loreText: "item__W_StaffOfTheSnake__lore",
    gameplayText: "item__W_StaffOfTheSnake__gameplay",
    inventorySpriteId: "weapons/Toxic_Staff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_ArchmagesSidekick,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_ArchmagesSidekick__name",
    loreText: "item__W_ArchmagesSidekick__lore",
    gameplayText: "item__W_ArchmagesSidekick__gameplay",
    inventorySpriteId: "weapons/Arcane_Staff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_SamsStirringStick,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_SamsStirringStick__name",
    loreText: "item__W_SamsStirringStick__lore",
    gameplayText: "item__W_SamsStirringStick__gameplay",
    inventorySpriteId: "weapons/staff_samsStirringStick.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.75,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_CandlelightStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_CandlelightStaff__name",
    loreText: "item__W_CandlelightStaff__lore",
    gameplayText: "item__W_CandlelightStaff__gameplay",
    inventorySpriteId: "weapons/staff_candleLight.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_TwistedBranch,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_TwistedBranch__name",
    loreText: "item__W_TwistedBranch__lore",
    gameplayText: "item__W_TwistedBranch__gameplay",
    inventorySpriteId: "weapons/staff_twistedBranch.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.75,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_IronStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_IronStaff__name",
    loreText: "item__W_IronStaff__lore",
    gameplayText: "item__W_IronStaff__gameplay",
    inventorySpriteId: "weapons/staff_ironStaff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.75,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.75,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_PharaohsStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_PharaohsStaff__name",
    loreText: "item__W_PharaohsStaff__lore",
    gameplayText: "item__W_PharaohsStaff__gameplay",
    inventorySpriteId: "weapons/staff_pharoahsStaff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_FairyStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_FairyStaff__name",
    loreText: "item__W_FairyStaff__lore",
    gameplayText: "item__W_FairyStaff__gameplay",
    inventorySpriteId: "weapons/staff_fairyStaff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.25,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_MidasStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_MidasStaff__name",
    loreText: "item__W_MidasStaff__lore",
    gameplayText: "item__W_MidasStaff__gameplay",
    inventorySpriteId: "weapons/staff_midasStaff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.8,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_DemonsEye,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_DemonsEye__name",
    loreText: "item__W_DemonsEye__lore",
    gameplayText: "item__W_DemonsEye__gameplay",
    inventorySpriteId: "weapons/staff_demonsEye.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_SlimeStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_SlimeStaff__name",
    loreText: "item__W_SlimeStaff__lore",
    gameplayText: "item__W_SlimeStaff__gameplay",
    inventorySpriteId: "weapons/staff_slimeStaff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.25,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_BeesOnAStick,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_BeesOnAStick__name",
    loreText: "item__W_BeesOnAStick__lore",
    gameplayText: "item__W_BeesOnAStick__gameplay",
    inventorySpriteId: "weapons/staff_beeStick.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.75,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.25,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_LichsStaff,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_LichsStaff__name",
    loreText: "item__W_LichsStaff__lore",
    gameplayText: "item__W_LichsStaff__gameplay",
    inventorySpriteId: "weapons/staff_lichStaff.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.75,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.25,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton,
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_FrostFlicker,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_FrostFlicker__name",
    loreText: "item__W_FrostFlicker__lore",
    gameplayText: "item__W_FrostFlicker__gameplay",
    inventorySpriteId: "weapons/staff_frostFlicker.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 34,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant,
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
/***********************************/ /* CROSSBOWS! Item IDs 100 -> 199  */ /***********************************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_CrudeCrossbow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_CrudeCrossbow__name",
    loreText: "item__W_CrudeCrossbow__lore",
    gameplayText: "item__W_CrudeCrossbow__gameplay",
    inventorySpriteId: "weapons/Crossbow_Wood.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_GuardsCrossbow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_GuardsCrossbow__name",
    loreText: "item__W_GuardsCrossbow__lore",
    gameplayText: "item__W_GuardsCrossbow__gameplay",
    inventorySpriteId: "weapons/crossbow_guards.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_SteelCrossbow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_SteelCrossbow__name",
    loreText: "item__W_SteelCrossbow__lore",
    gameplayText: "item__W_SteelCrossbow__gameplay",
    inventorySpriteId: "weapons/Crossbow_Steel.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_ReliqueryCrossbow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_ReliqueryCrossbow__name",
    loreText: "item__W_ReliqueryCrossbow__lore",
    gameplayText: "item__W_ReliqueryCrossbow__gameplay",
    inventorySpriteId: "weapons/Crossbow_Red.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests,
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_EldritchBlasters,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_EldritchBlasters__name",
    loreText: "item__W_EldritchBlasters__lore",
    gameplayText: "item__W_EldritchBlasters__gameplay",
    inventorySpriteId: "weapons/crossbow_eldritchBlasters.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: 1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_DarylsInstinct,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_DarylsInstinct__name",
    loreText: "item__W_DarylsInstinct__lore",
    gameplayText: "item__W_DarylsInstinct__gameplay",
    inventorySpriteId: "weapons/crossbow_darylsInstinct.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_FathersBane,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_FathersBane__name",
    loreText: "item__W_FathersBane__lore",
    gameplayText: "item__W_FathersBane__gameplay",
    inventorySpriteId: "weapons/crossbow_fathersBane.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_WitchHuntersRepeaters,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_WitchHuntersRepeaters__name",
    loreText: "item__W_WitchHuntersRepeaters__lore",
    gameplayText: "item__W_WitchHuntersRepeaters__gameplay",
    inventorySpriteId: "weapons/crossbow_witchHuntersRepeater.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_WyvernsTalon,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_WyvernsTalon__name",
    loreText: "item__W_WyvernsTalon__lore",
    gameplayText: "item__W_WyvernsTalon__gameplay",
    inventorySpriteId: "weapons/crossbow_wyvernTalon.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 36,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_TheCrossBow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_TheCrossBow__name",
    loreText: "item__W_TheCrossBow__lore",
    gameplayText: "item__W_TheCrossBow__gameplay",
    inventorySpriteId: "weapons/crossbow_theCrossBow.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.8,
    smallInventorySlotSpriteOffsetLeft: -1,
    smallInventorySlotSpriteOffsetTop: 2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 36,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: -1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
/***********************************/ /*   BOWS! Item IDs 200 -> 299     */ /***********************************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_RangersGuillotine,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_RangersGuillotine__name",
    loreText: "item__W_RangersGuillotine__lore",
    gameplayText: "item__W_RangersGuillotine__gameplay",
    inventorySpriteId: "weapons/bow_rangersGuillotine.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.2,
    smallInventorySlotSpriteOffsetLeft: 3,
    smallInventorySlotSpriteOffsetTop: -2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 25,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_DavidBowie,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_DavidBowie__name",
    loreText: "item__W_DavidBowie__lore",
    gameplayText: "item__W_DavidBowie__gameplay",
    inventorySpriteId: "weapons/bow_woodenShortbow.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 7,
    largeInventorySlotSpriteOffsetTop: -5,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_Emberstrike,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_Emberstrike__name",
    loreText: "item__W_Emberstrike__lore",
    gameplayText: "item__W_Emberstrike__gameplay",
    inventorySpriteId: "weapons/bow_emberStrike.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: -4,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.25,
    largeInventorySlotSpriteOffsetLeft: 1,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_MoonShadow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_MoonShadow__name",
    loreText: "item__W_MoonShadow__lore",
    gameplayText: "item__W_MoonShadow__gameplay",
    inventorySpriteId: "weapons/bow_moonShadow.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 3,
    smallInventorySlotSpriteOffsetTop: -2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 23,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.3,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_FairyBow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_FairyBow__name",
    loreText: "item__W_FairyBow__lore",
    gameplayText: "item__W_FairyBow__gameplay",
    inventorySpriteId: "weapons/bow_fairyBow.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 3,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.75,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant,
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_Bloodrider,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_Bloodrider__name",
    loreText: "item__W_Bloodrider__lore",
    gameplayText: "item__W_Bloodrider__gameplay",
    inventorySpriteId: "weapons/bow_bloodRider.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.2,
    smallInventorySlotSpriteOffsetLeft: 3,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -1,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre,
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_PhoenixWing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_PhoenixWing__name",
    loreText: "item__W_PhoenixWing__lore",
    gameplayText: "item__W_PhoenixWing__gameplay",
    inventorySpriteId: "weapons/bow_phoenixWing.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.3,
    largeInventorySlotSpriteOffsetLeft: 8,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_DivineWind,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_DivineWind__name",
    loreText: "item__W_DivineWind__lore",
    gameplayText: "item__W_DivineWind__gameplay",
    inventorySpriteId: "weapons/bow_divineWind.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 3,
    smallInventorySlotSpriteOffsetTop: -2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 23,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.3,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox,
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_StarShot,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_StarShot__name",
    loreText: "item__W_StarShot__lore",
    gameplayText: "item__W_StarShot__gameplay",
    inventorySpriteId: "weapons/bow_starShot.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.75,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.3,
    largeInventorySlotSpriteOffsetLeft: 7,
    largeInventorySlotSpriteOffsetTop: -5,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_CelestialBow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_CelestialBow__name",
    loreText: "item__W_CelestialBow__lore",
    gameplayText: "item__W_CelestialBow__gameplay",
    inventorySpriteId: "weapons/bow_celestialBow.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.7,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.3,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_ReapersEmbrace,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_ReapersEmbrace__name",
    loreText: "item__W_ReapersEmbrace__lore",
    gameplayText: "item__W_ReapersEmbrace__gameplay",
    inventorySpriteId: "weapons/bow_reapersEmbrace.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.75,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.3,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_QuincyBow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_QuincyBow__name",
    loreText: "item__W_QuincyBow__lore",
    gameplayText: "item__W_QuincyBow__gameplay",
    inventorySpriteId: "weapons/bow_quincyBow.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 1,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.75,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 29,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_SilentShadow,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_SilentShadow__name",
    loreText: "item__W_SilentShadow__lore",
    gameplayText: "item__W_SilentShadow__gameplay",
    inventorySpriteId: "weapons/bow_silentShadow.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 3,
    smallInventorySlotSpriteOffsetTop: -2,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 1.5,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 23,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 2.3,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
/***********************************/ /*   Wands! Item IDs 300 -> 399    */ /***********************************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_Stick,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_Stick__name",
    loreText: "item__W_Stick__lore",
    gameplayText: "item__W_Stick__gameplay",
    inventorySpriteId: "weapons/wand_stick.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 1,
    largeInventorySlotSpriteOffsetTop: 1,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_SpiraledWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_SpiraledWand__name",
    loreText: "item__W_SpiraledWand__lore",
    gameplayText: "item__W_SpiraledWand__gameplay",
    inventorySpriteId: "weapons/wand_spiraleWand.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 1,
    largeInventorySlotSpriteOffsetTop: 1,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_NightStick,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_NightStick__name",
    loreText: "item__W_NightStick__lore",
    gameplayText: "item__W_NightStick__gameplay",
    inventorySpriteId: "weapons/wand_nightStick.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 1,
    largeInventorySlotSpriteOffsetTop: 1,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_DragonsBreath,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_DragonsBreath__name",
    loreText: "item__W_DragonsBreath__lore",
    gameplayText: "item__W_DragonsBreath__gameplay",
    inventorySpriteId: "weapons/wand_dragonsBreath.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -5,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 30,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -10,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_PoseidonsWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_PoseidonsWand__name",
    loreText: "item__W_PoseidonsWand__lore",
    gameplayText: "item__W_PoseidonsWand__gameplay",
    inventorySpriteId: "weapons/wand_poissidonsWandn.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 1,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 2,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant,
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_BrokenDeathstick,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_BrokenDeathstick__name",
    loreText: "item__W_BrokenDeathstick__lore",
    gameplayText: "item__W_BrokenDeathstick__gameplay",
    inventorySpriteId: "weapons/wand_brokenDeathstick.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_HibidyKibity,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_HibidyKibity__name",
    loreText: "item__W_HibidyKibity__lore",
    gameplayText: "item__W_HibidyKibity__gameplay",
    inventorySpriteId: "weapons/wand_hibidyKibity.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 6,
    smallInventorySlotSpriteOffsetTop: -4,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 4,
    tooltipSlotSpriteOffsetLeft: 50,
    tooltipSlotSpriteOffsetTop: 30,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 4,
    largeInventorySlotSpriteOffsetLeft: 10,
    largeInventorySlotSpriteOffsetTop: -8,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK,
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_MagicalWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_MagicalWand__name",
    loreText: "item__W_MagicalWand__lore",
    gameplayText: "item__W_MagicalWand__gameplay",
    inventorySpriteId: "weapons/wand_magicalWand.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 1,
    largeInventorySlotSpriteOffsetTop: -1,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_BlackDahliaWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_BlackDahliaWand__name",
    loreText: "item__W_BlackDahliaWand__lore",
    gameplayText: "item__W_BlackDahliaWand__gameplay",
    inventorySpriteId: "weapons/wand_blackDahlia.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_FrostedTips,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_FrostedTips__name",
    loreText: "item__W_FrostedTips__lore",
    gameplayText: "item__W_FrostedTips__gameplay",
    inventorySpriteId: "weapons/wand_frostedTips.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_RelicWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_RelicWand__name",
    loreText: "item__W_RelicWand__lore",
    gameplayText: "item__W_RelicWand__gameplay",
    inventorySpriteId: "weapons/wand_relicWand.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 45,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 5,
    largeInventorySlotSpriteOffsetTop: -3,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_ZappingWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_ZappingWand__name",
    loreText: "item__W_ZappingWand__lore",
    gameplayText: "item__W_ZappingWand__gameplay",
    inventorySpriteId: "weapons/wand_zappingWand.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_IcewindWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_IcewindWand__name",
    loreText: "item__W_IcewindWand__lore",
    gameplayText: "item__W_IcewindWand__gameplay",
    inventorySpriteId: "weapons/wand_icewindWand.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_BlazeRod,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_BlazeRod__name",
    loreText: "item__W_BlazeRod__lore",
    gameplayText: "item__W_BlazeRod__gameplay",
    inventorySpriteId: "weapons/wand_blazeRod.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_ToxicWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_ToxicWand__name",
    loreText: "item__W_ToxicWand__lore",
    gameplayText: "item__W_ToxicWand__gameplay",
    inventorySpriteId: "weapons/wand_toxicWand.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_StarWand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__W_StarWand__name",
    loreText: "item__W_StarWand__lore",
    gameplayText: "item__W_StarWand__gameplay",
    inventorySpriteId: "weapons/wand_starWand.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 4,
    smallInventorySlotSpriteOffsetTop: -3,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 40,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre,
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
/*******************&&&&&&****************/ /*   Spellbooks! Item IDs 400 -> 499     */ /********************&&&&&&***************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_SpellbindersTome,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__W_SpellbindersTome__name",
    loreText: "item__W_SpellbindersTome__lore",
    gameplayText: "item__W_SpellbindersTome__gameplay",
    inventorySpriteId: "weapons/spell_spellbindersTome.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_Triforce,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_Triforce__name",
    loreText: "item__W_Triforce__lore",
    gameplayText: "item__W_Triforce__gameplay",
    inventorySpriteId: "weapons/spell_triForce.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_WizardsLedger,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__W_WizardsLedger__name",
    loreText: "item__W_WizardsLedger__lore",
    gameplayText: "item__W_WizardsLedger__gameplay",
    inventorySpriteId: "weapons/spell_wizardsLedger.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_NaturesReturn,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_NaturesReturn__name",
    loreText: "item__W_NaturesReturn__lore",
    gameplayText: "item__W_NaturesReturn__gameplay",
    inventorySpriteId: "weapons/spell_naturesReturn.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_KingBible,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__W_KingBible__name",
    loreText: "item__W_KingBible__lore",
    gameplayText: "item__W_KingBible__gameplay",
    inventorySpriteId: "weapons/spell_kingBible.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton,
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_BookOfTongues,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_BookOfTongues__name",
    loreText: "item__W_BookOfTongues__lore",
    gameplayText: "item__W_BookOfTongues__gameplay",
    inventorySpriteId: "weapons/spell_bookOfTongues.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard,
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.W_Deathstick,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.Weapon,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__W_Deathstick__name",
    loreText: "item__W_Deathstick__lore",
    gameplayText: "item__W_Deathstick__gameplay",
    inventorySpriteId: "weapons/wand_Deathstick.png",
    smallInventorySlotRotation: -45,
    smallInventorySlotSpriteScale: 1.7,
    smallInventorySlotSpriteOffsetLeft: 0,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: -45,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: -45,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox,
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK,
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
/*********************************************/ /*   Passive Gear! Item IDs 1000 -> 1999     */ /*********************************************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_SerpentsRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__PG_SerpentsRing__name",
    loreText: "item__PG_SerpentsRing__lore",
    gameplayText: "item__PG_SerpentsRing__gameplay",
    inventorySpriteId: "gear/ring_002.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.065
        }
    ],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_WindspeakersRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__PG_WindspeakersRing__name",
    loreText: "item__PG_WindspeakersRing__lore",
    gameplayText: "item__PG_WindspeakersRing__gameplay",
    inventorySpriteId: "gear/ring_001.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.05
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Information,
            abilityParameter: 0
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_IronFoxLocket,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__PG_IronFoxLocket__name",
    loreText: "item__PG_IronFoxLocket__lore",
    gameplayText: "item__PG_IronFoxLocket__gameplay",
    inventorySpriteId: "gear/necklace_03.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Physical,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Arcane,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Lightning,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Bleed,
            statAmount: 0.13
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Information,
            abilityParameter: 0
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 30
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_HeirloomCloak,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__PG_HeirloomCloak__name",
    loreText: "item__PG_HeirloomCloak__lore",
    gameplayText: "item__PG_HeirloomCloak__gameplay",
    inventorySpriteId: "gear/armor_14.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.20,
        abilityDurationInSeconds: 2,
        abilityCharges: 3,
        abilityCooldownInSeconds: 9
    },
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_ElvenGildedGuardian,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_ElvenGildedGuardian__name",
    loreText: "item__PG_ElvenGildedGuardian__lore",
    gameplayText: "item__PG_ElvenGildedGuardian__gameplay",
    inventorySpriteId: "gear/belt_02.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: 0.05
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_FrostFireRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__PG_FrostFireRing__name",
    loreText: "item__PG_FrostFireRing__lore",
    gameplayText: "item__PG_FrostFireRing__gameplay",
    inventorySpriteId: "gear/ring_004.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.07
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.085
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: -0.65
        }
    ],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_GirdleOfTheGoldenNecromancer,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_GirdleOfTheGoldenNecromancer__name",
    loreText: "item__PG_GirdleOfTheGoldenNecromancer__lore",
    gameplayText: "item__PG_GirdleOfTheGoldenNecromancer__gameplay",
    inventorySpriteId: "gear/belt_01.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedUp,
            abilityParameter: 0.06
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 10,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 15
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_RingOfConstellations,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_RingOfConstellations__name",
    loreText: "item__PG_RingOfConstellations__lore",
    gameplayText: "item__PG_RingOfConstellations__gameplay",
    inventorySpriteId: "gear/ring_050.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceUp,
            abilityParameter: 0.06
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_TantrumsLuckyLoop,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_TantrumsLuckyLoop__name",
    loreText: "item__PG_TantrumsLuckyLoop__lore",
    gameplayText: "item__PG_TantrumsLuckyLoop__gameplay",
    inventorySpriteId: "gear/ring_056.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedUp,
            abilityParameter: 0.03
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_GoldPlatedCape,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_GoldPlatedCape__name",
    loreText: "item__PG_GoldPlatedCape__lore",
    gameplayText: "item__PG_GoldPlatedCape__gameplay",
    inventorySpriteId: "gear/armor_15.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageUp,
            abilityParameter: 0.04
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_AssassinSignet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_AssassinSignet__name",
    loreText: "item__PG_AssassinSignet__lore",
    gameplayText: "item__PG_AssassinSignet__gameplay",
    inventorySpriteId: "gear/brooch_02.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceDown,
            abilityParameter: 0.03
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedDown,
            abilityParameter: 0.03
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 5,
        abilityCharges: 2,
        abilityCooldownInSeconds: 10
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CopperWristband,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_CopperWristband__name",
    loreText: "item__PG_CopperWristband__lore",
    gameplayText: "item__PG_CopperWristband__gameplay",
    inventorySpriteId: "gear/ring_115.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Physical,
            statAmount: 0.065
        }
    ],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_GolemsGrasp,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_GolemsGrasp__name",
    loreText: "item__PG_GolemsGrasp__lore",
    gameplayText: "item__PG_GolemsGrasp__gameplay",
    inventorySpriteId: "gear/ring_060.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 30
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedDown,
            abilityParameter: 0.06
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.WaterWalking,
            abilityParameter: 0.06
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_ShieldbearersAmulet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_ShieldbearersAmulet__name",
    loreText: "item__PG_ShieldbearersAmulet__lore",
    gameplayText: "item__PG_ShieldbearersAmulet__gameplay",
    inventorySpriteId: "gear/necklace_02.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.065
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 10,
        abilityDurationInSeconds: 0,
        abilityCharges: 1,
        abilityCooldownInSeconds: 0
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_MementoMoriLocket,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_MementoMoriLocket__name",
    loreText: "item__PG_MementoMoriLocket__lore",
    gameplayText: "item__PG_MementoMoriLocket__gameplay",
    inventorySpriteId: "gear/necklace_09.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.085
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: -0.065
        }
    ],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_GuardiansChainmailCollar,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_GuardiansChainmailCollar__name",
    loreText: "item__PG_GuardiansChainmailCollar__lore",
    gameplayText: "item__PG_GuardiansChainmailCollar__gameplay",
    inventorySpriteId: "gear/necklace_20.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedDown,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 15,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 15
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_NaturesAureateBarrier,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_NaturesAureateBarrier__name",
    loreText: "item__PG_NaturesAureateBarrier__lore",
    gameplayText: "item__PG_NaturesAureateBarrier__gameplay",
    inventorySpriteId: "gear/belt_03.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Incognito,
            abilityParameter: 0
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageDown,
            abilityParameter: 0.055
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 30,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 30
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_QuintsFishingGarb,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_QuintsFishingGarb__name",
    loreText: "item__PG_QuintsFishingGarb__lore",
    gameplayText: "item__PG_QuintsFishingGarb__gameplay",
    inventorySpriteId: "gear/armor_06.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedUp,
            abilityParameter: 0.05
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_GineshsBottleOpener,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_GineshsBottleOpener__name",
    loreText: "item__PG_GineshsBottleOpener__lore",
    gameplayText: "item__PG_GineshsBottleOpener__gameplay",
    inventorySpriteId: "gear/ring_105.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Physical,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Arcane,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Bleed,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Lightning,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.12
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.LoseHealthOverTime,
            abilityParameter: 0.3
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedUp,
            abilityParameter: 0.085
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceUp,
            abilityParameter: 0.085
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_AngelistasPotionPopper,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_AngelistasPotionPopper__name",
    loreText: "item__PG_AngelistasPotionPopper__lore",
    gameplayText: "item__PG_AngelistasPotionPopper__gameplay",
    inventorySpriteId: "gear/ring_107.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GainHealthOverTime,
            abilityParameter: 0.2
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_MunchkinsRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_MunchkinsRing__name",
    loreText: "item__PG_MunchkinsRing__lore",
    gameplayText: "item__PG_MunchkinsRing__gameplay",
    inventorySpriteId: "gear/ring_118.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedUp,
            abilityParameter: 0.05
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease,
            abilityParameter: 10
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CloakOfModestApproachability,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_CloakOfModestApproachability__name",
    loreText: "item__PG_CloakOfModestApproachability__lore",
    gameplayText: "item__PG_CloakOfModestApproachability__gameplay",
    inventorySpriteId: "gear/armor_52.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceUp,
            abilityParameter: 0.06
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 30,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 30
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_SummonersSign,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_SummonersSign__name",
    loreText: "item__PG_SummonersSign__lore",
    gameplayText: "item__PG_SummonersSign__gameplay",
    inventorySpriteId: "gear/brooch_01.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 10
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CoralReef,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_CoralReef__name",
    loreText: "item__PG_CoralReef__lore",
    gameplayText: "item__PG_CoralReef__gameplay",
    inventorySpriteId: "gear/necklace_13.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.WaterWalking,
            abilityParameter: 0.085
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: -0.1
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_IceQueensEarrings,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_IceQueensEarrings__name",
    loreText: "item__PG_IceQueensEarrings__lore",
    gameplayText: "item__PG_IceQueensEarrings__gameplay",
    inventorySpriteId: "gear/earring_01.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.065
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.05
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageUp,
            abilityParameter: 0.04
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.20,
        abilityDurationInSeconds: 3,
        abilityCharges: 2,
        abilityCooldownInSeconds: 7
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_RingOfTheOneHandedWarrior,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_RingOfTheOneHandedWarrior__name",
    loreText: "item__PG_RingOfTheOneHandedWarrior__lore",
    gameplayText: "item__PG_RingOfTheOneHandedWarrior__gameplay",
    inventorySpriteId: "gear/ring_116.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Physical,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Bleed,
            statAmount: 0.12
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease,
            abilityParameter: 10
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CompactedLimeGreenRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_CompactedLimeGreenRing__name",
    loreText: "item__PG_CompactedLimeGreenRing__lore",
    gameplayText: "item__PG_CompactedLimeGreenRing__gameplay",
    inventorySpriteId: "gear/ring_032.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.07
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceUp,
            abilityParameter: 0.05
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_LittleCompactedLimeGreenRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_LittleCompactedLimeGreenRing__name",
    loreText: "item__PG_LittleCompactedLimeGreenRing__lore",
    gameplayText: "item__PG_LittleCompactedLimeGreenRing__gameplay",
    inventorySpriteId: "gear/ring_044.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.13
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceUp,
            abilityParameter: 0.06
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_InfiniteLoop,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_InfiniteLoop__name",
    loreText: "item__PG_InfiniteLoop__lore",
    gameplayText: "item__PG_InfiniteLoop__gameplay",
    inventorySpriteId: "gear/ring_053.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease,
            abilityParameter: 10
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GainHealthOverTime,
            abilityParameter: 0.5
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 45,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 60
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_JaysesRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__PG_JaysesRing__name",
    loreText: "item__PG_JaysesRing__lore",
    gameplayText: "item__PG_JaysesRing__gameplay",
    inventorySpriteId: "gear/ring_003.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Lightning,
            statAmount: 0.12
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.12
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Ethereal,
            abilityParameter: 0.15
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageDown,
            abilityParameter: 0.09
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageUp,
            abilityParameter: 0.095
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_BellsShiningRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__PG_BellsShiningRing__name",
    loreText: "item__PG_BellsShiningRing__lore",
    gameplayText: "item__PG_BellsShiningRing__gameplay",
    inventorySpriteId: "gear/ring_010.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GainHealthOverTime,
            abilityParameter: 0.5
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 40
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.155
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageDown,
            abilityParameter: 0.095
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 60,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 45
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_RingOfViolentViolet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_RingOfViolentViolet__name",
    loreText: "item__PG_RingOfViolentViolet__lore",
    gameplayText: "item__PG_RingOfViolentViolet__gameplay",
    inventorySpriteId: "gear/ring_113.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Physical,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Arcane,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Bleed,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Lightning,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: -0.15
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Physical,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Arcane,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Bleed,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Lightning,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.17
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.17
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 30
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CloudedDarkness,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_CloudedDarkness__name",
    loreText: "item__PG_CloudedDarkness__lore",
    gameplayText: "item__PG_CloudedDarkness__gameplay",
    inventorySpriteId: "gear/ring_096.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.10
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.13
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Ethereal,
            abilityParameter: 0.20
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CapeOfPureDarkness,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_CapeOfPureDarkness__name",
    loreText: "item__PG_CapeOfPureDarkness__lore",
    gameplayText: "item__PG_CapeOfPureDarkness__gameplay",
    inventorySpriteId: "gear/armor_11.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.09
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.09
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.07
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.LoseHealthOverTime,
            abilityParameter: 0.2
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.25,
        abilityDurationInSeconds: 4,
        abilityCharges: 4,
        abilityCooldownInSeconds: 10
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_BloodGemRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_BloodGemRing__name",
    loreText: "item__PG_BloodGemRing__lore",
    gameplayText: "item__PG_BloodGemRing__gameplay",
    inventorySpriteId: "gear/ring_093.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease,
            abilityParameter: 20
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.5
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_PurpletratorsRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_PurpletratorsRing__name",
    loreText: "item__PG_PurpletratorsRing__lore",
    gameplayText: "item__PG_PurpletratorsRing__gameplay",
    inventorySpriteId: "gear/ring_092.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.03
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_AquamoorsBlessing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_AquamoorsBlessing__name",
    loreText: "item__PG_AquamoorsBlessing__lore",
    gameplayText: "item__PG_AquamoorsBlessing__gameplay",
    inventorySpriteId: "gear/armor_05.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GainHealthOverTime,
            abilityParameter: 0.03
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease,
            abilityParameter: 20
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.25,
        abilityDurationInSeconds: 3,
        abilityCharges: 4,
        abilityCooldownInSeconds: 9
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_EssenceConduit,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_EssenceConduit__name",
    loreText: "item__PG_EssenceConduit__lore",
    gameplayText: "item__PG_EssenceConduit__gameplay",
    inventorySpriteId: "gear/armor_17.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.09
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageDown,
            abilityParameter: 0.04
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_ArcaneEmber,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_ArcaneEmber__name",
    loreText: "item__PG_ArcaneEmber__lore",
    gameplayText: "item__PG_ArcaneEmber__gameplay",
    inventorySpriteId: "gear/ring_088.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageDown,
            abilityParameter: 0.065
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageUp,
            abilityParameter: 0.056
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_PhoenixsRespite,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_PhoenixsRespite__name",
    loreText: "item__PG_PhoenixsRespite__lore",
    gameplayText: "item__PG_PhoenixsRespite__gameplay",
    inventorySpriteId: "gear/armor_13.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.065
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.05
        }
    ],
    passiveAbilities: [],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 3,
        abilityCharges: 1,
        abilityCooldownInSeconds: 8
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulBindingRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_SoulBindingRing__name",
    loreText: "item__PG_SoulBindingRing__lore",
    gameplayText: "item__PG_SoulBindingRing__gameplay",
    inventorySpriteId: "gear/ring_083.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: 0.1
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.40
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_BloodiedVitality,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_BloodiedVitality__name",
    loreText: "item__PG_BloodiedVitality__lore",
    gameplayText: "item__PG_BloodiedVitality__gameplay",
    inventorySpriteId: "gear/armor_08.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 30
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GainHealthOverTime,
            abilityParameter: 0.6
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageDown,
            abilityParameter: 0.08
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionProtection,
            abilityParameter: -0.1
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Extract,
        abilityParameter: 0,
        abilityDurationInSeconds: 0,
        abilityCharges: 1,
        abilityCooldownInSeconds: 0
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: true,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_VenomousBite,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_VenomousBite__name",
    loreText: "item__PG_VenomousBite__lore",
    gameplayText: "item__PG_VenomousBite__gameplay",
    inventorySpriteId: "gear/armor_04.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.1
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.LoseHealthOverTime,
            abilityParameter: 0.2
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 30,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 30
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_RuneboundRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_RuneboundRing__name",
    loreText: "item__PG_RuneboundRing__lore",
    gameplayText: "item__PG_RuneboundRing__gameplay",
    inventorySpriteId: "gear/ring_067.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Arcane,
            statAmount: 0.07
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.WaterWalking,
            abilityParameter: 0.05
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_FrostbiteLoop,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_FrostbiteLoop__name",
    loreText: "item__PG_FrostbiteLoop__lore",
    gameplayText: "item__PG_FrostbiteLoop__gameplay",
    inventorySpriteId: "gear/ring_079.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedUp,
            abilityParameter: 0.06
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_PhantomBand,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_PhantomBand__name",
    loreText: "item__PG_PhantomBand__lore",
    gameplayText: "item__PG_PhantomBand__gameplay",
    inventorySpriteId: "gear/ring_071.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Ethereal,
            abilityParameter: 0.3
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_EmbergraspRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_EmbergraspRing__name",
    loreText: "item__PG_EmbergraspRing__lore",
    gameplayText: "item__PG_EmbergraspRing__gameplay",
    inventorySpriteId: "gear/ring_075.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 10
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulshackleVeil,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_SoulshackleVeil__name",
    loreText: "item__PG_SoulshackleVeil__lore",
    gameplayText: "item__PG_SoulshackleVeil__gameplay",
    inventorySpriteId: "gear/armor_51.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Ethereal,
            abilityParameter: 0.085
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedDown,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.25,
        abilityDurationInSeconds: 3,
        abilityCharges: 3,
        abilityCooldownInSeconds: 9
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_StormweaverCloak,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_StormweaverCloak__name",
    loreText: "item__PG_StormweaverCloak__lore",
    gameplayText: "item__PG_StormweaverCloak__gameplay",
    inventorySpriteId: "gear/ring_070.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Incognito,
            abilityParameter: 0
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CursedSignet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_CursedSignet__name",
    loreText: "item__PG_CursedSignet__lore",
    gameplayText: "item__PG_CursedSignet__gameplay",
    inventorySpriteId: "gear/ring_069.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.2
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_EnigmaLoop,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_EnigmaLoop__name",
    loreText: "item__PG_EnigmaLoop__lore",
    gameplayText: "item__PG_EnigmaLoop__gameplay",
    inventorySpriteId: "gear/ring_063.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.5
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Incognito,
            abilityParameter: 0
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_VampiricSeal,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_VampiricSeal__name",
    loreText: "item__PG_VampiricSeal__lore",
    gameplayText: "item__PG_VampiricSeal__gameplay",
    inventorySpriteId: "gear/armor_20.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.03
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 7,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 15
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_Wraithband,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_Wraithband__name",
    loreText: "item__PG_Wraithband__lore",
    gameplayText: "item__PG_Wraithband__gameplay",
    inventorySpriteId: "gear/ring_057.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: 0.07
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Ethereal,
            abilityParameter: 0.085
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease,
            abilityParameter: 10
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_NecroticSignet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_NecroticSignet__name",
    loreText: "item__PG_NecroticSignet__lore",
    gameplayText: "item__PG_NecroticSignet__gameplay",
    inventorySpriteId: "gear/armor_12.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: 0.13
        }
    ],
    passiveAbilities: [],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 45,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 30
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CorruptedTearRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_CorruptedTearRing__name",
    loreText: "item__PG_CorruptedTearRing__lore",
    gameplayText: "item__PG_CorruptedTearRing__gameplay",
    inventorySpriteId: "gear/ring_034.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: -0.07
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.09
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Lightning,
            statAmount: 0.09
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.07
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 5,
        abilityCharges: 3,
        abilityCooldownInSeconds: 9
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_DeathwhisperWrap,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_DeathwhisperWrap__name",
    loreText: "item__PG_DeathwhisperWrap__lore",
    gameplayText: "item__PG_DeathwhisperWrap__gameplay",
    inventorySpriteId: "gear/armor_50.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.13
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: 0.1
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.13
        }
    ],
    //TODO: Give this the 'Random' active ability when implemented
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_VeilstormCirclet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_VeilstormCirclet__name",
    loreText: "item__PG_VeilstormCirclet__lore",
    gameplayText: "item__PG_VeilstormCirclet__gameplay",
    inventorySpriteId: "gear/armor_02.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.12
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedDown,
            abilityParameter: 0.10
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 30,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 15
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulforgeRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_SoulforgeRing__name",
    loreText: "item__PG_SoulforgeRing__lore",
    gameplayText: "item__PG_SoulforgeRing__gameplay",
    inventorySpriteId: "gear/ring_031.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: -0.1
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Extract,
        abilityParameter: 0,
        abilityDurationInSeconds: 0,
        abilityCharges: 1,
        abilityCooldownInSeconds: 0
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: true,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CursedEternityRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__PG_CursedEternityRing__name",
    loreText: "item__PG_CursedEternityRing__lore",
    gameplayText: "item__PG_CursedEternityRing__gameplay",
    inventorySpriteId: "gear/ring_028.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.LoseHealthOverTime,
            abilityParameter: 0.3
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.48
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.085
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GoldRush,
            abilityParameter: 0.12
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.3,
        abilityDurationInSeconds: 5,
        abilityCharges: 5,
        abilityCooldownInSeconds: 10
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_MidnightsVeilBand,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_MidnightsVeilBand__name",
    loreText: "item__PG_MidnightsVeilBand__lore",
    gameplayText: "item__PG_MidnightsVeilBand__gameplay",
    inventorySpriteId: "gear/armor_16.png",
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 0,
        abilityDurationInSeconds: 5,
        abilityCharges: 2,
        abilityCooldownInSeconds: 10
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_DreadmorneLoop,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_DreadmorneLoop__name",
    loreText: "item__PG_DreadmorneLoop__lore",
    gameplayText: "item__PG_DreadmorneLoop__gameplay",
    inventorySpriteId: "gear/ring_025.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.1
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: -0.065
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedDown,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.3,
        abilityDurationInSeconds: 3,
        abilityCharges: 5,
        abilityCooldownInSeconds: 8
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_EbonfireRobelet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_EbonfireRobelet__name",
    loreText: "item__PG_EbonfireRobelet__lore",
    gameplayText: "item__PG_EbonfireRobelet__gameplay",
    inventorySpriteId: "gear/armor_49.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceUp,
            abilityParameter: 0.06
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_EverlastingSpiritCircle,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_EverlastingSpiritCircle__name",
    loreText: "item__PG_EverlastingSpiritCircle__lore",
    gameplayText: "item__PG_EverlastingSpiritCircle__gameplay",
    inventorySpriteId: "gear/ring_019.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GoldRush,
            abilityParameter: 0.10
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 25,
        abilityDurationInSeconds: 3,
        abilityCharges: 2,
        abilityCooldownInSeconds: 8
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_EnigmaticShadowweaveRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_EnigmaticShadowweaveRing__name",
    loreText: "item__PG_EnigmaticShadowweaveRing__lore",
    gameplayText: "item__PG_EnigmaticShadowweaveRing__gameplay",
    inventorySpriteId: "gear/ring_018.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageDown,
            abilityParameter: 0.09
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageUp,
            abilityParameter: 0.055
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 20,
        abilityDurationInSeconds: 0,
        abilityCharges: 1,
        abilityCooldownInSeconds: 0
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_BloodmoonLoop,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_BloodmoonLoop__name",
    loreText: "item__PG_BloodmoonLoop__lore",
    gameplayText: "item__PG_BloodmoonLoop__gameplay",
    inventorySpriteId: "gear/armor_01.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Bleed,
            statAmount: 0.05
        }
    ],
    passiveAbilities: [],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 5,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 20
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_DreamcasterDrapery,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_DreamcasterDrapery__name",
    loreText: "item__PG_DreamcasterDrapery__lore",
    gameplayText: "item__PG_DreamcasterDrapery__gameplay",
    inventorySpriteId: "gear/armor_19.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.065
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.065
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CelestialSolaceBand,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_CelestialSolaceBand__name",
    loreText: "item__PG_CelestialSolaceBand__lore",
    gameplayText: "item__PG_CelestialSolaceBand__gameplay",
    inventorySpriteId: "gear/ring_014.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.065
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Information,
            abilityParameter: 0
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 7,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 20
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_TalismanOfVeiledShadows,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_TalismanOfVeiledShadows__name",
    loreText: "item__PG_TalismanOfVeiledShadows__lore",
    gameplayText: "item__PG_TalismanOfVeiledShadows__gameplay",
    inventorySpriteId: "gear/necklace_04.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Chaos,
            statAmount: 0.085
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.085
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedDown,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 3,
        abilityCharges: 2,
        abilityCooldownInSeconds: 7
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_PendantOfAncientWisdom,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_PendantOfAncientWisdom__name",
    loreText: "item__PG_PendantOfAncientWisdom__lore",
    gameplayText: "item__PG_PendantOfAncientWisdom__gameplay",
    inventorySpriteId: "gear/necklace_06.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Arcane,
            statAmount: 0.085
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Arcane,
            statAmount: 0.07
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.0875
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageDown,
            abilityParameter: 0.07
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_SerpentsCoilChoker,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_SerpentsCoilChoker__name",
    loreText: "item__PG_SerpentsCoilChoker__lore",
    gameplayText: "item__PG_SerpentsCoilChoker__gameplay",
    inventorySpriteId: "gear/necklace_08.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Information,
            abilityParameter: 0
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_ArcaneSigilCollar,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_ArcaneSigilCollar__name",
    loreText: "item__PG_ArcaneSigilCollar__lore",
    gameplayText: "item__PG_ArcaneSigilCollar__gameplay",
    inventorySpriteId: "gear/necklace_10.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageDown,
            abilityParameter: 0.085
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageUp,
            abilityParameter: 0.095
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.30,
        abilityDurationInSeconds: 3,
        abilityCharges: 5,
        abilityCooldownInSeconds: 15
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_ResilientHeartstone,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_ResilientHeartstone__name",
    loreText: "item__PG_ResilientHeartstone__lore",
    gameplayText: "item__PG_ResilientHeartstone__gameplay",
    inventorySpriteId: "gear/necklace_11.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Information,
            abilityParameter: 0
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionProtection,
            abilityParameter: 0.05
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GoldRush,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 10,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 20
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_FrostfireShardPendant,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_FrostfireShardPendant__name",
    loreText: "item__PG_FrostfireShardPendant__lore",
    gameplayText: "item__PG_FrostfireShardPendant__gameplay",
    inventorySpriteId: "gear/necklace_12.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageUp,
            abilityParameter: 0.08
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionProtection,
            abilityParameter: 0.1
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_PhoenixFeatherTorque,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__PG_PhoenixFeatherTorque__name",
    loreText: "item__PG_PhoenixFeatherTorque__lore",
    gameplayText: "item__PG_PhoenixFeatherTorque__gameplay",
    inventorySpriteId: "gear/necklace_15.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Fire,
            statAmount: 0.195
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.195
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Toxic,
            statAmount: -0.195
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.6
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 60
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedDown,
            abilityParameter: 0.15
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_SoulstoneReliquary,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_SoulstoneReliquary__name",
    loreText: "item__PG_SoulstoneReliquary__lore",
    gameplayText: "item__PG_SoulstoneReliquary__gameplay",
    inventorySpriteId: "gear/necklace_16.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.05
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.20
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionProtection,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 4,
        abilityCharges: 1,
        abilityCooldownInSeconds: 8
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_EnchantedElixirNecklace,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__PG_EnchantedElixirNecklace__name",
    loreText: "item__PG_EnchantedElixirNecklace__lore",
    gameplayText: "item__PG_EnchantedElixirNecklace__gameplay",
    inventorySpriteId: "gear/necklace_17.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.6
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 60,
        abilityDurationInSeconds: 0,
        abilityCharges: 1,
        abilityCooldownInSeconds: 120
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_NecroticGraspTalisman,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_NecroticGraspTalisman__name",
    loreText: "item__PG_NecroticGraspTalisman__lore",
    gameplayText: "item__PG_NecroticGraspTalisman__gameplay",
    inventorySpriteId: "gear/necklace_19.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Shadow,
            statAmount: 0.12
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.LoseHealthOverTime,
            abilityParameter: 0.5
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.3,
        abilityDurationInSeconds: 5,
        abilityCharges: 1,
        abilityCooldownInSeconds: 10
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CelestialStarfallPendant,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__PG_CelestialStarfallPendant__name",
    loreText: "item__PG_CelestialStarfallPendant__lore",
    gameplayText: "item__PG_CelestialStarfallPendant__gameplay",
    inventorySpriteId: "gear/necklace_21.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Holy,
            statAmount: 0.05
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.065
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 3,
        abilityCharges: 2,
        abilityCooldownInSeconds: 7
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_CultistsMask,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__PG_CultistsMask__name",
    loreText: "item__PG_CultistsMask__lore",
    gameplayText: "item__PG_CultistsMask__gameplay",
    inventorySpriteId: "gear/icon735.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Incognito,
            abilityParameter: 0
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedUp,
            abilityParameter: 0.15
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 6,
        abilityCharges: 3,
        abilityCooldownInSeconds: 9
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_DepthStrider,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__PG_DepthStrider__name",
    loreText: "item__PG_DepthStrider__lore",
    gameplayText: "item__PG_DepthStrider__gameplay",
    inventorySpriteId: "gear/armor_07.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.WaterWalking,
            abilityParameter: 0.05
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_GoldenGauntlets,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__PG_GoldenGauntlets__name",
    loreText: "item__PG_GoldenGauntlets__lore",
    gameplayText: "item__PG_GoldenGauntlets__gameplay",
    inventorySpriteId: "gear/icon745.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GoldRush,
            abilityParameter: 0.1
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests,
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.PG_BeastVanquisherBoots,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__PG_BeastVanquisherBoots__name",
    loreText: "item__PG_BeastVanquisherBoots__lore",
    gameplayText: "item__PG_BeastVanquisherBoots__gameplay",
    inventorySpriteId: "gear/icon773.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedUp,
            abilityParameter: 0.12
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 45
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageUp,
            abilityParameter: 0.25
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageDown,
            abilityParameter: 0.12
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceDown,
            abilityParameter: 0.12
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat,
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
// setItemData({
//     itemType: ItemType.PassiveGear,
//     itemId: Item.PG_SamsTestItem,
//     maxItemQuantityPerRoll: 1,
//     itemRarity: ItemRarity.Legendary,
//     name: "Sam's Super Illegal Test Item",
//     loreText: "You should not have this.",
//     gameplayText: "Probably everything!",
//     inventorySpriteId: "items/crystal_side_6.png",
//     passiveStats: [],
//     passiveAbilities: [],
//     activeAbility: {
//         ability: ActiveAbility.Dash,
//         abilityParameter: 2,
//         abilityCharges: -1,
//         abilityCooldownInSeconds: 15,
//         abilityDurationInSeconds: 5
//     },
//     smallInventorySlotRotation: 0,
//     smallInventorySlotSpriteScale: 2,
//     smallInventorySlotSpriteOffsetLeft: 0.5,
//     smallInventorySlotSpriteOffsetTop: -1,
//     tooltipSlotRotation: 0,
//     tooltipSlotSpriteScale: 3,
//     tooltipSlotSpriteOffsetLeft: 37,
//     tooltipSlotSpriteOffsetTop: 35,
//     largeInventorySlotRotation: 0,
//     largeInventorySlotSpriteScale: 3,
//     largeInventorySlotSpriteOffsetLeft: 0,
//     largeInventorySlotSpriteOffsetTop: 0
// });
/*********************************************/ /*    Active Gear! Item IDs 2000 -> 2999     */ /*********************************************/ $faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_VestiasSoothingSignet,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__AG_VestiasSoothingSignet__name",
    loreText: "item__AG_VestiasSoothingSignet__lore",
    gameplayText: "item__AG_VestiasSoothingSignet__gameplay",
    inventorySpriteId: "gear/ring_103.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Incognito,
            abilityParameter: 0
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 30,
        abilityDurationInSeconds: 0,
        abilityCharges: 1,
        abilityCooldownInSeconds: 11
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_ViolasDinnerReminder,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__AG_ViolasDinnerReminder__name",
    loreText: "item__AG_ViolasDinnerReminder__lore",
    gameplayText: "item__AG_ViolasDinnerReminder__gameplay",
    inventorySpriteId: "gear/ring_054.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.085
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Frost,
            statAmount: 0.085
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceDown,
            abilityParameter: 0.05
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionProtection,
            abilityParameter: 0.07
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_WolfMedallion,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__AG_WolfMedallion__name",
    loreText: "item__AG_WolfMedallion__lore",
    gameplayText: "item__AG_WolfMedallion__gameplay",
    inventorySpriteId: "gear/necklace_23.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.1
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedUp,
            abilityParameter: 0.1
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 10,
        abilityDurationInSeconds: 0,
        abilityCharges: 3,
        abilityCooldownInSeconds: 15
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_PepperedCollar,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    name: "item__AG_PepperedCollar__name",
    loreText: "item__AG_PepperedCollar__lore",
    gameplayText: "item__AG_PepperedCollar__gameplay",
    inventorySpriteId: "gear/necklace_22.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ProjectileDistanceDown,
            abilityParameter: 0.03
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.25,
        abilityDurationInSeconds: 4,
        abilityCharges: 1,
        abilityCooldownInSeconds: 10
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_StuddedNecklace,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__AG_StuddedNecklace__name",
    loreText: "item__AG_StuddedNecklace__lore",
    gameplayText: "item__AG_StuddedNecklace__gameplay",
    inventorySpriteId: "gear/necklace_01.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedDown,
            abilityParameter: 0.03
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 4,
        abilityCharges: 3,
        abilityCooldownInSeconds: 9
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_TimeHerosRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__AG_TimeHerosRing__name",
    loreText: "item__AG_TimeHerosRing__lore",
    gameplayText: "item__AG_TimeHerosRing__gameplay",
    inventorySpriteId: "gear/ring_008.png",
    passiveStats: [
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.Defence,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.09
        },
        {
            passiveStatType: $faa1b3449016497b$export$6df8f823269939c6.DamageBoost,
            damageType: $faa1b3449016497b$export$b8f9e8b7bac978d5.Nature,
            statAmount: 0.07
        }
    ],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedDown,
            abilityParameter: 0.05
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.WaterWalking,
            abilityParameter: 0.07
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedUp,
            abilityParameter: 0.07
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 45,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 30
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_TheDarkLordsEmbrace,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__AG_TheDarkLordsEmbrace__name",
    loreText: "item__AG_TheDarkLordsEmbrace__lore",
    gameplayText: "item__AG_TheDarkLordsEmbrace__gameplay",
    inventorySpriteId: "gear/ring_001.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 30
        }
    ],
    //TODO: Give this the 'Random' active ability when implemented
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: true,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_Boros,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__AG_Boros__name",
    loreText: "item__AG_Boros__lore",
    gameplayText: "item__AG_Boros__gameplay",
    inventorySpriteId: "gear/ring_012.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageLeech,
            abilityParameter: 0.12
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.NPCDamageDown,
            abilityParameter: 0.12
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 7,
        abilityCharges: 3,
        abilityCooldownInSeconds: 10
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_MysteriousRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__AG_MysteriousRing__name",
    loreText: "item__AG_MysteriousRing__lore",
    gameplayText: "item__AG_MysteriousRing__gameplay",
    inventorySpriteId: "gear/ring_101.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.WaterWalking,
            abilityParameter: 0.07
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthIncrease,
            abilityParameter: 10
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.TimerExtender,
        abilityParameter: 30,
        abilityDurationInSeconds: 0,
        abilityCharges: 2,
        abilityCooldownInSeconds: 0
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.PassiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_DarkPustulesRing,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    name: "item__AG_DarkPustulesRing__name",
    loreText: "item__AG_DarkPustulesRing__lore",
    gameplayText: "item__AG_DarkPustulesRing__gameplay",
    inventorySpriteId: "gear/ring_119.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionProtection,
            abilityParameter: 0.05
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: 0.05
        }
    ],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_RingOfAnOceanMan,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__AG_RingOfAnOceanMan__name",
    loreText: "item__AG_RingOfAnOceanMan__lore",
    gameplayText: "item__AG_RingOfAnOceanMan__gameplay",
    inventorySpriteId: "gear/ring_112.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.WaterWalking,
            abilityParameter: 0.05
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Dash,
        abilityParameter: 0.20,
        abilityDurationInSeconds: 2,
        abilityCharges: 3,
        abilityCooldownInSeconds: 7
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_ForestsHaven,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__AG_ForestsHaven__name",
    loreText: "item__AG_ForestsHaven__lore",
    gameplayText: "item__AG_ForestsHaven__gameplay",
    inventorySpriteId: "gear/ring_090.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Ethereal,
            abilityParameter: 0.2
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Incognito,
            abilityParameter: 0
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: 0.1
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Heal,
        abilityParameter: 20,
        abilityDurationInSeconds: 0,
        abilityCharges: 4,
        abilityCooldownInSeconds: 15
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_DreamWeaversEmbrace,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    name: "item__AG_DreamWeaversEmbrace__name",
    loreText: "item__AG_DreamWeaversEmbrace__lore",
    gameplayText: "item__AG_DreamWeaversEmbrace__gameplay",
    inventorySpriteId: "gear/ring_082.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Incognito,
            abilityParameter: 0
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: 0.1
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.PlayerDamageDown,
            abilityParameter: 0.05
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityParameter: 1,
        abilityDurationInSeconds: 4,
        abilityCharges: 2,
        abilityCooldownInSeconds: 8
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_ObsidianEcho,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    name: "item__AG_ObsidianEcho__name",
    loreText: "item__AG_ObsidianEcho__lore",
    gameplayText: "item__AG_ObsidianEcho__gameplay",
    inventorySpriteId: "gear/ring_047.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MoveSpeedUp,
            abilityParameter: 0.12
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.70
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.MaxHealthDecrease,
            abilityParameter: 30
        }
    ],
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Extract,
        abilityParameter: 0,
        abilityDurationInSeconds: 0,
        abilityCharges: 1,
        abilityCooldownInSeconds: 0
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: true,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_AmuletOfCursedFate,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__AG_AmuletOfCursedFate__name",
    loreText: "item__AG_AmuletOfCursedFate__lore",
    gameplayText: "item__AG_AmuletOfCursedFate__gameplay",
    inventorySpriteId: "gear/necklace_14.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.Revive,
            abilityParameter: 0.40
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.AttackSpeedUp,
            abilityParameter: 0.1
        }
    ],
    //TODO: Give this the 'Random' active ability when implemented
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.ActiveGear,
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.AG_MagicBoots,
    maxItemQuantityPerRoll: 1,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    name: "item__AG_MagicBoots__name",
    loreText: "item__AG_MagicBoots__lore",
    gameplayText: "item__AG_MagicBoots__gameplay",
    inventorySpriteId: "gear/icon759.png",
    passiveStats: [],
    passiveAbilities: [
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.GainHealthOverTime,
            abilityParameter: 0.5
        },
        {
            passiveAbility: $faa1b3449016497b$export$f81ad329d1573de4.ExtractionSpeedUp,
            abilityParameter: -0.1
        }
    ],
    //TODO: Give this the 'Random' active ability when implemented
    activeAbility: {
        ability: $faa1b3449016497b$export$259a6f5d817ae02e.Invisibility,
        abilityCharges: 2,
        abilityCooldownInSeconds: 9,
        abilityDurationInSeconds: 5,
        abilityParameter: 1
    },
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: -1,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 0,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost,
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant,
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
/**********************************************/ /*    Vendor Trash! Item IDs 3000 -> 3999     */ /**********************************************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_OnyxGem,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_OnyxGem__name",
    loreText: "item__VT_OnyxGem__lore",
    gameplayText: "item__VT_OnyxGem__gameplay",
    inventorySpriteId: "items/material_38.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 36,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_GhostPlasma,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_GhostPlasma__name",
    loreText: "item__VT_GhostPlasma__lore",
    gameplayText: "item__VT_GhostPlasma__gameplay",
    inventorySpriteId: "items/icon271.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 36,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_GoblinCloth,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_GoblinCloth__name",
    loreText: "item__VT_GoblinCloth__lore",
    gameplayText: "item__VT_GoblinCloth__gameplay",
    inventorySpriteId: "items/icon257.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Fossil,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Fossil__name",
    loreText: "item__VT_Fossil__lore",
    gameplayText: "item__VT_Fossil__gameplay",
    inventorySpriteId: "items/icon171.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_BrokenSword,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_BrokenSword__name",
    loreText: "item__VT_BrokenSword__lore",
    gameplayText: "item__VT_BrokenSword__gameplay",
    inventorySpriteId: "items/brokensword.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_PileOfAsh,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_PileOfAsh__name",
    loreText: "item__VT_PileOfAsh__lore",
    gameplayText: "item__VT_PileOfAsh__gameplay",
    inventorySpriteId: "items/chunk_11.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 32,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Skull,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Skull__name",
    loreText: "item__VT_Skull__lore",
    gameplayText: "item__VT_Skull__gameplay",
    inventorySpriteId: "items/icon894.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 6,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Emerald,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Emerald__name",
    loreText: "item__VT_Emerald__lore",
    gameplayText: "item__VT_Emerald__gameplay",
    inventorySpriteId: "items/material_01.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Ruby,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Ruby__name",
    loreText: "item__VT_Ruby__lore",
    gameplayText: "item__VT_Ruby__gameplay",
    inventorySpriteId: "items/material_29.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_CubicZirconia,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_CubicZirconia__name",
    loreText: "item__VT_CubicZirconia__lore",
    gameplayText: "item__VT_CubicZirconia__gameplay",
    inventorySpriteId: "items/material_06.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Sapphire,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Sapphire__name",
    loreText: "item__VT_Sapphire__lore",
    gameplayText: "item__VT_Sapphire__gameplay",
    inventorySpriteId: "items/material_03.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Diamond,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Diamond__name",
    loreText: "item__VT_Diamond__lore",
    gameplayText: "item__VT_Diamond__gameplay",
    inventorySpriteId: "items/material_08.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Amber,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Amber__name",
    loreText: "item__VT_Amber__lore",
    gameplayText: "item__VT_Amber__gameplay",
    inventorySpriteId: "items/material_05.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Eyeball,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Eyeball__name",
    loreText: "item__VT_Eyeball__lore",
    gameplayText: "item__VT_Eyeball__gameplay",
    inventorySpriteId: "items/icon895.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_FangOfTheBloodMoon,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_FangOfTheBloodMoon__name",
    loreText: "item__VT_FangOfTheBloodMoon__lore",
    gameplayText: "item__VT_FangOfTheBloodMoon__gameplay",
    inventorySpriteId: "items/icon887.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 36,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_ChunkOfIron,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_ChunkOfIron__name",
    loreText: "item__VT_ChunkOfIron__lore",
    gameplayText: "item__VT_ChunkOfIron__gameplay",
    inventorySpriteId: "items/material_12.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_BrokenIronBand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_BrokenIronBand__name",
    loreText: "item__VT_BrokenIronBand__lore",
    gameplayText: "item__VT_BrokenIronBand__gameplay",
    inventorySpriteId: "items/broken_ring.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_RedMushroom,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_RedMushroom__name",
    loreText: "item__VT_RedMushroom__lore",
    gameplayText: "item__VT_RedMushroom__gameplay",
    inventorySpriteId: "items/icon337.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 36,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_SkeletonFemur,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_SkeletonFemur__name",
    loreText: "item__VT_SkeletonFemur__lore",
    gameplayText: "item__VT_SkeletonFemur__gameplay",
    inventorySpriteId: "items/icon892.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 38,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_GoldNugget,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_GoldNugget__name",
    loreText: "item__VT_GoldNugget__lore",
    gameplayText: "item__VT_GoldNugget__gameplay",
    inventorySpriteId: "items/icon890.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 38,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_AbyssalShard,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_AbyssalShard__name",
    loreText: "item__VT_AbyssalShard__lore",
    gameplayText: "item__VT_AbyssalShard__gameplay",
    inventorySpriteId: "items/material_07.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.5,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_DukesDiary,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_DukesDiary__name",
    loreText: "item__VT_DukesDiary__lore",
    gameplayText: "item__VT_DukesDiary__gameplay",
    inventorySpriteId: "items/icon380.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_QuartzRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_QuartzRing__name",
    loreText: "item__VT_QuartzRing__lore",
    gameplayText: "item__VT_QuartzRing__gameplay",
    inventorySpriteId: "gear/ring_097.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_RingOfNearPerfection,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_RingOfNearPerfection__name",
    loreText: "item__VT_RingOfNearPerfection__lore",
    gameplayText: "item__VT_RingOfNearPerfection__gameplay",
    inventorySpriteId: "gear/ring_099.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_OgreEntrails,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_OgreEntrails__name",
    loreText: "item__VT_OgreEntrails__lore",
    gameplayText: "item__VT_OgreEntrails__gameplay",
    inventorySpriteId: "items/icon522.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Potato,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Potato__name",
    loreText: "item__VT_Potato__lore",
    gameplayText: "item__VT_Potato__gameplay",
    inventorySpriteId: "items/icon311.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 4,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_TreantBranch,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_TreantBranch__name",
    loreText: "item__VT_TreantBranch__lore",
    gameplayText: "item__VT_TreantBranch__gameplay",
    inventorySpriteId: "items/icon885.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_RatFur,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_RatFur__name",
    loreText: "item__VT_RatFur__lore",
    gameplayText: "item__VT_RatFur__gameplay",
    inventorySpriteId: "items/icon948.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 4,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_EverlastingCandle,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_EverlastingCandle__name",
    loreText: "item__VT_EverlastingCandle__lore",
    gameplayText: "item__VT_EverlastingCandle__gameplay",
    inventorySpriteId: "items/icon431.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_StellarWeaveRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_StellarWeaveRing__name",
    loreText: "item__VT_StellarWeaveRing__lore",
    gameplayText: "item__VT_StellarWeaveRing__gameplay",
    inventorySpriteId: "gear/ring_120.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_BardsDiary,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_BardsDiary__name",
    loreText: "item__VT_BardsDiary__lore",
    gameplayText: "item__VT_BardsDiary__gameplay",
    inventorySpriteId: "items/icon368.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.75,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_RubyDust,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_RubyDust__name",
    loreText: "item__VT_RubyDust__lore",
    gameplayText: "item__VT_RubyDust__gameplay",
    inventorySpriteId: "items/chunk_7.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 32,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_EmeraldDust,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_EmeraldDust__name",
    loreText: "item__VT_EmeraldDust__lore",
    gameplayText: "item__VT_EmeraldDust__gameplay",
    inventorySpriteId: "items/chunk_8.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 32,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_SapphireDust,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_SapphireDust__name",
    loreText: "item__VT_SapphireDust__lore",
    gameplayText: "item__VT_SapphireDust__gameplay",
    inventorySpriteId: "items/chunk_5.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 1.5,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 32,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_WellWornRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Common,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_WellWornRing__name",
    loreText: "item__VT_WellWornRing__lore",
    gameplayText: "item__VT_WellWornRing__gameplay",
    inventorySpriteId: "gear/ring_100.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_WhispersOfTheVoid,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_WhispersOfTheVoid__name",
    loreText: "item__VT_WhispersOfTheVoid__lore",
    gameplayText: "item__VT_WhispersOfTheVoid__gameplay",
    inventorySpriteId: "items/icon370.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.VT_Cabbage,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.VendorTrash,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__VT_Cabbage__name",
    loreText: "item__VT_Cabbage__lore",
    gameplayText: "item__VT_Cabbage__gameplay",
    inventorySpriteId: "items/cabbage.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
/**********************************************/ /*    Collectors Items! Item IDs 4000 -> 4999     */ /**********************************************/ $faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_FragmentOfFate,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_FragmentOfFate__name",
    loreText: "item__CI_FragmentOfFate__lore",
    gameplayText: "item__CI_FragmentOfFate__gameplay",
    inventorySpriteId: "items/skill_033.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 3,
    tooltipSlotSpriteOffsetLeft: 37,
    tooltipSlotSpriteOffsetTop: 40,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3.5,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_PlayerSoulFragment,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_PlayerSoulFragment__name",
    loreText: "item__CI_PlayerSoulFragment__lore",
    gameplayText: "item__CI_PlayerSoulFragment__gameplay",
    inventorySpriteId: "items/material_10.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 41,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: []
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_LatrosKnavishBand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_LatrosKnavishBand__name",
    loreText: "item__CI_LatrosKnavishBand__lore",
    gameplayText: "item__CI_LatrosKnavishBand__gameplay",
    inventorySpriteId: "gear/ring_104.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_WeddingRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_WeddingRing__name",
    loreText: "item__CI_WeddingRing__lore",
    gameplayText: "item__CI_WeddingRing__gameplay",
    inventorySpriteId: "gear/ring_073.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_PeachRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_PeachRing__name",
    loreText: "item__CI_PeachRing__lore",
    gameplayText: "item__CI_PeachRing__gameplay",
    inventorySpriteId: "gear/ring_108.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_RingOfDelerium,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_RingOfDelerium__name",
    loreText: "item__CI_RingOfDelerium__lore",
    gameplayText: "item__CI_RingOfDelerium__gameplay",
    inventorySpriteId: "gear/ring_038.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_LifesSimpleRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_LifesSimpleRing__name",
    loreText: "item__CI_LifesSimpleRing__lore",
    gameplayText: "item__CI_LifesSimpleRing__gameplay",
    inventorySpriteId: "gear/ring_055.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies,
        $faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_SwampOgresRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_SwampOgresRing__name",
    loreText: "item__CI_SwampOgresRing__lore",
    gameplayText: "item__CI_SwampOgresRing__gameplay",
    inventorySpriteId: "gear/ring_002.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre,
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_RoyalBrooch,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_RoyalBrooch__name",
    loreText: "item__CI_RoyalBrooch__lore",
    gameplayText: "item__CI_RoyalBrooch__gameplay",
    inventorySpriteId: "gear/brooch_03.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 1,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 1,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_SuperStar,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_SuperStar__name",
    loreText: "item__CI_SuperStar__lore",
    gameplayText: "item__CI_SuperStar__gameplay",
    inventorySpriteId: "gear/brooch_04.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_Ouro,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_Ouro__name",
    loreText: "item__CI_Ouro__lore",
    gameplayText: "item__CI_Ouro__gameplay",
    inventorySpriteId: "gear/ring_011.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GRONK
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_AlloyedBend,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_AlloyedBend__name",
    loreText: "item__CI_AlloyedBend__lore",
    gameplayText: "item__CI_AlloyedBend__gameplay",
    inventorySpriteId: "gear/ring_117.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ogre
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_ProudlyPinkRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_ProudlyPinkRing__name",
    loreText: "item__CI_ProudlyPinkRing__lore",
    gameplayText: "item__CI_ProudlyPinkRing__gameplay",
    inventorySpriteId: "gear/ring_114.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Skeleton
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_ApposSignet,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_ApposSignet__name",
    loreText: "item__CI_ApposSignet__lore",
    gameplayText: "item__CI_ApposSignet__gameplay",
    inventorySpriteId: "gear/ring_109.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.GiantRat
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_CelestialEternity,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_CelestialEternity__name",
    loreText: "item__CI_CelestialEternity__lore",
    gameplayText: "item__CI_CelestialEternity__gameplay",
    inventorySpriteId: "gear/ring_087.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_BloodhuntersRing,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_BloodhuntersRing__name",
    loreText: "item__CI_BloodhuntersRing__lore",
    gameplayText: "item__CI_BloodhuntersRing__gameplay",
    inventorySpriteId: "gear/ring_080.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_EbonstarBand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_EbonstarBand__name",
    loreText: "item__CI_EbonstarBand__lore",
    gameplayText: "item__CI_EbonstarBand__gameplay",
    inventorySpriteId: "gear/ring_052.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Ghost
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_LuminousEnigma,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_LuminousEnigma__name",
    loreText: "item__CI_LuminousEnigma__lore",
    gameplayText: "item__CI_LuminousEnigma__gameplay",
    inventorySpriteId: "gear/armor_03.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_RadiantSunstoneBand,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_RadiantSunstoneBand__name",
    loreText: "item__CI_RadiantSunstoneBand__lore",
    gameplayText: "item__CI_RadiantSunstoneBand__gameplay",
    inventorySpriteId: "gear/ring_009.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_EchoingWhisperNecklace,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_EchoingWhisperNecklace__name",
    loreText: "item__CI_EchoingWhisperNecklace__lore",
    gameplayText: "item__CI_EchoingWhisperNecklace__gameplay",
    inventorySpriteId: "gear/necklace_07.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 1,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.IronFox
    ]
});
$faa1b3449016497b$var$setItemData({
    itemId: $faa1b3449016497b$export$6d08773d2e66f8f2.CI_FeyEnchantmentLocket,
    itemType: $faa1b3449016497b$export$1fc8f52ad1810e52.CollectorsItem,
    itemRarity: $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon,
    maxItemQuantityPerRoll: 1,
    name: "item__CI_FeyEnchantmentLocket__name",
    loreText: "item__CI_FeyEnchantmentLocket__lore",
    gameplayText: "item__CI_FeyEnchantmentLocket__gameplay",
    inventorySpriteId: "gear/necklace_18.png",
    smallInventorySlotRotation: 0,
    smallInventorySlotSpriteScale: 2,
    smallInventorySlotSpriteOffsetLeft: 0.5,
    smallInventorySlotSpriteOffsetTop: 0,
    tooltipSlotRotation: 0,
    tooltipSlotSpriteScale: 2.75,
    tooltipSlotSpriteOffsetLeft: 42,
    tooltipSlotSpriteOffsetTop: 35,
    largeInventorySlotRotation: 0,
    largeInventorySlotSpriteScale: 3,
    largeInventorySlotSpriteOffsetLeft: 0,
    largeInventorySlotSpriteOffsetTop: 2,
    passiveStats: [],
    passiveAbilities: [],
    activeAbility: $faa1b3449016497b$var$NoneActiveAbility,
    itemShouldBeDestroyedIfChargesExpended: false,
    droppedBy: [
        $faa1b3449016497b$export$e352ec3d384e8c44.Treant
    ]
});
//#endregion
//#region Loot Tables!
/********************************************************/ /*                                                      */ /*                     Loot Tables                      */ /*                                                      */ /********************************************************/ const $faa1b3449016497b$var$allCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>$faa1b3449016497b$export$dc0c4ec5c1198760(v).itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common);
const $faa1b3449016497b$var$allUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>$faa1b3449016497b$export$dc0c4ec5c1198760(v).itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon);
const $faa1b3449016497b$var$allRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>$faa1b3449016497b$export$dc0c4ec5c1198760(v).itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare);
const $faa1b3449016497b$var$allEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>$faa1b3449016497b$export$dc0c4ec5c1198760(v).itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic);
const $faa1b3449016497b$var$allLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>$faa1b3449016497b$export$dc0c4ec5c1198760(v).itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary);
const $faa1b3449016497b$export$ef64e4a820e715e1 = $faa1b3449016497b$export$59e95ec639a00e0().length;
const $faa1b3449016497b$export$a5b55c8481c9031f = $faa1b3449016497b$var$allCommonItems.length;
const $faa1b3449016497b$export$66eee877b246b932 = $faa1b3449016497b$var$allUncommonItems.length;
const $faa1b3449016497b$export$8d910d172896bc9f = $faa1b3449016497b$var$allRareItems.length;
const $faa1b3449016497b$export$449f95b1165adf6e = $faa1b3449016497b$var$allEpicItems.length;
const $faa1b3449016497b$export$92aee9933415bb9b = $faa1b3449016497b$var$allLegendaryItems.length;
var $faa1b3449016497b$export$27dd8d3f4f57d4c;
(function(LootTable) {
    LootTable[LootTable["AllItems"] = 0] = "AllItems";
    LootTable[LootTable["LootChest"] = 1] = "LootChest";
    LootTable[LootTable["GRONK"] = 2] = "GRONK";
    LootTable[LootTable["Skeleton"] = 3] = "Skeleton";
    LootTable[LootTable["Ghost"] = 4] = "Ghost";
    LootTable[LootTable["Rat"] = 5] = "Rat";
    LootTable[LootTable["Treant"] = 6] = "Treant";
    LootTable[LootTable["Ogre"] = 7] = "Ogre";
    LootTable[LootTable["IronFox"] = 8] = "IronFox";
    LootTable[LootTable["DarkWizard"] = 9] = "DarkWizard";
})($faa1b3449016497b$export$27dd8d3f4f57d4c || ($faa1b3449016497b$export$27dd8d3f4f57d4c = {}));
const $faa1b3449016497b$var$lootTableData = new Map();
const $faa1b3449016497b$export$b79a9e3cfcf3fb7e = (lootTableId, lootTable)=>{
    const existingEntryWithId = $faa1b3449016497b$var$lootTableData.get(lootTableId);
    if (existingEntryWithId) throw new Error(`Loot Table with id ${lootTableId} already exists! Error in Item data file.`);
    $faa1b3449016497b$var$lootTableData.set(lootTableId, lootTable);
};
const $faa1b3449016497b$export$545a9b11af9dbf88 = (lootTableId)=>{
    const foundLootTable = $faa1b3449016497b$var$lootTableData.get(lootTableId);
    if (!foundLootTable) throw new Error(`Loot Table with id ${lootTableId} does not exist! Error in Item data file.`);
    return foundLootTable;
};
/*******************/ /*  All Items      */ /*******************/ $faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.AllItems, {
    CommonItems: $faa1b3449016497b$var$allCommonItems,
    UncommonItems: $faa1b3449016497b$var$allUncommonItems,
    RareItems: $faa1b3449016497b$var$allRareItems,
    EpicItems: $faa1b3449016497b$var$allEpicItems,
    LegendaryItems: $faa1b3449016497b$var$allLegendaryItems
});
/*******************/ /*  Loot Chests    */ /*******************/ const $faa1b3449016497b$var$lootChestCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests);
});
const $faa1b3449016497b$var$lootChestUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests);
});
const $faa1b3449016497b$var$lootChestRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests);
});
const $faa1b3449016497b$var$lootChestEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests);
});
const $faa1b3449016497b$var$lootChestLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllLootChests);
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.LootChest, {
    CommonItems: $faa1b3449016497b$var$lootChestCommonItems,
    UncommonItems: $faa1b3449016497b$var$lootChestUncommonItems,
    RareItems: $faa1b3449016497b$var$lootChestRareItems,
    EpicItems: $faa1b3449016497b$var$lootChestEpicItems,
    LegendaryItems: $faa1b3449016497b$var$lootChestLegendaryItems
});
/*******************/ /*  Iron Fox       */ /*******************/ const $faa1b3449016497b$var$ironFoxCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.IronFox);
});
const $faa1b3449016497b$var$ironFoxUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.IronFox);
});
const $faa1b3449016497b$var$ironFoxRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.IronFox);
});
const $faa1b3449016497b$var$ironFoxEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.IronFox);
});
const $faa1b3449016497b$var$ironFoxLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.IronFox);
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.IronFox, {
    CommonItems: $faa1b3449016497b$var$ironFoxCommonItems,
    UncommonItems: $faa1b3449016497b$var$ironFoxUncommonItems,
    RareItems: $faa1b3449016497b$var$ironFoxRareItems,
    EpicItems: $faa1b3449016497b$var$ironFoxEpicItems,
    LegendaryItems: $faa1b3449016497b$var$ironFoxLegendaryItems
});
/*******************/ /*  GRONK          */ /*******************/ const $faa1b3449016497b$var$gronkCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GRONK);
});
const $faa1b3449016497b$var$gronkUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GRONK);
});
const $faa1b3449016497b$var$gronkRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GRONK);
});
const $faa1b3449016497b$var$gronkEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GRONK);
});
const $faa1b3449016497b$var$gronkLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GRONK);
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.GRONK, {
    CommonItems: $faa1b3449016497b$var$gronkCommonItems,
    UncommonItems: $faa1b3449016497b$var$gronkUncommonItems,
    RareItems: $faa1b3449016497b$var$gronkRareItems,
    EpicItems: $faa1b3449016497b$var$gronkEpicItems,
    LegendaryItems: $faa1b3449016497b$var$gronkLegendaryItems
});
/*******************/ /*  Skeleton       */ /*******************/ const $faa1b3449016497b$var$skeletonCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Skeleton) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$skeletonUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Skeleton) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$skeletonRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Skeleton) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$skeletonEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Skeleton) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$skeletonLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Skeleton) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.Skeleton, {
    CommonItems: $faa1b3449016497b$var$skeletonCommonItems,
    UncommonItems: $faa1b3449016497b$var$skeletonUncommonItems,
    RareItems: $faa1b3449016497b$var$skeletonRareItems,
    EpicItems: $faa1b3449016497b$var$skeletonEpicItems,
    LegendaryItems: $faa1b3449016497b$var$skeletonLegendaryItems
});
/*******************/ /*  Ghost          */ /*******************/ const $faa1b3449016497b$var$ghostCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ghost) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ghostUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ghost) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ghostRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ghost) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ghostEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ghost) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ghostLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ghost) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.Ghost, {
    CommonItems: $faa1b3449016497b$var$ghostCommonItems,
    UncommonItems: $faa1b3449016497b$var$ghostUncommonItems,
    RareItems: $faa1b3449016497b$var$ghostRareItems,
    EpicItems: $faa1b3449016497b$var$ghostEpicItems,
    LegendaryItems: $faa1b3449016497b$var$ghostLegendaryItems
});
/*******************/ /*  Rat            */ /*******************/ const $faa1b3449016497b$var$ratCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GiantRat) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ratUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GiantRat) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ratRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GiantRat) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ratEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GiantRat) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ratLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.GiantRat) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.Rat, {
    CommonItems: $faa1b3449016497b$var$ratCommonItems,
    UncommonItems: $faa1b3449016497b$var$ratUncommonItems,
    RareItems: $faa1b3449016497b$var$ratRareItems,
    EpicItems: $faa1b3449016497b$var$ratEpicItems,
    LegendaryItems: $faa1b3449016497b$var$ratLegendaryItems
});
/*******************/ /*  Treant         */ /*******************/ const $faa1b3449016497b$var$treantCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Treant) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$treantUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Treant) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$treantRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Treant) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$treantEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Treant) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$treantLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Treant) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.Treant, {
    CommonItems: $faa1b3449016497b$var$treantCommonItems,
    UncommonItems: $faa1b3449016497b$var$treantUncommonItems,
    RareItems: $faa1b3449016497b$var$treantRareItems,
    EpicItems: $faa1b3449016497b$var$treantEpicItems,
    LegendaryItems: $faa1b3449016497b$var$treantLegendaryItems
});
/*******************/ /*  Ogre           */ /*******************/ const $faa1b3449016497b$var$ogreCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ogre) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ogreUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ogre) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ogreRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ogre) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ogreEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ogre) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$ogreLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.Ogre) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.Ogre, {
    CommonItems: $faa1b3449016497b$var$ogreCommonItems,
    UncommonItems: $faa1b3449016497b$var$ogreUncommonItems,
    RareItems: $faa1b3449016497b$var$ogreRareItems,
    EpicItems: $faa1b3449016497b$var$ogreEpicItems,
    LegendaryItems: $faa1b3449016497b$var$ogreLegendaryItems
});
/*******************/ /*  Dark Wizard    */ /*******************/ const $faa1b3449016497b$var$darkWizardCommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Common && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$darkWizardUncommonItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Uncommon && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$darkWizardRareItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Rare && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$darkWizardEpicItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Epic && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
const $faa1b3449016497b$var$darkWizardLegendaryItems = $faa1b3449016497b$export$59e95ec639a00e0().filter((v)=>{
    const data = $faa1b3449016497b$export$dc0c4ec5c1198760(v);
    return data.itemRarity === $faa1b3449016497b$export$d2ffa9ea74cc769f.Legendary && (data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.DarkWizard) || data.droppedBy.includes($faa1b3449016497b$export$e352ec3d384e8c44.AllEnemies));
});
$faa1b3449016497b$export$b79a9e3cfcf3fb7e($faa1b3449016497b$export$27dd8d3f4f57d4c.DarkWizard, {
    CommonItems: $faa1b3449016497b$var$darkWizardCommonItems,
    UncommonItems: $faa1b3449016497b$var$darkWizardUncommonItems,
    RareItems: $faa1b3449016497b$var$darkWizardRareItems,
    EpicItems: $faa1b3449016497b$var$darkWizardEpicItems,
    LegendaryItems: $faa1b3449016497b$var$darkWizardLegendaryItems
}); //#endregion


const $b68713d61a9875e5$export$2c4ca88fbca02fe7 = {
    ENABLE_PREDICTION: true,
    SPEED_PER_SECOND: 70,
    MOVEMENT_COLLIDER_Y_OFFSET: 9,
    MOVEMENT_COLLIDER_RADIUS: 6,
    HITBOX_COLLIDER_WIDTH: 12,
    HITBOX_COLLIDER_HEIGHT: 20,
    DEBUG: {
        LOADOUT_OVERRIDES: {
            CHARACTER_SKIN: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).None,
            WEAPON_ONE: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None,
            WEAPON_TWO: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None,
            GEAR_ONE: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None,
            GEAR_TWO: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None,
            GEAR_THREE: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None
        },
        YOU_ARE_WAY_TOO_STRONG: false,
        YOU_ARE_INVINCIBLE: false,
        YOU_ARE_WAY_TOO_SQUISHY: false,
        SPAWN_WITH_ITEMS_IN_INVENTORY: 0,
        // Show real server-side entity for yourself
        DRAW_SERVERSIDE_SELF_DURING_PREDICTION: false,
        // Hiding specific sprites
        HIDE_PLAYER_SPRITE: false,
        HIDE_WEAPON_SPRITE: false,
        // Centerpoint visual
        DRAW_CENTERPOINT: false,
        // Movement collider visuals
        DRAW_MOVEMENT_COLLIDER: false,
        // Hitbox collider visuals
        DRAW_HITBOX_COLLIDER: false,
        // Aim indicator
        DRAW_AIM_INDICATOR: false,
        AIM_INDICATOR_SHOULD_BE_LONG_AF: false,
        // Theoretical projectile origin indicator
        DRAW_PROJECTILE_ORIGIN_INDICATOR: false,
        // Show position text
        DRAW_POSITION_TEXT: false,
        DRAW_TILE_GRID_TEXT: false,
        // Rectangle displaying the player's network view (culling area)
        DRAW_NETWORK_VIEW: false,
        // Give the player an omnipotent world view (don't cull anything)
        FORCE_OMEGA_NETCODE_CULLING_VIEW: false,
        // Players will no longer drop gravestones on death
        DONT_DROP_GRAVESTONES: false,
        // Custom override for player spawn position
        DEBUG_SPAWN_POSITION: {
            ENABLED: false,
            POSITION_X: 3241,
            POSITION_Y: 2603
        }
    }
};


const $dd72312a1effc8b4$export$c5154272f94334ca = {
    FOLLOW_SPEED: 0.1,
    FOLLOW_ACCELERATION: 1,
    FOLLOW_RADIUS: 10,
    DEFAULT_CAMERA_ZOOM: 3,
    DEBUG: {
        ALLOW_ZOOM: false,
        DEFAULT_MEGA_ZOOMED_OUT: false
    }
};


const $433dc5f32a7437eb$export$31154e48b1cf2ba0 = {
    DEBUG: {
        ENABLE_STATS: true
    }
};


var $c52f191d3f575144$export$3e27a2e13403a963;
(function(CollisionBroadphaseMode) {
    CollisionBroadphaseMode[CollisionBroadphaseMode["SPATIAL_GRID"] = 0] = "SPATIAL_GRID";
    CollisionBroadphaseMode[CollisionBroadphaseMode["QUADRATIC"] = 1] = "QUADRATIC";
})($c52f191d3f575144$export$3e27a2e13403a963 || ($c52f191d3f575144$export$3e27a2e13403a963 = {}));
const $c52f191d3f575144$export$c14d6c08f0e74a8e = {
    GRID_CELL_SIZE: 160,
    COLLISION_BROADPHASE_MODE: $c52f191d3f575144$export$3e27a2e13403a963.SPATIAL_GRID,
    ENABLE_CCD: false,
    DEBUG: {
        DRAW_BROADPHASE_SPATIAL_GRID: false,
        DRAW_COLLISION_TILE_LAYER: false
    }
};



var $21a778c44478d8dc$export$58825bda29b44ca2;
(function(Projectile) {
    Projectile[Projectile["BasicBlue"] = 0] = "BasicBlue";
    Projectile[Projectile["BasicRed"] = 1] = "BasicRed";
    Projectile[Projectile["BasicGreen"] = 2] = "BasicGreen";
    Projectile[Projectile["BasicPink"] = 3] = "BasicPink";
    Projectile[Projectile["FancyRed"] = 4] = "FancyRed";
    Projectile[Projectile["FireSkull"] = 5] = "FireSkull";
    Projectile[Projectile["FancyRainbow"] = 6] = "FancyRainbow";
    Projectile[Projectile["FancyAqua"] = 7] = "FancyAqua";
    Projectile[Projectile["FancyLime"] = 8] = "FancyLime";
    Projectile[Projectile["FancyBlack"] = 9] = "FancyBlack";
    Projectile[Projectile["FancyPink"] = 10] = "FancyPink";
    Projectile[Projectile["FancyPurple"] = 11] = "FancyPurple";
    Projectile[Projectile["FancyCrimson"] = 12] = "FancyCrimson";
    Projectile[Projectile["FancyWhite"] = 13] = "FancyWhite";
    Projectile[Projectile["FancyRainbowTwo"] = 14] = "FancyRainbowTwo";
    Projectile[Projectile["Boulder"] = 15] = "Boulder";
    Projectile[Projectile["ArcaneSpark"] = 16] = "ArcaneSpark";
    Projectile[Projectile["ArrowNormal"] = 17] = "ArrowNormal";
    Projectile[Projectile["StarArrow"] = 18] = "StarArrow";
    Projectile[Projectile["BloodArrow"] = 19] = "BloodArrow";
    Projectile[Projectile["DarylsBolt"] = 20] = "DarylsBolt";
    Projectile[Projectile["EldritchBolt"] = 21] = "EldritchBolt";
    Projectile[Projectile["GoldBolt"] = 22] = "GoldBolt";
    Projectile[Projectile["BoltNormal"] = 23] = "BoltNormal";
    Projectile[Projectile["BoltSilver"] = 24] = "BoltSilver";
    Projectile[Projectile["CelestialArrow"] = 25] = "CelestialArrow";
    Projectile[Projectile["FairyFireArrow"] = 26] = "FairyFireArrow";
    Projectile[Projectile["FairyIceArrow"] = 27] = "FairyIceArrow";
    Projectile[Projectile["FairyLightArrow"] = 28] = "FairyLightArrow";
    Projectile[Projectile["FairyNormalArrow"] = 29] = "FairyNormalArrow";
    Projectile[Projectile["FireArrow"] = 30] = "FireArrow";
    Projectile[Projectile["GiantsArrow"] = 31] = "GiantsArrow";
    Projectile[Projectile["GoldenArrow"] = 32] = "GoldenArrow";
    Projectile[Projectile["GuillotineArrow"] = 33] = "GuillotineArrow";
    Projectile[Projectile["MagicArrow"] = 34] = "MagicArrow";
    Projectile[Projectile["MoonArrow"] = 35] = "MoonArrow";
    Projectile[Projectile["ReaperArrow"] = 36] = "ReaperArrow";
    Projectile[Projectile["ShadowArrow"] = 37] = "ShadowArrow";
    Projectile[Projectile["Bees"] = 38] = "Bees";
    Projectile[Projectile["Blaze"] = 39] = "Blaze";
    Projectile[Projectile["Coin"] = 40] = "Coin";
    Projectile[Projectile["EyeBall"] = 41] = "EyeBall";
    Projectile[Projectile["MagicFairy"] = 42] = "MagicFairy";
    Projectile[Projectile["FlameBreath"] = 43] = "FlameBreath";
    Projectile[Projectile["HolySpark"] = 44] = "HolySpark";
    Projectile[Projectile["KingBible"] = 45] = "KingBible";
    Projectile[Projectile["MagicLeaf"] = 46] = "MagicLeaf";
    Projectile[Projectile["MagicalSpark"] = 47] = "MagicalSpark";
    Projectile[Projectile["MidasFist"] = 48] = "MidasFist";
    Projectile[Projectile["Poisson"] = 49] = "Poisson";
    Projectile[Projectile["SlimeBall"] = 50] = "SlimeBall";
    Projectile[Projectile["SpellBinder"] = 51] = "SpellBinder";
    Projectile[Projectile["MagicStar"] = 52] = "MagicStar";
    Projectile[Projectile["ToxicClouds"] = 53] = "ToxicClouds";
    Projectile[Projectile["TriForce"] = 54] = "TriForce";
    Projectile[Projectile["WandSpark"] = 55] = "WandSpark";
    Projectile[Projectile["TwistedSpark"] = 56] = "TwistedSpark";
    Projectile[Projectile["RedCrystal"] = 57] = "RedCrystal";
    Projectile[Projectile["CandleLight"] = 58] = "CandleLight";
    Projectile[Projectile["IronSpark"] = 59] = "IronSpark";
    Projectile[Projectile["LichSkull"] = 60] = "LichSkull";
    Projectile[Projectile["PhoenixArrow"] = 61] = "PhoenixArrow";
    Projectile[Projectile["BlackSpark"] = 62] = "BlackSpark";
    Projectile[Projectile["HibitySpark"] = 63] = "HibitySpark";
    Projectile[Projectile["IceSpark"] = 64] = "IceSpark";
    Projectile[Projectile["FrostWind"] = 65] = "FrostWind";
    Projectile[Projectile["ZapSpark"] = 66] = "ZapSpark";
    Projectile[Projectile["QuincyArrow"] = 67] = "QuincyArrow";
    Projectile[Projectile["GRONKBoulder"] = 68] = "GRONKBoulder";
    Projectile[Projectile["IronFoxSlash"] = 69] = "IronFoxSlash";
    Projectile[Projectile["IdleBlue"] = 70] = "IdleBlue";
    Projectile[Projectile["IdleFlameBreath"] = 71] = "IdleFlameBreath";
    Projectile[Projectile["IdleToxicClouds"] = 72] = "IdleToxicClouds";
    Projectile[Projectile["IdlePink"] = 73] = "IdlePink";
    Projectile[Projectile["IdleFancyRed"] = 74] = "IdleFancyRed";
    Projectile[Projectile["IdleCandleLight"] = 75] = "IdleCandleLight";
    Projectile[Projectile["IdleTwistedSpark"] = 76] = "IdleTwistedSpark";
    Projectile[Projectile["IdleIronSpark"] = 77] = "IdleIronSpark";
    Projectile[Projectile["IdleHolySpark"] = 78] = "IdleHolySpark";
    Projectile[Projectile["IdleMagicFairy"] = 79] = "IdleMagicFairy";
    Projectile[Projectile["IdleMidasFist"] = 80] = "IdleMidasFist";
    Projectile[Projectile["IdleEyeBall"] = 81] = "IdleEyeBall";
    Projectile[Projectile["IdleSlimeBall"] = 82] = "IdleSlimeBall";
    Projectile[Projectile["IdleBees"] = 83] = "IdleBees";
    Projectile[Projectile["IdleLichSkull"] = 84] = "IdleLichSkull";
    Projectile[Projectile["ShortBolt"] = 85] = "ShortBolt";
    Projectile[Projectile["BookOfTongues"] = 86] = "BookOfTongues";
    Projectile[Projectile["Deathstick"] = 87] = "Deathstick";
    Projectile[Projectile["DarkArrow"] = 88] = "DarkArrow";
})($21a778c44478d8dc$export$58825bda29b44ca2 || ($21a778c44478d8dc$export$58825bda29b44ca2 = {}));
const $21a778c44478d8dc$var$ProjectileData = new Map();
const $21a778c44478d8dc$var$setProjectileData = (projectileConfig)=>{
    const existingEntryWithId = $21a778c44478d8dc$var$ProjectileData.get(projectileConfig.id);
    if (existingEntryWithId) throw new Error(`ProjectileConfig with id ${projectileConfig.id} already exists! Error in projectile data file.`);
    $21a778c44478d8dc$var$ProjectileData.set(projectileConfig.id, projectileConfig);
};
const $21a778c44478d8dc$export$290d3183f69b75ee = (id)=>{
    const projectileConfig = $21a778c44478d8dc$var$ProjectileData.get(id);
    if (!projectileConfig) throw new Error(`ProjectileConfig with id ${id} does not exist! Error in projectile data file.`);
    return projectileConfig;
};
/***************************/ /*  Basic Blue Projectile  */ /***************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BasicBlue,
    projectileSpriteId: "projectiles/10/ptcBLU",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popBLU",
    impactSpriteScale: 0.5,
    speedPerSecond: 150,
    lifetimeInSeconds: 2.5,
    colliderRadius: 3,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/***************************/ /*  Idle Blue Projectile  */ /***************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleBlue,
    projectileSpriteId: "projectiles/10/ptcBLU",
    projectileSpriteScale: 4,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popBLU",
    impactSpriteScale: 0.5,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**************************/ /*  Basic Red Projectile  */ /**************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BasicRed,
    projectileSpriteId: "projectiles/11/ptcFIR",
    projectileSpriteScale: 3,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 1,
    speedPerSecond: 100,
    lifetimeInSeconds: 1,
    colliderRadius: 7,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/****************************/ /*  Basic Green Projectile  */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BasicGreen,
    projectileSpriteId: "projectiles/12/ptcGRE",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popGRE",
    impactSpriteScale: 0.5,
    speedPerSecond: 130,
    lifetimeInSeconds: 1.2,
    colliderRadius: 4.5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/****************************/ /*  Basic Pink Projectile   */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BasicPink,
    projectileSpriteId: "projectiles/13/ptcPNK",
    projectileSpriteScale: 2,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popPNK",
    impactSpriteScale: 0.75,
    speedPerSecond: 250,
    lifetimeInSeconds: 2,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/****************************/ /*  Idle Pink Projectile   */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdlePink,
    projectileSpriteId: "projectiles/13/ptcPNK",
    projectileSpriteScale: 4,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popPNK",
    impactSpriteScale: 0.75,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/****************************/ /*  Fire Skull Projectile   */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FireSkull,
    projectileSpriteId: "projectiles/fireskull/proj_fireSkull",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 1,
    speedPerSecond: 150,
    lifetimeInSeconds: 2,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/*******************************/ /*  Ogre Boulder               */ /*******************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.Boulder,
    projectileSpriteId: "projectiles/boulder/boulder",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popGRE",
    impactSpriteScale: 1,
    speedPerSecond: 150,
    lifetimeInSeconds: 1.2,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/********************************/ /*  GRONK Boulder               */ /********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.GRONKBoulder,
    projectileSpriteId: "projectiles/boulder/boulder",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popGRE",
    impactSpriteScale: 1,
    speedPerSecond: 200,
    lifetimeInSeconds: 3,
    colliderRadius: 10,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/****************************/ /*  Fancy Red Projectile    */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyRed,
    projectileSpriteId: "projectiles/1/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 0.5,
    speedPerSecond: 200,
    lifetimeInSeconds: 1.4,
    colliderRadius: 4,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/****************************/ /*  Idle Fancy Red Projectile    */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleFancyRed,
    projectileSpriteId: "projectiles/1/1",
    projectileSpriteScale: 5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 0.5,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 13,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/*******************************/ /*  Fancy Rainbow Projectile   */ /*******************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyRainbow,
    projectileSpriteId: "projectiles/7/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popPNK",
    impactSpriteScale: 0.5,
    speedPerSecond: 190,
    lifetimeInSeconds: 1.4,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/****************************/ /*  Fancy Aqua Projectile   */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyAqua,
    projectileSpriteId: "projectiles/2/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popBLU",
    impactSpriteScale: 0.5,
    speedPerSecond: 160,
    lifetimeInSeconds: 1.2,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/****************************/ /*  Fancy Lime Projectile   */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyLime,
    projectileSpriteId: "projectiles/3/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popGRE",
    impactSpriteScale: 0.5,
    speedPerSecond: 250,
    lifetimeInSeconds: 1.35,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/*****************************/ /*  Fancy Black Projectile   */ /*****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyBlack,
    projectileSpriteId: "projectiles/4/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 0.5,
    speedPerSecond: 140,
    lifetimeInSeconds: 1.6,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/****************************/ /*  Fancy Pink Projectile   */ /****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyPink,
    projectileSpriteId: "projectiles/5/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popPNK",
    impactSpriteScale: 0.5,
    speedPerSecond: 220,
    lifetimeInSeconds: 1.1,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/******************************/ /*  Fancy Purple Projectile   */ /******************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyPurple,
    projectileSpriteId: "projectiles/6/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popPNK2",
    impactSpriteScale: 0.5,
    speedPerSecond: 120,
    lifetimeInSeconds: 2,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/*******************************/ /*  Fancy Crimson Projectile   */ /*******************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyCrimson,
    projectileSpriteId: "projectiles/8/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popPNK",
    impactSpriteScale: 0.5,
    speedPerSecond: 300,
    lifetimeInSeconds: 1.1,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/*****************************/ /*  Fancy White Projectile   */ /*****************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyWhite,
    projectileSpriteId: "projectiles/9/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 0.5,
    speedPerSecond: 205,
    lifetimeInSeconds: 1.25,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/**********************************/ /*  Fancy RainbowTwo Projectile   */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FancyRainbowTwo,
    projectileSpriteId: "projectiles/7/1",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popGRE",
    impactSpriteScale: 0.5,
    speedPerSecond: 275,
    lifetimeInSeconds: 1.2,
    colliderRadius: 3,
    spriteXAnchor: 0.9,
    rotateProjectileSprite: true
});
/**********************************/ /*  Arcane Spark                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.ArcaneSpark,
    projectileSpriteId: "projectiles/arcaneSpark/proj_arcaneSpark",
    projectileSpriteScale: 2,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 100,
    lifetimeInSeconds: 1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Arrow Normal                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.ArrowNormal,
    projectileSpriteId: "projectiles/arrows/proj_arrowNormal",
    projectileSpriteScale: 0.6,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 160,
    lifetimeInSeconds: 1.2,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Star Arrows                   */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.StarArrow,
    projectileSpriteId: "projectiles/arrows/proj_arrowStar",
    projectileSpriteScale: 0.75,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 275,
    lifetimeInSeconds: 1.2,
    colliderRadius: 8,
    spriteXAnchor: 0.6,
    rotateProjectileSprite: true
});
/**********************************/ /*  Blood Arrow                   */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BloodArrow,
    projectileSpriteId: "projectiles/arrows/proj_bloodArrow",
    projectileSpriteScale: 0.75,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 205,
    lifetimeInSeconds: 1.25,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Daryls Bolts                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.DarylsBolt,
    projectileSpriteId: "projectiles/arrows/proj_boltDaryls",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 350,
    lifetimeInSeconds: 1,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Eldritch Bolts                */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.EldritchBolt,
    projectileSpriteId: "projectiles/arrows/proj_boltEldritch",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 230,
    lifetimeInSeconds: 1.1,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  GoldBolt                      */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.GoldBolt,
    projectileSpriteId: "projectiles/arrows/proj_boltGold",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 1.3,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Normal Bolts                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BoltNormal,
    projectileSpriteId: "projectiles/arrows/proj_boltNormal",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 280,
    lifetimeInSeconds: 2,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  ShortBolt                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.ShortBolt,
    projectileSpriteId: "projectiles/arrows/proj_boltNormal",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 280,
    lifetimeInSeconds: 1,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Silver Bolts                */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BoltSilver,
    projectileSpriteId: "projectiles/arrows/proj_boltSilver",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 260,
    lifetimeInSeconds: 1.4,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Celestial Arrow               */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.CelestialArrow,
    projectileSpriteId: "projectiles/arrows/proj_celestialArrow",
    projectileSpriteScale: 0.75,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 300,
    lifetimeInSeconds: 1.3,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Fairy Fire Arrow              */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FairyFireArrow,
    projectileSpriteId: "projectiles/arrows/proj_fairyFire",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 100,
    lifetimeInSeconds: 1,
    colliderRadius: 5,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Fairy Ice Arrow               */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FairyIceArrow,
    projectileSpriteId: "projectiles/arrows/proj_fairyIce",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 1.1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Fairy Light Arrow             */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FairyLightArrow,
    projectileSpriteId: "projectiles/arrows/proj_fairyLight",
    projectileSpriteScale: 0.6,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 1.1,
    colliderRadius: 5,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Fairy Normal Arrow            */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FairyNormalArrow,
    projectileSpriteId: "projectiles/arrows/proj_fairyNormal",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 1.1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Fire Arrow                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FireArrow,
    projectileSpriteId: "projectiles/arrows/proj_fireArrow",
    projectileSpriteScale: 0.75,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 1.1,
    colliderRadius: 5,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Phoenix Arrow                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.PhoenixArrow,
    projectileSpriteId: "projectiles/arrows/proj_fireArrow",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 190,
    lifetimeInSeconds: 1.4,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Giants Arrow                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.GiantsArrow,
    projectileSpriteId: "projectiles/arrows/proj_giantsArrow",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 100,
    lifetimeInSeconds: 1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Golden Arrow                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.GoldenArrow,
    projectileSpriteId: "projectiles/arrows/proj_goldenArrow",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 250,
    lifetimeInSeconds: 1.6,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Guillotine Arrow              */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.GuillotineArrow,
    projectileSpriteId: "projectiles/arrows/proj_guillotineArrow",
    projectileSpriteScale: 0.6,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 200,
    lifetimeInSeconds: 2,
    colliderRadius: 4,
    spriteXAnchor: 0.75,
    rotateProjectileSprite: true
});
/**********************************/ /*  Magic Arrow                   */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.MagicArrow,
    projectileSpriteId: "projectiles/arrows/proj_magicArrow",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 100,
    lifetimeInSeconds: 1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Moon Arrow                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.MoonArrow,
    projectileSpriteId: "projectiles/arrows/proj_moonArrow",
    projectileSpriteScale: 0.6,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 120,
    lifetimeInSeconds: 2,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Reaper Arrows                 */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.ReaperArrow,
    projectileSpriteId: "projectiles/arrows/proj_reaperArrow",
    projectileSpriteScale: 0.6,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 240,
    lifetimeInSeconds: 1.5,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Quincy Arrow                */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.QuincyArrow,
    projectileSpriteId: "projectiles/arrows/proj_arrowQuincy",
    projectileSpriteScale: 0.6,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 210,
    lifetimeInSeconds: 1.35,
    colliderRadius: 4,
    spriteXAnchor: 0.8,
    rotateProjectileSprite: true
});
/**********************************/ /*  Shadow Arrow                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.ShadowArrow,
    projectileSpriteId: "projectiles/arrows/proj_shadowArrow",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 100,
    lifetimeInSeconds: 1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Dark Arrow                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.DarkArrow,
    projectileSpriteId: "projectiles/arrows/proj_darkArrow",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "",
    impactSpriteScale: 1,
    speedPerSecond: 275,
    lifetimeInSeconds: 1.5,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Bees                          */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.Bees,
    projectileSpriteId: "projectiles/bees/proj_bees",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/bees/impact_bees",
    impactSpriteScale: 1,
    speedPerSecond: 150,
    lifetimeInSeconds: 2.5,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/**********************************/ /*  Idle Bees                          */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleBees,
    projectileSpriteId: "projectiles/bees/proj_bees",
    projectileSpriteScale: 3,
    hasImpactPfx: true,
    impactSpriteId: "pfx/bees/impact_bees",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/**********************************/ /*  Blaze                         */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.Blaze,
    projectileSpriteId: "projectiles/blaze/proj_blazePowder",
    projectileSpriteScale: 1.4,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/**********************************/ /*  Coin                          */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.Coin,
    projectileSpriteId: "projectiles/coin/proj_coin",
    projectileSpriteScale: 0.85,
    hasImpactPfx: true,
    impactSpriteId: "pfx/coin/impact_coin",
    impactSpriteScale: 1,
    speedPerSecond: 260,
    lifetimeInSeconds: 1.1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/**********************************/ /*  EyeBall                       */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.EyeBall,
    projectileSpriteId: "projectiles/eyeball/proj_eyeBall",
    projectileSpriteScale: 1.25,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 180,
    lifetimeInSeconds: 2.5,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle EyeBall                       */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleEyeBall,
    projectileSpriteId: "projectiles/eyeball/proj_eyeBall",
    projectileSpriteScale: 3,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Magic Fairy                   */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.MagicFairy,
    projectileSpriteId: "projectiles/fairy/proj_fairy",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/fairy/impact_fairy",
    impactSpriteScale: 0.5,
    speedPerSecond: 200,
    lifetimeInSeconds: 1.6,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Magic Fairy                   */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleMagicFairy,
    projectileSpriteId: "projectiles/fairy/proj_fairy",
    projectileSpriteScale: 2,
    hasImpactPfx: true,
    impactSpriteId: "pfx/fairy/impact_fairy",
    impactSpriteScale: 0.5,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Flame Breath                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FlameBreath,
    projectileSpriteId: "projectiles/flameBreath/proj_flameBreath",
    projectileSpriteScale: 1.25,
    hasImpactPfx: false,
    impactSpriteId: "",
    impactSpriteScale: 1,
    speedPerSecond: 120,
    lifetimeInSeconds: 1.15,
    colliderRadius: 8,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Flame Breath                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleFlameBreath,
    projectileSpriteId: "projectiles/flameBreath/proj_flameBreath",
    projectileSpriteScale: 2,
    hasImpactPfx: false,
    impactSpriteId: "",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 13,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Holy Spark                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.HolySpark,
    projectileSpriteId: "projectiles/holySpark/proj_holySpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 200,
    lifetimeInSeconds: 1,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Holy Spark                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleHolySpark,
    projectileSpriteId: "projectiles/holySpark/proj_holySpark",
    projectileSpriteScale: 2.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12.5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  King Bible                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.KingBible,
    projectileSpriteId: "projectiles/KingBible/proj_bible",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 210,
    lifetimeInSeconds: 2,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Magic Leaf                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.MagicLeaf,
    projectileSpriteId: "projectiles/leaf/proj_leaf",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/leaf/impact_leaf",
    impactSpriteScale: 0.5,
    speedPerSecond: 180,
    lifetimeInSeconds: 2.2,
    colliderRadius: 8,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Magical Spark                 */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.MagicalSpark,
    projectileSpriteId: "projectiles/magicSpark/proj_magicalSpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/magicalSpark/impact_magicalSpark",
    impactSpriteScale: 1,
    speedPerSecond: 225,
    lifetimeInSeconds: 1,
    colliderRadius: 8,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Midas Fist                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.MidasFist,
    projectileSpriteId: "projectiles/midasFist/proj_midasFist",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/midasFist/impact_midasFist",
    impactSpriteScale: 1,
    speedPerSecond: 180,
    lifetimeInSeconds: 2,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Midas Fist                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleMidasFist,
    projectileSpriteId: "projectiles/midasFist/proj_midasFist",
    projectileSpriteScale: 2.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/midasFist/impact_midasFist",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12.5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Poisson                       */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.Poisson,
    projectileSpriteId: "projectiles/poisson/proj_poisson",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/poisson/impact_poisson",
    impactSpriteScale: 1,
    speedPerSecond: 200,
    lifetimeInSeconds: 1.5,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  SlimeBall                     */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.SlimeBall,
    projectileSpriteId: "projectiles/slimeBall/proj_slime",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popGRE",
    impactSpriteScale: 0.5,
    speedPerSecond: 150,
    lifetimeInSeconds: 2,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle SlimeBall                     */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleSlimeBall,
    projectileSpriteId: "projectiles/slimeBall/proj_slime",
    projectileSpriteScale: 3,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popGRE",
    impactSpriteScale: 0.5,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  SpellBinder                   */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.SpellBinder,
    projectileSpriteId: "projectiles/spellbinder/proj_spellbinder",
    projectileSpriteScale: 1.25,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 200,
    lifetimeInSeconds: 2,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/**********************************/ /*  Magic Star                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.MagicStar,
    projectileSpriteId: "projectiles/star/proj_star",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/star/impact_star",
    impactSpriteScale: 1,
    speedPerSecond: 280,
    lifetimeInSeconds: 1.75,
    colliderRadius: 8,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Toxic Clouds                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.ToxicClouds,
    projectileSpriteId: "projectiles/toxicCloud/proj_toxicCloud",
    projectileSpriteScale: 2,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 130,
    lifetimeInSeconds: 1.75,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Toxic Clouds                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleToxicClouds,
    projectileSpriteId: "projectiles/toxicCloud/proj_toxicCloud",
    projectileSpriteScale: 4,
    hasImpactPfx: false,
    impactSpriteId: "pfx/popBLU_001",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  TriForce                      */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.TriForce,
    projectileSpriteId: "projectiles/triforce/proj_triForce",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 2,
    colliderRadius: 8,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Wand Spark                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.WandSpark,
    projectileSpriteId: "projectiles/wandSpark/proj_wandSpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 200,
    lifetimeInSeconds: 1.4,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Iron Spark                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IronSpark,
    projectileSpriteId: "projectiles/ironSpark/proj_blackSpark",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 200,
    lifetimeInSeconds: 1.4,
    colliderRadius: 3,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Iron Spark                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleIronSpark,
    projectileSpriteId: "projectiles/ironSpark/proj_blackSpark",
    projectileSpriteScale: 6,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Twisted Spark                 */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.TwistedSpark,
    projectileSpriteId: "projectiles/twistedSpark/proj_twistedSpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 100,
    lifetimeInSeconds: 1.7,
    colliderRadius: 4,
    spriteXAnchor: 0.7,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Twisted Spark                 */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleTwistedSpark,
    projectileSpriteId: "projectiles/twistedSpark/proj_twistedSpark",
    projectileSpriteScale: 3,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.7,
    rotateProjectileSprite: true
});
/**********************************/ /*  Red Crystal                 */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.RedCrystal,
    projectileSpriteId: "projectiles/redCrystal/proj_redCrystal",
    projectileSpriteScale: 1.4,
    hasImpactPfx: true,
    impactSpriteId: "pfx/redCrystal/impact_redCrystal",
    impactSpriteScale: 1,
    speedPerSecond: 250,
    lifetimeInSeconds: 1,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Candle Light                */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.CandleLight,
    projectileSpriteId: "projectiles/flameSpark/proj_flameSpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 1.5,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Idle Candle Light                */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleCandleLight,
    projectileSpriteId: "projectiles/flameSpark/proj_flameSpark",
    projectileSpriteScale: 3,
    hasImpactPfx: true,
    impactSpriteId: "pfx/wandSpark/impact_wandSpark",
    impactSpriteScale: 1,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 12,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Lich Skull                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.LichSkull,
    projectileSpriteId: "projectiles/lichSkull/proj_lichSkull",
    projectileSpriteScale: 1.25,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 2,
    speedPerSecond: 150,
    lifetimeInSeconds: 2.5,
    colliderRadius: 5,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/**********************************/ /*  Idle Lich Skull                    */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IdleLichSkull,
    projectileSpriteId: "projectiles/lichSkull/proj_lichSkull",
    projectileSpriteScale: 2.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 2,
    speedPerSecond: 0,
    lifetimeInSeconds: 5,
    colliderRadius: 10,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: false
});
/**********************************/ /*  Black Spark                 */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BlackSpark,
    projectileSpriteId: "projectiles/ironSpark/proj_blackSpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/blackSpark/impact_blackSpark",
    impactSpriteScale: 1,
    speedPerSecond: 220,
    lifetimeInSeconds: 0.5,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Hibity Spark                  */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.HibitySpark,
    projectileSpriteId: "projectiles/hibitySpark/proj_hibitySpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/arcaneSpark/impact_arcaneSpark",
    impactSpriteScale: 1,
    speedPerSecond: 300,
    lifetimeInSeconds: 0.7,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  Ice Spark                     */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IceSpark,
    projectileSpriteId: "projectiles/iceSpark/proj_iceSpark",
    projectileSpriteScale: 1.5,
    hasImpactPfx: true,
    impactSpriteId: "pfx/iceSpark/impact_iceSpark",
    impactSpriteScale: 1,
    speedPerSecond: 250,
    lifetimeInSeconds: 0.9,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/**********************************/ /*  FrostWind                     */ /**********************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.FrostWind,
    projectileSpriteId: "projectiles/frostWind/proj_frostWind",
    projectileSpriteScale: 1,
    hasImpactPfx: false,
    impactSpriteId: "pfx/iceSpark/impact_iceSpark",
    impactSpriteScale: 1,
    speedPerSecond: 140,
    lifetimeInSeconds: 0.45,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/***************************/ /*  Zap Spark              */ /***************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.ZapSpark,
    projectileSpriteId: "projectiles/zapSpark/proj_zapSpark",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "pfx/zapSpark/impact_zapSpark",
    impactSpriteScale: 1,
    speedPerSecond: 160,
    lifetimeInSeconds: 1.75,
    colliderRadius: 4,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/***************************/ /*  IronFoxSlash           */ /***************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.IronFoxSlash,
    projectileSpriteId: "projectiles/foxSlash/proj_foxSlash",
    projectileSpriteScale: 1,
    hasImpactPfx: true,
    impactSpriteId: "projectiles/foxSlash/impact_foxSlash",
    impactSpriteScale: 1,
    speedPerSecond: 150,
    lifetimeInSeconds: 3,
    colliderRadius: 15,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/***************************/ /*  Book of Tongues        */ /***************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.BookOfTongues,
    projectileSpriteId: "projectiles/bookOfTongues/proj_bookOfTongues",
    projectileSpriteScale: 1.75,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 1.25,
    speedPerSecond: 285,
    lifetimeInSeconds: 1.5,
    colliderRadius: 6,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});
/***************************/ /*  Deathstick             */ /***************************/ $21a778c44478d8dc$var$setProjectileData({
    id: $21a778c44478d8dc$export$58825bda29b44ca2.Deathstick,
    projectileSpriteId: "projectiles/deathstick/proj_deathstick",
    projectileSpriteScale: 0.4,
    hasImpactPfx: true,
    impactSpriteId: "pfx/popFIR",
    impactSpriteScale: 0.25,
    speedPerSecond: 500,
    lifetimeInSeconds: 0.2,
    colliderRadius: 3,
    spriteXAnchor: 0.5,
    rotateProjectileSprite: true
});


var $0acc22698d702be9$export$52dcef66f96a6ad8;
(function(WeaponFiringType) {
    WeaponFiringType[WeaponFiringType["Hitscan"] = 0] = "Hitscan";
    WeaponFiringType[WeaponFiringType["Projectile"] = 1] = "Projectile";
})($0acc22698d702be9$export$52dcef66f96a6ad8 || ($0acc22698d702be9$export$52dcef66f96a6ad8 = {}));
var $0acc22698d702be9$export$bd41ac242c5af35e;
(function(WeaponClass) {
    WeaponClass[WeaponClass["Staff"] = 0] = "Staff";
    WeaponClass[WeaponClass["Crossbow"] = 1] = "Crossbow";
    WeaponClass[WeaponClass["Bow"] = 2] = "Bow";
    WeaponClass[WeaponClass["Wand"] = 3] = "Wand";
    WeaponClass[WeaponClass["Spellbook"] = 4] = "Spellbook";
})($0acc22698d702be9$export$bd41ac242c5af35e || ($0acc22698d702be9$export$bd41ac242c5af35e = {}));
const $0acc22698d702be9$export$c3ce097c7a5ba27d = new Map();
const $0acc22698d702be9$var$setWeaponData = (weaponConfig)=>{
    const existingEntryWithId = $0acc22698d702be9$export$c3ce097c7a5ba27d.get(weaponConfig.id);
    if (existingEntryWithId) throw new Error(`WeaponConfig with id ${weaponConfig.id} already exists! Error in weapon data file.`);
    $0acc22698d702be9$export$c3ce097c7a5ba27d.set(weaponConfig.id, weaponConfig);
};
const $0acc22698d702be9$export$f96416c73a613aba = (id)=>{
    const weaponConfig = $0acc22698d702be9$export$c3ce097c7a5ba27d.get(id);
    if (!weaponConfig) throw new Error(`WeaponConfig with id ${id} does not exist! Error in weapon data file.`);
    return weaponConfig;
};
/*************************/ /*      Staves           */ /*************************/ $0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_ApprenticesStaff,
    inGameSpriteId: "weapons/Apprentices_Staff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 20,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.8,
    playerMovementMultiplier: 1.1,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleBlue),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_FlamespitterStaff,
    inGameSpriteId: "weapons/Flamespitter_Staff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 23,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.8,
    playerMovementMultiplier: 1.15,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleFlameBreath),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_StaffOfTheSnake,
    inGameSpriteId: "weapons/staff_staffOfTheSnake.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 24,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.9,
    playerMovementMultiplier: 1.15,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleToxicClouds),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_ArchmagesSidekick,
    inGameSpriteId: "weapons/Arcane_Staff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 21,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.9,
    playerMovementMultiplier: 1.1,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdlePink),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_SamsStirringStick,
    inGameSpriteId: "weapons/staff_samsStirringStick.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 25,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3,
    playerMovementMultiplier: 1.15,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleBlue),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_CandlelightStaff,
    inGameSpriteId: "weapons/staff_candleLight.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 22,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3,
    playerMovementMultiplier: 1.1,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdlePink),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_TwistedBranch,
    inGameSpriteId: "weapons/staff_twistedBranch.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 19,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.6,
    playerMovementMultiplier: 1.1,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleBlue),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_IronStaff,
    inGameSpriteId: "weapons/staff_ironStaff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 18,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.5,
    playerMovementMultiplier: 1.1,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleBlue),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_PharaohsStaff,
    inGameSpriteId: "weapons/staff_pharoahsStaff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 35,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3,
    playerMovementMultiplier: 1.25,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleHolySpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_FairyStaff,
    inGameSpriteId: "weapons/staff_fairyStaff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 34,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.9,
    playerMovementMultiplier: 1.25,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleMagicFairy),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_MidasStaff,
    inGameSpriteId: "weapons/staff_midasStaff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 40,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3,
    playerMovementMultiplier: 1.3,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleMidasFist),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_DemonsEye,
    inGameSpriteId: "weapons/staff_demonsEye.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 30,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3,
    playerMovementMultiplier: 1.2,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleEyeBall),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_SlimeStaff,
    inGameSpriteId: "weapons/staff_slimeStaff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 26,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3.1,
    playerMovementMultiplier: 1.15,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleBlue),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_BeesOnAStick,
    inGameSpriteId: "weapons/staff_beeStick.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 38,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 2.9,
    playerMovementMultiplier: 1.3,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleBees),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_LichsStaff,
    inGameSpriteId: "weapons/staff_lichStaff.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 27,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3.2,
    playerMovementMultiplier: 1.15,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleLichSkull),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_FrostFlicker,
    inGameSpriteId: "weapons/staff_frostFlicker.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 36,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 3.1,
    playerMovementMultiplier: 1.25,
    playerMovementMultiplierDurationInSeconds: 0.5,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IdleBlue),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Staff
});
/*************************/ /*     Crossbows         */ /*************************/ $0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_CrudeCrossbow,
    inGameSpriteId: "weapons/Crossbow_Wood.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 10,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.5,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BoltNormal),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_GuardsCrossbow,
    inGameSpriteId: "weapons/crossbow_guards.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 6.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: true,
    cooldownInSeconds: 1,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BoltNormal),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_SteelCrossbow,
    inGameSpriteId: "weapons/Crossbow_Steel.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 9,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Bleed,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.3,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BoltNormal),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_ReliqueryCrossbow,
    inGameSpriteId: "weapons/Crossbow_Black.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 11,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.6,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BoltNormal),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_EldritchBlasters,
    inGameSpriteId: "weapons/crossbow_eldritchBlasters.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 4.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.54,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).EldritchBolt),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_DarylsInstinct,
    inGameSpriteId: "weapons/crossbow_darylsInstinct.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 11,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Bleed,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.16,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).DarylsBolt),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_FathersBane,
    inGameSpriteId: "weapons/crossbow_fathersBane.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 12.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.32,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).GoldBolt),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_WitchHuntersRepeaters,
    inGameSpriteId: "weapons/crossbow_witchHuntersRepeater.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 7.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.9,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BoltSilver),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_WyvernsTalon,
    inGameSpriteId: "weapons/crossbow_wyvernTalon.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 9.25,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Bleed,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.75,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).ShortBolt),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_TheCrossBow,
    inGameSpriteId: "weapons/crossbow_theCrossBow.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 8.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.65,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).GoldBolt),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Crossbow
});
/*************************/ /*     Bows              */ /*************************/ $0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_RangersGuillotine,
    inGameSpriteId: "weapons/bow_rangersGuillotine.png",
    inGameSpriteScale: 0.75,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 17,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.22,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).GuillotineArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_DavidBowie,
    inGameSpriteId: "weapons/bow_woodenShortbow.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 3.7,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.55,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).ArrowNormal),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_Emberstrike,
    inGameSpriteId: "weapons/bow_emberStrike.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 4.4,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.6,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).FireArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_MoonShadow,
    inGameSpriteId: "weapons/bow_moonShadow.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 6.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.75,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).MoonArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_FairyBow,
    inGameSpriteId: "weapons/bow_fairyBow.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 7,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.9,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).FairyLightArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_Bloodrider,
    inGameSpriteId: "weapons/bow_bloodRider.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 9,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Bleed,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BloodArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_PhoenixWing,
    inGameSpriteId: "weapons/bow_phoenixWing.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 10,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.1,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).FireArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_DivineWind,
    inGameSpriteId: "weapons/bow_divineWind.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 18,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.3,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).GoldenArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_StarShot,
    inGameSpriteId: "weapons/bow_starShot.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 12,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.5,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).StarArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_CelestialBow,
    inGameSpriteId: "weapons/bow_celestialBow.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 14.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.18,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).CelestialArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_ReapersEmbrace,
    inGameSpriteId: "weapons/bow_reapersEmbrace.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 16,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.64,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).ReaperArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_QuincyBow,
    inGameSpriteId: "weapons/bow_quincyBow.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 10,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).QuincyArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_SilentShadow,
    inGameSpriteId: "weapons/bow_silentShadow.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 16,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.2,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).DarkArrow),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Bow
});
/**************************/ /*     Wands              */ /**************************/ $0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_Stick,
    inGameSpriteId: "weapons/wand_stick.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 2.6,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.4,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).WandSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_SpiraledWand,
    inGameSpriteId: "weapons/wand_spiraleWand.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 5.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.9,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).TwistedSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_NightStick,
    inGameSpriteId: "weapons/wand_nightStick.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 8.4,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.3,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IceSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_DragonsBreath,
    inGameSpriteId: "weapons/wand_dragonsBreath.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 3.3,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.3,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).FlameBreath),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_PoseidonsWand,
    inGameSpriteId: "weapons/wand_poissidonsWandn.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 7,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.76,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).Poisson),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_BrokenDeathstick,
    inGameSpriteId: "weapons/wand_brokenDeathstick.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 6,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.8,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).ArcaneSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_HibidyKibity,
    inGameSpriteId: "weapons/wand_hibidyKibity.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 11.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.67,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).HibitySpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_MagicalWand,
    inGameSpriteId: "weapons/wand_magicalWand.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 7.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.5,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).MagicalSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_BlackDahliaWand,
    inGameSpriteId: "weapons/wand_blackDahlia.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 9,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.4,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).WandSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_FrostedTips,
    inGameSpriteId: "weapons/wand_frostedTips.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 5.5,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.7,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IceSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_RelicWand,
    inGameSpriteId: "weapons/wand_relicWand.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 10,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.1,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).RedCrystal),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_ZappingWand,
    inGameSpriteId: "weapons/wand_zappingWand.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 10,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1.2,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).IceSpark),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_IcewindWand,
    inGameSpriteId: "weapons/wand_icewindWand.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 1.9,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.28,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).FrostWind),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_BlazeRod,
    inGameSpriteId: "weapons/wand_blazeRod.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 6.9,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 1,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).Blaze),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_ToxicWand,
    inGameSpriteId: "weapons/wand_toxicWand.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 4,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.58,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BasicGreen),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_StarWand,
    inGameSpriteId: "weapons/wand_starWand.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 7.1,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.9,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).MagicStar),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});
/*******************************/ /*     Spellbooks              */ /*******************************/ $0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_SpellbindersTome,
    inGameSpriteId: "weapons/spell_spellbindersTome.png",
    inGameSpriteScale: 0.8,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 15,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 5,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).SpellBinder),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Spellbook
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_Triforce,
    inGameSpriteId: "weapons/spell_triForce.png",
    inGameSpriteScale: 0.6,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 25,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 6.5,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).TriForce),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Spellbook
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_WizardsLedger,
    inGameSpriteId: "weapons/spell_wizardsLedger.png",
    inGameSpriteScale: 1,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 1,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.136,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).Coin),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Spellbook
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_NaturesReturn,
    inGameSpriteId: "weapons/spell_naturesReturn.png",
    inGameSpriteScale: 0.6,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 40,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 8,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).MagicLeaf),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Spellbook
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_KingBible,
    inGameSpriteId: "weapons/spell_kingBible.png",
    inGameSpriteScale: 0.5,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 27,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 7,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).KingBible),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Spellbook
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_BookOfTongues,
    inGameSpriteId: "weapons/spell_bookOfTongues.png",
    inGameSpriteScale: 0.5,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 35,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 7.5,
    playerMovementMultiplier: 1,
    playerMovementMultiplierDurationInSeconds: 1,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).BookOfTongues),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Spellbook
});
$0acc22698d702be9$var$setWeaponData({
    id: (0, $faa1b3449016497b$export$6d08773d2e66f8f2).W_Deathstick,
    inGameSpriteId: "weapons/wand_Deathstick.png",
    inGameSpriteScale: 0.75,
    firingType: $0acc22698d702be9$export$52dcef66f96a6ad8.Projectile,
    damage: 2,
    damageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    randomizeProjectileAimAngle: false,
    cooldownInSeconds: 0.12,
    playerMovementMultiplier: 0.55,
    playerMovementMultiplierDurationInSeconds: .75,
    projectileConfig: (0, $21a778c44478d8dc$export$290d3183f69b75ee)((0, $21a778c44478d8dc$export$58825bda29b44ca2).Deathstick),
    weaponClass: $0acc22698d702be9$export$bd41ac242c5af35e.Wand
});


(0, $fcbcf105ed644495$export$a5a6e0b888b2c992).SCALE_MODE = (0, $551209d754b5b429$export$6b734c6a0bba8473).NEAREST;
class $21f6279970269d97$export$f4e85fe081cb5cf0 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.CameraZoomLevel = (0, $dd72312a1effc8b4$export$c5154272f94334ca).DEFAULT_CAMERA_ZOOM;
        this.backgroundLayerOne = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.backgroundLayerTwo = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.middlegroundLayer = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.entityLayer = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.foregroundLayerOne = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.foregroundLayerTwo = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.MyLocalEntityHasInformationPassive = false;
        this.clickedGameRendererThisFrame = false;
        this.cameraFollowSettings = {
            speed: (0, $dd72312a1effc8b4$export$c5154272f94334ca).FOLLOW_SPEED,
            acceleration: (0, $dd72312a1effc8b4$export$c5154272f94334ca).FOLLOW_ACCELERATION,
            radius: (0, $dd72312a1effc8b4$export$c5154272f94334ca).FOLLOW_RADIUS
        };
    }
    Initialize() {
        const canvas = document.getElementById("game-canvas");
        const gameContainer = document.getElementById("game-container");
        const rendererContainerWidth = parseInt(window.getComputedStyle(gameContainer).width, 10);
        const rendererContainerHeight = parseInt(window.getComputedStyle(gameContainer).height, 10);
        this.pixiOptions = {
            view: canvas,
            width: rendererContainerWidth,
            height: rendererContainerHeight,
            antialias: false,
            resolution: 1,
            backgroundColor: "#000000",
            backgroundAlpha: 1,
            clearBeforeRender: true,
            context: null,
            powerPreference: "default",
            premultipliedAlpha: false,
            preserveDrawingBuffer: false,
            hello: true
        };
        this.pixiApplication = new (0, $1495858258e0a7a4$export$16975c34e60e1e61)(this.pixiOptions);
        if ((0, $433dc5f32a7437eb$export$31154e48b1cf2ba0).DEBUG.ENABLE_STATS) this.stats = (0, $d83e58a633e2e1c1$export$f2b48b4cd11b43fc)(document, this.pixiApplication);
        this.camera = new (0, $867beeb89be92199$export$d5c6c08dc2d3ca7)({
            screenWidth: rendererContainerWidth,
            screenHeight: rendererContainerHeight,
            worldWidth: (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_SIZE,
            worldHeight: (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_SIZE,
            events: this.pixiApplication.renderer.events
        });
        if ((0, $dd72312a1effc8b4$export$c5154272f94334ca).DEBUG.DEFAULT_MEGA_ZOOMED_OUT) this.camera.setZoom(1);
        else {
            if (window.innerWidth >= 1600 && window.innerHeight >= 900) {
                console.log("Setting zoom to default");
                this.CameraZoomLevel = (0, $dd72312a1effc8b4$export$c5154272f94334ca).DEFAULT_CAMERA_ZOOM;
            } else if (window.innerWidth >= 1280 && window.innerHeight >= 720) // console.log("Setting zoom to 2.5");
            this.CameraZoomLevel = 2.5;
            else if (window.innerWidth > 1000 && window.innerHeight > 900) // console.log("Setting zoom to 2.25");
            this.CameraZoomLevel = 2.25;
            else if (window.innerWidth > 860 && window.innerHeight > 720) // console.log("Setting zoom to 2");
            this.CameraZoomLevel = 2;
            else if (window.innerWidth > 650 && window.innerHeight > 550) // console.log("Setting zoom to 2");
            this.CameraZoomLevel = 1.75;
            else // console.log("Setting zoom to 1.5");
            this.CameraZoomLevel = 1.5;
            this.camera.setZoom(this.CameraZoomLevel, true);
        }
        this.backgroundImageOne = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)((0, $fff9e028a285d5fa$export$c8eca95e306f7116).get("background-layer1"));
        this.backgroundImageOne.position.set(0, 0);
        this.backgroundLayerOne.addChild(this.backgroundImageOne);
        this.camera.addChild(this.backgroundLayerOne);
        this.backgroundImageTwo = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)((0, $fff9e028a285d5fa$export$c8eca95e306f7116).get("background-layer2"));
        this.backgroundImageTwo.position.set(0, 0);
        this.backgroundLayerTwo.addChild(this.backgroundImageTwo);
        this.camera.addChild(this.backgroundLayerTwo);
        this.middlegroundImage = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)((0, $fff9e028a285d5fa$export$c8eca95e306f7116).get("middleground-layer"));
        this.middlegroundImage.position.set(0, 0);
        this.middlegroundLayer.addChild(this.middlegroundImage);
        this.camera.addChild(this.middlegroundLayer);
        this.entityLayer.sortableChildren = true;
        this.camera.addChild(this.entityLayer);
        this.foregroundImageOne = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)((0, $fff9e028a285d5fa$export$c8eca95e306f7116).get("foreground-layer1"));
        this.foregroundImageOne.position.set(0, 0);
        this.foregroundLayerOne.addChild(this.foregroundImageOne);
        this.camera.addChild(this.foregroundLayerOne);
        this.foregroundImageTwo = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)((0, $fff9e028a285d5fa$export$c8eca95e306f7116).get("foreground-layer2"));
        this.foregroundImageTwo.position.set(0, 0);
        this.foregroundLayerTwo.addChild(this.foregroundImageTwo);
        this.camera.addChild(this.foregroundLayerTwo);
        if ((0, $c52f191d3f575144$export$c14d6c08f0e74a8e).DEBUG.DRAW_COLLISION_TILE_LAYER) {
            this.collisionImage = new (0, $28766cd6a31d5ed8$export$3075603db8e6204c)((0, $fff9e028a285d5fa$export$c8eca95e306f7116).get("collisions-layer"));
            this.collisionImage.position.set(0, 0);
            this.camera.addChild(this.collisionImage);
        }
        let crossbowCrosshair;
        let bowCrosshair;
        let wandCrosshair;
        let spellbookCrosshair;
        let staffCrosshair;
        if (window.innerWidth >= 1280) {
            crossbowCrosshair = "url('crosshairs/crosshair_crossbow.png') 28 28,auto";
            bowCrosshair = "url('crosshairs/crosshair_bow.png') 28 28,auto";
            wandCrosshair = "url('crosshairs/crosshair_wand.png') 28 28,auto";
            spellbookCrosshair = "url('crosshairs/crosshair_spellbook.png') 28 28,auto";
            staffCrosshair = "url('crosshairs/crosshair_staff.png') 28 28,auto";
        } else {
            crossbowCrosshair = "url('crosshairs/crosshair_crossbow_small.png') 14 14,auto";
            bowCrosshair = "url('crosshairs/crosshair_bow_small.png') 14 14,auto";
            wandCrosshair = "url('crosshairs/crosshair_wand_small.png') 14 14,auto";
            spellbookCrosshair = "url('crosshairs/crosshair_spellbook_small.png') 14 14,auto";
            staffCrosshair = "url('crosshairs/crosshair_staff_small.png') 14 14,auto";
        }
        this.pixiApplication.renderer.events.cursorStyles.spellbook = spellbookCrosshair;
        this.pixiApplication.renderer.events.cursorStyles.wand = wandCrosshair;
        this.pixiApplication.renderer.events.cursorStyles.bow = bowCrosshair;
        this.pixiApplication.renderer.events.cursorStyles.crossbow = crossbowCrosshair;
        this.pixiApplication.renderer.events.cursorStyles.staff = staffCrosshair;
        this.pixiApplication.renderer.events.cursorStyles.default = staffCrosshair;
        // this.pixiApplication.renderer.events.setCursor("staff");
        // @ts-ignore
        // this.pixiApplication.renderer.events.currentCursor = "spellbook";
        // console.warn(this.pixiApplication.renderer.events);
        Game.ListenForEvent("Gameplay::NewWeaponClassEquipped", (event)=>{
            // @ts-ignore
            const { newWeaponClass: newWeaponClass  } = event;
            switch(newWeaponClass){
                case (0, $0acc22698d702be9$export$bd41ac242c5af35e).Staff:
                    // console.log("setting to Staff crosshair");
                    this.pixiApplication.renderer.events.cursorStyles.default = staffCrosshair;
                    this.pixiApplication.renderer.events.setCursor(staffCrosshair);
                    break;
                case (0, $0acc22698d702be9$export$bd41ac242c5af35e).Crossbow:
                    // console.log("setting to Crossbow crosshair");
                    this.pixiApplication.renderer.events.cursorStyles.default = crossbowCrosshair;
                    this.pixiApplication.renderer.events.setCursor(crossbowCrosshair);
                    break;
                case (0, $0acc22698d702be9$export$bd41ac242c5af35e).Bow:
                    // console.log("setting to Bow crosshair");
                    this.pixiApplication.renderer.events.cursorStyles.default = bowCrosshair;
                    this.pixiApplication.renderer.events.setCursor(bowCrosshair);
                    break;
                case (0, $0acc22698d702be9$export$bd41ac242c5af35e).Wand:
                    // console.log("setting to Wand crosshair");
                    this.pixiApplication.renderer.events.cursorStyles.default = wandCrosshair;
                    this.pixiApplication.renderer.events.setCursor(wandCrosshair);
                    break;
                case (0, $0acc22698d702be9$export$bd41ac242c5af35e).Spellbook:
                    // console.log("setting to Spellbook crosshair");
                    this.pixiApplication.renderer.events.cursorStyles.default = spellbookCrosshair;
                    this.pixiApplication.renderer.events.setCursor(spellbookCrosshair);
                    break;
                default:
                    // console.warn("default cause hit");
                    this.pixiApplication.renderer.events.cursorStyles.default = staffCrosshair;
                    this.pixiApplication.renderer.events.setCursor(staffCrosshair);
                    break;
            }
        // console.log("new weapon class equipped: ", WeaponClass[newWeaponClass]);
        });
        this.pixiApplication.stage.addChild(this.camera);
        this.pixiApplication.stage.interactive = true;
        this.pixiApplication.stage.on("pointerdown", (event)=>{
            this.clickedGameRendererThisFrame = true;
        });
        this.pixiApplication.stage.on("pointerup", (event)=>{
            this.clickedGameRendererThisFrame = false;
        });
        if ((0, $dd72312a1effc8b4$export$c5154272f94334ca).DEBUG.ALLOW_ZOOM) this.camera.wheel().pinch();
        this.camera.clamp({
            direction: "all"
        });
        Game.ListenForEvent("Resizer::RealtimeGameWindowResize", this.Resize.bind(this));
        Game.ListenForEvent("Resizer::GameWindowResizeComplete", this.Resize.bind(this));
        Game.ListenForEvent("Bootstrap::MyEntitiesNidIsKnown", (event)=>{
            const { myId: myId , myX: myX , myY: myY  } = event;
            this.MyLocalNonPredictedEntityNid = myId;
            // this.camera.position.set(myX, myY);
            this.camera.animate({
                time: 0,
                position: new (0, $88931fa1c0809be8$export$baf26146a414f24a)(myX, myY)
            });
        });
        // TODO: Why doesnt this work?!
        Game.ListenForEvent("debug:testCameraBounce", ()=>{
            const cameraBounceOptions = {
                sides: "all",
                friction: 0.5,
                time: 5000
            };
            this.camera.bounce(cameraBounceOptions);
        });
        // this.debugBackground = new Graphics();
        // this.debugBackground.beginFill(0x698d41);
        // this.debugBackground.drawRect(0, 0, worldConfig.WORLD_SIZE, worldConfig.WORLD_SIZE);
        // this.debugBackground.endFill();
        // this.AddRenderedEntity(this.debugBackground);
        this.LogInfo("Ready!");
    }
    PlayOneOffPfx(x, y, pfxId, pfxScale, rotation, overrideAnimationSpeed) {
        const pfx = new (0, $e6a89d1e24ad5bef$export$1ab9f6b591c1e54)(x, y, pfxId, pfxScale, rotation, overrideAnimationSpeed);
        this.AddRenderedEntity(pfx);
    }
    getSystemName() {
        return "Renderer";
    }
    ClickedRendererThisFrame() {
        return this.clickedGameRendererThisFrame;
    }
    UnsetClickedRendererThisFrame() {
        this.clickedGameRendererThisFrame = false;
    }
    Update(__deltaTime) {
        if ((0, $433dc5f32a7437eb$export$31154e48b1cf2ba0).DEBUG.ENABLE_STATS && this.stats) this.stats.update((0, $bc7ed83ac944008c$export$688aaf132ba9b379).UTILITY);
        // Lazily associated our local entity if it isnt already
        if (this.MyLocalNonPredictedEntityNid !== undefined && this.MyLocalNonPredictedEntity === undefined) {
            // It may not be created yet! Try grabbing it by nid
            const entity = Game.GetEntityByNid(this.MyLocalNonPredictedEntityNid);
            // If we successfully found it, that means it exists and is fully initialized
            if (entity) {
                this.LogInfo("my entity is identified, and we got their actual entity");
                this.MyLocalNonPredictedEntity = entity;
                this.MyLocalNonPredictedEntity.IdentifyAsMyPlayer();
                Game.EmitEvent("Bootstrap::MyServerSideEntityIsFullyCreatedLocally", {
                    myEntity: this.MyLocalNonPredictedEntity
                });
                if (this.MyLocalNonPredictedEntity.hasInformationPassiveItem) this.MyLocalEntityHasInformationPassive = true;
                if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION) Game.EmitEvent("Prediction::ReadyToCreatePredictedEntity", {
                    originalCreationPayload: this.MyLocalNonPredictedEntity.originalCreationPayload
                });
                else this.StartFollowing(this.MyLocalNonPredictedEntityNid, this.MyLocalNonPredictedEntity);
            }
        }
    // uncomment to see how many rendered entities exist. handy to see if we are leaking memory by not cleaning up children
    // if (this.camera) this.LogInfo(this.camera.children.length);
    }
    Cleanup() {}
    AddDebugGraphics(graphics) {
        this.foregroundLayerTwo.addChild(graphics);
    }
    AddRenderedEntity(renderedEntity) {
        this.entityLayer.addChild(renderedEntity.RenderedEntity);
    }
    RemoveRenderedEntity(renderedEntity) {
        this.entityLayer.removeChild(renderedEntity.RenderedEntity);
    }
    Resize({ newWidth: newWidth , newHeight: newHeight  }) {
        this.camera.resize(newWidth, newHeight);
        this.pixiApplication.renderer.resize(newWidth, newHeight);
    }
    StartFollowing(nid, entity) {
        this.LogInfo(`Started following entity with nid: ${nid}`);
        if (entity && entity.RenderedEntity) this.camera.follow(entity.RenderedEntity, this.cameraFollowSettings);
        else console.warn(`unable to follow entity with nid ${nid} because our client doesnt think it exists`);
    }
    StopFollowing() {
        this.LogInfo("Stopping following entity");
        this.camera.plugins.remove("follow");
    }
    GetMyLocalAuthoritativeEntityX() {
        if (this.MyLocalNonPredictedEntity === undefined) return 0;
        return this.MyLocalNonPredictedEntity.x;
    }
    GetMyLocalAuthoritativeEntityY() {
        if (this.MyLocalNonPredictedEntity === undefined) return 0;
        return this.MyLocalNonPredictedEntity.y;
    }
    _drawGrid() {
    // const grid = new Container();
    // const { GRID_CELL_SIZE } = collisionConfig;
    // for (let x = 0; x < worldConfig.WORLD_SIZE; x += GRID_CELL_SIZE) {
    //     for (let y = 0; y < worldConfig.WORLD_SIZE; y += GRID_CELL_SIZE) {
    //         const cell = new Graphics();
    //         cell.lineStyle(30, 0x000000);
    //         cell.drawRect(x, y, GRID_CELL_SIZE, GRID_CELL_SIZE);
    //         grid.addChild(cell);
    //     }
    // }
    // const WORLD_EDGE_LINE_WIDTH = 8;
    // const LINE_WIDTH = 40; // Width of the lines
    // const WORLD_EDGE_LINE_COLOR = 0x000000;
    // const LINE_COLOR = 0x64863e; // Color of the lines
    // // Loop through and draw the horizontal lines (excluding world bounds lines)
    // for (let y = GRID_CELL_SIZE; y <= worldConfig.WORLD_SIZE - GRID_CELL_SIZE; y += GRID_CELL_SIZE) {
    //     const line = new Graphics();
    //     line.lineStyle(LINE_WIDTH, LINE_COLOR);
    //     line.moveTo(0, y);
    //     line.lineTo(worldConfig.WORLD_SIZE, y);
    //     grid.addChild(line);
    // }
    // // Loop through and draw the vertical lines (excluding world bounds lines)
    // for (let x = GRID_CELL_SIZE; x <= worldConfig.WORLD_SIZE - GRID_CELL_SIZE; x += GRID_CELL_SIZE) {
    //     const line = new Graphics();
    //     line.lineStyle(LINE_WIDTH, LINE_COLOR);
    //     line.moveTo(x, 0);
    //     line.lineTo(x, worldConfig.WORLD_SIZE);
    //     grid.addChild(line);
    // }
    // // Draw the horizontal line on the top of the world border
    // const topBorder = new Graphics();
    // topBorder.lineStyle(WORLD_EDGE_LINE_WIDTH, WORLD_EDGE_LINE_COLOR);
    // topBorder.moveTo(0, 0);
    // topBorder.lineTo(worldConfig.WORLD_SIZE, 0);
    // grid.addChild(topBorder);
    // // Draw the horizontal line on the bottom of the world border
    // const bottomBorder = new Graphics();
    // bottomBorder.lineStyle(WORLD_EDGE_LINE_WIDTH, WORLD_EDGE_LINE_COLOR);
    // bottomBorder.moveTo(0, worldConfig.WORLD_SIZE);
    // bottomBorder.lineTo(worldConfig.WORLD_SIZE, worldConfig.WORLD_SIZE);
    // grid.addChild(bottomBorder);
    // // Draw the vertical line on the left side of the world border
    // const leftBorder = new Graphics();
    // leftBorder.lineStyle(WORLD_EDGE_LINE_WIDTH, WORLD_EDGE_LINE_COLOR);
    // leftBorder.moveTo(0, 0);
    // leftBorder.lineTo(0, worldConfig.WORLD_SIZE);
    // grid.addChild(leftBorder);
    // // Draw the vertical line on the right side of the world border
    // const rightBorder = new Graphics();
    // rightBorder.lineStyle(WORLD_EDGE_LINE_WIDTH, WORLD_EDGE_LINE_COLOR);
    // rightBorder.moveTo(worldConfig.WORLD_SIZE, 0);
    // rightBorder.lineTo(worldConfig.WORLD_SIZE, worldConfig.WORLD_SIZE);
    // grid.addChild(rightBorder);
    // if (collisionConfig.DEBUG.DRAW_COLLISION_GRID_TEXT) {
    //     for (let x = 0; x <= worldConfig.WORLD_SIZE; x += GRID_CELL_SIZE) {
    //         if (x === worldConfig.WORLD_SIZE) continue;
    //         for (let y = 0; y < worldConfig.WORLD_SIZE; y += GRID_CELL_SIZE) {
    //             const somePixiText = new Text(`${x}x,${y}y`, {
    //                 fontFamily: 'Fira Code',
    //                 fontSize: 64,
    //                 fill: 0xffffff
    //             });
    //             somePixiText.x = x + 5;
    //             somePixiText.y = y + 5;
    //             somePixiText.scale.set(0.1);
    //             const rect = new Graphics();
    //             rect.beginFill(0x000000);
    //             rect.drawRect(0, 0, LINE_WIDTH, LINE_WIDTH);
    //             rect.endFill();
    //             rect.x = x - LINE_WIDTH / 2;
    //             rect.y = y - LINE_WIDTH / 2;
    //             grid.addChild(rect);
    //             this.AddRenderedEntity(somePixiText);
    //         }
    //     }
    // }
    // this.AddRenderedEntity(grid);
    }
}



var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;


class $831f1ac66545ac96$export$8a8d879dc6224ad5 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.isDragging = false;
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.initialGameContainerWidth = 0;
        this.initialGameContainerHeight = 0;
        const gameContainer = document.getElementById("game-container");
        this.gameContainerRef = gameContainer;
        this.dragHandle = this.gameContainerRef.querySelector(".drag-handle");
        this.gameCanvasRef = document.getElementById("game-canvas");
    }
    getSystemName() {
        return "Resizer";
    }
    Initialize() {
        this._forceCanvasToMatchContainerSize();
        const { scaledWidth: scaledWidth , scaledHeight: scaledHeight  } = this.GetVisibleWorldBoundsWithCameraScale();
        this.lastCommumicatedViewWidth = scaledWidth;
        this.lastCommunicatedViewHeight = scaledHeight;
        // Add an event listener to the drag handle to detect when the user clicks and starts dragging
        this.dragHandle.addEventListener("mousedown", (e)=>{
            this.LogVerbose("Mouse down of drag handle was fired");
            // Set the isDragging variable to true
            this.isDragging = true;
            // Store the starting position of the mouse and the starting size of the game container
            this.dragStartX = e.pageX;
            this.dragStartY = e.pageY;
            this.initialGameContainerWidth = this._getGameContainerWidth();
            this.initialGameContainerHeight = this._getGameContainerHeight();
            // Prevent default browser behavior (e.g. highlighting text) while dragging
            e.preventDefault();
        });
        // Add an event listener to the document to detect when the user stops dragging
        // Frustratingly, this event needs to listen on document specifically, because if you release your mouse off of
        // the element that started the drag, it doesnt fire the mouse up event. Stupid!
        document.addEventListener("mouseup", ()=>{
            this.LogVerbose("Mouse up of drag handle was fired");
            if (this.isDragging === true) // Set the isDragging variable to false
            this.isDragging = false;
        });
        // Add an event listener to the document to detect when the user is dragging
        document.addEventListener("mousemove", (e)=>{
            // Check if the user is currently dragging the drag handle
            if (this.isDragging) {
                this.LogVerbose("Mouse move of drag handle was fired");
                // Calculate the difference between the current position of the mouse and the starting position
                const deltaX = e.pageX - this.dragStartX;
                const deltaY = e.pageY - this.dragStartY;
                // Set the new size and position of the game container and canvas element based on the starting size and position plus the difference
                this.gameContainerRef.style.width = this.initialGameContainerWidth + deltaX + "px";
                this.gameContainerRef.style.height = this.initialGameContainerHeight + deltaY + "px";
                this._forceCanvasToMatchContainerSize();
                Game.EmitEvent("Resizer::RealtimeGameWindowResize", {
                    newWidth: this._getGameContainerWidth(),
                    newHeight: this._getGameContainerHeight()
                });
            }
        });
        document.addEventListener("mouseup", (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(this._onGameWindowResized.bind(this), 100));
        window.onresize = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(this._onGameWindowResized.bind(this), 100);
        this.LogInfo("Ready!");
    }
    GetVisibleWorldBoundsWithCameraScale() {
        const canvasDomWidth = parseInt(this.gameCanvasRef.style.width, 10);
        const canvasDomHeight = parseInt(this.gameCanvasRef.style.height, 10);
        return {
            width: canvasDomWidth,
            height: canvasDomHeight,
            scaledWidth: Math.ceil(canvasDomWidth / Game.Renderer.CameraZoomLevel),
            scaledHeight: Math.ceil(canvasDomHeight / Game.Renderer.CameraZoomLevel)
        };
    }
    _forceCanvasToMatchContainerSize() {
        this.gameCanvasRef.style.width = this._getGameContainerWidth() + "px";
        this.gameCanvasRef.style.height = this._getGameContainerHeight() + "px";
    }
    _getGameContainerWidth() {
        return parseInt(window.getComputedStyle(this.gameContainerRef).width, 10);
    }
    _getGameContainerHeight() {
        return parseInt(window.getComputedStyle(this.gameContainerRef).height, 10);
    }
    _onGameWindowResized() {
        this._forceCanvasToMatchContainerSize();
        const { width: width , height: height , scaledWidth: scaledWidth , scaledHeight: scaledHeight  } = this.GetVisibleWorldBoundsWithCameraScale();
        if (scaledHeight !== this.lastCommunicatedViewHeight || scaledWidth !== this.lastCommumicatedViewWidth) {
            this.lastCommunicatedViewHeight = scaledHeight;
            this.lastCommumicatedViewWidth = scaledWidth;
            Game.EmitEvent("Resizer::GameWindowResizeComplete", {
                newWidth: width,
                newHeight: height,
                newScaledWidth: scaledWidth,
                newScaledHeight: scaledHeight
            });
        }
    }
    Update(__deltaTime) {}
    Cleanup() {
        this.LogInfo("Cleaning up...");
    }
}


var $688d8a22fbcfc874$exports = {};
"use strict";
var $688d8a22fbcfc874$var$__createBinding = $688d8a22fbcfc874$exports && $688d8a22fbcfc874$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $688d8a22fbcfc874$var$__exportStar = $688d8a22fbcfc874$exports && $688d8a22fbcfc874$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $688d8a22fbcfc874$var$__createBinding(exports1, m, p);
};
Object.defineProperty($688d8a22fbcfc874$exports, "__esModule", {
    value: true
});

// server
$688d8a22fbcfc874$var$__exportStar((parcelRequire("824SG")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("a1Glk")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("hJuLK")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("5ERau")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("dnI4a")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("ajywS")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("bmjqg")), $688d8a22fbcfc874$exports);

// client
$688d8a22fbcfc874$var$__exportStar((parcelRequire("5pnqf")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("47cup")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("9fOWK")), $688d8a22fbcfc874$exports);

// common
$688d8a22fbcfc874$var$__exportStar((parcelRequire("cPwLs")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("ahX3I")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("cXATR")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("5kAXU")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("5GmkY")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("2ROiR")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("ezF4f")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("8QdZd")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("99SoP")), $688d8a22fbcfc874$exports);

// types for integration with adapters
$688d8a22fbcfc874$var$__exportStar((parcelRequire("aW80P")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("8qllu")), $688d8a22fbcfc874$exports);

$688d8a22fbcfc874$var$__exportStar((parcelRequire("i1GLq")), $688d8a22fbcfc874$exports);

// benchmarks/tests
$688d8a22fbcfc874$var$__exportStar((parcelRequire("gMx7w")), $688d8a22fbcfc874$exports);




const $282dc2f79e0204c8$export$dfbbeca3e3775011 = new (0, $688d8a22fbcfc874$exports.Context)();
var $282dc2f79e0204c8$export$f7cab339749a57d7;
(function(NType) {
    NType[NType[// Commands (client->server)
    "InputCommand"] = 1] = "InputCommand";
    NType[NType["ClientViewBoundsChangedCommand"] = 2] = "ClientViewBoundsChangedCommand";
    NType[NType["SpectateMyKillerCommand"] = 3] = "SpectateMyKillerCommand";
    NType[NType["InteractCommand"] = 4] = "InteractCommand";
    NType[NType["LootItemCommand"] = 5] = "LootItemCommand";
    NType[NType["PlaceholderPingCommand"] = 6] = "PlaceholderPingCommand";
    NType[NType["AdminShutdownCommand"] = 7] = "AdminShutdownCommand";
    NType[NType[// Entities (replicated)
    "PlayerEntity"] = 8] = "PlayerEntity";
    NType[NType["ProjectileEntity"] = 9] = "ProjectileEntity";
    NType[NType["ExtractionPointEntity"] = 10] = "ExtractionPointEntity";
    NType[NType["AIEntity"] = 11] = "AIEntity";
    NType[NType["ItemContainerEntity"] = 12] = "ItemContainerEntity";
    NType[NType[// Debug Entities
    "DebugGridCellEntity"] = 13] = "DebugGridCellEntity";
    NType[NType["CollisionMapTileEntity"] = 14] = "CollisionMapTileEntity";
    NType[NType[// Messages (server->client)
    "TestMessage"] = 15] = "TestMessage";
    NType[NType["IdentityMessage"] = 16] = "IdentityMessage";
    NType[NType["PlayPfxAtLocationMessage"] = 17] = "PlayPfxAtLocationMessage";
    NType[NType["YouDiedMessage"] = 18] = "YouDiedMessage";
    NType[NType["SuccessfullyExtractedMessage"] = 19] = "SuccessfullyExtractedMessage";
    NType[NType["LoadoutFromServerMessage"] = 20] = "LoadoutFromServerMessage";
    NType[NType["ItemsLootedOnRunUpdatedMessage"] = 21] = "ItemsLootedOnRunUpdatedMessage";
    NType[NType["SpectateEntityOfNidMessage"] = 22] = "SpectateEntityOfNidMessage";
    NType[NType["OpenedOrUpdatedItemContainerMessage"] = 23] = "OpenedOrUpdatedItemContainerMessage";
    NType[NType["HideItemContainerMessage"] = 24] = "HideItemContainerMessage";
    NType[NType["PopToastOfArbitraryStringMessage"] = 25] = "PopToastOfArbitraryStringMessage";
    NType[NType["DrawDebugShapeMessage"] = 26] = "DrawDebugShapeMessage";
    NType[NType["LeaderboardStateMessage"] = 27] = "LeaderboardStateMessage";
    NType[NType["PlaceholderPingAckMessage"] = 28] = "PlaceholderPingAckMessage";
    NType[NType["ServerEventFeedLootMessage"] = 29] = "ServerEventFeedLootMessage";
    NType[NType["ServerEventFeedPvPKillMessage"] = 30] = "ServerEventFeedPvPKillMessage";
    NType[NType["ServerEventFeedBossSpawnMessage"] = 31] = "ServerEventFeedBossSpawnMessage";
    NType[NType["ServerEventFeedBossUnderAttackMessage"] = 32] = "ServerEventFeedBossUnderAttackMessage";
    NType[NType["ServerEventFeedExtractionStartedMessage"] = 33] = "ServerEventFeedExtractionStartedMessage";
    NType[NType["ServerEventFeedExtractionSuccessfulMessage"] = 34] = "ServerEventFeedExtractionSuccessfulMessage";
})($282dc2f79e0204c8$export$f7cab339749a57d7 || ($282dc2f79e0204c8$export$f7cab339749a57d7 = {}));
/*************************************************/ /*                                               */ /*  Entity Replication!                          */ /*                                               */ /*************************************************/ /*****************/ /* Player Entity */ /*****************/ const $282dc2f79e0204c8$var$playerEntity = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float64,
        interp: true
    },
    y: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float64,
        interp: true
    },
    aim: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Rotation,
        interp: true
    },
    timeRemainingToExtractInSeconds: (0, $688d8a22fbcfc874$exports.Binary).UInt32,
    extractionInProgressAccumulator: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    extractionSuccessful: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    IsDeveloper: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    IsSupporter: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    IsFounder: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    username: (0, $688d8a22fbcfc874$exports.Binary).String,
    userType: (0, $688d8a22fbcfc874$exports.Binary).UInt8,
    debugViewWidth: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    debugViewHeight: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    isAlive: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    currentHealthPercentage: (0, $688d8a22fbcfc874$exports.Binary).Float32,
    characterSkin: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    activeWeaponSlot: (0, $688d8a22fbcfc874$exports.Binary).UInt8,
    weaponOneId: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    weaponTwoId: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    gearOneId: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    gearTwoId: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    gearThreeId: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    weaponOneCooldownProgressPercentage: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float32,
        interp: true
    },
    weaponTwoCooldownProgressPercentage: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float32,
        interp: true
    },
    gearOneCooldownProgressPercentage: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float32,
        interp: true
    },
    gearTwoCooldownProgressPercentage: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float32,
        interp: true
    },
    gearThreeCooldownProgressPercentage: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float32,
        interp: true
    },
    gearOneCharges: (0, $688d8a22fbcfc874$exports.Binary).Int8,
    gearTwoCharges: (0, $688d8a22fbcfc874$exports.Binary).Int8,
    gearThreeCharges: (0, $688d8a22fbcfc874$exports.Binary).Int8,
    insuredSlot: (0, $688d8a22fbcfc874$exports.Binary).Int8,
    hasInformationPassive: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    characterOpacityAmount: (0, $688d8a22fbcfc874$exports.Binary).Float32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.PlayerEntity, $282dc2f79e0204c8$var$playerEntity);
/*****************/ /* AI Entity */ /*****************/ const $282dc2f79e0204c8$var$aiEntity = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float64,
        interp: true
    },
    y: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float64,
        interp: true
    },
    isAlive: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    currentHealthPercentage: (0, $688d8a22fbcfc874$exports.Binary).Float32,
    enemySkin: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    currentState: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    spawnX: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    spawnY: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    targetX: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    targetY: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    attackedThisFrame: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    hasLineOfSightWithTarget: (0, $688d8a22fbcfc874$exports.Binary).Boolean
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.AIEntity, $282dc2f79e0204c8$var$aiEntity);
/*********************/ /* Circle Projectile */ /*********************/ const $282dc2f79e0204c8$var$circleProjectile = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float64,
        interp: true
    },
    y: {
        type: (0, $688d8a22fbcfc874$exports.Binary).Float64,
        interp: true
    },
    spawnTrajectoryInRads: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    owningEntityNid: (0, $688d8a22fbcfc874$exports.Binary).UInt32,
    projectileType: (0, $688d8a22fbcfc874$exports.Binary).UInt8,
    damage: (0, $688d8a22fbcfc874$exports.Binary).UInt16,
    damageType: (0, $688d8a22fbcfc874$exports.Binary).UInt8,
    dataId: (0, $688d8a22fbcfc874$exports.Binary).UInt8
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ProjectileEntity, $282dc2f79e0204c8$var$circleProjectile);
/*********************/ /* Item Containers   */ /*********************/ const $282dc2f79e0204c8$var$itemContainer = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    y: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    // lootItems: Binary.Int16Array,
    // lootQuantities: Binary.Int16Array,
    containerType: (0, $688d8a22fbcfc874$exports.Binary).UInt8,
    containerName: (0, $688d8a22fbcfc874$exports.Binary).String,
    uniqueContainerId: (0, $688d8a22fbcfc874$exports.Binary).String,
    owningPlayerNid: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    spriteId: (0, $688d8a22fbcfc874$exports.Binary).String
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ItemContainerEntity, $282dc2f79e0204c8$var$itemContainer);
/*********************/ /* Extraction Point  */ /*********************/ const $282dc2f79e0204c8$var$extractionPoint = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    y: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    width: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    height: (0, $688d8a22fbcfc874$exports.Binary).Float64
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ExtractionPointEntity, $282dc2f79e0204c8$var$extractionPoint);
/*********************/ /*  Debug Grid Cell  */ /*********************/ const $282dc2f79e0204c8$var$debugGridCell = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    y: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    width: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    height: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    isActive: (0, $688d8a22fbcfc874$exports.Binary).Boolean
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.DebugGridCellEntity, $282dc2f79e0204c8$var$debugGridCell);
/*************************************************/ /*                                               */ /*  Messages (server ---> client)                */ /*                                               */ /*************************************************/ /********************/ /* Identity Message */ /********************/ const $282dc2f79e0204c8$var$identityMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    myId: (0, $688d8a22fbcfc874$exports.Binary).UInt32,
    myX: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    myY: (0, $688d8a22fbcfc874$exports.Binary).Float64
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.IdentityMessage, $282dc2f79e0204c8$var$identityMessageSchema);
/*****************************/ /* LoadoutFromServer Message */ /*****************************/ const $282dc2f79e0204c8$var$loadoutFromServerMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    characterSkin: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    weaponOne: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    weaponTwo: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    gearOne: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    gearTwo: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    gearThree: (0, $688d8a22fbcfc874$exports.Binary).Int16,
    insuredSlot: (0, $688d8a22fbcfc874$exports.Binary).Int8
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.LoadoutFromServerMessage, $282dc2f79e0204c8$var$loadoutFromServerMessageSchema);
/*****************************/ /* PlayPfxAtLocation Message */ /*****************************/ const $282dc2f79e0204c8$var$playPfxAtLocationMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    y: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    scale: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    pfxType: (0, $688d8a22fbcfc874$exports.Binary).String
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.PlayPfxAtLocationMessage, $282dc2f79e0204c8$var$playPfxAtLocationMessageSchema);
/*****************************************/ /* Pop Toast of Arbitrary String Message */ /*****************************************/ const $282dc2f79e0204c8$var$popToastOfArbitraryStringMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    message: (0, $688d8a22fbcfc874$exports.Binary).String
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.PopToastOfArbitraryStringMessage, $282dc2f79e0204c8$var$popToastOfArbitraryStringMessageSchema);
/*****************************************/ /* Leaderboard State Message */ /*****************************************/ const $282dc2f79e0204c8$var$leaderboardStateMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    leaderboardState: (0, $688d8a22fbcfc874$exports.Binary).String
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.LeaderboardStateMessage, $282dc2f79e0204c8$var$leaderboardStateMessageSchema);
/*****************************/ /* You Died Message          */ /*****************************/ const $282dc2f79e0204c8$var$youDiedMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    killedBy: (0, $688d8a22fbcfc874$exports.Binary).String,
    runDurationInSeconds: (0, $688d8a22fbcfc874$exports.Binary).UInt32,
    goldLost: (0, $688d8a22fbcfc874$exports.Binary).UInt32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.YouDiedMessage, $282dc2f79e0204c8$var$youDiedMessageSchema);
/*******************************************/ /* Successfully Extracted Message          */ /*******************************************/ const $282dc2f79e0204c8$var$successfullyExtractedMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    runDurationInSeconds: (0, $688d8a22fbcfc874$exports.Binary).UInt32,
    goldEarned: (0, $688d8a22fbcfc874$exports.Binary).UInt32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.SuccessfullyExtractedMessage, $282dc2f79e0204c8$var$successfullyExtractedMessageSchema);
/*******************************************/ /* SpectateEntityMessage                   */ /*******************************************/ const $282dc2f79e0204c8$var$spectateEntityOfNidMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    nidOfEntityToFollow: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    entityName: (0, $688d8a22fbcfc874$exports.Binary).String
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.SpectateEntityOfNidMessage, $282dc2f79e0204c8$var$spectateEntityOfNidMessageSchema);
/*******************************************/ /* Ping Ack Msg                            */ /*******************************************/ const $282dc2f79e0204c8$var$placeholderPingAckMessageSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    ack: (0, $688d8a22fbcfc874$exports.Binary).Boolean
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.PlaceholderPingAckMessage, $282dc2f79e0204c8$var$placeholderPingAckMessageSchema);
/*******************************************/ /* Run Inventory Updated Message           */ /*******************************************/ const $282dc2f79e0204c8$var$itemsLootedOnRunUpdatedMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    items: (0, $688d8a22fbcfc874$exports.Binary).Int16Array,
    quantities: (0, $688d8a22fbcfc874$exports.Binary).Int16Array
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ItemsLootedOnRunUpdatedMessage, $282dc2f79e0204c8$var$itemsLootedOnRunUpdatedMessage);
/*******************************************/ /* Opened Item Container Message           */ /*******************************************/ const $282dc2f79e0204c8$var$openedOrUpdatedItemContainerMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    containerName: (0, $688d8a22fbcfc874$exports.Binary).String,
    itemContainerId: (0, $688d8a22fbcfc874$exports.Binary).String,
    items: (0, $688d8a22fbcfc874$exports.Binary).Int16Array,
    quantities: (0, $688d8a22fbcfc874$exports.Binary).Int16Array
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.OpenedOrUpdatedItemContainerMessage, $282dc2f79e0204c8$var$openedOrUpdatedItemContainerMessage);
/*******************************************/ /* Hide Item Container Message             */ /*******************************************/ const $282dc2f79e0204c8$var$hideItemContainerMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    itemContainerId: (0, $688d8a22fbcfc874$exports.Binary).String
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.HideItemContainerMessage, $282dc2f79e0204c8$var$hideItemContainerMessage);
/*******************************************/ /* Draw Debug Shape Message                */ /*******************************************/ const $282dc2f79e0204c8$var$drawDebugShapeMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    x: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    y: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    shape: (0, $688d8a22fbcfc874$exports.Binary).UInt8,
    destX: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    destY: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    radius: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    width: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    height: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    destroyAfterSeconds: (0, $688d8a22fbcfc874$exports.Binary).Float64
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.DrawDebugShapeMessage, $282dc2f79e0204c8$var$drawDebugShapeMessage);
/*******************************************/ /* Server Event Feed Loot Msg              */ /*******************************************/ const $282dc2f79e0204c8$var$serverEventFeedLootMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    playerName: (0, $688d8a22fbcfc874$exports.Binary).String,
    rarity: (0, $688d8a22fbcfc874$exports.Binary).UInt8,
    locationX: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    locationY: (0, $688d8a22fbcfc874$exports.Binary).Int32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ServerEventFeedLootMessage, $282dc2f79e0204c8$var$serverEventFeedLootMessage);
/*******************************************/ /* Server Event Feed Kill Msg              */ /*******************************************/ const $282dc2f79e0204c8$var$serverEventFeedPvPKillMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    killer: (0, $688d8a22fbcfc874$exports.Binary).String,
    victim: (0, $688d8a22fbcfc874$exports.Binary).String,
    locationX: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    locationY: (0, $688d8a22fbcfc874$exports.Binary).Int32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ServerEventFeedPvPKillMessage, $282dc2f79e0204c8$var$serverEventFeedPvPKillMessage);
/*******************************************/ /* Server Event Feed Boss Spawn Msg        */ /*******************************************/ const $282dc2f79e0204c8$var$serverEventFeedBossSpawnMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    bossName: (0, $688d8a22fbcfc874$exports.Binary).String,
    locationX: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    locationY: (0, $688d8a22fbcfc874$exports.Binary).Int32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ServerEventFeedBossSpawnMessage, $282dc2f79e0204c8$var$serverEventFeedBossSpawnMessage);
/*******************************************/ /* Server Event Feed Boss Attack Msg       */ /*******************************************/ const $282dc2f79e0204c8$var$serverEventFeedBossUnderAttackMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    bossName: (0, $688d8a22fbcfc874$exports.Binary).String,
    locationX: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    locationY: (0, $688d8a22fbcfc874$exports.Binary).Int32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ServerEventFeedBossUnderAttackMessage, $282dc2f79e0204c8$var$serverEventFeedBossUnderAttackMessage);
/*********************************************/ /* Server Event Extraction Started Msg       */ /*********************************************/ const $282dc2f79e0204c8$var$serverEventExtractionStartedMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    playerName: (0, $688d8a22fbcfc874$exports.Binary).String,
    locationX: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    locationY: (0, $688d8a22fbcfc874$exports.Binary).Int32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ServerEventFeedExtractionStartedMessage, $282dc2f79e0204c8$var$serverEventExtractionStartedMessage);
/*********************************************/ /* Server Event Extraction Successful Msg       */ /*********************************************/ const $282dc2f79e0204c8$var$serverEventExtractionSuccessfulMessage = (0, $688d8a22fbcfc874$exports.defineSchema)({
    playerName: (0, $688d8a22fbcfc874$exports.Binary).String,
    locationX: (0, $688d8a22fbcfc874$exports.Binary).Int32,
    locationY: (0, $688d8a22fbcfc874$exports.Binary).Int32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ServerEventFeedExtractionSuccessfulMessage, $282dc2f79e0204c8$var$serverEventExtractionSuccessfulMessage);
/*************************************************/ /*                                               */ /*  Commands (client ---> server)                */ /*                                               */ /*************************************************/ /*********/ /* Input */ /*********/ const $282dc2f79e0204c8$var$inputCommandSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    up: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    down: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    left: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    right: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    aim: (0, $688d8a22fbcfc874$exports.Binary).Float64,
    usedWeapon: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    genericSwappedWeapon: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    swappedToFirstWeapon: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    swappedToSecondWeapon: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    usedGearOne: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    usedGearTwo: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    usedGearThree: (0, $688d8a22fbcfc874$exports.Binary).Boolean,
    delta: (0, $688d8a22fbcfc874$exports.Binary).Float64
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.InputCommand, $282dc2f79e0204c8$var$inputCommandSchema);
/******************/ /* Admin Shutdown */ /******************/ const $282dc2f79e0204c8$var$adminShutdownCommandSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    shutdown: (0, $688d8a22fbcfc874$exports.Binary).Boolean
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.AdminShutdownCommand, $282dc2f79e0204c8$var$adminShutdownCommandSchema);
/************/ /* Interact */ /************/ const $282dc2f79e0204c8$var$interactCommandSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    interactingWithContainerOfId: (0, $688d8a22fbcfc874$exports.Binary).String
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.InteractCommand, $282dc2f79e0204c8$var$interactCommandSchema);
/*************/ /* Ping      */ /*************/ const $282dc2f79e0204c8$var$placeholderPingCommandSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    ping: (0, $688d8a22fbcfc874$exports.Binary).Boolean
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.PlaceholderPingCommand, $282dc2f79e0204c8$var$placeholderPingCommandSchema);
/*************/ /* Loot Item */ /*************/ const $282dc2f79e0204c8$var$lootItemCommandSchema = (0, $688d8a22fbcfc874$exports.defineSchema)({
    interactingWithContainerOfId: (0, $688d8a22fbcfc874$exports.Binary).String,
    itemIdToLoot: (0, $688d8a22fbcfc874$exports.Binary).Int32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.LootItemCommand, $282dc2f79e0204c8$var$lootItemCommandSchema);
/**************************/ /* Spectating Your Killer */ /**************************/ const $282dc2f79e0204c8$var$spectateMyKillerCommand = (0, $688d8a22fbcfc874$exports.defineSchema)({
    spectateMyKiller: (0, $688d8a22fbcfc874$exports.Binary).Boolean
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.SpectateMyKillerCommand, $282dc2f79e0204c8$var$spectateMyKillerCommand);
/****************/ /* View Changed */ /****************/ const $282dc2f79e0204c8$var$clientViewBoundsChangedCommand = (0, $688d8a22fbcfc874$exports.defineSchema)({
    cw: (0, $688d8a22fbcfc874$exports.Binary).UInt32,
    ch: (0, $688d8a22fbcfc874$exports.Binary).UInt32,
    cz: (0, $688d8a22fbcfc874$exports.Binary).Float32
});
$282dc2f79e0204c8$export$dfbbeca3e3775011.register($282dc2f79e0204c8$export$f7cab339749a57d7.ClientViewBoundsChangedCommand, $282dc2f79e0204c8$var$clientViewBoundsChangedCommand);


var $4ebc683cc53721cf$exports = {};
"use strict";
Object.defineProperty($4ebc683cc53721cf$exports, "__esModule", {
    value: true
});
$4ebc683cc53721cf$exports.WebSocketClientAdapter = void 0;

var $8ef4ef754532fcd8$exports = {};
"use strict";
var $8ef4ef754532fcd8$var$__createBinding = $8ef4ef754532fcd8$exports && $8ef4ef754532fcd8$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ef4ef754532fcd8$var$__exportStar = $8ef4ef754532fcd8$exports && $8ef4ef754532fcd8$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8ef4ef754532fcd8$var$__createBinding(exports1, m, p);
};
Object.defineProperty($8ef4ef754532fcd8$exports, "__esModule", {
    value: true
});

$8ef4ef754532fcd8$var$__exportStar((parcelRequire("lKMGf")), $8ef4ef754532fcd8$exports);

$8ef4ef754532fcd8$var$__exportStar((parcelRequire("cjSum")), $8ef4ef754532fcd8$exports);


class $4ebc683cc53721cf$var$WebSocketClientAdapter {
    constructor(network){
        this.socket = null;
        this.network = network;
        this.context = this.network.client.context;
    }
    flush() {
        if (!this.socket) {
            console.log("CANCELED, no socket");
            return;
        }
        if (this.socket.readyState !== 1) {
            console.log("socket not open");
            return;
        }
        const buffer = this.network.createOutboundBuffer($8ef4ef754532fcd8$exports.DataViewWriter);
        this.socket.send(buffer);
    }
    setupWebsocket(socket) {
        this.socket = socket;
        socket.onmessage = (event)=>{
            if (event.data instanceof ArrayBuffer) {
                const dr = new $8ef4ef754532fcd8$exports.DataViewReader(event.data, 0);
                this.network.readSnapshot(dr);
            }
        };
        socket.onclose = function(event) {
            console.log("sock closed");
            console.log(event);
        // TODO
        };
        socket.onerror = function(event) {
            console.log("socket error");
            console.log(event);
        // TODO
        };
    }
    connect(wsUrl, handshake) {
        return new Promise((resolve, reject)=>{
            const socket = new WebSocket(wsUrl);
            socket.binaryType = "arraybuffer";
            socket.onopen = (event)=>{
                socket.send(this.network.createHandshakeBuffer(handshake, $8ef4ef754532fcd8$exports.DataViewWriter));
            };
            socket.onclose = function(event) {
                reject(event);
            };
            socket.onerror = function(event) {
                reject(event);
            };
            socket.onmessage = (event)=>{
                // initially the only thing we care to read is a response to our handshake
                // we don't even setup the parser for the rest of what a nengi client can receive
                const dr = new $8ef4ef754532fcd8$exports.DataViewReader(event.data, 0);
                const type = dr.readUInt8(); // type of message
                if (type === $688d8a22fbcfc874$exports.BinarySection.EngineMessages) {
                    const count = dr.readUInt8(); // quantity of engine messages
                    const connectionResponseByte = dr.readUInt8();
                    if (connectionResponseByte === $688d8a22fbcfc874$exports.EngineMessage.ConnectionAccepted) {
                        // setup listeners for normal game data
                        this.setupWebsocket(socket);
                        resolve("accepted");
                    }
                    if (connectionResponseByte === $688d8a22fbcfc874$exports.EngineMessage.ConnectionDenied) {
                        const denyReason = JSON.parse(dr.readString());
                        reject(denyReason);
                    }
                }
            };
        });
    }
}
$4ebc683cc53721cf$exports.WebSocketClientAdapter = $4ebc683cc53721cf$var$WebSocketClientAdapter;


var $69a172d21320641e$export$cd1c2f7f06852a53;
(function(ServerConnectionErrorReasons) {
    ServerConnectionErrorReasons["GameClientOutOfDate"] = "GameClientOutOfDate";
    ServerConnectionErrorReasons["InvalidConnectionToken"] = "InvalidConnectionToken";
    ServerConnectionErrorReasons["UnexpectedConnectionError"] = "UnexpectedConnectionError";
    ServerConnectionErrorReasons["InvalidRunDetails"] = "InvalidRunDetails";
    ServerConnectionErrorReasons["PlayerAlreadyLoggedIn"] = "PlayerAlreadyLoggedIn";
})($69a172d21320641e$export$cd1c2f7f06852a53 || ($69a172d21320641e$export$cd1c2f7f06852a53 = {}));
var $69a172d21320641e$export$14498c06a50e821e;
(function(FacingDirection) {
    FacingDirection[FacingDirection["Left"] = 0] = "Left";
    FacingDirection[FacingDirection["Right"] = 1] = "Right";
})($69a172d21320641e$export$14498c06a50e821e || ($69a172d21320641e$export$14498c06a50e821e = {}));
const $69a172d21320641e$var$supportedLanguages = [
    // English
    "en",
    // Spanish
    "es",
    // Russian
    "ru",
    // Chinese (Simplified)
    "zh-cn",
    // German
    "de",
    // Japanese
    "ja",
    // Portuguese
    "pt",
    // Korean
    "ko",
    // Hindi
    "hi",
    // French
    "fr",
    // Arabic
    "ar",
    // Italian
    "it",
    // Polish
    "pl",
    // Turkish
    "tr"
];
const $69a172d21320641e$var$supportedMatchmakingRegions = [
    "any",
    "us-east",
    "us-west",
    "eu",
    "australia",
    "asia",
    "south-america"
];
var $69a172d21320641e$export$8436e53e45ffe15b;
(function(UserType) {
    UserType[UserType["Anonymous"] = 0] = "Anonymous";
    UserType[UserType["Registered"] = 1] = "Registered";
})($69a172d21320641e$export$8436e53e45ffe15b || ($69a172d21320641e$export$8436e53e45ffe15b = {}));
var $69a172d21320641e$export$7d7a98f44861e6f7;
(function(ContainerType) {
    ContainerType[ContainerType["LootChest"] = 0] = "LootChest";
    ContainerType[ContainerType["PlayerGravestone"] = 1] = "PlayerGravestone";
    ContainerType[ContainerType["EnemyDrop"] = 2] = "EnemyDrop";
})($69a172d21320641e$export$7d7a98f44861e6f7 || ($69a172d21320641e$export$7d7a98f44861e6f7 = {}));
var $69a172d21320641e$export$3b9c5fedfb1fdc77;
(function(ServerEventFeedEventTypes) {
    ServerEventFeedEventTypes[ServerEventFeedEventTypes["Loot"] = 0] = "Loot";
    ServerEventFeedEventTypes[ServerEventFeedEventTypes["Kill"] = 1] = "Kill";
    ServerEventFeedEventTypes[ServerEventFeedEventTypes["BossSpawn"] = 2] = "BossSpawn";
    ServerEventFeedEventTypes[ServerEventFeedEventTypes["BossAttack"] = 3] = "BossAttack";
    ServerEventFeedEventTypes[ServerEventFeedEventTypes["ExtractionStarted"] = 4] = "ExtractionStarted";
    ServerEventFeedEventTypes[ServerEventFeedEventTypes["ExtractionSuccessful"] = 5] = "ExtractionSuccessful";
})($69a172d21320641e$export$3b9c5fedfb1fdc77 || ($69a172d21320641e$export$3b9c5fedfb1fdc77 = {}));





var $acw62 = parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

$11492dca620dcaa5$exports = (parcelRequire("3y30c"));



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$err(message) {
    const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
    // err.stack property is accessed.
    if (error.stack === undefined) // IE sets the stack only if error is thrown
    try {
        throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty
    return error;
}
var $7ef244517b504261$var$err_1 = $7ef244517b504261$var$err;
// @oss-only
var $7ef244517b504261$var$Recoil_err = $7ef244517b504261$var$err_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function $7ef244517b504261$var$isPromise(p) {
    return !!p && typeof p.then === "function";
}
var $7ef244517b504261$var$Recoil_isPromise = $7ef244517b504261$var$isPromise;
function $7ef244517b504261$var$nullthrows(x, message) {
    if (x != null) return x;
    throw $7ef244517b504261$var$Recoil_err(message !== null && message !== void 0 ? message : "Got unexpected null or undefined");
}
var $7ef244517b504261$var$Recoil_nullthrows = $7ef244517b504261$var$nullthrows;
function $7ef244517b504261$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $7ef244517b504261$var$BaseLoadable {
    getValue() {
        throw $7ef244517b504261$var$Recoil_err("BaseLoadable");
    }
    toPromise() {
        throw $7ef244517b504261$var$Recoil_err("BaseLoadable");
    }
    valueMaybe() {
        throw $7ef244517b504261$var$Recoil_err("BaseLoadable");
    }
    valueOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $7ef244517b504261$var$Recoil_err(`Loadable expected value, but in "${this.state}" state`);
    }
    promiseMaybe() {
        throw $7ef244517b504261$var$Recoil_err("BaseLoadable");
    }
    promiseOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $7ef244517b504261$var$Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
    }
    errorMaybe() {
        throw $7ef244517b504261$var$Recoil_err("BaseLoadable");
    }
    errorOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $7ef244517b504261$var$Recoil_err(`Loadable expected error, but in "${this.state}" state`);
    }
    is(other) {
        // $FlowFixMe[prop-missing]
        return other.state === this.state && other.contents === this.contents;
    }
    map(_map) {
        throw $7ef244517b504261$var$Recoil_err("BaseLoadable");
    }
}
class $7ef244517b504261$var$ValueLoadable extends $7ef244517b504261$var$BaseLoadable {
    constructor(value){
        super();
        $7ef244517b504261$var$_defineProperty(this, "state", "hasValue");
        $7ef244517b504261$var$_defineProperty(this, "contents", void 0);
        this.contents = value;
    }
    getValue() {
        return this.contents;
    }
    toPromise() {
        return Promise.resolve(this.contents);
    }
    valueMaybe() {
        return this.contents;
    }
    valueOrThrow() {
        return this.contents;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        try {
            const next = map(this.contents);
            return $7ef244517b504261$var$Recoil_isPromise(next) ? $7ef244517b504261$var$loadableWithPromise(next) : $7ef244517b504261$var$isLoadable(next) ? next : $7ef244517b504261$var$loadableWithValue(next);
        } catch (e) {
            return $7ef244517b504261$var$Recoil_isPromise(e) ? // errors and subsequent retries will be handled in 'loading' case
            // $FlowFixMe[prop-missing]
            $7ef244517b504261$var$loadableWithPromise(e.next(()=>this.map(map))) : $7ef244517b504261$var$loadableWithError(e);
        }
    }
}
class $7ef244517b504261$var$ErrorLoadable extends $7ef244517b504261$var$BaseLoadable {
    constructor(error){
        super();
        $7ef244517b504261$var$_defineProperty(this, "state", "hasError");
        $7ef244517b504261$var$_defineProperty(this, "contents", void 0);
        this.contents = error;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return Promise.reject(this.contents);
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return this.contents;
    }
    errorOrThrow() {
        return this.contents;
    }
    map(_map) {
        // $FlowIssue[incompatible-return]
        return this;
    }
}
class $7ef244517b504261$var$LoadingLoadable extends $7ef244517b504261$var$BaseLoadable {
    constructor(promise){
        super();
        $7ef244517b504261$var$_defineProperty(this, "state", "loading");
        $7ef244517b504261$var$_defineProperty(this, "contents", void 0);
        this.contents = promise;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return this.contents;
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return this.contents;
    }
    promiseOrThrow() {
        return this.contents;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        return $7ef244517b504261$var$loadableWithPromise(this.contents.then((value)=>{
            const next = map(value);
            if ($7ef244517b504261$var$isLoadable(next)) {
                const nextLoadable = next;
                switch(nextLoadable.state){
                    case "hasValue":
                        return nextLoadable.contents;
                    case "hasError":
                        throw nextLoadable.contents;
                    case "loading":
                        return nextLoadable.contents;
                }
            } // $FlowIssue[incompatible-return]
            return next;
        }) // $FlowFixMe[incompatible-call]
        .catch((e)=>{
            if ($7ef244517b504261$var$Recoil_isPromise(e)) // we were "suspended," try again
            return e.then(()=>this.map(map).contents);
            throw e;
        }));
    }
}
function $7ef244517b504261$var$loadableWithValue(value) {
    return Object.freeze(new $7ef244517b504261$var$ValueLoadable(value));
}
function $7ef244517b504261$var$loadableWithError(error) {
    return Object.freeze(new $7ef244517b504261$var$ErrorLoadable(error));
}
function $7ef244517b504261$var$loadableWithPromise(promise) {
    return Object.freeze(new $7ef244517b504261$var$LoadingLoadable(promise));
}
function $7ef244517b504261$var$loadableLoading() {
    return Object.freeze(new $7ef244517b504261$var$LoadingLoadable(new Promise(()=>{})));
}
function $7ef244517b504261$var$loadableAllArray(inputs) {
    return inputs.every((i)=>i.state === "hasValue") ? $7ef244517b504261$var$loadableWithValue(inputs.map((i)=>i.contents)) : inputs.some((i)=>i.state === "hasError") ? $7ef244517b504261$var$loadableWithError($7ef244517b504261$var$Recoil_nullthrows(inputs.find((i)=>i.state === "hasError"), "Invalid loadable passed to loadableAll").contents) : $7ef244517b504261$var$loadableWithPromise(Promise.all(inputs.map((i)=>i.contents)));
}
function $7ef244517b504261$var$loadableAll(inputs) {
    const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map((key)=>inputs[key]);
    const normalizedInputs = unwrapedInputs.map((x)=>$7ef244517b504261$var$isLoadable(x) ? x : $7ef244517b504261$var$Recoil_isPromise(x) ? $7ef244517b504261$var$loadableWithPromise(x) : $7ef244517b504261$var$loadableWithValue(x));
    const output = $7ef244517b504261$var$loadableAllArray(normalizedInputs);
    return Array.isArray(inputs) ? output : // $FlowIssue[incompatible-call]
    output.map((outputs)=>Object.getOwnPropertyNames(inputs).reduce((out, key, idx)=>({
                ...out,
                [key]: outputs[idx]
            }), {}));
}
function $7ef244517b504261$var$isLoadable(x) {
    return x instanceof $7ef244517b504261$var$BaseLoadable;
}
const $7ef244517b504261$var$LoadableStaticInterface = {
    of: (value)=>$7ef244517b504261$var$Recoil_isPromise(value) ? $7ef244517b504261$var$loadableWithPromise(value) : $7ef244517b504261$var$isLoadable(value) ? value : $7ef244517b504261$var$loadableWithValue(value),
    error: (error)=>$7ef244517b504261$var$loadableWithError(error),
    // $FlowIssue[incompatible-return]
    loading: ()=>$7ef244517b504261$var$loadableLoading(),
    // $FlowIssue[unclear-type]
    all: $7ef244517b504261$var$loadableAll,
    isLoadable: $7ef244517b504261$var$isLoadable
};
var $7ef244517b504261$var$Recoil_Loadable = {
    loadableWithValue: $7ef244517b504261$var$loadableWithValue,
    loadableWithError: $7ef244517b504261$var$loadableWithError,
    loadableWithPromise: $7ef244517b504261$var$loadableWithPromise,
    loadableLoading: $7ef244517b504261$var$loadableLoading,
    loadableAll: $7ef244517b504261$var$loadableAll,
    isLoadable: $7ef244517b504261$var$isLoadable,
    RecoilLoadable: $7ef244517b504261$var$LoadableStaticInterface
};
var $7ef244517b504261$var$Recoil_Loadable_1 = $7ef244517b504261$var$Recoil_Loadable.loadableWithValue;
var $7ef244517b504261$var$Recoil_Loadable_2 = $7ef244517b504261$var$Recoil_Loadable.loadableWithError;
var $7ef244517b504261$var$Recoil_Loadable_3 = $7ef244517b504261$var$Recoil_Loadable.loadableWithPromise;
var $7ef244517b504261$var$Recoil_Loadable_4 = $7ef244517b504261$var$Recoil_Loadable.loadableLoading;
var $7ef244517b504261$var$Recoil_Loadable_5 = $7ef244517b504261$var$Recoil_Loadable.loadableAll;
var $7ef244517b504261$var$Recoil_Loadable_6 = $7ef244517b504261$var$Recoil_Loadable.isLoadable;
var $7ef244517b504261$var$Recoil_Loadable_7 = $7ef244517b504261$var$Recoil_Loadable.RecoilLoadable;
var $7ef244517b504261$var$Recoil_Loadable$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    loadableWithValue: $7ef244517b504261$var$Recoil_Loadable_1,
    loadableWithError: $7ef244517b504261$var$Recoil_Loadable_2,
    loadableWithPromise: $7ef244517b504261$var$Recoil_Loadable_3,
    loadableLoading: $7ef244517b504261$var$Recoil_Loadable_4,
    loadableAll: $7ef244517b504261$var$Recoil_Loadable_5,
    isLoadable: $7ef244517b504261$var$Recoil_Loadable_6,
    RecoilLoadable: $7ef244517b504261$var$Recoil_Loadable_7
});
const $7ef244517b504261$var$env = {
    RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
    // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
    RECOIL_GKS_ENABLED: new Set([
        "recoil_hamt_2020",
        "recoil_sync_external_store",
        "recoil_suppress_rerender_in_callback",
        "recoil_memory_managament_2020"
    ])
};
function $7ef244517b504261$var$readProcessEnvBooleanFlag(name, set) {
    var _process$env$name, _process$env$name$toL;
    const sanitizedValue = (_process$env$name = $cfae44f0dfdf62c0$exports.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();
    if (sanitizedValue == null || sanitizedValue === "") return;
    const allowedValues = [
        "true",
        "false"
    ];
    if (!allowedValues.includes(sanitizedValue)) throw $7ef244517b504261$var$Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
    set(sanitizedValue === "true");
}
function $7ef244517b504261$var$readProcessEnvStringArrayFlag(name, set) {
    var _process$env$name2;
    const sanitizedValue = (_process$env$name2 = $cfae44f0dfdf62c0$exports.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();
    if (sanitizedValue == null || sanitizedValue === "") return;
    set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */ function $7ef244517b504261$var$applyProcessEnvFlagOverrides() {
    var _process;
    // note: this check is needed in addition to the check below, runtime error will occur without it!
    // eslint-disable-next-line fb-www/typeof-undefined
    if (typeof $cfae44f0dfdf62c0$exports === "undefined") return;
    if (((_process = $cfae44f0dfdf62c0$exports) === null || _process === void 0 ? void 0 : _process.env) == null) return;
    $7ef244517b504261$var$readProcessEnvBooleanFlag("RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED", (value)=>{
        $7ef244517b504261$var$env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
    });
    $7ef244517b504261$var$readProcessEnvStringArrayFlag("RECOIL_GKS_ENABLED", (value)=>{
        value.forEach((gk)=>{
            $7ef244517b504261$var$env.RECOIL_GKS_ENABLED.add(gk);
        });
    });
}
$7ef244517b504261$var$applyProcessEnvFlagOverrides();
var $7ef244517b504261$var$Recoil_RecoilEnv = $7ef244517b504261$var$env;
function $7ef244517b504261$var$Recoil_gkx_OSS(gk) {
    return $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}
$7ef244517b504261$var$Recoil_gkx_OSS.setPass = (gk)=>{
    $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};
$7ef244517b504261$var$Recoil_gkx_OSS.setFail = (gk)=>{
    $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};
$7ef244517b504261$var$Recoil_gkx_OSS.clear = ()=>{
    $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};
var $7ef244517b504261$var$Recoil_gkx = $7ef244517b504261$var$Recoil_gkx_OSS; // @oss-only
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$recoverableViolation(message, _projectName, { error: error  } = {}) {
    console.error(message, error);
    return null;
}
var $7ef244517b504261$var$recoverableViolation_1 = $7ef244517b504261$var$recoverableViolation;
// @oss-only
var $7ef244517b504261$var$Recoil_recoverableViolation = $7ef244517b504261$var$recoverableViolation_1;
var $7ef244517b504261$var$_createMutableSource, $7ef244517b504261$var$_useMutableSource, $7ef244517b504261$var$_useSyncExternalStore;
const $7ef244517b504261$var$createMutableSource = ($7ef244517b504261$var$_createMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createMutableSource) !== null && $7ef244517b504261$var$_createMutableSource !== void 0 ? $7ef244517b504261$var$_createMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).unstable_createMutableSource;
const $7ef244517b504261$var$useMutableSource = ($7ef244517b504261$var$_useMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMutableSource) !== null && $7ef244517b504261$var$_useMutableSource !== void 0 ? $7ef244517b504261$var$_useMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86
const $7ef244517b504261$var$useSyncExternalStore = ($7ef244517b504261$var$_useSyncExternalStore = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore) !== null && $7ef244517b504261$var$_useSyncExternalStore !== void 0 ? $7ef244517b504261$var$_useSyncExternalStore : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).unstable_useSyncExternalStore;
let $7ef244517b504261$var$ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.
function $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore() {
    var _ReactCurrentDispatch;
    // $FlowFixMe[incompatible-use]
    const { ReactCurrentDispatcher: ReactCurrentDispatcher , ReactCurrentOwner: ReactCurrentOwner  } = /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
    const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;
    if ($7ef244517b504261$var$useSyncExternalStore && !isUseSyncExternalStoreSupported && !$7ef244517b504261$var$ReactRendererVersionMismatchWarnOnce) {
        $7ef244517b504261$var$ReactRendererVersionMismatchWarnOnce = true;
        $7ef244517b504261$var$Recoil_recoverableViolation("A React renderer without React 18+ API support is being used with React 18+.");
    }
    return isUseSyncExternalStoreSupported;
}
/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */ function $7ef244517b504261$var$reactMode() {
    // NOTE: This mode is currently broken with some Suspense cases
    // see Recoil_selector-test.js
    if ($7ef244517b504261$var$Recoil_gkx("recoil_transition_support")) return {
        mode: "TRANSITION_SUPPORT",
        early: true,
        concurrent: true
    };
    if ($7ef244517b504261$var$Recoil_gkx("recoil_sync_external_store") && $7ef244517b504261$var$useSyncExternalStore != null) return {
        mode: "SYNC_EXTERNAL_STORE",
        early: true,
        concurrent: false
    };
    if ($7ef244517b504261$var$Recoil_gkx("recoil_mutable_source") && $7ef244517b504261$var$useMutableSource != null && typeof window !== "undefined" && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) return $7ef244517b504261$var$Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
        mode: "MUTABLE_SOURCE",
        early: true,
        concurrent: true
    } : {
        mode: "MUTABLE_SOURCE",
        early: false,
        concurrent: false
    };
    return $7ef244517b504261$var$Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
        mode: "LEGACY",
        early: true,
        concurrent: false
    } : {
        mode: "LEGACY",
        early: false,
        concurrent: false
    };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:
function $7ef244517b504261$var$isFastRefreshEnabled() {
    // @fb-only: const {isAcceptingUpdate} = require('__debug');
    // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
    return false; // @oss-only
}
var $7ef244517b504261$var$Recoil_ReactMode = {
    createMutableSource: $7ef244517b504261$var$createMutableSource,
    useMutableSource: $7ef244517b504261$var$useMutableSource,
    useSyncExternalStore: $7ef244517b504261$var$useSyncExternalStore,
    currentRendererSupportsUseSyncExternalStore: $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore,
    reactMode: $7ef244517b504261$var$reactMode,
    isFastRefreshEnabled: $7ef244517b504261$var$isFastRefreshEnabled
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // eslint-disable-next-line no-unused-vars
class $7ef244517b504261$var$AbstractRecoilValue {
    constructor(newKey){
        $7ef244517b504261$var$_defineProperty(this, "key", void 0);
        this.key = newKey;
    }
    toJSON() {
        return {
            key: this.key
        };
    }
}
class $7ef244517b504261$var$RecoilState extends $7ef244517b504261$var$AbstractRecoilValue {
}
class $7ef244517b504261$var$RecoilValueReadOnly extends $7ef244517b504261$var$AbstractRecoilValue {
}
function $7ef244517b504261$var$isRecoilValue(x) {
    return x instanceof $7ef244517b504261$var$RecoilState || x instanceof $7ef244517b504261$var$RecoilValueReadOnly;
}
var $7ef244517b504261$var$Recoil_RecoilValue = {
    AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue,
    RecoilState: $7ef244517b504261$var$RecoilState,
    RecoilValueReadOnly: $7ef244517b504261$var$RecoilValueReadOnly,
    isRecoilValue: $7ef244517b504261$var$isRecoilValue
};
var $7ef244517b504261$var$Recoil_RecoilValue_1 = $7ef244517b504261$var$Recoil_RecoilValue.AbstractRecoilValue;
var $7ef244517b504261$var$Recoil_RecoilValue_2 = $7ef244517b504261$var$Recoil_RecoilValue.RecoilState;
var $7ef244517b504261$var$Recoil_RecoilValue_3 = $7ef244517b504261$var$Recoil_RecoilValue.RecoilValueReadOnly;
var $7ef244517b504261$var$Recoil_RecoilValue_4 = $7ef244517b504261$var$Recoil_RecoilValue.isRecoilValue;
var $7ef244517b504261$var$Recoil_RecoilValue$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractRecoilValue: $7ef244517b504261$var$Recoil_RecoilValue_1,
    RecoilState: $7ef244517b504261$var$Recoil_RecoilValue_2,
    RecoilValueReadOnly: $7ef244517b504261$var$Recoil_RecoilValue_3,
    isRecoilValue: $7ef244517b504261$var$Recoil_RecoilValue_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$sprintf(format, ...args) {
    let index = 0;
    return format.replace(/%s/g, ()=>String(args[index++]));
}
var $7ef244517b504261$var$sprintf_1 = $7ef244517b504261$var$sprintf;
function $7ef244517b504261$var$expectationViolation(format, ...args) {
    {
        const message = $7ef244517b504261$var$sprintf_1.call(null, format, ...args);
        const error = new Error(message);
        error.name = "Expectation Violation";
        console.error(error);
    }
}
var $7ef244517b504261$var$expectationViolation_1 = $7ef244517b504261$var$expectationViolation;
// @oss-only
var $7ef244517b504261$var$Recoil_expectationViolation = $7ef244517b504261$var$expectationViolation_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */ function $7ef244517b504261$var$mapIterable(iterable, callback) {
    // Use generator to create iterable/iterator
    return function*() {
        let index = 0;
        for (const value of iterable)yield callback(value, index++);
    }();
}
var $7ef244517b504261$var$Recoil_mapIterable = $7ef244517b504261$var$mapIterable;
const { isFastRefreshEnabled: $7ef244517b504261$var$isFastRefreshEnabled$1  } = $7ef244517b504261$var$Recoil_ReactMode;
class $7ef244517b504261$var$DefaultValue {
}
const $7ef244517b504261$var$DEFAULT_VALUE = new $7ef244517b504261$var$DefaultValue();
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$nodes = new Map(); // flowlint-next-line unclear-type:off
const $7ef244517b504261$var$recoilValues = new Map();
/* eslint-disable no-redeclare */ function $7ef244517b504261$var$recoilValuesForKeys(keys) {
    return $7ef244517b504261$var$Recoil_mapIterable(keys, (key)=>$7ef244517b504261$var$Recoil_nullthrows($7ef244517b504261$var$recoilValues.get(key)));
}
function $7ef244517b504261$var$checkForDuplicateAtomKey(key) {
    if ($7ef244517b504261$var$nodes.has(key)) {
        const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;
        // TODO Figure this out for open-source
        if (!$7ef244517b504261$var$isFastRefreshEnabled$1()) $7ef244517b504261$var$Recoil_expectationViolation(message, "recoil");
    }
}
function $7ef244517b504261$var$registerNode(node) {
    if ($7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) $7ef244517b504261$var$checkForDuplicateAtomKey(node.key);
    $7ef244517b504261$var$nodes.set(node.key, node);
    const recoilValue = node.set == null ? new $7ef244517b504261$var$Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new $7ef244517b504261$var$Recoil_RecoilValue$1.RecoilState(node.key);
    $7ef244517b504261$var$recoilValues.set(node.key, recoilValue);
    return recoilValue;
}
/* eslint-enable no-redeclare */ class $7ef244517b504261$var$NodeMissingError extends Error {
} // flowlint-next-line unclear-type:off
function $7ef244517b504261$var$getNode(key) {
    const node = $7ef244517b504261$var$nodes.get(key);
    if (node == null) throw new $7ef244517b504261$var$NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
    return node;
} // flowlint-next-line unclear-type:off
function $7ef244517b504261$var$getNodeMaybe(key) {
    return $7ef244517b504261$var$nodes.get(key);
}
const $7ef244517b504261$var$configDeletionHandlers = new Map();
function $7ef244517b504261$var$deleteNodeConfigIfPossible(key) {
    var _node$shouldDeleteCon;
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const node = $7ef244517b504261$var$nodes.get(key);
    if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
        var _getConfigDeletionHan;
        $7ef244517b504261$var$nodes.delete(key);
        (_getConfigDeletionHan = $7ef244517b504261$var$getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 || _getConfigDeletionHan();
        $7ef244517b504261$var$configDeletionHandlers.delete(key);
    }
}
function $7ef244517b504261$var$setConfigDeletionHandler(key, fn) {
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    if (fn === undefined) $7ef244517b504261$var$configDeletionHandlers.delete(key);
    else $7ef244517b504261$var$configDeletionHandlers.set(key, fn);
}
function $7ef244517b504261$var$getConfigDeletionHandler(key) {
    return $7ef244517b504261$var$configDeletionHandlers.get(key);
}
var $7ef244517b504261$var$Recoil_Node = {
    nodes: $7ef244517b504261$var$nodes,
    recoilValues: $7ef244517b504261$var$recoilValues,
    registerNode: $7ef244517b504261$var$registerNode,
    getNode: $7ef244517b504261$var$getNode,
    getNodeMaybe: $7ef244517b504261$var$getNodeMaybe,
    deleteNodeConfigIfPossible: $7ef244517b504261$var$deleteNodeConfigIfPossible,
    setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler,
    getConfigDeletionHandler: $7ef244517b504261$var$getConfigDeletionHandler,
    recoilValuesForKeys: $7ef244517b504261$var$recoilValuesForKeys,
    NodeMissingError: $7ef244517b504261$var$NodeMissingError,
    DefaultValue: $7ef244517b504261$var$DefaultValue,
    DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$enqueueExecution(s, f) {
    f();
}
var $7ef244517b504261$var$Recoil_Queue = {
    enqueueExecution: $7ef244517b504261$var$enqueueExecution
};
function $7ef244517b504261$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $7ef244517b504261$var$hamt_1 = $7ef244517b504261$var$createCommonjsModule(function(module) {
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/ var hamt = {}; // export
    /* Configuration
 ******************************************************************************/ var SIZE = 5;
    var BUCKET_SIZE = Math.pow(2, SIZE);
    var MASK = BUCKET_SIZE - 1;
    var MAX_INDEX_NODE = BUCKET_SIZE / 2;
    var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
    /*
 ******************************************************************************/ var nothing = {};
    var constant = function constant(x) {
        return function() {
            return x;
        };
    };
    /**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/ var hash = hamt.hash = function(str) {
        var type = typeof str === "undefined" ? "undefined" : _typeof(str);
        if (type === "number") return str;
        if (type !== "string") str += "";
        var hash = 0;
        for(var i = 0, len = str.length; i < len; ++i){
            var c = str.charCodeAt(i);
            hash = (hash << 5) - hash + c | 0;
        }
        return hash;
    };
    /* Bit Ops
 ******************************************************************************/ /**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/ var popcount = function popcount(x) {
        x -= x >> 1 & 0x55555555;
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x += x >> 8;
        x += x >> 16;
        return x & 0x7f;
    };
    var hashFragment = function hashFragment(shift, h) {
        return h >>> shift & MASK;
    };
    var toBitmap = function toBitmap(x) {
        return 1 << x;
    };
    var fromBitmap = function fromBitmap(bitmap, bit) {
        return popcount(bitmap & bit - 1);
    };
    /* Array Ops
 ******************************************************************************/ /**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/ var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
        var out = arr;
        if (!mutate) {
            var len = arr.length;
            out = new Array(len);
            for(var i = 0; i < len; ++i)out[i] = arr[i];
        }
        out[at] = v;
        return out;
    };
    /**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/ var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
        var newLen = arr.length - 1;
        var i = 0;
        var g = 0;
        var out = arr;
        if (mutate) i = g = at;
        else {
            out = new Array(newLen);
            while(i < at)out[g++] = arr[i++];
        }
        ++i;
        while(i <= newLen)out[g++] = arr[i++];
        if (mutate) out.length = newLen;
        return out;
    };
    /**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/ var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
        var len = arr.length;
        if (mutate) {
            var _i = len;
            while(_i >= at)arr[_i--] = arr[_i];
            arr[at] = v;
            return arr;
        }
        var i = 0, g = 0;
        var out = new Array(len + 1);
        while(i < at)out[g++] = arr[i++];
        out[at] = v;
        while(i < len)out[++g] = arr[i++];
        return out;
    };
    /* Node Structures
 ******************************************************************************/ var LEAF = 1;
    var COLLISION = 2;
    var INDEX = 3;
    var ARRAY = 4;
    /**
    Empty node.
*/ var empty = {
        __hamt_isEmpty: true
    };
    var isEmptyNode = function isEmptyNode(x) {
        return x === empty || x && x.__hamt_isEmpty;
    };
    /**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/ var Leaf = function Leaf(edit, hash, key, value) {
        return {
            type: LEAF,
            edit: edit,
            hash: hash,
            key: key,
            value: value,
            _modify: Leaf__modify
        };
    };
    /**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/ var Collision = function Collision(edit, hash, children) {
        return {
            type: COLLISION,
            edit: edit,
            hash: hash,
            children: children,
            _modify: Collision__modify
        };
    };
    /**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/ var IndexedNode = function IndexedNode(edit, mask, children) {
        return {
            type: INDEX,
            edit: edit,
            mask: mask,
            children: children,
            _modify: IndexedNode__modify
        };
    };
    /**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/ var ArrayNode = function ArrayNode(edit, size, children) {
        return {
            type: ARRAY,
            edit: edit,
            size: size,
            children: children,
            _modify: ArrayNode__modify
        };
    };
    /**
    Is `node` a leaf node?
*/ var isLeaf = function isLeaf(node) {
        return node === empty || node.type === LEAF || node.type === COLLISION;
    };
    /* Internal node operations.
 ******************************************************************************/ /**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/ var expand = function expand(edit, frag, child, bitmap, subNodes) {
        var arr = [];
        var bit = bitmap;
        var count = 0;
        for(var i = 0; bit; ++i){
            if (bit & 1) arr[i] = subNodes[count++];
            bit >>>= 1;
        }
        arr[frag] = child;
        return ArrayNode(edit, count + 1, arr);
    };
    /**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/ var pack = function pack(edit, count, removed, elements) {
        var children = new Array(count - 1);
        var g = 0;
        var bitmap = 0;
        for(var i = 0, len = elements.length; i < len; ++i)if (i !== removed) {
            var elem = elements[i];
            if (elem && !isEmptyNode(elem)) {
                children[g++] = elem;
                bitmap |= 1 << i;
            }
        }
        return IndexedNode(edit, bitmap, children);
    };
    /**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/ var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
        if (h1 === h2) return Collision(edit, h1, [
            n2,
            n1
        ]);
        var subH1 = hashFragment(shift, h1);
        var subH2 = hashFragment(shift, h2);
        return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [
            mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)
        ] : subH1 < subH2 ? [
            n1,
            n2
        ] : [
            n2,
            n1
        ]);
    };
    /**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/ var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
        var len = list.length;
        for(var i = 0; i < len; ++i){
            var child = list[i];
            if (keyEq(k, child.key)) {
                var value = child.value;
                var _newValue = f(value);
                if (_newValue === value) return list;
                if (_newValue === nothing) {
                    --size.value;
                    return arraySpliceOut(mutate, i, list);
                }
                return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
            }
        }
        var newValue = f();
        if (newValue === nothing) return list;
        ++size.value;
        return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
    };
    var canEditNode = function canEditNode(edit, node) {
        return edit === node.edit;
    };
    /* Editing
 ******************************************************************************/ var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
        if (keyEq(k, this.key)) {
            var _v = f(this.value);
            if (_v === this.value) return this;
            else if (_v === nothing) {
                --size.value;
                return empty;
            }
            if (canEditNode(edit, this)) {
                this.value = _v;
                return this;
            }
            return Leaf(edit, h, k, _v);
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
        if (h === this.hash) {
            var canEdit = canEditNode(edit, this);
            var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
            if (list === this.children) return this;
            return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
        var mask = this.mask;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var bit = toBitmap(frag);
        var indx = fromBitmap(mask, bit);
        var exists = mask & bit;
        var current = exists ? children[indx] : empty;
        var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (current === child) return this;
        var canEdit = canEditNode(edit, this);
        var bitmap = mask;
        var newChildren = void 0;
        if (exists && isEmptyNode(child)) {
            // remove
            bitmap &= ~bit;
            if (!bitmap) return empty;
            if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse
            newChildren = arraySpliceOut(canEdit, indx, children);
        } else if (!exists && !isEmptyNode(child)) {
            // add
            if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
            bitmap |= bit;
            newChildren = arraySpliceIn(canEdit, indx, child, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, indx, child, children);
        if (canEdit) {
            this.mask = bitmap;
            this.children = newChildren;
            return this;
        }
        return IndexedNode(edit, bitmap, newChildren);
    };
    var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
        var count = this.size;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var child = children[frag];
        var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (child === newChild) return this;
        var canEdit = canEditNode(edit, this);
        var newChildren = void 0;
        if (isEmptyNode(child) && !isEmptyNode(newChild)) {
            // add
            ++count;
            newChildren = arrayUpdate(canEdit, frag, newChild, children);
        } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
            // remove
            --count;
            if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
            newChildren = arrayUpdate(canEdit, frag, empty, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, frag, newChild, children);
        if (canEdit) {
            this.size = count;
            this.children = newChildren;
            return this;
        }
        return ArrayNode(edit, count, newChildren);
    };
    empty._modify = function(edit, keyEq, shift, f, h, k, size) {
        var v = f();
        if (v === nothing) return empty;
        ++size.value;
        return Leaf(edit, h, k, v);
    };
    /*
 ******************************************************************************/ function Map1(editable, edit, config, root, size) {
        this._editable = editable;
        this._edit = edit;
        this._config = config;
        this._root = root;
        this._size = size;
    }
    Map1.prototype.setTree = function(newRoot, newSize) {
        if (this._editable) {
            this._root = newRoot;
            this._size = newSize;
            return this;
        }
        return newRoot === this._root ? this : new Map1(this._editable, this._edit, this._config, newRoot, newSize);
    };
    /* Queries
 ******************************************************************************/ /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/ var tryGetHash = hamt.tryGetHash = function(alt, hash, key, map) {
        var node = map._root;
        var shift = 0;
        var keyEq = map._config.keyEq;
        while(true)switch(node.type){
            case LEAF:
                return keyEq(key, node.key) ? node.value : alt;
            case COLLISION:
                if (hash === node.hash) {
                    var children = node.children;
                    for(var i = 0, len = children.length; i < len; ++i){
                        var child = children[i];
                        if (keyEq(key, child.key)) return child.value;
                    }
                }
                return alt;
            case INDEX:
                var frag = hashFragment(shift, hash);
                var bit = toBitmap(frag);
                if (node.mask & bit) {
                    node = node.children[fromBitmap(node.mask, bit)];
                    shift += SIZE;
                    break;
                }
                return alt;
            case ARRAY:
                node = node.children[hashFragment(shift, hash)];
                if (node) {
                    shift += SIZE;
                    break;
                }
                return alt;
            default:
                return alt;
        }
    };
    Map1.prototype.tryGetHash = function(alt, hash, key) {
        return tryGetHash(alt, hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/ var tryGet = hamt.tryGet = function(alt, key, map) {
        return tryGetHash(alt, map._config.hash(key), key, map);
    };
    Map1.prototype.tryGet = function(alt, key) {
        return tryGet(alt, key, this);
    };
    /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/ var getHash = hamt.getHash = function(hash, key, map) {
        return tryGetHash(undefined, hash, key, map);
    };
    Map1.prototype.getHash = function(hash, key) {
        return getHash(hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/ var get = hamt.get = function(key, map) {
        return tryGetHash(undefined, map._config.hash(key), key, map);
    };
    Map1.prototype.get = function(key, alt) {
        return tryGet(alt, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/ var hasHash = hamt.has = function(hash, key, map) {
        return tryGetHash(nothing, hash, key, map) !== nothing;
    };
    Map1.prototype.hasHash = function(hash, key) {
        return hasHash(hash, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/ var has = hamt.has = function(key, map) {
        return hasHash(map._config.hash(key), key, map);
    };
    Map1.prototype.has = function(key) {
        return has(key, this);
    };
    var defKeyCompare = function defKeyCompare(x, y) {
        return x === y;
    };
    /**
    Create an empty map.

    @param config Configuration.
*/ hamt.make = function(config) {
        return new Map1(0, 0, {
            keyEq: config && config.keyEq || defKeyCompare,
            hash: config && config.hash || hash
        }, empty, 0);
    };
    /**
    Empty map.
*/ hamt.empty = hamt.make();
    /**
    Does `map` contain any elements?
*/ var isEmpty = hamt.isEmpty = function(map) {
        return map && !!isEmptyNode(map._root);
    };
    Map1.prototype.isEmpty = function() {
        return isEmpty(this);
    };
    /* Updates
 ******************************************************************************/ /**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/ var modifyHash = hamt.modifyHash = function(f, hash, key, map) {
        var size = {
            value: map._size
        };
        var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);
        return map.setTree(newRoot, size.value);
    };
    Map1.prototype.modifyHash = function(hash, key, f) {
        return modifyHash(f, hash, key, this);
    };
    /**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/ var modify = hamt.modify = function(f, key, map) {
        return modifyHash(f, map._config.hash(key), key, map);
    };
    Map1.prototype.modify = function(key, f) {
        return modify(f, key, this);
    };
    /**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/ var setHash = hamt.setHash = function(hash, key, value, map) {
        return modifyHash(constant(value), hash, key, map);
    };
    Map1.prototype.setHash = function(hash, key, value) {
        return setHash(hash, key, value, this);
    };
    /**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/ var set = hamt.set = function(key, value, map) {
        return setHash(map._config.hash(key), key, value, map);
    };
    Map1.prototype.set = function(key, value) {
        return set(key, value, this);
    };
    /**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/ var del = constant(nothing);
    var removeHash = hamt.removeHash = function(hash, key, map) {
        return modifyHash(del, hash, key, map);
    };
    Map1.prototype.removeHash = Map1.prototype.deleteHash = function(hash, key) {
        return removeHash(hash, key, this);
    };
    /**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/ var remove = hamt.remove = function(key, map) {
        return removeHash(map._config.hash(key), key, map);
    };
    Map1.prototype.remove = Map1.prototype.delete = function(key) {
        return remove(key, this);
    };
    /* Mutation
 ******************************************************************************/ /**
    Mark `map` as mutable.
 */ var beginMutation = hamt.beginMutation = function(map) {
        return new Map1(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
    };
    Map1.prototype.beginMutation = function() {
        return beginMutation(this);
    };
    /**
    Mark `map` as immutable.
 */ var endMutation = hamt.endMutation = function(map) {
        map._editable = map._editable && map._editable - 1;
        return map;
    };
    Map1.prototype.endMutation = function() {
        return endMutation(this);
    };
    /**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/ var mutate = hamt.mutate = function(f, map) {
        var transient = beginMutation(map);
        f(transient);
        return endMutation(transient);
    };
    Map1.prototype.mutate = function(f) {
        return mutate(f, this);
    };
    /* Traversal
 ******************************************************************************/ /**
    Apply a continuation.
*/ var appk = function appk(k) {
        return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
    };
    /**
    Recursively visit all values stored in an array of nodes lazily.
*/ var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
        while(i < len){
            var child = children[i++];
            if (child && !isEmptyNode(child)) return lazyVisit(child, f, [
                len,
                children,
                i,
                f,
                k
            ]);
        }
        return appk(k);
    };
    /**
    Recursively visit all values stored in `node` lazily.
*/ var lazyVisit = function lazyVisit(node, f, k) {
        switch(node.type){
            case LEAF:
                return {
                    value: f(node),
                    rest: k
                };
            case COLLISION:
            case ARRAY:
            case INDEX:
                var children = node.children;
                return lazyVisitChildren(children.length, children, 0, f, k);
            default:
                return appk(k);
        }
    };
    var DONE = {
        done: true
    };
    /**
    Javascript iterator over a map.
*/ function MapIterator(v) {
        this.v = v;
    }
    MapIterator.prototype.next = function() {
        if (!this.v) return DONE;
        var v0 = this.v;
        this.v = appk(v0.rest);
        return v0;
    };
    MapIterator.prototype[Symbol.iterator] = function() {
        return this;
    };
    /**
    Lazily visit each value in map with function `f`.
*/ var visit = function visit(map, f) {
        return new MapIterator(lazyVisit(map._root, f));
    };
    /**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/ var buildPairs = function buildPairs(x) {
        return [
            x.key,
            x.value
        ];
    };
    var entries = hamt.entries = function(map) {
        return visit(map, buildPairs);
    };
    Map1.prototype.entries = Map1.prototype[Symbol.iterator] = function() {
        return entries(this);
    };
    /**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/ var buildKeys = function buildKeys(x) {
        return x.key;
    };
    var keys = hamt.keys = function(map) {
        return visit(map, buildKeys);
    };
    Map1.prototype.keys = function() {
        return keys(this);
    };
    /**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/ var buildValues = function buildValues(x) {
        return x.value;
    };
    var values = hamt.values = Map1.prototype.values = function(map) {
        return visit(map, buildValues);
    };
    Map1.prototype.values = function() {
        return values(this);
    };
    /* Fold
 ******************************************************************************/ /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/ var fold = hamt.fold = function(f, z, m) {
        var root = m._root;
        if (root.type === LEAF) return f(z, root.value, root.key);
        var toVisit = [
            root.children
        ];
        var children = void 0;
        while(children = toVisit.pop())for(var i = 0, len = children.length; i < len;){
            var child = children[i++];
            if (child && child.type) {
                if (child.type === LEAF) z = f(z, child.value, child.key);
                else toVisit.push(child.children);
            }
        }
        return z;
    };
    Map1.prototype.fold = function(f, z) {
        return fold(f, z, this);
    };
    /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/ var forEach = hamt.forEach = function(f, map) {
        return fold(function(_, value, key) {
            return f(value, key, map);
        }, null, map);
    };
    Map1.prototype.forEach = function(f) {
        return forEach(f, this);
    };
    /* Aggregate
 ******************************************************************************/ /**
    Get the number of entries in `map`.
*/ var count = hamt.count = function(map) {
        return map._size;
    };
    Map1.prototype.count = function() {
        return count(this);
    };
    Object.defineProperty(Map1.prototype, "size", {
        get: Map1.prototype.count
    });
    /* Export
 ******************************************************************************/ if (module.exports) module.exports = hamt;
    else undefined.hamt = hamt;
});
class $7ef244517b504261$var$BuiltInMap {
    constructor(existing){
        $7ef244517b504261$var$_defineProperty(this, "_map", void 0);
        this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
    }
    keys() {
        return this._map.keys();
    }
    entries() {
        return this._map.entries();
    }
    get(k) {
        return this._map.get(k);
    }
    has(k) {
        return this._map.has(k);
    }
    set(k, v) {
        this._map.set(k, v);
        return this;
    }
    delete(k) {
        this._map.delete(k);
        return this;
    }
    clone() {
        return $7ef244517b504261$var$persistentMap(this);
    }
    toMap() {
        return new Map(this._map);
    }
}
class $7ef244517b504261$var$HashArrayMappedTrieMap {
    // Because hamt.empty is not a function there is no way to introduce type
    // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
    // $FlowIssue
    constructor(existing){
        $7ef244517b504261$var$_defineProperty(this, "_hamt", $7ef244517b504261$var$hamt_1.empty.beginMutation());
        if (existing instanceof $7ef244517b504261$var$HashArrayMappedTrieMap) {
            const h = existing._hamt.endMutation();
            existing._hamt = h.beginMutation();
            this._hamt = h.beginMutation();
        } else if (existing) for (const [k, v] of existing.entries())this._hamt.set(k, v);
    }
    keys() {
        return this._hamt.keys();
    }
    entries() {
        return this._hamt.entries();
    }
    get(k) {
        return this._hamt.get(k);
    }
    has(k) {
        return this._hamt.has(k);
    }
    set(k, v) {
        this._hamt.set(k, v);
        return this;
    }
    delete(k) {
        this._hamt.delete(k);
        return this;
    }
    clone() {
        return $7ef244517b504261$var$persistentMap(this);
    }
    toMap() {
        return new Map(this._hamt);
    }
}
function $7ef244517b504261$var$persistentMap(existing) {
    if ($7ef244517b504261$var$Recoil_gkx("recoil_hamt_2020")) return new $7ef244517b504261$var$HashArrayMappedTrieMap(existing);
    else return new $7ef244517b504261$var$BuiltInMap(existing);
}
var $7ef244517b504261$var$Recoil_PersistentMap = {
    persistentMap: $7ef244517b504261$var$persistentMap
};
var $7ef244517b504261$var$Recoil_PersistentMap_1 = $7ef244517b504261$var$Recoil_PersistentMap.persistentMap;
var $7ef244517b504261$var$Recoil_PersistentMap$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    persistentMap: $7ef244517b504261$var$Recoil_PersistentMap_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */ function $7ef244517b504261$var$differenceSets(set, ...setsWithValuesToRemove) {
    const ret = new Set();
    FIRST: for (const value of set){
        for (const otherSet of setsWithValuesToRemove){
            if (otherSet.has(value)) continue FIRST;
        }
        ret.add(value);
    }
    return ret;
}
var $7ef244517b504261$var$Recoil_differenceSets = $7ef244517b504261$var$differenceSets;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */ function $7ef244517b504261$var$mapMap(map, callback) {
    const result = new Map();
    map.forEach((value, key)=>{
        result.set(key, callback(value, key));
    });
    return result;
}
var $7ef244517b504261$var$Recoil_mapMap = $7ef244517b504261$var$mapMap;
function $7ef244517b504261$var$makeGraph() {
    return {
        nodeDeps: new Map(),
        nodeToNodeSubscriptions: new Map()
    };
}
function $7ef244517b504261$var$cloneGraph(graph) {
    return {
        nodeDeps: $7ef244517b504261$var$Recoil_mapMap(graph.nodeDeps, (s)=>new Set(s)),
        nodeToNodeSubscriptions: $7ef244517b504261$var$Recoil_mapMap(graph.nodeToNodeSubscriptions, (s)=>new Set(s))
    };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.
function $7ef244517b504261$var$mergeDepsIntoGraph(key, newDeps, graph, // graph compared with olderGraph:
olderGraph) {
    const { nodeDeps: nodeDeps , nodeToNodeSubscriptions: nodeToNodeSubscriptions  } = graph;
    const oldDeps = nodeDeps.get(key);
    if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) return;
     // Update nodeDeps:
    nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:
    const addedDeps = oldDeps == null ? newDeps : $7ef244517b504261$var$Recoil_differenceSets(newDeps, oldDeps);
    for (const dep of addedDeps){
        if (!nodeToNodeSubscriptions.has(dep)) nodeToNodeSubscriptions.set(dep, new Set());
        const existing = $7ef244517b504261$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
        existing.add(key);
    } // Remove removed deps from nodeToNodeSubscriptions:
    if (oldDeps) {
        const removedDeps = $7ef244517b504261$var$Recoil_differenceSets(oldDeps, newDeps);
        for (const dep of removedDeps){
            if (!nodeToNodeSubscriptions.has(dep)) return;
            const existing = $7ef244517b504261$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
            existing.delete(key);
            if (existing.size === 0) nodeToNodeSubscriptions.delete(dep);
        }
    }
}
function $7ef244517b504261$var$saveDepsToStore(key, deps, store, version) {
    var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;
    const storeState = store.getState();
    if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $7ef244517b504261$var$Recoil_recoverableViolation("Tried to save dependencies to a discarded tree");
     // Merge the dependencies discovered into the store's dependency map
    // for the version that was read:
    const graph = store.getGraph(version);
    $7ef244517b504261$var$mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
    // into later versions if they don't already have their own:
    if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
        const currentGraph = store.getGraph(storeState.currentTree.version);
        $7ef244517b504261$var$mergeDepsIntoGraph(key, deps, currentGraph, graph);
    }
    if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
        var _storeState$nextTree2;
        const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;
        if (nextVersion !== undefined) {
            const nextGraph = store.getGraph(nextVersion);
            $7ef244517b504261$var$mergeDepsIntoGraph(key, deps, nextGraph, graph);
        }
    }
}
var $7ef244517b504261$var$Recoil_Graph = {
    cloneGraph: $7ef244517b504261$var$cloneGraph,
    graph: $7ef244517b504261$var$makeGraph,
    saveDepsToStore: $7ef244517b504261$var$saveDepsToStore
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let $7ef244517b504261$var$nextTreeStateVersion = 0;
const $7ef244517b504261$var$getNextTreeStateVersion = ()=>$7ef244517b504261$var$nextTreeStateVersion++;
let $7ef244517b504261$var$nextStoreID = 0;
const $7ef244517b504261$var$getNextStoreID = ()=>$7ef244517b504261$var$nextStoreID++;
let $7ef244517b504261$var$nextComponentID = 0;
const $7ef244517b504261$var$getNextComponentID = ()=>$7ef244517b504261$var$nextComponentID++;
var $7ef244517b504261$var$Recoil_Keys = {
    getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion,
    getNextStoreID: $7ef244517b504261$var$getNextStoreID,
    getNextComponentID: $7ef244517b504261$var$getNextComponentID
};
const { persistentMap: $7ef244517b504261$var$persistentMap$1  } = $7ef244517b504261$var$Recoil_PersistentMap$1;
const { graph: $7ef244517b504261$var$graph  } = $7ef244517b504261$var$Recoil_Graph;
const { getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$1  } = $7ef244517b504261$var$Recoil_Keys;
function $7ef244517b504261$var$makeEmptyTreeState() {
    const version = $7ef244517b504261$var$getNextTreeStateVersion$1();
    return {
        version: version,
        stateID: version,
        transactionMetadata: {},
        dirtyAtoms: new Set(),
        atomValues: $7ef244517b504261$var$persistentMap$1(),
        nonvalidatedAtoms: $7ef244517b504261$var$persistentMap$1()
    };
}
function $7ef244517b504261$var$makeEmptyStoreState() {
    const currentTree = $7ef244517b504261$var$makeEmptyTreeState();
    return {
        currentTree: currentTree,
        nextTree: null,
        previousTree: null,
        commitDepth: 0,
        knownAtoms: new Set(),
        knownSelectors: new Set(),
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(currentTree.version, $7ef244517b504261$var$graph()),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        nodeCleanupFunctions: new Map()
    };
}
var $7ef244517b504261$var$Recoil_State = {
    makeEmptyTreeState: $7ef244517b504261$var$makeEmptyTreeState,
    makeEmptyStoreState: $7ef244517b504261$var$makeEmptyStoreState,
    getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $7ef244517b504261$var$RetentionZone {
}
function $7ef244517b504261$var$retentionZone() {
    return new $7ef244517b504261$var$RetentionZone();
}
var $7ef244517b504261$var$Recoil_RetentionZone = {
    RetentionZone: $7ef244517b504261$var$RetentionZone,
    retentionZone: $7ef244517b504261$var$retentionZone
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$setByAddingToSet(set, v) {
    const next = new Set(set);
    next.add(v);
    return next;
}
function $7ef244517b504261$var$setByDeletingFromSet(set, v) {
    const next = new Set(set);
    next.delete(v);
    return next;
}
function $7ef244517b504261$var$mapBySettingInMap(map, k, v) {
    const next = new Map(map);
    next.set(k, v);
    return next;
}
function $7ef244517b504261$var$mapByUpdatingInMap(map, k, updater) {
    const next = new Map(map);
    next.set(k, updater(next.get(k)));
    return next;
}
function $7ef244517b504261$var$mapByDeletingFromMap(map, k) {
    const next = new Map(map);
    next.delete(k);
    return next;
}
function $7ef244517b504261$var$mapByDeletingMultipleFromMap(map, ks) {
    const next = new Map(map);
    ks.forEach((k)=>next.delete(k));
    return next;
}
var $7ef244517b504261$var$Recoil_CopyOnWrite = {
    setByAddingToSet: $7ef244517b504261$var$setByAddingToSet,
    setByDeletingFromSet: $7ef244517b504261$var$setByDeletingFromSet,
    mapBySettingInMap: $7ef244517b504261$var$mapBySettingInMap,
    mapByUpdatingInMap: $7ef244517b504261$var$mapByUpdatingInMap,
    mapByDeletingFromMap: $7ef244517b504261$var$mapByDeletingFromMap,
    mapByDeletingMultipleFromMap: $7ef244517b504261$var$mapByDeletingMultipleFromMap
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */ function* $7ef244517b504261$var$filterIterable(iterable, predicate) {
    // Use generator to create iterable/iterator
    let index = 0;
    for (const value of iterable)if (predicate(value, index++)) yield value;
}
var $7ef244517b504261$var$Recoil_filterIterable = $7ef244517b504261$var$filterIterable;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */ // $FlowIssue[unclear-type]
function $7ef244517b504261$var$lazyProxy(base, factories) {
    const proxy = new Proxy(base, {
        // Compute and cache lazy property if not already done.
        get: (target, prop)=>{
            if (!(prop in target) && prop in factories) target[prop] = factories[prop]();
            return target[prop];
        },
        // This method allows user to iterate keys as normal
        ownKeys: (target)=>{
            return Object.keys(target);
        }
    }); // $FlowIssue[incompatible-return]
    return proxy;
}
var $7ef244517b504261$var$Recoil_lazyProxy = $7ef244517b504261$var$lazyProxy;
const { getNode: $7ef244517b504261$var$getNode$1 , getNodeMaybe: $7ef244517b504261$var$getNodeMaybe$1 , recoilValuesForKeys: $7ef244517b504261$var$recoilValuesForKeys$1  } = $7ef244517b504261$var$Recoil_Node;
const { RetentionZone: $7ef244517b504261$var$RetentionZone$1  } = $7ef244517b504261$var$Recoil_RetentionZone;
const { setByAddingToSet: $7ef244517b504261$var$setByAddingToSet$1  } = $7ef244517b504261$var$Recoil_CopyOnWrite;
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$emptySet = Object.freeze(new Set());
class $7ef244517b504261$var$ReadOnlyRecoilValueError extends Error {
}
function $7ef244517b504261$var$initializeRetentionForNode(store, nodeKey, retainedBy) {
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return ()=>undefined;
    const { nodesRetainedByZone: nodesRetainedByZone  } = store.getState().retention;
    function addToZone(zone) {
        let set = nodesRetainedByZone.get(zone);
        if (!set) nodesRetainedByZone.set(zone, set = new Set());
        set.add(nodeKey);
    }
    if (retainedBy instanceof $7ef244517b504261$var$RetentionZone$1) addToZone(retainedBy);
    else if (Array.isArray(retainedBy)) for (const zone of retainedBy)addToZone(zone);
    return ()=>{
        if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
        const { retention: retention  } = store.getState();
        function deleteFromZone(zone) {
            const set = retention.nodesRetainedByZone.get(zone);
            set === null || set === void 0 || set.delete(nodeKey);
            if (set && set.size === 0) retention.nodesRetainedByZone.delete(zone);
        }
        if (retainedBy instanceof $7ef244517b504261$var$RetentionZone$1) deleteFromZone(retainedBy);
        else if (Array.isArray(retainedBy)) for (const zone of retainedBy)deleteFromZone(zone);
    };
}
function $7ef244517b504261$var$initializeNodeIfNewToStore(store, treeState, key, trigger) {
    const storeState = store.getState();
    if (storeState.nodeCleanupFunctions.has(key)) return;
    const node = $7ef244517b504261$var$getNode$1(key);
    const retentionCleanup = $7ef244517b504261$var$initializeRetentionForNode(store, key, node.retainedBy);
    const nodeCleanup = node.init(store, treeState, trigger);
    storeState.nodeCleanupFunctions.set(key, ()=>{
        nodeCleanup();
        retentionCleanup();
    });
}
function $7ef244517b504261$var$initializeNode(store, key, trigger) {
    $7ef244517b504261$var$initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}
function $7ef244517b504261$var$cleanUpNode(store, key) {
    var _state$nodeCleanupFun;
    const state = store.getState();
    (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 || _state$nodeCleanupFun();
    state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.
function $7ef244517b504261$var$getNodeLoadable(store, state, key) {
    $7ef244517b504261$var$initializeNodeIfNewToStore(store, state, key, "get");
    return $7ef244517b504261$var$getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change
function $7ef244517b504261$var$peekNodeLoadable(store, state, key) {
    return $7ef244517b504261$var$getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.
function $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
    var _node$invalidate;
    const node = $7ef244517b504261$var$getNodeMaybe$1(key);
    node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
    return {
        ...state,
        atomValues: state.atomValues.clone().delete(key),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
        dirtyAtoms: $7ef244517b504261$var$setByAddingToSet$1(state.dirtyAtoms, key)
    };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)
function $7ef244517b504261$var$setNodeValue(store, state, key, newValue) {
    const node = $7ef244517b504261$var$getNode$1(key);
    if (node.set == null) throw new $7ef244517b504261$var$ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
    const set = node.set; // so flow doesn't lose the above refinement.
    $7ef244517b504261$var$initializeNodeIfNewToStore(store, state, key, "set");
    return set(store, state, newValue);
}
function $7ef244517b504261$var$peekNodeInfo(store, state, key) {
    const storeState = store.getState();
    const graph = store.getGraph(state.version);
    const type = $7ef244517b504261$var$getNode$1(key).nodeType;
    return $7ef244517b504261$var$Recoil_lazyProxy({
        type: type
    }, {
        // $FlowFixMe[underconstrained-implicit-instantiation]
        loadable: ()=>$7ef244517b504261$var$peekNodeLoadable(store, state, key),
        isActive: ()=>storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
        isSet: ()=>type === "selector" ? false : state.atomValues.has(key),
        isModified: ()=>state.dirtyAtoms.has(key),
        // Report current dependencies.  If the node hasn't been evaluated, then
        // dependencies may be missing based on the current state.
        deps: ()=>{
            var _graph$nodeDeps$get;
            return $7ef244517b504261$var$recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
        },
        // Reports all "current" subscribers.  Evaluating other nodes or
        // previous in-progress async evaluations may introduce new subscribers.
        subscribers: ()=>{
            var _storeState$nodeToCom, _storeState$nodeToCom2;
            return {
                nodes: $7ef244517b504261$var$recoilValuesForKeys$1($7ef244517b504261$var$Recoil_filterIterable($7ef244517b504261$var$getDownstreamNodes(store, state, new Set([
                    key
                ])), (nodeKey)=>nodeKey !== key)),
                components: $7ef244517b504261$var$Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name])=>({
                        name: name
                    }))
            };
        }
    });
} // Find all of the recursively dependent nodes
function $7ef244517b504261$var$getDownstreamNodes(store, state, keys) {
    const visitedNodes = new Set();
    const visitingNodes = Array.from(keys);
    const graph = store.getGraph(state.version);
    for(let key = visitingNodes.pop(); key; key = visitingNodes.pop()){
        var _graph$nodeToNodeSubs;
        visitedNodes.add(key);
        const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : $7ef244517b504261$var$emptySet;
        for (const downstreamNode of subscribedNodes)if (!visitedNodes.has(downstreamNode)) visitingNodes.push(downstreamNode);
    }
    return visitedNodes;
}
var $7ef244517b504261$var$Recoil_FunctionalCore = {
    getNodeLoadable: $7ef244517b504261$var$getNodeLoadable,
    peekNodeLoadable: $7ef244517b504261$var$peekNodeLoadable,
    setNodeValue: $7ef244517b504261$var$setNodeValue,
    initializeNode: $7ef244517b504261$var$initializeNode,
    cleanUpNode: $7ef244517b504261$var$cleanUpNode,
    setUnvalidatedAtomValue_DEPRECATED: $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED,
    peekNodeInfo: $7ef244517b504261$var$peekNodeInfo,
    getDownstreamNodes: $7ef244517b504261$var$getDownstreamNodes
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let $7ef244517b504261$var$_invalidateMemoizedSnapshot = null;
function $7ef244517b504261$var$setInvalidateMemoizedSnapshot(invalidate) {
    $7ef244517b504261$var$_invalidateMemoizedSnapshot = invalidate;
}
function $7ef244517b504261$var$invalidateMemoizedSnapshot() {
    var _invalidateMemoizedSn;
    (_invalidateMemoizedSn = $7ef244517b504261$var$_invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 || _invalidateMemoizedSn();
}
var $7ef244517b504261$var$Recoil_SnapshotCache = {
    setInvalidateMemoizedSnapshot: $7ef244517b504261$var$setInvalidateMemoizedSnapshot,
    invalidateMemoizedSnapshot: $7ef244517b504261$var$invalidateMemoizedSnapshot
};
const { getDownstreamNodes: $7ef244517b504261$var$getDownstreamNodes$1 , getNodeLoadable: $7ef244517b504261$var$getNodeLoadable$1 , setNodeValue: $7ef244517b504261$var$setNodeValue$1  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { getNextComponentID: $7ef244517b504261$var$getNextComponentID$1  } = $7ef244517b504261$var$Recoil_Keys;
const { getNode: $7ef244517b504261$var$getNode$2 , getNodeMaybe: $7ef244517b504261$var$getNodeMaybe$2  } = $7ef244517b504261$var$Recoil_Node;
const { DefaultValue: $7ef244517b504261$var$DefaultValue$1  } = $7ef244517b504261$var$Recoil_Node;
const { reactMode: $7ef244517b504261$var$reactMode$1  } = $7ef244517b504261$var$Recoil_ReactMode;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$1 , RecoilState: $7ef244517b504261$var$RecoilState$1 , RecoilValueReadOnly: $7ef244517b504261$var$RecoilValueReadOnly$1 , isRecoilValue: $7ef244517b504261$var$isRecoilValue$1  } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { invalidateMemoizedSnapshot: $7ef244517b504261$var$invalidateMemoizedSnapshot$1  } = $7ef244517b504261$var$Recoil_SnapshotCache;
function $7ef244517b504261$var$getRecoilValueAsLoadable(store, { key: key  }, treeState = store.getState().currentTree) {
    var _storeState$nextTree, _storeState$previousT;
    // Reading from an older tree can cause bugs because the dependencies that we
    // discover during the read are lost.
    const storeState = store.getState();
    if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $7ef244517b504261$var$Recoil_recoverableViolation("Tried to read from a discarded tree");
    const loadable = $7ef244517b504261$var$getNodeLoadable$1(store, treeState, key);
    if (loadable.state === "loading") loadable.contents.catch(()=>{
        /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */ return;
    });
    return loadable;
}
function $7ef244517b504261$var$applyAtomValueWrites(atomValues, writes) {
    const result = atomValues.clone();
    writes.forEach((v, k)=>{
        if (v.state === "hasValue" && v.contents instanceof $7ef244517b504261$var$DefaultValue$1) result.delete(k);
        else result.set(k, v);
    });
    return result;
}
function $7ef244517b504261$var$valueFromValueOrUpdater(store, state, { key: key  }, valueOrUpdater) {
    if (typeof valueOrUpdater === "function") {
        // Updater form: pass in the current value. Throw if the current value
        // is unavailable (namely when updating an async selector that's
        // pending or errored):
        const current = $7ef244517b504261$var$getNodeLoadable$1(store, state, key);
        if (current.state === "loading") {
            const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
            $7ef244517b504261$var$Recoil_recoverableViolation(msg);
            throw $7ef244517b504261$var$Recoil_err(msg);
        } else if (current.state === "hasError") throw current.contents;
         // T itself may be a function, so our refinement is not sufficient:
        return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
    } else return valueOrUpdater;
}
function $7ef244517b504261$var$applyAction(store, state, action) {
    if (action.type === "set") {
        const { recoilValue: recoilValue , valueOrUpdater: valueOrUpdater  } = action;
        const newValue = $7ef244517b504261$var$valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
        const writes = $7ef244517b504261$var$setNodeValue$1(store, state, recoilValue.key, newValue);
        for (const [key, loadable] of writes.entries())$7ef244517b504261$var$writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === "setLoadable") {
        const { recoilValue: { key: key  } , loadable: loadable  } = action;
        $7ef244517b504261$var$writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === "markModified") {
        const { recoilValue: { key: key  }  } = action;
        state.dirtyAtoms.add(key);
    } else if (action.type === "setUnvalidated") {
        var _node$invalidate;
        // Write value directly to state bypassing the Node interface as the node
        // definitions may not have been loaded yet when processing the initial snapshot.
        const { recoilValue: { key: key  } , unvalidatedValue: unvalidatedValue  } = action;
        const node = $7ef244517b504261$var$getNodeMaybe$2(key);
        node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
        state.atomValues.delete(key);
        state.nonvalidatedAtoms.set(key, unvalidatedValue);
        state.dirtyAtoms.add(key);
    } else $7ef244517b504261$var$Recoil_recoverableViolation(`Unknown action ${action.type}`);
}
function $7ef244517b504261$var$writeLoadableToTreeState(state, key, loadable) {
    if (loadable.state === "hasValue" && loadable.contents instanceof $7ef244517b504261$var$DefaultValue$1) state.atomValues.delete(key);
    else state.atomValues.set(key, loadable);
    state.dirtyAtoms.add(key);
    state.nonvalidatedAtoms.delete(key);
}
function $7ef244517b504261$var$applyActionsToStore(store, actions) {
    store.replaceState((state)=>{
        const newState = $7ef244517b504261$var$copyTreeState(state);
        for (const action of actions)$7ef244517b504261$var$applyAction(store, newState, action);
        $7ef244517b504261$var$invalidateDownstreams(store, newState);
        $7ef244517b504261$var$invalidateMemoizedSnapshot$1();
        return newState;
    });
}
function $7ef244517b504261$var$queueOrPerformStateUpdate(store, action) {
    if ($7ef244517b504261$var$batchStack.length) {
        const actionsByStore = $7ef244517b504261$var$batchStack[$7ef244517b504261$var$batchStack.length - 1];
        let actions = actionsByStore.get(store);
        if (!actions) actionsByStore.set(store, actions = []);
        actions.push(action);
    } else $7ef244517b504261$var$applyActionsToStore(store, [
        action
    ]);
}
const $7ef244517b504261$var$batchStack = [];
function $7ef244517b504261$var$batchStart() {
    const actionsByStore = new Map();
    $7ef244517b504261$var$batchStack.push(actionsByStore);
    return ()=>{
        for (const [store, actions] of actionsByStore)$7ef244517b504261$var$applyActionsToStore(store, actions);
        const popped = $7ef244517b504261$var$batchStack.pop();
        if (popped !== actionsByStore) $7ef244517b504261$var$Recoil_recoverableViolation("Incorrect order of batch popping");
    };
}
function $7ef244517b504261$var$copyTreeState(state) {
    return {
        ...state,
        atomValues: state.atomValues.clone(),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
        dirtyAtoms: new Set(state.dirtyAtoms)
    };
}
function $7ef244517b504261$var$invalidateDownstreams(store, state) {
    // Inform any nodes that were changed or downstream of changes so that they
    // can clear out any caches as needed due to the update:
    const downstreams = $7ef244517b504261$var$getDownstreamNodes$1(store, state, state.dirtyAtoms);
    for (const key of downstreams){
        var _getNodeMaybe, _getNodeMaybe$invalid;
        (_getNodeMaybe = $7ef244517b504261$var$getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 || (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 || _getNodeMaybe$invalid.call(_getNodeMaybe, state);
    }
}
function $7ef244517b504261$var$setRecoilValue(store, recoilValue, valueOrUpdater) {
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: "set",
        recoilValue: recoilValue,
        valueOrUpdater: valueOrUpdater
    });
}
function $7ef244517b504261$var$setRecoilValueLoadable(store, recoilValue, loadable) {
    if (loadable instanceof $7ef244517b504261$var$DefaultValue$1) return $7ef244517b504261$var$setRecoilValue(store, recoilValue, loadable);
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: "setLoadable",
        recoilValue: recoilValue,
        loadable: loadable
    });
}
function $7ef244517b504261$var$markRecoilValueModified(store, recoilValue) {
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: "markModified",
        recoilValue: recoilValue
    });
}
function $7ef244517b504261$var$setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: "setUnvalidated",
        recoilValue: recoilValue,
        unvalidatedValue: unvalidatedValue
    });
}
function $7ef244517b504261$var$subscribeToRecoilValue(store, { key: key  }, callback, componentDebugName = null) {
    const subID = $7ef244517b504261$var$getNextComponentID$1();
    const storeState = store.getState();
    if (!storeState.nodeToComponentSubscriptions.has(key)) storeState.nodeToComponentSubscriptions.set(key, new Map());
    $7ef244517b504261$var$Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [
        componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : "<not captured>",
        callback
    ]); // Handle the case that, during the same tick that we are subscribing, an atom
    // has been updated by some effect handler. Otherwise we will miss the update.
    const mode = $7ef244517b504261$var$reactMode$1();
    if (mode.early && (mode.mode === "LEGACY" || mode.mode === "MUTABLE_SOURCE")) {
        const nextTree = store.getState().nextTree;
        if (nextTree && nextTree.dirtyAtoms.has(key)) callback(nextTree);
    }
    return {
        release: ()=>{
            const releaseStoreState = store.getState();
            const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);
            if (subs === undefined || !subs.has(subID)) {
                $7ef244517b504261$var$Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
                return;
            }
            subs.delete(subID);
            if (subs.size === 0) releaseStoreState.nodeToComponentSubscriptions.delete(key);
        }
    };
}
function $7ef244517b504261$var$refreshRecoilValue(store, recoilValue) {
    var _node$clearCache;
    const { currentTree: currentTree  } = store.getState();
    const node = $7ef244517b504261$var$getNode$2(recoilValue.key);
    (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, currentTree);
}
var $7ef244517b504261$var$Recoil_RecoilValueInterface = {
    RecoilValueReadOnly: $7ef244517b504261$var$RecoilValueReadOnly$1,
    AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$1,
    RecoilState: $7ef244517b504261$var$RecoilState$1,
    getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable,
    setRecoilValue: $7ef244517b504261$var$setRecoilValue,
    setRecoilValueLoadable: $7ef244517b504261$var$setRecoilValueLoadable,
    markRecoilValueModified: $7ef244517b504261$var$markRecoilValueModified,
    setUnvalidatedRecoilValue: $7ef244517b504261$var$setUnvalidatedRecoilValue,
    subscribeToRecoilValue: $7ef244517b504261$var$subscribeToRecoilValue,
    isRecoilValue: $7ef244517b504261$var$isRecoilValue$1,
    applyAtomValueWrites: $7ef244517b504261$var$applyAtomValueWrites,
    batchStart: // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
    $7ef244517b504261$var$batchStart,
    writeLoadableToTreeState: $7ef244517b504261$var$writeLoadableToTreeState,
    invalidateDownstreams: $7ef244517b504261$var$invalidateDownstreams,
    copyTreeState: $7ef244517b504261$var$copyTreeState,
    refreshRecoilValue: $7ef244517b504261$var$refreshRecoilValue
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */ function $7ef244517b504261$var$someSet(set, callback, context) {
    const iterator = set.entries();
    let current = iterator.next();
    while(!current.done){
        const entry = current.value;
        if (callback.call(context, entry[1], entry[0], set)) return true;
        current = iterator.next();
    }
    return false;
}
var $7ef244517b504261$var$Recoil_someSet = $7ef244517b504261$var$someSet;
const { cleanUpNode: $7ef244517b504261$var$cleanUpNode$1  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { deleteNodeConfigIfPossible: $7ef244517b504261$var$deleteNodeConfigIfPossible$1 , getNode: $7ef244517b504261$var$getNode$3  } = $7ef244517b504261$var$Recoil_Node;
const { RetentionZone: $7ef244517b504261$var$RetentionZone$2  } = $7ef244517b504261$var$Recoil_RetentionZone;
// Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.
const $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS = 120000;
const $7ef244517b504261$var$emptySet$1 = new Set();
function $7ef244517b504261$var$releaseRetainablesNowOnCurrentTree(store, retainables) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    if (storeState.nextTree) {
        $7ef244517b504261$var$Recoil_recoverableViolation("releaseNodesNowOnCurrentTree should only be called at the end of a batch");
        return; // leak memory rather than erase something that's about to be used.
    }
    const nodes = new Set();
    for (const r of retainables){
        if (r instanceof $7ef244517b504261$var$RetentionZone$2) for (const n of $7ef244517b504261$var$nodesRetainedByZone(storeState, r))nodes.add(n);
        else nodes.add(r);
    }
    const releasableNodes = $7ef244517b504261$var$findReleasableNodes(store, nodes);
    for (const node of releasableNodes)$7ef244517b504261$var$releaseNode(store, treeState, node);
}
function $7ef244517b504261$var$findReleasableNodes(store, searchFromNodes) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    const graph = store.getGraph(treeState.version);
    const releasableNodes = new Set(); // mutated to collect answer
    const nonReleasableNodes = new Set();
    findReleasableNodesInner(searchFromNodes);
    return releasableNodes;
    function findReleasableNodesInner(searchFromNodes) {
        const releasableNodesFoundThisIteration = new Set();
        const downstreams = $7ef244517b504261$var$getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, nonReleasableNodes // don't descend into these
        ); // Find which of the downstream nodes are releasable and which are not:
        for (const node of downstreams){
            var _storeState$retention;
            // Not releasable if configured to be retained forever:
            if ($7ef244517b504261$var$getNode$3(node).retainedBy === "recoilRoot") {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained directly by a component:
            if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained by a zone:
            if ($7ef244517b504261$var$zonesThatCouldRetainNode(node).some((z)=>storeState.retention.referenceCounts.get(z))) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if it has a non-releasable child (which will already be in
            // nonReleasableNodes because we are going in topological order):
            const nodeChildren = graph.nodeToNodeSubscriptions.get(node);
            if (nodeChildren && $7ef244517b504261$var$Recoil_someSet(nodeChildren, (child)=>nonReleasableNodes.has(child))) {
                nonReleasableNodes.add(node);
                continue;
            }
            releasableNodes.add(node);
            releasableNodesFoundThisIteration.add(node);
        } // If we found any releasable nodes, we need to walk UP from those nodes to
        // find whether their parents can now be released as well:
        const parents = new Set();
        for (const node of releasableNodesFoundThisIteration)for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : $7ef244517b504261$var$emptySet$1){
            var _graph$nodeDeps$get;
            if (!releasableNodes.has(parent)) parents.add(parent);
        }
        if (parents.size) findReleasableNodesInner(parents);
    }
} // Children before parents
function $7ef244517b504261$var$getDownstreamNodesInTopologicalOrder(store, treeState, nodes, doNotDescendInto1, doNotDescendInto2) {
    const graph = store.getGraph(treeState.version);
    const answer = [];
    const visited = new Set();
    while(nodes.size > 0)visit($7ef244517b504261$var$Recoil_nullthrows(nodes.values().next().value));
    return answer;
    function visit(node) {
        if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
            nodes.delete(node);
            return;
        }
        if (visited.has(node)) return;
        const children = graph.nodeToNodeSubscriptions.get(node);
        if (children) for (const child of children)visit(child);
        visited.add(node);
        nodes.delete(node);
        answer.push(node);
    }
}
function $7ef244517b504261$var$releaseNode(store, treeState, node) {
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
     // Atom effects, in-closure caches, etc.:
    $7ef244517b504261$var$cleanUpNode$1(store, node); // Delete from store state:
    const storeState = store.getState();
    storeState.knownAtoms.delete(node);
    storeState.knownSelectors.delete(node);
    storeState.nodeTransactionSubscriptions.delete(node);
    storeState.retention.referenceCounts.delete(node);
    const zones = $7ef244517b504261$var$zonesThatCouldRetainNode(node);
    for (const zone of zones){
        var _storeState$retention2;
        (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 || _storeState$retention2.delete(node);
    } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
    // already happens when the last component that was retaining the node unmounts,
    // and this could happen either before or after that.
    // Delete from TreeState and dep graph:
    treeState.atomValues.delete(node);
    treeState.dirtyAtoms.delete(node);
    treeState.nonvalidatedAtoms.delete(node);
    const graph = storeState.graphsByVersion.get(treeState.version);
    if (graph) {
        const deps = graph.nodeDeps.get(node);
        if (deps !== undefined) {
            graph.nodeDeps.delete(node);
            for (const dep of deps){
                var _graph$nodeToNodeSubs;
                (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 || _graph$nodeToNodeSubs.delete(node);
            }
        } // No need to delete sub's deps as there should be no subs at this point.
        // But an invariant would require deleting nodes in topological order.
        graph.nodeToNodeSubscriptions.delete(node);
    } // Node config (for family members only as their configs can be recreated, and
    // only if they are not retained within any other Stores):
    $7ef244517b504261$var$deleteNodeConfigIfPossible$1(node);
}
function $7ef244517b504261$var$nodesRetainedByZone(storeState, zone) {
    var _storeState$retention3;
    return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : $7ef244517b504261$var$emptySet$1;
}
function $7ef244517b504261$var$zonesThatCouldRetainNode(node) {
    const retainedBy = $7ef244517b504261$var$getNode$3(node).retainedBy;
    if (retainedBy === undefined || retainedBy === "components" || retainedBy === "recoilRoot") return [];
    else if (retainedBy instanceof $7ef244517b504261$var$RetentionZone$2) return [
        retainedBy
    ];
    else return retainedBy; // it's an array of zones
}
function $7ef244517b504261$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
    const state = store.getState();
    if (state.nextTree) state.retention.retainablesToCheckForRelease.add(retainable);
    else $7ef244517b504261$var$releaseRetainablesNowOnCurrentTree(store, new Set([
        retainable
    ]));
}
function $7ef244517b504261$var$updateRetainCount(store, retainable, delta) {
    var _map$get;
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const map = store.getState().retention.referenceCounts;
    const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;
    if (newCount === 0) $7ef244517b504261$var$updateRetainCountToZero(store, retainable);
    else map.set(retainable, newCount);
}
function $7ef244517b504261$var$updateRetainCountToZero(store, retainable) {
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const map = store.getState().retention.referenceCounts;
    map.delete(retainable);
    $7ef244517b504261$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}
function $7ef244517b504261$var$releaseScheduledRetainablesNow(store) {
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const state = store.getState();
    $7ef244517b504261$var$releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
    state.retention.retainablesToCheckForRelease.clear();
}
function $7ef244517b504261$var$retainedByOptionWithDefault(r) {
    // The default will change from 'recoilRoot' to 'components' in the future.
    return r === undefined ? "recoilRoot" : r;
}
var $7ef244517b504261$var$Recoil_Retention = {
    SUSPENSE_TIMEOUT_MS: $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS,
    updateRetainCount: $7ef244517b504261$var$updateRetainCount,
    updateRetainCountToZero: $7ef244517b504261$var$updateRetainCountToZero,
    releaseScheduledRetainablesNow: $7ef244517b504261$var$releaseScheduledRetainablesNow,
    retainedByOptionWithDefault: $7ef244517b504261$var$retainedByOptionWithDefault
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ const { unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates  } = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports)));
var $7ef244517b504261$var$ReactBatchedUpdates = {
    unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ // @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const { unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates$1  } = $7ef244517b504261$var$ReactBatchedUpdates; // @oss-only
var $7ef244517b504261$var$Recoil_ReactBatchedUpdates = {
    unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ const { batchStart: $7ef244517b504261$var$batchStart$1  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates$2  } = $7ef244517b504261$var$Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off
/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */ let $7ef244517b504261$var$batcher = $7ef244517b504261$var$unstable_batchedUpdates$2 || ((batchFn)=>batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */ const $7ef244517b504261$var$setBatcher = (newBatcher)=>{
    $7ef244517b504261$var$batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */ const $7ef244517b504261$var$getBatcher = ()=>$7ef244517b504261$var$batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */ const $7ef244517b504261$var$batchUpdates = (callback)=>{
    $7ef244517b504261$var$batcher(()=>{
        let batchEnd = ()=>undefined;
        try {
            batchEnd = $7ef244517b504261$var$batchStart$1();
            callback();
        } finally{
            batchEnd();
        }
    });
};
var $7ef244517b504261$var$Recoil_Batching = {
    getBatcher: $7ef244517b504261$var$getBatcher,
    setBatcher: $7ef244517b504261$var$setBatcher,
    batchUpdates: $7ef244517b504261$var$batchUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */ function* $7ef244517b504261$var$concatIterables(iters) {
    for (const iter of iters)for (const val of iter)yield val;
}
var $7ef244517b504261$var$Recoil_concatIterables = $7ef244517b504261$var$concatIterables;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /* eslint-disable fb-www/typeof-undefined */ const $7ef244517b504261$var$isSSR = typeof Window === "undefined" || typeof window === "undefined";
/* eslint-enable fb-www/typeof-undefined */ const $7ef244517b504261$var$isWindow = (value)=>!$7ef244517b504261$var$isSSR && (value === window || value instanceof Window);
const $7ef244517b504261$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative"; // eslint-disable-line fb-www/typeof-undefined
var $7ef244517b504261$var$Recoil_Environment = {
    isSSR: $7ef244517b504261$var$isSSR,
    isReactNative: $7ef244517b504261$var$isReactNative,
    isWindow: $7ef244517b504261$var$isWindow
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */ function $7ef244517b504261$var$memoizeWithArgsHash(fn, hashFunction) {
    let cache;
    return (...args)=>{
        if (!cache) cache = {};
        const key = hashFunction(...args);
        if (!Object.hasOwnProperty.call(cache, key)) cache[key] = fn(...args);
        return cache[key];
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $7ef244517b504261$var$memoizeOneWithArgsHash(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    return (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    const memoizedFn = (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
    const invalidate = ()=>{
        lastKey = null;
    };
    return [
        memoizedFn,
        invalidate
    ];
}
var $7ef244517b504261$var$Recoil_Memoize = {
    memoizeWithArgsHash: $7ef244517b504261$var$memoizeWithArgsHash,
    memoizeOneWithArgsHash: $7ef244517b504261$var$memoizeOneWithArgsHash,
    memoizeOneWithArgsHashAndInvalidation: $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation
};
const { batchUpdates: $7ef244517b504261$var$batchUpdates$1  } = $7ef244517b504261$var$Recoil_Batching;
const { initializeNode: $7ef244517b504261$var$initializeNode$1 , peekNodeInfo: $7ef244517b504261$var$peekNodeInfo$1  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { graph: $7ef244517b504261$var$graph$1  } = $7ef244517b504261$var$Recoil_Graph;
const { getNextStoreID: $7ef244517b504261$var$getNextStoreID$1  } = $7ef244517b504261$var$Recoil_Keys;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$1 , recoilValues: $7ef244517b504261$var$recoilValues$1 , recoilValuesForKeys: $7ef244517b504261$var$recoilValuesForKeys$2  } = $7ef244517b504261$var$Recoil_Node;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$2 , getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$1 , setRecoilValue: $7ef244517b504261$var$setRecoilValue$1 , setUnvalidatedRecoilValue: $7ef244517b504261$var$setUnvalidatedRecoilValue$1  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { updateRetainCount: $7ef244517b504261$var$updateRetainCount$1  } = $7ef244517b504261$var$Recoil_Retention;
const { setInvalidateMemoizedSnapshot: $7ef244517b504261$var$setInvalidateMemoizedSnapshot$1  } = $7ef244517b504261$var$Recoil_SnapshotCache;
const { getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$2 , makeEmptyStoreState: $7ef244517b504261$var$makeEmptyStoreState$1  } = $7ef244517b504261$var$Recoil_State;
const { isSSR: $7ef244517b504261$var$isSSR$1  } = $7ef244517b504261$var$Recoil_Environment;
const { memoizeOneWithArgsHashAndInvalidation: $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation$1  } = $7ef244517b504261$var$Recoil_Memoize;
// Opaque at this surface because it's part of the public API from here.
const $7ef244517b504261$var$retainWarning = `
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`; // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.
class $7ef244517b504261$var$Snapshot {
    // eslint-disable-next-line fb-www/no-uninitialized-properties
    constructor(storeState, parentStoreID){
        $7ef244517b504261$var$_defineProperty(this, "_store", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_refCount", 1);
        $7ef244517b504261$var$_defineProperty(this, "getLoadable", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return $7ef244517b504261$var$getRecoilValueAsLoadable$1(this._store, recoilValue);
        });
        $7ef244517b504261$var$_defineProperty(this, "getPromise", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return this.getLoadable(recoilValue).toPromise();
        });
        $7ef244517b504261$var$_defineProperty(this, "getNodes_UNSTABLE", (opt)=>{
            this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors
            if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
                if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) return [];
                const state = this._store.getState().currentTree;
                return $7ef244517b504261$var$recoilValuesForKeys$2(state.dirtyAtoms);
            }
            const knownAtoms = this._store.getState().knownAtoms;
            const knownSelectors = this._store.getState().knownSelectors;
            return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? $7ef244517b504261$var$recoilValues$1.values() : opt.isInitialized === true ? $7ef244517b504261$var$recoilValuesForKeys$2($7ef244517b504261$var$Recoil_concatIterables([
                knownAtoms,
                knownSelectors
            ])) : $7ef244517b504261$var$Recoil_filterIterable($7ef244517b504261$var$recoilValues$1.values(), ({ key: key  })=>!knownAtoms.has(key) && !knownSelectors.has(key));
        });
        $7ef244517b504261$var$_defineProperty(this, "getInfo_UNSTABLE", ({ key: key  })=>{
            this.checkRefCount_INTERNAL();
            return $7ef244517b504261$var$peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
        });
        $7ef244517b504261$var$_defineProperty(this, "map", (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new $7ef244517b504261$var$MutableSnapshot(this, $7ef244517b504261$var$batchUpdates$1);
            mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here
            return mutableSnapshot;
        });
        $7ef244517b504261$var$_defineProperty(this, "asyncMap", async (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new $7ef244517b504261$var$MutableSnapshot(this, $7ef244517b504261$var$batchUpdates$1);
            mutableSnapshot.retain(); // Retain new snapshot during async mapper
            await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
            // after the next tick, the same as a new synchronous snapshot.
            mutableSnapshot.autoRelease_INTERNAL();
            return mutableSnapshot;
        });
        this._store = {
            storeID: $7ef244517b504261$var$getNextStoreID$1(),
            parentStoreID: parentStoreID,
            getState: ()=>storeState,
            replaceState: (replacer)=>{
                // no batching, so nextTree is never active
                storeState.currentTree = replacer(storeState.currentTree);
            },
            getGraph: (version)=>{
                const graphs = storeState.graphsByVersion;
                if (graphs.has(version)) return $7ef244517b504261$var$Recoil_nullthrows(graphs.get(version));
                const newGraph = $7ef244517b504261$var$graph$1();
                graphs.set(version, newGraph);
                return newGraph;
            },
            subscribeToTransactions: ()=>({
                    release: ()=>{}
                }),
            addTransactionMetadata: ()=>{
                throw $7ef244517b504261$var$Recoil_err("Cannot subscribe to Snapshots");
            }
        }; // Initialize any nodes that are live in the parent store (primarily so that
        // this snapshot gets counted towards the node's live stores count).
        // TODO Optimize this when cloning snapshots for callbacks
        for (const nodeKey of this._store.getState().knownAtoms){
            $7ef244517b504261$var$initializeNode$1(this._store, nodeKey, "get");
            $7ef244517b504261$var$updateRetainCount$1(this._store, nodeKey, 1);
        }
        this.autoRelease_INTERNAL();
    }
    retain() {
        if (this._refCount <= 0) throw $7ef244517b504261$var$Recoil_err("Snapshot has already been released.");
        this._refCount++;
        let released = false;
        return ()=>{
            if (!released) {
                released = true;
                this._release();
            }
        };
    }
    /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */ autoRelease_INTERNAL() {
        if (!$7ef244517b504261$var$isSSR$1) // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
        window.setTimeout(()=>this._release(), 10);
    }
    _release() {
        this._refCount--;
        if (this._refCount === 0) {
            this._store.getState().nodeCleanupFunctions.forEach((cleanup)=>cleanup());
            this._store.getState().nodeCleanupFunctions.clear();
            if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
             // Temporarily nerfing this to allow us to find broken call sites without
        // actually breaking anybody yet.
        // for (const k of this._store.getState().knownAtoms) {
        //   updateRetainCountToZero(this._store, k);
        // }
        } else if (this._refCount < 0) $7ef244517b504261$var$Recoil_recoverableViolation("Snapshot released an extra time.");
    }
    isRetained() {
        return this._refCount > 0;
    }
    checkRefCount_INTERNAL() {
        if ($7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020") && this._refCount <= 0) $7ef244517b504261$var$Recoil_recoverableViolation($7ef244517b504261$var$retainWarning);
    }
    getStore_INTERNAL() {
        this.checkRefCount_INTERNAL();
        return this._store;
    }
    getID() {
        this.checkRefCount_INTERNAL();
        return this._store.getState().currentTree.stateID;
    }
    getStoreID() {
        this.checkRefCount_INTERNAL();
        return this._store.storeID;
    }
}
function $7ef244517b504261$var$cloneStoreState(store, treeState, bumpVersion = false) {
    const storeState = store.getState();
    const version = bumpVersion ? $7ef244517b504261$var$getNextTreeStateVersion$2() : treeState.version;
    return {
        // Always clone the TreeState to isolate stores from accidental mutations.
        // For example, reading a selector from a cloned snapshot shouldn't cache
        // in the original treestate which may cause the original to skip
        // initialization of upstream atoms.
        currentTree: {
            // TODO snapshots shouldn't really have versions because a new version number
            // is always assigned when the snapshot is gone to.
            version: bumpVersion ? version : treeState.version,
            stateID: bumpVersion ? version : treeState.stateID,
            transactionMetadata: {
                ...treeState.transactionMetadata
            },
            dirtyAtoms: new Set(treeState.dirtyAtoms),
            atomValues: treeState.atomValues.clone(),
            nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
        },
        commitDepth: 0,
        nextTree: null,
        previousTree: null,
        knownAtoms: new Set(storeState.knownAtoms),
        // FIXME here's a copy
        knownSelectors: new Set(storeState.knownSelectors),
        // FIXME here's a copy
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        // FIXME here's a copy
        // Create blank cleanup handlers for atoms so snapshots don't re-run
        // atom effects.
        nodeCleanupFunctions: new Map($7ef244517b504261$var$Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key])=>[
                key,
                ()=>{}
            ]))
    };
} // Factory to build a fresh snapshot
function $7ef244517b504261$var$freshSnapshot(initializeState) {
    const snapshot = new $7ef244517b504261$var$Snapshot($7ef244517b504261$var$makeEmptyStoreState$1());
    return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state
const [$7ef244517b504261$var$memoizedCloneSnapshot, $7ef244517b504261$var$invalidateMemoizedSnapshot$2] = $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation$1((store, version)=>{
    var _storeState$nextTree;
    const storeState = store.getState();
    const treeState = version === "latest" ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : $7ef244517b504261$var$Recoil_nullthrows(storeState.previousTree);
    return new $7ef244517b504261$var$Snapshot($7ef244517b504261$var$cloneStoreState(store, treeState), store.storeID);
}, (store, version)=>{
    var _store$getState$nextT, _store$getState$previ;
    return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies
$7ef244517b504261$var$setInvalidateMemoizedSnapshot$1($7ef244517b504261$var$invalidateMemoizedSnapshot$2);
function $7ef244517b504261$var$cloneSnapshot(store, version = "latest") {
    const snapshot = $7ef244517b504261$var$memoizedCloneSnapshot(store, version);
    if (!snapshot.isRetained()) {
        $7ef244517b504261$var$invalidateMemoizedSnapshot$2();
        return $7ef244517b504261$var$memoizedCloneSnapshot(store, version);
    }
    return snapshot;
}
class $7ef244517b504261$var$MutableSnapshot extends $7ef244517b504261$var$Snapshot {
    constructor(snapshot, batch){
        super($7ef244517b504261$var$cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());
        $7ef244517b504261$var$_defineProperty(this, "_batch", void 0);
        $7ef244517b504261$var$_defineProperty(this, "set", (recoilState, newValueOrUpdater)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
            // read the written value after calling `set`. I would like to remove this
            // behavior and only batch in `Snapshot.map`, but this would be a breaking
            // change potentially.
            this._batch(()=>{
                $7ef244517b504261$var$updateRetainCount$1(store, recoilState.key, 1);
                $7ef244517b504261$var$setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
            });
        });
        $7ef244517b504261$var$_defineProperty(this, "reset", (recoilState)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            this._batch(()=>{
                $7ef244517b504261$var$updateRetainCount$1(store, recoilState.key, 1);
                $7ef244517b504261$var$setRecoilValue$1(this.getStore_INTERNAL(), recoilState, $7ef244517b504261$var$DEFAULT_VALUE$1);
            });
        });
        $7ef244517b504261$var$_defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", (values)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            $7ef244517b504261$var$batchUpdates$1(()=>{
                for (const [k, v] of values.entries()){
                    $7ef244517b504261$var$updateRetainCount$1(store, k, 1);
                    $7ef244517b504261$var$setUnvalidatedRecoilValue$1(store, new $7ef244517b504261$var$AbstractRecoilValue$2(k), v);
                }
            });
        });
        this._batch = batch;
    }
}
var $7ef244517b504261$var$Recoil_Snapshot = {
    Snapshot: $7ef244517b504261$var$Snapshot,
    MutableSnapshot: $7ef244517b504261$var$MutableSnapshot,
    freshSnapshot: $7ef244517b504261$var$freshSnapshot,
    cloneSnapshot: $7ef244517b504261$var$cloneSnapshot
};
var $7ef244517b504261$var$Recoil_Snapshot_1 = $7ef244517b504261$var$Recoil_Snapshot.Snapshot;
var $7ef244517b504261$var$Recoil_Snapshot_2 = $7ef244517b504261$var$Recoil_Snapshot.MutableSnapshot;
var $7ef244517b504261$var$Recoil_Snapshot_3 = $7ef244517b504261$var$Recoil_Snapshot.freshSnapshot;
var $7ef244517b504261$var$Recoil_Snapshot_4 = $7ef244517b504261$var$Recoil_Snapshot.cloneSnapshot;
var $7ef244517b504261$var$Recoil_Snapshot$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Snapshot: $7ef244517b504261$var$Recoil_Snapshot_1,
    MutableSnapshot: $7ef244517b504261$var$Recoil_Snapshot_2,
    freshSnapshot: $7ef244517b504261$var$Recoil_Snapshot_3,
    cloneSnapshot: $7ef244517b504261$var$Recoil_Snapshot_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$unionSets(...sets) {
    const result = new Set();
    for (const set of sets)for (const value of set)result.add(value);
    return result;
}
var $7ef244517b504261$var$Recoil_unionSets = $7ef244517b504261$var$unionSets;
const { useRef: $7ef244517b504261$var$useRef  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */ function $7ef244517b504261$var$useRefInitOnce(initialValue) {
    // $FlowExpectedError[incompatible-call]
    const ref = $7ef244517b504261$var$useRef(initialValue);
    if (ref.current === initialValue && typeof initialValue === "function") // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
    return ref;
}
var $7ef244517b504261$var$Recoil_useRefInitOnce = $7ef244517b504261$var$useRefInitOnce;
// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');
const { getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$3 , makeEmptyStoreState: $7ef244517b504261$var$makeEmptyStoreState$2  } = $7ef244517b504261$var$Recoil_State;
const { cleanUpNode: $7ef244517b504261$var$cleanUpNode$2 , getDownstreamNodes: $7ef244517b504261$var$getDownstreamNodes$2 , initializeNode: $7ef244517b504261$var$initializeNode$2 , setNodeValue: $7ef244517b504261$var$setNodeValue$2 , setUnvalidatedAtomValue_DEPRECATED: $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED$1  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { graph: $7ef244517b504261$var$graph$2  } = $7ef244517b504261$var$Recoil_Graph;
const { cloneGraph: $7ef244517b504261$var$cloneGraph$1  } = $7ef244517b504261$var$Recoil_Graph;
const { getNextStoreID: $7ef244517b504261$var$getNextStoreID$2  } = $7ef244517b504261$var$Recoil_Keys;
const { createMutableSource: $7ef244517b504261$var$createMutableSource$1 , reactMode: $7ef244517b504261$var$reactMode$2  } = $7ef244517b504261$var$Recoil_ReactMode;
const { applyAtomValueWrites: $7ef244517b504261$var$applyAtomValueWrites$1  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { releaseScheduledRetainablesNow: $7ef244517b504261$var$releaseScheduledRetainablesNow$1  } = $7ef244517b504261$var$Recoil_Retention;
const { freshSnapshot: $7ef244517b504261$var$freshSnapshot$1  } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { useCallback: $7ef244517b504261$var$useCallback , useContext: $7ef244517b504261$var$useContext , useEffect: $7ef244517b504261$var$useEffect , useMemo: $7ef244517b504261$var$useMemo , useRef: $7ef244517b504261$var$useRef$1 , useState: $7ef244517b504261$var$useState  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$notInAContext() {
    throw $7ef244517b504261$var$Recoil_err("This component must be used inside a <RecoilRoot> component.");
}
const $7ef244517b504261$var$defaultStore = Object.freeze({
    storeID: $7ef244517b504261$var$getNextStoreID$2(),
    getState: $7ef244517b504261$var$notInAContext,
    replaceState: $7ef244517b504261$var$notInAContext,
    getGraph: $7ef244517b504261$var$notInAContext,
    subscribeToTransactions: $7ef244517b504261$var$notInAContext,
    addTransactionMetadata: $7ef244517b504261$var$notInAContext
});
let $7ef244517b504261$var$stateReplacerIsBeingExecuted = false;
function $7ef244517b504261$var$startNextTreeIfNeeded(store) {
    if ($7ef244517b504261$var$stateReplacerIsBeingExecuted) throw $7ef244517b504261$var$Recoil_err("An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.");
    const storeState = store.getState();
    if (storeState.nextTree === null) {
        if ($7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020") && $7ef244517b504261$var$Recoil_gkx("recoil_release_on_cascading_update_killswitch_2021")) // If this is a cascading update (that is, rendering due to one state change
        // invokes a second state change), we won't have cleaned up retainables yet
        // because this normally happens after notifying components. Do it before
        // proceeding with the cascading update so that it remains predictable:
        {
            if (storeState.commitDepth > 0) $7ef244517b504261$var$releaseScheduledRetainablesNow$1(store);
        }
        const version = storeState.currentTree.version;
        const nextVersion = $7ef244517b504261$var$getNextTreeStateVersion$3();
        storeState.nextTree = {
            ...storeState.currentTree,
            version: nextVersion,
            stateID: nextVersion,
            dirtyAtoms: new Set(),
            transactionMetadata: {}
        };
        storeState.graphsByVersion.set(nextVersion, $7ef244517b504261$var$cloneGraph$1($7ef244517b504261$var$Recoil_nullthrows(storeState.graphsByVersion.get(version))));
    }
}
const $7ef244517b504261$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    current: $7ef244517b504261$var$defaultStore
});
const $7ef244517b504261$var$useStoreRef = ()=>$7ef244517b504261$var$useContext($7ef244517b504261$var$AppContext); // $FlowExpectedError[incompatible-call]
const $7ef244517b504261$var$MutableSourceContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $7ef244517b504261$var$useRecoilMutableSource() {
    const mutableSource = $7ef244517b504261$var$useContext($7ef244517b504261$var$MutableSourceContext);
    if (mutableSource == null) $7ef244517b504261$var$Recoil_expectationViolation("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks.");
    return mutableSource;
}
function $7ef244517b504261$var$notifyComponents(store, storeState, treeState) {
    const dependentNodes = $7ef244517b504261$var$getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);
    for (const key of dependentNodes){
        const comps = storeState.nodeToComponentSubscriptions.get(key);
        if (comps) for (const [_subID, [_debugName, callback]] of comps)callback(treeState);
    }
}
function $7ef244517b504261$var$sendEndOfBatchNotifications(store) {
    const storeState = store.getState();
    const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:
    const dirtyAtoms = treeState.dirtyAtoms;
    if (dirtyAtoms.size) {
        // Execute Node-specific subscribers before global subscribers
        for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions){
            if (dirtyAtoms.has(key)) for (const [_, subscription] of subscriptions)subscription(store);
        }
        for (const [_, subscription] of storeState.transactionSubscriptions)subscription(store);
        if (!$7ef244517b504261$var$reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
            // Notifying components is needed to wake from suspense, even when using
            // early rendering.
            $7ef244517b504261$var$notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
            // We need to wake up components not just when some asynchronous selector
            // resolved, but also when changing synchronous values because this may cause
            // a selector to change from asynchronous to synchronous, in which case there
            // would be no follow-up asynchronous resolution to wake us up.
            // TODO OPTIMIZATION Only wake up related downstream components
            storeState.suspendedComponentResolvers.forEach((cb)=>cb());
            storeState.suspendedComponentResolvers.clear();
        }
    } // Special behavior ONLY invoked by useInterface.
    // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
    storeState.queuedComponentCallbacks_DEPRECATED.forEach((cb)=>cb(treeState));
    storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}
function $7ef244517b504261$var$endBatch(store) {
    const storeState = store.getState();
    storeState.commitDepth++;
    try {
        const { nextTree: nextTree  } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
        // because something above RecoilRoot re-rendered:
        if (nextTree == null) return;
         // nextTree is now committed -- note that copying and reset occurs when
        // a transaction begins, in startNextTreeIfNeeded:
        storeState.previousTree = storeState.currentTree;
        storeState.currentTree = nextTree;
        storeState.nextTree = null;
        $7ef244517b504261$var$sendEndOfBatchNotifications(store);
        if (storeState.previousTree != null) storeState.graphsByVersion.delete(storeState.previousTree.version);
        else $7ef244517b504261$var$Recoil_recoverableViolation("Ended batch with no previous state, which is unexpected", "recoil");
        storeState.previousTree = null;
        if ($7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) // Only release retainables if there were no writes during the end of the
        // batch.  This avoids releasing something we might be about to use.
        {
            if (nextTree == null) $7ef244517b504261$var$releaseScheduledRetainablesNow$1(store);
        }
    } finally{
        storeState.commitDepth--;
    }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */ function $7ef244517b504261$var$Batcher({ setNotifyBatcherOfChange: setNotifyBatcherOfChange  }) {
    const storeRef = $7ef244517b504261$var$useStoreRef();
    const [, setState] = $7ef244517b504261$var$useState([]); // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(()=>setState({}));
    $7ef244517b504261$var$useEffect(()=>{
        // $FlowFixMe[incompatible-call]
        setNotifyBatcherOfChange(()=>setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
        // notifyBatcherOfChange will still be called. An error gets thrown whenever
        // setState is called after a component is already unmounted, so this sets
        // notifyBatcherOfChange to be a no-op.
        return ()=>{
            setNotifyBatcherOfChange(()=>{});
        };
    }, [
        setNotifyBatcherOfChange
    ]);
    $7ef244517b504261$var$useEffect(()=>{
        // enqueueExecution runs this function immediately; it is only used to
        // manipulate the order of useEffects during tests, since React seems to
        // call useEffect in an unpredictable order sometimes.
        $7ef244517b504261$var$Recoil_Queue.enqueueExecution("Batcher", ()=>{
            $7ef244517b504261$var$endBatch(storeRef.current);
        });
    });
    return null;
}
if (typeof window !== "undefined" && !window.$recoilDebugStates) window.$recoilDebugStates = [];
// which will no longer be needed.
function $7ef244517b504261$var$initialStoreState_DEPRECATED(store, initializeState) {
    const initial = $7ef244517b504261$var$makeEmptyStoreState$2();
    initializeState({
        set: (atom, value)=>{
            const state = initial.currentTree;
            const writes = $7ef244517b504261$var$setNodeValue$2(store, state, atom.key, value);
            const writtenNodes = new Set(writes.keys());
            const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();
            for (const n of writtenNodes)nonvalidatedAtoms.delete(n);
            initial.currentTree = {
                ...state,
                dirtyAtoms: $7ef244517b504261$var$Recoil_unionSets(state.dirtyAtoms, writtenNodes),
                atomValues: $7ef244517b504261$var$applyAtomValueWrites$1(state.atomValues, writes),
                nonvalidatedAtoms: // NB: PLEASE un-export applyAtomValueWrites when deleting this code
                nonvalidatedAtoms
            };
        },
        setUnvalidatedAtomValues: (atomValues)=>{
            // FIXME replace this with a mutative loop
            atomValues.forEach((v, k)=>{
                initial.currentTree = $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
            });
        }
    });
    return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.
function $7ef244517b504261$var$initialStoreState(initializeState) {
    // Initialize a snapshot and get its store
    const snapshot = $7ef244517b504261$var$freshSnapshot$1(initializeState);
    const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release
    snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
    // they will re-initialize if used during rendering.  This allows atom effect
    // initialization to take precedence over initializeState and be compatible
    // with StrictMode semantics.
    storeState.nodeCleanupFunctions.forEach((cleanup)=>cleanup());
    storeState.nodeCleanupFunctions.clear();
    return storeState;
}
let $7ef244517b504261$var$nextID = 0;
function $7ef244517b504261$var$RecoilRoot_INTERNAL({ initializeState_DEPRECATED: initializeState_DEPRECATED , initializeState: initializeState , store_INTERNAL: storeProp , children: // For use with React "context bridging"
children  }) {
    // prettier-ignore
    // @fb-only: useEffect(() => {
    // @fb-only: if (gkx('recoil_usage_logging')) {
    // @fb-only: try {
    // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
    // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
    // @fb-only: path: URI.getRequestURI().getPath(),
    // @fb-only: }));
    // @fb-only: } catch {
    // @fb-only: recoverableViolation(
    // @fb-only: 'Error when logging Recoil Usage event',
    // @fb-only: 'recoil',
    // @fb-only: );
    // @fb-only: }
    // @fb-only: }
    // @fb-only: }, []);
    let storeStateRef; // eslint-disable-line prefer-const
    const getGraph = (version)=>{
        const graphs = storeStateRef.current.graphsByVersion;
        if (graphs.has(version)) return $7ef244517b504261$var$Recoil_nullthrows(graphs.get(version));
        const newGraph = $7ef244517b504261$var$graph$2();
        graphs.set(version, newGraph);
        return newGraph;
    };
    const subscribeToTransactions = (callback, key)=>{
        if (key == null) {
            // Global transaction subscriptions
            const { transactionSubscriptions: transactionSubscriptions  } = storeRef.current.getState();
            const id = $7ef244517b504261$var$nextID++;
            transactionSubscriptions.set(id, callback);
            return {
                release: ()=>{
                    transactionSubscriptions.delete(id);
                }
            };
        } else {
            // Node-specific transaction subscriptions:
            const { nodeTransactionSubscriptions: nodeTransactionSubscriptions  } = storeRef.current.getState();
            if (!nodeTransactionSubscriptions.has(key)) nodeTransactionSubscriptions.set(key, new Map());
            const id = $7ef244517b504261$var$nextID++;
            $7ef244517b504261$var$Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
            return {
                release: ()=>{
                    const subs = nodeTransactionSubscriptions.get(key);
                    if (subs) {
                        subs.delete(id);
                        if (subs.size === 0) nodeTransactionSubscriptions.delete(key);
                    }
                }
            };
        }
    };
    const addTransactionMetadata = (metadata)=>{
        $7ef244517b504261$var$startNextTreeIfNeeded(storeRef.current);
        for (const k of Object.keys(metadata))$7ef244517b504261$var$Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    };
    const replaceState = (replacer)=>{
        $7ef244517b504261$var$startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:
        const nextTree = $7ef244517b504261$var$Recoil_nullthrows(storeStateRef.current.nextTree);
        let replaced;
        try {
            $7ef244517b504261$var$stateReplacerIsBeingExecuted = true;
            replaced = replacer(nextTree);
        } finally{
            $7ef244517b504261$var$stateReplacerIsBeingExecuted = false;
        }
        if (replaced === nextTree) return;
        if (typeof window !== "undefined") window.$recoilDebugStates.push(replaced); // TODO this shouldn't happen here because it's not batched
        storeStateRef.current.nextTree = replaced;
        if ($7ef244517b504261$var$reactMode$2().early) $7ef244517b504261$var$notifyComponents(storeRef.current, storeStateRef.current, replaced);
        $7ef244517b504261$var$Recoil_nullthrows(notifyBatcherOfChange.current)();
    };
    const notifyBatcherOfChange = $7ef244517b504261$var$useRef$1(null);
    const setNotifyBatcherOfChange = $7ef244517b504261$var$useCallback((x)=>{
        notifyBatcherOfChange.current = x;
    }, [
        notifyBatcherOfChange
    ]);
    const storeRef = $7ef244517b504261$var$Recoil_useRefInitOnce(()=>storeProp !== null && storeProp !== void 0 ? storeProp : {
            storeID: $7ef244517b504261$var$getNextStoreID$2(),
            getState: ()=>storeStateRef.current,
            replaceState: replaceState,
            getGraph: getGraph,
            subscribeToTransactions: subscribeToTransactions,
            addTransactionMetadata: addTransactionMetadata
        });
    if (storeProp != null) storeRef.current = storeProp;
    storeStateRef = $7ef244517b504261$var$Recoil_useRefInitOnce(()=>initializeState_DEPRECATED != null ? $7ef244517b504261$var$initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? $7ef244517b504261$var$initialStoreState(initializeState) : $7ef244517b504261$var$makeEmptyStoreState$2());
    const mutableSource = $7ef244517b504261$var$useMemo(()=>$7ef244517b504261$var$createMutableSource$1 === null || $7ef244517b504261$var$createMutableSource$1 === void 0 ? void 0 : $7ef244517b504261$var$createMutableSource$1(storeStateRef, ()=>storeStateRef.current.currentTree.version), [
        storeStateRef
    ]); // Cleanup when the <RecoilRoot> is unmounted
    $7ef244517b504261$var$useEffect(()=>{
        // React is free to call effect cleanup handlers and effects at will, the
        // deps array is only an optimization.  For example, React strict mode
        // will execute each effect twice for testing.  Therefore, we need symmetry
        // to re-initialize all known atoms after they were cleaned up.
        const store = storeRef.current;
        for (const atomKey of new Set(store.getState().knownAtoms))$7ef244517b504261$var$initializeNode$2(store, atomKey, "get");
        return ()=>{
            for (const atomKey of store.getState().knownAtoms)$7ef244517b504261$var$cleanUpNode$2(store, atomKey);
        };
    }, [
        storeRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$AppContext.Provider, {
        value: storeRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$MutableSourceContext.Provider, {
        value: mutableSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$Batcher, {
        setNotifyBatcherOfChange: setNotifyBatcherOfChange
    }), children));
}
function $7ef244517b504261$var$RecoilRoot(props) {
    const { override: override , ...propsExceptOverride } = props;
    const ancestorStoreRef = $7ef244517b504261$var$useStoreRef();
    if (override === false && ancestorStoreRef.current !== $7ef244517b504261$var$defaultStore) // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$RecoilRoot_INTERNAL, propsExceptOverride);
}
function $7ef244517b504261$var$useRecoilStoreID() {
    return $7ef244517b504261$var$useStoreRef().current.storeID;
}
var $7ef244517b504261$var$Recoil_RecoilRoot = {
    RecoilRoot: $7ef244517b504261$var$RecoilRoot,
    useStoreRef: $7ef244517b504261$var$useStoreRef,
    useRecoilMutableSource: $7ef244517b504261$var$useRecoilMutableSource,
    useRecoilStoreID: $7ef244517b504261$var$useRecoilStoreID,
    notifyComponents_FOR_TESTING: $7ef244517b504261$var$notifyComponents,
    sendEndOfBatchNotifications_FOR_TESTING: $7ef244517b504261$var$sendEndOfBatchNotifications
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$shallowArrayEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
var $7ef244517b504261$var$Recoil_shallowArrayEqual = $7ef244517b504261$var$shallowArrayEqual;
const { useEffect: $7ef244517b504261$var$useEffect$1 , useRef: $7ef244517b504261$var$useRef$2  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$usePrevious(value) {
    const ref = $7ef244517b504261$var$useRef$2();
    $7ef244517b504261$var$useEffect$1(()=>{
        // $FlowFixMe[incompatible-type]
        ref.current = value;
    });
    return ref.current;
}
var $7ef244517b504261$var$Recoil_usePrevious = $7ef244517b504261$var$usePrevious;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$1  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { SUSPENSE_TIMEOUT_MS: $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$1  } = $7ef244517b504261$var$Recoil_Retention;
const { updateRetainCount: $7ef244517b504261$var$updateRetainCount$2  } = $7ef244517b504261$var$Recoil_Retention;
const { RetentionZone: $7ef244517b504261$var$RetentionZone$3  } = $7ef244517b504261$var$Recoil_RetentionZone;
const { useEffect: $7ef244517b504261$var$useEffect$2 , useRef: $7ef244517b504261$var$useRef$3  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
const { isSSR: $7ef244517b504261$var$isSSR$2  } = $7ef244517b504261$var$Recoil_Environment;
// I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.
// flowlint-line unclear-type:off
function $7ef244517b504261$var$useRetain(toRetain) {
    if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
     // eslint-disable-next-line fb-www/react-hooks
    return $7ef244517b504261$var$useRetain_ACTUAL(toRetain);
}
function $7ef244517b504261$var$useRetain_ACTUAL(toRetain) {
    const array = Array.isArray(toRetain) ? toRetain : [
        toRetain
    ];
    const retainables = array.map((a)=>a instanceof $7ef244517b504261$var$RetentionZone$3 ? a : a.key);
    const storeRef = $7ef244517b504261$var$useStoreRef$1();
    $7ef244517b504261$var$useEffect$2(()=>{
        if (!$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) return;
        const store = storeRef.current;
        if (timeoutID.current && !$7ef244517b504261$var$isSSR$2) {
            // Already performed a temporary retain on render, simply cancel the release
            // of that temporary retain.
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
        } else for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, 1);
        return ()=>{
            for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, -1);
        }; // eslint-disable-next-line fb-www/react-hooks-deps
    }, [
        storeRef,
        ...retainables
    ]); // We want to retain if the component suspends. This is terrible but the Suspense
    // API affords us no better option. If we suspend and never commit after some
    // seconds, then release. The 'actual' retain/release in the effect above
    // cancels this.
    const timeoutID = $7ef244517b504261$var$useRef$3();
    const previousRetainables = $7ef244517b504261$var$Recoil_usePrevious(retainables);
    if (!$7ef244517b504261$var$isSSR$2 && (previousRetainables === undefined || !$7ef244517b504261$var$Recoil_shallowArrayEqual(previousRetainables, retainables))) {
        const store = storeRef.current;
        for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, 1);
        if (previousRetainables) for (const r of previousRetainables)$7ef244517b504261$var$updateRetainCount$2(store, r, -1);
        if (timeoutID.current) window.clearTimeout(timeoutID.current);
        timeoutID.current = window.setTimeout(()=>{
            timeoutID.current = null;
            for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, -1);
        }, $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$1);
    }
}
var $7ef244517b504261$var$Recoil_useRetain = $7ef244517b504261$var$useRetain;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */ // const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');
function $7ef244517b504261$var$useComponentName() {
    // const nameRef = useRef();
    // if (__DEV__) {
    //   if (gkx('recoil_infer_component_names')) {
    //     if (nameRef.current === undefined) {
    //       // There is no blessed way to determine the calling React component from
    //       // within a hook. This hack uses the fact that hooks must start with 'use'
    //       // and that hooks are either called by React Components or other hooks. It
    //       // follows therefore, that to find the calling component, you simply need
    //       // to look down the stack and find the first function which doesn't start
    //       // with 'use'. We are only enabling this in dev for now, since once the
    //       // codebase is minified, the naming assumptions no longer hold true.
    //       // eslint-disable-next-line fb-www/no-new-error
    //       const frames = stackTraceParser(new Error().stack);
    //       for (const {methodName} of frames) {
    //         // I observed cases where the frame was of the form 'Object.useXXX'
    //         // hence why I'm searching for hooks following a word boundary
    //         if (!methodName.match(/\buse[^\b]+$/)) {
    //           return (nameRef.current = methodName);
    //         }
    //       }
    //       nameRef.current = null;
    //     }
    //     return nameRef.current ?? '<unable to determine component name>';
    //   }
    // }
    // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
    return "<component name not available>"; // @oss-only
}
var $7ef244517b504261$var$Recoil_useComponentName = $7ef244517b504261$var$useComponentName;
const { batchUpdates: $7ef244517b504261$var$batchUpdates$2  } = $7ef244517b504261$var$Recoil_Batching;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$2  } = $7ef244517b504261$var$Recoil_Node;
const { currentRendererSupportsUseSyncExternalStore: $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore$1 , reactMode: $7ef244517b504261$var$reactMode$3 , useMutableSource: $7ef244517b504261$var$useMutableSource$1 , useSyncExternalStore: $7ef244517b504261$var$useSyncExternalStore$1  } = $7ef244517b504261$var$Recoil_ReactMode;
const { useRecoilMutableSource: $7ef244517b504261$var$useRecoilMutableSource$1 , useStoreRef: $7ef244517b504261$var$useStoreRef$2  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$2  } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$3 , getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$2 , setRecoilValue: $7ef244517b504261$var$setRecoilValue$2 , setUnvalidatedRecoilValue: $7ef244517b504261$var$setUnvalidatedRecoilValue$2 , subscribeToRecoilValue: $7ef244517b504261$var$subscribeToRecoilValue$1  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { useCallback: $7ef244517b504261$var$useCallback$1 , useEffect: $7ef244517b504261$var$useEffect$3 , useMemo: $7ef244517b504261$var$useMemo$1 , useRef: $7ef244517b504261$var$useRef$4 , useState: $7ef244517b504261$var$useState$1  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
const { setByAddingToSet: $7ef244517b504261$var$setByAddingToSet$2  } = $7ef244517b504261$var$Recoil_CopyOnWrite;
const { isSSR: $7ef244517b504261$var$isSSR$3  } = $7ef244517b504261$var$Recoil_Environment;
function $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef) {
    // We can't just throw the promise we are waiting on to Suspense.  If the
    // upstream dependencies change it may produce a state in which the component
    // can render, but it would still be suspended on a Promise that may never resolve.
    if (loadable.state === "hasValue") return loadable.contents;
    else if (loadable.state === "loading") {
        const promise = new Promise((resolve)=>{
            const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
            suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
            // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)
            if ($7ef244517b504261$var$isSSR$3 && $7ef244517b504261$var$Recoil_isPromise(loadable.contents)) loadable.contents.finally(()=>{
                suspendedComponentResolvers.delete(resolve);
            });
        }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
        // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;
        throw promise;
    } else if (loadable.state === "hasError") throw loadable.contents;
    else throw $7ef244517b504261$var$Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
}
function $7ef244517b504261$var$validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
    if (!$7ef244517b504261$var$isRecoilValue$2(recoilValue)) throw $7ef244517b504261$var$Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
}
/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */ function $7ef244517b504261$var$useRecoilInterface_DEPRECATED() {
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const storeRef = $7ef244517b504261$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = $7ef244517b504261$var$useState$1([]);
    const recoilValuesUsed = $7ef244517b504261$var$useRef$4(new Set());
    recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render
    const previousSubscriptions = $7ef244517b504261$var$useRef$4(new Set());
    const subscriptions = $7ef244517b504261$var$useRef$4(new Map());
    const unsubscribeFrom = $7ef244517b504261$var$useCallback$1((key)=>{
        const sub = subscriptions.current.get(key);
        if (sub) {
            sub.release();
            subscriptions.current.delete(key);
        }
    }, [
        subscriptions
    ]);
    const updateState = $7ef244517b504261$var$useCallback$1((_state, key)=>{
        if (subscriptions.current.has(key)) forceUpdate([]);
    }, []); // Effect to add/remove subscriptions as nodes are used
    $7ef244517b504261$var$useEffect$3(()=>{
        const store = storeRef.current;
        $7ef244517b504261$var$Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach((key)=>{
            if (subscriptions.current.has(key)) {
                $7ef244517b504261$var$Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
                return;
            }
            const sub = $7ef244517b504261$var$subscribeToRecoilValue$1(store, new $7ef244517b504261$var$AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            subscriptions.current.set(key, sub);
            /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */ // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
            const state = store.getState();
            if (state.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
                updateState(store.getState(), key);
            });
            else updateState(store.getState(), key);
        });
        $7ef244517b504261$var$Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach((key)=>{
            unsubscribeFrom(key);
        });
        previousSubscriptions.current = recoilValuesUsed.current;
    }); // Effect to unsubscribe from all when unmounting
    $7ef244517b504261$var$useEffect$3(()=>{
        const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice
        $7ef244517b504261$var$Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach((key)=>{
            const sub = $7ef244517b504261$var$subscribeToRecoilValue$1(storeRef.current, new $7ef244517b504261$var$AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            currentSubscriptions.set(key, sub);
        });
        return ()=>currentSubscriptions.forEach((_, key)=>unsubscribeFrom(key));
    }, [
        componentName,
        storeRef,
        unsubscribeFrom,
        updateState
    ]);
    return $7ef244517b504261$var$useMemo$1(()=>{
        // eslint-disable-next-line no-shadow
        function useSetRecoilState(recoilState) {
            $7ef244517b504261$var$validateRecoilValue(recoilState, "useSetRecoilState");
            return (newValueOrUpdater)=>{
                $7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
            };
        } // eslint-disable-next-line no-shadow
        function useResetRecoilState(recoilState) {
            $7ef244517b504261$var$validateRecoilValue(recoilState, "useResetRecoilState");
            return ()=>$7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, $7ef244517b504261$var$DEFAULT_VALUE$2);
        } // eslint-disable-next-line no-shadow
        function useRecoilValueLoadable(recoilValue) {
            var _storeState$nextTree;
            $7ef244517b504261$var$validateRecoilValue(recoilValue, "useRecoilValueLoadable");
            if (!recoilValuesUsed.current.has(recoilValue.key)) recoilValuesUsed.current = $7ef244517b504261$var$setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
             // TODO Restore optimization to memoize lookup
            const storeState = storeRef.current.getState();
            return $7ef244517b504261$var$getRecoilValueAsLoadable$2(storeRef.current, recoilValue, $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
        } // eslint-disable-next-line no-shadow
        function useRecoilValue(recoilValue) {
            $7ef244517b504261$var$validateRecoilValue(recoilValue, "useRecoilValue");
            const loadable = useRecoilValueLoadable(recoilValue);
            return $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef);
        } // eslint-disable-next-line no-shadow
        function useRecoilState(recoilState) {
            $7ef244517b504261$var$validateRecoilValue(recoilState, "useRecoilState");
            return [
                useRecoilValue(recoilState),
                useSetRecoilState(recoilState)
            ];
        } // eslint-disable-next-line no-shadow
        function useRecoilStateLoadable(recoilState) {
            $7ef244517b504261$var$validateRecoilValue(recoilState, "useRecoilStateLoadable");
            return [
                useRecoilValueLoadable(recoilState),
                useSetRecoilState(recoilState)
            ];
        }
        return {
            getRecoilValue: useRecoilValue,
            getRecoilValueLoadable: useRecoilValueLoadable,
            getRecoilState: useRecoilState,
            getRecoilStateLoadable: useRecoilStateLoadable,
            getSetRecoilState: useSetRecoilState,
            getResetRecoilState: useResetRecoilState
        };
    }, [
        recoilValuesUsed,
        storeRef
    ]);
}
const $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING = {
    current: 0
};
function $7ef244517b504261$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const getSnapshot = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree2;
        $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
        const loadable = $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
        return {
            loadable: loadable,
            key: recoilValue.key
        };
    }, [
        storeRef,
        recoilValue
    ]); // Memoize the state to avoid unnecessary rerenders
    const memoizePreviousSnapshot = $7ef244517b504261$var$useCallback$1((getState)=>{
        let prevState;
        return ()=>{
            var _prevState, _prevState2;
            const nextState = getState();
            if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) return prevState;
            prevState = nextState;
            return nextState;
        };
    }, []);
    const getMemoizedSnapshot = $7ef244517b504261$var$useMemo$1(()=>memoizePreviousSnapshot(getSnapshot), [
        getSnapshot,
        memoizePreviousSnapshot
    ]);
    const subscribe = $7ef244517b504261$var$useCallback$1((notify)=>{
        const store = storeRef.current;
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName
    ]);
    return $7ef244517b504261$var$useSyncExternalStore$1(subscribe, getMemoizedSnapshot, getMemoizedSnapshot // getServerSnapshot() for SSR support
    ).loadable;
}
function $7ef244517b504261$var$useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const getLoadable = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree3;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
        return $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getLoadableWithTesting = $7ef244517b504261$var$useCallback$1(()=>{
        $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
        return getLoadable();
    }, [
        getLoadable
    ]);
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const subscribe = $7ef244517b504261$var$useCallback$1((_storeState, notify)=>{
        const store = storeRef.current;
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(store, recoilValue, ()=>{
            if (!$7ef244517b504261$var$Recoil_gkx("recoil_suppress_rerender_in_callback")) return notify();
             // Only re-render if the value has changed.
            // This will evaluate the atom/selector now as well as when the
            // component renders, but that may help with prefetching.
            const newLoadable = getLoadable();
            if (!prevLoadableRef.current.is(newLoadable)) notify();
             // If the component is suspended then the effect setting prevLoadableRef
            // will not run.  So, set the previous value here when its subscription
            // is fired to wake it up.  We can't just rely on this, though, because
            // this only executes when an atom/selector is dirty and the atom/selector
            // passed to the hook can dynamically change.
            prevLoadableRef.current = newLoadable;
        }, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName,
        getLoadable
    ]);
    const source = $7ef244517b504261$var$useRecoilMutableSource$1();
    if (source == null) throw $7ef244517b504261$var$Recoil_err("Recoil hooks must be used in components contained within a <RecoilRoot> component.");
    const loadable = $7ef244517b504261$var$useMutableSource$1(source, getLoadableWithTesting, subscribe);
    const prevLoadableRef = $7ef244517b504261$var$useRef$4(loadable);
    $7ef244517b504261$var$useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    return loadable;
}
function $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const componentName = $7ef244517b504261$var$Recoil_useComponentName(); // Accessors to get the current state
    const getLoadable = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree4;
        $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
        return $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getState = $7ef244517b504261$var$useCallback$1(()=>({
            loadable: getLoadable(),
            key: recoilValue.key
        }), [
        getLoadable,
        recoilValue.key
    ]); // Memoize state snapshots
    const updateState = $7ef244517b504261$var$useCallback$1((prevState)=>{
        const nextState = getState();
        return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
    }, [
        getState
    ]); // Subscribe to Recoil state changes
    $7ef244517b504261$var$useEffect$3(()=>{
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(storeRef.current, recoilValue, (_state)=>{
            setState(updateState);
        }, componentName); // Update state in case we are using a different key
        setState(updateState);
        return subscription.release;
    }, [
        componentName,
        recoilValue,
        storeRef,
        updateState
    ]); // Get the current state
    const [state, setState] = $7ef244517b504261$var$useState$1(getState); // If we changed keys, then return the state for the new key.
    // This is important in case the old key would cause the component to suspend.
    // We don't have to set the new state here since the subscribing effect above
    // will do that.
    return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}
function $7ef244517b504261$var$useRecoilValueLoadable_LEGACY(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = $7ef244517b504261$var$useState$1([]);
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const getLoadable = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree5;
        $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING.current++;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
        return $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const loadable = getLoadable();
    const prevLoadableRef = $7ef244517b504261$var$useRef$4(loadable);
    $7ef244517b504261$var$useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    $7ef244517b504261$var$useEffect$3(()=>{
        const store = storeRef.current;
        const storeState = store.getState();
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(store, recoilValue, (_state)=>{
            var _prevLoadableRef$curr;
            if (!$7ef244517b504261$var$Recoil_gkx("recoil_suppress_rerender_in_callback")) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }, componentName);
        /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */ if (storeState.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
            // $FlowFixMe[incompatible-type]
            prevLoadableRef.current = null;
            forceUpdate([]);
        });
        else {
            var _prevLoadableRef$curr2;
            if (!$7ef244517b504261$var$Recoil_gkx("recoil_suppress_rerender_in_callback")) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }
        return subscription.release;
    }, [
        componentName,
        getLoadable,
        recoilValue,
        storeRef
    ]);
    return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/ function $7ef244517b504261$var$useRecoilValueLoadable(recoilValue) {
    $7ef244517b504261$var$validateRecoilValue(recoilValue, "useRecoilValueLoadable");
    if ($7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) // eslint-disable-next-line fb-www/react-hooks
    $7ef244517b504261$var$Recoil_useRetain(recoilValue);
    return ({
        TRANSITION_SUPPORT: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
        // `reactMode()` before calling it.  However, sometimes the host React
        // environment supports it but uses additional React renderers (such as with
        // `react-three-fiber`) which do not.  While this is technically a user issue
        // by using a renderer with React 18+ that doesn't fully support React 18 we
        // don't want to break users if it can be avoided. As the current renderer can
        // change at runtime, we need to dynamically check and fallback if necessary.
        SYNC_EXTERNAL_STORE: $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore$1() ? $7ef244517b504261$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE : $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        MUTABLE_SOURCE: $7ef244517b504261$var$useRecoilValueLoadable_MUTABLE_SOURCE,
        LEGACY: $7ef244517b504261$var$useRecoilValueLoadable_LEGACY
    })[$7ef244517b504261$var$reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */ function $7ef244517b504261$var$useRecoilValue(recoilValue) {
    $7ef244517b504261$var$validateRecoilValue(recoilValue, "useRecoilValue");
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const loadable = $7ef244517b504261$var$useRecoilValueLoadable(recoilValue);
    return $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/ function $7ef244517b504261$var$useSetRecoilState(recoilState) {
    $7ef244517b504261$var$validateRecoilValue(recoilState, "useSetRecoilState");
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    return $7ef244517b504261$var$useCallback$1((newValueOrUpdater)=>{
        $7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/ function $7ef244517b504261$var$useResetRecoilState(recoilState) {
    $7ef244517b504261$var$validateRecoilValue(recoilState, "useResetRecoilState");
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    return $7ef244517b504261$var$useCallback$1(()=>{
        $7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, $7ef244517b504261$var$DEFAULT_VALUE$2);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/ function $7ef244517b504261$var$useRecoilState(recoilState) {
    $7ef244517b504261$var$validateRecoilValue(recoilState, "useRecoilState");
    return [
        $7ef244517b504261$var$useRecoilValue(recoilState),
        $7ef244517b504261$var$useSetRecoilState(recoilState)
    ];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/ function $7ef244517b504261$var$useRecoilStateLoadable(recoilState) {
    $7ef244517b504261$var$validateRecoilValue(recoilState, "useRecoilStateLoadable");
    return [
        $7ef244517b504261$var$useRecoilValueLoadable(recoilState),
        $7ef244517b504261$var$useSetRecoilState(recoilState)
    ];
}
function $7ef244517b504261$var$useSetUnvalidatedAtomValues() {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    return (values, transactionMetadata = {})=>{
        $7ef244517b504261$var$batchUpdates$2(()=>{
            storeRef.current.addTransactionMetadata(transactionMetadata);
            values.forEach((value, key)=>$7ef244517b504261$var$setUnvalidatedRecoilValue$2(storeRef.current, new $7ef244517b504261$var$AbstractRecoilValue$3(key), value));
        });
    };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */ function $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    $7ef244517b504261$var$validateRecoilValue(recoilValue, "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE");
    if (!$7ef244517b504261$var$reactMode$3().early) $7ef244517b504261$var$Recoil_recoverableViolation("Attepmt to use a hook with UNSTABLE_TRANSITION_SUPPORT in a rendering mode incompatible with concurrent rendering.  Try enabling the recoil_sync_external_store or recoil_transition_support GKs.");
    if ($7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020")) // eslint-disable-next-line fb-www/react-hooks
    $7ef244517b504261$var$Recoil_useRetain(recoilValue);
    return $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}
function $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    $7ef244517b504261$var$validateRecoilValue(recoilValue, "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE");
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const loadable = $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
    return $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef);
}
function $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
    $7ef244517b504261$var$validateRecoilValue(recoilState, "useRecoilState_TRANSITION_SUPPORT_UNSTABLE");
    return [
        $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState),
        $7ef244517b504261$var$useSetRecoilState(recoilState)
    ];
}
var $7ef244517b504261$var$Recoil_Hooks = {
    recoilComponentGetRecoilValueCount_FOR_TESTING: $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING,
    useRecoilInterface: $7ef244517b504261$var$useRecoilInterface_DEPRECATED,
    useRecoilState: $7ef244517b504261$var$useRecoilState,
    useRecoilStateLoadable: $7ef244517b504261$var$useRecoilStateLoadable,
    useRecoilValue: $7ef244517b504261$var$useRecoilValue,
    useRecoilValueLoadable: $7ef244517b504261$var$useRecoilValueLoadable,
    useResetRecoilState: $7ef244517b504261$var$useResetRecoilState,
    useSetRecoilState: $7ef244517b504261$var$useSetRecoilState,
    useSetUnvalidatedAtomValues: $7ef244517b504261$var$useSetUnvalidatedAtomValues,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */ function $7ef244517b504261$var$filterMap(map, callback) {
    const result = new Map();
    for (const [key, value] of map)if (callback(value, key)) result.set(key, value);
    return result;
}
var $7ef244517b504261$var$Recoil_filterMap = $7ef244517b504261$var$filterMap;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */ function $7ef244517b504261$var$filterSet(set, callback) {
    const result = new Set();
    for (const value of set)if (callback(value)) result.add(value);
    return result;
}
var $7ef244517b504261$var$Recoil_filterSet = $7ef244517b504261$var$filterSet;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$mergeMaps(...maps) {
    const result = new Map();
    for(let i = 0; i < maps.length; i++){
        const iterator = maps[i].keys();
        let nextKey;
        while(!(nextKey = iterator.next()).done)// $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
        result.set(nextKey.value, maps[i].get(nextKey.value));
    }
    return result;
}
var $7ef244517b504261$var$Recoil_mergeMaps = $7ef244517b504261$var$mergeMaps;
const { batchUpdates: $7ef244517b504261$var$batchUpdates$3  } = $7ef244517b504261$var$Recoil_Batching;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$3 , getNode: $7ef244517b504261$var$getNode$4 , nodes: $7ef244517b504261$var$nodes$1  } = $7ef244517b504261$var$Recoil_Node;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$3  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$4 , setRecoilValueLoadable: $7ef244517b504261$var$setRecoilValueLoadable$1  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { SUSPENSE_TIMEOUT_MS: $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$2  } = $7ef244517b504261$var$Recoil_Retention;
const { cloneSnapshot: $7ef244517b504261$var$cloneSnapshot$1  } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { useCallback: $7ef244517b504261$var$useCallback$2 , useEffect: $7ef244517b504261$var$useEffect$4 , useRef: $7ef244517b504261$var$useRef$5 , useState: $7ef244517b504261$var$useState$2  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
const { isSSR: $7ef244517b504261$var$isSSR$4  } = $7ef244517b504261$var$Recoil_Environment;
function $7ef244517b504261$var$useTransactionSubscription(callback) {
    const storeRef = $7ef244517b504261$var$useStoreRef$3();
    $7ef244517b504261$var$useEffect$4(()=>{
        const sub = storeRef.current.subscribeToTransactions(callback);
        return sub.release;
    }, [
        callback,
        storeRef
    ]);
}
function $7ef244517b504261$var$externallyVisibleAtomValuesInState(state) {
    const atomValues = state.atomValues.toMap();
    const persistedAtomContentsValues = $7ef244517b504261$var$Recoil_mapMap($7ef244517b504261$var$Recoil_filterMap(atomValues, (v, k)=>{
        const node = $7ef244517b504261$var$getNode$4(k);
        const persistence = node.persistence_UNSTABLE;
        return persistence != null && persistence.type !== "none" && v.state === "hasValue";
    }), (v)=>v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
    // all have persistence on or they wouldn't be there in the first place.
    return $7ef244517b504261$var$Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}
/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/ function $7ef244517b504261$var$useTransactionObservation_DEPRECATED(callback) {
    $7ef244517b504261$var$useTransactionSubscription($7ef244517b504261$var$useCallback$2((store)=>{
        let previousTree = store.getState().previousTree;
        const currentTree = store.getState().currentTree;
        if (!previousTree) {
            $7ef244517b504261$var$Recoil_recoverableViolation("Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil");
            previousTree = store.getState().currentTree; // attempt to trundle on
        }
        const atomValues = $7ef244517b504261$var$externallyVisibleAtomValuesInState(currentTree);
        const previousAtomValues = $7ef244517b504261$var$externallyVisibleAtomValuesInState(previousTree);
        const atomInfo = $7ef244517b504261$var$Recoil_mapMap($7ef244517b504261$var$nodes$1, (node)=>{
            var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;
            return {
                persistence_UNSTABLE: {
                    type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : "none",
                    backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
                }
            };
        }); // Filter on existance in atomValues so that externally-visible rules
        // are also applied to modified atoms (specifically exclude selectors):
        const modifiedAtoms = $7ef244517b504261$var$Recoil_filterSet(currentTree.dirtyAtoms, (k)=>atomValues.has(k) || previousAtomValues.has(k));
        callback({
            atomValues: atomValues,
            previousAtomValues: previousAtomValues,
            atomInfo: atomInfo,
            modifiedAtoms: modifiedAtoms,
            transactionMetadata: {
                ...currentTree.transactionMetadata
            }
        });
    }, [
        callback
    ]));
}
function $7ef244517b504261$var$useRecoilTransactionObserver(callback) {
    $7ef244517b504261$var$useTransactionSubscription($7ef244517b504261$var$useCallback$2((store)=>{
        const snapshot = $7ef244517b504261$var$cloneSnapshot$1(store, "latest");
        const previousSnapshot = $7ef244517b504261$var$cloneSnapshot$1(store, "previous");
        callback({
            snapshot: snapshot,
            previousSnapshot: previousSnapshot
        });
    }, [
        callback
    ]));
} // Return a snapshot of the current state and subscribe to all state changes
function $7ef244517b504261$var$useRecoilSnapshot() {
    const storeRef = $7ef244517b504261$var$useStoreRef$3();
    const [snapshot, setSnapshot] = $7ef244517b504261$var$useState$2(()=>$7ef244517b504261$var$cloneSnapshot$1(storeRef.current));
    const previousSnapshot = $7ef244517b504261$var$Recoil_usePrevious(snapshot);
    const timeoutID = $7ef244517b504261$var$useRef$5();
    const releaseRef = $7ef244517b504261$var$useRef$5();
    $7ef244517b504261$var$useTransactionSubscription($7ef244517b504261$var$useCallback$2((store)=>setSnapshot($7ef244517b504261$var$cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted
    $7ef244517b504261$var$useEffect$4(()=>{
        const release = snapshot.retain(); // Release the retain from the rendering call
        if (timeoutID.current && !$7ef244517b504261$var$isSSR$4) {
            var _releaseRef$current;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 || _releaseRef$current.call(releaseRef);
            releaseRef.current = null;
        }
        return ()=>{
            // Defer the release.  If "Fast Refresh"" is used then the component may
            // re-render with the same state.  The previous cleanup will then run and
            // then the new effect will run. We don't want the snapshot to be released
            // by that cleanup before the new effect has a chance to retain it again.
            // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
            window.setTimeout(release, 10);
        };
    }, [
        snapshot
    ]); // Retain snapshot until above effect is run.
    // Release after a threshold in case component is suspended.
    if (previousSnapshot !== snapshot && !$7ef244517b504261$var$isSSR$4) {
        // Release the previous snapshot
        if (timeoutID.current) {
            var _releaseRef$current2;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 || _releaseRef$current2.call(releaseRef);
            releaseRef.current = null;
        }
        releaseRef.current = snapshot.retain();
        timeoutID.current = window.setTimeout(()=>{
            var _releaseRef$current3;
            timeoutID.current = null;
            (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 || _releaseRef$current3.call(releaseRef);
            releaseRef.current = null;
        }, $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$2);
    }
    return snapshot;
}
function $7ef244517b504261$var$gotoSnapshot(store, snapshot) {
    var _storeState$nextTree;
    const storeState = store.getState();
    const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
    const next = snapshot.getStore_INTERNAL().getState().currentTree;
    $7ef244517b504261$var$batchUpdates$3(()=>{
        const keysToUpdate = new Set();
        for (const keys of [
            prev.atomValues.keys(),
            next.atomValues.keys()
        ])for (const key of keys){
            var _prev$atomValues$get, _next$atomValues$get;
            if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && $7ef244517b504261$var$getNode$4(key).shouldRestoreFromSnapshots) keysToUpdate.add(key);
        }
        keysToUpdate.forEach((key)=>{
            $7ef244517b504261$var$setRecoilValueLoadable$1(store, new $7ef244517b504261$var$AbstractRecoilValue$4(key), next.atomValues.has(key) ? $7ef244517b504261$var$Recoil_nullthrows(next.atomValues.get(key)) : $7ef244517b504261$var$DEFAULT_VALUE$3);
        });
        store.replaceState((state)=>({
                ...state,
                stateID: snapshot.getID()
            }));
    });
}
function $7ef244517b504261$var$useGotoRecoilSnapshot() {
    const storeRef = $7ef244517b504261$var$useStoreRef$3();
    return $7ef244517b504261$var$useCallback$2((snapshot)=>$7ef244517b504261$var$gotoSnapshot(storeRef.current, snapshot), [
        storeRef
    ]);
}
var $7ef244517b504261$var$Recoil_SnapshotHooks = {
    useRecoilSnapshot: $7ef244517b504261$var$useRecoilSnapshot,
    gotoSnapshot: $7ef244517b504261$var$gotoSnapshot,
    useGotoRecoilSnapshot: $7ef244517b504261$var$useGotoRecoilSnapshot,
    useRecoilTransactionObserver: $7ef244517b504261$var$useRecoilTransactionObserver,
    useTransactionObservation_DEPRECATED: $7ef244517b504261$var$useTransactionObservation_DEPRECATED,
    useTransactionSubscription_DEPRECATED: $7ef244517b504261$var$useTransactionSubscription
};
const { peekNodeInfo: $7ef244517b504261$var$peekNodeInfo$2  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$4  } = $7ef244517b504261$var$Recoil_RecoilRoot;
function $7ef244517b504261$var$useGetRecoilValueInfo() {
    const storeRef = $7ef244517b504261$var$useStoreRef$4(); // $FlowFixMe[incompatible-return]
    return ({ key: key  })=>$7ef244517b504261$var$peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}
var $7ef244517b504261$var$Recoil_useGetRecoilValueInfo = $7ef244517b504261$var$useGetRecoilValueInfo;
const { reactMode: $7ef244517b504261$var$reactMode$4  } = $7ef244517b504261$var$Recoil_ReactMode;
const { RecoilRoot: $7ef244517b504261$var$RecoilRoot$1 , useStoreRef: $7ef244517b504261$var$useStoreRef$5  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { useMemo: $7ef244517b504261$var$useMemo$2  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$useRecoilBridgeAcrossReactRoots() {
    // The test fails when using useMutableSource(), but only if act() is used
    // for the nested root.  So, this may only be a testing environment issue.
    if ($7ef244517b504261$var$reactMode$4().mode === "MUTABLE_SOURCE") // eslint-disable-next-line fb-www/no-console
    console.warn("Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.");
    const store = $7ef244517b504261$var$useStoreRef$5().current;
    return $7ef244517b504261$var$useMemo$2(()=>{
        // eslint-disable-next-line no-shadow
        function RecoilBridge({ children: children  }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$RecoilRoot$1, {
                store_INTERNAL: store
            }, children);
        }
        return RecoilBridge;
    }, [
        store
    ]);
}
var $7ef244517b504261$var$Recoil_useRecoilBridgeAcrossReactRoots = $7ef244517b504261$var$useRecoilBridgeAcrossReactRoots;
const { loadableWithValue: $7ef244517b504261$var$loadableWithValue$1  } = $7ef244517b504261$var$Recoil_Loadable$1;
const { initializeNode: $7ef244517b504261$var$initializeNode$3  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$4 , getNode: $7ef244517b504261$var$getNode$5  } = $7ef244517b504261$var$Recoil_Node;
const { copyTreeState: $7ef244517b504261$var$copyTreeState$1 , getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$3 , invalidateDownstreams: $7ef244517b504261$var$invalidateDownstreams$1 , writeLoadableToTreeState: $7ef244517b504261$var$writeLoadableToTreeState$1  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
function $7ef244517b504261$var$isAtom(recoilValue) {
    return $7ef244517b504261$var$getNode$5(recoilValue.key).nodeType === "atom";
}
class $7ef244517b504261$var$TransactionInterfaceImpl {
    constructor(store, treeState){
        $7ef244517b504261$var$_defineProperty(this, "_store", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_treeState", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_changes", void 0);
        $7ef244517b504261$var$_defineProperty(this, "get", (recoilValue)=>{
            if (this._changes.has(recoilValue.key)) // $FlowIssue[incompatible-return]
            return this._changes.get(recoilValue.key);
            if (!$7ef244517b504261$var$isAtom(recoilValue)) throw $7ef244517b504261$var$Recoil_err("Reading selectors within atomicUpdate is not supported");
            const loadable = $7ef244517b504261$var$getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);
            if (loadable.state === "hasValue") return loadable.contents;
            else if (loadable.state === "hasError") throw loadable.contents;
            else throw $7ef244517b504261$var$Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
        });
        $7ef244517b504261$var$_defineProperty(this, "set", (recoilState, valueOrUpdater)=>{
            if (!$7ef244517b504261$var$isAtom(recoilState)) throw $7ef244517b504261$var$Recoil_err("Setting selectors within atomicUpdate is not supported");
            if (typeof valueOrUpdater === "function") {
                const current = this.get(recoilState);
                this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off
            } else {
                // Initialize atom and run effects if not initialized yet
                $7ef244517b504261$var$initializeNode$3(this._store, recoilState.key, "set");
                this._changes.set(recoilState.key, valueOrUpdater);
            }
        });
        $7ef244517b504261$var$_defineProperty(this, "reset", (recoilState)=>{
            this.set(recoilState, $7ef244517b504261$var$DEFAULT_VALUE$4);
        });
        this._store = store;
        this._treeState = treeState;
        this._changes = new Map();
    }
    // eslint-disable-next-line fb-www/extra-arrow-initializer
    newTreeState_INTERNAL() {
        if (this._changes.size === 0) return this._treeState;
        const newState = $7ef244517b504261$var$copyTreeState$1(this._treeState);
        for (const [k, v] of this._changes)$7ef244517b504261$var$writeLoadableToTreeState$1(newState, k, $7ef244517b504261$var$loadableWithValue$1(v));
        $7ef244517b504261$var$invalidateDownstreams$1(this._store, newState);
        return newState;
    }
}
function $7ef244517b504261$var$atomicUpdater(store) {
    return (fn)=>{
        store.replaceState((treeState)=>{
            const changeset = new $7ef244517b504261$var$TransactionInterfaceImpl(store, treeState);
            fn(changeset);
            return changeset.newTreeState_INTERNAL();
        });
    };
}
var $7ef244517b504261$var$Recoil_AtomicUpdates = {
    atomicUpdater: $7ef244517b504261$var$atomicUpdater
};
var $7ef244517b504261$var$Recoil_AtomicUpdates_1 = $7ef244517b504261$var$Recoil_AtomicUpdates.atomicUpdater;
var $7ef244517b504261$var$Recoil_AtomicUpdates$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    atomicUpdater: $7ef244517b504261$var$Recoil_AtomicUpdates_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$invariant(condition, message) {
    if (!condition) throw new Error(message);
}
var $7ef244517b504261$var$invariant_1 = $7ef244517b504261$var$invariant;
// @oss-only
var $7ef244517b504261$var$Recoil_invariant = $7ef244517b504261$var$invariant_1;
const { atomicUpdater: $7ef244517b504261$var$atomicUpdater$1  } = $7ef244517b504261$var$Recoil_AtomicUpdates$1;
const { batchUpdates: $7ef244517b504261$var$batchUpdates$4  } = $7ef244517b504261$var$Recoil_Batching;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$5  } = $7ef244517b504261$var$Recoil_Node;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$6  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { refreshRecoilValue: $7ef244517b504261$var$refreshRecoilValue$1 , setRecoilValue: $7ef244517b504261$var$setRecoilValue$3  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { cloneSnapshot: $7ef244517b504261$var$cloneSnapshot$2  } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { gotoSnapshot: $7ef244517b504261$var$gotoSnapshot$1  } = $7ef244517b504261$var$Recoil_SnapshotHooks;
const { useCallback: $7ef244517b504261$var$useCallback$3  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
class $7ef244517b504261$var$Sentinel {
}
const $7ef244517b504261$var$SENTINEL = new $7ef244517b504261$var$Sentinel();
function $7ef244517b504261$var$recoilCallback(store, fn, args, extraInterface) {
    let ret = $7ef244517b504261$var$SENTINEL;
    let releaseSnapshot;
    $7ef244517b504261$var$batchUpdates$4(()=>{
        const errMsg = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
        if (typeof fn !== "function") throw $7ef244517b504261$var$Recoil_err(errMsg);
         // Clone the snapshot lazily to avoid overhead if the callback does not use it.
        // Note that this means the snapshot may represent later state from when
        // the callback was called if it first accesses the snapshot asynchronously.
        const callbackInterface = $7ef244517b504261$var$Recoil_lazyProxy({
            ...extraInterface !== null && extraInterface !== void 0 ? extraInterface : {},
            // flowlint-line unclear-type:off
            // $FlowFixMe[missing-local-annot]
            set: (node, newValue)=>$7ef244517b504261$var$setRecoilValue$3(store, node, newValue),
            // $FlowFixMe[missing-local-annot]
            reset: (node)=>$7ef244517b504261$var$setRecoilValue$3(store, node, $7ef244517b504261$var$DEFAULT_VALUE$5),
            // $FlowFixMe[missing-local-annot]
            refresh: (node)=>$7ef244517b504261$var$refreshRecoilValue$1(store, node),
            gotoSnapshot: (snapshot)=>$7ef244517b504261$var$gotoSnapshot$1(store, snapshot),
            transact_UNSTABLE: (transaction)=>$7ef244517b504261$var$atomicUpdater$1(store)(transaction)
        }, {
            snapshot: ()=>{
                const snapshot = $7ef244517b504261$var$cloneSnapshot$2(store);
                releaseSnapshot = snapshot.retain();
                return snapshot;
            }
        });
        const callback = fn(callbackInterface);
        if (typeof callback !== "function") throw $7ef244517b504261$var$Recoil_err(errMsg);
        ret = callback(...args);
    });
    !!(ret instanceof $7ef244517b504261$var$Sentinel) && $7ef244517b504261$var$Recoil_invariant(false, "batchUpdates should return immediately");
    if ($7ef244517b504261$var$Recoil_isPromise(ret)) ret = ret.finally(()=>{
        var _releaseSnapshot;
        (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 || _releaseSnapshot();
    });
    else {
        var _releaseSnapshot2;
        (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 || _releaseSnapshot2();
    }
    return ret;
}
function $7ef244517b504261$var$useRecoilCallback(fn, deps) {
    const storeRef = $7ef244517b504261$var$useStoreRef$6();
    return $7ef244517b504261$var$useCallback$3((...args)=>{
        return $7ef244517b504261$var$recoilCallback(storeRef.current, fn, args);
    }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $7ef244517b504261$var$Recoil_useRecoilCallback = {
    recoilCallback: $7ef244517b504261$var$recoilCallback,
    useRecoilCallback: $7ef244517b504261$var$useRecoilCallback
};
const { useStoreRef: $7ef244517b504261$var$useStoreRef$7  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { refreshRecoilValue: $7ef244517b504261$var$refreshRecoilValue$2  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { useCallback: $7ef244517b504261$var$useCallback$4  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$useRecoilRefresher(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$7();
    return $7ef244517b504261$var$useCallback$4(()=>{
        const store = storeRef.current;
        $7ef244517b504261$var$refreshRecoilValue$2(store, recoilValue);
    }, [
        recoilValue,
        storeRef
    ]);
}
var $7ef244517b504261$var$Recoil_useRecoilRefresher = $7ef244517b504261$var$useRecoilRefresher;
const { atomicUpdater: $7ef244517b504261$var$atomicUpdater$2  } = $7ef244517b504261$var$Recoil_AtomicUpdates$1;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$8  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { useMemo: $7ef244517b504261$var$useMemo$3  } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$useRecoilTransaction(fn, deps) {
    const storeRef = $7ef244517b504261$var$useStoreRef$8();
    return $7ef244517b504261$var$useMemo$3(()=>(...args)=>{
            const atomicUpdate = $7ef244517b504261$var$atomicUpdater$2(storeRef.current);
            atomicUpdate((transactionInterface)=>{
                fn(transactionInterface)(...args);
            });
        }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $7ef244517b504261$var$Recoil_useRecoilTransaction = $7ef244517b504261$var$useRecoilTransaction;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $7ef244517b504261$var$WrappedValue {
    constructor(value){
        $7ef244517b504261$var$_defineProperty(this, "value", void 0);
        this.value = value;
    }
}
var $7ef244517b504261$var$Recoil_Wrapper = {
    WrappedValue: $7ef244517b504261$var$WrappedValue
};
var $7ef244517b504261$var$Recoil_Wrapper_1 = $7ef244517b504261$var$Recoil_Wrapper.WrappedValue;
var $7ef244517b504261$var$Recoil_Wrapper$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WrappedValue: $7ef244517b504261$var$Recoil_Wrapper_1
});
const { isFastRefreshEnabled: $7ef244517b504261$var$isFastRefreshEnabled$2  } = $7ef244517b504261$var$Recoil_ReactMode;
class $7ef244517b504261$var$ChangedPathError extends Error {
}
class $7ef244517b504261$var$TreeCache {
    // $FlowIssue[unclear-type]
    constructor(options){
        var _options$onHit, _options$onSet, _options$mapNodeValue;
        $7ef244517b504261$var$_defineProperty(this, "_name", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_numLeafs", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_root", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_onHit", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_onSet", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_mapNodeValue", void 0);
        this._name = options === null || options === void 0 ? void 0 : options.name;
        this._numLeafs = 0;
        this._root = null;
        this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : ()=>{};
        this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : ()=>{};
        this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : (val)=>val;
    }
    size() {
        return this._numLeafs;
    }
    root() {
        return this._root;
    }
    get(getNodeValue, handlers) {
        var _this$getLeafNode;
        return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
    }
    getLeafNode(getNodeValue, handlers) {
        if (this._root == null) return undefined;
         // Iterate down the tree based on the current node values until we hit a leaf
        // $FlowIssue[unclear-type]
        let node = this._root;
        while(node){
            handlers === null || handlers === void 0 || handlers.onNodeVisit(node);
            if (node.type === "leaf") {
                this._onHit(node);
                return node;
            }
            const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));
            node = node.branches.get(nodeValue);
        }
        return undefined;
    }
    set(route, value, handlers) {
        const addLeaf = ()=>{
            var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;
            // First, setup the branch nodes for the route:
            // Iterate down the tree to find or add branch nodes following the route
            let node;
            let branchKey;
            for (const [nodeKey, nodeValue] of route){
                var _node, _handlers$onNodeVisit, _this$_root;
                // If the previous root was a leaf, while we not have a get(), it means
                // the selector has inconsistent values or implementation changed.
                const root = this._root;
                if ((root === null || root === void 0 ? void 0 : root.type) === "leaf") throw this.invalidCacheError();
                 // node now refers to the next node down in the tree
                const parent = node; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = (_node = node) !== null && _node !== void 0 ? _node : {
                    type: "branch",
                    nodeKey: nodeKey,
                    parent: parent,
                    branches: new Map(),
                    branchKey: branchKey
                }; // If we found an existing node, confirm it has a consistent value
                if (node.type !== "branch" || node.nodeKey !== nodeKey) throw this.invalidCacheError();
                 // Add the branch node to the tree
                parent === null || parent === void 0 || parent.branches.set(branchKey, node);
                handlers === null || handlers === void 0 || (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 || _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.
                branchKey = this._mapNodeValue(nodeValue);
                this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
            } // Second, setup the leaf node:
            // If there is an existing leaf for this route confirm it is consistent
            const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;
            if (oldLeaf != null && (oldLeaf.type !== "leaf" || oldLeaf.branchKey !== branchKey)) throw this.invalidCacheError();
             // Create a new or replacement leaf.
            const leafNode = {
                type: "leaf",
                value: value,
                parent: node,
                branchKey: branchKey
            }; // Install the leaf and call handlers
            (_node3 = node) === null || _node3 === void 0 || _node3.branches.set(branchKey, leafNode);
            this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
            this._numLeafs++;
            this._onSet(leafNode);
            handlers === null || handlers === void 0 || (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 || _handlers$onNodeVisit2.call(handlers, leafNode);
        };
        try {
            addLeaf();
        } catch (error) {
            // If the cache was stale or observed inconsistent values, such as with
            // Fast Refresh, then clear it and rebuild with the new values.
            if (error instanceof $7ef244517b504261$var$ChangedPathError) {
                this.clear();
                addLeaf();
            } else throw error;
        }
    }
    delete(leaf) {
        const root = this.root();
        if (!root) return false;
        if (leaf === root) {
            this._root = null;
            this._numLeafs = 0;
            return true;
        } // Iterate up from the leaf deleteing it from it's parent's branches.
        let node = leaf.parent;
        let branchKey = leaf.branchKey;
        while(node){
            var _node4;
            node.branches.delete(branchKey); // Stop iterating if we hit the root.
            if (node === root) {
                if (node.branches.size === 0) {
                    this._root = null;
                    this._numLeafs = 0;
                } else this._numLeafs--;
                return true;
            } // Stop iterating if there are other branches since we don't need to
            // remove any more nodes.
            if (node.branches.size > 0) break;
             // Iterate up to our parent
            branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
            node = node.parent;
        } // Confirm that the leaf we are deleting is actually attached to our tree
        for(; node !== root; node = node.parent){
            if (node == null) return false;
        }
        this._numLeafs--;
        return true;
    }
    clear() {
        this._numLeafs = 0;
        this._root = null;
    }
    invalidCacheError() {
        const CHANGED_PATH_ERROR_MESSAGE = $7ef244517b504261$var$isFastRefreshEnabled$2() ? "Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache." : "Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.";
        $7ef244517b504261$var$Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ""));
        throw new $7ef244517b504261$var$ChangedPathError();
    }
}
var $7ef244517b504261$var$Recoil_TreeCache = {
    TreeCache: $7ef244517b504261$var$TreeCache
};
var $7ef244517b504261$var$Recoil_TreeCache_1 = $7ef244517b504261$var$Recoil_TreeCache.TreeCache;
var $7ef244517b504261$var$Recoil_TreeCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TreeCache: $7ef244517b504261$var$Recoil_TreeCache_1
});
class $7ef244517b504261$var$LRUCache {
    constructor(options){
        var _options$mapKey;
        $7ef244517b504261$var$_defineProperty(this, "_maxSize", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_size", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_head", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_tail", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_map", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_keyMapper", void 0);
        this._maxSize = options.maxSize;
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    head() {
        return this._head;
    }
    tail() {
        return this._tail;
    }
    size() {
        return this._size;
    }
    maxSize() {
        return this._maxSize;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        const mappedKey = this._keyMapper(key);
        const node = this._map.get(mappedKey);
        if (!node) return undefined;
        this.set(key, node.value);
        return node.value;
    }
    set(key, val) {
        const mappedKey = this._keyMapper(key);
        const existingNode = this._map.get(mappedKey);
        if (existingNode) this.delete(key);
        const head = this.head();
        const node = {
            key: key,
            right: head,
            left: null,
            value: val
        };
        if (head) head.left = node;
        else this._tail = node;
        this._map.set(mappedKey, node);
        this._head = node;
        this._size++;
        this._maybeDeleteLRU();
    }
    _maybeDeleteLRU() {
        if (this.size() > this.maxSize()) this.deleteLru();
    }
    deleteLru() {
        const tail = this.tail();
        if (tail) this.delete(tail.key);
    }
    delete(key) {
        const mappedKey = this._keyMapper(key);
        if (!this._size || !this._map.has(mappedKey)) return;
        const node = $7ef244517b504261$var$Recoil_nullthrows(this._map.get(mappedKey));
        const right = node.right;
        const left = node.left;
        if (right) right.left = node.left;
        if (left) left.right = node.right;
        if (node === this.head()) this._head = right;
        if (node === this.tail()) this._tail = left;
        this._map.delete(mappedKey);
        this._size--;
    }
    clear() {
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
    }
}
var $7ef244517b504261$var$Recoil_LRUCache = {
    LRUCache: $7ef244517b504261$var$LRUCache
};
var $7ef244517b504261$var$Recoil_LRUCache_1 = $7ef244517b504261$var$Recoil_LRUCache.LRUCache;
var $7ef244517b504261$var$Recoil_LRUCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    LRUCache: $7ef244517b504261$var$Recoil_LRUCache_1
});
const { LRUCache: $7ef244517b504261$var$LRUCache$1  } = $7ef244517b504261$var$Recoil_LRUCache$1;
const { TreeCache: $7ef244517b504261$var$TreeCache$1  } = $7ef244517b504261$var$Recoil_TreeCache$1;
function $7ef244517b504261$var$treeCacheLRU({ name: name , maxSize: maxSize , mapNodeValue: mapNodeValue = (v)=>v  }) {
    const lruCache = new $7ef244517b504261$var$LRUCache$1({
        maxSize: maxSize
    });
    const cache = new $7ef244517b504261$var$TreeCache$1({
        name: name,
        mapNodeValue: mapNodeValue,
        onHit: (node)=>{
            lruCache.set(node, true);
        },
        onSet: (node)=>{
            const lruNode = lruCache.tail();
            lruCache.set(node, true);
            if (lruNode && cache.size() > maxSize) // $FlowFixMe[incompatible-call]
            cache.delete(lruNode.key);
        }
    });
    return cache;
}
var $7ef244517b504261$var$Recoil_treeCacheLRU = $7ef244517b504261$var$treeCacheLRU;
const $7ef244517b504261$var$TIME_WARNING_THRESHOLD_MS = 15;
function $7ef244517b504261$var$stringify(x, opt, key) {
    // A optimization to avoid the more expensive JSON.stringify() for simple strings
    // This may lose protection for u2028 and u2029, though.
    if (typeof x === "string" && !x.includes('"') && !x.includes("\\")) return `"${x}"`;
     // Handle primitive types
    switch(typeof x){
        case "undefined":
            return "";
        // JSON.stringify(undefined) returns undefined, but we always want to return a string
        case "boolean":
            return x ? "true" : "false";
        case "number":
        case "symbol":
            // case 'bigint': // BigInt is not supported in www
            return String(x);
        case "string":
            // Add surrounding quotes and escape internal quotes
            return JSON.stringify(x);
        case "function":
            if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) throw $7ef244517b504261$var$Recoil_err("Attempt to serialize function in a Recoil cache key");
            return `__FUNCTION(${x.name})__`;
    }
    if (x === null) return "null";
     // Fallback case for unknown types
    if (typeof x !== "object") {
        var _JSON$stringify;
        return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "";
    } // Deal with all promises as equivalent for now.
    if ($7ef244517b504261$var$Recoil_isPromise(x)) return "__PROMISE__";
     // Arrays handle recursive stringification
    if (Array.isArray(x)) // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i)=>$7ef244517b504261$var$stringify(v, opt, i.toString()))}]`;
     // If an object defines a toJSON() method, then use that to override the
    // serialization.  This matches the behavior of JSON.stringify().
    // Pass the key for compatibility.
    // Immutable.js collections define this method to allow us to serialize them.
    if (typeof x.toJSON === "function") // flowlint-next-line unclear-type: off
    return $7ef244517b504261$var$stringify(x.toJSON(key), opt, key);
     // For built-in Maps, sort the keys in a stable order instead of the
    // default insertion order.  Support non-string keys.
    if (x instanceof Map) {
        const obj = {};
        for (const [k, v] of x)// Stringify will escape any nested quotes
        obj[typeof k === "string" ? k : $7ef244517b504261$var$stringify(k, opt)] = v;
        return $7ef244517b504261$var$stringify(obj, opt, key);
    } // For built-in Sets, sort the keys in a stable order instead of the
    // default insertion order.
    if (x instanceof Set) return $7ef244517b504261$var$stringify(Array.from(x).sort((a, b)=>$7ef244517b504261$var$stringify(a, opt).localeCompare($7ef244517b504261$var$stringify(b, opt))), opt, key);
     // Anything else that is iterable serialize as an Array.
    if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === "function") // flowlint-next-line unclear-type: off
    return $7ef244517b504261$var$stringify(Array.from(x), opt, key);
     // For all other Objects, sort the keys in a stable order.
    return `{${Object.keys(x).filter((k)=>x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
    .map((k)=>`${$7ef244517b504261$var$stringify(k, opt)}:${$7ef244517b504261$var$stringify(x[k], opt, k)}`).join(",")}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples
function $7ef244517b504261$var$stableStringify(x, opt = {
    allowFunctions: false
}) {
    if (typeof window !== "undefined") {
        const startTime = window.performance ? window.performance.now() : 0;
        const str = $7ef244517b504261$var$stringify(x, opt);
        const endTime = window.performance ? window.performance.now() : 0;
        if (endTime - startTime > $7ef244517b504261$var$TIME_WARNING_THRESHOLD_MS) {
            /* eslint-disable fb-www/no-console */ console.groupCollapsed(`Recoil: Spent ${endTime - startTime}ms computing a cache key`);
            console.warn(x, str);
            console.groupEnd();
        /* eslint-enable fb-www/no-console */ }
        return str;
    }
    return $7ef244517b504261$var$stringify(x, opt);
}
var $7ef244517b504261$var$Recoil_stableStringify = $7ef244517b504261$var$stableStringify;
const { TreeCache: $7ef244517b504261$var$TreeCache$2  } = $7ef244517b504261$var$Recoil_TreeCache$1;
const $7ef244517b504261$var$defaultPolicy = {
    equality: "reference",
    eviction: "keep-all",
    maxSize: Infinity
};
function $7ef244517b504261$var$treeCacheFromPolicy({ equality: equality = $7ef244517b504261$var$defaultPolicy.equality , eviction: eviction = $7ef244517b504261$var$defaultPolicy.eviction , maxSize: maxSize = $7ef244517b504261$var$defaultPolicy.maxSize  } = $7ef244517b504261$var$defaultPolicy, name) {
    const valueMapper = $7ef244517b504261$var$getValueMapper(equality);
    return $7ef244517b504261$var$getTreeCache(eviction, maxSize, valueMapper, name);
}
function $7ef244517b504261$var$getValueMapper(equality) {
    switch(equality){
        case "reference":
            return (val)=>val;
        case "value":
            return (val)=>$7ef244517b504261$var$Recoil_stableStringify(val);
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized equality policy ${equality}`);
}
function $7ef244517b504261$var$getTreeCache(eviction, maxSize, mapNodeValue, name) {
    switch(eviction){
        case "keep-all":
            return new $7ef244517b504261$var$TreeCache$2({
                name: name,
                mapNodeValue: mapNodeValue
            });
        case "lru":
            return $7ef244517b504261$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: $7ef244517b504261$var$Recoil_nullthrows(maxSize),
                mapNodeValue: mapNodeValue
            });
        case "most-recent":
            return $7ef244517b504261$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: 1,
                mapNodeValue: mapNodeValue
            });
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var $7ef244517b504261$var$Recoil_treeCacheFromPolicy = $7ef244517b504261$var$treeCacheFromPolicy;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$isNode(object) {
    var _ownerDocument, _doc$defaultView;
    if (typeof window === "undefined") return false;
    const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
    const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
    return !!(object != null && (typeof defaultView.Node === "function" ? object instanceof defaultView.Node : typeof object === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string"));
}
var $7ef244517b504261$var$Recoil_isNode = $7ef244517b504261$var$isNode;
const { isReactNative: $7ef244517b504261$var$isReactNative$1 , isWindow: $7ef244517b504261$var$isWindow$1  } = $7ef244517b504261$var$Recoil_Environment;
function $7ef244517b504261$var$shouldNotBeFrozen(value) {
    // Primitives and functions:
    if (value === null || typeof value !== "object") return true;
     // React elements:
    switch(typeof value.$$typeof){
        case "symbol":
            return true;
        case "number":
            return true;
    } // Immutable structures:
    if (value["@@__IMMUTABLE_ITERABLE__@@"] != null || value["@@__IMMUTABLE_KEYED__@@"] != null || value["@@__IMMUTABLE_INDEXED__@@"] != null || value["@@__IMMUTABLE_ORDERED__@@"] != null || value["@@__IMMUTABLE_RECORD__@@"] != null) return true;
     // DOM nodes:
    if ($7ef244517b504261$var$Recoil_isNode(value)) return true;
    if ($7ef244517b504261$var$Recoil_isPromise(value)) return true;
    if (value instanceof Error) return true;
    if (ArrayBuffer.isView(value)) return true;
     // Some environments, just as Jest, don't work with the instanceof check
    if (!$7ef244517b504261$var$isReactNative$1 && $7ef244517b504261$var$isWindow$1(value)) return true;
    return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)
function $7ef244517b504261$var$deepFreezeValue(value) {
    if (typeof value !== "object" || $7ef244517b504261$var$shouldNotBeFrozen(value)) return;
    Object.freeze(value); // Make all properties read-only
    for(const key in value)// $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
        const prop = value[key]; // Prevent infinite recurssion for circular references.
        if (typeof prop === "object" && prop != null && !Object.isFrozen(prop)) $7ef244517b504261$var$deepFreezeValue(prop);
    }
    Object.seal(value); // This also makes existing properties non-configurable.
}
var $7ef244517b504261$var$Recoil_deepFreezeValue = $7ef244517b504261$var$deepFreezeValue;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$startPerfBlock(_id) {
    return ()=>null;
}
var $7ef244517b504261$var$Recoil_PerformanceTimings = {
    startPerfBlock: $7ef244517b504261$var$startPerfBlock
};
const { isLoadable: $7ef244517b504261$var$isLoadable$1 , loadableWithError: $7ef244517b504261$var$loadableWithError$1 , loadableWithPromise: $7ef244517b504261$var$loadableWithPromise$1 , loadableWithValue: $7ef244517b504261$var$loadableWithValue$2  } = $7ef244517b504261$var$Recoil_Loadable$1;
const { WrappedValue: $7ef244517b504261$var$WrappedValue$1  } = $7ef244517b504261$var$Recoil_Wrapper$1;
const { getNodeLoadable: $7ef244517b504261$var$getNodeLoadable$2 , peekNodeLoadable: $7ef244517b504261$var$peekNodeLoadable$1 , setNodeValue: $7ef244517b504261$var$setNodeValue$3  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { saveDepsToStore: $7ef244517b504261$var$saveDepsToStore$1  } = $7ef244517b504261$var$Recoil_Graph;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$6 , getConfigDeletionHandler: $7ef244517b504261$var$getConfigDeletionHandler$1 , getNode: $7ef244517b504261$var$getNode$6 , registerNode: $7ef244517b504261$var$registerNode$1  } = $7ef244517b504261$var$Recoil_Node;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$3  } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { markRecoilValueModified: $7ef244517b504261$var$markRecoilValueModified$1  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: $7ef244517b504261$var$retainedByOptionWithDefault$1  } = $7ef244517b504261$var$Recoil_Retention;
const { recoilCallback: $7ef244517b504261$var$recoilCallback$1  } = $7ef244517b504261$var$Recoil_useRecoilCallback;
const { startPerfBlock: $7ef244517b504261$var$startPerfBlock$1  } = $7ef244517b504261$var$Recoil_PerformanceTimings;
class $7ef244517b504261$var$Canceled {
}
const $7ef244517b504261$var$CANCELED = new $7ef244517b504261$var$Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */ const $7ef244517b504261$var$dependencyStack = []; // for detecting circular dependencies.
const $7ef244517b504261$var$waitingStores = new Map();
const $7ef244517b504261$var$getNewExecutionID = (()=>{
    let executionID = 0;
    return ()=>executionID++;
})();
/* eslint-disable no-redeclare */ function $7ef244517b504261$var$selector(options) {
    let recoilValue = null;
    const { key: key , get: get , cachePolicy_UNSTABLE: cachePolicy  } = options;
    const set = options.set != null ? options.set : undefined; // flow
    if (typeof key !== "string") throw $7ef244517b504261$var$Recoil_err("A key option with a unique string value must be provided when creating a selector.");
    if (typeof get !== "function") throw $7ef244517b504261$var$Recoil_err("Selectors must specify a get callback option to get the selector value.");
    const discoveredDependencyNodeKeys = new Set();
    const cache = $7ef244517b504261$var$Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
        equality: "reference",
        eviction: "keep-all"
    }, key);
    const retainedBy = $7ef244517b504261$var$retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
    const executionInfoMap = new Map();
    let liveStoresCount = 0;
    function selectorIsLive() {
        return !$7ef244517b504261$var$Recoil_gkx("recoil_memory_managament_2020") || liveStoresCount > 0;
    }
    function selectorInit(store) {
        store.getState().knownSelectors.add(key);
        liveStoresCount++;
        return ()=>{
            liveStoresCount--;
        };
    }
    function selectorShouldDeleteConfigOnRelease() {
        return $7ef244517b504261$var$getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
    }
    function resolveAsync(store, state, executionID, loadable, depValues) {
        setCache(state, loadable, depValues);
        notifyStoresOfResolvedAsync(store, executionID);
    }
    function notifyStoresOfResolvedAsync(store, executionID) {
        if (isLatestExecution(store, executionID)) clearExecutionInfo(store);
        notifyWaitingStores(executionID, true);
    }
    /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */ function notifyStoresOfNewAsyncDep(store, executionID) {
        if (isLatestExecution(store, executionID)) {
            const executionInfo = $7ef244517b504261$var$Recoil_nullthrows(getExecutionInfo(store));
            executionInfo.stateVersions.clear();
            notifyWaitingStores(executionID, false);
        }
    }
    function notifyWaitingStores(executionID, clearWaitlist) {
        const stores = $7ef244517b504261$var$waitingStores.get(executionID);
        if (stores != null) {
            for (const waitingStore of stores)$7ef244517b504261$var$markRecoilValueModified$1(waitingStore, $7ef244517b504261$var$Recoil_nullthrows(recoilValue));
            if (clearWaitlist) $7ef244517b504261$var$waitingStores.delete(executionID);
        }
    }
    function markStoreWaitingForResolvedAsync(store, executionID) {
        let stores = $7ef244517b504261$var$waitingStores.get(executionID);
        if (stores == null) $7ef244517b504261$var$waitingStores.set(executionID, stores = new Set());
        stores.add(store);
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */ function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
        return promise.then((value)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            }
            const loadable = $7ef244517b504261$var$loadableWithValue$2(value);
            resolveAsync(store, state, executionID, loadable, depValues);
            return value;
        }).catch((errorOrPromise)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            }
            if ($7ef244517b504261$var$Recoil_isPromise(errorOrPromise)) return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
            const loadable = $7ef244517b504261$var$loadableWithError$1(errorOrPromise);
            resolveAsync(store, state, executionID, loadable, depValues);
            throw errorOrPromise;
        });
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */ function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
        return promise.then((resolvedDep)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            } // Check if we are handling a pending Recoil dependency or if the user
            // threw their own Promise to "suspend" a selector evaluation.  We need
            // to check that the loadingDepPromise actually matches the promise that
            // we caught in case the selector happened to catch the promise we threw
            // for a pending Recoil dependency from `getRecoilValue()` and threw
            // their own promise instead.
            if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */ state.atomValues.set(loadingDepsState.loadingDepKey, $7ef244517b504261$var$loadableWithValue$2(resolvedDep));
            else /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */ store.getState().knownSelectors.forEach((nodeKey)=>{
                state.atomValues.delete(nodeKey);
            });
            /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */ const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);
            if (cachedLoadable && cachedLoadable.state !== "loading") {
                /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */ if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) notifyStoresOfResolvedAsync(store, executionID);
                if (cachedLoadable.state === "hasValue") return cachedLoadable.contents;
                else throw cachedLoadable.contents;
            }
            /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */ if (!isLatestExecution(store, executionID)) {
                const executionInfo = getInProgressExecutionInfo(store, state);
                if (executionInfo != null) /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */ return executionInfo.loadingLoadable.contents;
            } // Retry the selector evaluation now that the dependency has resolved
            const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);
            if (loadable.state !== "loading") resolveAsync(store, state, executionID, loadable, depValues);
            if (loadable.state === "hasError") throw loadable.contents;
            return loadable.contents;
        }).catch((error)=>{
            // The selector was released since the request began; ignore the response.
            if (error instanceof $7ef244517b504261$var$Canceled) throw $7ef244517b504261$var$CANCELED;
            if (!selectorIsLive()) {
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            }
            const loadable = $7ef244517b504261$var$loadableWithError$1(error);
            resolveAsync(store, state, executionID, loadable, existingDeps);
            throw error;
        });
    }
    function updateDeps(store, state, deps, executionID) {
        var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;
        if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
            var _store$getState$nextT, _store$getState3, _store$getState3$next;
            $7ef244517b504261$var$saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
        }
        for (const nodeKey of deps)discoveredDependencyNodeKeys.add(nodeKey);
    }
    function evaluateSelectorGetter(store, state, executionID) {
        const endPerfBlock = $7ef244517b504261$var$startPerfBlock$1(key); // TODO T63965866: use execution ID here
        let duringSynchronousExecution = true;
        let duringAsynchronousExecution = true;
        const finishEvaluation = ()=>{
            endPerfBlock();
            duringAsynchronousExecution = false;
        };
        let result;
        let resultIsError = false;
        let loadable;
        const loadingDepsState = {
            loadingDepKey: null,
            loadingDepPromise: null
        };
        /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */ const depValues = new Map();
        function getRecoilValue({ key: depKey  }) {
            const depLoadable = $7ef244517b504261$var$getNodeLoadable$2(store, state, depKey);
            depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
            // knows if it has to restart evaluation if one of them is updated before
            // the asynchronous selector completely resolves.
            if (!duringSynchronousExecution) {
                updateDeps(store, state, new Set(depValues.keys()), executionID);
                notifyStoresOfNewAsyncDep(store, executionID);
            }
            switch(depLoadable.state){
                case "hasValue":
                    return depLoadable.contents;
                case "hasError":
                    throw depLoadable.contents;
                case "loading":
                    loadingDepsState.loadingDepKey = depKey;
                    loadingDepsState.loadingDepPromise = depLoadable.contents;
                    throw depLoadable.contents;
            }
            throw $7ef244517b504261$var$Recoil_err("Invalid Loadable state");
        }
        const getCallback = (fn)=>{
            return (...args)=>{
                if (duringAsynchronousExecution) throw $7ef244517b504261$var$Recoil_err("Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.");
                !(recoilValue != null) && $7ef244517b504261$var$Recoil_invariant(false, "Recoil Value can never be null");
                return $7ef244517b504261$var$recoilCallback$1(store, fn, args, {
                    node: recoilValue
                } // flowlint-line unclear-type:off
                );
            };
        };
        try {
            result = get({
                get: getRecoilValue,
                getCallback: getCallback
            });
            result = $7ef244517b504261$var$isRecoilValue$3(result) ? getRecoilValue(result) : result;
            if ($7ef244517b504261$var$isLoadable$1(result)) {
                if (result.state === "hasError") resultIsError = true;
                result = result.contents;
            }
            if ($7ef244517b504261$var$Recoil_isPromise(result)) result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else finishEvaluation();
            result = result instanceof $7ef244517b504261$var$WrappedValue$1 ? result.value : result;
        } catch (errorOrDepPromise) {
            result = errorOrDepPromise;
            if ($7ef244517b504261$var$Recoil_isPromise(result)) result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else {
                resultIsError = true;
                finishEvaluation();
            }
        }
        if (resultIsError) loadable = $7ef244517b504261$var$loadableWithError$1(result);
        else if ($7ef244517b504261$var$Recoil_isPromise(result)) loadable = $7ef244517b504261$var$loadableWithPromise$1(result);
        else loadable = $7ef244517b504261$var$loadableWithValue$2(result);
        duringSynchronousExecution = false;
        updateExecutionInfoDepValues(store, executionID, depValues);
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        return [
            loadable,
            depValues
        ];
    }
    function getLoadableFromCacheAndUpdateDeps(store, state) {
        // First, look up in the state cache
        // If it's here, then the deps in the store should already be valid.
        let cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
         // Second, look up in the selector cache and update the deps in the store
        const depsAfterCacheLookup = new Set();
        try {
            cachedLoadable = cache.get((nodeKey)=>{
                !(typeof nodeKey === "string") && $7ef244517b504261$var$Recoil_invariant(false, "Cache nodeKey is type string");
                return $7ef244517b504261$var$getNodeLoadable$2(store, state, nodeKey).contents;
            }, {
                onNodeVisit: (node)=>{
                    if (node.type === "branch" && node.nodeKey !== key) depsAfterCacheLookup.add(node.nodeKey);
                }
            });
        } catch (error) {
            throw $7ef244517b504261$var$Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
        }
        if (cachedLoadable) {
            var _getExecutionInfo;
            // Cache the results in the state to allow for cheaper lookup than
            // iterating the tree cache of dependencies.
            state.atomValues.set(key, cachedLoadable);
            /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */ updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
        }
        return cachedLoadable;
    }
    /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */ function getSelectorLoadableAndUpdateDeps(store, state) {
        // First, see if our current state is cached
        const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);
        if (cachedVal != null) {
            clearExecutionInfo(store);
            return cachedVal;
        } // Second, check if there is already an ongoing execution based on the current state
        const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);
        if (inProgressExecutionInfo != null) {
            var _inProgressExecutionI;
            if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === "loading") markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
             // FIXME: check after the fact to see if we made the right choice by waiting
            return inProgressExecutionInfo.loadingLoadable;
        } // Third, start a new evaluation of the selector
        const newExecutionID = $7ef244517b504261$var$getNewExecutionID();
        const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
        /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */ if (loadable.state === "loading") {
            setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
            markStoreWaitingForResolvedAsync(store, newExecutionID);
        } else {
            clearExecutionInfo(store);
            setCache(state, loadable, newDepValues);
        }
        return loadable;
    }
    /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */ function getInProgressExecutionInfo(store, state) {
        // Sort the pending executions so that our current store is checked first.
        const pendingExecutions = $7ef244517b504261$var$Recoil_concatIterables([
            executionInfoMap.has(store) ? [
                $7ef244517b504261$var$Recoil_nullthrows(executionInfoMap.get(store))
            ] : [],
            $7ef244517b504261$var$Recoil_mapIterable($7ef244517b504261$var$Recoil_filterIterable(executionInfoMap, ([s])=>s !== store), ([, execInfo])=>execInfo)
        ]);
        function anyDepChanged(execDepValues) {
            for (const [depKey, execLoadable] of execDepValues){
                if (!$7ef244517b504261$var$getNodeLoadable$2(store, state, depKey).is(execLoadable)) return true;
            }
            return false;
        }
        for (const execInfo of pendingExecutions)if (// of state, then let's use it!
        execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
        !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
            execInfo.stateVersions.set(state.version, true);
            return execInfo;
        } else execInfo.stateVersions.set(state.version, false);
        return undefined;
    }
    function getExecutionInfo(store) {
        return executionInfoMap.get(store);
    }
    /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */ function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
        executionInfoMap.set(store, {
            depValuesDiscoveredSoFarDuringAsyncWork: depValues,
            executionID: newExecutionID,
            loadingLoadable: loadable,
            stateVersions: new Map([
                [
                    state.version,
                    true
                ]
            ])
        });
    }
    function updateExecutionInfoDepValues(store, executionID, depValues) {
        // We only need to bother updating the deps for the latest execution because
        // that's all getInProgressExecutionInfo() will be looking for.
        if (isLatestExecution(store, executionID)) {
            const executionInfo = getExecutionInfo(store);
            if (executionInfo != null) executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
        }
    }
    function clearExecutionInfo(store) {
        executionInfoMap.delete(store);
    }
    function isLatestExecution(store, executionID) {
        var _getExecutionInfo2;
        return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
    }
    /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */ function depValuesToDepRoute(depValues) {
        return Array.from(depValues.entries()).map(([depKey, valLoadable])=>[
                depKey,
                valLoadable.contents
            ]);
    }
    function setCache(state, loadable, depValues) {
        if (loadable.state !== "loading" && Boolean(options.dangerouslyAllowMutability) === false) $7ef244517b504261$var$Recoil_deepFreezeValue(loadable.contents);
        state.atomValues.set(key, loadable);
        try {
            cache.set(depValuesToDepRoute(depValues), loadable);
        } catch (error) {
            throw $7ef244517b504261$var$Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
        }
    }
    function detectCircularDependencies(fn) {
        if ($7ef244517b504261$var$dependencyStack.includes(key)) {
            const message = `Recoil selector has circular dependencies: ${$7ef244517b504261$var$dependencyStack.slice($7ef244517b504261$var$dependencyStack.indexOf(key)).join(" → ")}`;
            return $7ef244517b504261$var$loadableWithError$1($7ef244517b504261$var$Recoil_err(message));
        }
        $7ef244517b504261$var$dependencyStack.push(key);
        try {
            return fn();
        } finally{
            $7ef244517b504261$var$dependencyStack.pop();
        }
    }
    function selectorPeek(store, state) {
        const cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
        return cache.get((nodeKey)=>{
            var _peekNodeLoadable;
            !(typeof nodeKey === "string") && $7ef244517b504261$var$Recoil_invariant(false, "Cache nodeKey is type string");
            return (_peekNodeLoadable = $7ef244517b504261$var$peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
        });
    }
    function selectorGet(store, state) {
        return detectCircularDependencies(()=>getSelectorLoadableAndUpdateDeps(store, state));
    }
    function invalidateSelector(state) {
        state.atomValues.delete(key);
    }
    function clearSelectorCache(store, treeState) {
        !(recoilValue != null) && $7ef244517b504261$var$Recoil_invariant(false, "Recoil Value can never be null");
        for (const nodeKey of discoveredDependencyNodeKeys){
            var _node$clearCache;
            const node = $7ef244517b504261$var$getNode$6(nodeKey);
            (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, treeState);
        }
        discoveredDependencyNodeKeys.clear();
        invalidateSelector(treeState);
        cache.clear();
        $7ef244517b504261$var$markRecoilValueModified$1(store, recoilValue);
    }
    if (set != null) {
        /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */ const selectorSet = (store, state, newValue)=>{
            let syncSelectorSetFinished = false;
            const writes = new Map();
            function getRecoilValue({ key: depKey  }) {
                if (syncSelectorSetFinished) throw $7ef244517b504261$var$Recoil_err("Recoil: Async selector sets are not currently supported.");
                const loadable = $7ef244517b504261$var$getNodeLoadable$2(store, state, depKey);
                if (loadable.state === "hasValue") return loadable.contents;
                else if (loadable.state === "loading") {
                    const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
                    $7ef244517b504261$var$Recoil_recoverableViolation(msg);
                    throw $7ef244517b504261$var$Recoil_err(msg);
                } else throw loadable.contents;
            }
            function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
            ) {
                if (syncSelectorSetFinished) {
                    const msg = "Recoil: Async selector sets are not currently supported.";
                    $7ef244517b504261$var$Recoil_recoverableViolation(msg);
                    throw $7ef244517b504261$var$Recoil_err(msg);
                }
                const setValue = typeof valueOrUpdater === "function" ? // flowlint-next-line unclear-type:off
                valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
                const upstreamWrites = $7ef244517b504261$var$setNodeValue$3(store, state, recoilState.key, setValue);
                upstreamWrites.forEach((v, k)=>writes.set(k, v));
            }
            function resetRecoilState(recoilState) {
                setRecoilState(recoilState, $7ef244517b504261$var$DEFAULT_VALUE$6);
            }
            const ret = set({
                set: setRecoilState,
                get: getRecoilValue,
                reset: resetRecoilState
            }, newValue); // set should be a void method, but if the user makes it `async`, then it
            // will return a Promise, which we don't currently support.
            if (ret !== undefined) throw $7ef244517b504261$var$Recoil_isPromise(ret) ? $7ef244517b504261$var$Recoil_err("Recoil: Async selector sets are not currently supported.") : $7ef244517b504261$var$Recoil_err("Recoil: selector set should be a void function.");
            syncSelectorSetFinished = true;
            return writes;
        };
        return recoilValue = $7ef244517b504261$var$registerNode$1({
            key: key,
            nodeType: "selector",
            peek: selectorPeek,
            get: selectorGet,
            set: selectorSet,
            init: selectorInit,
            invalidate: invalidateSelector,
            clearCache: clearSelectorCache,
            shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            shouldRestoreFromSnapshots: false,
            retainedBy: retainedBy
        });
    } else return recoilValue = $7ef244517b504261$var$registerNode$1({
        key: key,
        nodeType: "selector",
        peek: selectorPeek,
        get: selectorGet,
        init: selectorInit,
        invalidate: invalidateSelector,
        clearCache: clearSelectorCache,
        shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        shouldRestoreFromSnapshots: false,
        retainedBy: retainedBy
    });
}
/* eslint-enable no-redeclare */ // $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]
$7ef244517b504261$var$selector.value = (value)=>new $7ef244517b504261$var$WrappedValue$1(value);
var $7ef244517b504261$var$Recoil_selector = $7ef244517b504261$var$selector;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const { isLoadable: $7ef244517b504261$var$isLoadable$2 , loadableWithError: $7ef244517b504261$var$loadableWithError$2 , loadableWithPromise: $7ef244517b504261$var$loadableWithPromise$2 , loadableWithValue: $7ef244517b504261$var$loadableWithValue$3  } = $7ef244517b504261$var$Recoil_Loadable$1;
const { WrappedValue: $7ef244517b504261$var$WrappedValue$2  } = $7ef244517b504261$var$Recoil_Wrapper$1;
const { peekNodeInfo: $7ef244517b504261$var$peekNodeInfo$3  } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$7 , DefaultValue: $7ef244517b504261$var$DefaultValue$2 , getConfigDeletionHandler: $7ef244517b504261$var$getConfigDeletionHandler$2 , registerNode: $7ef244517b504261$var$registerNode$2 , setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler$1  } = $7ef244517b504261$var$Recoil_Node;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$4  } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$4 , markRecoilValueModified: $7ef244517b504261$var$markRecoilValueModified$2 , setRecoilValue: $7ef244517b504261$var$setRecoilValue$4 , setRecoilValueLoadable: $7ef244517b504261$var$setRecoilValueLoadable$2  } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: $7ef244517b504261$var$retainedByOptionWithDefault$2  } = $7ef244517b504261$var$Recoil_Retention;
const $7ef244517b504261$var$unwrap = (x)=>x instanceof $7ef244517b504261$var$WrappedValue$2 ? x.value : x;
function $7ef244517b504261$var$baseAtom(options) {
    const { key: key , persistence_UNSTABLE: persistence  } = options;
    const retainedBy = $7ef244517b504261$var$retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
    let liveStoresCount = 0;
    function unwrapPromise(promise) {
        return $7ef244517b504261$var$loadableWithPromise$2(promise.then((value)=>{
            defaultLoadable = $7ef244517b504261$var$loadableWithValue$3(value);
            return value;
        }).catch((error)=>{
            defaultLoadable = $7ef244517b504261$var$loadableWithError$2(error);
            throw error;
        }));
    }
    let defaultLoadable = $7ef244517b504261$var$Recoil_isPromise(options.default) ? unwrapPromise(options.default) : $7ef244517b504261$var$isLoadable$2(options.default) ? options.default.state === "loading" ? unwrapPromise(options.default.contents) : options.default : $7ef244517b504261$var$loadableWithValue$3($7ef244517b504261$var$unwrap(options.default));
    maybeFreezeValueOrPromise(defaultLoadable.contents);
    let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
    // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>
    const cleanupEffectsByStore = new Map();
    function maybeFreezeValueOrPromise(valueOrPromise) {
        if (options.dangerouslyAllowMutability !== true) {
            if ($7ef244517b504261$var$Recoil_isPromise(valueOrPromise)) return valueOrPromise.then((value)=>{
                $7ef244517b504261$var$Recoil_deepFreezeValue(value);
                return value;
            });
            else {
                $7ef244517b504261$var$Recoil_deepFreezeValue(valueOrPromise);
                return valueOrPromise;
            }
        }
        return valueOrPromise;
    }
    function wrapPendingPromise(store, promise) {
        const wrappedPromise = promise.then((value)=>{
            var _store$getState$nextT, _state$atomValues$get;
            const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;
            if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) $7ef244517b504261$var$setRecoilValue$4(store, node, value);
            return value;
        }).catch((error)=>{
            var _store$getState$nextT2, _state$atomValues$get2;
            const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;
            if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) $7ef244517b504261$var$setRecoilValueLoadable$2(store, node, $7ef244517b504261$var$loadableWithError$2(error));
            throw error;
        });
        return wrappedPromise;
    }
    function initAtom(store, initState, trigger) {
        var _options$effects;
        liveStoresCount++;
        const cleanupAtom = ()=>{
            var _cleanupEffectsByStor;
            liveStoresCount--;
            (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 || _cleanupEffectsByStor.forEach((cleanup)=>cleanup());
            cleanupEffectsByStore.delete(store);
        };
        store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve
        if (defaultLoadable.state === "loading") {
            const notifyDefaultSubscribers = ()=>{
                var _store$getState$nextT3;
                const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;
                if (!state.atomValues.has(key)) $7ef244517b504261$var$markRecoilValueModified$2(store, node);
            };
            defaultLoadable.contents.finally(notifyDefaultSubscribers);
        } ///////////////////
        // Run Atom Effects
        ///////////////////
        const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;
        if (effects != null) {
            // This state is scoped by Store, since this is in the initAtom() closure
            let initValue = $7ef244517b504261$var$DEFAULT_VALUE$7;
            let isDuringInit = true;
            let isInitError = false;
            let pendingSetSelf = null;
            function getLoadable(recoilValue) {
                // Normally we can just get the current value of another atom.
                // But for our own value we need to check if there is a pending
                // initialized value or get the fallback default value.
                if (isDuringInit && recoilValue.key === key) {
                    // Cast T to S
                    const retValue = initValue; // flowlint-line unclear-type:off
                    return retValue instanceof $7ef244517b504261$var$DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
                     : $7ef244517b504261$var$Recoil_isPromise(retValue) ? $7ef244517b504261$var$loadableWithPromise$2(retValue.then((v)=>v instanceof $7ef244517b504261$var$DefaultValue$2 ? defaultLoadable.toPromise() // flowlint-line unclear-type:off
                         : v)) : $7ef244517b504261$var$loadableWithValue$3(retValue);
                }
                return $7ef244517b504261$var$getRecoilValueAsLoadable$4(store, recoilValue);
            }
            function getPromise(recoilValue) {
                return getLoadable(recoilValue).toPromise();
            }
            function getInfo_UNSTABLE(recoilValue) {
                var _store$getState$nextT4;
                const info = $7ef244517b504261$var$peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
                return isDuringInit && recoilValue.key === key && !(initValue instanceof $7ef244517b504261$var$DefaultValue$2) ? {
                    ...info,
                    isSet: true,
                    loadable: getLoadable(recoilValue)
                } : info;
            }
            const setSelf = (effect)=>(valueOrUpdater)=>{
                    if (isDuringInit) {
                        const currentLoadable = getLoadable(node);
                        const currentValue = currentLoadable.state === "hasValue" ? currentLoadable.contents : $7ef244517b504261$var$DEFAULT_VALUE$7;
                        initValue = typeof valueOrUpdater === "function" ? valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                         : valueOrUpdater;
                        if ($7ef244517b504261$var$Recoil_isPromise(initValue)) initValue = initValue.then((value)=>{
                            // Avoid calling onSet() when setSelf() initializes with a Promise
                            pendingSetSelf = {
                                effect: effect,
                                value: value
                            };
                            return value;
                        });
                    } else {
                        if ($7ef244517b504261$var$Recoil_isPromise(valueOrUpdater)) throw $7ef244517b504261$var$Recoil_err("Setting atoms to async values is not implemented.");
                        if (typeof valueOrUpdater !== "function") pendingSetSelf = {
                            effect: effect,
                            value: $7ef244517b504261$var$unwrap(valueOrUpdater)
                        };
                        $7ef244517b504261$var$setRecoilValue$4(store, node, typeof valueOrUpdater === "function" ? (currentValue)=>{
                            const newValue = $7ef244517b504261$var$unwrap(valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                            ); // $FlowFixMe[incompatible-type]
                            pendingSetSelf = {
                                effect: effect,
                                value: newValue
                            };
                            return newValue;
                        } : $7ef244517b504261$var$unwrap(valueOrUpdater));
                    }
                };
            const resetSelf = (effect)=>()=>setSelf(effect)($7ef244517b504261$var$DEFAULT_VALUE$7);
            const onSet = (effect)=>(handler)=>{
                    var _cleanupEffectsByStor2;
                    const { release: release  } = store.subscribeToTransactions((currentStore)=>{
                        var _currentTree$atomValu;
                        // eslint-disable-next-line prefer-const
                        let { currentTree: currentTree , previousTree: previousTree  } = currentStore.getState();
                        if (!previousTree) {
                            $7ef244517b504261$var$Recoil_recoverableViolation("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil");
                            previousTree = currentTree; // attempt to trundle on
                        }
                        const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;
                        if (newLoadable.state === "hasValue") {
                            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;
                            const newValue = newLoadable.contents;
                            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
                            const oldValue = oldLoadable.state === "hasValue" ? oldLoadable.contents : $7ef244517b504261$var$DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
                            // Ignore atom value changes that were set via setSelf() in the same effect.
                            // We will still properly call the handler if there was a subsequent
                            // set from something other than an atom effect which was batched
                            // with the `setSelf()` call.  However, we may incorrectly ignore
                            // the handler if the subsequent batched call happens to set the
                            // atom to the exact same value as the `setSelf()`.   But, in that
                            // case, it was kind of a noop, so the semantics are debatable..
                            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) handler(newValue, oldValue, !currentTree.atomValues.has(key));
                            else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) pendingSetSelf = null;
                        }
                    }, key);
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : [],
                        release
                    ]);
                };
            for (const effect of effects)try {
                const cleanup = effect({
                    node: node,
                    storeID: store.storeID,
                    parentStoreID_UNSTABLE: store.parentStoreID,
                    trigger: trigger,
                    setSelf: setSelf(effect),
                    resetSelf: resetSelf(effect),
                    onSet: onSet(effect),
                    getPromise: getPromise,
                    getLoadable: getLoadable,
                    getInfo_UNSTABLE: getInfo_UNSTABLE
                });
                if (cleanup != null) {
                    var _cleanupEffectsByStor3;
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : [],
                        cleanup
                    ]);
                }
            } catch (error) {
                initValue = error;
                isInitError = true;
            }
            isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
            // since we are the ones initializing on first use.
            if (!(initValue instanceof $7ef244517b504261$var$DefaultValue$2)) {
                var _store$getState$nextT5;
                const initLoadable = isInitError ? $7ef244517b504261$var$loadableWithError$2(initValue) : $7ef244517b504261$var$Recoil_isPromise(initValue) ? $7ef244517b504261$var$loadableWithPromise$2(wrapPendingPromise(store, initValue)) : $7ef244517b504261$var$loadableWithValue$3($7ef244517b504261$var$unwrap(initValue));
                maybeFreezeValueOrPromise(initLoadable.contents);
                initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
                // This could happen if the atom was first initialized in an action that
                // also updated some other atom's state.
                (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 || _store$getState$nextT5.atomValues.set(key, initLoadable);
            }
        }
        return cleanupAtom;
    }
    function peekAtom(_store, state) {
        var _ref, _state$atomValues$get3;
        return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
    }
    function getAtom(_store, state) {
        if (state.atomValues.has(key)) // Atom value is stored in state:
        return $7ef244517b504261$var$Recoil_nullthrows(state.atomValues.get(key));
        else if (state.nonvalidatedAtoms.has(key)) {
            // Atom value is stored but needs validation before use.
            // We might have already validated it and have a cached validated value:
            if (cachedAnswerForUnvalidatedValue != null) return cachedAnswerForUnvalidatedValue;
            if (persistence == null) {
                $7ef244517b504261$var$Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
                return defaultLoadable;
            }
            const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
            const validatorResult = persistence.validator(nonvalidatedValue, $7ef244517b504261$var$DEFAULT_VALUE$7);
            const validatedValueLoadable = validatorResult instanceof $7ef244517b504261$var$DefaultValue$2 ? defaultLoadable : $7ef244517b504261$var$loadableWithValue$3(validatorResult);
            cachedAnswerForUnvalidatedValue = validatedValueLoadable;
            return cachedAnswerForUnvalidatedValue;
        } else return defaultLoadable;
    }
    function invalidateAtom() {
        cachedAnswerForUnvalidatedValue = undefined;
    }
    function setAtom(_store, state, newValue) {
        // Bail out if we're being set to the existing value, or if we're being
        // reset but have no stored value (validated or unvalidated) to reset from:
        if (state.atomValues.has(key)) {
            const existing = $7ef244517b504261$var$Recoil_nullthrows(state.atomValues.get(key));
            if (existing.state === "hasValue" && newValue === existing.contents) return new Map();
        } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof $7ef244517b504261$var$DefaultValue$2) return new Map();
        maybeFreezeValueOrPromise(newValue);
        cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use
        return new Map().set(key, $7ef244517b504261$var$loadableWithValue$3(newValue));
    }
    function shouldDeleteConfigOnReleaseAtom() {
        return $7ef244517b504261$var$getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
    }
    const node = $7ef244517b504261$var$registerNode$2({
        key: key,
        nodeType: "atom",
        peek: peekAtom,
        get: getAtom,
        set: setAtom,
        init: initAtom,
        invalidate: invalidateAtom,
        shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        persistence_UNSTABLE: options.persistence_UNSTABLE ? {
            type: options.persistence_UNSTABLE.type,
            backButton: options.persistence_UNSTABLE.backButton
        } : undefined,
        shouldRestoreFromSnapshots: true,
        retainedBy: retainedBy
    });
    return node;
} // prettier-ignore
function $7ef244517b504261$var$atom(options) {
    if (typeof options.key !== "string") throw $7ef244517b504261$var$Recoil_err("A key option with a unique string value must be provided when creating an atom.");
    const { ...restOptions } = options;
    const optionsDefault = "default" in options ? options.default : new Promise(()=>{});
    if ($7ef244517b504261$var$isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
    ) return $7ef244517b504261$var$atomWithFallback({
        ...restOptions,
        default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    else return $7ef244517b504261$var$baseAtom({
        ...restOptions,
        default: optionsDefault
    });
}
function $7ef244517b504261$var$atomWithFallback(options) {
    const base = $7ef244517b504261$var$atom({
        ...options,
        default: $7ef244517b504261$var$DEFAULT_VALUE$7,
        persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : {
            ...options.persistence_UNSTABLE,
            validator: (storedValue)=>storedValue instanceof $7ef244517b504261$var$DefaultValue$2 ? storedValue : $7ef244517b504261$var$Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, $7ef244517b504261$var$DEFAULT_VALUE$7)
        },
        // TODO Hack for now.
        effects: options.effects,
        // flowlint-line unclear-type: off
        effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off
    }); // $FlowFixMe[incompatible-call]
    const sel = $7ef244517b504261$var$Recoil_selector({
        key: `${options.key}__withFallback`,
        get: ({ get: get  })=>{
            const baseValue = get(base);
            return baseValue instanceof $7ef244517b504261$var$DefaultValue$2 ? options.default : baseValue;
        },
        // $FlowFixMe[incompatible-call]
        set: ({ set: set  }, newValue)=>set(base, newValue),
        // This selector does not need to cache as it is a wrapper selector
        // and the selector within the wrapper selector will have a cache
        // option by default
        cachePolicy_UNSTABLE: {
            eviction: "most-recent"
        },
        dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });
    $7ef244517b504261$var$setConfigDeletionHandler$1(sel.key, $7ef244517b504261$var$getConfigDeletionHandler$2(options.key));
    return sel;
} // $FlowFixMe[missing-local-annot]
$7ef244517b504261$var$atom.value = (value)=>new $7ef244517b504261$var$WrappedValue$2(value);
var $7ef244517b504261$var$Recoil_atom = $7ef244517b504261$var$atom;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $7ef244517b504261$var$MapCache {
    constructor(options){
        var _options$mapKey;
        $7ef244517b504261$var$_defineProperty(this, "_map", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_keyMapper", void 0);
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    size() {
        return this._map.size;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        return this._map.get(this._keyMapper(key));
    }
    set(key, val) {
        this._map.set(this._keyMapper(key), val);
    }
    delete(key) {
        this._map.delete(this._keyMapper(key));
    }
    clear() {
        this._map.clear();
    }
}
var $7ef244517b504261$var$Recoil_MapCache = {
    MapCache: $7ef244517b504261$var$MapCache
};
var $7ef244517b504261$var$Recoil_MapCache_1 = $7ef244517b504261$var$Recoil_MapCache.MapCache;
var $7ef244517b504261$var$Recoil_MapCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MapCache: $7ef244517b504261$var$Recoil_MapCache_1
});
const { LRUCache: $7ef244517b504261$var$LRUCache$2  } = $7ef244517b504261$var$Recoil_LRUCache$1;
const { MapCache: $7ef244517b504261$var$MapCache$1  } = $7ef244517b504261$var$Recoil_MapCache$1;
const $7ef244517b504261$var$defaultPolicy$1 = {
    equality: "reference",
    eviction: "none",
    maxSize: Infinity
};
function $7ef244517b504261$var$cacheFromPolicy({ equality: equality = $7ef244517b504261$var$defaultPolicy$1.equality , eviction: eviction = $7ef244517b504261$var$defaultPolicy$1.eviction , maxSize: maxSize = $7ef244517b504261$var$defaultPolicy$1.maxSize  } = $7ef244517b504261$var$defaultPolicy$1) {
    const valueMapper = $7ef244517b504261$var$getValueMapper$1(equality);
    const cache = $7ef244517b504261$var$getCache(eviction, maxSize, valueMapper);
    return cache;
}
function $7ef244517b504261$var$getValueMapper$1(equality) {
    switch(equality){
        case "reference":
            return (val)=>val;
        case "value":
            return (val)=>$7ef244517b504261$var$Recoil_stableStringify(val);
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized equality policy ${equality}`);
}
function $7ef244517b504261$var$getCache(eviction, maxSize, mapKey) {
    switch(eviction){
        case "keep-all":
            return new $7ef244517b504261$var$MapCache$1({
                mapKey: mapKey
            });
        case "lru":
            return new $7ef244517b504261$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: $7ef244517b504261$var$Recoil_nullthrows(maxSize)
            });
        case "most-recent":
            return new $7ef244517b504261$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: 1
            });
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var $7ef244517b504261$var$Recoil_cacheFromPolicy = $7ef244517b504261$var$cacheFromPolicy;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
const { setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler$2  } = $7ef244517b504261$var$Recoil_Node;
// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }
/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/ function $7ef244517b504261$var$atomFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const atomCache = $7ef244517b504261$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
        eviction: "keep-all"
    }); // Simple atomFamily implementation to cache individual atoms based
    // on the parameter value equality.
    return (params)=>{
        var _stableStringify, _options$effects;
        const cachedAtom = atomCache.get(params);
        if (cachedAtom != null) return cachedAtom;
        const { cachePolicyForParams_UNSTABLE: cachePolicyForParams_UNSTABLE , ...atomOptions } = options;
        const optionsDefault = "default" in options ? options.default : new Promise(()=>{});
        const newAtom = $7ef244517b504261$var$Recoil_atom({
            ...atomOptions,
            key: `${options.key}__${(_stableStringify = $7ef244517b504261$var$Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}`,
            default: typeof optionsDefault === "function" ? // Flow doesn't know that T isn't a function, so we need to case to any
            // $FlowIssue[incompatible-use]
            optionsDefault(params) : optionsDefault,
            retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
            effects: typeof options.effects === "function" ? options.effects(params) : typeof options.effects_UNSTABLE === "function" ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
        });
        atomCache.set(params, newAtom);
        $7ef244517b504261$var$setConfigDeletionHandler$2(newAtom.key, ()=>{
            atomCache.delete(params);
        });
        return newAtom;
    };
}
var $7ef244517b504261$var$Recoil_atomFamily = $7ef244517b504261$var$atomFamily;
const { setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler$3  } = $7ef244517b504261$var$Recoil_Node;
// Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify
// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let $7ef244517b504261$var$nextIndex = 0;
/* eslint-disable no-redeclare */ // Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function $7ef244517b504261$var$selectorFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const selectorCache = $7ef244517b504261$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
        eviction: "keep-all"
    });
    return (params)=>{
        var _stableStringify;
        // Throw an error with selector key so that it is clear which
        // selector is causing an error
        let cachedSelector;
        try {
            cachedSelector = selectorCache.get(params);
        } catch (error) {
            throw $7ef244517b504261$var$Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
        }
        if (cachedSelector != null) return cachedSelector;
        const myKey = `${options.key}__selectorFamily/${(_stableStringify = $7ef244517b504261$var$Recoil_stableStringify(params, {
            // It is possible to use functions in parameters if the user uses
            // a cache with reference equality thanks to the incrementing index.
            allowFunctions: true
        })) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}/${$7ef244517b504261$var$nextIndex++}`; // Append index in case values serialize to the same key string
        const myGet = (callbacks)=>options.get(params)(callbacks);
        const myCachePolicy = options.cachePolicy_UNSTABLE;
        const retainedBy = typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
        let newSelector;
        if (options.set != null) {
            const set = options.set;
            const mySet = (callbacks, newValue)=>set(params)(callbacks, newValue);
            newSelector = $7ef244517b504261$var$Recoil_selector({
                key: myKey,
                get: myGet,
                set: mySet,
                cachePolicy_UNSTABLE: myCachePolicy,
                dangerouslyAllowMutability: options.dangerouslyAllowMutability,
                retainedBy_UNSTABLE: retainedBy
            });
        } else newSelector = $7ef244517b504261$var$Recoil_selector({
            key: myKey,
            get: myGet,
            cachePolicy_UNSTABLE: myCachePolicy,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            retainedBy_UNSTABLE: retainedBy
        });
        selectorCache.set(params, newSelector);
        $7ef244517b504261$var$setConfigDeletionHandler$3(newSelector.key, ()=>{
            selectorCache.delete(params);
        });
        return newSelector;
    };
}
/* eslint-enable no-redeclare */ var $7ef244517b504261$var$Recoil_selectorFamily = $7ef244517b504261$var$selectorFamily;
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$constantSelector = $7ef244517b504261$var$Recoil_selectorFamily({
    key: "__constant",
    get: (constant)=>()=>constant,
    cachePolicyForParams_UNSTABLE: {
        equality: "reference"
    }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.
function $7ef244517b504261$var$constSelector(constant) {
    return $7ef244517b504261$var$constantSelector(constant);
}
var $7ef244517b504261$var$Recoil_constSelector = $7ef244517b504261$var$constSelector;
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$throwingSelector = $7ef244517b504261$var$Recoil_selectorFamily({
    key: "__error",
    get: (message)=>()=>{
            throw $7ef244517b504261$var$Recoil_err(message);
        },
    // TODO Why?
    cachePolicyForParams_UNSTABLE: {
        equality: "reference"
    }
}); // Function that returns a selector which always throws an error
// with the provided message.
function $7ef244517b504261$var$errorSelector(message) {
    return $7ef244517b504261$var$throwingSelector(message);
}
var $7ef244517b504261$var$Recoil_errorSelector = $7ef244517b504261$var$errorSelector;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$readOnlySelector(atom) {
    // flowlint-next-line unclear-type: off
    return atom;
}
var $7ef244517b504261$var$Recoil_readOnlySelector = $7ef244517b504261$var$readOnlySelector;
const { loadableWithError: $7ef244517b504261$var$loadableWithError$3 , loadableWithPromise: $7ef244517b504261$var$loadableWithPromise$3 , loadableWithValue: $7ef244517b504261$var$loadableWithValue$4  } = $7ef244517b504261$var$Recoil_Loadable$1;
/////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.
function $7ef244517b504261$var$concurrentRequests(getRecoilValue, deps) {
    const results = Array(deps.length).fill(undefined);
    const exceptions = Array(deps.length).fill(undefined);
    for (const [i, dep] of deps.entries())try {
        results[i] = getRecoilValue(dep);
    } catch (e) {
        // exceptions can either be Promises of pending results or real errors
        exceptions[i] = e;
    }
    return [
        results,
        exceptions
    ];
}
function $7ef244517b504261$var$isError(exp) {
    return exp != null && !$7ef244517b504261$var$Recoil_isPromise(exp);
}
function $7ef244517b504261$var$unwrapDependencies(dependencies) {
    return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map((key)=>dependencies[key]);
}
function $7ef244517b504261$var$wrapResults(dependencies, /* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */ results) {
    return Array.isArray(dependencies) ? results : Object.getOwnPropertyNames(dependencies).reduce((out, key, idx)=>({
            ...out,
            [key]: results[idx]
        }), {});
}
function $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions) {
    const output = exceptions.map((exception, idx)=>exception == null ? $7ef244517b504261$var$loadableWithValue$4(results[idx]) : $7ef244517b504261$var$Recoil_isPromise(exception) ? $7ef244517b504261$var$loadableWithPromise$3(exception) : $7ef244517b504261$var$loadableWithError$3(exception));
    return $7ef244517b504261$var$wrapResults(dependencies, output);
}
function $7ef244517b504261$var$combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
    return asyncResults.map((result, idx)=>/**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */ result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.
const $7ef244517b504261$var$waitForNone = $7ef244517b504261$var$Recoil_selectorFamily({
    key: "__waitForNone",
    get: (dependencies)=>({ get: get  })=>{
            // Issue requests for all dependencies in parallel.
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // Always return the current status of the results; never block.
            return $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions);
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.
const $7ef244517b504261$var$waitForAny = $7ef244517b504261$var$Recoil_selectorFamily({
    key: "__waitForAny",
    get: (dependencies)=>({ get: get  })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // If any results are available, value or error, return the current status
            if (exceptions.some((exp)=>!$7ef244517b504261$var$Recoil_isPromise(exp))) return $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions);
             // Otherwise, return a promise that will resolve when the next result is
            // available, whichever one happens to be next.  But, if all pending
            // dependencies end up with errors, then reject the promise.
            return new Promise((resolve)=>{
                for (const [i, exp] of exceptions.entries())if ($7ef244517b504261$var$Recoil_isPromise(exp)) exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                    resolve($7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions));
                }).catch((error)=>{
                    exceptions[i] = error;
                    resolve($7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions));
                });
            });
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.
const $7ef244517b504261$var$waitForAll = $7ef244517b504261$var$Recoil_selectorFamily({
    key: "__waitForAll",
    get: (dependencies)=>({ get: get  })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>exp == null)) return $7ef244517b504261$var$wrapResults(dependencies, results);
             // If we have any errors, throw the first error
            const error = exceptions.find($7ef244517b504261$var$isError);
            if (error != null) throw error;
             // Otherwise, return a promise that will resolve when all results are available
            return Promise.all(exceptions).then((exceptionResults)=>$7ef244517b504261$var$wrapResults(dependencies, $7ef244517b504261$var$combineAsyncResultsWithSyncResults(results, exceptionResults)));
        },
    dangerouslyAllowMutability: true
});
const $7ef244517b504261$var$waitForAllSettled = $7ef244517b504261$var$Recoil_selectorFamily({
    key: "__waitForAllSettled",
    get: (dependencies)=>({ get: get  })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>!$7ef244517b504261$var$Recoil_isPromise(exp))) return $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions);
             // Wait for all results to settle
            return Promise.all(exceptions.map((exp, i)=>$7ef244517b504261$var$Recoil_isPromise(exp) ? exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                }).catch((error)=>{
                    results[i] = undefined;
                    exceptions[i] = error;
                }) : null)) // Then wrap them as loadables
            .then(()=>$7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions));
        },
    dangerouslyAllowMutability: true
});
const $7ef244517b504261$var$noWait = $7ef244517b504261$var$Recoil_selectorFamily({
    key: "__noWait",
    get: (dependency)=>({ get: get  })=>{
            try {
                return $7ef244517b504261$var$Recoil_selector.value($7ef244517b504261$var$loadableWithValue$4(get(dependency)));
            } catch (exception) {
                return $7ef244517b504261$var$Recoil_selector.value($7ef244517b504261$var$Recoil_isPromise(exception) ? $7ef244517b504261$var$loadableWithPromise$3(exception) : $7ef244517b504261$var$loadableWithError$3(exception));
            }
        },
    dangerouslyAllowMutability: true
});
var $7ef244517b504261$var$Recoil_WaitFor = {
    waitForNone: $7ef244517b504261$var$waitForNone,
    waitForAny: $7ef244517b504261$var$waitForAny,
    waitForAll: $7ef244517b504261$var$waitForAll,
    waitForAllSettled: $7ef244517b504261$var$waitForAllSettled,
    noWait: $7ef244517b504261$var$noWait
};
const { RecoilLoadable: $7ef244517b504261$var$RecoilLoadable  } = $7ef244517b504261$var$Recoil_Loadable$1;
const { DefaultValue: $7ef244517b504261$var$DefaultValue$3  } = $7ef244517b504261$var$Recoil_Node;
const { RecoilRoot: $7ef244517b504261$var$RecoilRoot$2 , useRecoilStoreID: $7ef244517b504261$var$useRecoilStoreID$1  } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$5  } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { retentionZone: $7ef244517b504261$var$retentionZone$1  } = $7ef244517b504261$var$Recoil_RetentionZone;
const { freshSnapshot: $7ef244517b504261$var$freshSnapshot$2  } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { useRecoilState: $7ef244517b504261$var$useRecoilState$1 , useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1 , useRecoilStateLoadable: $7ef244517b504261$var$useRecoilStateLoadable$1 , useRecoilValue: $7ef244517b504261$var$useRecoilValue$1 , useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1 , useRecoilValueLoadable: $7ef244517b504261$var$useRecoilValueLoadable$1 , useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1 , useResetRecoilState: $7ef244517b504261$var$useResetRecoilState$1 , useSetRecoilState: $7ef244517b504261$var$useSetRecoilState$1  } = $7ef244517b504261$var$Recoil_Hooks;
const { useGotoRecoilSnapshot: $7ef244517b504261$var$useGotoRecoilSnapshot$1 , useRecoilSnapshot: $7ef244517b504261$var$useRecoilSnapshot$1 , useRecoilTransactionObserver: $7ef244517b504261$var$useRecoilTransactionObserver$1  } = $7ef244517b504261$var$Recoil_SnapshotHooks;
const { useRecoilCallback: $7ef244517b504261$var$useRecoilCallback$1  } = $7ef244517b504261$var$Recoil_useRecoilCallback;
const { noWait: $7ef244517b504261$var$noWait$1 , waitForAll: $7ef244517b504261$var$waitForAll$1 , waitForAllSettled: $7ef244517b504261$var$waitForAllSettled$1 , waitForAny: $7ef244517b504261$var$waitForAny$1 , waitForNone: $7ef244517b504261$var$waitForNone$1  } = $7ef244517b504261$var$Recoil_WaitFor;
var $7ef244517b504261$var$Recoil_index = {
    // Types
    DefaultValue: $7ef244517b504261$var$DefaultValue$3,
    isRecoilValue: $7ef244517b504261$var$isRecoilValue$5,
    RecoilLoadable: $7ef244517b504261$var$RecoilLoadable,
    // Global Recoil environment settiongs
    RecoilEnv: $7ef244517b504261$var$Recoil_RecoilEnv,
    // Recoil Root
    RecoilRoot: $7ef244517b504261$var$RecoilRoot$2,
    useRecoilStoreID: $7ef244517b504261$var$useRecoilStoreID$1,
    useRecoilBridgeAcrossReactRoots_UNSTABLE: $7ef244517b504261$var$Recoil_useRecoilBridgeAcrossReactRoots,
    // Atoms/Selectors
    atom: $7ef244517b504261$var$Recoil_atom,
    selector: $7ef244517b504261$var$Recoil_selector,
    // Convenience Atoms/Selectors
    atomFamily: $7ef244517b504261$var$Recoil_atomFamily,
    selectorFamily: $7ef244517b504261$var$Recoil_selectorFamily,
    constSelector: $7ef244517b504261$var$Recoil_constSelector,
    errorSelector: $7ef244517b504261$var$Recoil_errorSelector,
    readOnlySelector: $7ef244517b504261$var$Recoil_readOnlySelector,
    // Concurrency Helpers for Atoms/Selectors
    noWait: $7ef244517b504261$var$noWait$1,
    waitForNone: $7ef244517b504261$var$waitForNone$1,
    waitForAny: $7ef244517b504261$var$waitForAny$1,
    waitForAll: $7ef244517b504261$var$waitForAll$1,
    waitForAllSettled: $7ef244517b504261$var$waitForAllSettled$1,
    // Hooks for Atoms/Selectors
    useRecoilValue: $7ef244517b504261$var$useRecoilValue$1,
    useRecoilValueLoadable: $7ef244517b504261$var$useRecoilValueLoadable$1,
    useRecoilState: $7ef244517b504261$var$useRecoilState$1,
    useRecoilStateLoadable: $7ef244517b504261$var$useRecoilStateLoadable$1,
    useSetRecoilState: $7ef244517b504261$var$useSetRecoilState$1,
    useResetRecoilState: $7ef244517b504261$var$useResetRecoilState$1,
    useGetRecoilValueInfo_UNSTABLE: $7ef244517b504261$var$Recoil_useGetRecoilValueInfo,
    useRecoilRefresher_UNSTABLE: $7ef244517b504261$var$Recoil_useRecoilRefresher,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
    // Hooks for complex operations
    useRecoilCallback: $7ef244517b504261$var$useRecoilCallback$1,
    useRecoilTransaction_UNSTABLE: $7ef244517b504261$var$Recoil_useRecoilTransaction,
    // Snapshots
    useGotoRecoilSnapshot: $7ef244517b504261$var$useGotoRecoilSnapshot$1,
    useRecoilSnapshot: $7ef244517b504261$var$useRecoilSnapshot$1,
    useRecoilTransactionObserver_UNSTABLE: $7ef244517b504261$var$useRecoilTransactionObserver$1,
    snapshot_UNSTABLE: $7ef244517b504261$var$freshSnapshot$2,
    // Memory Management
    useRetain: $7ef244517b504261$var$Recoil_useRetain,
    retentionZone: $7ef244517b504261$var$retentionZone$1
};
var $7ef244517b504261$export$a4e369a19907695d = $7ef244517b504261$var$Recoil_index.DefaultValue;
var $7ef244517b504261$export$8e2120adc095590f = $7ef244517b504261$var$Recoil_index.isRecoilValue;
var $7ef244517b504261$export$b04cb8d38132ba6e = $7ef244517b504261$var$Recoil_index.RecoilLoadable;
var $7ef244517b504261$export$b6bd5219181c222b = $7ef244517b504261$var$Recoil_index.RecoilEnv;
var $7ef244517b504261$export$f72b9f9819639629 = $7ef244517b504261$var$Recoil_index.RecoilRoot;
var $7ef244517b504261$export$cb8baa5ebbbeec81 = $7ef244517b504261$var$Recoil_index.useRecoilStoreID;
var $7ef244517b504261$export$a42d8cff2ac8d9e5 = $7ef244517b504261$var$Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var $7ef244517b504261$export$5fb5cc0d078610b = $7ef244517b504261$var$Recoil_index.atom;
var $7ef244517b504261$export$aea217a45095ce11 = $7ef244517b504261$var$Recoil_index.selector;
var $7ef244517b504261$export$98dc87c59e005bfc = $7ef244517b504261$var$Recoil_index.atomFamily;
var $7ef244517b504261$export$62317b671b80c71d = $7ef244517b504261$var$Recoil_index.selectorFamily;
var $7ef244517b504261$export$18e41ac5fdf5533e = $7ef244517b504261$var$Recoil_index.constSelector;
var $7ef244517b504261$export$47aec13333381be0 = $7ef244517b504261$var$Recoil_index.errorSelector;
var $7ef244517b504261$export$11880e5adc5def9 = $7ef244517b504261$var$Recoil_index.readOnlySelector;
var $7ef244517b504261$export$ab07e6aa23cd7e90 = $7ef244517b504261$var$Recoil_index.noWait;
var $7ef244517b504261$export$5c93b0ea2ae8f20b = $7ef244517b504261$var$Recoil_index.waitForNone;
var $7ef244517b504261$export$9ee161e2f87911b5 = $7ef244517b504261$var$Recoil_index.waitForAny;
var $7ef244517b504261$export$4dcf1964c6471cb6 = $7ef244517b504261$var$Recoil_index.waitForAll;
var $7ef244517b504261$export$a82851251af05082 = $7ef244517b504261$var$Recoil_index.waitForAllSettled;
var $7ef244517b504261$export$8b71bf98365f8042 = $7ef244517b504261$var$Recoil_index.useRecoilValue;
var $7ef244517b504261$export$23331814aa7f2650 = $7ef244517b504261$var$Recoil_index.useRecoilValueLoadable;
var $7ef244517b504261$export$12012bbeae92bfa2 = $7ef244517b504261$var$Recoil_index.useRecoilState;
var $7ef244517b504261$export$223ac8c28103fd98 = $7ef244517b504261$var$Recoil_index.useRecoilStateLoadable;
var $7ef244517b504261$export$4102102216e95cfa = $7ef244517b504261$var$Recoil_index.useSetRecoilState;
var $7ef244517b504261$export$75b418d01f19b2e = $7ef244517b504261$var$Recoil_index.useResetRecoilState;
var $7ef244517b504261$export$24dc7ee2767b2f1c = $7ef244517b504261$var$Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var $7ef244517b504261$export$3726f445fa0ad4a7 = $7ef244517b504261$var$Recoil_index.useRecoilRefresher_UNSTABLE;
var $7ef244517b504261$export$c6e9c47eec22eb86 = $7ef244517b504261$var$Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var $7ef244517b504261$export$435b1bf0f9f79a38 = $7ef244517b504261$var$Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var $7ef244517b504261$export$2df379f232d6fe77 = $7ef244517b504261$var$Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var $7ef244517b504261$export$6ef5088871c318c5 = $7ef244517b504261$var$Recoil_index.useRecoilCallback;
var $7ef244517b504261$export$4a76cc788f949bc4 = $7ef244517b504261$var$Recoil_index.useRecoilTransaction_UNSTABLE;
var $7ef244517b504261$export$a7cf2c8ce398f17a = $7ef244517b504261$var$Recoil_index.useGotoRecoilSnapshot;
var $7ef244517b504261$export$7cc4a4decba383e9 = $7ef244517b504261$var$Recoil_index.useRecoilSnapshot;
var $7ef244517b504261$export$924c13ee4d1c0013 = $7ef244517b504261$var$Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var $7ef244517b504261$export$fe4c07befea3edfb = $7ef244517b504261$var$Recoil_index.snapshot_UNSTABLE;
var $7ef244517b504261$export$f9d5dc8f5133b7e8 = $7ef244517b504261$var$Recoil_index.useRetain;
var $7ef244517b504261$export$33ebb0dc02dfd75d = $7ef244517b504261$var$Recoil_index.retentionZone;
var $7ef244517b504261$export$2e2bcd8739ae039 = $7ef244517b504261$var$Recoil_index;


var $4f76ed508686472d$exports = {};
"use strict";
Object.defineProperty($4f76ed508686472d$exports, "__esModule", {
    value: true
});
$4f76ed508686472d$exports.resetRecoil = $4f76ed508686472d$exports.setRecoil = $4f76ed508686472d$exports.getRecoilPromise = $4f76ed508686472d$exports.getRecoil = void 0;

var $4f76ed508686472d$var$nexus = {};
function $4f76ed508686472d$var$RecoilNexus() {
    $4f76ed508686472d$var$nexus.get = (0, $7ef244517b504261$export$6ef5088871c318c5)(function(_a) {
        var snapshot = _a.snapshot;
        return function(atom) {
            return snapshot.getLoadable(atom).contents;
        };
    }, []);
    $4f76ed508686472d$var$nexus.getPromise = (0, $7ef244517b504261$export$6ef5088871c318c5)(function(_a) {
        var snapshot = _a.snapshot;
        return function(atom) {
            return snapshot.getPromise(atom);
        };
    }, []);
    $4f76ed508686472d$var$nexus.set = (0, $7ef244517b504261$export$6ef5088871c318c5)(function(_a) {
        var transact_UNSTABLE = _a.transact_UNSTABLE;
        return function(atom, valOrUpdater) {
            transact_UNSTABLE(function(_a) {
                var set = _a.set;
                set(atom, valOrUpdater);
            });
        };
    }, []);
    $4f76ed508686472d$var$nexus.reset = (0, $7ef244517b504261$export$6ef5088871c318c5)(function(_a) {
        var reset = _a.reset;
        return reset;
    }, []);
    return null;
}
$4f76ed508686472d$exports.default = $4f76ed508686472d$var$RecoilNexus;
function $4f76ed508686472d$var$getRecoil(atom) {
    return $4f76ed508686472d$var$nexus.get(atom);
}
$4f76ed508686472d$exports.getRecoil = $4f76ed508686472d$var$getRecoil;
function $4f76ed508686472d$var$getRecoilPromise(atom) {
    return $4f76ed508686472d$var$nexus.getPromise(atom);
}
$4f76ed508686472d$exports.getRecoilPromise = $4f76ed508686472d$var$getRecoilPromise;
function $4f76ed508686472d$var$setRecoil(atom, valOrUpdater) {
    $4f76ed508686472d$var$nexus.set(atom, valOrUpdater);
}
$4f76ed508686472d$exports.setRecoil = $4f76ed508686472d$var$setRecoil;
function $4f76ed508686472d$var$resetRecoil(atom) {
    $4f76ed508686472d$var$nexus.reset(atom);
}
$4f76ed508686472d$exports.resetRecoil = $4f76ed508686472d$var$resetRecoil;






const $3dc337423aed9780$export$ad23d14f88292c68 = "PvPz.io";
const $3dc337423aed9780$export$9badeb9b04b4b71c = "2.0.1-alpha";
const $3dc337423aed9780$export$d0ad00b11a82791a = $3dc337423aed9780$export$9badeb9b04b4b71c.substring(0, 1);
const $3dc337423aed9780$export$f8f753fb4aaeb8b9 = 20;
console.log("\n -- USING GAME VERSION DETAILS --");
console.log(`GAME_VERSION --> ${$3dc337423aed9780$export$9badeb9b04b4b71c}`);
console.log(`MAJOR_GAME_VERSION --> ${$3dc337423aed9780$export$d0ad00b11a82791a}\n`);


const $bc8c2d9d797d9b02$export$f34f1260dfb72f42 = (version)=>{
    return `pvpzio::${version}::`;
};
var $bc8c2d9d797d9b02$export$c02c1f4c11d08446;
(function(LSKeys) {
    LSKeys["AuthToken"] = "authToken";
    LSKeys["AnonymousUserId"] = "anonymousUserId";
    LSKeys["TermsAndPrivacyPolicyAccepted"] = "termsAndPrivacyPolicyAccepted";
    LSKeys["PromotionAccepted"] = "promotionAccepted";
})($bc8c2d9d797d9b02$export$c02c1f4c11d08446 || ($bc8c2d9d797d9b02$export$c02c1f4c11d08446 = {}));
const $bc8c2d9d797d9b02$export$3727fff6c4775dc0 = (key)=>{
    return localStorage.getItem(`${$bc8c2d9d797d9b02$export$f34f1260dfb72f42((0, $3dc337423aed9780$export$d0ad00b11a82791a))}${key}`) !== null;
};
const $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d = (key, value)=>{
    localStorage.setItem(`${$bc8c2d9d797d9b02$export$f34f1260dfb72f42((0, $3dc337423aed9780$export$d0ad00b11a82791a))}${key}`, value);
    return value;
};
const $bc8c2d9d797d9b02$export$e68c847c0bceb7d5 = (key)=>{
    const retrievedFromStore = localStorage.getItem(`${$bc8c2d9d797d9b02$export$f34f1260dfb72f42((0, $3dc337423aed9780$export$d0ad00b11a82791a))}${key}`);
    return retrievedFromStore;
};
const $bc8c2d9d797d9b02$export$50b227d68205c4cc = (key, version)=>{
    const retrievedFromStore = localStorage.getItem(`${$bc8c2d9d797d9b02$export$f34f1260dfb72f42(version.toString())}${key}`);
    return retrievedFromStore;
};
const $bc8c2d9d797d9b02$export$f39d14204f621823 = (key, version)=>{
    return localStorage.removeItem(`${$bc8c2d9d797d9b02$export$f34f1260dfb72f42(version.toString())}${key}`);
};
const $bc8c2d9d797d9b02$export$34a3032bf337a702 = (key)=>{
    return localStorage.removeItem(`${$bc8c2d9d797d9b02$export$f34f1260dfb72f42((0, $3dc337423aed9780$export$d0ad00b11a82791a))}${key}`);
};


class $8ae692c0d811c501$export$30df2395274cb2d1 extends Error {
    constructor(errorMessage){
        super("AuthExpiredError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$8504b66dedabad9 extends Error {
    constructor(errorMessage){
        super("EmailAlreadyTakenError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$b808c9b500e608bb extends Error {
    constructor(errorMessage){
        super("IncorrectLoginMethodError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$338c70d50f9836d1 extends Error {
    constructor(errorMessage){
        super("EmailInvalidError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$de1c284e0d02c776 extends Error {
    constructor(errorMessage){
        super("InvalidPasswordError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$85893ee190966bc4 extends Error {
    constructor(errorMessage){
        super("EmailNotFoundError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$cde8491b20a04fb4 extends Error {
    constructor(errorMessage){
        super("UnknownAPIError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$7333e7db5e5d49a extends Error {
    constructor(errorMessage){
        super("UserNotFoundError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$d43b4070434a7c5e extends Error {
    constructor(errorMessage){
        super("AllServersFullError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$c7df658ddd676e46 extends Error {
    constructor(errorMessage){
        super("NoServersOnlineError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$1ff33a28a6321926 extends Error {
    constructor(errorMessage){
        super("AlreadyOnARunError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$7a990e7dd7005320 extends Error {
    constructor(errorMessage){
        super("UsernameAlreadyTakenError");
        this.message = errorMessage;
    }
}
class $8ae692c0d811c501$export$7dfd19b7d8eb309 extends Error {
    constructor(errorMessage){
        super("UsernameInappropriateError");
        this.message = errorMessage;
    }
}


const $5f76e53daf4e01a1$export$10dd65538540bee3 = {
    // Anonymous User
    getAnonymousUserMe: "/pvpz/anonymous-user/me",
    createAnonymousUser: "/pvpz/anonymous-user",
    registerAnonymousUserEmail: "/pvpz/anonymous-user/register-email",
    // User
    changeUsername: "/user/change-username",
    getMyUserDetails: "/pvpz/user/me",
    userLogin: "/pvpz/user/login",
    postUserChangeUsername: "/pvpz/user/change-username",
    postUserVerifyEmail: "/pvpz/user/verify-email",
    postUserAnonymousPromotion: "/pvpz/user/anonymous-promotion",
    postBuySkinWithGems: "/pvpz/xsolla/buy-skin-with-gems",
    postBuyInsuranceWithGems: "/pvpz/xsolla/buy-insurance-with-gems",
    postBuyInsuranceWithCoins: "/pvpz/xsolla/buy-insurance-with-coins",
    postGetPurchaseLinkForSKU: "/pvpz/xsolla/get-purchase-link-for-sku",
    // Either user type
    maintenanceStatus: "/pvpz/maintenance-status",
    startRun: "/pvpz/game/start-run",
    abandonRun: "/pvpz/game/abandon-run",
    updateLoadout: "/pvpz/game/update-loadout",
    updatePreferences: "/pvpz/game/update-preferences",
    insureSlot: "/pvpz/game/insure-slot",
    equipItemToSlot: "/pvpz/game/equip-item-to-slot",
    equipSkin: "/pvpz/game/equip-skin"
};


/***********************************************************/ /*                                                         */ /*          Client-Side Only Request Utilities             */ /*                                                         */ /***********************************************************/ const $155c80569fd4a71a$var$parseResponseAndThrowIfError = (response)=>{
    return response.json().then((data)=>{
        if (response.headers.has("x-smg-refreshed-token")) {
            const refreshedToken = response.headers.get("x-smg-refreshed-token");
            if (refreshedToken !== null && refreshedToken !== undefined && refreshedToken !== "" && refreshedToken.length > 0) {
                console.info("Server gave us an updated auth token! Overwriting the one in local storage");
                (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken, refreshedToken);
            }
        }
        if (response.status === 200 || response.status === 201) return data;
        else if (response.status === 404 || response.status === 409 || response.status === 400 || response.status === 401 || response.status === 403 || response.status === 500) {
            if (data.error === "TokenExpired") {
                console.error("Auth token expired!");
                throw new (0, $8ae692c0d811c501$export$30df2395274cb2d1)("Users auth token has expired!");
            } else if (data.error === "EmailAlreadyTaken") {
                console.error("Email Already Taken!");
                throw new (0, $8ae692c0d811c501$export$8504b66dedabad9)("EmailAlreadyTaken");
            } else if (data.error === "IncorrectLoginMethod") {
                console.error("Incorrect Login Method!");
                throw new (0, $8ae692c0d811c501$export$b808c9b500e608bb)("IncorrectLoginMethod");
            } else if (data.error === "EmailNotFound") {
                console.error("Email Not Found!");
                throw new (0, $8ae692c0d811c501$export$85893ee190966bc4)("EmailNotFound");
            } else if (data.error === "InvalidEmail") {
                console.error("Invalid Email!");
                throw new (0, $8ae692c0d811c501$export$338c70d50f9836d1)("InvalidEmail");
            } else if (data.error === "InvalidPassword") {
                console.error("Invalid Password!");
                throw new (0, $8ae692c0d811c501$export$de1c284e0d02c776)("InvalidPassword");
            } else if (data.error === "AllServersFull") {
                console.error("All servers are full!");
                throw new (0, $8ae692c0d811c501$export$d43b4070434a7c5e)("All servers are full! Try again later.");
            } else if (data.error === "NoServersAvailable") {
                console.error("No servers are available!");
                throw new (0, $8ae692c0d811c501$export$c7df658ddd676e46)("No servers are available! Try again later.");
            } else if (data.error === "UserNotFound" || data.error === "AnonymousUserNotFound") {
                console.error("User not found!");
                throw new (0, $8ae692c0d811c501$export$7333e7db5e5d49a)("No user found with matching ID");
            } else if (data.error === "AlreadyOnARun") {
                console.error("User is already on a run!");
                throw new (0, $8ae692c0d811c501$export$1ff33a28a6321926)("User is already on a run! Cannot start a new run until the current one is finished.");
            } else if (data.error === "UsernameAlreadyTaken") {
                console.error("Username is taken!");
                throw new (0, $8ae692c0d811c501$export$7a990e7dd7005320)("Username is unavailable!");
            } else if (data.error === "UsernameInappropriate") {
                console.error("Username is inappropriate!");
                throw new (0, $8ae692c0d811c501$export$7dfd19b7d8eb309)("Username is inappropriate!");
            } else {
                console.error("Unknown API Error!", data.error);
                throw new (0, $8ae692c0d811c501$export$cde8491b20a04fb4)("An unhandled API error has occurred");
            }
        }
    });
};
const $155c80569fd4a71a$var$getRequest = async (url, headers)=>{
    const rawResponse = await fetch(url, {
        headers: {
            ...headers
        }
    });
    return $155c80569fd4a71a$var$parseResponseAndThrowIfError(rawResponse);
};
const $155c80569fd4a71a$var$postRequest = async (url, body, headers)=>{
    const rawResponse = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...headers
        },
        body: JSON.stringify(body)
    });
    return $155c80569fd4a71a$var$parseResponseAndThrowIfError(rawResponse);
};
const $155c80569fd4a71a$var$getSavedAnonymousUserId = ()=>{
    const anonymousUserIdFromLS = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
    return anonymousUserIdFromLS;
};
const $155c80569fd4a71a$var$getAuthHeaders = ()=>{
    const authTokenFromLS = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken);
    if (authTokenFromLS === null) return {};
    else return {
        Authorization: `${authTokenFromLS}`
    };
};
const $155c80569fd4a71a$export$1ba3b2ba3b6c6931 = async (id, agreedToPromotion)=>{
    const promoteBody = {
        anonymousUserId: id,
        agreedToPromotion: agreedToPromotion
    };
    const response = await $155c80569fd4a71a$var$postRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).postUserAnonymousPromotion}`, promoteBody, $155c80569fd4a71a$var$getAuthHeaders());
    return response;
};
const $155c80569fd4a71a$export$1438efb660d0e2db = async ()=>{
    const response = await $155c80569fd4a71a$var$getRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).getMyUserDetails}`, $155c80569fd4a71a$var$getAuthHeaders());
    return response;
};
const $155c80569fd4a71a$export$fd2a7795a45c388 = async (id)=>{
    const response = await $155c80569fd4a71a$var$getRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).getAnonymousUserMe}?anonymousUserId=${id}`);
    return response;
};
const $155c80569fd4a71a$export$12d407bce29ab995 = async ()=>{
    const lang = navigator.language;
    const userAgentString = navigator.userAgent;
    const originatingDomain = OriginatingDomain;
    const documentReferrer = DocumentReferrer;
    const createBody = {
        lang: lang,
        userAgentString: userAgentString,
        originatingDomain: originatingDomain,
        documentReferrer: documentReferrer
    };
    const response = await $155c80569fd4a71a$var$postRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).createAnonymousUser}`, createBody);
    return response;
};
const $155c80569fd4a71a$export$59a77c4afb731802 = async ()=>{
    const url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).maintenanceStatus}`;
    // console.log("hitting url:", url);
    const response = await $155c80569fd4a71a$var$getRequest(url);
    const res = response;
    return res;
};
const $155c80569fd4a71a$export$a9baae562ac2dc6a = async (userType)=>{
    let response;
    let additionalParams = "";
    if (window.location.href.includes("localhost")) additionalParams += "&debugSkipMatchmaking=true";
    if (window.location.href.includes("skipMenu=true")) additionalParams += "&debugForceAbandonRun=true";
    additionalParams += `&preferredRegion=${(0, $9b9fb0750f8f8ccb$export$a4d8782b5c88d429)()}`;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
        if (savedAnonUserId === null) throw new Error("No anon user ID found in LS, start run request will fail!");
        const url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).startRun}?r=true&anonymousUserId=${savedAnonUserId}${additionalParams}`;
        // console.log("hitting url:", url);
        response = await $155c80569fd4a71a$var$getRequest(url);
    } else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) {
        const url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).startRun}?r=true${additionalParams}`;
        // console.log("hitting url:", url);
        response = await $155c80569fd4a71a$var$getRequest(url, $155c80569fd4a71a$var$getAuthHeaders());
    } else throw new Error("Invalid user type provided to start run request!");
    const res = response;
    if (res.runDepartureSuccessful) return res;
    else return res;
};
const $155c80569fd4a71a$export$9ea6a90857d7c467 = async (userType)=>{
    let response;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
        if (savedAnonUserId === null) throw new Error("No anon user ID found in LS, abandon run request will fail!");
        response = await $155c80569fd4a71a$var$getRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).abandonRun}?anonymousUserId=${savedAnonUserId}`);
    } else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) response = await $155c80569fd4a71a$var$getRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).abandonRun}`, $155c80569fd4a71a$var$getAuthHeaders());
    else throw new Error("Invalid user type provided to abandon run request!");
    return response;
};
const $155c80569fd4a71a$export$a117f742519595e2 = async (userType, skin)=>{
    let response;
    let url;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
        if (savedAnonUserId === null) throw new Error("No anon user ID found in LS, update preferences request will fail!");
        url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).equipSkin}?anonymousUserId=${savedAnonUserId}`;
    } else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).equipSkin}`;
    else throw new Error("Invalid user type provided to update preferences request!");
    response = await $155c80569fd4a71a$var$postRequest(url, {
        skin: skin
    }, $155c80569fd4a71a$var$getAuthHeaders());
    return {
        ...response
    };
};
const $155c80569fd4a71a$export$316eeb8335d217de = async (userType, slot, itemId)=>{
    let response;
    let url;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
        if (savedAnonUserId === null) throw new Error("No anon user ID found in LS, update preferences request will fail!");
        url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).equipItemToSlot}?anonymousUserId=${savedAnonUserId}`;
    } else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).equipItemToSlot}`;
    else throw new Error("Invalid user type provided to update preferences request!");
    response = await $155c80569fd4a71a$var$postRequest(url, {
        slot: slot,
        itemId: itemId
    }, $155c80569fd4a71a$var$getAuthHeaders());
    return {
        ...response
    };
};
const $155c80569fd4a71a$export$9168aba11906f7b7 = async (userType, insuredSlot)=>{
    let url;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
        if (savedAnonUserId === null) throw new Error("No anon user ID found in LS, update preferences request will fail!");
        url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).insureSlot}?anonymousUserId=${savedAnonUserId}`;
    } else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).insureSlot}`;
    else throw new Error("Invalid user type provided to update preferences request!");
    const response = await $155c80569fd4a71a$var$postRequest(url, {
        insuredSlot: insuredSlot
    }, $155c80569fd4a71a$var$getAuthHeaders());
    return {
        ...response
    };
};
const $155c80569fd4a71a$export$a6b99f82a24af4e9 = async (username, email, confirmEmail, password, confirmPassword, agreedToEmailPromo)=>{
    const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
    const url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).registerAnonymousUserEmail}?anonymousUserId=${savedAnonUserId}`;
    try {
        const response = await $155c80569fd4a71a$var$postRequest(url, {
            username: username,
            email: email,
            confirmEmail: confirmEmail,
            password: password,
            confirmPassword: confirmPassword,
            agreedToEmailPromo: agreedToEmailPromo
        }, $155c80569fd4a71a$var$getAuthHeaders());
        return response;
    } catch (e) {
        console.log("error registering anon user email:", e);
        throw e;
    }
};
const $155c80569fd4a71a$export$a87cc9961e568037 = async (email, password)=>{
    const url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).userLogin}`;
    try {
        const response = await $155c80569fd4a71a$var$postRequest(url, {
            email: email,
            password: password
        });
        return response;
    } catch (e) {
        console.log("error logging in user:", e);
        throw e;
    }
};
const $155c80569fd4a71a$export$47e924e4b78aa4b6 = async (skin)=>{
    const response = await $155c80569fd4a71a$var$postRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).postBuySkinWithGems}`, {
        skin: skin
    }, $155c80569fd4a71a$var$getAuthHeaders());
    console.log("API response of buying skin with gems request", response);
    return response;
};
const $155c80569fd4a71a$export$4a23007b16b45ce3 = async ()=>{
    const response = await $155c80569fd4a71a$var$postRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).postBuyInsuranceWithGems}`, {
        quantity: 1
    }, $155c80569fd4a71a$var$getAuthHeaders());
    console.log("API response of buying insurance with gems request", response);
    return response;
};
const $155c80569fd4a71a$export$945e7e2dfa4ae369 = async ()=>{
    const response = await $155c80569fd4a71a$var$postRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).postBuyInsuranceWithCoins}`, {
        quantity: 1
    }, $155c80569fd4a71a$var$getAuthHeaders());
    console.log("API response of buying insurance with coins request", response);
    return response;
};
const $155c80569fd4a71a$export$7feec229e984cb9a = async (sku)=>{
    const response = await $155c80569fd4a71a$var$getRequest(`${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).postGetPurchaseLinkForSKU}?sku=${sku}`, $155c80569fd4a71a$var$getAuthHeaders());
    console.log("API response of get link for sku request", response);
    return response;
};
const $155c80569fd4a71a$export$d8e5ff8d207947de = async (userType, newUsername)=>{
    let response;
    let url;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
        if (savedAnonUserId === null) throw new Error("No anon user ID found in LS, update preferences request will fail!");
        url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).changeUsername}?anonymousUserId=${savedAnonUserId}`;
    } else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).changeUsername}`;
    else throw new Error("Invalid user type provided to update preferences request!");
    response = await $155c80569fd4a71a$var$postRequest(url, {
        desiredNewUsername: newUsername
    }, $155c80569fd4a71a$var$getAuthHeaders());
    return response;
};
const $155c80569fd4a71a$export$2606dfc89cdc611 = async (userType, preferences)=>{
    let response;
    let url;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        const savedAnonUserId = $155c80569fd4a71a$var$getSavedAnonymousUserId();
        if (savedAnonUserId === null) throw new Error("No anon user ID found in LS, update preferences request will fail!");
        url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).updatePreferences}?anonymousUserId=${savedAnonUserId}`;
    } else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) url = `${"https://dev-api.trigonometryexplained.com"}${(0, $5f76e53daf4e01a1$export$10dd65538540bee3).updatePreferences}`;
    else throw new Error("Invalid user type provided to update preferences request!");
    response = await $155c80569fd4a71a$var$postRequest(url, {
        updatedPreferences: preferences
    }, $155c80569fd4a71a$var$getAuthHeaders());
    return {
        ...response
    };
};



var $acw62 = parcelRequire("acw62");
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;


const $ad26fe773541dcd3$var$u = (t)=>"number" == typeof t && !isNaN(t), $ad26fe773541dcd3$var$d = (t)=>"string" == typeof t, $ad26fe773541dcd3$var$p = (t)=>"function" == typeof t, $ad26fe773541dcd3$var$m = (t)=>$ad26fe773541dcd3$var$d(t) || $ad26fe773541dcd3$var$p(t) ? t : null, $ad26fe773541dcd3$var$f = (t)=>(0, $acw62.isValidElement)(t) || $ad26fe773541dcd3$var$d(t) || $ad26fe773541dcd3$var$p(t) || $ad26fe773541dcd3$var$u(t);
function $ad26fe773541dcd3$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o , style: s  } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $ad26fe773541dcd3$export$3ff7dc44d332d222(e) {
    let { enter: a , exit: r , appendPosition: i = !1 , collapse: l = !0 , collapseDuration: c = 300  } = e;
    return function(e) {
        let { children: u , position: d , preventExitTransition: p , done: m , nodeRef: f , isIn: h  } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $acw62.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $ad26fe773541dcd3$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, u);
    };
}
function $ad26fe773541dcd3$var$y(t, e) {
    return {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    };
}
const $ad26fe773541dcd3$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $ad26fe773541dcd3$var$T = (e)=>{
    let { theme: n , type: o , ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $ad26fe773541dcd3$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $ad26fe773541dcd3$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $acw62.useReducer)((t)=>t + 1, 0), [l, c] = (0, $acw62.useState)([]), g = (0, $acw62.useRef)(null), h = (0, $acw62.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $acw62.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e  } = t;
        const { limit: n  } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t , toastProps: e , staleId: n  } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s , staleId: r , ...i } = n;
        if (!$ad26fe773541dcd3$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l , updateId: c , data: T  } = i, { props: b  } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $ad26fe773541dcd3$var$m(i.className || b.toastClassName),
            bodyClassName: $ad26fe773541dcd3$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $ad26fe773541dcd3$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $ad26fe773541dcd3$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $ad26fe773541dcd3$var$y(h.get(l), "removed");
                h.delete(l), $ad26fe773541dcd3$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n , type: o , isLoading: s , icon: r  } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($ad26fe773541dcd3$var$p(r) ? i = r(l) : (0, $acw62.isValidElement)(r) ? i = (0, $acw62.cloneElement)(r, l) : $ad26fe773541dcd3$var$d(r) || $ad26fe773541dcd3$var$u(r) ? i = r : s ? i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $ad26fe773541dcd3$export$4f13f83fd8bb1dac)(o) && (i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $ad26fe773541dcd3$var$p(i.onOpen) && (M.onOpen = i.onOpen), $ad26fe773541dcd3$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $ad26fe773541dcd3$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$ad26fe773541dcd3$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $acw62.isValidElement)(t) && !$ad26fe773541dcd3$var$d(t.type) ? x = (0, $acw62.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $ad26fe773541dcd3$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $ad26fe773541dcd3$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o  } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $ad26fe773541dcd3$var$v.emit(4, $ad26fe773541dcd3$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $acw62.useEffect)(()=>(C.containerId = t.containerId, $ad26fe773541dcd3$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $ad26fe773541dcd3$var$v.emit(3, C);
        }), []), (0, $acw62.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e  } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $ad26fe773541dcd3$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $ad26fe773541dcd3$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $ad26fe773541dcd3$export$a407b657d3044108(t) {
    const [o, a] = (0, $acw62.useState)(!1), [r, l] = (0, $acw62.useState)(!1), c = (0, $acw62.useRef)(null), u = (0, $acw62.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $acw62.useRef)(t), { autoClose: m , pauseOnHover: f , closeToast: g , onClick: h , closeOnClick: y  } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $ad26fe773541dcd3$var$b(e.nativeEvent), u.y = $ad26fe773541dcd3$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n , bottom: o , left: s , right: a  } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $ad26fe773541dcd3$var$b(e), u.y = $ad26fe773541dcd3$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $acw62.useEffect)(()=>{
        d.current = t;
    }), (0, $acw62.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $ad26fe773541dcd3$var$p(t.onOpen) && t.onOpen((0, $acw62.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $ad26fe773541dcd3$var$p(t.onClose) && t.onClose((0, $acw62.isValidElement)(t.children) && t.children.props);
        }), []), (0, $acw62.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $ad26fe773541dcd3$var$L(e) {
    let { closeToast: n , theme: o , ariaLabel: s = "close"  } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $ad26fe773541dcd3$var$O(e) {
    let { delay: n , isRunning: o , closeToast: s , type: a = "default" , hide: r , className: i , style: l , controlledProgress: u , progress: d , rtl: m , isIn: f , theme: g  } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $ad26fe773541dcd3$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $ad26fe773541dcd3$var$N = (n)=>{
    const { isRunning: o , preventExitTransition: s , toastRef: r , eventHandlers: i  } = $ad26fe773541dcd3$export$a407b657d3044108(n), { closeButton: l , children: u , autoClose: d , onClick: m , type: f , hideProgressBar: g , closeToast: h , transition: y , position: v , className: T , style: E , bodyClassName: C , bodyStyle: b , progressClassName: I , progressStyle: N , updateId: M , role: R , progress: w , rtl: x , toastId: $ , deleteToast: k , isIn: P , isLoading: B , iconOut: D , closeOnClick: A , theme: z  } = n, F = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $ad26fe773541dcd3$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $ad26fe773541dcd3$var$p(l) ? l(q) : (0, $acw62.isValidElement)(l) ? (0, $acw62.cloneElement)(l, q) : $ad26fe773541dcd3$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...P && {
            role: R
        },
        className: $ad26fe773541dcd3$var$p(C) ? C({
            type: f
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $ad26fe773541dcd3$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $ad26fe773541dcd3$export$d20e79fdc3899e95 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("bounce", !0)), $ad26fe773541dcd3$export$d8dc01b5c85a37b9 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("slide", !0)), $ad26fe773541dcd3$export$65cfd44a2050f99 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("zoom")), $ad26fe773541dcd3$export$4d2fae537bd90431 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("flip")), $ad26fe773541dcd3$export$f2815235e76a62b9 = (0, $acw62.forwardRef)((e, n)=>{
    const { getToastToRender: o , containerRef: a , isToastActive: r  } = $ad26fe773541dcd3$export$b262e13ca2dd2381(e), { className: i , style: l , rtl: u , containerId: d  } = e;
    function f(t) {
        const e = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $ad26fe773541dcd3$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(e, $ad26fe773541dcd3$var$m(i));
    }
    return (0, $acw62.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s , props: a  } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$ad26fe773541dcd3$export$f2815235e76a62b9.displayName = "ToastContainer", $ad26fe773541dcd3$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $ad26fe773541dcd3$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $ad26fe773541dcd3$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $ad26fe773541dcd3$var$P, $ad26fe773541dcd3$var$B = new Map, $ad26fe773541dcd3$var$D = [], $ad26fe773541dcd3$var$A = 1;
function $ad26fe773541dcd3$var$z() {
    return "" + $ad26fe773541dcd3$var$A++;
}
function $ad26fe773541dcd3$var$F(t) {
    return t && ($ad26fe773541dcd3$var$d(t.toastId) || $ad26fe773541dcd3$var$u(t.toastId)) ? t.toastId : $ad26fe773541dcd3$var$z();
}
function $ad26fe773541dcd3$var$H(t, e) {
    return $ad26fe773541dcd3$var$B.size > 0 ? $ad26fe773541dcd3$var$v.emit(0, t, e) : $ad26fe773541dcd3$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $ad26fe773541dcd3$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $ad26fe773541dcd3$var$F(e)
    };
}
function $ad26fe773541dcd3$var$q(t) {
    return (e, n)=>$ad26fe773541dcd3$var$H(e, $ad26fe773541dcd3$var$S(t, n));
}
function $ad26fe773541dcd3$export$b410431fab84fa58(t, e) {
    return $ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", e));
}
$ad26fe773541dcd3$export$b410431fab84fa58.loading = (t, e)=>$ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $ad26fe773541dcd3$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s , error: a , success: r  } = e;
    s && (o = $ad26fe773541dcd3$var$d(s) ? $ad26fe773541dcd3$export$b410431fab84fa58.loading(s, n) : $ad26fe773541dcd3$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $ad26fe773541dcd3$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $ad26fe773541dcd3$var$d(e) ? {
            render: e
        } : e;
        return o ? $ad26fe773541dcd3$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $ad26fe773541dcd3$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $ad26fe773541dcd3$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $ad26fe773541dcd3$export$b410431fab84fa58.success = $ad26fe773541dcd3$var$q("success"), $ad26fe773541dcd3$export$b410431fab84fa58.info = $ad26fe773541dcd3$var$q("info"), $ad26fe773541dcd3$export$b410431fab84fa58.error = $ad26fe773541dcd3$var$q("error"), $ad26fe773541dcd3$export$b410431fab84fa58.warning = $ad26fe773541dcd3$var$q("warning"), $ad26fe773541dcd3$export$b410431fab84fa58.warn = $ad26fe773541dcd3$export$b410431fab84fa58.warning, $ad26fe773541dcd3$export$b410431fab84fa58.dark = (t, e)=>$ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", {
        theme: "dark",
        ...e
    })), $ad26fe773541dcd3$export$b410431fab84fa58.dismiss = (t)=>{
    $ad26fe773541dcd3$var$B.size > 0 ? $ad26fe773541dcd3$var$v.emit(1, t) : $ad26fe773541dcd3$var$D = $ad26fe773541dcd3$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $ad26fe773541dcd3$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $ad26fe773541dcd3$var$v.emit(5, t);
}, $ad26fe773541dcd3$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $ad26fe773541dcd3$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $ad26fe773541dcd3$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n  } = e;
            const o = $ad26fe773541dcd3$var$B.get(n || $ad26fe773541dcd3$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o , content: s  } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $ad26fe773541dcd3$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $ad26fe773541dcd3$var$H(r, a);
        }
    }, 0);
}, $ad26fe773541dcd3$export$b410431fab84fa58.done = (t)=>{
    $ad26fe773541dcd3$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $ad26fe773541dcd3$export$b410431fab84fa58.onChange = (t)=>($ad26fe773541dcd3$var$v.on(4, t), ()=>{
        $ad26fe773541dcd3$var$v.off(4, t);
    }), $ad26fe773541dcd3$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $ad26fe773541dcd3$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $ad26fe773541dcd3$var$v.on(2, (t)=>{
    $ad26fe773541dcd3$var$P = t.containerId || t, $ad26fe773541dcd3$var$B.set($ad26fe773541dcd3$var$P, t), $ad26fe773541dcd3$var$D.forEach((t)=>{
        $ad26fe773541dcd3$var$v.emit(0, t.content, t.options);
    }), $ad26fe773541dcd3$var$D = [];
}).on(3, (t)=>{
    $ad26fe773541dcd3$var$B.delete(t.containerId || t), 0 === $ad26fe773541dcd3$var$B.size && $ad26fe773541dcd3$var$v.off(0).off(1).off(5);
});


const $4a3136d799878a30$var$bounce = (0, $ad26fe773541dcd3$export$3ff7dc44d332d222)({
    enter: "animate__animated animate__bounceIn",
    exit: "animate__animated animate__bounceOut"
});
const $4a3136d799878a30$var$messageTypeToEmoji = {
    none: "",
    success: "✅",
    error: "❌",
    warning: "⚠️"
};
var $4a3136d799878a30$export$67897bded358b5bc;
(function(ToastStatuses) {
    ToastStatuses["NONE"] = "none";
    ToastStatuses["SUCCESS"] = "success";
    ToastStatuses["ERROR"] = "error";
    ToastStatuses["WARNING"] = "warning";
})($4a3136d799878a30$export$67897bded358b5bc || ($4a3136d799878a30$export$67897bded358b5bc = {}));
const $4a3136d799878a30$export$6b89521c3f482608 = (toastOptions)=>{
    const { status: status , message: message  } = toastOptions;
    (0, $ad26fe773541dcd3$export$b410431fab84fa58).dark(`${$4a3136d799878a30$var$messageTypeToEmoji[status]} ${message}`, {
        transition: $4a3136d799878a30$var$bounce
    });
};







var $102fc1000c26cf91$export$7369a5563924ac4;
(function(LoadoutSlots) {
    LoadoutSlots[LoadoutSlots["None"] = -1] = "None";
    LoadoutSlots[LoadoutSlots["WeaponOne"] = 1] = "WeaponOne";
    LoadoutSlots[LoadoutSlots["WeaponTwo"] = 2] = "WeaponTwo";
    LoadoutSlots[LoadoutSlots["GearOne"] = 3] = "GearOne";
    LoadoutSlots[LoadoutSlots["GearTwo"] = 4] = "GearTwo";
    LoadoutSlots[LoadoutSlots["GearThree"] = 5] = "GearThree";
})($102fc1000c26cf91$export$7369a5563924ac4 || ($102fc1000c26cf91$export$7369a5563924ac4 = {}));
class $102fc1000c26cf91$export$87056d933ed937b1 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.activeWeaponSlot = $102fc1000c26cf91$export$7369a5563924ac4.WeaponOne;
        this.weaponSwapCooldownInSeconds = 0.5;
        this.secondsSinceLastSwappedWeapons = 0;
        this.secondsSinceLastUsedWeapon = 0;
        this.gearOneAbility = (0, $faa1b3449016497b$export$259a6f5d817ae02e).None;
        this.gearOneCooldownInSeconds = 0;
        this.secondsSinceLastUsedGearOne = 0;
        this.gearOneCharges = -1;
        this.gearOneDurationAbilityDurationInSeconds = 0;
        this.gearOneDurationAbilityAccumulator = 0;
        this.gearOneAbilityIsActive = false;
        this.gearTwoAbility = (0, $faa1b3449016497b$export$259a6f5d817ae02e).None;
        this.gearTwoCooldownInSeconds = 0;
        this.secondsSinceLastUsedGearTwo = 0;
        this.gearTwoCharges = -1;
        this.gearTwoDurationAbilityDurationInSeconds = 0;
        this.gearTwoDurationAbilityAccumulator = 0;
        this.gearTwoAbilityIsActive = false;
        this.gearThreeAbility = (0, $faa1b3449016497b$export$259a6f5d817ae02e).None;
        this.gearThreeCooldownInSeconds = 0;
        this.secondsSinceLastUsedGearThree = 0;
        this.gearThreeCharges = -1;
        this.gearThreeDurationAbilityDurationInSeconds = 0;
        this.gearThreeDurationAbilityAccumulator = 0;
        this.gearThreeAbilityIsActive = false;
    }
    SetWeaponDetails(weaponOne, weaponTwo) {
        this.equippedWeaponOne = weaponOne;
        this.equippedWeaponTwo = weaponTwo;
        const weaponOneConfig = (0, $0acc22698d702be9$export$f96416c73a613aba)(weaponOne);
        if (weaponOneConfig === undefined) throw new Error(`Weapon with id ${weaponOne} does not exist in the weapon config map; this should never happen`);
        const weaponTwoConfig = (0, $0acc22698d702be9$export$f96416c73a613aba)(weaponTwo);
        if (weaponTwoConfig === undefined) throw new Error(`Weapon with id ${weaponTwo} does not exist in the weapon config map; this should never happen`);
        this.weaponOneConfig = weaponOneConfig;
        this.weaponTwoConfig = weaponTwoConfig;
        const attackSpeedMultiplier = this.GetOwningEntity().attackSpeedMultiplier;
        // console.warn("@@@ attack speed multiplier in weapon setup");
        // console.log(attackSpeedMultiplier);
        this.weaponCooldownInSeconds = weaponOneConfig.cooldownInSeconds * attackSpeedMultiplier;
        this.secondsSinceLastUsedWeapon = weaponOneConfig.cooldownInSeconds * attackSpeedMultiplier; // make it off cooldown immediately
        this.playerMovementImpactModifier = weaponOneConfig.playerMovementMultiplier;
        this.playerMovementImpactDurationInSeconds = weaponOneConfig.playerMovementMultiplierDurationInSeconds;
        this.playerMovementImpactAccumulator = weaponOneConfig.playerMovementMultiplierDurationInSeconds;
    }
    SetGearDetails(gearOne, gearTwo, gearThree) {
        this.equippedGearOne = gearOne;
        this.equippedGearTwo = gearTwo;
        this.equippedGearThree = gearThree;
        if (gearOne !== (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None) {
            const gearOneConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearOne);
            if (gearOneConfig === undefined) throw new Error(`Gear with id ${gearOne} does not exist in the gear config map; this should never happen`);
            this.gearOneConfig = gearOneConfig;
            if (this.gearOneConfig.activeAbility.ability !== (0, $faa1b3449016497b$export$259a6f5d817ae02e).None) {
                // console.log("Gear one has an active ability; setting the details now");
                this.gearOneAbility = gearOneConfig.activeAbility.ability;
                this.gearOneCooldownInSeconds = gearOneConfig.activeAbility.abilityCooldownInSeconds;
                this.secondsSinceLastUsedGearOne = gearOneConfig.activeAbility.abilityCooldownInSeconds; // make it off cooldown immediately
                this.gearOneCharges = gearOneConfig.activeAbility.abilityCharges;
                this.gearOneDurationAbilityDurationInSeconds = gearOneConfig.activeAbility.abilityDurationInSeconds;
            }
        }
        if (gearTwo !== (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None) {
            const gearTwoConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearTwo);
            if (gearTwoConfig === undefined) throw new Error(`Gear with id ${gearTwo} does not exist in the gear config map; this should never happen`);
            this.gearTwoConfig = gearTwoConfig;
            if (this.gearTwoConfig.activeAbility.ability !== (0, $faa1b3449016497b$export$259a6f5d817ae02e).None) {
                // console.log("Gear two has an active ability; setting the details now");
                this.gearTwoAbility = gearTwoConfig.activeAbility.ability;
                this.gearTwoCooldownInSeconds = gearTwoConfig.activeAbility.abilityCooldownInSeconds;
                this.secondsSinceLastUsedGearTwo = gearTwoConfig.activeAbility.abilityCooldownInSeconds; // make it off cooldown immediately
                this.gearTwoCharges = gearTwoConfig.activeAbility.abilityCharges;
                this.gearTwoDurationAbilityDurationInSeconds = gearTwoConfig.activeAbility.abilityDurationInSeconds;
            }
        }
        if (gearThree !== (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None) {
            const gearThreeConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearThree);
            if (gearThreeConfig === undefined) throw new Error(`Gear with id ${gearThree} does not exist in the gear config map; this should never happen`);
            this.gearThreeConfig = gearThreeConfig;
            if (this.gearThreeConfig.activeAbility.ability !== (0, $faa1b3449016497b$export$259a6f5d817ae02e).None) {
                // console.log("Gear three has an active ability; setting the details now");
                this.gearThreeAbility = gearThreeConfig.activeAbility.ability;
                this.gearThreeCooldownInSeconds = gearThreeConfig.activeAbility.abilityCooldownInSeconds;
                this.secondsSinceLastUsedGearThree = gearThreeConfig.activeAbility.abilityCooldownInSeconds; // make it off cooldown immediately
                this.gearThreeCharges = gearThreeConfig.activeAbility.abilityCharges;
                this.gearThreeDurationAbilityDurationInSeconds = gearThreeConfig.activeAbility.abilityDurationInSeconds;
            }
        }
    }
    SetOwningEntity(entity) {
        this.owningEntity = entity;
    }
    GetActiveWeaponConfig() {
        if (this.activeWeaponSlot === $102fc1000c26cf91$export$7369a5563924ac4.WeaponOne) return this.weaponOneConfig;
        else if (this.activeWeaponSlot === $102fc1000c26cf91$export$7369a5563924ac4.WeaponTwo) return this.weaponTwoConfig;
        else throw new Error(`Invalid active weapon slot ${this.activeWeaponSlot}l; unable to retrieve weapon config in GetActiveWeaponConfig`);
    }
    GetCooldownProgressPercentage(slot) {
        if (slot === $102fc1000c26cf91$export$7369a5563924ac4.WeaponOne || slot === $102fc1000c26cf91$export$7369a5563924ac4.WeaponTwo) return (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(Math.floor(this.secondsSinceLastUsedWeapon / this.weaponCooldownInSeconds * 100), 0, 100);
        else if (slot === $102fc1000c26cf91$export$7369a5563924ac4.GearOne) return (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(Math.floor(this.secondsSinceLastUsedGearOne / this.gearOneCooldownInSeconds * 100), 0, 100);
        else if (slot === $102fc1000c26cf91$export$7369a5563924ac4.GearTwo) return (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(Math.floor(this.secondsSinceLastUsedGearTwo / this.gearTwoCooldownInSeconds * 100), 0, 100);
        else if (slot === $102fc1000c26cf91$export$7369a5563924ac4.GearThree) return (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(Math.floor(this.secondsSinceLastUsedGearThree / this.gearThreeCooldownInSeconds * 100), 0, 100);
        else throw new Error("Unrecognized loadout slot passed to SharedGearAndWeaponSystem GetCooldownProgressPercentage()");
    }
    GetCharges(slot) {
        if (slot === $102fc1000c26cf91$export$7369a5563924ac4.GearOne) return this.gearOneCharges;
        else if (slot === $102fc1000c26cf91$export$7369a5563924ac4.GearTwo) return this.gearTwoCharges;
        else if (slot === $102fc1000c26cf91$export$7369a5563924ac4.GearThree) return this.gearThreeCharges;
        return -1;
    }
    GetOwningEntity() {
        return this.owningEntity;
    }
    GetOwningEntityNid() {
        return this.owningEntity.nid;
    }
    GetPlayerMovementImpactModifier() {
        return this.playerMovementImpactModifier;
    }
    ShouldSlowMovementBecauseOfShooting() {
        return this.playerMovementImpactAccumulator < this.playerMovementImpactDurationInSeconds;
    }
    _useActiveAbility(__activeAbility, __abilityDefinition) {}
    ProcessInputs(inputCommand) {
        const { delta: delta , usedWeapon: usedWeapon , swappedToFirstWeapon: swappedToFirstWeapon , swappedToSecondWeapon: swappedToSecondWeapon , genericSwappedWeapon: genericSwappedWeapon , usedGearOne: usedGearOne , usedGearTwo: usedGearTwo , usedGearThree: usedGearThree  } = inputCommand;
        this.secondsSinceLastUsedWeapon += delta;
        this.secondsSinceLastSwappedWeapons += delta;
        this.playerMovementImpactAccumulator += delta;
        this.secondsSinceLastUsedGearOne += delta;
        this.secondsSinceLastUsedGearTwo += delta;
        this.secondsSinceLastUsedGearThree += delta;
        // Check for duration having elapsed for all active abilities that have durations
        if (this.gearOneAbilityIsActive) {
            this.gearOneDurationAbilityAccumulator += delta;
            if (this.gearOneDurationAbilityAccumulator >= this.gearOneDurationAbilityDurationInSeconds) {
                // console.log("gear one duration has completed! resetting the ability!");
                this.gearOneDurationAbilityAccumulator = 0;
                this.gearOneAbilityIsActive = false;
            }
        }
        if (this.gearTwoAbilityIsActive) {
            this.gearTwoDurationAbilityAccumulator += delta;
            if (this.gearTwoDurationAbilityAccumulator >= this.gearTwoDurationAbilityDurationInSeconds) {
                // console.log("gear two duration has completed! resetting the ability!");
                this.gearTwoDurationAbilityAccumulator = 0;
                this.gearTwoAbilityIsActive = false;
            }
        }
        if (this.gearThreeAbilityIsActive) {
            this.gearThreeDurationAbilityAccumulator += delta;
            if (this.gearThreeDurationAbilityAccumulator >= this.gearThreeDurationAbilityDurationInSeconds) {
                // console.log("gear three duration has completed! resetting the ability!");
                this.gearThreeDurationAbilityAccumulator = 0;
                this.gearThreeAbilityIsActive = false;
            }
        }
        // Handle potential weapon swaps first, because they have the potential
        // to reset the weapon use cooldowns (weapon cooldown should reset when
        // a player swaps weapons to prevent the cheese)
        if (this.CanSwapWeapon()) {
            if (genericSwappedWeapon) {
                if (this.activeWeaponSlot === $102fc1000c26cf91$export$7369a5563924ac4.WeaponOne) this.SwapToWeaponSlot($102fc1000c26cf91$export$7369a5563924ac4.WeaponTwo);
                else if (this.activeWeaponSlot === $102fc1000c26cf91$export$7369a5563924ac4.WeaponTwo) this.SwapToWeaponSlot($102fc1000c26cf91$export$7369a5563924ac4.WeaponOne);
            } else if (swappedToFirstWeapon) {
                if (this.activeWeaponSlot !== $102fc1000c26cf91$export$7369a5563924ac4.WeaponOne && swappedToFirstWeapon) this.SwapToWeaponSlot($102fc1000c26cf91$export$7369a5563924ac4.WeaponOne);
            } else if (swappedToSecondWeapon) {
                if (this.activeWeaponSlot !== $102fc1000c26cf91$export$7369a5563924ac4.WeaponTwo && swappedToSecondWeapon) this.SwapToWeaponSlot($102fc1000c26cf91$export$7369a5563924ac4.WeaponTwo);
            }
        }
        if (usedWeapon && this.CanUseWeapon()) this.UseWeapon();
        if (usedGearOne && this.CanUseGear($102fc1000c26cf91$export$7369a5563924ac4.GearOne)) this.UseGear($102fc1000c26cf91$export$7369a5563924ac4.GearOne);
        if (usedGearTwo && this.CanUseGear($102fc1000c26cf91$export$7369a5563924ac4.GearTwo)) this.UseGear($102fc1000c26cf91$export$7369a5563924ac4.GearTwo);
        if (usedGearThree && this.CanUseGear($102fc1000c26cf91$export$7369a5563924ac4.GearThree)) this.UseGear($102fc1000c26cf91$export$7369a5563924ac4.GearThree);
    }
    Update(__deltaTime) {}
    _gearHasChargesRemaining(gearSlot) {
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearOne) {
            if (this.gearOneCharges === -1) return true;
            else return this.gearOneCharges > 0;
        }
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearTwo) {
            if (this.gearTwoCharges === -1) return true;
            else return this.gearTwoCharges > 0;
        }
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearThree) {
            if (this.gearThreeCharges === -1) return true;
            else return this.gearThreeCharges > 0;
        }
        return false;
    }
    _gearIsOffCooldown(gearSlot) {
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearOne) return this.secondsSinceLastUsedGearOne >= this.gearOneCooldownInSeconds;
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearTwo) return this.secondsSinceLastUsedGearTwo >= this.gearTwoCooldownInSeconds;
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearThree) return this.secondsSinceLastUsedGearThree >= this.gearThreeCooldownInSeconds;
        return false;
    }
    _gearHasAnActiveAbility(gearSlot) {
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearOne) return this.gearOneAbility !== (0, $faa1b3449016497b$export$259a6f5d817ae02e).None;
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearTwo) return this.gearTwoAbility !== (0, $faa1b3449016497b$export$259a6f5d817ae02e).None;
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearThree) return this.gearThreeAbility !== (0, $faa1b3449016497b$export$259a6f5d817ae02e).None;
        return false;
    }
    CanUseGear(gearSlot) {
        if (this._gearHasAnActiveAbility(gearSlot) === false) return false;
        if (this._gearHasChargesRemaining(gearSlot) === false) return false;
        if (this._gearIsOffCooldown(gearSlot) === false) return false;
        // console.log({ hasActiveAbility: this._gearHasAnActiveAbility(gearSlot), hasChargesRemaining: this._gearHasChargesRemaining(gearSlot), isOffCooldown: this._gearIsOffCooldown(gearSlot) });
        return true;
    }
    UseGear(gearSlot) {
        // console.log("Used gear slot: ", LoadoutSlots[gearSlot]);
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearOne) {
            this.secondsSinceLastUsedGearOne = 0;
            if (this.gearTwoConfig !== undefined && this.gearTwoConfig.itemId !== -1) {
                if (this.gearTwoConfig.activeAbility.ability === this.gearOneConfig.activeAbility.ability) // console.log("gear one and gear two have the same ability! resetting gear two cooldown also to prevent stacking!");
                this.secondsSinceLastUsedGearTwo = 0;
            }
            if (this.gearThreeConfig !== undefined && this.gearThreeConfig.itemId !== -1) {
                if (this.gearThreeConfig.activeAbility.ability === this.gearOneConfig.activeAbility.ability) // console.log("gear one and gear three have the same ability! resetting gear three cooldown also to prevent stacking!");
                this.secondsSinceLastUsedGearThree = 0;
            }
            // if gear one has charges, decrement them by 1 for this use
            if (this.gearOneCharges !== -1) // console.log(`gear one has charges! decrementing by 1! (old: ${this.gearOneCharges} new: ${this.gearOneCharges - 1})`);
            this.gearOneCharges--;
            // if gear one has a duration, reset the accumulator and set the ability to active
            if (this.gearOneDurationAbilityDurationInSeconds !== 0) {
                // console.log("gear one has a duration! setting the ability to active!");
                this.gearOneDurationAbilityAccumulator = 0;
                this.gearOneAbilityIsActive = true;
            }
        }
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearTwo) {
            this.secondsSinceLastUsedGearTwo = 0;
            if (this.gearOneConfig !== undefined && this.gearOneConfig.itemId !== -1) {
                if (this.gearOneConfig.activeAbility.ability === this.gearTwoConfig.activeAbility.ability) // console.log("gear two and gear one have the same ability! resetting gear one cooldown also to prevent stacking!");
                this.secondsSinceLastUsedGearOne = 0;
            }
            if (this.gearThreeConfig !== undefined && this.gearThreeConfig.itemId !== -1) {
                if (this.gearThreeConfig.activeAbility.ability === this.gearTwoConfig.activeAbility.ability) // console.log("gear two and gear three have the same ability! resetting gear three cooldown also to prevent stacking!");
                this.secondsSinceLastUsedGearThree = 0;
            }
            // if gear two has charges, decrement them by 1 for this use
            if (this.gearTwoCharges !== -1) // console.log(`gear two has charges! decrementing by 1! (old: ${this.gearTwoCharges} new: ${this.gearTwoCharges - 1})`);
            this.gearTwoCharges--;
            // if gear two has a duration, reset the accumulator and set the ability to active
            if (this.gearTwoDurationAbilityDurationInSeconds !== 0) {
                // console.log("gear two has a duration! setting the ability to active!");
                this.gearTwoDurationAbilityAccumulator = 0;
                this.gearTwoAbilityIsActive = true;
            }
        }
        if (gearSlot === $102fc1000c26cf91$export$7369a5563924ac4.GearThree) {
            this.secondsSinceLastUsedGearThree = 0;
            if (this.gearOneConfig !== undefined && this.gearOneConfig.itemId !== -1) {
                if (this.gearOneConfig.activeAbility.ability === this.gearThreeConfig.activeAbility.ability) // console.log("gear three and gear one have the same ability! resetting gear one cooldown also to prevent stacking!");
                this.secondsSinceLastUsedGearOne = 0;
            }
            if (this.gearTwoConfig !== undefined && this.gearTwoConfig.itemId !== -1) {
                if (this.gearTwoConfig.activeAbility.ability === this.gearThreeConfig.activeAbility.ability) // console.log("gear three and gear two have the same ability! resetting gear two cooldown also to prevent stacking!");
                this.secondsSinceLastUsedGearTwo = 0;
            }
            // if gear three has charges, decrement them by 1 for this use
            if (this.gearThreeCharges !== -1) // console.log(`gear three has charges! decrementing by 1! (old: ${this.gearThreeCharges} new: ${this.gearThreeCharges - 1})`);
            this.gearThreeCharges--;
            // if gear three has a duration, reset the accumulator and set the ability to active
            if (this.gearThreeDurationAbilityDurationInSeconds !== 0) {
                // console.log("gear three has a duration! setting the ability to active!");
                this.gearThreeDurationAbilityAccumulator = 0;
                this.gearThreeAbilityIsActive = true;
            }
        }
    }
    UseWeapon() {
        this.secondsSinceLastUsedWeapon = 0;
        this.playerMovementImpactAccumulator = 0;
    }
    CanUseWeapon() {
        return this.secondsSinceLastUsedWeapon >= this.weaponCooldownInSeconds;
    }
    SwapToWeaponSlot(newSlot) {
        this.activeWeaponSlot = newSlot;
        const newActiveWeaponConfig = this.GetActiveWeaponConfig();
        const attackSpeedMultiplier = this.GetOwningEntity().attackSpeedMultiplier;
        // console.warn("@@@ attack speed multiplier in weapon setup");
        // console.log(attackSpeedMultiplier);
        this.weaponCooldownInSeconds = newActiveWeaponConfig.cooldownInSeconds * attackSpeedMultiplier;
        this.playerMovementImpactDurationInSeconds = newActiveWeaponConfig.playerMovementMultiplierDurationInSeconds;
        this.playerMovementImpactModifier = newActiveWeaponConfig.playerMovementMultiplier;
        // Set the movement impact modifier to its default duration so that it doesnt cause them to slow down just by activating the weapon
        this.playerMovementImpactAccumulator = newActiveWeaponConfig.playerMovementMultiplierDurationInSeconds;
        this.secondsSinceLastSwappedWeapons = 0;
        // Also reset the weapon cooldown so that the player cant use the weapon immediately the same frame as swapping
        this.secondsSinceLastUsedWeapon = 0;
    }
    CanSwapWeapon() {
        return this.secondsSinceLastSwappedWeapons >= this.weaponSwapCooldownInSeconds;
    }
    Initialize() {
        this.LogInfo("Ready!");
    }
    getSystemName() {
        return "Weapon";
    }
    Cleanup() {}
}



const $d1dfdf83584ec9ce$export$5279190db4d8f228 = (shouldSkipMenu, shouldSkipToLoadout)=>{
    console.warn("@@@ RELOADING WITH SDK:", ThirdPartySDK);
    console.warn("@@@ RELOADING WITH ORIGINAL LOCATION:", OriginalLocation);
    let prefix = "?";
    console.log("OriginalLocation:", OriginalLocation);
    console.log(OriginalLocation.includes);
    if (OriginalLocation.includes("?")) prefix = "&";
    let redirectUri = OriginalLocation;
    if (window.location.href.includes("localhost") && shouldSkipMenu) {
        if (ThirdPartySDK === "crazygames") redirectUri = `${OriginalLocation}${prefix}skipMenu=true&force-third-party-sdk=crazygames`;
        else redirectUri = `${OriginalLocation}${prefix}skipMenu=true`;
    } else {
        if (shouldSkipToLoadout) {
            if (ThirdPartySDK === "crazygames") redirectUri = `${OriginalLocation}${prefix}sl=true&force-third-party-sdk=crazygames`;
            else redirectUri = `${OriginalLocation}${prefix}sl=true`;
        } else if (ThirdPartySDK === "crazygames") redirectUri = `${OriginalLocation}${prefix}force-third-party-sdk=crazygames`;
        else redirectUri = OriginalLocation;
    }
    // console.warn("@@@ SDK REDIRECTING TO:", redirectUri);
    document.location.href = redirectUri;
};


const $a9786bc83f165385$export$6890cbbf7baa7104 = {
    TIME_TO_EXTRACT_IN_SECONDS: 10,
    MAX_RUN_DURATION_IN_SECONDS: 420,
    DEBUG: {
        // Collider visuals
        DRAW_COLLIDER: false
    }
};





var $9b9fb0750f8f8ccb$export$4d514e3f82243c75;
(function(UIModes) {
    UIModes["Menus"] = "Menus";
    UIModes["InGame"] = "InGame";
})($9b9fb0750f8f8ccb$export$4d514e3f82243c75 || ($9b9fb0750f8f8ccb$export$4d514e3f82243c75 = {}));
var $9b9fb0750f8f8ccb$export$b714373eb9ab036b;
(function(Screens) {
    Screens["MainMenu"] = "MainMenu";
    Screens["Settings"] = "Settings";
    Screens["Rankings"] = "Rankings";
    Screens["Vendors"] = "Vendors";
    Screens["HowToPlay"] = "HowToPlay";
    Screens["RunPrep"] = "RunPrep";
    Screens["KitTest"] = "KitTest";
    Screens["RunInProgress"] = "RunInProgress";
    Screens["FindingMatch"] = "FindingMatch";
    Screens["ChangeUsername"] = "ChangeUsername";
    Screens["Inventory"] = "Inventory";
    Screens["Stats"] = "Stats";
    Screens["ItemTest"] = "ItemTest";
    Screens["MatchmakingError"] = "MatchmakingError";
    Screens["Partners"] = "Partners";
    Screens["Register"] = "Register";
    Screens["Login"] = "Login";
    Screens["PatchNotes"] = "PatchNotes";
    Screens["CollectionLog"] = "CollectionLog";
    Screens["Shop"] = "Shop";
    Screens["BundleDetails"] = "BundleDetails";
    Screens["PurchaseSuccessful"] = "PurchaseSuccessful";
    Screens["ConfirmSkinPurchase"] = "ConfirmSkinPurchase";
    Screens["ConfirmInsurancePurchase"] = "ConfirmInsurancePurchase";
    Screens["ConfirmCoinInsurancePurchase"] = "ConfirmCoinInsurancePurchase";
})($9b9fb0750f8f8ccb$export$b714373eb9ab036b || ($9b9fb0750f8f8ccb$export$b714373eb9ab036b = {}));
const $9b9fb0750f8f8ccb$export$a81c8bd4ed6c2681 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "uiModeState",
    default: $9b9fb0750f8f8ccb$export$4d514e3f82243c75.Menus
});
const $9b9fb0750f8f8ccb$export$e15de0447bb57da2 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "selectedSkinToPurchaseState",
    default: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).None
});
const $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a = (skinId)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$e15de0447bb57da2, skinId);
};
const $9b9fb0750f8f8ccb$export$580257368aee5734 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "selectedBundleState",
    default: "none"
});
const $9b9fb0750f8f8ccb$export$575176a09217577a = (bundleId)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$580257368aee5734, bundleId);
};
const $9b9fb0750f8f8ccb$export$64e34d6705ba6281 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "intentionalDisconnectState",
    default: false
});
const $9b9fb0750f8f8ccb$export$af0d689d0f8c0f26 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "currentScreenState",
    default: $9b9fb0750f8f8ccb$export$b714373eb9ab036b.MainMenu
});
const $9b9fb0750f8f8ccb$export$f166ba1253c74e5f = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "changeUsernameInputState",
    default: ""
});
const $9b9fb0750f8f8ccb$export$2e98e77ec812cd4d = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "registerState",
    default: {
        loading: false
    }
});
const $9b9fb0750f8f8ccb$var$currentPromoValueFromLS = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).PromotionAccepted);
const $9b9fb0750f8f8ccb$var$currentPromoValueFromLSBool = $9b9fb0750f8f8ccb$var$currentPromoValueFromLS === "true";
const $9b9fb0750f8f8ccb$export$702a4b36187033b7 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "registerCheckboxesState",
    default: {
        emailPromo: $9b9fb0750f8f8ccb$var$currentPromoValueFromLSBool
    }
});
const $9b9fb0750f8f8ccb$export$25d1b4614a995c49 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "loginState",
    default: {
        loading: false
    }
});
const $9b9fb0750f8f8ccb$export$89d88943573cfd68 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "latestPingState",
    default: 0
});
const $9b9fb0750f8f8ccb$export$741e7d002666f097 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "identityErrorState",
    default: {
        show: false,
        message: "Unknown error"
    }
});
const $9b9fb0750f8f8ccb$export$999d36e97dd00396 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "abandonRunState",
    default: {
        abandoningInProgress: false
    }
});
const $9b9fb0750f8f8ccb$export$72c737a0a43ed66b = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "matchmakingErrorState",
    default: {
        title: "...",
        message: "..."
    }
});
const $9b9fb0750f8f8ccb$export$5f79f90abe9d2b63 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "maintenanceModeState",
    default: {
        checkingMaintenanceModeStatusInProgress: true,
        isInmaintenanceMode: false
    }
});
const $9b9fb0750f8f8ccb$export$c220fc29a809546f = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "regionState",
    default: {
        shown: false,
        regionName: ""
    }
});
const $9b9fb0750f8f8ccb$export$80fa840cdc9361a9 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "serverEventFeedState",
    default: {
        events: []
    }
});
const $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "userState",
    default: {
        userType: (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous,
        loadingPlayerIdentity: true,
        userDetails: {
            _id: "...",
            userType: (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous,
            username: "...",
            createdAt: new Date(),
            SMG_Stats: {
                logins: 0,
                lastLoggedIn: new Date()
            },
            PVPZ_GameState: {
                currentRunId: "...",
                currentlyOnARun: false
            },
            PVPZ_Stats: {
                runsEmbarkedOn: 0,
                successfulExtractions: 0,
                failedExtractions: 0,
                goldLooted: 0,
                itemsLooted: 0,
                playerKills: 0,
                npcKills: 0,
                timeSpentOnRunsInSeconds: 0,
                distanceTravelled: 0,
                commonItemsLooted: 0,
                uncommonItemsLooted: 0,
                rareItemsLooted: 0,
                epicItemsLooted: 0,
                legendaryItemsLooted: 0
            },
            PVPZ_Stash: (0, $faa1b3449016497b$export$c23e01eb11268785)(),
            PVPZ_Preferences: {
                enableMusic: true,
                enableSoundEffects: true,
                preferredLanguage: "en",
                preferredMatchmakingRegion: "any"
            },
            PVPZ_Loadout: {
                characterSkin: -1,
                weaponOne: -1,
                weaponTwo: -1,
                gearOne: -1,
                gearTwo: -1,
                gearThree: -1,
                insuredSlot: -1
            }
        }
    }
});
const $9b9fb0750f8f8ccb$export$d78251c206367d5f = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "extractionInProgressState",
    default: {
        extractionProgress: 0
    }
});
const $9b9fb0750f8f8ccb$export$4e3ba682b8458616 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "loadoutCooldownState",
    default: {
        weaponOneCooldown: 100,
        weaponTwoCooldown: 100,
        gearOneCooldown: 100,
        gearTwoCooldown: 100,
        gearThreeCooldown: 100
    }
});
const $9b9fb0750f8f8ccb$export$e98a8743fbd387b9 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "loadoutChargesState",
    default: {
        gearOneCharges: -1,
        gearTwoCharges: -1,
        gearThreeCharges: -1
    }
});
const $9b9fb0750f8f8ccb$export$e24e5ed97d5f3d42 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "activeWeaponSlotState",
    default: (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne
});
const $9b9fb0750f8f8ccb$export$d67f9a35d18eb345 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "inGameLeaderboardState",
    default: {
        show: true,
        entries: []
    }
});
const $9b9fb0750f8f8ccb$export$23341af0bec1ee28 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "spectatingState",
    default: {
        spectating: false,
        spectatingPlayerName: "..."
    }
});
const $9b9fb0750f8f8ccb$export$c632688729fcb9a7 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "extractionTimerState",
    default: {
        timeRemainingInSeconds: (0, $a9786bc83f165385$export$6890cbbf7baa7104).MAX_RUN_DURATION_IN_SECONDS
    }
});
const $9b9fb0750f8f8ccb$export$d3f466f4fc70952 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "debugState",
    default: {
        skippingMenu: window.location.href.includes("skipMenu")
    }
});
const $9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "shopActionState",
    default: {
        shopActionInProgress: false
    }
});
const $9b9fb0750f8f8ccb$export$95c23f336a305d72 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "loadingState",
    default: {
        loadingAssets: true,
        progress: 0
    }
});
const $9b9fb0750f8f8ccb$export$29fa98681c68ecb7 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "extractionSuccessfulState",
    default: {
        show: false,
        loading: false,
        goldLooted: 0,
        runDuration: "..."
    }
});
const $9b9fb0750f8f8ccb$export$644c40fb1febeb7 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "youDiedState",
    default: {
        show: false,
        loading: false,
        killerName: "Loading...",
        runDuration: "Loading...",
        goldLost: "..."
    }
});
const $9b9fb0750f8f8ccb$export$b8b34d3739f5d143 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "fullScreenErrorState",
    default: {
        show: false,
        message: "Lost connection to server!",
        reason: ""
    }
});
const $9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "playerLoadoutState",
    default: {
        playerLoadoutOperationInProgress: false,
        loadout: {
            characterSkin: -1,
            weaponOne: -1,
            weaponTwo: -1,
            gearOne: -1,
            gearTwo: -1,
            gearThree: -1,
            insuredSlot: -1
        },
        loadoutScreen: {
            selectionMode: "none"
        }
    }
});
const $9b9fb0750f8f8ccb$export$1796ef2d8b76e06c = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "itemsLootedOnRunState",
    default: {
        showInventoryPanel: false,
        items: (0, $faa1b3449016497b$export$c23e01eb11268785)()
    }
});
const $9b9fb0750f8f8ccb$export$923d88b3f72a7929 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "lootedItemContainerState",
    default: {
        showPanel: false,
        itemContainerName: "Loot Chest",
        itemContainerId: "",
        items: (0, $faa1b3449016497b$export$c23e01eb11268785)()
    }
});
const $9b9fb0750f8f8ccb$export$50ab1c01fc6ede55 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "playerInventoryState",
    default: {
        inventoryOperationInProgress: false,
        items: (0, $faa1b3449016497b$export$c23e01eb11268785)()
    }
});
const $9b9fb0750f8f8ccb$export$7365d374980890c6 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "playerPreferencesState",
    default: {
        savingPreferencesInProgress: true,
        fromServer: {
            enableMusic: false,
            enableSoundEffects: false,
            preferredLanguage: "en",
            preferredMatchmakingRegion: "any"
        },
        local: {
            enableMusic: false,
            enableSoundEffects: false,
            preferredLanguage: "en",
            preferredMatchmakingRegion: "any"
        }
    }
});
const $9b9fb0750f8f8ccb$export$34e323431127bf02 = (0, $7ef244517b504261$export$aea217a45095ce11)({
    key: "JustWeaponsFromStash",
    get: ({ get: get  })=>{
        const allItems = get($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55);
        const weapons = {};
        for(const key in allItems.items){
            const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(parseInt(key));
            if (itemConfig.itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).Weapon) // @ts-ignore
            weapons[key] = allItems.items[key];
        }
        return weapons;
    }
});
const $9b9fb0750f8f8ccb$export$e478d6af9991afc6 = (0, $7ef244517b504261$export$aea217a45095ce11)({
    key: "JustGearFromStash",
    get: ({ get: get  })=>{
        const allItems = get($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55);
        const gear = {};
        for(const key in allItems.items){
            const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(parseInt(key));
            if (itemConfig.itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).ActiveGear || itemConfig.itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).PassiveGear) // @ts-ignore
            gear[key] = allItems.items[key];
        }
        return gear;
    }
});
const $9b9fb0750f8f8ccb$export$5bfac95b6ca4eca4 = (0, $7ef244517b504261$export$aea217a45095ce11)({
    key: "JustVendorTrashFromStash",
    get: ({ get: get  })=>{
        const allItems = get($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55);
        const vendorTrash = {};
        for(const key in allItems.items){
            const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(parseInt(key));
            if (itemConfig.itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).VendorTrash) // @ts-ignore
            vendorTrash[key] = allItems.items[key];
        }
        return vendorTrash;
    }
});
const $9b9fb0750f8f8ccb$export$6f811727066fa9af = (0, $7ef244517b504261$export$aea217a45095ce11)({
    key: "JustCollectorsItemsFromStash",
    get: ({ get: get  })=>{
        const allItems = get($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55);
        const collectorsItems = {};
        for(const key in allItems.items){
            const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(parseInt(key));
            if (itemConfig.itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).CollectorsItem) // @ts-ignore
            collectorsItems[key] = allItems.items[key];
        }
        return collectorsItems;
    }
});
const $9b9fb0750f8f8ccb$export$37c83b4c63c3c87f = (0, $7ef244517b504261$export$aea217a45095ce11)({
    key: "ProfileStats",
    get: ({ get: get  })=>{
        const { PVPZ_Stats: PVPZ_Stats  } = get($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb).userDetails;
        return PVPZ_Stats;
    }
});
const $9b9fb0750f8f8ccb$export$20aa5718ceb0ad82 = (0, $7ef244517b504261$export$aea217a45095ce11)({
    key: "QuantityOfItemsInRunInventory",
    get: ({ get: get  })=>{
        const { items: items  } = get($9b9fb0750f8f8ccb$export$1796ef2d8b76e06c);
        let totalItems = 0;
        for (const [_, quantity] of Object.entries(items))if (quantity > 0) totalItems += quantity;
        return totalItems;
    }
});
const $9b9fb0750f8f8ccb$export$ed3dc26e4263a468 = ()=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$923d88b3f72a7929);
    const { showPanel: showPanel  } = currentState;
    return showPanel;
};
const $9b9fb0750f8f8ccb$export$d5829f412ad50c76 = ()=>{
    const isDisconnectIntentional = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$64e34d6705ba6281);
    return isDisconnectIntentional;
};
const $9b9fb0750f8f8ccb$export$e72b59a15fc1f76 = (newScreen)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$af0d689d0f8c0f26, newScreen);
};
const $9b9fb0750f8f8ccb$export$ea5c4f81e9a958f4 = (newMode)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$a81c8bd4ed6c2681, newMode);
};
const $9b9fb0750f8f8ccb$export$fda554ce779f8ebc = (progress)=>{
    const currentLoadingState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$95c23f336a305d72);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$95c23f336a305d72, {
        ...currentLoadingState,
        progress: progress
    });
};
const $9b9fb0750f8f8ccb$var$UI_RemoveEventFromServerFeed = (eventId)=>{
    const currentFeed = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$80fa840cdc9361a9);
    const newEvents = currentFeed.events.filter((event)=>event.id !== eventId);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$80fa840cdc9361a9, {
        events: newEvents
    });
};
const $9b9fb0750f8f8ccb$export$4311e1a2433001ae = (serverEvent)=>{
    const currentFeed = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$80fa840cdc9361a9);
    // console.log("adding server event to feed:", serverEvent);
    setTimeout(()=>{
        $9b9fb0750f8f8ccb$var$UI_RemoveEventFromServerFeed(serverEvent.id);
    }, 10000);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$80fa840cdc9361a9, {
        events: [
            ...currentFeed.events,
            serverEvent
        ]
    });
};
const $9b9fb0750f8f8ccb$export$4e3301a0de828066 = ()=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$95c23f336a305d72, {
        loadingAssets: false,
        progress: 1
    });
};
const $9b9fb0750f8f8ccb$export$91a38d259b67210e = (identity)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
        userType: (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous,
        loadingPlayerIdentity: false,
        userDetails: {
            ...identity
        }
    });
};
const $9b9fb0750f8f8ccb$export$41e17486540c90b = (regionName)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$c220fc29a809546f, {
        shown: true,
        regionName: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(regionName)
    });
};
const $9b9fb0750f8f8ccb$export$293a1596637cb649 = ()=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$c220fc29a809546f);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$c220fc29a809546f, {
        ...currentState,
        shown: false
    });
};
const $9b9fb0750f8f8ccb$export$36bd996d858bb699 = (loadoutSlot, newPercentage)=>{
    if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616),
        weaponOneCooldown: newPercentage
    });
    else if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616),
        weaponTwoCooldown: newPercentage
    });
    else if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616),
        gearOneCooldown: newPercentage
    });
    else if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616),
        gearTwoCooldown: newPercentage
    });
    else if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$4e3ba682b8458616),
        gearThreeCooldown: newPercentage
    });
};
const $9b9fb0750f8f8ccb$export$e4fed43e8bd3e41f = (loadoutSlot, newCharges)=>{
    if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$e98a8743fbd387b9, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$e98a8743fbd387b9),
        gearOneCharges: newCharges
    });
    else if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$e98a8743fbd387b9, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$e98a8743fbd387b9),
        gearTwoCharges: newCharges
    });
    else if (loadoutSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree) (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$e98a8743fbd387b9, {
        ...(0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$e98a8743fbd387b9),
        gearThreeCharges: newCharges
    });
};
const $9b9fb0750f8f8ccb$export$8b96a41f9ed15ff0 = (intentional)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$64e34d6705ba6281, intentional);
};
const $9b9fb0750f8f8ccb$export$1e7c3af35249366 = (identity)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
        userType: (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered,
        loadingPlayerIdentity: false,
        userDetails: {
            ...identity
        }
    });
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$f166ba1253c74e5f, identity.username);
};
const $9b9fb0750f8f8ccb$export$b13946f7af8f1594 = (newPing)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$89d88943573cfd68, newPing);
};
const $9b9fb0750f8f8ccb$export$105985ba4db5af3f = (title, message)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$72c737a0a43ed66b, {
        title: title,
        message: message
    });
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$af0d689d0f8c0f26, $9b9fb0750f8f8ccb$export$b714373eb9ab036b.MatchmakingError);
};
const $9b9fb0750f8f8ccb$export$659811ec5a629f27 = (message, reason)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$b8b34d3739f5d143, {
        show: true,
        message: message,
        reason: reason !== undefined ? reason : ""
    });
};
const $9b9fb0750f8f8ccb$export$a6e2a162910a7a6 = (message)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$741e7d002666f097, {
        show: true,
        message: message
    });
};
const $9b9fb0750f8f8ccb$export$7e1a92d919d9ab21 = (newActiveSlot)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$e24e5ed97d5f3d42, newActiveSlot);
};
const $9b9fb0750f8f8ccb$export$dce591b3e402a805 = (preferences)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$7365d374980890c6, {
        savingPreferencesInProgress: false,
        fromServer: {
            ...preferences
        },
        local: {
            ...preferences
        }
    });
};
const $9b9fb0750f8f8ccb$export$6153c37a1e6341e2 = (inventory)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55, {
        inventoryOperationInProgress: false,
        items: inventory
    });
};
const $9b9fb0750f8f8ccb$export$3995aacaa8581db8 = (loadout)=>{
    const { loadoutScreen: loadoutScreen , playerLoadoutOperationInProgress: playerLoadoutOperationInProgress  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad);
    // console.log('loadout before:', getRecoil(playerLoadoutStateAtom));
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
        playerLoadoutOperationInProgress: playerLoadoutOperationInProgress,
        loadoutScreen: loadoutScreen,
        loadout: {
            ...loadout
        }
    });
// setTimeout(() => {
//     console.log('loadout after:', getRecoil(playerLoadoutStateAtom));
// }, 1000);
};
const $9b9fb0750f8f8ccb$export$33937c63fbdea3c9 = (openedItemContainerMsg)=>{
    const openedItemContainer = {
        [(0, $faa1b3449016497b$export$6d08773d2e66f8f2).None]: 0
    };
    for(let i = 0; i < openedItemContainerMsg.items.length; i++){
        const itemId = openedItemContainerMsg.items[i];
        const quantity = openedItemContainerMsg.quantities[i];
        // @ts-ignore TODO: this is valid, fix types
        openedItemContainer[itemId] = quantity;
    }
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$923d88b3f72a7929, {
        showPanel: true,
        itemContainerName: openedItemContainerMsg.containerName,
        itemContainerId: openedItemContainerMsg.itemContainerId,
        items: openedItemContainer
    });
};
const $9b9fb0750f8f8ccb$export$e73dafe305ab20de = (updatedLootedItemsMsg)=>{
    const itemsLootedOnRunAsContainerMap = {
        [(0, $faa1b3449016497b$export$6d08773d2e66f8f2).None]: 0
    };
    for(let i = 0; i < updatedLootedItemsMsg.items.length; i++){
        const itemId = updatedLootedItemsMsg.items[i];
        const quantity = updatedLootedItemsMsg.quantities[i];
        // @ts-ignore TODO: this is valid, fix types
        itemsLootedOnRunAsContainerMap[itemId] = quantity;
    }
    const { showInventoryPanel: showInventoryPanel  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1796ef2d8b76e06c);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1796ef2d8b76e06c, {
        showInventoryPanel: showInventoryPanel,
        items: itemsLootedOnRunAsContainerMap
    });
};
const $9b9fb0750f8f8ccb$export$8a4175547626753f = ()=>{
    const { showInventoryPanel: showInventoryPanel , items: items  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1796ef2d8b76e06c);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1796ef2d8b76e06c, {
        showInventoryPanel: !showInventoryPanel,
        items: items
    });
};
const $9b9fb0750f8f8ccb$export$98cfc4ed4d392760 = (loadout)=>{
    const { loadoutScreen: loadoutScreen  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
        playerLoadoutOperationInProgress: false,
        loadout: loadout,
        loadoutScreen: loadoutScreen
    });
};
const $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d = (mode)=>{
    const { loadoutScreen: loadoutScreen , loadout: loadout , playerLoadoutOperationInProgress: playerLoadoutOperationInProgress  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad);
    const { selectionMode: selectionMode  } = loadoutScreen;
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
        playerLoadoutOperationInProgress: playerLoadoutOperationInProgress,
        loadout: loadout,
        loadoutScreen: {
            ...loadoutScreen,
            selectionMode: selectionMode === mode ? "none" : mode
        }
    });
};
const $9b9fb0750f8f8ccb$export$428337d08d832f8d = (runDuration, goldEarned)=>{
    const runDurationAsString = (0, $276f03d77ac4b507$export$3acfa4651e1e404d)(runDuration);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$29fa98681c68ecb7, {
        show: true,
        loading: true,
        runDuration: runDurationAsString,
        goldLooted: goldEarned
    });
};
const $9b9fb0750f8f8ccb$export$8b4f61df848724e7 = ()=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$29fa98681c68ecb7);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$29fa98681c68ecb7, {
        ...currentState,
        loading: false
    });
};
const $9b9fb0750f8f8ccb$export$7fe418107821b4c2 = ()=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$644c40fb1febeb7);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$644c40fb1febeb7, {
        ...currentState,
        loading: false
    });
};
const $9b9fb0750f8f8ccb$export$8c55cea1fa2cfb67 = (killerName, runDuration, goldLost)=>{
    const runDurationAsString = (0, $276f03d77ac4b507$export$3acfa4651e1e404d)(runDuration);
    const goldLostAsString = goldLost.toString();
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$644c40fb1febeb7, {
        show: true,
        loading: true,
        killerName: killerName,
        runDuration: runDurationAsString,
        goldLost: goldLostAsString
    });
};
const $9b9fb0750f8f8ccb$export$d4d0e648646dc7d9 = (agreed)=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$702a4b36187033b7);
    (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).PromotionAccepted, agreed.toString());
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$702a4b36187033b7, {
        ...currentState,
        emailPromo: agreed
    });
};
const $9b9fb0750f8f8ccb$export$bffa017a369a8f48 = ()=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$644c40fb1febeb7);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$644c40fb1febeb7, {
        ...currentState,
        show: false,
        loading: false
    });
};
const $9b9fb0750f8f8ccb$export$b024072126f41aab = ()=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$d67f9a35d18eb345);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$d67f9a35d18eb345, {
        ...currentState,
        show: !currentState.show
    });
};
const $9b9fb0750f8f8ccb$export$ed7d33d6afbe02b1 = ()=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$923d88b3f72a7929, {
        itemContainerName: "Loot Chest",
        itemContainerId: "",
        items: (0, $faa1b3449016497b$export$c23e01eb11268785)(),
        showPanel: false
    });
};
const $9b9fb0750f8f8ccb$export$3bab0bc3cf5490e6 = (entityName)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$23341af0bec1ee28, {
        spectating: true,
        spectatingPlayerName: entityName
    });
};
const $9b9fb0750f8f8ccb$export$8e4e970d9670815f = (timeRemainingInSeconds)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$c632688729fcb9a7, {
        timeRemainingInSeconds: timeRemainingInSeconds
    });
};
const $9b9fb0750f8f8ccb$export$6a80ff18a0ca69a6 = (leaderboardState)=>{
    // console.log("SERVER TOLD US ABOUT UPDATED LEADERBOARD STATE:", leaderboardState);
    const parsedState = JSON.parse(leaderboardState);
    const currentUIState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$d67f9a35d18eb345);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$d67f9a35d18eb345, {
        ...currentUIState,
        entries: parsedState
    });
};
const $9b9fb0750f8f8ccb$export$78b432a0867784be = (progress)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$d78251c206367d5f, {
        extractionProgress: progress
    });
};
const $9b9fb0750f8f8ccb$export$f1f240c812b6ed34 = async ()=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$5f79f90abe9d2b63, {
        checkingMaintenanceModeStatusInProgress: true,
        isInmaintenanceMode: false
    });
    try {
        const result = await (0, $155c80569fd4a71a$export$59a77c4afb731802)();
        let { isInMaintenanceMode: isInMaintenanceMode  } = result;
        if (window.location.href.includes("?bypass=4ed2b85f-4266-4569-a2e8-64d37305226e")) isInMaintenanceMode = false;
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$5f79f90abe9d2b63, {
            checkingMaintenanceModeStatusInProgress: false,
            isInmaintenanceMode: isInMaintenanceMode
        });
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$5f79f90abe9d2b63, {
            checkingMaintenanceModeStatusInProgress: false,
            isInmaintenanceMode: true
        });
        console.error("Caught error in check maintenance mode");
        console.error(e);
    }
};
const $9b9fb0750f8f8ccb$export$997e0077ced76e1 = async (email, password)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$25d1b4614a995c49, {
        loading: true
    });
    let clientError = false;
    const currentIdentityState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
        ...currentIdentityState,
        loadingPlayerIdentity: true
    });
    if (email.length < 4) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__email_not_long_enough")
        });
        clientError = true;
    }
    if (password.length < 8) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__password_not_long_enough")
        });
        clientError = true;
    }
    if ((0, $276f03d77ac4b507$export$976c37132e9c6a10).test(email) === false) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__not_an_email_address")
        });
        clientError = true;
    }
    if (clientError) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$25d1b4614a995c49, {
            loading: false
        });
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
            ...currentIdentityState,
            loadingPlayerIdentity: false
        });
        return;
    }
    // console.log("Registering new account with details:");
    // console.log({
    //     email,
    //     password
    // });
    try {
        const result = await (0, $155c80569fd4a71a$export$a87cc9961e568037)(email, password);
        // console.log("Result of login:", result);
        const { authToken: authToken  } = result;
        (0, $bc8c2d9d797d9b02$export$34a3032bf337a702)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
        (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken, authToken);
        // console.log("check local storage state");
        (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$25d1b4614a995c49, {
            loading: false
        });
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
            ...currentIdentityState,
            loadingPlayerIdentity: false
        });
        console.error("Caught error in login");
        console.error(e);
        if (e instanceof (0, $8ae692c0d811c501$export$338c70d50f9836d1)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That isn't a valid email address!"
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$8504b66dedabad9)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That email address is already registered!"
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$b808c9b500e608bb)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "It looks like that account should sign in with a different method. Try again!"
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$de1c284e0d02c776)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That doesn't look like the right password, try again!"
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$85893ee190966bc4)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "No user was found with that email address!"
        });
        else (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "Something went wrong registering your account!"
        });
    }
};
const $9b9fb0750f8f8ccb$export$b567335756c9d894 = async (username, email, confirmEmail, password, confirmPassword)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$2e98e77ec812cd4d, {
        loading: true
    });
    let clientError = false;
    const registerCheckboxesState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$702a4b36187033b7);
    const { emailPromo: emailPromo , termsAndPrivacyPolicy: termsAndPrivacyPolicy  } = registerCheckboxesState;
    if (termsAndPrivacyPolicy === false) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__toast__must_agree_to_terms")
        });
        clientError = true;
    }
    const currentIdentityState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
        ...currentIdentityState,
        loadingPlayerIdentity: true
    });
    if (username.length < 1) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__username_too_short")
        });
        clientError = true;
    }
    if (password !== confirmPassword) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__passwords_dont_match")
        });
        clientError = true;
    }
    if (email !== confirmEmail) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__email_doesnt_match")
        });
        clientError = true;
    }
    if (email.length < 4 || confirmEmail.length < 4) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__email_not_long_enough")
        });
        clientError = true;
    }
    if (password.length < 8 || confirmPassword.length < 8) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__password_not_long_enough")
        });
        clientError = true;
    }
    if ((0, $276f03d77ac4b507$export$976c37132e9c6a10).test(email) === false) {
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__not_an_email_address")
        });
        clientError = true;
    }
    if (clientError) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$2e98e77ec812cd4d, {
            loading: false
        });
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
            ...currentIdentityState,
            loadingPlayerIdentity: false
        });
        return;
    }
    // console.log("Registering new account with details:");
    // console.log({
    //     username,
    //     email,
    //     confirmEmail,
    //     password,
    //     confirmPassword
    // });
    try {
        const result = await (0, $155c80569fd4a71a$export$a6b99f82a24af4e9)(username, email, confirmEmail, password, confirmPassword, emailPromo, termsAndPrivacyPolicy);
        // console.log("Result of register:", result);
        const { authToken: authToken  } = result;
        (0, $bc8c2d9d797d9b02$export$34a3032bf337a702)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
        (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken, authToken);
        // console.log("check local storage state");
        (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$2e98e77ec812cd4d, {
            loading: false
        });
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
            ...currentIdentityState,
            loadingPlayerIdentity: false
        });
        console.error("Caught error in register");
        console.error(e);
        if (e instanceof (0, $8ae692c0d811c501$export$7dfd19b7d8eb309)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That username is inappropriate! Try a different one."
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$7a990e7dd7005320)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That username is taken!"
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$338c70d50f9836d1)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That isn't a valid email address!"
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$8504b66dedabad9)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That email address is already registered!"
        });
        else (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "Something went wrong registering your account!"
        });
    }
};
const $9b9fb0750f8f8ccb$export$2592a4af2dd89e62 = async (newUsername)=>{
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    const { userType: userType  } = currentState;
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
        ...currentState,
        loadingPlayerIdentity: true
    });
    try {
        await (0, $155c80569fd4a71a$export$d8e5ff8d207947de)(userType, newUsername);
        const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
            ...currentState,
            loadingPlayerIdentity: false,
            userDetails: {
                ...currentState.userDetails,
                username: newUsername
            }
        });
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).SUCCESS,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("toast__username_changed")
        });
        $9b9fb0750f8f8ccb$export$e72b59a15fc1f76($9b9fb0750f8f8ccb$export$b714373eb9ab036b.MainMenu);
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
            ...currentState,
            loadingPlayerIdentity: false
        });
        console.error("Caught error in change username");
        console.error(e);
        if (e instanceof (0, $8ae692c0d811c501$export$7dfd19b7d8eb309)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That username is inappropriate! Try a different one."
        });
        else if (e instanceof (0, $8ae692c0d811c501$export$7a990e7dd7005320)) (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "That username is taken!"
        });
        else (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "Something went wrong changing your username! Try again."
        });
    }
};
const $9b9fb0750f8f8ccb$export$745bc315e91cf00b = async ()=>{
    const { userType: userType  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$999d36e97dd00396, {
        abandoningInProgress: true
    });
    try {
        const abandonRunResponse = await (0, $155c80569fd4a71a$export$9ea6a90857d7c467)(userType);
        (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false, true);
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$999d36e97dd00396, {
            abandoningInProgress: false
        });
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "Uh oh! Something went wrong abandoning your current run :("
        });
    }
};
const $9b9fb0750f8f8ccb$export$7a7184d464c6fe49 = async (skin)=>{
    const { userType: userType  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    const { loadout: loadout , loadoutScreen: loadoutScreen  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
        loadout: loadout,
        loadoutScreen: loadoutScreen,
        playerLoadoutOperationInProgress: true
    });
    try {
        const equippedSkinResponse = await (0, $155c80569fd4a71a$export$a117f742519595e2)(userType, skin);
        const { updatedLoadout: updatedLoadout  } = equippedSkinResponse;
        console.log("got equipped skin response:", equippedSkinResponse);
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
            loadout: updatedLoadout,
            loadoutScreen: loadoutScreen,
            playerLoadoutOperationInProgress: false
        });
    // PopToast({ status: ToastStatuses.SUCCESS, message: 'Skin equipped!' });
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
            loadout: loadout,
            loadoutScreen: loadoutScreen,
            playerLoadoutOperationInProgress: false
        });
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "Uh oh! Something went wrong equipping that skin :("
        });
    }
};
const $9b9fb0750f8f8ccb$export$707c9a05415c721f = async (slot, itemId)=>{
    const { userType: userType  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    const { loadout: loadout , loadoutScreen: loadoutScreen  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad);
    const currentInventoryState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55, {
        ...currentInventoryState,
        inventoryOperationInProgress: true
    });
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
        loadout: loadout,
        loadoutScreen: loadoutScreen,
        playerLoadoutOperationInProgress: true
    });
    try {
        const equippedItemResponse = await (0, $155c80569fd4a71a$export$316eeb8335d217de)(userType, slot, itemId);
        const { updatedLoadout: updatedLoadout , updatedInventory: updatedInventory  } = equippedItemResponse;
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55, {
            inventoryOperationInProgress: false,
            items: updatedInventory
        });
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
            loadout: updatedLoadout,
            loadoutScreen: loadoutScreen,
            playerLoadoutOperationInProgress: false
        });
    // PopToast({ status: ToastStatuses.SUCCESS, message: 'Item equipped!' });
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
            loadout: loadout,
            loadoutScreen: loadoutScreen,
            playerLoadoutOperationInProgress: false
        });
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$50ab1c01fc6ede55, {
            ...currentInventoryState,
            inventoryOperationInProgress: false
        });
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "Uh oh! Something went wrong equipping that item :("
        });
    }
};
const $9b9fb0750f8f8ccb$export$65b487fedafdd9e6 = async (sku)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: true
    });
    const response = await (0, $155c80569fd4a71a$export$7feec229e984cb9a)(sku);
    console.log("Response from backend:", response);
    const { link: link  } = response;
    window.location.href = link;
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: false
    });
    return response;
};
const $9b9fb0750f8f8ccb$export$a397c73219b6ab32 = async (skin)=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: true
    });
    const response = await (0, $155c80569fd4a71a$export$47e924e4b78aa4b6)(skin);
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: false
    });
    $9b9fb0750f8f8ccb$export$e72b59a15fc1f76($9b9fb0750f8f8ccb$export$b714373eb9ab036b.PurchaseSuccessful);
    return response;
};
const $9b9fb0750f8f8ccb$export$7088ca1845f00dc1 = async ()=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: true
    });
    const response = await (0, $155c80569fd4a71a$export$4a23007b16b45ce3)();
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: false
    });
    $9b9fb0750f8f8ccb$export$e72b59a15fc1f76($9b9fb0750f8f8ccb$export$b714373eb9ab036b.PurchaseSuccessful);
    return response;
};
const $9b9fb0750f8f8ccb$export$9ffb6b01ba1afaf4 = async ()=>{
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: true
    });
    const response = await (0, $155c80569fd4a71a$export$945e7e2dfa4ae369)();
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55, {
        shopActionInProgress: false
    });
    $9b9fb0750f8f8ccb$export$e72b59a15fc1f76($9b9fb0750f8f8ccb$export$b714373eb9ab036b.PurchaseSuccessful);
    return response;
};
const $9b9fb0750f8f8ccb$export$43c525c16a9d313 = async (slot)=>{
    const { userType: userType  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    const { loadout: loadout , loadoutScreen: loadoutScreen  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad);
    const timeoutDuration = 0;
    setTimeout(async ()=>{
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
            loadout: loadout,
            loadoutScreen: loadoutScreen,
            playerLoadoutOperationInProgress: true
        });
        try {
            const insuredSlotResponse = await (0, $155c80569fd4a71a$export$9168aba11906f7b7)(userType, slot);
            const { updatedLoadout: updatedLoadout  } = insuredSlotResponse;
            const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
            (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb, {
                ...currentState,
                userDetails: {
                    ...currentState.userDetails,
                    // @ts-ignore
                    PVPZ_Currency: {
                        // @ts-ignore
                        ...currentState.userDetails.PVPZ_Currency,
                        // @ts-ignore
                        insuranceCredits: currentState.userDetails.PVPZ_Currency.insuranceCredits - 1
                    }
                }
            });
            (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
                loadout: updatedLoadout,
                loadoutScreen: loadoutScreen,
                playerLoadoutOperationInProgress: false
            });
        // PopToast({ status: ToastStatuses.SUCCESS, message: 'Slot insured!' });
        } catch (e) {
            (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad, {
                loadout: loadout,
                loadoutScreen: loadoutScreen,
                playerLoadoutOperationInProgress: false
            });
            (0, $4a3136d799878a30$export$6b89521c3f482608)({
                status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                message: "Uh oh! Something went wrong insuring that item slot :("
            });
        }
    }, timeoutDuration);
};
const $9b9fb0750f8f8ccb$export$7e71fac318a16f2f = async ()=>{
    const { userType: userType  } = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$1be1edc9a09be8eb);
    const currentState = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$7365d374980890c6);
    const local = currentState.local;
    (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$7365d374980890c6, {
        ...currentState,
        savingPreferencesInProgress: true
    });
    try {
        const savedPreferences = await (0, $155c80569fd4a71a$export$2606dfc89cdc611)(userType, local);
        Lang = savedPreferences.preferredLanguage;
        document.querySelector("body").className = "";
        document.querySelector("body").classList.add(Lang);
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$7365d374980890c6, {
            fromServer: {
                ...savedPreferences
            },
            local: {
                ...savedPreferences
            },
            savingPreferencesInProgress: false
        });
        $9b9fb0750f8f8ccb$export$e72b59a15fc1f76($9b9fb0750f8f8ccb$export$b714373eb9ab036b.MainMenu);
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).SUCCESS,
            message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__settings_saved")
        });
    } catch (e) {
        (0, $4f76ed508686472d$exports.setRecoil)($9b9fb0750f8f8ccb$export$7365d374980890c6, {
            ...currentState,
            savingPreferencesInProgress: false
        });
        (0, $4a3136d799878a30$export$6b89521c3f482608)({
            status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
            message: "Uh oh! Something went wrong saving your settings :("
        });
    }
};
const $9b9fb0750f8f8ccb$export$a4d8782b5c88d429 = ()=>{
    const preferences = (0, $4f76ed508686472d$exports.getRecoil)($9b9fb0750f8f8ccb$export$7365d374980890c6);
    const { preferredMatchmakingRegion: preferredMatchmakingRegion  } = preferences.local;
    return preferredMatchmakingRegion;
}; //#endregion


var $832dafdaff9ab9c5$exports = {};
!function(t, i) {
    $832dafdaff9ab9c5$exports = i();
}(window, function() {
    return function(t) {
        var i = {};
        function e(o) {
            if (i[o]) return i[o].exports;
            var n = i[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(n.exports, n, n.exports, e), n.l = !0, n.exports;
        }
        return e.m = t, e.c = i, e.d = function(t, i, o) {
            e.o(t, i) || Object.defineProperty(t, i, {
                enumerable: !0,
                get: o
            });
        }, e.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, e.t = function(t, i) {
            if (1 & i && (t = e(t)), 8 & i) return t;
            if (4 & i && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (e.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & i && "string" != typeof t) for(var n in t)e.d(o, n, (function(i) {
                return t[i];
            }).bind(null, n));
            return o;
        }, e.n = function(t) {
            var i = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(i, "a", i), i;
        }, e.o = function(t, i) {
            return Object.prototype.hasOwnProperty.call(t, i);
        }, e.p = "", e(e.s = 0);
    }([
        function(t, i, e) {
            "use strict";
            e.r(i);
            var o, n = function(t, i) {
                var e = i.x - t.x, o = i.y - t.y;
                return Math.sqrt(e * e + o * o);
            }, s = function(t) {
                return t * (Math.PI / 180);
            }, r = function(t) {
                return t * (180 / Math.PI);
            }, d = new Map, a = function(t) {
                d.has(t) && clearTimeout(d.get(t)), d.set(t, setTimeout(t, 100));
            }, p = function(t, i, e) {
                for(var o, n = i.split(/[ ,]+/g), s = 0; s < n.length; s += 1)o = n[s], t.addEventListener ? t.addEventListener(o, e, !1) : t.attachEvent && t.attachEvent(o, e);
            }, c = function(t, i, e) {
                for(var o, n = i.split(/[ ,]+/g), s = 0; s < n.length; s += 1)o = n[s], t.removeEventListener ? t.removeEventListener(o, e) : t.detachEvent && t.detachEvent(o, e);
            }, l = function(t) {
                return t.preventDefault(), t.type.match(/^touch/) ? t.changedTouches : t;
            }, h = function() {
                return {
                    x: void 0 !== window.pageXOffset ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
                    y: void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
                };
            }, u = function(t, i) {
                i.top || i.right || i.bottom || i.left ? (t.style.top = i.top, t.style.right = i.right, t.style.bottom = i.bottom, t.style.left = i.left) : (t.style.left = i.x + "px", t.style.top = i.y + "px");
            }, f = function(t, i, e) {
                var o = y(t);
                for(var n in o)if (o.hasOwnProperty(n)) {
                    if ("string" == typeof i) o[n] = i + " " + e;
                    else {
                        for(var s = "", r = 0, d = i.length; r < d; r += 1)s += i[r] + " " + e + ", ";
                        o[n] = s.slice(0, -2);
                    }
                }
                return o;
            }, y = function(t) {
                var i = {};
                i[t] = "";
                return [
                    "webkit",
                    "Moz",
                    "o"
                ].forEach(function(e) {
                    i[e + t.charAt(0).toUpperCase() + t.slice(1)] = "";
                }), i;
            }, m = function(t, i) {
                for(var e in i)i.hasOwnProperty(e) && (t[e] = i[e]);
                return t;
            }, v = function(t, i) {
                if (t.length) for(var e = 0, o = t.length; e < o; e += 1)i(t[e]);
                else i(t);
            }, g = !!("ontouchstart" in window), b = !!window.PointerEvent, x = !!window.MSPointerEvent, O = {
                start: "mousedown",
                move: "mousemove",
                end: "mouseup"
            }, w = {};
            function _() {}
            b ? o = {
                start: "pointerdown",
                move: "pointermove",
                end: "pointerup, pointercancel"
            } : x ? o = {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointerUp"
            } : g ? (o = {
                start: "touchstart",
                move: "touchmove",
                end: "touchend, touchcancel"
            }, w = O) : o = O, _.prototype.on = function(t, i) {
                var e, o = t.split(/[ ,]+/g);
                this._handlers_ = this._handlers_ || {};
                for(var n = 0; n < o.length; n += 1)e = o[n], this._handlers_[e] = this._handlers_[e] || [], this._handlers_[e].push(i);
                return this;
            }, _.prototype.off = function(t, i) {
                return this._handlers_ = this._handlers_ || {}, void 0 === t ? this._handlers_ = {} : void 0 === i ? this._handlers_[t] = null : this._handlers_[t] && this._handlers_[t].indexOf(i) >= 0 && this._handlers_[t].splice(this._handlers_[t].indexOf(i), 1), this;
            }, _.prototype.trigger = function(t, i) {
                var e, o = this, n = t.split(/[ ,]+/g);
                o._handlers_ = o._handlers_ || {};
                for(var s = 0; s < n.length; s += 1)e = n[s], o._handlers_[e] && o._handlers_[e].length && o._handlers_[e].forEach(function(t) {
                    t.call(o, {
                        type: e,
                        target: o
                    }, i);
                });
            }, _.prototype.config = function(t) {
                this.options = this.defaults || {}, t && (this.options = function(t, i) {
                    var e = {};
                    for(var o in t)t.hasOwnProperty(o) && i.hasOwnProperty(o) ? e[o] = i[o] : t.hasOwnProperty(o) && (e[o] = t[o]);
                    return e;
                }(this.options, t));
            }, _.prototype.bindEvt = function(t, i) {
                var e = this;
                return e._domHandlers_ = e._domHandlers_ || {}, e._domHandlers_[i] = function() {
                    "function" == typeof e["on" + i] ? e["on" + i].apply(e, arguments) : console.warn('[WARNING] : Missing "on' + i + '" handler.');
                }, p(t, o[i], e._domHandlers_[i]), w[i] && p(t, w[i], e._domHandlers_[i]), e;
            }, _.prototype.unbindEvt = function(t, i) {
                return this._domHandlers_ = this._domHandlers_ || {}, c(t, o[i], this._domHandlers_[i]), w[i] && c(t, w[i], this._domHandlers_[i]), delete this._domHandlers_[i], this;
            };
            var T = _;
            function k(t, i) {
                return this.identifier = i.identifier, this.position = i.position, this.frontPosition = i.frontPosition, this.collection = t, this.defaults = {
                    size: 100,
                    threshold: .1,
                    color: "white",
                    fadeTime: 250,
                    dataOnly: !1,
                    restJoystick: !0,
                    restOpacity: .5,
                    mode: "dynamic",
                    zone: document.body,
                    lockX: !1,
                    lockY: !1,
                    shape: "circle"
                }, this.config(i), "dynamic" === this.options.mode && (this.options.restOpacity = 0), this.id = k.id, k.id += 1, this.buildEl().stylize(), this.instance = {
                    el: this.ui.el,
                    on: this.on.bind(this),
                    off: this.off.bind(this),
                    show: this.show.bind(this),
                    hide: this.hide.bind(this),
                    add: this.addToDom.bind(this),
                    remove: this.removeFromDom.bind(this),
                    destroy: this.destroy.bind(this),
                    setPosition: this.setPosition.bind(this),
                    resetDirection: this.resetDirection.bind(this),
                    computeDirection: this.computeDirection.bind(this),
                    trigger: this.trigger.bind(this),
                    position: this.position,
                    frontPosition: this.frontPosition,
                    ui: this.ui,
                    identifier: this.identifier,
                    id: this.id,
                    options: this.options
                }, this.instance;
            }
            k.prototype = new T, k.constructor = k, k.id = 0, k.prototype.buildEl = function(t) {
                return this.ui = {}, this.options.dataOnly || (this.ui.el = document.createElement("div"), this.ui.back = document.createElement("div"), this.ui.front = document.createElement("div"), this.ui.el.className = "nipple collection_" + this.collection.id, this.ui.back.className = "back", this.ui.front.className = "front", this.ui.el.setAttribute("id", "nipple_" + this.collection.id + "_" + this.id), this.ui.el.appendChild(this.ui.back), this.ui.el.appendChild(this.ui.front)), this;
            }, k.prototype.stylize = function() {
                if (this.options.dataOnly) return this;
                var t = this.options.fadeTime + "ms", i = function(t, i) {
                    var e = y(t);
                    for(var o in e)e.hasOwnProperty(o) && (e[o] = i);
                    return e;
                }("borderRadius", "50%"), e = f("transition", "opacity", t), o = {};
                return o.el = {
                    position: "absolute",
                    opacity: this.options.restOpacity,
                    display: "block",
                    zIndex: 999
                }, o.back = {
                    position: "absolute",
                    display: "block",
                    width: this.options.size + "px",
                    height: this.options.size + "px",
                    marginLeft: -this.options.size / 2 + "px",
                    marginTop: -this.options.size / 2 + "px",
                    background: this.options.color,
                    opacity: ".5"
                }, o.front = {
                    width: this.options.size / 2 + "px",
                    height: this.options.size / 2 + "px",
                    position: "absolute",
                    display: "block",
                    marginLeft: -this.options.size / 4 + "px",
                    marginTop: -this.options.size / 4 + "px",
                    background: this.options.color,
                    opacity: ".5",
                    transform: "translate(0px, 0px)"
                }, m(o.el, e), "circle" === this.options.shape && m(o.back, i), m(o.front, i), this.applyStyles(o), this;
            }, k.prototype.applyStyles = function(t) {
                for(var i in this.ui)if (this.ui.hasOwnProperty(i)) for(var e in t[i])this.ui[i].style[e] = t[i][e];
                return this;
            }, k.prototype.addToDom = function() {
                return this.options.dataOnly || document.body.contains(this.ui.el) || this.options.zone.appendChild(this.ui.el), this;
            }, k.prototype.removeFromDom = function() {
                return this.options.dataOnly || !document.body.contains(this.ui.el) || this.options.zone.removeChild(this.ui.el), this;
            }, k.prototype.destroy = function() {
                clearTimeout(this.removeTimeout), clearTimeout(this.showTimeout), clearTimeout(this.restTimeout), this.trigger("destroyed", this.instance), this.removeFromDom(), this.off();
            }, k.prototype.show = function(t) {
                var i = this;
                return i.options.dataOnly || (clearTimeout(i.removeTimeout), clearTimeout(i.showTimeout), clearTimeout(i.restTimeout), i.addToDom(), i.restCallback(), setTimeout(function() {
                    i.ui.el.style.opacity = 1;
                }, 0), i.showTimeout = setTimeout(function() {
                    i.trigger("shown", i.instance), "function" == typeof t && t.call(this);
                }, i.options.fadeTime)), i;
            }, k.prototype.hide = function(t) {
                var i = this;
                if (i.options.dataOnly) return i;
                if (i.ui.el.style.opacity = i.options.restOpacity, clearTimeout(i.removeTimeout), clearTimeout(i.showTimeout), clearTimeout(i.restTimeout), i.removeTimeout = setTimeout(function() {
                    var e = "dynamic" === i.options.mode ? "none" : "block";
                    i.ui.el.style.display = e, "function" == typeof t && t.call(i), i.trigger("hidden", i.instance);
                }, i.options.fadeTime), i.options.restJoystick) {
                    var e = i.options.restJoystick, o = {};
                    o.x = !0 === e || !1 !== e.x ? 0 : i.instance.frontPosition.x, o.y = !0 === e || !1 !== e.y ? 0 : i.instance.frontPosition.y, i.setPosition(t, o);
                }
                return i;
            }, k.prototype.setPosition = function(t, i) {
                var e = this;
                e.frontPosition = {
                    x: i.x,
                    y: i.y
                };
                var o = e.options.fadeTime + "ms", n = {};
                n.front = f("transition", [
                    "transform"
                ], o);
                var s = {
                    front: {}
                };
                s.front = {
                    transform: "translate(" + e.frontPosition.x + "px," + e.frontPosition.y + "px)"
                }, e.applyStyles(n), e.applyStyles(s), e.restTimeout = setTimeout(function() {
                    "function" == typeof t && t.call(e), e.restCallback();
                }, e.options.fadeTime);
            }, k.prototype.restCallback = function() {
                var t = {};
                t.front = f("transition", "none", ""), this.applyStyles(t), this.trigger("rested", this.instance);
            }, k.prototype.resetDirection = function() {
                this.direction = {
                    x: !1,
                    y: !1,
                    angle: !1
                };
            }, k.prototype.computeDirection = function(t) {
                var i, e, o, n = t.angle.radian, s = Math.PI / 4, r = Math.PI / 2;
                if (n > s && n < 3 * s && !t.lockX ? i = "up" : n > -s && n <= s && !t.lockY ? i = "left" : n > 3 * -s && n <= -s && !t.lockX ? i = "down" : t.lockY || (i = "right"), t.lockY || (e = n > -r && n < r ? "left" : "right"), t.lockX || (o = n > 0 ? "up" : "down"), t.force > this.options.threshold) {
                    var d, a = {};
                    for(d in this.direction)this.direction.hasOwnProperty(d) && (a[d] = this.direction[d]);
                    var p = {};
                    for(d in this.direction = {
                        x: e,
                        y: o,
                        angle: i
                    }, t.direction = this.direction, a)a[d] === this.direction[d] && (p[d] = !0);
                    if (p.x && p.y && p.angle) return t;
                    p.x && p.y || this.trigger("plain", t), p.x || this.trigger("plain:" + e, t), p.y || this.trigger("plain:" + o, t), p.angle || this.trigger("dir dir:" + i, t);
                } else this.resetDirection();
                return t;
            };
            var P = k;
            function E(t, i) {
                this.nipples = [], this.idles = [], this.actives = [], this.ids = [], this.pressureIntervals = {}, this.manager = t, this.id = E.id, E.id += 1, this.defaults = {
                    zone: document.body,
                    multitouch: !1,
                    maxNumberOfNipples: 10,
                    mode: "dynamic",
                    position: {
                        top: 0,
                        left: 0
                    },
                    catchDistance: 200,
                    size: 100,
                    threshold: .1,
                    color: "white",
                    fadeTime: 250,
                    dataOnly: !1,
                    restJoystick: !0,
                    restOpacity: .5,
                    lockX: !1,
                    lockY: !1,
                    shape: "circle",
                    dynamicPage: !1,
                    follow: !1
                }, this.config(i), "static" !== this.options.mode && "semi" !== this.options.mode || (this.options.multitouch = !1), this.options.multitouch || (this.options.maxNumberOfNipples = 1);
                var e = getComputedStyle(this.options.zone.parentElement);
                return e && "flex" === e.display && (this.parentIsFlex = !0), this.updateBox(), this.prepareNipples(), this.bindings(), this.begin(), this.nipples;
            }
            E.prototype = new T, E.constructor = E, E.id = 0, E.prototype.prepareNipples = function() {
                var t = this.nipples;
                t.on = this.on.bind(this), t.off = this.off.bind(this), t.options = this.options, t.destroy = this.destroy.bind(this), t.ids = this.ids, t.id = this.id, t.processOnMove = this.processOnMove.bind(this), t.processOnEnd = this.processOnEnd.bind(this), t.get = function(i) {
                    if (void 0 === i) return t[0];
                    for(var e = 0, o = t.length; e < o; e += 1)if (t[e].identifier === i) return t[e];
                    return !1;
                };
            }, E.prototype.bindings = function() {
                this.bindEvt(this.options.zone, "start"), this.options.zone.style.touchAction = "none", this.options.zone.style.msTouchAction = "none";
            }, E.prototype.begin = function() {
                var t = this.options;
                if ("static" === t.mode) {
                    var i = this.createNipple(t.position, this.manager.getIdentifier());
                    i.add(), this.idles.push(i);
                }
            }, E.prototype.createNipple = function(t, i) {
                var e = this.manager.scroll, o = {}, n = this.options, s = this.parentIsFlex ? e.x : e.x + this.box.left, r = this.parentIsFlex ? e.y : e.y + this.box.top;
                if (t.x && t.y) o = {
                    x: t.x - s,
                    y: t.y - r
                };
                else if (t.top || t.right || t.bottom || t.left) {
                    var d = document.createElement("DIV");
                    d.style.display = "hidden", d.style.top = t.top, d.style.right = t.right, d.style.bottom = t.bottom, d.style.left = t.left, d.style.position = "absolute", n.zone.appendChild(d);
                    var a = d.getBoundingClientRect();
                    n.zone.removeChild(d), o = t, t = {
                        x: a.left + e.x,
                        y: a.top + e.y
                    };
                }
                var p = new P(this, {
                    color: n.color,
                    size: n.size,
                    threshold: n.threshold,
                    fadeTime: n.fadeTime,
                    dataOnly: n.dataOnly,
                    restJoystick: n.restJoystick,
                    restOpacity: n.restOpacity,
                    mode: n.mode,
                    identifier: i,
                    position: t,
                    zone: n.zone,
                    frontPosition: {
                        x: 0,
                        y: 0
                    },
                    shape: n.shape
                });
                return n.dataOnly || (u(p.ui.el, o), u(p.ui.front, p.frontPosition)), this.nipples.push(p), this.trigger("added " + p.identifier + ":added", p), this.manager.trigger("added " + p.identifier + ":added", p), this.bindNipple(p), p;
            }, E.prototype.updateBox = function() {
                this.box = this.options.zone.getBoundingClientRect();
            }, E.prototype.bindNipple = function(t) {
                var i, e = this, o = function(t, o) {
                    i = t.type + " " + o.id + ":" + t.type, e.trigger(i, o);
                };
                t.on("destroyed", e.onDestroyed.bind(e)), t.on("shown hidden rested dir plain", o), t.on("dir:up dir:right dir:down dir:left", o), t.on("plain:up plain:right plain:down plain:left", o);
            }, E.prototype.pressureFn = function(t, i, e) {
                var o = this, n = 0;
                clearInterval(o.pressureIntervals[e]), o.pressureIntervals[e] = setInterval((function() {
                    var e = t.force || t.pressure || t.webkitForce || 0;
                    e !== n && (i.trigger("pressure", e), o.trigger("pressure " + i.identifier + ":pressure", e), n = e);
                }).bind(o), 100);
            }, E.prototype.onstart = function(t) {
                var i = this, e = i.options, o = t;
                t = l(t), i.updateBox();
                return v(t, function(n) {
                    i.actives.length < e.maxNumberOfNipples ? i.processOnStart(n) : o.type.match(/^touch/) && (Object.keys(i.manager.ids).forEach(function(e) {
                        if (Object.values(o.touches).findIndex(function(t) {
                            return t.identifier === e;
                        }) < 0) {
                            var n = [
                                t[0]
                            ];
                            n.identifier = e, i.processOnEnd(n);
                        }
                    }), i.actives.length < e.maxNumberOfNipples && i.processOnStart(n));
                }), i.manager.bindDocument(), !1;
            }, E.prototype.processOnStart = function(t) {
                var i, e = this, o = e.options, s = e.manager.getIdentifier(t), r = t.force || t.pressure || t.webkitForce || 0, d = {
                    x: t.pageX,
                    y: t.pageY
                }, a = e.getOrCreate(s, d);
                a.identifier !== s && e.manager.removeIdentifier(a.identifier), a.identifier = s;
                var p = function(i) {
                    i.trigger("start", i), e.trigger("start " + i.id + ":start", i), i.show(), r > 0 && e.pressureFn(t, i, i.identifier), e.processOnMove(t);
                };
                if ((i = e.idles.indexOf(a)) >= 0 && e.idles.splice(i, 1), e.actives.push(a), e.ids.push(a.identifier), "semi" !== o.mode) p(a);
                else {
                    if (!(n(d, a.position) <= o.catchDistance)) return a.destroy(), void e.processOnStart(t);
                    p(a);
                }
                return a;
            }, E.prototype.getOrCreate = function(t, i) {
                var e, o = this.options;
                return /(semi|static)/.test(o.mode) ? (e = this.idles[0]) ? (this.idles.splice(0, 1), e) : "semi" === o.mode ? this.createNipple(i, t) : (console.warn("Coudln't find the needed nipple."), !1) : e = this.createNipple(i, t);
            }, E.prototype.processOnMove = function(t) {
                var i = this.options, e = this.manager.getIdentifier(t), o = this.nipples.get(e), d = this.manager.scroll;
                if (function(t) {
                    return isNaN(t.buttons) ? 0 !== t.pressure : 0 !== t.buttons;
                }(t)) {
                    if (!o) return console.error("Found zombie joystick with ID " + e), void this.manager.removeIdentifier(e);
                    if (i.dynamicPage) {
                        var a = o.el.getBoundingClientRect();
                        o.position = {
                            x: d.x + a.left,
                            y: d.y + a.top
                        };
                    }
                    o.identifier = e;
                    var p = o.options.size / 2, c = {
                        x: t.pageX,
                        y: t.pageY
                    };
                    i.lockX && (c.y = o.position.y), i.lockY && (c.x = o.position.x);
                    var l, h, u, f, y, m, v, g, b, x, O = n(c, o.position), w = (l = c, h = o.position, u = h.x - l.x, f = h.y - l.y, r(Math.atan2(f, u))), _ = s(w), T = O / p, k = {
                        distance: O,
                        position: c
                    };
                    if ("circle" === o.options.shape ? (y = Math.min(O, p), v = o.position, g = y, x = {
                        x: 0,
                        y: 0
                    }, b = s(b = w), x.x = v.x - g * Math.cos(b), x.y = v.y - g * Math.sin(b), m = x) : (m = function(t, i, e) {
                        return {
                            x: Math.min(Math.max(t.x, i.x - e), i.x + e),
                            y: Math.min(Math.max(t.y, i.y - e), i.y + e)
                        };
                    }(c, o.position, p), y = n(m, o.position)), i.follow) {
                        if (O > p) {
                            var P = c.x - m.x, E = c.y - m.y;
                            o.position.x += P, o.position.y += E, o.el.style.top = o.position.y - (this.box.top + d.y) + "px", o.el.style.left = o.position.x - (this.box.left + d.x) + "px", O = n(c, o.position);
                        }
                    } else c = m, O = y;
                    var I = c.x - o.position.x, z = c.y - o.position.y;
                    o.frontPosition = {
                        x: I,
                        y: z
                    }, i.dataOnly || (o.ui.front.style.transform = "translate(" + I + "px," + z + "px)");
                    var D = {
                        identifier: o.identifier,
                        position: c,
                        force: T,
                        pressure: t.force || t.pressure || t.webkitForce || 0,
                        distance: O,
                        angle: {
                            radian: _,
                            degree: w
                        },
                        vector: {
                            x: I / p,
                            y: -z / p
                        },
                        raw: k,
                        instance: o,
                        lockX: i.lockX,
                        lockY: i.lockY
                    };
                    (D = o.computeDirection(D)).angle = {
                        radian: s(180 - w),
                        degree: 180 - w
                    }, o.trigger("move", D), this.trigger("move " + o.id + ":move", D);
                } else this.processOnEnd(t);
            }, E.prototype.processOnEnd = function(t) {
                var i = this, e = i.options, o = i.manager.getIdentifier(t), n = i.nipples.get(o), s = i.manager.removeIdentifier(n.identifier);
                n && (e.dataOnly || n.hide(function() {
                    "dynamic" === e.mode && (n.trigger("removed", n), i.trigger("removed " + n.id + ":removed", n), i.manager.trigger("removed " + n.id + ":removed", n), n.destroy());
                }), clearInterval(i.pressureIntervals[n.identifier]), n.resetDirection(), n.trigger("end", n), i.trigger("end " + n.id + ":end", n), i.ids.indexOf(n.identifier) >= 0 && i.ids.splice(i.ids.indexOf(n.identifier), 1), i.actives.indexOf(n) >= 0 && i.actives.splice(i.actives.indexOf(n), 1), /(semi|static)/.test(e.mode) ? i.idles.push(n) : i.nipples.indexOf(n) >= 0 && i.nipples.splice(i.nipples.indexOf(n), 1), i.manager.unbindDocument(), /(semi|static)/.test(e.mode) && (i.manager.ids[s.id] = s.identifier));
            }, E.prototype.onDestroyed = function(t, i) {
                this.nipples.indexOf(i) >= 0 && this.nipples.splice(this.nipples.indexOf(i), 1), this.actives.indexOf(i) >= 0 && this.actives.splice(this.actives.indexOf(i), 1), this.idles.indexOf(i) >= 0 && this.idles.splice(this.idles.indexOf(i), 1), this.ids.indexOf(i.identifier) >= 0 && this.ids.splice(this.ids.indexOf(i.identifier), 1), this.manager.removeIdentifier(i.identifier), this.manager.unbindDocument();
            }, E.prototype.destroy = function() {
                for(var t in this.unbindEvt(this.options.zone, "start"), this.nipples.forEach(function(t) {
                    t.destroy();
                }), this.pressureIntervals)this.pressureIntervals.hasOwnProperty(t) && clearInterval(this.pressureIntervals[t]);
                this.trigger("destroyed", this.nipples), this.manager.unbindDocument(), this.off();
            };
            var I = E;
            function z(t) {
                var i = this;
                i.ids = {}, i.index = 0, i.collections = [], i.scroll = h(), i.config(t), i.prepareCollections();
                var e = function() {
                    var t;
                    i.collections.forEach(function(e) {
                        e.forEach(function(e) {
                            t = e.el.getBoundingClientRect(), e.position = {
                                x: i.scroll.x + t.left,
                                y: i.scroll.y + t.top
                            };
                        });
                    });
                };
                p(window, "resize", function() {
                    a(e);
                });
                var o = function() {
                    i.scroll = h();
                };
                return p(window, "scroll", function() {
                    a(o);
                }), i.collections;
            }
            z.prototype = new T, z.constructor = z, z.prototype.prepareCollections = function() {
                var t = this;
                t.collections.create = t.create.bind(t), t.collections.on = t.on.bind(t), t.collections.off = t.off.bind(t), t.collections.destroy = t.destroy.bind(t), t.collections.get = function(i) {
                    var e;
                    return t.collections.every(function(t) {
                        return !(e = t.get(i));
                    }), e;
                };
            }, z.prototype.create = function(t) {
                return this.createCollection(t);
            }, z.prototype.createCollection = function(t) {
                var i = new I(this, t);
                return this.bindCollection(i), this.collections.push(i), i;
            }, z.prototype.bindCollection = function(t) {
                var i, e = this, o = function(t, o) {
                    i = t.type + " " + o.id + ":" + t.type, e.trigger(i, o);
                };
                t.on("destroyed", e.onDestroyed.bind(e)), t.on("shown hidden rested dir plain", o), t.on("dir:up dir:right dir:down dir:left", o), t.on("plain:up plain:right plain:down plain:left", o);
            }, z.prototype.bindDocument = function() {
                this.binded || (this.bindEvt(document, "move").bindEvt(document, "end"), this.binded = !0);
            }, z.prototype.unbindDocument = function(t) {
                Object.keys(this.ids).length && !0 !== t || (this.unbindEvt(document, "move").unbindEvt(document, "end"), this.binded = !1);
            }, z.prototype.getIdentifier = function(t) {
                var i;
                return t ? void 0 === (i = void 0 === t.identifier ? t.pointerId : t.identifier) && (i = this.latest || 0) : i = this.index, void 0 === this.ids[i] && (this.ids[i] = this.index, this.index += 1), this.latest = i, this.ids[i];
            }, z.prototype.removeIdentifier = function(t) {
                var i = {};
                for(var e in this.ids)if (this.ids[e] === t) {
                    i.id = e, i.identifier = this.ids[e], delete this.ids[e];
                    break;
                }
                return i;
            }, z.prototype.onmove = function(t) {
                return this.onAny("move", t), !1;
            }, z.prototype.onend = function(t) {
                return this.onAny("end", t), !1;
            }, z.prototype.oncancel = function(t) {
                return this.onAny("end", t), !1;
            }, z.prototype.onAny = function(t, i) {
                var e, o = this, n = "processOn" + t.charAt(0).toUpperCase() + t.slice(1);
                i = l(i);
                var s = function(t, i, e) {
                    e.ids.indexOf(i) >= 0 && (e[n](t), t._found_ = !0);
                };
                return v(i, function(t) {
                    e = o.getIdentifier(t), v(o.collections, s.bind(null, t, e)), t._found_ || o.removeIdentifier(e);
                }), !1;
            }, z.prototype.destroy = function() {
                this.unbindDocument(!0), this.ids = {}, this.index = 0, this.collections.forEach(function(t) {
                    t.destroy();
                }), this.off();
            }, z.prototype.onDestroyed = function(t, i) {
                if (this.collections.indexOf(i) < 0) return !1;
                this.collections.splice(this.collections.indexOf(i), 1);
            };
            var D = new z;
            i.default = {
                create: function(t) {
                    return D.create(t);
                },
                factory: D
            };
        }
    ]).default;
});


var // These are not arbitrary, these are the values in web engines for left right and middle! do not change!
$9bbbba98c8da0b07$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["Left"] = 0] = "Left";
    MouseButton[MouseButton["Middle"] = 1] = "Middle";
    MouseButton[MouseButton["Right"] = 2] = "Right";
})($9bbbba98c8da0b07$var$MouseButton || ($9bbbba98c8da0b07$var$MouseButton = {}));
var $9bbbba98c8da0b07$export$4b0075e5ea5e1f26;
(function(Keys) {
    Keys[// Language Agnostic
    "One"] = "1";
    Keys["Two"] = "2";
    Keys["Three"] = "3";
    Keys["Four"] = "4";
    Keys["Five"] = "5";
    Keys[// English
    "W"] = "w";
    Keys["A"] = "a";
    Keys["S"] = "s";
    Keys["D"] = "d";
    Keys["Q"] = "q";
    Keys["E"] = "e";
    Keys["I"] = "i";
    Keys["L"] = "l";
    Keys["UppercaseW"] = "W";
    Keys["UppercaseA"] = "A";
    Keys["UppercaseS"] = "S";
    Keys["UppercaseD"] = "D";
    Keys["UppercaseQ"] = "Q";
    Keys["UppercaseE"] = "E";
    Keys["UppercaseI"] = "I";
    Keys["UppercaseL"] = "L";
    Keys[// Russian
    "RussianUp"] = "ц";
    Keys["RussianLeft"] = "ф";
    Keys["RussianDown"] = "ы";
    Keys["RussianRight"] = "в";
    Keys["RussianE"] = "у";
    Keys["RussianI"] = "ш";
    Keys["RussianL"] = "д";
})($9bbbba98c8da0b07$export$4b0075e5ea5e1f26 || ($9bbbba98c8da0b07$export$4b0075e5ea5e1f26 = {}));
var $9bbbba98c8da0b07$export$1f94f10f2aaba1df;
(function(AlternateKeys) {
    AlternateKeys["UpArrow"] = "ArrowUp";
    AlternateKeys["LeftArrow"] = "ArrowLeft";
    AlternateKeys["DownArrow"] = "ArrowDown";
    AlternateKeys["RightArrow"] = "ArrowRight";
})($9bbbba98c8da0b07$export$1f94f10f2aaba1df || ($9bbbba98c8da0b07$export$1f94f10f2aaba1df = {}));
class $9bbbba98c8da0b07$export$ebed6576fc29bd3e extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    // todo better controller support
    // private readonly controllerAxesActiveThreshold = 0.3;
    constructor(){
        super();
        this.keyState = new Map();
        this.mouseState = new Map();
        this.mouseWheelScrolled = false;
        this.mouseWorldX = 0;
        this.mouseWorldY = 0;
        this.mouseScreenX = 0;
        this.mouseScreenY = 0;
        this.joystickAngleInRads = 0;
        this.lastOpenedInventoryAccumulator = 0.3;
        this.lastToggledLeaderboardAccumulator = 0.3;
        this.isMobile = false;
        this.aimJoystickActive = false;
        this.clickedGearOneThisFrame = false;
        this.clickedGearTwoThisFrame = false;
        this.clickedGearThreeThisFrame = false;
        this.clickedInventoryThisFrame = false;
        // disallows right click menu on the game screen
        document.addEventListener("contextmenu", (event)=>event.preventDefault());
        // listen for keystrokes, update keyboard state accordingly
        document.addEventListener("keydown", this._updateKeyState.bind(this));
        document.addEventListener("keyup", this._updateKeyState.bind(this));
        // listen for mouse clicks, update mouse state accordingly
        document.addEventListener("mousedown", (event)=>this.mouseState.set(event.button, true));
        document.addEventListener("mouseup", (event)=>this.mouseState.set(event.button, false));
        document.addEventListener("wheel", (event)=>{
            event.preventDefault();
            this.mouseWheelScrolled = true;
        });
        window.onblur = ()=>{
            this._resetAllkeyStates();
        };
    }
    getSystemName() {
        return "Input";
    }
    Initialize() {
        Game.Renderer.camera.on("globalmousemove", this._handleMouseMove.bind(this));
        this.isMobile = document.querySelector("html").classList.contains("mobile");
        if (this.isMobile) {
            const leftJoystickManager = (0, (/*@__PURE__*/$parcel$interopDefault($832dafdaff9ab9c5$exports))).create({
                zone: document.getElementById("left-joystick-zone"),
                mode: "dynamic"
            });
            // console.log(leftJoystickManager);
            const rightJoystickManager = (0, (/*@__PURE__*/$parcel$interopDefault($832dafdaff9ab9c5$exports))).create({
                zone: document.getElementById("right-joystick-zone"),
                mode: "dynamic"
            });
            // console.log(rightJoystickManager);
            leftJoystickManager.on("move", (__evt, joystickData)=>{
                if (joystickData.direction) {
                    const xDir = joystickData.direction.x;
                    const yDir = joystickData.direction.y;
                    // console.log(xDir, yDir);
                    if (xDir === "left") {
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.A, true);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseA, true);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.D, false);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseD, false);
                    } else if (xDir === "right") {
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.A, false);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseA, false);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.D, true);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseD, true);
                    }
                    if (yDir === "up") {
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.W, true);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseW, true);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.S, false);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseS, false);
                    } else if (yDir === "down") {
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.W, false);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseW, false);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.S, true);
                        this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseS, true);
                    }
                }
            });
            rightJoystickManager.on("move", (__evt, joystickData)=>{
                this.aimJoystickActive = true;
                if (joystickData.angle) this.joystickAngleInRads = -joystickData.angle.radian;
            });
            leftJoystickManager.on("end", ()=>{
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.W, false);
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseW, false);
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.A, false);
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseA, false);
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.S, false);
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseS, false);
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.D, false);
                this.keyState.set($9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseD, false);
            });
            rightJoystickManager.on("end", ()=>{
                this.aimJoystickActive = false;
            });
        }
        this.LogInfo("Ready!");
    }
    AimJoystickActive() {
        return this.aimJoystickActive;
    }
    _resetAllkeyStates() {
        this.keyState.forEach((_, key)=>{
            this.keyState.set(key, false);
        });
    }
    _updateKeyState(e) {
        // console.log(e.key);
        // Disable the minus and plus keys
        if (e.key === "-" || e.key === "+" || e.key === "_" || e.key === "=" || e.key === "CapsLock" || e.key === "Control" || e.key === "Shift" || e.key === "Alt" || e.key === "Meta" || e.key === "Tab") e.preventDefault();
        if (e.key === "F8") Game.Netcode.SendAdminShutdownCommand();
        if ((e.key === $9bbbba98c8da0b07$export$4b0075e5ea5e1f26.I || e.key === $9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseI || e.key === $9bbbba98c8da0b07$export$4b0075e5ea5e1f26.RussianI) && this.lastOpenedInventoryAccumulator >= 0.3) {
            (0, $9b9fb0750f8f8ccb$export$8a4175547626753f)();
            this.lastOpenedInventoryAccumulator = 0;
        }
        if ((e.key === $9bbbba98c8da0b07$export$4b0075e5ea5e1f26.L || e.key === $9bbbba98c8da0b07$export$4b0075e5ea5e1f26.UppercaseL || e.key === $9bbbba98c8da0b07$export$4b0075e5ea5e1f26.RussianL) && this.lastToggledLeaderboardAccumulator >= 0.3) {
            (0, $9b9fb0750f8f8ccb$export$b024072126f41aab)();
            this.lastToggledLeaderboardAccumulator = 0;
        }
        const keyToMutate = e.key.toLowerCase();
        this.keyState.set(keyToMutate, e.type === "keydown");
    }
    Update(__deltaTime) {
        this.lastOpenedInventoryAccumulator += __deltaTime;
        this.lastToggledLeaderboardAccumulator += __deltaTime;
        if (this.mouseWheelScrolled) this.mouseWheelScrolled = false;
        // todo better controller support
        // const gamepads = navigator.getGamepads();
        // if (gamepads.length >= 1) {
        //     const gamepad = gamepads[0];
        //     if (gamepad) {
        //         const [x, y] = gamepad.axes;
        //         // this.LogWarning('---');
        //         // this.LogWarning('left?', x <= -this._controllerAxesActiveThreshold);
        //         // this.LogWarning('right?', x >= this._controllerAxesActiveThreshold);
        //         // this.LogWarning('up?', y <= -this._controllerAxesActiveThreshold);
        //         // this.LogWarning('down?', y >= this._controllerAxesActiveThreshold);
        //         this.keyState.set('a', x <= -this.controllerAxesActiveThreshold);
        //         this.keyState.set('d', x >= this.controllerAxesActiveThreshold);
        //         this.keyState.set('w', y <= -this.controllerAxesActiveThreshold);
        //         this.keyState.set('s', y >= this.controllerAxesActiveThreshold);
        //     }
        // }
        // this.LogWarning('Update in input manager!');
        if (this.clickedGearOneThisFrame === true) this.clickedGearOneThisFrame = false;
        if (this.clickedGearTwoThisFrame === true) this.clickedGearTwoThisFrame = false;
        if (this.clickedGearThreeThisFrame === true) this.clickedGearThreeThisFrame = false;
        if (this.clickedInventoryThisFrame === true) this.clickedInventoryThisFrame = false;
    }
    Cleanup() {}
    _isMouseButtonPressed(button) {
        return !!this.mouseState.get(button);
    }
    LeftMousePressed() {
        return this._isMouseButtonPressed($9bbbba98c8da0b07$var$MouseButton.Left);
    }
    RightMousePressed() {
        return this._isMouseButtonPressed($9bbbba98c8da0b07$var$MouseButton.Right);
    }
    MiddleMousePressed() {
        return this._isMouseButtonPressed($9bbbba98c8da0b07$var$MouseButton.Middle);
    }
    Scrolled() {
        return this.mouseWheelScrolled;
    }
    IsKeyDown(key) {
        return !!this.keyState.get(key);
    }
    GetMouseWorldX() {
        return this.mouseWorldX;
    }
    GetMouseWorldY() {
        return this.mouseWorldY;
    }
    GetMouseScreenX() {
        return this.mouseScreenX;
    }
    GetMouseScreenY() {
        return this.mouseScreenY;
    }
    GetPlayerAimAngleFromCharacterPosition(x, y) {
        if (this.isMobile) return this.joystickAngleInRads;
        else {
            const camera = Game.Renderer.camera;
            const characterPositionInScreenSpace = camera.toScreen(x, y);
            return Math.atan2(this.GetMouseScreenY() - characterPositionInScreenSpace.y, this.GetMouseScreenX() - characterPositionInScreenSpace.x);
        }
    }
    ToggleFullScreen() {
        if (!document.fullscreenElement) document.documentElement.requestFullscreen();
        else if (document.exitFullscreen) document.exitFullscreen();
    }
    GetFacingDirectionBasedOnCurrentMouseWorldPosition(x, __lastFacing) {
        let facing;
        if (this.mouseWorldX < x) facing = (0, $69a172d21320641e$export$14498c06a50e821e).Left;
        else facing = (0, $69a172d21320641e$export$14498c06a50e821e).Right;
        return facing;
    }
    _handleMouseMove(event) {
        const { x: x , y: y  } = Game.Renderer.camera.toWorld(event.global.x, event.global.y);
        this.mouseWorldX = x;
        this.mouseWorldY = y;
        this.mouseScreenX = event.screen.x;
        this.mouseScreenY = event.screen.y;
    }
}




const $6da4cdfbd9ffc918$export$3c88819347ad1821 = {
    TARGET_TICKS_PER_SECOND: 20,
    TARGET_DELTA_IN_SECONDS: 0.05,
    TARGET_DELTA_IN_MS: 50
};


class $7a59c25e600d6438$export$44a6ae0ecea6459a extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(predictor){
        super();
        this.predictionReady = false;
        this.serverSideSelfReady = false;
        this.isConnected = false;
        this.sentPingTimestamp = Date.now();
        this.windowHasFocus = true;
        this.lastBroadcastedPingToUIAccumulator = 2;
        this.broadcastPingToUIThrottleMs = 2;
        this.lastSentInteractCommandAccumulator = 0;
        this.interactCommandThrottleMs = 0.7;
        this.predictor = predictor;
        Game.ListenForEvent("Resizer::GameWindowResizeComplete", this._onGameResized.bind(this));
        Game.ListenForEvent("Prediction::PredictionReady", ()=>{
            this.predictionReady = true;
        });
        Game.ListenForEvent("Bootstrap::MyServerSideEntityIsFullyCreatedLocally", (event)=>{
            // @ts-ignore
            const { myEntity: myEntity  } = event;
            this.myServerSideEntity = myEntity;
            this.serverSideSelfReady = true;
        });
        this.client = new (0, $688d8a22fbcfc874$exports.Client)((0, $282dc2f79e0204c8$export$dfbbeca3e3775011), (0, $4ebc683cc53721cf$exports.WebSocketClientAdapter));
        this.interpolator = new (0, $688d8a22fbcfc874$exports.Interpolator)(this.client);
        // TODO on disconnect callback in client when the API is available
        window.onfocus = ()=>{
            this.windowHasFocus = true;
        };
        window.onblur = ()=>{
            this.windowHasFocus = false;
            if (this.isConnected) {
                const inputCommand = {
                    ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).InputCommand,
                    up: false,
                    down: false,
                    left: false,
                    right: false,
                    usedWeapon: false,
                    genericSwappedWeapon: false,
                    swappedToFirstWeapon: false,
                    swappedToSecondWeapon: false,
                    usedGearOne: false,
                    usedGearTwo: false,
                    usedGearThree: false,
                    aim: 0,
                    delta: 0.016
                };
                if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION && this.predictionReady && this.predictor.LocallyPredictedEntityIsAlive()) this.predictor.PredictPlayerInputCommand(inputCommand);
                this.client.addCommand(inputCommand);
            }
        };
    }
    Initialize() {}
    getSystemName() {
        return "Netcode";
    }
    async Connect(serverAddress, connectionToken, gameClientVersion) {
        try {
            const { scaledWidth: scaledWidth , scaledHeight: scaledHeight  } = Game.Resizer.GetVisibleWorldBoundsWithCameraScale();
            const clientZoomLevel = Game.Renderer.CameraZoomLevel;
            const res = await this.client.connect(serverAddress, {
                connectionToken: connectionToken,
                clientWidth: scaledWidth,
                clientHeight: scaledHeight,
                gameClientVersion: gameClientVersion,
                clientZoomLevel: clientZoomLevel
            });
            Game.Rewards.GameplayStarted();
            this.LogInfo(`Connection response: ${res}`);
            this.isConnected = true;
            (0, $9b9fb0750f8f8ccb$export$ea5c4f81e9a958f4)((0, $9b9fb0750f8f8ccb$export$4d514e3f82243c75).InGame);
            var e;
            // TODO: this will eventually be surfaced via the this.client interface, for now dig deep to find it
            this.client.adapter.socket.addEventListener("close", ()=>{
                console.log("Socket to server closed!");
                this.isConnected = false;
                if ((0, $9b9fb0750f8f8ccb$export$d5829f412ad50c76)()) console.log("Disconnect is intentional; not showing server disconnect error");
                else (0, $9b9fb0750f8f8ccb$export$659811ec5a629f27)("Server shut down", "the server is down. It is likely going down for maintenance.");
            });
        } catch (err) {
            this.LogError("connection error");
            this.LogError(typeof err);
            this.LogError(err);
            let reasonExplanation;
            if (err === (0, $69a172d21320641e$export$cd1c2f7f06852a53).GameClientOutOfDate) reasonExplanation = "Your game client is out of date! Please update your game client to the latest version and try again.";
            else if (err === (0, $69a172d21320641e$export$cd1c2f7f06852a53).InvalidConnectionToken) reasonExplanation = "The server rejected your user! Please try again.";
            else if (err === (0, $69a172d21320641e$export$cd1c2f7f06852a53).PlayerAlreadyLoggedIn) reasonExplanation = "You're already logged in!";
            else reasonExplanation = "Unknown connection error :(";
            (0, $9b9fb0750f8f8ccb$export$659811ec5a629f27)("Server connection error!", reasonExplanation);
            return;
        }
        this.LogInfo("Ready!");
    }
    ReceivedPingAck() {
        const pingDuration = Date.now() - this.sentPingTimestamp;
        (0, $9b9fb0750f8f8ccb$export$b13946f7af8f1594)(pingDuration);
    }
    _onGameResized({ newScaledWidth: newScaledWidth , newScaledHeight: newScaledHeight  }) {
        // console.warn("sending server our new bounds with zoom level:", Game.Renderer.CameraZoomLevel);
        this.client.addCommand({
            ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ClientViewBoundsChangedCommand,
            cw: newScaledWidth,
            ch: newScaledHeight,
            cz: Game.Renderer.CameraZoomLevel
        });
    }
    SendAdminShutdownCommand() {
        this.client.addCommand({
            ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).AdminShutdownCommand,
            shutdown: true
        });
    }
    SendSpectateKillerCommand() {
        this.client.addCommand({
            ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).SpectateMyKillerCommand,
            spectateMyKiller: true
        });
    }
    SendLootItemCommand(itemContainerId, itemId) {
        this.client.addCommand({
            ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).LootItemCommand,
            interactingWithContainerOfId: itemContainerId,
            itemIdToLoot: itemId
        });
    }
    Update(deltaTime) {
        if (this.isConnected) {
            // Interpolate two server ticks worth of data
            const interpolatorState = this.interpolator.getInterpolatedState((0, $6da4cdfbd9ffc918$export$3c88819347ad1821).TARGET_DELTA_IN_MS * 2);
            while(this.client.network.messages.length > 0)Game.ProcessMessage(this.client.network.messages.pop());
            interpolatorState.forEach((snapshot)=>{
                snapshot.createEntities.forEach((entityToCreate)=>{
                    Game.AddEntity(entityToCreate);
                });
                snapshot.updateEntities.forEach((entityUpdatePayload)=>{
                    Game.UpdateEntity(entityUpdatePayload);
                });
                snapshot.deleteEntities.forEach((nid)=>{
                    Game.DeleteEntity(nid);
                });
            });
            // Only send input commands if our server-side entity is both fully created locally, as well as alive, and hasnt extracted successfully
            if (this.serverSideSelfReady && this.myServerSideEntity.isAlive && this.myServerSideEntity.extractionSuccessful === false && this.windowHasFocus) {
                // Movement inputs
                const up = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).W) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$1f94f10f2aaba1df).UpArrow) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).RussianUp) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).UppercaseW);
                const down = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).S) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$1f94f10f2aaba1df).DownArrow) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).RussianDown) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).UppercaseS);
                const left = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).A) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$1f94f10f2aaba1df).LeftArrow) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).RussianLeft) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).UppercaseA);
                const right = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).D) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$1f94f10f2aaba1df).RightArrow) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).RussianRight) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).UppercaseD);
                const interacted = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).E) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).RussianE) || Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).UppercaseE);
                // Weapon and gear inputs
                // let usedWeapon = Game.Input.LeftMousePressed();
                const usedWeapon = Game.Renderer.ClickedRendererThisFrame() || Game.Input.AimJoystickActive();
                const genericSwappedWeapon = Game.Input.Scrolled();
                const swappedToFirstWeapon = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).One);
                const swappedToSecondWeapon = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).Two);
                const usedGearOne = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).Three) || Game.Input.clickedGearOneThisFrame;
                const usedGearTwo = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).Four) || Game.Input.clickedGearTwoThisFrame;
                const usedGearThree = Game.Input.IsKeyDown((0, $9bbbba98c8da0b07$export$4b0075e5ea5e1f26).Five) || Game.Input.clickedGearThreeThisFrame;
                let aim = 0;
                // If prediction is enabled, use the predicted position of the player to calculate aim angle
                if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION && this.predictionReady) aim = Game.Input.GetPlayerAimAngleFromCharacterPosition(this.predictor.GetPredictedEntityX(), this.predictor.GetPredictedEntityY());
                else if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION === false && this.serverSideSelfReady) // If prediction is disabled, use the server-side authoritative position of the player to calculate aim angle
                aim = Game.Input.GetPlayerAimAngleFromCharacterPosition(Game.Renderer.GetMyLocalAuthoritativeEntityX(), Game.Renderer.GetMyLocalAuthoritativeEntityY());
                const inputCommand = {
                    ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).InputCommand,
                    up: up,
                    down: down,
                    left: left,
                    right: right,
                    usedWeapon: usedWeapon,
                    genericSwappedWeapon: genericSwappedWeapon,
                    swappedToFirstWeapon: swappedToFirstWeapon,
                    swappedToSecondWeapon: swappedToSecondWeapon,
                    usedGearOne: usedGearOne,
                    usedGearTwo: usedGearTwo,
                    usedGearThree: usedGearThree,
                    aim: aim,
                    delta: deltaTime
                };
                this.lastBroadcastedPingToUIAccumulator += deltaTime;
                this.lastSentInteractCommandAccumulator += deltaTime;
                if (this.lastBroadcastedPingToUIAccumulator > this.broadcastPingToUIThrottleMs) {
                    // console.log(Object.keys(this.client));
                    // @ts-ignore
                    // console.log(this.client.latency);
                    // @ts-ignore
                    // console.log(this.client.network.latency);
                    // UI_UpdateLatestPing(this.client.network.latency);
                    const pingCommand = {
                        ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlaceholderPingCommand,
                        ping: true
                    };
                    this.sentPingTimestamp = Date.now();
                    this.client.addCommand(pingCommand);
                    this.lastBroadcastedPingToUIAccumulator = 0;
                }
                if (interacted && this.lastSentInteractCommandAccumulator > this.interactCommandThrottleMs) // console.warn("@@@ throttled client send interact command!");
                {
                    if (this.myServerSideEntity.InteractingWithContainerOfId !== null) {
                        const interactCommand = {
                            ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).InteractCommand,
                            interactingWithContainerOfId: this.myServerSideEntity.InteractingWithContainerOfId
                        };
                        this.client.addCommand(interactCommand);
                        this.lastSentInteractCommandAccumulator = 0;
                    }
                }
                if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION && this.predictionReady && this.predictor.LocallyPredictedEntityIsAlive()) // console.log('@@@');
                // console.log(this.predictionReady);
                // console.log(this.predictor.LocallyPredictedEntityIsAlive());
                this.predictor.PredictPlayerInputCommand(inputCommand);
                this.client.addCommand(inputCommand);
            }
            this.client.flush();
        }
    }
    Cleanup() {
        this.LogInfo("Cleaning up...");
    }
}







var $5193b59038b4228e$export$c370bc722bf6d86a;
(function(DebugShape) {
    DebugShape[DebugShape["Circle"] = 0] = "Circle";
    DebugShape[DebugShape["Rectangle"] = 1] = "Rectangle";
    DebugShape[DebugShape["Line"] = 2] = "Line";
})($5193b59038b4228e$export$c370bc722bf6d86a || ($5193b59038b4228e$export$c370bc722bf6d86a = {}));
class $5193b59038b4228e$export$8c72b781155167e0 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.shouldSkipMenu = false;
        this.gameHasStarted = false;
        this.assetsAreLoaded = false;
        this.identityIsLoaded = false;
        this.drawnDebugShapes = new Map();
    }
    getSystemName() {
        return "Debug";
    }
    Initialize() {
        if (window.location.href.includes("skipMenu=true") && window.location.href.includes("localhost")) this.shouldSkipMenu = true;
        Game.ListenForEvent("Assets::Loaded", ()=>{
            this.assetsAreLoaded = true;
        });
        Game.ListenForEvent("Identity::Identified_Anonymous", (__identity)=>{
            this.identityIsLoaded = true;
        });
        Game.ListenForEvent("Identity::Identified_Registered", ()=>{
            this.identityIsLoaded = true;
        });
        document.addEventListener("keydown", (event)=>{
            if (event.key === "F1") {
                event.preventDefault();
                let randomEvent;
                if (Math.random() <= 0.16) randomEvent = {
                    id: Math.floor(Math.random() * 10000),
                    type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).Loot,
                    username: `Sam#${Math.floor(Math.random() * 10000)}`,
                    rarity: (0, $faa1b3449016497b$export$d2ffa9ea74cc769f).Legendary,
                    locationX: Math.floor(Math.random() * 3999),
                    locationY: Math.floor(Math.random() * 3999)
                };
                else if (Math.random() <= 0.32) randomEvent = {
                    id: Math.floor(Math.random() * 10000),
                    type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).Kill,
                    killer: `Markiplier#${Math.floor(Math.random() * 10000)}`,
                    victim: `PewDiePie#${Math.floor(Math.random() * 10000)}`,
                    locationX: Math.floor(Math.random() * 3999),
                    locationY: Math.floor(Math.random() * 3999)
                };
                else if (Math.random() <= 0.48) randomEvent = {
                    id: Math.floor(Math.random() * 10000),
                    type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).BossSpawn,
                    locationX: Math.floor(Math.random() * 3999),
                    locationY: Math.floor(Math.random() * 3999),
                    bossName: Math.random() > 0.5 ? "GRONK" : "Iron Fox"
                };
                else if (Math.random() <= 0.64) randomEvent = {
                    id: Math.floor(Math.random() * 10000),
                    type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).ExtractionStarted,
                    playerName: `Sam#${Math.floor(Math.random() * 1000000)}`,
                    locationX: Math.floor(Math.random() * 3999),
                    locationY: Math.floor(Math.random() * 3999)
                };
                else if (Math.random() <= 0.83) randomEvent = {
                    id: Math.floor(Math.random() * 10000),
                    type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).ExtractionSuccessful,
                    playerName: `Sam#${Math.floor(Math.random() * 1000000)}`,
                    locationX: Math.floor(Math.random() * 3999),
                    locationY: Math.floor(Math.random() * 3999)
                };
                else randomEvent = {
                    id: Math.floor(Math.random() * 10000),
                    type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).BossAttack,
                    locationX: Math.floor(Math.random() * 3999),
                    locationY: Math.floor(Math.random() * 3999),
                    bossName: Math.random() > 0.5 ? "GRONK" : "Iron Fox"
                };
                (0, $9b9fb0750f8f8ccb$export$4311e1a2433001ae)(randomEvent);
            }
            if (event.key === "F2") event.preventDefault();
            if (event.key === "F3") event.preventDefault();
            if (event.key === "F4") event.preventDefault();
            if (event.key === "F5") event.preventDefault();
            if (event.key === "F6") event.preventDefault();
            if (event.key === "F7") event.preventDefault();
            if (event.key === "F8") event.preventDefault();
            if (event.key === "F9") {
                event.preventDefault();
                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).KitTest);
            }
            if (event.key === "F10") {
                event.preventDefault();
                const stats = document.querySelector("#stats");
                if (stats.style.display === "none" || stats.style.display === "") stats.style.display = "Flex";
                else stats.style.display = "none";
            }
        });
        this.LogInfo("Ready!");
    }
    DrawDebugShape(x, y, shape, shapeDetails) {
        if (shape === $5193b59038b4228e$export$c370bc722bf6d86a.Circle) {
            const { radius: radius , destroyAfterSeconds: destroyAfterSeconds  } = shapeDetails;
            console.log("server told us to draw circle at " + x + ", " + y + " with radius " + radius);
            const key = `circle::x${x},y${y},r${radius}`;
            if (this.drawnDebugShapes.has(key)) return; // dont re-draw the same shape
            else {
                const circle = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
                circle.lineStyle(2, 0x00ff00, 1);
                circle.drawCircle(x, y, radius);
                circle.endFill();
                Game.Renderer.AddDebugGraphics(circle);
                this.drawnDebugShapes.set(key, circle);
                if (destroyAfterSeconds) setTimeout(()=>{
                    circle.destroy();
                    this.drawnDebugShapes.delete(key);
                }, destroyAfterSeconds * 1000);
            }
        } else if (shape === $5193b59038b4228e$export$c370bc722bf6d86a.Rectangle) {
            const { height: height , width: width , destroyAfterSeconds: destroyAfterSeconds  } = shapeDetails;
            console.log("server told us to draw rectangle at " + x + ", " + y + " with width " + width + " and height " + height);
            const key = `rectangle::x${x},y${y},w${width},h${height}`;
            if (this.drawnDebugShapes.has(key)) return; // dont re-draw the same shape
            else {
                const rectangle = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
                rectangle.lineStyle(2, 0xff0000, 1);
                rectangle.drawRect(x, y, width, height);
                rectangle.endFill();
                Game.Renderer.AddDebugGraphics(rectangle);
                this.drawnDebugShapes.set(key, rectangle);
                if (destroyAfterSeconds) setTimeout(()=>{
                    rectangle.destroy();
                    this.drawnDebugShapes.delete(key);
                }, destroyAfterSeconds * 1000);
            }
        } else if (shape === $5193b59038b4228e$export$c370bc722bf6d86a.Line) {
            const { destX: destX , destY: destY , destroyAfterSeconds: destroyAfterSeconds  } = shapeDetails;
            console.log("server told us to draw line from " + x + ", " + y + " to " + destX + ", " + destY);
            const key = `line::x${x},y${y},destX${destX},destY${destY}`;
            if (this.drawnDebugShapes.has(key)) return; // dont re-draw the same shape
            else {
                const line = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
                line.lineStyle(2, 0x0000ff, 1);
                line.moveTo(x, y);
                line.lineTo(destX, destY);
                line.endFill();
                Game.Renderer.AddDebugGraphics(line);
                this.drawnDebugShapes.set(key, line);
                if (destroyAfterSeconds) setTimeout(()=>{
                    line.destroy();
                    this.drawnDebugShapes.delete(key);
                }, destroyAfterSeconds * 1000);
            }
        }
    }
    Update(__deltaTime) {
        if (this.shouldSkipMenu && this.gameHasStarted === false && this.assetsAreLoaded && this.identityIsLoaded) {
            this.gameHasStarted = true;
            Game.EmitEvent("Debug::SkipMenu");
        }
    }
    Cleanup() {}
}









var $2104f92cbe769454$exports = {};
// Version 0.9.0 - Copyright 2012 - 2021 -  Jim Riecken <jimr@jimr.ca>
//
// Released under the MIT License - https://github.com/jriecken/sat-js
//
// A simple library for determining intersections of circles and
// polygons using the Separating Axis Theorem.
/** @preserve SAT.js - Version 0.9.0 - Copyright 2012 - 2021 - Jim Riecken <jimr@jimr.ca> - released under the MIT License. https://github.com/jriecken/sat-js */ /*global define: false, module: false*/ /*jshint shadow:true, sub:true, forin:true, noarg:true, noempty:true,
  eqeqeq:true, bitwise:true, strict:true, undef:true,
  curly:true, browser:true */ // Create a UMD wrapper for SAT. Works in:
//
//  - Plain browser via global SAT variable
//  - AMD loader (like require.js)
//  - Node.js
//
// The quoted properties all over the place are used so that the Closure Compiler
// does not mangle the exposed API in advanced mode.
/**
 * @param {*} root - The global scope
 * @param {Function} factory - Factory that creates SAT module
 */ (function(root, factory) {
    "use strict";
    if (typeof define === "function" && define["amd"]) define(factory);
    else $2104f92cbe769454$exports = factory();
})($2104f92cbe769454$exports, function() {
    "use strict";
    var SAT = {};
    //
    // ## Vector
    //
    // Represents a vector in two dimensions with `x` and `y` properties.
    // Create a new Vector, optionally passing in the `x` and `y` coordinates. If
    // a coordinate is not specified, it will be set to `0`
    /**
   * @param {?number=} x The x position.
   * @param {?number=} y The y position.
   * @constructor
   */ function Vector(x, y) {
        this["x"] = x || 0;
        this["y"] = y || 0;
    }
    SAT["Vector"] = Vector;
    // Alias `Vector` as `V`
    SAT["V"] = Vector;
    // Copy the values of another Vector into this one.
    /**
   * @param {Vector} other The other Vector.
   * @return {Vector} This for chaining.
   */ Vector.prototype["copy"] = Vector.prototype.copy = function(other) {
        this["x"] = other["x"];
        this["y"] = other["y"];
        return this;
    };
    // Create a new vector with the same coordinates as this on.
    /**
   * @return {Vector} The new cloned vector
   */ Vector.prototype["clone"] = Vector.prototype.clone = function() {
        return new Vector(this["x"], this["y"]);
    };
    // Change this vector to be perpendicular to what it was before. (Effectively
    // roatates it 90 degrees in a clockwise direction)
    /**
   * @return {Vector} This for chaining.
   */ Vector.prototype["perp"] = Vector.prototype.perp = function() {
        var x = this["x"];
        this["x"] = this["y"];
        this["y"] = -x;
        return this;
    };
    // Rotate this vector (counter-clockwise) by the specified angle (in radians).
    /**
   * @param {number} angle The angle to rotate (in radians)
   * @return {Vector} This for chaining.
   */ Vector.prototype["rotate"] = Vector.prototype.rotate = function(angle) {
        var x = this["x"];
        var y = this["y"];
        this["x"] = x * Math.cos(angle) - y * Math.sin(angle);
        this["y"] = x * Math.sin(angle) + y * Math.cos(angle);
        return this;
    };
    // Reverse this vector.
    /**
   * @return {Vector} This for chaining.
   */ Vector.prototype["reverse"] = Vector.prototype.reverse = function() {
        this["x"] = -this["x"];
        this["y"] = -this["y"];
        return this;
    };
    // Normalize this vector.  (make it have length of `1`)
    /**
   * @return {Vector} This for chaining.
   */ Vector.prototype["normalize"] = Vector.prototype.normalize = function() {
        var d = this.len();
        if (d > 0) {
            this["x"] = this["x"] / d;
            this["y"] = this["y"] / d;
        }
        return this;
    };
    // Add another vector to this one.
    /**
   * @param {Vector} other The other Vector.
   * @return {Vector} This for chaining.
   */ Vector.prototype["add"] = Vector.prototype.add = function(other) {
        this["x"] += other["x"];
        this["y"] += other["y"];
        return this;
    };
    // Subtract another vector from this one.
    /**
   * @param {Vector} other The other Vector.
   * @return {Vector} This for chaiing.
   */ Vector.prototype["sub"] = Vector.prototype.sub = function(other) {
        this["x"] -= other["x"];
        this["y"] -= other["y"];
        return this;
    };
    // Scale this vector. An independent scaling factor can be provided
    // for each axis, or a single scaling factor that will scale both `x` and `y`.
    /**
   * @param {number} x The scaling factor in the x direction.
   * @param {?number=} y The scaling factor in the y direction.  If this
   *   is not specified, the x scaling factor will be used.
   * @return {Vector} This for chaining.
   */ Vector.prototype["scale"] = Vector.prototype.scale = function(x, y) {
        this["x"] *= x;
        this["y"] *= typeof y != "undefined" ? y : x;
        return this;
    };
    // Project this vector on to another vector.
    /**
   * @param {Vector} other The vector to project onto.
   * @return {Vector} This for chaining.
   */ Vector.prototype["project"] = Vector.prototype.project = function(other) {
        var amt = this.dot(other) / other.len2();
        this["x"] = amt * other["x"];
        this["y"] = amt * other["y"];
        return this;
    };
    // Project this vector onto a vector of unit length. This is slightly more efficient
    // than `project` when dealing with unit vectors.
    /**
   * @param {Vector} other The unit vector to project onto.
   * @return {Vector} This for chaining.
   */ Vector.prototype["projectN"] = Vector.prototype.projectN = function(other) {
        var amt = this.dot(other);
        this["x"] = amt * other["x"];
        this["y"] = amt * other["y"];
        return this;
    };
    // Reflect this vector on an arbitrary axis.
    /**
   * @param {Vector} axis The vector representing the axis.
   * @return {Vector} This for chaining.
   */ Vector.prototype["reflect"] = Vector.prototype.reflect = function(axis) {
        var x = this["x"];
        var y = this["y"];
        this.project(axis).scale(2);
        this["x"] -= x;
        this["y"] -= y;
        return this;
    };
    // Reflect this vector on an arbitrary axis (represented by a unit vector). This is
    // slightly more efficient than `reflect` when dealing with an axis that is a unit vector.
    /**
   * @param {Vector} axis The unit vector representing the axis.
   * @return {Vector} This for chaining.
   */ Vector.prototype["reflectN"] = Vector.prototype.reflectN = function(axis) {
        var x = this["x"];
        var y = this["y"];
        this.projectN(axis).scale(2);
        this["x"] -= x;
        this["y"] -= y;
        return this;
    };
    // Get the dot product of this vector and another.
    /**
   * @param {Vector}  other The vector to dot this one against.
   * @return {number} The dot product.
   */ Vector.prototype["dot"] = Vector.prototype.dot = function(other) {
        return this["x"] * other["x"] + this["y"] * other["y"];
    };
    // Get the squared length of this vector.
    /**
   * @return {number} The length^2 of this vector.
   */ Vector.prototype["len2"] = Vector.prototype.len2 = function() {
        return this.dot(this);
    };
    // Get the length of this vector.
    /**
   * @return {number} The length of this vector.
   */ Vector.prototype["len"] = Vector.prototype.len = function() {
        return Math.sqrt(this.len2());
    };
    // ## Circle
    //
    // Represents a circle with a position and a radius.
    // Create a new circle, optionally passing in a position and/or radius. If no position
    // is given, the circle will be at `(0,0)`. If no radius is provided, the circle will
    // have a radius of `0`.
    /**
   * @param {Vector=} pos A vector representing the position of the center of the circle
   * @param {?number=} r The radius of the circle
   * @constructor
   */ function Circle(pos, r) {
        this["pos"] = pos || new Vector();
        this["r"] = r || 0;
        this["offset"] = new Vector();
    }
    SAT["Circle"] = Circle;
    // Compute the axis-aligned bounding box (AABB) of this Circle.
    //
    // Note: Returns a _new_ `Box` each time you call this.
    /**
   * @return {Polygon} The AABB
   */ Circle.prototype["getAABBAsBox"] = Circle.prototype.getAABBAsBox = function() {
        var r = this["r"];
        var corner = this["pos"].clone().add(this["offset"]).sub(new Vector(r, r));
        return new Box(corner, r * 2, r * 2);
    };
    // Compute the axis-aligned bounding box (AABB) of this Circle.
    //
    // Note: Returns a _new_ `Polygon` each time you call this.
    /**
   * @return {Polygon} The AABB
   */ Circle.prototype["getAABB"] = Circle.prototype.getAABB = function() {
        return this.getAABBAsBox().toPolygon();
    };
    // Set the current offset to apply to the radius.
    /**
   * @param {Vector} offset The new offset vector.
   * @return {Circle} This for chaining.
   */ Circle.prototype["setOffset"] = Circle.prototype.setOffset = function(offset) {
        this["offset"] = offset;
        return this;
    };
    // ## Polygon
    //
    // Represents a *convex* polygon with any number of points (specified in counter-clockwise order)
    //
    // Note: Do _not_ manually change the `points`, `angle`, or `offset` properties. Use the
    // provided setters. Otherwise the calculated properties will not be updated correctly.
    //
    // `pos` can be changed directly.
    // Create a new polygon, passing in a position vector, and an array of points (represented
    // by vectors relative to the position vector). If no position is passed in, the position
    // of the polygon will be `(0,0)`.
    /**
   * @param {Vector=} pos A vector representing the origin of the polygon. (all other
   *   points are relative to this one)
   * @param {Array<Vector>=} points An array of vectors representing the points in the polygon,
   *   in counter-clockwise order.
   * @constructor
   */ function Polygon(pos, points) {
        this["pos"] = pos || new Vector();
        this["angle"] = 0;
        this["offset"] = new Vector();
        this.setPoints(points || []);
    }
    SAT["Polygon"] = Polygon;
    // Set the points of the polygon. Any consecutive duplicate points will be combined.
    //
    // Note: The points are counter-clockwise *with respect to the coordinate system*.
    // If you directly draw the points on a screen that has the origin at the top-left corner
    // it will _appear_ visually that the points are being specified clockwise. This is just
    // because of the inversion of the Y-axis when being displayed.
    /**
   * @param {Array<Vector>=} points An array of vectors representing the points in the polygon,
   *   in counter-clockwise order.
   * @return {Polygon} This for chaining.
   */ Polygon.prototype["setPoints"] = Polygon.prototype.setPoints = function(points) {
        // Only re-allocate if this is a new polygon or the number of points has changed.
        var lengthChanged = !this["points"] || this["points"].length !== points.length;
        if (lengthChanged) {
            var i;
            var calcPoints = this["calcPoints"] = [];
            var edges = this["edges"] = [];
            var normals = this["normals"] = [];
            // Allocate the vector arrays for the calculated properties
            for(i = 0; i < points.length; i++){
                // Remove consecutive duplicate points
                var p1 = points[i];
                var p2 = i < points.length - 1 ? points[i + 1] : points[0];
                if (p1 !== p2 && p1.x === p2.x && p1.y === p2.y) {
                    points.splice(i, 1);
                    i -= 1;
                    continue;
                }
                calcPoints.push(new Vector());
                edges.push(new Vector());
                normals.push(new Vector());
            }
        }
        this["points"] = points;
        this._recalc();
        return this;
    };
    // Set the current rotation angle of the polygon.
    /**
   * @param {number} angle The current rotation angle (in radians).
   * @return {Polygon} This for chaining.
   */ Polygon.prototype["setAngle"] = Polygon.prototype.setAngle = function(angle) {
        this["angle"] = angle;
        this._recalc();
        return this;
    };
    // Set the current offset to apply to the `points` before applying the `angle` rotation.
    /**
   * @param {Vector} offset The new offset vector.
   * @return {Polygon} This for chaining.
   */ Polygon.prototype["setOffset"] = Polygon.prototype.setOffset = function(offset) {
        this["offset"] = offset;
        this._recalc();
        return this;
    };
    // Rotates this polygon counter-clockwise around the origin of *its local coordinate system* (i.e. `pos`).
    //
    // Note: This changes the **original** points (so any `angle` will be applied on top of this rotation).
    /**
   * @param {number} angle The angle to rotate (in radians)
   * @return {Polygon} This for chaining.
   */ Polygon.prototype["rotate"] = Polygon.prototype.rotate = function(angle) {
        var points = this["points"];
        var len = points.length;
        for(var i = 0; i < len; i++)points[i].rotate(angle);
        this._recalc();
        return this;
    };
    // Translates the points of this polygon by a specified amount relative to the origin of *its own coordinate
    // system* (i.e. `pos`).
    //
    // This is most useful to change the "center point" of a polygon. If you just want to move the whole polygon, change
    // the coordinates of `pos`.
    //
    // Note: This changes the **original** points (so any `offset` will be applied on top of this translation)
    /**
   * @param {number} x The horizontal amount to translate.
   * @param {number} y The vertical amount to translate.
   * @return {Polygon} This for chaining.
   */ Polygon.prototype["translate"] = Polygon.prototype.translate = function(x, y) {
        var points = this["points"];
        var len = points.length;
        for(var i = 0; i < len; i++){
            points[i]["x"] += x;
            points[i]["y"] += y;
        }
        this._recalc();
        return this;
    };
    // Computes the calculated collision polygon. Applies the `angle` and `offset` to the original points then recalculates the
    // edges and normals of the collision polygon.
    /**
   * @return {Polygon} This for chaining.
   */ Polygon.prototype._recalc = function() {
        // Calculated points - this is what is used for underlying collisions and takes into account
        // the angle/offset set on the polygon.
        var calcPoints = this["calcPoints"];
        // The edges here are the direction of the `n`th edge of the polygon, relative to
        // the `n`th point. If you want to draw a given edge from the edge value, you must
        // first translate to the position of the starting point.
        var edges = this["edges"];
        // The normals here are the direction of the normal for the `n`th edge of the polygon, relative
        // to the position of the `n`th point. If you want to draw an edge normal, you must first
        // translate to the position of the starting point.
        var normals = this["normals"];
        // Copy the original points array and apply the offset/angle
        var points = this["points"];
        var offset = this["offset"];
        var angle = this["angle"];
        var len = points.length;
        var i;
        for(i = 0; i < len; i++){
            var calcPoint = calcPoints[i].copy(points[i]);
            calcPoint["x"] += offset["x"];
            calcPoint["y"] += offset["y"];
            if (angle !== 0) calcPoint.rotate(angle);
        }
        // Calculate the edges/normals
        for(i = 0; i < len; i++){
            var p1 = calcPoints[i];
            var p2 = i < len - 1 ? calcPoints[i + 1] : calcPoints[0];
            var e = edges[i].copy(p2).sub(p1);
            normals[i].copy(e).perp().normalize();
        }
        return this;
    };
    // Compute the axis-aligned bounding box. Any current state
    // (translations/rotations) will be applied before constructing the AABB.
    //
    // Note: Returns a _new_ `Box` each time you call this.
    /**
   * @return {Polygon} The AABB
   */ Polygon.prototype["getAABBAsBox"] = Polygon.prototype.getAABBAsBox = function() {
        var points = this["calcPoints"];
        var len = points.length;
        var xMin = points[0]["x"];
        var yMin = points[0]["y"];
        var xMax = points[0]["x"];
        var yMax = points[0]["y"];
        for(var i = 1; i < len; i++){
            var point = points[i];
            if (point["x"] < xMin) xMin = point["x"];
            else if (point["x"] > xMax) xMax = point["x"];
            if (point["y"] < yMin) yMin = point["y"];
            else if (point["y"] > yMax) yMax = point["y"];
        }
        return new Box(this["pos"].clone().add(new Vector(xMin, yMin)), xMax - xMin, yMax - yMin);
    };
    // Compute the axis-aligned bounding box. Any current state
    // (translations/rotations) will be applied before constructing the AABB.
    //
    // Note: Returns a _new_ `Polygon` each time you call this.
    /**
   * @return {Polygon} The AABB
   */ Polygon.prototype["getAABB"] = Polygon.prototype.getAABB = function() {
        return this.getAABBAsBox().toPolygon();
    };
    // Compute the centroid (geometric center) of the polygon. Any current state
    // (translations/rotations) will be applied before computing the centroid.
    //
    // See https://en.wikipedia.org/wiki/Centroid#Centroid_of_a_polygon
    //
    // Note: Returns a _new_ `Vector` each time you call this.
    /**
   * @return {Vector} A Vector that contains the coordinates of the Centroid.
   */ Polygon.prototype["getCentroid"] = Polygon.prototype.getCentroid = function() {
        var points = this["calcPoints"];
        var len = points.length;
        var cx = 0;
        var cy = 0;
        var ar = 0;
        for(var i = 0; i < len; i++){
            var p1 = points[i];
            var p2 = i === len - 1 ? points[0] : points[i + 1]; // Loop around if last point
            var a = p1["x"] * p2["y"] - p2["x"] * p1["y"];
            cx += (p1["x"] + p2["x"]) * a;
            cy += (p1["y"] + p2["y"]) * a;
            ar += a;
        }
        ar = ar * 3; // we want 1 / 6 the area and we currently have 2*area
        cx = cx / ar;
        cy = cy / ar;
        return new Vector(cx, cy);
    };
    // ## Box
    //
    // Represents an axis-aligned box, with a width and height.
    // Create a new box, with the specified position, width, and height. If no position
    // is given, the position will be `(0,0)`. If no width or height are given, they will
    // be set to `0`.
    /**
   * @param {Vector=} pos A vector representing the bottom-left of the box (i.e. the smallest x and smallest y value).
   * @param {?number=} w The width of the box.
   * @param {?number=} h The height of the box.
   * @constructor
   */ function Box(pos, w, h) {
        this["pos"] = pos || new Vector();
        this["w"] = w || 0;
        this["h"] = h || 0;
    }
    SAT["Box"] = Box;
    // Returns a polygon whose edges are the same as this box.
    /**
   * @return {Polygon} A new Polygon that represents this box.
   */ Box.prototype["toPolygon"] = Box.prototype.toPolygon = function() {
        var pos = this["pos"];
        var w = this["w"];
        var h = this["h"];
        return new Polygon(new Vector(pos["x"], pos["y"]), [
            new Vector(),
            new Vector(w, 0),
            new Vector(w, h),
            new Vector(0, h)
        ]);
    };
    // ## Response
    //
    // An object representing the result of an intersection. Contains:
    //  - The two objects participating in the intersection
    //  - The vector representing the minimum change necessary to extract the first object
    //    from the second one (as well as a unit vector in that direction and the magnitude
    //    of the overlap)
    //  - Whether the first object is entirely inside the second, and vice versa.
    /**
   * @constructor
   */ function Response() {
        this["a"] = null;
        this["b"] = null;
        this["overlapN"] = new Vector();
        this["overlapV"] = new Vector();
        this.clear();
    }
    SAT["Response"] = Response;
    // Set some values of the response back to their defaults.  Call this between tests if
    // you are going to reuse a single Response object for multiple intersection tests (recommented
    // as it will avoid allcating extra memory)
    /**
   * @return {Response} This for chaining
   */ Response.prototype["clear"] = Response.prototype.clear = function() {
        this["aInB"] = true;
        this["bInA"] = true;
        this["overlap"] = Number.MAX_VALUE;
        return this;
    };
    // ## Object Pools
    // A pool of `Vector` objects that are used in calculations to avoid
    // allocating memory.
    /**
   * @type {Array<Vector>}
   */ var T_VECTORS = [];
    for(var i = 0; i < 10; i++)T_VECTORS.push(new Vector());
    // A pool of arrays of numbers used in calculations to avoid allocating
    // memory.
    /**
   * @type {Array<Array<number>>}
   */ var T_ARRAYS = [];
    for(var i = 0; i < 5; i++)T_ARRAYS.push([]);
    // Temporary response used for polygon hit detection.
    /**
   * @type {Response}
   */ var T_RESPONSE = new Response();
    // Tiny "point" polygon used for polygon hit detection.
    /**
   * @type {Polygon}
   */ var TEST_POINT = new Box(new Vector(), 0.000001, 0.000001).toPolygon();
    // ## Helper Functions
    // Flattens the specified array of points onto a unit vector axis,
    // resulting in a one dimensional range of the minimum and
    // maximum value on that axis.
    /**
   * @param {Array<Vector>} points The points to flatten.
   * @param {Vector} normal The unit vector axis to flatten on.
   * @param {Array<number>} result An array.  After calling this function,
   *   result[0] will be the minimum value,
   *   result[1] will be the maximum value.
   */ function flattenPointsOn(points, normal, result) {
        var min = Number.MAX_VALUE;
        var max = -Number.MAX_VALUE;
        var len = points.length;
        for(var i = 0; i < len; i++){
            // The magnitude of the projection of the point onto the normal
            var dot = points[i].dot(normal);
            if (dot < min) min = dot;
            if (dot > max) max = dot;
        }
        result[0] = min;
        result[1] = max;
    }
    // Check whether two convex polygons are separated by the specified
    // axis (must be a unit vector).
    /**
   * @param {Vector} aPos The position of the first polygon.
   * @param {Vector} bPos The position of the second polygon.
   * @param {Array<Vector>} aPoints The points in the first polygon.
   * @param {Array<Vector>} bPoints The points in the second polygon.
   * @param {Vector} axis The axis (unit sized) to test against.  The points of both polygons
   *   will be projected onto this axis.
   * @param {Response=} response A Response object (optional) which will be populated
   *   if the axis is not a separating axis.
   * @return {boolean} true if it is a separating axis, false otherwise.  If false,
   *   and a response is passed in, information about how much overlap and
   *   the direction of the overlap will be populated.
   */ function isSeparatingAxis(aPos, bPos, aPoints, bPoints, axis, response) {
        var rangeA = T_ARRAYS.pop();
        var rangeB = T_ARRAYS.pop();
        // The magnitude of the offset between the two polygons
        var offsetV = T_VECTORS.pop().copy(bPos).sub(aPos);
        var projectedOffset = offsetV.dot(axis);
        // Project the polygons onto the axis.
        flattenPointsOn(aPoints, axis, rangeA);
        flattenPointsOn(bPoints, axis, rangeB);
        // Move B's range to its position relative to A.
        rangeB[0] += projectedOffset;
        rangeB[1] += projectedOffset;
        // Check if there is a gap. If there is, this is a separating axis and we can stop
        if (rangeA[0] > rangeB[1] || rangeB[0] > rangeA[1]) {
            T_VECTORS.push(offsetV);
            T_ARRAYS.push(rangeA);
            T_ARRAYS.push(rangeB);
            return true;
        }
        // This is not a separating axis. If we're calculating a response, calculate the overlap.
        if (response) {
            var overlap = 0;
            // A starts further left than B
            if (rangeA[0] < rangeB[0]) {
                response["aInB"] = false;
                // A ends before B does. We have to pull A out of B
                if (rangeA[1] < rangeB[1]) {
                    overlap = rangeA[1] - rangeB[0];
                    response["bInA"] = false;
                // B is fully inside A.  Pick the shortest way out.
                } else {
                    var option1 = rangeA[1] - rangeB[0];
                    var option2 = rangeB[1] - rangeA[0];
                    overlap = option1 < option2 ? option1 : -option2;
                }
            // B starts further left than A
            } else {
                response["bInA"] = false;
                // B ends before A ends. We have to push A out of B
                if (rangeA[1] > rangeB[1]) {
                    overlap = rangeA[0] - rangeB[1];
                    response["aInB"] = false;
                // A is fully inside B.  Pick the shortest way out.
                } else {
                    var option1 = rangeA[1] - rangeB[0];
                    var option2 = rangeB[1] - rangeA[0];
                    overlap = option1 < option2 ? option1 : -option2;
                }
            }
            // If this is the smallest amount of overlap we've seen so far, set it as the minimum overlap.
            var absOverlap = Math.abs(overlap);
            if (absOverlap < response["overlap"]) {
                response["overlap"] = absOverlap;
                response["overlapN"].copy(axis);
                if (overlap < 0) response["overlapN"].reverse();
            }
        }
        T_VECTORS.push(offsetV);
        T_ARRAYS.push(rangeA);
        T_ARRAYS.push(rangeB);
        return false;
    }
    SAT["isSeparatingAxis"] = isSeparatingAxis;
    // Calculates which Voronoi region a point is on a line segment.
    // It is assumed that both the line and the point are relative to `(0,0)`
    //
    //            |       (0)      |
    //     (-1)  [S]--------------[E]  (1)
    //            |       (0)      |
    /**
   * @param {Vector} line The line segment.
   * @param {Vector} point The point.
   * @return  {number} LEFT_VORONOI_REGION (-1) if it is the left region,
   *          MIDDLE_VORONOI_REGION (0) if it is the middle region,
   *          RIGHT_VORONOI_REGION (1) if it is the right region.
   */ function voronoiRegion(line, point) {
        var len2 = line.len2();
        var dp = point.dot(line);
        // If the point is beyond the start of the line, it is in the
        // left voronoi region.
        if (dp < 0) return LEFT_VORONOI_REGION;
        else if (dp > len2) return RIGHT_VORONOI_REGION;
        else return MIDDLE_VORONOI_REGION;
    }
    // Constants for Voronoi regions
    /**
   * @const
   */ var LEFT_VORONOI_REGION = -1;
    /**
   * @const
   */ var MIDDLE_VORONOI_REGION = 0;
    /**
   * @const
   */ var RIGHT_VORONOI_REGION = 1;
    // ## Collision Tests
    // Check if a point is inside a circle.
    /**
   * @param {Vector} p The point to test.
   * @param {Circle} c The circle to test.
   * @return {boolean} true if the point is inside the circle, false if it is not.
   */ function pointInCircle(p, c) {
        var differenceV = T_VECTORS.pop().copy(p).sub(c["pos"]).sub(c["offset"]);
        var radiusSq = c["r"] * c["r"];
        var distanceSq = differenceV.len2();
        T_VECTORS.push(differenceV);
        // If the distance between is smaller than the radius then the point is inside the circle.
        return distanceSq <= radiusSq;
    }
    SAT["pointInCircle"] = pointInCircle;
    // Check if a point is inside a convex polygon.
    /**
   * @param {Vector} p The point to test.
   * @param {Polygon} poly The polygon to test.
   * @return {boolean} true if the point is inside the polygon, false if it is not.
   */ function pointInPolygon(p, poly) {
        TEST_POINT["pos"].copy(p);
        T_RESPONSE.clear();
        var result = testPolygonPolygon(TEST_POINT, poly, T_RESPONSE);
        if (result) result = T_RESPONSE["aInB"];
        return result;
    }
    SAT["pointInPolygon"] = pointInPolygon;
    // Check if two circles collide.
    /**
   * @param {Circle} a The first circle.
   * @param {Circle} b The second circle.
   * @param {Response=} response Response object (optional) that will be populated if
   *   the circles intersect.
   * @return {boolean} true if the circles intersect, false if they don't.
   */ function testCircleCircle(a, b, response) {
        // Check if the distance between the centers of the two
        // circles is greater than their combined radius.
        var differenceV = T_VECTORS.pop().copy(b["pos"]).add(b["offset"]).sub(a["pos"]).sub(a["offset"]);
        var totalRadius = a["r"] + b["r"];
        var totalRadiusSq = totalRadius * totalRadius;
        var distanceSq = differenceV.len2();
        // If the distance is bigger than the combined radius, they don't intersect.
        if (distanceSq > totalRadiusSq) {
            T_VECTORS.push(differenceV);
            return false;
        }
        // They intersect.  If we're calculating a response, calculate the overlap.
        if (response) {
            var dist = Math.sqrt(distanceSq);
            response["a"] = a;
            response["b"] = b;
            response["overlap"] = totalRadius - dist;
            response["overlapN"].copy(differenceV.normalize());
            response["overlapV"].copy(differenceV).scale(response["overlap"]);
            response["aInB"] = a["r"] <= b["r"] && dist <= b["r"] - a["r"];
            response["bInA"] = b["r"] <= a["r"] && dist <= a["r"] - b["r"];
        }
        T_VECTORS.push(differenceV);
        return true;
    }
    SAT["testCircleCircle"] = testCircleCircle;
    // Check if a polygon and a circle collide.
    /**
   * @param {Polygon} polygon The polygon.
   * @param {Circle} circle The circle.
   * @param {Response=} response Response object (optional) that will be populated if
   *   they interset.
   * @return {boolean} true if they intersect, false if they don't.
   */ function testPolygonCircle(polygon, circle, response) {
        // Get the position of the circle relative to the polygon.
        var circlePos = T_VECTORS.pop().copy(circle["pos"]).add(circle["offset"]).sub(polygon["pos"]);
        var radius = circle["r"];
        var radius2 = radius * radius;
        var points = polygon["calcPoints"];
        var len = points.length;
        var edge = T_VECTORS.pop();
        var point = T_VECTORS.pop();
        // For each edge in the polygon:
        for(var i = 0; i < len; i++){
            var next = i === len - 1 ? 0 : i + 1;
            var prev = i === 0 ? len - 1 : i - 1;
            var overlap = 0;
            var overlapN = null;
            // Get the edge.
            edge.copy(polygon["edges"][i]);
            // Calculate the center of the circle relative to the starting point of the edge.
            point.copy(circlePos).sub(points[i]);
            // If the distance between the center of the circle and the point
            // is bigger than the radius, the polygon is definitely not fully in
            // the circle.
            if (response && point.len2() > radius2) response["aInB"] = false;
            // Calculate which Voronoi region the center of the circle is in.
            var region = voronoiRegion(edge, point);
            // If it's the left region:
            if (region === LEFT_VORONOI_REGION) {
                // We need to make sure we're in the RIGHT_VORONOI_REGION of the previous edge.
                edge.copy(polygon["edges"][prev]);
                // Calculate the center of the circle relative the starting point of the previous edge
                var point2 = T_VECTORS.pop().copy(circlePos).sub(points[prev]);
                region = voronoiRegion(edge, point2);
                if (region === RIGHT_VORONOI_REGION) {
                    // It's in the region we want.  Check if the circle intersects the point.
                    var dist = point.len();
                    if (dist > radius) {
                        // No intersection
                        T_VECTORS.push(circlePos);
                        T_VECTORS.push(edge);
                        T_VECTORS.push(point);
                        T_VECTORS.push(point2);
                        return false;
                    } else if (response) {
                        // It intersects, calculate the overlap.
                        response["bInA"] = false;
                        overlapN = point.normalize();
                        overlap = radius - dist;
                    }
                }
                T_VECTORS.push(point2);
            // If it's the right region:
            } else if (region === RIGHT_VORONOI_REGION) {
                // We need to make sure we're in the left region on the next edge
                edge.copy(polygon["edges"][next]);
                // Calculate the center of the circle relative to the starting point of the next edge.
                point.copy(circlePos).sub(points[next]);
                region = voronoiRegion(edge, point);
                if (region === LEFT_VORONOI_REGION) {
                    // It's in the region we want.  Check if the circle intersects the point.
                    var dist = point.len();
                    if (dist > radius) {
                        // No intersection
                        T_VECTORS.push(circlePos);
                        T_VECTORS.push(edge);
                        T_VECTORS.push(point);
                        return false;
                    } else if (response) {
                        // It intersects, calculate the overlap.
                        response["bInA"] = false;
                        overlapN = point.normalize();
                        overlap = radius - dist;
                    }
                }
            // Otherwise, it's the middle region:
            } else {
                // Need to check if the circle is intersecting the edge,
                // Change the edge into its "edge normal".
                var normal = edge.perp().normalize();
                // Find the perpendicular distance between the center of the
                // circle and the edge.
                var dist = point.dot(normal);
                var distAbs = Math.abs(dist);
                // If the circle is on the outside of the edge, there is no intersection.
                if (dist > 0 && distAbs > radius) {
                    // No intersection
                    T_VECTORS.push(circlePos);
                    T_VECTORS.push(normal);
                    T_VECTORS.push(point);
                    return false;
                } else if (response) {
                    // It intersects, calculate the overlap.
                    overlapN = normal;
                    overlap = radius - dist;
                    // If the center of the circle is on the outside of the edge, or part of the
                    // circle is on the outside, the circle is not fully inside the polygon.
                    if (dist >= 0 || overlap < 2 * radius) response["bInA"] = false;
                }
            }
            // If this is the smallest overlap we've seen, keep it.
            // (overlapN may be null if the circle was in the wrong Voronoi region).
            if (overlapN && response && Math.abs(overlap) < Math.abs(response["overlap"])) {
                response["overlap"] = overlap;
                response["overlapN"].copy(overlapN);
            }
        }
        // Calculate the final overlap vector - based on the smallest overlap.
        if (response) {
            response["a"] = polygon;
            response["b"] = circle;
            response["overlapV"].copy(response["overlapN"]).scale(response["overlap"]);
        }
        T_VECTORS.push(circlePos);
        T_VECTORS.push(edge);
        T_VECTORS.push(point);
        return true;
    }
    SAT["testPolygonCircle"] = testPolygonCircle;
    // Check if a circle and a polygon collide.
    //
    // **NOTE:** This is slightly less efficient than polygonCircle as it just
    // runs polygonCircle and reverses everything at the end.
    /**
   * @param {Circle} circle The circle.
   * @param {Polygon} polygon The polygon.
   * @param {Response=} response Response object (optional) that will be populated if
   *   they interset.
   * @return {boolean} true if they intersect, false if they don't.
   */ function testCirclePolygon(circle, polygon, response) {
        // Test the polygon against the circle.
        var result = testPolygonCircle(polygon, circle, response);
        if (result && response) {
            // Swap A and B in the response.
            var a = response["a"];
            var aInB = response["aInB"];
            response["overlapN"].reverse();
            response["overlapV"].reverse();
            response["a"] = response["b"];
            response["b"] = a;
            response["aInB"] = response["bInA"];
            response["bInA"] = aInB;
        }
        return result;
    }
    SAT["testCirclePolygon"] = testCirclePolygon;
    // Checks whether polygons collide.
    /**
   * @param {Polygon} a The first polygon.
   * @param {Polygon} b The second polygon.
   * @param {Response=} response Response object (optional) that will be populated if
   *   they interset.
   * @return {boolean} true if they intersect, false if they don't.
   */ function testPolygonPolygon(a, b, response) {
        var aPoints = a["calcPoints"];
        var aLen = aPoints.length;
        var bPoints = b["calcPoints"];
        var bLen = bPoints.length;
        // If any of the edge normals of A is a separating axis, no intersection.
        for(var i = 0; i < aLen; i++){
            if (isSeparatingAxis(a["pos"], b["pos"], aPoints, bPoints, a["normals"][i], response)) return false;
        }
        // If any of the edge normals of B is a separating axis, no intersection.
        for(var i = 0; i < bLen; i++){
            if (isSeparatingAxis(a["pos"], b["pos"], aPoints, bPoints, b["normals"][i], response)) return false;
        }
        // Since none of the edge normals of A or B are a separating axis, there is an intersection
        // and we've already calculated the smallest overlap (in isSeparatingAxis).  Calculate the
        // final overlap vector.
        if (response) {
            response["a"] = a;
            response["b"] = b;
            response["overlapV"].copy(response["overlapN"]).scale(response["overlap"]);
        }
        return true;
    }
    SAT["testPolygonPolygon"] = testPolygonPolygon;
    return SAT;
});








var $35b008eefffaa37f$exports = {};
$35b008eefffaa37f$exports = JSON.parse('{"compressionlevel":-1,"height":250,"infinite":false,"layers":[{"data":[781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,711,711,711,1607,1605,1543,1478,1606,1413,1607,1543,1414,1414,1605,1607,1413,1606,1607,1478,1541,1477,1542,1415,1413,1414,1477,1542,1414,1542,1477,1541,1478,1413,1414,1477,1413,1477,1541,1478,1478,1477,1413,1541,1478,1414,1541,1414,1414,1477,1413,1542,1478,1414,1477,1541,1414,1542,1414,1478,1478,1413,1477,1542,1414,1541,1541,1413,1414,1542,1541,1413,1542,1542,1478,1478,1542,1414,1477,1541,1478,1478,1414,1477,1542,1478,1477,1478,1541,1541,1542,1542,1413,1542,1413,1541,1542,1541,1606,1414,1542,1605,1478,1414,1542,1413,1413,1542,1542,1478,1541,1413,1478,1605,1541,1414,1414,1477,1414,1478,1605,1606,1414,1606,1605,1413,1542,1541,1541,1606,1541,1542,1487,1551,1423,1550,1488,1551,1424,1422,1615,1422,1552,1423,1540,1540,1603,1603,1475,1411,1540,1604,1540,1476,1411,1476,1539,1411,1475,1412,1793,1992,1992,1992,1992,1992,1992,1992,1992,1857,1423,1424,1550,1614,1422,1551,1424,1616,527,528,529,530,531,147,1422,1614,1615,1422,1424,272,273,274,275,276,1423,1487,272,658,722,595,723,594,594,658,657,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,711,711,1605,1607,1543,1605,1543,1606,1607,1414,1607,1479,1477,1477,1541,1413,1607,1541,1477,1541,1607,1478,1478,1542,1413,1478,1413,1541,1414,1541,1477,1542,1478,1542,1414,1541,1542,1414,1414,1414,1478,1477,1413,1541,1413,1542,1413,1478,1477,1413,1541,1541,1541,1413,1542,1413,1413,1542,1413,1414,1414,1413,1542,1414,1477,1414,1542,1414,1477,1413,1413,1541,1542,1541,1542,1414,1413,1478,1542,1478,1541,1542,1413,1478,1477,1414,1414,1542,1542,1478,1478,1478,1606,1414,1414,1606,1605,1477,1542,1542,1413,1414,1605,1605,1413,1542,1606,1605,1414,1478,1606,1477,1541,1605,773,1424,1614,1552,1616,1422,1423,1424,1423,1486,1488,1424,773,1605,1477,1605,1606,1605,1605,773,1616,1486,1614,1614,1604,1539,1475,1539,1411,1412,1539,1540,1539,1540,1604,1412,1476,1539,1411,1475,1411,1604,1923,1797,1797,1666,1992,1992,1992,1992,1992,1992,1992,1669,1927,1487,1488,1422,1552,1552,1614,1614,1550,591,592,593,594,595,660,1488,1615,1422,1488,1424,336,337,338,339,340,1422,1423,272,721,657,593,723,594,594,657,595,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1477,1607,1607,1605,1414,1605,1415,1543,1543,1605,1541,1541,1543,1541,1479,1478,1479,1415,1477,1605,1477,1479,1607,1413,1413,1541,1542,1414,1413,1414,1478,1542,1414,1413,1478,1541,1542,1413,1414,1477,1541,1478,1414,1541,1542,1414,1478,1542,1478,1413,1414,1478,1477,1413,1478,1478,1413,1413,1542,1542,1478,1541,1542,1413,1413,1542,1542,1477,1477,1478,1477,1413,1477,1478,1542,1478,1414,1414,1414,1477,1477,1413,1478,1541,1477,1542,1414,1414,1413,1414,1478,1414,1478,1477,1478,1605,1542,1413,1541,1413,1478,1605,1606,1542,1477,1477,1477,1542,1541,1478,1542,1542,773,1488,1486,1487,1551,1616,1542,1605,1606,1606,1552,1423,1614,1423,1487,773,1487,1423,1616,710,773,1422,1539,1540,1411,1539,1475,1603,1475,1539,1604,1412,1412,1540,1411,1475,1476,1539,1475,1923,1797,1797,1797,1797,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1550,1551,1552,1488,1614,1614,1422,1424,1551,655,656,657,658,659,211,530,532,1552,1550,1487,400,401,402,403,404,1551,1424,272,721,721,657,722,659,593,594,595,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1477,1413,1605,1477,1542,1414,1414,1605,1605,1413,1415,1478,1605,1415,1542,1541,1605,1605,1415,1415,1605,1543,1478,1414,1541,1542,1541,1414,1542,1542,1542,1542,1413,1478,1478,1542,1478,1413,1414,1413,1541,1478,1414,1478,1477,1542,1541,1413,1541,1478,1414,1414,1414,1478,1477,1413,1542,1477,1542,1477,1414,1413,1413,1542,1478,1414,1477,1414,1414,1413,1413,1413,1477,1478,1477,1478,1414,1541,1541,1477,1477,1477,1478,1414,1414,1542,1359,1359,1359,1359,1359,1359,1231,1414,1606,1414,1414,1477,1606,1605,1605,1414,1542,1542,1413,1477,1413,1478,1413,1542,1414,773,1552,1615,1487,1616,1615,1423,1413,1414,1606,1605,1487,1487,1486,1487,1423,1423,1552,1616,1615,1550,1615,1422,1476,1539,1604,1540,1539,1604,1412,1412,1475,1540,1539,1412,1603,1540,1476,1923,1797,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1614,1615,1616,1424,1487,1551,1488,1614,1487,719,720,721,657,593,723,594,596,1551,1423,1422,1552,1486,1422,1551,1614,1486,1424,272,657,659,595,722,721,657,658,659,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1479,1606,1606,1477,1479,1605,1414,1542,1542,1541,1541,1541,1415,1478,1414,1606,1479,1542,1606,1414,1605,1542,1414,1606,1413,1541,1541,1414,1413,1478,1477,1541,1413,1542,1414,1413,1413,1414,1541,1477,1477,1541,1478,1413,1477,1477,1477,1478,1414,1414,1414,1414,1413,1414,1414,1413,1542,1414,1414,1414,1542,1477,1414,1413,1477,1414,1414,1542,1478,1414,1541,1414,1541,1477,1414,1542,1477,1414,1414,1414,1477,1542,1359,1359,1359,1359,1359,781,781,781,781,781,781,781,1361,1231,1361,1231,1541,1541,1542,1542,1541,1413,1605,1605,1414,1413,1478,1477,1541,1542,1424,1424,1488,1614,1616,1487,1486,1422,773,1606,1541,1488,1424,1551,1542,1542,1477,1486,1476,1412,1412,1412,1539,1475,1411,1603,1475,1540,1475,1604,1539,1475,1539,1475,1604,1540,1603,1603,1985,1861,1861,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1424,1422,1423,1424,1422,1486,1614,1615,1424,1551,783,336,337,722,657,722,659,660,1551,1423,1551,1616,1552,1488,1552,1615,1423,1552,336,337,657,722,657,658,721,722,723,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1541,1543,1605,1478,1479,1478,1542,1415,1541,1477,1607,1543,1478,1606,1478,1542,1477,1541,1414,1605,1542,1606,1478,1477,1414,1413,1541,1542,1541,1542,1542,1414,1477,1413,1413,1478,1414,1414,1477,1541,1541,1413,1541,1542,1413,1477,1413,1542,1414,1413,1414,1414,1541,1541,1477,1541,1541,1542,1477,1477,1542,1542,1542,1414,1541,1542,1477,1541,1542,1478,1413,1542,1414,1414,1478,1541,1477,1414,1542,1541,1359,1359,1359,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1294,1361,1231,1477,1606,1478,1606,1541,1605,1541,1477,1414,1606,1477,1605,1606,1615,1551,1552,1541,1552,1424,1551,1422,1422,1615,1551,1424,1550,1414,1475,1539,1540,1604,1539,1540,1604,1475,1603,1412,1475,1540,1475,1412,1411,1603,1475,1411,1539,1412,1412,1603,1476,1475,1539,1476,1604,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1488,1552,1550,1551,1552,1550,1552,1424,1551,1552,1487,1552,401,659,595,722,721,724,1422,1488,1423,1424,1615,1616,1552,1488,1486,1550,400,401,402,402,402,402,402,402,402,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1542,1543,1606,1415,1479,1543,1541,1541,1414,713,1230,1231,1231,1231,1231,1231,1231,1231,1231,1231,1231,1231,1231,1231,1231,1359,1359,1359,1359,1359,1359,1359,1542,1478,1414,1541,1478,1413,1478,1541,1477,1414,1542,1541,1414,1542,1414,1413,1541,1477,1414,1541,1414,1478,1414,1413,1414,1542,1477,1477,1541,1477,1478,1413,1413,1477,1542,1478,1478,1542,1478,1478,1542,1414,1542,1413,1478,1414,1359,1359,781,781,781,781,781,781,781,781,781,781,1294,1297,781,1602,781,781,781,781,1474,781,1361,1231,1542,1605,1478,1477,1541,1542,1414,1542,1541,1605,1542,1108,1108,1108,1108,1108,1108,1108,1487,1616,1486,1488,1475,1475,1476,1475,1476,1412,1603,1411,1412,1540,1604,1603,1604,1411,1540,1539,1411,1540,1540,1475,1476,1603,1539,1539,1476,1476,1539,1539,1603,1540,1412,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,1551,1552,1615,1486,1424,1615,1614,1423,1551,1488,1486,1615,1422,783,784,785,786,787,788,1423,1551,1422,1487,1424,1422,1422,1488,1550,1423,1552,1551,1615,1552,1486,1551,1614,1487,1487,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1607,1413,1479,1543,1478,1542,1606,1479,1230,1231,1231,1360,1360,1360,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1294,1297,1297,1297,1297,1297,1297,1359,1359,1413,1413,1414,1541,1413,1542,1477,1413,1413,1541,1414,1478,1478,1541,1414,1477,1542,1477,1414,1477,1478,1413,1478,1541,1541,1541,1413,1541,1478,1414,1477,1477,1541,1414,1541,1542,1542,1542,1542,1478,1414,1478,1359,1359,781,781,781,781,781,781,781,781,781,781,781,781,1294,2684355341,1474,1474,1474,1474,1474,1474,1474,1474,781,1297,1297,1297,1231,1231,1231,1231,1231,1231,1231,1231,1231,1365,1365,1365,1365,1365,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1411,1603,1475,1540,1476,1412,1539,1412,1604,1475,1603,1476,1604,1411,1412,1412,1411,1411,1411,1604,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1616,1614,1615,1551,1423,1487,1614,1614,1616,1423,1423,1551,1614,1615,1550,1423,1424,1422,1614,1616,1488,1423,1615,1551,1614,1486,1486,1614,1551,1422,1615,1616,272,593,593,593,593,657,721,658,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1230,1231,1231,1231,1231,1231,1231,1231,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1294,1297,1297,1297,1297,1297,1297,1294,1297,1359,1359,1413,1414,1413,1414,1478,1478,1541,1541,1541,1542,1541,1413,1414,1414,1542,1414,1414,1477,1477,1478,1542,1477,1477,1414,1541,1414,1541,1477,1477,1542,1541,1542,1414,1541,1413,1542,1477,1478,1359,1359,781,781,781,781,781,781,781,781,781,781,781,781,781,1294,1294,1474,1615,1923,1666,1992,1992,1667,1925,1615,1474,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1365,1365,1235,1235,1235,1235,1235,1235,1235,1235,1235,1365,1365,1365,1365,1365,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1108,1729,1992,1992,1992,1992,1992,1992,1992,1669,1927,1424,1422,1423,1552,1423,1614,1550,1422,1552,1422,1487,1488,1486,1422,1550,1614,1614,1616,1550,1614,1424,1614,1487,1486,1616,1422,1551,1551,1614,1424,1550,1615,272,721,657,721,595,723,593,657,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,647,647,647,647,647,647,647,647,647,647,647,647,647,647,647,647,647,647,519,647,647,647,647,781,781,781,781,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1297,1297,1297,1297,1297,1297,1294,1297,1294,1297,1359,1359,1413,1541,1541,1478,1541,1478,1542,1414,1413,1413,1541,1414,1477,1542,1477,1477,1478,1413,1413,1478,1414,1478,1477,1414,1414,1414,1413,1414,1542,1478,1541,1478,1359,1359,1359,1359,781,781,781,781,781,781,781,781,781,781,781,781,781,1361,1361,1361,1361,1601,1923,1666,2000,2000,2000,2000,1667,1925,1474,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1793,1992,1992,1992,1992,1992,1992,1992,1857,1487,1488,1486,1615,1422,1422,1422,1423,1486,1615,1486,1486,1423,1551,1550,1614,1615,1422,1615,1486,1551,1614,1487,1550,1551,1550,1423,1615,1423,1551,1615,1422,1423,272,722,722,723,593,594,595,658,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,647,647,1605,519,1605,711,711,647,647,711,711,711,711,711,583,583,1605,1605,519,647,647,647,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1297,1294,1297,1294,1297,1359,1541,1477,1477,1477,1542,1414,1478,1541,1477,1542,1478,1414,1414,1477,1478,1542,1413,1414,1359,1359,1359,1359,1359,1359,1359,1359,1359,1359,1359,1359,1359,781,781,781,781,781,781,781,781,781,781,781,781,1361,1361,1361,1361,1361,1414,1605,1605,1417,1482,1793,1992,2000,2000,2000,2000,1992,1857,149,1223,400,580,149,1349,391,330,149,964,1601,1537,1476,1540,1412,1538,1473,466,1602,963,466,963,1223,1473,1473,1409,399,853,1487,965,1615,466,149,963,1615,82,1537,1410,853,655,469,1349,966,1475,1537,964,1487,965,655,964,1615,1349,853,1487,82,853,1793,1992,1992,1992,1992,1992,1992,1992,1857,1551,1552,1550,1614,1552,1616,1614,1423,1424,1423,1422,1551,1488,1552,1550,1488,1422,1488,1616,1423,1551,1422,1616,1423,1551,1616,1367,1368,1303,1432,1423,1550,1486,272,659,594,593,723,594,595,594,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,519,519,519,519,1605,1605,1605,1605,1605,1605,1605,711,583,1605,1605,1605,1605,1605,1605,1605,649,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1297,1294,1297,1294,1359,1359,1413,1541,1414,1413,1414,1414,1541,1477,1413,1542,1359,1359,1359,1359,1359,1359,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1361,1361,1477,1541,1606,1478,1541,1478,1605,1417,1482,580,1793,1992,2000,2000,2000,2000,1992,1857,1349,149,456,580,965,773,149,1602,1539,1539,1539,1410,1409,1473,1602,1539,1411,1411,1411,1540,1604,1410,1476,1410,277,1538,1409,1475,1601,1474,1409,1473,1602,1410,1409,1537,1475,1540,1409,1474,1475,1476,1540,1409,1538,1475,1349,966,1487,400,400,277,853,1615,1615,966,1985,1729,1992,1992,1669,1861,1861,1861,1927,1615,1616,1614,1422,1486,1488,1552,1614,1424,1488,1424,1422,1552,1552,1424,1550,1486,1488,1487,1616,1486,1486,1550,1422,1422,1552,1615,1367,1432,1367,1614,1488,1552,272,721,723,659,657,594,722,659,781,781,781,781,781,781,781,781,781,781,781,781,781,781,519,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,648,648,519,519,520,519,520,519,520,519,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,583,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1297,1294,1294,1297,1359,1359,1359,1359,1359,1359,1359,1359,1359,1359,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1361,1361,1361,1361,1605,1605,1413,1477,1478,1606,1477,1541,1417,1482,1482,456,1793,1992,1992,2000,2000,2000,1992,1857,392,469,963,965,1476,1604,1412,1539,1474,1474,1410,1602,1474,1604,1602,1602,1411,1474,1409,1473,1537,1410,1601,1537,1412,1409,1538,1475,1409,1539,1474,1475,1604,1602,1475,1537,1601,1411,1540,1601,1602,1474,1409,1539,399,1539,1487,149,1223,469,965,1349,965,1487,655,1488,1486,1793,1992,1992,1857,1422,1423,1424,1422,1423,1424,1422,1487,1614,1615,1551,1486,1615,1616,1615,1422,1614,1616,1423,1424,1552,1488,1422,528,530,529,530,531,532,1424,1424,1487,1367,1367,1614,1422,1487,272,722,723,723,723,722,722,593,781,781,781,781,781,781,781,781,781,781,1605,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,584,583,584,583,584,647,647,583,584,583,584,651,1605,1605,1605,519,1605,519,584,520,519,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,522,522,1605,1605,1477,1541,1478,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1294,1297,1294,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1361,1361,1361,1361,1605,1605,1605,1605,1542,1478,1542,1605,1605,1415,1605,1416,1420,1482,1482,1547,1793,1992,1992,2000,2000,2000,1992,1857,469,964,469,466,1349,1538,1540,1539,1474,1476,1411,1412,1475,1411,1601,1602,1537,1538,1540,1475,1412,1539,1409,1604,1412,1603,1603,1474,1474,1604,1411,1603,1602,1411,1476,1540,1537,1411,1602,1601,1411,1412,1411,1539,1540,1410,655,1349,469,966,964,400,1349,1615,1615,1552,1423,1985,1861,1861,1927,1486,1487,1488,1486,1487,1488,1486,1486,1552,1487,1551,1422,1616,1488,1488,1486,1615,1615,1488,1487,1423,1551,1552,592,593,594,595,659,660,1615,1424,1614,1431,1432,1551,1488,1486,272,593,658,659,722,593,593,723,781,781,781,781,781,781,781,781,781,781,1605,647,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,649,519,520,519,520,647,647,647,647,647,647,519,520,583,519,1605,1605,1605,583,520,583,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,520,520,583,1605,1605,1605,522,1477,1477,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1297,1294,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1605,521,1605,1605,1605,1605,1605,1606,1605,1477,1605,1605,1605,1605,1605,1545,1546,1546,1547,392,1793,1992,1992,2000,2000,2000,1992,1857,1487,1474,1601,1476,1538,1411,1537,1538,1474,1475,1539,1475,1475,1412,1539,1476,1412,1601,1540,1476,1537,1409,1540,1601,1540,1603,1602,1409,1538,1601,1474,1601,1476,1410,1409,1412,1539,1475,1410,1411,1552,1411,1540,1602,1475,1473,1603,466,1487,466,853,966,965,966,1223,469,781,1422,1422,1422,1551,1486,1487,1551,1487,1550,1615,1487,781,1422,1424,1551,1424,1488,1487,1552,1423,1487,1552,1423,1422,1488,1424,1424,656,657,658,659,723,788,1550,1424,1552,1304,1368,1423,1422,1552,272,721,722,593,723,594,659,594,781,781,781,781,781,781,781,781,781,781,1605,583,1605,1605,1605,1605,1605,648,648,648,711,519,711,519,711,519,647,583,711,583,711,583,647,647,647,647,647,583,711,519,583,584,1605,1605,1605,519,1605,1605,1486,1923,1797,1797,1797,1925,1614,1605,1605,1605,583,520,584,583,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,585,520,521,520,519,1605,1605,1605,1605,1605,1605,1605,1478,1542,1413,1605,1605,1542,1605,1605,1605,1605,1416,1605,1605,1605,1605,1605,1605,455,1793,1992,1992,2000,2000,2000,1992,1857,853,1540,1539,1601,1601,1476,1539,1473,1411,1602,1412,1410,1474,1473,1603,1537,1411,1475,1540,1537,1604,1475,1604,1537,1602,1474,1409,1603,1601,1540,1474,1538,1537,1474,1601,1473,1602,1412,1476,1423,1487,1550,1537,1412,1476,1604,1409,469,964,277,966,277,1349,1487,400,963,1423,1368,1303,1304,1368,1368,1367,1424,1551,1552,1424,1487,1550,1486,1422,1552,1422,1486,1486,1552,1616,1615,1486,1551,1424,1487,1424,1488,656,721,722,339,340,1614,1488,1488,1424,1422,1616,1422,1423,1614,272,595,659,594,595,593,721,721,781,781,781,781,781,781,781,781,781,781,647,647,1605,1605,1605,1605,1605,1605,648,520,519,520,519,647,647,647,647,647,647,520,519,520,519,520,647,520,519,520,519,520,649,519,584,583,583,519,1605,1551,1423,1793,1992,1992,1992,1857,1614,1605,1605,1605,583,522,522,522,583,584,1605,1605,1605,1605,1605,1605,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,521,583,583,520,519,519,520,584,584,520,520,583,521,585,521,584,519,584,522,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1413,1605,1605,1413,1605,1605,1605,1605,1605,1605,1605,1605,1605,1420,1421,1605,1605,646,1793,1992,1992,2000,2000,2000,1992,1857,466,1474,1412,1601,1601,1476,1411,1603,1603,1604,1603,1410,1602,1411,1603,1411,1473,1601,1410,1604,1539,1538,1604,1473,1473,1475,1540,1602,1475,1538,1476,1473,1603,1476,1601,1538,1476,1540,1411,1488,1550,1616,1602,1537,1537,1602,1476,965,82,1223,965,655,400,149,277,400,1615,1495,1368,1367,1432,1304,1486,1486,1551,1423,1488,1486,1616,1424,1423,1550,1614,1551,1486,1615,1422,1615,1487,1422,1614,1614,1486,781,784,785,786,403,404,1422,1424,1551,1614,1552,1614,1551,1552,1552,1614,1423,1551,1487,1488,1615,1615,1422,781,781,781,781,781,781,781,781,781,781,647,1605,1605,1605,1605,1605,1605,649,583,584,583,647,647,647,647,647,647,647,583,584,583,584,583,584,522,584,583,584,583,584,583,1422,1423,1551,1487,1422,1422,1923,1797,1666,1992,1992,1992,1667,1925,1422,1605,1605,1605,1605,584,519,584,1605,1605,1605,1605,1542,1541,519,519,520,584,1415,1605,1605,1415,1541,1542,1413,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,584,583,521,583,586,521,520,520,522,585,519,519,584,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1415,1484,1485,1611,1605,517,1793,1992,1992,2000,2000,2000,1992,1857,400,1603,1602,1537,1604,1540,1411,1538,1410,1475,1603,1410,1537,1604,1540,1539,1537,1601,1539,1540,1601,1601,1538,1603,1538,1411,1603,1537,1537,1475,1475,1538,1537,1475,1602,1409,1476,1475,1412,1475,1488,1424,1411,1473,1538,1476,1537,1615,399,399,963,82,1223,149,1487,466,1615,1367,1432,1367,1495,1486,1486,1488,1486,1422,1424,1422,1487,1616,1616,1422,1423,1551,1486,1423,1550,1432,1303,1304,1431,1304,1495,1615,1551,1551,1422,1424,1551,1422,1552,1424,1550,1422,1423,1615,1551,1423,1616,1424,1552,1614,1615,1616,1487,1615,781,781,781,781,781,781,781,781,781,781,647,521,1605,1605,651,1605,1605,1605,519,520,519,520,519,647,647,647,647,647,519,520,583,1614,1923,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1666,1992,1992,1992,1992,1992,1992,1857,1551,1605,1605,1605,1605,1605,1605,1605,1605,1606,1542,1477,1477,1413,1541,519,520,1413,1605,1605,1605,1605,1414,1605,1414,1606,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,583,522,584,519,520,1605,1477,1606,1606,1606,1413,1541,1414,1542,1414,1413,1605,1541,1605,1413,1606,1542,1605,1605,1605,1605,1605,1605,1605,456,1605,1605,1605,1605,1416,1605,1605,1605,1605,1605,1605,456,1793,1992,1992,2000,2000,2000,1992,1857,963,1602,1476,1473,1412,1409,1473,1410,1475,1412,1603,1601,1474,1540,1603,1603,1476,1412,1473,1538,1602,1537,1410,1475,1603,1601,1538,1539,1410,1604,1604,1538,1539,1409,1601,1473,1409,1602,1412,1601,1602,1539,1601,1603,1604,1601,1411,1550,1614,1486,1552,1550,1616,1551,1552,1550,1614,1367,1495,1616,1614,1550,528,530,530,530,530,530,147,1550,1422,1487,1614,1616,1488,1423,1550,1367,1495,1614,1614,1614,1614,1614,1423,1488,1552,1551,1486,1615,1551,1486,1488,1423,1615,1487,1616,1550,1551,1614,1614,1487,1550,1422,1486,1551,781,781,781,781,781,781,781,781,781,781,1605,521,1605,1605,1605,1605,1605,1605,522,584,711,584,711,584,711,647,647,647,711,584,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1423,519,711,520,1605,1605,1605,1605,1605,1605,1605,1605,1415,1414,1413,1478,1477,1605,1605,1605,1605,1605,1605,1478,1541,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1606,1541,1606,1605,1541,1424,1422,1423,1424,1422,1423,1424,1606,1542,1478,1541,1542,1478,1414,1542,1605,1605,1605,1605,1605,455,1605,1605,1605,1605,1605,1605,392,392,392,1605,1605,517,1793,1992,1992,2000,2000,2000,1992,1857,456,1411,1601,1475,1601,1475,1411,1473,1476,1410,1474,1411,1539,1410,1474,1540,1474,1601,1604,1539,1604,1474,1537,1474,1476,1409,1473,1412,1412,1410,1410,1602,1602,1538,1604,1473,1603,1604,1539,1410,1538,1604,1601,1601,1538,1604,1552,1614,1488,1488,1616,1615,1487,1551,1614,1551,1487,1495,1303,1486,1615,528,209,659,657,658,659,657,211,531,532,1615,1550,1550,1486,1486,781,1367,1614,1614,1614,1614,1614,1614,1614,1616,1423,1552,1486,1423,1487,1551,1614,1423,1615,1614,1550,1551,1614,1615,1422,1551,1422,144,145,146,781,781,781,781,781,781,781,781,781,781,647,647,583,1605,1605,1605,1605,711,650,650,650,650,650,522,519,520,519,520,519,520,1923,1666,1992,1992,1992,1992,1992,1992,1992,1669,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1927,1422,520,649,1605,711,520,711,1605,1605,1605,1605,1605,1605,1605,1605,1413,1413,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1414,1413,1541,1477,1606,1477,1541,1605,1477,1605,1605,1605,1541,1542,1606,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1414,1478,1606,1542,1413,1605,1605,1605,1605,1605,1605,1605,392,455,392,456,1605,1605,646,1793,1992,1992,2000,2000,2000,1992,1857,1615,1476,1602,1412,1410,1538,1475,1601,1410,1412,1411,1412,1539,1601,1473,1604,1540,1537,1410,1538,1538,1537,1473,1473,1537,1604,1410,1602,1539,1539,1603,1410,1603,1601,1411,1603,1603,1602,1475,1538,1539,1602,1540,1473,1604,1603,1411,1616,1488,1423,1488,1552,1614,1488,1423,1423,1423,1486,1488,1614,1486,272,722,723,721,722,723,721,722,723,660,1552,1495,1495,1431,1431,1423,1614,1614,1614,1614,1614,1614,781,1550,1422,1486,781,1614,1614,1616,1422,1422,1550,1616,1487,1487,1422,1424,1486,1551,1488,1486,208,209,210,781,781,781,781,781,781,781,781,781,781,1605,647,711,649,1605,1605,649,1605,650,650,650,650,650,650,522,584,583,584,583,584,1793,1992,1992,1992,1992,1992,1992,1992,1669,1927,1550,1487,1551,1551,1550,1551,1551,1423,1487,715,715,1614,715,715,519,584,519,521,711,1605,521,711,583,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1478,1606,1478,1478,1542,1478,1605,1606,1542,1605,1605,1605,1606,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1605,1606,1605,1605,1605,1605,1605,1605,456,391,455,456,455,1605,1605,516,1793,1992,1992,2000,2000,2000,1992,1857,853,1473,1601,1538,1410,1410,1602,1476,1601,1475,1476,1476,1538,1604,1411,1476,1603,1540,1473,1476,1604,1473,1603,1411,1602,1409,1475,1475,1410,1473,1410,1410,1537,1604,1473,1537,1603,1539,1601,1409,1412,1540,1539,1537,1537,1411,1604,1412,1411,1614,1488,1616,1487,1422,1614,1424,781,1488,1615,1486,1614,401,594,339,786,786,786,786,786,786,788,1614,1367,1368,1495,1368,1614,1614,1614,1614,961,962,963,964,965,966,967,1496,1432,1614,781,1551,1487,1486,1552,781,1487,1614,1422,1496,1422,1488,1552,272,273,274,781,781,781,781,781,781,781,781,781,781,781,519,583,586,1605,1605,1605,1605,650,711,647,584,650,650,583,583,519,522,519,522,1985,1861,1729,1992,1992,1992,1992,1992,1857,773,1550,1486,715,715,715,715,715,715,715,583,715,715,715,715,519,583,521,649,519,520,520,521,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1541,1605,1605,1414,1413,1541,1605,1605,1605,1477,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1413,1606,1414,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,519,1793,1992,1992,2000,2000,2000,1992,1857,965,1601,1603,1604,1601,1537,1537,1602,1538,1410,1603,1540,1474,1409,1473,1410,1540,1537,1410,1538,1473,1474,1411,1538,1410,1409,1473,1475,1539,1539,1602,1410,1540,1602,1409,1411,1409,1476,1538,1603,1475,1476,1537,1537,1409,1475,1537,1603,1410,1411,1474,1409,1487,1614,1423,1615,781,1551,1616,1424,1550,1614,401,403,1551,1423,1424,1423,1614,1616,1422,1422,1423,1615,1550,1614,1614,1614,1410,1409,1025,1026,1027,1028,1029,1030,1031,1496,1303,1614,1496,1550,1422,1488,1614,1615,1431,1431,1367,1496,144,145,146,209,594,595,781,781,781,781,781,781,781,781,781,781,781,647,1605,1605,1605,1605,1605,1605,584,647,647,647,1605,1605,519,1481,522,1476,1410,1483,1550,1422,1793,1992,1992,1992,1992,1992,1857,1614,715,715,715,715,715,520,583,715,715,715,715,715,583,715,583,583,584,520,520,520,583,519,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1477,1414,1605,1605,1605,1605,1605,1413,1605,1605,1605,1605,1605,1605,1605,1542,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1541,1606,1606,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,1793,1992,1992,2000,2000,2000,1992,1857,1349,1410,1411,1603,1538,1539,1537,1601,1412,1475,1410,1409,1604,1474,1537,1475,1538,1603,1538,1411,1475,1602,1476,1602,1603,1410,1603,1604,1411,1537,1539,1540,1476,1412,1475,1604,1474,1602,1409,1604,1604,1537,1537,1422,1473,1409,1410,1538,1474,1411,1538,1537,1412,1602,1475,1488,1486,1552,1423,1422,1552,1552,1550,1551,1552,1422,1488,1552,1552,1486,1550,1552,1486,1486,1423,1487,1614,1538,1602,1539,1089,1090,1091,1092,1093,1094,1095,781,1303,1432,1496,1423,1551,1614,1422,1368,1303,1303,1368,1496,208,209,210,657,658,659,781,781,781,781,781,781,781,781,781,781,781,647,1605,1605,1605,1605,1605,1605,1605,647,647,647,519,1605,1605,1545,1484,1412,1410,1483,393,1487,1985,1729,1992,1992,1992,1992,1857,1614,715,715,715,715,520,715,715,715,715,715,715,715,715,715,715,715,715,715,583,520,519,521,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1413,1606,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1542,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1542,1606,1542,1414,1605,1605,1605,1605,1605,1605,1605,584,1985,1729,1992,1992,2000,2000,1992,1857,710,1539,1602,1603,1410,1410,1551,1473,1615,1540,1409,1475,1602,1603,1540,1540,1537,1604,1412,1476,1602,1409,1412,1538,1539,1602,1412,1540,1412,1603,1409,1409,1537,1602,1538,1538,1411,1411,1602,1476,1473,1409,1539,1486,1551,1615,1616,1487,1616,1424,1486,1552,1475,1475,1476,1422,1615,1614,1488,1616,1616,1552,1487,1487,1423,1486,1431,1432,1486,1551,1487,1424,1615,1551,1422,1488,1424,1614,1409,1602,1153,1154,1155,1156,1157,1158,1159,781,1367,1303,1496,1422,1551,1486,1431,1303,1368,1304,1431,1496,272,273,274,721,722,723,781,781,781,781,781,781,781,781,781,781,647,519,583,1605,1605,1605,1605,1605,1605,584,647,647,1605,1605,1605,1605,1481,1538,1475,1483,711,393,1422,1793,1992,1992,1992,1992,1857,715,715,715,1614,1614,715,715,583,715,715,715,715,715,715,715,715,715,583,715,715,584,519,521,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1606,1414,1542,1413,1477,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1414,1477,1478,1478,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1414,1542,1605,1605,1605,1605,1605,1605,1605,520,582,1985,1729,1992,2000,2000,1992,1857,456,1602,1474,1538,1537,1475,1616,1422,1488,1550,1488,1488,1410,1604,1476,1475,1409,1538,1538,1538,1540,1476,1475,1540,1411,1411,1537,1412,1474,1475,1537,1603,1475,1411,1409,1539,1604,1537,1409,1603,1412,1476,1604,1539,1551,1486,1616,1551,1551,1550,1486,1615,1615,1422,1424,1422,1486,1422,1424,1424,1411,1604,1422,1422,1615,1552,1486,1367,1367,1304,1474,1475,1475,1538,1552,1422,1487,1488,1614,1614,1217,1218,1219,1220,1221,1222,1223,1496,1431,1368,1496,1424,1488,1486,1495,1368,1368,1368,1368,1496,656,593,594,595,723,722,781,781,781,781,781,781,781,781,781,781,647,518,651,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1481,1411,1412,1483,393,393,1422,1793,1992,1992,1992,1992,1857,715,715,715,1614,1614,1614,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,520,583,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1415,1605,1542,1542,1605,1605,1415,1541,1477,1541,1605,1605,1605,1605,1605,1541,1606,1414,1606,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1542,1605,1605,1605,1605,1605,1605,1605,519,836,392,1793,1992,2000,2000,1992,1857,1349,466,1604,1473,1412,1538,1614,1615,1488,1615,1552,1552,1539,1602,1601,1411,1602,1540,1537,1473,1411,1476,1409,1538,1476,1410,1604,1476,1412,1540,1474,1538,1602,1411,1537,1603,1473,1474,1601,1474,1603,1601,1539,1412,1412,1487,1488,1550,1424,1614,528,530,530,530,532,1487,1614,1423,1550,1488,1488,1604,1409,1538,1475,1473,1410,1476,1410,1539,1475,1602,1614,1488,1615,1487,1615,1614,1614,1616,1281,1282,1283,1284,1285,1286,1287,1496,1303,1424,1496,1423,1488,1488,1431,1367,1367,1368,1432,1496,656,657,658,657,721,658,781,781,781,781,781,781,781,781,781,781,647,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1481,1539,1474,1483,393,393,1423,1793,1992,1992,1992,1992,1857,715,715,520,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,1294,1360,1360,1358,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1415,1413,1413,1413,1605,1605,1606,1605,1413,1605,1605,1605,1605,1414,1542,1605,1605,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1477,1605,1605,1605,1605,1605,1605,1605,456,456,773,1793,1992,2000,2000,1992,1857,966,655,1411,1604,1540,1539,1412,1486,1487,1424,1603,1539,1537,1476,1409,1473,1475,1604,1473,1473,1474,1601,1410,1473,1537,1409,1474,1410,1540,1409,1538,1538,1540,1537,1474,1476,1473,1540,1474,1412,1540,1474,1475,1537,1538,1487,1614,1551,1614,1487,656,658,659,657,276,1486,1550,1422,1551,1616,1615,1552,1551,1551,1473,1473,1412,1540,1602,1411,1539,1552,1422,1551,1614,1487,1614,1614,1422,1614,1345,1346,1347,1348,1349,1350,1351,781,1431,1432,1496,1422,1423,1424,1423,1432,1304,1495,1368,1496,336,337,723,593,594,594,781,781,781,781,781,781,781,781,781,781,647,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1481,1538,1539,1483,393,393,1551,1793,1992,1992,1992,1992,1857,715,715,583,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,583,715,715,715,715,1294,1360,1294,781,781,1605,1542,1478,1605,1605,1605,1605,1605,1605,1605,1605,1478,1605,1605,1413,1415,1605,1605,1605,1413,1478,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1542,1542,1605,1605,1605,1605,1605,1605,391,516,392,1793,1992,2000,2000,1992,1857,392,1487,1349,1604,1603,1412,1474,1476,1604,1603,1603,1540,1409,1603,1601,1412,1537,1412,1474,1602,1410,1473,1539,1540,1412,1410,1601,1540,1602,1410,1540,1409,1538,1474,1475,1540,1604,1411,1603,1539,1411,1410,1601,1476,1538,1552,1424,1488,1551,1422,656,722,723,721,211,212,1616,1550,1487,1424,781,1488,1615,1422,1476,1603,1424,1552,1552,1551,1614,1422,1423,1616,1486,1423,1614,1614,1614,1551,1550,1487,1488,1487,1614,1614,781,781,1423,1303,1496,1614,1488,1615,1551,1550,1431,1495,1367,1496,400,272,593,594,658,657,781,781,781,781,781,781,781,781,781,781,647,518,583,1605,1605,1605,1605,1605,1605,1605,1605,1605,1415,1605,1605,1605,1481,1411,1474,1483,393,710,1424,1793,1992,1992,1992,1669,1927,773,715,715,715,715,715,715,715,715,715,715,1559,1482,1482,1549,1559,715,715,715,715,715,715,715,715,711,711,649,1605,1294,1294,781,1605,1477,1478,1477,1542,1542,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1542,1605,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1477,1605,1605,1605,1605,1605,1605,1605,330,392,853,1793,1992,2000,2000,1992,1857,1487,82,966,1603,1474,1540,1410,1540,1603,1604,1476,1409,1601,1538,1601,1409,1602,1409,1601,1409,1603,1602,1603,1538,1538,1539,1473,1537,1602,1412,1474,1603,1487,1614,1423,1604,1539,1475,1539,1602,1409,1602,1603,1540,1539,1423,1552,1424,1614,1614,656,594,595,593,594,211,530,532,1424,1422,1614,1550,1486,1614,1614,1614,1614,1614,1474,1424,1552,1551,1488,1488,1550,1616,1422,1614,1550,1614,1550,1616,1616,1424,1423,1423,1367,1367,1423,1495,781,1614,1488,1616,1551,1616,1614,1367,1424,781,1552,656,657,658,723,722,781,781,781,781,781,781,781,781,781,781,781,647,518,647,521,521,647,647,647,518,518,647,518,647,1605,1605,1481,1540,1540,1483,393,393,1423,1793,1992,1992,1992,1857,1424,583,520,715,715,715,715,715,715,583,715,715,1623,1609,1482,1611,715,715,715,715,715,715,715,715,519,519,711,711,1605,1605,1294,1361,1605,1478,1414,1542,1478,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1484,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1413,1541,1414,1477,1605,1605,1605,1605,392,710,773,1793,1992,2000,2000,1992,1857,466,1615,1223,655,1539,1475,1539,1540,1411,1601,1537,1474,1603,1539,1602,1411,1538,1476,1604,1410,1604,1410,1409,1476,1409,1539,1474,1475,1475,1537,1601,1424,1551,1423,1550,1486,1603,1602,1540,1473,1537,1601,1537,1537,1538,1551,1487,1423,1614,1487,784,658,659,657,658,659,657,658,532,1487,1486,1487,1614,1614,1614,1614,1614,1614,1604,1488,1488,1551,1486,1423,528,530,531,532,1614,1616,1422,1614,1424,1423,1551,1422,1368,1304,1614,1615,781,781,781,1551,1614,1550,781,781,781,781,1422,336,337,338,593,594,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1481,1412,1540,1483,393,393,1551,1793,1992,1992,1992,1857,773,1605,520,519,583,519,583,711,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,1605,1605,1605,1416,1605,1605,1416,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1416,1420,1421,1605,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1605,1606,1478,1605,1478,1606,1605,1605,516,963,399,1793,1992,2000,2000,1992,1857,966,580,965,1223,1410,1475,1603,1476,1538,1603,1475,1411,1539,1473,1409,1409,1601,1537,1603,1409,1474,1474,1537,1473,1537,1604,1411,1473,1604,1412,1614,1486,1551,1423,1486,1422,1615,1473,1601,1537,1411,1410,1603,1604,1409,1616,1616,1615,1488,1486,1422,336,337,721,722,723,721,722,660,1488,1614,1552,1488,1486,1614,1614,1537,1410,1537,1422,1488,1422,1424,1424,592,657,658,660,1424,1615,1486,1614,1550,1487,1551,1424,1488,1486,1423,1551,1431,1368,1495,1614,1550,1367,1303,1496,1422,1422,1422,1550,401,402,657,658,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1481,1411,1412,1483,393,393,1422,1793,1992,1992,1992,1857,1486,1605,1605,711,583,649,584,1559,1605,1415,715,715,715,647,715,715,715,715,715,583,715,715,715,715,1605,1605,1609,1418,1418,1418,1418,1418,1418,1418,1418,1418,1418,1418,1418,1418,1419,1605,1605,1605,1605,1605,1605,1605,1484,1485,1415,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1606,1414,1477,1606,1605,1542,1605,1605,330,710,516,1793,1992,2000,2000,1992,1857,82,1349,773,391,655,1411,1473,1410,1409,1475,1602,1601,1537,1539,1537,1473,1540,1603,1475,1603,1412,1537,1602,1474,1602,1540,1409,1537,1604,1412,1614,1422,1422,1487,1604,1552,1552,1552,1474,1603,1538,1474,1474,1410,1601,1552,1551,1422,1486,1422,1550,1550,336,337,594,595,593,594,788,1424,1615,1422,1488,1488,1614,1410,1411,781,1487,1487,1550,1551,1550,781,656,721,722,660,1550,1616,1488,1423,1486,1422,1550,1614,1614,1487,1552,1550,1304,1303,1614,1424,1424,1487,1368,1496,1486,1422,1487,1423,1488,1614,336,337,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,518,1605,1481,1482,1540,1483,393,710,1551,1793,1992,1992,1992,1857,1615,1605,1605,1605,1605,1605,1605,1605,1605,649,715,715,647,715,715,715,715,715,715,715,715,715,715,715,1605,1415,1605,1545,1546,1546,1546,1546,1546,1546,1484,1410,1410,1410,1410,1410,1410,1418,1418,1418,1419,1605,1416,1548,1610,1611,1605,1415,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1605,1606,1414,1477,1477,1605,1605,1605,1605,455,469,1349,1793,1992,1992,1992,1992,1857,1349,466,516,456,392,1412,1603,1603,1601,1603,1603,1410,1604,1539,1537,1475,1473,1409,1409,1475,1540,1603,1473,1601,1540,1475,1603,1411,1539,1476,1475,1474,1487,1614,1487,1550,1488,1602,1409,1602,1475,1603,1602,1539,1412,1424,1424,1550,1550,1552,1422,1550,1614,401,658,339,787,788,1615,1615,781,1423,1615,1424,1602,1540,1476,1475,1422,1615,1431,1304,1486,1486,784,785,786,788,1487,1551,1432,1367,1423,1422,1423,1424,1614,1487,1486,1550,1614,1488,1551,1487,1550,1486,1495,1496,1551,1616,1616,1486,1615,1550,400,401,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1481,1601,1476,1421,1419,393,1551,1793,1992,1992,1992,1667,1925,1605,1605,1559,1605,1605,1605,1605,1605,519,584,715,715,715,715,715,715,583,715,715,715,715,715,520,1605,1605,1605,1605,1605,1605,1605,521,1605,1605,1545,1546,1546,1410,1410,1410,1485,1546,1546,1546,1546,1610,1610,1613,1416,1605,1605,1605,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1477,1413,1605,1605,1605,1605,1605,1605,1605,456,277,853,1793,1992,1992,1992,1861,1858,965,149,469,964,853,1410,1410,1539,1604,1410,1601,1539,1475,1474,1537,1604,1474,1409,1474,1475,1538,1540,1539,1602,1411,1538,1537,1476,1603,1601,1474,1409,1602,1422,1488,1614,1488,1474,1411,1411,1411,1539,1540,1411,1409,1551,1475,1487,1551,1550,1552,1488,1424,1488,784,788,1488,1423,1423,1422,781,1550,1487,1604,1538,1539,1604,1539,1552,1614,1552,1431,1495,1616,1487,1614,781,1551,1551,1495,1432,1368,1616,1551,1616,1615,1486,1486,1551,1424,1614,1614,1423,1424,1486,1423,1303,1496,1424,1423,1551,1616,1550,1488,1552,1487,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1481,1538,1539,1412,1483,393,1486,1793,1992,1992,1992,1992,1857,708,1605,1605,1605,1605,1605,1605,1605,584,649,584,1481,715,715,1483,711,715,715,715,715,583,715,715,1605,1605,1416,1605,1605,1605,1605,584,1605,1605,1605,1605,1605,1545,1484,1601,1483,1605,1605,1605,1605,1605,1605,1605,1605,1416,1605,1605,1605,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1414,1605,1605,1605,1605,1605,1605,1605,1605,516,853,965,1795,1861,1861,1858,1614,1921,964,580,399,1615,1615,1552,1537,1409,1540,1412,1476,1409,1410,1412,1410,1602,1601,1410,1603,1410,1412,1603,1538,1412,1473,1409,1410,1476,1410,1475,1604,1473,1474,1488,1616,1422,1488,1602,1540,1537,1538,1538,1538,1538,1539,1422,1409,1540,1424,1551,1423,1550,1615,1424,1487,1550,1551,1423,1616,1486,1614,1486,1409,1540,1538,1604,1540,1604,1424,1423,1431,1495,1431,1367,1550,1616,1551,1488,1550,1615,1614,1432,1431,1614,1614,1551,1424,1551,1423,1615,1488,1550,1486,1422,1423,1488,1486,1496,1487,1423,1616,1488,1614,1550,1616,1487,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1545,1538,1538,1540,1601,1419,1422,1793,1992,1992,1992,1992,1857,643,1605,1605,1605,1605,1605,1605,1605,520,520,519,1481,715,1475,1483,1605,517,1559,583,715,520,520,521,649,649,711,1605,521,583,519,583,1605,1605,1416,1605,1605,1605,1481,1601,1483,1605,1416,1605,1605,1605,1415,1605,1605,1605,1605,1605,1605,1605,1605,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1414,1477,1413,1605,1605,1605,1605,1605,1605,1605,517,773,330,1921,1614,1615,1921,1550,1921,399,399,399,965,963,1551,1475,1540,1538,1539,1412,1604,1604,1603,1537,1409,1602,1475,1475,1601,1538,1473,1475,1475,1539,1474,1603,1410,1474,1409,1475,1474,1412,1601,1412,1409,1476,1474,1537,1603,1474,1409,1475,1423,1424,1422,1423,1473,1603,1487,1551,1488,1486,1424,1488,1552,1488,1615,1551,1486,1487,1603,1409,1540,1476,1538,1412,1551,1488,1487,1367,1615,1304,1431,1495,1552,1615,1552,1616,1423,1424,1304,1367,1303,1303,1431,1552,1616,1550,1616,1486,1424,1615,1487,1552,1615,1551,1496,1422,1551,1424,1488,1423,528,529,146,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1545,1476,1410,1540,1540,1419,1793,1992,1992,1992,1992,1857,1614,1605,1605,1605,1605,1605,1605,1605,584,1605,1605,1481,1538,1412,1547,1605,581,581,517,649,517,519,711,520,1605,1605,1605,1605,584,520,649,1605,1605,649,649,649,649,1481,1601,1547,649,649,1478,1413,1605,1541,1605,1605,1605,1605,1294,1297,1605,1605,1605,1605,1605,1413,1477,1542,1477,1413,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1552,1550,1551,1477,1606,1477,1605,1605,1605,1605,1605,1605,1605,1605,1605,773,517,1794,1925,1614,1794,1797,1859,781,781,781,781,963,1422,1552,1539,1410,1539,1473,1537,1412,1409,1601,1412,1602,1539,1539,1601,1411,1602,1475,1604,1540,1604,1410,1409,1410,1539,1473,1537,1539,1474,1601,1538,1473,1412,1539,1410,1538,1537,1488,1615,1550,1551,1487,1422,1411,1475,1602,1488,1486,1488,1488,1423,1550,1487,1410,1409,1539,1474,1604,1538,1604,1473,1538,1423,1486,1551,1495,1303,1432,1432,1367,1423,1486,1422,1551,1551,1424,1303,1303,1432,1495,1488,1424,1488,1552,1423,1616,1423,1423,1422,1616,1552,1614,1496,1487,1552,1488,1488,1615,592,593,721,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1545,1546,1484,1601,1474,1985,1729,1992,1992,1992,1857,708,1605,1605,1605,1605,1605,1605,1541,1478,1605,1417,1475,1411,1483,1605,1605,1605,781,781,781,781,781,781,781,781,520,583,781,781,781,584,1605,1605,1605,1478,1479,1416,1481,1483,520,455,1415,1541,1414,1605,1605,1605,1605,1605,1605,1294,781,781,1297,1605,1605,1605,1605,1605,1414,1414,1477,1478,1414,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1616,1614,1615,1414,1413,1605,1605,1605,1605,1605,1605,1605,1605,1605,1359,1359,1359,1793,1667,1797,1666,1992,1857,781,781,781,781,781,1551,1410,1537,1487,1602,1476,1540,1538,1410,1601,1410,1602,1473,1604,1538,1602,1539,1601,1473,1473,1537,1538,1604,1476,1474,1475,1412,1538,1409,1476,1476,1474,1412,1411,1410,1603,1538,1552,1488,1488,1616,1422,1488,1614,1422,1473,1539,1409,1473,1476,1409,1540,1540,1540,1602,1473,1412,1474,1540,1411,1475,1488,781,1550,1423,1616,1368,1303,1488,1550,1423,1614,1614,1551,1487,1486,1486,1486,1616,1486,1614,1552,1552,1424,1422,1550,1487,1488,1614,1432,1367,1431,1496,1551,1615,1486,1552,208,209,595,659,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1545,1475,1410,1475,1985,1992,1992,1992,1857,643,1605,1605,1605,1605,1605,1605,1605,1605,1417,1475,1482,1540,1483,1605,1605,1605,781,781,781,781,781,781,781,781,584,649,781,781,781,649,1605,1605,1477,1414,1416,1414,1481,1483,519,1415,1416,1605,1414,1605,1413,1605,1605,1605,1605,1294,781,781,781,781,1297,1605,1605,1605,1605,1542,1605,1541,1413,1413,1605,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1424,1422,1423,1414,1541,1541,1414,1606,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1297,1297,1361,1992,1992,1992,1992,1361,781,781,781,781,781,1551,1537,1614,1487,655,516,466,1412,1601,1604,1411,1411,1602,1604,1537,1604,1473,1474,1410,1537,1475,1473,1409,1412,1602,1476,1473,1410,1409,1539,1411,1409,1538,1473,1473,1411,1473,1551,1424,781,1422,1616,1614,1550,1602,1411,1603,1537,1604,1538,1537,1602,1411,1474,1475,1475,1540,1616,1615,1552,1411,1551,1422,1616,1550,1487,1614,1552,1303,1303,1614,1614,1614,1551,1487,1552,1615,1488,1422,1551,1423,1616,1616,1486,1424,1487,1614,1550,1422,1495,1431,1303,1496,1616,1616,1422,1616,272,721,593,721,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1410,1605,1605,1605,1605,1545,1484,1603,919,919,919,919,919,1418,1418,1418,1418,1418,1418,1418,1418,1418,1412,1482,1475,1410,1483,1605,1605,1605,781,781,781,781,781,781,781,781,583,649,1358,1360,1361,519,584,1605,1606,649,1477,711,1481,1483,584,1416,519,1414,1414,1478,1414,1605,1605,1605,1605,1294,1361,781,781,781,781,781,781,1297,1605,1605,1605,1605,1605,1478,1605,1414,1415,1605,1487,1488,1486,1487,1488,1486,1487,1488,1486,1487,1488,1542,1542,1541,1477,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1294,1297,1297,1361,1992,1992,1992,1992,1361,1361,1361,1361,1361,781,1486,1473,1616,1488,781,456,966,1603,1412,1540,1475,1604,1603,1474,1537,1476,1603,1473,1538,1537,1412,1473,1412,1411,1601,1601,1475,1412,1409,1604,1410,1410,1601,1539,1475,1602,1550,1616,1614,781,1550,1422,1475,1604,1604,1473,1473,1475,1538,1410,1537,1604,1411,1475,1422,1486,1488,1488,1550,1550,1615,1552,781,1487,1488,1422,1422,1550,1368,1368,1552,1487,1551,1550,1486,781,1487,1422,1422,1550,781,530,530,530,530,530,532,1615,1424,1431,1552,1551,781,1550,1614,1422,1423,272,657,658,594,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1410,1605,1605,1605,1415,1605,1481,1603,985,983,983,1049,983,1601,1474,1538,1412,1540,1411,1412,1538,1411,1540,1538,1410,1410,1547,1605,836,1605,781,781,781,781,781,781,781,781,520,583,584,519,519,649,1413,1542,1542,1605,1478,520,1481,1483,649,519,520,1414,520,1605,1414,1478,1605,1605,1605,1605,1605,1361,1361,1361,781,781,781,781,781,1297,1605,1605,1605,1541,1413,1606,1478,1542,1605,1605,1605,1605,1542,1477,1605,1477,1550,1551,1541,1606,1477,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1230,1231,1294,1297,1297,1361,1992,2000,2000,1992,1667,1797,1925,456,1361,1361,1603,1476,1616,781,781,781,466,82,966,516,391,1487,466,456,1409,1539,1476,1537,1410,1537,1410,1537,1476,1476,1539,1412,1409,1475,655,1604,1603,1603,1539,1223,964,1615,469,963,965,781,469,1602,1368,1304,1538,1476,1602,1304,1539,1304,1474,1367,1367,1368,1539,1539,1616,1616,1552,1551,1615,1424,781,1487,1615,781,1487,1616,1486,1368,1551,781,1423,1551,1550,1488,1486,1423,1550,720,721,657,658,659,657,658,660,1424,1422,1616,1614,528,529,529,529,529,529,209,657,723,723,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1410,1410,1605,1605,1605,1605,1605,1545,1484,1047,1047,1047,1047,1047,1546,1546,1546,1546,1546,1546,1546,1546,1546,1546,1546,1546,1547,1605,1609,1613,1605,1294,1361,1360,1361,1360,1361,1361,1361,583,649,519,519,519,519,455,649,649,584,520,519,1481,1483,519,517,649,1541,520,649,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1361,1361,1361,1361,781,781,781,781,1605,1541,1541,1413,1415,1478,1606,1542,1478,1605,1605,1478,1478,1542,1414,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1230,1359,1359,1359,1359,1294,1297,1297,1297,1297,1361,1992,2000,2000,1992,1992,1992,1857,1422,1486,1552,1488,1411,1552,1361,1361,781,781,781,781,781,781,781,853,655,277,391,1487,399,330,400,655,1475,1475,1476,1409,1538,1422,966,1223,1223,964,469,1349,400,965,853,1487,466,1615,781,965,1473,1602,1474,1539,1539,1368,1476,1304,1409,1537,1304,1409,1287,1539,1539,781,1488,1616,1488,1487,1487,1486,1488,1551,1422,1424,1487,1551,1422,1424,1552,1488,1614,1552,1550,1488,1487,1614,720,657,721,722,723,721,722,660,1550,1615,1487,1616,656,722,657,594,722,594,657,722,721,593,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1410,1605,1605,1605,1605,1605,1605,391,1486,1793,1992,1992,1992,1857,1614,1605,519,1605,519,649,519,649,583,583,649,584,519,651,711,711,651,651,584,649,520,649,584,519,519,520,1477,1542,1542,519,519,455,584,1605,1605,1605,520,1545,1483,711,519,517,584,520,649,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1361,1361,1361,1361,1605,1541,1605,1605,1417,1605,1409,1410,1605,1419,1605,1542,1606,1605,1605,1605,1605,1230,1231,1296,1231,1359,1296,1231,1296,1231,1294,1297,1297,1297,1297,1297,1297,1297,1297,1297,1793,1992,1992,2000,2000,1992,1992,1857,1422,1423,1552,1550,1550,655,330,1361,1361,1361,1361,781,781,781,781,781,781,781,781,781,781,466,1223,1487,1602,1601,1476,1602,853,963,399,964,963,965,82,1487,400,965,466,963,853,466,781,469,1537,1410,1473,1476,1303,1410,1303,1368,1287,1473,1537,1410,1304,1539,1539,781,1423,1614,1551,1616,1615,1422,1615,1488,1616,1616,1616,1486,1614,1488,1424,1615,1616,1486,1423,1616,1424,1488,401,594,593,594,595,593,594,660,1614,1551,1422,1552,656,657,721,658,659,721,594,721,659,721,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1410,1605,1605,1605,1605,1605,1605,1605,456,1423,1793,1992,1992,1669,1927,1614,1605,1605,520,520,519,649,520,649,519,583,520,646,519,651,520,519,584,519,583,519,649,520,584,520,1605,1541,1477,1605,649,649,455,455,1605,1605,1605,1605,711,1544,584,649,517,520,584,649,1605,1605,1605,519,522,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1545,1484,1473,1474,1475,1605,1605,1477,1414,1230,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,330,1985,1729,1992,2000,2000,1992,1992,1857,1486,1552,1604,1601,1539,330,655,469,516,966,1361,1361,1361,1361,781,781,781,781,781,781,781,781,781,965,1537,1603,400,781,781,781,781,781,781,781,781,781,781,781,781,781,853,82,781,966,1474,1304,1410,1287,1476,1367,1368,1367,1304,1476,1409,1410,1602,1539,1539,1550,1423,1486,1550,1488,1486,1423,1424,1488,1552,1486,1552,1616,1486,1488,1550,1488,1615,1486,1615,1614,1486,1615,1424,401,337,658,659,657,658,660,1614,1615,1424,1424,656,657,722,721,722,723,658,595,595,723,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1410,1410,1605,1605,1605,1605,1605,1605,1605,456,1551,1793,1992,1992,1857,1486,1605,583,520,584,649,1605,520,584,584,584,1605,1605,1605,1605,1605,1605,1605,646,520,520,584,1605,1605,1605,520,520,584,1414,1605,649,583,519,517,1605,1605,1605,1605,1605,1544,517,584,584,1414,1413,649,1605,1605,1605,583,583,583,584,1605,1605,1605,1605,1605,519,520,522,519,1605,1605,1605,1605,1605,1605,1605,1605,1484,1538,1539,1605,1419,584,519,583,584,520,584,583,520,519,519,584,583,520,519,584,583,584,583,519,583,520,1605,392,582,456,516,1793,1992,2000,2000,1992,1992,1857,1550,1486,1539,1473,1603,1539,1488,1486,1487,330,516,965,456,1361,1361,1361,1361,1361,1361,1361,1361,781,781,1615,1603,1537,469,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1304,1409,1539,1367,1410,1539,1602,1304,1409,1474,1368,1410,1367,1539,1539,1539,1423,1423,1614,1486,1615,1552,1488,1550,1487,1422,1615,144,145,146,146,146,146,532,1423,1424,1488,1550,1488,1616,1614,656,722,723,721,722,660,1487,1422,1615,1552,656,659,593,722,723,659,723,721,659,659,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,520,520,1605,1605,1410,1605,1605,1605,1605,1605,1605,1605,1605,455,1487,1793,1992,1992,1927,1422,649,584,1605,1605,1605,1605,1605,649,519,520,583,583,520,1605,1605,1605,1605,649,519,1605,1605,1605,1605,1605,519,649,583,583,520,649,584,520,1477,1477,1542,517,1416,519,1544,711,519,1414,1606,1478,1605,1477,1605,1605,1605,1605,1605,519,583,1605,1605,1605,1605,583,583,583,583,520,522,584,1605,1605,1605,1605,1605,1481,1602,1603,1604,1605,1605,1605,584,583,584,519,584,583,583,583,584,584,584,520,520,519,583,520,584,519,1605,1605,517,582,1615,1488,1793,1992,1992,2000,2000,1992,1857,1488,1488,1603,1538,1540,1412,1474,1423,1551,466,516,710,277,456,963,963,966,391,966,964,82,1361,1361,963,277,400,964,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,963,1410,1367,1476,1367,1473,1368,1602,1410,1539,1474,1410,1303,964,1539,1539,1487,1487,1423,1488,1550,1422,1487,1487,1551,208,146,146,209,658,659,657,658,660,1616,1552,1487,1424,1550,1486,1615,784,787,787,787,787,403,1614,1615,1550,1550,656,723,593,722,659,595,721,721,593,657,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,519,1605,1605,1605,1410,1605,1605,1605,1605,1605,1605,1605,1605,456,1486,1793,1992,1857,1486,1423,583,649,1605,1605,1605,1605,1605,519,583,520,583,649,583,583,1605,1605,1605,1605,1605,1605,1605,1605,1605,583,1923,1925,583,520,520,584,1478,1414,1605,1542,1478,1541,1479,517,1608,519,519,455,1414,1605,1413,1605,1414,1605,1605,1605,1605,1605,583,1605,1605,1605,1605,519,522,584,519,584,583,584,1605,1605,1605,1605,1605,1481,1410,1411,1412,1605,1419,1605,1605,1605,1605,583,584,583,584,519,520,520,519,583,519,583,583,520,584,1605,1605,1605,517,330,1486,1614,1793,1992,1992,2000,2000,1992,1857,1422,1424,1411,1604,1601,1539,1601,1486,1424,1424,1423,1551,400,965,964,965,964,963,773,1615,1487,330,853,277,1349,82,277,399,277,966,964,400,964,966,400,466,277,400,1349,466,965,149,1615,466,1476,1410,1409,1410,1539,1409,1367,1602,1303,1287,1303,1476,1538,1539,1539,1615,1486,1550,1616,1616,1551,1424,1615,1552,272,722,723,721,722,723,721,722,660,1550,1423,1615,1422,1615,1552,1551,1550,1551,1550,1616,1616,1616,1551,1550,1487,1614,656,658,659,657,658,593,721,658,593,594,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,520,520,583,584,1605,1410,1410,1605,1605,1605,1605,1605,1605,1605,1605,1605,1423,1793,1992,1857,1423,1550,520,583,649,649,519,1605,1605,584,584,519,520,520,583,519,649,584,1605,1605,1605,1605,1605,583,519,1923,1666,1992,1925,583,520,584,1541,1606,1478,584,711,520,1416,1479,520,517,517,519,584,1478,1606,1606,1542,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,520,583,522,583,522,1605,1605,1605,1605,1605,1605,1605,1545,1484,1475,1476,1473,1483,1605,1605,1605,1605,1605,1605,1605,1605,1605,519,584,520,519,520,583,519,519,583,1605,1605,1605,646,330,1486,1615,1793,1992,1992,2000,2000,1992,1857,1486,1422,1474,1473,1412,1603,1537,1423,1422,1551,1487,1551,391,400,82,392,82,399,655,456,1615,392,399,466,1537,1537,964,655,964,466,82,466,466,853,400,1615,466,853,82,400,966,1223,1615,466,1538,1474,1539,1410,1304,1539,1473,1410,1410,965,853,466,149,1539,1539,781,1487,1486,1423,1486,1615,1550,1551,1422,336,402,595,593,594,595,593,594,660,1423,1422,1486,1614,1424,1550,1486,1423,1552,1552,1614,1486,1615,1550,1486,1615,1552,656,595,593,595,657,723,595,722,722,594,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,584,520,1605,1605,1410,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1551,1793,1992,1667,1925,1551,649,520,583,519,649,519,520,519,583,1923,1797,1797,1797,1925,519,520,1605,1605,1605,1605,1605,584,519,1985,1992,1992,1992,1925,520,520,649,1605,1605,583,1541,1477,1414,1541,1416,1541,1416,1478,584,1479,583,1413,1477,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1481,1539,1540,1537,1483,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,583,584,520,520,1605,1605,1605,1605,1605,392,582,516,1552,1793,1992,1992,2000,2000,1992,1857,1423,1551,1424,1487,1473,1411,1602,1488,1488,1422,1551,1551,963,277,277,456,965,965,1487,466,330,580,966,1487,1537,1537,277,965,1349,964,963,399,853,964,963,400,965,399,965,466,1223,965,400,466,1476,1287,1367,400,400,1410,1474,1303,1410,1476,1410,1287,1473,1539,1539,1487,1423,1551,1422,1422,1488,1552,1616,1487,1424,1424,401,657,658,659,657,658,660,1616,1423,1423,1616,1551,1550,1550,1616,1616,1614,1616,1422,1615,1551,1616,144,145,209,721,721,721,723,594,593,657,657,659,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,715,715,715,715,715,583,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,456,1422,1793,1992,1992,1667,1925,1614,584,520,519,583,583,649,519,1988,1861,1992,1992,1992,1857,583,519,1605,1605,1605,1605,1605,519,583,583,1985,1861,1992,1992,1925,519,649,1605,1605,1477,1413,1478,1414,1478,1477,1413,1414,1477,1542,1413,649,583,519,1605,1605,1605,1605,391,391,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1545,1484,1604,1601,1605,1419,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,584,584,1605,1605,1605,1605,1605,1605,1605,391,516,1422,1550,1793,1992,1992,2000,2000,1992,1857,966,1488,1551,1551,1551,1412,1474,1424,1486,1422,1424,1486,963,966,399,82,1349,82,1615,466,1349,966,1487,1487,1537,1537,1487,853,965,963,82,963,1615,149,399,400,655,966,655,1615,82,853,781,82,1474,1473,1602,1287,1539,1537,1538,1476,1367,1602,1287,1304,1538,1539,1539,1486,1552,1486,1614,1488,1487,1552,1488,1551,1551,1423,1551,721,722,723,721,722,723,1550,1487,1486,1488,1487,1422,1615,1422,1422,1423,1552,1616,1488,1487,1616,208,209,210,593,659,595,657,659,721,721,1297,723,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,715,715,715,715,715,519,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,456,1487,1793,1992,1992,1992,1667,1925,1614,1614,583,649,584,519,583,584,520,1985,1861,1861,1927,519,649,1605,1605,1605,1605,1605,1605,1605,584,649,649,1793,1992,1857,584,711,519,520,1413,1413,1478,1413,1477,1541,1606,1606,1606,1414,1542,583,520,522,583,1605,1605,391,455,392,392,456,392,1605,1605,1605,1605,1605,1605,1605,1605,0,0,0,1605,1361,1605,1605,1481,1412,1409,1410,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,646,391,1487,1551,1793,1992,1992,2000,2000,1992,1857,1550,1550,1486,1422,1551,1552,1488,1487,1487,1487,1552,1423,1423,1488,1486,1550,1552,1423,1552,1488,1551,1422,1423,963,1537,1537,1537,466,1615,655,1223,399,82,966,466,965,1223,469,400,1487,82,400,781,82,1410,1602,1476,1304,1304,1223,963,1303,1539,1476,853,1537,1602,1539,1539,1551,1486,1487,1614,1422,1614,1552,1422,1488,1550,1423,1552,593,594,595,593,594,595,1615,1422,1488,1616,1486,1486,1614,1614,1552,1551,1486,1487,1424,1615,208,209,593,594,595,723,210,595,593,595,658,657,659,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,715,715,715,715,715,715,520,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,1550,1793,1992,1992,1992,1992,1667,1797,1925,1614,1614,649,584,520,519,520,584,519,584,649,584,1605,1605,1605,519,583,584,1605,1605,519,646,519,1985,1992,1927,583,646,519,520,1413,1542,1413,1606,1541,1605,1477,1414,1542,1477,1478,1414,520,711,649,649,1486,1615,1486,1486,1424,392,391,456,391,648,1605,1605,1605,1605,1605,0,0,0,1361,1605,1605,1605,1545,1484,1473,1474,1605,1419,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,580,516,1550,1985,1729,1992,2000,2000,1992,1667,1925,1615,1552,1551,1488,1422,1487,1552,1423,1422,1486,1488,1487,1551,1422,1550,1488,1487,1424,1551,1551,1488,1423,400,1223,1537,1537,399,82,966,965,1223,1223,966,400,853,82,466,655,466,655,966,781,1409,149,1304,1410,1304,1473,1474,1304,1303,963,1367,1537,1368,1537,1539,1539,1551,1422,1614,1487,1423,1487,1422,1423,1614,1614,1423,1423,1486,1551,1551,1550,1551,1424,1615,1614,1422,1616,1424,1552,1616,1422,1551,1422,1488,1614,1614,1614,272,273,657,593,594,595,210,594,721,273,722,273,275,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,715,715,715,715,715,715,520,583,1605,1605,1605,1605,1605,1605,1605,1605,392,456,1614,1923,1666,1992,1992,1992,1992,1992,1992,1667,1797,1925,1614,1614,520,516,584,649,519,584,649,649,1605,1605,1605,649,584,520,1605,1605,836,646,649,584,1989,520,519,519,646,836,1541,1478,1605,1413,1478,1414,1541,1477,1414,1478,1477,1413,583,520,1424,1615,1488,1424,1423,1616,1423,1487,1487,1550,456,456,456,1605,1605,1605,1361,1361,1361,1361,1605,1605,1605,1605,1605,1481,1537,1538,1539,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,840,967,840,840,1281,840,706,1605,1605,1605,646,582,1486,1423,1793,1992,2000,2000,1992,1992,1667,1925,1424,1424,1424,1488,1424,1487,1551,1424,1487,1424,715,715,715,715,715,1488,1551,1551,1550,1488,1550,1423,1424,1537,1537,1486,1422,1486,1487,1552,1550,1488,1552,655,1615,469,655,277,963,469,781,469,1304,1473,853,1367,1473,1473,1487,1304,1287,1410,1474,1368,1538,1539,1539,1486,1552,1551,1486,1422,1422,1552,1488,1488,1422,1615,1487,1550,1550,1615,1616,1551,1486,1422,1488,1616,1550,1550,1424,1615,1615,1486,1614,1424,1552,1487,277,336,337,721,657,658,659,593,595,721,273,657,595,210,781,781,781,781,781,781,781,781,781,781,781,781,1605,519,715,715,715,715,715,715,584,584,1605,1605,1605,1605,1605,1605,456,392,455,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1925,1614,1614,1614,1614,1614,710,520,583,583,520,1542,1665,583,836,584,1605,1605,1605,1605,583,583,584,519,1605,646,651,1414,1605,1605,1605,1413,1478,1606,1542,1413,1477,1477,519,1552,1616,1488,1616,1488,1550,1487,1614,1424,1422,1488,455,455,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1545,1484,1602,1603,1605,1419,1605,1605,1605,1605,1605,1605,1605,1605,1605,840,1026,1027,1028,1029,1030,642,1605,1605,1605,517,456,391,1551,1793,1992,2000,2000,1992,1992,1992,1857,1422,1552,1424,1550,1486,1423,1551,715,715,715,715,715,715,715,715,715,715,715,1487,1422,1487,1552,1423,1537,1537,1488,1422,1551,1423,1551,1423,1550,1550,1486,1486,82,853,400,466,963,781,1349,82,1474,1367,1539,1538,1602,1602,466,965,1473,966,853,1287,1539,1539,1487,1422,1422,1487,1486,1488,1486,1551,1552,1615,1422,1488,1616,1487,1488,1486,1616,1423,1615,1550,1616,1423,1551,1550,1552,1422,1614,1422,1423,1550,1550,1223,400,401,337,721,722,723,657,658,273,275,723,595,722,781,781,781,781,781,781,781,781,781,781,781,781,1605,583,715,715,715,715,715,715,584,520,1605,1605,1605,1605,1605,391,455,1488,1550,1614,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1925,1614,1349,1614,1614,1614,1614,1614,1614,1665,1987,1665,1665,1542,1605,1605,1605,1605,1605,1605,1605,1605,1605,648,646,1477,1605,1606,1605,1606,1414,1478,1605,1413,1478,1413,1488,1615,1424,1923,1797,1797,1797,1797,1925,1665,1487,1424,1550,651,391,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1481,1410,1411,1412,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1281,1090,1091,1092,1093,1094,840,1605,1605,1605,582,646,517,1550,1793,1992,1992,1992,1992,1992,1992,1857,1551,1423,1551,1486,1424,1424,715,715,715,715,1623,1623,586,1623,1623,715,715,715,715,1552,1550,1423,1551,1551,1424,1488,1537,1537,1552,1487,1488,1487,1422,1551,1615,277,655,1349,966,399,466,963,399,964,1476,82,1487,655,1410,1287,1476,1367,1368,1367,1304,1367,1304,781,82,469,277,853,1537,1602,655,966,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1550,1615,1361,1361,1361,656,658,722,721,593,594,658,723,658,658,210,781,781,781,781,781,781,781,781,781,781,781,781,1605,519,519,715,715,715,584,520,583,1605,1605,1605,1605,1605,456,392,1423,1486,1422,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,1614,1614,1614,1614,1614,1349,1614,1614,1794,1797,1925,1665,710,583,1605,1605,1605,1605,1605,1605,1605,1605,711,1542,1477,1414,1541,1413,1413,1542,1414,1477,1414,1414,1423,1550,1923,1666,1992,1992,1992,1992,1667,1925,1665,1665,1487,1422,392,392,392,392,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1545,1484,1475,1476,1605,1605,1419,1605,1605,1605,1605,1605,1605,1605,840,1154,1155,1156,1157,1158,1281,1605,1605,1605,392,391,1616,1488,1793,1992,1992,1992,1992,1992,1669,1927,1488,1488,1423,1550,1422,715,715,715,1623,1623,648,648,586,648,648,1623,1623,715,715,715,1488,1422,1422,1551,1552,1550,1486,1551,1550,1550,1552,1551,1486,655,466,466,1223,82,655,1487,400,963,466,1349,853,82,655,1476,1367,1368,1539,1602,1304,1409,1474,1409,1474,781,1615,149,1223,1487,655,1473,1539,1539,965,277,1487,1223,1287,1474,1602,1303,1368,1602,1304,1473,1349,1616,1424,1487,1614,1424,1488,1424,1487,1551,277,399,469,784,658,722,722,274,723,273,338,595,273,274,781,781,781,781,781,781,781,781,781,781,781,781,1605,519,519,520,584,1605,519,1605,1605,1605,1605,1605,1605,456,1616,1423,1550,1614,1487,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1614,1923,1925,1614,1614,1991,1614,1923,1666,1992,1667,1925,1614,1614,516,1605,1605,1605,1605,1605,1605,583,711,1541,1542,1413,1477,1605,1414,1477,1541,1477,1477,1414,1552,1923,1666,1992,1992,1992,1992,1992,1992,1667,1925,1615,1550,1422,1615,1550,1614,455,711,648,1605,1605,1605,1605,1605,1605,1605,1605,1605,1545,1484,1540,1537,1538,1605,1605,1605,1605,1605,1605,1605,1605,840,1218,1219,1220,1221,1222,840,1605,1605,1605,580,392,1614,1616,1793,1992,1992,2000,1992,1669,1927,1615,1487,1551,1488,1487,1424,715,715,1623,648,648,648,648,586,648,648,648,648,1623,715,715,1423,1486,1424,1488,1424,1487,1551,1423,1488,1423,1487,1422,1486,963,965,466,1487,1223,966,1223,963,966,1615,964,853,853,966,1539,1602,1304,1473,1368,1602,1410,1539,1410,1539,1410,1539,1538,1474,1474,1615,966,853,1473,1538,1349,655,1538,1410,1410,1539,1602,1473,1303,1476,1476,1349,1551,1616,1616,1550,1552,1486,1552,1616,1488,966,964,1487,965,656,659,274,273,210,659,274,275,210,593,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,1616,1550,1487,1488,1551,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1614,1793,1992,1925,1614,1614,1614,1985,1729,1992,1669,1927,1614,1614,1614,1614,1614,1614,710,1605,1605,1605,1542,1413,1477,1477,1413,1478,1477,1541,1477,1478,1477,1477,1615,1793,1992,1992,1992,1992,1992,1992,1992,1992,1857,1552,1550,1550,1616,1423,1615,391,456,646,1605,1605,1605,1605,519,711,715,715,715,1605,1545,1484,1601,1602,1605,1605,1605,1605,1605,1605,1605,1605,967,1282,1283,1284,1285,1286,967,1605,1605,1605,582,646,1550,1923,1666,1992,1992,2000,1992,1857,1488,1552,1486,1422,1424,1552,1424,715,715,1623,648,648,648,586,648,586,648,648,648,1623,715,715,1424,1551,1424,1487,1552,1486,1422,1550,1552,1488,1487,1550,1552,1349,400,277,277,655,655,1615,1223,1223,149,469,655,149,1349,1473,1368,1602,1539,1409,1367,1602,1303,1602,1303,149,1474,466,400,1303,1287,82,469,277,1602,1473,1368,963,1368,1303,1473,1304,1409,1287,1304,1287,1409,1422,1424,1551,1423,1424,1550,1487,1422,1422,149,277,1223,966,656,593,594,595,595,723,594,338,275,273,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1601,1605,1605,1605,1605,391,1423,1422,1551,1422,1614,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1614,1793,1669,1863,1990,1487,1614,1614,1793,1669,1927,1614,1614,1349,1614,1923,1797,1925,1614,456,1541,1605,1605,1605,1605,1542,1414,1413,1477,1414,1413,1413,1413,1478,1423,1793,1992,1992,1992,2000,1992,1992,1992,1992,1857,1550,1424,1487,1488,1551,1614,1615,836,651,1605,1605,711,715,715,715,715,715,715,715,1605,1545,1484,1410,1605,1605,1605,1605,1605,1605,1605,1605,840,642,840,840,1281,840,1541,1605,1605,1605,517,392,1615,1793,1992,1992,1992,2000,1992,1857,1488,1422,1551,1552,1424,1424,715,715,1623,648,648,648,648,586,648,586,648,648,648,648,1623,715,715,1488,1488,1550,1550,1424,1488,1422,1550,1423,1423,1551,1551,149,277,1615,399,469,655,1487,466,400,964,1223,966,965,1349,1539,1409,1367,1304,1539,1473,1410,1410,1410,1410,1487,1223,964,400,1349,1473,1537,966,964,1615,964,1409,1476,1287,1474,1473,1538,466,1368,1602,1537,1303,1473,1304,1409,1367,1303,1474,853,82,1349,82,1223,965,399,656,722,659,657,721,594,659,593,274,274,781,781,781,781,781,781,781,781,781,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1601,1605,1605,1605,1605,456,1614,1488,1616,1423,1424,1985,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1614,1985,1927,1614,1614,1614,1614,1487,1985,1927,1614,1551,1423,1615,1614,1985,1861,1927,1614,1614,1542,836,1605,1605,1605,1605,1478,1542,1414,1542,1542,1478,1478,1550,1488,1793,1992,1992,2000,2000,1992,1992,1992,1992,1857,1422,1422,1552,1423,1486,1552,1552,1487,456,1605,1605,519,519,584,715,715,715,715,1605,1605,1605,1545,1605,1605,584,584,519,584,584,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,516,1488,1793,1992,1992,1992,2000,1992,1857,1551,1486,1488,1550,1424,1550,715,715,586,586,586,586,586,586,586,586,586,586,586,586,586,715,715,1424,1422,1422,1487,1550,466,1223,1349,966,466,149,149,149,965,655,149,82,966,469,963,966,82,466,966,277,82,1304,1539,1473,1304,1539,1473,1410,1410,1303,399,853,963,1349,466,1223,966,466,400,82,655,400,466,1409,1303,399,964,1538,1537,1615,1476,1473,1474,1368,1538,1303,1303,1537,1474,400,277,399,400,277,1349,965,656,595,338,659,275,274,275,721,275,210,781,781,781,781,781,781,781,781,781,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1601,1605,1605,1605,1605,456,455,1487,1614,1616,1552,1614,1985,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,1551,1614,1615,1614,1614,1349,1614,1614,1614,1614,1551,1422,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,710,1541,1413,456,1413,1424,1424,1616,1424,1551,1488,1616,1422,1923,1666,1992,1992,2000,1992,1992,1992,1992,1992,1857,1488,1614,1487,1615,1486,1423,1551,1424,1422,1605,1605,1605,1605,711,715,715,520,715,1605,1605,520,519,583,715,520,711,519,715,583,715,520,711,519,711,711,1605,1605,1605,1605,1605,1605,392,1487,1486,1793,1992,1992,1992,2000,1992,1857,1551,1422,1552,1552,1488,1487,715,715,1623,648,586,586,648,586,648,586,648,586,586,648,1623,715,715,1551,1422,1423,1551,1422,1550,1551,1424,1487,1488,1550,1551,1423,1423,1422,1550,1487,1423,1422,1424,1488,1488,1488,1551,1488,1552,1424,1552,1303,1304,1304,1539,1473,1410,1410,1303,1551,1424,1614,1616,1422,1616,1423,1422,1423,1551,1550,1422,1423,1487,1614,1551,1550,1423,1550,1486,1423,1424,1552,1409,1539,1473,1538,1287,1487,964,853,469,965,655,966,656,659,723,721,722,593,722,274,275,659,781,781,781,781,781,781,781,781,781,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1601,1605,1605,1605,1605,391,391,1487,1422,1616,1486,1551,1614,1985,1861,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1487,1614,1616,1614,1614,1988,1990,1614,1349,1614,1614,1614,1486,1423,1614,1614,1614,1349,1614,1614,1614,1614,1991,1614,1614,1413,455,455,1665,1923,1797,1797,1797,1797,1797,1797,1797,1666,1992,1992,1992,2000,1992,1992,1992,1992,1992,1857,1487,1423,1424,1487,1423,1422,391,520,584,584,711,1605,1605,711,1605,1605,519,1605,1605,519,584,519,715,715,715,715,715,519,583,715,715,715,715,715,519,583,519,1605,1605,1605,1605,455,1551,1486,1793,1992,1992,1992,2000,1992,1857,1486,1550,1488,1422,1488,1422,715,715,1623,648,648,648,586,648,586,648,586,648,648,648,1623,715,715,1423,1550,1487,1487,528,529,530,1303,1304,1303,1368,1304,1303,1368,1303,1303,1303,1368,1303,1368,1303,1303,1368,1368,1368,1303,1368,1303,1368,1368,1304,1539,1473,1410,1410,1304,1303,1303,1368,1303,1304,1304,1304,1304,1303,1303,1303,1304,1303,1368,1368,1303,1304,1304,1304,1303,1368,1303,1615,277,1368,1368,1367,1476,1349,400,400,399,963,400,208,209,721,722,595,338,721,658,594,273,658,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,519,1605,1605,1601,1605,1605,1605,1605,1605,455,392,1487,392,1616,1551,1614,1424,1614,1614,1985,1729,1992,1992,1992,1669,1861,1861,1861,1927,1614,1614,1614,1349,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1349,1616,1614,1614,1614,1614,1614,1614,1349,1614,1552,1486,1486,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1857,1488,1551,1423,1550,392,392,1605,1605,1605,1605,584,1605,1605,1605,1605,1605,520,520,584,711,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,711,519,1605,1605,1605,330,1486,1486,1793,1992,1992,1992,1992,1992,1857,1550,1487,1552,1486,1423,1422,715,715,1623,648,648,586,648,586,586,586,648,586,648,648,1623,715,715,1423,1550,528,529,209,721,658,1304,1303,1304,1303,1368,1368,1304,1303,1368,1304,1368,1304,1303,1368,1303,1303,1304,1303,1368,1304,1303,1368,1304,1304,1304,1304,1368,1304,1303,1304,1303,1368,1368,1368,1304,1304,1303,1368,1304,1368,1303,1303,1303,1368,1368,1304,1303,1368,1304,1368,1304,1424,853,963,1410,1287,1410,655,966,655,964,964,966,272,273,723,273,338,721,722,721,275,274,657,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,1605,1605,519,583,646,1605,1605,1605,1605,1605,1605,1605,1605,455,584,455,391,392,391,392,392,391,1614,1985,1861,1861,1729,1857,1614,1614,1614,1614,1614,1991,1614,1614,1614,1923,1925,1616,1614,1614,1991,1614,1923,1925,1614,1615,1614,1923,1797,1797,1797,1925,1551,1423,1615,1614,1614,1665,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1424,1486,1487,1551,1614,1605,1605,1605,1605,584,1605,1605,1605,1605,1605,1605,711,584,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,519,583,1605,1605,455,516,469,1793,1992,1992,1992,1992,1992,1857,1423,1423,1551,1550,1486,1486,1487,715,715,1623,648,586,586,586,1605,586,586,586,648,1623,715,715,1422,1551,1550,272,657,723,722,721,1368,1368,1303,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1304,1304,1368,1303,1303,1304,1303,1368,1304,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1368,1303,1304,1616,277,655,1349,965,1409,469,1349,965,469,149,966,336,337,721,722,210,273,274,659,593,657,659,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,1605,582,519,714,584,584,582,1605,1605,1605,584,520,584,583,584,584,391,391,392,456,456,455,1614,1614,1614,1614,1985,1927,1614,392,1542,1606,1614,1614,1614,1923,1797,1666,1667,1925,1614,1615,1423,1487,1985,1927,1614,1486,1551,1793,1992,1992,1992,1667,1797,1925,1614,1616,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1665,1665,1550,1424,1487,651,1605,1605,520,391,456,1605,1605,1605,1605,1605,584,519,715,715,715,715,715,715,715,715,715,715,715,520,520,583,715,715,715,715,715,715,1605,1605,1605,649,455,149,1793,1992,1992,1992,1669,1861,1927,1552,1486,1550,1424,1424,1550,1550,715,715,1623,648,586,1605,1605,1605,1605,1605,586,648,1623,715,715,1422,1422,1551,272,721,722,659,593,1303,1368,1304,1303,1368,1368,1303,1304,1368,1303,1304,1368,1368,1303,1303,1304,1368,1368,1303,1368,1303,1304,1368,1368,1303,1303,1368,1303,1303,1304,1304,1304,1303,1304,1303,1304,1304,1368,1303,1304,1368,1304,1304,1368,781,1368,1303,1303,1304,1303,1304,1552,400,149,400,853,964,964,1487,469,1349,469,964,400,272,273,274,593,338,721,593,723,593,659,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,519,646,584,715,649,711,715,584,520,1605,583,520,584,715,519,519,519,583,1605,1605,1605,1605,392,391,456,456,1614,1614,456,392,1414,1606,1541,456,1665,1988,1862,1729,1992,1992,1667,1925,1614,1551,1614,1614,1614,1614,1614,1486,1793,1992,1992,1992,1992,1992,1667,1925,1614,1614,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1861,1861,1731,1925,1665,1665,1665,1615,1550,391,455,455,455,711,1605,1605,1605,1605,1605,1605,520,715,715,715,715,715,715,715,715,715,715,715,519,520,584,584,715,715,715,715,715,516,714,582,330,517,963,1793,1992,1992,1992,1857,1552,1486,1487,1551,1423,1552,1422,1422,1551,715,715,715,1623,586,1605,1605,1605,1605,1605,586,1623,715,715,715,1423,1551,1422,272,595,721,593,721,1368,1303,1368,1368,1368,1303,1368,1304,1303,1367,1304,1368,1367,1367,1368,1367,1303,1304,1368,1304,1368,1304,1304,1303,1304,1303,1368,1304,1303,1303,1303,1368,1368,1304,1304,1304,1303,1423,1367,1303,1303,1368,1368,1368,781,1304,1304,1304,1368,1303,1368,1616,1615,966,149,1487,399,400,966,466,149,400,1223,1487,656,658,593,594,594,658,275,723,594,338,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,519,715,715,715,715,715,715,715,715,715,715,1605,715,715,715,715,715,584,1605,1605,1605,1605,1605,1605,455,455,391,392,392,456,1605,1605,1478,392,1541,1665,1665,1985,1861,1729,1669,1927,1550,1488,1551,1552,1614,1423,1614,1614,1793,1992,1992,2000,2000,1992,1992,1857,1614,1614,1793,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1669,1861,1861,1927,1424,1551,1551,1985,1731,1797,1925,1665,1665,1550,1616,392,1605,1605,1605,1605,1605,1605,1605,1605,1605,711,715,715,715,715,715,715,715,715,715,715,715,715,584,519,715,715,715,715,715,715,330,582,646,455,582,655,1793,1992,1992,1992,1857,1486,1422,1424,1550,1537,1552,1423,1551,1486,1552,715,715,715,715,1623,1623,1623,1623,1623,715,715,715,715,1550,1551,1486,1487,272,658,723,593,595,1303,1368,1304,1368,1303,1368,1303,781,1303,1487,1422,1422,1423,1422,1550,1488,1424,1303,1368,1368,781,1304,1304,1368,1304,1368,1368,1303,1303,1304,781,1304,1303,1303,1367,1488,1550,1488,1550,1486,1368,1368,1304,1368,781,1368,1368,1304,1303,1304,1304,1552,1349,1349,277,1615,1349,853,964,655,963,149,149,399,656,657,657,723,593,657,658,210,657,721,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,714,649,715,715,715,715,715,715,715,715,715,715,519,715,715,715,715,715,584,584,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,1542,1607,1606,1665,1665,1985,1927,1614,1614,1486,1614,1614,1614,1486,1614,1614,1985,1861,1729,1992,1992,2000,1992,1857,1551,1614,1793,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1857,1422,1614,1614,1422,1551,1486,1551,1985,1861,1731,1925,1665,1665,1487,1486,651,391,455,1605,1605,1605,1605,1605,1605,520,715,715,715,520,715,715,715,715,715,715,715,715,715,715,715,715,715,584,519,715,651,646,455,646,646,1614,1793,1992,1992,1992,1857,1552,1486,1487,1423,1537,1551,1423,1550,1551,1552,1486,715,715,715,715,715,715,715,715,715,715,715,1488,1486,1488,1552,1552,272,657,659,594,722,1368,1304,1368,1368,1303,1304,781,781,1367,1550,1488,1367,1551,1424,1487,1423,1552,1304,1368,1368,781,1368,1303,1303,1303,1303,1303,1368,1368,1303,781,1304,1368,1368,1551,1550,1487,1551,1552,1422,1552,1367,1368,1368,781,1304,1303,1368,1303,1368,1304,1486,965,655,966,277,466,853,966,1487,1615,853,1223,966,336,658,594,273,594,721,658,275,210,658,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,1605,646,715,715,715,715,715,715,715,715,715,711,715,1605,715,715,715,715,520,520,584,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1413,1607,1414,1414,1478,1606,456,455,392,1541,455,1541,1991,1614,1614,1614,1985,1729,1992,1992,1992,1857,1423,1614,1793,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,1551,1424,1552,1424,1616,1486,1615,1424,1615,1985,1731,1797,1925,1665,1422,1615,455,455,392,836,711,583,455,455,519,583,715,583,519,583,715,715,715,715,715,583,583,715,715,715,520,715,520,583,715,714,580,391,582,391,1614,1793,1992,1992,1992,1857,1488,1424,1488,1486,1537,1550,1550,1552,1488,1550,1424,1486,1423,1424,715,715,715,715,715,1422,1552,1550,1422,1424,1486,1487,1552,272,595,593,657,659,1368,1303,1304,1304,1368,1368,1303,1487,1551,1488,1488,1423,1550,1487,1551,1550,1550,1550,1367,1368,781,1304,1368,1304,1303,1368,1304,1368,1368,1368,781,1303,1304,1367,1486,1552,1552,1487,1552,1423,1424,1423,1304,1303,781,1303,1368,1368,1368,1303,1304,1487,965,1487,966,966,853,1223,965,400,964,965,82,1424,1423,784,657,659,721,722,210,722,657,593,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,583,582,715,715,715,715,715,715,715,715,647,647,1605,1605,583,520,583,520,583,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,391,392,1414,1605,1605,584,1614,1614,1614,1985,1729,1669,1861,1927,1614,1614,1793,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1669,1861,1927,1422,1550,1616,1422,1487,1616,1422,1550,1551,1616,1985,1861,1731,1797,1925,1665,1552,836,456,456,455,584,583,455,583,583,520,583,584,520,715,715,715,584,583,519,519,715,715,584,519,520,520,715,584,391,517,646,582,517,1614,1793,1992,2000,1992,1857,1552,1550,1552,1552,1537,1537,1550,1486,1552,1423,1423,1550,1486,1487,1488,1423,1486,1488,1550,1486,1488,1550,1488,1552,1551,1488,1550,272,594,722,595,657,1368,1368,1303,1304,1303,1303,1486,1552,1367,1367,1423,1487,1487,1550,1422,1367,1550,1552,1304,1368,781,1304,1303,1303,1368,1303,1303,1368,1303,1304,781,1304,1304,1368,1487,1552,1424,1550,1367,1424,1487,1423,1423,1367,781,1304,1368,1368,1303,1304,1304,1488,1223,1223,399,469,1615,963,965,1487,965,963,965,1552,1550,1614,656,595,210,722,338,723,594,722,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,715,714,584,715,715,715,715,715,715,715,715,711,711,1605,1605,1605,519,584,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,715,1614,1614,1614,1985,1927,1614,1614,1614,1614,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1550,1488,1615,455,1607,455,1422,1551,1486,1424,1552,1615,1614,1488,1985,1861,1731,1925,1424,1552,1422,836,392,582,519,584,584,520,520,520,583,519,582,715,715,520,583,583,519,715,715,583,583,519,583,715,715,646,456,455,517,1614,1614,1793,1992,2000,1992,1857,1551,1551,1551,1552,1537,1537,1537,1486,1487,1424,1552,1422,1551,1487,1424,1551,1423,1552,1424,1423,1550,1422,1424,1552,1486,1423,208,209,657,658,657,659,1304,1304,1368,1303,1303,1304,1367,1487,1422,1424,1486,1367,1487,1424,1422,1550,1550,1368,1304,1368,781,1304,1304,1303,1304,1303,1304,1368,1303,1304,781,1304,1303,1368,1367,1423,1488,1423,1552,1486,1551,1422,1551,1486,781,1303,1368,1303,1368,1368,1304,1550,964,1349,149,400,655,965,469,1223,400,853,963,1487,1616,1550,336,337,722,595,595,659,274,657,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,715,646,715,715,715,715,715,715,715,715,715,715,1605,1605,1605,1601,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,651,1614,1614,1614,1614,1614,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1487,1423,456,392,1606,1605,392,1477,392,1478,1413,1614,1615,1616,1551,1550,1551,1985,1731,1797,1925,1551,1488,455,392,392,519,455,520,455,520,584,517,715,715,715,583,715,715,715,715,715,715,520,711,715,715,715,1417,1412,1475,1475,1410,1614,919,919,919,919,919,710,1349,456,580,1537,516,1537,392,400,965,580,466,392,1487,1486,1422,1423,1550,1424,1422,1552,1488,1550,1424,1487,1552,272,721,658,659,659,657,1303,1303,1303,1303,1303,1303,1303,1422,1424,1488,1487,1552,1551,1488,1551,1368,1368,781,781,781,781,1368,1368,1304,1368,1303,1368,1303,1367,1368,781,1304,1368,1303,1368,1550,1488,1486,1486,1367,1552,1424,1551,1486,781,1303,1368,1368,1368,1304,1303,1552,1615,853,149,82,963,853,853,149,1223,964,1223,277,1488,1552,963,272,593,273,722,338,594,721,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,715,519,715,715,715,715,715,715,715,715,715,519,1605,1605,1605,1544,1605,1605,1605,1605,1605,1605,1605,1605,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1614,1614,1614,1614,1614,1614,1614,1605,1605,1605,1605,1605,1605,1614,1614,1614,1614,1923,1666,1992,1992,1669,1861,1861,1729,1992,1992,1669,1861,1927,1550,1424,1606,1605,1605,1605,1605,1605,1605,1605,1605,1542,1541,1616,1551,1551,1424,1487,1488,1985,1992,1857,1665,1614,1423,1423,392,1551,392,711,583,520,711,715,715,519,519,519,715,715,715,715,715,715,715,715,715,715,715,1545,1476,1475,1537,1539,1614,983,983,983,983,983,1473,1540,1476,1540,1412,1473,1476,1539,1411,1540,82,1419,277,965,1486,1551,1486,1486,1552,1551,1487,1488,1552,1423,1423,1486,272,723,658,593,659,659,1303,1368,1303,1303,1304,1368,1303,1303,1304,1367,1303,1368,1367,1304,1368,1304,1304,1368,1304,1304,1303,1303,1304,1304,1367,1368,1303,1368,1368,1303,781,1368,1368,1303,1304,1368,1424,1488,1367,1304,1488,1424,1367,1488,1368,1304,1368,1368,1368,1303,1303,1422,149,399,400,1223,963,277,466,963,277,82,966,965,1487,400,966,272,273,210,721,275,659,274,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,715,582,519,715,715,715,715,715,715,715,519,584,1605,1605,1605,1544,1605,1605,1605,1605,1605,1605,1605,1605,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1614,1923,1797,1797,1797,1797,1925,1614,715,1605,1605,1605,1605,1605,651,651,1614,1923,1666,1992,1992,1992,1857,1614,1614,1985,1729,1669,1927,1550,1422,836,455,1413,1605,1605,1605,1605,1605,1605,1605,1605,1605,1542,1413,1413,1614,1486,1551,651,1614,1985,1731,1925,1550,1422,1616,1615,1552,1488,392,1488,391,520,715,715,519,520,517,715,583,583,715,715,715,715,715,715,715,715,1474,1476,1538,1474,1537,1540,983,983,983,983,983,1546,1546,1412,1412,1476,1475,1474,1474,1412,1474,1539,1476,330,964,1552,1487,1422,1550,1487,1537,1550,1486,1488,1488,1424,208,209,594,593,593,595,593,1303,1368,1304,1303,1303,1304,1303,781,781,781,781,781,1304,1368,1368,1368,1303,1303,1304,1304,1304,1367,1367,1304,1304,1368,1367,1368,1304,1304,1304,1303,1368,1368,1303,1368,1303,1304,1303,1368,1367,1487,1552,1486,1368,1304,1368,1304,1304,1368,1368,1615,1349,277,1349,1349,655,1349,149,1487,655,1349,964,1615,1615,966,1487,272,338,275,721,721,210,274,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,1605,583,646,715,715,715,715,647,647,582,582,1605,1605,1605,1612,1549,1605,1605,1605,1605,781,781,781,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1991,1605,1605,1605,1605,1614,1985,1729,1992,1992,1992,1667,1925,1614,1605,1605,1605,1605,1605,1605,1605,1614,1985,1729,1992,1992,1992,1857,1614,1605,1614,1985,1927,1424,1550,1605,391,1607,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,1413,1552,1424,1552,648,1614,1985,1731,1925,1665,1488,1614,1551,1488,1614,1615,392,391,455,711,836,649,517,715,715,715,715,715,715,715,715,715,715,584,1537,1545,1539,1546,1546,1546,1047,1047,1047,1047,1047,149,149,1538,1476,1475,1474,1476,1474,1537,1409,1537,1409,1537,1223,966,966,469,1537,1537,1537,1488,1552,1422,1488,1488,272,595,721,595,595,658,658,1303,1303,1304,1304,1368,1368,1368,1368,1304,1304,1368,1303,1303,1368,1368,1304,1304,1304,1368,1303,1304,1422,1487,1368,1304,1367,1488,1367,1487,1368,1304,1368,1368,1304,1368,1304,1304,1303,1303,1304,1304,1304,1488,1487,1368,1368,1304,1304,1368,1368,1303,1423,1349,965,655,1615,82,965,469,466,399,1349,469,82,1349,149,277,272,593,595,593,657,721,275,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,584,520,715,715,715,715,715,715,715,1605,520,1605,1605,1605,1544,1605,1605,1605,1605,781,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1614,1985,1861,1861,1861,1861,1927,1614,1605,1605,1605,1605,1605,1477,456,1605,1614,1985,1729,1992,1669,1927,1614,1605,1605,1614,1423,1488,1424,1542,1477,1605,1605,1605,1605,1605,1605,1923,1797,1797,1925,1605,1605,1605,1605,1413,1606,1422,1551,1616,455,1614,1985,1731,1925,1665,1614,1614,1614,1424,1551,1614,455,455,392,836,517,584,455,715,715,715,715,715,715,715,715,715,711,583,330,582,1550,1551,1616,1793,1992,2000,1992,1857,966,710,580,655,1487,400,391,1539,1412,1474,1412,1540,1411,1474,1409,277,1537,1537,1537,1552,1424,1487,1422,1487,1488,272,658,595,594,595,723,593,1303,1304,1304,1368,1368,1368,1368,1368,1303,1303,1368,1303,1303,1304,1303,1303,1304,1304,1304,0,0,1422,1423,1367,1423,1488,1488,1552,1424,1367,0,0,1368,1368,1303,1368,1303,1304,1368,1304,1303,1304,1368,1368,1304,1303,1304,1304,1304,1303,1303,1488,963,400,965,853,149,82,82,466,963,149,1349,1223,1615,965,655,272,273,275,338,273,210,721,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,519,711,715,715,715,715,715,715,715,520,584,583,1605,1605,1544,1605,1605,1605,781,781,1475,1601,1410,1604,1603,1476,1539,1411,1601,1538,1410,1483,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1614,1614,1614,1614,1614,1614,1614,1605,1605,1605,1605,1605,456,1607,1541,1605,1614,1985,1861,1927,1614,1605,391,1478,1605,1614,1991,1487,1477,1605,1605,1605,1605,1605,1923,1797,1666,1992,1992,1667,1925,1605,1605,1605,392,455,1605,1486,1615,1486,391,1614,1985,1731,1925,1665,1614,1614,1615,1616,1614,1551,1424,456,1424,1486,1487,836,711,715,715,715,715,715,715,715,715,520,584,516,391,1550,1486,1615,1793,1992,2000,1992,1857,149,1552,1487,1552,1486,1423,391,655,963,1537,1410,1410,1475,1409,1540,1540,1537,965,1552,1486,1424,1422,1552,1422,1487,272,722,722,658,595,721,595,1303,1304,1368,1304,1304,1304,1304,1304,1303,1303,1304,1304,1304,1368,1368,1303,1368,1303,1303,1368,1303,1367,1424,1422,1552,1367,1486,1551,1551,1422,1304,1368,1368,1304,1304,1303,1304,781,781,781,781,781,781,781,781,1368,1368,1368,1368,1303,1368,1487,1615,400,1487,469,82,469,1349,466,965,399,149,400,965,1487,469,272,210,722,338,274,594,658,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,646,582,520,715,715,715,715,715,715,714,583,582,1605,1605,1608,1605,1605,1605,781,781,1603,1482,1604,1538,1601,1604,1540,1602,1482,1485,1546,1547,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1413,1606,392,1614,1614,1542,1423,1477,1413,1542,455,1488,1614,1422,1607,1607,1605,1605,1605,1923,1666,1992,1992,1992,1992,1992,1667,1925,1605,1605,1605,455,455,520,1422,1487,1551,1478,1615,1985,1731,1925,1550,1422,1550,1424,1552,1486,1552,1486,1550,1488,1423,1550,584,520,715,584,520,715,519,584,715,711,582,391,646,1424,1486,1422,1793,1992,2000,1992,1857,966,1552,1423,1422,1422,1422,1551,963,1487,391,392,1475,1409,1473,1409,1411,1411,466,466,456,1349,1486,1488,1486,1486,272,657,657,721,657,658,659,1368,1303,1303,1304,1303,1368,1368,1303,1304,1368,1304,1368,1303,1368,1303,1368,1303,1303,1303,1368,1303,1486,1487,1487,1550,1552,1423,1486,1423,1551,1304,1304,1368,1368,1304,1368,1304,781,1304,1303,1303,1304,1368,1304,1304,1368,1303,1368,1304,1304,1368,1614,1303,964,1487,82,149,965,655,964,277,966,1487,399,149,964,149,272,721,338,595,210,273,721,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,1605,1605,520,715,715,715,715,715,647,649,520,1605,1605,1605,1605,1605,1605,1605,781,781,1601,1410,1601,1482,1482,1485,1546,1546,1546,1547,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1606,1607,1477,1478,1422,1423,1605,1605,456,456,1478,1542,1414,1606,1605,1605,1923,1797,1666,1992,1992,1992,1992,1992,1992,1992,1667,1925,1605,1605,1478,456,455,1605,1614,1422,1488,1423,1616,1793,1857,1423,1665,1552,1616,1424,1552,1614,1614,1615,1422,1423,1488,584,711,715,715,519,520,583,715,715,583,582,582,1552,1486,1616,1550,1793,1992,2000,1992,1857,966,1488,1424,1486,1552,1488,1423,1552,1424,1486,1223,456,149,1409,1538,1475,1540,1540,1418,516,710,399,1550,1550,208,209,658,593,595,593,593,722,1304,1303,1304,1303,1303,1303,1303,1304,1304,1304,1303,1368,1303,1368,1303,1368,1368,1368,1303,1992,1992,1923,1797,1797,1797,1797,1797,1797,1797,1925,1992,1992,1304,1304,1303,1304,1304,781,1304,1304,1303,1368,1368,1304,1368,1368,1304,1368,1303,1304,1303,1368,1303,1368,963,1368,965,965,963,1349,466,964,655,966,1615,277,149,272,658,721,595,723,723,273,1614,2000,1614,1614,1614,1614,1605,1605,1605,1605,1605,1605,1605,519,711,519,715,715,715,715,649,520,582,1605,1605,1480,1605,1605,1416,1605,1361,1361,1546,1546,1546,1546,1546,1547,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,1605,1605,1477,1606,1477,1486,1487,1614,1487,1478,1985,1731,1925,1665,1665,1488,1423,1488,1614,1615,1422,1487,1422,1614,1423,583,583,715,583,584,715,715,583,584,456,456,456,1424,1552,1550,1793,1992,2000,1992,1857,966,1552,1487,1424,1551,1424,1550,1550,1550,1423,966,655,580,710,773,1475,1409,1411,1411,1476,1487,392,1486,1424,272,595,721,594,723,659,658,658,1368,1304,1368,1368,1304,1304,1304,1368,1303,1303,1304,1368,1304,1304,1303,1303,1368,1368,1368,1992,1992,1793,1992,1992,1992,1992,1992,1992,1992,1857,1365,1365,1551,1367,1303,1303,1368,781,1304,1368,1368,1303,1303,1303,1303,1368,1304,1304,1303,1304,1368,1486,1368,1304,399,1304,965,655,1487,1487,277,963,466,1349,399,965,963,272,210,594,275,659,594,593,1614,1614,1614,1614,1614,1614,1605,1605,1605,649,649,519,714,582,711,649,583,715,711,711,711,583,714,1605,1605,1544,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1605,1605,1605,392,1413,1605,1486,1542,1616,1422,1487,1793,1857,1614,1665,1551,1615,1614,1614,1614,1424,1550,456,1552,1615,1551,583,519,715,715,715,715,715,519,519,391,392,1550,1615,1615,1793,1992,2000,1992,1857,466,1486,1488,1486,1423,1552,1550,1488,1424,1423,1552,1551,1487,1223,392,456,1476,1412,1476,1474,1540,710,965,965,1488,1422,1551,1487,1487,1552,1487,1552,1304,1368,1368,1304,1368,1368,1303,1303,1303,1303,1303,1304,1303,1368,1303,1303,1368,1368,1303,1923,1797,1670,1861,1861,1861,1861,1861,1861,1861,1731,1797,1925,1552,1486,1303,1303,1304,781,1303,1368,1368,1368,1304,1368,1303,1368,1368,1303,1304,1304,1303,1551,853,1304,655,1303,1368,277,1487,149,399,964,399,469,399,277,399,272,338,721,593,210,722,210,2000,2000,2000,1667,1797,1797,1797,1797,1925,1605,711,584,1605,1605,583,584,584,584,714,714,584,1605,1605,1605,1605,1608,1605,1416,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1923,1797,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1857,1605,1605,1605,1605,392,1605,1488,1550,1614,1616,1422,1985,1731,1925,1552,1422,1422,1614,1550,1614,1616,1423,1552,455,1487,1551,520,520,715,715,715,715,519,583,520,455,391,1488,1550,1551,1793,1992,2000,1992,1857,149,1488,1551,1423,1486,1550,1424,1486,1488,1551,1552,1550,1488,1423,1423,82,1223,1412,1474,1474,1409,1412,82,400,1615,965,1486,1424,1487,1550,1423,1486,1303,1303,1368,1303,1368,1304,1304,1368,1368,1303,1368,1303,1304,1303,1303,1368,1367,1303,1552,1793,1992,1857,961,962,1153,1350,1281,1350,967,1793,1992,1857,1488,1550,1367,1304,1303,781,1304,1368,1368,1303,1303,1304,1303,1304,1368,1304,1368,1304,1368,1368,1304,1368,964,277,853,963,965,963,277,655,149,966,1615,277,466,272,595,659,721,658,594,657,2000,2000,2000,2000,1992,1992,1992,1992,1667,1797,1797,1925,1605,1605,1605,1605,519,583,711,584,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1793,1992,1992,1797,1925,1605,1605,1605,1605,1605,1605,1923,1797,1797,1797,1797,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1991,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1861,1729,1992,1669,1861,1861,1861,1927,1605,1605,456,517,1478,455,1486,1424,1423,1552,1424,1487,1793,1857,1550,1488,1615,1488,1487,1551,1550,1615,1552,330,517,1487,392,584,584,715,711,520,519,392,455,1552,1423,1423,1424,1615,1793,1992,2000,1992,1857,399,1551,1552,1422,1423,1424,1424,1424,1424,1552,1552,1486,1488,1550,1550,1488,82,1349,1538,1473,1412,1409,1411,1540,1349,149,963,149,149,1486,1486,1422,1303,1303,1368,1368,1303,1304,1304,1368,1368,1368,1304,1304,1368,1304,1303,1367,1488,1423,1487,1793,1992,1857,1350,1026,1027,1028,1029,1030,1031,1793,1992,1857,1550,1367,1550,1368,1368,781,781,781,781,781,781,781,781,1304,1368,1304,1368,1303,1303,1614,466,149,82,1487,1223,964,82,1615,277,1349,149,655,399,965,853,272,338,594,338,722,721,275,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1667,1797,1925,1605,1605,1605,649,582,582,1605,1605,1605,1605,1605,1605,1605,1605,1605,1480,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1992,1992,1857,1605,1605,1605,1605,1605,1605,1985,1729,1992,1992,1992,1992,1797,1797,1798,1990,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1927,1605,1605,1605,1605,1605,1605,456,392,455,455,1615,1552,1486,1486,1614,1486,1793,1667,1925,1551,1616,1614,1422,1487,1487,1552,1424,1486,456,646,582,455,583,583,584,520,330,582,646,1551,1552,1614,1616,1422,1793,1992,2000,1992,1857,456,1487,1487,1486,1550,1488,1423,1551,1550,1552,1486,1486,1550,1488,1487,1552,966,963,1537,1537,1537,1411,1409,1537,1474,1474,1223,400,964,1552,1486,1486,1304,1304,1304,1303,1368,1368,1304,1368,1303,1304,1303,1368,1303,1368,1551,1488,1550,1487,1367,1793,1992,1857,1089,1090,1091,1092,1093,1094,1153,1793,1992,1857,1423,1487,1423,1367,1368,1304,1304,1368,1303,1304,1304,1304,1368,1304,1303,1368,1304,1368,1304,1616,966,1615,1223,655,1615,466,277,469,1349,963,965,399,1487,400,655,272,658,273,721,659,594,275,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1667,1797,1925,1605,1605,1605,1605,1605,1605,1605,520,520,1605,1605,1605,1605,1612,1549,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1927,1605,1605,1605,1605,1605,1605,1605,1985,1729,1992,1992,1992,1992,1669,1927,1605,1605,1605,1605,1605,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,517,517,455,455,455,1477,1605,1488,1488,1423,1424,1985,1729,1667,1925,1552,1665,1550,1614,1614,1614,1552,516,455,580,391,517,580,330,330,582,1487,1486,1487,1488,1423,1615,1552,1487,1793,1992,2000,1992,1667,1925,82,1422,1552,1550,1422,1488,1486,1488,1488,1422,1487,1487,1423,1424,1486,1550,1486,1537,1537,1537,400,1540,1473,1538,1410,1410,965,1349,1424,1550,1487,1368,1368,1304,1303,1368,1303,1303,1304,1303,1304,1303,1368,1367,1550,1550,1424,1424,1487,1550,1793,1992,1857,1153,1154,1155,1156,1157,1158,1303,1793,1992,1857,1422,1423,1488,1304,1303,1304,1303,1368,1304,1368,1368,1303,1368,1303,1303,1303,1304,1304,1368,1614,469,1349,1615,655,1487,1487,963,655,1487,466,965,400,1349,1487,277,272,658,274,274,275,721,657,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1667,1925,1605,1605,1605,1605,1605,1605,583,646,646,1605,1605,1605,1605,1544,1605,1605,1605,1605,1923,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1729,1992,1992,1857,1605,1605,1605,1605,781,781,781,781,781,781,781,781,781,781,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,646,391,646,1607,1541,1606,1423,1488,1488,1488,1985,1729,1667,1925,1615,1616,1615,1614,1487,1487,392,582,330,516,516,392,1551,1422,1552,1615,1615,1550,1616,1423,1486,1486,1422,1793,1992,2000,1992,1992,1667,1925,1488,1488,1422,1487,1424,1550,1423,1423,1552,1487,1488,1486,1487,1422,1422,1486,1537,1537,1537,1537,399,1349,965,399,1223,963,82,1486,1487,1487,1304,1368,1304,1368,1304,1303,1368,1303,1368,1368,1304,1368,1303,1486,1367,1424,1487,1488,1551,1793,1992,1857,1217,1218,1219,1220,1221,1222,1281,1793,1992,1857,1423,1423,1367,1304,1303,1304,1368,1368,1303,1368,1368,1303,1304,1368,1368,1303,1303,1303,1304,1423,466,466,466,965,965,1349,82,853,399,277,149,963,400,466,528,209,721,723,593,338,657,723,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1857,1605,1605,1923,1797,1797,1797,1925,582,646,646,1605,1605,1605,1608,1605,1480,1605,1605,1985,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1729,1857,1605,1605,1605,1605,781,781,781,781,781,781,781,781,781,781,781,781,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1923,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,456,517,392,1542,1605,1487,1614,1486,1615,1985,1729,1667,1925,1665,1423,1551,1423,1486,1616,1487,1614,1422,1423,1487,1422,1616,1550,1487,1616,1488,1424,1487,1616,1615,466,1793,1992,2000,1992,1992,1992,1857,1488,1488,1550,1488,1424,1424,1550,1488,1424,1550,1487,1423,1488,1486,1422,1486,1537,1537,1537,1537,277,1615,400,400,399,149,1349,1487,1422,1551,1368,1304,1368,1304,1304,1368,1304,1368,1304,1303,1303,1368,1304,1304,1368,1368,1487,1367,1422,1992,1992,1857,1281,1282,1283,1284,1285,1286,1348,1793,1992,1992,1422,1422,1303,1303,1304,781,781,781,781,781,781,781,781,1368,1303,1368,1304,1368,1304,1616,277,82,277,1223,149,963,1615,964,655,469,469,1615,399,1615,656,658,723,594,658,595,659,722,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1667,1797,1797,1666,1992,1992,1992,1857,583,711,582,584,583,1605,1605,1605,1544,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1477,1605,1605,1605,1605,1985,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,646,391,1413,646,1615,1550,1615,1487,1793,1992,1857,773,1614,1552,1550,1616,1486,1488,1486,1615,1550,1422,1551,1615,1422,1488,1616,1424,1551,1486,1550,1615,1349,1793,1992,2000,1992,1992,1992,1857,1486,1551,1486,1488,1486,1422,1488,1487,1488,1551,1550,1486,1424,1550,1423,1422,1550,1537,1537,1537,399,149,1349,655,1349,966,1349,1486,1551,1488,1303,1368,1303,1303,1303,1368,1368,1304,1368,1304,1303,1368,1368,1304,1303,1303,1488,1551,1422,1992,1992,1857,1368,1346,1347,1348,1281,1350,1368,1793,1992,1992,1552,1423,1304,1368,1368,1304,1304,1368,1304,1304,1368,1304,781,1368,1304,1303,1303,1304,1368,1616,1487,400,1487,82,149,82,655,400,82,277,1615,82,1487,853,784,786,786,786,337,657,723,595,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,519,711,584,714,1605,1605,1605,1608,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1991,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,651,646,651,1605,1605,1605,1605,1605,1605,1414,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,517,1614,1487,456,1424,1552,1487,1552,1985,1729,1667,1925,1665,1665,1550,1486,1487,1423,1615,1614,1486,1550,1614,1614,1614,1614,1614,1552,1552,1552,1552,1488,277,1793,1992,2000,1992,1992,1669,1927,1486,1551,1551,1550,1550,1488,1488,1487,1551,1488,1486,1422,1550,1551,1552,1552,1423,1537,1537,1537,1550,1552,1552,1422,1424,1422,1422,1551,1487,1424,1368,1368,1368,1304,1303,1368,1303,1304,1368,1368,1304,1303,1368,1303,1303,1368,1303,1487,1488,1992,1992,1731,1797,1797,1797,1797,1797,1797,1797,1670,1992,1992,1551,1367,1368,1303,1304,1303,1304,1368,1304,1368,1304,1368,781,1303,1303,1303,1303,1368,1303,1552,399,1615,277,469,853,966,655,469,82,469,1487,1486,1615,1550,1552,1424,1614,1552,336,595,594,657,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1857,1605,711,584,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,651,646,1605,1605,1605,1605,1605,456,391,651,646,391,651,1605,1605,1923,1925,1605,1478,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,455,391,1424,1488,456,1614,1486,1423,1551,1985,1729,1857,773,1665,1665,1486,1552,1487,1550,1550,1422,1614,1614,1551,1614,1614,1614,1614,1552,1614,1423,1616,966,1793,1992,2000,1992,1992,1857,456,1424,1424,1550,1550,1550,1552,1488,1486,1424,1552,1488,1552,1422,1486,1486,1486,1422,1488,1550,1422,1487,1424,1424,1550,1551,1423,1423,1552,1552,1552,1303,1303,1368,1303,1303,1303,1303,1368,1304,1304,1368,1304,1304,1304,1368,1304,1303,1423,1424,781,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1992,1992,1303,1304,1304,1303,1303,1304,1304,1304,1304,1303,1303,1303,781,1303,1303,1304,1368,1303,1303,1487,1349,469,1223,1615,963,966,149,149,277,853,1486,1614,1488,1424,1422,1424,1488,1424,1552,272,595,721,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1669,1927,1605,1605,1605,1605,1605,1923,1797,1797,1797,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,392,1988,1922,1922,1922,1990,651,651,1605,1605,517,456,391,1923,1797,1797,1797,1797,1797,1797,1666,1857,1605,1606,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,455,1616,517,392,1605,392,392,1614,1551,1422,1552,1793,1667,1925,773,1665,1616,1423,1616,1486,1423,1486,1614,1614,1614,1614,1422,1614,1614,1614,1614,1616,1614,1487,1793,1992,2000,1992,1992,1857,966,1488,1551,1486,1487,1550,1424,1487,1488,1424,1552,1486,1488,1486,1550,1422,1550,1488,1487,1488,1486,1487,1486,1423,593,723,723,595,594,721,658,1304,1304,1368,1304,1303,1303,1368,1303,1368,1304,1368,1368,1304,1368,1304,1303,1304,1367,1424,1364,1365,1992,1992,1992,1992,1992,1992,1992,1992,1857,1365,1365,1303,1304,1304,1304,1304,1303,1304,1304,1303,1304,1304,1303,781,1304,1304,1304,1304,1303,1368,1422,149,964,1223,1487,1223,853,149,1349,853,277,1423,1614,1424,1422,1552,1614,1614,1552,1487,272,721,722,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1857,1605,1605,1605,1605,1605,1605,1985,1729,1669,1861,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,651,1605,1605,651,391,651,1605,1605,773,391,1923,1797,1666,1992,1992,1992,1992,1669,1861,1861,1927,1605,1606,1541,1413,1606,1605,1477,1414,1541,1477,1605,1606,1413,1478,1478,1414,1605,1477,1361,1361,1605,1605,1605,1605,1605,517,456,517,392,517,517,391,1424,1422,1614,1985,1729,1992,1925,392,1486,1551,1423,1552,1552,1422,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1422,1551,1793,1992,2000,1992,1669,1927,580,1487,1488,1552,1551,1423,1614,1614,1614,1614,1614,1614,1614,1614,1614,1422,1550,1487,1552,1488,1487,1488,1424,1486,1488,272,722,658,659,658,721,1303,1304,1303,1368,1303,1303,1368,1368,1368,1304,1304,1304,1368,1303,1304,1304,1303,1304,1303,1424,1424,1793,1992,1992,1992,1992,1992,1992,1992,1857,1367,1304,1303,1368,1368,1304,1368,1303,1368,1368,1304,1304,1304,1303,781,1304,1368,1303,1368,1368,1304,1551,277,82,1487,1615,399,964,1615,399,466,1487,1422,1550,1615,1488,1423,1550,1614,1550,1422,272,722,659,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1669,1927,1605,1605,1605,1605,1605,1605,1605,1985,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,773,392,517,517,455,1605,1605,456,773,1985,1861,1729,1992,1992,1669,1861,1927,1605,1605,1605,1605,1413,1605,1605,1605,1923,1797,1925,1605,1605,1605,1605,1605,1605,1606,1414,1477,1605,1541,1361,1361,1361,1605,1605,1605,392,391,456,392,391,456,391,456,1550,1550,1550,1793,1992,1667,1925,1550,1665,1486,1550,1615,1424,1614,1614,1614,1614,1614,1614,1614,1614,1614,1488,1552,1550,1793,1992,2000,1992,1857,330,1487,1551,1488,1422,1486,1424,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1422,1486,1422,1423,1486,1422,1487,1488,1424,272,657,657,658,657,593,1304,1304,1304,1368,1303,1303,1304,1304,1304,1304,1303,1303,1304,1303,1368,1303,1304,1303,1303,1423,1488,1793,1992,1992,1992,1992,1992,1992,1992,1857,1304,1304,1368,1368,1303,1368,1368,1303,1368,1304,1304,1303,1368,1303,781,1304,1304,1304,1303,1368,1303,1424,1487,1223,965,399,853,853,964,1349,1487,964,1488,1552,1614,1616,1423,1486,1550,1423,1552,272,595,659,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1923,1797,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,1605,1985,1729,1669,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1988,1730,1992,1667,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1477,1606,1413,1361,1605,1605,1605,1605,456,391,1605,1605,517,456,456,517,1616,1487,1985,1729,1992,1857,1551,1552,1665,1665,1487,1486,1614,1424,1614,1614,1614,1614,1614,1422,1614,1614,1486,1550,1793,1992,2000,1992,1857,82,1552,1552,1551,1488,1424,1487,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1552,1486,1551,1550,1550,1551,1551,1488,272,593,659,721,657,594,1303,1303,1303,1303,1368,1368,1303,1368,1368,1368,1303,1368,1368,1304,1303,1303,1368,1303,1303,1367,1424,1793,1992,1992,1992,1992,1992,1992,1992,1857,1368,1368,1368,1304,1303,1304,1303,781,781,781,781,781,781,781,781,1368,1303,1304,1304,1368,1303,1551,399,966,1487,399,655,655,963,963,469,1349,1487,1487,1550,1550,1551,1550,1488,1422,1488,272,593,593,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1923,1666,1992,1667,1797,1797,1797,1925,1605,1605,1605,1605,1605,1605,1605,392,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,582,1605,1985,1927,1605,1605,1605,1616,1486,1488,1424,1487,1423,1423,1550,1985,1861,1861,1927,1551,1614,1552,1423,1616,1424,1605,1605,1605,1605,1605,1414,1361,1361,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,646,1487,1550,1487,1985,1729,1667,1925,1552,1488,1665,1665,1550,1551,1614,1614,1614,1614,1614,1422,1551,1614,1614,1488,1486,1793,1992,2000,1992,1857,399,1486,1486,1422,1424,1422,1423,1422,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1550,1488,1424,1423,1550,1487,208,209,593,722,657,595,659,1368,1368,1304,1368,1304,1303,1368,1304,1368,1304,1303,1303,1304,1368,1368,1303,1368,1303,1304,1368,1486,1793,1992,1992,1992,1992,1992,1992,1992,1857,1303,1368,1304,1303,1303,1303,1368,1303,1304,1303,1303,1368,1368,1303,1303,1368,1368,1303,1303,1303,1304,1487,1615,82,966,853,277,466,655,963,469,966,1552,1614,1486,1423,1552,1422,1424,1616,1423,272,722,721,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1669,1861,1861,1927,650,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1923,1797,1666,1992,1992,1992,1992,1992,1992,1857,1605,1605,1605,1605,1605,1605,391,646,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,517,456,1605,1487,1551,1614,1923,1925,1487,1487,1423,1616,1615,1423,1424,1488,1552,1923,1797,1797,1797,1797,1797,1925,1605,1605,1605,1605,1606,1414,1414,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,391,1424,1552,1614,1985,1729,1992,1925,1551,1552,1614,1665,1486,1614,1616,1486,1424,1487,1614,1614,1614,1487,1552,1551,1793,1992,1992,1992,1857,391,1423,1551,1487,1551,1488,1550,1422,1550,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1488,1486,1550,1551,1424,272,594,594,721,657,594,657,1368,1304,1303,1303,1304,1303,781,781,781,781,781,781,781,781,781,781,1368,1303,1304,1304,1303,1793,1992,1992,1992,1992,1992,1992,1992,1857,1367,1303,1304,1303,1303,1303,1303,1368,1368,1368,1303,1303,1303,1304,1303,1303,1304,1368,1304,1368,1303,1486,1349,466,1615,1487,466,277,0,0,0,0,0,0,0,1488,1424,1614,1422,1487,1422,784,786,786,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1669,1861,1861,1927,1605,1605,1605,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1729,1992,1992,1669,1861,1861,1861,1927,1605,1605,1605,1605,1605,1605,646,1987,1605,1605,1605,455,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,392,1486,1424,1923,1797,1666,1667,1797,1797,1797,1797,1797,1925,1615,1423,1923,1666,1992,1992,1992,1992,1992,1667,1925,1551,1605,1605,1605,1478,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1550,1423,1422,1488,1985,1729,1667,1925,516,1550,1422,1665,1486,1488,1488,1488,1615,1614,1614,1551,1424,1488,1422,1793,1992,1992,1992,1857,1615,1488,1423,1552,1552,1486,1552,1486,1423,1422,1551,1424,1614,1614,1614,1614,1614,1614,1614,1614,1423,1487,1551,1488,1550,272,594,593,595,722,659,595,1304,1368,1304,1303,1303,1304,781,1368,1368,1368,1304,1304,1304,1368,1303,1303,1303,1303,1303,1304,1303,1793,1992,1992,1992,1992,1992,1992,1992,1857,1368,1303,1368,1304,1368,1304,1304,1368,1303,1368,1304,1368,1368,1304,1303,1304,1304,1303,1368,1368,1303,1615,853,964,1615,400,1487,399,0,0,1297,1297,1297,1297,1297,1551,1552,1422,1487,1614,1614,1297,1297,1297,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1669,1861,1927,714,1605,1605,1605,1605,1605,650,1605,1605,1605,1605,1605,649,519,1923,1925,519,649,520,584,650,583,1605,1605,1605,1605,1605,1605,1605,1605,1985,1861,1861,1927,1605,1605,1605,1605,1605,1605,1605,1605,1988,1800,1922,1928,646,1605,1605,646,1923,1925,1605,1605,1605,1605,1605,1605,517,456,1423,1422,1615,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,1616,1985,1729,1992,1992,1992,1992,1992,1992,1667,1925,1605,1605,1605,1605,1605,1605,1605,391,1616,392,455,456,1605,1605,1605,1605,391,1487,1550,1616,1424,1985,1729,1667,1797,1925,1488,1614,1488,1665,1552,1551,1486,1615,1550,1487,1550,1488,1551,1793,1992,1992,1992,1857,469,966,1487,1423,1423,1423,1423,1550,1488,1487,1550,1552,1486,1488,1423,1488,1614,1614,1614,1614,1614,1551,1422,1552,1552,272,593,722,593,722,721,403,1304,1368,1304,1304,1368,1368,781,1304,1368,1303,1303,1304,1368,1304,1303,1303,1368,1303,1368,1368,1367,1793,1992,1992,1992,1992,1992,1992,1992,1857,1304,1304,1304,1304,1368,1304,1368,1368,1304,1304,1368,1368,1304,1303,1303,1303,1303,1304,1303,1368,1303,1488,853,655,853,1223,399,966,0,0,528,529,530,531,532,1488,1615,1552,1422,1614,1422,1297,1297,1297,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1669,1927,1605,1605,1605,1605,1605,1605,1605,1605,1991,1605,1605,1605,1605,1605,583,1923,1666,1667,1797,1797,1797,1797,1925,649,1605,1605,1605,1605,1605,1605,1616,1488,1551,1614,1550,1552,1487,1550,1422,1550,1605,1605,1605,1605,1605,1989,1605,1605,646,1605,1605,456,1985,1927,1605,1605,1605,1605,1605,392,455,1551,1551,1616,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,1614,1985,1729,1992,1992,1992,1992,1992,1992,1857,1605,1605,519,1605,1605,1605,456,455,1552,1487,1423,517,392,455,1605,1605,392,455,1616,1616,1550,1487,1985,1729,1992,1667,1797,1925,1615,1552,1665,1550,1487,1486,1423,1422,1424,1423,1615,1793,1992,2000,1992,1857,391,966,1550,1486,1486,1551,1550,1551,1550,1422,1550,1488,1488,1423,1552,1551,1423,1487,1614,1614,1614,1422,1488,1423,1423,272,593,593,722,721,403,1422,1368,1303,1304,1303,1304,1303,781,1368,1303,1304,1304,1368,1304,1303,1303,1304,1303,1368,1304,1304,1304,1793,1992,1992,1992,1992,1992,1992,1992,1857,1304,1304,1303,1303,1368,1368,1368,1303,1304,1368,1303,1304,1303,1304,1368,1368,1368,1304,1303,1303,1303,1551,1349,963,655,466,466,965,1297,1297,592,593,594,595,596,1551,1552,1551,1615,1488,1487,1297,1297,1297,2000,2000,2000,2000,2000,2000,2000,2000,1992,1669,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1923,1666,1992,1992,1992,1992,1992,1992,1667,1797,1925,649,714,1605,1605,1488,1424,1616,1616,1551,1614,1424,1424,1424,1615,1423,1422,1488,1605,1605,1605,1605,1605,1605,1605,1605,1605,651,1605,1605,1605,1605,1605,1605,773,456,456,1487,1616,1423,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,1614,1793,1992,1992,1992,1992,1992,1992,1857,1486,519,582,1605,1605,1605,517,1551,1422,1551,1614,1487,391,391,391,1605,1605,391,1424,1423,1423,1616,1551,1985,1729,1992,1992,1667,1925,1487,1665,1665,1665,1550,1423,1487,1424,1488,1424,1793,1992,2000,1992,1857,399,1223,1550,1552,1422,1422,1424,1422,1487,1486,1486,1423,1423,1550,1423,1423,1424,1423,1488,1423,1487,1424,1487,1550,1424,272,659,723,339,403,1487,1424,1368,1303,1304,1368,1368,1304,781,1304,1368,1368,1304,1304,1368,1303,1368,1304,1368,1303,1304,1304,1368,1793,1992,1992,1992,1992,1992,1992,1992,1857,1368,1368,1303,1303,1304,1304,1304,1304,1303,1368,1304,1368,1368,1304,1368,1303,1304,1304,1303,1368,1303,1552,963,1349,469,966,1487,655,1487,655,656,657,658,659,660,1551,1423,1423,1487,1614,1616,1297,1297,1297,2000,2000,2000,2000,2000,1992,1992,1992,1669,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1985,1729,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,714,1486,1551,1614,1552,1424,1987,1614,1424,1487,1552,1424,1550,1422,1488,1614,1991,1551,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,1550,1923,1666,1992,1992,1992,1992,1992,1992,1669,1861,1861,1729,1992,1992,1992,1667,1797,1666,1992,1992,1992,1992,1992,1992,1857,1550,646,714,1605,1605,1605,517,1552,1424,1424,1616,1488,1615,646,517,1605,1605,456,391,1487,1551,1423,1488,1550,1985,1729,1992,1992,1667,1797,1925,1487,1665,1665,1615,1424,1552,1550,1486,1793,1992,2000,1992,1857,965,580,1422,1487,1486,1487,1423,1487,1486,1552,1422,1424,1552,1488,1486,1486,1551,1487,1424,1422,1550,1488,1552,1422,1422,784,785,786,403,1488,1422,1422,1304,1303,1303,1304,1303,1304,781,1368,1368,1368,1304,1303,1303,1304,1304,1304,1368,781,1303,1368,1303,1793,1992,1992,1992,1992,1992,1992,1992,1857,1304,1303,1304,781,1304,1303,1303,1368,1368,1368,1368,781,1303,1368,1368,1304,1304,1304,1368,1304,1368,1614,400,655,277,1349,82,1223,655,719,720,721,722,723,724,1424,1551,1551,1551,1615,1488,1297,1297,1297,2000,2000,2000,1992,1992,1669,1861,1861,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,714,1985,1861,1861,1861,1861,1729,1992,1992,1992,1669,1927,1551,1615,1422,1487,1487,1988,1732,1925,1422,1987,1488,1991,1486,1614,1424,1614,1423,1614,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1614,1422,1793,1992,1992,1992,1992,1992,1669,1861,1927,1348,1281,1985,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,1552,646,1605,1605,1605,646,456,1486,1487,1423,1486,1614,392,392,517,1605,392,391,1486,1616,1615,1486,1487,1486,1985,1729,1992,1992,1992,1667,1925,853,1665,1665,1615,469,1550,1223,1793,1992,2000,1992,1857,277,964,1551,1423,1423,1550,1423,1424,1424,1423,1486,1552,1550,1486,1422,1551,1423,1551,1488,1486,1424,1422,1486,1487,1488,1423,1486,1487,1422,1488,1422,1367,1303,1368,1367,1368,1304,1304,1304,1303,1303,1368,781,781,781,781,781,1368,1303,781,1304,1303,1304,1793,1992,1992,1992,1992,1992,1992,1992,1857,1304,1304,1303,781,1304,1304,1304,1368,1303,1368,1368,781,1304,1368,1368,1368,1303,1368,1304,1304,1304,1614,963,1349,149,965,655,149,966,783,784,785,786,787,788,1550,1550,1614,1550,1486,1615,1297,1297,1297,1992,1992,1992,1992,1861,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,584,1985,1861,1861,1861,1927,1552,583,1616,1614,1615,1616,1615,1793,1927,1615,1989,1551,1486,1422,1486,1424,1486,1486,1488,1615,1552,1422,1486,1551,1550,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1488,1923,1666,1992,1992,1992,1992,1992,1857,1026,1027,1028,1029,1030,1985,1729,1992,1992,1992,1669,1861,1861,1861,1729,1992,1992,1992,1857,1424,520,1605,1605,1605,1605,391,1551,1423,1614,1552,1615,1552,1605,392,1605,1605,456,391,1551,1487,1614,1614,1424,1614,1793,1992,1992,1992,1992,1667,1797,1925,1665,1665,966,1551,399,1793,1992,2000,1992,1857,773,391,1552,1551,1487,1552,1423,1422,1552,1488,1488,1424,1422,1486,1552,1424,1422,1488,1551,1551,1424,1487,1486,1551,1423,1487,1486,1487,655,1552,1304,1303,1303,1303,1304,1368,1367,1303,1304,1303,1368,1368,1303,1303,1304,1304,1304,1303,1304,781,1368,1368,1304,1793,1992,1992,1992,1992,1992,1992,1992,1857,1368,1304,1368,781,1304,1303,1304,1303,1304,1303,1304,781,1304,1303,1304,1368,1368,1368,1368,1304,1304,1614,469,853,149,966,965,965,1223,1487,469,400,1615,1486,1424,1551,1486,1614,1616,1422,1551,1297,1297,1297,1669,1861,1861,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,714,650,584,1422,1486,1488,1550,1487,1424,1424,1921,1552,1552,1614,1488,1552,1552,1422,1550,1422,1616,1422,1424,1423,1551,1487,1487,1487,1614,1422,1605,1605,1605,1605,1605,1605,1605,1605,1605,1614,1793,1992,1992,1992,1992,1992,1669,1927,1090,1091,1092,1093,1094,961,1793,1992,1992,1669,1927,1551,1488,1422,1985,1861,1729,1992,1857,1550,455,1605,1605,1605,391,456,1550,1550,1423,1551,1423,1552,391,646,455,1605,391,456,1486,1615,1424,1615,1424,1423,1985,1729,1992,1669,1861,1861,1861,1731,1925,1665,1665,1423,1615,1793,1992,2000,1992,1857,1487,469,1552,1552,1422,1487,1423,1488,1486,1487,1486,1488,1551,1552,1424,1488,1550,1550,1487,1551,1424,1422,1487,1486,1424,1487,1422,1552,1487,1303,1303,1368,1368,1368,1368,1304,1368,1304,1368,1368,1304,1368,1368,1303,1304,1304,1303,1303,1368,781,1368,1303,1304,0,0,0,0,0,0,0,0,0,1368,1303,1303,781,1303,1368,1304,1368,1303,1368,1304,781,1304,1304,1303,1304,1304,1304,1303,1304,1368,1615,853,399,1223,965,149,399,466,82,277,82,1551,1550,1616,1616,1488,1550,1487,1422,1423,1297,1297,1297,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,584,649,1987,519,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1488,1422,1550,1422,1550,1616,1989,1486,1615,1552,1552,1487,1616,1486,1488,1616,1422,1424,1486,1423,1486,1487,1424,1486,1614,1487,1605,1605,1605,1605,1605,1605,1605,1605,1605,1552,1793,1992,1992,1992,1992,1992,1857,1281,1154,1155,1156,1157,1158,1348,1793,1992,1992,1857,1486,1616,1615,1488,1487,1488,1793,1992,1667,1925,1551,1605,517,646,392,456,391,1550,1422,1615,1487,1551,1424,455,456,1605,392,455,1422,1423,1615,1614,1615,1616,1422,1985,1992,1857,580,1616,1616,1985,1731,1797,1925,1665,964,1793,1992,2000,1992,1857,1223,1349,1422,1551,1552,1486,1486,1422,1551,1424,1487,1550,1552,1487,1423,1486,1422,1552,1486,1488,1552,1551,1422,1550,1423,1422,1486,1367,1223,1488,1303,1486,1303,1304,1303,1303,1303,1303,1368,1303,1303,1303,1368,1368,1368,1303,1368,1368,1304,781,1368,1368,1368,1304,1992,1992,1992,1992,1992,1992,1992,1304,1304,1303,1303,781,1303,1304,1368,1368,1304,1303,1304,781,1368,1368,1304,1303,1303,1368,1304,1304,1368,1488,655,277,965,400,82,399,853,1615,399,1349,1616,1486,1424,1422,1550,1552,1614,1616,1422,1297,1297,1297,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,650,1923,1668,1925,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1987,1616,1615,1552,1487,1424,1423,1487,1424,1488,1550,1615,1488,1550,1551,1551,1422,1615,1614,1487,1987,1486,1486,1614,1551,1551,1605,1605,1605,1605,1605,1605,1605,1423,1422,1793,1992,1992,1992,1992,1992,1857,1159,1218,1219,1220,1221,1222,1923,1666,1992,1992,1857,1487,1422,1614,1423,1552,1551,1793,1992,1992,1857,1487,1605,456,455,455,456,517,517,1550,1552,1550,1486,1486,1422,391,391,392,1605,1424,1550,1488,1424,1424,1487,1615,1488,1985,1731,1925,853,1422,1488,1985,1729,1667,1925,1665,1793,1992,2000,1992,1667,1925,710,1486,1422,1487,1550,1552,1552,1424,1551,1422,1551,1424,1552,1487,1424,1488,1551,1551,1487,1424,1424,1423,1550,1552,1551,1488,1487,277,1488,1367,1423,1368,1303,1304,1303,1304,1368,1303,1303,1368,1304,1303,1368,1304,1304,1303,1303,1303,781,1303,1303,1303,1303,1368,1304,1304,1303,1368,1304,1304,1368,1368,1304,1303,781,1304,1304,1304,1304,1304,1368,1303,781,1368,1368,1368,1368,1368,1304,1368,1303,1303,1550,400,466,963,966,963,400,965,82,853,965,1424,1614,1487,1615,1486,1486,1488,1424,1422,1297,1297,1297,1605,1605,307,308,309,310,311,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,455,1605,1605,1605,1923,1666,1992,1857,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1986,1990,1551,1486,1551,1552,1486,1552,1614,1552,1616,1486,1551,1550,1488,1550,1422,1422,1923,1797,1668,1797,1797,1925,1551,1552,1614,1605,1605,1605,1605,1605,1605,1423,1552,1793,1992,1992,1992,1992,1992,1667,1925,1282,1283,1284,1285,1286,1793,1992,1992,1992,1857,1616,1550,1422,1486,1614,1614,1793,1992,1992,1857,1424,584,455,649,1605,1605,1605,1605,1605,1605,1605,1615,1552,1614,517,455,456,1614,1422,1616,1486,1486,1550,1551,1486,1616,1423,1793,1857,1349,965,1551,1423,1985,1729,1667,1797,1666,1992,2000,1992,1992,1857,277,853,1487,1551,1487,1488,1422,1486,1424,1552,1551,1552,1488,1614,1614,1614,1422,1424,1422,1422,1487,1486,1488,1423,1551,1424,1486,964,1550,1424,1550,1303,1303,1303,1368,1368,1368,1304,1368,1303,1303,1303,1303,1303,1368,1304,1304,1304,1368,1304,1304,1368,1368,1303,1368,1368,1303,1303,1304,1304,1303,1303,1304,1304,1368,1368,1304,1304,1304,1368,1304,1303,1368,1368,1368,1304,1303,1304,1368,1304,1303,1368,1486,965,655,1223,82,1487,853,399,964,0,0,0,0,0,0,1487,1486,1486,1550,1488,1297,1297,1297,2684355341,2684355341,371,372,373,374,375,2684355341,2684355341,1605,1605,1605,1605,392,1605,392,391,1605,1605,1605,1605,1985,1861,1861,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1422,1423,1551,1616,1422,1615,1615,1550,1614,1550,1552,1616,1488,1616,1422,1424,1422,1988,1992,1992,1992,1992,1992,1667,1797,1925,1614,1551,1605,1605,1624,1605,1422,1615,1616,1793,1992,1992,1992,1992,1992,1992,1667,1925,1348,961,1348,1923,1666,1992,1992,1992,1857,1551,1616,1614,1487,1486,1486,1793,1992,1992,1857,1422,714,650,649,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1423,1424,1614,1552,1486,1551,1487,1423,1423,1550,1985,1731,1925,392,1422,1424,966,1985,1729,1992,1992,1992,2000,1992,1992,1857,466,853,1550,1551,1424,1424,1552,1550,1422,1614,1614,1614,1552,1614,1614,1614,1614,1614,1488,1550,1423,1487,1424,1488,1552,1423,1487,82,1550,1422,1423,1303,1304,1368,1368,1368,1368,1304,1304,1304,1368,1303,1368,1368,1368,1368,1368,1304,1303,1368,1304,1303,1793,1992,1992,1992,1992,1992,1992,1992,1857,1368,1368,1303,1303,1368,1304,1304,1304,1303,1304,1304,1303,1303,1304,1304,1304,1368,1368,1368,1303,1304,1552,82,964,1349,965,964,964,966,964,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,2684355341,2684355341,435,436,437,438,439,2684355341,2684355341,1605,1605,1605,1605,456,456,392,391,1605,1605,1605,1605,520,520,517,519,1605,1605,1605,1605,1605,1605,1991,1605,1605,1605,1605,1605,1605,1605,1423,1424,1550,1616,1551,1423,1552,1615,1552,1991,1616,1552,1487,1614,1486,1488,1423,1487,1985,1861,1861,1861,1861,1861,1861,1927,1486,1424,1487,1605,1550,1615,1424,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1666,1992,1669,1861,1861,1731,1797,1925,1423,1487,1488,1923,1666,1992,1669,1927,517,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1550,1614,1486,1424,1551,1614,1422,1488,1550,964,1550,1488,1793,1857,1615,1423,1615,1423,1616,1985,1861,1729,1992,2000,1992,1992,1857,1487,82,1422,1486,1422,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1486,1422,1423,1487,1550,1422,1422,1615,1422,1551,1551,1300,1365,1364,1362,1364,1362,1235,1364,1235,1364,1236,1236,1236,1235,1234,1235,1364,1299,1234,1298,1300,1793,1992,1992,1992,1992,1992,1992,1992,1857,1300,1364,1236,1365,1364,1298,1236,1363,1363,1234,1237,1236,1298,1363,1303,1368,1303,1300,1237,1363,1235,1423,1349,1223,466,149,400,965,149,1349,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,2684355341,2684355341,307,308,309,310,311,2684355341,2684355341,1605,456,456,392,456,1987,391,391,392,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1422,1614,1614,1615,1614,1424,1616,1487,1550,1487,1550,1614,1550,1550,1616,1614,1550,1552,1615,1616,1423,1616,1550,1486,1488,1424,1615,1486,1488,1614,1614,1923,1797,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1615,1552,1793,1992,1667,1797,1797,1797,1666,1992,1992,1857,1423,517,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1552,1614,1552,1424,1550,1423,1486,1486,1550,1615,1424,1487,149,469,1614,1985,1858,964,965,149,853,1422,966,400,1793,1992,2000,2000,1992,1667,1925,1422,1488,1423,1616,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1551,1550,1423,1488,1552,1552,1423,466,1486,1487,1486,1365,1364,1362,1362,1300,1362,1299,1298,1364,1362,1365,1237,1234,1237,1364,1236,1234,1234,1300,1236,1237,1793,1992,1992,1992,1992,1992,1992,1992,1857,1234,1299,1364,1237,1235,1362,1236,1364,1365,1236,1299,1300,1301,1301,1368,1303,1303,1304,1235,1301,1301,1486,1223,277,1615,466,966,277,149,277,1297,1297,1297,1297,1297,1297,0,0,0,0,0,1297,1297,1297,2684355341,2684355341,371,372,373,374,375,2684355341,2684355341,1605,1605,456,1924,1922,1732,1925,456,392,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,455,456,1605,1605,1605,1488,1615,1616,1614,1423,1422,1486,1423,1423,1551,1488,1488,1422,1615,1614,1551,1488,1486,1486,1551,1550,1552,1551,1551,1487,1615,1422,1988,1799,1797,1666,1992,1992,1861,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1486,1552,1793,1992,1992,1992,1992,1992,1992,1992,1992,1857,1488,584,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1487,1614,1487,1616,1616,1487,1423,1550,1551,1486,1615,964,1550,1487,1614,1550,1794,1925,400,392,1487,1615,1615,1486,1793,1992,2000,2000,1992,1992,1857,1487,1550,1551,1424,1488,1552,1551,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1487,1551,1551,1552,1550,1552,1486,655,1550,1550,1486,1236,1237,1364,1363,1362,1364,1301,1364,1365,1362,1299,1235,1234,1364,1235,1234,1234,1365,1235,1237,1363,1793,1992,1992,1992,1992,1992,1992,1992,1857,1365,1235,1298,1298,1236,1234,1234,1237,1301,1237,1234,1298,1235,1235,1303,1303,1304,1368,1235,1368,1237,1615,1615,1349,149,277,399,963,963,469,965,655,469,277,1423,1297,1297,1297,1297,1297,1297,1297,1297,1297,2684355341,2684355341,435,436,437,438,439,2684355341,2684355341,1605,392,1923,1859,1223,1793,1857,456,456,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,392,455,455,391,391,391,391,1605,1605,1605,1605,1423,1551,1614,1423,1552,1423,1486,1616,1488,1487,1551,1615,1486,1616,1422,1486,1614,1615,1487,1486,1614,1488,1423,1615,1487,1615,1552,1985,1729,1992,1992,1857,1423,1422,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1614,1422,1793,1992,1992,1992,1992,1992,1992,1992,1669,1927,1423,649,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1550,1552,1614,1614,1550,1614,1552,1486,1423,1486,1550,964,1486,1487,1793,1857,1422,1550,1551,773,1551,1551,1793,1992,2000,2000,1992,1992,1667,1925,1615,1616,1551,1487,1424,1424,1487,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1550,1423,1486,1488,1550,1550,400,1487,1488,1486,1551,1422,1552,1486,1488,1488,1422,1423,1424,1487,1424,1424,1487,1550,1552,1423,1424,1552,1487,1488,1488,1422,1793,1992,1992,1992,1992,1992,1992,1992,1857,1487,1424,1422,1551,1614,1488,1552,1551,1615,1616,1487,1614,1615,1422,1303,1303,1368,1304,1304,1303,1368,1615,1349,399,963,1349,400,277,964,1223,466,466,963,149,1551,1616,1614,1486,1486,1615,1424,1297,1297,1297,2684355341,2684355341,307,308,309,310,311,2684355341,2684355341,1605,456,1985,1863,1922,1862,1927,456,391,1605,1605,1923,1797,1797,1925,1605,1605,1605,1605,1605,1605,455,392,392,1987,455,392,456,456,1605,1605,1605,1615,1614,1551,1424,1615,1423,1552,1550,1424,1488,1550,1615,1615,1614,1616,1615,1487,1422,1551,1615,1422,1552,1614,1423,1486,1487,1615,1615,1614,1793,1669,1861,1858,1488,1486,1985,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1422,1923,1666,1992,1992,1992,1992,1992,1992,1992,1857,1614,520,519,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1487,1487,1487,1550,1552,1424,1486,1552,1422,1552,1550,1423,966,1423,1793,1857,1223,469,1616,1487,1616,1422,1985,1729,1992,2000,2000,1992,1992,1667,1925,1488,1423,1616,1550,1488,1486,1550,1487,1614,1614,1614,1614,1614,1487,1614,1614,1614,1422,1551,1424,1424,1550,1551,1349,82,655,1223,1616,1488,1424,1551,1487,1487,1423,1422,1615,1488,853,964,964,1223,965,966,853,149,466,964,400,399,1793,1992,1992,1992,1992,1992,1992,1992,1857,466,963,399,82,1487,400,466,965,82,149,1349,400,965,853,277,1304,1304,1304,1614,1614,1614,1614,1614,853,966,963,965,655,1223,853,964,400,853,466,1616,1616,1551,1616,1488,1552,1550,1297,1297,1297,2684355341,2684355341,371,372,373,374,375,2684355341,2684355341,1605,391,392,391,456,456,456,391,1605,1605,1605,1985,1729,1992,1992,1925,1605,391,1605,456,1605,456,455,1923,1668,1797,1797,1797,1925,1605,1605,1423,1487,1552,1424,1486,1424,1614,1616,1614,1424,1991,1614,1422,1616,1615,1424,1923,1797,1797,1925,1614,1614,1616,1616,1422,1615,1424,1550,1615,1923,1666,1857,1552,1989,1614,1991,1487,1486,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1666,1992,1992,1992,1992,1992,1992,1992,1992,1857,1614,517,455,649,1615,1424,1616,1616,1422,1550,1487,1552,1486,2684355341,2684355341,2684355341,2684355341,1487,1614,1615,1424,1423,1422,1614,1614,1614,1614,1614,1614,965,1550,1985,1731,1925,1552,1488,1615,1551,1614,1424,1793,1992,2000,2000,2000,1992,1992,1857,1551,1550,1423,1552,1423,1550,1422,1552,1424,1422,1551,1487,1488,1552,1423,1424,1422,1423,1424,1422,1552,1424,1424,1349,1487,655,963,1552,1488,1615,1487,1614,1487,1616,1614,1614,1488,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,149,965,1793,1992,1992,1992,1992,1992,1992,1992,1857,400,964,1615,1487,1349,1223,964,1487,1487,655,469,966,149,1487,469,853,1368,1614,1614,1304,1614,1614,1614,469,1615,853,149,964,1615,277,655,1349,399,399,1616,1422,1486,1614,1423,1615,1551,1297,1297,1297,2684355341,2684355341,435,436,437,438,439,2684355341,2684355341,1605,1605,1605,1605,456,455,456,455,1605,1605,392,456,1985,1861,1861,1927,455,455,392,456,455,455,1923,1666,1992,1992,1992,1992,1667,1925,1552,1550,1616,1424,1552,1488,1487,1616,1615,1551,1991,1424,1423,1614,1552,1552,1988,1862,1861,1861,1863,1990,1486,1424,1423,1614,1423,1423,1923,1797,1666,1669,1927,1615,1424,1551,1615,1486,1422,1985,1861,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1861,1927,583,455,517,714,1422,1424,1614,1552,1487,1551,1551,1424,1614,2684355341,2684355341,2684355341,2684355341,1423,1552,1550,1423,1422,1614,1614,1614,1614,1614,1614,1614,965,1487,1486,1793,1857,1550,1550,1423,1552,1616,1552,1793,1992,1992,1992,2000,2000,1992,1667,1797,1925,1615,1551,1552,1615,1550,1487,1422,1486,1550,1486,1422,1550,1486,1487,1488,1422,1423,1486,1423,1488,1424,1424,399,966,963,1424,1615,1614,1614,1614,1486,1487,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,966,1349,1793,1992,1992,1992,1992,1992,1992,1669,1927,853,399,1223,277,1614,1614,1614,1614,1614,1614,1614,1349,469,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1487,399,1223,469,655,1349,964,1223,82,1349,1422,1616,1550,1422,1424,1488,1297,1297,1297,2684355341,2684355341,307,308,309,310,311,2684355341,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,1605,1605,456,392,456,455,392,392,456,455,1985,1729,1992,1992,1992,1992,1992,1857,1424,1488,1487,1615,1616,1422,1488,1615,1423,1550,1550,1552,1551,1616,1551,1551,1488,1550,1423,1422,1422,1616,1615,1616,1616,1487,1550,1923,1666,1992,1669,1927,1423,1486,1488,1552,1552,1422,1422,1424,1552,1423,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1423,1422,1551,1487,650,584,455,520,455,519,1550,1424,1488,1423,1487,1616,2684355341,2684355341,2684355341,2684355341,1614,1423,1614,1614,1614,1614,1614,715,715,1614,1614,1614,516,516,1551,1985,1731,1925,1550,1615,1422,1488,1487,1793,1992,1992,1992,2000,2000,1992,1992,1992,1667,1797,1925,1422,1552,1616,1615,1487,1615,1550,1488,1423,1550,1552,1423,1551,1486,1550,1487,1424,1424,1552,1486,1552,1487,399,1616,1424,1614,1614,1614,1486,1551,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,82,655,1793,1992,1992,1992,1992,1992,1992,1857,1424,964,1223,964,966,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,964,853,1615,1614,1614,965,964,1487,1422,1423,1487,1422,1423,1424,1349,1616,1616,1550,1615,1424,1422,1297,1297,1297,2684355341,2684355341,371,372,373,374,375,2684355341,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,455,1605,456,456,392,456,1605,1605,391,392,392,1985,1729,1992,1992,1992,1669,1927,1616,1551,1551,1615,1616,1616,1424,1552,1614,1615,1550,1423,1424,1487,1551,1551,1423,1551,1615,1424,1422,1614,1486,1552,1424,1550,1923,1666,1669,1861,1927,1424,1616,1616,1614,1486,1424,1424,1991,1615,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1550,1551,650,392,456,392,1605,1605,1605,1605,1605,1605,1605,1422,1551,1616,1422,2684355341,2684355341,2684355341,2684355341,1424,1423,1614,715,1614,1614,715,715,1614,1614,715,1614,1422,1349,1552,1424,1985,1857,1424,1423,1615,1487,1423,1793,1992,1992,1992,1992,2000,1992,1992,1992,1992,1992,1667,1797,1925,1424,1423,1422,1615,1422,1616,1487,1487,1423,1551,1488,1488,1488,1423,1487,1615,1550,1488,1551,1422,1423,1223,469,1614,1614,1614,469,466,1614,1614,1614,1614,1614,1614,1424,1551,1614,1550,1487,1424,1423,1424,1550,1793,1992,1992,1992,1992,1992,1992,1857,1487,1422,1487,1424,1615,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1423,1552,1424,1551,1487,1614,1614,1552,1616,1550,1424,1551,1487,1486,1487,1488,1486,1487,1487,1422,1615,1615,1422,1297,1297,1297,2684355341,2684355341,435,436,437,438,439,2684355341,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,456,455,1605,1605,1605,1605,1605,1605,392,392,391,1985,1861,1861,1861,1927,1414,1552,1615,1424,1424,1550,1488,1424,1614,1550,1423,1614,1486,1424,1422,1551,1422,1550,1614,1486,1616,1487,1487,1488,1614,1923,1797,1666,1992,1857,1614,1488,1551,1615,1487,1614,1552,1487,1487,1486,1551,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1614,517,1605,455,455,455,392,1605,1605,1605,1605,1605,1605,1605,1486,1488,1550,2684355341,2684355341,2684355341,2684355341,2684355341,1614,1488,1614,1614,1614,715,715,715,715,715,1614,1614,1423,1551,1552,1423,1422,1921,1552,1486,1486,1552,1422,1985,1861,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1925,1551,1488,1422,1615,1616,1422,1550,1616,1991,1616,1551,1616,1422,1551,1552,1487,1422,1488,1551,1616,1423,1488,1487,964,964,469,399,1550,1424,1550,1615,1487,1551,1616,1616,1488,1487,1552,1552,1423,1422,1616,1793,1992,1992,1992,1992,1992,1992,1857,1614,1551,1488,1550,1616,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1486,1614,1614,1614,1614,1614,1614,1551,1551,1424,1615,1552,1486,1487,1615,1487,1550,1487,1551,1487,1614,1615,1550,1297,1297,1297,2684355341,2684355341,307,308,309,310,311,2684355341,2684355341,1605,1605,1605,1605,1605,1605,1605,1542,1542,1413,1606,1605,1605,1605,455,456,1605,1605,1605,1605,1605,1605,392,391,455,456,1541,1606,1606,1414,1542,1552,1552,1423,1923,1797,1797,1797,1797,1925,1487,1424,1487,1486,1486,1615,1488,1551,1550,1487,1486,1424,1923,1797,1666,1992,1992,1669,1927,1552,1614,1550,1552,1614,1550,1551,1923,1797,1797,1797,1666,1669,1861,1861,1729,1992,1992,1669,1861,1861,1729,1669,1861,1729,1992,1857,455,455,456,456,392,1605,1605,1605,1605,1605,646,646,1605,1605,1616,1486,1550,2684355341,2684355341,2684355341,2684355341,2684355341,1424,1423,1614,715,715,715,715,1614,715,715,715,1614,1550,1551,1422,1488,1422,1794,1925,1488,1422,1551,1615,1552,1552,1422,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1925,1551,1423,1550,1488,1488,1551,1552,1486,1486,1552,1423,1552,1614,781,781,781,1614,1614,1550,1487,1551,1551,1422,1486,149,1424,1615,1550,1486,1552,1616,1487,1422,1616,1424,1423,1423,1552,1488,1488,1793,1992,1992,1992,1992,1992,1992,1667,1925,1423,1551,1487,1616,1424,1615,1614,1487,1486,1550,1486,1551,1616,1614,1614,1614,1614,1614,1550,1424,1614,1614,1614,1615,1423,1616,1614,1614,1614,1424,1552,1423,1551,1615,1614,1487,1487,1614,1424,1487,1488,1297,1297,1297,2684355341,2684355341,371,372,373,374,375,2684355341,2684355341,1605,1605,1605,1605,1606,1606,1542,1413,1605,1605,1414,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,456,1605,1413,1413,1414,1605,1477,1616,1923,1666,1992,1992,1992,1992,1667,1925,1551,1551,1423,1550,1488,1551,1422,1615,1552,1923,1797,1666,1992,1992,1992,1669,1927,1614,1551,1552,1616,1552,1550,1552,1923,1666,1669,1861,1861,1861,1927,1487,1551,1985,1861,1861,1927,1488,1487,1793,1857,1423,1793,1992,1857,456,392,456,455,1605,1605,1605,1605,1605,1605,646,456,1605,1605,1550,1606,1606,2684355341,2684355341,2684355341,2684355341,2684355341,1422,1424,1614,715,715,1614,1614,1614,1614,715,715,1614,1614,1614,1552,1424,1487,1793,1857,1616,1550,1423,1424,1550,1550,1487,1793,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1667,1925,1486,1422,1488,1550,1487,1422,1488,1616,1551,1550,1365,1365,1365,1365,1365,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1424,1550,1793,1992,1992,1992,1992,1992,1992,1992,1857,1616,1486,1487,1616,1614,1550,1487,1550,1488,1551,1423,1488,1552,1614,1614,1614,1614,1614,1486,1614,1614,1614,1614,1615,1615,1616,1614,1614,1614,1551,1551,1615,1615,1487,1615,1550,1487,1551,1424,1552,1488,1297,1297,1297,2684355341,2684355341,435,436,437,438,439,2684355341,2684355341,1605,1605,1605,1605,1478,1606,1414,1606,1605,1541,1478,1541,1605,1605,1605,1605,1605,1605,1605,1605,455,456,1605,1605,1605,1605,1605,1605,1605,1477,1605,1414,1605,1985,1861,1729,1992,1669,1861,1861,1927,1424,1422,1488,1423,1424,1423,1616,1923,1797,1666,1992,1992,1992,1992,1669,1927,1616,1551,1988,1990,1550,1615,1923,1797,1666,1992,1857,1486,1550,1422,1423,1550,1424,1551,1552,1423,1486,1550,1552,1985,1927,1550,1985,1861,1927,455,517,1605,1605,1605,1605,1605,1605,1605,1605,1605,646,1605,1605,1605,1605,1541,2684355341,2684355341,2684355341,2684355341,2684355341,1615,1616,1614,715,715,715,715,715,715,715,1614,1614,1614,715,1550,1422,1422,1985,1731,1925,1424,1552,1422,1424,1616,1487,1793,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1992,1667,1797,1797,1797,1925,1615,1614,1616,1552,1422,1422,1552,1487,1614,1487,1488,1365,1365,1365,1365,1365,1365,1365,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1793,1992,1992,1992,1992,1992,1992,1992,1857,781,781,781,781,781,781,1615,1615,1551,1551,1487,1550,1551,1424,1551,1424,1616,1423,1487,1552,1614,1614,1614,1423,1487,1614,1424,1551,1615,1422,1422,1614,1486,1488,1551,1615,1551,1551,1424,1487,1486,1297,1297,1297,2000,2000,2000,2000,1857,1605,1605,1605,1605,1605,1605,1605,1605,1605,1414,1605,1414,1541,1414,1478,1605,1542,1605,1605,1605,1605,1605,1605,1605,1987,391,391,455,1605,1605,1605,1605,1605,1605,1605,1541,1605,1552,1487,1985,1861,1927,1550,1422,1422,1487,1551,1551,1614,1487,1422,1923,1666,1992,1992,1992,1992,1992,1992,1857,1424,1550,1423,1552,1551,1923,1797,1666,1992,1992,1669,1927,1550,1614,1422,1550,1615,1551,392,455,456,455,1605,1488,1423,456,455,1488,1424,1488,649,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1542,2684355341,2684355341,2684355341,2684355341,2684355341,1423,1486,1614,1614,1614,715,715,715,715,715,1614,1614,1614,1614,1615,1422,1550,1486,1793,1857,1422,1615,1615,1615,1552,1550,1793,1992,1992,1992,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1925,1550,1487,1423,1615,1551,1552,1423,1552,1615,1422,1551,1423,1616,1424,1486,1615,1365,1365,1365,1365,1365,781,781,781,781,781,781,781,781,781,781,781,781,1793,1992,1992,1992,1992,1992,1992,1992,1857,781,781,781,781,781,781,781,781,781,1487,1423,1422,1551,1615,1486,1614,1552,1486,1552,1487,1550,1422,1424,1550,1552,1422,1423,1552,1551,1614,1487,1615,1552,1615,1552,1486,1486,1551,1486,1552,1487,1297,1297,1297,2000,2000,2000,2000,1857,1605,1605,1605,1605,1605,1605,1605,1605,1923,1797,1797,1797,1797,1925,1414,1477,1478,1605,1605,1478,1541,1605,1605,391,1794,1797,1797,1925,456,455,455,391,456,1605,1605,1413,1542,1606,1552,1615,1423,1550,1550,1614,1488,1488,1614,1424,1487,1923,1797,1666,1992,1992,1992,1992,1992,1992,1992,1671,1922,1922,1922,1922,1922,1862,1861,1861,1861,1861,1927,1614,1616,1486,1552,1550,456,456,455,456,1605,456,392,391,392,456,392,391,455,456,392,520,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,1614,2684355341,2684355341,2684355341,2684355341,2684355341,1551,1614,1614,1614,1614,1614,715,715,715,1614,715,1614,1614,1614,1488,1422,1422,1552,1793,1667,1925,1551,1616,1487,1487,1487,1985,1729,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1667,1797,1797,1925,1487,1423,1487,1550,1551,1614,1615,1616,1423,1614,1615,1424,1550,1616,1615,1422,1424,1487,1365,1365,1365,1365,781,781,781,781,781,781,781,781,1793,1992,1992,2000,2000,1992,1992,1992,1857,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1552,1488,1486,1614,1615,1424,1486,1423,1615,1552,1488,1486,1615,1550,1614,1614,1486,1550,1422,1423,1550,1615,1616,1550,1297,1297,1297,2000,2000,2000,2000,1857,1605,1605,1605,1605,715,583,519,1923,1666,1992,1992,1992,1992,1667,1925,1606,1414,1478,1413,1477,1414,1477,1605,456,1793,1992,1861,1927,456,455,1605,1605,1605,1605,1605,1605,1477,1477,1413,1551,1422,1551,1488,1423,1424,1614,1616,1923,1797,1992,1992,1992,1992,1992,1992,1669,1861,1861,1861,1927,1550,1486,1552,1550,1551,1486,1551,1486,1552,1423,1614,1551,1552,1550,2684355080,2684355143,391,392,1605,1605,1605,1605,1605,391,456,456,1605,1605,1605,1417,1418,1418,1418,1419,1605,517,456,517,391,455,1605,1605,1605,1605,646,391,1542,2684355341,2684355341,2684355341,2684355341,2684355341,1487,1616,1487,1487,1550,1422,1614,1614,1614,1614,1614,1614,1550,1552,1424,1552,1614,1551,1793,1992,1857,1424,1423,1552,1424,1552,1614,1793,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1615,1615,1615,1488,1422,1551,1486,1550,1423,1422,1486,1423,1614,1424,1551,1424,1550,1614,1551,1423,1614,1550,1365,1365,1365,1365,1365,781,781,781,1793,1992,1992,2000,2000,2000,1992,1992,1857,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1552,1551,1552,1616,1488,1487,1423,1551,1423,1487,1422,1423,1552,1551,1487,1615,1550,1297,1297,1297,2000,2000,2000,2000,1857,1605,1605,1605,1605,715,520,584,1793,1992,1992,1992,1992,1992,1992,1857,1478,1541,1477,1606,1606,1541,1606,1605,456,1985,1927,392,455,456,1605,1605,1605,1605,1605,1605,1605,1413,1478,1478,1414,1477,1550,1488,1550,1923,1797,1797,1992,1992,1992,1992,1992,1992,1669,1861,1927,2684354951,2684355080,2684355015,2684355143,1614,1616,1423,1552,1614,1550,1552,1551,1552,1488,1486,1615,2684355079,391,456,391,455,1605,1605,1605,1605,1605,1605,456,455,1605,1479,1605,1605,1481,1474,1540,1601,1483,1605,517,391,456,456,392,455,456,1605,1605,392,455,1606,2684355341,2684355341,2684355341,2684355341,2684355341,1551,1615,1616,1615,1423,1614,1614,1614,1614,1424,1616,1424,1424,1424,1486,1551,1616,1488,1985,1729,1667,1925,1424,1615,1616,1422,1551,1793,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1797,1797,1925,1488,1615,1423,1487,1422,1424,1486,1488,1615,1551,1615,1615,1551,1616,1616,1616,1615,1550,1486,781,781,781,1793,1992,1992,2000,2000,2000,1992,1992,1857,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,781,1551,1552,781,781,781,781,781,781,781,1424,1487,1550,1614,1550,1552,1614,1552,1297,1297,1297,2000,2000,2000,2000,1857,1605,1605,1605,1605,715,715,519,1985,1729,1992,1992,1992,1992,1992,1857,1541,1478,1478,1478,1605,1541,1541,1605,1605,391,392,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1542,1478,1606,1605,1923,1797,1666,1992,1992,1992,1992,1992,1992,1992,1669,1927,2684355143,2684355016,2684355080,2684354951,1605,455,455,455,391,391,391,391,391,1486,1552,1552,1615,455,455,456,392,2684355143,1605,1605,1605,1605,1605,1605,1605,1605,1605,1414,1414,1414,1605,1481,1601,1475,1411,1483,1605,1605,1605,1605,455,456,517,455,455,646,1605,1605,1541,2684355341,2684355341,2684355341,2684355341,2684355341,1422,1552,1550,1487,1616,1422,1615,1487,1552,1616,1487,1422,1487,1615,1424,1487,1486,1488,1423,1793,1992,1857,1552,1423,1486,1487,1488,1793,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1488,1424,1550,1487,1550,1552,1488,1616,1616,1486,1422,1614,1616,1423,1488,1550,1487,1615,1552,1365,1365,1365,1793,1992,1992,2000,2000,2000,1992,1992,1857,781,781,781,781,781,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1615,1616,781,781,781,781,781,781,781,781,781,781,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,715,715,715,715,715,715,715,1605,715,715,715,715,584,1985,1861,1861,1729,1992,1992,1857,1541,1542,1542,1606,1605,1413,1605,1605,1605,1605,1605,1605,1605,1605,1414,1413,1478,1478,1605,1605,1605,1605,1605,1605,1605,1413,1923,1666,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,2684354952,2684355079,2684355015,1605,456,392,391,456,392,456,456,456,391,392,456,391,391,456,392,456,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1479,1414,1605,1545,1484,1537,1539,1601,1483,1479,1605,1605,1605,1605,646,392,392,455,1605,1605,1478,2684355341,2684355341,2684355341,2684355341,2684355341,1422,1487,1616,1550,1615,1487,1423,1552,1487,1422,1552,1487,1616,1615,1552,1486,1615,1488,1422,1985,1729,1857,1486,1615,1551,1423,1424,1793,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1797,1797,1797,1797,1925,1552,1488,1487,1488,1423,1487,1423,1616,1552,1488,1487,1923,1666,1992,1992,2000,2000,2000,1992,1992,1857,1365,1365,1365,1365,1365,1616,1488,1422,1615,1424,1550,1550,1488,1614,1615,1615,1488,1486,1423,1424,1424,1487,1550,1424,1488,1616,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1797,1925,715,715,1923,1797,715,715,715,715,715,715,715,583,583,519,1985,1861,1861,1927,1413,1541,1414,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1542,1413,1542,1605,1605,2684354952,2684354952,2684355016,2684355015,1923,1666,1992,1992,1992,1992,1992,1992,1669,1861,1927,2684355015,2684355016,2684354952,2684355080,1605,1605,1605,1605,1605,1605,1605,456,392,392,455,391,456,392,456,391,391,391,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,1605,1605,1481,1538,1409,1473,1483,1479,1479,1605,1605,1605,456,391,1605,392,1605,392,1614,1423,1486,2684355341,2684355341,2684355341,1552,1614,1424,1422,1552,1488,1616,1614,1552,1552,1551,1424,1552,1486,1487,1552,1422,1551,1615,1551,1985,1731,1925,1552,1550,1616,1422,1793,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1925,1616,1552,1550,1616,1614,1923,1666,1992,1992,1992,2000,2000,2000,1992,1992,1857,1550,1615,1551,1423,1424,1614,1550,1423,1550,1424,1487,1424,1487,1615,1422,1423,1488,1615,1614,1423,1615,1614,1614,1487,1488,1487,1616,1486,1616,1552,1424,1616,1424,1486,1488,1552,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,1797,1797,1992,1667,1797,1925,520,715,715,715,715,715,584,519,584,455,456,455,1605,1605,1605,1605,1605,1478,1605,1542,1605,1605,1605,1605,1605,1605,1923,1797,1925,1414,1542,1605,2684355143,2684355080,2684354952,2684355079,1923,1666,1992,1992,1992,1992,1992,1669,1861,1927,2684355016,2684355079,2684354952,2684354951,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,456,455,392,456,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,456,455,1605,1545,1484,1473,1410,1421,1419,1479,1414,1605,1605,1605,1605,1605,1605,1605,456,1478,1423,1486,2684355341,2684355341,2684355341,1616,1422,1616,1614,1616,1551,1614,1551,1487,1422,1488,1551,1488,1614,1615,1551,1424,1424,1423,1616,1487,1793,1667,1925,1551,1665,1923,1666,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1666,1992,1992,1992,1992,2000,2000,2000,1992,1992,1667,1925,1486,1488,1551,1488,1614,1488,1550,1550,1424,1551,1614,1614,1422,1487,1423,1550,1552,1615,1616,1551,1422,1488,1551,1616,1488,1552,1488,1424,1614,1550,1614,1552,1552,1551,1616,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,1992,1992,1992,1925,519,715,715,715,715,583,583,583,519,584,1605,1605,1605,1605,1413,1606,1414,1478,1414,1413,1542,1414,1605,1542,1605,1985,1861,1927,1478,1605,2684355144,2684355079,2684355016,2684355015,2684355080,1793,1992,1992,1992,1992,1992,1669,1927,2684355143,2684355016,2684355143,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,391,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,455,392,1605,1481,1473,1410,1539,1410,1419,1605,455,1605,1605,1605,1605,456,1605,1605,1542,1541,1551,1486,1551,1486,1614,1616,1422,1551,1552,1552,1488,1616,1552,1423,1551,1552,1552,1486,1614,1550,1551,1422,1487,1552,1552,1985,1729,1667,1797,1797,1666,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1667,1797,1797,1797,1797,1925,1486,1423,1487,1423,1422,1552,1487,1616,1486,1422,1487,1552,1551,1550,1552,1487,1423,1487,1551,1422,1550,1422,1616,1487,1486,1551,1422,1616,1304,1424,1422,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,1992,1857,584,519,520,583,584,584,520,584,584,455,1605,1605,1606,1413,1541,1477,1542,1606,1478,1478,1414,1605,1413,1413,1413,1605,1605,1605,1605,1605,2684355016,2684355079,2684354951,2684355015,1923,1666,1992,1992,1992,1992,1669,1927,520,2684355079,2684355143,2684355016,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1545,1546,1546,1484,1473,1409,1419,392,392,1605,1605,1605,456,1614,1542,1606,1542,1606,1541,1542,1423,1488,1422,1487,1488,1551,1615,1615,1614,1552,1615,1614,1486,1424,1422,1615,1486,1550,1424,1424,1616,1551,1486,1985,1729,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1857,1552,1616,1616,1487,1423,1486,1991,1422,1422,1615,1552,1552,1423,1615,1551,1488,1551,1488,1487,1614,1550,1424,1614,1487,1487,1423,1424,1552,1431,1487,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,1992,1667,1925,584,520,519,584,520,519,456,1605,1605,1478,1477,1606,1605,1923,1797,1925,1478,1605,1606,1605,1478,1541,1477,1605,1605,1605,1605,1605,1605,2684354952,2684355015,2684355080,2684355080,1793,1992,1992,1992,1992,1669,1927,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,584,517,650,392,455,391,392,1605,1481,1538,1410,1476,391,391,1605,1605,1605,455,1478,1614,1541,1542,1478,1606,1478,1551,1423,1487,1488,1615,1488,1552,1488,1423,1486,1487,1552,1550,1550,1486,1424,1615,1550,1551,1422,1486,1423,1615,1422,1985,1729,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1925,1422,1614,1486,1615,1423,1616,1423,1551,1615,1423,1423,1486,1552,1614,1550,1615,1552,1614,1424,1486,1422,1432,1423,1552,1614,1368,1367,1423,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1857,391,520,520,584,1605,1605,1605,1605,1478,1605,1414,1923,1797,1666,1992,1667,1797,1925,1605,1477,1605,1605,1605,1605,1606,1605,1605,1605,1605,2684355015,2684355015,2684355016,1923,1666,1992,1992,1992,1669,1927,455,1605,1605,1605,1605,1605,1605,1605,1605,1605,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,584,520,584,1605,1605,1605,455,391,1545,1540,1474,1540,1483,455,456,1605,1605,1605,1542,1541,1542,1614,1542,1486,1486,1486,1614,1422,1486,1486,1550,1487,1551,1486,1551,1552,715,715,715,715,715,715,1616,1552,1552,1552,1486,1551,1424,1424,1985,1729,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1614,1616,1552,1423,1923,1797,1797,1797,1797,1797,1925,1422,1615,1486,1422,1423,1552,1486,1614,1551,1616,1303,1367,1303,1423,1476,1424,1423,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1857,456,1605,1605,1605,1605,1605,1605,1606,1541,1923,1797,1666,1992,1992,1992,1992,1992,1857,1605,1605,1413,1605,1605,1991,1477,1478,1605,1605,1605,1605,1541,1605,1793,1992,1992,1992,1669,1927,520,517,2684354951,2684355079,2684355144,2684355080,1605,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,520,392,583,649,519,520,650,520,392,519,517,584,1605,1605,1605,392,391,455,1481,1411,1412,1483,391,455,1605,1605,1605,1542,1606,1541,1606,1541,1422,1616,1423,1486,1422,1615,1552,1614,1614,1424,1614,1488,1551,715,715,715,715,715,715,1616,1422,1424,1488,1486,1552,1488,1422,1552,1985,1729,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1857,1551,1616,1486,1487,1793,1992,1992,1992,1992,1992,1667,1797,1925,1424,1486,1424,1552,1488,1550,1550,1486,1495,1303,1367,1602,1538,1304,1486,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1857,392,455,391,1605,1605,1605,1605,1413,1923,1666,1992,1992,1992,1992,1992,1992,1992,1857,1606,1478,1541,1605,1605,1413,1478,1477,1414,1605,1605,1541,1541,1923,1666,1992,1992,1992,1857,517,520,519,2684355143,2684355080,2684355143,2684355016,1605,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,649,517,714,650,455,455,714,1615,1552,1616,1552,2684355341,2684355341,2684355341,2684355341,2684355341,1605,455,1481,1474,1540,1483,392,455,1605,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1615,1488,1487,1552,1422,1423,1424,715,715,715,715,715,715,715,715,583,715,715,715,1487,1551,1550,1487,1422,1550,1424,1487,1424,1551,1793,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1550,1486,1422,1423,1793,1992,1992,1992,1992,1992,1992,1992,1857,1551,1616,1614,1486,1616,1486,1551,1422,1367,1538,1538,1431,1495,1424,1487,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1857,392,391,455,1605,1605,1605,1605,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1857,1414,1413,1413,1605,1605,1605,1605,1541,1477,1477,1477,1542,1542,1793,1992,1992,1992,1669,1927,1605,1605,2684355143,1605,2684355015,2684354952,2684355016,2684355144,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1359,1359,1360,1360,1359,1358,1359,1361,1358,1358,1358,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,520,650,517,583,520,1559,455,1615,1487,1422,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,392,1481,1411,1540,1476,391,392,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1616,1423,1551,1488,1551,1616,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,1424,1422,1551,1487,1423,1616,1488,1793,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1729,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1423,1486,1488,1486,1793,1992,1992,1992,1992,1992,1669,1861,1927,1552,1551,1423,1615,1550,1488,1551,1552,1423,1495,1304,1431,1432,1424,1615,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1667,1925,456,455,1605,1605,1605,1605,1985,1729,1992,1992,1992,1992,1992,1992,1669,1861,1927,1477,1413,1605,1605,1605,1605,1605,1605,1542,1605,1605,1413,1477,1793,1992,1992,1992,1857,2684355080,1605,1605,2684354952,2684355080,2684355143,2684355143,2684354952,2684355015,1359,1358,1358,1359,1361,1360,1615,1550,1552,1424,1550,1614,1552,1424,1423,1614,1486,1361,1361,1360,1360,1361,1360,1361,1358,1358,1360,649,519,714,584,520,1559,392,1422,1423,1487,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1605,1481,1601,1412,1412,1483,392,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1614,1550,1488,1422,1488,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,1488,1615,1542,1552,1616,1615,1423,1985,1729,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1423,1424,1616,1551,1422,1551,1488,1616,1487,1488,1486,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,1992,1992,1992,1667,1925,1552,1616,1424,1985,1729,1992,1992,1992,1992,1857,1486,1552,1614,1551,1422,1304,1432,1614,1550,1304,1432,1615,1304,1368,1368,1616,1424,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1857,392,391,392,1605,1605,1605,1478,1985,1729,1992,1992,1992,1992,1669,1927,1541,1605,1413,1414,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1923,1666,1992,1992,1669,1927,2684355015,2684355079,2684355144,1605,2684354952,1550,1615,1488,1487,1550,1551,1423,1614,1616,1486,1423,1423,1551,1615,1423,1552,1550,1424,1551,1424,1551,1424,1486,1615,1616,1552,1614,1551,1424,1551,1552,1552,584,650,520,520,455,455,1423,1551,1614,1552,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1552,1481,1601,1412,1409,1483,1550,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1614,1551,1422,1488,715,715,715,715,715,715,715,715,583,584,520,715,715,715,715,715,715,715,1551,1606,1616,1550,1614,1550,1552,1423,1793,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1410,1603,1474,1992,1992,1992,1858,1550,1424,1615,1424,1615,1616,1423,1550,1551,1615,1487,1985,1729,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1667,1925,1424,1615,1552,1793,1992,1992,1992,1992,1857,1614,1488,1552,1550,1487,1538,1495,1602,1602,1495,1495,1304,1367,1495,1431,1616,1495,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1857,455,456,392,1605,1605,1605,1541,1542,1985,1861,1861,1861,1861,1927,1414,1541,1606,1605,1605,1605,1605,1542,1606,1605,1605,1605,1605,1413,1542,1793,1992,1992,1992,1857,2684355143,2684354952,2684354952,2684355144,2684355015,2684355144,1550,1614,1487,1487,1486,1550,1487,1551,1615,1424,1616,1422,1487,1424,1614,1551,1615,1552,1551,1552,1614,1422,1423,1422,1552,1487,1552,1614,1552,1552,1616,1615,455,584,714,519,517,455,1424,1488,1422,1424,1423,1423,1423,1424,1423,1488,1550,1481,1601,1601,1601,1483,1551,1423,1552,1552,1488,1488,1486,1550,1550,1551,1616,1422,1552,715,715,715,715,715,584,715,519,583,715,715,715,715,715,584,715,715,715,1552,1423,1542,1616,1422,1486,1551,1551,1793,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1411,1601,1411,1473,1475,1601,1410,1539,1992,1488,1615,1424,1550,1486,1552,1616,1614,1551,1552,1487,1552,1985,1861,1729,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1992,1992,1667,1925,1551,1616,1985,1861,1861,1861,1861,1927,1551,1424,1486,1422,1424,1422,1476,1495,1495,1495,1476,1476,1303,1422,1602,1495,1538,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1667,1925,392,392,1605,1605,1605,1414,1542,1477,1413,1606,1478,1606,1413,1478,1477,1605,1605,1605,391,1606,1541,1542,1541,1605,1605,1477,1413,1478,1793,1992,1992,1992,1857,2684355016,2684354951,2684355015,2684355016,2684355080,2684354951,1422,1615,1423,1488,1422,1422,1550,1424,1550,1486,1424,1551,1551,1551,1487,1551,1488,1422,1615,1550,1551,1423,1615,1614,1616,1488,1488,1616,1423,1550,1488,1422,517,455,392,455,583,392,1422,1488,1616,1487,1487,1551,1424,1487,1424,1616,1550,1481,1601,1601,1410,1483,1422,1551,1486,1486,1615,1616,1552,1614,1488,1615,1615,1488,1614,715,715,715,715,715,583,715,715,715,715,715,715,715,715,715,715,715,715,1423,1487,1615,1550,1551,1423,1423,1422,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1540,1540,1475,1603,1601,1411,1475,1604,1615,1615,1422,1614,1423,1616,1487,1486,1422,1552,1486,1487,1616,1423,1423,1486,1488,1616,1550,1793,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1667,1925,1551,1550,1615,1550,1551,1550,1488,1551,1551,1550,1488,1615,1488,1495,1495,1432,1616,1552,1304,1368,1476,1368,1303,1432,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1857,391,455,1605,1605,1605,1605,1478,1605,1605,1413,1477,1606,1413,1413,1413,1478,1477,1414,456,1541,1606,1606,1605,1605,1605,1413,1542,1923,1666,1992,1992,1992,1857,2684355143,2684355144,2684355144,2684355079,2684355015,2684355079,2684355144,2684355143,1486,1488,1615,1422,1615,1614,1551,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1615,1550,1422,1616,2684355341,2684355341,2684355341,517,584,714,1624,711,583,455,1486,1614,1486,1424,1614,1550,1552,1487,1616,1486,1487,1481,1601,1601,1410,1483,1486,1422,1552,1552,1486,1487,1614,1488,1486,1424,1424,1552,1615,715,715,715,715,715,519,715,715,715,715,715,520,715,715,715,715,715,715,1487,1616,1542,1551,1423,1552,1616,1422,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1412,1603,1474,1538,1474,1604,1410,1540,1412,1476,1412,1615,1486,1615,1550,1486,1487,1551,1614,1488,1616,1486,1551,1422,1614,1615,1423,1614,1487,1551,1793,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1667,1925,1616,1424,1551,1616,1487,1615,1487,1424,1616,1422,1552,1614,1488,1303,1495,1495,1602,1431,1538,1495,1431,1422,1368,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1925,391,391,455,1605,1605,1605,1605,1605,1605,1605,1605,1542,1541,1605,1413,1413,392,455,1477,1478,1605,1605,1605,1478,1605,1606,1793,1992,1992,1992,1992,1857,2684355143,2684355016,2684355143,1605,2684355015,2684355079,2684355143,2684355080,1550,1615,1488,1424,1551,1424,983,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,983,1487,1424,1423,2684355341,2684355341,2684355341,520,583,584,711,649,714,1623,1486,1550,1422,1550,1550,1615,1488,1616,1615,1422,1550,1481,1601,1474,1411,1483,1424,1423,1552,1615,1423,1486,1614,1486,1488,1422,1552,1551,1486,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,715,1422,1550,1488,1487,1615,1487,1616,1488,1615,1616,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1409,1474,1601,1411,1602,1602,1473,1411,1604,1603,1604,1604,1412,1537,1602,1486,1486,1614,1422,1615,1423,1615,1552,1614,1422,1616,1614,1423,1486,1424,1552,1488,1422,1423,1793,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1667,1797,1925,1551,1424,1552,1551,1552,1488,1486,1615,1487,1488,1423,1488,1495,1422,1422,1368,1538,1422,1431,1495,1486,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1925,392,391,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1605,1414,456,1991,391,392,391,1605,1605,1606,1605,1541,1605,1793,1992,1992,1992,1669,1927,2684355144,1605,1605,2684355341,2684355341,2684355341,2684355341,2684355341,1616,1424,1424,1487,1487,1615,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,1487,1616,1615,2684355341,2684355341,2684355341,519,455,584,1560,517,583,455,1424,1424,1486,1423,1422,1614,1615,1422,1486,1551,1487,1481,1601,1473,1474,1483,1488,1615,1422,1424,1422,1423,1424,1422,1550,1486,1616,1551,1422,1486,1423,1423,715,715,715,715,715,520,584,715,715,715,715,715,715,1552,1423,1487,1615,1488,1616,1488,1424,1615,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1601,1604,1409,1538,1537,1411,1410,1603,1476,1602,1412,1604,1537,1410,1422,1486,1423,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1424,1616,1552,1486,1616,1793,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1925,1550,1614,1614,1614,1615,1423,1615,1486,1424,1476,1614,1614,1614,1614,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1857,456,456,1605,1605,1605,1605,1605,1605,1605,1605,1605,1542,1413,1477,456,392,391,392,1477,1605,1605,1605,1414,1606,1478,1793,1992,1992,1992,1857,2684354951,2684354951,1605,2684355016,2684355341,2684355341,2684355341,2684355341,2684355341,1488,1551,1422,1422,1487,1424,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,1487,1488,1423,2684355341,2684355341,2684355341,584,520,583,520,650,1559,1624,1487,1552,1551,1552,1424,1616,1488,1424,1616,1615,1550,1481,1539,1538,1411,1483,1614,1486,1615,1423,1488,1552,1614,1424,1616,1616,1614,1550,1424,1488,1424,1424,1550,1616,715,715,715,715,519,715,583,715,715,715,715,1550,1550,1616,1423,1424,1424,1424,1616,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1537,1601,1476,1412,1474,1410,1537,1604,1475,1410,1411,1602,1602,1412,1551,1550,1424,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1486,1423,1487,1423,1487,1793,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1925,1552,1614,1615,1615,1614,1552,1486,328,263,1614,1614,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1925,391,1605,1605,1605,1605,1605,1605,1605,1605,1605,1478,1477,456,392,391,392,1414,1541,1605,1605,1605,1541,1478,1923,1666,1992,1992,1992,1857,2684355016,2684355079,2684355143,2684355015,2684355341,2684355341,2684355341,2684355341,2684355341,1616,1615,1550,1551,1616,1486,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,1487,1486,1551,2684355341,2684355341,2684355341,517,1560,1624,649,517,520,519,1486,1423,1615,1615,1615,1615,1488,1422,1615,1422,1488,1481,1411,1539,1601,1483,1552,1422,1614,1552,1488,1488,1551,1616,1614,1615,1551,1616,1616,1424,1422,1424,1551,1615,715,715,715,715,715,715,715,715,715,1614,1486,1552,1486,1487,1488,1488,1422,1615,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1604,1604,1604,1473,1602,1473,1409,1538,1410,1603,1537,1538,1537,1604,1550,1486,1616,1550,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1486,1486,1423,1550,1614,1487,1793,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1487,1424,1488,1614,1488,1552,328,263,1614,1614,1614,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,391,1605,1605,1605,1605,1605,1605,1605,1605,1605,1413,391,391,391,391,1605,1605,1542,1605,1605,1605,1478,1478,1793,1992,1992,1992,1992,1857,2684355079,2684355143,2684354952,2684355016,2684355341,2684355341,2684355341,2684355341,2684355341,1488,1486,1488,1424,1424,1422,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,1616,1487,1552,2684355341,2684355341,2684355341,520,1559,455,1615,1424,1422,1486,1616,1424,1614,1550,1486,1423,1423,1424,1616,1616,1423,1481,1601,1412,1538,1483,1424,1616,1423,1486,1614,1550,1550,1422,1422,1486,1550,1550,1486,1550,1614,1486,1486,1551,715,715,715,715,715,715,715,715,715,1424,1422,1486,1615,1422,1423,1614,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1409,1475,1601,1473,1540,1540,1473,1411,1411,1410,1601,1409,1410,1603,1487,1614,1552,1552,1488,1615,1614,1614,1614,1614,1614,1614,1614,1614,1614,1422,1552,1614,1615,1616,1615,1793,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1667,1925,1423,1424,1550,1488,1424,263,327,1614,1486,1614,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,455,455,1605,1605,1605,1605,1605,1605,1605,1605,392,391,1550,391,456,1606,1414,1605,1605,1605,1605,1605,1606,1793,1992,1992,1992,1992,1857,2684355079,2684355015,2684355144,2684355079,2684355341,2684355341,2684355341,2684355341,2684355341,1488,1551,1616,1550,1486,1422,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,983,1486,1486,1616,2684355341,2684355341,2684355341,649,455,714,1423,1424,1551,1487,1616,1487,1423,1487,1488,1614,1422,1614,1422,1550,1486,1481,1411,1538,1475,1483,1615,1550,1615,1488,1614,1550,1614,1422,1486,1614,1614,1486,1550,1486,1550,1550,1422,1487,1616,1424,1422,1488,1488,1422,1487,1422,1423,1486,1487,1550,1614,1552,1616,1614,1614,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1411,1603,1540,1538,1411,1602,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1604,1539,1410,1410,1537,1476,1601,1411,1474,1473,1603,1551,1487,1551,1614,1616,1614,1615,1614,1615,1551,1616,1486,1616,1423,1423,1422,1488,1616,1488,1552,1424,1550,1793,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,1552,1550,1423,1422,1552,264,327,1488,1422,1488,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,392,392,1605,1605,1605,1605,1605,1605,1605,391,1605,1486,1550,392,392,1542,1478,1605,1605,1605,1605,1605,1414,1793,1992,1992,1992,1992,1857,2684354952,2684355016,2684354952,2684354952,2684355341,2684355341,2684355341,2684355341,2684355341,1487,1616,1487,1424,1616,1551,1614,1423,1616,1552,1487,983,983,1552,1487,983,983,983,983,983,983,983,983,1486,1423,1422,2684355341,2684355341,2684355341,520,1623,520,1488,1551,1616,1614,1488,1423,1550,1552,1614,1486,1423,1488,1486,1551,1550,1481,1411,1411,1475,1483,1488,1424,1486,1552,1422,1422,1550,1614,1923,1797,1925,1614,1614,1614,1991,1614,1614,1614,1550,1486,1423,1423,1551,1422,1552,1616,1614,1551,1552,1550,1550,1423,1552,1614,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1409,1473,1601,1537,1603,1475,1474,1410,1604,1602,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1476,1604,1602,1474,1538,1411,1410,1475,1601,1409,1488,1486,1488,1616,1422,1614,1614,1424,1552,1488,1616,1550,1422,1616,1488,1422,1423,1550,1487,1422,1552,1488,1793,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,1422,1487,1552,1615,327,328,263,1616,1422,1486,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,456,456,1413,1605,1605,1605,1605,1605,1605,455,1605,1487,1551,391,456,455,1605,1605,1605,1478,1606,1413,1542,1793,1992,1992,1992,1992,1857,2684355080,1605,2684354951,2684355143,2684355341,2684355341,2684355341,2684355341,2684355341,1552,1488,1487,1552,1422,1487,1550,1616,1486,1424,1552,983,983,1422,1550,983,983,983,983,983,983,983,983,1614,1614,1550,2684355341,2684355341,2684355341,1422,1424,1616,1488,1615,1615,1616,1615,1552,1423,1486,1423,1615,1615,1550,1550,1487,1616,1481,1476,1540,1538,1483,1551,1423,1488,1550,1614,1550,1614,1614,1793,1669,1927,1614,1614,1614,1614,1614,1614,1614,1614,1422,1987,1614,1487,1615,1614,1616,1488,1614,1615,1486,1550,1616,1422,1923,1666,1992,1992,1992,1992,1992,1992,1475,1412,1473,1539,1474,1476,1409,1601,1603,1601,1602,1411,1476,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1604,1473,1412,1412,1601,1411,1601,1473,1422,1424,1551,1552,1550,1424,1615,1550,1551,1550,1422,1614,1551,1550,1488,1550,1487,1551,1487,1616,1486,1551,1793,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,1615,1487,1488,263,328,328,328,1551,1616,1487,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,456,455,1606,1606,1542,1605,1605,1605,1605,392,1605,1551,1486,455,456,455,1605,1605,1605,1605,1606,1414,1478,1793,1992,1992,1992,1992,1857,583,649,584,714,2684355341,2684355341,2684355341,2684355341,2684355341,1487,1424,1616,1614,1424,1615,1423,1616,1615,1614,1550,983,983,1551,1486,983,983,983,983,983,983,983,983,1487,1614,1552,2684355341,2684355341,2684355341,1550,1616,1614,1615,1551,1424,1487,1616,1551,1422,1552,1488,1488,1486,1488,1552,1423,1552,1481,1473,1538,1473,1483,1616,1551,1616,1616,1615,1422,1488,1614,1985,1927,1614,1550,1614,1614,1614,1614,1614,1550,1614,1614,1794,1925,1614,1487,1422,1488,1552,1552,1486,1487,1615,1488,1604,1793,1992,1992,1992,1992,1992,1992,1603,1476,1537,1410,1539,1411,1409,1537,1602,1474,1604,1603,1409,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1601,1475,1604,1538,1601,1410,1474,1551,1486,1423,1616,1486,1486,1615,1550,1615,1488,1550,1422,1423,1423,1487,1614,1487,1423,1423,1614,1615,1487,1793,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1667,1925,1488,1423,1616,264,264,264,1615,1422,1486,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,456,391,456,1541,1605,1605,1605,1605,1605,455,1424,1616,1616,1615,391,392,1477,1605,1605,1605,1605,1413,1923,1666,1992,1992,1992,1992,1857,392,517,649,519,2684355341,2684355341,2684355341,2684355341,2684355341,1614,1424,961,962,963,964,965,966,967,1487,1551,1616,1486,1551,1551,983,983,983,983,983,983,983,983,1614,1488,1615,2684355341,2684355341,2684355341,1422,1550,1422,1615,1551,1552,1550,1488,1551,1551,1552,1487,1615,1487,1616,1551,1552,1422,1481,1601,1411,1409,1483,1552,1486,1550,1488,1550,1423,1615,1423,1614,1614,1614,1614,1614,1923,1797,1925,1614,1614,1614,1614,1985,1927,1614,1552,1423,1424,1488,1550,1614,1606,264,1538,1412,1793,1992,1992,1992,1992,1992,1410,1537,1603,1474,1476,1540,1412,1409,1474,1602,1540,1409,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1537,1602,1409,1538,1411,1474,1615,1552,1422,1486,1615,1424,1422,1487,1616,1552,1614,1550,1552,1552,1614,1422,1615,1424,1616,1486,1422,1550,1793,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,1487,1615,1423,328,328,264,1551,1488,1422,1614,1614,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,391,456,455,1414,1542,1541,1542,1605,1605,392,1616,1487,1486,392,455,1605,1478,1605,1605,1605,1605,1477,1793,1992,1992,1992,1992,1669,1927,517,519,520,392,2684355341,2684355341,2684355341,2684355341,2684355341,1615,1488,1025,1026,1027,1028,1029,1030,1031,1615,1422,1488,1422,1423,1552,983,983,983,983,983,983,983,983,1615,1487,1615,2684355341,2684355341,2684355341,1551,1550,1616,1552,1552,1616,1486,1486,1552,1487,1486,1423,1487,1552,1422,1616,1550,1551,1481,1601,1474,1476,1483,1423,1550,1424,1616,1487,1486,1616,1552,1424,1614,1614,1614,1923,1666,1992,1667,1797,1925,1614,1614,1614,1614,1614,1424,1551,1616,1424,1616,1423,1542,1538,327,1475,1793,1992,1992,1992,1992,1992,1475,1602,1474,1539,1474,1410,1538,1473,1601,1475,1473,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1411,1537,1475,1475,1423,1615,1551,1423,1424,1551,1614,1616,1615,1365,1365,1365,1487,1550,1551,1923,1992,1992,1992,1992,1992,1992,1666,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,1614,1424,1615,264,328,263,1422,1551,1486,1361,1361,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,391,391,456,1413,1413,1542,1605,1605,1605,391,391,1552,1486,392,391,1606,1477,1605,1605,1605,1605,1477,1793,1992,1992,1992,1992,1857,649,584,519,392,517,2684355341,2684355341,2684355341,2684355341,2684355341,1424,1550,1089,1090,1091,1092,1093,1094,1095,1422,1550,1424,1551,1422,1551,983,983,983,983,983,983,983,983,1423,1616,1616,2684355341,2684355341,2684355341,1615,1614,1488,1550,1550,1552,983,983,983,983,983,983,983,1486,1552,1550,1615,1552,1420,1540,1540,1601,1483,1616,1487,1424,1422,1615,1614,1552,1423,1614,1614,1923,1797,1666,1992,1992,1992,1992,1667,1797,1925,1614,1614,1614,1550,1616,1552,1424,1616,1616,1615,1616,327,1474,1793,1992,1992,1992,1992,1992,1602,1476,1604,1409,1411,1604,1538,1540,1409,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1602,1473,1552,1550,1550,1551,1488,1365,1365,1365,1365,1365,1365,1992,1797,1992,1992,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1857,1424,1424,1488,1488,328,1615,1424,1616,1551,1551,1615,1614,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,455,455,1605,1541,1606,1605,1605,1605,455,392,455,1423,1551,455,391,1606,1605,1605,1605,1605,1605,1606,1793,1992,1992,1992,1992,1857,455,519,650,517,392,2684355341,2684355341,2684355341,2684355341,2684355341,1616,1486,1153,1154,1155,1156,1157,1158,1159,1551,1552,1551,1424,1487,1487,983,983,983,983,983,983,983,983,1614,1614,1488,2684355341,2684355341,2684355341,1365,1365,1365,1551,1424,1614,983,983,983,983,983,983,983,1486,1424,1614,1422,1551,1481,1540,1476,1601,1483,1488,1551,1550,1488,1486,1487,1488,1616,1615,1614,1793,1992,1992,1992,1992,1992,1992,1992,1669,1927,1614,1422,1614,1616,1614,1422,1424,1424,1550,264,263,328,1473,1793,1992,1992,1992,1992,1992,1411,1539,1604,1540,1476,1537,1602,1474,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1616,1552,1488,1551,1423,1365,1365,1365,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1486,1486,1551,1552,327,1551,1488,1551,1422,1552,1616,1361,1361,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,455,1605,1605,1605,1605,1605,1605,1605,456,391,1616,1423,1423,392,1477,1414,1605,1605,1605,1605,1605,1477,1793,1992,1992,1992,1992,1857,455,517,584,520,455,2684355341,2684355341,2684355341,2684355341,2684355341,1486,1424,1217,1218,1219,1220,1221,1222,1223,1488,1551,1616,1423,1551,1550,1486,1614,1424,1487,1488,1352,1550,1615,1616,1487,1616,2684355341,2684355341,2684355341,1616,1422,1487,1615,1486,1424,983,983,983,983,983,983,983,1616,1422,1424,1538,389,1539,1473,1474,1475,1483,1615,1423,1615,1615,1552,1550,1551,1616,1424,1614,1985,1729,1992,1992,1992,1992,1992,1669,1927,1614,1614,1614,1551,1423,1488,1487,1616,1551,389,264,1476,1538,1614,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1424,1423,1486,1615,1551,1615,1424,1615,1551,1422,1615,1793,1992,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1927,455,1605,1605,1605,1605,1605,1605,1605,455,391,1614,1551,1551,391,1606,1605,1605,1605,1605,1605,1542,1414,1793,1992,1992,1992,1992,1857,584,1559,711,1623,1624,650,2684355341,2684355341,2684355341,2684355341,1616,1423,1281,1282,1283,1284,1285,1286,1287,1487,1422,1488,1423,1486,1616,1488,1422,1614,1487,1614,1487,1614,1488,1552,1488,1488,2684355341,2684355341,2684355341,1487,1422,1424,1487,1486,1552,983,983,983,983,983,983,983,1552,1488,1550,389,264,1474,1539,1409,1537,1483,1550,1550,1616,1488,1616,1486,1487,1550,1488,1614,1486,1985,1861,1729,1992,1992,1669,1927,1614,1614,1422,1550,1615,1424,1486,1550,1923,1925,1538,389,1475,1923,1797,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1423,1422,1614,1423,1423,1486,1551,1424,1615,1552,1488,1793,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,392,456,1605,1605,1605,1605,1605,1605,1605,392,1486,1423,1422,1550,392,1478,1605,1605,1605,1605,1605,1542,1606,1793,1992,1992,1992,1992,1857,392,583,517,519,519,392,2684355341,2684355341,2684355341,2684355341,1550,1552,1345,1346,1347,1348,1349,1350,1351,1422,1551,1486,1551,1614,1615,1422,1488,1616,1551,1614,1616,1550,1614,1424,1424,1614,2684355341,2684355341,2684355341,1487,1552,1550,1422,1424,1424,983,983,983,983,983,983,983,1486,1487,263,327,1476,1476,1412,1411,1601,1483,1422,1614,1487,1488,1422,1550,1615,1486,1615,1486,1550,1614,1614,1985,1861,1861,1927,1614,1614,1991,1614,1550,1550,1551,1550,1422,1795,1927,1538,1604,1923,1666,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1487,1552,1551,1423,1616,1616,1614,1422,1487,1550,1550,1793,1992,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,391,455,1605,1605,1605,1605,391,391,392,455,1488,1614,1552,1486,391,1542,1542,1605,1605,1605,1605,1542,1923,1666,1992,1992,1992,1669,1927,1552,1423,1552,1552,1423,1365,2684355341,2684355341,2684355341,2684355341,1614,1615,1486,1424,1486,1615,1614,1488,1615,1551,1422,1486,1551,1488,1551,1422,1615,1615,1422,1488,1422,1487,1614,1487,1550,1615,2684355341,2684355341,2684355341,1486,1422,1488,1551,1422,1616,983,983,983,983,983,983,983,1615,327,389,1475,1476,1476,1412,1540,1601,1547,1614,1488,1422,1487,1422,1488,1552,1616,1552,1550,1924,1990,1550,1614,1614,1614,1614,1614,1614,1614,1614,1487,1424,1488,1487,1487,1989,328,1604,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1927,1424,1616,1615,1550,1487,1422,1488,1487,1423,1486,1488,1985,1729,1992,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,456,1605,1605,1605,1541,456,392,456,455,455,1488,1488,1488,1487,456,1605,1542,1477,1478,1605,1413,1478,1793,1992,1992,1992,1992,1857,1487,1424,1551,1487,1552,1486,1550,2684355341,2684355341,2684355341,2684355341,1424,1552,1487,1486,1486,1551,1423,1552,327,328,1488,1550,1487,1422,1552,1424,1552,1614,1487,1487,1422,1486,1424,1488,1488,2684355341,2684355341,2684355341,2684355341,1550,1551,1423,1487,1552,1551,1551,1616,1552,983,983,1551,1486,1614,263,1474,1476,1411,1476,1476,1473,389,1538,1424,1551,1423,1488,1552,1614,1423,1486,1614,1614,1989,1488,1614,1550,1550,1614,1614,1614,1614,1550,1614,1614,1550,1552,1616,327,328,1410,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1927,1551,1551,1550,1423,1424,1616,1616,1616,1616,1550,1486,1423,1486,1487,1551,1552,1616,1423,1486,1616,1616,1486,1424,1551,1614,1614,1793,1992,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,456,1605,1605,1605,1478,456,1605,392,456,392,1552,1488,1552,1552,391,456,456,1478,1606,1541,1542,455,1793,1992,1992,1992,1992,1857,1614,1424,1552,1552,1550,1424,1488,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1487,1423,1552,1551,328,328,1486,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1422,1552,1551,1423,1422,1552,1550,1486,327,983,983,389,327,263,327,1476,1538,1411,1537,1540,327,328,264,1614,1550,1614,1552,1550,1614,1550,1424,1550,1486,1550,1486,1550,1486,1423,1614,1422,1550,1614,1550,1422,1486,1552,1488,389,263,1539,1540,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1412,1474,1539,1538,1412,1475,1473,1410,1537,1476,1409,1601,1411,1540,1603,1475,1601,1539,1992,1992,1992,1669,1927,1550,1423,1614,1614,1614,1551,1614,1614,1614,1424,1424,1550,1615,1615,1552,1550,1488,1551,1550,1422,1487,1422,1486,1551,1550,1616,1423,1793,1992,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,1605,1605,456,1413,1606,1605,1606,391,391,1552,1616,1616,1423,1551,1552,392,392,392,1541,1478,1413,455,1793,1992,1992,1992,1992,1857,1615,1550,1616,1423,1616,1424,1614,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1550,1424,1615,1551,328,1476,1615,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1615,1616,1424,1422,389,328,389,1355,1354,1356,1357,983,983,1355,1356,1357,1411,1473,1539,1410,1475,1483,263,1538,264,1615,1550,1423,1423,1422,0,0,0,0,0,0,0,1488,1552,1423,1424,1614,1614,1422,1486,1486,1422,1422,328,327,1410,1410,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1409,1537,1411,1409,1409,1475,1539,1601,1538,1410,1539,1602,1540,1601,1412,1409,1410,1475,1411,1474,1992,1992,1992,1667,1925,1614,1616,1614,1614,1614,1614,1614,1614,1614,1614,1614,1486,1423,1550,327,264,1487,1550,1616,1551,1551,1487,1551,1486,1551,1423,1551,1793,1992,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1927,1605,391,1478,1478,1478,1541,455,455,1614,1488,1488,1551,1424,1551,1616,456,456,392,1414,456,1414,456,1793,1992,1992,1992,1992,1857,1424,1487,1487,1487,1423,1550,1551,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1552,328,263,1538,1616,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1551,1486,328,327,389,1538,1538,327,1474,1475,1538,1410,1538,1540,1539,1537,1540,1409,1537,1476,1475,1537,389,1538,263,1552,1487,1488,1552,1422,0,1226,1227,1228,1227,1228,0,1486,1550,1422,1552,1614,1422,1486,1614,1614,1486,389,328,1539,328,1539,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1601,1409,1412,1538,1601,1474,1411,1602,1411,1601,1474,1602,1473,1537,1410,1537,1604,1410,1410,1602,1476,1992,1992,1992,1992,1667,1925,1614,1424,1423,1488,1486,1424,1550,1614,1615,1422,1550,1422,1551,264,328,263,263,327,1422,1552,1616,1616,1615,1424,1423,1488,1793,1992,2684355341,2684355341,2684355341,2684355341,2684355341,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1857,455,1605,455,1606,392,1477,1541,392,391,1424,1614,1486,1615,1552,1487,1486,456,455,456,455,455,392,391,1793,1992,1992,1992,1992,1857,1616,1552,1551,1486,1615,1424,1424,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1486,264,1537,1601,328,1423,1616,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1615,1488,1365,1365,263,328,328,1538,1412,1409,1474,1538,1412,1475,1538,1539,1475,1474,1540,1537,1411,1411,1537,1474,1421,263,263,263,1424,1550,1551,1422,0,1290,1291,1292,1291,1292,0,1488,1615,1423,1488,1551,1550,1551,1488,1488,1488,264,1538,328,1538,1603,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1476,1474,1538,1473,1410,1602,1473,1540,1540,1601,1601,1538,1475,1538,1540,1540,1411,1604,1473,1474,1603,1410,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1925,1551,1552,1423,1615,1615,1422,1486,1422,1423,327,327,328,328,328,1615,1488,1616,1488,1423,1487,1616,1985,1729,1992,1487,1487,2684355341,2684355341,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,456,391,456,392,456,1477,456,455,456,1424,1422,1616,1486,1551,1615,1550,1423,392,455,456,456,456,392,1793,1992,1992,1992,1992,1857,1486,1550,1488,1552,1414,1413,1422,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1616,263,1537,1537,263,1552,1423,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1487,389,263,389,1410,1409,1539,1537,1540,1538,1473,1412,1473,1409,1537,1410,1412,1475,1411,1412,1474,1409,1539,1538,1409,389,328,328,1614,1552,0,0,0,1354,1355,1356,1355,1356,0,1487,1422,1422,1551,1486,1423,1614,1550,1552,1614,263,263,389,1411,1539,1992,1992,1992,1992,918,920,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1540,1412,1475,1475,1476,1409,1537,1538,1604,1537,1474,1473,1412,1412,1537,1601,1992,1992,1412,1603,1537,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1925,1616,1614,1486,1422,1614,264,263,263,328,1424,1551,1424,1423,1422,1422,1487,1793,1992,1550,1486,2684355341,2684355341,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1927,455,392,391,456,391,455,456,455,455,1424,1486,1487,1616,1614,1615,1552,1487,1616,1615,1614,1424,1487,1923,1666,1992,1992,1992,1992,1857,1487,1614,1413,1477,1541,1414,1478,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,2684355341,1423,264,1411,1538,1603,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,328,1474,1409,1475,1539,1412,1540,1476,1474,1475,1537,1410,1410,1412,1410,1482,1410,1474,1476,1412,1474,1410,1411,1409,263,1538,1615,1422,0,1290,1292,983,983,983,983,983,0,1488,1614,1550,1424,1424,1486,1552,1488,1487,1616,263,1538,1538,1538,1540,1992,1992,1992,1992,982,984,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1474,1601,1409,1476,1410,1476,1474,1475,1474,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,1552,1488,1486,1615,1615,1486,1551,327,263,1423,1615,1488,1423,1423,1550,1486,1985,1992,1992,1424,2684355341,2684355341,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,392,455,392,455,391,392,455,391,455,1488,1615,1552,1552,1614,1487,1423,1551,1616,1486,1551,1616,1488,1616,1793,1992,1992,1992,1992,1992,1857,1552,1478,1477,1542,1542,1542,1606,1478,1542,1542,1414,1606,1542,1478,1606,1413,1478,1477,456,392,1415,391,1413,1605,1413,1477,1541,1414,1478,1605,1605,1413,1542,1413,1542,1616,264,1538,263,1539,1410,1410,1539,1409,1410,1473,1410,1474,1412,1412,1539,1539,1537,1410,1539,1473,1476,1475,1409,1410,1474,1409,1538,1614,1614,1615,0,1354,1356,983,983,983,983,983,0,1615,1424,1422,1424,1422,1616,1488,1424,1550,1614,264,264,264,1601,919,919,919,919,919,983,984,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1538,1537,1412,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1488,1551,1616,1424,1551,1552,1486,1550,1424,1616,327,1423,327,1550,1422,1422,1488,1422,1614,1793,1992,1424,2684355341,2684355341,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,456,1605,456,455,392,456,1605,455,391,1616,1552,1616,1423,1488,1486,1616,1615,1423,1486,1422,1487,1550,1616,1793,1992,1992,1992,1992,1992,1857,1615,1413,1605,1477,1605,1478,1478,1365,1365,1365,1365,1365,1365,1365,1365,1365,1365,1413,1415,392,392,456,1542,1541,1605,1542,1606,1478,1414,1606,1541,1542,1477,1542,1413,1551,1410,1473,1410,1474,1409,1410,1412,1409,1473,1410,1537,1539,1537,1537,1410,1539,1537,1539,1537,1410,1412,1411,1412,1410,1538,328,327,1538,327,263,983,983,983,983,983,983,983,983,0,1486,1615,1614,1616,1550,1487,1487,1551,1424,264,389,263,1410,1475,983,1047,1047,1047,1047,1047,1048,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1552,1615,1615,1550,1614,1424,1551,1550,1551,1424,1488,1487,327,327,1487,1424,1424,1488,1486,1550,1793,1992,1424,2684355341,2684355341,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,391,1605,1605,1605,456,391,455,455,1551,1615,1616,1551,1550,1614,1422,1422,1488,1486,1424,1614,1616,1552,1551,1793,1992,1992,1669,1861,1861,1858,1552,1606,1542,1414,1541,1477,1541,1541,1542,1414,1477,1606,1477,1606,1477,1606,1413,1541,1478,1414,1410,1411,1477,1414,1414,1478,1541,1478,1414,1477,1413,1605,1542,1477,1606,1478,1409,1476,1539,1476,1412,1474,1474,1410,1412,1482,1537,1537,1539,1537,1412,1410,1473,1539,1539,1537,1410,1540,1539,1474,1409,389,389,327,1538,264,0,0,0,0,0,0,0,0,0,1488,1424,1552,1488,1486,1614,1552,1486,263,328,1538,1604,1604,1409,1412,1473,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1616,1615,1552,1615,1614,1487,1615,1551,1424,1551,1423,1486,327,263,263,1488,1488,1550,1487,1616,1423,1793,1992,1552,2684355341,2684355341,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1857,392,1605,1605,391,391,392,455,455,1615,1488,1614,1552,1488,1552,1487,1615,1487,1614,1614,1552,1487,1423,1486,1795,1861,1861,1858,1476,1412,1921,1423,1486,1606,1606,1414,1605,1413,1542,1477,1541,1478,1414,1605,1413,1477,1413,1477,1606,1414,1473,1474,1475,1413,1542,1541,1541,1477,1477,1478,1477,1606,1542,1477,1541,1477,1477,1479,1538,1539,1412,1412,1474,1539,1474,1412,1482,1539,1537,1539,1537,1475,1409,1412,1539,1482,1537,1537,1475,1473,1474,389,328,264,1487,1538,264,1227,1226,1228,1226,1227,1226,1227,1228,1229,1486,1552,1486,1616,1615,1488,327,1538,389,328,1473,1604,1537,1540,1602,1476,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1424,1552,1486,1614,1487,1615,1552,1616,1616,1487,1614,1487,263,328,264,328,1422,1486,1616,1614,1616,1615,1985,1729,1992,2684355341,2684355341,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1669,1927,1605,1605,1541,1606,391,456,392,1552,1487,1486,1552,1424,1488,1614,1486,1486,1488,1604,1476,1412,1538,1474,1550,1921,1538,1473,1921,1411,1540,1921,1409,1410,1411,1412,1409,1410,1542,1606,1605,1606,1605,1541,1414,1413,1478,1606,1414,1541,1477,1537,1538,1539,1478,1541,1541,1477,1606,1542,1542,1605,1542,1413,1605,1478,1542,1606,1541,1413,1538,1540,1538,1410,1475,1537,1482,1539,1539,1411,1539,1482,1476,1410,1412,1410,1412,1539,1537,1410,1540,1540,1538,1538,389,1486,327,328,1291,1290,1292,1290,1291,1290,1291,1292,1293,1423,1424,1486,1552,263,327,327,263,328,1474,1601,1409,1409,1474,1474,1539,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,1486,1488,1614,1424,1550,1552,1615,1486,1551,1616,1422,1488,1550,327,328,1616,1614,1424,1616,1552,1550,1552,1551,1550,1793,1992,2684355341,2684355341,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,456,1605,1605,1477,1414,391,392,1487,1616,1615,1423,1552,1423,1615,1551,1615,1537,1602,1473,1410,1603,1538,1615,1923,1859,1539,1411,1794,1797,1797,1859,1615,1423,1475,1476,1473,1474,1475,1414,1605,1541,1605,1603,1603,1477,1605,1413,1477,1478,1605,1601,1602,1603,1605,1477,1605,1414,1478,1478,1542,1413,1477,1605,1606,1413,1478,1478,1477,1479,1542,1473,1539,1476,1537,1539,1412,1475,1537,1412,1538,1538,1409,1482,1539,1412,1537,1410,1539,1409,1473,1412,389,328,328,1538,263,1550,1355,1354,1356,1354,1355,1354,1355,1356,1357,1487,1423,1538,327,389,1409,1412,1412,1538,1412,1474,1410,1474,1473,1602,1411,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,2000,1992,2000,2000,2000,2000,2000,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1857,1488,1552,1552,1616,1488,1615,1552,1550,1486,1614,1486,1552,1551,1614,263,328,1487,1551,1550,1424,1487,1614,1615,1422,1550,1615,1985,1729,1992,2684355341,2000,2000,2000,2000,1992,1992,1992,1992,1992,1669,1927,391,1605,1413,1478,456,1552,1488,1614,1487,1551,1616,1424,1487,1487,1614,1537,1539,1411,1473,1539,1473,1601,1422,1793,1667,1797,1797,1666,1992,1992,1857,1424,1552,1606,1477,1542,1414,1606,1605,1477,1605,1606,1605,1477,1477,1478,1409,1410,1411,1412,1409,1410,1411,1414,1477,1414,1542,1478,1477,1477,1541,1414,1477,1414,1541,1541,1478,1606,1414,1478,1409,1410,1473,1410,1410,1412,1539,1539,1539,1482,1539,1412,1539,1410,1539,1537,1482,1537,1473,1410,1476,1538,263,328,389,328,389,327,328,389,263,327,328,327,263,389,327,1538,264,327,1538,1604,1539,1474,1409,1539,1537,1601,1538,1473,1603,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,1488,1488,1615,1616,1614,1488,1424,1488,1550,1487,1487,1551,1615,1552,1422,1487,1550,1486,1486,1423,1488,1488,1615,1614,1614,1424,1551,1793,1992,1488,2000,2000,2000,2000,1992,1992,1992,1992,1669,1927,455,391,1542,1477,1542,456,1550,1614,1616,1616,1424,1550,1423,1486,1488,1604,1412,1602,1476,1410,1616,1488,1550,1551,1793,1992,1992,1992,1992,1992,1992,1857,1551,1614,1541,1541,1605,1606,1606,1605,1413,1605,1541,1606,1542,1413,1413,1473,1474,1475,1476,1473,1474,1475,1477,1605,1478,1542,1541,1477,1414,1606,1605,1605,1541,1478,1413,1542,1475,1538,1410,1409,1537,1412,1538,1539,1537,1412,1539,1410,1539,1412,1412,1410,1412,1537,1539,1412,1538,1411,1410,1473,1410,1410,1475,1537,264,264,327,327,264,389,327,389,328,389,327,263,328,327,328,1409,1601,1539,1540,1539,1537,1602,1476,1410,1538,1475,1793,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,1616,1486,1552,1488,1488,1424,1486,1550,1487,1424,1423,1488,1550,1423,1423,1488,1552,1487,1488,1488,1488,1616,1422,1488,1551,1616,1486,1487,1614,1793,1992,1550,2000,2000,2000,2000,1992,1992,1992,1669,1927,455,392,455,1413,1541,391,392,1486,1616,1487,1488,1423,1423,1486,1551,1423,1473,1476,1475,1615,1552,1550,1550,1550,1422,1793,1992,1992,1992,1992,1992,1992,1857,1487,1616,1488,1414,1542,1541,1542,1414,1414,1542,1541,1541,1477,1542,1542,1542,1413,1539,1540,1537,1538,1539,1540,1541,1605,1477,1541,1414,1414,1542,1605,1605,1541,1413,1541,1552,1412,1475,1474,1475,1537,1540,1539,1411,1482,1412,1539,1412,1412,1539,1412,1410,1482,1539,1482,1537,1537,1539,1412,1539,1409,1473,1539,1540,1410,1412,1473,1537,1473,1226,1224,1226,1227,1228,1224,1226,389,1537,1473,1410,1410,1539,1409,1537,1476,1409,1538,1604,1538,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1669,1861,1861,1861,1861,1927,1551,1551,1486,1422,1423,1615,1423,1615,1616,1487,1422,1488,264,328,1423,1424,1615,1551,1552,1424,1552,1487,1615,1551,1615,1423,1423,1422,1488,1424,1422,1793,1992,1551,2000,2000,2000,2000,1992,1992,1992,1857,456,455,392,456,1606,1542,391,1487,1424,1486,1488,1488,1552,1552,1616,1424,1488,1614,1424,1550,1423,1423,1614,1487,1424,1422,1793,1992,1992,2000,2000,1992,1992,1857,1551,1614,1616,1542,1414,1477,1478,1541,1478,1413,1542,1478,1541,1478,1477,1606,1542,1606,1605,1606,1602,1603,1604,1601,1413,1477,1541,1542,1605,1542,1605,1410,1411,1412,1409,1410,1476,1474,1538,1476,1476,1410,1473,1539,1539,1412,1410,1412,1539,1473,1540,1473,1539,1540,1476,1410,1539,1475,1410,328,389,1424,1423,1551,1487,1550,1537,1411,1229,1290,1288,1290,1291,1292,1288,1290,1424,1537,1409,1601,1412,1412,1537,1409,1475,1604,1540,1475,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1669,1927,1551,1552,1615,1552,1423,1551,1424,1487,1424,1424,1551,1424,1551,1424,1616,1423,328,263,327,1424,1422,1422,1552,1424,1424,1486,1615,1616,1487,1422,1550,1424,1487,1486,1615,1550,1793,1992,1551,2000,2000,2000,2000,1992,1992,1669,1927,391,391,391,1414,1605,456,392,1551,1614,1487,1551,1614,1616,1487,1616,1551,1486,1615,1486,1488,1614,1615,1551,1552,1424,1551,1793,1992,1992,2000,2000,1992,1992,1857,1550,1488,1478,1478,1605,1542,1414,1541,1477,1413,1413,1541,1605,1414,1542,1605,1413,1413,1541,1541,1605,1606,1412,1409,1410,1606,1413,1541,1542,1478,1473,1474,1475,1476,1473,1475,1538,1473,1539,1474,1537,1474,1410,1476,1537,1410,1482,1539,1409,1474,1474,1412,1540,1540,1475,1476,1473,263,1538,1538,328,389,1551,1550,1486,1488,1474,1476,1229,1354,1352,1354,1355,1356,1352,1354,1488,1409,1412,1602,1603,1601,1475,1601,1412,1412,1410,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1669,1927,1422,1550,1423,1552,1616,1486,1550,1550,1488,1488,1486,1616,1551,1423,1552,1614,327,327,328,1616,1488,1487,1423,1615,1616,1423,1552,1424,1614,1552,1616,1487,1550,1550,1552,1488,1424,1793,1992,1487,2000,2000,2000,2000,1992,1669,1927,456,455,1606,1413,1414,391,391,1423,1424,1487,1487,1550,1552,1488,1487,1552,1422,1487,1423,1615,1423,1423,1616,1615,1423,1552,1923,1666,1992,1992,2000,2000,1992,1992,1857,1487,1614,1605,1541,1477,1541,1478,1413,1541,1413,1414,1605,1605,1413,1478,1414,1541,1542,1542,1606,1478,1413,1414,1541,1474,1475,1476,1473,1414,1414,1478,1538,1539,1414,1478,1486,328,1538,264,389,1538,1412,1540,1475,1411,1539,1476,1410,1412,1473,1411,1537,1475,1474,1410,1474,1537,328,263,264,327,1551,1424,1615,1486,1487,1410,1410,1357,983,983,983,983,983,983,983,264,1539,1409,1540,1474,1538,1473,1476,1537,1411,1538,1412,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1861,1861,1861,1992,1992,1992,1992,1992,1992,1992,1992,1669,1861,1927,1487,1487,1423,1552,1488,1422,1424,1550,1552,1487,1615,1616,1423,1486,1614,1551,1423,327,328,1488,1550,1615,1488,1423,1614,1614,1486,1614,1552,1552,1550,1550,1488,1614,1551,1486,1616,1487,1793,1992,1488,2000,2000,2000,2000,1669,1927,391,455,1601,1411,1409,455,391,1551,1487,1550,1424,1551,1487,1550,1422,1488,1601,1604,1488,1424,1550,1488,1486,1486,1615,1614,1552,1793,1992,1992,1992,2000,2000,2000,1992,1857,1488,1615,1551,1542,1477,1477,1605,1478,1478,1477,1606,1605,1541,1606,1414,1413,1605,1542,1541,1606,1477,1414,1414,1478,1541,1542,1540,1537,1538,1606,1477,1477,1606,1478,1605,1422,1615,327,389,389,389,1538,328,263,1538,389,264,1474,1409,1539,1410,327,264,263,264,263,327,263,264,1538,327,1423,1616,1552,1487,1616,1476,1537,983,983,983,983,983,983,983,983,389,389,263,1474,1476,1602,1412,1540,1473,1412,1537,1538,1474,1540,1603,1475,1539,1474,1537,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1669,1861,1861,1927,1538,1602,1538,1985,1861,1861,1992,1992,1992,1992,1669,1927,1487,1423,1552,1487,1616,1486,1615,1423,1615,1424,1616,1552,1551,1422,1488,1614,1616,1424,1614,327,263,1423,1487,1487,1552,1616,1551,1486,1488,1422,1615,1552,1550,1551,1552,1616,1424,1487,1422,1614,1793,1992,1486,2000,2000,2000,2000,1857,456,391,391,1412,1473,1412,1486,1615,1487,1488,1424,1616,1550,1423,1615,1424,1538,1539,1474,1616,1616,1487,1423,1616,1615,1487,1423,1614,1793,1992,1992,2000,2000,2000,2000,1992,1857,1488,1422,1550,1414,1477,1414,1542,1477,1605,1414,1414,1606,1413,1542,1542,1478,1542,1605,1477,1606,1542,1478,1541,1542,1605,1414,1413,1606,1541,1478,1605,1541,1606,1541,1413,1414,1424,1488,1552,1614,264,389,263,264,1538,328,328,263,389,327,1538,1538,263,264,328,264,328,263,327,1538,1552,1423,1423,1423,1424,1486,1474,1540,983,983,983,983,983,983,983,983,1538,1538,389,1538,264,1603,1604,1476,1603,1473,1537,1602,1539,1412,1412,1410,1409,1412,1410,1410,1412,1411,1474,1412,1476,1540,1537,1410,1603,1409,1474,1538,1409,1603,1602,1475,1537,1474,1410,1603,1601,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1857,1604,1473,1601,1540,1411,1604,1476,1538,1409,1985,1861,1861,1861,1927,1551,1423,1486,1424,1550,1423,1550,1422,1486,1423,1422,1550,1616,1550,1424,1551,1488,1615,1423,1614,1551,1550,1552,1424,1423,1551,1423,1552,1488,1614,1615,1422,1486,1487,1615,1614,1551,1550,1488,1551,1614,1793,1992,2684355341,2000,2000,2000,2000,1857,1422,1424,1475,1412,1474,1602,1474,1614,1423,1487,1486,1616,1487,1550,1411,1602,1602,1475,1603,1424,1424,1486,1424,1487,1614,1615,1422,1923,1666,1992,1992,2000,2000,2000,2000,1992,1857,1550,1422,1423,1542,1542,1477,1477,1414,1413,1477,1478,1605,1413,1477,1605,1606,1478,1605,1414,1414,1542,1542,1413,1413,1542,1413,1541,1414,1606,1478,1414,1413,1478,1478,1541,1414,1488,1488,1550,1488,1616,1552,1615,1226,1227,1228,1228,1227,1228,1229,1551,1615,1488,1488,1486,1616,1551,1550,1616,1550,1422,1487,1550,1422,1488,1550,1410,1537,1227,1226,1224,1228,1226,1224,1226,1228,1229,1423,1422,263,264,328,1538,328,1538,1475,1473,1602,1410,1603,1410,1412,1537,1603,1473,1412,1410,1604,1540,1604,1537,1604,1475,1539,1412,1604,1410,1412,1538,1476,1538,1538,1602,1476,1538,1539,1474,1538,1412,1412,1409,1602,1537,1604,1410,1409,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1857,1412,1411,1538,1604,1540,1604,1473,263,327,264,328,1486,1550,1487,1550,1552,1615,1487,1422,1486,1614,1486,1422,1550,1424,1488,1552,1551,1614,1615,1551,1551,1486,1550,1486,1551,1614,1550,1486,1424,1552,1423,1487,1551,1423,1550,1616,1422,1422,1486,1551,1616,1552,1423,1552,1793,1992,2684355341,2000,2000,2000,2000,1857,1601,1540,1540,1412,1604,1539,1488,1551,1552,1424,1614,1423,1487,1410,1474,1539,1412,1604,1475,1486,1487,1488,1486,1551,1552,1615,1424,1793,1992,1992,1992,2000,2000,2000,2000,1992,1857,1616,1615,1551,1422,1541,1606,1605,1542,1542,1605,1605,1413,1605,1413,1478,1541,1414,1541,1477,1477,1477,1478,1478,1478,1605,1541,1606,1414,1542,1414,1541,1606,1605,1414,1477,1478,1606,1552,1616,1551,1424,1616,1424,1290,1291,1292,1292,1291,1292,1293,1422,1422,1488,1551,1486,983,983,983,983,983,983,1422,1487,1615,1552,1615,1412,1475,1291,1290,1288,1292,1290,1288,1290,1292,1293,1423,1486,1424,1615,1423,1616,1423,1614,1614,1538,1538,1538,1538,263,327,264,264,1603,1475,1540,1474,1540,1411,1603,1537,1601,1475,1603,1603,1473,1537,1540,1601,1474,1538,1602,1473,1540,1537,1473,1539,1412,1476,1474,1475,1412,1412,1475,1411,1411,1410,1473,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1669,1927,1411,1410,1412,1601,1412,328,327,264,263,1552,1423,1551,1488,1616,1424,1550,1422,1424,1486,1488,1488,1424,1614,1615,1424,1423,1486,1486,1614,1422,1424,1616,1616,1551,1615,1424,1487,1423,1422,1614,1423,1423,1552,1551,1550,1424,1550,1486,1614,1488,1615,1422,1550,1614,1551,1793,1992,2684355341,2000,2000,2000,2000,1857,1410,1604,1474,1411,1411,1603,1476,1550,1551,1488,1423,1422,1409,1601,1603,1603,1409,1473,1601,1551,1424,1615,1488,1550,1486,1550,1550,1793,1992,1992,1992,2000,2000,2000,2000,1992,1857,1616,1550,1552,1424,1423,1551,1542,1478,1413,1413,1478,1541,1605,1542,1413,1606,1541,1478,1478,1542,1606,1541,1414,1605,1541,1413,1413,1542,1477,1477,1414,1542,1606,1478,1477,1542,1606,1424,1614,1423,1550,1487,1551,1354,1355,1356,1355,1355,1356,1357,1614,1488,1616,1551,1552,983,983,983,983,983,983,1552,1487,1614,1552,1488,1539,1473,1355,1354,1352,1356,1354,1352,1354,1356,1357,1550,1616,1550,1616,1486,1424,1424,1424,1488,1423,1616,1488,1422,1424,1615,327,328,328,328,264,1538,327,327,327,1538,328,264,327,1538,1538,1540,1475,1474,1603,1409,1474,1601,1537,1476,1540,1475,1412,1476,1409,1473,1474,1410,1602,1537,1538,1410,1409,1476,1538,1793,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,1992,1992,1992,1857,1409,1538,1603,327,263,328,264,263,1551,1423,1422,1422,1552,1424,1616,1614,1552,1423,1424,1488,1486,1423,1486,1422,1550,1423,1614,1614,1614,1614,1614,1614,1422,1616,1486,1424,1614,1552,1614,1616,1424,1423,1424,1552,1423,1487,1423,1424,1423,1552,1488,1424,1488,1486,1615,1923,1666,1992,2000,2000,2000,2000,2000,1667,1925,1603,1602,1473,1538,1604,1602,1409,1409,1551,1552,1601,1409,1412,1475,1474,1539,1537,1422,1550,1486,1616,1487,1538,1552,1615,1486,1793,1992,1992,1992,2000,2000,2000,2000,1992,1857,1616,1486,1422,1551,1616,1552,1413,1413,1542,1542,1542,1541,1541,1478,1413,1422,1550,1486,1413,1413,1477,1542,1414,1477,1606,1414,1414,328,327,1606,1413,1414,1541,1606,1413,1414,1414,1477,1414,1423,1424,1424,1614,983,983,983,983,983,983,983,1229,1422,1487,1550,1423,983,983,983,983,983,983,1422,1486,1422,1423,1538,1474,1537,1614,1551,1486,1487,1616,1422,1614,1422,1551,1551,1422,1422,1550,1551,1424,1424,1552,1616,1551,1616,1551,1550,1615,1488,1552,1488,1422,1615,327,263,1551,1615,1614,1616,1551,1616,1615,263,264,1538,327,264,328,327,263,263,327,389,264,328,389,264,328,327,1537,1475,1539,1540,1539,1410,1538,1409,1601,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1857,1410,1538,1601,328,264,1487,1486,1487,1615,1423,1424,1486,1488,1615,1552,1616,1616,1423,1550,1424,1614,1614,1614,1614,1614,1614,1614,1614,1614,1614,1423,1422,1550,1424,1487,1488,1551,1616,1551,1423,1615,1422,1550,1616,1424,1616,1551,1424,1423,1422,1423,1487,1486,1550,1551,1793,1992,2000,2000,2000,2000,2000,2000,2000,1667,1925,1409,1475,1540,1601,1476,1601,1473,1474,1603,1475,1475,1473,1411,1603,1474,1410,1552,1550,1616,1552,1603,1539,1474,1615,1923,1666,1992,1992,1992,2000,2000,2000,2000,1992,1667,1925,1486,1488,1424,1487,1550,1422,1424,1550,1424,1616,1614,1614,1424,1487,1550,1423,1552,1422,1477,1541,1477,1414,1414,1550,327,389,389,389,1423,1551,1414,1479,1542,1541,1542,1479,1542,1606,1478,1487,1422,1424,983,983,983,983,983,921,921,985,1422,1487,1615,1614,983,983,983,983,983,983,1424,1424,1487,1550,328,1475,1411,1615,1486,1422,1615,1424,1550,1486,1486,1551,1614,1551,1552,1423,1551,1552,1487,1551,1551,1486,1424,1616,1614,1487,1488,1487,1614,1486,1615,1486,1551,1550,1488,1487,1486,1614,1614,1616,1552,1423,1423,1551,1550,1423,1615,1487,1552,961,962,963,964,965,966,967,389,263,263,1538,1601,1476,1604,1538,1475,1476,1537,1538,1540,1602,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1857,1474,1538,263,263,1422,1488,1552,1424,1550,1488,1551,1486,1616,1551,1423,1488,1551,1614,1614,1614,1424,1614,1614,1614,1614,1614,1614,1614,1551,1614,1552,1551,1424,1424,1614,1486,1486,1422,1487,1424,1615,1422,1424,1552,1423,1616,1552,1487,1552,1423,1424,1551,1488,1424,1551,1793,1992,2000,2000,2000,2000,2000,2000,2000,2000,1667,1925,1410,1409,1474,1601,1537,1539,1410,1476,1603,1411,1539,1603,1602,1604,1540,1539,1550,1488,1411,1473,1537,1412,1486,1793,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1857,1615,1550,1614,1552,1424,1422,1616,1614,1423,1616,1550,1423,1424,1615,1424,1551,1422,1615,1488,1486,1478,1478,1479,1486,1422,1540,1476,1538,1411,1422,1616,1551,1477,1413,1479,1478,1541,1542,1423,1615,1487,1488,983,983,983,983,983,983,983,1357,1614,1550,1615,1486,983,983,983,983,983,983,1488,1550,1552,1551,328,1411,1412,1552,1615,1615,1423,1616,1550,1616,1550,1614,1614,1488,1488,1423,1552,1486,1552,1488,1424,1616,1552,1423,1551,1615,1616,1615,1486,1488,1423,1423,1616,1615,1616,1422,1486,1486,1552,1551,1422,1551,1422,1616,1551,1423,1486,1422,1423,1025,1026,1027,1028,1029,1030,1031,264,327,389,264,264,264,389,1411,1411,1538,1474,1537,1538,1411,1602,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1857,1474,1411,263,1550,1422,1487,1614,1552,1488,1422,1487,1550,1615,1424,1422,1550,1551,1614,1614,1614,1614,1614,1614,1614,1614,1422,1614,1614,1424,1615,1552,1614,1550,1616,1423,1423,1486,1488,1423,1488,1486,1486,1423,1550,1424,1487,1424,1615,1551,1550,1488,1551,1551,1614,1487,1793,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1667,1925,1602,1409,1539,1537,1474,1411,1475,1410,1412,1412,1411,1603,1475,1473,1474,1409,1476,1476,1604,1603,1422,1486,1793,1992,1992,1992,2000,2000,2000,2000,2000,1992,1992,1857,1487,1487,1424,1486,1550,966,966,966,966,966,966,1616,1615,1423,1486,1422,1616,1550,1550,1552,1550,1422,1487,1615,1550,1487,1540,1538,1409,1411,1550,1550,1552,1423,1486,1478,1413,1615,1551,1614,1487,1423,983,983,983,983,983,983,983,1614,1487,1422,1552,1488,983,983,983,983,983,983,1614,1486,389,1538,327,1474,1539,1486,1486,263,1487,389,1487,389,389,1614,1550,1486,1487,1487,1422,1424,1423,1422,1422,1552,1422,1551,1550,1614,1551,1422,1422,1487,1614,1614,1551,1488,1423,1551,1616,1551,1614,1486,1614,1615,1552,1486,1551,1615,1424,1550,1616,1089,1090,1091,1092,1093,1094,1095,1614,1538,328,389,328,389,389,327,1602,1411,1538,1602,1475,1411,1603,1475,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1857,1474,1475,327,1550,1552,1422,1552,1488,1422,1486,1615,1487,1423,1423,1551,1423,1487,1422,1552,1616,1614,1614,1614,1614,1614,1614,1614,1614,1552,1422,1422,1614,1616,1614,1424,1423,1487,1552,1614,1550,1552,1424,1616,1424,1552,1615,1615,1616,1614,1614,1614,1614,1551,1488,1422,1793,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1667,1797,1925,1474,1537,1473,1604,1539,1539,1537,1601,1475,1604,1409,1537,1601,1604,1409,1410,1601,1539,1540,1923,1666,1992,1992,1992,2000,2000,2000,2000,2000,1992,1992,1857,1424,1552,1422,1423,1552,1614,1551,1487,1616,1488,1615,1488,1552,1486,1424,1424,1616,1423,1487,1550,1614,1550,1424,1423,1616,1551,1486,1473,1540,1423,1423,1487,1486,1488,1551,1486,1550,1615,1423,1486,1486,1227,1226,1227,1228,1225,1227,1224,1226,1229,1422,1423,1487,1614,1552,1423,1486,1422,327,264,263,1540,1409,1537,1615,1539,1473,1423,327,1538,263,264,264,389,328,389,1424,1487,1616,327,1615,1552,1538,1488,1487,1488,1488,1487,1424,1614,1423,1616,1550,1487,1422,1552,1422,1424,1422,1487,1488,1616,1487,1487,1615,1616,1488,1550,1422,1488,1424,1487,1552,1153,1154,1155,1156,1157,1158,1159,1410,389,264,1604,1473,1537,1473,1474,1538,1601,1411,1475,1475,1409,1537,1923,1666,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1667,1925,1604,264,1615,1487,1488,1423,1616,1616,1488,1423,1550,1488,1424,1552,1488,1550,1614,1551,1552,1550,1616,1614,1614,1614,1551,1423,1614,1487,1616,1550,1551,1422,1424,1551,1486,1552,1614,1616,1486,1550,1488,1486,1424,1424,1552,1616,1550,1614,1615,1424,1616,1615,1923,1797,1666,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1667,1925,1409,1539,1409,1476,1539,1540,1473,1411,1538,1537,1604,1539,1411,1410,1602,1601,1603,1923,1666,1992,1992,1992,2000,2000,2000,2000,2000,2000,1992,1992,1667,1925,1616,1424,1614,1422,1550,1552,1424,1550,1423,1551,1552,1424,1423,1422,1614,1551,1551,1486,1422,1616,1552,1488,1551,1616,1488,1614,1550,1551,1614,1423,1616,1488,1614,1551,1487,1614,1550,1423,1488,328,1291,1290,1291,1292,1289,1291,1288,1290,1293,263,1422,1487,1422,1423,1422,1538,327,1538,1049,983,983,983,983,983,983,983,1539,328,327,389,1538,263,1410,389,327,264,264,1486,327,327,389,327,1488,389,1614,1615,327,328,328,1486,327,264,1552,1422,1424,1614,1423,1550,1488,1423,1552,1486,1552,1486,1615,1550,1486,1486,1552,1551,1487,1486,1217,1218,1219,1220,1221,1222,1223,1538,264,1538,1539,1538,1474,1604,1476,1602,1412,1409,1410,1603,1409,1540,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,1992,1992,1857,1422,263,1551,1550,1615,1488,1552,1422,1616,1614,1487,1616,1551,1550,1615,1614,1422,1424,1423,1487,1616,1552,1422,1551,1488,1487,1422,1422,1615,1552,1424,1424,1550,1423,1614,1614,1487,1551,1614,1422,1487,1488,1550,1550,1614,1552,1550,1614,1615,1615,1424,1923,1666,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1667,1925,1475,1602,1538,1602,1540,1537,1410,1537,1473,1473,1409,1474,1603,1476,1410,1923,1666,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1857,1551,1488,1550,1552,1422,1486,1422,1423,1488,1550,1423,1422,1550,1423,1424,1551,1551,1424,1614,1488,1614,1614,1552,1616,1551,1424,1550,1422,1614,1423,1615,1422,1423,1423,1552,1550,1615,327,327,1538,1355,1354,1355,1356,1353,1355,1352,1354,1357,263,264,327,389,328,1538,263,327,983,983,983,983,983,983,1049,983,983,1603,1538,1604,389,1474,1476,1409,1539,1409,1538,327,1538,264,327,328,328,327,263,1538,263,327,328,263,328,264,264,1487,1614,1616,1616,1552,1422,1486,1616,1487,1552,1551,1487,1487,1424,1552,1488,1487,1422,1616,389,1281,1282,1283,1284,1285,1286,1287,1473,1540,1411,1539,1409,1539,1412,1601,1540,1475,1475,1603,1540,1537,1923,1666,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,1992,1992,1667,1925,1551,1423,1423,1616,1616,1616,1550,1550,1615,1488,1488,1424,1551,1424,1550,1550,1551,1616,1487,1552,1488,1616,1615,1423,1551,1422,1423,1422,1488,1488,1422,1615,1614,1422,1615,1423,1487,1423,1550,1488,1616,1487,1488,1615,1552,1614,1614,1487,1923,1797,1666,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1667,1797,1925,1539,1604,1476,1475,1473,1474,1412,1474,1410,1476,1410,1411,1923,1666,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1667,1925,1537,1475,1410,1552,1423,1486,1616,1486,1615,1486,1551,1422,1488,1614,1551,1552,1422,1486,1486,1487,1551,1537,1540,1412,1409,1537,1537,1474,1537,1409,1538,1473,1475,1473,1476,983,1538,983,1539,1539,1539,1474,1476,1538,1410,1412,1412,1538,1411,1412,1473,1538,1538,1538,263,1476,983,983,983,983,983,983,983,983,983,1412,1538,1473,1409,1412,1601,1540,1539,1476,1409,1537,1410,1412,1537,327,1537,1540,1538,1601,263,1411,1475,1409,264,264,264,328,1550,1552,1551,1551,1615,1424,1486,1487,1488,1552,1422,1488,1551,1488,1616,1486,1552,263,1538,1345,1346,1347,1348,1349,1350,1351,1476,1410,1602,1475,1410,1540,1540,1474,1538,1412,1476,1475,1476,1923,1666,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1857,1488,1487,1552,1616,1550,1551,1551,1487,1550,1486,1488,1487,1422,1423,1552,1550,1615,1551,1424,1486,1487,1487,1616,1616,1615,1615,1615,1552,1424,1424,1551,1616,1614,1486,1614,1424,1424,1423,1423,1486,1423,1487,1616,1552,1923,1797,1797,1797,1666,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1667,1797,1797,1797,1797,1925,1473,1604,1412,1410,1539,1411,1923,1666,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1857,1411,1476,1474,1537,1409,1537,1538,1475,1475,1538,1473,1409,1474,1540,1475,1410,1475,1476,1476,1537,1410,1412,1539,1539,1473,1411,1410,1476,1537,1412,1412,1412,1476,1538,1537,985,983,983,983,1049,1540,1476,1474,1473,1411,1476,1539,1537,1473,1474,1474,1537,1539,1412,1474,983,983,983,984,1539,1604,1473,1601,1410,1476,1604,1409,1601,1410,1473,1538,1475,1603,1539,1410,1539,1601,1538,1603,1475,1603,1412,1411,1409,1409,1412,1538,1601,1474,1474,1601,389,1538,327,1422,1616,1550,1550,1615,1488,1552,1616,1486,1486,1616,1488,1614,1486,1423,1538,263,1410,1412,1604,1474,1410,1538,1601,1539,1601,1537,1603,1475,1411,1539,1476,1411,1473,1411,1473,1923,1666,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1667,1797,1797,1797,1925,1616,1552,1615,1615,1424,1422,1551,1614,1616,1614,1486,1616,1614,1552,1614,1486,1551,1551,1552,1423,1423,1424,1423,1487,1487,1614,1487,1552,1486,1614,1923,1797,1797,1797,1797,1797,1797,1797,1797,1797,1666,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1667,1797,1797,1797,1797,1797,1797,1666,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1925,1539,1476,1411,1473,1537,1410,1539,1473,1539,1540,1474,1410,1476,1410,1540,1540,1475,1474,1410,1409,1411,1412,1540,1049,983,983,1540,1537,1475,1474,1476,1474,1537,1473,983,983,1049,983,983,983,983,983,983,983,985,983,983,983,983,983,983,983,983,983,983,983,983,984,1602,1475,1538,1476,1412,1473,1474,1476,1473,1537,1537,1475,1538,1475,1474,1540,1476,1539,1604,1603,1537,1539,1601,1602,1540,1601,1540,1473,1473,1410,1538,1411,327,264,327,263,1552,1487,1538,328,264,327,327,1423,1616,1423,1487,1551,327,328,1538,1473,1604,1473,1539,1476,1602,1601,1475,1540,1475,1539,1475,1476,1602,1411,1409,1603,1476,1604,1474,1793,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1797,1925,1424,1424,1486,1423,1486,1552,1615,1552,1552,1550,1614,1422,1552,1615,1615,1551,1423,1550,1923,1797,1797,1797,1797,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1667,1925,1476,1474,1410,1409,1537,1537,1476,1410,1412,1409,1538,1539,1538,1537,1473,1537,1537,1410,1539,1923,1797,1797,982,983,983,1797,1797,1797,1797,1797,1797,1797,1797,983,983,1047,1047,1047,983,983,983,1047,1047,1047,1047,1047,1047,1047,1047,1047,1047,1047,1047,1047,983,1049,984,1538,1540,1604,1539,1539,1601,1603,1473,1602,1538,1601,1409,1539,1537,1538,1538,1475,1473,1538,1601,1603,1537,1539,1604,1603,1537,1475,1539,1540,1540,1409,1476,1410,327,389,263,264,389,263,389,1538,328,389,263,328,1616,389,389,328,264,1603,1473,1410,1410,1410,1538,1602,1540,1409,1602,1410,1409,1539,1540,1476,1601,1412,1602,1473,1410,1473,1793,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,2000,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1666,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1857,1538,1537,1474,1473,1474,1475,1476,1538,1476,1476,1473,1539,1540,1537,1473,1476,1476,1923,1797,1666,1992,1992,982,983,984,1992,1992,1992,1992,1992,1992,1992,1992,982,984,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1539,1475,1604,1475,1601,1475,1539,1604,1411,1537,1603,1412,1539,1604,1537,263,389,263,263,328,264,1538,263,1538,389,327,1538,1409,1601,1603,1540,1410,1474,1475,1476,1539,1412,1410,1476,1603,1410,1475,1412,1602,1474,1537,1923,1797,1797,1666,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1667,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1797,1666,1992,1992,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,982,984,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1412,1538,1540,1540,1409,1537,1409,1797,1797,1797,1797,1797,1925,1603,1538,1604,1411,1540,1412,1474,1603,1539,1410,1540,1537,1476,1474,1409,1476,1603,1540,1602,1602,1410,1474,1538,1537,1411,1602,1923,1797,1666,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,1046,1048,2000,2000,2000,982,1049,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1046,1047,1048,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1797,1797,1666,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1797,1925,1603,1604,1475,1412,1412,1537,1412,1410,1603,1409,1603,1540,1540,1539,1537,1601,1923,1797,1797,1666,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,985,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1925,1539,1475,1409,1473,1601,1923,1797,1797,1797,1797,1797,1797,1797,1666,1992,1992,1992,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1667,1797,1797,1797,1797,1797,1666,1992,1992,1992,1992,1992,1992,1992,1992,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,985,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1046,1047,1048,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,982,983,984,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1046,1047,1048,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,1992,1992,1992,1992,1992,1992,1992,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000],"height":250,"id":1,"name":"Ground1","opacity":1,"type":"tilelayer","visible":true,"width":250,"x":0,"y":0},{"data":[368,369,370,371,432,433,434,435,304,305,306,307,368,369,370,371,368,369,370,371,368,369,370,371,368,369,370,371,368,369,370,371,368,369,370,371,368,369,370,371,372,373,374,375,1011,1012,810,811,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,304,305,306,307,368,369,370,371,432,433,434,435,432,433,434,435,432,433,434,435,432,433,434,435,432,433,434,435,432,433,434,435,432,433,434,435,436,437,438,439,1075,1076,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,2000,2000,2000,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,368,369,370,371,432,433,434,435,306,307,496,497,498,499,496,497,498,499,496,497,498,499,496,497,498,499,496,497,498,499,496,497,498,499,496,497,500,501,502,503,947,948,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,432,433,434,435,129,129,368,369,500,501,560,561,562,563,560,561,562,563,560,561,562,563,560,561,562,563,560,561,562,563,560,561,562,563,560,561,564,565,566,567,1011,1012,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,2000,2000,1677,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,129,129,129,304,305,306,432,433,564,565,624,625,948,945,946,947,948,947,948,945,946,947,948,945,946,947,948,946,947,948,945,946,947,948,945,946,947,948,630,631,1075,1076,1066,1067,0,1192,1193,1194,1195,1192,1193,1194,1195,1192,1193,1194,1195,1192,1193,1194,1195,1192,1193,1194,1195,1192,1193,1194,1195,1192,1193,1194,1195,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1297,1297,1361,1361,1361,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,2000,2000,2000,2000,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,305,306,307,368,369,370,371,308,309,310,948,823,824,1009,1010,1011,1012,1011,1012,1009,1010,1011,1012,1009,1010,1011,1012,1010,1011,1012,1009,1010,1011,1012,1009,1010,1011,1012,950,951,952,953,1130,1131,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,1297,1297,1297,1361,1297,1361,1361,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,2000,2000,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,369,370,371,432,433,434,435,372,373,374,886,887,888,1073,1074,1075,1076,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1074,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1014,1015,1016,1017,1194,1195,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1297,1361,1297,1361,1297,1361,1297,1361,1297,0,0,0,0,781,781,781,781,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,2000,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,433,434,435,304,305,306,307,436,437,438,950,951,952,953,950,1137,1138,1139,1140,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1078,1079,1080,1081,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1297,1361,1297,1361,1297,1297,1361,1361,1361,1297,1297,0,0,781,781,781,781,781,781,781,781,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,1677,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,305,306,307,368,369,370,371,500,373,374,1014,1015,1201,1202,1203,1201,1202,1203,1204,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1142,1143,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,1297,1297,1297,1361,1297,1361,1297,1361,1361,1297,1361,0,0,781,717,0,0,0,0,0,0,717,781,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,2000,2000,2000,2000,1677,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,369,370,371,432,433,434,435,564,437,438,1014,1015,1016,1129,1130,1265,1266,1267,1268,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1206,1207,0,0,0,0,0,0,0,0,0,0,0,780,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,1297,1361,1361,1361,1297,1297,1297,1297,1361,1297,0,0,0,0,716,0,1931,0,0,0,0,0,0,782,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,1801,2000,2000,2000,2000,1865,0,0,0,0,0,731,733,733,733,733,731,733,733,733,733,731,733,733,733,733,733,733,731,733,733,733,733,731,733,733,733,733,731,0,0,0,0,0,0,0,0,0,0,432,433,434,435,433,434,435,370,371,500,501,1076,950,951,1078,0,1121,1122,1123,1121,1122,1123,1121,1122,1123,0,1121,1122,1123,0,1121,1122,1123,0,1121,1122,1123,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,737,0,0,740,0,0,0,0,0,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1297,1361,1361,1297,1361,1297,1361,1361,1297,1297,1361,0,0,0,0,0,717,717,717,717,653,0,1801,1801,0,0,0,0,0,1412,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,653,1801,2000,2000,1677,1869,1935,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,306,307,304,305,306,307,307,434,435,564,1139,1140,1014,1015,1142,0,1144,1145,0,0,0,0,1630,1631,1632,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,0,0,804,0,0,0,0,0,0,0,0,0,0,0,0,0,801,0,0,0,0,0,0,0,0,737,0,0,740,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1297,1361,1297,1297,1361,1361,1297,1361,1297,1361,1361,1361,1361,1297,1361,1361,1297,1361,1361,1297,1361,1297,0,0,717,717,717,717,717,0,0,0,1410,1538,0,1801,1801,0,0,0,1933,0,0,1539,1412,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,368,369,370,371,371,500,501,1076,1014,1015,1016,1017,0,0,1208,1209,0,0,0,0,0,0,0,0,0,0,0,0,0,0,387,0,0,0,0,0,0,0,0,0,0,865,0,0,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1297,1297,1297,1361,1361,1297,1361,1297,1297,1297,1297,1361,1361,1297,1297,1361,1297,1297,1361,1297,1361,1297,1297,1361,0,0,0,0,717,717,0,0,0,0,0,0,0,1476,1476,1412,0,1993,1737,0,0,0,1865,0,0,1412,1412,1474,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,432,433,434,435,435,564,1139,1140,1078,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1192,1626,1627,0,0,0,929,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,1297,1297,1361,1297,1361,1297,1297,1297,1361,1361,1297,1361,1297,1361,1297,1361,1361,1361,1297,1361,1361,1361,1361,1297,1361,1297,1361,1297,1297,1361,0,0,0,0,717,717,717,717,0,0,0,0,0,0,0,0,0,1540,1473,0,0,0,1801,0,0,0,1865,0,0,0,1540,1409,1411,1410,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,129,432,433,434,435,500,501,1076,950,951,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1555,1555,1555,1555,1555,1555,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,1361,1297,1297,1297,1297,1297,1297,1361,1297,1361,1297,1361,1297,1361,1297,1297,1297,1297,1297,1297,0,0,0,0,0,0,0,0,0,0,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,1538,1475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,733,733,733,733,733,731,733,733,733,733,733,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,501,564,1139,1140,1014,1015,0,0,0,0,0,0,0,0,1685,1686,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1424,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,306,307,435,436,437,438,822,823,824,825,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,1424,0,0,1931,1805,1933,0,0,1554,1493,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,732,732,732,732,732,732,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,307,308,309,310,945,946,947,948,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1424,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,371,372,373,374,1009,1010,1011,1012,0,0,0,0,0,0,0,513,514,0,0,0,0,0,0,0,0,0,0,0,1494,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,2000,2000,1871,1998,0,1424,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,306,307,435,436,437,438,1073,1074,1075,1076,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1615,0,0,1931,1805,1805,1805,1805,1805,1930,1930,1930,1930,1930,1930,1930,1930,1930,1869,1869,1869,1935,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,732,732,732,732,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,307,308,309,310,945,946,947,948,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,2000,2000,2000,2000,2000,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,0,0,0,0,0,0,731,733,733,733,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,371,372,373,374,1009,1010,1011,1012,0,737,0,0,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1996,1869,2000,2000,2000,2000,1865,0,0,0,0,0,0,1615,0,0,0,1426,1427,1427,1424,1426,1425,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,0,0,0,731,0,0,0,0,731,733,733,733,731,0,0,0,0,0,0,306,307,435,436,437,438,1073,1074,1075,1076,0,801,0,0,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,1801,2000,2000,2000,1865,0,0,0,0,1426,1427,1427,1427,1427,1427,1429,0,0,711,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,0,0,0,0,0,0,0,370,371,307,308,309,310,945,946,947,948,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,2000,2000,2000,1865,0,1615,1426,1427,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,371,372,373,374,1009,1010,1011,1012,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1428,0,0,0,1801,2000,2000,1865,0,1426,1429,1494,1555,1555,1493,0,0,0,0,0,711,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,589,590,0,0,0,0,0,777,778,779,0,0,0,0,589,590,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,306,307,435,436,437,438,1073,1074,1075,1076,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1430,1428,0,0,1801,2000,2000,1865,0,1490,0,1492,1616,0,1490,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,145,146,146,146,146,212,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,589,590,0,0,0,0,0,0,841,842,843,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,306,307,307,308,309,310,945,946,947,948,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,1801,2000,2000,1865,0,1490,0,1492,1488,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,208,146,146,209,595,274,721,658,660,0,0,0,0,0,208,530,530,212,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,371,372,373,374,1009,1010,1011,1012,0,0,0,0,0,0,0,513,514,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,1801,2000,2000,1865,0,1490,0,1430,1427,1427,1427,1429,0,0,0,0,0,0,0,904,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,528,531,532,0,0,0,0,0,656,273,273,275,659,338,657,722,660,0,0,528,530,530,209,657,659,211,212,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,435,436,437,438,1073,1074,1075,1076,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,1801,2000,2000,1935,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,720,657,596,0,0,0,0,0,656,593,723,594,657,659,658,722,660,0,528,209,721,659,275,274,338,659,211,212,0,0,0,0,0,0,0,1490,1122,1123,1124,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,732,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,306,307,307,308,309,310,945,946,947,948,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,1801,2000,1865,0,0,0,0,0,0,521,0,0,0,0,726,0,0,777,778,779,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,784,785,788,0,0,0,0,0,401,786,274,657,595,273,273,338,788,0,272,721,593,338,721,723,273,659,273,211,212,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,371,372,373,374,1009,1010,1011,1012,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,1801,2000,1865,0,0,0,0,0,0,0,0,0,0,0,790,0,521,841,842,843,0,0,0,902,903,0,0,1810,0,0,0,0,0,0,0,0,716,0,0,0,1118,1119,1120,0,0,0,0,0,0,524,0,0,589,590,460,461,0,0,0,0,0,0,0,0,0,0,0,0,401,786,786,594,274,340,0,0,272,274,210,593,210,593,658,210,273,658,276,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,733,731,0,0,731,733,731,733,731,0,0,0,0,0,0,434,435,435,436,437,438,1073,1074,1075,1076,812,813,817,818,819,820,817,818,819,820,817,818,819,820,0,0,0,0,0,0,0,1752,0,0,1801,2000,1865,0,0,0,0,0,0,0,0,0,0,0,854,0,0,0,521,0,0,0,0,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,460,461,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,401,340,0,0,528,209,210,657,658,721,593,721,593,210,274,276,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,0,0,0,0,0,717,717,0,0,0,0,0,0,242,243,307,308,309,310,945,946,947,948,945,946,947,948,945,946,947,948,945,946,947,948,945,946,0,1747,0,0,0,0,741,742,743,0,1801,2000,1865,0,0,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,410,411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,144,145,146,147,148,0,0,0,0,656,275,721,658,722,658,657,210,339,402,402,403,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,1993,1737,1935,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,733,733,733,733,733,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,306,307,371,372,373,374,112,125,126,115,112,113,114,115,112,113,114,115,112,113,114,115,1009,1010,0,1811,0,0,0,0,805,806,807,0,1801,2000,1865,0,0,1490,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,474,475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,208,209,210,211,212,0,0,0,0,656,593,273,722,657,657,274,595,276,0,0,0,0,0,0,0,0,1426,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1935,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,1752,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,435,436,437,438,176,189,190,179,176,177,178,179,176,177,178,179,176,177,178,179,1073,1074,0,0,0,0,0,0,0,1492,0,0,1801,2000,1865,0,0,1554,1493,0,0,0,0,0,0,0,0,0,0,0,521,0,0,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,272,273,274,275,276,0,0,0,0,784,786,786,786,337,722,339,786,403,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,240,241,242,243,240,241,242,243,240,241,242,243,240,241,242,243,240,241,242,243,1137,1138,0,0,0,0,0,0,0,1492,0,0,1801,2000,2000,1933,0,0,1490,0,0,0,0,0,0,0,0,0,0,521,583,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,720,721,338,339,340,0,0,0,0,0,0,0,0,784,786,788,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,304,305,304,305,306,307,304,305,306,307,304,305,306,307,305,306,307,499,496,497,498,499,1009,1010,0,0,0,0,0,0,0,0,1615,0,1801,2000,2000,1865,0,0,1490,0,0,0,0,1745,0,0,1810,0,0,1415,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1105,0,0,0,0,0,0,0,0,0,784,785,402,403,404,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1426,1427,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1752,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,370,371,371,368,369,370,371,368,369,370,371,563,560,561,562,563,1073,1074,0,0,1416,0,0,0,0,0,0,0,1993,2000,2000,1865,0,0,1490,0,0,0,0,1809,0,0,410,411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1040,0,0,0,1427,1427,1427,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,976,1169,1167,1105,1166,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,434,435,435,432,433,434,435,432,433,434,435,627,624,625,626,627,1137,1138,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,1490,0,0,0,1810,0,855,0,474,475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1039,0,0,0,0,0,0,1427,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1999,974,911,1105,1105,1168,1105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,306,307,304,305,306,307,0,0,0,0,0,0,1009,1010,0,0,0,0,0,0,1480,1416,0,0,0,0,0,0,0,1801,2000,1865,0,0,1490,0,0,0,0,905,1810,968,855,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,0,0,0,0,0,1168,0,0,0,0,0,1427,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1426,1427,1427,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1999,1690,0,0,0,0,0,0,0,718,0,0,1169,1041,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,370,371,368,369,370,371,0,0,0,0,0,0,1073,1074,0,0,0,0,0,0,1544,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,969,0,0,0,0,0,0,0,0,1746,0,0,0,0,0,0,0,0,0,718,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,1361,0,0,0,0,0,974,0,0,0,0,0,1427,0,327,0,0,0,0,0,0,0,0,0,0,0,1427,1427,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1933,0,0,0,0,0,0,716,0,0,1169,1166,1167,910,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,733,733,733,733,731,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,432,433,434,435,432,433,434,435,432,433,434,435,0,0,0,0,0,0,1137,1138,0,0,0,0,0,1416,1544,0,737,0,0,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,1361,1361,0,0,0,0,0,0,718,0,0,0,0,264,264,328,263,1427,1427,1427,1427,1427,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1231,1231,1231,1801,0,0,1865,717,717,717,717,0,0,716,0,0,0,0,974,912,1167,1041,912,0,0,0,0,0,0,0,0,0,1411,1539,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,733,733,731,0,0,0,0,0,731,0,0,0,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,304,305,306,307,304,305,306,307,304,305,306,307,308,309,310,311,0,0,0,0,0,0,0,0,0,1548,1613,0,0,0,0,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,717,717,717,0,0,0,0,1361,1230,1359,1359,716,0,0,0,0,327,264,328,1483,0,0,0,0,0,1427,1427,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1231,1231,1231,0,0,0,1801,0,0,1675,1933,0,0,0,717,717,653,0,0,0,0,0,0,0,1166,1168,910,976,1038,1041,0,0,263,1476,1475,1539,1540,1475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,370,371,368,369,370,371,372,373,374,375,0,0,0,0,0,0,0,0,1609,1613,1416,0,0,0,0,0,0,0,0,1801,2000,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,653,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,0,0,0,0,716,0,0,0,0,263,0,0,1421,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,1993,1737,0,0,1865,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,974,912,1102,976,974,912,976,0,1412,1411,1475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,434,435,432,433,434,435,436,437,438,439,0,0,0,0,0,0,0,0,1480,1416,0,0,0,1477,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,855,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,653,0,0,0,0,0,0,0,0,1483,0,0,0,0,1231,1231,1231,1231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,717,717,717,0,0,0,0,0,0,0,0,0,0,1169,1041,1040,1411,0,0,1539,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,306,307,304,305,316,317,318,319,945,946,0,0,0,0,0,0,0,1548,1613,0,1477,0,0,0,0,0,0,0,0,1801,1935,0,0,0,0,855,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1421,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,1801,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,717,717,717,0,0,0,0,0,0,0,0,0,0,718,0,0,1412,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,370,371,368,369,380,381,382,383,1009,1010,0,0,0,0,0,1416,0,1544,0,0,0,0,0,0,0,0,0,0,0,1929,0,0,0,0,0,0,460,461,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1483,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1477,1414,0,0,0,0,0,1993,1737,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,0,0,716,263,327,1411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,434,435,432,433,444,445,446,447,1073,1074,0,0,0,0,0,0,1416,1544,0,1413,1477,0,1121,1122,1123,1124,0,0,0,1929,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1421,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1477,1541,1414,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,653,327,264,327,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,308,316,317,318,319,310,311,945,946,0,0,0,740,0,0,0,1548,1613,0,1477,0,0,1413,0,0,0,0,0,0,1929,0,0,0,0,0,0,0,0,460,461,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1413,1541,1478,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1417,1418,1419,263,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,733,733,733,733,733,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,372,380,381,382,383,374,375,1009,1010,0,0,0,0,0,0,0,1608,0,1477,0,0,1477,1477,0,0,0,0,0,0,1929,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1477,1414,1478,1413,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1481,1476,1483,327,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,436,444,445,446,447,438,439,1073,1074,0,0,0,0,0,0,1415,0,0,0,1413,1413,0,0,0,0,0,0,0,0,1801,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,1421,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1542,1477,1541,1413,1542,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,1481,1410,1603,1419,263,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,308,309,310,311,945,946,1009,1137,1138,1066,1067,0,0,0,0,0,0,1477,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,1483,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1478,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,391,0,0,456,455,455,0,0,0,0,0,1545,1539,1603,1483,327,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,372,373,374,375,1009,1010,0,1201,1202,1130,1131,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,653,0,0,0,0,0,1421,0,0,0,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,392,455,517,456,456,456,392,455,455,392,517,0,0,0,1481,1410,1483,263,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,436,437,438,439,1073,1074,0,1265,1266,1194,1195,1059,1060,0,0,0,1416,0,0,0,0,0,1413,1413,0,0,0,0,0,1801,2000,2000,2000,1933,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,1483,0,456,391,456,392,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,456,455,0,520,0,0,0,391,0,455,1032,1033,456,0,0,1481,1539,1483,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,308,309,310,311,945,946,0,1198,1199,1206,1207,1123,1124,0,0,0,0,1415,0,1413,0,0,0,0,0,0,0,0,1931,1674,2000,2000,2000,2000,1933,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1630,1631,1632,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,0,0,0,0,0,0,0,0,0,1421,0,456,455,391,455,456,0,0,0,0,0,0,0,0,0,0,1414,0,1118,1119,1120,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,392,456,0,0,0,0,0,0,0,0,0,1096,1097,904,0,0,1481,1546,1547,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,372,373,374,375,1009,1010,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1479,0,0,0,0,0,0,1931,1674,2000,2000,1869,1869,2000,2000,2000,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1483,0,391,391,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1541,1541,0,0,0,0,0,1801,2000,1677,1935,0,0,0,0,0,0,0,0,392,392,520,0,0,0,0,1811,0,0,584,0,0,0,456,392,391,1608,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,436,437,438,439,1073,1074,0,0,0,0,0,0,0,0,0,0,1416,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1935,0,1690,1993,1869,2000,2000,1933,0,0,0,1690,1690,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1421,1418,0,0,0,0,455,584,0,0,0,0,0,0,0,0,0,0,1477,0,0,0,0,0,0,1801,2000,1675,1933,0,0,0,0,0,0,0,456,517,0,0,0,520,0,0,0,1542,1478,0,0,520,0,0,391,455,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,653,0,717,717,717,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,308,309,310,311,945,946,0,0,0,0,0,1479,0,0,0,0,0,737,0,0,740,0,0,0,0,1690,0,0,0,0,1690,0,0,0,0,1993,2000,2000,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,519,584,0,0,0,0,0,0,1483,1479,1416,455,391,456,392,0,0,0,0,0,0,0,0,0,1541,0,0,0,0,0,0,1993,1737,0,1865,0,0,0,0,0,0,0,902,903,0,0,0,0,1478,0,0,0,1541,0,1478,0,0,0,0,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,372,373,374,375,1009,1010,0,0,0,0,0,0,0,0,0,1415,0,801,0,0,804,0,0,0,0,0,0,0,0,0,0,0,0,1690,1690,0,1801,2000,2000,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,1753,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1630,1631,1632,0,0,1753,1801,2000,2000,1865,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,1545,0,0,0,1483,1479,1415,456,455,455,391,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,456,0,0,0,0,1542,1413,0,0,0,1477,1413,0,0,583,0,455,392,455,391,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,436,437,438,439,1073,1074,0,0,0,0,0,543,544,0,1480,0,0,0,0,0,0,0,0,0,0,0,1996,1805,1805,1805,1933,1690,0,0,0,0,1993,2000,2000,2000,2000,2000,1935,1690,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,1931,1674,0,2000,1865,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,0,0,0,1483,1416,1479,1415,1416,0,0,0,1415,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,520,0,0,0,0,1541,0,0,1281,0,0,0,1478,0,0,0,0,0,392,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,308,309,310,311,945,946,0,0,740,1479,0,0,0,1416,1544,0,0,0,0,0,0,0,0,0,0,0,1690,1993,2000,2000,2000,1933,0,1690,0,1690,0,1993,2000,2000,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1118,1119,1120,0,0,0,0,1801,0,0,2000,1865,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,583,0,0,0,1546,1547,0,1480,0,1479,1416,0,583,519,520,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,584,1811,0,583,0,0,1303,1025,1304,0,0,583,0,1811,519,0,455,517,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,372,373,374,375,1009,1010,0,0,804,0,0,1479,0,0,1481,1419,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,2000,1933,0,0,0,0,0,1993,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1630,1631,1632,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,2000,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,583,584,0,584,0,0,0,0,0,583,0,0,0,0,584,0,1544,520,0,0,0,0,0,0,0,0,519,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,1626,1627,1628,0,0,455,0,584,0,0,0,0,1281,1304,1304,1095,1281,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,436,437,438,439,1073,1074,0,0,0,0,0,0,0,0,1481,1483,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,1993,2000,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,1746,0,0,1811,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,1753,0,1801,0,2000,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,0,519,0,0,0,0,0,0,0,519,584,520,1608,519,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,1032,1033,0,519,1477,1413,1542,0,1367,1304,1095,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,733,733,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,304,305,308,309,310,311,945,946,0,0,0,0,0,0,0,0,1481,1485,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,1993,2000,1935,0,0,1690,0,0,1690,0,0,0,0,0,0,1690,0,0,805,806,807,0,0,0,0,0,0,1746,0,0,1690,0,0,0,0,0,0,0,0,1689,0,0,0,0,1753,0,0,0,0,1801,0,0,1677,1935,0,0,0,0,0,0,0,0,0,1685,1686,0,0,0,519,0,519,0,0,0,0,0,0,0,0,0,455,584,519,584,0,0,0,0,0,0,0,0,0,0,0,583,0,0,0,0,0,0,0,0,1993,1869,1935,0,0,0,0,0,0,1096,1097,0,0,0,1541,0,0,0,1281,0,0,0,0,0,0,0,0,392,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,368,369,372,373,374,375,1009,1010,1002,1003,0,0,0,0,0,0,1608,0,0,0,0,0,0,0,0,0,0,0,740,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1935,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,584,520,583,0,0,0,0,0,0,0,0,0,0,0,520,519,519,520,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,968,905,0,0,0,1541,0,0,0,0,0,0,0,0,0,583,0,455,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,432,433,436,437,438,439,1073,1074,1066,1067,0,0,0,0,0,0,0,0,1415,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,0,0,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1881,0,0,0,0,0,0,1811,0,0,0,0,0,1931,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,583,583,583,519,0,1811,0,0,0,0,0,0,0,0,519,520,0,0,0,0,0,0,1995,0,0,0,0,0,0,328,263,0,0,969,0,0,0,0,0,0,1477,1541,1414,0,0,0,0,0,0,392,392,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,716,717,717,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,316,500,501,502,503,1004,1005,1006,1130,1131,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,517,0,0,0,0,0,0,0,0,0,801,0,0,0,0,0,1690,0,0,0,0,1690,0,0,0,0,0,0,0,0,1690,1931,1805,1933,0,1690,0,0,0,1690,0,0,1753,0,1801,2000,2000,2000,2000,2000,2000,2000,1865,0,0,1690,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,520,583,0,0,460,461,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1933,0,0,0,0,0,264,263,0,0,0,0,0,584,519,1811,0,0,1542,1477,0,1811,0,0,0,583,391,392,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,372,372,373,566,567,1068,1069,1070,1194,1195,0,0,0,0,737,0,0,0,0,0,1416,0,0,0,0,0,0,0,0,0,455,710,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,1753,0,0,0,0,0,0,0,1690,0,0,0,1993,0,1933,1933,0,0,1690,0,0,0,1690,0,0,1801,2000,0,0,0,2000,1677,1869,1935,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1935,0,0,0,0,0,264,263,0,0,0,392,0,0,0,520,0,0,0,519,0,0,0,0,583,392,456,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,716,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,436,436,437,630,631,1074,1002,1003,0,0,0,0,0,0,801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,836,517,651,773,517,0,0,0,392,392,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,1993,1737,0,1933,0,0,0,0,1689,0,0,1931,1674,2000,0,0,0,2000,1865,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1811,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1746,1811,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,264,264,264,0,0,0,391,392,0,0,0,0,0,0,0,0,0,0,0,456,392,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,304,305,306,307,308,309,310,311,945,946,874,875,0,0,0,543,544,0,0,0,0,0,0,0,1480,0,0,0,0,0,0,0,0,0,517,0,0,0,0,0,0,0,710,773,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,1993,1869,1935,0,0,0,0,0,1690,0,1801,0,0,0,0,2000,2000,1865,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,460,461,0,0,0,0,0,0,0,0,0,0,0,0,460,461,0,0,0,0,0,0,0,0,1931,1805,1933,0,0,0,0,0,263,264,264,263,0,0,0,392,391,0,0,0,0,456,0,0,517,456,455,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,372,373,374,375,1009,1010,938,939,0,0,0,0,0,0,0,0,0,0,0,0,1608,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,1630,1631,1632,0,0,0,0,0,0,0,0,836,0,0,0,0,0,0,0,0,0,0,0,1746,0,0,0,0,0,0,0,0,0,1690,0,1753,0,0,1801,0,0,0,1677,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,779,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,1630,1631,264,1412,1412,0,328,263,0,0,0,0,0,0,0,0,391,456,391,456,392,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,436,437,438,439,1073,1074,1002,1003,0,0,0,0,0,0,0,0,0,0,0,1416,0,1480,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,456,646,773,0,0,0,0,454,392,455,0,0,715,715,715,1809,0,0,0,0,0,1690,0,0,0,0,0,0,0,1993,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,841,842,843,0,0,0,0,0,0,1415,520,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,264,1539,1475,0,264,264,263,0,0,0,0,0,0,0,392,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,496,497,498,499,500,501,502,503,945,946,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,1544,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,836,455,0,0,0,0,455,391,1550,1551,0,0,715,715,715,715,715,0,1615,1551,1690,0,1746,0,0,1690,1690,0,0,1689,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,391,456,520,0,1418,1418,1418,328,0,0,0,0,0,0,855,1418,1418,0,0,1473,0,1418,1418,1419,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,731,716,0,0,0,0,0,716,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,560,561,562,563,564,565,566,567,1009,1010,938,939,0,0,0,0,0,0,1121,1122,1123,1124,0,0,1416,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,456,1488,1487,1551,1552,1615,1552,1423,711,715,715,715,715,0,1616,1488,1690,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,520,1416,1415,0,0,0,0,855,983,0,0,0,0,0,983,855,0,0,0,0,0,0,0,0,1418,0,0,0,0,0,0,0,327,328,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,731,731,731,0,0,1431,0,0,0,0,0,0,731,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,624,625,626,627,628,629,630,631,1073,1074,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,651,392,0,0,0,1551,1488,0,0,0,0,0,0,1488,1809,715,715,715,520,0,1422,1486,0,0,0,1753,0,1881,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1494,1555,1555,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,1415,519,1479,1477,0,0,0,0,983,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1419,0,0,0,0,328,264,0,328,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,731,0,0,0,0,0,0,717,717,717,717,0,0,0,0,1431,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,945,946,947,948,945,946,947,948,945,946,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1296,1296,1296,1296,1296,1296,1296,1296,1296,1296,1296,716,456,773,456,0,456,0,0,1614,1488,0,0,1753,0,1881,0,0,1424,710,715,710,392,0,392,1550,1423,0,1690,0,0,0,0,0,1616,0,0,0,0,0,0,0,0,0,0,1494,1555,1555,1556,1423,1488,1555,1493,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,519,1607,1414,1413,0,1546,0,0,0,0,0,0,0,0,0,0,1545,1546,1546,1546,1546,0,0,0,0,0,0,1418,1419,0,263,327,328,327,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1431,0,731,731,731,731,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1009,1010,1011,1012,1009,1010,1011,1012,1009,1010,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,456,836,646,392,456,0,0,456,391,1488,0,0,0,0,0,0,1486,391,391,0,519,455,0,0,1551,1423,0,0,1690,0,0,1486,1616,1487,1487,0,0,0,0,0,0,0,1555,1556,1488,1615,0,0,0,0,1554,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,392,584,392,0,0,1487,1487,0,0,1801,0,1865,0,0,0,0,0,0,0,0,1545,1546,0,0,0,0,0,0,1419,0,0,706,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1431,717,717,717,717,717,1431,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,717,1365,1365,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1073,1074,1075,1076,1073,1074,1075,1076,1073,1074,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,0,0,717,717,717,717,717,717,717,717,717,717,717,717,653,0,0,836,455,651,0,0,0,392,519,1424,1422,1486,0,1423,0,1616,0,0,519,0,1748,1605,1605,1605,1424,1552,1488,0,0,1486,1552,0,0,1486,1424,0,0,0,0,0,0,1423,1488,0,0,0,0,0,0,0,1554,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,0,0,327,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,1545,1546,0,0,0,0,0,0,706,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1431,0,0,0,0,0,0,0,0,0,0,0,0,1431,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,731,731,731,731,731,731,716,0,0,0,1365,1365,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1296,1296,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,391,454,392,455,1552,1550,0,455,456,456,0,392,0,1605,1605,1605,1605,0,0,1422,0,0,0,0,0,0,0,0,0,0,0,0,1494,1555,1616,0,0,0,0,0,0,0,0,0,1554,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1746,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,1545,1546,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1431,1431,0,0,0,0,1431,0,0,0,0,0,1431,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,0,0,0,0,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,717,1294,1297,0,0,0,0,0,0,0,0,0,0,836,0,0,0,0,0,0,0,0,0,0,0,0,391,392,0,391,0,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,836,0,0,0,0,0,0,0,1430,0,0,0,0,0,0,1681,1682,1683,0,0,0,1554,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1811,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,1546,0,0,0,0,1419,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,1690,0,1690,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,0,0,0,0,0,0,0,0,0,0,0,0,737,0,0,740,0,0,0,1294,0,0,0,0,0,0,0,456,773,773,651,773,836,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,646,0,517,710,392,0,0,0,0,0,0,0,1494,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,0,0,0,0,1419,513,514,0,0,0,0,0,0,0,0,0,0,733,733,731,732,732,732,732,732,731,732,732,732,732,732,731,0,1431,0,1365,1365,716,0,1690,0,0,0,1689,1690,0,0,0,716,0,0,0,0,0,0,0,0,0,779,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1192,1193,1194,0,1192,1193,1194,0,1192,1193,1194,0,0,0,1626,1627,1628,0,0,0,0,0,0,801,0,0,804,0,0,0,717,717,0,1057,1058,1059,456,710,773,651,392,455,710,646,392,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,710,517,651,710,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,1931,1933,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,1545,0,0,0,0,1419,0,0,1348,967,962,1347,962,1281,1217,1153,1348,1348,1348,967,1217,962,1347,1347,1281,962,1281,1347,1348,967,962,1281,0,0,0,717,717,653,0,0,0,1690,0,0,0,0,717,717,653,0,0,0,0,0,0,0,841,842,843,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,646,651,1122,1123,710,710,710,0,0,0,392,392,836,0,0,0,0,1494,1555,1555,1555,1555,1555,1555,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,0,1494,1555,456,0,0,0,0,0,1430,1428,0,0,0,0,0,0,0,0,1993,1935,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,0,0,0,0,1419,1304,1368,1304,1368,1303,1368,1304,1368,1368,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,0,0,1690,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,710,651,651,651,710,456,0,0,0,0,0,651,0,0,1118,1119,1120,0,0,0,0,0,0,1554,1555,1555,1555,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,391,580,456,0,0,0,0,0,1427,1428,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1419,1368,1368,1303,1303,1304,1368,1368,1303,0,0,0,0,0,0,0,0,0,0,0,0,1431,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,392,392,646,0,0,0,0,0,836,392,646,0,0,1492,0,0,0,1753,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,392,456,456,456,0,0,0,0,0,0,0,1427,1427,1428,0,0,0,1551,1550,1551,1426,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,328,0,0,0,0,0,0,1304,1368,1368,1368,1303,1304,1368,1303,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1431,0,0,0,1690,0,0,0,0,0,0,0,0,1690,0,1690,0,0,0,0,0,731,731,731,731,731,731,731,731,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,836,773,773,836,456,456,0,0,0,0,392,456,773,651,0,1430,1428,0,0,0,0,0,0,0,0,1426,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,392,455,0,0,1494,1555,1555,1555,1555,1493,0,0,0,1551,1487,1552,1614,1616,1550,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,643,0,706,0,706,1545,1546,1304,1368,1303,1303,1304,1304,1304,1304,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,717,717,717,717,717,717,717,717,653,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,646,0,0,392,773,392,651,0,392,836,836,455,773,710,773,392,1430,1428,0,0,0,0,1753,0,1426,1429,0,0,1230,1233,1297,1297,1297,1297,1297,1233,1233,1231,1231,1297,718,0,0,0,0,580,455,392,0,1492,1422,1424,1551,1423,1554,1493,0,0,1427,1424,1486,1424,1552,1422,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,263,327,328,643,0,643,1304,1304,1304,1368,1304,1304,1303,1304,1368,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,455,0,0,773,456,773,710,392,392,517,651,0,0,0,0,710,0,1430,1427,1428,0,0,0,0,1490,0,0,0,1358,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,716,0,0,0,0,516,391,456,0,1492,1487,1551,1488,0,0,1554,0,0,0,1427,1552,1486,1552,1487,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,2000,1865,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,706,328,327,327,264,706,1303,1304,1304,1304,1304,1304,1303,1368,1368,1368,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1431,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,667,667,667,667,667,667,667,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,651,773,773,392,646,0,0,0,0,0,0,0,836,0,0,0,0,0,0,1430,1427,1428,0,0,1490,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,653,0,0,0,0,392,516,391,0,1430,1428,1487,1552,0,0,1488,0,0,0,0,1427,1427,1427,1427,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,1801,0,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,643,327,327,264,0,1303,1303,1304,1368,1304,1368,1368,1304,1304,0,0,0,0,0,0,0,0,0,1431,0,0,0,0,0,1431,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,731,731,731,731,731,731,0,718,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,0,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,583,519,0,0,0,0,710,0,646,456,0,0,0,0,0,0,1430,1427,1427,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,456,516,392,0,0,0,1428,1424,1487,1550,1426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,264,263,264,643,0,706,1368,1303,1304,1368,1304,1368,1303,1303,0,0,0,1431,0,0,0,0,1431,1431,0,0,0,0,1431,1431,1431,0,0,0,0,0,0,0,0,1690,0,0,1753,0,0,0,0,0,0,0,0,717,717,717,717,0,0,717,0,716,0,0,0,0,0,716,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,520,715,715,584,584,520,0,0,0,773,651,0,0,0,0,392,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,392,1361,0,0,1430,1427,1427,1427,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1348,967,1348,1281,1217,1347,1347,967,0,1347,1217,1153,1281,1281,962,1217,1347,1153,1153,1281,1347,962,962,0,0,0,0,0,0,716,1753,0,1690,0,0,1690,1690,0,0,0,716,0,0,0,0,0,0,0,0,841,842,843,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,519,715,715,715,715,715,715,584,583,836,836,0,0,0,0,0,580,456,516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,391,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,327,328,263,264,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,784,0,0,0,0,0,0,0,733,733,731,733,733,733,733,733,731,733,733,733,733,733,731,0,0,0,0,0,716,0,0,0,1753,0,0,1690,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,583,583,715,715,715,715,715,584,583,0,0,0,0,0,0,0,0,455,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,1551,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,327,327,263,327,263,264,0,0,0,0,0,0,0,0,0,0,0,513,514,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,653,1690,0,0,0,0,0,1689,0,717,717,653,0,0,0,0,0,0,0,0,0,0,779,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,519,583,583,583,520,715,715,520,0,1494,1493,1494,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1551,1422,1424,1551,456,580,455,392,0,0,0,456,580,392,516,580,580,0,0,0,0,717,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,263,263,264,1409,1540,263,263,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,841,842,843,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,520,584,520,583,0,0,1494,0,0,0,1554,1555,1555,1555,1555,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1488,0,1753,0,0,1422,1422,1551,1487,1488,1550,1487,1488,392,0,0,0,0,0,516,391,580,516,516,455,391,580,773,456,717,717,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,327,263,0,0,1801,0,1865,0,0,0,264,327,1538,1473,1537,1475,327,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,1690,0,0,0,1690,0,0,0,0,0,0,0,0,667,667,667,667,667,667,667,0,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1494,0,0,0,0,0,0,0,0,1616,1554,1493,0,0,0,0,0,0,0,0,0,0,0,0,391,773,0,0,0,1551,0,0,1486,1551,1488,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,516,392,773,391,392,516,0,0,0,716,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,263,263,263,0,0,1801,0,1865,0,0,1410,1473,1538,1537,1412,1539,328,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,1690,0,0,0,0,0,0,0,0,731,731,731,731,731,731,731,731,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1614,1552,1490,0,0,0,0,0,0,0,0,0,0,0,0,456,392,0,0,0,0,0,0,0,1423,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,392,456,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,264,263,264,328,263,0,0,264,327,327,264,264,1412,0,0,1993,1869,1935,0,1409,1410,1409,1475,1539,1474,327,328,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,1690,0,0,0,1690,0,0,0,0,1493,0,0,0,0,0,0,717,717,717,717,717,717,717,717,653,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1494,0,0,0,0,0,0,0,0,0,0,1551,1426,1429,0,0,0,1556,0,0,0,0,0,1494,1555,1493,456,392,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,580,516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,264,263,1475,1412,327,327,327,263,1537,1411,1410,1476,328,0,0,0,0,0,264,1540,1537,1475,1410,264,327,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,731,731,731,731,731,731,731,731,731,716,0,0,0,0,0,0,1753,0,1753,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,1494,1619,1620,0,0,0,0,1616,1551,1488,1487,1618,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,328,0,263,264,327,1475,1474,1538,1411,1409,1476,0,0,1931,1805,1933,0,328,1411,1538,1540,327,263,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,717,717,717,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,716,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,519,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,0,1554,1554,1493,0,1428,0,1426,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,264,1474,1412,1411,1540,1412,1474,1537,0,0,1801,0,1865,0,327,263,328,327,264,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,1690,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,519,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1493,0,0,0,0,0,0,0,0,1427,1427,1429,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,328,327,328,328,328,263,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,1365,1365,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,1690,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1869,1869,1869,1935,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,583,519,583,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1494,1620,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,263,264,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,1365,717,0,0,0,0,731,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,1690,0,0,0,0,0,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,520,520,584,584,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1555,1555,1555,1555,1555,1493,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,391,1630,1631,1632,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,1365,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,718,0,1494,0,0,0,1690,0,0,1753,1690,0,0,0,0,0,718,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,519,584,584,584,583,584,584,583,583,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,1554,0,0,0,391,773,580,0,0,0,1492,0,0,0,0,0,0,0,0,0,1026,1027,1028,1029,1030,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,731,731,731,731,731,0,0,0,716,0,1492,0,1753,0,0,0,0,0,0,0,0,0,0,0,716,0,0,779,0,0,0,0,716,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,584,584,584,519,584,583,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,1554,0,0,580,455,455,516,0,0,1492,0,0,0,0,0,0,0,0,0,1090,1091,1092,1093,1094,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,0,0,0,716,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,716,841,842,843,0,0,0,0,716,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,583,520,583,519,519,0,0,0,0,0,0,0,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1493,455,516,455,773,0,1494,1556,0,0,0,0,0,0,0,0,0,1154,1155,1156,1157,1158,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,391,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,1492,0,0,0,0,0,0,0,0,0,718,0,0,0,716,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,520,584,520,519,0,0,0,0,0,0,0,0,392,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1493,456,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,1218,1219,1220,1221,1222,0,0,0,0,0,0,1690,0,0,1690,0,0,0,0,0,0,391,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,945,946,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,584,520,520,0,0,0,0,0,0,0,0,0,0,516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1493,0,0,1494,1556,0,0,0,0,0,0,0,0,0,0,1282,1283,1284,1285,1286,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,455,516,456,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,718,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1009,1010,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,0,1555,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,773,580,516,516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1073,1074,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1617,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,1365,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,945,946,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,392,455,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,717,1365,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1009,1010,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,456,455,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,1365,0,1365,0,716,0,0,0,0,0,0,0,0,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1073,1074,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,456,391,773,456,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,1993,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,653,0,0,0,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,945,946,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,455,456,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1620,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,391,516,1297,1361,1360,1360,1361,1360,1361,1360,1360,1297,1297,0,0,0,0,1361,1361,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1009,1010,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,580,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,580,580,717,717,717,717,717,717,717,717,717,717,1361,0,0,0,1361,717,717,653,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1073,1074,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,455,580,773,392,1428,0,0,0,0,0,0,0,0,1361,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1737,0,0,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,945,946,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,580,455,455,516,1430,1427,1428,0,0,0,0,0,0,1297,0,0,0,716,0,0,0,0,0,0,1557,1620,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,513,514,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1009,1010,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,516,391,455,392,0,1430,0,1430,1427,1428,0,0,0,0,1361,0,0,0,716,0,0,1425,0,0,1426,1553,0,0,1425,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,513,514,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1073,1074,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,456,580,516,392,0,0,0,0,0,0,1492,0,0,0,1360,1361,0,0,0,716,0,0,0,0,1426,1429,1430,1427,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,945,946,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,516,456,456,455,516,0,0,1810,0,0,0,0,1492,0,0,0,1297,1297,0,0,0,716,0,0,1426,1427,1429,715,715,715,1430,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,368,369,370,371,0,0,0,1009,1010,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,580,580,0,0,0,0,0,0,0,0,0,0,1492,0,1426,1427,1297,1361,0,0,0,716,0,0,1490,715,715,715,715,715,715,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,432,433,434,435,0,0,0,1073,1074,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,1931,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,455,516,455,0,0,0,0,1810,0,0,0,0,0,1430,1427,1429,0,1360,1297,0,0,0,716,0,0,1554,1493,715,715,715,715,1494,1556,0,0,1425,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,516,456,0,0,0,0,0,0,0,0,0,0,0,1810,0,0,0,1361,1360,0,0,0,716,0,0,0,1554,1555,1555,1555,1555,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,1931,1674,1677,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,0,0,0,716,0,0,0,0,0,1618,1619,1620,0,1425,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,1931,1805,1674,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1360,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1066,1067,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,1931,1805,1805,1674,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1360,1361,0,0,0,0,0,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1130,1131,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1556,0,0,0,0,1931,1674,2000,2000,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1193,1194,1195,0,0,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,1677,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1297,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,1681,1682,1683,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1192,1193,1194,0,1192,1193,1194,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,1677,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1360,1297,1297,1361,1360,716,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,1675,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,1993,1737,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1426,1427,1427,1427,1427,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1737,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1426,1427,1427,1427,1427,1427,1429,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1358,1361,0,0,1361,1361,1360,0,1360,1361,1361,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,1426,1429,0,0,0,0,0,0,0,0,0,0,1430,1427,1427,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,1677,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1677,1935,0,0,0,0,0,0,0,0,0,0,1358,1361,1361,1361,0,0,717,717,717,717,717,717,717,717,717,717,717,0,0,0,0,0,0,0,1361,0,0,716,0,0,0,0,0,0,0,0,0,1360,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,1426,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,1861,1861,1861,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,717,1360,1360,1360,1297,1361,1360,716,0,0,0,0,0,0,1297,1361,1297,1360,1361,1361,1360,1297,716,0,0,0,1426,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1737,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,1677,1935,0,0,0,0,0,0,0,0,0,0,0,1861,1927,0,0,0,1985,1861,1861,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1678,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,653,0,0,0,0,0,0,717,717,717,717,717,717,717,717,653,0,0,0,1490,0,0,0,0,0,0,0,0,513,514,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,2000,0,0,2000,2000,1677,1935,0,0,0,0,0,0,0,0,1861,1861,1861,1927,0,0,0,1494,1556,1551,1551,1487,1989,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1869,1869,1869,1869,1869,1869,1737,0,0,0,0,1865,0,0,0,0,0,0,1861,1861,1927,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1494,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,1865,0,0,1861,1861,1861,1927,0,0,0,0,0,1630,1631,1632,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,1801,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1678,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1355,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1357,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1555,1555,1493,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,1865,0,1927,0,0,0,0,0,0,0,0,0,0,0,0,1494,1555,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,1690,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1355,1356,1354,1355,1356,1353,1352,1356,1354,1355,1356,1354,1352,1356,1357,1229,716,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1555,1493,0,0,0,0,0,0,0,0,0,1494,0,0,0,0,0,0,0,0,0,0,0,1681,1682,1683,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,1865,1857,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,1293,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,1494,1555,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1677,1869,1935,1857,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1357,716,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1490,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1816,1817,0,0,0,0,0,1801,0,0,1865,1816,1817,1857,0,0,0,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,1753,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,653,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1555,1555,1555,1555,1555,1555,1555,1556,0,0,0,0,0,0,0,0,0,1681,1682,1683,0,0,0,0,0,0,1669,1861,1861,1861,1861,1861,1861,1729,0,0,0,1993,1869,1869,1935,0,0,1857,0,0,0,589,590,0,0,0,0,0,0,0,1494,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,1669,1861,1927,0,0,0,0,0,0,1985,1861,1729,0,0,0,0,0,0,0,1667,1797,1925,0,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,1690,0,1753,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,716,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1816,1817,1669,1861,1861,1927,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,1667,1925,0,0,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,1993,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1669,1927,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,1667,1797,1925,0,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1355,1356,1355,1354,1355,0,0,1355,1356,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1669,1927,0,0,0,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,0,0,0,0,0,0,0,0,1667,1925,0,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,0,0,717,717,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1816,1817,0,0,1857,0,0,0,0,0,0,0,0,0,0,0,0,1923,1797,1666,0,0,0,1931,1805,1805,1805,1805,1933,0,0,0,0,0,1667,1925,0,0,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,1753,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,791,792,793,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1816,1817,0,1857,0,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,1931,1674,0,0,0,0,1675,1805,1933,0,0,0,0,1667,1797,1925,0,0,0,1492,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,1797,1797,1797,1797,1797,1797,0,0,0,0,1993,1869,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,781,781,781,781,781,781,0,0,0,0,0,1690,0,1690,0,0,0,1689,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1857,0,0,0,0,0,0,589,590,0,1923,1797,1666,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,1667,1797,1925,0,1492,589,590,0,0,0,0,0,0,0,0,0,717,653,1797,1797,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,0,0,0,0,0,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,716,0,0,1355,1354,1355,1356,1352,1356,1357,0,716,0,0,0,0,0,0,0,0,781,781,781,781,781,781,0,0,0,0,0,1753,0,1690,0,1753,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1857,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,1667,1797,1925,0,0,0,0,0,0,0,0,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1737,0,0,0,0,0,0,0,0,1677,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1360,1360,1231,1296,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1357,1354,1357,1354,1357,1352,1354,1357,716,0,0,0,0,0,717,717,717,653,0,0,717,717,717,717,717,717,717,0,716,0,0,0,0,0,0,0,0,781,781,781,781,781,781,718,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1667,1797,1797,1797,1797,1797,1797,1797,1797,1666,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,1667,1797,1797,1797,1797,1797,717,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1869,1869,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1361,1361,1361,1361,1361,1361,0,0,0,0,0,0,0,0,0,1865,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,0,0,0,0,0,0,716,0,0,0,0,0,0,985,0,0,0,1049,904,0,716,0,0,0,0,0,0,0,0,781,781,781,781,781,781,716,0,0,0,0,0,1689,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,717,717,717,717,717,717,0,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,781,781,781,781,781,781,716,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,2000,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,1355,1353,1356,1357,1352,1357,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,0,0,0,1681,1682,1683,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,2000,2000,2000,2000,2000,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,1049,0,0,0,0,716,0,0,0,0,0,0,0,0,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,1677,1869,1869,1737,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,1669,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1729,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,0,0,0,0,0,0,0,0,1865,0,1690,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,1677,1935,1992,1992,1801,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,1669,1861,1927,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1985,1729,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,855,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,1677,1935,1992,1690,1992,1993,1869,1737,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,1669,1927,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,0,0,0,0,0,0,0,0,1865,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,717,717,717,717,855,0,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,1793,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,1865,1992,1992,1992,1992,1753,0,1993,1869,1869,1869,1869,1869,1869,1869,1869,1869,1935,1811,0,0,0,0,0,0,0,0,1669,1927,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,2000,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,1810,0,0,0,0,0,0,855,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,1865,1992,1753,1753,1992,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1857,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,2000,2000,2000,2000,2000,0,0,0,0,0,0,1677,1935,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,653,0,0,0,0,0,902,903,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,1677,1869,1869,1869,1869,1935,1992,1992,1992,1992,0,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1857,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1923,1925,0,0,0,1923,1666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,2000,0,0,0,0,0,0,1865,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1805,1805,1674,0,0,0,0,0,0,0,1675,1933,0,1690,0,0,1690,1992,1753,1992,1931,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1933,1811,0,0,0,0,0,0,0,0,1667,1925,0,0,0,0,0,0,0,0,0,1923,1797,1797,1797,1797,1797,1666,1667,1797,1797,1797,1666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,2000,2000,2000,2000,0,0,0,0,0,1677,1935,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,1690,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,985,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,1992,1690,1992,1690,1801,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,1931,1805,1805,1933,1667,1925,0,0,0,1923,1797,1797,1797,1797,1666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,1816,1817,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,653,0,1049,0,0,0,716,0,0,0,1685,1686,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,1753,1801,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,1931,1674,0,0,1865,0,1667,1797,1797,1797,1666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,1415,0,0,0,717,717,717,717,717,717,717,717,717,717,653,0,0,1417,1419,513,514,0,0,0,0,0,0,0,0,0,0,0,0,1484,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1746,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,1689,1931,1674,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,1801,0,0,0,1865,0,0,0,0,0,0,1931,1805,1805,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,2000,0,0,0,0,1677,1935,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1816,1817,0,0,0,0,0,0,1416,0,0,0,0,0,0,0,0,0,0,0,1415,0,0,0,0,1417,0,1483,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,1484,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,1931,1674,0,0,0,1675,1933,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,2000,2000,2000,0,0,0,0,1865,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,1426,1427,1427,1427,1620,0,0,0,0,0,0,0,0,0,0,0,0,0,1419,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1483,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1484,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1810,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,1793,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1935,0,0,1931,1805,1674,0,0,0,0,0,1675,1805,1805,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,1675,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,2000,0,0,0,0,1865,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1426,1426,1429,0,0,1494,0,0,0,0,0,0,0,0,0,0,0,1484,0,0,0,1611,0,0,0,1609,1610,1611,0,0,0,1417,1418,1420,0,0,1483,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1811,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1869,1737,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1935,0,0,0,0,1801,0,2000,0,0,0,0,2000,2000,2000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,2000,2000,0,0,0,0,1865,0,0,0,1690,0,1690,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,1426,1426,1429,1494,1555,1555,1556,0,0,0,0,0,0,1753,0,1690,0,0,0,1546,1485,1416,0,0,1415,0,0,0,0,0,0,1417,0,0,0,0,0,1483,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1481,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,0,0,1993,1869,1869,1869,1869,1737,0,0,0,0,0,0,0,0,1677,1869,1869,1869,1935,0,0,1993,1869,1869,1737,0,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,2000,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,0,1865,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1426,1426,1429,1555,1556,0,0,0,0,0,1816,1817,0,0,0,0,0,0,0,1554,0,0,0,0,0,0,0,0,0,0,0,0,1481,0,0,0,0,0,1483,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1417,1418,1420,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,1993,1869,1869,1869,1869,1737,0,0,0,1935,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,1677,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1554,1556,0,0,0,0,0,0,0,1690,1931,1805,1805,1933,1690,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,1545,1546,0,0,0,0,0,1419,0,0,0,0,0,0,0,0,0,0,0,1492,1417,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1869,1869,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1869,1935,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,0,1865,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,1546,1546,0,0,0,1419,0,0,0,0,0,0,0,1417,1418,1418,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,0,0,0,0,0,0,0,1923,1666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,0,1865,0,1690,1690,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,1865,0,0,0,0,1426,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,1545,1546,0,0,1419,0,0,0,0,0,1609,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,1988,1730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1684,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1869,1869,1869,1869,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,0,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,1801,0,0,1675,1933,0,0,0,1554,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,1546,0,1418,1418,1419,0,0,0,1545,1546,1485,1492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,1355,717,717,717,717,717,717,717,0,716,0,0,0,0,0,0,0,0,0,0,1985,1861,1861,1861,1861,1861,1861,1729,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,1992,0,0,0,0,1429,0,1492,0,0,0,0,0,0,0,0,0,0,0,1426,1428,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,1865,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,1546,0,0,1419,0,0,0,0,0,345,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,653,0,0,0,1049,0,985,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1985,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1861,1729,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,1992,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,1426,1490,1492,0,0,0,0,0,0,0,0,0,1690,0,1801,0,0,0,0,1865,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1545,1546,1547,0,0,0,0,0,408,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1985,1861,1861,1861,1861,1861,1861,1861,1861,1729,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,1992,0,0,0,1490,0,0,1430,1620,0,0,0,0,0,0,0,1426,1427,1427,1429,1492,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,1865,0,0,0,0,1490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,408,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,1985,1861,1861,1729,0,0,0,0,1993,1869,1737,0,0,0,0,0,0,0,0,0,1677,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1426,1429,0,0,0,1492,0,0,589,590,0,0,0,0,0,0,0,1801,0,0,0,0,1865,0,0,0,0,1554,1555,1555,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,408,0,1428,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,781,781,781,781,781,781,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,1985,1861,1729,0,0,0,0,1801,0,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,2000,0,0,0,1992,0,0,0,0,0,0,0,1492,0,0,0,0,0,1426,1429,0,0,0,1494,1556,0,0,0,0,0,1121,1122,1123,1124,0,0,1801,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,535,535,535,535,535,535,535,535,535,535,535,535,536,0,0,0,0,534,535,535,535,535,472,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,781,781,781,781,781,781,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1737,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,1992,0,0,0,0,0,0,0,1430,1427,1428,0,0,1426,1429,0,0,0,0,1492,0,0,0,0,0,1489,0,0,0,1690,0,0,1801,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,718,1555,1555,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1428,0,0,0,0,717,717,717,717,717,717,717,1357,716,0,0,0,781,781,781,781,781,781,718,0,0,0,0,0,0,717,717,717,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,1985,1861,1861,1861,1729,0,0,1993,1869,1737,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,0,0,0,0,1931,0,0,0,0,0,0,1992,0,0,0,0,0,0,0,0,0,1427,1427,1429,0,0,0,0,0,1492,0,0,0,0,1426,1427,1428,0,0,0,0,0,1801,0,0,0,0,1865,0,0,0,0,0,0,0,1291,1292,1289,1291,1292,1293,716,0,0,0,0,0,0,1555,1555,0,0,0,1556,0,0,0,0,0,1554,1555,1555,0,0,0,0,0,0,1620,0,0,0,716,1049,0,0,1049,0,985,0,716,0,0,0,781,781,781,781,781,781,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1985,1729,0,0,0,1801,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1430,1428,0,0,1426,1429,0,1556,0,0,0,0,1931,1674,0,0,0,0,1865,0,0,0,0,0,0,0,1355,1356,1353,1355,1356,1357,716,0,0,0,0,0,0,0,0,1555,1555,1555,0,0,0,0,0,0,0,0,0,1554,1555,1555,0,0,1556,0,0,0,0,716,0,0,0,1049,0,0,0,653,0,0,0,781,781,781,781,781,781,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,741,742,743,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1985,1729,0,0,1801,0,0,0,0,1865,1682,1683,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1427,1427,1429,1121,1122,1123,1124,0,0,0,1801,0,0,0,0,0,1865,0,0,0,0,0,0,0,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1554,1556,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1355,1353,1356,1357,1352,1357,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,805,806,807,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,1793,0,0,1801,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,718,0,0,0,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,1992,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1793,0,0,0,1801,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,1121,1122,1123,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1630,1631,1632,0,0,1121,1122,1123,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,0,0,0,0,0,0,0,0,0,0,0,0,0,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1427,1427,1427,1427,1427,1427,0,0,0,0,0,0,0,0,1427,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,1428,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,1426,1427,1427,0,0,0,0,0,0,1427,1427,1427,1427,1427,1427,1427,1427,0,717,717,717,717,717,717,717,717,717,653,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1630,1631,1632,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1992,1992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1427,1429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1805,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1992,1992,1992,1992,1992,0,0,0,0,0,0,0,0,1931,1805,1805,1805,1674,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,1931,1805,1674,2000,0,0,0,0,0,0,0,0,0,1675,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1992,1992,1992,1992,1992,1992,1992,1992,1992,1992,0,0,0,2000,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,0,0,0,1805,1805,1805,1805,1805,1805,1805,1805,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1925,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,2000,0,0,1675,1805,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,1931,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,1925,0,0,0,0,0,0,0,1923,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1935,0,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1935,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,0,0,1677,1869,1869,1869,1869,1869,1869,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1935,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1805,1805,1805,1805,1805,1674,0,1677,1869,1869,1869,1935,0,0,0,0,0,0,1993,1869,1869,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1869,1869,1935,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1933,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,1677,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,1993,1869,1737,0,0,0,0,0,0,0,0,0,0,0,0,0,1677,1869,1869,1935,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,1993,1869,1869,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,1931,1805,1805,1933,0,0,0,0,0,1993,1869,1737,0,0,0,0,0,1677,1869,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1996,1930,1807,1674,0,0,1675,1805,1805,1933,0,0,0,0,1993,1869,1869,1869,1869,1869,1935,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1805,1805,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1805,1805,1805,1805,1805,1933,0,0,0,0,0,0,1993,1869,1737,0,0,0,0,0,1675,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,1993,1869,1869,1869,1737,0,0,0,0,1865,0,0,0,0,0,0,0,1931,1805,1805,1805,1805,1805,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,1993,1869,1869,1869,1869,1935,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1931,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1933,0,0,0,0,0,1931,1805,1805,1805,1805,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1805,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":250,"id":2,"name":"Ground2","opacity":1,"type":"tilelayer","visible":true,"width":250,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1073,1074,1075,1076,1201,1202,1203,1204,1142,1143,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1137,1138,1139,1140,1265,1266,1267,1268,1206,1207,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1995,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1201,1202,1203,1204,1142,1143,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1929,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1265,1266,1267,1268,1206,1207,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,603,0,0,0,0,603,0,0,0,0,0,0,603,0,0,0,0,603,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,669,669,669,669,667,669,669,669,669,667,669,669,669,669,669,669,667,669,669,669,669,667,668,668,668,668,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,0,0,0,0,0,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1999,0,0,0,0,0,0,0,0,904,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,905,0,0,0,902,903,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,603,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,1628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,969,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,669,669,669,669,669,667,669,669,669,669,669,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,1562,1563,1564,0,0,0,0,0,543,0,0,1055,1056,0,0,0,0,1688,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1999,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,680,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,1626,1627,1628,0,321,322,0,0,0,0,1118,1119,1120,0,0,0,0,1752,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,669,669,669,669,669,669,667,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,385,386,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,0,1124,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,1690,0,1881,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,669,669,669,669,667,0,0,0,0,0,0,603,0,0,0,603,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,669,669,669,602,0,0,603,0,0,0,0,730,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,602,0,0,0,0,667,669,669,669,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,666,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,1566,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1881,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,666,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,1630,1631,1632,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,680,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,525,526,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,730,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,321,322,0,1055,1056,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,602,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,385,386,1118,1119,1120,1562,1563,1564,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,1748,1749,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,666,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,1626,1627,1628,0,0,0,0,0,0,0,0,0,1816,1817,0,0,0,0,0,0,0,589,590,0,0,0,0,0,1812,1813,1814,1815,0,0,0,1032,1033,0,0,0,0,0,0,1230,1231,1231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,730,0,0,666,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1746,0,0,0,0,0,0,0,1096,1097,0,0,0,0,0,0,0,1295,1295,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,668,667,0,0,666,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1688,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,603,0,0,603,0,603,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1746,0,0,1752,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,669,667,0,0,667,669,602,669,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,1688,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1745,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1054,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,667,669,669,669,669,669,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1809,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,1688,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1811,0,0,0,0,1811,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,1688,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,496,497,498,499,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,1816,1817,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,381,560,561,562,563,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,244,245,624,625,626,627,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,666,0,0,0,603,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,308,309,310,311,945,946,947,948,1137,1138,1139,1140,1066,1067,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,1297,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,603,0,0,0,0,0,730,0,0,0,667,669,669,669,669,667,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,372,373,374,375,1009,1010,1011,1012,1201,1202,1203,1204,1130,1131,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,669,669,667,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,436,437,438,439,1073,1074,1075,1076,1014,1015,1016,1017,1194,1195,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1231,1231,1231,1231,1231,1231,1231,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,0,0,0,0,0,1230,1231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1137,1138,1139,1140,1078,1079,1080,1081,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1231,1296,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,947,948,1202,1203,1204,1142,1143,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1296,1296,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1011,1012,1015,1016,1268,1206,1207,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,534,535,535,535,536,0,0,0,0,0,1748,1749,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1296,1296,1297,1297,1296,1296,0,0,0,0,0,0,0,1296,1297,1233,1296,1297,1296,1231,1231,1233,1231,1296,1233,1231,1296,1233,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,1079,1080,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1233,0,0,0,0,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,1361,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,668,668,668,668,668,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,1748,1749,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,931,932,0,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1231,1359,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,1128,1129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,0,0,0,1230,1233,1233,1231,1231,1296,1231,1296,1233,1231,1233,1231,1231,1231,1360,1361,1297,1360,0,0,1230,1231,1231,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,1198,1199,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1118,1119,1120,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,730,0,0,0,0,0,0,0,0,1297,1360,1294,1297,1361,1361,1360,1361,1361,1361,1297,1297,1360,1360,1361,1361,1360,1361,1360,1360,0,0,1294,1297,1361,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1816,1817,0,0,0,0,0,0,0,1753,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,1681,1682,1683,0,479,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,1753,1684,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,479,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1881,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,1689,0,0,0,0,1753,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,1689,0,1816,1817,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,669,669,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,669,669,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,731,733,733,1237,1235,1300,1237,1235,1235,1235,1235,1235,1300,1300,1237,1237,1235,1237,1237,1300,1234,0,0,0,0,0,0,0,0,0,1234,1237,1300,1237,1300,1237,1235,1235,1237,1300,1237,1235,1235,1237,1237,1235,1300,1237,733,733,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,1816,1817,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1365,1298,1298,1365,1365,1365,1298,1365,1365,1298,1365,1365,1298,1298,1298,1298,1298,0,0,0,0,0,0,0,0,0,1298,1365,1298,1365,1365,1298,1298,1365,1298,1365,1298,1298,1298,1298,1365,1298,1365,1365,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,373,883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,1753,0,1690,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,946,947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,1753,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,479,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1748,1749,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,1753,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,1566,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,456,520,0,1745,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,455,710,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1422,456,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1745,0,0,0,968,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1300,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1364,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1066,1067,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,908,908,908,908,908,908,908,0,0,0,0,1300,1300,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1130,1131,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,667,667,667,667,667,667,667,0,0,0,0,1364,1364,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,904,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1748,1749,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,603,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,1235,1237,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1066,1067,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,1362,1237,1234,667,668,668,668,668,668,667,668,668,668,668,668,667,0,0,0,1235,1236,0,0,0,0,0,0,0,0,0,1235,1236,0,0,0,0,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1130,1131,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,905,0,905,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,1365,1365,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,969,0,969,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,1365,1365,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,908,908,908,908,908,908,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1681,1682,1683,0,1748,1749,1750,1751,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,1681,1682,1683,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1121,1122,1123,1124,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,908,908,908,908,908,908,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,667,667,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,1299,1300,0,0,0,0,0,0,0,0,0,1235,1236,0,0,0,0,0,0,0,0,0,777,778,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,668,668,668,668,668,667,668,668,668,668,668,667,0,0,0,1300,1301,0,0,0,0,0,0,0,0,0,1299,1300,0,0,0,0,0,0,0,0,0,0,0,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,777,778,0,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,908,908,908,908,908,908,908,908,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1295,1295,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1232,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,618,619,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,682,683,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,746,747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,113,114,115,115,116,117,118,945,0,810,811,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1300,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,177,178,179,179,180,181,182,1009,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,241,242,243,243,244,245,246,1073,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1233,1233,1233,1233,1295,0,0,0,0,0,0,0,0,306,307,0,0,0,0,0,1137,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1359,1359,1231,1359,1231,1231,1231,1233,1359,1359,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1295,1295,1295,1233,1233,0,0,0,370,371,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1360,1297,1360,1361,1360,1297,1297,1297,1360,1360,1297,0,0,0,1360,1360,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1360,1297,1361,1360,1360,1361,1297,1360,1361,1361,1361,0,0,1360,1297,1360,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,306,307,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1360,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,0,0,0,0,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,306,307,0,0,0,0,0,0,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,0,0,0,0,0,0,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,0,0,179,180,0,0,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,306,307,0,0,243,244,309,310,0,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,901,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,370,371,0,0,499,500,373,374,0,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,905,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,434,435,0,0,563,564,625,626,0,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,969,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,496,497,498,499,502,503,946,947,948,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1748,1749,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,902,903,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,560,561,562,563,437,1009,1010,1011,1012,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,624,625,626,627,1076,1073,1074,1075,1076,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1235,1364,1235,1362,1362,1364,1362,1364,1237,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1140,1137,1138,1139,1140,1137,1138,1139,1140,1066,1067,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1298,1365,1298,1365,1365,1365,1298,1365,1364,1362,1237,1362,1362,1362,1237,1237,1235,1362,1235,1237,1237,1237,1364,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1204,1201,1202,1203,1204,1201,1202,1203,1204,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1748,1749,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,1298,1298,1298,1365,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1268,1265,1266,1267,1268,1265,1266,1267,1131,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1812,1813,1814,1815,0,0,0,0,0,0,1230,1359,1233,1233,1359,1231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1297,1360,1360,1361,1361,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1166,1105,0,0,0,0,0,0,0,0,0,0,0,1040,976,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,1104,1102,912,0,0,0,0,0,0,0,1361,1297,1361,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,910,976,1103,913,1105,0,0,0,1231,1361,1232,1295,1297,1231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1231,1231,1230,1231,1231,1230,1231,1231,1230,1230,1230,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,1296,975,911,1169,976,0,0,0,1358,1359,1358,1359,1232,1295,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1231,1230,1231,1231,1230,1294,1360,1360,1360,1360,1360,1360,1360,1360,1360,1296,1230,1230,1231,1231,1230,1231,1231,1231,1230,1231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,387,0,0,0,0,387,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1230,1295,1294,1168,1169,0,0,0,1230,1230,1360,1295,1358,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1361,1360,1360,1361,1296,0,0,0,0,0,0,0,0,0,0,0,1294,1360,1360,1360,1360,1360,1360,1360,1360,1360,0,0,0,0,0,0,0,0,0,0,1230,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1360,1231,1296,1231,1039,911,0,0,0,1233,1358,1230,1361,1359,1294,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1231,1231,1231,1231,1233,0,0,0,0,0,0,0,1230,1231,1231,1231,1231,1231,1231,1233,0,0,0,0,0,0,0,387,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1360,1102,975,0,0,0,1233,1232,1232,1233,1231,1231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,905,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,387,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1359,1230,0,0,0,1359,1295,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,969,0,0,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1227,1227,1228,1228,1226,1227,1228,1226,1227,1228,1226,1227,1228,1226,1227,1228,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1359,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,387,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,1292,1290,1291,1292,1289,1288,1292,1290,1291,1292,1290,1288,1292,1293,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,387,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,346,347,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,387,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,534,535,535,536,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,534,535,535,535,536,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,1292,1291,1290,1291,0,0,1291,1292,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1752,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1685,1686,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1360,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1295,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1227,0,0,0,0,0,0,0,0,1365,1365,1365,0,0,0,1291,1290,1293,1290,1288,1292,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,1290,1291,1290,1291,1288,1292,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,1032,1033,0,901,0,0,0,0,0,0,0,0,0,0,0,0,0,1162,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1227,1225,1228,1227,1224,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,345,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,1289,1292,1291,1288,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,408,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1355,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,408,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,791,792,793,0,0,0,0,0,0,0,0,0,0,534,535,535,535,535,472,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,905,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1298,0,0,0,0,0,1032,1033,0,0,0,0,0,968,969,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1096,1097,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1689,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1228,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1298,1298,1298,1298,1298,1298,1298,1298,1298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1355,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1753,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,410,411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,474,475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1226,1224,1226,1227,1228,1224,1226,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1227,1226,1224,1228,1226,1224,1226,1228,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1229,1228,1225,1227,1228,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,716,0,0,0,0,0,0,0,0,0,0,0,1162,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1227,1225,1228,1227,1224,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1291,1289,1292,1291,1288,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1355,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,1567,1568,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1675,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1805,1805,1805,1933,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1805,1805,1805,1805,1805,1805,1805,1805,1805,1674,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,589,590,0,0,0,0,0,589,590,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":250,"id":3,"name":"Middleground","opacity":1,"type":"tilelayer","visible":true,"width":250,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,2000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,2000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2000,2000,2000,2000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1673,1673,1673,1673,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,1673,1673,1673,1673,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,129,129,129,1673,1673,129,1361,1361,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,98,99,100,101,102,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,1310,1311,1312,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,129,781,0,1673,1673,0,781,129,1361,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,129,0,0,0,1673,1673,0,0,0,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,1438,1439,1440,0,0,0,0,0,0,0,0,0,0,737,738,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1673,1673,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,1502,1503,1504,0,0,0,0,0,0,0,0,0,0,801,802,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1114,1115,1116,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,1497,1498,1499,1500,1501,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,929,930,1561,1562,1563,1564,1565,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,1060,1563,1564,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,905,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1561,1562,1563,1564,1565,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,669,669,669,669,669,667,669,669,669,669,669,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,98,99,100,101,102,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,666,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,603,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,321,322,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,525,526,164,165,166,167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1498,1499,1500,1501,0,0,0,0,0,0,0,602,669,669,669,669,669,669,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1312,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,525,526,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,669,669,669,669,602,0,0,0,0,0,0,603,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,669,669,669,602,0,0,603,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,799,800,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,667,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,863,864,1370,1371,1372,1373,0,0,0,0,0,38,39,40,41,42,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1041,912,912,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,1567,1568,0,0,927,928,1434,1435,1436,1437,97,98,99,100,101,102,103,104,105,106,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,129,129,1105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,1498,1499,1500,1501,161,162,163,164,165,166,167,168,169,170,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1039,129,129,129,1166,1104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,525,526,525,526,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,321,322,0,1055,1056,1562,1563,1564,1565,225,226,227,228,229,230,231,232,233,234,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1167,1166,1039,129,129,129,1102,910,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,1750,1751,0,0,0,0,0,0,0,0,1230,1231,1231,976,1041,1167,1166,911,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,1294,1295,1297,0,0,0,911,1040,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1166,1102,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,798,799,800,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,668,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,689,690,691,692,689,690,691,692,692,689,690,691,692,618,619,481,482,483,484,485,486,487,488,489,490,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1688,0,0,0,0,0,0,0,0,0,1231,1231,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,862,863,864,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,603,0,0,603,0,603,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,753,754,755,756,753,754,755,756,756,753,754,755,756,682,683,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,926,927,928,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,667,0,0,667,668,602,668,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,817,818,819,820,817,818,819,820,820,817,818,819,820,0,0,609,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,990,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,124,125,126,127,0,0,0,0,881,882,883,884,881,882,883,884,884,881,882,883,884,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,668,668,668,668,668,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,188,189,190,191,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1688,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,252,253,254,255,0,0,0,0,0,0,0,1009,1010,1011,1012,1009,1010,1011,1012,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,251,252,0,0,0,0,0,0,0,0,1073,1074,1075,1076,1073,1074,1075,1076,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,912,913,977,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,315,316,0,0,0,0,0,0,308,309,310,311,1139,1140,1137,1138,1139,1140,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,129,912,912,1105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1688,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,308,309,310,311,1011,1012,1009,1010,1011,1012,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1167,129,129,129,910,976,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1106,917,1045,1170,1045,1045,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,372,373,374,375,1075,1076,1073,1074,1075,1076,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,0,1230,911,1040,1167,129,129,910,1041,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,980,129,129,129,129,1044,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,916,917,916,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,436,437,438,439,1139,1140,1137,1138,1139,1140,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1104,913,1167,977,1166,976,1105,1105,0,0,1039,1103,1168,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,1361,1359,1359,911,129,129,129,1039,1166,1103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1040,1169,974,976,1103,0,0,0,0,914,979,1108,1171,917,1043,0,0,0,1044,1172,917,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,916,129,980,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,905,0,0,0,0,0,0,0,0,0,0,975,129,129,129,129,129,129,910,0,0,910,1104,1040,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,1361,1230,912,1104,976,129,129,1039,1169,1167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,1168,1166,1166,1169,913,0,0,0,0,0,1235,1237,1237,1298,1235,0,0,0,1044,129,129,1170,1172,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,916,915,129,1044,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,667,668,668,668,668,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,913,1104,976,974,910,976,1168,1102,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,1230,1231,1359,912,974,129,129,1168,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,912,912,1103,1168,912,1103,912,1041,1104,0,0,0,0,0,0,0,0,0,1298,0,0,0,914,916,129,129,129,1106,1172,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,916,978,129,129,916,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,668,668,667,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,0,1233,1233,1231,1231,1233,1233,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,1361,1230,1359,1040,911,912,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1103,1105,1166,1038,911,912,910,1167,1040,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1237,1235,1173,1044,1109,129,129,916,981,978,917,0,0,0,0,0,0,0,0,0,0,1042,1043,1044,1045,1042,1043,1044,1045,1042,916,916,978,129,129,129,1172,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1040,1168,1041,1040,1167,974,1038,1040,1102,913,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1235,1237,1237,916,916,1106,129,129,1109,1109,1045,0,0,0,0,0,0,0,0,1106,129,129,129,129,129,129,129,129,129,129,129,129,129,129,916,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,910,910,1102,974,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1298,1298,1237,1108,980,1170,1043,1172,1044,1172,917,0,0,0,0,0,980,981,980,981,978,979,980,981,978,979,980,981,978,978,979,980,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,1237,1235,1235,1235,1298,1237,1107,1042,917,0,0,0,0,1237,1235,1235,1237,1237,1235,1237,1298,1235,1298,1237,1298,1235,1235,1235,1298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,616,617,618,619,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,1235,1237,0,0,0,0,1237,1235,1235,1298,1237,1235,1237,1298,1237,1298,1298,1237,1235,1298,1235,1237,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,680,681,682,683,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,744,745,746,747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,1169,1167,974,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,602,668,668,668,668,668,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,808,809,810,811,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,1038,129,1104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,872,873,874,875,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,0,0,0,0,0,0,0,0,976,910,1105,129,976,911,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,754,755,0,0,936,937,938,939,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,95,96,0,0,0,0,0,0,37,38,39,0,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,0,0,0,0,0,0,910,129,129,974,1103,1296,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1104,1105,913,1104,911,975,1167,912,1104,912,1039,1102,975,911,1040,1168,976,1166,0,0,1168,1040,1102,977,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,818,819,0,0,1000,1001,1002,1003,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,800,0,159,160,0,0,0,98,99,100,101,102,103,104,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,0,0,0,0,0,0,0,0,0,1166,1166,977,977,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1104,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,912,0,0,910,129,129,912,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1064,1065,95,96,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,223,224,0,0,0,162,163,164,165,166,167,168,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,0,0,0,0,0,0,0,0,0,1233,1296,1296,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,913,1041,913,976,976,974,1040,1102,1105,1167,974,976,1040,1039,975,975,1167,1105,1038,910,0,0,913,1169,975,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,159,160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,287,288,0,0,0,226,227,228,229,230,231,232,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,610,611,612,613,614,615,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,975,976,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,223,224,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,351,352,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,676,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,287,288,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,415,416,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,798,799,1438,1439,1440,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,351,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,479,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,0,0,0,0,862,863,1502,1503,1504,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,415,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,490,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,0,0,926,927,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,479,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,0,0,0,0,0,990,991,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1949,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1951,0,0,0,0,0,0,0,0,0,1949,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1951,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,1883,0,0,0,0,0,0,0,0,0,1819,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1695,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1953,0,0,0,0,0,0,0,0,0,2011,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1759,1887,1887,1887,1755,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,95,96,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,607,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,159,160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,671,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,223,224,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,735,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,287,288,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,1310,1311,1312,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,351,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,1374,1375,1376,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,1950,2016,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,415,0,0,737,738,739,740,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,1438,1439,1440,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1114,1115,1116,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,2015,667,0,0,0,0,0,0,0,0,0,0,0,0,2013,0,0,0,0,0,0,0,0,0,2013,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,479,0,0,801,802,803,804,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,1502,1503,1504,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1166,1041,1041,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1745,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1501,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,2015,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,911,1105,1041,913,1040,129,977,1166,913,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2014,1948,1948,1953,0,0,0,0,0,0,0,0,0,2015,0,0,0,0,0,0,0,0,0,0,0,0,0,667,0,0,0,1819,2018,1883,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,1041,977,1166,1039,129,129,129,129,129,129,129,977,913,977,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,0,0,0,0,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,1241,1242,1243,1244,1245,0,0,0,0,0,1041,129,129,129,129,129,129,129,129,129,129,129,129,129,1169,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1745,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,1630,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,2014,1948,1948,1948,2016,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,1305,1306,1307,1308,1309,0,0,0,0,0,1041,129,1105,1102,1169,1105,1102,1038,1041,1169,977,1104,912,912,1105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,1369,1370,1371,1372,1373,0,0,0,0,0,1168,129,910,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1950,1948,1948,1948,1948,1948,1948,2016,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,1433,1434,1435,1436,1437,0,0,0,0,0,910,129,1102,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,99,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1949,1951,0,0,0,0,0,0,0,0,0,1949,1951,0,0,0,0,0,1947,667,667,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,911,1102,0,801,802,803,804,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,321,322,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2011,1953,0,0,0,0,0,0,0,0,0,2011,1953,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,0,0,0,0,2011,1887,1953,603,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,1237,1237,0,0,0,0,0,0,0,0,0,1237,1237,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,799,800,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,667,668,668,668,668,668,667,668,668,668,668,668,667,0,0,0,1298,1365,0,0,0,0,0,0,0,0,0,1365,1298,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,905,0,905,993,994,995,996,0,0,0,0,0,863,864,0,0,0,0,927,928,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,1561,1562,1563,1564,1565,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,777,778,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,991,992,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1169,1040,913,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,1819,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,1055,1056,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,974,129,977,1167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2012,1948,1948,1948,1948,1948,1948,2016,0,0,0,1819,2018,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,1040,1038,1169,1039,911,912,912,1039,1105,0,0,0,0,0,0,0,0,0,0,0,1102,129,129,1167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,667,667,667,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,1103,129,129,129,129,129,129,129,1166,1166,1103,0,0,0,0,0,0,0,0,0,911,129,129,974,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,913,912,910,1103,1103,912,977,975,976,1040,1166,1040,0,0,0,0,0,0,0,0,1103,129,129,1102,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,974,129,129,1166,1102,974,1039,911,1168,1167,1038,976,1040,1038,975,1168,977,1104,974,913,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1561,1562,1563,1564,1565,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2014,1948,1948,1948,1948,1948,1948,1952,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1169,911,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,1040,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1949,1951,0,0,0,0,0,0,0,0,0,1949,1951,0,0,0,0,0,667,667,667,667,667,667,667,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,977,1041,974,975,976,977,912,974,912,976,912,1167,911,1104,912,1039,1104,129,912,976,1167,1038,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1949,1823,1951,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2011,1953,0,0,0,0,0,0,0,0,0,2011,1953,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1297,1360,1360,1360,1233,1233,1360,1233,1297,1360,1360,1360,1297,1297,1297,1233,1041,129,129,129,129,977,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,321,322,0,0,0,0,0,0,0,0,0,1819,2018,1883,603,0,0,0,0,0,603,0,0,0,0,0,603,0,0,0,1365,1365,0,0,0,0,0,0,0,0,0,1365,1298,0,0,0,0,0,0,0,0,0,777,778,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,1297,1297,1297,1297,1360,1360,1233,1297,1297,1297,1297,1297,1297,1230,1041,976,976,129,977,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,0,0,0,0,1819,2018,1883,667,668,668,668,668,668,667,668,668,668,668,668,667,0,0,0,1298,1365,0,0,0,0,0,0,0,0,0,1365,1298,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,37,38,39,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1360,1233,977,129,977,0,0,0,1369,1370,1371,1372,1373,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,98,99,100,101,102,103,104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1297,1040,1041,1041,0,0,0,1433,1434,1435,1436,1437,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,777,778,0,1947,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,162,163,164,165,166,167,168,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1230,1233,1233,0,0,0,1497,1498,1499,1500,1501,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2014,1948,1948,1948,1948,1948,1948,1954,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1294,1297,1297,0,0,0,0,1562,1563,1564,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,667,667,667,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,1105,912,974,911,974,1041,1104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,102,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,1950,1948,1948,1948,1948,1948,1948,1948,1948,2016,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,975,129,129,129,129,129,1169,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,168,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,1947,667,667,667,667,667,667,667,667,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,1039,129,975,912,1041,1104,1038,0,0,0,0,0,0,912,912,976,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,1103,1041,0,0,0,0,0,0,0,0,0,0,0,977,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1040,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,0,1883,0,0,0,2015,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1166,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,0,0,0,0,0,667,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,912,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1566,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,102,103,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2014,1948,1948,1948,2016,0,0,2013,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2013,0,0,0,0,0,0,0,2013,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,910,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,168,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,667,667,667,667,667,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1168,129,129,690,691,692,689,690,691,692,689,690,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,777,778,0,0,0,0,1947,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1102,129,129,754,755,756,753,754,755,756,753,754,0,0,0,0,0,0,0,0,0,0,0,0,0,38,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,673,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1949,1823,1823,1823,1823,1823,1823,1823,1951,0,0,0,1947,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,911,129,129,818,819,820,817,818,819,820,817,818,0,0,0,0,0,0,0,0,0,0,99,0,0,102,103,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,37,38,39,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1947,0,0,0,1819,2018,2018,2018,2018,2018,2018,2018,1883,0,0,0,1947,0,0,0,0,0,0,0,1947,0,0,0,0,0,0,1819,2018,1883,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1039,129,129,882,883,884,881,882,883,884,881,882,0,0,0,0,0,0,0,0,0,0,163,164,165,166,167,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,98,99,100,101,102,103,104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1819,2018,1693,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1823,1694,1823,1823,1951,1819,2018,2018,2018,2018,2018,2018,2018,1883,1949,1823,1823,1694,1823,1823,1823,1823,1823,1823,1823,1694,1823,0,0,0,1823,1823,1692,2018,1883,0,0,0,0,0,0,0,0,0,1038,912,1168,1040,1039,911,0,0,0,0,0,976,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,799,800,162,163,164,165,166,167,168,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1102,1168,911,975,1104,1169,1103,1167,1105,1168,1104,913,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,1819,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,1883,2011,1887,1887,1887,1887,1887,1887,1887,1953,1819,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,2018,0,0,0,0,2018,2018,2018,1883,0,0,0,0,0,0,0,0,0,1167,129,129,129,129,1105,976,913,911,1040,1102,975,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,0,1113,1114,1115,1116,1117,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,863,864,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1040,129,129,129,129,129,129,129,129,129,129,913,1166,911,910,913,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,525,526,0,0,0,0,2011,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1365,1365,1365,1365,1365,1365,1365,1365,1365,2011,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,1887,0,0,0,1887,1887,1887,1953,0,0,0,0,0,0,0,0,0,913,976,1039,976,1105,1040,129,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,1177,1178,1179,1180,1181,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,927,928,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1038,1102,975,913,975,1166,977,1039,913,1167,912,129,129,129,129,1039,913,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,717,717,717,717,717,717,717,1365,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1041,976,976,1040,1167,975,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,1241,1242,1243,1244,1245,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,991,992,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,1233,1233,1233,1233,1233,1233,1233,1233,1233,1103,129,129,129,911,912,974,0,0,0,0,0,0,0,0,0,673,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,717,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1103,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,735,1305,1306,1307,1308,1309,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,1055,1056,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,1297,1297,1297,1297,1297,1297,1297,1297,1297,1166,129,129,1102,977,1233,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1041,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,0,0,0,0,0,0,0,0,0,910,129,129,1167,1233,1297,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,1038,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,913,129,129,1102,1297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,321,322,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1169,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1040,129,129,1039,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1561,1562,1563,1564,1565,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,0,0,0,0,0,0,0,321,322,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1102,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1167,129,129,976,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,1166,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1168,129,129,1166,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,974,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,102,103,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,912,129,129,1102,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1105,975,1039,974,1169,1102,1169,1038,977,1168,1167,1041,975,910,1103,913,911,1039,977,1040,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1105,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,168,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,911,1168,129,129,1038,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,912,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,1104,975,1040,977,1039,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,910,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1169,912,1166,129,1040,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1168,977,911,975,913,910,912,913,1104,912,913,974,1104,977,1169,977,1038,129,129,129,129,1039,975,1104,1169,977,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1166,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1102,129,911,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,1365,1298,1298,1237,1234,1234,1234,1234,1237,1237,1237,1169,913,1103,1102,129,129,129,129,910,911,1166,1105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1041,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1114,1115,1116,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1038,977,129,976,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1298,1298,1365,1298,1234,1237,1234,1234,912,1168,911,1038,913,129,129,975,0,0,0,0,0,0,0,0,0,910,911,912,913,910,910,911,912,913,910,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,911,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,0,0,0,0,0,0,0,0,0,0,0,1750,1751,0,0,0,0,0,0,0,0,0,0,1038,1040,129,129,974,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1298,1365,1365,1298,1234,1234,1234,1234,1234,1038,911,1038,0,0,0,0,0,0,0,0,0,974,129,129,129,129,129,129,129,129,974,911,912,913,910,911,912,913,910,911,912,913,910,911,912,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1104,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1039,1169,1040,129,1041,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1365,1298,1365,1298,1298,1234,1237,1237,0,0,0,0,0,0,0,0,0,1038,1039,1040,1041,1038,1039,974,975,976,129,129,129,129,129,129,129,129,129,129,129,129,129,129,976,0,0,910,911,912,913,910,911,912,913,910,911,912,913,910,911,912,1041,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1102,129,1038,1041,974,975,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1365,1298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1038,1039,1040,1041,1038,1039,1040,1041,1038,1039,1040,1041,1038,1039,1040,0,0,974,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1168,129,129,129,129,1105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1298,1298,1298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1038,1039,1040,1041,1038,1039,1040,1041,1038,1039,1040,1041,1038,1039,1040,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,673,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1750,1751,0,0,0,0,0,0,911,977,976,1104,1039,974,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1054,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1237,1364,1364,1364,1362,1364,1362,1364,1362,1364,1237,1362,1364,1362,1102,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,1233,1233,1233,1233,1233,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1104,1166,1166,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,1297,1297,1297,0,0,0,0,0,0,0,0,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,1039,1166,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1168,976,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1102,129,129,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,978,1107,916,981,1109,914,979,978,1106,1172,1170,914,981,1170,981,914,1106,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1166,1105,0,0,0,0,0,0,0,1168,129,129,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,914,1109,978,1044,914,129,129,129,129,129,129,129,129,129,129,129,129,129,129,129,1172,1170,917,1042,979,1173,979,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,781,1102,912,0,0,0,0,0,912,129,129,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1044,129,129,129,129,917,1106,1109,1043,1045,1171,981,914,1043,979,1107,915,1042,129,129,129,129,129,129,129,129,1109,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,40,41,42,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,910,781,781,913,1105,0,0,0,1168,912,1104,912,976,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1045,1045,1045,914,1043,1109,1233,1233,1233,1233,1233,1233,1233,1233,1233,1233,1233,1107,1170,1106,1170,915,1107,981,1042,917,1042,0,0,0,0,0,0,0,0,0,0,1045,1172,1109,1171,1173,0,0,0,0,0,0,0,0,0,915,916,916,915,914,978,917,1170,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,98,99,100,101,102,103,104,105,106,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,975,911,1169,976,0,0,0,976,1040,1297,1297,913,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,1233,1233,1233,1233,1233,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,1233,1233,1233,1233,1233,1233,1233,1233,1233,1233,0,0,0,0,0,0,0,0,0,0,1107,914,129,129,129,914,1173,0,0,0,0,0,0,0,980,129,129,129,129,129,129,978,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,168,169,170,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,1297,1297,1168,1169,0,0,0,1297,1297,1361,1361,1167,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,1297,1297,1297,0,0,0,0,0,0,0,0,0,0,0,1297,1297,1297,1297,1297,1297,1297,1297,1297,1297,0,0,0,0,0,0,0,0,0,0,0,979,1173,916,979,1170,1173,0,0,0,0,0,0,0,978,1172,1171,1173,916,1109,914,1171,0,0,0,0,0,0,0,323,0,0,0,0,0,321,322,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,0,0,225,226,227,228,229,230,231,232,233,234,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1361,1361,1039,911,0,0,0,1361,1361,0,0,1169,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,737,738,739,740,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1102,975,0,0,0,0,0,0,0,910,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,801,802,803,804,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,99,0,0,102,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,798,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1233,1233,0,0,0,0,0,0,0,974,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,738,739,740,865,866,867,868,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,163,164,165,166,167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,862,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1297,1297,0,0,0,0,0,0,0,911,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,802,803,804,929,930,931,932,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,0,0,0,0,0,0,0,0,0,1114,1115,1116,0,0,0,0,0,0,0,0,0,926,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1567,1568,0,0,0,0,0,481,482,483,484,485,486,487,488,489,490,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,975,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,866,867,868,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1227,1228,1226,1227,1228,1225,1224,1228,1226,1227,1228,1226,1224,1228,1229,1160,0,0,0,1042,915,1044,290,291,292,293,294,295,296,297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,323,1178,1179,1180,0,0,0,0,0,798,799,800,0,990,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,977,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,980,129,1045,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,862,863,864,0,1054,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,913,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1045,978,979,1170,1171,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1043,129,1173,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,926,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,913,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1172,129,129,129,917,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1107,129,1173,482,483,484,485,486,487,488,489,735,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,323,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,990,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1105,913,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,978,129,129,129,916,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,978,129,1171,546,547,548,549,550,551,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,1054,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1105,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1043,129,129,129,914,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1044,129,978,610,611,612,613,614,615,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1105,1103,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,1750,1751,0,0,0,0,0,0,0,0,0,0,0,1173,129,129,129,915,0,0,0,0,0,0,1160,1160,1160,1160,1160,0,0,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,981,129,914,0,0,0,677,678,679,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,911,912,974,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,917,129,129,129,1108,0,0,0,0,0,0,1227,1228,1227,1228,1229,0,0,1227,1228,1160,0,0,0,0,0,0,1160,0,0,0,1173,129,1045,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1688,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1039,129,129,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,930,931,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1044,129,129,129,1045,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,1160,0,0,0,1044,129,1045,1109,1170,1043,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1105,1168,911,976,1102,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,975,1167,1038,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,994,995,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,978,129,129,129,981,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,1160,0,0,0,1042,129,129,129,129,917,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1041,913,913,129,129,129,1041,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,0,0,0,1233,1233,1039,129,129,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,0,0,917,129,129,129,1107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,1160,0,0,0,1108,129,1107,914,1108,1172,0,0,1160,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1169,129,129,1105,910,1104,1166,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,102,103,0,0,0,1297,1297,1167,911,974,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,102,103,0,0,979,129,129,129,1045,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,1045,129,979,1235,1235,1235,0,0,1160,1227,1226,1227,1226,1224,1228,1229,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,1168,912,1168,1040,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,798,0,0,0,161,162,163,164,165,166,167,168,0,0,0,0,1233,1233,912,129,129,129,129,129,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,168,0,1043,129,129,129,1173,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1227,1226,1227,1226,1227,1224,1228,1229,0,0,0,981,129,980,0,0,0,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,1098,1099,1099,1100,1099,1101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,232,0,0,0,0,1297,1297,1038,977,1168,1167,1038,912,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,232,0,1106,917,129,129,917,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,914,129,980,0,0,0,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,970,971,972,971,971,973,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,1301,917,129,129,979,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1106,129,1171,0,0,0,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,1162,1163,1164,1163,1164,1165,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,1365,981,129,129,917,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1044,129,978,0,0,0,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,1057,1058,1059,1060,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,1045,129,129,1108,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1045,129,1106,0,0,0,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1055,1056,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,916,129,129,979,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1107,129,980,0,0,0,0,0,1160,1160,1160,1160,0,0,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,1042,129,129,917,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,917,978,129,978,0,0,0,0,0,1227,1226,1228,1229,0,0,1227,1228,1229,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,929,930,931,932,0,0,0,0,0,737,738,739,740,0,0,0,0,609,610,611,612,613,614,615,616,0,0,917,129,129,980,1171,1109,1171,914,914,1045,0,0,0,0,0,981,1109,1043,1172,1045,1109,1108,917,1170,914,980,979,1109,1172,915,129,914,1045,0,0,0,0,0,1291,1290,1292,1293,0,0,1291,1292,1293,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,673,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,801,802,803,804,0,0,0,0,673,674,675,676,677,678,679,680,0,0,917,129,129,129,129,129,129,129,129,979,0,0,0,0,0,1043,129,129,129,129,129,129,129,129,129,129,129,129,129,129,1107,1237,1237,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1042,129,129,129,129,129,129,129,129,1042,0,0,0,0,0,917,1109,980,980,978,1173,978,1173,1106,1107,914,978,1107,914,1107,915,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,981,129,129,129,129,129,129,129,129,916,0,0,0,0,0,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,737,738,739,740,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1173,914,1043,1045,1173,916,1172,1108,1170,1045,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1227,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,798,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1747,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1237,1237,1237,1237,1237,1237,1237,1237,1237,1237,0,0,0,0,0,321,322,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,385,386,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1114,1115,1116,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,449,450,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1114,1115,1116,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1750,1751,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,95,96,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,95,96,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,159,160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,159,160,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,223,224,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,223,224,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,95,96,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1498,1499,1500,1501,0,0,0,0,1032,1033,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,287,288,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,287,288,0,0,0,0,0,0,0,0,0,0,0,0,0,159,160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,1160,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,351,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,351,0,0,0,0,0,0,0,0,0,0,0,0,0,0,223,224,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,415,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,415,0,0,0,0,0,0,0,0,0,0,0,0,0,0,287,288,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,525,526,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,102,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,479,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,479,0,0,0,0,0,0,0,0,0,0,0,0,0,0,351,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,168,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,415,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,479,0,0,801,802,803,804,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,993,994,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1098,1099,1100,1099,1100,1101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,970,971,971,971,972,973,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,1229,0,0,0,0,1098,1099,1099,1100,1099,1101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,800,0,0,0,0,0,0,0,0,0,0,0,801,802,803,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1162,1163,1163,1163,1164,1165,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,1293,0,0,0,0,970,971,972,971,971,973,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,863,864,0,0,0,0,0,0,0,737,738,739,740,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,1162,1163,1164,1163,1164,1165,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,927,928,0,0,0,0,0,0,0,801,802,803,804,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,673,674,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,991,992,0,0,0,0,0,0,0,865,866,867,868,993,994,995,996,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,1057,1058,1059,1060,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1160,1160,1160,1160,1160,1160,1160,1160,1160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,1567,1568,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,1567,1568,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1562,1563,1564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,525,526,0,0,0,0,0,525,526,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":250,"id":4,"name":"Foreground1","opacity":1,"type":"tilelayer","visible":true,"width":250,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1997,1929,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1999,1929,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1995,1997,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1929,0,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1019,1020,1021,1022,1023,1024,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,95,96,0,1312,0,0,0,0,0,0,0,0,0,0,0,0,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1997,1995,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1083,1084,1085,1086,1087,1088,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,159,160,0,0,0,0,0,0,0,0,0,0,0,0,0,0,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1801,1995,1929,1865,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1147,1148,1149,1150,1151,1152,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,223,224,0,0,0,0,0,0,0,0,0,0,0,0,0,0,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1211,1212,1213,1214,1215,1216,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,287,288,0,799,800,0,0,0,0,0,0,0,0,0,0,0,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1022,1023,1024,0,0,0,0,0,0,0,0,0,0,0,351,352,0,863,864,0,0,0,0,0,0,0,0,0,0,0,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,509,510,511,512,1087,1088,0,0,0,0,0,0,0,0,0,0,0,415,416,0,927,928,0,0,0,0,0,0,0,0,0,0,0,0,1562,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,573,574,575,576,1215,1216,0,0,0,0,0,0,0,0,0,0,0,479,480,0,991,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1279,1280,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1343,1344,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,163,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1215,1216,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1279,1280,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1343,1344,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1215,1216,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1279,1280,0,0,0,0,0,0,0,0,0,0,0,1305,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1343,1344,0,0,0,0,0,0,0,0,0,0,0,1369,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1215,1216,0,0,0,0,0,0,0,0,0,0,0,1433,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1279,1280,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1343,1344,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1215,1216,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1279,1280,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1343,1344,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1407,1408,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,33,34,35,36,37,38,39,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,98,99,100,101,102,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,161,162,163,164,165,166,167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,225,226,227,228,229,230,231,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,298,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,490,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,609,610,611,612,613,614,615,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,800,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,864,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,928,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,992,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1114,1115,1116,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,799,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1113,1114,1115,1116,1117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1177,1178,1179,1180,1181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1241,1242,1243,1244,1245,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1305,1306,1307,1308,1309,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1369,1370,1371,1372,1373,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1433,1434,1435,1436,1437,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1497,1498,1499,1500,1501,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,38,39,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,102,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,163,164,165,166,167,168,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,226,227,228,229,230,231,232,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,291,292,293,294,295,296,297,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,353,354,355,356,357,358,359,360,361,362,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,417,418,419,420,421,422,423,424,425,426,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,481,482,483,484,485,486,487,488,489,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,545,546,547,548,549,550,551,552,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,610,611,612,613,614,615,616,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,675,676,677,678,679,680,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,738,739,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,802,803,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,737,738,739,740,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1057,1058,1059,1060,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,801,802,803,804,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1310,1311,1312,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,865,866,867,868,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1374,1375,1376,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,929,930,931,932,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1438,1439,1440,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,993,994,995,996,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1502,1503,1504,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":250,"id":5,"name":"Foreground2","opacity":1,"type":"tilelayer","visible":true,"width":250,"x":0,"y":0},{"data":[11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,16,16,16,16,16,16,16,16,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,16,0,0,0,0,0,0,0,0,16,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,1,1,1,1,1,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,0,0,11,11,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,16,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,17,1,1,1,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,0,0,17,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,0,0,0,0,0,0,11,0,0,11,18,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,17,1,1,1,1,1,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,1,1,1,1,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,1,1,1,1,1,1,1,0,0,17,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,17,0,0,0,0,11,0,0,0,17,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,11,0,0,0,0,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,11,11,11,0,0,0,0,0,17,17,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,0,11,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,16,16,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,11,11,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,11,11,0,0,0,0,0,11,11,11,11,0,0,0,17,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,16,11,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,11,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,8,0,0,17,17,0,0,0,0,0,11,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,1,1,1,1,1,1,1,1,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,17,0,0,17,17,17,17,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,8,0,0,16,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,11,0,0,11,11,1,7,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,1,1,1,1,1,1,1,1,1,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,19,11,18,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,11,0,0,0,0,0,0,17,0,0,0,0,0,17,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,19,11,18,0,1,1,1,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,11,0,0,0,0,0,0,11,11,11,11,11,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,11,0,0,0,0,0,0,2,4,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,1,1,1,1,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,11,0,0,0,17,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,1,1,1,1,11,11,11,11,11,11,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,17,0,0,0,0,0,11,0,0,0,11,11,11,11,11,11,1,1,1,1,1,1,0,0,0,0,0,11,0,0,0,0,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,1,1,1,1,0,0,0,0,11,11,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,17,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,11,1,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,17,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,1,1,1,1,1,1,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,11,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,1,1,1,1,1,1,1,1,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,17,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,11,11,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0,0,0,0,0,0,7,1,0,0,0,0,0,0,0,0,1,1,1,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,11,18,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,17,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,11,11,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,16,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,1,1,1,1,1,1,1,1,11,11,11,17,0,0,0,0,0,17,0,0,0,0,0,17,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,1,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,0,0,17,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,16,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,11,11,0,0,0,0,0,0,11,18,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,1,1,1,1,1,1,1,11,11,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,11,11,11,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,17,0,0,0,0,0,17,0,0,0,0,0,17,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,16,16,16,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,1,1,1,1,1,1,1,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,17,17,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,1,1,11,11,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,1,1,11,11,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,11,11,11,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,11,11,1,1,1,1,1,0,0,0,0,0,0,11,11,11,11,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,11,11,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,11,11,1,1,1,1,1,0,0,0,0,0,0,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,11,11,11,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,11,11,11,11,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,11,11,0,11,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,11,11,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,11,11,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,17,17,0,0,0,0,11,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,16,16,0,0,0,0,11,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,16,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,1,1,1,1,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,0,0,1,1,1,1,1,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,1,1,1,1,1,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,1,1,1,1,1,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,1,1,1,1,1,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,11,11,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,19,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,11,11,0,0,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,11,17,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,16,11,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,0,0,0,0,0,12,14,0,0,0,0,0,1,1,1,1,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,19,11,11,11,0,0,0,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,11,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,11,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,11,0,0,0,11,11,11,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,11,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,11,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,11,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,11,0,0,0,11,11,11,11,11,11,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,11,11,11,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,11,11,11,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,11,11,11,0,0,0,0,0,11,11,11,0,11,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,11,11,11,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,0,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,18,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,0,0,0,0,0,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,19,11,18,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,11,11,0,0,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,19,11,18,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,11,11,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,16,0,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,1,1,1,1,1,1,1,0,0,0,0,0,0,11,11,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,11,11,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,14,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,11,11,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,11,11,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,12,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,19,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,16,11,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,16,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,11,11,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,1,11,11,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,11,11,0,0,0,0,0,1,11,11,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,11,11,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,17,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,19,11,18,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,11,18,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,11,11,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,14,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,11,11,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,11,11,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,1,1,1,1,1,1,1,1,0,0,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,0,0,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,0,0,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11],"height":250,"id":6,"name":"Collisions","opacity":1,"type":"tilelayer","visible":true,"width":250,"x":0,"y":0},{"draworder":"topdown","id":9,"name":"ExtractionPoints","objects":[{"height":80,"id":13,"name":"","rotation":0,"type":"","visible":true,"width":79.5,"x":2033.84,"y":862.916},{"height":77.2727,"id":14,"name":"","rotation":0,"type":"","visible":true,"width":77.4545,"x":898.031,"y":2433.55},{"height":77,"id":15,"name":"","rotation":0,"type":"","visible":true,"width":77,"x":2514.25,"y":2962.5},{"height":76.75,"id":18,"name":"","rotation":0,"type":"","visible":true,"width":76.75,"x":3186.17,"y":1329.92},{"height":80,"id":79,"name":"","rotation":0,"type":"","visible":true,"width":79.5,"x":1312.9,"y":1648.32},{"height":80,"id":122,"name":"","rotation":0,"type":"","visible":true,"width":79.5,"x":3601.1,"y":353.152}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0},{"draworder":"topdown","id":10,"name":"EnemySpawns","objects":[{"height":0,"id":179,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":7}],"rotation":0,"type":"","visible":true,"width":0,"x":3280.32,"y":2575.43},{"height":0,"id":180,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":5}],"rotation":0,"type":"","visible":true,"width":0,"x":1424.74,"y":1674.1},{"height":0,"id":181,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":464.419,"y":2610.49},{"height":0,"id":182,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":550.562,"y":2138.58},{"height":0,"id":183,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":513.109,"y":1558.05},{"height":0,"id":184,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":617.978,"y":958.801},{"height":0,"id":185,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":1228.46,"y":838.951},{"height":0,"id":186,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":730.337,"y":662.921},{"height":0,"id":187,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":1078.65,"y":1475.66},{"height":0,"id":188,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":835.206,"y":2775.28},{"height":0,"id":189,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1554.31,"y":2779.03},{"height":0,"id":190,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1157.3,"y":2397},{"height":0,"id":191,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1048.69,"y":2535.58},{"height":0,"id":192,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1258.43,"y":2940.07},{"height":0,"id":193,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1700.37,"y":2951.31},{"height":0,"id":194,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1591.76,"y":2445.69},{"height":0,"id":195,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1973.78,"y":2647.94},{"height":0,"id":196,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":3247.19,"y":1584.27},{"height":0,"id":197,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":2943.82,"y":1385.77},{"height":0,"id":198,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":3217.23,"y":1194.76},{"height":0,"id":199,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":3359.55,"y":1382.02},{"height":0,"id":200,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":3535.58,"y":1640.45},{"height":0,"id":201,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":3719.1,"y":1329.59},{"height":0,"id":202,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":2588.01,"y":1617.98},{"height":0,"id":203,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":2651.69,"y":1119.85},{"height":0,"id":204,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":6}],"rotation":0,"type":"","visible":true,"width":0,"x":2573.03,"y":936.33},{"height":0,"id":205,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":2}],"rotation":0,"type":"","visible":true,"width":0,"x":1752.81,"y":677.903},{"height":0,"id":206,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":2}],"rotation":0,"type":"","visible":true,"width":0,"x":1861.42,"y":1048.69},{"height":0,"id":207,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":2}],"rotation":0,"type":"","visible":true,"width":0,"x":1977.53,"y":1707.87},{"height":0,"id":208,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":2}],"rotation":0,"type":"","visible":true,"width":0,"x":2048.69,"y":1325.84},{"height":0,"id":209,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":2}],"rotation":0,"type":"","visible":true,"width":0,"x":2164.79,"y":2176.03},{"height":0,"id":210,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":2}],"rotation":0,"type":"","visible":true,"width":0,"x":1468.16,"y":1142.32},{"height":0,"id":211,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":2}],"rotation":0,"type":"","visible":true,"width":0,"x":1168.54,"y":2037.45},{"height":0,"id":212,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":2531.84,"y":573.034},{"height":0,"id":213,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":2925.09,"y":389.513},{"height":0,"id":214,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":2868.91,"y":606.742},{"height":0,"id":215,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":3359.55,"y":449.438},{"height":0,"id":216,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":3131.09,"y":700.375},{"height":0,"id":217,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":3524.34,"y":468.165},{"height":0,"id":218,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":3790.26,"y":580.524},{"height":0,"id":219,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":3636.7,"y":734.082},{"height":0,"id":220,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":1}],"rotation":0,"type":"","visible":true,"width":0,"x":3786.52,"y":295.88},{"height":0,"id":221,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":3647.94,"y":561.798},{"height":0,"id":222,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":3318.35,"y":599.251},{"height":0,"id":223,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":2764.04,"y":1719.1},{"height":0,"id":224,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":3014.98,"y":1112.36},{"height":0,"id":225,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":3434.46,"y":1142.32},{"height":0,"id":226,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":2258.43,"y":3063.67},{"height":0,"id":227,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":2808.99,"y":2981.27},{"height":0,"id":228,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":2775.28,"y":3280.9},{"height":0,"id":229,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":2644.19,"y":2632.96},{"height":0,"id":230,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":0}],"rotation":0,"type":"","visible":true,"width":0,"x":2535.58,"y":1925.09},{"height":0,"id":233,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":913.858,"y":573.034},{"height":0,"id":234,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":749.064,"y":456.929},{"height":0,"id":235,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":4}],"rotation":0,"type":"","visible":true,"width":0,"x":985.019,"y":1254.68},{"height":0,"id":236,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":951.311,"y":2857.68},{"height":0,"id":237,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":928.839,"y":2513.11},{"height":0,"id":238,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":910.112,"y":2344.57},{"height":0,"id":239,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1198.5,"y":2546.82},{"height":0,"id":240,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1097.38,"y":2741.57},{"height":0,"id":241,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1101.12,"y":2917.6},{"height":0,"id":242,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1265.92,"y":2752.81},{"height":0,"id":243,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1479.4,"y":2689.14},{"height":0,"id":244,"name":"","point":true,"properties":[{"name":"OnlySpawnEnemy","type":"int","value":3}],"rotation":0,"type":"","visible":true,"width":0,"x":1389.51,"y":2790.26}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0},{"draworder":"topdown","id":7,"name":"PlayerSpawns","objects":[{"height":0,"id":1,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3928,"y":2855.66},{"height":0,"id":2,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3724.56,"y":3050.22},{"height":0,"id":3,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":176.333,"y":1667.34},{"height":0,"id":9,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":374.667,"y":334},{"height":0,"id":35,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1384.6,"y":3242.55},{"height":0,"id":36,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2448.14,"y":2299.67},{"height":0,"id":37,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":600.788,"y":1283.18},{"height":0,"id":38,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":216,"y":1167.33},{"height":0,"id":39,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":452.667,"y":296.334},{"height":0,"id":94,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":245,"y":930.666},{"height":0,"id":95,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":137.333,"y":2907.34},{"height":0,"id":120,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1193.33,"y":214.333},{"height":0,"id":121,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3927.5,"y":1952},{"height":0,"id":124,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":770,"y":3095.33},{"height":0,"id":136,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":376,"y":3042.67},{"height":0,"id":137,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":229.333,"y":2004},{"height":0,"id":138,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3102.67,"y":3044},{"height":0,"id":140,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1594.67,"y":309.333}],"opacity":0.39,"type":"objectgroup","visible":true,"x":0,"y":0},{"draworder":"topdown","id":12,"name":"LootSpawns","objects":[{"height":0,"id":42,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":666.636,"y":1530.88},{"height":0,"id":43,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2191.34,"y":2674.34},{"height":0,"id":44,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3875.23,"y":2285.62},{"height":0,"id":46,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3796.67,"y":203.667},{"height":0,"id":47,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1040.25,"y":2332.58},{"height":0,"id":48,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1931.39,"y":1081.89},{"height":0,"id":49,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1416.61,"y":2963.22},{"height":0,"id":51,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1523.12,"y":1702.19},{"height":0,"id":52,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":290.167,"y":1399.67},{"height":0,"id":53,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":832.334,"y":508.916},{"height":0,"id":54,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1972.75,"y":1475.83},{"height":0,"id":55,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1465.59,"y":2514.42},{"height":0,"id":56,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3000,"y":1144.58},{"height":0,"id":57,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3523.42,"y":1284.33},{"height":0,"id":58,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1776.83,"y":594.833},{"height":0,"id":59,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1909.42,"y":1881.83},{"height":0,"id":60,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":715.667,"y":2533.66},{"height":0,"id":61,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1016,"y":1181.25},{"height":0,"id":82,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1014.92,"y":465.334},{"height":0,"id":83,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2567.75,"y":986.5},{"height":0,"id":84,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2242,"y":92},{"height":0,"id":85,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3245.25,"y":292.083},{"height":0,"id":86,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2689.42,"y":438.833},{"height":0,"id":87,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3439,"y":1458.5},{"height":0,"id":88,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3557.83,"y":1098},{"height":0,"id":89,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2960,"y":1601.5},{"height":0,"id":90,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3452,"y":594},{"height":0,"id":91,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3012,"y":2317.83},{"height":0,"id":92,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1813.42,"y":2671.69},{"height":0,"id":93,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1830.94,"y":2861.18},{"height":0,"id":98,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2518.66,"y":1775.33},{"height":0,"id":117,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2635.83,"y":2657.67},{"height":0,"id":118,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3602.66,"y":1812.34},{"height":0,"id":119,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2872.17,"y":3306},{"height":0,"id":127,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":189.334,"y":2424.67},{"height":0,"id":135,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":2005,"y":2229.5},{"height":0,"id":142,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":1154.5,"y":2422.5},{"height":0,"id":231,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3168.54,"y":2610.49},{"height":0,"id":232,"name":"","point":true,"rotation":0,"type":"","visible":true,"width":0,"x":3322.1,"y":2614.23}],"opacity":0.28,"type":"objectgroup","visible":true,"x":0,"y":0},{"draworder":"topdown","id":13,"name":"NamedRegions","objects":[{"height":906.892,"id":144,"name":"region__skull_lake","rotation":0,"type":"","visible":true,"width":975.413,"x":1108.42,"y":1164.85},{"height":1479.24,"id":145,"name":"region__swamp_of_sorrows","rotation":0,"type":"","visible":true,"width":677.146,"x":28.2144,"y":999.597},{"height":1007.66,"id":147,"name":"region__swamp_of_sorrows","rotation":0,"type":"","visible":true,"width":350.665,"x":705.361,"y":1003.63},{"height":939.137,"id":150,"name":"region__dreamers_forest","rotation":0,"type":"","visible":true,"width":2212.82,"x":28.2144,"y":52.3982},{"height":1217.25,"id":151,"name":"region__erthel","rotation":0,"type":"","visible":true,"width":1459.09,"x":745.667,"y":2124.14},{"height":1588.07,"id":152,"name":"region__ert_lich","rotation":0,"type":"","visible":true,"width":1749.29,"x":2237,"y":1962.92},{"height":886.739,"id":154,"name":"region__forgotten_temple","rotation":0,"type":"","visible":true,"width":882.709,"x":2781.14,"y":935.107},{"height":795.455,"id":157,"name":"region__the_edgelands","rotation":0,"type":"","visible":true,"width":1636.36,"x":2356.06,"y":3.78788}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0}],"nextlayerid":14,"nextobjectid":245,"orientation":"orthogonal","renderorder":"right-down","tiledversion":"1.10.1","tileheight":16,"tilesets":[{"columns":64,"firstgid":1,"image":"../../../../static/world/tileset.png","imageheight":512,"imagewidth":1024,"margin":0,"name":"tileset","spacing":0,"tilecount":2048,"tileheight":16,"tilewidth":16}],"tilewidth":16,"type":"map","version":"1.10","width":250}');


var $f4842134c1afe84a$export$eb95ba86e8878685;
(function(CollisionGridTileIds) {
    CollisionGridTileIds[CollisionGridTileIds[// Full colliders (blocks both players and projectiles)
    "EMPTY"] = 0] = "EMPTY";
    CollisionGridTileIds[CollisionGridTileIds["SOLID"] = 11] = "SOLID";
    CollisionGridTileIds[CollisionGridTileIds["LEFT_HALF"] = 18] = "LEFT_HALF";
    CollisionGridTileIds[CollisionGridTileIds["RIGHT_HALF"] = 19] = "RIGHT_HALF";
    CollisionGridTileIds[CollisionGridTileIds["TOP_HALF"] = 16] = "TOP_HALF";
    CollisionGridTileIds[CollisionGridTileIds["BOTTOM_HALF"] = 17] = "BOTTOM_HALF";
    CollisionGridTileIds[CollisionGridTileIds["TOP_LEFT_QUARTER"] = 14] = "TOP_LEFT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds["TOP_RIGHT_QUARTER"] = 12] = "TOP_RIGHT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds["BOTTOM_LEFT_QUARTER"] = 13] = "BOTTOM_LEFT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds["BOTTOM_RIGHT_QUARTER"] = 15] = "BOTTOM_RIGHT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds[// "Low" colliders (blocks only player movement, projectiles fly through it)
    "LOW_SOLID"] = 1] = "LOW_SOLID";
    CollisionGridTileIds[CollisionGridTileIds["LOW_LEFT_HALF"] = 8] = "LOW_LEFT_HALF";
    CollisionGridTileIds[CollisionGridTileIds["LOW_RIGHT_HALF"] = 9] = "LOW_RIGHT_HALF";
    CollisionGridTileIds[CollisionGridTileIds["LOW_TOP_HALF"] = 6] = "LOW_TOP_HALF";
    CollisionGridTileIds[CollisionGridTileIds["LOW_BOTTOM_HALF"] = 7] = "LOW_BOTTOM_HALF";
    CollisionGridTileIds[CollisionGridTileIds["LOW_TOP_LEFT_QUARTER"] = 4] = "LOW_TOP_LEFT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds["LOW_TOP_RIGHT_QUARTER"] = 2] = "LOW_TOP_RIGHT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds["LOW_BOTTOM_LEFT_QUARTER"] = 3] = "LOW_BOTTOM_LEFT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds["LOW_BOTTOM_RIGHT_QUARTER"] = 5] = "LOW_BOTTOM_RIGHT_QUARTER";
    CollisionGridTileIds[CollisionGridTileIds["FULL_WATER"] = 1992] = "FULL_WATER";
})($f4842134c1afe84a$export$eb95ba86e8878685 || ($f4842134c1afe84a$export$eb95ba86e8878685 = {}));
const $f4842134c1afe84a$var$mapData = (0, (/*@__PURE__*/$parcel$interopDefault($35b008eefffaa37f$exports)));
const $f4842134c1afe84a$export$f34f76252d01f8d0 = $f4842134c1afe84a$var$mapData.layers.find((layer)=>layer.name === "NamedRegions");
const $f4842134c1afe84a$export$4157961b70214611 = $f4842134c1afe84a$var$mapData.layers.find((layer)=>layer.name === "EnemySpawns");
const $f4842134c1afe84a$export$ca93362b91007063 = $f4842134c1afe84a$var$mapData.layers.find((layer)=>layer.name === "PlayerSpawns");
const $f4842134c1afe84a$export$e568a2d7650b9d64 = $f4842134c1afe84a$var$mapData.layers.find((layer)=>layer.name === "LootSpawns");
const $f4842134c1afe84a$export$4f3e83a3f2401002 = $f4842134c1afe84a$var$mapData.layers.find((layer)=>layer.name === "ExtractionPoints");
const $f4842134c1afe84a$export$3e8ce3cbcd5334a2 = $f4842134c1afe84a$var$mapData.layers.find((layer)=>layer.name === "Collisions");
const $f4842134c1afe84a$export$2bf279a7cbd1e646 = $f4842134c1afe84a$var$mapData.layers.find((layer)=>layer.name === "Ground1");
const $f4842134c1afe84a$export$d3d91ab9f65eca0a = ()=>{
    const random = Math.floor(Math.random() * $f4842134c1afe84a$export$ca93362b91007063.objects.length);
    return $f4842134c1afe84a$export$ca93362b91007063.objects[random];
}; // export const getRandomEnemySpawn = () => {
 //     const random = Math.floor(Math.random() * EnemySpawnsFromTiledMap.objects.length);
 //     return EnemySpawnsFromTiledMap.objects[random];
 // };


class $63b908b83aafc686$export$9e3eb75d5eb92e43 {
    constructor(columnIndex, rowIndex, xPosition, yPosition, indexInGrid){
        this.nid = -1;
        this.ntype = (0, $282dc2f79e0204c8$export$f7cab339749a57d7).DebugGridCellEntity;
        this.indexInGrid = -1;
        this.isActive = false;
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.players = new Set();
        this.projectiles = new Set();
        this.extractionPoints = new Set();
        this.enemies = new Set();
        this.interactables = new Set();
        this.x = xPosition;
        this.y = yPosition;
        this.column = columnIndex;
        this.row = rowIndex;
        this.indexInGrid = indexInGrid;
    }
    IsEmpty() {
        return this.HasPlayers() === false && this.HasProjectiles() === false;
    }
    HasPlayers() {
        return this.players.size > 0;
    }
    HasProjectiles() {
        return this.projectiles.size > 0;
    }
    GetColumnAndRow() {
        return {
            column: this.column,
            row: this.row
        };
    }
    AddEntity(entity) {
        if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlayerEntity) this.players.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ProjectileEntity) this.projectiles.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ExtractionPointEntity) this.extractionPoints.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).AIEntity) this.enemies.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ItemContainerEntity) this.interactables.add(entity);
        else throw new Error(`Tried to add entity of unknown type to grid cell #${this.indexInGrid}: ${entity.ntype}`);
    }
    RemoveEntity(entity) {
        if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlayerEntity) this.players.delete(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ProjectileEntity) this.projectiles.delete(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).AIEntity) this.enemies.delete(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ItemContainerEntity) this.interactables.delete(entity);
        else throw new Error(`Tried to remove entity of unknown type from grid cell #${this.indexInGrid}: ${entity.ntype}`);
    }
    get width() {
        return (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE;
    }
    get height() {
        return (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE;
    }
    get x() {
        return this.position.x;
    }
    set x(newX) {
        this.position.x = newX;
    }
    get y() {
        return this.position.y;
    }
    set y(newY) {
        this.position.y = newY;
    }
    Update(__deltaTime) {}
}
class $63b908b83aafc686$export$65d371600423f3b5 {
    constructor(){
        this.gridCells = new Array();
        this.gridWidth = (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_SIZE / (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE;
        this.gridHeight = (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_SIZE / (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE;
        // Build the spatial collision grid
        for(let rowIndex = 0; rowIndex < this.gridWidth; rowIndex++)for(let columnIndex = 0; columnIndex < this.gridHeight; columnIndex++){
            const xPosition = columnIndex * (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE;
            const yPosition = rowIndex * (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE;
            const indexIn1DGrid = this.gridCells.length;
            this.gridCells.push(new $63b908b83aafc686$export$9e3eb75d5eb92e43(columnIndex, rowIndex, xPosition, yPosition, indexIn1DGrid));
        }
    }
    DeactivateAllGridCells() {
        for (const gridCell of this.gridCells)gridCell.isActive = false;
    }
    GetGridCellFromGridCellIndex(gridCellIndex) {
        return this.gridCells[gridCellIndex];
    }
    GetAllBroadphaseGridCells() {
        return this.gridCells;
    }
    GetGridCellFromGridXY(gridX, gridY) {
        return this.gridCells[gridY * this.gridWidth + gridX];
    }
    GetGridCellIndexFromWorldXY(x, y) {
        const gridX = Math.floor(x / (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE);
        const gridY = Math.floor(y / (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE);
        return gridY * ((0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_SIZE / (0, $c52f191d3f575144$export$c14d6c08f0e74a8e).GRID_CELL_SIZE) + gridX;
    }
    GetGridCellFromWorldXY(x, y) {
        return this.gridCells[this.GetGridCellIndexFromWorldXY(x, y)];
    }
    AddEntity(entity, knownDestinationGridCell) {
        let gridCell;
        if (knownDestinationGridCell !== undefined) gridCell = this.GetGridCellFromGridCellIndex(knownDestinationGridCell);
        else gridCell = this.GetGridCellFromWorldXY(entity.x, entity.y);
        if (gridCell === undefined) console.error(`Entity position x${entity.x},y${entity.y} did not produce a valid collision grid cell! This should never happen, entity possible out of world bounds?`);
        else {
            entity.currentCollisionGridCell = gridCell;
            gridCell.AddEntity(entity);
        }
    }
    RemoveEntity(entity) {
        const gridCell = entity.currentCollisionGridCell;
        if (gridCell === undefined) console.error("Tried to remove entity from grid cell but entity did not have a valid currentCollisionGridCell! This should never happen!");
        else gridCell.RemoveEntity(entity);
    }
    UpdateEntityPositionsInGrid() {
        for (const gridCell of this.gridCells){
            for (const player of gridCell.players){
                const newGridCell = this.GetGridCellFromWorldXY(player.x, player.y);
                if (newGridCell === undefined) {
                    console.log(`Position x/y ${player.x},${player.y} resulted in bad collision grid; ignoring`);
                    continue;
                } else if (newGridCell.indexInGrid !== gridCell.indexInGrid) {
                    this.RemoveEntity(player);
                    this.AddEntity(player, newGridCell.indexInGrid);
                }
            }
            for (const projectile of gridCell.projectiles){
                const newGridCell = this.GetGridCellFromWorldXY(projectile.x, projectile.y);
                if (newGridCell === undefined) {
                    console.log(`Position x/y ${projectile.x},${projectile.y} resulted in bad collision grid; ignoring`);
                    continue;
                } else if (newGridCell.indexInGrid !== gridCell.indexInGrid) {
                    this.RemoveEntity(projectile);
                    this.AddEntity(projectile, newGridCell.indexInGrid);
                }
            }
            for (const enemy of gridCell.enemies){
                const newGridCell = this.GetGridCellFromWorldXY(enemy.x, enemy.y);
                if (newGridCell === undefined) {
                    console.log(`Position x/y ${enemy.x},${enemy.y} resulted in bad collision grid; ignoring`);
                    continue;
                } else if (newGridCell.indexInGrid !== gridCell.indexInGrid) {
                    this.RemoveEntity(enemy);
                    this.AddEntity(enemy, newGridCell.indexInGrid);
                }
            }
        // TODO update AI positions in grid?
        }
    }
}
class $63b908b83aafc686$var$StaticMapTileCollisionGrid {
    static #_ = (()=>{
        this.TileInfo = {
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).EMPTY]: {
                height: 0,
                width: 0,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).SOLID]: {
                height: 16,
                width: 16,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).TOP_HALF]: {
                height: 8,
                width: 16,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).BOTTOM_HALF]: {
                height: 8,
                width: 16,
                offsetY: 8,
                offsetX: 0,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LEFT_HALF]: {
                height: 16,
                width: 8,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).RIGHT_HALF]: {
                height: 16,
                width: 8,
                offsetY: 0,
                offsetX: 8,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).TOP_LEFT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).TOP_RIGHT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 0,
                offsetX: 8,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).BOTTOM_LEFT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 8,
                offsetX: 0,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).BOTTOM_RIGHT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 8,
                offsetX: 8,
                blocksProjectiles: true
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_SOLID]: {
                height: 16,
                width: 16,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_TOP_HALF]: {
                height: 8,
                width: 16,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_BOTTOM_HALF]: {
                height: 8,
                width: 16,
                offsetY: 8,
                offsetX: 0,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_LEFT_HALF]: {
                height: 16,
                width: 8,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_RIGHT_HALF]: {
                height: 16,
                width: 8,
                offsetY: 0,
                offsetX: 8,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_TOP_LEFT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 0,
                offsetX: 0,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_TOP_RIGHT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 0,
                offsetX: 8,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_BOTTOM_LEFT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 8,
                offsetX: 0,
                blocksProjectiles: false
            },
            [(0, $f4842134c1afe84a$export$eb95ba86e8878685).LOW_BOTTOM_RIGHT_QUARTER]: {
                height: 8,
                width: 8,
                offsetY: 8,
                offsetX: 8,
                blocksProjectiles: false
            }
        };
    })();
    constructor(){
        this.mapTileCollisionGrid = [];
        for(let i = 0; i < (0, $f4842134c1afe84a$export$3e8ce3cbcd5334a2).data.length; i++){
            const collisionTileId = (0, $f4842134c1afe84a$export$3e8ce3cbcd5334a2).data[i];
            if (!$63b908b83aafc686$var$StaticMapTileCollisionGrid.TileInfo[collisionTileId]) console.error(`Unknown collision tile ID found in collision grid: ${collisionTileId}`);
            // Dont create collision tiles for empty tiles
            if (collisionTileId === (0, $f4842134c1afe84a$export$eb95ba86e8878685).EMPTY || !$63b908b83aafc686$var$StaticMapTileCollisionGrid.TileInfo[collisionTileId]) this.mapTileCollisionGrid.push(null);
            else {
                const gridX = Math.floor(i % (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS);
                const gridY = Math.floor(i / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS);
                const { height: height , width: width , offsetY: offsetY , offsetX: offsetX , blocksProjectiles: blocksProjectiles  } = $63b908b83aafc686$var$StaticMapTileCollisionGrid.TileInfo[collisionTileId];
                const polygonForThisTile = new (0, $2104f92cbe769454$exports.Box)(new (0, $2104f92cbe769454$exports.Vector)(gridX * (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE + offsetX, gridY * (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE + offsetY), width, height).toPolygon();
                // @ts-ignore TODO: hack
                polygonForThisTile.blocksProjectiles = blocksProjectiles;
                this.mapTileCollisionGrid.push(polygonForThisTile);
            }
        }
    }
    GetCollisionPolygonForGridXY(gridX, gridY) {
        const tileIndex = gridY * (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS + gridX;
        return this.mapTileCollisionGrid[tileIndex];
    }
}
class $63b908b83aafc686$export$52ef19685b59c674 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    static #_ = (()=>{
        this.GridOffsets = [
            [
                0,
                0
            ],
            [
                -1,
                -1
            ],
            [
                0,
                -1
            ],
            [
                1,
                -1
            ],
            [
                -1,
                0
            ],
            [
                1,
                0
            ],
            [
                -1,
                1
            ],
            [
                0,
                1
            ],
            [
                1,
                1
            ] // Bottom right
        ];
    })();
    constructor(){
        super();
        this.players = new Set();
        this.projectiles = new Set();
        this.extractionPoints = new Set();
        this.enemies = new Set();
        this.interactables = new Set();
        this.reusableCollisionResponseObject = new (0, $2104f92cbe769454$exports.Response)();
        this.collisionsCheckedThisFrame = 0;
        this.broadphaseCollisionGrid = new $63b908b83aafc686$export$65d371600423f3b5();
        this.staticMapTileCollisionGrid = new $63b908b83aafc686$var$StaticMapTileCollisionGrid();
    }
    Initialize() {
        this.LogInfo("Ready!");
    }
    GetAllGridCells() {
        return this.broadphaseCollisionGrid.GetAllBroadphaseGridCells();
    }
    getSystemName() {
        return "Collision";
    }
    AddEntity(entity) {
        if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlayerEntity) this.players.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ProjectileEntity) this.projectiles.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ExtractionPointEntity) this.extractionPoints.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).AIEntity) this.enemies.add(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ItemContainerEntity) this.interactables.add(entity);
        this.broadphaseCollisionGrid.AddEntity(entity);
    }
    IsTileAtGridXYaSpecificTileId(gridX, gridY, tileId) {
        return (0, $f4842134c1afe84a$export$2bf279a7cbd1e646).data[gridY * (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS + gridX] === tileId;
    }
    GetCollisionPolygonAtGridXY(gridX, gridY) {
        return this.staticMapTileCollisionGrid.GetCollisionPolygonForGridXY(gridX, gridY);
    }
    PerformOneOffCirclePolygonCollisionCheck(circle, polygon) {
        this.collisionsCheckedThisFrame++;
        const response = new (0, $2104f92cbe769454$exports.Response)();
        const collisionResponseResult = (0, $2104f92cbe769454$exports.testPolygonCircle)(polygon, circle, response);
        if (collisionResponseResult) return response;
        else return false;
    }
    RemoveEntity(entity) {
        if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlayerEntity) this.players.delete(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ProjectileEntity) this.projectiles.delete(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ExtractionPointEntity) this.extractionPoints.delete(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).AIEntity) this.enemies.delete(entity);
        else if (entity.ntype === (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ItemContainerEntity) this.interactables.delete(entity);
        this.broadphaseCollisionGrid.RemoveEntity(entity);
    }
    // public OneOffCollisionCheck;
    Update(__deltaTime) {
        if ((0, $c52f191d3f575144$export$c14d6c08f0e74a8e).DEBUG.DRAW_BROADPHASE_SPATIAL_GRID) this.broadphaseCollisionGrid.DeactivateAllGridCells();
        this.broadphaseCollisionGrid.UpdateEntityPositionsInGrid();
        const collisionUpdateStartTimestampMs = (0, $276f03d77ac4b507$export$b646210dbab6d1e3)();
        for (const enemy of this.enemies){
            const enemyEntity = enemy;
            const enemyCurrentGridCell = enemyEntity.currentCollisionGridCell;
            if (enemyEntity.isAlive === false) continue;
            for (const offset of $63b908b83aafc686$export$52ef19685b59c674.GridOffsets){
                const [x, y] = offset;
                const adjacentX = enemyCurrentGridCell.column + x;
                const adjacentY = enemyCurrentGridCell.row + y;
                // If the potential grid cell that is adjacent to this grid cell is out of the bounds of the world, skip it as this grid cell does not exist
                if (adjacentX > this.broadphaseCollisionGrid.gridWidth - 1 || adjacentY > this.broadphaseCollisionGrid.gridHeight - 1 || adjacentX < 0 || adjacentY < 0) continue;
                const relevantSpatialGridCell = this.broadphaseCollisionGrid.GetGridCellFromGridXY(enemyCurrentGridCell.column + x, enemyCurrentGridCell.row + y);
                if (relevantSpatialGridCell === undefined) {
                    this.LogWarning("relevantGridCell is undefined despite above safeguards, skipping iteration, likely collision system bug");
                    continue;
                }
                if ((0, $c52f191d3f575144$export$c14d6c08f0e74a8e).DEBUG.DRAW_BROADPHASE_SPATIAL_GRID) relevantSpatialGridCell.isActive = true;
                /**********************************************************************/ /*                                                                    */ /*                                                                    */ /*                  AI <-> Projectile Collision                       */ /*                                                                    */ /*                                                                    */ /**********************************************************************/ for (const projectile of relevantSpatialGridCell.projectiles){
                    const projectileEntity = projectile;
                    // dont even bother checking for collisions if this projectile has already been flagged for removal this frame
                    if (projectileEntity.ToBeDestroyed) continue;
                    // Skip collisions for whom you are the owner (cant shoot yourself)
                    if (projectileEntity.owningEntityNid === enemyEntity.nid) continue;
                    // No friendly fire for AI
                    if (projectileEntity.isAIOwnedProjectile === true) continue;
                    this.collisionsCheckedThisFrame++;
                    const collisionResponse = (0, $2104f92cbe769454$exports.testPolygonCircle)(enemyEntity.HitboxCollider, projectileEntity.HitboxCollider, this.reusableCollisionResponseObject);
                    if (collisionResponse) {
                        enemyEntity.lastDamagedByNid = projectileEntity.owningEntityNid;
                        enemyEntity.TakeDamage(projectileEntity.damage, projectileEntity.damageType, projectileEntity.owningEntityNid, projectileEntity.npcDamageModifier);
                        projectileEntity.ToBeDestroyed = true;
                    }
                    this.reusableCollisionResponseObject.clear();
                }
            }
            /**********************************************************************/ /*                                                                    */ /*                                                                    */ /*                  AI <-> AI Max Chase                               */ /*                                                                    */ /*                                                                    */ /**********************************************************************/ // Outer max chase radius; clear any chase targets if AI leaves this collider and don't chase any players until
            // it returns back within the innner radius.
            let collisionResponse = (0, $2104f92cbe769454$exports.testPolygonCircle)(enemyEntity.HitboxCollider, enemyEntity.MaxChaseOuterCollider, this.reusableCollisionResponseObject);
            if (!collisionResponse) {
                enemyEntity.SetTargetPlayer(null);
                continue;
            }
            // Inner chase target; skip the following Aggro <-> Player collision only if we aren't already chasing someone
            // to prevent the AI to not thrash between chasing/not chasing.
            if (enemyEntity.GetTargetPlayer() == null) {
                collisionResponse = (0, $2104f92cbe769454$exports.testPolygonCircle)(enemyEntity.HitboxCollider, enemyEntity.MaxChaseInnerCollider, this.reusableCollisionResponseObject);
                if (!collisionResponse) {
                    enemyEntity.SetTargetPlayer(null);
                    continue;
                }
            }
            /**********************************************************************/ /*                                                                    */ /*                                                                    */ /*                  AI Aggro <-> Player Collision                     */ /*                                                                    */ /*                                                                    */ /**********************************************************************/ let closestPlayerDistance = enemyEntity.AggroCollider.r;
            let closestPlayer = null;
            for (const player of this.players){
                const playerEntity = player;
                // Leave the dead players alone.
                if (playerEntity.isAlive == false) continue;
                const collisionResponse = (0, $2104f92cbe769454$exports.testPolygonCircle)(playerEntity.HitboxCollider, enemyEntity.AggroCollider, this.reusableCollisionResponseObject);
                if (collisionResponse) {
                    const dx = playerEntity.x - enemyEntity.x;
                    const dy = playerEntity.y - enemyEntity.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance < closestPlayerDistance) {
                        closestPlayerDistance = distance;
                        closestPlayer = playerEntity;
                    }
                }
                this.reusableCollisionResponseObject.clear();
            }
            enemyEntity.SetTargetPlayer(closestPlayer);
        }
        for (const player of this.players){
            const playerEntity = player;
            playerEntity.collidedWithExtractionPointThisFrame = false;
            const playersCurrentGridCell = playerEntity.currentCollisionGridCell;
            // Dont do a collision checks dead players
            if (playerEntity.isAlive === false) continue;
            // Don't do collision checks against players that are already extracted
            if (playerEntity.extractionSuccessful) continue;
            for (const offset of $63b908b83aafc686$export$52ef19685b59c674.GridOffsets){
                const [x, y] = offset;
                const adjacentX = playersCurrentGridCell.column + x;
                const adjacentY = playersCurrentGridCell.row + y;
                // If the potential grid cell that is adjacent to this grid cell is out of the bounds of the world, skip it as this grid cell does not exist
                if (adjacentX > this.broadphaseCollisionGrid.gridWidth - 1 || adjacentY > this.broadphaseCollisionGrid.gridHeight - 1 || adjacentX < 0 || adjacentY < 0) continue;
                const relevantSpatialGridCell = this.broadphaseCollisionGrid.GetGridCellFromGridXY(playersCurrentGridCell.column + x, playersCurrentGridCell.row + y);
                if (relevantSpatialGridCell === undefined) {
                    this.LogWarning("relevantGridCell is undefined despite above safeguards, skipping iteration, likely collision system bug");
                    continue;
                }
                if ((0, $c52f191d3f575144$export$c14d6c08f0e74a8e).DEBUG.DRAW_BROADPHASE_SPATIAL_GRID) relevantSpatialGridCell.isActive = true;
                /**********************************************************************/ /*                                                                    */ /*                                                                    */ /*                  Player <-> Projectile Collision                   */ /*                                                                    */ /*                                                                    */ /**********************************************************************/ for (const projectile of relevantSpatialGridCell.projectiles){
                    const projectileEntity = projectile;
                    // dont even bother checking for collisions if this projectile has already been flagged for removal this frame
                    if (projectileEntity.ToBeDestroyed) continue;
                    // Skip collisions for whom you are the owner (cant shoot yourself)
                    if (projectileEntity.owningEntityNid === playerEntity.nid) continue;
                    this.collisionsCheckedThisFrame++;
                    const collisionResponse = (0, $2104f92cbe769454$exports.testPolygonCircle)(playerEntity.HitboxCollider, projectileEntity.HitboxCollider, this.reusableCollisionResponseObject);
                    if (collisionResponse) {
                        playerEntity.TakeDamage(projectileEntity.damage, projectileEntity.damageType, projectileEntity.owningEntityNid, projectileEntity.playerDamageModifier);
                        projectileEntity.ToBeDestroyed = true;
                    }
                    this.reusableCollisionResponseObject.clear();
                }
                /******************************************************************************/ /*                                                                            */ /*                                                                            */ /*                  Player <-> Extraction Point Collision                     */ /*                                                                            */ /*                                                                            */ /******************************************************************************/ for (const extractionPoint of relevantSpatialGridCell.extractionPoints){
                    const extractionPointEntity = extractionPoint;
                    this.collisionsCheckedThisFrame++;
                    const response = new (0, $2104f92cbe769454$exports.Response)();
                    const collisionResponse = (0, $2104f92cbe769454$exports.testPolygonCircle)(extractionPointEntity.HitboxCollider, playerEntity.MovementCollider, response);
                    if (collisionResponse) playerEntity.collidedWithExtractionPointThisFrame = true;
                }
            }
        }
        for (const projectile of this.projectiles){
            const pr = projectile;
            const projectilesCurrentGridCell = pr.currentCollisionGridCell;
            // Dont do a collision checks on projectiles that are already flagged for destruction
            if (pr.ToBeDestroyed === true) continue;
            for (const offset of $63b908b83aafc686$export$52ef19685b59c674.GridOffsets){
                const [x, y] = offset;
                const adjacentX = projectilesCurrentGridCell.column + x;
                const adjacentY = projectilesCurrentGridCell.row + y;
                // If the potential grid cell that is adjacent to this grid cell is out of the bounds of the world, skip it as this grid cell does not exist
                if (adjacentX > this.broadphaseCollisionGrid.gridWidth - 1 || adjacentY > this.broadphaseCollisionGrid.gridHeight - 1 || adjacentX < 0 || adjacentY < 0) continue;
                const relevantGridCell = this.broadphaseCollisionGrid.GetGridCellFromGridXY(projectilesCurrentGridCell.column + x, projectilesCurrentGridCell.row + y);
                if (relevantGridCell === undefined) {
                    this.LogWarning("relevantGridCell is undefined despite above safeguards, skipping iteration, likely collision system bug");
                    continue;
                }
                if ((0, $c52f191d3f575144$export$c14d6c08f0e74a8e).DEBUG.DRAW_BROADPHASE_SPATIAL_GRID) relevantGridCell.isActive = true;
            }
        }
        // CCD stuff
        // const distancePerTick = projectileConfig.SPEED_PER_SECOND * deltaTime;
        // this.LogInfo('Distance a projectile travels in 1 tick in any direction:', distancePerTick);
        // const maxDistanceBeforeTunneling = projectile.HitboxCollider.r; // arbitrary value for now, seems "big enough" to avoid tunneling for our smallest current projectile
        // this.LogInfo('Max distance before tunneling:', maxDistanceBeforeTunneling);
        // const stepsNeededToAvoidTunneling = Math.ceil(distancePerTick / maxDistanceBeforeTunneling);
        // this.LogInfo('Steps needed to avoid tunneling:', stepsNeededToAvoidTunneling);
        // const ccdDt = deltaTime / stepsNeededToAvoidTunneling;
        // this.LogInfo('ccdDt:', ccdDt);
        // this.LogInfo(` -- Projectile position before CCD: ${projectile.position.x} --`);
        // for (let i = 0; i < stepsNeededToAvoidTunneling; i++) {
        //     this.LogInfo('');
        //     this.LogInfo(`performing intermediate ccd step #${i + 1}`);
        //     // stop future ccd steps if the projectile is already tagged to be destroyed (by previous step)
        //     if (projectile.ToBeDestroyed) continue;
        //     this.LogInfo('prev iteration ccd pos:', projectile.HitboxCollider.pos.x);
        //     projectile.HitboxCollider.pos.x += projectile.velocity.x * (projectileConfig.SPEED_PER_SECOND * ccdDt);
        //     projectile.HitboxCollider.pos.y += projectile.velocity.y * (projectileConfig.SPEED_PER_SECOND * ccdDt);
        //     this.collisionsCheckedThisFrame++;
        //     const collisionResponse: boolean = testCirclePolygon(projectile.HitboxCollider, player.HitboxCollider.toPolygon(), this.reusableCollisionResponseObject);
        //     if (collisionResponse) {
        //         this.LogInfo('!!! Projectile <-> player collision !!!');
        //         player.TakeDamage(7, projectile.owningEntityNid);
        //         projectile.position.x = projectile.HitboxCollider.pos.x;
        //         projectile.position.y = projectile.HitboxCollider.pos.y;
        //         projectile.ToBeDestroyed = true;
        //     } else {
        //         // this.LogInfo('No projectile <-> player collision!');
        //         // Reset the hitbox collider of the projectile to match its expected position this frame (we temporarily incremented if for CCD)
        //         projectile.HitboxCollider.pos.x = projectile.position.x;
        //         projectile.HitboxCollider.pos.y = projectile.position.y;
        //     }
        // }
        // this.LogInfo(` -- Projectile position after CCD: ${projectile.position.x} --`);
        //     }
        // }
        this.ConditionallyLogTickMsg("Collisions checked this frame: " + this.collisionsCheckedThisFrame);
        this.ConditionallyLogTickMsg(`Collision updates took: ${(0, $276f03d77ac4b507$export$b646210dbab6d1e3)() - collisionUpdateStartTimestampMs}ms`);
        this.collisionsCheckedThisFrame = 0;
    }
    Cleanup() {}
}






class $e43461312e04d5e4$export$ca71fcae86980bb {
    constructor(collisionSystem){
        this.nid = -1;
        this.ntype = (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlayerEntity;
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.velocity = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.prevPosition = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.isAlive = true;
        this.maxHealth = 100;
        this.currentHealth = 100;
        this.currentHealthPercentage = 1;
        this.extractionInProgressAccumulator = 0;
        this.collidedWithExtractionPointThisFrame = false;
        this.extractionSuccessful = false;
        this.timeRemainingToExtractInSeconds = (0, $a9786bc83f165385$export$6890cbbf7baa7104).MAX_RUN_DURATION_IN_SECONDS;
        this.MovementCollider = new (0, $2104f92cbe769454$exports.Circle)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).MOVEMENT_COLLIDER_RADIUS);
        this.HitboxCollider = new (0, $2104f92cbe769454$exports.Box)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_WIDTH, (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_HEIGHT).toPolygon();
        this.isOnWater = false;
        this.cantMoveForSecondsAccumulator = 0;
        this.aim = 0;
        this.projectileOrigin = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        // passive abilities
        this.passiveAbilityFlags = {
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).MoveSpeedUp]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).MoveSpeedDown]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).GainHealthOverTime]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).LoseHealthOverTime]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).ProjectileDistanceUp]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).ProjectileDistanceDown]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).MaxHealthIncrease]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).MaxHealthDecrease]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).GoldRush]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).PlayerDamageLeech]: false,
            // [PassiveAbility.WeaponCooldownReset]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).WaterWalking]: false,
            // [PassiveAbility.CorpseExplosion]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).Ethereal]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).Revive]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).AttackSpeedUp]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).AttackSpeedDown]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).ExtractionProtection]: false,
            // [PassiveAbility.ScavMode]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).ExtractionSpeedUp]: false,
            // [PassiveAbility.SmolMode]: false,
            // [PassiveAbility.BigMode]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).PlayerDamageUp]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).PlayerDamageDown]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).NPCDamageUp]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).Information]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).NPCDamageDown]: false,
            [(0, $faa1b3449016497b$export$f81ad329d1573de4).Incognito]: false
        };
        this.extractionProtectionModifier = 1;
        this.extractionSpeedModifier = 1;
        this.playerDamageModifier = 1;
        this.npcDamageModifier = 1;
        this.attackSpeedMultiplier = 1;
        this.waterMovementSpeedMultiplier = 1;
        this.movementSpeedMultiplier = 1;
        this.healthChangePerSecond = 0;
        this.projectileDistanceMultiplier = 1;
        this.characterOpacityAmount = 1;
        this.goldAcquiredMultiplier = 1;
        this.leechMultiplier = 0;
        this.hasExpendedReviveThisRun = false;
        this.reviveHealthPercentageGain = 0;
        // public readonly weaponCooldownResetChance: number = 0.01;
        this.tempMoveSpeedUpAccumulator = 0;
        this.tempMoveSpeedUpAmount = 0;
        this.collisionSystemRef = collisionSystem;
    }
    get activeWeaponSlot() {
        return this.GearAndWeaponSystem.activeWeaponSlot;
    }
    set activeWeaponSlot(newSlot) {
    // no-op
    }
    HasIncognitoAbility() {
        return this.passiveAbilityFlags[(0, $faa1b3449016497b$export$f81ad329d1573de4).Incognito];
    }
    get weaponOneId() {
        return this.GearAndWeaponSystem.equippedWeaponOne;
    }
    set weaponOneId(newVal) {}
    get weaponTwoId() {
        return this.GearAndWeaponSystem.equippedWeaponTwo;
    }
    set weaponTwoId(newVal) {}
    get gearOneId() {
        return this.GearAndWeaponSystem.equippedGearOne;
    }
    set gearOneId(newVal) {}
    get gearTwoId() {
        return this.GearAndWeaponSystem.equippedGearTwo;
    }
    set gearTwoId(newVal) {}
    get gearThreeId() {
        return this.GearAndWeaponSystem.equippedGearThree;
    }
    set gearThreeId(newVal) {}
    get gearOneCharges() {
        return this.GearAndWeaponSystem.GetCharges((0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne);
    }
    set gearOneCharges(__newCharges) {}
    get gearTwoCharges() {
        return this.GearAndWeaponSystem.GetCharges((0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo);
    }
    set gearTwoCharges(__newCharges) {}
    get gearThreeCharges() {
        return this.GearAndWeaponSystem.GetCharges((0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree);
    }
    set gearThreeCharges(__newCharges) {}
    get weaponOneCooldownProgressPercentage() {
        return this.GearAndWeaponSystem.GetCooldownProgressPercentage((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne);
    }
    set weaponOneCooldownProgressPercentage(__newPercentage) {}
    get weaponTwoCooldownProgressPercentage() {
        return this.GearAndWeaponSystem.GetCooldownProgressPercentage((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo);
    }
    set weaponTwoCooldownProgressPercentage(__newPercentage) {}
    get gearOneCooldownProgressPercentage() {
        return this.GearAndWeaponSystem.GetCooldownProgressPercentage((0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne);
    }
    set gearOneCooldownProgressPercentage(__newPercentage) {}
    get gearTwoCooldownProgressPercentage() {
        return this.GearAndWeaponSystem.GetCooldownProgressPercentage((0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo);
    }
    set gearTwoCooldownProgressPercentage(__newPercentage) {}
    get gearThreeCooldownProgressPercentage() {
        return this.GearAndWeaponSystem.GetCooldownProgressPercentage((0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree);
    }
    set gearThreeCooldownProgressPercentage(__newPercentage) {}
    _increaseMoveSpeed(amountAsDecimalPercent) {
        // console.log("increasing move speed in sharedplayer");
        this.movementSpeedMultiplier += amountAsDecimalPercent;
    }
    _increaseExtractionProtectionModifier(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.extractionProtectionModifier -= amountAsDecimalPercent;
    }
    _increaseAttackSpeedModifier(amountAsDecimalPercent) {
        // console.log("increasing attack speed in sharedplayer");
        this.attackSpeedMultiplier -= amountAsDecimalPercent;
    // console.log("attack speed multiplier after applying passive: " + this.attackSpeedMultiplier);
    }
    _decreaseAttackSpeedModifier(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.attackSpeedMultiplier += amountAsDecimalPercent;
    }
    _increaseNPCDamageModifier(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.npcDamageModifier += amountAsDecimalPercent;
    }
    _decreaseNPCDamageModifier(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.npcDamageModifier -= amountAsDecimalPercent;
    }
    _increasePlayerDamageModifier(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.playerDamageModifier += amountAsDecimalPercent;
    }
    _decreasePlayerDamageModifier(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.playerDamageModifier -= amountAsDecimalPercent;
    }
    _increaseExtractionSpeedModifier(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.extractionSpeedModifier += amountAsDecimalPercent;
    }
    _increaseWaterMoveSpeed(amountAsDecimalPercent) {
        // console.log("increasing water move speed in sharedplayer");
        this.waterMovementSpeedMultiplier += amountAsDecimalPercent;
    }
    _decreaseMoveSpeed(amountAsDecimalPercent) {
        // console.log("decreasing move speed in sharedplayer");
        this.movementSpeedMultiplier -= amountAsDecimalPercent;
    }
    _addHealthGainOverTime(amount) {
        // console.log("adding health gain over time in sharedplayer");
        this.healthChangePerSecond += amount;
    }
    _addHealthLossOverTime(amount) {
        // console.log("adding health loss over time in sharedplayer");
        this.healthChangePerSecond -= amount;
    }
    _increaseProjectileDistance(amountAsDecimalPercent) {
        // console.log("increasing projectile distance in sharedplayer");
        this.projectileDistanceMultiplier += amountAsDecimalPercent;
    }
    _decreaseProjectileDistance(amountAsDecimalPercent) {
        // console.log("decreasing projectile distance in sharedplayer");
        this.projectileDistanceMultiplier -= amountAsDecimalPercent;
    }
    _increaseMaxHealth(amount, matchCurrentHealth = false) {
        // console.log("increasing max health in sharedplayer");
        this.maxHealth += amount;
        if (matchCurrentHealth) this.currentHealth = this.maxHealth;
    }
    _decreaseMaxHealth(amount, matchCurrentHealth = false) {
        // console.log("decreasing max health in sharedplayer");
        this.maxHealth -= amount;
        if (matchCurrentHealth) this.currentHealth = this.maxHealth;
    }
    _increaseGoldAcquiredModifier(amountAsDecimalPercent) {
        // console.log("increasing gold acquired modifier in sharedplayer");
        this.goldAcquiredMultiplier += amountAsDecimalPercent;
    // console.log("modifier now:", this.goldAcquiredMultiplier);
    }
    _increaseLeechModifier(amountAsDecimalPercent) {
        // console.log("increasing leech modifier in sharedplayer");
        this.leechMultiplier += amountAsDecimalPercent;
    }
    _increaseReviveModifier(amountAsDecimalPercent) {
        // console.log("increasing revive modifier in sharedplayer");
        this.reviveHealthPercentageGain += amountAsDecimalPercent;
    }
    _makePlayerEthereal(amountAsDecimalPercent) {
        this.characterOpacityAmount = (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(this.characterOpacityAmount - amountAsDecimalPercent, 0.1, 1);
    }
    get x() {
        return this.position.x;
    }
    set x(newX) {
        this.position.x = newX;
        this.MovementCollider.pos.x = this.x;
        this.HitboxCollider.pos.x = this.x - (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_WIDTH / 2;
    }
    get y() {
        return this.position.y;
    }
    set y(newY) {
        this.position.y = newY;
        this.MovementCollider.pos.y = this.y + (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).MOVEMENT_COLLIDER_Y_OFFSET;
        this.HitboxCollider.pos.y = this.y - (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_HEIGHT / 2;
    }
    get prevX() {
        return this.prevPosition.x;
    }
    set prevX(newX) {
        this.prevPosition.x = newX;
    }
    get prevY() {
        return this.prevPosition.y;
    }
    set prevY(newY) {
        this.prevPosition.y = newY;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    // public UseActiveAbility_Relocation(): void {
    //     this.cantMoveForSecondsAccumulator = 4;
    // }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UseActiveAbility_Dash(amountAsDecimalPercent, durationInSeconds) {
        this._increaseMoveSpeed(amountAsDecimalPercent);
        this.tempMoveSpeedUpAccumulator = durationInSeconds;
        this.tempMoveSpeedUpAmount = amountAsDecimalPercent;
    }
    _updateProjectileOriginBasedOnWeaponOffset() {
        // TODO: updated projectile origin based on weapon offset
        this.projectileOrigin.x = this.x + Math.cos(this.aim) * 18;
        this.projectileOrigin.y = this.y + Math.sin(this.aim) * 18;
    }
    ProcessInputs(inputCommand) {
        const { up: up , left: left , down: down , right: right , aim: aim , delta: delta  } = inputCommand;
        // Undo temp buffs that require determinism
        if (this.tempMoveSpeedUpAccumulator > 0) {
            this.tempMoveSpeedUpAccumulator = (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(this.tempMoveSpeedUpAccumulator - delta, 0, 1000);
            if (this.tempMoveSpeedUpAccumulator <= 0) {
                this._decreaseMoveSpeed(this.tempMoveSpeedUpAmount);
                this.tempMoveSpeedUpAmount = 0;
            }
        }
        this.aim = aim;
        if (up) this.velocity.y = -1;
        if (down) this.velocity.y = 1;
        if (left) this.velocity.x = -1;
        if (right) this.velocity.x = 1;
        this.GearAndWeaponSystem.ProcessInputs(inputCommand);
        this.Move(delta);
    }
    Move(deltaTime) {
        this.prevX = this.x;
        this.prevY = this.y;
        // console.log(deltaTime);
        if (deltaTime > 0.1) deltaTime = 0.1;
        if (this.healthChangePerSecond !== 0) {
            // console.log("player has some health change per second, applying it!");
            // console.log("current health before: ", this.currentHealth);
            // console.log("taking damage:", this.healthChangePerSecond * deltaTime);
            if (this.healthChangePerSecond > 0) this.HealHealth(this.healthChangePerSecond * deltaTime);
            else if (this.healthChangePerSecond < 0) this.TakeDamage(Math.abs(this.healthChangePerSecond * deltaTime), (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos, -2, 1);
        // console.log("current health is now: ", this.currentHealth);
        }
        const cappedVelocityMagnitude = Math.sqrt(this.velocity.x * this.velocity.x + this.velocity.y * this.velocity.y);
        if (cappedVelocityMagnitude !== 0) {
            this.velocity.x /= cappedVelocityMagnitude;
            this.velocity.y /= cappedVelocityMagnitude;
        }
        if (this.GearAndWeaponSystem.ShouldSlowMovementBecauseOfShooting()) {
            const movementImpactFromShooting = this.GearAndWeaponSystem.GetPlayerMovementImpactModifier();
            this.velocity.x *= movementImpactFromShooting;
            this.velocity.y *= movementImpactFromShooting;
        }
        this.velocity.x *= this.movementSpeedMultiplier;
        this.velocity.y *= this.movementSpeedMultiplier;
        if (this.cantMoveForSecondsAccumulator > 0) {
            this.cantMoveForSecondsAccumulator -= deltaTime;
            return;
        }
        if (this.isOnWater) {
            this.velocity.x *= this.waterMovementSpeedMultiplier;
            this.velocity.y *= this.waterMovementSpeedMultiplier;
        }
        this.x = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(this.x + this.velocity.x * ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).SPEED_PER_SECOND * deltaTime));
        this.y = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(this.y + this.velocity.y * ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).SPEED_PER_SECOND * deltaTime));
        this.velocity.x = 0;
        this.velocity.y = 0;
        this._applyMapCollisions();
    }
    _applyMapCollisions() {
        const currentTileGridX = Math.floor(this.MovementCollider.pos.x / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
        const currentTileGridY = Math.floor(this.MovementCollider.pos.y / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
        for (const offset of (0, $63b908b83aafc686$export$52ef19685b59c674).GridOffsets){
            const [xOffset, yOffset] = offset;
            const relevantTileGridX = currentTileGridX + xOffset;
            const relevantTileGridY = currentTileGridY + yOffset;
            // Don't include tiles outside of the world
            if (relevantTileGridX > (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS - 1 || relevantTileGridY > (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS - 1 || relevantTileGridX < 0 || relevantTileGridY < 0) continue;
            if (xOffset === 0 && yOffset === 0) {
                if (this.collisionSystemRef.IsTileAtGridXYaSpecificTileId(relevantTileGridX, relevantTileGridY, (0, $f4842134c1afe84a$export$eb95ba86e8878685).FULL_WATER)) this.isOnWater = true;
                else this.isOnWater = false;
            }
            const collisionPolygon = this.collisionSystemRef.GetCollisionPolygonAtGridXY(relevantTileGridX, relevantTileGridY);
            if (collisionPolygon) {
                const collisionResponse = this.collisionSystemRef.PerformOneOffCirclePolygonCollisionCheck(this.MovementCollider, collisionPolygon);
                if (collisionResponse) {
                    const { overlapV: overlapV  } = collisionResponse;
                    this.MovementCollider.pos.add(overlapV);
                    this.position.x = this.MovementCollider.pos.x;
                    this.position.y = this.MovementCollider.pos.y - (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).MOVEMENT_COLLIDER_Y_OFFSET;
                    this.x = this.position.x;
                    this.y = this.position.y;
                }
            }
        }
    }
    Update(__deltaTime, __currentTimeInMilliseconds) {
        this._updateProjectileOriginBasedOnWeaponOffset();
    }
    TakeDamage(__damage, __damageType, __damageDealerNid, __playerDamageModifier) {}
    HealHealth(__amount) {}
}











class $9963602032b82d57$export$75d5526a7020db extends (0, $e43461312e04d5e4$export$ca71fcae86980bb) {
    constructor(createPlayerPayload){
        super(Game.Collision);
        this.debugRotatingVisualsParent = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.wasDeadOnInit = false;
        this.wasExtractedOnInit = false;
        this.isMyEntity = false;
        this.RenderedEntity = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.healthBarContainer = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.healthBarWidth = 25;
        this.healthBarHeight = 3;
        this.healthBarHeightOffset = 20;
        this.animationSpeed = 1 / 9;
        this.lastOpacityAmount = 0;
        this.lastKnownExtractionState = false;
        this.lastKnownLivelihoodState = true;
        this.lastKnownHealthPercentage = 1;
        this.lastTookDamageTimestamp = 0;
        this.damageTakenFlashDurationInMilliseconds = 250;
        this.damageTakenFlashColor = 0xff0000;
        this.timeBeforeHealthBarFadesInMilliseconds = 1500;
        this.InteractingWithContainerOfId = null;
        this.username = "";
        this.IsDeveloper = false;
        this.hasInformationPassiveItem = false;
        this.IsSupporter = false;
        this.IsFounder = false;
        this.lastBroadcastedExtractionInProgressTimer = 0;
        this.lastBroadcastedTimeExpiryTimer = (0, $a9786bc83f165385$export$6890cbbf7baa7104).MAX_RUN_DURATION_IN_SECONDS;
        this.originalCreationPayload = createPlayerPayload;
        // console.log("\n\n creating new local player entity");
        // console.log("original creation payload on client:", this.originalCreationPayload);
        const { nid: nid , x: x , y: y , username: username , aim: aim , debugViewWidth: debugViewWidth , debugViewHeight: debugViewHeight , isAlive: isAlive , currentHealthPercentage: currentHealthPercentage , IsDeveloper: IsDeveloper , weaponOneId: weaponOneId , weaponTwoId: weaponTwoId , gearOneId: gearOneId , gearTwoId: gearTwoId , gearThreeId: gearThreeId , insuredSlot: insuredSlot , userType: userType , activeWeaponSlot: activeWeaponSlot , characterSkin: characterSkin , extractionSuccessful: extractionSuccessful , characterOpacityAmount: characterOpacityAmount , hasInformationPassive: hasInformationPassive , IsSupporter: IsSupporter , IsFounder: IsFounder  } = createPlayerPayload;
        this.IsDeveloper = IsDeveloper;
        this.IsSupporter = IsSupporter;
        this.IsFounder = IsFounder;
        // console.log("@@@");
        // console.log(hasInformationPassive);
        this.hasInformationPassiveItem = hasInformationPassive;
        // console.log("full createPlayerPayload", createPlayerPayload);
        // console.warn("@@@ isAlive in createPlayerPayload:", isAlive);
        this.nid = nid;
        this.userType = userType;
        this.characterSkin = characterSkin;
        this.insuredSlot = insuredSlot;
        const justItemsInLoadout = [
            weaponOneId,
            weaponTwoId,
            gearOneId,
            gearTwoId,
            gearThreeId
        ];
        this._setupPassiveAbilitiesFromLoadout(justItemsInLoadout);
        const { inGameSpriteId: wepOneSpriteId , inGameSpriteScale: wepOneSpriteScale  } = (0, $0acc22698d702be9$export$f96416c73a613aba)(weaponOneId);
        const { inGameSpriteId: wepTwoSpriteId , inGameSpriteScale: wepTwoSpriteScale  } = (0, $0acc22698d702be9$export$f96416c73a613aba)(weaponTwoId);
        const characterSkinData = (0, $cee99d2008daa3ee$export$183400f7af0e3a3c).get(characterSkin);
        if (this.IsDeveloper) {
            this.characterSpriteIdleAnimationId = "enemies/ANIM_ironFox_idle";
            this.characterSpriteWalkAnimationId = "enemies/ANIM_ironFox_walk";
        } else {
            this.characterSpriteIdleAnimationId = characterSkinData.idleFramesSpriteId;
            this.characterSpriteWalkAnimationId = characterSkinData.walkFramesSpriteId;
        }
        this.characterSpriteYOffset = characterSkinData.spriteYOffset;
        this.weaponOneSpriteId = wepOneSpriteId;
        this.weaponOneSpriteScale = wepOneSpriteScale;
        this.weaponTwoSpriteId = wepTwoSpriteId;
        this.weaponTwoSpriteScale = wepTwoSpriteScale;
        this.x = x;
        this.y = y;
        this.RenderedEntity.x = x;
        this.RenderedEntity.y = y;
        this.aim = aim;
        this.debugViewHeight = debugViewHeight;
        this.debugViewWidth = debugViewWidth;
        // console.warn("@@@ PLAYER ALIVE STATE IN CTOR:", isAlive);
        // console.warn("@@@ PLAYER EXTRACTED STATE IN CTOR", extractionSuccessful);
        this.isAlive = isAlive;
        if (this.isAlive === false) this.wasDeadOnInit = true;
        if (extractionSuccessful === true) this.wasExtractedOnInit = true;
        this.lastKnownExtractionState = extractionSuccessful;
        this.lastKnownLivelihoodState = isAlive;
        this.currentHealthPercentage = currentHealthPercentage;
        this.lastKnownHealthPercentage = currentHealthPercentage;
        this.username = username;
        this._setupCharacterVisuals(activeWeaponSlot);
        this._setupDebugVisuals();
        this.RenderedEntity.addChild(this.debugRotatingVisualsParent);
        // Hide dead entities when they are first created (as this is indicative of them already being in thet process of being destroyed, no point in showing them on this client)
        if (this.wasDeadOnInit === true) this._die(false);
        else if (this.wasExtractedOnInit === true) this._extract(false);
        else this.RenderedEntity.alpha = characterOpacityAmount;
    }
    _setupPassiveAbilitiesFromLoadout(equippedItems) {
        // console.log("\n\n---");
        // console.log("equipped items..", equippedItems);
        // console.log("PLAYERS PASSIVE ABILITIES BEFORE (CLIENT):", JSON.stringify(this.passiveAbilityFlags));
        for(let i = 0; i < equippedItems.length; i++){
            const item = equippedItems[i];
            if (item === -1) continue;
            const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(item);
            const { passiveAbilities: passiveAbilities  } = itemConfig;
            if (passiveAbilities.length === 0) continue;
            for(let j = 0; j < passiveAbilities.length; j++){
                // console.log("Applying passive ability:", PassiveAbility[passiveAbilities[j].passiveAbility], ` because item ${itemConfig.name} has it configured!`);
                this.passiveAbilityFlags[passiveAbilities[j].passiveAbility] = true;
                switch(passiveAbilities[j].passiveAbility){
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).MoveSpeedUp:
                        super._increaseMoveSpeed(passiveAbilities[j].abilityParameter);
                        break;
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).MoveSpeedDown:
                        super._decreaseMoveSpeed(passiveAbilities[j].abilityParameter);
                        break;
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).ProjectileDistanceUp:
                        super._increaseProjectileDistance(passiveAbilities[j].abilityParameter);
                        break;
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).ProjectileDistanceDown:
                        super._decreaseProjectileDistance(passiveAbilities[j].abilityParameter);
                        break;
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).AttackSpeedUp:
                        super._increaseAttackSpeedModifier(passiveAbilities[j].abilityParameter);
                        break;
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).AttackSpeedDown:
                        super._decreaseAttackSpeedModifier(passiveAbilities[j].abilityParameter);
                        break;
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).Ethereal:
                        super._makePlayerEthereal(passiveAbilities[j].abilityParameter);
                        break;
                    case (0, $faa1b3449016497b$export$f81ad329d1573de4).WaterWalking:
                        super._increaseWaterMoveSpeed(passiveAbilities[j].abilityParameter);
                        break;
                    default:
                        break;
                }
            }
        }
    // console.log("PLAYERS PASSIVE ABILITIES AFTER (CLIENT):", JSON.stringify(this.passiveAbilityFlags));
    }
    IdentifyAsMyPlayer() {
        this.isMyEntity = true;
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_NETWORK_VIEW) {
            this.debugNetworkViewSquare = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugNetworkViewSquare.lineStyle(2, 0xff0000, 1);
            this.debugNetworkViewSquare.drawRect(0 - this.debugViewWidth / 2, 0 - this.debugViewHeight / 2, this.debugViewWidth, this.debugViewHeight);
            this.RenderedEntity.addChild(this.debugNetworkViewSquare);
            this.debugNetworkViewSquareText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(`Player view dimensions: ${this.debugViewWidth}x${this.debugViewHeight}`, {
                fontFamily: "alagardmedium",
                fontSize: 64,
                fill: 0x000000
            });
            this.debugNetworkViewSquareText.scale.set(0.1);
            this.debugNetworkViewSquareText.x = -this.debugViewWidth / 2 + 5;
            this.debugNetworkViewSquareText.y = -this.debugViewHeight / 2 + 5;
            this.RenderedEntity.addChild(this.debugNetworkViewSquareText);
            Game.ListenForEvent("Resizer::GameWindowResizeComplete", ({ newScaledWidth: newScaledWidth , newScaledHeight: newScaledHeight  })=>{
                this.debugNetworkViewSquareText.text = `Player view dimensions: ${this.debugViewWidth}x${this.debugViewHeight}`;
                this.debugNetworkViewSquareText.x = -this.debugViewWidth / 2 + 5;
                this.debugNetworkViewSquareText.y = -this.debugViewHeight / 2 + 5;
                this.debugNetworkViewSquare.clear();
                this.debugNetworkViewSquare.lineStyle(2, 0xff0000, 1);
                this.debugNetworkViewSquare.drawRect(0 - newScaledWidth / 2, 0 - newScaledHeight / 2, newScaledWidth, newScaledHeight);
            });
        }
        // this.usernameText.alpha = 0;
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION) {
            if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_SERVERSIDE_SELF_DURING_PREDICTION === false) this._hideVisuals();
        }
        // Remove our own entity from collision system
        Game.Collision.RemoveEntity(this);
    }
    set activeWeaponSlot(newSlot) {
        if (newSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne) {
            this.weaponOneSprite.alpha = 1;
            this.weaponTwoSprite.alpha = 0;
            if (this.isMyEntity) (0, $9b9fb0750f8f8ccb$export$7e1a92d919d9ab21)((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne);
        } else if (newSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo) {
            this.weaponOneSprite.alpha = 0;
            this.weaponTwoSprite.alpha = 1;
            if (this.isMyEntity) (0, $9b9fb0750f8f8ccb$export$7e1a92d919d9ab21)((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo);
        } else throw new Error("Invalid weapon slot received by client");
        if (this.IsDeveloper) {
            this.weaponOneSprite.alpha = 0;
            this.weaponTwoSprite.alpha = 0;
        }
    }
    _die(playDeathAnimation = false) {
        console.log("Player died!");
        if (playDeathAnimation && this.isMyEntity === false) Game.Renderer.PlayOneOffPfx(this.x, this.y + 2, "pfx/death/effect_death", 1, 1, 1);
        this.lastKnownLivelihoodState = false;
        this._hideVisuals();
    }
    _extract(playExtractionAnimation = false) {
        console.log("Player extracted!");
        if (playExtractionAnimation && this.isMyEntity === false) Game.Renderer.PlayOneOffPfx(this.x, this.y - 15, "pfx/teleport/effect_teleport", 1.5, 1, 1);
        this._hideVisuals();
        this.lastKnownExtractionState = true;
    }
    _setupCharacterVisuals(initialActiveWeaponSlot) {
        //#region Player Character
        /****************************************/ /*                                      */ /*             Character                */ /*                                      */ /****************************************/ const idleAnimation = Game.Loader.GetAnimation(this.characterSpriteIdleAnimationId);
        const movingAnimation = Game.Loader.GetAnimation(this.characterSpriteWalkAnimationId);
        this.idleFrames = new Array();
        for(let i = 0; i < idleAnimation.length; i++)this.idleFrames.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(idleAnimation[i]));
        this.walkFrames = new Array();
        for(let i = 0; i < movingAnimation.length; i++)this.walkFrames.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(movingAnimation[i]));
        this.characterSprite = new (0, $bef80d21b8b0b6b2$export$dae599798687ad3c)(this.idleFrames);
        this.characterSprite.position.y = this.characterSpriteYOffset;
        this.characterSprite.scale.set(1);
        this.characterSprite.anchor.set(0.5, 0.5);
        this.characterSprite.animationSpeed = this.animationSpeed;
        this.characterSprite.play();
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.HIDE_PLAYER_SPRITE) this.characterSprite.alpha = 0;
        this.RenderedEntity.addChild(this.characterSprite);
        //#endregion
        //#region Weapons
        /****************************************/ /*                                      */ /*              Weapons                 */ /*                                      */ /****************************************/ /*******************/ /*     Weapon  1   */ /*******************/ this.weaponOneSprite = (0, $28766cd6a31d5ed8$export$3075603db8e6204c).from(Game.Loader.GetSpritesheetTexture(this.weaponOneSpriteId));
        this.weaponOneSprite.scale.set(this.weaponOneSpriteScale);
        this.weaponOneSprite.anchor.set(0.25, 0.5);
        this.weaponOneSprite.position.set(0, 0);
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.HIDE_WEAPON_SPRITE || this.IsDeveloper) this.weaponOneSprite.alpha = 0;
        this.RenderedEntity.addChild(this.weaponOneSprite);
        /*******************/ /*     Weapon  2   */ /*******************/ this.weaponTwoSprite = (0, $28766cd6a31d5ed8$export$3075603db8e6204c).from(Game.Loader.GetSpritesheetTexture(this.weaponTwoSpriteId));
        this.weaponTwoSprite.scale.set(this.weaponTwoSpriteScale);
        this.weaponTwoSprite.anchor.set(0.25, 0.5);
        this.weaponTwoSprite.position.set(0, 0);
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.HIDE_WEAPON_SPRITE || this.IsDeveloper) this.weaponTwoSprite.alpha = 0;
        this.RenderedEntity.addChild(this.weaponTwoSprite);
        if (initialActiveWeaponSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne) this.weaponTwoSprite.alpha = 0;
        else if (initialActiveWeaponSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo) this.weaponOneSprite.alpha = 0;
        else throw new Error(`Invalid initialActiveWeaponSlot in ClientPlayerBase _setupCharacterVisuals: ${initialActiveWeaponSlot}`);
        //#endregion
        //#region Username
        /****************************************/ /*                                      */ /*              Username                */ /*                                      */ /****************************************/ console.warn(this.IsSupporter);
        console.warn(this.IsFounder);
        const usernameColor = this.IsFounder ? 0x551a8b : this.IsSupporter ? 0x0000ff : 0xffffff;
        this.usernameText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(this.username, {
            fontFamily: "alagardmedium",
            fontSize: this.IsDeveloper ? 112 : 56,
            fill: usernameColor
        });
        this.usernameText.scale.set(0.15);
        this.usernameText.anchor.set(0.5, 0.5);
        if (this.IsDeveloper) this.usernameText.y -= 40;
        else this.usernameText.y -= 20;
        this.RenderedEntity.addChild(this.usernameText);
        //#endregion
        //#region Health Text
        /****************************************/ /*                                      */ /*              Health Text             */ /*                                      */ /****************************************/ if (Game.Renderer.MyLocalEntityHasInformationPassive) {
            this.healthText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(`${Math.ceil(this.currentHealthPercentage * 100)}/100`, {
                fontFamily: "alagardmedium",
                fontSize: 56,
                fill: 0xffffff
            });
            this.healthText.scale.set(0.15);
            this.healthText.anchor.set(0.5, 0.5);
            this.healthText.y += 27;
            this.RenderedEntity.addChild(this.healthText);
        }
        //#endregion
        //#region Health Bar
        /****************************************/ /*                                      */ /*              Healthbar               */ /*                                      */ /****************************************/ // Create the healthBarBackground rectangle
        this.healthBarBackground = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.healthBarBackground.beginFill(0x000000);
        this.healthBarBackground.drawRect(0 - this.healthBarWidth / 2, this.healthBarHeightOffset, this.healthBarWidth, this.healthBarHeight);
        this.healthBarBackground.endFill();
        this.healthBarContainer.addChild(this.healthBarBackground);
        // Create the foreground rectangle
        this.healthBarForeground = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.healthBarForeground.beginFill(0xff0000);
        this.healthBarForeground.drawRect(0 - this.healthBarWidth / 2, this.healthBarHeightOffset, this.healthBarWidth, this.healthBarHeight);
        this.healthBarForeground.endFill();
        this.healthBarContainer.addChild(this.healthBarForeground);
        // Position the healthBarForeground rectangle relative to the healthBarBackground rectangle
        this.healthBarForeground.position.x = this.healthBarBackground.position.x;
        this.healthBarForeground.position.y = this.healthBarBackground.position.y;
        // Set the mask for the healthBarForeground rectangle to be a rectangle with the same dimensions as the background rectangle
        this.healthBarForeground.mask = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.healthBarForeground.mask.beginFill(0xffffff);
        this.healthBarForeground.mask.drawRect(0 - this.healthBarWidth / 2, this.healthBarHeightOffset, this.healthBarWidth, this.healthBarHeight);
        this.healthBarForeground.mask.endFill();
        this.healthBarContainer.addChild(this.healthBarForeground.mask);
        if (Game.Renderer.MyLocalEntityHasInformationPassive === false) this.healthBarContainer.alpha = 0;
        this.RenderedEntity.addChild(this.healthBarContainer);
    //#endregion
    }
    _setupDebugVisuals() {
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_AIM_INDICATOR) {
            const aimIndicatorLength = (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).MOVEMENT_COLLIDER_RADIUS + ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.AIM_INDICATOR_SHOULD_BE_LONG_AF ? 10000 : 17);
            this.debugAimIndicator = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugAimIndicator.lineStyle(2, 0x00ff00);
            this.debugAimIndicator.moveTo(0, 0);
            this.debugAimIndicator.lineTo(aimIndicatorLength, 0);
            this.debugRotatingVisualsParent.addChild(this.debugAimIndicator);
        }
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_HITBOX_COLLIDER) {
            this.debugHitboxCollider = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            // this.debugHitboxCollider.beginFill(0x000000);
            this.debugHitboxCollider.lineStyle(1, 0x000000);
            this.debugHitboxCollider.drawRect(0 - (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_WIDTH / 2, 0 - (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_HEIGHT / 2, (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_WIDTH, (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).HITBOX_COLLIDER_HEIGHT);
            this.debugHitboxCollider.endFill();
            this.RenderedEntity.addChild(this.debugHitboxCollider);
        }
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_MOVEMENT_COLLIDER) {
            this.debugMovementCollider = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugMovementCollider.lineStyle(1, 0x0000ff);
            this.debugMovementCollider.drawCircle(0, (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).MOVEMENT_COLLIDER_Y_OFFSET, (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).MOVEMENT_COLLIDER_RADIUS);
            this.debugMovementCollider.endFill();
            this.debugMovementColliderCenter = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugMovementColliderCenter.lineStyle(1, 0xffffff);
            this.debugMovementColliderCenter.drawCircle(0, (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).MOVEMENT_COLLIDER_Y_OFFSET, 1);
            this.debugMovementColliderCenter.endFill();
            this.RenderedEntity.addChild(this.debugMovementCollider);
            this.RenderedEntity.addChild(this.debugMovementColliderCenter);
        }
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_CENTERPOINT) {
            this.debugCenterpoint = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugCenterpoint.beginFill(0xffffff);
            this.debugCenterpoint.drawCircle(0, 0, 2);
            this.debugCenterpoint.endFill();
            this.debugRotatingVisualsParent.addChild(this.debugCenterpoint);
        }
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_PROJECTILE_ORIGIN_INDICATOR) {
            this.debugProjectileOrigin = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugProjectileOrigin.beginFill(0x000000);
            this.debugProjectileOrigin.drawCircle(18, 0, 3);
            this.debugProjectileOrigin.endFill();
            this.debugRotatingVisualsParent.addChild(this.debugProjectileOrigin);
        }
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_POSITION_TEXT) {
            this.debugPositionText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(`${Math.floor(this.x)}x, ${Math.floor(this.y)}y`, {
                fontFamily: "alagardmedium",
                fontSize: 64,
                fill: 0xffffff
            });
            this.debugPositionText.scale.set(0.1);
            this.debugPositionText.anchor.set(0.5, 0.5);
            this.debugPositionText.y += 30;
            this.RenderedEntity.addChild(this.debugPositionText);
        }
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_TILE_GRID_TEXT) {
            const currentTileGridX = Math.floor(this.MovementCollider.pos.x / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
            const currentTileGridY = Math.floor(this.MovementCollider.pos.y / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
            this.debugTileGridPositionText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(`${currentTileGridX}x, ${currentTileGridY}y`, {
                fontFamily: "alagardmedium",
                fontSize: 64,
                fill: 0xffffff
            });
            this.debugTileGridPositionText.scale.set(0.1);
            this.debugTileGridPositionText.anchor.set(0.5, 0.5);
            this.debugTileGridPositionText.y += 50;
            this.RenderedEntity.addChild(this.debugTileGridPositionText);
        }
    }
    _showVisuals() {
        this.RenderedEntity.alpha = 1;
    }
    _fadeVisuals() {
        this.RenderedEntity.alpha = 1;
    }
    _hideVisuals() {
        this.RenderedEntity.alpha = 0;
    }
    // TODO make damage flashes better, likely via the pixi-heaven plugin
    _triggerDamageFlash() {
        this.characterSprite.tint = this.damageTakenFlashColor;
    }
    _undoDamageFlash() {
        this.characterSprite.tint = 0xffffff;
    }
    _updateCharacterVisuals(deltaTime, currentTimeInMilliseconds) {
        if (this.currentHealthPercentage !== this.lastKnownHealthPercentage && this.currentHealthPercentage < this.lastKnownHealthPercentage) {
            this.healthBarContainer.alpha = 1;
            this._triggerDamageFlash();
            this.lastTookDamageTimestamp = currentTimeInMilliseconds;
            this.lastKnownHealthPercentage = this.currentHealthPercentage;
            if (Game.Renderer.MyLocalEntityHasInformationPassive) {
                if (this.healthText !== undefined) this.healthText.text = `${Math.ceil(this.currentHealthPercentage * 100)}/100`;
            }
        }
        const timeSinceLastTookDamage = currentTimeInMilliseconds - this.lastTookDamageTimestamp;
        if (timeSinceLastTookDamage > this.timeBeforeHealthBarFadesInMilliseconds && this.currentHealthPercentage >= 98 && Game.Renderer.MyLocalEntityHasInformationPassive === false) this.healthBarContainer.alpha -= deltaTime;
        if (timeSinceLastTookDamage > this.damageTakenFlashDurationInMilliseconds) this._undoDamageFlash();
        if (this.x !== this.clientLastFrameX || this.y !== this.clientLastFrameY) this.isMovingThisFrame = true;
        else this.isMovingThisFrame = false;
        this.RenderedEntity.x = this.x;
        this.RenderedEntity.y = this.y;
        this.RenderedEntity.zIndex = this.y + 10;
        if (this.wasMovingLastFrame === true && this.isMovingThisFrame === false) {
            this.characterSprite.textures = this.idleFrames;
            this.characterSprite.play();
        }
        if (this.wasMovingLastFrame === false && this.isMovingThisFrame === true) {
            this.characterSprite.textures = this.walkFrames;
            this.characterSprite.play();
        }
        if (this.healthBarForeground !== undefined) this.healthBarForeground.mask.width = this.currentHealthPercentage * this.healthBarWidth;
        this.clientLastFrameX = this.x;
        this.clientLastFrameY = this.y;
        this.wasMovingLastFrame = this.isMovingThisFrame;
        this._updateWeaponAim();
    }
    _updateDebugVisuals(__deltaTime) {
        this.debugRotatingVisualsParent.rotation = this.aim;
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_POSITION_TEXT) this.debugPositionText.text = `${Math.floor(this.x)}x, ${Math.floor(this.y)}y`;
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.DRAW_TILE_GRID_TEXT) {
            const currentTileGridX = Math.floor(this.MovementCollider.pos.x / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
            const currentTileGridY = Math.floor(this.MovementCollider.pos.y / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
            this.debugTileGridPositionText.text = `${currentTileGridX}x, ${currentTileGridY}y`;
        }
    }
    _updateWeaponAim() {
        const facing = this.aim > -Math.PI / 2 && this.aim < Math.PI / 2 ? (0, $69a172d21320641e$export$14498c06a50e821e).Right : (0, $69a172d21320641e$export$14498c06a50e821e).Left;
        this.weaponOneSprite.rotation = facing === (0, $69a172d21320641e$export$14498c06a50e821e).Left ? this.aim + Math.PI : this.aim;
        this.weaponTwoSprite.rotation = facing === (0, $69a172d21320641e$export$14498c06a50e821e).Left ? this.aim + Math.PI : this.aim;
        if (facing === this.facingLastFrame) return;
        if (facing === (0, $69a172d21320641e$export$14498c06a50e821e).Left) {
            this.characterSprite.scale.x = -1;
            this.weaponOneSprite.scale.x = -1;
            this.weaponTwoSprite.scale.x = -1;
        } else {
            this.characterSprite.scale.x = 1;
            this.weaponOneSprite.scale.x = 1;
            this.weaponTwoSprite.scale.x = 1;
        }
        this.facingLastFrame = facing;
    }
    // public override set weaponOneCooldownProgressPercentage(__newPercentage: number) {
    //     if (this.isMyEntity) {
    //         console.log("Weapon one cooldown progress %:", __newPercentage);
    //     }
    // }
    // public override set weaponTwoCooldownProgressPercentage(__newPercentage: number) {
    //     if (this.isMyEntity) {
    //         console.log("Weapon two cooldown progress %:", __newPercentage);
    //     }
    // }
    // public override set gearOneCooldownProgressPercentage(__newPercentage: number) {
    //     if (this.isMyEntity) {
    //         console.log("Gear one cooldown progress %:", __newPercentage);
    //     }
    // }
    // public override set gearTwoCooldownProgressPercentage(__newPercentage: number) {
    //     if (this.isMyEntity) {
    //         console.log("Gear two cooldown progress %:", __newPercentage);
    //     }
    // }
    // public override set gearThreeCooldownProgressPercentage(__newPercentage: number) {
    //     if (this.isMyEntity) {
    //         console.log("Gear three cooldown progress %:", __newPercentage);
    //     }
    // }
    _emitUIEvents() {
        const extractionInProgressTimerAsPercentage = (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(Math.ceil(this.extractionInProgressAccumulator / (0, $a9786bc83f165385$export$6890cbbf7baa7104).TIME_TO_EXTRACT_IN_SECONDS * 100), 0, 100);
        if (this.lastBroadcastedExtractionInProgressTimer === 0 && extractionInProgressTimerAsPercentage !== 0 && extractionInProgressTimerAsPercentage !== 100) {
            (0, $9b9fb0750f8f8ccb$export$78b432a0867784be)(extractionInProgressTimerAsPercentage);
            this.lastBroadcastedExtractionInProgressTimer = extractionInProgressTimerAsPercentage;
        } else if (this.lastBroadcastedExtractionInProgressTimer < 100 && extractionInProgressTimerAsPercentage === 100) {
            (0, $9b9fb0750f8f8ccb$export$78b432a0867784be)(extractionInProgressTimerAsPercentage);
            this.lastBroadcastedExtractionInProgressTimer = extractionInProgressTimerAsPercentage;
        } else if (this.lastBroadcastedExtractionInProgressTimer !== extractionInProgressTimerAsPercentage) {
            (0, $9b9fb0750f8f8ccb$export$78b432a0867784be)(extractionInProgressTimerAsPercentage);
            this.lastBroadcastedExtractionInProgressTimer = extractionInProgressTimerAsPercentage;
        }
        if (this.lastBroadcastedTimeExpiryTimer === (0, $a9786bc83f165385$export$6890cbbf7baa7104).MAX_RUN_DURATION_IN_SECONDS && this.timeRemainingToExtractInSeconds !== (0, $a9786bc83f165385$export$6890cbbf7baa7104).MAX_RUN_DURATION_IN_SECONDS) {
            (0, $9b9fb0750f8f8ccb$export$8e4e970d9670815f)(this.timeRemainingToExtractInSeconds);
            this.lastBroadcastedTimeExpiryTimer = this.timeRemainingToExtractInSeconds;
        } else if (this.lastBroadcastedTimeExpiryTimer > 0 && this.timeRemainingToExtractInSeconds === 0) {
            (0, $9b9fb0750f8f8ccb$export$8e4e970d9670815f)(this.timeRemainingToExtractInSeconds);
            this.lastBroadcastedTimeExpiryTimer = this.timeRemainingToExtractInSeconds;
        } else if (this.lastBroadcastedTimeExpiryTimer !== this.timeRemainingToExtractInSeconds) {
            (0, $9b9fb0750f8f8ccb$export$8e4e970d9670815f)(this.timeRemainingToExtractInSeconds);
            this.lastBroadcastedTimeExpiryTimer = this.timeRemainingToExtractInSeconds;
        }
    }
    Update(deltaTime, currentTimeInMilliseconds) {
        // Dont bother updating for entities that were already dead or extracted at the time of creation
        if (this.wasDeadOnInit === true || this.wasExtractedOnInit === true) return;
        if (this.extractionSuccessful === true && this.lastKnownExtractionState === false) {
            this._extract(true);
            return;
        }
        if (this.isAlive === false && this.lastKnownLivelihoodState === true) {
            this._die(true);
            return;
        }
        if (this.isMyEntity === false && this.wasDeadOnInit === false && this.wasExtractedOnInit === false) {
            if (this.lastOpacityAmount !== this.characterOpacityAmount) {
                this.RenderedEntity.alpha = this.characterOpacityAmount;
                this.lastOpacityAmount = this.characterOpacityAmount;
                if (this.characterOpacityAmount === 0) // console.log("@@@!");
                Game.Renderer.PlayOneOffPfx(this.x, this.y, "pfx/invis/effect_goInvisible", 1.5, 1, 1);
            }
        }
        super.Update(deltaTime);
        if (this.isMyEntity) this._emitUIEvents();
        this._updateCharacterVisuals(deltaTime, currentTimeInMilliseconds);
        this._updateDebugVisuals(deltaTime);
    }
}











const $f391157c0a664ddb$export$dc6c5fa57b35ec66 = {
    DEBUG: {
        DRAW_COLLIDER: false,
        // Show your true authoritatiive server projectiles (that are otherwise predicted on your client and therefore hidden)
        DRAW_SERVERSIDE_PROJECTILES_DURING_PREDICTION: false
    }
};







class $ed94c4fc8a783cda$export$666e7a22e3e67d16 {
    constructor(collisionSystemRef, owningEntityNid, startingXPosition, startingYPosition, spawnTrajectoryInRads, damage, damageType, projectileDetails, distanceMultiplier, playerDamageModifier, npcDamageModifier){
        this.nid = -1;
        this.ntype = (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ProjectileEntity;
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.velocity = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.prevPosition = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.HitboxCollider = new (0, $2104f92cbe769454$exports.Circle)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), 0);
        this.spawnTrajectoryInRads = 0;
        this.projectileLifeAccumulatorInSeconds = 0;
        this.ToBeDestroyed = false;
        // console.log({ collisionSystemRef, owningEntityNid, startingXPosition, startingYPosition, spawnTrajectoryInRads, damage, damageType, projectileDetails });
        // console.log("projectile details in sharedprojectile constructor", projectileDetails);
        this.collisionSystemRef = collisionSystemRef;
        this.owningEntityNid = owningEntityNid;
        this.spawnTrajectoryInRads = spawnTrajectoryInRads;
        this.npcDamageModifier = npcDamageModifier;
        this.playerDamageModifier = playerDamageModifier;
        this.x = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(startingXPosition);
        this.y = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(startingYPosition);
        this.prevPosition.x = this.position.x;
        this.prevPosition.y = this.position.y;
        this.velocity.x = Math.cos(this.spawnTrajectoryInRads);
        this.velocity.y = Math.sin(this.spawnTrajectoryInRads);
        this.damage = damage;
        this.damageType = damageType;
        this.maxProjectileLifetimeInSeconds = projectileDetails.lifetimeInSeconds * distanceMultiplier;
        this.HitboxCollider.r = projectileDetails.colliderRadius;
        this.speedPerSecond = projectileDetails.speedPerSecond;
        this.dataId = projectileDetails.id;
        this.hasImpactPfx = projectileDetails.hasImpactPfx;
        const cappedVelocityMagnitude = Math.sqrt(this.velocity.x * this.velocity.x + this.velocity.y * this.velocity.y);
        if (cappedVelocityMagnitude !== 0) {
            this.velocity.x /= cappedVelocityMagnitude;
            this.velocity.y /= cappedVelocityMagnitude;
        }
    }
    get x() {
        return this.position.x;
    }
    set x(newX) {
        this.position.x = newX;
        this.HitboxCollider.pos.x = this.x;
    }
    get y() {
        return this.position.y;
    }
    set y(newY) {
        this.position.y = newY;
        this.HitboxCollider.pos.y = this.y;
    }
    get prevX() {
        return this.prevPosition.x;
    }
    set prevX(newX) {
        this.prevPosition.x = newX;
    }
    get prevY() {
        return this.prevPosition.y;
    }
    set prevY(newY) {
        this.prevPosition.y = newY;
    }
    Move(deltaTime) {
        this.prevX = this.x;
        this.prevY = this.y;
        this.x = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(this.x + this.velocity.x * (this.speedPerSecond * deltaTime));
        this.y = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(this.y + this.velocity.y * (this.speedPerSecond * deltaTime));
        this._applyMapCollisions();
    }
    _applyMapCollisions() {
        const currentTileGridX = Math.floor(this.HitboxCollider.pos.x / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
        const currentTileGridY = Math.floor(this.HitboxCollider.pos.y / (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).TILE_SIZE);
        for (const offset of (0, $63b908b83aafc686$export$52ef19685b59c674).GridOffsets){
            const [xOffset, yOffset] = offset;
            const relevantTileGridX = currentTileGridX + xOffset;
            const relevantTileGridY = currentTileGridY + yOffset;
            // Don't include tiles outside of the world
            if (relevantTileGridX > (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS - 1 || relevantTileGridY > (0, $952fbb3f4cef768a$export$b9c5bbe98d67049c).WORLD_TILE_DIMENSIONS - 1 || relevantTileGridX < 0 || relevantTileGridY < 0) continue;
            const collisionPolygon = this.collisionSystemRef.GetCollisionPolygonAtGridXY(relevantTileGridX, relevantTileGridY);
            // @ts-ignore TODO: hack
            if (collisionPolygon && collisionPolygon.blocksProjectiles) {
                const collisionResponse = this.collisionSystemRef.PerformOneOffCirclePolygonCollisionCheck(this.HitboxCollider, collisionPolygon);
                if (collisionResponse) this.ToBeDestroyed = true;
            } else continue;
        }
    }
    Update(__deltaTime) {}
}




class $76f9cef755a397a1$export$722aee2580a3ce21 extends (0, $ed94c4fc8a783cda$export$666e7a22e3e67d16) {
    constructor(createProjectilePayload, isOwnedByMyPlayer, distanceMultiplier, playerDamageModifier, npcDamageModifier){
        const { nid: nid , x: x , y: y , spawnTrajectoryInRads: spawnTrajectoryInRads , damage: damage , damageType: damageType , dataId: dataId , owningEntityNid: owningEntityNid  } = createProjectilePayload;
        const projectileData = (0, $21a778c44478d8dc$export$290d3183f69b75ee)(dataId);
        super(Game.Collision, owningEntityNid, x, y, spawnTrajectoryInRads, damage, damageType, projectileData, distanceMultiplier, playerDamageModifier, npcDamageModifier);
        this.RenderedEntity = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.xVel = 0;
        this.yVel = 0;
        this.animationSpeed = 0.2;
        this.projectileData = projectileData;
        const { projectileSpriteId: projectileSpriteId , projectileSpriteScale: projectileSpriteScale , colliderRadius: colliderRadius , spriteXAnchor: spriteXAnchor  } = this.projectileData;
        this.spriteXAnchor = spriteXAnchor;
        this.projectileSpriteId = projectileSpriteId;
        this.projectileSpriteScale = projectileSpriteScale;
        this.colliderRadiusForDebugVisuals = colliderRadius;
        this.nid = nid;
        this.RenderedEntity.x = x;
        this.RenderedEntity.y = y;
        this.RenderedEntity.zIndex = y;
        this.isMyProjectile = isOwnedByMyPlayer;
        this.RenderedEntity.on("destroyed", ()=>{
            if (this.projectileData.hasImpactPfx && this.RenderedEntity.alpha !== 0) Game.Renderer.PlayOneOffPfx(this.x, this.y, this.projectileData.impactSpriteId, this.projectileData.impactSpriteScale, spawnTrajectoryInRads);
        });
        this._setupProjectileVisuals();
        this._setupDebugVisuals();
        if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION && this.isMyProjectile) {
            if ((0, $f391157c0a664ddb$export$dc6c5fa57b35ec66).DEBUG.DRAW_SERVERSIDE_PROJECTILES_DURING_PREDICTION) this.RenderedEntity.alpha = 0.5;
            else this.RenderedEntity.alpha = 0;
        } else this.RenderedEntity.alpha = 1;
    }
    _setupDebugVisuals() {
        if ((0, $f391157c0a664ddb$export$dc6c5fa57b35ec66).DEBUG.DRAW_COLLIDER) {
            this.debugProjectileCollider = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugProjectileCollider.lineStyle(1, 0x000000, 0.15);
            this.debugProjectileCollider.drawCircle(0, 0, this.colliderRadiusForDebugVisuals);
            this.debugProjectileCollider.endFill();
            this.RenderedEntity.addChild(this.debugProjectileCollider);
        }
    }
    _setupProjectileVisuals() {
        this.projectileSprite = (0, $bef80d21b8b0b6b2$export$dae599798687ad3c).fromFrames(Game.Loader.GetAnimation(this.projectileSpriteId));
        this.projectileSprite.scale.set(this.projectileSpriteScale);
        this.projectileSprite.anchor.set(this.spriteXAnchor, 0.5);
        if (this.projectileData.rotateProjectileSprite) this.projectileSprite.rotation = this.spawnTrajectoryInRads;
        this.projectileSprite.animationSpeed = this.animationSpeed;
        this.projectileSprite.play();
        this.RenderedEntity.addChild(this.projectileSprite);
    }
    _updateProjectileVisuals() {
        this.RenderedEntity.x = this.x;
        this.RenderedEntity.y = this.y;
    }
    _updateDebugVisuals() {}
    Update(deltaTime) {
        super.Update(deltaTime);
        this._updateProjectileVisuals();
        this._updateDebugVisuals();
    }
}


class $f2b5322cb98b1f84$export$f9e0075ad029516 extends (0, $76f9cef755a397a1$export$722aee2580a3ce21) {
    constructor(createProjectilePayload, distanceMultiplier){
        super(createProjectilePayload, true, distanceMultiplier, 1, 1);
        this.RenderedEntity.alpha = 1;
    }
    Update(deltaInSeconds) {
        super.Update(deltaInSeconds);
        this.projectileLifeAccumulatorInSeconds += deltaInSeconds;
        this.Move(deltaInSeconds);
        if (this.projectileLifeAccumulatorInSeconds > this.maxProjectileLifetimeInSeconds) this.ToBeDestroyed = true;
    }
}


class $deb9a0774f23f547$export$9ea9964d929a7e1 extends (0, $102fc1000c26cf91$export$87056d933ed937b1) {
    SwapToWeaponSlot(newSlot) {
        super.SwapToWeaponSlot(newSlot);
        const newWeaponClass = this.GetActiveWeaponConfig().weaponClass;
        Game.EmitEvent("Gameplay::NewWeaponClassEquipped", {
            newWeaponClass: newWeaponClass
        });
    }
    SetWeaponDetails(weaponOne, weaponTwo) {
        super.SetWeaponDetails(weaponOne, weaponTwo);
        const newWeaponClass = this.GetActiveWeaponConfig().weaponClass;
        Game.EmitEvent("Gameplay::NewWeaponClassEquipped", {
            newWeaponClass: newWeaponClass
        });
    }
    UseWeapon() {
        if (this.GetOwningEntity().IsDeveloper) return;
        super.UseWeapon();
        const { firingType: type , damage: damage , damageType: damageType , projectileConfig: projectileConfig , randomizeProjectileAimAngle: randomizeProjectileAimAngle  } = this.GetActiveWeaponConfig();
        const { id: id  } = projectileConfig;
        if (type === (0, $0acc22698d702be9$export$52dcef66f96a6ad8).Projectile) {
            const owningEntity = this.GetOwningEntity();
            const owningEntityNid = this.GetOwningEntityNid();
            let aim = owningEntity.aim;
            if (randomizeProjectileAimAngle) aim = (0, $276f03d77ac4b507$export$5c945887f38dcb4b)(aim, 0.2);
            const projectileCreationPayload = {
                nid: -1,
                ntype: (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ProjectileEntity,
                x: owningEntity.projectileOrigin.x,
                y: owningEntity.projectileOrigin.y,
                damage: damage,
                damageType: damageType,
                spawnTrajectoryInRads: aim,
                owningEntityNid: owningEntityNid,
                projectileType: 0,
                dataId: id
            };
            const distanceMuliplier = this.GetOwningEntity().projectileDistanceMultiplier;
            // console.log("distance multiplier in client weapon system:", distanceMuliplier);
            const predictedProjectile = new (0, $f2b5322cb98b1f84$export$f9e0075ad029516)(projectileCreationPayload, distanceMuliplier);
            this.predictedProjectiles.add(predictedProjectile);
            Game.Renderer.AddRenderedEntity(predictedProjectile);
            Game.Collision.AddEntity(predictedProjectile);
        } else (0, $0acc22698d702be9$export$52dcef66f96a6ad8).Hitscan;
    }
    UseGear(gearSlot) {
        super.UseGear(gearSlot);
        console.log("USING GEAR SLOT ON CLIENT: ", (0, $102fc1000c26cf91$export$7369a5563924ac4)[gearSlot]);
        let ability = (0, $faa1b3449016497b$export$259a6f5d817ae02e).None;
        let abilityConfig = {
            ability: (0, $faa1b3449016497b$export$259a6f5d817ae02e).None,
            abilityCharges: 0,
            abilityCooldownInSeconds: 0,
            abilityDurationInSeconds: 0,
            abilityParameter: 0
        };
        if (gearSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne) {
            ability = this.gearOneAbility;
            abilityConfig = this.gearOneConfig.activeAbility;
        }
        if (gearSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo) {
            ability = this.gearTwoAbility;
            abilityConfig = this.gearTwoConfig.activeAbility;
        }
        if (gearSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree) {
            ability = this.gearThreeAbility;
            abilityConfig = this.gearThreeConfig.activeAbility;
        }
        this._useActiveAbility(ability, abilityConfig);
    }
    _useActiveAbility(activeAbility, abilityDefinition) {
        super._useActiveAbility(activeAbility, abilityDefinition);
        console.log("using ability on client:", (0, $faa1b3449016497b$export$259a6f5d817ae02e)[activeAbility]);
        switch(activeAbility){
            case (0, $faa1b3449016497b$export$259a6f5d817ae02e).Dash:
                this.GetOwningEntity().UseActiveAbility_Dash(abilityDefinition.abilityParameter, abilityDefinition.abilityDurationInSeconds);
                break;
            // case ActiveAbility.Relocation:
            // case ActiveAbility.ZoomOut:
            // case ActiveAbility.DamageReduction:
            // case ActiveAbility.DamageBoost:
            // case ActiveAbility.ProjectilePierce:
            // case ActiveAbility.Random:
            case (0, $faa1b3449016497b$export$259a6f5d817ae02e).None:
            case (0, $faa1b3449016497b$export$259a6f5d817ae02e).Invisibility:
            case (0, $faa1b3449016497b$export$259a6f5d817ae02e).TimerExtender:
            case (0, $faa1b3449016497b$export$259a6f5d817ae02e).Suicide:
            case (0, $faa1b3449016497b$export$259a6f5d817ae02e).Heal:
            case (0, $faa1b3449016497b$export$259a6f5d817ae02e).Extract:
                console.log("active ability use ignored on client (likely server only)");
                break;
            default:
                console.log("unrecognized active ability used on client");
                break;
        }
    }
    Update(deltaTime) {
        super.Update(deltaTime);
        this.predictedProjectiles.forEach((predictedProjectile)=>{
            predictedProjectile.Update(deltaTime);
            if (predictedProjectile.ToBeDestroyed) {
                Game.Renderer.RemoveRenderedEntity(predictedProjectile);
                predictedProjectile.RenderedEntity.destroy();
                this.predictedProjectiles.delete(predictedProjectile);
            }
        });
    }
    constructor(...args){
        super(...args);
        this.predictedProjectiles = new Set();
    }
}




class $684d742272b6c23f$export$69c0d78807786d95 extends (0, $9963602032b82d57$export$75d5526a7020db) {
    static #_ = (()=>{
        this.WhitelistedReplicatedProperties = [
            "currentHealthPercentage",
            "isAlive",
            "activeWeaponSlot",
            "characterOpacityAmount",
            "gearOneCharges",
            "gearTwoCharges",
            "gearThreeCharges",
            "extractionSuccessful"
        ];
    })();
    constructor(originalCreationPayload){
        super(originalCreationPayload);
        this.lastBroadcastedWeaponOneCooldownPercentage = 100;
        this.lastBroadcastedWeaponTwoCooldownPercentage = 100;
        this.lastBroadcastedGearOneCooldownPercentage = 100;
        this.lastBroadcastedGearTwoCooldownPercentage = 100;
        this.lastBroadcastedGearThreeCooldownPercentage = 100;
        this.lastBroadcastedGearOneCharges = -1;
        this.lastBroadcastedGearTwoCharges = -1;
        this.lastBroadcastedGearThreeCharges = -1;
        this.lastOpacityAmount = this.characterOpacityAmount;
        const { weaponOneId: weaponOneId , weaponTwoId: weaponTwoId , gearOneId: gearOneId , gearTwoId: gearTwoId , gearThreeId: gearThreeId  } = originalCreationPayload;
        this.GearAndWeaponSystem = new (0, $deb9a0774f23f547$export$9ea9964d929a7e1)();
        this.GearAndWeaponSystem.SetOwningEntity(this);
        this.GearAndWeaponSystem.SetWeaponDetails(weaponOneId, weaponTwoId);
        this.GearAndWeaponSystem.SetGearDetails(gearOneId, gearTwoId, gearThreeId);
        // this.usernameText.alpha = 0;
        Game.Collision.AddEntity(this);
    }
    Update(deltaTime, currentTimeInMilliseconds) {
        super.Update(deltaTime, currentTimeInMilliseconds);
        if (this.isAlive === false || this.extractionSuccessful === true) return;
        if (this.lastOpacityAmount !== this.characterOpacityAmount) {
            // console.log("character opacity amount in predicted", this.characterOpacityAmount);
            this.RenderedEntity.alpha = this.characterOpacityAmount;
            this.lastOpacityAmount = this.characterOpacityAmount;
        }
        if (this.weaponOneCooldownProgressPercentage !== this.lastBroadcastedWeaponOneCooldownPercentage) {
            this.lastBroadcastedWeaponOneCooldownPercentage = this.weaponOneCooldownProgressPercentage;
            (0, $9b9fb0750f8f8ccb$export$36bd996d858bb699)((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne, this.weaponOneCooldownProgressPercentage);
        }
        if (this.weaponTwoCooldownProgressPercentage !== this.lastBroadcastedWeaponTwoCooldownPercentage) {
            this.lastBroadcastedWeaponTwoCooldownPercentage = this.weaponTwoCooldownProgressPercentage;
            (0, $9b9fb0750f8f8ccb$export$36bd996d858bb699)((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo, this.weaponTwoCooldownProgressPercentage);
        }
        if (this.gearOneCooldownProgressPercentage !== this.lastBroadcastedGearOneCooldownPercentage) {
            this.lastBroadcastedGearOneCooldownPercentage = this.gearOneCooldownProgressPercentage;
            (0, $9b9fb0750f8f8ccb$export$36bd996d858bb699)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne, this.gearOneCooldownProgressPercentage);
        }
        if (this.gearTwoCooldownProgressPercentage !== this.lastBroadcastedGearTwoCooldownPercentage) {
            this.lastBroadcastedGearTwoCooldownPercentage = this.gearTwoCooldownProgressPercentage;
            (0, $9b9fb0750f8f8ccb$export$36bd996d858bb699)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo, this.gearTwoCooldownProgressPercentage);
        }
        if (this.gearThreeCooldownProgressPercentage !== this.lastBroadcastedGearThreeCooldownPercentage) {
            this.lastBroadcastedGearThreeCooldownPercentage = this.gearThreeCooldownProgressPercentage;
            (0, $9b9fb0750f8f8ccb$export$36bd996d858bb699)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree, this.gearThreeCooldownProgressPercentage);
        }
        if (this.lastBroadcastedGearOneCharges !== this.gearOneCharges) {
            this.lastBroadcastedGearOneCharges = this.gearOneCharges;
            // console.log(this.gearOneCharges);
            (0, $9b9fb0750f8f8ccb$export$e4fed43e8bd3e41f)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne, this.gearOneCharges);
        }
        if (this.lastBroadcastedGearTwoCharges !== this.gearTwoCharges) {
            this.lastBroadcastedGearTwoCharges = this.gearTwoCharges;
            (0, $9b9fb0750f8f8ccb$export$e4fed43e8bd3e41f)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo, this.gearTwoCharges);
        }
        if (this.lastBroadcastedGearThreeCharges !== this.gearThreeCharges) {
            this.lastBroadcastedGearThreeCharges = this.gearThreeCharges;
            (0, $9b9fb0750f8f8ccb$export$e4fed43e8bd3e41f)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree, this.gearThreeCharges);
        }
        this.GearAndWeaponSystem.Update(deltaTime);
    }
}


class $fe9e2d3ae8505e4b$export$8ccb38c26a8ab5aa extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.initialized = false;
        Game.ListenForEvent("Prediction::ReadyToCreatePredictedEntity", this._setupLocallyPredictedPlayer.bind(this));
    }
    _setupLocallyPredictedPlayer(event) {
        const { originalCreationPayload: originalCreationPayload  } = event;
        this.myLocallyPredictedEntity = new (0, $684d742272b6c23f$export$69c0d78807786d95)(originalCreationPayload);
        this.Initialize();
    }
    Initialize() {
        Game.Renderer.AddRenderedEntity(this.myLocallyPredictedEntity);
        Game.Renderer.StartFollowing(this.myLocallyPredictedEntity.nid, this.myLocallyPredictedEntity);
        this.initialized = true;
        Game.EmitEvent("Prediction::PredictionReady");
        this.LogInfo("Ready!");
    }
    getSystemName() {
        return "CSP";
    }
    GetPredictedEntity() {
        return this.myLocallyPredictedEntity;
    }
    GetPredictedEntityX() {
        if (this.myLocallyPredictedEntity === undefined) return 0;
        return this.myLocallyPredictedEntity.x;
    }
    GetPredictedEntityY() {
        if (this.myLocallyPredictedEntity === undefined) return 0;
        return this.myLocallyPredictedEntity.y;
    }
    LocallyPredictedEntityIsAlive() {
        return Boolean(this.myLocallyPredictedEntity.isAlive);
    }
    PredictPlayerInputCommand(command) {
        if (this.initialized === false) return;
        if (this.myLocallyPredictedEntity === undefined) return;
        this.myLocallyPredictedEntity.ProcessInputs(command);
    }
    Update(deltaTime, currentTimeInMilliseconds) {
        if (this.initialized === false) return;
        this.myLocallyPredictedEntity.Update(deltaTime, currentTimeInMilliseconds);
    }
    Cleanup() {}
}




var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $7e96a608cb33bf79$var$i = $11492dca620dcaa5$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$7e96a608cb33bf79$export$882461b6382ed46c = function(c, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.createRoot(c, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};
$7e96a608cb33bf79$export$757ceba2d55c277e = function(c, h, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.hydrateRoot(c, h, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("7B2bR"));


parcelRequire("acw62");

// I hate this but it's apparently necessary, rip


parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


function $973e4da43f2a375d$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $973e4da43f2a375d$var$getLengthFromAxis(axis) {
    return axis === "y" ? "height" : "width";
}
function $973e4da43f2a375d$var$getSide(placement) {
    return placement.split("-")[0];
}
function $973e4da43f2a375d$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].includes($973e4da43f2a375d$var$getSide(placement)) ? "x" : "y";
}
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
    const length = $973e4da43f2a375d$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $973e4da43f2a375d$var$getSide(placement);
    const isVertical = mainAxis === "x";
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($973e4da43f2a375d$var$getAlignment(placement)){
        case "start":
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name , fn: fn  } = validMiddleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $973e4da43f2a375d$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $973e4da43f2a375d$var$getSideObjectFromPadding(padding) {
    return typeof padding !== "number" ? $973e4da43f2a375d$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $973e4da43f2a375d$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = state;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = options;
    const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $973e4da43f2a375d$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $973e4da43f2a375d$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
const $973e4da43f2a375d$var$min = Math.min;
const $973e4da43f2a375d$var$max = Math.max;
function $973e4da43f2a375d$var$within(min$1, value, max$1) {
    return $973e4da43f2a375d$var$max(min$1, $973e4da43f2a375d$var$min(value, max$1));
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            // Since `element` is required, we don't Partial<> the type.
            const { element: element , padding: padding = 0  } = options || {};
            const { x: x , y: y , placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            if (element == null) return {};
            const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const length = $973e4da43f2a375d$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $973e4da43f2a375d$var$within(min, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = $973e4da43f2a375d$var$getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $973e4da43f2a375d$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $973e4da43f2a375d$var$allPlacements = /*#__PURE__*/ $973e4da43f2a375d$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
const $973e4da43f2a375d$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $973e4da43f2a375d$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$973e4da43f2a375d$var$oppositeSideMap[side]);
}
function $973e4da43f2a375d$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
    const length = $973e4da43f2a375d$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $973e4da43f2a375d$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $973e4da43f2a375d$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $973e4da43f2a375d$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$973e4da43f2a375d$var$oppositeAlignmentMap[alignment]);
}
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $973e4da43f2a375d$var$getAlignment(placement) === alignment || (autoAlignment ? $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = state;
            const { crossAxis: crossAxis = false , alignment: alignment , allowedPlacements: allowedPlacements = $973e4da43f2a375d$var$allPlacements , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = options;
            const placements = alignment !== undefined || allowedPlacements === $973e4da43f2a375d$var$allPlacements ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main , cross: cross  } = $973e4da43f2a375d$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$973e4da43f2a375d$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = $973e4da43f2a375d$var$getAlignment(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                $973e4da43f2a375d$var$getAlignment(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getExpandedPlacements(placement) {
    const oppositePlacement = $973e4da43f2a375d$var$getOppositePlacement(placement);
    return [
        $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $973e4da43f2a375d$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $973e4da43f2a375d$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $973e4da43f2a375d$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    let list = $973e4da43f2a375d$var$getSideList($973e4da43f2a375d$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($973e4da43f2a375d$var$getOppositeAlignmentPlacement));
    }
    return list;
}
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , fallbackAxisSideDirection: fallbackAxisSideDirection = "none" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = options;
            const side = $973e4da43f2a375d$var$getSide(placement);
            const isBasePlacement = $973e4da43f2a375d$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $973e4da43f2a375d$var$getOppositePlacement(initialPlacement)
            ] : $973e4da43f2a375d$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$973e4da43f2a375d$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main , cross: cross  } = $973e4da43f2a375d$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return $973e4da43f2a375d$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = options;
            const { rects: rects  } = state;
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = $973e4da43f2a375d$var$min(...rects.map((rect)=>rect.left));
    const minY = $973e4da43f2a375d$var$min(...rects.map((rect)=>rect.top));
    const maxX = $973e4da43f2a375d$var$max(...rects.map((rect)=>rect.right));
    const maxY = $973e4da43f2a375d$var$max(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>$973e4da43f2a375d$export$ee05aea0aeecbad4($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = options;
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = $973e4da43f2a375d$export$ee05aea0aeecbad4($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ($973e4da43f2a375d$var$getMainAxisFromPlacement(placement) === "x") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $973e4da43f2a375d$var$getSide(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $973e4da43f2a375d$var$getSide(placement) === "left";
                    const maxRight = $973e4da43f2a375d$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $973e4da43f2a375d$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
async function $973e4da43f2a375d$var$convertValueToCoords(state, value) {
    const { placement: placement , platform: platform , elements: elements  } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $973e4da43f2a375d$var$getSide(placement);
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    const isVertical = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement) === "x";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === "function" ? value(state) : value;
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: "offset",
        options: value,
        async fn (state) {
            const { x: x , y: y  } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $973e4da43f2a375d$var$getCrossAxis(axis) {
    return axis === "x" ? "y" : "x";
}
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement($973e4da43f2a375d$var$getSide(placement));
            const crossAxis = $973e4da43f2a375d$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $973e4da43f2a375d$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $973e4da43f2a375d$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = state;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const crossAxis = $973e4da43f2a375d$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === "function" ? offset(state) : offset;
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($973e4da43f2a375d$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            const { apply: apply = ()=>{} , ...detectOverflowOptions } = options;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = $973e4da43f2a375d$var$getSide(placement);
            const alignment = $973e4da43f2a375d$var$getAlignment(placement);
            const axis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const isXAxis = axis === "x";
            const { width: width , height: height  } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isXAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? $973e4da43f2a375d$var$min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? $973e4da43f2a375d$var$min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = $973e4da43f2a375d$var$max(overflow.left, 0);
                const xMax = $973e4da43f2a375d$var$max(overflow.right, 0);
                const yMin = $973e4da43f2a375d$var$max(overflow.top, 0);
                const yMax = $973e4da43f2a375d$var$max(overflow.bottom, 0);
                if (isXAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $973e4da43f2a375d$var$max(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $973e4da43f2a375d$var$max(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};


function $461947879dcdbcd4$var$getWindow(node) {
    var _node$ownerDocument;
    return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $461947879dcdbcd4$var$getComputedStyle$1(element) {
    return $461947879dcdbcd4$var$getWindow(element).getComputedStyle(element);
}
function $461947879dcdbcd4$var$isNode(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).Node;
}
function $461947879dcdbcd4$var$getNodeName(node) {
    return $461947879dcdbcd4$var$isNode(node) ? (node.nodeName || "").toLowerCase() : "";
}
let $461947879dcdbcd4$var$uaString;
function $461947879dcdbcd4$var$getUAString() {
    if ($461947879dcdbcd4$var$uaString) return $461947879dcdbcd4$var$uaString;
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) {
        $461947879dcdbcd4$var$uaString = uaData.brands.map((item)=>item.brand + "/" + item.version).join(" ");
        return $461947879dcdbcd4$var$uaString;
    }
    return navigator.userAgent;
}
function $461947879dcdbcd4$var$isHTMLElement(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).HTMLElement;
}
function $461947879dcdbcd4$var$isElement(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).Element;
}
function $461947879dcdbcd4$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $461947879dcdbcd4$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $461947879dcdbcd4$var$isOverflowElement(element) {
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY , display: display  } = $461947879dcdbcd4$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $461947879dcdbcd4$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($461947879dcdbcd4$var$getNodeName(element));
}
function $461947879dcdbcd4$var$isContainingBlock(element) {
    // TODO: Try to use feature detection here instead.
    const isFirefox = /firefox/i.test($461947879dcdbcd4$var$getUAString());
    const css = $461947879dcdbcd4$var$getComputedStyle$1(element);
    const backdropFilter = css.backdropFilter || css.WebkitBackdropFilter;
    // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (backdropFilter ? backdropFilter !== "none" : false) || isFirefox && css.willChange === "filter" || isFirefox && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective"
    ].some((value)=>css.willChange.includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>{
        // Add type check for old browsers.
        const contain = css.contain;
        return contain != null ? contain.includes(value) : false;
    });
}
/**
 * Determines whether or not `.getBoundingClientRect()` is affected by visual
 * viewport offsets. In Safari, the `x`/`y` offsets are values relative to the
 * visual viewport, while in other engines, they are values relative to the
 * layout viewport.
 */ function $461947879dcdbcd4$var$isClientRectVisualViewportBased() {
    // TODO: Try to use feature detection here instead. Feature detection for
    // this can fail in various ways, making the userAgent check the most
    // reliable:
    // • Always-visible scrollbar or not
    // • Width of <html>
    // Is Safari.
    return /^((?!chrome|android).)*safari/i.test($461947879dcdbcd4$var$getUAString());
}
function $461947879dcdbcd4$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($461947879dcdbcd4$var$getNodeName(node));
}
const $461947879dcdbcd4$var$min = Math.min;
const $461947879dcdbcd4$var$max = Math.max;
const $461947879dcdbcd4$var$round = Math.round;
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = $461947879dcdbcd4$var$getComputedStyle$1(element);
    let width = parseFloat(css.width);
    let height = parseFloat(css.height);
    const hasOffset = $461947879dcdbcd4$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $461947879dcdbcd4$var$round(width) !== offsetWidth || $461947879dcdbcd4$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        fallback: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !$461947879dcdbcd4$var$isElement(element) ? element.contextElement : element;
}
const $461947879dcdbcd4$var$FALLBACK_SCALE = {
    x: 1,
    y: 1
};
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!$461947879dcdbcd4$var$isHTMLElement(domElement)) return $461947879dcdbcd4$var$FALLBACK_SCALE;
    const rect = domElement.getBoundingClientRect();
    const { width: width , height: height , fallback: fallback  } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = (fallback ? $461947879dcdbcd4$var$round(rect.width) : rect.width) / width;
    let y = (fallback ? $461947879dcdbcd4$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    var _win$visualViewport, _win$visualViewport2;
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = $461947879dcdbcd4$var$FALLBACK_SCALE;
    if (includeScale) {
        if (offsetParent) {
            if ($461947879dcdbcd4$var$isElement(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const win = domElement ? $461947879dcdbcd4$var$getWindow(domElement) : window;
    const addVisualOffsets = $461947879dcdbcd4$var$isClientRectVisualViewportBased() && isFixedStrategy;
    let x = (clientRect.left + (addVisualOffsets ? ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0 : 0)) / scale.x;
    let y = (clientRect.top + (addVisualOffsets ? ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0 : 0)) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $461947879dcdbcd4$var$getWindow(domElement);
        const offsetWin = offsetParent && $461947879dcdbcd4$var$isElement(offsetParent) ? $461947879dcdbcd4$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = getComputedStyle(currentIFrame);
            iframeRect.x += (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            iframeRect.y += (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += iframeRect.x;
            y += iframeRect.y;
            currentIFrame = $461947879dcdbcd4$var$getWindow(currentIFrame).frameElement;
        }
    }
    return (0, $973e4da43f2a375d$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $461947879dcdbcd4$var$getDocumentElement(node) {
    return (($461947879dcdbcd4$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $461947879dcdbcd4$var$getNodeScroll(element) {
    if ($461947879dcdbcd4$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isOffsetParentAnElement = $461947879dcdbcd4$var$isHTMLElement(offsetParent);
    const documentElement = $461947879dcdbcd4$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = {
        x: 1,
        y: 1
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($461947879dcdbcd4$var$getNodeName(offsetParent) !== "body" || $461947879dcdbcd4$var$isOverflowElement(documentElement)) scroll = $461947879dcdbcd4$var$getNodeScroll(offsetParent);
        if ($461947879dcdbcd4$var$isHTMLElement(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect($461947879dcdbcd4$var$getDocumentElement(element)).left + $461947879dcdbcd4$var$getNodeScroll(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = $461947879dcdbcd4$var$getDocumentElement(element);
    const scroll = $461947879dcdbcd4$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $461947879dcdbcd4$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $461947879dcdbcd4$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($461947879dcdbcd4$var$getComputedStyle$1(body).direction === "rtl") x += $461947879dcdbcd4$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getParentNode(node) {
    if ($461947879dcdbcd4$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $461947879dcdbcd4$var$isShadowRoot(node) && node.host || // Fallback.
    $461947879dcdbcd4$var$getDocumentElement(node);
    return $461947879dcdbcd4$var$isShadowRoot(result) ? result.host : result;
}
function $461947879dcdbcd4$var$getNearestOverflowAncestor(node) {
    const parentNode = $461947879dcdbcd4$var$getParentNode(node);
    if ($461947879dcdbcd4$var$isLastTraversableNode(parentNode)) // `getParentNode` will never return a `Document` due to the fallback
    // check, so it's either the <html> or <body> element.
    return parentNode.ownerDocument.body;
    if ($461947879dcdbcd4$var$isHTMLElement(parentNode) && $461947879dcdbcd4$var$isOverflowElement(parentNode)) return parentNode;
    return $461947879dcdbcd4$var$getNearestOverflowAncestor(parentNode);
}
function $461947879dcdbcd4$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $461947879dcdbcd4$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $461947879dcdbcd4$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $461947879dcdbcd4$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $461947879dcdbcd4$export$3b57c1601291186b(scrollableAncestor));
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = $461947879dcdbcd4$var$getWindow(element);
    const html = $461947879dcdbcd4$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $461947879dcdbcd4$var$isClientRectVisualViewportBased();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $461947879dcdbcd4$var$isHTMLElement(element) ? $461947879dcdbcd4$var$getScale(element) : {
        x: 1,
        y: 1
    };
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect($461947879dcdbcd4$var$getDocumentElement(element));
    else if ($461947879dcdbcd4$var$isElement(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const mutableRect = {
            ...clippingAncestor
        };
        if ($461947879dcdbcd4$var$isClientRectVisualViewportBased()) {
            var _win$visualViewport, _win$visualViewport2;
            const win = $461947879dcdbcd4$var$getWindow(element);
            mutableRect.x -= ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0;
            mutableRect.y -= ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0;
        }
        rect = mutableRect;
    }
    return (0, $973e4da43f2a375d$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $461947879dcdbcd4$var$getParentNode(element);
    if (parentNode === stopNode || !$461947879dcdbcd4$var$isElement(parentNode) || $461947879dcdbcd4$var$isLastTraversableNode(parentNode)) return false;
    return $461947879dcdbcd4$var$getComputedStyle$1(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $461947879dcdbcd4$export$3b57c1601291186b(element).filter((el)=>$461947879dcdbcd4$var$isElement(el) && $461947879dcdbcd4$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $461947879dcdbcd4$var$getComputedStyle$1(element).position === "fixed";
    let currentNode = elementIsFixed ? $461947879dcdbcd4$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($461947879dcdbcd4$var$isElement(currentNode) && !$461947879dcdbcd4$var$isLastTraversableNode(currentNode)){
        const computedStyle = $461947879dcdbcd4$var$getComputedStyle$1(currentNode);
        const currentNodeIsContaining = $461947879dcdbcd4$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $461947879dcdbcd4$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $461947879dcdbcd4$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $461947879dcdbcd4$var$max(rect.top, accRect.top);
        accRect.right = $461947879dcdbcd4$var$min(rect.right, accRect.right);
        accRect.bottom = $461947879dcdbcd4$var$min(rect.bottom, accRect.bottom);
        accRect.left = $461947879dcdbcd4$var$max(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    return $461947879dcdbcd4$var$getCssDimensions(element);
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!$461947879dcdbcd4$var$isHTMLElement(element) || $461947879dcdbcd4$var$getComputedStyle$1(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $461947879dcdbcd4$var$getContainingBlock(element) {
    let currentNode = $461947879dcdbcd4$var$getParentNode(element);
    while($461947879dcdbcd4$var$isHTMLElement(currentNode) && !$461947879dcdbcd4$var$isLastTraversableNode(currentNode)){
        if ($461947879dcdbcd4$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $461947879dcdbcd4$var$getParentNode(currentNode);
    }
    return null;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const window1 = $461947879dcdbcd4$var$getWindow(element);
    if (!$461947879dcdbcd4$var$isHTMLElement(element)) return window1;
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $461947879dcdbcd4$var$isTableElement(offsetParent) && $461947879dcdbcd4$var$getComputedStyle$1(offsetParent).position === "static")offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($461947879dcdbcd4$var$getNodeName(offsetParent) === "html" || $461947879dcdbcd4$var$getNodeName(offsetParent) === "body" && $461947879dcdbcd4$var$getComputedStyle$1(offsetParent).position === "static" && !$461947879dcdbcd4$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $461947879dcdbcd4$var$getContainingBlock(element) || window1;
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $461947879dcdbcd4$var$isHTMLElement(offsetParent);
    const documentElement = $461947879dcdbcd4$var$getDocumentElement(offsetParent);
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed", offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($461947879dcdbcd4$var$getNodeName(offsetParent) !== "body" || $461947879dcdbcd4$var$isOverflowElement(documentElement)) scroll = $461947879dcdbcd4$var$getNodeScroll(offsetParent);
        if ($461947879dcdbcd4$var$isHTMLElement(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $461947879dcdbcd4$var$isElement,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getDocumentElement: $461947879dcdbcd4$var$getDocumentElement,
    getScale: $461947879dcdbcd4$var$getScale,
    async getElementRects (_ref) {
        let { reference: reference , floating: floating , strategy: strategy  } = _ref;
        const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        return {
            reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
            floating: {
                x: 0,
                y: 0,
                ...await getDimensionsFn(floating)
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$461947879dcdbcd4$var$getComputedStyle$1(element).direction === "rtl"
};
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true , ancestorResize: ancestorResize = true , elementResize: elementResize = true , animationFrame: animationFrame = false  } = options;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$461947879dcdbcd4$var$isElement(reference) ? $461947879dcdbcd4$export$3b57c1601291186b(reference) : reference.contextElement ? $461947879dcdbcd4$export$3b57c1601291186b(reference.contextElement) : [],
        ...$461947879dcdbcd4$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        // ignores Window, checks for [object VisualViewport]
        const isVisualViewport = !$461947879dcdbcd4$var$isElement(ancestor) && ancestor.toString().includes("V");
        if (ancestorScroll && (animationFrame ? isVisualViewport : true)) ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    let observer = null;
    if (elementResize) {
        observer = new ResizeObserver(()=>{
            update();
        });
        $461947879dcdbcd4$var$isElement(reference) && !animationFrame && observer.observe(reference);
        if (!$461947879dcdbcd4$var$isElement(reference) && reference.contextElement && !animationFrame) observer.observe(reference.contextElement);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};


const $b6649b19c980ca22$var$f = (e, t, r)=>{
    let o = null;
    return function(...l) {
        const n = ()=>{
            o = null, r || e.apply(this, l);
        };
        r && !o && (e.apply(this, l), o = setTimeout(n, t)), r || (o && clearTimeout(o), o = setTimeout(n, t));
    };
}, $b6649b19c980ca22$var$h = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $b6649b19c980ca22$var$y = (0, $acw62.createContext)({
    getTooltipData: ()=>$b6649b19c980ca22$var$h
}), $b6649b19c980ca22$export$f78649fb9ca566b8 = ({ children: t  })=>{
    const [n, a] = (0, $acw62.useState)({
        DEFAULT_TOOLTIP_ID: new Set
    }), [c, i] = (0, $acw62.useState)({
        DEFAULT_TOOLTIP_ID: {
            current: null
        }
    }), s = (e, ...t)=>{
        a((r)=>{
            var o;
            const l = null !== (o = r[e]) && void 0 !== o ? o : new Set;
            return t.forEach((e)=>l.add(e)), {
                ...r,
                [e]: new Set(l)
            };
        });
    }, u = (e, ...t)=>{
        a((r)=>{
            const o = r[e];
            return o ? (t.forEach((e)=>o.delete(e)), {
                ...r
            }) : r;
        });
    }, d = (0, $acw62.useCallback)((e = "DEFAULT_TOOLTIP_ID")=>{
        var t, r;
        return {
            anchorRefs: null !== (t = n[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (r = c[e]) && void 0 !== r ? r : {
                current: null
            },
            attach: (...t)=>s(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    i((r)=>{
                        var o;
                        return (null === (o = r[e]) || void 0 === o ? void 0 : o.current) === t.current ? r : {
                            ...r,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        n,
        c,
        s,
        u
    ]), p = (0, $acw62.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b6649b19c980ca22$var$y.Provider, {
        value: p
    }, t);
};
function $b6649b19c980ca22$var$A(e = "DEFAULT_TOOLTIP_ID") {
    return (0, $acw62.useContext)($b6649b19c980ca22$var$y).getTooltipData(e);
}
const $b6649b19c980ca22$export$57a09c4864b20b90 = ({ tooltipId: t , children: r , className: o , place: l , content: n , html: i , variant: u , offset: d , wrapper: p , events: v , positionStrategy: m , delayShow: f , delayHide: h  })=>{
    const { attach: y , detach: w  } = $b6649b19c980ca22$var$A(t), S = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>(y(S), ()=>{
            w(S);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: S,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("react-tooltip-wrapper", o),
        "data-tooltip-place": l,
        "data-tooltip-content": n,
        "data-tooltip-html": i,
        "data-tooltip-variant": u,
        "data-tooltip-offset": d,
        "data-tooltip-wrapper": p,
        "data-tooltip-events": v,
        "data-tooltip-position-strategy": m,
        "data-tooltip-delay-show": f,
        "data-tooltip-delay-hide": h
    }, r);
}, $b6649b19c980ca22$var$_ = "undefined" != typeof window ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $b6649b19c980ca22$var$b = async ({ elementReference: e = null , tooltipReference: t = null , tooltipArrowReference: r = null , place: o = "top" , offset: l = 10 , strategy: n = "absolute" , middlewares: a = [
    (0, $973e4da43f2a375d$export$cc800923e997bb8)(Number(l)),
    (0, $973e4da43f2a375d$export$8a83211c878a3f1f)(),
    (0, $973e4da43f2a375d$export$fba63a578e423eb)({
        padding: 5
    })
]  })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: o
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: o
    };
    const c = a;
    return r ? (c.push((0, $973e4da43f2a375d$export$f2120bbfa5450bd2)({
        element: r,
        padding: 5
    })), (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(e, t, {
        placement: o,
        strategy: n,
        middleware: c
    }).then(({ x: e , y: t , placement: r , middlewareData: o  })=>{
        var l, n;
        const a = {
            left: `${e}px`,
            top: `${t}px`
        }, { x: c , y: i  } = null !== (l = o.arrow) && void 0 !== l ? l : {
            x: 0,
            y: 0
        };
        return {
            tooltipStyles: a,
            tooltipArrowStyles: {
                left: null != c ? `${c}px` : "",
                top: null != i ? `${i}px` : "",
                right: "",
                bottom: "",
                [null !== (n = ({
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right"
                })[r.split("-")[0]]) && void 0 !== n ? n : "bottom"]: "-4px"
            },
            place: r
        };
    })) : (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(e, t, {
        placement: "bottom",
        strategy: n,
        middleware: c
    }).then(({ x: e , y: t , placement: r  })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: r
        }));
};
var $b6649b19c980ca22$var$g = {
    tooltip: "styles-module_tooltip__mnnfp",
    fixed: "styles-module_fixed__7ciUi",
    arrow: "styles-module_arrow__K0L3T",
    noArrow: "styles-module_noArrow__T8y2L",
    clickable: "styles-module_clickable__Bv9o7",
    show: "styles-module_show__2NboJ",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $b6649b19c980ca22$var$E = ({ id: t , className: o , classNameArrow: l , variant: n = "dark" , anchorId: i , anchorSelect: u , place: d = "top" , offset: p = 10 , events: v = [
    "hover"
] , openOnClick: m = !1 , positionStrategy: h = "absolute" , middlewares: y , wrapper: w , delayShow: S = 0 , delayHide: E = 0 , float: T = !1 , noArrow: O = !1 , clickable: k = !1 , closeOnEsc: L = !1 , style: N , position: x , afterShow: R , afterHide: I , content: $ , contentWrapperRef: D , isOpen: H , setIsOpen: j , activeAnchor: q , setActiveAnchor: C  })=>{
    const W = (0, $acw62.useRef)(null), F = (0, $acw62.useRef)(null), P = (0, $acw62.useRef)(null), U = (0, $acw62.useRef)(null), [M, B] = (0, $acw62.useState)(d), [K, X] = (0, $acw62.useState)({}), [z, J] = (0, $acw62.useState)({}), [Y, Z] = (0, $acw62.useState)(!1), [G, Q] = (0, $acw62.useState)(!1), V = (0, $acw62.useRef)(!1), ee = (0, $acw62.useRef)(null), { anchorRefs: te , setActiveAnchor: re  } = $b6649b19c980ca22$var$A(t), oe = (0, $acw62.useRef)(!1), [le, ne] = (0, $acw62.useState)([]), ae = (0, $acw62.useRef)(!1), ce = m || v.includes("click");
    $b6649b19c980ca22$var$_(()=>(ae.current = !0, ()=>{
            ae.current = !1;
        }), []), (0, $acw62.useEffect)(()=>{
        if (!Y) {
            const e = setTimeout(()=>{
                Q(!1);
            }, 150);
            return ()=>{
                clearTimeout(e);
            };
        }
        return ()=>null;
    }, [
        Y
    ]);
    const ie = (e)=>{
        ae.current && (e && Q(!0), setTimeout(()=>{
            ae.current && (null == j || j(e), void 0 === H && Z(e));
        }, 10));
    };
    (0, $acw62.useEffect)(()=>{
        if (void 0 === H) return ()=>null;
        H && Q(!0);
        const e = setTimeout(()=>{
            Z(H);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        H
    ]), (0, $acw62.useEffect)(()=>{
        Y !== V.current && (V.current = Y, Y ? null == R || R() : null == I || I());
    }, [
        Y
    ]);
    const se = (e = E)=>{
        U.current && clearTimeout(U.current), U.current = setTimeout(()=>{
            oe.current || ie(!1);
        }, e);
    }, ue = (e)=>{
        var t;
        if (!e) return;
        const r = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == r ? void 0 : r.isConnected)) return C(null), void re({
            current: null
        });
        S ? (P.current && clearTimeout(P.current), P.current = setTimeout(()=>{
            ie(!0);
        }, S)) : ie(!0), C(r), re({
            current: r
        }), U.current && clearTimeout(U.current);
    }, de = ()=>{
        k ? se(E || 100) : E ? se() : ie(!1), P.current && clearTimeout(P.current);
    }, pe = ({ x: e , y: t  })=>{
        $b6649b19c980ca22$var$b({
            place: d,
            offset: p,
            elementReference: {
                getBoundingClientRect: ()=>({
                        x: e,
                        y: t,
                        width: 0,
                        height: 0,
                        top: t,
                        left: e,
                        right: e,
                        bottom: t
                    })
            },
            tooltipReference: W.current,
            tooltipArrowReference: F.current,
            strategy: h,
            middlewares: y
        }).then((e)=>{
            Object.keys(e.tooltipStyles).length && X(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && J(e.tooltipArrowStyles), B(e.place);
        });
    }, ve = (e)=>{
        if (!e) return;
        const t = e, r = {
            x: t.clientX,
            y: t.clientY
        };
        pe(r), ee.current = r;
    }, me = (e)=>{
        ue(e), E && se();
    }, fe = (e)=>{
        var t;
        [
            document.querySelector(`[id='${i}']`),
            ...le
        ].some((t)=>null == t ? void 0 : t.contains(e.target)) || (null === (t = W.current) || void 0 === t ? void 0 : t.contains(e.target)) || ie(!1);
    }, he = (e)=>{
        "Escape" === e.key && ie(!1);
    }, ye = $b6649b19c980ca22$var$f(ue, 50, !0), we = $b6649b19c980ca22$var$f(de, 50, !0);
    (0, $acw62.useEffect)(()=>{
        var e, t;
        const r = new Set(te);
        le.forEach((e)=>{
            r.add({
                current: e
            });
        });
        const o = document.querySelector(`[id='${i}']`);
        o && r.add({
            current: o
        }), L && window.addEventListener("keydown", he);
        const l = [];
        ce ? (window.addEventListener("click", fe), l.push({
            event: "click",
            listener: me
        })) : (l.push({
            event: "mouseenter",
            listener: ye
        }, {
            event: "mouseleave",
            listener: we
        }, {
            event: "focus",
            listener: ye
        }, {
            event: "blur",
            listener: we
        }), T && l.push({
            event: "mousemove",
            listener: ve
        }));
        const n = ()=>{
            oe.current = !0;
        }, a = ()=>{
            oe.current = !1, de();
        };
        return k && !ce && (null === (e = W.current) || void 0 === e || e.addEventListener("mouseenter", n), null === (t = W.current) || void 0 === t || t.addEventListener("mouseleave", a)), l.forEach(({ event: e , listener: t  })=>{
            r.forEach((r)=>{
                var o;
                null === (o = r.current) || void 0 === o || o.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            ce && window.removeEventListener("click", fe), L && window.removeEventListener("keydown", he), k && !ce && (null === (e = W.current) || void 0 === e || e.removeEventListener("mouseenter", n), null === (t = W.current) || void 0 === t || t.removeEventListener("mouseleave", a)), l.forEach(({ event: e , listener: t  })=>{
                r.forEach((r)=>{
                    var o;
                    null === (o = r.current) || void 0 === o || o.removeEventListener(e, t);
                });
            });
        };
    }, [
        G,
        te,
        le,
        L,
        v
    ]), (0, $acw62.useEffect)(()=>{
        let e = null != u ? u : "";
        !e && t && (e = `[data-tooltip-id='${t}']`);
        const r = new MutationObserver((r)=>{
            const o = [];
            r.forEach((r)=>{
                if ("attributes" === r.type && "data-tooltip-id" === r.attributeName) r.target.getAttribute("data-tooltip-id") === t && o.push(r.target);
                if ("childList" === r.type && (q && [
                    ...r.removedNodes
                ].some((e)=>{
                    var t;
                    return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, q)) && (Q(!1), ie(!1), C(null), !0);
                }), e)) try {
                    const t = [
                        ...r.addedNodes
                    ].filter((e)=>1 === e.nodeType);
                    o.push(...t.filter((t)=>t.matches(e))), o.push(...t.flatMap((t)=>[
                            ...t.querySelectorAll(e)
                        ]));
                } catch (e) {}
            }), o.length && ne((e)=>[
                    ...e,
                    ...o
                ]);
        });
        return r.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ]
        }), ()=>{
            r.disconnect();
        };
    }, [
        t,
        u,
        q
    ]);
    const Ae = ()=>{
        x ? pe(x) : T ? ee.current && pe(ee.current) : $b6649b19c980ca22$var$b({
            place: d,
            offset: p,
            elementReference: q,
            tooltipReference: W.current,
            tooltipArrowReference: F.current,
            strategy: h,
            middlewares: y
        }).then((e)=>{
            ae.current && (Object.keys(e.tooltipStyles).length && X(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && J(e.tooltipArrowStyles), B(e.place));
        });
    };
    (0, $acw62.useEffect)(()=>{
        Ae();
    }, [
        Y,
        q,
        $,
        N,
        d,
        p,
        h,
        x
    ]), (0, $acw62.useEffect)(()=>{
        if (!(null == D ? void 0 : D.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            Ae();
        });
        return e.observe(D.current), ()=>{
            e.disconnect();
        };
    }, [
        $,
        null == D ? void 0 : D.current
    ]), (0, $acw62.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${i}']`), r = [
            ...le,
            t
        ];
        q && r.includes(q) || C(null !== (e = le[0]) && void 0 !== e ? e : t);
    }, [
        i,
        le,
        q
    ]), (0, $acw62.useEffect)(()=>()=>{
            P.current && clearTimeout(P.current), U.current && clearTimeout(U.current);
        }, []), (0, $acw62.useEffect)(()=>{
        let e = u;
        if (!e && t && (e = `[data-tooltip-id='${t}']`), e) try {
            const t = Array.from(document.querySelectorAll(e));
            ne(t);
        } catch (e) {
            ne([]);
        }
    }, [
        t,
        u
    ]);
    const Se = $ && Y && Object.keys(K).length > 0;
    return G ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(w, {
        id: t,
        role: "tooltip",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("react-tooltip", $b6649b19c980ca22$var$g.tooltip, $b6649b19c980ca22$var$g[n], o, `react-tooltip__place-${M}`, {
            [$b6649b19c980ca22$var$g.show]: Se,
            [$b6649b19c980ca22$var$g.fixed]: "fixed" === h,
            [$b6649b19c980ca22$var$g.clickable]: k
        }),
        style: {
            ...N,
            ...K
        },
        ref: W
    }, $, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(w, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("react-tooltip-arrow", $b6649b19c980ca22$var$g.arrow, l, {
            [$b6649b19c980ca22$var$g.noArrow]: O
        }),
        style: z,
        ref: F
    })) : null;
}, $b6649b19c980ca22$var$T = ({ content: t  })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $b6649b19c980ca22$export$28c660c63b792dea = ({ id: t , anchorId: o , anchorSelect: l , content: n , html: i , render: s , className: u , classNameArrow: d , variant: p = "dark" , place: v = "top" , offset: m = 10 , wrapper: f = "div" , children: h = null , events: y = [
    "hover"
] , openOnClick: w = !1 , positionStrategy: S = "absolute" , middlewares: _ , delayShow: b = 0 , delayHide: g = 0 , float: O = !1 , noArrow: k = !1 , clickable: L = !1 , closeOnEsc: N = !1 , style: x , position: R , isOpen: I , setIsOpen: $ , afterShow: D , afterHide: H  })=>{
    const [j, q] = (0, $acw62.useState)(n), [C, W] = (0, $acw62.useState)(i), [F, P] = (0, $acw62.useState)(v), [U, M] = (0, $acw62.useState)(p), [B, K] = (0, $acw62.useState)(m), [X, z] = (0, $acw62.useState)(b), [J, Y] = (0, $acw62.useState)(g), [Z, G] = (0, $acw62.useState)(O), [Q, V] = (0, $acw62.useState)(f), [ee, te] = (0, $acw62.useState)(y), [re, oe] = (0, $acw62.useState)(S), [le, ne] = (0, $acw62.useState)(null), { anchorRefs: ae , activeAnchor: ce  } = $b6649b19c980ca22$var$A(t), ie = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, r)=>{
            var o;
            if (r.startsWith("data-tooltip-")) t[r.replace(/^data-tooltip-/, "")] = null !== (o = null == e ? void 0 : e.getAttribute(r)) && void 0 !== o ? o : null;
            return t;
        }, {}), se = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                P(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                q(null != e ? e : n);
            },
            html: (e)=>{
                W(null != e ? e : i);
            },
            variant: (e)=>{
                var t;
                M(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                K(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                V(null !== (t = e) && void 0 !== t ? t : f);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                te(null != t ? t : y);
            },
            "position-strategy": (e)=>{
                var t;
                oe(null !== (t = e) && void 0 !== t ? t : S);
            },
            "delay-show": (e)=>{
                z(null === e ? b : Number(e));
            },
            "delay-hide": (e)=>{
                Y(null === e ? g : Number(e));
            },
            float: (e)=>{
                G(null === e ? O : "true" === e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, r])=>{
            var o;
            null === (o = t[e]) || void 0 === o || o.call(t, r);
        });
    };
    (0, $acw62.useEffect)(()=>{
        q(n);
    }, [
        n
    ]), (0, $acw62.useEffect)(()=>{
        W(i);
    }, [
        i
    ]), (0, $acw62.useEffect)(()=>{
        P(v);
    }, [
        v
    ]), (0, $acw62.useEffect)(()=>{
        var e;
        const r = new Set(ae);
        let n = l;
        if (!n && t && (n = `[data-tooltip-id='${t}']`), n) try {
            document.querySelectorAll(n).forEach((e)=>{
                r.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${l}" is not a valid CSS selector`);
        }
        const a = document.querySelector(`[id='${o}']`);
        if (a && r.add({
            current: a
        }), !r.size) return ()=>null;
        const c = null !== (e = null != le ? le : a) && void 0 !== e ? e : ce.current, i = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const r = ie(c);
                se(r);
            });
        }), s = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (c) {
            const e = ie(c);
            se(e), i.observe(c, s);
        }
        return ()=>{
            i.disconnect();
        };
    }, [
        ae,
        ce,
        le,
        o,
        l
    ]);
    let ue = h;
    const de = (0, $acw62.useRef)(null);
    if (s) {
        const t = s({
            content: null != j ? j : null,
            activeAnchor: le
        });
        ue = t ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: de,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else j && (ue = j);
    C && (ue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b6649b19c980ca22$var$T, {
        content: C
    }));
    const pe = {
        id: t,
        anchorId: o,
        anchorSelect: l,
        className: u,
        classNameArrow: d,
        content: ue,
        contentWrapperRef: de,
        place: F,
        variant: U,
        offset: B,
        wrapper: Q,
        events: ee,
        openOnClick: w,
        positionStrategy: re,
        middlewares: _,
        delayShow: X,
        delayHide: J,
        float: Z,
        noArrow: k,
        clickable: L,
        closeOnEsc: N,
        style: x,
        position: R,
        isOpen: I,
        setIsOpen: $,
        afterShow: D,
        afterHide: H,
        activeAnchor: le,
        setActiveAnchor: (e)=>ne(e)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b6649b19c980ca22$var$E, {
        ...pe
    });
};



var $660d7b02729e1e51$exports = {};

$660d7b02729e1e51$exports = new URL((parcelRequire("27Lyk")).resolve("8v8H6"), import.meta.url).toString();



parcelRequire("acw62");



const $9b66d9d7a3aaa12f$export$b08b517936747730 = ()=>{
    const tooltipContainer = document.getElementById("tooltip-container");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "loading-spinner",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "lds-ring",
                "data-tooltip-id": "twitter-tooltip",
                "data-tooltip-content": (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__loading_bar_text"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
                ]
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                id: "twitter-tooltip",
                style: {
                    fontSize: "32px"
                }
            }), tooltipContainer)
        ]
    });
};


/* eslint-disable jsx-a11y/anchor-has-content */ 

var $acw62 = parcelRequire("acw62");

var $ced2c26794754a71$exports = {};

$ced2c26794754a71$exports = new URL((parcelRequire("27Lyk")).resolve("d1kZ0"), import.meta.url).toString();


var $b0e3b0d05ff6c615$exports = {};

$b0e3b0d05ff6c615$exports = new URL((parcelRequire("27Lyk")).resolve("i5q0k"), import.meta.url).toString();


var $8af26c8d08730c93$exports = {};

$8af26c8d08730c93$exports = new URL((parcelRequire("27Lyk")).resolve("a1vmr"), import.meta.url).toString();


var $e2778d854e35183e$exports = {};

$e2778d854e35183e$exports = new URL((parcelRequire("27Lyk")).resolve("59XMg"), import.meta.url).toString();



const $194dbcfeb96a4cc9$export$3c6291d64322016c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
    const url = window.location != window.parent.location ? document.referrer : document.location.href;
    const isOnCrazygames = url.includes("crazygames.com");
    const isOnIoGames = url.includes("iogames.space");
    const isOnAddictingGames = url.includes("addictinggames");
    // console.warn("@@@ Parent URL:", url);
    // console.warn("OriginalLocation:", OriginalLocation);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "main-menu-left-panel-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "neutral-button menu-btn patch-notes-btn",
                onClick: ()=>{
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).PatchNotes);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__patch_notes_btn")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__partners")
            }),
            isOnCrazygames === false && IsOnKongregate === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                target: "_blank",
                rel: "noreferrer noopener",
                href: "https://addictinggames.com/",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "iogames",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ced2c26794754a71$exports))),
                    alt: "Addicting Games"
                })
            }),
            isOnCrazygames === false && IsOnKongregate === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                target: "_blank",
                rel: "noreferrer noopener",
                href: "https://iogames.space/",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "iogames",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b0e3b0d05ff6c615$exports))),
                    alt: "iogames.space"
                })
            }),
            (isOnIoGames === false || isOnAddictingGames === false) && IsOnKongregate === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                target: "_blank",
                rel: "noreferrer noopener",
                href: "https://crazygames.com/",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "crazygames",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e2778d854e35183e$exports))),
                    alt: "Crazy Games"
                })
            }),
            IsOnKongregate === true && isOnAddictingGames === false && isOnIoGames === false && isOnCrazygames === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                target: "_blank",
                rel: "noreferrer noopener",
                href: "https://kongregate.com/",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "kongregate",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8af26c8d08730c93$exports))),
                    alt: "Kongregate"
                })
            }),
            isOnCrazygames === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "none-button",
                onClick: ()=>{
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Partners);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__partners_and_credits")
            })
        ]
    });
}, (__prepProps, __nextProps)=>true);


/* eslint-disable jsx-a11y/anchor-has-content */ 
parcelRequire("acw62");



const $a3a312f09392a0ae$export$8cdedda1c1b7bd5d = ()=>{
    const tooltipContainer = document.getElementById("tooltip-container");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "socials",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "social-links-wrapper",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "social-link twitter",
                    href: "https://twitter.com/2ndmonitorgames",
                    rel: "noreferrer noopener",
                    target: "_blank",
                    "data-tooltip-id": "twitter-tooltip",
                    "data-tooltip-content": (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__twitter_btn_tooltip")
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                    id: "twitter-tooltip",
                    style: {
                        fontSize: "32px"
                    }
                }), tooltipContainer),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "social-link discord",
                    href: "https://discord.gg/nfmg9mz8GQ",
                    rel: "noreferrer noopener",
                    target: "_blank",
                    "data-tooltip-id": "discord-tooltip",
                    "data-tooltip-content": (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__discord_btn_tooltip")
                }),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                    id: "discord-tooltip",
                    style: {
                        fontSize: "32px"
                    }
                }), tooltipContainer)
            ]
        })
    });
};


const $14d1455d3ab5388e$export$4e08dcf990b776c0 = ()=>{
    const { checkingMaintenanceModeStatusInProgress: checkingMaintenanceModeStatusInProgress , isInmaintenanceMode: isInmaintenanceMode  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$5f79f90abe9d2b63));
    const { loadingPlayerIdentity: loadingPlayerIdentity , userType: userType , userDetails: userDetails  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const { loadingAssets: loadingAssets  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$95c23f336a305d72));
    const [preferences, updatePreferences] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $9b9fb0750f8f8ccb$export$7365d374980890c6));
    const { savingPreferencesInProgress: savingPreferencesInProgress , local: local  } = preferences;
    const { username: username , PVPZ_Stats: PVPZ_Stats , PVPZ_GameState: PVPZ_GameState  } = userDetails;
    const { currentlyOnARun: currentlyOnARun  } = PVPZ_GameState;
    const { runsEmbarkedOn: runsEmbarkedOn  } = PVPZ_Stats;
    const tooltipContainer = document.getElementById("tooltip-container");
    const onMatchmakingRegionChanged = (e)=>{
        console.log("on matchmaking region changed");
        updatePreferences({
            ...preferences,
            local: {
                ...local,
                preferredMatchmakingRegion: e.target.value
            }
        });
        (0, $9b9fb0750f8f8ccb$export$7e71fac318a16f2f)();
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (event.key === "F1") (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ItemTest);
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, []);
    const anonymousUserDetails = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "anonymous-user-details",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "welcome-back",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "wb-header",
                        children: [
                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__welcome_panel_title"),
                            " ",
                            runsEmbarkedOn > 1 && (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__welcome_panel_title_suffix")
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "wb-username",
                        "data-tooltip-id": "discord-tooltip",
                        "data-tooltip-content": username,
                        children: [
                            username,
                            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                                id: "discord-tooltip",
                                style: {
                                    fontSize: "32px"
                                }
                            }), tooltipContainer)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "wb-signup-cta",
                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__welcome_sign_in_cta")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "create-account-btn neutral-button",
                onClick: ()=>{
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Register);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__create_account_btn")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "sign-in-btn neutral-button",
                onClick: ()=>{
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Login);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__sign_in_btn")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "inventory-btn neutral-button",
                onClick: ()=>{
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Inventory);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__view_inventory_btn")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "stats-btn neutral-button",
                onClick: ()=>{
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Stats);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__view_your_stats_btn")
            })
        ]
    });
    const loadingDetails = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "loading-user-details",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b66d9d7a3aaa12f$export$b08b517936747730), {})
    });
    const registeredUserDetails = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "registered-user-details",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "welcome-back",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "wb-header",
                    children: [
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__welcome_panel_title"),
                        " ",
                        runsEmbarkedOn > 1 && (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__welcome_panel_title_suffix")
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "wb-username",
                    "data-tooltip-id": "discord-tooltip",
                    "data-tooltip-content": username,
                    children: [
                        username,
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                            id: "discord-tooltip",
                            style: {
                                fontSize: "32px"
                            }
                        }), tooltipContainer)
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "inventory-btn neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Inventory);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__view_inventory_btn")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "stats-btn neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Stats);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__view_your_stats_btn")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "change-username-btn neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ChangeUsername);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__change_username_btn")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "inventory-btn destructive-button",
                    onClick: ()=>{
                        Game.EmitEvent("Identity::Logout");
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__logout_btn")
                })
            ]
        })
    });
    const shouldDisablePlayButton = loadingPlayerIdentity || loadingAssets || savingPreferencesInProgress;
    const screenWidth = window.innerWidth;
    const screenSizeIsSufficientlyLarge = screenWidth >= 1050;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "main-menu",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "center-content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "game-logo animate__animated animate__jackInTheBox",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            draggable: "false",
                            className: "game-logo-image",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($660d7b02729e1e51$exports))),
                            alt: "PvPz.io - Loot your friends \uD83D\uDE08"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: (0, $3dc337423aed9780$export$9badeb9b04b4b71c).substring(0, 5)
                        })
                    ]
                }),
                (checkingMaintenanceModeStatusInProgress || isInmaintenanceMode) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "maintenance-mode",
                    children: [
                        checkingMaintenanceModeStatusInProgress && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b66d9d7a3aaa12f$export$b08b517936747730), {}),
                        isInmaintenanceMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__game_is_in_maintenance_mode")
                        })
                    ]
                }),
                checkingMaintenanceModeStatusInProgress === false && isInmaintenanceMode === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "panels",
                    children: [
                        screenSizeIsSufficientlyLarge && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "main-menu-ad-panel animate__animated animate__bounceInLeft animate__fast",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $194dbcfeb96a4cc9$export$3c6291d64322016c), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "main-menu-primary-panel animate__animated animate__bounceInUp animate__fast",
                            children: [
                                loadingPlayerIdentity && loadingDetails,
                                loadingPlayerIdentity === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            style: {
                                                position: "relative"
                                            },
                                            className: "affirmative-button btn-large play-game-btn",
                                            disabled: shouldDisablePlayButton,
                                            onClick: ()=>{
                                                // in the FTUE case (they've never played before, skip straight to the gameplay since they wouldnt have an inventory/loadout to customize anyway, and we want to get them in the game faster)
                                                // if (runsEmbarkedOn === 0) {
                                                //     Game.EmitEvent('GameLifecycle::RunStarted');
                                                // } else
                                                if (currentlyOnARun === true) (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).RunInProgress);
                                                else (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).RunPrep);
                                            },
                                            children: shouldDisablePlayButton ? "..." : (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__play_btn")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                            value: local.preferredMatchmakingRegion,
                                            onChange: onMatchmakingRegionChanged,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "any",
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_any")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "us-east",
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_na_east")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "us-west",
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_na_west")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "eu",
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_eu")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "asia",
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_asia")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "australia",
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_australia_oceania")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: "south-america",
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_south_america")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "neutral-button menu-btn how-to-play-btn",
                                            onClick: ()=>{
                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).HowToPlay);
                                            },
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__how_to_play_btn")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "neutral-button menu-btn vendors-btn",
                                            onClick: ()=>{
                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Vendors);
                                            },
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__vendors_btn")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            className: "menu-btn vendors-btn affirmative-button animate__animated animate__jello animate__infinite animate__slow",
                                            onClick: ()=>{
                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "shop-new-tag",
                                                    children: "New!"
                                                }),
                                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__shop_btn")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "neutral-button menu-btn rankings-btn",
                                            onClick: ()=>{
                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Rankings);
                                            },
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__rankings_btn")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "neutral-button menu-btn settings-btn",
                                            onClick: ()=>{
                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Settings);
                                            },
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__settings_btn")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3a312f09392a0ae$export$8cdedda1c1b7bd5d), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "main-menu-profile-panel animate__animated animate__bounceInRight animate__fast",
                            children: [
                                loadingPlayerIdentity && loadingDetails,
                                loadingPlayerIdentity === false && userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && anonymousUserDetails,
                                loadingPlayerIdentity === false && userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered && registeredUserDetails
                            ]
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");



const $437c3525f5d10421$export$c72f6eaae7b9adff = ()=>{
    const { loadingPlayerIdentity: loadingPlayerIdentity  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const [preferences, updatePreferences] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $9b9fb0750f8f8ccb$export$7365d374980890c6));
    const { savingPreferencesInProgress: savingPreferencesInProgress , local: local , fromServer: fromServer  } = preferences;
    const { enableMusic: enableMusic , enableSoundEffects: enableSoundEffects  } = local;
    const toggleMusic = ()=>{
        updatePreferences({
            ...preferences,
            local: {
                ...local,
                enableMusic: !enableMusic
            }
        });
    };
    const toggleSfx = ()=>{
        updatePreferences({
            ...preferences,
            local: {
                ...local,
                enableSoundEffects: !enableSoundEffects
            }
        });
    };
    const onLanguageChanged = (e)=>{
        updatePreferences({
            ...preferences,
            local: {
                ...local,
                preferredLanguage: e.target.value
            }
        });
    };
    const onMatchmakingRegionChanged = (e)=>{
        updatePreferences({
            ...preferences,
            local: {
                ...local,
                preferredMatchmakingRegion: e.target.value
            }
        });
    };
    const stringifiedServerPreferences = JSON.stringify(fromServer);
    const stringifiedLocalPreferences = JSON.stringify(local);
    const saveButtonShouldBeDisabled = stringifiedServerPreferences === stringifiedLocalPreferences || loadingPlayerIdentity || savingPreferencesInProgress;
    const cancelButtonShouldBeDisabled = loadingPlayerIdentity || savingPreferencesInProgress;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "settings-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "settings-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "setting-row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "setting-label",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__enable_music")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "setting-control",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "toggle-switch enabled",
                                onClick: toggleMusic,
                                children: [
                                    enableMusic === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "toggle-switch-checked"
                                    }),
                                    enableMusic === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "toggle-switch-unchecked"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "setting-row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "setting-label",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__language")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "setting-control",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: local.preferredLanguage,
                                onChange: onLanguageChanged,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "en",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__language_dropdown_english")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "es",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__language_dropdown_spanish")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "ru",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__language_dropdown_russian")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "pt",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__language_dropdown_portuguese")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "setting-row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "setting-label",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "setting-control",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: local.preferredMatchmakingRegion,
                                onChange: onMatchmakingRegionChanged,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "any",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_any")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "us-east",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_na_west")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "us-west",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_na_east")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "eu",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_eu")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "asia",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_asia")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "australia",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_australia_oceania")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "south-america",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__matchmaking_region_dropdown_south_america")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "settings-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "neutral-button",
                            disabled: cancelButtonShouldBeDisabled,
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__back_to_main_menu_button")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "affirmative-button",
                            disabled: saveButtonShouldBeDisabled,
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$7e71fac318a16f2f)();
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__save_button")
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");

var $96b553e52fba4d95$exports = {};

$96b553e52fba4d95$exports = new URL((parcelRequire("27Lyk")).resolve("cx9h3"), import.meta.url).toString();


var $973cbde788a072ae$exports = {};

$973cbde788a072ae$exports = new URL((parcelRequire("27Lyk")).resolve("4gwYA"), import.meta.url).toString();


var $9a68bb0f12e967b0$exports = {};

$9a68bb0f12e967b0$exports = new URL((parcelRequire("27Lyk")).resolve("iGE9x"), import.meta.url).toString();


var $bce5a31a4ab318c6$exports = {};

$bce5a31a4ab318c6$exports = new URL((parcelRequire("27Lyk")).resolve("dKYJo"), import.meta.url).toString();


var $8c17d8db060b9c2e$exports = {};

$8c17d8db060b9c2e$exports = new URL((parcelRequire("27Lyk")).resolve("cbtiy"), import.meta.url).toString();


var $da4a5e6d9838d6d2$exports = {};

$da4a5e6d9838d6d2$exports = new URL((parcelRequire("27Lyk")).resolve("6l7yo"), import.meta.url).toString();


var $bfe7790ded2a0320$exports = {};

$bfe7790ded2a0320$exports = new URL((parcelRequire("27Lyk")).resolve("eTeyd"), import.meta.url).toString();


var $5bfcbcc0fa00f095$exports = {};

$5bfcbcc0fa00f095$exports = new URL((parcelRequire("27Lyk")).resolve("bDmaD"), import.meta.url).toString();


var $f5e19d1378262fad$exports = {};

$f5e19d1378262fad$exports = new URL((parcelRequire("27Lyk")).resolve("dC9Hz"), import.meta.url).toString();


var $3a87ceeb1cdb3482$exports = {};

$3a87ceeb1cdb3482$exports = new URL((parcelRequire("27Lyk")).resolve("5OZCA"), import.meta.url).toString();


var $c78efa2e4af54708$exports = {};

$c78efa2e4af54708$exports = new URL((parcelRequire("27Lyk")).resolve("cyHCR"), import.meta.url).toString();


var $fa9231b47f2e9e17$exports = {};

$fa9231b47f2e9e17$exports = new URL((parcelRequire("27Lyk")).resolve("17Gwb"), import.meta.url).toString();


var $c829baa8c73bb4e4$exports = {};

$c829baa8c73bb4e4$exports = new URL((parcelRequire("27Lyk")).resolve("j0h63"), import.meta.url).toString();


var $be45ff20ac557b40$exports = {};

$be45ff20ac557b40$exports = new URL((parcelRequire("27Lyk")).resolve("a1Zd2"), import.meta.url).toString();


var $d776f4f492cac056$exports = {};

$d776f4f492cac056$exports = new URL((parcelRequire("27Lyk")).resolve("9ibTU"), import.meta.url).toString();


var $97d9dea021cba588$exports = {};

$97d9dea021cba588$exports = new URL((parcelRequire("27Lyk")).resolve("5iHbQ"), import.meta.url).toString();


var $a3b5bf61aba7c3d5$exports = {};

$a3b5bf61aba7c3d5$exports = new URL((parcelRequire("27Lyk")).resolve("j0J96"), import.meta.url).toString();


var $af6a681d5b10e412$exports = {};

$af6a681d5b10e412$exports = new URL((parcelRequire("27Lyk")).resolve("3E2e3"), import.meta.url).toString();


var $68ba9b00e5b669e3$exports = {};

$68ba9b00e5b669e3$exports = new URL((parcelRequire("27Lyk")).resolve("3WiuC"), import.meta.url).toString();



const $031b28671ed16b8d$export$45c4ca16caeed66b = ()=>{
    const [keyState, updateKeyState] = (0, $acw62.useState)({
        w: false,
        a: false,
        s: false,
        d: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        ArrowUp: false,
        ArrowDown: false,
        ArrowLeft: false,
        ArrowRight: false,
        t: false,
        l: false,
        i: false,
        leftClick: false,
        mouseMove: false
    });
    (0, $acw62.useEffect)(()=>{
        const bindKeyPress = (event)=>{
            updateKeyState({
                ...keyState,
                [event.key]: true
            });
        };
        const bindKeyUnpress = (event)=>{
            updateKeyState({
                ...keyState,
                [event.key]: false
            });
        };
        const bindMouseDown = (event)=>{
            if (event.button === 0) updateKeyState({
                ...keyState,
                leftClick: true
            });
        };
        const bindMouseUp = (event)=>{
            if (event.button === 0) updateKeyState({
                ...keyState,
                leftClick: false
            });
        };
        document.addEventListener("keydown", bindKeyPress);
        document.addEventListener("keyup", bindKeyUnpress);
        document.addEventListener("mousedown", bindMouseDown);
        document.addEventListener("mouseup", bindMouseUp);
        // 👇️ remove event listeners when the how to play screen unmounts
        return ()=>{
            document.removeEventListener("keydown", bindKeyPress);
            document.removeEventListener("keyup", bindKeyUnpress);
            document.removeEventListener("mousedown", bindMouseDown);
            document.removeEventListener("mouseup", bindMouseUp);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "how-to-play-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "how-to-play-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        textAlign: "center",
                        alignSelf: "center",
                        fontSize: "32px"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__top_big_paragraph")
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        textAlign: "center",
                        alignSelf: "center"
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__small_paragraph_one")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        textAlign: "center",
                        alignSelf: "center"
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__small_paragraph_three")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__test_keys_header")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "control-list-parent",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "control-list chonky-control-list",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($96b553e52fba4d95$exports))),
                                                    alt: "W Key",
                                                    className: `${keyState["w"] === true ? "active" : ""}`
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "&"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($973cbde788a072ae$exports))),
                                                    alt: "Up Arrow Key",
                                                    className: `${keyState["ArrowUp"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__move_up_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9a68bb0f12e967b0$exports))),
                                                    alt: "A Key",
                                                    className: `${keyState["a"] === true ? "active" : ""}`
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "&"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bce5a31a4ab318c6$exports))),
                                                    alt: "Left Arrow Key",
                                                    className: `${keyState["ArrowLeft"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__move_left_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8c17d8db060b9c2e$exports))),
                                                    alt: "S Key",
                                                    className: `${keyState["s"] === true ? "active" : ""}`
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "&"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($da4a5e6d9838d6d2$exports))),
                                                    alt: "Down Arrow Key",
                                                    className: `${keyState["ArrowDown"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__move_down_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bfe7790ded2a0320$exports))),
                                                    alt: "D Key",
                                                    className: `${keyState["d"] === true ? "active" : ""}`
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "&"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5bfcbcc0fa00f095$exports))),
                                                    alt: "Right Arrow Key",
                                                    className: `${keyState["ArrowRight"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__move_right_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control mouse",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label mouse mousedrag",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a3b5bf61aba7c3d5$exports))),
                                                    className: "mousearrow mal",
                                                    alt: "Mouse Move Arrow Left"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a3b5bf61aba7c3d5$exports))),
                                                    className: "mousearrow mar",
                                                    alt: "Mouse Move Arrow Right"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a3b5bf61aba7c3d5$exports))),
                                                    className: "mousearrow mau",
                                                    alt: "Mouse Move Arrow Up"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a3b5bf61aba7c3d5$exports))),
                                                    className: "mousearrow mad",
                                                    alt: "Mouse Move Arrow Down"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($97d9dea021cba588$exports))),
                                                    alt: "Mouse Move",
                                                    className: `${keyState["mouseMove"] === true ? "active" : ""}`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-description",
                                            children: [
                                                ": ",
                                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__mouse_aim_controls")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "control-list",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c78efa2e4af54708$exports))),
                                                    alt: "3 Key",
                                                    className: `${keyState["3"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__ability_one_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fa9231b47f2e9e17$exports))),
                                                    alt: "4 Key",
                                                    className: `${keyState["4"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__ability_two_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: `${keyState["5"] === true ? "active" : ""}`,
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d776f4f492cac056$exports))),
                                                    alt: "5 Key"
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__ability_three_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c829baa8c73bb4e4$exports))),
                                                    alt: "i Key",
                                                    className: `${keyState["i"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__inventory_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($be45ff20ac557b40$exports))),
                                                    alt: "L Key",
                                                    className: `${keyState["l"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__leaderboard_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control mouse",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label mouse",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($af6a681d5b10e412$exports))),
                                                    alt: "Mouse Move",
                                                    className: `${keyState["leftClick"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__mouse_shoot_controls")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "control-list",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f5e19d1378262fad$exports))),
                                                    alt: "1 Key",
                                                    className: `${keyState["1"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__weapon_one_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3a87ceeb1cdb3482$exports))),
                                                    alt: "2 Key",
                                                    className: `${keyState["2"] === true ? "active" : ""}`
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__weapon_two_key")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    className: "control extraction-control",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "control-label",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($68ba9b00e5b669e3$exports))),
                                                    alt: "Extraction",
                                                    className: "extraction"
                                                }),
                                                " :"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "control-description",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__extraction")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("how_to_play__back_to_main_menu_button")
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");




var $6f8d961a1537580d$exports = {};

$6f8d961a1537580d$exports = new URL((parcelRequire("27Lyk")).resolve("5jDSs"), import.meta.url).toString();


var $3ec7ab44d075dfe3$exports = {};

$3ec7ab44d075dfe3$exports = new URL((parcelRequire("27Lyk")).resolve("8LIGh"), import.meta.url).toString();


var $f7906d7a23d661d6$exports = {};

$f7906d7a23d661d6$exports = new URL((parcelRequire("27Lyk")).resolve("ode0x"), import.meta.url).toString();


var $29a5768d09b02258$exports = {};

$29a5768d09b02258$exports = new URL((parcelRequire("27Lyk")).resolve("fBSa5"), import.meta.url).toString();


var $1fcf710a6ce148eb$exports = {};

$1fcf710a6ce148eb$exports = new URL((parcelRequire("27Lyk")).resolve("gYNrw"), import.meta.url).toString();


var $84318edd7909e2df$exports = {};

$84318edd7909e2df$exports = new URL((parcelRequire("27Lyk")).resolve("2Xa6R"), import.meta.url).toString();


var $98b223ff8eaa32f0$exports = {};

$98b223ff8eaa32f0$exports = new URL((parcelRequire("27Lyk")).resolve("hXmKT"), import.meta.url).toString();


var $e8616bb6c3229e80$exports = {};

$e8616bb6c3229e80$exports = new URL((parcelRequire("27Lyk")).resolve("iOqRE"), import.meta.url).toString();


var $6970398eee575e9b$exports = {};

$6970398eee575e9b$exports = new URL((parcelRequire("27Lyk")).resolve("3CFcB"), import.meta.url).toString();


var $09594d5a165cd718$exports = {};

$09594d5a165cd718$exports = new URL((parcelRequire("27Lyk")).resolve("fsFv8"), import.meta.url).toString();


var $041a7dc1e8d8927a$exports = {};

$041a7dc1e8d8927a$exports = new URL((parcelRequire("27Lyk")).resolve("lIjHY"), import.meta.url).toString();


var $532e2626c8c21047$exports = {};

$532e2626c8c21047$exports = new URL((parcelRequire("27Lyk")).resolve("l5j8S"), import.meta.url).toString();




var $fa3a351f034b35e0$export$d2a4afdad40c5757;
(function(SlotVisualOptions) {
    SlotVisualOptions[SlotVisualOptions["Inventory"] = 0] = "Inventory";
    SlotVisualOptions[SlotVisualOptions["Gear"] = 1] = "Gear";
    SlotVisualOptions[SlotVisualOptions["Weapon"] = 2] = "Weapon";
})($fa3a351f034b35e0$export$d2a4afdad40c5757 || ($fa3a351f034b35e0$export$d2a4afdad40c5757 = {}));
const $fa3a351f034b35e0$export$406cc9815f4008ac = (itemType, gameText)=>{
    switch(itemType){
        case (0, $faa1b3449016497b$export$1fc8f52ad1810e52).Weapon:
        case (0, $faa1b3449016497b$export$1fc8f52ad1810e52).VendorTrash:
        case (0, $faa1b3449016497b$export$1fc8f52ad1810e52).CollectorsItem:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "weapon-prefix",
                children: gameText
            }, `item-slot-weapon-prefix-${Math.random() * 10000}`);
        case (0, $faa1b3449016497b$export$1fc8f52ad1810e52).ActiveGear:
        case (0, $faa1b3449016497b$export$1fc8f52ad1810e52).PassiveGear:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "gear-abilities",
                children: gameText.split(" | ").map((txt)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "ability-line-item",
                        children: [
                            "• ",
                            txt
                        ]
                    }, `item-slot-ability-line-${Math.random() * 10000}`);
                })
            });
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    }
};
const $fa3a351f034b35e0$export$c2b08f0dad0547e0 = (props)=>{
    const { OnClickFn: onClickFn , itemId: itemId , quantity: quantity , slotVisualType: slotVisualType , slotSize: slotSize , selected: selected , showLeftClickEquipPrompt: showLeftClickEquipPrompt , showLeftClickLootPrompt: showLeftClickLootPrompt , showYouMustExtractPrompt: showYouMustExtractPrompt , showInsuredLock: showInsuredLock , disableHover: disableHover  } = props;
    const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(itemId);
    const random = Math.floor(Math.random() * 100000);
    const tooltipContainer = document.getElementById("tooltip-container");
    const renderedSlotSize = slotSize ? slotSize : "normal";
    let { name: name , gameplayText: gameplayText , loreText: loreText  } = itemConfig;
    // console.warn("@@@ translations");
    name = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(name);
    gameplayText = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(gameplayText);
    loreText = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(loreText);
    // console.log({ name, gameplayText, loreText });
    // console.warn("@@@ translations");
    const { itemType: itemType , itemRarity: itemRarity , inventorySpriteId: inventorySpriteId , smallInventorySlotRotation: smallInventorySlotRotation , smallInventorySlotSpriteScale: smallInventorySlotSpriteScale , smallInventorySlotSpriteOffsetLeft: smallInventorySlotSpriteOffsetLeft , smallInventorySlotSpriteOffsetTop: smallInventorySlotSpriteOffsetTop , largeInventorySlotRotation: largeInventorySlotRotation , largeInventorySlotSpriteScale: largeInventorySlotSpriteScale , largeInventorySlotSpriteOffsetLeft: largeInventorySlotSpriteOffsetLeft , largeInventorySlotSpriteOffsetTop: largeInventorySlotSpriteOffsetTop , tooltipSlotRotation: tooltipSlotRotation , tooltipSlotSpriteScale: tooltipSlotSpriteScale , tooltipSlotSpriteOffsetLeft: tooltipSlotSpriteOffsetLeft , tooltipSlotSpriteOffsetTop: tooltipSlotSpriteOffsetTop  } = itemConfig;
    const spritePath = "/sprites/" + inventorySpriteId;
    let spriteImage;
    let damageTypeSprite;
    let damageType = (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).None;
    if (itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).Weapon) {
        const weaponConfig = (0, $0acc22698d702be9$export$f96416c73a613aba)(itemId);
        damageType = weaponConfig.damageType;
        // console.warn("@@@ Damage type:", damageType);
        switch(damageType){
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3ec7ab44d075dfe3$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Bleed:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f7906d7a23d661d6$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($29a5768d09b02258$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1fcf710a6ce148eb$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($84318edd7909e2df$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($98b223ff8eaa32f0$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e8616bb6c3229e80$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6970398eee575e9b$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($09594d5a165cd718$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($041a7dc1e8d8927a$exports))),
                    alt: ""
                });
                break;
            case (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    draggable: "false",
                    className: "damage-type-icon",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($532e2626c8c21047$exports))),
                    alt: ""
                });
                break;
            default:
                damageTypeSprite = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
                break;
        }
    }
    if (renderedSlotSize === "large") spriteImage = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        draggable: "false",
        className: "item-image",
        src: spritePath,
        alt: "",
        style: {
            transform: `rotate(${largeInventorySlotRotation}deg) scale(${largeInventorySlotSpriteScale})`,
            top: `${largeInventorySlotSpriteOffsetTop}px`,
            left: `${largeInventorySlotSpriteOffsetLeft}px`
        }
    });
    else spriteImage = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        draggable: "false",
        className: "item-image",
        src: spritePath,
        alt: "",
        style: {
            transform: `rotate(${smallInventorySlotRotation}deg) scale(${smallInventorySlotSpriteScale})`,
            top: `${smallInventorySlotSpriteOffsetTop}px`,
            left: `${smallInventorySlotSpriteOffsetLeft}px`
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `item-slot slot-type-${$fa3a351f034b35e0$export$d2a4afdad40c5757[slotVisualType].toLowerCase()} slot-size-${renderedSlotSize} ${selected ? "selected" : ""} ${disableHover ? "disable-hover" : ""} slot-rarity-${(0, $faa1b3449016497b$export$d2ffa9ea74cc769f)[itemRarity].toLowerCase()}`,
        "data-tooltip-id": `item-tooltip-${itemId}-${random}`,
        onClick: (__e)=>{
            onClickFn(itemId);
        },
        children: [
            quantity && quantity >= 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "quantity",
                children: quantity
            }),
            showInsuredLock && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                draggable: "false",
                className: "insured-lock",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6f8d961a1537580d$exports))),
                alt: ""
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "selection-parent",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner top-left"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner top-right"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner bottom-left"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner bottom-right"
                    })
                ]
            }),
            spriteImage,
            damageTypeSprite,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                id: `item-tooltip-${itemId}-${random}`,
                className: "fancy-tooltip",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            draggable: "false",
                            className: "item-image",
                            style: {
                                transform: `rotate(${tooltipSlotRotation}deg) scale(${tooltipSlotSpriteScale})`,
                                top: `${tooltipSlotSpriteOffsetTop}px`,
                                left: `${tooltipSlotSpriteOffsetLeft}px`
                            },
                            src: spritePath,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: `item-name ${(0, $faa1b3449016497b$export$d2ffa9ea74cc769f)[itemRarity].toLowerCase()}`,
                            children: name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "item-type",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)((0, $faa1b3449016497b$export$d2ffa9ea74cc769f)[itemRarity].toLowerCase()) + " " + (0, $faa1b3449016497b$export$3d208edac0e62a11)(itemType)
                        }),
                        damageType !== (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).None && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "damage-type-line",
                            children: [
                                damageTypeSprite,
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        (0, $faa1b3449016497b$export$b8f9e8b7bac978d5)[damageType],
                                        " ",
                                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_slot__damage")
                                    ]
                                })
                            ]
                        }),
                        loreText.length !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "item-description",
                            children: loreText
                        }),
                        gameplayText.length !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "item-gameplay-info",
                            children: $fa3a351f034b35e0$export$406cc9815f4008ac(itemType, gameplayText)
                        }),
                        showLeftClickEquipPrompt === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "item-click-info",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    draggable: "false",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($af6a681d5b10e412$exports))),
                                    alt: ""
                                }),
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_slot__equip_prompt")
                            ]
                        }),
                        showLeftClickLootPrompt === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "item-click-info",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    draggable: "false",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($af6a681d5b10e412$exports))),
                                    alt: ""
                                }),
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_slot__loot_prompt")
                            ]
                        }),
                        showYouMustExtractPrompt === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "item-extract-info",
                            children: [
                                "\uD83D\uDEA8 ",
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_slot__extract_prompt")
                            ]
                        })
                    ]
                })
            }), tooltipContainer)
        ]
    });
};




parcelRequire("acw62");



const $fbe727221247bde8$export$ed5c7e9f758b0272 = (props)=>{
    const { skin: skin , OnClickFn: OnClickFn , selected: selected  } = props;
    const tooltipContainer = document.getElementById("tooltip-container");
    const characterSkinData = (0, $cee99d2008daa3ee$export$183400f7af0e3a3c).get(skin);
    const characterSkinSprite = characterSkinData.staticSpriteId;
    const characterSkinName = characterSkinData.friendlyName;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "character-skin-slot" + ` ${selected === true ? "selected" : ""}`,
                "data-tooltip-id": `character-skin-slot-tooltip-${skin}`,
                onClick: OnClickFn,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "selection-parent",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "selection-corner top-left"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "selection-corner top-right"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "selection-corner bottom-left"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "selection-corner bottom-right"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        draggable: "false",
                        src: characterSkinSprite,
                        alt: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c)[skin]
                    })
                ]
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                id: `character-skin-slot-tooltip-${skin}`,
                style: {
                    fontSize: "32px",
                    padding: "10px 0",
                    margin: 0,
                    textAlign: "center"
                },
                children: characterSkinName
            }), tooltipContainer)
        ]
    });
};



parcelRequire("acw62");


const $82a27a6c8d8545b3$export$ed8671f612970784 = (props)=>{
    const { items: items , showLeftClickEquipPrompt: showLeftClickEquipPrompt , showLeftClickLootPrompt: showLeftClickLootPrompt , showYouMustExtractPrompt: showYouMustExtractPrompt , OnSlotClickFn: onSlotClickFn  } = props;
    const sortedItems = Object.entries(items).filter(([itemId, __itemQuantity])=>{
        // @ts-ignore
        return itemId !== "-1" && itemId !== -1;
    }).sort(([itemID1, __quantity1], [itemID2, __quantity2])=>{
        const itemRarity1 = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(parseInt(itemID1)).itemRarity;
        const itemRarity2 = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(parseInt(itemID2)).itemRarity;
        if (itemRarity1 > itemRarity2) return -1;
        if (itemRarity1 < itemRarity2) return 1;
        return 0;
    });
    const inventory = [];
    for(let i = 0; i < sortedItems.length; i++){
        const [itemId, quantity] = sortedItems[i];
        // @ts-ignore
        if (itemId === -1 || itemId === "-1") continue;
        if (quantity <= 0) continue;
        inventory.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
            OnClickFn: onSlotClickFn,
            itemId: parseInt(itemId),
            quantity: quantity,
            slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Inventory,
            showLeftClickEquipPrompt: showLeftClickEquipPrompt ? showLeftClickEquipPrompt : false,
            showLeftClickLootPrompt: showLeftClickLootPrompt ? showLeftClickLootPrompt : false,
            showYouMustExtractPrompt: showYouMustExtractPrompt ? showYouMustExtractPrompt : false
        }, itemId));
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "item-container",
        children: inventory
    });
};




parcelRequire("acw62");


const $ba56ec254e4e26c8$export$b081dc7b28c9b0a8 = (props)=>{
    const { slotVisualType: slotVisualType , slotSize: slotSize , onClickFn: onClickFn , selected: selected , showInsuredLock: showInsuredLock , disableHover: disableHover  } = props;
    const renderedSlotSize = slotSize ? slotSize : "normal";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "item-slot" + ` slot-type-${(0, $fa3a351f034b35e0$export$d2a4afdad40c5757)[slotVisualType].toLowerCase()} ` + `slot-size-${renderedSlotSize}` + ` ${selected ? "selected" : ""} ${disableHover ? "disable-hover" : ""}`,
        onClick: onClickFn,
        children: [
            showInsuredLock && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                draggable: "false",
                className: "insured-lock",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6f8d961a1537580d$exports))),
                alt: "Insured Lock"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "selection-parent",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner top-left"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner top-right"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner bottom-left"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "selection-corner bottom-right"
                    })
                ]
            })
        ]
    });
};




var $06c12dbb02effcc3$exports = {};

$06c12dbb02effcc3$exports = new URL((parcelRequire("27Lyk")).resolve("rgAZX"), import.meta.url).toString();






const $7f56119da642b0b0$export$da43adadf9b663fe = (items)=>{
    const abilitySummaries = [];
    for(let i = 0; i < items.length; i++){
        if (items[i] === -1) continue;
        const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(items[i]);
        if (itemConfig.itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).PassiveGear || itemConfig.itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).ActiveGear) {
            if (itemConfig.activeAbility.ability !== (0, $faa1b3449016497b$export$259a6f5d817ae02e).None || itemConfig.passiveAbilities.length > 0) abilitySummaries.push(...(0, $4bbe42650164e1e5$export$625550452a3fa3ec)(itemConfig.gameplayText).split(" | "));
        }
    }
    return abilitySummaries;
};
const $7f56119da642b0b0$export$2915bcb1753dec25 = ()=>{
    const justWeaponsFromStash = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$34e323431127bf02));
    const justGearFromStash = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$e478d6af9991afc6));
    console.log((0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb)));
    const { userType: userType , userDetails: userDetails  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    // @ts-ignore
    const { PVPZ_UnlockedSkins: PVPZ_UnlockedSkins , PVPZ_Currency: PVPZ_Currency , PVPZ_PurchasedSKUs: PVPZ_PurchasedSKUs  } = userDetails;
    const { insuranceCredits: insuranceCredits  } = PVPZ_Currency;
    const { loadout: loadout , loadoutScreen: loadoutScreen , playerLoadoutOperationInProgress: playerLoadoutOperationInProgress  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad));
    const { selectionMode: selectionMode  } = loadoutScreen;
    const [isFullscreen, setIsFullscreen] = (0, $acw62.useState)(false);
    const currentUrl = window.location != window.parent.location ? document.referrer : document.location.href;
    const isOnCrazygames = currentUrl.includes("crazygames.com") || OriginalLocation?.includes("crazygames");
    const loadoutWeaponOne = (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.WEAPON_ONE === -1 ? loadout.weaponOne : (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.WEAPON_ONE;
    const loadoutWeaponTwo = (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.WEAPON_TWO === -1 ? loadout.weaponTwo : (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.WEAPON_TWO;
    const loadoutGearOne = (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.GEAR_ONE === -1 ? loadout.gearOne : (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.GEAR_ONE;
    const loadoutGearTwo = (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.GEAR_TWO === -1 ? loadout.gearTwo : (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.GEAR_TWO;
    const loadoutGearThree = (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.GEAR_THREE === -1 ? loadout.gearThree : (0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).DEBUG.LOADOUT_OVERRIDES.GEAR_THREE;
    const justItemsFromLoadout = [
        loadoutWeaponOne,
        loadoutWeaponTwo,
        loadoutGearOne,
        loadoutGearTwo,
        loadoutGearThree
    ];
    const maxHealthWithBoostsFactoredIn = Math.ceil(100 + (0, $faa1b3449016497b$export$65f9a86fc3e52a6a)(justItemsFromLoadout));
    const physicalDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical, justItemsFromLoadout, true);
    const fireDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire, justItemsFromLoadout, true);
    const toxicDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic, justItemsFromLoadout, true);
    const arcaneDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane, justItemsFromLoadout, true);
    const frostDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost, justItemsFromLoadout, true);
    const lightningDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning, justItemsFromLoadout, true);
    const holyDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy, justItemsFromLoadout, true);
    const shadowDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow, justItemsFromLoadout, true);
    const chaosDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos, justItemsFromLoadout, true);
    const natureDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature, justItemsFromLoadout, true);
    const bleedDamageBoost = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Bleed, justItemsFromLoadout, true);
    const physicalDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical, justItemsFromLoadout, true);
    const fireDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire, justItemsFromLoadout, true);
    const toxicDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic, justItemsFromLoadout, true);
    const arcaneDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane, justItemsFromLoadout, true);
    const frostDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Frost, justItemsFromLoadout, true);
    const lightningDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Lightning, justItemsFromLoadout, true);
    const holyDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Holy, justItemsFromLoadout, true);
    const shadowDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow, justItemsFromLoadout, true);
    const chaosDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos, justItemsFromLoadout, true);
    const natureDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature, justItemsFromLoadout, true);
    const bleedDamageReduction = (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).Defence, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Bleed, justItemsFromLoadout, true);
    const allAbilityDescriptions = $7f56119da642b0b0$export$da43adadf9b663fe(justItemsFromLoadout);
    const abilityDescriptionsDom = allAbilityDescriptions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "no-abilities",
        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__no_abilities")
    }) : allAbilityDescriptions.map((abilityDescription, __index)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "ability",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "• ",
                    abilityDescription
                ]
            })
        }, `ability-${__index}`);
    });
    //#region Slot Visuals or Empty Slots
    const weaponSlotOne = loadoutWeaponOne === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        onClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("weaponOne");
        },
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: selectionMode === "weaponOne",
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("weaponOne");
        },
        itemId: loadoutWeaponOne,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: selectionMode === "weaponOne",
        showLeftClickEquipPrompt: false,
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne
    });
    const weaponSlotTwo = loadoutWeaponTwo === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        onClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("weaponTwo");
        },
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: selectionMode === "weaponTwo",
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("weaponTwo");
        },
        itemId: loadoutWeaponTwo,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: selectionMode === "weaponTwo",
        showLeftClickEquipPrompt: false,
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo
    });
    const gearSlotOne = loadoutGearOne === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        onClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("gearOne");
        },
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: selectionMode === "gearOne",
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("gearOne");
        },
        itemId: loadoutGearOne,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: selectionMode === "gearOne",
        showLeftClickEquipPrompt: false,
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne
    });
    const gearSlotTwo = loadoutGearTwo === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        onClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("gearTwo");
        },
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: selectionMode === "gearTwo",
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("gearTwo");
        },
        itemId: loadoutGearTwo,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: selectionMode === "gearTwo",
        showLeftClickEquipPrompt: false,
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo
    });
    const getInsuredItemName = (slot)=>{
        let insuredItem;
        switch(slot){
            case (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne:
                insuredItem = loadoutWeaponOne;
                break;
            case (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo:
                insuredItem = loadoutWeaponTwo;
                break;
            case (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne:
                insuredItem = loadoutGearOne;
                break;
            case (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo:
                insuredItem = loadoutGearTwo;
                break;
            case (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree:
                insuredItem = loadoutGearThree;
                break;
            default:
                insuredItem = -1;
                break;
        }
        if (insuredItem === -1) return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("insured_item_nothing");
        const itemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(insuredItem);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: `item-rarity-${(0, $faa1b3449016497b$export$d2ffa9ea74cc769f)[itemConfig.itemRarity].toLowerCase()}`,
            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(itemConfig.name)
        });
    };
    const gearSlotThree = loadoutGearThree === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        onClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("gearThree");
        },
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: selectionMode === "gearThree",
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{
            (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("gearThree");
        },
        itemId: loadoutGearThree,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: selectionMode === "gearThree",
        showLeftClickEquipPrompt: false,
        showInsuredLock: loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree
    });
    //#endregion
    const equipItemToSlot = (slot, itemId)=>{
        // console.log(`equipping item ${Item[itemId]} to slot: ${slot}`);
        (0, $9b9fb0750f8f8ccb$export$707c9a05415c721f)(slot, itemId);
    };
    const equipSkin = (skin)=>{
        (0, $9b9fb0750f8f8ccb$export$7a7184d464c6fe49)(skin);
    // if (userType === UserType.Anonymous && (skin === CharacterSkin.NobleKnight || skin === CharacterSkin.Wizard_Corrupted || skin === CharacterSkin.Wizard_Veteran || skin === CharacterSkin.Boltman)) {
    //     PopToast({ status: ToastStatuses.ERROR, message: t("runprep__skin_not_unlocked_registered") });
    //     return;
    // }
    // if (userType === UserType.Anonymous) {
    //     if (skin === CharacterSkin.NobleKnight || skin === CharacterSkin.Wizard_Corrupted || skin === CharacterSkin.Wizard_Veteran) {
    //         PopToast({ status: ToastStatuses.ERROR, message: t("runprep__skin_not_unlocked_registered") });
    //         return;
    //     } else if (skin === CharacterSkin.MidnightThief || skin === CharacterSkin.ForestArcher || skin === CharacterSkin.Assassin || skin === CharacterSkin.VengefulKnight) {
    //         UI_SetSelectedSkinToPurchase(skin);
    //         UI_SwapScreen(Screens.ConfirmSkinPurchase);
    //     } else if (skin === CharacterSkin.Estranged_Wizard) {
    //         UI_SetSelectedBundle("welcome");
    //         UI_SwapScreen(Screens.BundleDetails);
    //     } else if (skin === CharacterSkin.AdeptArcher || skin === CharacterSkin.WealthyAssassin || skin === CharacterSkin.FallenWizardsApprentice) {
    //         UI_SetSelectedBundle("supporter");
    //         UI_SwapScreen(Screens.BundleDetails);
    //     } else {
    //         UI_SetSelectedBundle("founder");
    //         UI_SwapScreen(Screens.BundleDetails);
    //     }
    // } else {
    //     if (requiresOwnership && PVPZ_UnlockedSkins !== undefined) {
    //         console.log("user is equipping a skin that requires ownership", PVPZ_UnlockedSkins);
    //         if (PVPZ_UnlockedSkins.includes(skin) === false) {
    //             if (skin === CharacterSkin.MidnightThief || skin === CharacterSkin.ForestArcher || skin === CharacterSkin.Assassin || skin === CharacterSkin.VengefulKnight) {
    //                 UI_SetSelectedSkinToPurchase(skin);
    //                 UI_SwapScreen(Screens.ConfirmSkinPurchase);
    //             } else if (skin === CharacterSkin.Estranged_Wizard) {
    //                 UI_SetSelectedBundle("welcome");
    //                 UI_SwapScreen(Screens.BundleDetails);
    //             } else if (skin === CharacterSkin.AdeptArcher || skin === CharacterSkin.WealthyAssassin || skin === CharacterSkin.FallenWizardsApprentice) {
    //                 UI_SetSelectedBundle("supporter");
    //                 UI_SwapScreen(Screens.BundleDetails);
    //             } else {
    //                 UI_SetSelectedBundle("founder");
    //                 UI_SwapScreen(Screens.BundleDetails);
    //             }
    //         } else {
    //             UI_EquipSkin(skin);
    //         }
    //     } else {
    //         // console.log(`equipping skin ${CharacterSkin[skin]}`);
    //     }
    // }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "runprep-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                isOnCrazygames === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: `fullscreen-button ${isFullscreen ? "is-full-screen neutral-button" : "affirmative-button animate__animated animate__jello animate__infinite animate__slow"}`,
                    onClick: ()=>{
                        setIsFullscreen(!isFullscreen);
                        Game.Input.ToggleFullScreen();
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: isFullscreen ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("exit_fullscreen") : (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("fullscreen")
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "runprep-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "runprep-content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "runprep-loadout",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "character",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "skin-title",
                                            children: [
                                                "~ ",
                                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__skin_header"),
                                                " ~"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                            selected: selectionMode === "characterSkin",
                                            OnClickFn: ()=>{
                                                (0, $9b9fb0750f8f8ccb$export$ea43fe87ae3be17d)("characterSkin");
                                            },
                                            skin: loadout.characterSkin
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "weapons",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "weps-title",
                                            children: [
                                                "~ ",
                                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__weapons_header"),
                                                " ~"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "weapon-slots",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "weapon-parent",
                                                    children: [
                                                        weaponSlotOne,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `neutral-button insure-btn ${loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne ? "insured" : ""}`,
                                                            disabled: playerLoadoutOperationInProgress || loadoutWeaponOne === -1 || insuranceCredits <= 0,
                                                            onClick: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne);
                                                            },
                                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__insurance_button")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "weapon-parent",
                                                    children: [
                                                        weaponSlotTwo,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `neutral-button insure-btn ${loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo ? "insured" : ""}`,
                                                            disabled: playerLoadoutOperationInProgress || loadoutWeaponTwo === -1 || insuranceCredits <= 0,
                                                            onClick: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)((0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo);
                                                            },
                                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__insurance_button")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "gear",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "gear-title",
                                            children: [
                                                "~ ",
                                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__gear_header"),
                                                " ~"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "gear-slots",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "gear-parent",
                                                    children: [
                                                        gearSlotOne,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `neutral-button insure-btn ${loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne ? "insured" : ""}`,
                                                            disabled: playerLoadoutOperationInProgress || loadoutGearOne === -1 || insuranceCredits <= 0,
                                                            onClick: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne);
                                                            // Game.Rewards.PreInsurance(LoadoutSlots.GearOne);
                                                            },
                                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__insurance_button")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "gear-parent",
                                                    children: [
                                                        gearSlotTwo,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `neutral-button insure-btn ${loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo ? "insured" : ""}`,
                                                            disabled: playerLoadoutOperationInProgress || loadoutGearTwo === -1 || insuranceCredits <= 0,
                                                            onClick: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo);
                                                            },
                                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__insurance_button")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "gear-parent",
                                                    children: [
                                                        gearSlotThree,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: `neutral-button insure-btn ${loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree ? "insured" : ""}`,
                                                            disabled: playerLoadoutOperationInProgress || loadoutGearThree === -1 || insuranceCredits <= 0,
                                                            onClick: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)((0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree);
                                                            },
                                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__insurance_button")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "insurance-credits-label",
                                            children: [
                                                "Insurance Credits Remaining: ",
                                                insuranceCredits
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            draggable: "false",
                            className: "divider divider-one",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($06c12dbb02effcc3$exports))),
                            alt: "Divider"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "runprep-inventory",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "runprep-selector",
                                    children: [
                                        selectionMode === "none" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "no-selection",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            marginRight: "10px"
                                                        },
                                                        children: "\uD83D\uDC48"
                                                    }),
                                                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__no_slot_selected_scrollbox")
                                                ]
                                            })
                                        }),
                                        selectionMode === "characterSkin" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "character-skin-select",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__scrollbox_with_skins_text")
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Apprentice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Apprentice);
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Apprentice
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Corrupted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $4a3136d799878a30$export$6b89521c3f482608)({
                                                                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                                                                    message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("runprep__skin_not_unlocked_registered")
                                                                });
                                                                return;
                                                            } else equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Corrupted);
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Corrupted
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Veteran && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $4a3136d799878a30$export$6b89521c3f482608)({
                                                                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                                                                    message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("runprep__skin_not_unlocked_registered")
                                                                });
                                                                return;
                                                            } else equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Veteran);
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Wizard_Veteran
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Boltman && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Boltman);
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Boltman
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Knight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Knight);
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Knight
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Thief && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Thief);
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Thief
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).NobleKnight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $4a3136d799878a30$export$6b89521c3f482608)({
                                                                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                                                                    message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("runprep__skin_not_unlocked_registered")
                                                                });
                                                                return;
                                                            } else equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).NobleKnight);
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).NobleKnight
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).AdeptArcher && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("supporter");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).AdeptArcher)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).AdeptArcher);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("supporter");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).AdeptArcher
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher);
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin);
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CherryBlossomBoltman && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CherryBlossomBoltman)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CherryBlossomBoltman);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CherryBlossomBoltman
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Coldsteel_Knight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Coldsteel_Knight)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Coldsteel_Knight);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Coldsteel_Knight
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CursedCorruptedWizard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CursedCorruptedWizard)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CursedCorruptedWizard);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CursedCorruptedWizard
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).FallenWizardsApprentice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("supporter");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).FallenWizardsApprentice)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).FallenWizardsApprentice);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("supporter");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).FallenWizardsApprentice
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).HeroicKnight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).HeroicKnight)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).HeroicKnight);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).HeroicKnight
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief);
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).RadiantKnight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).RadiantKnight)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).RadiantKnight);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).RadiantKnight
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight);
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).WealthyAssassin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("supporter");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).WealthyAssassin)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).WealthyAssassin);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("supporter");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).WealthyAssassin
                                                    }),
                                                    loadout.characterSkin !== (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Estranged_Wizard && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                        selected: false,
                                                        OnClickFn: ()=>{
                                                            if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
                                                                (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("welcome");
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                            } else if (PVPZ_UnlockedSkins !== undefined) {
                                                                if (PVPZ_UnlockedSkins.includes((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Estranged_Wizard)) equipSkin((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Estranged_Wizard);
                                                                else {
                                                                    (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("welcome");
                                                                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                                                }
                                                            }
                                                        },
                                                        skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Estranged_Wizard
                                                    })
                                                ]
                                            })
                                        }),
                                        (selectionMode === "weaponOne" || selectionMode === "weaponTwo") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "weapon-select",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__scrollbox_with_weapons_text")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                                                        OnSlotClickFn: (itemId)=>{
                                                            const slot = selectionMode === "weaponOne" ? (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne : (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo;
                                                            equipItemToSlot(slot, itemId);
                                                        },
                                                        items: justWeaponsFromStash,
                                                        showLeftClickEquipPrompt: true
                                                    })
                                                ]
                                            })
                                        }),
                                        (selectionMode === "gearOne" || selectionMode === "gearTwo" || selectionMode === "gearThree") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "gear-select",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__scrollbox_with_gear_text")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                                                        OnSlotClickFn: (itemId)=>{
                                                            const slot = selectionMode === "gearOne" ? (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne : selectionMode === "gearTwo" ? (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo : (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree;
                                                            equipItemToSlot(slot, itemId);
                                                        },
                                                        items: justGearFromStash,
                                                        showLeftClickEquipPrompt: true
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "runprep-insurance",
                                    children: [
                                        loadout.insuredSlot === -1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__no_slot_selected_insurance_text")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "smol",
                                                    style: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__no_slot_selected_insurance_text_2")
                                                })
                                            ]
                                        }),
                                        loadout.insuredSlot !== -1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__slot_insured_text")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "smol",
                                                    children: [
                                                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__your"),
                                                        " ",
                                                        getInsuredItemName(loadout.insuredSlot),
                                                        " ",
                                                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__will_be_safe")
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            draggable: "false",
                            className: "divider divider-two",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($06c12dbb02effcc3$exports))),
                            alt: "Divider"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "runprep-summary",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "runprep-stats",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "health",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    children: [
                                                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__health"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                maxHealthWithBoostsFactoredIn
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "stats",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "offensive-stats",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "stat-category-title",
                                                            children: [
                                                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__damage"),
                                                                "+"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: physicalDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: fireDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: toxicDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: arcaneDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: frostDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: lightningDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: holyDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: shadowDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: chaosDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: natureDamageBoost
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: bleedDamageBoost
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "stats-labels",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stat-category-title",
                                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__stat")
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "stats-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_physical")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_fire")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_toxic")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_arcane")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_frost")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_lightning")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_holy")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_shadow")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_chaos")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_nature")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "stats-row",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stat_type_bleed")
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "defensive-stats",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "stat-category-title",
                                                            children: [
                                                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__defence"),
                                                                "+"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: physicalDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: fireDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: toxicDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: arcaneDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: frostDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: lightningDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: holyDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: shadowDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: chaosDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: natureDamageReduction
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "stats-row",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                children: bleedDamageReduction
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "abilities-and-passives",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h5", {
                                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__abilities_header")
                                                }),
                                                abilityDescriptionsDom
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "runprep-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            disabled: playerLoadoutOperationInProgress,
                                            className: "affirmative-button start-btn",
                                            onClick: ()=>{
                                                Game.Rewards.PreGame();
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__start_run_button")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            disabled: playerLoadoutOperationInProgress,
                                            className: "neutral-button back-btn",
                                            onClick: ()=>{
                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loadout_menu__back_to_main_menu_button")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




parcelRequire("acw62");




const $f25666371afd2617$export$418c8281873ce7ff = ()=>{
    const { message: errorMessage , reason: reason  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$b8b34d3739f5d143));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "full-screen-error",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("connection_error__oof")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: errorMessage
            }),
            reason !== "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("connection_error__error_reason"),
                    ": ",
                    reason
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "destructive-button",
                style: {
                    fontSize: "24px",
                    padding: "0 20px",
                    margin: "0"
                },
                onClick: ()=>{
                    (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__back_to_main_menu_button")
            })
        ]
    });
};



parcelRequire("acw62");


const $42e89473d4bc79a2$export$5987dceff545a7f9 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "vendors-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "vendors-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("vendors__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("vendors__coming_soon")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("vendors__back_to_main_menu_button")
                })
            ]
        })
    });
};



parcelRequire("acw62");


const $f243e0e2aecc75d8$export$fa86afedc77126db = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "rankings-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "rankings-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("rankings__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("rankings__coming_soon")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__back_to_main_menu_button")
                })
            ]
        })
    });
};



parcelRequire("acw62");



const $8f779959bfcd045b$export$6665614bc5d690f6 = ()=>{
    const loadingState = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$95c23f336a305d72));
    const { progress: progress  } = loadingState;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "loading-bar",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "loading-bar-progress",
                style: {
                    width: `${progress}%`
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "loading-bar-text",
                children: [
                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__loading_bar_text"),
                    ": ",
                    progress,
                    "%"
                ]
            })
        ]
    });
};



parcelRequire("acw62");





const $c43c1805e4c055ed$export$6c1870f4a8d858a7 = ()=>{
    const { message: errorMessage  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$741e7d002666f097));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "user-identity-error",
        style: {
            pointerEvents: "all"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "user-identity-error-panel",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__identity_error_title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "affirmative-button",
                    onClick: ()=>{
                        window.history.replaceState({}, document.title, "/");
                        setTimeout(()=>{
                            (0, $bc8c2d9d797d9b02$export$34a3032bf337a702)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken);
                            (0, $bc8c2d9d797d9b02$export$34a3032bf337a702)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
                            (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
                        });
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__back_to_main_menu_button")
                })
            ]
        })
    });
};



parcelRequire("acw62");



var $7e80a23966bd0a02$exports = {};

$7e80a23966bd0a02$exports = new URL((parcelRequire("27Lyk")).resolve("02oa6"), import.meta.url).toString();










const $8d838ee681b82e8b$export$8cec688109811753 = ()=>{
    const { userType: userType  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const { show: showYouDiedPanel , loading: youDiedPanelLoading  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: playerHasExtracted  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const { items: items  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1796ef2d8b76e06c));
    const { loadout: loadout  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad));
    const { killerName: killerName , runDuration: runDuration , goldLost: goldLost  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    // youDiedPanelLoading = true;
    // console.warn('Items looted on run in YouDied Panel:', items);
    const weaponSlotOne = loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : loadout.weaponOne === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: false,
        showInsuredLock: false,
        disableHover: true
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{},
        itemId: loadout.weaponOne,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: false,
        showLeftClickEquipPrompt: false,
        showInsuredLock: false,
        disableHover: true
    });
    const weaponSlotTwo = loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : loadout.weaponTwo === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: false,
        showInsuredLock: false,
        disableHover: true
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{},
        itemId: loadout.weaponTwo,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
        slotSize: "large",
        selected: false,
        showLeftClickEquipPrompt: false,
        showInsuredLock: false,
        disableHover: true
    });
    const gearSlotOne = loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearOne ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : loadout.gearOne === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: false,
        showInsuredLock: false,
        disableHover: true
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{},
        itemId: loadout.gearOne,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: false,
        showLeftClickEquipPrompt: false,
        showInsuredLock: false,
        disableHover: true
    });
    const gearSlotTwo = loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearTwo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : loadout.gearTwo === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: false,
        showInsuredLock: false,
        disableHover: true
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{},
        itemId: loadout.gearTwo,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: false,
        showLeftClickEquipPrompt: false,
        showInsuredLock: false,
        disableHover: true
    });
    const gearSlotThree = loadout.insuredSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).GearThree ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : loadout.gearThree === -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: false,
        showInsuredLock: false,
        disableHover: true
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{},
        itemId: loadout.gearThree,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: false,
        showLeftClickEquipPrompt: false,
        showInsuredLock: false,
        disableHover: true
    });
    const lowercaseFirstLetter = (str)=>{
        return str.charAt(0).toLowerCase() + str.slice(1);
    };
    // TODO: hacky way to get the insured item in the loadout
    // @ts-ignore
    const insuredItemInLoadout = loadout[lowercaseFirstLetter((0, $102fc1000c26cf91$export$7369a5563924ac4)[loadout.insuredSlot])];
    let insuredItemSlot;
    if (insuredItemInLoadout) insuredItemSlot = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
        OnClickFn: ()=>{},
        itemId: insuredItemInLoadout,
        slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
        slotSize: "large",
        selected: false,
        showLeftClickEquipPrompt: false,
        showInsuredLock: false,
        disableHover: true
    });
    else insuredItemSlot = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "nothing-insured",
        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__nothing_insured")
    });
    if (showYouDiedPanel === false || playerHasExtracted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "you-died-panel animate__animated animate__fadeInUpBig",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "socials-wrapper",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3a312f09392a0ae$export$8cdedda1c1b7bd5d), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7e80a23966bd0a02$exports))),
                            alt: "skull",
                            className: "left-skull"
                        }),
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__title"),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7e80a23966bd0a02$exports))),
                            alt: "skull",
                            className: "right-skull"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "middle-segment",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "left-stats",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "run-metric",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "metric-title",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__your_killer")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "metric-value",
                                            children: killerName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "run-metric",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "metric-title",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__survived_for")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "metric-value",
                                            children: runDuration
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "run-metric",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "metric-title",
                                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__gold_lost")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "metric-value",
                                            children: goldLost
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            draggable: "false",
                            className: "divider",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($06c12dbb02effcc3$exports))),
                            alt: "Divider"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "right-items-lost",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "youdied-loadout",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "lost-title",
                                        children: [
                                            "~ ",
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__weapons_lost"),
                                            " ~"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "weapons",
                                        children: [
                                            weaponSlotOne,
                                            weaponSlotTwo
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "lost-title",
                                        children: [
                                            "~ ",
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__gear_lost"),
                                            " ~"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "gear",
                                        children: [
                                            gearSlotOne,
                                            gearSlotTwo,
                                            gearSlotThree
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "insured-title",
                                        children: [
                                            "~ ",
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__insured_items"),
                                            " ~"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "insured-items",
                                        children: insuredItemSlot
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "lost-loot",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                            children: [
                                "~ ",
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__loot_lost"),
                                " ~"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                            items: items,
                            showLeftClickEquipPrompt: false,
                            OnSlotClickFn: ()=>{}
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "actions",
                    children: [
                        userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "delete-acc-cta",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__delete_account_cta_less_aggressive")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            disabled: youDiedPanelLoading,
                            className: `neutral-button ${youDiedPanelLoading ? "loading animate__animated animate__jello animate__infinite" : ""}`,
                            onClick: ()=>{
                                if (youDiedPanelLoading) return;
                                (0, $9b9fb0750f8f8ccb$export$8b96a41f9ed15ff0)(true);
                                setTimeout(()=>{
                                    (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
                                }, 150);
                            },
                            children: youDiedPanelLoading ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__saving_your_run_button") : (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__back_to_main_menu_button")
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");



const $548eeacfcb94c781$export$fe46d4a10b67055 = ()=>{
    const { items: items  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$50ab1c01fc6ede55));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "kittest-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "kittest-header",
                    children: "UI Kit"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                    items: items,
                    OnSlotClickFn: (__itemId)=>{}
                })
            ]
        })
    });
};



parcelRequire("acw62");



const $4f5d987146aaddab$export$4586659ef7addab4 = ()=>{
    const { abandoningInProgress: abandoningInProgress  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$999d36e97dd00396));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "runinprogress-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "runinprogress-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("character_already_on_run_menu__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("character_already_on_run_menu__bolded_header")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("character_already_on_run_menu__paragraph_one")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("character_already_on_run_menu__paragraph_two")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "abandon-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "neutral-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("character_already_on_run_menu__back_to_main_menu_button")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            disabled: abandoningInProgress,
                            className: "abandon-btn destructive-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$745bc315e91cf00b)();
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("character_already_on_run_menu__abondon_run_button")
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");



const $ccae45590b480272$export$7ba4b7dd907360b3 = ()=>{
    const { show: playerHasDied  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: playerHasExtracted  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const { extractionProgress: progressAsPercentage  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$d78251c206367d5f));
    const shouldShowExtractionMeter = progressAsPercentage > 0 && progressAsPercentage < 100;
    if (shouldShowExtractionMeter === false || playerHasDied || playerHasExtracted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `extraction-bar animate__animated animate__infinite animate__fast ${progressAsPercentage > 85 ? "animate__flash" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "extraction-bar-progress",
                style: {
                    width: `${progressAsPercentage}%`
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "extraction-bar-text",
                children: [
                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("in_game__extracting"),
                    "... ",
                    progressAsPercentage,
                    "%"
                ]
            })
        ]
    });
};



parcelRequire("acw62");

const $5b8f7bdeee8b58f4$export$9d9df356b5b75a53 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "finding-match",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "finding-match-panel animate__animated animate__infinite animate__jello",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_transition__finding_match")
            })
        })
    });
};



parcelRequire("acw62");




const $12bf9c9483dd9ed3$export$814a940fbc38873 = ()=>{
    const { spectatingPlayerName: spectatingPlayerName  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$23341af0bec1ee28));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "spectating animate__animated animate__fadeInUp",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                children: [
                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__spectating"),
                    " ",
                    spectatingPlayerName
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "neutral-button",
                onClick: ()=>{
                    (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
                },
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__back_to_main_menu_button")
            })
        ]
    });
};



parcelRequire("acw62");







const $a7dc62c5c9ef94b4$export$a9d4ef180e44b39a = ()=>{
    const { userType: userType  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const { show: playerHasDied  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: showExtractionSuccessfulpanel , loading: extractionSuccessulPanelIsLoading , runDuration: runDuration , goldLooted: goldLooted  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const { items: items  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1796ef2d8b76e06c));
    // extractionSuccessulPanelIsLoading = true;
    if (showExtractionSuccessfulpanel === false || playerHasDied) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "extraction-successful-panel animate__animated animate__fadeInUp",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "socials-wrapper",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3a312f09392a0ae$export$8cdedda1c1b7bd5d), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("extracted_menu__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "stats",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "run-metric",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "metric-title",
                                    children: [
                                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("extracted_menu__run_duration"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "metric-value",
                                    children: runDuration
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "run-metric",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "metric-title",
                                    children: [
                                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("extracted_menu__gold_looted"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "metric-value",
                                    children: goldLooted
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "loot-acquired",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                            children: [
                                "~ ",
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("extracted_menu__loot_acquired"),
                                " ~"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                            items: items,
                            showLeftClickEquipPrompt: false,
                            OnSlotClickFn: ()=>{}
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "actions",
                    children: [
                        userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "delete-acc-cta",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__delete_account_cta_less_aggressive")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            disabled: extractionSuccessulPanelIsLoading,
                            className: `neutral-button ${extractionSuccessulPanelIsLoading ? "loading animate__animated animate__jello animate__infinite" : ""}`,
                            onClick: ()=>{
                                if (extractionSuccessulPanelIsLoading) return;
                                (0, $9b9fb0750f8f8ccb$export$8b96a41f9ed15ff0)(true);
                                setTimeout(()=>{
                                    (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
                                }, 150);
                            },
                            children: extractionSuccessulPanelIsLoading ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__saving_your_run_button") : (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("death_menu__back_to_main_menu_button")
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");





const $96f60e91057049b4$export$481892a1a83a68a0 = ()=>{
    const { show: playerHasDied  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: playerHasExtracted  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const { timeRemainingInSeconds: timeRemainingInSeconds  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$c632688729fcb9a7));
    const maxTime = (0, $a9786bc83f165385$export$6890cbbf7baa7104).MAX_RUN_DURATION_IN_SECONDS;
    const friendlyTimeRemainingInSeconds = (0, $276f03d77ac4b507$export$3acfa4651e1e404d)(timeRemainingInSeconds, false);
    const percentageOfTimeRemaining = (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(Math.floor(timeRemainingInSeconds / maxTime * 100), 0, 100);
    const closeToExpiry = percentageOfTimeRemaining < 20;
    return percentageOfTimeRemaining === 0 || timeRemainingInSeconds === 0 || playerHasDied || playerHasExtracted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `extraction-time-remaining animate__animated animate__fadeInDown ${closeToExpiry ? " close-to-expiry" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: closeToExpiry ? "animate__animated animate__infinite animate__flash" : "",
                children: [
                    friendlyTimeRemainingInSeconds,
                    " ",
                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__time_left_to_extract")
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "animate__animated animate__infinite animate__slower animate__flash",
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__find_an_extraction_point")
            })
        ]
    });
};



parcelRequire("acw62");








const $f02d39bd1e5b4acc$export$59aca900590621cb = ()=>{
    const { show: playerHasDied  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: playerHasExtracted  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const activeWeaponSlot = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$e24e5ed97d5f3d42));
    const { loadout: loadout  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$75c5b2e5e05fcaad));
    const { weaponOne: weaponOne , weaponTwo: weaponTwo , gearOne: gearOne , gearTwo: gearTwo , gearThree: gearThree  } = loadout;
    const { weaponOneCooldown: weaponOneCooldown , weaponTwoCooldown: weaponTwoCooldown , gearOneCooldown: gearOneCooldown , gearTwoCooldown: gearTwoCooldown , gearThreeCooldown: gearThreeCooldown  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$4e3ba682b8458616));
    const { gearOneCharges: gearOneCharges , gearTwoCharges: gearTwoCharges , gearThreeCharges: gearThreeCharges  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$e98a8743fbd387b9));
    const gearOneIsPassive = gearOne === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? true : (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearOne).itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).PassiveGear;
    const gearTwoIsPassive = gearTwo === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? true : (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearTwo).itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).PassiveGear;
    const gearThreeIsPassive = gearThree === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? true : (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearThree).itemType === (0, $faa1b3449016497b$export$1fc8f52ad1810e52).PassiveGear;
    const weaponOneIsOnCooldown = weaponOneCooldown < 100;
    const weaponTwoIsOnCooldown = weaponTwoCooldown < 100;
    const gearOneIsOnCooldown = gearOneCooldown < 100;
    const gearTwoIsOnCooldown = gearTwoCooldown < 100;
    const gearThreeIsOnCooldown = gearThreeCooldown < 100;
    // console.log(gearOneCharges, gearTwoCharges, gearThreeCharges);
    const gearOneHasInfiniteCharges = gearOneCharges === -1;
    const gearTwoHasInfiniteCharges = gearTwoCharges === -1;
    const gearThreeHasInfiniteCharges = gearThreeCharges === -1;
    const weaponOneHasLongCooldown = weaponOne === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? false : (0, $0acc22698d702be9$export$f96416c73a613aba)(weaponOne).cooldownInSeconds > 0.75;
    const weaponTwoHasLongCooldown = weaponTwo === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? false : (0, $0acc22698d702be9$export$f96416c73a613aba)(weaponTwo).cooldownInSeconds > 0.75;
    const gearOneMaxCharges = gearOne === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? 0 : (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearOne).activeAbility.abilityCharges;
    const gearTwoMaxCharges = gearTwo === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? 0 : (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearTwo).activeAbility.abilityCharges;
    const gearThreeMaxCharges = gearThree === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? 0 : (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(gearThree).activeAbility.abilityCharges;
    return playerHasDied || playerHasExtracted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "gear-and-weapon-hud animate__animated animate__slideInUp",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "weapon-slots",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `weapon-one ${weaponOneIsOnCooldown ? "on-cooldown" : ""} ${activeWeaponSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne ? "active" : "inactive"}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "hotkey hotkey-1",
                                children: "1"
                            }),
                            weaponOne === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
                                slotSize: "large"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: weaponOne,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
                                OnClickFn: ()=>{},
                                slotSize: "large"
                            }),
                            activeWeaponSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponOne && weaponOneIsOnCooldown && weaponOneHasLongCooldown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "cooldown",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__cooldown"),
                                            "..."
                                        ]
                                    }),
                                    weaponOneCooldown,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `weapon-two ${weaponTwoIsOnCooldown ? "on-cooldown" : ""} ${activeWeaponSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo ? "active" : "inactive"}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "hotkey hotkey-2",
                                children: "2"
                            }),
                            weaponTwo === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
                                slotSize: "large"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: weaponTwo,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
                                OnClickFn: ()=>{},
                                slotSize: "large"
                            }),
                            activeWeaponSlot === (0, $102fc1000c26cf91$export$7369a5563924ac4).WeaponTwo && weaponTwoIsOnCooldown && weaponTwoHasLongCooldown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "cooldown",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__cooldown"),
                                            "..."
                                        ]
                                    }),
                                    weaponTwoCooldown,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "gear-slots",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `hud-gear-slot gear-slot-one ${gearOneIsOnCooldown ? "on-cooldown" : ""} ${gearOneCharges === 0 ? "on-cooldown" : ""}`,
                        onClick: ()=>{
                            console.log("Clicked gear hud #1");
                            Game.Input.clickedGearOneThisFrame = true;
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "hotkey hotkey-q",
                                children: gearOne !== (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None && "3"
                            }),
                            gearOne === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: gearOne,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
                                OnClickFn: ()=>{}
                            }),
                            gearOneIsOnCooldown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "cooldown",
                                children: [
                                    gearOneCooldown,
                                    "%"
                                ]
                            }),
                            gearOneIsOnCooldown === false && gearOneHasInfiniteCharges === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "charges",
                                children: [
                                    gearOneCharges,
                                    "/",
                                    gearOneMaxCharges
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `hud-gear-slot gear-slot-two ${gearTwoIsOnCooldown ? "on-cooldown" : ""} ${gearTwoCharges === 0 ? "on-cooldown" : ""}`,
                        onClick: ()=>{
                            console.log("Clicked gear hud #2");
                            Game.Input.clickedGearTwoThisFrame = true;
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "hotkey hotkey-e",
                                children: gearTwo !== (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None && "4"
                            }),
                            gearTwo === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: gearTwo,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
                                OnClickFn: ()=>{}
                            }),
                            gearTwoIsOnCooldown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "cooldown",
                                children: [
                                    gearTwoCooldown,
                                    "%"
                                ]
                            }),
                            gearTwoIsOnCooldown === false && gearTwoHasInfiniteCharges === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "charges",
                                children: [
                                    gearTwoCharges,
                                    "/",
                                    gearTwoMaxCharges
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `hud-gear-slot gear-slot-three ${gearThreeIsOnCooldown ? "on-cooldown" : ""} ${gearThreeCharges === 0 ? "on-cooldown" : ""}`,
                        onClick: ()=>{
                            console.log("Clicked gear hud #3");
                            Game.Input.clickedGearThreeThisFrame = true;
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "hotkey hotkey-space",
                                children: gearThree !== (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None && "5"
                            }),
                            gearThree === (0, $faa1b3449016497b$export$6d08773d2e66f8f2).None ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba56ec254e4e26c8$export$b081dc7b28c9b0a8), {
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: gearThree,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
                                OnClickFn: ()=>{}
                            }),
                            gearThreeIsOnCooldown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "cooldown",
                                children: [
                                    gearThreeCooldown,
                                    "%"
                                ]
                            }),
                            gearThreeIsOnCooldown === false && gearThreeHasInfiniteCharges === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "charges",
                                children: [
                                    gearThreeCharges,
                                    "/",
                                    gearThreeMaxCharges
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");



const $5d076d0942235782$export$bff664fe2c092334 = ()=>{
    const { loadingPlayerIdentity: loadingPlayerIdentity , userDetails: userDetails  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const { username: currentUsername  } = userDetails;
    const [username, setUsername] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $9b9fb0750f8f8ccb$export$f166ba1253c74e5f));
    const onUsernameInputChanged = (e)=>{
        // console.log("Username input changed", e.target.value);
        setUsername(e.target.value);
    };
    const errorNodes = [];
    if (username.length === 0) errorNodes.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__cant_be_empty_error")
    }));
    else if (username.length >= 20) errorNodes.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__too_long_error")
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "change-username-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "change-username-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__header")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "change-username-form",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "label",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__current_prompt")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "current",
                            children: currentUsername
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "label",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__enter_new")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: "change-username-input",
                            type: "text",
                            value: username,
                            onChange: onUsernameInputChanged,
                            disabled: loadingPlayerIdentity,
                            placeholder: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__enter_new")
                        }),
                        errorNodes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "errors",
                            children: errorNodes
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "change-username-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "neutral-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__back")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            disabled: loadingPlayerIdentity || errorNodes.length > 0,
                            className: "change-username-btn affirmative-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$2592a4af2dd89e62)(username);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__save")
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");





const $d1265088cfe66ec0$export$3cdec2bba15e3523 = ()=>{
    const stats = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$37c83b4c63c3c87f));
    const { userType: userType  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    console.log("userType", userType);
    let { commonItemsLooted: commonItemsLooted , distanceTravelled: distanceTravelled , epicItemsLooted: epicItemsLooted , failedExtractions: failedExtractions , goldLooted: goldLooted , itemsLooted: itemsLooted , legendaryItemsLooted: legendaryItemsLooted , npcKills: npcKills , playerKills: playerKills , rareItemsLooted: rareItemsLooted , runsEmbarkedOn: runsEmbarkedOn , successfulExtractions: successfulExtractions , timeSpentOnRunsInSeconds: timeSpentOnRunsInSeconds , uncommonItemsLooted: uncommonItemsLooted , bossesKilled: bossesKilled , goldLost: goldLost , itemsLost: itemsLost  } = stats;
    if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) {
        commonItemsLooted = Math.floor(Math.random() * 100);
        distanceTravelled = Math.floor(Math.random() * 100);
        epicItemsLooted = Math.floor(Math.random() * 100);
        failedExtractions = Math.floor(Math.random() * 100);
        goldLooted = Math.floor(Math.random() * 100);
        itemsLooted = Math.floor(Math.random() * 100);
        legendaryItemsLooted = Math.floor(Math.random() * 100);
        npcKills = Math.floor(Math.random() * 100);
        playerKills = Math.floor(Math.random() * 100);
        rareItemsLooted = Math.floor(Math.random() * 100);
        runsEmbarkedOn = Math.floor(Math.random() * 100);
        successfulExtractions = Math.floor(Math.random() * 100);
        timeSpentOnRunsInSeconds = Math.floor(Math.random() * 100);
        uncommonItemsLooted = Math.floor(Math.random() * 100);
        bossesKilled = Math.floor(Math.random() * 100);
        goldLost = Math.floor(Math.random() * 100);
        itemsLost = Math.floor(Math.random() * 100);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "stats-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "stats-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__header")
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "overlay",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "delete-acc-cta",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__delete_account_cta_2")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "affirmative-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Register);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__register")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "stats-container",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: "."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__global_rank")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: (0, $276f03d77ac4b507$export$67128de51a301bf0)(timeSpentOnRunsInSeconds)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__time_played")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "stat-value",
                                    children: [
                                        runsEmbarkedOn === 0 ? 0 : Math.floor(successfulExtractions / runsEmbarkedOn * 100),
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__run_success_percentage")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: runsEmbarkedOn
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__runs")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: successfulExtractions
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__successful_runs")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: failedExtractions
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__failed_runs")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: distanceTravelled
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__distanced_travelled")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: npcKills
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__npc_kills")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: bossesKilled
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__boss_kills")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: playerKills
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__player_kills")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: itemsLooted
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__items_looted")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: goldLooted
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__gold_looted")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: goldLost
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__gold_lost_to_deaths")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: itemsLost
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__items_lost_to_deaths")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: commonItemsLooted
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__common_items_looted")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: uncommonItemsLooted
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__uncommon_items_looted")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: rareItemsLooted
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__rare_items_looted")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: epicItemsLooted
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__epic_items_looted")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "stat",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-value",
                                    children: legendaryItemsLooted
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "stat-label",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__legendary_items_looted")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};



parcelRequire("acw62");






const $2c5a036284e26556$var$getQuantityOfItems = (items)=>{
    let q = 0;
    for (const quantity of Object.values(items))if (quantity > 0) q++;
    return q;
};
const $2c5a036284e26556$var$getQuantityOfItemsOfRarity = (rarity, items)=>{
    let q = 0;
    for (const [itemID, quantity] of Object.entries(items)){
        if (quantity === 0) continue;
        const itemRarity = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(parseInt(itemID)).itemRarity;
        if (itemRarity === rarity) q++;
    }
    return q;
};
const $2c5a036284e26556$export$a033e390692f359f = ()=>{
    const { userType: userType  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const { items: allItemsInStash  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$50ab1c01fc6ede55));
    const justWeaponsFromStash = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$34e323431127bf02));
    const justGearFromStash = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$e478d6af9991afc6));
    const justVendorTrashFromStash = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$5bfac95b6ca4eca4));
    const justCollectorsItemsFromStash = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$6f811727066fa9af));
    const numberOfWeapons = $2c5a036284e26556$var$getQuantityOfItems(justWeaponsFromStash);
    const numberOfGear = $2c5a036284e26556$var$getQuantityOfItems(justGearFromStash);
    const numberOfVendorTrash = $2c5a036284e26556$var$getQuantityOfItems(justVendorTrashFromStash);
    const numberOfCollectorsItems = $2c5a036284e26556$var$getQuantityOfItems(justCollectorsItemsFromStash);
    const quantityOfCommonItems = $2c5a036284e26556$var$getQuantityOfItemsOfRarity((0, $faa1b3449016497b$export$d2ffa9ea74cc769f).Common, allItemsInStash);
    const quantityOfUncommonItems = $2c5a036284e26556$var$getQuantityOfItemsOfRarity((0, $faa1b3449016497b$export$d2ffa9ea74cc769f).Uncommon, allItemsInStash);
    const quantityOfRareItems = $2c5a036284e26556$var$getQuantityOfItemsOfRarity((0, $faa1b3449016497b$export$d2ffa9ea74cc769f).Rare, allItemsInStash);
    const quantityOfEpicItems = $2c5a036284e26556$var$getQuantityOfItemsOfRarity((0, $faa1b3449016497b$export$d2ffa9ea74cc769f).Epic, allItemsInStash);
    const quantityOfLegendaryItems = $2c5a036284e26556$var$getQuantityOfItemsOfRarity((0, $faa1b3449016497b$export$d2ffa9ea74cc769f).Legendary, allItemsInStash);
    const quantityOfAllObtainedItems = quantityOfCommonItems + quantityOfUncommonItems + quantityOfRareItems + quantityOfEpicItems + quantityOfLegendaryItems;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "inventory-panel animate__animated animate__fadeInUp animate__faster",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "inventory-header",
                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__header")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "totals",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "all-total",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "rarity-total",
                            children: [
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__total_items_discovered"),
                                ": ",
                                quantityOfAllObtainedItems,
                                " / ",
                                (0, $faa1b3449016497b$export$ef64e4a820e715e1)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rarity-totals",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rarity-total",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "common",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_rarity__common")
                                    }),
                                    " ",
                                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                    ":",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    quantityOfCommonItems,
                                    " / ",
                                    (0, $faa1b3449016497b$export$a5b55c8481c9031f)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rarity-total",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "uncommon",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_rarity__uncommon")
                                    }),
                                    " ",
                                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                    ":",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    quantityOfUncommonItems,
                                    " / ",
                                    (0, $faa1b3449016497b$export$66eee877b246b932)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rarity-total",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "rare",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_rarity__rare")
                                    }),
                                    " ",
                                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                    ":",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    quantityOfRareItems,
                                    " / ",
                                    (0, $faa1b3449016497b$export$8d910d172896bc9f)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rarity-total",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "epic",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_rarity__epic")
                                    }),
                                    " ",
                                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                    ":",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    quantityOfEpicItems,
                                    " / ",
                                    (0, $faa1b3449016497b$export$449f95b1165adf6e)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rarity-total",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "legendary",
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_rarity__legendary")
                                    }),
                                    " ",
                                    (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                    ":",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    quantityOfLegendaryItems,
                                    " / ",
                                    (0, $faa1b3449016497b$export$92aee9933415bb9b)
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "items",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "left-col",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "inventory-contents weapons",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "item-category-title",
                                        children: [
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__weapons"),
                                            " ",
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                            ": ",
                                            numberOfWeapons,
                                            "/",
                                            (0, $faa1b3449016497b$export$86ba917eb87cda3c)()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                                        OnSlotClickFn: ()=>{},
                                        items: justWeaponsFromStash
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "inventory-contents gear",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "item-category-title",
                                        children: [
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__gear"),
                                            " ",
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                            ": ",
                                            numberOfGear,
                                            "/",
                                            (0, $faa1b3449016497b$export$6978f0e6036e3b20)()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                                        OnSlotClickFn: ()=>{},
                                        items: justGearFromStash
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "right-col",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "inventory-contents vendor-trash",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "item-category-title",
                                        children: [
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__vendor_items"),
                                            " ",
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                            ": ",
                                            numberOfVendorTrash,
                                            "/",
                                            (0, $faa1b3449016497b$export$ca5102cbd15a68f5)()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                                        OnSlotClickFn: ()=>{},
                                        items: justVendorTrashFromStash
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "inventory-contents collectors-items",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "item-category-title",
                                        children: [
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__collectors_items"),
                                            " ",
                                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu_stash__discovered"),
                                            ": ",
                                            numberOfCollectorsItems,
                                            "/",
                                            (0, $faa1b3449016497b$export$a03459053fefb51d)()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                                        OnSlotClickFn: ()=>{},
                                        items: justCollectorsItemsFromStash
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bottom-actions",
                children: [
                    userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "delete-acc-cta",
                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__delete_account_cta_less_aggressive")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "neutral-button",
                        onClick: ()=>{
                            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                        },
                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__back")
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");







const $1e565658c851c7a5$export$6b49c872b2198970 = ()=>{
    const tooltipContainer = document.getElementById("tooltip-container");
    const { show: playerHasDied  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: playerHasExtracted  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const { items: items , showPanel: showPanel , itemContainerId: itemContainerId , itemContainerName: itemContainerName  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$923d88b3f72a7929));
    const itemContainerNameTranslated = itemContainerName === "Loot Chest" ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_container__loot_chest") : itemContainerName === "Loot Drop" ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("item_container__loot_drop") : itemContainerName;
    const lootItem = (itemId)=>{
        console.log(`Player clicked to loot item! ${(0, $faa1b3449016497b$export$6d08773d2e66f8f2)[itemId]} out of container ${itemContainerId}`);
        Game.LootItem(itemContainerId, itemId);
    };
    if (showPanel === false || playerHasDied || playerHasExtracted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "item-container-panel animate__animated animate__slideInLeft animate__faster",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "loot",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        "data-tooltip-id": "container-name-tooltip",
                        "data-tooltip-content": itemContainerNameTranslated,
                        children: itemContainerNameTranslated
                    }),
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                        id: "container-name-tooltip",
                        style: {
                            fontSize: "32px"
                        }
                    }), tooltipContainer),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                        items: items,
                        showLeftClickEquipPrompt: false,
                        showLeftClickLootPrompt: true,
                        OnSlotClickFn: lootItem
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$ed7d33d6afbe02b1)();
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__looted_container_close")
                })
            })
        ]
    });
};



parcelRequire("acw62");





var $547973eb5911c591$exports = {};

$547973eb5911c591$exports = new URL((parcelRequire("27Lyk")).resolve("aAVOp"), import.meta.url).toString();


const $a6baec1e346cf26a$export$7fd0d3064e7706e1 = ()=>{
    const { show: playerHasDied  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: playerHasExtracted  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const { items: items , showInventoryPanel: showInventoryPanel  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1796ef2d8b76e06c));
    if (showInventoryPanel === false || playerHasDied || playerHasExtracted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "in-run-inventory-panel animate__animated animate__slideInLeft animate__faster",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "your-inventory",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                    children: [
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__your_inventory_header"),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "([i] ",
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__your_inventory_hide"),
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82a27a6c8d8545b3$export$ed8671f612970784), {
                    items: items,
                    showLeftClickEquipPrompt: false,
                    showLeftClickLootPrompt: false,
                    showYouMustExtractPrompt: true,
                    OnSlotClickFn: ()=>{}
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "extraction-notification",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($547973eb5911c591$exports))),
                            alt: "Extraction Preview Hand",
                            className: "extraction-pointer animate__animated animate__jello animate__infinite"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($68ba9b00e5b669e3$exports))),
                            alt: "Extraction Preview",
                            className: "extraction-preview"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__inventory_extract_prompt")
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");




const $167fb719395e2bc8$export$1f24e401d18c8eaf = ()=>{
    const itemOptions = (0, $faa1b3449016497b$export$59e95ec639a00e0)();
    const [selectedItem, setSelectedItem] = (0, $acw62.useState)((0, $faa1b3449016497b$export$6d08773d2e66f8f2).AG_AmuletOfCursedFate);
    console.log("itemOptions", itemOptions);
    const onItemChanged = (event)=>{
        console.log("onItemChanged", event.target.value);
        setSelectedItem(parseInt(event.target.value));
    };
    const itemOptionsDom = itemOptions.map((item)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
            value: item,
            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)((0, $faa1b3449016497b$export$dc0c4ec5c1198760)(item).name)
        }, item);
    });
    const selectedItemConfig = (0, $faa1b3449016497b$export$dc0c4ec5c1198760)(selectedItem);
    const { itemId: itemId , itemType: itemType , itemRarity: itemRarity , maxItemQuantityPerRoll: maxItemQuantityPerRoll  } = selectedItemConfig;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "item-test-panel animate__animated animate__fadeInUp animate__faster",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "item-test-header",
                children: "Item Test"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "item-test-section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                        className: "item-test-select",
                        value: selectedItem,
                        onChange: onItemChanged,
                        children: itemOptionsDom
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "selected-item-details",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "selected-item-details-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "selected-item-details-label",
                                        children: "itemId: "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "selected-item-details-value",
                                        children: [
                                            " ",
                                            "\xa0",
                                            itemId,
                                            " (",
                                            "-->",
                                            " ",
                                            (0, $faa1b3449016497b$export$6d08773d2e66f8f2)[itemId],
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "selected-item-details-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "selected-item-details-label",
                                        children: "itemType: "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "selected-item-details-value",
                                        children: [
                                            " ",
                                            "\xa0",
                                            itemType,
                                            " (",
                                            "-->",
                                            " ",
                                            (0, $faa1b3449016497b$export$1fc8f52ad1810e52)[itemType],
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "selected-item-details-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "selected-item-details-label",
                                        children: "itemRarity: "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "selected-item-details-value",
                                        children: [
                                            " ",
                                            "\xa0",
                                            itemRarity,
                                            " (",
                                            "-->",
                                            " ",
                                            (0, $faa1b3449016497b$export$d2ffa9ea74cc769f)[itemRarity],
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "selected-item-details-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "selected-item-details-label",
                                        children: "maxItemQuantityPerRoll: "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "selected-item-details-value",
                                        children: [
                                            " \xa0",
                                            maxItemQuantityPerRoll
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "selected-item-slots",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                slotSize: "large",
                                itemId: selectedItemConfig.itemId,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
                                quantity: 1,
                                selected: true,
                                showInsuredLock: false,
                                OnClickFn: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: selectedItemConfig.itemId,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
                                quantity: 1,
                                selected: false,
                                showInsuredLock: false,
                                showYouMustExtractPrompt: true,
                                OnClickFn: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: selectedItemConfig.itemId,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Gear,
                                quantity: 1,
                                selected: false,
                                showInsuredLock: true,
                                OnClickFn: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                slotSize: "large",
                                itemId: selectedItemConfig.itemId,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
                                quantity: 1,
                                selected: true,
                                showInsuredLock: false,
                                OnClickFn: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: selectedItemConfig.itemId,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
                                quantity: 1,
                                selected: false,
                                showInsuredLock: false,
                                OnClickFn: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3a351f034b35e0$export$c2b08f0dad0547e0), {
                                itemId: selectedItemConfig.itemId,
                                slotVisualType: (0, $fa3a351f034b35e0$export$d2a4afdad40c5757).Weapon,
                                quantity: 1,
                                selected: false,
                                showInsuredLock: true,
                                OnClickFn: ()=>{}
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "item-stats",
                children: (0, $faa1b3449016497b$export$797b6866e8905776)((0, $faa1b3449016497b$export$6df8f823269939c6).DamageBoost, (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Arcane, [
                    selectedItem
                ])
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "item-test-actions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: "Back To Menu"
                })
            })
        ]
    });
};



parcelRequire("acw62");





var $1d62da80ed7163b3$exports = {};

$1d62da80ed7163b3$exports = new URL((parcelRequire("27Lyk")).resolve("coZR4"), import.meta.url).toString();


const $1daeb039ce6e9eb3$export$f20c3e4eca527526 = ()=>{
    const leaderboardState = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$d67f9a35d18eb345));
    const { show: show , entries: entries  } = leaderboardState;
    const tooltipContainer = document.getElementById("tooltip-container");
    const leaderboardRows = entries.map((entry, __index)=>{
        const { r: r , un: un , pk: pk , i: i , npck: npck , reg: reg  } = entry;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "leaderboard-row",
            children: [
                reg && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1d62da80ed7163b3$exports))),
                    alt: "registered-user-icon",
                    className: "registered-user-icon"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rank",
                    children: [
                        "#",
                        r,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "username",
                    "data-tooltip-id": `username-tooltip-${un}`,
                    children: [
                        un,
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b6649b19c980ca22$export$28c660c63b792dea), {
                            id: `username-tooltip-${un}`,
                            style: {
                                fontSize: "18px"
                            }
                        }), tooltipContainer)
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "player-kills",
                    children: pk
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "items-looted",
                    children: i
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "npc-kills",
                    children: npck
                })
            ]
        }, `un${Math.random() * 3000}`);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "top-right-hud animate__animated animate__slideInRight",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `leaderboard ${show ? "" : "hidden"}`,
                children: [
                    show && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "leaderboard-title",
                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__leaderboard_current_world")
                    }),
                    show && leaderboardRows.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "leaderboard-legend",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "rank"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "username"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "player-kills",
                                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("leaderboard__player_kills")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "items-looted",
                                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("leaderboard__loot")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "npc-kills",
                                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("leaderboard__npc_kills")
                            })
                        ]
                    }),
                    show && leaderboardRows,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "leaderboard-close",
                        children: [
                            "[ ",
                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("hotkey_toggle_leaderboard"),
                            " ] ",
                            show ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__leaderboard_hide") : (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__leaderboard_show"),
                            " ",
                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__leaderboard")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "stats-preview"
            })
        ]
    });
};



parcelRequire("acw62");


var $dd41187467184f8c$exports = {};

$dd41187467184f8c$exports = new URL((parcelRequire("27Lyk")).resolve("58qUf"), import.meta.url).toString();



const $84675554534cc87a$export$c9176e726496162e = ()=>{
    const quantityOfItemsInRunInventory = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$20aa5718ceb0ad82));
    const { showInventoryPanel: showInventoryPanel  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1796ef2d8b76e06c));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bottom-left-hud animate__animated animate__slideInLeft",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                pointerEvents: "all",
                cursor: "pointer"
            },
            className: "bottom-left-inventory",
            onClick: ()=>{
                (0, $9b9fb0750f8f8ccb$export$8a4175547626753f)();
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "inventory-sprite",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dd41187467184f8c$exports))),
                            alt: "Inventory"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "item-quantity",
                            children: quantityOfItemsInRunInventory
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "inventory-texts",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "inventory-text",
                        children: [
                            "[ ",
                            (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("hotkey_open_inventory"),
                            " ] ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: showInventoryPanel === false && (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("game_hud__inventory_hud")
                            })
                        ]
                    })
                })
            ]
        })
    });
};



parcelRequire("acw62");



const $c828c2af32485839$export$60be593cf9a5a44b = ()=>{
    const { message: message , title: title  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$72c737a0a43ed66b));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "matchmaking-error-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: message
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "abandon-actions",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "neutral-button",
                        onClick: ()=>{
                            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                        },
                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__back_to_main_menu_button")
                    })
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");


var $b4df27835c0f80ff$exports = {};

$b4df27835c0f80ff$exports = new URL((parcelRequire("27Lyk")).resolve("1Q189"), import.meta.url).toString();



const $67644d1becb2832a$export$25cf97d095b3336a = ()=>{
    const latestPing = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$89d88943573cfd68));
    const pingIsBad = latestPing > 200;
    const [isFullscreen, setIsFullscreen] = (0, $acw62.useState)(false);
    const currentUrl = window.location != window.parent.location ? document.referrer : document.location.href;
    const isOnCrazygames = currentUrl.includes("crazygames.com") || OriginalLocation?.includes("crazygames");
    // latestPing = 666;
    // pingIsBad = true;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "top-left-hud animate__animated animate__slideInLeft",
        children: [
            isOnCrazygames === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: `fullscreen-button ${isFullscreen ? "is-full-screen neutral-button" : "affirmative-button"}`,
                onClick: ()=>{
                    setIsFullscreen(!isFullscreen);
                    Game.Input.ToggleFullScreen();
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: isFullscreen ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("exit_fullscreen") : (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("fullscreen")
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ping",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4df27835c0f80ff$exports))),
                        alt: "good ping",
                        className: `ping-image ${pingIsBad ? "bad" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            pingIsBad ? "⚠️" : "",
                            " ",
                            latestPing,
                            "ms ",
                            pingIsBad ? "⚠️" : "",
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};


/* eslint-disable jsx-a11y/anchor-has-content */ 
parcelRequire("acw62");


const $56c7250855afd2cf$export$df5ebfc630cfdc36 = ()=>{
    const { shown: shown , regionName: regionName  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$c220fc29a809546f));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `region-pop-up animate__animated ${shown ? "animate__fadeIn" : "animate__fadeOut"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: regionName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "underline"
            })
        ]
    });
};


/* eslint-disable jsx-a11y/anchor-has-content */ 

var $acw62 = parcelRequire("acw62");
const $8bb3e47e0b720393$export$95d89f9f2dc93b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
    console.log("Render of right container called!");
    Game.Rewards.ShowInGameRight();
    // const screenHeight = window.innerHeight;
    // const shouldUseSmallContainers = screenHeight <= 600;
    const styles = {
        border: window.location.href.includes("localhost") ? "1px solid red" : "none",
        display: "flex",
        width: "160px",
        height: "600px"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "right-container",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "right-container-inner",
            id: "pvpz-io_160x600_2",
            style: styles
        })
    });
}, (__prepProps, __nextProps)=>true);


/* eslint-disable jsx-a11y/anchor-has-content */ 

var $acw62 = parcelRequire("acw62");
const $3fbf8a706e44f6f2$export$77468e507dd9c979 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
    console.log("Render of left container called!");
    Game.Rewards.ShowInGameLeft();
    // const screenHeight = window.innerHeight;
    // const shouldUseSmallContainers = screenHeight <= 600;
    const styles = {
        border: window.location.href.includes("localhost") ? "1px solid red" : "none",
        display: "flex",
        width: "160px",
        height: "600px"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "left-container",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "left-container-inner",
            id: "pvpz-io_160x600_1",
            style: styles
        })
    });
}, (__prepProps, __nextProps)=>true);


/* eslint-disable jsx-a11y/anchor-has-content */ 

var $acw62 = parcelRequire("acw62");
const $9acb122d31ff87f5$export$aaaa284fbfa7c5e7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
    console.log("Render of main menu left container called!");
    Game.Rewards.ShowMainMenuLeft();
    const screenHeight = window.innerHeight;
    const shouldUseSmallContainers = screenHeight <= 600;
    const styles = {
        border: window.location.href.includes("localhost") ? "1px solid red" : "none",
        display: "flex",
        width: shouldUseSmallContainers ? "250px" : "160px",
        height: shouldUseSmallContainers ? "250px" : "600px",
        position: "relative",
        top: shouldUseSmallContainers ? "75px" : "auto"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "main-menu-left-container",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "main-menu-left-container-inner",
            id: "pvpz-io_160x600_3",
            style: styles
        })
    });
}, (__prepProps, __nextProps)=>true);


/* eslint-disable jsx-a11y/anchor-has-content */ 

var $acw62 = parcelRequire("acw62");
const $f4fc77b936f0afc6$export$ac8c8d82cb85c6e0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
    console.log("Render of main menu right container called!");
    Game.Rewards.ShowMainMenuRight();
    const screenHeight = window.innerHeight;
    const shouldUseSmallContainers = screenHeight <= 600;
    const styles = {
        border: window.location.href.includes("localhost") ? "1px solid red" : "none",
        display: "flex",
        width: shouldUseSmallContainers ? "250px" : "160px",
        height: shouldUseSmallContainers ? "250px" : "600px",
        position: "relative",
        top: shouldUseSmallContainers ? "75px" : "auto"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "main-menu-right-container",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "main-menu-right-container-inner",
            id: "pvpz-io_160x600_4",
            style: styles
        })
    });
}, (__prepProps, __nextProps)=>true);



parcelRequire("acw62");


const $4fe0f05341c36299$export$31512ee37400d4d3 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "partners-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "partners-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("main_menu__partners")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "partners-list",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://crazygames.com/",
                            target: "_blank",
                            title: "Crazy Games!",
                            rel: "noreferrer noopener",
                            children: "Crazy Games"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://kongregate.com/",
                            target: "_blank",
                            title: "Kongregate",
                            rel: "noreferrer noopener",
                            children: "Kongregate"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://addictinggames.com/",
                            target: "_blank",
                            title: "Addicting Games",
                            rel: "noreferrer noopener",
                            children: "Addicting Games"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://iogames.space/",
                            target: "_blank",
                            title: ".io Games Space!",
                            rel: "noreferrer noopener",
                            children: "iogames.space"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://silvergames.com/",
                            target: "_blank",
                            title: "Silver Games",
                            rel: "noreferrer noopener",
                            children: "Silver Games"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://kevin.games/",
                            target: "_blank",
                            title: "Kevin Games",
                            rel: "noreferrer noopener",
                            children: "Kevin Games"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__back_to_main_menu_button")
                })
            ]
        })
    });
};



parcelRequire("acw62");





const $081fc42f386d51f3$export$4011a43e3ea1594e = ()=>{
    const { events: events  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$80fa840cdc9361a9));
    const eventfeedDom = events.map((event)=>{
        let locationName = undefined;
        let middle = undefined;
        switch(event.type){
            case (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).Loot:
                locationName = Game.GetLocationNameFromXY(event.locationX, event.locationY);
                if (locationName === "Wilderness") middle = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__in_the");
                else middle = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__at");
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: "animate__animated animate__fadeOut",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "username",
                            children: event.username
                        }),
                        " ",
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__looted_a"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: (0, $faa1b3449016497b$export$d2ffa9ea74cc769f)[event.rarity].toLowerCase(),
                            children: [
                                " ",
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)((0, $faa1b3449016497b$export$d2ffa9ea74cc769f)[event.rarity].toLowerCase())
                            ]
                        }),
                        " ",
                        middle,
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "location",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(locationName.toLowerCase())
                        }),
                        "!"
                    ]
                }, event.id);
            case (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).Kill:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: "animate__animated animate__fadeOut",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "username",
                            children: event.killer
                        }),
                        " ",
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__killed"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `username ${event.victim === "GRONK" ? (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__boss") : ""}`,
                            children: event.victim
                        }),
                        "!"
                    ]
                }, event.id);
            case (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).ExtractionStarted:
                locationName = Game.GetLocationNameFromXY(event.locationX, event.locationY);
                if (locationName === "Wilderness") middle = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__in_the");
                else middle = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__at");
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: "animate__animated animate__fadeOut",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "username",
                            children: event.playerName
                        }),
                        " ",
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__is_extracting"),
                        " ",
                        middle,
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "location",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(locationName.toLowerCase())
                        }),
                        "!"
                    ]
                }, event.id);
            case (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).ExtractionSuccessful:
                locationName = Game.GetLocationNameFromXY(event.locationX, event.locationY);
                if (locationName === "Wilderness") middle = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__in_the");
                else middle = (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__at");
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: "animate__animated animate__fadeOut",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "username",
                            children: event.playerName
                        }),
                        " ",
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__has_extracted")
                    ]
                }, event.id);
            case (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).BossSpawn:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: "animate__animated animate__fadeOut",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "boss",
                            children: event.bossName
                        }),
                        " ",
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__has_spawned"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "location",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(Game.GetLocationNameFromXY(event.locationX, event.locationY).toLowerCase())
                        }),
                        "!"
                    ]
                }, event.id);
            case (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).BossAttack:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: "animate__animated animate__fadeOut",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "boss",
                            children: event.bossName
                        }),
                        " ",
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("event_feed__under_attack"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "location",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(Game.GetLocationNameFromXY(event.locationX, event.locationY).toLowerCase())
                        }),
                        "!"
                    ]
                }, event.id);
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "server-event-feed animate__animated animate__slideInRight",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
            children: eventfeedDom
        })
    });
};




var $acw62 = parcelRequire("acw62");




const $8aec434da52e9e9d$export$157c131647dc68e = ()=>{
    const { loadingPlayerIdentity: loadingPlayerIdentity  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const { emailPromo: emailPromo  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$702a4b36187033b7));
    const [usernameValue, setUsernameValue] = (0, $acw62.useState)("");
    const [emailAddressValue, setEmailAddressValue] = (0, $acw62.useState)("");
    const [confirmEmailAddressValue, setConfirmEmailAddressValue] = (0, $acw62.useState)("");
    const [passwordValue, setPasswordValue] = (0, $acw62.useState)("");
    const [confirmPasswordValue, setConfirmPasswordValue] = (0, $acw62.useState)("");
    const onUsernameInputChanged = (e)=>{
        setUsernameValue(e.target.value);
    };
    const onEmailAddressInputChanged = (e)=>{
        setEmailAddressValue(e.target.value);
    };
    const onConfirmEmailAddressInputChanged = (e)=>{
        setConfirmEmailAddressValue(e.target.value);
    };
    const onPasswordInputChanged = (e)=>{
        setPasswordValue(e.target.value);
    };
    const onConfirmPasswordInputChanged = (e)=>{
        setConfirmPasswordValue(e.target.value);
    };
    const togglePromo = ()=>{
        (0, $9b9fb0750f8f8ccb$export$d4d0e648646dc7d9)(!emailPromo);
    };
    // const errorNodes = [];
    // if (username.length === 0) {
    //     errorNodes.push(<p>{t("change_username__cant_be_empty_error")}</p>);
    // } else if (username.length >= 20) {
    //     errorNodes.push(<p>{t("change_username__too_long_error")}</p>);
    // }
    // const shouldDisableRegisterButton = loadingPlayerIdentity || usernameValue.length === 0 || emailAddressValue.length === 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "register-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "register-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__header")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "terms-prompt",
                    children: [
                        (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__terms_label_1"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://app.termly.io/document/terms-of-service/293416da-8b5f-45b6-8b0b-966b73214f72",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__terms_label_2")
                        }),
                        " ",
                        "and",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: "https://app.termly.io/document/privacy-policy/a88f9624-708f-4045-a224-5fbae9a0d2ea",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: [
                                (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__terms_label_3"),
                                " "
                            ]
                        }),
                        "and",
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://app.termly.io/document/cookie-policy/a5d9d64f-141a-4b81-bf08-542969f3bf6b",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: "Cookie Policy"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "checkboxes",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "setting-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "setting-label",
                                children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__promo_label")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "setting-control",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "toggle-switch enabled",
                                    onClick: togglePromo,
                                    children: [
                                        emailPromo === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "toggle-switch-checked"
                                        }),
                                        emailPromo === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "toggle-switch-unchecked"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                (0, $276f03d77ac4b507$export$acf2935d58de9402)() === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "register-socials",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "social-btn discord-oauth-btn",
                                    href: "https://discord.com/api/oauth2/authorize?client_id=1102622111014588427&redirect_uri=https%3A%2F%2Fdev-api.trigonometryexplained.com%2Fpvpz%2Fauth%2Fdiscord%2Fcallback&response_type=code&scope=email%20identify",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__register_with_discord_btn")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "social-btn google-oauth-btn",
                                    href: "https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&response_type=code&redirect_uri=https://dev-api.trigonometryexplained.com/pvpz/auth/google/callback&client_id=986076822105-r63tqcbrrob73lich2svbbglhvu49v3h.apps.googleusercontent.com",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__register_with_google_btn")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "register-or-separator",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__or")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "register-form",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-row-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-label",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__username")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-input",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "register-input",
                                        type: "text",
                                        value: usernameValue,
                                        onChange: onUsernameInputChanged,
                                        disabled: loadingPlayerIdentity,
                                        placeholder: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__enter_new")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-row-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-label",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__email")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-input",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "register-input",
                                        type: "text",
                                        value: emailAddressValue,
                                        onChange: onEmailAddressInputChanged,
                                        disabled: loadingPlayerIdentity,
                                        placeholder: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__email_placeholder")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-row-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-label",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__email_confirm")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-input",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "register-input",
                                        type: "text",
                                        value: confirmEmailAddressValue,
                                        onChange: onConfirmEmailAddressInputChanged,
                                        disabled: loadingPlayerIdentity,
                                        placeholder: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__email_placeholder_confirm")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-row-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-label",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__password")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-input",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "register-input",
                                        type: "password",
                                        value: passwordValue,
                                        onChange: onPasswordInputChanged,
                                        disabled: loadingPlayerIdentity,
                                        placeholder: ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-row-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-label",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__password_confirm")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-input",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "register-input",
                                        type: "password",
                                        value: confirmPasswordValue,
                                        onChange: onConfirmPasswordInputChanged,
                                        disabled: loadingPlayerIdentity,
                                        placeholder: ""
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "register-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "neutral-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__back")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            style: {
                                width: "225px"
                            },
                            disabled: loadingPlayerIdentity,
                            className: "register-btn affirmative-button",
                            onClick: ()=>{
                                console.log("Registering with values:");
                                (0, $9b9fb0750f8f8ccb$export$b567335756c9d894)(usernameValue, emailAddressValue, confirmEmailAddressValue, passwordValue, confirmPasswordValue);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__register")
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");




const $ff1211293ec9dd57$export$21a94553ffa41578 = ()=>{
    const { loadingPlayerIdentity: loadingPlayerIdentity  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const [emailAddressValue, setEmailAddressValue] = (0, $acw62.useState)("");
    const [passwordValue, setPasswordValue] = (0, $acw62.useState)("");
    const onEmailAddressInputChanged = (e)=>{
        setEmailAddressValue(e.target.value);
    };
    const onPasswordInputChanged = (e)=>{
        setPasswordValue(e.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "login-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "login-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("login__header")
                }),
                (0, $276f03d77ac4b507$export$acf2935d58de9402)() === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "login-socials",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "social-btn discord-oauth-btn",
                                    href: "https://discord.com/api/oauth2/authorize?client_id=1102622111014588427&redirect_uri=https%3A%2F%2Fdev-api.trigonometryexplained.com%2Fpvpz%2Fauth%2Fdiscord%2Fcallback&response_type=code&scope=email%20identify",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("signin_sign_in_with_discord_btn")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: "social-btn google-oauth-btn",
                                    href: "https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&response_type=code&redirect_uri=https://dev-api.trigonometryexplained.com/pvpz/auth/google/callback&client_id=986076822105-r63tqcbrrob73lich2svbbglhvu49v3h.apps.googleusercontent.com",
                                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("signin_sign_in_with_google_btn")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "login-or-separator",
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__or")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "login-form",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-row-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-label",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__email")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-input",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "login-input",
                                        type: "text",
                                        value: emailAddressValue,
                                        onChange: onEmailAddressInputChanged,
                                        disabled: loadingPlayerIdentity,
                                        placeholder: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__email_placeholder")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-row-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-label",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("register__password")
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "form-input",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "login-input",
                                        type: "password",
                                        value: passwordValue,
                                        onChange: onPasswordInputChanged,
                                        disabled: loadingPlayerIdentity,
                                        placeholder: ""
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "login-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "neutral-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("change_username__back")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            style: {
                                width: "225px"
                            },
                            disabled: loadingPlayerIdentity,
                            className: "login-btn affirmative-button",
                            onClick: ()=>{
                                console.log("Signing in with values:");
                                (0, $9b9fb0750f8f8ccb$export$997e0077ced76e1)(emailAddressValue, passwordValue);
                            },
                            children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("signin_sign_in")
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");



var $e761d3c91a0daa0f$exports = {};

$e761d3c91a0daa0f$exports = new URL((parcelRequire("27Lyk")).resolve("awhjN"), import.meta.url).toString();


var $db66f70bf5008384$exports = {};

$db66f70bf5008384$exports = new URL((parcelRequire("27Lyk")).resolve("dFhUa"), import.meta.url).toString();


var $c6349e74f3300be5$exports = {};

$c6349e74f3300be5$exports = new URL((parcelRequire("27Lyk")).resolve("eJmGu"), import.meta.url).toString();


var $dc8eaca608c08598$exports = {};

$dc8eaca608c08598$exports = new URL((parcelRequire("27Lyk")).resolve("i4qHM"), import.meta.url).toString();


var $893e9682d102709b$exports = {};

$893e9682d102709b$exports = new URL((parcelRequire("27Lyk")).resolve("3lvFJ"), import.meta.url).toString();


var $c5b493382d495a7d$exports = {};

$c5b493382d495a7d$exports = new URL((parcelRequire("27Lyk")).resolve("3T6gD"), import.meta.url).toString();


var $eea04f05ea564e80$exports = {};

$eea04f05ea564e80$exports = new URL((parcelRequire("27Lyk")).resolve("9i1iT"), import.meta.url).toString();


var $8c28456d30459a34$exports = {};

$8c28456d30459a34$exports = new URL((parcelRequire("27Lyk")).resolve("561Kr"), import.meta.url).toString();



const $a4835721cecdb76d$export$3bf8a6653f63d61f = ()=>{
    const [activeCategory, setActiveCategory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("all_enemies");
    const { items: allItemsInStash  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$50ab1c01fc6ede55));
    const allLootChestsLootTable = (0, $faa1b3449016497b$export$545a9b11af9dbf88)((0, $faa1b3449016497b$export$27dd8d3f4f57d4c).LootChest);
    console.log("allItemsFromStash", allItemsInStash);
    console.log("allLootChestsLootTable", allLootChestsLootTable);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "collection-log-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "collection-log-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("collection_log__header")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "log",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "log-categories",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("all_chests");
                                    },
                                    className: `category ${activeCategory === "all_chests" ? "active" : ""}`,
                                    children: "All Loot Chests"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("ghost");
                                    },
                                    className: `category ${activeCategory === "ghost" ? "active" : ""}`,
                                    children: "Ghost"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("skeleton");
                                    },
                                    className: `category ${activeCategory === "skeleton" ? "active" : ""}`,
                                    children: "Skeleton"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("giantrat");
                                    },
                                    className: `category ${activeCategory === "giantrat" ? "active" : ""}`,
                                    children: "Giant Rat"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("treant");
                                    },
                                    className: `category ${activeCategory === "treant" ? "active" : ""}`,
                                    children: "Treant"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("ogre");
                                    },
                                    className: `category ${activeCategory === "ogre" ? "active" : ""}`,
                                    children: "Ogre"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("darkwizard");
                                    },
                                    className: `category ${activeCategory === "darkwizard" ? "active" : ""}`,
                                    children: "Dark Wizard"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("gronk");
                                    },
                                    className: `category boss ${activeCategory === "gronk" ? "active" : ""}`,
                                    children: "BOSS: Gronk"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        setActiveCategory("ironfox");
                                    },
                                    className: `category boss ${activeCategory === "ironfox" ? "active" : ""}`,
                                    children: "BOSS: Iron Fox"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "log-data",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "meta",
                                    children: [
                                        activeCategory === "all_chests" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e761d3c91a0daa0f$exports))),
                                            alt: "lootchest",
                                            className: "loot-source-preview lootchest"
                                        }),
                                        activeCategory === "ghost" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dc8eaca608c08598$exports))),
                                            alt: "ghost",
                                            className: "loot-source-preview ghost"
                                        }),
                                        activeCategory === "skeleton" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($893e9682d102709b$exports))),
                                            alt: "skeleton",
                                            className: "loot-source-preview skeleton"
                                        }),
                                        activeCategory === "giantrat" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c5b493382d495a7d$exports))),
                                            alt: "giantrat",
                                            className: "loot-source-preview giantrat"
                                        }),
                                        activeCategory === "darkwizard" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($eea04f05ea564e80$exports))),
                                            alt: "darkwizard",
                                            className: "loot-source-preview darkwizard"
                                        }),
                                        activeCategory === "ogre" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($db66f70bf5008384$exports))),
                                            alt: "ogre",
                                            className: "loot-source-preview ogre"
                                        }),
                                        activeCategory === "treant" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8c28456d30459a34$exports))),
                                            alt: "treant",
                                            className: "loot-source-preview treant"
                                        }),
                                        activeCategory === "gronk" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($db66f70bf5008384$exports))),
                                            alt: "Gronk",
                                            className: "loot-source-preview gronk"
                                        }),
                                        activeCategory === "ironfox" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c6349e74f3300be5$exports))),
                                            alt: "ironfox",
                                            className: "loot-source-preview ironfox"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "log-items"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};



parcelRequire("acw62");


const $b2123c9a00ea565d$export$670af3369e44ae02 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "patch-notes-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "patch-notes-header",
                    children: "Updates"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "patch-notes",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.3.0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.3.0 - February 5th, 2024"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: "Misc backend changes"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.10 - August 9th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Epic and Legendary Gear has been changed/tuned to better fit our idea of what Epic and Legendary gear should look/act like."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Legendary weapon stats have been adjusted to continue to encourage new metas and gameplay!"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.9",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.9 - August 2nd, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: 'New Legendary Gear "Beast Vanquisher Boots"! These can be looted from Giant Rats and Ogres'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Rare Gear has been changed/tuned to better fit our idea of what rare gear should look/act like. Expect these changes to be applied to other rarities in coming updates."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Legendary weapon stats have been adjusted to continue to encourage new metas and gameplay!"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Fixed a bug where Midnights Veil would be consumed on use."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Fixed a bug where Silent Shadow could spawn in chests"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.8",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.8 - July 25th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Insurance can now be bought with gold in store!"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "A number of translation bugs have been fixed"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Uncommon gear has been changed/tuned to better fit our idea of what uncommon gear should look/act like. Expect these changes to be applied to other rarities in coming updates."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Legendary weapon stats have been adjusted to continue to encourage new metas and gameplay!"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.7",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.7 - July 20th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Store Now Available! Checkout our store where you can buy insurance, cool skins, and other customization packages!"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Added new weapons: Silent Shadow (Legendary) and Frost Flicker (Epic)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Added new gear: Depth Strider (Common), Golden Gauntlets (Uncommon), and Magic Boots (Rare)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Fixed UI bug on Divine Wind that said it shoots shadow projectiles when it shoots Holy projectiles."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Staff Speed Boost: In addition to laying dangerous traps, staffs now also provide a temporary movement speed increase when fired thus giving you a moment of reprive during an intense battle."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Spellbook Starters: Spellbook behaviour has changed! These powerful books now boast a high-damage projectile with a very long cooldown (Chanting spells out of these books takes time and energy). This weapon class is used best as a one-off blast to gain the advantage at the start of combat! The Wizard's Ledger is the only exception."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Most common gear has been changed/tuned to better fit our idea of what common gear should look/act like. Expect these changes to be applied to other rarities in coming updates."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Legendary weapon stats have been adjusted to continue to encourage new metas and gameplay!"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Default Loadout changed so staff is no longer a primary weapon"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.6 - July 12th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Added new legendary weapon: Deathstick"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Fixed a bug where Book of Tongues would shoot the wrong projectile"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Iron Fox Locket: Reduced all resistances granted by 3, added 45 max HP, removed the ability to extract anywhere, and this item can no longer be destroyed"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Tantrum's Lucky Loop: reduced projectile distance to 5% and reduced movement speed to 3%"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Ginesh's Bottle Opener: reduced projectile distance to 15%"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Cloak of Modest Approachability: reduced projectile range to 12%"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Compacted Lime Green Ring: reduced projectile distance to 5%"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Little Compacted Lime Green Ring: reduced projectile distance to 12%"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.5 - July 7th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Added a new legendary weapon: Book of Tongues"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Added new legendary gear: Cultists Mask"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Rework: Staffs are now a class of weapon that create stationary projectiles which can block pathways"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Large balance pass: Tuned all legendary weapons, so that Celestial Bow is not the only option for a primary weapon"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Nerf to several movement speed items"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Reduced the negative effects on some items"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Reduced the power of lower tier items Buffed ghosts, rats and skeletons slightly, while nerfing Treants and Dark Wizards"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.4 - June 14th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Added a server selector dropdown to the main menu & settings screens"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Added more servers to: Asia, Australia, Europe, and South America"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "'Extract' active ability now takes full extraction time (10 seconds)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Passive Regen items now increase health over time more strongly"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "ALL 'Extract\" active ability items will now break when the active extraction ability is used"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Made Legendary and Epic items slightly more rare"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Nerf: Bees on a Stick - does slightly less damage, has a slightly longer cooldown and shoots slower projectiles"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Nerf: Nature's Return - does slightly less damage, has a slightly longer cooldown and shoots slower projectiles"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Nerf: Magical Staff - has a slightly longer cooldown and shoots slower projectiles"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: 'Nerf: "Waterwalking" stat - now never exceeds a 15% speed boost per item'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Nerf: Pheonix Feather Toque - now gives -20% attack speed"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Nerf: Time Hero's Ring - Changed attack speed increase from 20% to 5%"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Besides the above specific items that are worth mentioning, we also did a general large-scale weapon balance pass across many weapons"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Bug Fix: Fixed a bug where pressing the caps lock key would sometimes make your character stuck moving"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.3 - June 11th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "added a patch notes screen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "added support for fullscreen mode"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "added support for 4k resolution"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bug fix: fixed an issue where several invisibility items wouldnt properly grant you invisibility"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bug fix: fixed a UI text overlap issue in the server event feed"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bug fix: fixed a UI issue with the loading button on the You Died & You Extracted screens"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.2 - June 10th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "re-balanced many weapons (some nerfs, some buffs)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bug fix: fixed some screen size overlap issues on smaller screens"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.1 - June 9th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "new visuals for item tooltips to make reading them easier"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "the loot window will now automatically close if you move away from what you were looting"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "Iron Fox and GRONKs arenas are now a bit more open / there's less cover"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "nerf extraction protection items"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "nerf treant and dark wizard health"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bug fix: fixed an issue where you could stack multiple speed boost items. now when you use an ability, any other items you have that have the same ability will also go on cooldown"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bug fix: fixed a css bug causing 9slice borders to appear on some browsers"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bug fix: fixed a bug where dust sprite icons overlapped their text in the item tooltip"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "patch-segment patch-1.2.0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: "Update 1.2.0 - June 8th, 2023"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "SIGNIFICANT re-balance of all gear added a bunch of new stats to a bunch of items..."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "INCOGNITO; hides your location and loot messages from the server"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "INSPECTION; reveals information about your opponents"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "gold rush; earn more gold from chests"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "extraction speed; makes you extract faster"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "extraction protection; makes you take less damage while extracting"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "attack speed up"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "attack speed down"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "+damage against players only"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "-damage against players only"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "+damage against NPCs only"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "-damage against NPC only"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "projectile distance up"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "projectile distance down"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "new enemy; Dark Wizard"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "new boss; Iron Fox"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "bosses now always drop at least rare items"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "enemies now each have their own loot tables. now certain enemies will only drop certain items"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "added new player skin for registered users; Noble Knight"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "disallow Corrupted Wizard and Veteran Wizard skins unless you are registered"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "disallow viewing stats unless you are registered"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "we now play some particle effects when a player HEALS with a healing item"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "we now play some particle effects when a player REVIVES with a revive item"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "allow clicking ui elements in game (this is to prep for a mobile version) instead of pressing the hotkey"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "track new player stats (gold lost, items lost, bosses killed, common/uncommon/rare/epic/legendary items looted)"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "all enemies now take 15 seconds to respawn"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "all bosses now take 10 minutes to respawn"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "buffed GRONK. now he's extra stronk."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "increased font size of player names"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "fixed a bug where the revive effect wouldnt always proc"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "fixed a bug where your max health wouldnt update correctly on the loading screen"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "fixed a bug where a user identity error could result in an infinite loop"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            children: "fixed a bug where you could avoid sharing cooldowns from stacked items"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};



parcelRequire("acw62");


var $1f6d35e03f19310a$exports = {};

$1f6d35e03f19310a$exports = new URL((parcelRequire("27Lyk")).resolve("l1wAQ"), import.meta.url).toString();


var $64fb21e2d15f2c34$exports = {};

$64fb21e2d15f2c34$exports = new URL((parcelRequire("27Lyk")).resolve("23XXF"), import.meta.url).toString();


var $67ef4a04bfc05a82$exports = {};

$67ef4a04bfc05a82$exports = new URL((parcelRequire("27Lyk")).resolve("lIWv2"), import.meta.url).toString();


var $4344c233926c9dcd$exports = {};

$4344c233926c9dcd$exports = new URL((parcelRequire("27Lyk")).resolve("ai1bk"), import.meta.url).toString();


var $e306f1d6c793dda7$exports = {};

$e306f1d6c793dda7$exports = new URL((parcelRequire("27Lyk")).resolve("e0uKV"), import.meta.url).toString();


var $b8bbe752d02d9b02$exports = {};

$b8bbe752d02d9b02$exports = new URL((parcelRequire("27Lyk")).resolve("fdi53"), import.meta.url).toString();


var $e08e106930ffe739$exports = {};

$e08e106930ffe739$exports = new URL((parcelRequire("27Lyk")).resolve("bwLyn"), import.meta.url).toString();


var $0a7103b4f32598e2$exports = {};

$0a7103b4f32598e2$exports = new URL((parcelRequire("27Lyk")).resolve("8SAJE"), import.meta.url).toString();








const $0f090b3ddfd9f737$export$aa82d568fb2f38da = ()=>{
    const { userType: userType , userDetails: userDetails  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    console.log(userDetails);
    // @ts-ignore
    const { PVPZ_Currency: PVPZ_Currency  } = userDetails;
    const { insuranceCredits: insuranceCredits , gems: gems , gold: gold  } = PVPZ_Currency;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "shop-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "shop-header",
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("shop__title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "back",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "neutral-button",
                        onClick: ()=>{
                            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu);
                        },
                        children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("settings__back_to_main_menu_button")
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "currencies",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "gems",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4344c233926c9dcd$exports))),
                                    alt: "Your Gems"
                                }),
                                " ",
                                gems,
                                " Gems"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "coins",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0a7103b4f32598e2$exports))),
                                    alt: "Your Gold"
                                }),
                                gold,
                                " Gold"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "top-shop-content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "left-shop-content",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bundles",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bundle first-buyer-bundle",
                                        onClick: ()=>{
                                            (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("welcome");
                                            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bundle-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "bundle-title",
                                                        children: "Welcome Bundle - $5.00"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bundle-description",
                                                        children: [
                                                            "980 Gems and one character skin.",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Click to see more details!"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bundle-img",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1f6d35e03f19310a$exports))),
                                                    alt: "First Timer Bundle"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bundle supporter-bundle",
                                        onClick: ()=>{
                                            (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("supporter");
                                            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bundle-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "bundle-title",
                                                        children: "Supporter Bundle - $25.00"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bundle-description",
                                                        children: [
                                                            "THREE skins, 1000 gems, a special name color, and more!",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Click to see more details!"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bundle-img",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($64fb21e2d15f2c34$exports))),
                                                    alt: "First Timer Bundle"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bundle founder-bundle",
                                        onClick: ()=>{
                                            (0, $9b9fb0750f8f8ccb$export$575176a09217577a)("founder");
                                            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bundle-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "bundle-title",
                                                        children: "Founder Bundle - $50.00"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bundle-description",
                                                        children: [
                                                            "FIVE skins, 2000 gems, a special name color, and more!",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                children: "Click to see more details!"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "bundle-img",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($67ef4a04bfc05a82$exports))),
                                                    alt: "First Timer Bundle"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "right-shop-content",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "gems",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "gems-title",
                                            children: "Gems"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "gem-bundle",
                                            onClick: ()=>{
                                                if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) (0, $4a3136d799878a30$export$6b89521c3f482608)({
                                                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                                                    message: "Only registered users can purchase Gems from the shop! Create an account and try again."
                                                });
                                                else (0, $9b9fb0750f8f8ccb$export$65b487fedafdd9e6)("e1abc9cd-26d1-446f-8b86-822bdbad7459");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4344c233926c9dcd$exports))),
                                                    alt: "Gem Bundle 1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-text",
                                                    children: "220 Gems"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-price",
                                                    children: "$2.00"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "gem-bundle",
                                            onClick: ()=>{
                                                if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) (0, $4a3136d799878a30$export$6b89521c3f482608)({
                                                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                                                    message: "Only registered users can purchase Gems from the shop! Create an account and try again."
                                                });
                                                else (0, $9b9fb0750f8f8ccb$export$65b487fedafdd9e6)("71864fae-7436-454e-a47c-705b62f3ec18");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e306f1d6c793dda7$exports))),
                                                    alt: "Gem Bundle 2"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-text",
                                                    children: "490 Gems"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-price",
                                                    children: "$4.00"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "gem-bundle",
                                            onClick: ()=>{
                                                if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) (0, $4a3136d799878a30$export$6b89521c3f482608)({
                                                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                                                    message: "Only registered users can purchase Gems from the shop! Create an account and try again."
                                                });
                                                else (0, $9b9fb0750f8f8ccb$export$65b487fedafdd9e6)("ef71686a-d4b6-4add-818e-a96698afb54a");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b8bbe752d02d9b02$exports))),
                                                    alt: "Gem Bundle 3"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-text",
                                                    children: "1490 Gems"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-price",
                                                    children: "$10.00"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "gem-bundle",
                                            onClick: ()=>{
                                                if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) (0, $4a3136d799878a30$export$6b89521c3f482608)({
                                                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                                                    message: "Only registered users can purchase Gems from the shop! Create an account and try again."
                                                });
                                                else (0, $9b9fb0750f8f8ccb$export$65b487fedafdd9e6)("6a201bc6-df3e-42e0-a383-1507b49141a3");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e08e106930ffe739$exports))),
                                                    alt: "Gem Bundle 4"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-text",
                                                    children: "3340 Gems"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "gems-price",
                                                    children: "$20.00"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "skins",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "skins-title",
                                            children: "Skins"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "skins-content",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "skin-purchase",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                            selected: false,
                                                            OnClickFn: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            },
                                                            skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "price",
                                                            children: [
                                                                "200 ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4344c233926c9dcd$exports))),
                                                                    alt: "Gem Cost"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "skin-purchase",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                            selected: false,
                                                            OnClickFn: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            },
                                                            skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "price",
                                                            children: [
                                                                "450 ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4344c233926c9dcd$exports))),
                                                                    alt: "Gem Cost"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "skin-purchase",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                            selected: false,
                                                            OnClickFn: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            },
                                                            skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "price",
                                                            children: [
                                                                "700 ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4344c233926c9dcd$exports))),
                                                                    alt: "Gem Cost"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "skin-purchase",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                                            selected: false,
                                                            OnClickFn: ()=>{
                                                                (0, $9b9fb0750f8f8ccb$export$6e7b1c2beea6dc4a)((0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight);
                                                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase);
                                                            },
                                                            skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "price",
                                                            children: [
                                                                "1500 ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4344c233926c9dcd$exports))),
                                                                    alt: "Gem Cost"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bottom-shop-content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "insurance-title",
                            children: [
                                "Run Insurance: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($dd41187467184f8c$exports))),
                                    alt: "Insurance"
                                }),
                                "\xa0 ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        insuranceCredits,
                                        " Insurance Credits Owned"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "insurance-description",
                            children: [
                                "Buy insurance credits with gems or coins to protect your items from being lost!",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "10"
                                }),
                                " insurance credits costs ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "150 Gems"
                                }),
                                " or ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "5000 Gold"
                                }),
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "insurance-actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "affirmative-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmInsurancePurchase);
                            },
                            children: "Buy With Gems (150)"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "affirmative-button",
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmCoinInsurancePurchase);
                            },
                            children: "Buy With Coins (5000)"
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");






const $934097460f5e5313$export$93f663bec6d70b3f = ()=>{
    const selectedBundle = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$580257368aee5734));
    const { userDetails: userDetails , userType: userType  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    const { PVPZ_PurchasedSKUs: PVPZ_PurchasedSKUs  } = userDetails;
    console.log("selected bundle: ", selectedBundle);
    let sku;
    let priceInUSD = 0;
    let alreadyOwnThisBundle = false;
    if (selectedBundle === "welcome") {
        sku = "91b9536f-321b-4802-9a8c-3644c1c1bfbf";
        priceInUSD = 5;
    } else if (selectedBundle === "supporter") {
        sku = "6caa849c-c514-4a41-bbf4-c4170022e48a";
        priceInUSD = 25;
    } else if (selectedBundle === "founder") {
        sku = "81d969c4-371d-4c64-9345-808f9fbf2cad";
        priceInUSD = 50;
    }
    if (PVPZ_PurchasedSKUs.includes(sku)) alreadyOwnThisBundle = true;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bundle-details-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bundle-details-header",
                    children: "Bundles"
                }),
                selectedBundle === "supporter" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "bundle-title",
                            children: "Supporter Bundle"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "bundle-description",
                            children: "Greatly support the development of PvPz.io by purchasing a supporter bundle! This bundle includes..."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "bundle-features",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Three character skins (see below)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "1000 Gems"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        "A special colored name in-game (",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "rare-blue",
                                            children: "rare blue"
                                        }),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        "A special PvPz.io",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "https://discord.com/invite/nfmg9mz8GQ",
                                            target: "_blank",
                                            rel: "noreferrer noopener",
                                            children: "Discord"
                                        }),
                                        " ",
                                        "Server role"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "skins",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).AdeptArcher
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).WealthyAssassin
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).FallenWizardsApprentice
                                })
                            ]
                        })
                    ]
                }),
                selectedBundle === "founder" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "bundle-title",
                            children: "Founder Bundle"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "bundle-description",
                            children: "Tremendously support the development of PvPz.io by purchasing a founder bundle! This bundle includes..."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "bundle-features",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Five character skins (see below)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "2000 Gems"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        "A special colored name in-game (",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "epic-purple",
                                            children: "epic purple"
                                        }),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "A special PvPz.io Discord Server role"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        "Access to a private founders-only",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "https://discord.com/invite/nfmg9mz8GQ",
                                            target: "_blank",
                                            rel: "noreferrer noopener",
                                            children: "Discord"
                                        }),
                                        " ",
                                        "channel to help shape the direction of the game"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "skins",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).HeroicKnight
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).RadiantKnight
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Coldsteel_Knight
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CursedCorruptedWizard
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                    selected: false,
                                    OnClickFn: ()=>{},
                                    skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).CherryBlossomBoltman
                                })
                            ]
                        })
                    ]
                }),
                selectedBundle === "welcome" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "bundle-title",
                            children: "Welcome Bundle"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "bundle-description",
                            children: "Support the development of PvPz.io by purchasing a welcome bundle! This bundle includes..."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            className: "bundle-features",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "One character skin (see below)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "980 Gems"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "skins",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                                selected: false,
                                OnClickFn: ()=>{},
                                skin: (0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Estranged_Wizard
                            })
                        })
                    ]
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "not-registered",
                        children: "Sorry, only registered accounts can buy things from the store! Create an account and try again!"
                    })
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered && alreadyOwnThisBundle === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "not-registered",
                        children: "You already own this!"
                    })
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered && alreadyOwnThisBundle === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "affirmative-button",
                        style: {
                            width: "475px"
                        },
                        onClick: ()=>{
                            (0, $9b9fb0750f8f8ccb$export$65b487fedafdd9e6)(sku);
                        },
                        children: [
                            "Buy Bundle - $",
                            priceInUSD,
                            " USD"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};



parcelRequire("acw62");






const $b534a1ea068397d2$export$273cd5366c98bc6c = ()=>{
    const { shopActionInProgress: shopActionInProgress  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55));
    const { userDetails: userDetails , userType: userType  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    // @ts-ignore
    // eslint-disable-next-line prefer-const
    let { PVPZ_Currency: PVPZ_Currency , PVPZ_UnlockedSkins: PVPZ_UnlockedSkins  } = userDetails;
    if (PVPZ_UnlockedSkins === undefined) PVPZ_UnlockedSkins = [];
    const { gems: gems  } = PVPZ_Currency;
    const currentSelectedSkin = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$e15de0447bb57da2));
    console.log("currentSelectedSkin", currentSelectedSkin);
    console.log(PVPZ_UnlockedSkins);
    let alreadyOwnThisSkin = false;
    if (PVPZ_UnlockedSkins.includes(currentSelectedSkin)) alreadyOwnThisSkin = true;
    const gemPrices = {
        [(0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).MidnightThief]: 200,
        [(0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).ForestArcher]: 450,
        [(0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).Assassin]: 700,
        [(0, $cee99d2008daa3ee$export$b3cdd2c2676dcd8c).VengefulKnight]: 1500
    };
    // @ts-ignore
    const selectedPrice = gemPrices[currentSelectedSkin];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "confirm-skin-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "confirm-skin-header",
                    children: "Buy Skin"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "confirmation",
                    style: {
                        marginBottom: "20px"
                    },
                    children: [
                        gems < selectedPrice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "It looks like you don't have enough Gems to purchase this skin!"
                        }),
                        gems >= selectedPrice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Are you sure you want to purchase this skin? It will cost you ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        selectedPrice,
                                        " gems"
                                    ]
                                }),
                                "!"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "skin-preview",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe727221247bde8$export$ed5c7e9f758b0272), {
                        selected: false,
                        OnClickFn: ()=>{},
                        skin: currentSelectedSkin
                    })
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "not-registered",
                        children: "Sorry, only registered accounts can buy things from the store! Create an account and try again!"
                    })
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        alreadyOwnThisSkin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "not-registered",
                            children: "You already own this!"
                        }),
                        alreadyOwnThisSkin === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            className: "affirmative-button",
                            disabled: gems < selectedPrice || shopActionInProgress,
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$a397c73219b6ab32)(currentSelectedSkin);
                            },
                            children: [
                                "Buy for ",
                                selectedPrice,
                                " gems"
                            ]
                        }),
                        gems < selectedPrice && alreadyOwnThisSkin === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "affirmative-button",
                            disabled: shopActionInProgress,
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop);
                            },
                            children: "Buy Gems"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    disabled: shopActionInProgress,
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};



parcelRequire("acw62");




const $a4d700960a151262$export$4d646e9f7381dbb3 = ()=>{
    const { shopActionInProgress: shopActionInProgress  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55));
    const { userType: userType , userDetails: userDetails  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    // @ts-ignore
    const { PVPZ_Currency: PVPZ_Currency  } = userDetails;
    const { gems: gems  } = PVPZ_Currency;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "confirm-skin-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "confirm-skin-header",
                    children: "Insurance"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "confirmation",
                    style: {
                        marginBottom: "20px"
                    },
                    children: [
                        gems < 150 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "It looks like you don't have enough Gems to purchase insurance credits!"
                        }),
                        gems >= 150 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Purchasing ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "10 Insurance Credits"
                                }),
                                " will cost",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "150 gems"
                                }),
                                ". Are you sure?"
                            ]
                        })
                    ]
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "not-registered",
                        children: "Sorry, only registered accounts can buy things from the store! Create an account and try again!"
                    })
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "affirmative-button",
                            disabled: gems < 150 || shopActionInProgress,
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$7088ca1845f00dc1)();
                            },
                            children: "Buy 10 Credits for 150 Gems"
                        }),
                        gems < 150 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "affirmative-button",
                            disabled: shopActionInProgress,
                            onClick: ()=>{
                                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop);
                            },
                            children: "Buy Gems"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    disabled: shopActionInProgress,
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};



parcelRequire("acw62");

const $0c3870eec2f43904$export$97e2f580404b0a1f = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "purchase-successful-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "purchase-successful-header",
                    children: "Thank you!"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Your purchase has been added to your account!"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Thank you for supporting us!"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    onClick: ()=>{
                        window.location.reload();
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};



parcelRequire("acw62");




const $d977265c0c49d6eb$export$eec78f811c0a853e = ()=>{
    const { shopActionInProgress: shopActionInProgress  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$62ebb3e8b0a56b55));
    const { userType: userType , userDetails: userDetails  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$1be1edc9a09be8eb));
    // @ts-ignore
    const { PVPZ_Currency: PVPZ_Currency  } = userDetails;
    const { gems: gems , gold: gold  } = PVPZ_Currency;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "confirm-skin-panel animate__animated animate__fadeInUp animate__faster",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "confirm-skin-header",
                    children: "Insurance"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "confirmation",
                    style: {
                        marginBottom: "20px"
                    },
                    children: [
                        gems < 150 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: "It looks like you don't have enough Gold to purchase insurance credits!"
                        }),
                        gems >= 150 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                "Purchasing ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "10 Insurance Credits"
                                }),
                                " will cost",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "5000 Gold"
                                }),
                                ". Are you sure?"
                            ]
                        })
                    ]
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "not-registered",
                        children: "Sorry, only registered accounts can buy things from the store! Create an account and try again!"
                    })
                }),
                userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "affirmative-button",
                        disabled: gold < 5000 || shopActionInProgress,
                        onClick: ()=>{
                            (0, $9b9fb0750f8f8ccb$export$9ffb6b01ba1afaf4)();
                        },
                        children: "Buy 10 Credits for 5000 Gold"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "neutral-button",
                    disabled: shopActionInProgress,
                    onClick: ()=>{
                        (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop);
                    },
                    children: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("stats__back_btn")
                })
            ]
        })
    });
};


const $cae73d8e98ce7a92$export$cd08bb56bae76d04 = ()=>{
    const { show: showYouDiedPanel  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$644c40fb1febeb7));
    const { show: showExtractionSuccessfulPanel  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$29fa98681c68ecb7));
    const currentUIMode = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$a81c8bd4ed6c2681));
    const currentScreen = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$af0d689d0f8c0f26));
    const { show: userIdentityError  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$741e7d002666f097));
    const { show: gameBreakingError  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$b8b34d3739f5d143));
    const { loadingAssets: loadingAssets  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$95c23f336a305d72));
    const { skippingMenu: skippingMenu  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$d3f466f4fc70952));
    const { spectating: spectating  } = (0, $7ef244517b504261$export$8b71bf98365f8042)((0, $9b9fb0750f8f8ccb$export$23341af0bec1ee28));
    const MainMenuUI = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MainMenu && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14d1455d3ab5388e$export$4e08dcf990b776c0), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Vendors && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42e89473d4bc79a2$export$5987dceff545a7f9), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).HowToPlay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $031b28671ed16b8d$export$45c4ca16caeed66b), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).HowToPlay && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $031b28671ed16b8d$export$45c4ca16caeed66b), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Rankings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f243e0e2aecc75d8$export$fa86afedc77126db), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Settings && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $437c3525f5d10421$export$c72f6eaae7b9adff), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).RunPrep && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f56119da642b0b0$export$2915bcb1753dec25), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).BundleDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $934097460f5e5313$export$93f663bec6d70b3f), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmInsurancePurchase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4d700960a151262$export$4d646e9f7381dbb3), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmCoinInsurancePurchase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d977265c0c49d6eb$export$eec78f811c0a853e), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ConfirmSkinPurchase && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b534a1ea068397d2$export$273cd5366c98bc6c), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).PurchaseSuccessful && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c3870eec2f43904$export$97e2f580404b0a1f), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Shop && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f090b3ddfd9f737$export$aa82d568fb2f38da), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Partners && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0f05341c36299$export$31512ee37400d4d3), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Register && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8aec434da52e9e9d$export$157c131647dc68e), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Login && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff1211293ec9dd57$export$21a94553ffa41578), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).KitTest && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $548eeacfcb94c781$export$fe46d4a10b67055), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).RunInProgress && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5d987146aaddab$export$4586659ef7addab4), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).FindingMatch && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b8f7bdeee8b58f4$export$9d9df356b5b75a53), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ChangeUsername && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d076d0942235782$export$bff664fe2c092334), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Stats && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1265088cfe66ec0$export$3cdec2bba15e3523), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).Inventory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c5a036284e26556$export$a033e390692f359f), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).ItemTest && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $167fb719395e2bc8$export$1f24e401d18c8eaf), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).PatchNotes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2123c9a00ea565d$export$670af3369e44ae02), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).CollectionLog && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4835721cecdb76d$export$3bf8a6653f63d61f), {}),
            currentScreen === (0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).MatchmakingError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c828c2af32485839$export$60be593cf9a5a44b), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9acb122d31ff87f5$export$aaaa284fbfa7c5e7), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4fc77b936f0afc6$export$ac8c8d82cb85c6e0), {})
        ]
    });
    const InGameUI = spectating ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "game-hud",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12bf9c9483dd9ed3$export$814a940fbc38873), {})
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-hud",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96f60e91057049b4$export$481892a1a83a68a0), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7dc62c5c9ef94b4$export$a9d4ef180e44b39a), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d838ee681b82e8b$export$8cec688109811753), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccae45590b480272$export$7ba4b7dd907360b3), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f02d39bd1e5b4acc$export$59aca900590621cb), {}),
            showYouDiedPanel === false && showExtractionSuccessfulPanel === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $081fc42f386d51f3$export$4011a43e3ea1594e), {}),
            showYouDiedPanel === false && showExtractionSuccessfulPanel === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1daeb039ce6e9eb3$export$f20c3e4eca527526), {}),
            showYouDiedPanel === false && showExtractionSuccessfulPanel === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84675554534cc87a$export$c9176e726496162e), {}),
            showYouDiedPanel === false && showExtractionSuccessfulPanel === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67644d1becb2832a$export$25cf97d095b3336a), {}),
            showYouDiedPanel === false && showExtractionSuccessfulPanel === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56c7250855afd2cf$export$df5ebfc630cfdc36), {}),
            showYouDiedPanel === false && showExtractionSuccessfulPanel === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "left-inventory-containers",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6baec1e346cf26a$export$7fd0d3064e7706e1), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e565658c851c7a5$export$6b49c872b2198970), {})
                ]
            }),
            (showYouDiedPanel || showExtractionSuccessfulPanel) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8bb3e47e0b720393$export$95d89f9f2dc93b), {}),
            (showYouDiedPanel || showExtractionSuccessfulPanel) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbf8a706e44f6f2$export$77468e507dd9c979), {})
        ]
    });
    if (userIdentityError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c43c1805e4c055ed$export$6c1870f4a8d858a7), {});
    else if (gameBreakingError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f25666371afd2617$export$418c8281873ce7ff), {});
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "screen-too-small",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Sorry!"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "It looks like you are trying to play on a phone or tablet and that is not yet supported. Expect a mobile version in the near future!"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "screen-router",
                children: [
                    currentUIMode === (0, $9b9fb0750f8f8ccb$export$4d514e3f82243c75).Menus && skippingMenu === false && MainMenuUI,
                    (currentUIMode === (0, $9b9fb0750f8f8ccb$export$4d514e3f82243c75).InGame || skippingMenu === true) && InGameUI
                ]
            }),
            loadingAssets && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f779959bfcd045b$export$6665614bc5d690f6), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad26fe773541dcd3$export$f2815235e76a62b9), {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true,
                theme: "dark"
            })
        ]
    });
};



const $ecdf19e944a26e1a$export$63548ce3f438e2c4 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7ef244517b504261$export$f72b9f9819639629), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4f76ed508686472d$exports))), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cae73d8e98ce7a92$export$cd08bb56bae76d04), {})
        ]
    });
};



class $0729739820ea5e30$export$618b19ebc933e619 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.reactRoot = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("ui-root"));
        Game.ListenForEvent("Assets::Loaded", ()=>(0, $9b9fb0750f8f8ccb$export$4e3301a0de828066)());
        Game.ListenForEvent("Identity::Identified_Anonymous", ({ identity: identity  })=>{
            (0, $9b9fb0750f8f8ccb$export$91a38d259b67210e)(identity);
            (0, $9b9fb0750f8f8ccb$export$dce591b3e402a805)(identity.PVPZ_Preferences);
            // console.log(identity.PVPZ_Stash);
            (0, $9b9fb0750f8f8ccb$export$6153c37a1e6341e2)(identity.PVPZ_Stash);
            (0, $9b9fb0750f8f8ccb$export$98cfc4ed4d392760)(identity.PVPZ_Loadout);
        });
        Game.ListenForEvent("Identity::Identified_Registered", ({ identity: identity  })=>{
            (0, $9b9fb0750f8f8ccb$export$1e7c3af35249366)(identity);
            (0, $9b9fb0750f8f8ccb$export$dce591b3e402a805)(identity.PVPZ_Preferences);
            // console.log(identity.PVPZ_Stash);
            (0, $9b9fb0750f8f8ccb$export$6153c37a1e6341e2)(identity.PVPZ_Stash);
            (0, $9b9fb0750f8f8ccb$export$98cfc4ed4d392760)(identity.PVPZ_Loadout);
        });
        Game.ListenForEvent("Identity::Error::IncorrectIdentityProvider", ()=>(0, $9b9fb0750f8f8ccb$export$a6e2a162910a7a6)("It looks like you're trying to log in with the wrong platform associated to this user. Please try again."));
        Game.ListenForEvent("Identity::Error::AuthExpired", ()=>(0, $9b9fb0750f8f8ccb$export$a6e2a162910a7a6)("Sorry about that, your session has expired! We haven't seen you in awhile so we've logged you out for now. You'll need to log in again!"));
        Game.ListenForEvent("Identity::Error::OAuthFailed", ()=>(0, $9b9fb0750f8f8ccb$export$a6e2a162910a7a6)("There was an error logging you in with the chosen platform. Please try again."));
        Game.ListenForEvent("Identity::Error::UnknownIrrecoverableAPIError", ()=>(0, $9b9fb0750f8f8ccb$export$a6e2a162910a7a6)("Something went wrong logging you in. Please try again later."));
    }
    Initialize() {
        this.reactRoot.render((0, $ecdf19e944a26e1a$export$63548ce3f438e2c4)());
        this.LogInfo("Ready!");
    }
    getSystemName() {
        return "UI";
    }
    Update(__deltaTime) {
        throw new Error("Method not implemented.");
    }
    Cleanup() {
        this.LogInfo("Cleaning up...");
    }
}










class $0d9696dfcdfbca4b$export$21753bcb649b7783 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.identified = false;
    }
    GetUserType() {
        return this.userType;
    }
    _IsFailedExistingOauthAttempt() {
        return window.location.href.includes("?af=true&e=");
    }
    _IsExistingLoggedInUser() {
        const existingAuthToken = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken);
        if (existingAuthToken !== null) return true;
        else return false;
    }
    _IsExistingAnonymousUser() {
        const existingAnonUserId = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
        if (existingAnonUserId !== null) return true;
        else return false;
    }
    _IsNewUserRegistration() {
        return window.location.href.includes("?as=true&t=");
    }
    _portUserAuthBetweenMajorGameVersionsIfNecessary() {
        const currentVersionAsInt = parseInt((0, $3dc337423aed9780$export$d0ad00b11a82791a));
        const previousMajorGameVersion = currentVersionAsInt - 1;
        const existingPreviousAnonUserId = (0, $bc8c2d9d797d9b02$export$50b227d68205c4cc)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId, previousMajorGameVersion);
        if (existingPreviousAnonUserId !== null) {
            (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId, existingPreviousAnonUserId);
            (0, $bc8c2d9d797d9b02$export$f39d14204f621823)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId, previousMajorGameVersion);
            this.LogInfo("New major game version detected, ported anonymous user id from previous version!");
        }
        const existingPreviousAuthToken = (0, $bc8c2d9d797d9b02$export$50b227d68205c4cc)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken, previousMajorGameVersion);
        if (existingPreviousAuthToken !== null) {
            (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken, existingPreviousAuthToken);
            (0, $bc8c2d9d797d9b02$export$f39d14204f621823)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken, previousMajorGameVersion);
            this.LogInfo("New major game version detected, ported user auth tokens from previous version!");
        }
    }
    async Initialize() {
        let identity = undefined;
        let userType = undefined;
        this._portUserAuthBetweenMajorGameVersionsIfNecessary();
        setTimeout(()=>{
            (0, $9b9fb0750f8f8ccb$export$f1f240c812b6ed34)();
        }, 50);
        const existingLocalStoragePrefForPromotion = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).PromotionAccepted);
        let acceptedPromotionBoolean = false;
        if (existingLocalStoragePrefForPromotion === null) {
            (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).PromotionAccepted, "true");
            acceptedPromotionBoolean = true;
        } else acceptedPromotionBoolean = existingLocalStoragePrefForPromotion === "true";
        try {
            if (this._IsFailedExistingOauthAttempt()) {
                // TODO: fix react rendering issue where this event is emitted before the UI is ready to handle it
                setTimeout(()=>{
                    // if we failed to log in with oauth, delete the auth token and let the user try again if they want
                    this.LogError("Prior auth attempt was failed for some reason");
                    const { e: e  } = Object.fromEntries(new URLSearchParams(window.location.search));
                    if (e === "incorrect_identity_provider") Game.EmitEvent("Identity::Error::IncorrectIdentityProvider");
                    else if (e === "oauth_failed") Game.EmitEvent("Identity::Error::OAuthFailed");
                    else if (e === "auth_expired") {
                        this.ClearLocalAuth();
                        Game.EmitEvent("Identity::Error::AuthExpired");
                    } else {
                        this.ClearLocalAuth();
                        Game.EmitEvent("Identity::Error::UnknownIrrecoverableAPIError");
                    }
                }, 50);
                return;
            } else if (this._IsExistingLoggedInUser()) {
                // grab their user details if this is an existing logged in user
                this.LogInfo("Registered user auth token found, retrieving existing user");
                const retrievedUser = await (0, $155c80569fd4a71a$export$1438efb660d0e2db)();
                identity = retrievedUser;
                userType = (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered;
            } else if (this._IsNewUserRegistration()) {
                // promote their existing anon user to a registered user if this is a new user registration
                // as denoted by the query params that only get applied when redirected from oauth2 callback
                this.LogInfo("Registered user auth token & anon user id found, promoting existing anonymous user to registered user");
                const { t: t  } = Object.fromEntries(new URLSearchParams(window.location.search).entries());
                if (t === undefined) throw new Error("Failed to retrieve auth token in new user reg case; cannot proceed with identity");
                (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken, t);
                const anonUserId = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
                const promotedUser = await (0, $155c80569fd4a71a$export$1ba3b2ba3b6c6931)(anonUserId, acceptedPromotionBoolean);
                (0, $bc8c2d9d797d9b02$export$34a3032bf337a702)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
                identity = promotedUser;
                userType = (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered;
                this.LogInfo("Newly created registered user:");
            // this.LogInfo("\n" + JSON.stringify(promotedUser, null, 2));
            } else if (this._IsExistingAnonymousUser()) {
                // load an existing anon user if none of the above apply
                this.LogInfo("Anonymous user found, retrieving info for existing anonymous user");
                const anonUserId = (0, $bc8c2d9d797d9b02$export$e68c847c0bceb7d5)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
                const retrievedAnonUser = await (0, $155c80569fd4a71a$export$fd2a7795a45c388)(anonUserId);
                identity = retrievedAnonUser;
                userType = (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous;
                this.LogInfo("Retrieved existing anonymous user!");
            // this.LogInfo("\n" + JSON.stringify(retrievedAnonUser, null, 2));
            } else {
                // lastly, create a new anon user if none of the above apply
                this.LogInfo("No anonymous user found, creating net new anon user");
                const createdAnonUser = await (0, $155c80569fd4a71a$export$12d407bce29ab995)();
                (0, $bc8c2d9d797d9b02$export$1b8cd2d0ef9a8e5d)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId, createdAnonUser._id);
                identity = createdAnonUser;
                userType = (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous;
                this.LogInfo("Newly created anonymous user:");
            // this.LogInfo("\n" + JSON.stringify(createdAnonUser, null, 2));
            }
        } catch (e) {
            if (e instanceof (0, $8ae692c0d811c501$export$30df2395274cb2d1)) {
                this.ClearLocalAuth();
                this.AuthExpiredLogout();
            } else if (e instanceof (0, $8ae692c0d811c501$export$7333e7db5e5d49a)) {
                this.ClearLocalAuth();
                this.AuthExpiredLogout();
            } else console.error("Unknown API Error", e);
        }
        if (identity === undefined || userType === undefined) {
            this.ClearLocalAuth();
            Game.EmitEvent("Identity::Error::UnknownIrrecoverableAPIError");
            return;
        }
        Lang = identity.PVPZ_Preferences.preferredLanguage;
        document.querySelector("body").className = "";
        document.querySelector("body").classList.add(Lang);
        if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous) Game.EmitEvent("Identity::Identified_Anonymous", {
            identity: identity
        });
        else if (userType === (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) Game.EmitEvent("Identity::Identified_Registered", {
            identity: identity
        });
        this.identity = identity;
        this.userType = userType;
        this.identified = true;
        Game.ListenForEvent("Identity::Logout", ()=>{
            this.ClearLocalAuth(true);
        });
        this.LogInfo("Ready!\n\nUsername is: " + this.identity.username);
        const shouldSkipToLoadout = window.location.href.includes("sl=true");
        const shouldSkipToPurchaseSuccessfulScreen = window.location.href.includes("ps=true");
        if (window.location.href.includes("skipMenu=true") === false && window.location.href.includes("bypass=4ed2b85f-4266-4569-a2e8-64d37305226e") === false) window.history.replaceState({}, document.title, "/");
        if (shouldSkipToLoadout) (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).RunPrep);
        else if (shouldSkipToPurchaseSuccessfulScreen) (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).PurchaseSuccessful);
    }
    GetUsername() {
        return this.identity.username;
    }
    ClearLocalAuth(reload) {
        (0, $bc8c2d9d797d9b02$export$34a3032bf337a702)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AuthToken);
        (0, $bc8c2d9d797d9b02$export$34a3032bf337a702)((0, $bc8c2d9d797d9b02$export$c02c1f4c11d08446).AnonymousUserId);
        if (reload) (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
    }
    AuthExpiredLogout() {
        (0, $d1dfdf83584ec9ce$export$5279190db4d8f228)(false);
    }
    getSystemName() {
        return "Identity";
    }
    Update(__deltaTime) {}
    Cleanup() {}
}


/* eslint-disable @typescript-eslint/no-explicit-any */ 

var $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb;
var $f89d8ffbdc18f2ab$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = "canplaythrough";
            self._navigator = typeof window !== "undefined" && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== "undefined") {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, "")];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || "suspended" : "suspended";
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== "undefined") try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === "undefined") self._canPlayEvent = "canplay";
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== "undefined" ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== "function") return self;
            var mpegTest = audioTest.canPlayType("audio/mpeg;").replace(/^no$/, "");
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : "";
            var checkOpera = ua.match(/OPR\/([0-6].)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split("/")[1], 10) < 33;
            var checkSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!audioTest.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!audioTest.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(audioTest.canPlayType("audio/x-m4a;") || audioTest.canPlayType("audio/m4a;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(audioTest.canPlayType("audio/x-m4b;") || audioTest.canPlayType("audio/m4b;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(audioTest.canPlayType("audio/x-mp4;") || audioTest.canPlayType("audio/mp4;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(audioTest.canPlayType("audio/x-flac;") || audioTest.canPlayType("audio/flac;")).replace(/^no$/, "")
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === "undefined") source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === "function") self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener("touchstart", unlock, true);
                    document.removeEventListener("touchend", unlock, true);
                    document.removeEventListener("click", unlock, true);
                    document.removeEventListener("keydown", unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("unlock");
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener("touchstart", unlock, true);
            document.addEventListener("touchend", unlock, true);
            document.addEventListener("click", unlock, true);
            document.addEventListener("keydown", unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== "undefined" && (testPlay instanceof Promise || typeof testPlay.then === "function")) testPlay.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === "undefined" || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = "suspending";
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = "suspended";
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === "undefined" || !Howler1.usingWebAudio) return;
            if (self.state === "running" && self.ctx.state !== "interrupted" && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === "suspended" || self.state === "running" && self.ctx.state === "interrupted") {
                self.ctx.resume().then(function() {
                    self.state = "running";
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("resume");
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === "suspending") self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error("An array of source files must be passed with any new Howl.");
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== "string" ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === "boolean" || o.preload === "metadata" ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== "string" ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = "unloaded";
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== "undefined" && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: "play",
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== "none") self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit("loaderror", null, "No audio support.");
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === "string") self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== "string") {
                        self._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split("?", 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit("loaderror", null, "No codec support for selected audio sources.");
                return;
            }
            self._src = url;
            self._state = "loading";
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === "https:" && url.slice(0, 5) === "http:") {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === "number") {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === "string" && self._state === "loaded" && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === "undefined") {
                // Use the default sound sprite (plays the full audio length).
                sprite = "__default";
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || "__default";
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== "loaded") {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: "play",
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue("play");
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === "undefined") sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit("play", sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === "running" && Howler1.ctx.state !== "interrupted") playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once("resume", playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== "undefined" && (play instanceof Promise || typeof play.then === "function")) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit("play", sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit("play", sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== "__default" || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener("ended", self._endTimers[sound._id], false);
                            };
                            node.addEventListener("ended", self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit("playerror", sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA") {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = "loading";
                    var listener = function() {
                        self._state = "loaded";
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "pause",
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit("pause", sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "stop",
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit("stop", sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "mute",
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === "undefined") {
                if (typeof muted === "boolean") self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit("mute", sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === "undefined") {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "volume",
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === "undefined") self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit("volume", sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "fade",
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === "undefined");
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit("fade", sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit("fade", id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === "boolean") {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === "number") {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "rate",
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === "undefined") self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit("rate", sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === "undefined") return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === "number" && (self._state !== "loaded" || self._playLock)) {
                self._queue.push({
                    event: "seek",
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === "number" && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit("seek", id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === "number") {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener("error", sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener("ended", sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = "unloaded";
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self["_on" + event];
            if (typeof fn === "function") events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self["_on" + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === "number") {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self["_on" + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf("_on") === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self["_on" + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === "load") {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit("end", sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit("play", sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== "function") clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener("ended", self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === "undefined") {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf("Apple") >= 0;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener("error", self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener("ended", self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? "auto" : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit("loaderror", self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener("error", self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== "loaded") {
                parent._state = "loaded";
                parent._emit("load");
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener("ended", self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(",")[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = "arraybuffer";
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + "")[0];
                if (code !== "0" && code !== "2" && code !== "3") {
                    self._emit("loaderror", null, "Failed loading audio file with status: " + xhr.status + ".");
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit("loaderror", null, "Decoding audio data failed.");
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== "undefined" && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== "loaded") {
            self._state = "loaded";
            self._emit("load");
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== "undefined") Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === "function" && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb = Howler1;
    $f89d8ffbdc18f2ab$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== "undefined") {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._pos[1] : y;
        z = typeof z !== "number" ? self._pos[2] : z;
        if (typeof x === "number") {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== "undefined") {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== "number" ? or[1] : y;
        z = typeof z !== "number" ? or[2] : z;
        xUp = typeof xUp !== "number" ? or[3] : xUp;
        yUp = typeof yUp !== "number" ? or[4] : yUp;
        zUp = typeof zUp !== "number" ? or[5] : zUp;
        if (typeof x === "number") {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== "undefined") {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : "inverse",
                maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : "HRTF",
                refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "stereo",
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === "undefined" ? "spatial" : "stereo";
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === "number") {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === "number") {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = "equalpower";
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === "spatial") {
                            if (typeof sound._panner.positionX !== "undefined") {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit("stereo", sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "pos",
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? 0 : y;
        z = typeof z !== "number" ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === "number") self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, "spatial");
                        if (typeof sound._panner.positionX !== "undefined") {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit("pos", sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "orientation",
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._orientation[1] : y;
        z = typeof z !== "number" ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === "number") self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, "spatial");
                        }
                        if (typeof sound._panner.orientationX !== "undefined") {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit("orientation", sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === "object") {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === "undefined") {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== "undefined" ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== "undefined" ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== "undefined" ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== "undefined" ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== "undefined" ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== "undefined" ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== "undefined" ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== "undefined" ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : pa.panningModel
                };
                // Update the panner values or create a new panner if none exists.
                var panner = sound._panner;
                if (panner) {
                    panner.coneInnerAngle = pa.coneInnerAngle;
                    panner.coneOuterAngle = pa.coneOuterAngle;
                    panner.coneOuterGain = pa.coneOuterGain;
                    panner.distanceModel = pa.distanceModel;
                    panner.maxDistance = pa.maxDistance;
                    panner.refDistance = pa.refDistance;
                    panner.rolloffFactor = pa.rolloffFactor;
                    panner.panningModel = pa.panningModel;
                } else {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, "spatial");
                }
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || "spatial";
        // Create the new panner node.
        if (type === "spatial") {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== "undefined") {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== "undefined") {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();



var $a03267c74f6ddfe1$export$2e2bcd8739ae039 = {
    extension: {
        name: "Howler Loader Parser",
        priority: (0, $dc037be75324b6bc$export$820ed6348c4f2750).Normal,
        type: (0, $0fcbd3e56b89a698$export$4f037c6ec2da4eeb).LoadParser
    },
    test (url) {
        return (0, $5d808cc4b6a3c326$exports).path.extname(url).includes(".mp3") || (0, $5d808cc4b6a3c326$exports).path.extname(url).includes(".wav") || (0, $5d808cc4b6a3c326$exports).path.extname(url).includes(".ogg") || (0, $5d808cc4b6a3c326$exports).path.extname(url).includes(".mpeg");
    },
    async load (url) {
        return new Promise((resolve, reject)=>{
            const howl = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
                src: [
                    url
                ],
                onload: ()=>resolve(howl),
                onloaderror: (id, message)=>reject(message)
            });
        });
    }
};



class $8debebb62d6d10fa$export$a22a9a8b98fa91fd extends Error {
    constructor(message){
        super(message);
    }
}



class $faff1e9a6587b391$export$b6a607d5b0e013e9 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.AssetsFullyLoaded = false;
        (0, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f).add((0, $a03267c74f6ddfe1$export$2e2bcd8739ae039));
    }
    async Initialize() {
        try {
            Game.Rewards.LoadingStarted();
            await (0, $fff9e028a285d5fa$export$c8eca95e306f7116).init({
                manifest: {
                    bundles: [
                        {
                            name: "game-assets",
                            assets: [
                                {
                                    name: "sprites",
                                    srcs: `/sprites/sprites.json?pvpzts=${Date.now()}`
                                },
                                {
                                    name: "background-layer1",
                                    srcs: `/world/pvpz-background1.png?pvpzts=${Date.now()}`
                                },
                                {
                                    name: "background-layer2",
                                    srcs: `/world/pvpz-background2.png?pvpzts=${Date.now()}`
                                },
                                {
                                    name: "middleground-layer",
                                    srcs: `/world/pvpz-middleground.png?pvpzts=${Date.now()}`
                                },
                                {
                                    name: "foreground-layer1",
                                    srcs: `/world/pvpz-foreground1.png?pvpzts=${Date.now()}`
                                },
                                {
                                    name: "foreground-layer2",
                                    srcs: `/world/pvpz-foreground2.png?pvpzts=${Date.now()}`
                                },
                                {
                                    name: "collisions-layer",
                                    srcs: `/world/pvpz-collisions.png?pvpzts=${Date.now()}`
                                }
                            ]
                        }
                    ]
                }
            });
            (0, $fff9e028a285d5fa$export$c8eca95e306f7116).backgroundLoadBundle("game-assets");
            (0, $fff9e028a285d5fa$export$c8eca95e306f7116).loadBundle("game-assets", this._onLoadProgress.bind(this)).then(this._onLoadComplete.bind(this));
        } catch (e) {
            console.error("Caught error loading assets!");
            console.log(e);
        }
        this.LogInfo("Ready (ish)!");
    }
    _onLoadComplete() {
        this.LogInfo("Load complete!");
        this.AssetsFullyLoaded = true;
        Game.Rewards.LoadingComplete();
        const spritesAsset = (0, $fff9e028a285d5fa$export$c8eca95e306f7116).get("sprites");
        if (!spritesAsset) {
            this.LogError("Sprites asset not found!");
            throw new (0, $8debebb62d6d10fa$export$a22a9a8b98fa91fd)("Master sprites JSON asset not found!");
        }
        const spritesAssetData = spritesAsset.data;
        if (!spritesAssetData) {
            this.LogError("Incorrectly configured sprites JSON!");
            throw new (0, $8debebb62d6d10fa$export$a22a9a8b98fa91fd)("Master sprites JSON asset is malformed!");
        }
        const animations = spritesAssetData.animations;
        if (!animations) {
            this.LogError("No animations found in sprites JSON!");
            throw new (0, $8debebb62d6d10fa$export$a22a9a8b98fa91fd)("No animations found in sprites JSON!");
        }
        const textures = spritesAsset.textures;
        if (!textures) {
            this.LogError("No textures found in sprites JSON!");
            throw new (0, $8debebb62d6d10fa$export$a22a9a8b98fa91fd)("No textures found in sprites JSON!");
        }
        this.animations = animations;
        this.spriteSheetTextures = textures;
        Game.EmitEvent("Assets::Loaded");
    }
    GetAnimation(name) {
        const foundAnimation = this.animations[name];
        if (!foundAnimation) {
            this.LogError(`Animation ${name} not found!`);
            throw new (0, $8debebb62d6d10fa$export$a22a9a8b98fa91fd)(`Unable to find animation with name: ${name} in the loaded assets.`);
        }
        return foundAnimation;
    }
    GetSpritesheetTexture(name) {
        const foundTexture = this.spriteSheetTextures[name];
        // console.log(this.spriteSheetTextures);
        if (!foundTexture) {
            this.LogError(`Texture ${name} not found!`);
            throw new (0, $8debebb62d6d10fa$export$a22a9a8b98fa91fd)(`Unable to find texture with name: ${name} in the loaded assets.`);
        }
        return foundTexture;
    }
    _onLoadProgress(progress) {
        const progressAsPercentage = (0, $276f03d77ac4b507$export$7d15b64cf5a3a4c4)(Math.ceil(progress * 100), 0, 100);
        this.LogInfo(`Load progress %: ${progressAsPercentage}`);
        (0, $9b9fb0750f8f8ccb$export$fda554ce779f8ebc)(progressAsPercentage);
    }
    getSystemName() {
        return "Loader";
    }
    Update(__deltaTime) {}
    Cleanup() {}
}





const $6ece21d96ecc593d$export$c85ba824665b708f = {
    DEBUG: {
        // Game resizing for debugging/responsiveness testing
        ENABLE_EASY_RESIZABLE_GAME_CONTAINER: false,
        DEFAULT_GAME_VIEWPORT_WIDTH_IN_RESIZABLE_MODE: 1920,
        DEFAULT_GAME_VIEWPORT_HEIGHT_IN_RESIZABLE_MODE: 1080
    }
};






class $143e9eb050e49bf0$export$bcbbb686a6fc093 {
    constructor(createGridCellPayload){
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.RenderedEntity = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.inactiveGridCellVisual = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.activeGridCellVisual = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.gridCellBorderSize = 20;
        const { nid: nid , ntype: ntype , x: x , y: y , width: width , height: height , isActive: isActive  } = createGridCellPayload;
        this.nid = nid;
        this.ntype = ntype;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.isActive = isActive;
        this.inactiveGridCellVisual.lineStyle(this.gridCellBorderSize, 0x000000);
        this.inactiveGridCellVisual.drawRect(this.x, this.y, this.width, this.height);
        this.RenderedEntity.addChild(this.inactiveGridCellVisual);
        this.activeGridCellVisual.lineStyle(this.gridCellBorderSize, 0xffffff);
        this.activeGridCellVisual.drawRect(this.x + this.gridCellBorderSize, this.y + this.gridCellBorderSize, this.width - this.gridCellBorderSize * 2, this.height - this.gridCellBorderSize * 2);
        this.activeGridCellVisual.alpha = isActive ? 1 : 0;
        this.RenderedEntity.addChild(this.activeGridCellVisual);
    }
    set isActive(newValue) {
        this.activeGridCellVisual.alpha = newValue ? 1 : 0;
    }
    get x() {
        return this.position.x;
    }
    set x(newX) {
        this.position.x = newX;
    }
    get y() {
        return this.position.y;
    }
    set y(newY) {
        this.position.y = newY;
    }
    Update(__deltaTime) {}
}







class $f2e4e53c05f9bf48$export$f3d3dada4f7adfe6 {
    constructor(createExtractionPointPayload){
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.RenderedEntity = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.hitboxGraphics = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        const { nid: nid , ntype: ntype , x: x , y: y , width: width , height: height  } = createExtractionPointPayload;
        this.nid = nid;
        this.ntype = ntype;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.RenderedEntity.zIndex = y;
        // this.RenderedEntity.filters = [new ShockwaveFilter(this.RenderedEntity.position)];
        const topAnimation = Game.Loader.GetAnimation("pfx/extractEffect/effect_extractZone");
        const topFrames = new Array();
        for(let i = 0; i < topAnimation.length; i++)topFrames.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(topAnimation[i]));
        this.pfxSprite = new (0, $bef80d21b8b0b6b2$export$dae599798687ad3c)(topFrames);
        this.pfxSprite.position.set(this.width / 2, this.height / 2 - 8);
        this.pfxSprite.zIndex = y;
        this.pfxSprite.scale.set(1);
        this.pfxSprite.anchor.set(0.5, 0.5);
        this.pfxSprite.animationSpeed = 1 / 9;
        this.pfxSprite.play();
        this.RenderedEntity.addChild(this.pfxSprite);
        if ((0, $a9786bc83f165385$export$6890cbbf7baa7104).DEBUG.DRAW_COLLIDER) {
            this.hitboxGraphics.lineStyle(2, 0x00ff00);
            this.hitboxGraphics.drawRect(this.x, this.y, this.width, this.height);
            this.RenderedEntity.addChild(this.hitboxGraphics);
        }
    }
    get x() {
        return this.position.x;
    }
    set x(newX) {
        this.position.x = newX;
        this.RenderedEntity.x = this.x;
    }
    get y() {
        return this.position.y;
    }
    set y(newY) {
        this.position.y = newY;
        this.RenderedEntity.y = this.y;
    }
    Update(__deltaTime) {}
}



const $71d39c9303805e25$export$536e4cf7e28a219c = {
    MOVEMENT_COLLIDER_Y_OFFSET: 9,
    MOVEMENT_COLLIDER_RADIUS: 6,
    HITBOX_COLLIDER_WIDTH: 12,
    HITBOX_COLLIDER_HEIGHT: 20,
    // TODO: each enemy should probably define these separately
    AGGRO_COLLIDER_RADIUS: 180,
    MAX_CHASE_OUTER_COLLIDER_RADIUS: 300,
    MAX_CHASE_INNER_COLLIDER_RADIUS: 200,
    SPEED_PER_SECOND: 40,
    ATTACK_RANGE: 100,
    USE_PATHFINDING: true,
    DEBUG: {
        ALWAYS_DROP_LOOT: false,
        INSTANT_RESPAWNS: false,
        DISABLE_ALL_AI: false,
        AI_ARE_STATIC: false,
        // Centerpoint visual
        DRAW_CENTERPOINT: false,
        // Movement collider visuals
        DRAW_MOVEMENT_COLLIDER: false,
        // Hitbox collider visuals
        DRAW_HITBOX_COLLIDER: false,
        // Theoretical projectile origin indicator
        DRAW_PROJECTILE_ORIGIN_INDICATOR: false,
        // Show position text
        DRAW_POSITION_TEXT: false,
        // Show state
        DRAW_BEHAVIOUR_STATE: false,
        // Show state target position
        DRAW_BEHAVIOUR_DESTINATION: false,
        // Show the collider radius where upon a player entering the enemy will chase the player
        DRAW_AGGRO_RADIUS: false,
        // Show the collider radius where upon the AI enemy leaving will return to it's spawn
        DRAW_MAX_CHASE_RADIUS: false,
        // Pathfinding visualization
        DRAW_PATHFINDING_GRID: false
    }
};





var $6bb88083b1a56412$export$883c93106ef8cbe6;
(function(EnemyState) {
    EnemyState[EnemyState["None"] = -1] = "None";
    EnemyState[EnemyState["Dead"] = 0] = "Dead";
    EnemyState[EnemyState["Idle"] = 1] = "Idle";
    EnemyState[EnemyState["MoveToTargetPosition"] = 2] = "MoveToTargetPosition";
    EnemyState[EnemyState["MoveToTargetEntity"] = 3] = "MoveToTargetEntity";
    EnemyState[EnemyState["Attack"] = 4] = "Attack";
})($6bb88083b1a56412$export$883c93106ef8cbe6 || ($6bb88083b1a56412$export$883c93106ef8cbe6 = {}));





var $67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3;
(function(EnemySkin) {
    EnemySkin[EnemySkin["None"] = -1] = "None";
    EnemySkin[EnemySkin["Ghost"] = 0] = "Ghost";
    EnemySkin[EnemySkin["Skeleton"] = 1] = "Skeleton";
    EnemySkin[EnemySkin["Ogre"] = 2] = "Ogre";
    EnemySkin[EnemySkin["GiantRat"] = 3] = "GiantRat";
    EnemySkin[EnemySkin["Treant"] = 4] = "Treant";
    EnemySkin[EnemySkin["GRONK"] = 5] = "GRONK";
    EnemySkin[EnemySkin["DarkWizard"] = 6] = "DarkWizard";
    EnemySkin[EnemySkin["IronFox"] = 7] = "IronFox";
})($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3 || ($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3 = {}));
var $67a5d1338cb9fc3d$export$b44c453a2ac16d2a;
(function(EnemyClass) {
    EnemyClass[EnemyClass["Regular"] = 0] = "Regular";
    EnemyClass[EnemyClass["Boss"] = 1] = "Boss";
})($67a5d1338cb9fc3d$export$b44c453a2ac16d2a || ($67a5d1338cb9fc3d$export$b44c453a2ac16d2a = {}));
const $67a5d1338cb9fc3d$export$b05d30c6432c96df = new Map();
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.Ghost, {
    friendlyName: "Ghost",
    staticSpriteId: "sprites/enemies/ANIM_ghost01_base.png",
    idleFramesSpriteId: "enemies/ANIM_ghost01_idle",
    walkFramesSpriteId: "enemies/ANIM_ghost01_walk",
    attackFramesSpriteId: "enemies/ANIM_ghost01_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).BasicBlue,
    spriteYOffset: -15,
    spriteScale: 1,
    health: 30,
    attackDelay: 0,
    attackInterval: 0.5,
    numProjectilesPerAttack: 4,
    attackDamage: 3,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    lootDropChance: 0.5,
    hitboxWidth: 20,
    hitboxHeight: 23,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Regular,
    colliderYOffset: -15,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 15000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).Ghost
});
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.Skeleton, {
    friendlyName: "Skeleton",
    staticSpriteId: "sprites/enemies/ANIM_Skeleton01_base.png",
    idleFramesSpriteId: "enemies/ANIM_Skeleton01_idle",
    walkFramesSpriteId: "enemies/ANIM_Skeleton01_walk",
    attackFramesSpriteId: "enemies/ANIM_Skeleton01_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).FireSkull,
    spriteYOffset: -13,
    spriteScale: 1,
    health: 35,
    attackDelay: 0,
    attackInterval: 0.75,
    numProjectilesPerAttack: 2,
    attackDamage: 7,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Fire,
    lootDropChance: 0.6,
    hitboxWidth: 15,
    hitboxHeight: 25,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Regular,
    colliderYOffset: -10,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 15000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).Skeleton
});
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.Ogre, {
    friendlyName: "Ogre",
    staticSpriteId: "sprites/enemies/ANIM_bigGoblin_idle001.png",
    idleFramesSpriteId: "enemies/ANIM_bigGoblin_idle",
    walkFramesSpriteId: "enemies/ANIM_bigGoblin_walk",
    attackFramesSpriteId: "enemies/ANIM_bigGoblin_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).Boulder,
    spriteYOffset: -18,
    spriteScale: 1,
    health: 55,
    attackDelay: 0,
    attackInterval: 2,
    numProjectilesPerAttack: 1,
    attackDamage: 15,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    lootDropChance: 0.7,
    hitboxWidth: 22,
    hitboxHeight: 30,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Regular,
    colliderYOffset: -11,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 15000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).Ogre
});
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.GiantRat, {
    friendlyName: "Giant Rat",
    staticSpriteId: "sprites/enemies/ANIM_giantRat_idle001.png",
    idleFramesSpriteId: "enemies/ANIM_giantRat_idle",
    walkFramesSpriteId: "enemies/ANIM_giantRat_walk",
    attackFramesSpriteId: "enemies/ANIM_giantRat_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).ToxicClouds,
    spriteYOffset: -9,
    spriteScale: 1,
    health: 30,
    attackDelay: 0,
    attackInterval: 0.5,
    numProjectilesPerAttack: 5,
    attackDamage: 3,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Toxic,
    lootDropChance: 0.5,
    hitboxWidth: 15,
    hitboxHeight: 15,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Regular,
    colliderYOffset: -7,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 15000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).Rat
});
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.Treant, {
    friendlyName: "Treant",
    staticSpriteId: "sprites/enemies/ANIM_Treant_idle001.png",
    idleFramesSpriteId: "enemies/ANIM_Treant_idle",
    walkFramesSpriteId: "enemies/ANIM_Treant_walk",
    attackFramesSpriteId: "enemies/ANIM_Treant_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).MagicLeaf,
    spriteYOffset: -20,
    spriteScale: 1,
    health: 55,
    attackDelay: 0,
    attackInterval: 0.5,
    numProjectilesPerAttack: 4,
    attackDamage: 4,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Nature,
    lootDropChance: 0.5,
    hitboxWidth: 17,
    hitboxHeight: 35,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Regular,
    colliderYOffset: -15,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 15000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).Treant
});
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.GRONK, {
    friendlyName: "GRONK",
    staticSpriteId: "sprites/enemies/ANIM_bigGoblin_idle001.png",
    idleFramesSpriteId: "enemies/ANIM_bigGoblin_idle",
    walkFramesSpriteId: "enemies/ANIM_bigGoblin_walk",
    attackFramesSpriteId: "enemies/ANIM_bigGoblin_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).GRONKBoulder,
    spriteYOffset: -40,
    spriteScale: 2,
    health: 1225,
    attackDelay: 0,
    attackInterval: 0.5,
    numProjectilesPerAttack: 5,
    attackDamage: 10,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Physical,
    lootDropChance: 0,
    hitboxWidth: 30,
    hitboxHeight: 45,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Boss,
    colliderYOffset: -25,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 600000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).GRONK
});
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.DarkWizard, {
    friendlyName: "Dark Wizard",
    staticSpriteId: "sprites/enemies/darkwizard_idle1.png",
    idleFramesSpriteId: "enemies/darkwizard_idle",
    walkFramesSpriteId: "enemies/darkwizard_walk",
    attackFramesSpriteId: "enemies/darkwizard_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).LichSkull,
    spriteYOffset: -20,
    spriteScale: 1,
    health: 55,
    attackDelay: 0,
    attackInterval: 0.7,
    numProjectilesPerAttack: 3,
    attackDamage: 6,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Chaos,
    lootDropChance: 0.5,
    hitboxWidth: 17,
    hitboxHeight: 35,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Regular,
    colliderYOffset: -15,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 15000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).DarkWizard
});
$67a5d1338cb9fc3d$export$b05d30c6432c96df.set($67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3.IronFox, {
    friendlyName: "Iron Fox",
    staticSpriteId: "sprites/enemies/ANIM_ironFox_idle001.png",
    idleFramesSpriteId: "enemies/ANIM_ironFox_idle",
    walkFramesSpriteId: "enemies/ANIM_ironFox_walk",
    attackFramesSpriteId: "enemies/ANIM_ironFox_attack",
    attackProjectileId: (0, $21a778c44478d8dc$export$58825bda29b44ca2).IronFoxSlash,
    spriteYOffset: -35,
    spriteScale: 1,
    health: 1750,
    attackDelay: 0,
    attackInterval: 1,
    numProjectilesPerAttack: 2,
    attackDamage: 25,
    attackDamageType: (0, $faa1b3449016497b$export$b8f9e8b7bac978d5).Shadow,
    lootDropChance: 0,
    hitboxWidth: 25,
    hitboxHeight: 55,
    enemyClass: $67a5d1338cb9fc3d$export$b44c453a2ac16d2a.Boss,
    colliderYOffset: -32,
    respawnTimeInMilliseconds: (0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.INSTANT_RESPAWNS ? 1 : 600000,
    lootTable: (0, $faa1b3449016497b$export$27dd8d3f4f57d4c).IronFox
});


class $2259ea0bfb47d778$export$5cb5aaeeab988cb0 {
    constructor(enemySkin){
        this.nid = -1;
        this.ntype = (0, $282dc2f79e0204c8$export$f7cab339749a57d7).AIEntity;
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.velocity = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.prevPosition = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.isAlive = true;
        this.lastDamagedByNid = -1;
        this.maxHealth = 100 // Set upon construction of ServerAIEntity
        ;
        this.currentHealth = 100 // Set upon construction of ServerAIEntity
        ;
        this.currentHealthPercentage = 1;
        this.currentState = (0, $6bb88083b1a56412$export$883c93106ef8cbe6).None;
        this.spawnPosition = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.targetPosition = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.attackedThisFrame = false;
        this.hasLineOfSightWithTarget = false;
        this.AggroCollider = new (0, $2104f92cbe769454$exports.Circle)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), (0, $71d39c9303805e25$export$536e4cf7e28a219c).AGGRO_COLLIDER_RADIUS);
        this.MaxChaseOuterCollider = new (0, $2104f92cbe769454$exports.Circle)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), (0, $71d39c9303805e25$export$536e4cf7e28a219c).MAX_CHASE_OUTER_COLLIDER_RADIUS);
        this.MaxChaseInnerCollider = new (0, $2104f92cbe769454$exports.Circle)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), (0, $71d39c9303805e25$export$536e4cf7e28a219c).MAX_CHASE_INNER_COLLIDER_RADIUS);
        const enemySkinData = (0, $67a5d1338cb9fc3d$export$b05d30c6432c96df).get(enemySkin);
        this.enemySkinData = enemySkinData;
        this.HitboxCollider = new (0, $2104f92cbe769454$exports.Box)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), enemySkinData.hitboxWidth, enemySkinData.hitboxHeight).toPolygon();
    }
    get x() {
        return this.position.x;
    }
    set x(newX) {
        this.position.x = newX;
        this.HitboxCollider.pos.x = this.x - this.enemySkinData.hitboxWidth / 2;
        this.AggroCollider.pos.x = this.x;
        this.MaxChaseOuterCollider.pos.x = this.spawnPosition.x;
        this.MaxChaseInnerCollider.pos.x = this.spawnPosition.x;
    }
    get y() {
        return this.position.y;
    }
    set y(newY) {
        this.position.y = newY;
        this.HitboxCollider.pos.y = this.y - this.enemySkinData.hitboxHeight / 2 + this.enemySkinData.colliderYOffset;
        this.AggroCollider.pos.y = this.y;
        this.MaxChaseOuterCollider.pos.y = this.spawnPosition.y;
        this.MaxChaseInnerCollider.pos.y = this.spawnPosition.y;
    }
    get prevX() {
        return this.prevPosition.x;
    }
    set prevX(newX) {
        this.prevPosition.x = newX;
    }
    get prevY() {
        return this.prevPosition.y;
    }
    set prevY(newY) {
        this.prevPosition.y = newY;
    }
    get spawnX() {
        return this.spawnPosition.x;
    }
    set spawnX(newX) {
        this.spawnPosition.x = newX;
    }
    get spawnY() {
        return this.spawnPosition.y;
    }
    set spawnY(newY) {
        this.spawnPosition.y = newY;
    }
    get targetX() {
        return this.targetPosition.x;
    }
    set targetX(newX) {
        this.targetPosition.x = newX;
    }
    get targetY() {
        return this.targetPosition.y;
    }
    set targetY(newY) {
        this.targetPosition.y = newY;
    }
    // public get debug_pathfindingTileIndices(): number[] {
    //     return this._debug_pathfindingTileIndices;
    // }
    // public set debug_pathfindingTileIndices(newTileIndices: number[]) {
    //     this._debug_pathfindingTileIndices = newTileIndices;
    // }
    Move(deltaTime) {
        this.prevX = this.x;
        this.prevY = this.y;
        const cappedVelocityMagnitude = Math.sqrt(this.velocity.x * this.velocity.x + this.velocity.y * this.velocity.y);
        if (cappedVelocityMagnitude !== 0) {
            this.velocity.x /= cappedVelocityMagnitude;
            this.velocity.y /= cappedVelocityMagnitude;
        }
        this.x = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(this.x + this.velocity.x * ((0, $71d39c9303805e25$export$536e4cf7e28a219c).SPEED_PER_SECOND * deltaTime));
        this.y = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(this.y + this.velocity.y * ((0, $71d39c9303805e25$export$536e4cf7e28a219c).SPEED_PER_SECOND * deltaTime));
    }
    Update(__deltaTime, __currentTimeInMilliseconds) {}
    TakeDamage(__damage, __damageType, __damageDealerNid, __npcDamageModifier) {}
    SetTargetPlayer(__targetPlayerEntity) {}
    GetTargetPlayer() {
        return null;
    }
}





class $e182978755a91fde$export$960dc136cdb74743 extends (0, $2259ea0bfb47d778$export$5cb5aaeeab988cb0) {
    constructor(createAIEntityPayload){
        const { nid: nid , x: x , y: y , isAlive: isAlive , currentHealthPercentage: currentHealthPercentage , enemySkin: enemySkin , currentState: currentState , spawnX: spawnX , spawnY: spawnY , targetX: targetX , targetY: targetY , attackedThisFrame: attackedThisFrame  } = createAIEntityPayload;
        super(enemySkin);
        this.debugRotatingVisualsParent = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.debugPathfindingVisualParent = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.wasDeadOnInit = false;
        this.RenderedEntity = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.healthBarContainer = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.healthBarWidth = 25;
        this.healthBarHeight = 3;
        this.healthBarHeightOffset = 20;
        this.animationSpeed = 1 / 9;
        this.lastKnownLivelihoodState = true;
        this.lastKnownHealthPercentage = 1;
        this.lastTookDamageTimestamp = 0;
        this.damageTakenFlashDurationInMilliseconds = 250;
        this.damageTakenFlashColor = 0xff0000;
        this.timeBeforeHealthBarFadesInMilliseconds = 1500;
        this.nid = nid;
        this.enemySkin = enemySkin;
        // console.warn("Set enemy config for enemy:", this.enemySkinData);
        this.characterSpriteIdleAnimationId = this.enemySkinData.idleFramesSpriteId;
        this.characterSpriteWalkAnimationId = this.enemySkinData.walkFramesSpriteId;
        this.characterSpriteAttackAnimationId = this.enemySkinData.attackFramesSpriteId;
        this.characterSpriteYOffset = this.enemySkinData.spriteYOffset;
        this.characterSpriteScale = this.enemySkinData.spriteScale;
        this.healthBarHeightOffset = this.enemySkinData.spriteYOffset + 22;
        this.x = x;
        this.y = y;
        this.RenderedEntity.x = x;
        this.RenderedEntity.y = y;
        this.RenderedEntity.zIndex = y;
        this.spawnPosition.x = spawnX;
        this.spawnPosition.y = spawnY;
        this.targetPosition.x = targetX;
        this.targetPosition.y = targetY;
        this.attackedThisFrame = attackedThisFrame;
        // this.debug_pathfindingTileIndices = debug_pathfindingTileIndices;
        this.currentState = currentState;
        this.isAlive = isAlive;
        if (this.isAlive === false) this.wasDeadOnInit = true;
        this.lastKnownLivelihoodState = isAlive;
        this.currentHealthPercentage = currentHealthPercentage;
        this._setupCharacterVisuals();
        this._setupDebugVisuals();
        this.RenderedEntity.addChild(this.debugRotatingVisualsParent);
        this.RenderedEntity.addChild(this.debugPathfindingVisualParent);
        // Hide dead entities when they are first created (as this is indicative of them already being in thet process of being destroyed, no point in showing them on this client)
        if (this.isAlive === false) this._die();
    }
    _die() {
        // console.log("Enemy died!");
        Game.Renderer.PlayOneOffPfx(this.x, this.y + this.characterSpriteYOffset, "pfx/death/effect_death", 1, 1, 1);
        this.lastKnownLivelihoodState = false;
        this._hideVisuals();
    }
    _setupCharacterVisuals() {
        //#region Enemy Character
        /****************************************/ /*                                      */ /*             Character                */ /*                                      */ /****************************************/ const idleAnimation = Game.Loader.GetAnimation(this.characterSpriteIdleAnimationId);
        const movingAnimation = Game.Loader.GetAnimation(this.characterSpriteWalkAnimationId);
        const attackAnimation = Game.Loader.GetAnimation(this.characterSpriteAttackAnimationId);
        this.idleFrames = new Array();
        for(let i = 0; i < idleAnimation.length; i++)this.idleFrames.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(idleAnimation[i]));
        this.walkFrames = new Array();
        for(let i = 0; i < movingAnimation.length; i++)this.walkFrames.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(movingAnimation[i]));
        this.attackFrames = new Array();
        for(let i = 0; i < attackAnimation.length; i++)this.attackFrames.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(attackAnimation[i]));
        this.characterSprite = new (0, $bef80d21b8b0b6b2$export$dae599798687ad3c)(this.idleFrames);
        this.characterSprite.position.y = this.characterSpriteYOffset;
        this.characterSprite.scale.set(this.characterSpriteScale);
        this.characterSprite.anchor.set(0.5, 0.5);
        this.characterSprite.animationSpeed = this.animationSpeed;
        this.characterSprite.play();
        this.RenderedEntity.addChild(this.characterSprite);
        //#endregion
        //#region Username
        /****************************************/ /*                                      */ /*              Name                    */ /*                                      */ /****************************************/ if (this.enemySkinData.enemyClass === (0, $67a5d1338cb9fc3d$export$b44c453a2ac16d2a).Boss) {
            this.nameText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(this.enemySkinData.friendlyName, {
                fontFamily: "alagardmedium",
                fontSize: 96,
                fill: 0x8b0000,
                dropShadow: true,
                dropShadowDistance: 10
            });
            this.nameText.scale.set(0.15);
            this.nameText.anchor.set(0.5, 0.5);
            if (this.enemySkin === (0, $67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3).GRONK) this.nameText.y += this.enemySkinData.spriteYOffset - 25;
            else if (this.enemySkin === (0, $67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3).IronFox) this.nameText.y += this.enemySkinData.spriteYOffset - 35;
            else this.nameText.y += this.enemySkinData.spriteYOffset - 20;
            this.RenderedEntity.addChild(this.nameText);
        }
        //#endregion
        //#region Health Text
        /****************************************/ /*                                      */ /*              Health Text             */ /*                                      */ /****************************************/ if (Game.Renderer.MyLocalEntityHasInformationPassive) {
            this.healthText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(`${Math.ceil(this.currentHealthPercentage * 100)}/100`, {
                fontFamily: "alagardmedium",
                fontSize: 56,
                fill: 0xffffff
            });
            this.healthText.scale.set(0.15);
            this.healthText.anchor.set(0.5, 0.5);
            if (this.enemySkin === (0, $67a5d1338cb9fc3d$export$abf2d4e2c37ad5e3).GiantRat) this.healthText.y -= 20;
            else this.healthText.y -= 35;
            this.RenderedEntity.addChild(this.healthText);
        }
        //#endregion
        //#region Health Bar
        /****************************************/ /*                                      */ /*              Healthbar               */ /*                                      */ /****************************************/ // Create the healthBarBackground rectangle
        this.healthBarBackground = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.healthBarBackground.beginFill(0x000000);
        this.healthBarBackground.drawRect(0 - this.healthBarWidth / 2, this.healthBarHeightOffset, this.healthBarWidth, this.healthBarHeight);
        this.healthBarBackground.endFill();
        this.healthBarContainer.addChild(this.healthBarBackground);
        // Create the foreground rectangle
        this.healthBarForeground = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.healthBarForeground.beginFill(0xff0000);
        this.healthBarForeground.drawRect(0 - this.healthBarWidth / 2, this.healthBarHeightOffset, this.healthBarWidth, this.healthBarHeight);
        this.healthBarForeground.endFill();
        this.healthBarContainer.addChild(this.healthBarForeground);
        // Position the healthBarForeground rectangle relative to the healthBarBackground rectangle
        this.healthBarForeground.position.x = this.healthBarBackground.position.x;
        this.healthBarForeground.position.y = this.healthBarBackground.position.y;
        // Set the mask for the healthBarForeground rectangle to be a rectangle with the same dimensions as the background rectangle
        this.healthBarForeground.mask = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.healthBarForeground.mask.beginFill(0xffffff);
        this.healthBarForeground.mask.drawRect(0 - this.healthBarWidth / 2, this.healthBarHeightOffset, this.healthBarWidth, this.healthBarHeight);
        this.healthBarForeground.mask.endFill();
        this.healthBarContainer.addChild(this.healthBarForeground.mask);
        if (Game.Renderer.MyLocalEntityHasInformationPassive === false) this.healthBarContainer.alpha = 0;
        if (this.enemySkinData.enemyClass === (0, $67a5d1338cb9fc3d$export$b44c453a2ac16d2a).Boss) {
            this.healthBarContainer.scale.set(1.5);
            this.healthBarContainer.y += 30;
            if (this.healthText !== undefined) {
                this.healthText.scale.set(0.3);
                this.healthText.y += 50;
            }
        }
        this.RenderedEntity.addChild(this.healthBarContainer);
    //#endregion
    }
    _setupDebugVisuals() {
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_HITBOX_COLLIDER) {
            this.debugHitboxCollider = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            // this.debugHitboxCollider.beginFill(0x000000);
            this.debugHitboxCollider.lineStyle(1, 0x000000);
            this.debugHitboxCollider.drawRect(0 - this.enemySkinData.hitboxWidth / 2, 0 - this.enemySkinData.hitboxHeight / 2 + this.enemySkinData.colliderYOffset, this.enemySkinData.hitboxWidth, this.enemySkinData.hitboxHeight);
            this.debugHitboxCollider.endFill();
            this.RenderedEntity.addChild(this.debugHitboxCollider);
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_CENTERPOINT) {
            this.debugCenterpoint = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugCenterpoint.beginFill(0xffffff);
            this.debugCenterpoint.drawCircle(0, 0, 2);
            this.debugCenterpoint.endFill();
            this.debugRotatingVisualsParent.addChild(this.debugCenterpoint);
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_POSITION_TEXT) {
            this.debugPositionText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(`${Math.floor(this.x)}x, ${Math.floor(this.y)}y`, {
                fontFamily: "alagardmedium",
                fontSize: 64,
                fill: 0xffffff
            });
            this.debugPositionText.scale.set(0.1);
            this.debugPositionText.anchor.set(0.5, 0.5);
            this.debugPositionText.y += 30;
            this.RenderedEntity.addChild(this.debugPositionText);
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_BEHAVIOUR_STATE) {
            this.debugStateText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)(`State: ${(0, $6bb88083b1a56412$export$883c93106ef8cbe6)[this.currentState]}`, {
                fontFamily: "alagardmedium",
                fontSize: 64,
                fill: 0xffffff
            });
            this.debugStateText.scale.set(0.1);
            this.debugStateText.anchor.set(0.5, 0.5);
            this.debugStateText.y += 40;
            this.RenderedEntity.addChild(this.debugStateText);
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_AGGRO_RADIUS) {
            this.debugAggroCollider = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugAggroCollider.lineStyle(1, 0xff0000);
            this.debugAggroCollider.drawCircle(0, 0, (0, $71d39c9303805e25$export$536e4cf7e28a219c).AGGRO_COLLIDER_RADIUS);
            this.debugAggroCollider.endFill();
            this.RenderedEntity.addChild(this.debugAggroCollider);
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_MAX_CHASE_RADIUS) {
            this.debugMaxChaseCollider = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugMaxChaseCollider.lineStyle(1, 0x00ff00);
            this.debugMaxChaseCollider.drawCircle(0, 0, (0, $71d39c9303805e25$export$536e4cf7e28a219c).MAX_CHASE_OUTER_COLLIDER_RADIUS);
            this.debugMaxChaseCollider.endFill();
            this.debugMaxChaseCollider.lineStyle(1, 0x00ff00);
            this.debugMaxChaseCollider.drawCircle(0, 0, (0, $71d39c9303805e25$export$536e4cf7e28a219c).MAX_CHASE_INNER_COLLIDER_RADIUS);
            this.debugMaxChaseCollider.endFill();
            this.RenderedEntity.addChild(this.debugMaxChaseCollider);
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_BEHAVIOUR_DESTINATION) {
            this.debugTargetPosition = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugTargetPosition.lineStyle(1, 0x00ff00);
            this.debugTargetPosition.lineTo(this.targetPosition.x, this.targetPosition.y);
            this.debugTargetPosition.endFill();
            this.RenderedEntity.addChild(this.debugTargetPosition);
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_PATHFINDING_GRID) {
            this.debugPathfindingNodes = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
            this.debugPathfindingVisualParent.addChild(this.debugPathfindingNodes);
        }
    }
    _showVisuals() {
        this.RenderedEntity.alpha = 1;
    }
    _fadeVisuals() {
        this.RenderedEntity.alpha = 0.3;
    }
    _hideVisuals() {
        this.RenderedEntity.alpha = 0;
    }
    // TODO make damage flashes better, likely via the pixi-heaven plugin
    _triggerDamageFlash() {
        this.characterSprite.tint = this.damageTakenFlashColor;
    }
    _undoDamageFlash() {
        this.characterSprite.tint = 0xffffff;
    }
    _updateCharacterVisuals(deltaTime, currentTimeInMilliseconds) {
        if (this.currentHealthPercentage !== this.lastKnownHealthPercentage) {
            this.healthBarContainer.alpha = 1;
            this._triggerDamageFlash();
            this.lastTookDamageTimestamp = currentTimeInMilliseconds;
            this.lastKnownHealthPercentage = this.currentHealthPercentage;
            if (Game.Renderer.MyLocalEntityHasInformationPassive) {
                if (this.healthText !== undefined) this.healthText.text = `${Math.ceil(this.currentHealthPercentage * 100)}/100`;
            }
        }
        const timeSinceLastTookDamage = currentTimeInMilliseconds - this.lastTookDamageTimestamp;
        if (timeSinceLastTookDamage > this.timeBeforeHealthBarFadesInMilliseconds && Game.Renderer.MyLocalEntityHasInformationPassive === false) this.healthBarContainer.alpha -= deltaTime;
        if (timeSinceLastTookDamage > this.damageTakenFlashDurationInMilliseconds) this._undoDamageFlash();
        if (this.x !== this.clientLastFrameX || this.y !== this.clientLastFrameY) this.isMovingThisFrame = true;
        else this.isMovingThisFrame = false;
        this.RenderedEntity.x = this.x;
        this.RenderedEntity.y = this.y;
        this.RenderedEntity.zIndex = this.y;
        if (this.wasMovingLastFrame === true && this.isMovingThisFrame === false) {
            this.characterSprite.textures = this.idleFrames;
            this.characterSprite.play();
        }
        if (this.wasMovingLastFrame === false && this.isMovingThisFrame === true) {
            this.characterSprite.textures = this.walkFrames;
            this.characterSprite.play();
        }
        if (this.attackedThisFrame === true) {
            this.isAttacking = true;
            this.characterSprite.loop = false;
            this.characterSprite.textures = this.attackFrames;
            this.characterSprite.onComplete = this.onAttackAnimComplete.bind(this);
            this.characterSprite.play();
        }
        if (this.healthBarForeground !== undefined) this.healthBarForeground.mask.width = this.currentHealthPercentage * this.healthBarWidth;
        // Strictly greater than for movement direction change, for no movement (same x) stay facing the same direction
        if (this.x > this.clientLastFrameX) this.characterSprite.scale.x = this.characterSpriteScale; // Left
        else if (this.x < this.clientLastFrameX) this.characterSprite.scale.x = -this.characterSpriteScale; // Right
        this.clientLastFrameX = this.x;
        this.clientLastFrameY = this.y;
        this.wasMovingLastFrame = this.isMovingThisFrame;
    }
    onAttackAnimComplete() {
        if (this.attackedThisFrame === true) {
            this.isAttacking = true;
            this.characterSprite.loop = false;
            this.characterSprite.textures = this.attackFrames;
            this.characterSprite.play();
            this.characterSprite.onComplete = this.onAttackAnimComplete.bind(this);
        } else if (this.isMovingThisFrame === false) {
            this.isAttacking = false;
            this.characterSprite.loop = true;
            this.characterSprite.textures = this.idleFrames;
            this.characterSprite.play();
            this.characterSprite.onComplete = undefined;
        } else if (this.isMovingThisFrame === true) {
            this.isAttacking = false;
            this.characterSprite.loop = true;
            this.characterSprite.textures = this.walkFrames;
            this.characterSprite.play();
            this.characterSprite.onComplete = undefined;
        }
    }
    _updateDebugVisuals(deltaTime) {
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_POSITION_TEXT) this.debugPositionText.text = `${Math.floor(this.x)}x, ${Math.floor(this.y)}y`;
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_BEHAVIOUR_STATE) this.debugStateText.text = `State: ${(0, $6bb88083b1a56412$export$883c93106ef8cbe6)[this.currentState]}`;
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_MAX_CHASE_RADIUS) {
            this.debugMaxChaseCollider.x = this.spawnPosition.x - this.x;
            this.debugMaxChaseCollider.y = this.spawnPosition.y - this.y;
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_BEHAVIOUR_DESTINATION) {
            this.debugTargetPosition.clear();
            this.debugTargetPosition.lineStyle(1, this.hasLineOfSightWithTarget ? 0x00ff00 : 0xff0000);
            this.debugTargetPosition.lineTo(this.targetPosition.x - this.x, this.targetPosition.y - this.y);
            this.debugTargetPosition.endFill();
        }
        if ((0, $71d39c9303805e25$export$536e4cf7e28a219c).DEBUG.DRAW_PATHFINDING_GRID) {
            // World space
            this.debugPathfindingVisualParent.x = -this.x;
            this.debugPathfindingVisualParent.y = -this.y;
        }
    }
    _updatePathfindingVisuals() {
    // if (enemyConfig.DEBUG.DRAW_PATHFINDING_GRID && this.debugPathfindingNodes != null) {
    //     this.debugPathfindingNodes.clear();
    //     const worldWidth = worldConfig.WORLD_SIZE / pathfindingConfig.TILE_SIZE;
    //     const worldHeight = worldConfig.WORLD_SIZE / pathfindingConfig.TILE_SIZE;
    //     for (let i = 0; i < this._debug_pathfindingTileIndices.length; i++) {
    //         const tileIndex = this._debug_pathfindingTileIndices[i];
    //         const column = Math.floor(tileIndex % worldWidth);
    //         const row = Math.floor(tileIndex / worldHeight);
    //         const xPosition = column * pathfindingConfig.TILE_SIZE;
    //         const yPosition = row * pathfindingConfig.TILE_SIZE;
    //         this.debugPathfindingNodes.lineStyle(2, 0x0000ff);
    //         this.debugPathfindingNodes.beginFill(0x000099);
    //         this.debugPathfindingNodes.drawCircle(xPosition + 8, yPosition + 8, 4);
    //         this.debugPathfindingNodes.endFill();
    //     }
    // }
    }
    // public override set debug_pathfindingTileIndices(newTileIndices: number[]) {
    //     this._debug_pathfindingTileIndices = newTileIndices;
    //     this._updatePathfindingVisuals();
    // }
    Update(deltaTime, currentTimeInMilliseconds) {
        if (this.wasDeadOnInit === true) return;
        if (this.isAlive === false && this.lastKnownLivelihoodState === true) {
            this._die();
            return;
        }
        super.Update(deltaTime);
        this._updateCharacterVisuals(deltaTime, currentTimeInMilliseconds);
        this._updateDebugVisuals(deltaTime);
    }
}






const $29cfa5e220cdc813$export$26773e6fd5f813db = {
    ITEM_CONTAINER_COLLIDER_RADIUS: 30,
    DEBUG: {
        OVERRIDE_ITEMS_ROLLED_QUANTITY: 0,
        DRAW_ITEM_CONTAINER_COLLIDER: false,
        CHESTS_DROP_A_TON_OF_ITEMS: false
    }
};






class $25c340da2a552010$export$c990932bfb0dc07b {
    constructor(x, y){
        this.nid = -1;
        this.ntype = (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ItemContainerEntity;
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.HitboxCollider = new (0, $2104f92cbe769454$exports.Circle)(new (0, $2104f92cbe769454$exports.Vector)(0, 0), 0);
        this.x = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(x);
        this.y = (0, $276f03d77ac4b507$export$b13c16d22ae33620)(y);
        this.HitboxCollider = new (0, $2104f92cbe769454$exports.Circle)(new (0, $2104f92cbe769454$exports.Vector)(x, y), (0, $29cfa5e220cdc813$export$26773e6fd5f813db).ITEM_CONTAINER_COLLIDER_RADIUS);
    }
    get x() {
        return this.position.x;
    }
    set x(newX) {
        this.position.x = newX;
        this.HitboxCollider.pos.x = this.x;
    }
    get y() {
        return this.position.y;
    }
    set y(newY) {
        this.position.y = newY;
        this.HitboxCollider.pos.y = this.y;
    }
    Update(__deltaTime, __currentTimeInMilliseconds) {}
}


/*!
 * pixi-filters - v5.2.1
 * Compiled Fri, 24 Mar 2023 22:12:11 UTC
 *
 * pixi-filters is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /*!
 * @pixi/filter-adjustment - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-adjustment is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $2a9f94ca6af1543e$var$e = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $2a9f94ca6af1543e$var$o = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform float gamma;
uniform float contrast;
uniform float saturation;
uniform float brightness;
uniform float red;
uniform float green;
uniform float blue;
uniform float alpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (c.a > 0.0) {
        c.rgb /= c.a;

        vec3 rgb = pow(c.rgb, vec3(1. / gamma));
        rgb = mix(vec3(.5), mix(vec3(dot(vec3(.2125, .7154, .0721), rgb)), rgb, saturation), contrast);
        rgb.r *= red;
        rgb.g *= green;
        rgb.b *= blue;
        c.rgb = rgb * brightness;

        c.rgb *= c.a;
    }

    gl_FragColor = c * alpha;
}
`;
class $2a9f94ca6af1543e$export$9ac29bfc5603b2cd extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(t){
        super($2a9f94ca6af1543e$var$e, $2a9f94ca6af1543e$var$o), this.gamma = 1, this.saturation = 1, this.contrast = 1, this.brightness = 1, this.red = 1, this.green = 1, this.blue = 1, this.alpha = 1, Object.assign(this, t);
    }
    apply(t, r, n, i) {
        this.uniforms.gamma = Math.max(this.gamma, 1e-4), this.uniforms.saturation = this.saturation, this.uniforms.contrast = this.contrast, this.uniforms.brightness = this.brightness, this.uniforms.red = this.red, this.uniforms.green = this.green, this.uniforms.blue = this.blue, this.uniforms.alpha = this.alpha, t.applyFilter(this, r, n, i);
    }
}


/*!
 * @pixi/filter-advanced-bloom - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-advanced-bloom is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
/*!
 * @pixi/filter-kawase-blur - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-kawase-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $950238d694024b6e$var$c = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $950238d694024b6e$var$v = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec2 uOffset;

void main(void)
{
    vec4 color = vec4(0.0);

    // Sample top left pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y));

    // Sample top right pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y));

    // Sample bottom right pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y));

    // Sample bottom left pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y));

    // Average
    color *= 0.25;

    gl_FragColor = color;
}`, $950238d694024b6e$var$y = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec2 uOffset;
uniform vec4 filterClamp;

void main(void)
{
    vec4 color = vec4(0.0);

    // Sample top left pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y), filterClamp.xy, filterClamp.zw));

    // Sample top right pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y), filterClamp.xy, filterClamp.zw));

    // Sample bottom right pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y), filterClamp.xy, filterClamp.zw));

    // Sample bottom left pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y), filterClamp.xy, filterClamp.zw));

    // Average
    color *= 0.25;

    gl_FragColor = color;
}
`;
class $950238d694024b6e$export$31164edf0fb20199 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e = 4, t = 3, i = !1){
        super($950238d694024b6e$var$c, i ? $950238d694024b6e$var$y : $950238d694024b6e$var$v), this._kernels = [], this._blur = 4, this._quality = 3, this.uniforms.uOffset = new Float32Array(2), this._pixelSize = new (0, $88931fa1c0809be8$export$baf26146a414f24a), this.pixelSize = 1, this._clamp = i, Array.isArray(e) ? this.kernels = e : (this._blur = e, this.quality = t);
    }
    apply(e, t, i, o) {
        const n = this._pixelSize.x / t._frame.width, l = this._pixelSize.y / t._frame.height;
        let r;
        if (this._quality === 1 || this._blur === 0) r = this._kernels[0] + .5, this.uniforms.uOffset[0] = r * n, this.uniforms.uOffset[1] = r * l, e.applyFilter(this, t, i, o);
        else {
            const x = e.getFilterTexture();
            let s = t, u = x, f;
            const p = this._quality - 1;
            for(let a = 0; a < p; a++)r = this._kernels[a] + .5, this.uniforms.uOffset[0] = r * n, this.uniforms.uOffset[1] = r * l, e.applyFilter(this, s, u, 1), f = s, s = u, u = f;
            r = this._kernels[p] + .5, this.uniforms.uOffset[0] = r * n, this.uniforms.uOffset[1] = r * l, e.applyFilter(this, s, i, o), e.returnFilterTexture(x);
        }
    }
    _updatePadding() {
        this.padding = Math.ceil(this._kernels.reduce((e, t)=>e + t + .5, 0));
    }
    _generateKernels() {
        const e = this._blur, t = this._quality, i = [
            e
        ];
        if (e > 0) {
            let o = e;
            const n = e / t;
            for(let l = 1; l < t; l++)o -= n, i.push(o);
        }
        this._kernels = i, this._updatePadding();
    }
    get kernels() {
        return this._kernels;
    }
    set kernels(e) {
        Array.isArray(e) && e.length > 0 ? (this._kernels = e, this._quality = e.length, this._blur = Math.max(...e)) : (this._kernels = [
            0
        ], this._quality = 1);
    }
    get clamp() {
        return this._clamp;
    }
    set pixelSize(e) {
        typeof e == "number" ? (this._pixelSize.x = e, this._pixelSize.y = e) : Array.isArray(e) ? (this._pixelSize.x = e[0], this._pixelSize.y = e[1]) : e instanceof (0, $88931fa1c0809be8$export$baf26146a414f24a) ? (this._pixelSize.x = e.x, this._pixelSize.y = e.y) : (this._pixelSize.x = 1, this._pixelSize.y = 1);
    }
    get pixelSize() {
        return this._pixelSize;
    }
    get quality() {
        return this._quality;
    }
    set quality(e) {
        this._quality = Math.max(1, Math.round(e)), this._generateKernels();
    }
    get blur() {
        return this._blur;
    }
    set blur(e) {
        this._blur = e, this._generateKernels();
    }
}


var $8545026179246cad$var$a = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $8545026179246cad$var$m = `
uniform sampler2D uSampler;
varying vec2 vTextureCoord;

uniform float threshold;

void main() {
    vec4 color = texture2D(uSampler, vTextureCoord);

    // A simple & fast algorithm for getting brightness.
    // It's inaccuracy , but good enought for this feature.
    float _max = max(max(color.r, color.g), color.b);
    float _min = min(min(color.r, color.g), color.b);
    float brightness = (_max + _min) * 0.5;

    if(brightness > threshold) {
        gl_FragColor = color;
    } else {
        gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
    }
}
`;
class $8545026179246cad$var$x extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(r = .5){
        super($8545026179246cad$var$a, $8545026179246cad$var$m), this.threshold = r;
    }
    get threshold() {
        return this.uniforms.threshold;
    }
    set threshold(r) {
        this.uniforms.threshold = r;
    }
}
var $8545026179246cad$var$g = `uniform sampler2D uSampler;
varying vec2 vTextureCoord;

uniform sampler2D bloomTexture;
uniform float bloomScale;
uniform float brightness;

void main() {
    vec4 color = texture2D(uSampler, vTextureCoord);
    color.rgb *= brightness;
    vec4 bloomColor = vec4(texture2D(bloomTexture, vTextureCoord).rgb, 0.0);
    bloomColor.rgb *= bloomScale;
    gl_FragColor = color + bloomColor;
}
`;
const $8545026179246cad$var$c = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(t){
        super($8545026179246cad$var$a, $8545026179246cad$var$g), this.bloomScale = 1, this.brightness = 1, this._resolution = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).FILTER_RESOLUTION, typeof t == "number" && (t = {
            threshold: t
        });
        const r = Object.assign($8545026179246cad$var$c.defaults, t);
        this.bloomScale = r.bloomScale, this.brightness = r.brightness;
        const { kernels: l , blur: i , quality: s , pixelSize: o , resolution: e  } = r;
        this._extractFilter = new $8545026179246cad$var$x(r.threshold), this._extractFilter.resolution = e, this._blurFilter = l ? new (0, $950238d694024b6e$export$31164edf0fb20199)(l) : new (0, $950238d694024b6e$export$31164edf0fb20199)(i, s), this.pixelSize = o, this.resolution = e;
    }
    apply(t, r, l, i, s) {
        const o = t.getFilterTexture();
        this._extractFilter.apply(t, r, o, 1, s);
        const e = t.getFilterTexture();
        this._blurFilter.apply(t, o, e, 1), this.uniforms.bloomScale = this.bloomScale, this.uniforms.brightness = this.brightness, this.uniforms.bloomTexture = e, t.applyFilter(this, r, l, i), t.returnFilterTexture(e), t.returnFilterTexture(o);
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(t) {
        this._resolution = t, this._extractFilter && (this._extractFilter.resolution = t), this._blurFilter && (this._blurFilter.resolution = t);
    }
    get threshold() {
        return this._extractFilter.threshold;
    }
    set threshold(t) {
        this._extractFilter.threshold = t;
    }
    get kernels() {
        return this._blurFilter.kernels;
    }
    set kernels(t) {
        this._blurFilter.kernels = t;
    }
    get blur() {
        return this._blurFilter.blur;
    }
    set blur(t) {
        this._blurFilter.blur = t;
    }
    get quality() {
        return this._blurFilter.quality;
    }
    set quality(t) {
        this._blurFilter.quality = t;
    }
    get pixelSize() {
        return this._blurFilter.pixelSize;
    }
    set pixelSize(t) {
        this._blurFilter.pixelSize = t;
    }
};
let $8545026179246cad$export$b970daeca74b07ea = $8545026179246cad$var$c;
$8545026179246cad$export$b970daeca74b07ea.defaults = {
    threshold: .5,
    bloomScale: 1,
    brightness: 1,
    kernels: null,
    blur: 8,
    quality: 4,
    pixelSize: 1,
    resolution: (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).FILTER_RESOLUTION
};


/*!
 * @pixi/filter-ascii - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-ascii is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $6c70ac0e52948134$var$o = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $6c70ac0e52948134$var$r = `varying vec2 vTextureCoord;

uniform vec4 filterArea;
uniform float pixelSize;
uniform sampler2D uSampler;

vec2 mapCoord( vec2 coord )
{
    coord *= filterArea.xy;
    coord += filterArea.zw;

    return coord;
}

vec2 unmapCoord( vec2 coord )
{
    coord -= filterArea.zw;
    coord /= filterArea.xy;

    return coord;
}

vec2 pixelate(vec2 coord, vec2 size)
{
    return floor(coord / size) * size;
}

vec2 getMod(vec2 coord, vec2 size)
{
    return mod(coord, size) / size;
}

float character(float n, vec2 p)
{
    p = floor(p*vec2(4.0, 4.0) + 2.5);

    if (clamp(p.x, 0.0, 4.0) == p.x)
    {
        if (clamp(p.y, 0.0, 4.0) == p.y)
        {
            if (int(mod(n/exp2(p.x + 5.0*p.y), 2.0)) == 1) return 1.0;
        }
    }
    return 0.0;
}

void main()
{
    vec2 coord = mapCoord(vTextureCoord);

    // get the grid position
    vec2 pixCoord = pixelate(coord, vec2(pixelSize));
    pixCoord = unmapCoord(pixCoord);

    // sample the color at grid position
    vec4 color = texture2D(uSampler, pixCoord);

    // brightness of the color as it's perceived by the human eye
    float gray = 0.3 * color.r + 0.59 * color.g + 0.11 * color.b;

    // determine the character to use
    float n =  65536.0;             // .
    if (gray > 0.2) n = 65600.0;    // :
    if (gray > 0.3) n = 332772.0;   // *
    if (gray > 0.4) n = 15255086.0; // o
    if (gray > 0.5) n = 23385164.0; // &
    if (gray > 0.6) n = 15252014.0; // 8
    if (gray > 0.7) n = 13199452.0; // @
    if (gray > 0.8) n = 11512810.0; // #

    // get the mod..
    vec2 modd = getMod(coord, vec2(pixelSize));

    gl_FragColor = color * character( n, vec2(-1.0) + modd * 2.0);

}
`;
class $6c70ac0e52948134$export$15bcb18d890d25c4 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(n = 8){
        super($6c70ac0e52948134$var$o, $6c70ac0e52948134$var$r), this.size = n;
    }
    get size() {
        return this.uniforms.pixelSize;
    }
    set size(n) {
        this.uniforms.pixelSize = n;
    }
}


/*!
 * @pixi/filter-bevel - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-bevel is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $3914085d8d1fa6e1$var$n = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $3914085d8d1fa6e1$var$e = `precision mediump float;

varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;

uniform float transformX;
uniform float transformY;
uniform vec3 lightColor;
uniform float lightAlpha;
uniform vec3 shadowColor;
uniform float shadowAlpha;

void main(void) {
    vec2 transform = vec2(1.0 / filterArea) * vec2(transformX, transformY);
    vec4 color = texture2D(uSampler, vTextureCoord);
    float light = texture2D(uSampler, vTextureCoord - transform).a;
    float shadow = texture2D(uSampler, vTextureCoord + transform).a;

    color.rgb = mix(color.rgb, lightColor, clamp((color.a - light) * lightAlpha, 0.0, 1.0));
    color.rgb = mix(color.rgb, shadowColor, clamp((color.a - shadow) * shadowAlpha, 0.0, 1.0));
    gl_FragColor = vec4(color.rgb * color.a, color.a);
}
`;
class $3914085d8d1fa6e1$export$b3fbca19e4458c27 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(o){
        super($3914085d8d1fa6e1$var$n, $3914085d8d1fa6e1$var$e), this._thickness = 2, this._angle = 0, this.uniforms.lightColor = new Float32Array(3), this.uniforms.shadowColor = new Float32Array(3), Object.assign(this, {
            rotation: 45,
            thickness: 2,
            lightColor: 16777215,
            lightAlpha: .7,
            shadowColor: 0,
            shadowAlpha: .7
        }, o), this.padding = 1;
    }
    _updateTransform() {
        this.uniforms.transformX = this._thickness * Math.cos(this._angle), this.uniforms.transformY = this._thickness * Math.sin(this._angle);
    }
    get rotation() {
        return this._angle / (0, $07142e085c72c7cc$export$870617f62e3187f1);
    }
    set rotation(o) {
        this._angle = o * (0, $07142e085c72c7cc$export$870617f62e3187f1), this._updateTransform();
    }
    get thickness() {
        return this._thickness;
    }
    set thickness(o) {
        this._thickness = o, this._updateTransform();
    }
    get lightColor() {
        return (0, $5d808cc4b6a3c326$exports).rgb2hex(this.uniforms.lightColor);
    }
    set lightColor(o) {
        (0, $5d808cc4b6a3c326$exports).hex2rgb(o, this.uniforms.lightColor);
    }
    get lightAlpha() {
        return this.uniforms.lightAlpha;
    }
    set lightAlpha(o) {
        this.uniforms.lightAlpha = o;
    }
    get shadowColor() {
        return (0, $5d808cc4b6a3c326$exports).rgb2hex(this.uniforms.shadowColor);
    }
    set shadowColor(o) {
        (0, $5d808cc4b6a3c326$exports).hex2rgb(o, this.uniforms.shadowColor);
    }
    get shadowAlpha() {
        return this.uniforms.shadowAlpha;
    }
    set shadowAlpha(o) {
        this.uniforms.shadowAlpha = o;
    }
}


/*!
 * @pixi/filter-bloom - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-bloom is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 


class $e44922011b642e5e$export$fbc160adde9cf656 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(t = 2, l = 4, e = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).FILTER_RESOLUTION, i = 5){
        super();
        let r, u;
        typeof t == "number" ? (r = t, u = t) : t instanceof (0, $88931fa1c0809be8$export$baf26146a414f24a) ? (r = t.x, u = t.y) : Array.isArray(t) && (r = t[0], u = t[1]), this.blurXFilter = new (0, $e02eb7d1be82cd90$export$b100a8e8116621cf)(!0, r, l, e, i), this.blurYFilter = new (0, $e02eb7d1be82cd90$export$b100a8e8116621cf)(!1, u, l, e, i), this.blurYFilter.blendMode = (0, $551209d754b5b429$export$f821c68fe9beaecf).SCREEN, this.defaultFilter = new (0, $eb46baeaa5184069$export$adbaa0de008b0d7a);
    }
    apply(t, l, e, i) {
        const r = t.getFilterTexture();
        this.defaultFilter.apply(t, l, e, i), this.blurXFilter.apply(t, l, r, 1), this.blurYFilter.apply(t, r, e, 0), t.returnFilterTexture(r);
    }
    get blur() {
        return this.blurXFilter.blur;
    }
    set blur(t) {
        this.blurXFilter.blur = this.blurYFilter.blur = t;
    }
    get blurX() {
        return this.blurXFilter.blur;
    }
    set blurX(t) {
        this.blurXFilter.blur = t;
    }
    get blurY() {
        return this.blurYFilter.blur;
    }
    set blurY(t) {
        this.blurYFilter.blur = t;
    }
}


/*!
 * @pixi/filter-bulge-pinch - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-bulge-pinch is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $5cc6f33afa87130b$var$d = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $5cc6f33afa87130b$var$u = `uniform float radius;
uniform float strength;
uniform vec2 center;
uniform sampler2D uSampler;
varying vec2 vTextureCoord;

uniform vec4 filterArea;
uniform vec4 filterClamp;
uniform vec2 dimensions;

void main()
{
    vec2 coord = vTextureCoord * filterArea.xy;
    coord -= center * dimensions.xy;
    float distance = length(coord);
    if (distance < radius) {
        float percent = distance / radius;
        if (strength > 0.0) {
            coord *= mix(1.0, smoothstep(0.0, radius / distance, percent), strength * 0.75);
        } else {
            coord *= mix(1.0, pow(percent, 1.0 + strength * 0.75) * radius / distance, 1.0 - percent);
        }
    }
    coord += center * dimensions.xy;
    coord /= filterArea.xy;
    vec2 clampedCoord = clamp(coord, filterClamp.xy, filterClamp.zw);
    vec4 color = texture2D(uSampler, clampedCoord);
    if (coord != clampedCoord) {
        color *= max(0.0, 1.0 - length(coord - clampedCoord));
    }

    gl_FragColor = color;
}
`;
const $5cc6f33afa87130b$var$n = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e){
        super($5cc6f33afa87130b$var$d, $5cc6f33afa87130b$var$u), this.uniforms.dimensions = new Float32Array(2), Object.assign(this, $5cc6f33afa87130b$var$n.defaults, e);
    }
    apply(e, r, o, i) {
        const { width: s , height: a  } = r.filterFrame;
        this.uniforms.dimensions[0] = s, this.uniforms.dimensions[1] = a, e.applyFilter(this, r, o, i);
    }
    get radius() {
        return this.uniforms.radius;
    }
    set radius(e) {
        this.uniforms.radius = e;
    }
    get strength() {
        return this.uniforms.strength;
    }
    set strength(e) {
        this.uniforms.strength = e;
    }
    get center() {
        return this.uniforms.center;
    }
    set center(e) {
        this.uniforms.center = e;
    }
};
let $5cc6f33afa87130b$export$3db008ed2b7e8808 = $5cc6f33afa87130b$var$n;
$5cc6f33afa87130b$export$3db008ed2b7e8808.defaults = {
    center: [
        .5,
        .5
    ],
    radius: 100,
    strength: 1
};


/*!
 * @pixi/filter-color-gradient - v5.2.0
 * Compiled Tue, 28 Feb 2023 14:24:35 UTC
 *
 * @pixi/filter-color-gradient is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $44dfd4d8fe8f2605$var$Q = `const float PI = 3.1415926538;
const float PI_2 = PI*2.;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;
uniform sampler2D uSampler;

const int TYPE_LINEAR = 0;
const int TYPE_RADIAL = 1;
const int TYPE_CONIC = 2;
const int MAX_STOPS = 32;

uniform int uNumStops;
uniform float uAlphas[3*MAX_STOPS];
uniform vec3 uColors[MAX_STOPS];
uniform float uOffsets[MAX_STOPS];
uniform int uType;
uniform float uAngle;
uniform float uAlpha;
uniform int uMaxColors;

struct ColorStop {
    float offset;
    vec3 color;
    float alpha;
};

mat2 rotate2d(float angle){
    return mat2(cos(angle), -sin(angle),
    sin(angle), cos(angle));
}

float projectLinearPosition(vec2 pos, float angle){
    vec2 center = vec2(0.5);
    vec2 result = pos - center;
    result = rotate2d(angle) * result;
    result = result + center;
    return clamp(result.x, 0., 1.);
}

float projectRadialPosition(vec2 pos) {
    float r = distance(vFilterCoord, vec2(0.5));
    return clamp(2.*r, 0., 1.);
}

float projectAnglePosition(vec2 pos, float angle) {
    vec2 center = pos - vec2(0.5);
    float polarAngle=atan(-center.y, center.x);
    return mod(polarAngle + angle, PI_2) / PI_2;
}

float projectPosition(vec2 pos, int type, float angle) {
    if (type == TYPE_LINEAR) {
        return projectLinearPosition(pos, angle);
    } else if (type == TYPE_RADIAL) {
        return projectRadialPosition(pos);
    } else if (type == TYPE_CONIC) {
        return projectAnglePosition(pos, angle);
    }

    return pos.y;
}

void main(void) {
    // current/original color
    vec4 currentColor = texture2D(uSampler, vTextureCoord);

    // skip calculations if gradient alpha is 0
    if (0.0 == uAlpha) {
        gl_FragColor = currentColor;
        return;
    }

    // project position
    float y = projectPosition(vFilterCoord, uType, radians(uAngle));

    // check gradient bounds
    float offsetMin = uOffsets[0];
    float offsetMax = 0.0;

    for (int i = 0; i < MAX_STOPS; i++) {
        if (i == uNumStops-1){ // last index
            offsetMax = uOffsets[i];
        }
    }

    if (y  < offsetMin || y > offsetMax) {
        gl_FragColor = currentColor;
        return;
    }

    // limit colors
    if (uMaxColors > 0) {
        float stepSize = 1./float(uMaxColors);
        float stepNumber = float(floor(y/stepSize));
        y = stepSize * (stepNumber + 0.5);// offset by 0.5 to use color from middle of segment
    }

    // find color stops
    ColorStop from;
    ColorStop to;

    for (int i = 0; i < MAX_STOPS; i++) {
        if (y >= uOffsets[i]) {
            from = ColorStop(uOffsets[i], uColors[i], uAlphas[i]);
            to = ColorStop(uOffsets[i+1], uColors[i+1], uAlphas[i+1]);
        }

        if (i == uNumStops-1){ // last index
            break;
        }
    }

    // mix colors from stops
    vec4 colorFrom = vec4(from.color * from.alpha, from.alpha);
    vec4 colorTo = vec4(to.color * to.alpha, to.alpha);

    float segmentHeight = to.offset - from.offset;
    float relativePos = y - from.offset;// position from 0 to [segmentHeight]
    float relativePercent = relativePos / segmentHeight;// position in percent between [from.offset] and [to.offset].

    float gradientAlpha = uAlpha * currentColor.a;
    vec4 gradientColor = mix(colorFrom, colorTo, relativePercent) * gradientAlpha;

    // mix resulting color with current color
    gl_FragColor = gradientColor + currentColor*(1.-gradientColor.a);
}
`, $44dfd4d8fe8f2605$var$W = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform vec4 inputSize;
uniform vec4 outputFrame;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
    vFilterCoord = vTextureCoord * inputSize.xy / outputFrame.zw;
}
`, $44dfd4d8fe8f2605$var$v = $44dfd4d8fe8f2605$var$v || {};
$44dfd4d8fe8f2605$var$v.stringify = function() {
    var e = {
        "visit_linear-gradient": function(t) {
            return e.visit_gradient(t);
        },
        "visit_repeating-linear-gradient": function(t) {
            return e.visit_gradient(t);
        },
        "visit_radial-gradient": function(t) {
            return e.visit_gradient(t);
        },
        "visit_repeating-radial-gradient": function(t) {
            return e.visit_gradient(t);
        },
        visit_gradient: function(t) {
            var r = e.visit(t.orientation);
            return r && (r += ", "), t.type + "(" + r + e.visit(t.colorStops) + ")";
        },
        visit_shape: function(t) {
            var r = t.value, o = e.visit(t.at), n = e.visit(t.style);
            return n && (r += " " + n), o && (r += " at " + o), r;
        },
        "visit_default-radial": function(t) {
            var r = "", o = e.visit(t.at);
            return o && (r += o), r;
        },
        "visit_extent-keyword": function(t) {
            var r = t.value, o = e.visit(t.at);
            return o && (r += " at " + o), r;
        },
        "visit_position-keyword": function(t) {
            return t.value;
        },
        visit_position: function(t) {
            return e.visit(t.value.x) + " " + e.visit(t.value.y);
        },
        "visit_%": function(t) {
            return t.value + "%";
        },
        visit_em: function(t) {
            return t.value + "em";
        },
        visit_px: function(t) {
            return t.value + "px";
        },
        visit_literal: function(t) {
            return e.visit_color(t.value, t);
        },
        visit_hex: function(t) {
            return e.visit_color("#" + t.value, t);
        },
        visit_rgb: function(t) {
            return e.visit_color("rgb(" + t.value.join(", ") + ")", t);
        },
        visit_rgba: function(t) {
            return e.visit_color("rgba(" + t.value.join(", ") + ")", t);
        },
        visit_color: function(t, r) {
            var o = t, n = e.visit(r.length);
            return n && (o += " " + n), o;
        },
        visit_angular: function(t) {
            return t.value + "deg";
        },
        visit_directional: function(t) {
            return "to " + t.value;
        },
        visit_array: function(t) {
            var r = "", o = t.length;
            return t.forEach(function(n, i) {
                r += e.visit(n), i < o - 1 && (r += ", ");
            }), r;
        },
        visit: function(t) {
            if (!t) return "";
            var r = "";
            if (t instanceof Array) return e.visit_array(t, r);
            if (t.type) {
                var o = e["visit_" + t.type];
                if (o) return o(t);
                throw Error("Missing visitor visit_" + t.type);
            } else throw Error("Invalid node.");
        }
    };
    return function(t) {
        return e.visit(t);
    };
}();
var $44dfd4d8fe8f2605$var$v = $44dfd4d8fe8f2605$var$v || {};
$44dfd4d8fe8f2605$var$v.parse = function() {
    var e = {
        linearGradient: /^(\-(webkit|o|ms|moz)\-)?(linear\-gradient)/i,
        repeatingLinearGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-linear\-gradient)/i,
        radialGradient: /^(\-(webkit|o|ms|moz)\-)?(radial\-gradient)/i,
        repeatingRadialGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-radial\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    }, t = "";
    function r(a) {
        var u = new Error(t + ": " + a);
        throw u.source = t, u;
    }
    function o() {
        var a = n();
        return t.length > 0 && r("Invalid input not EOF"), a;
    }
    function n() {
        return C(i);
    }
    function i() {
        return l("linear-gradient", e.linearGradient, s) || l("repeating-linear-gradient", e.repeatingLinearGradient, s) || l("radial-gradient", e.radialGradient, O) || l("repeating-radial-gradient", e.repeatingRadialGradient, O);
    }
    function l(a, u, c) {
        return f(u, function(d) {
            var j = c();
            return j && (m(e.comma) || r("Missing comma before color stops")), {
                type: a,
                orientation: j,
                colorStops: C(V)
            };
        });
    }
    function f(a, u) {
        var c = m(a);
        if (c) {
            m(e.startCall) || r("Missing (");
            var d = u(c);
            return m(e.endCall) || r("Missing )"), d;
        }
    }
    function s() {
        return p() || w();
    }
    function p() {
        return h("directional", e.sideOrCorner, 1);
    }
    function w() {
        return h("angular", e.angleValue, 1);
    }
    function O() {
        var a, u = g(), c;
        return u && (a = [], a.push(u), c = t, m(e.comma) && (u = g(), u ? a.push(u) : t = c)), a;
    }
    function g() {
        var a = b() || $();
        if (a) a.at = F();
        else {
            var u = _();
            if (u) {
                a = u;
                var c = F();
                c && (a.at = c);
            } else {
                var d = M();
                d && (a = {
                    type: "default-radial",
                    at: d
                });
            }
        }
        return a;
    }
    function b() {
        var a = h("shape", /^(circle)/i, 0);
        return a && (a.style = I() || _()), a;
    }
    function $() {
        var a = h("shape", /^(ellipse)/i, 0);
        return a && (a.style = x() || _()), a;
    }
    function _() {
        return h("extent-keyword", e.extentKeywords, 1);
    }
    function F() {
        if (h("position", /^at/, 0)) {
            var a = M();
            return a || r("Missing positioning value"), a;
        }
    }
    function M() {
        var a = q();
        if (a.x || a.y) return {
            type: "position",
            value: a
        };
    }
    function q() {
        return {
            x: x(),
            y: x()
        };
    }
    function C(a) {
        var u = a(), c = [];
        if (u) for(c.push(u); m(e.comma);)u = a(), u ? c.push(u) : r("One extra comma");
        return c;
    }
    function V() {
        var a = H();
        return a || r("Expected color definition"), a.length = x(), a;
    }
    function H() {
        return X() || B() || Y() || K();
    }
    function K() {
        return h("literal", e.literalColor, 0);
    }
    function X() {
        return h("hex", e.hexColor, 1);
    }
    function Y() {
        return f(e.rgbColor, function() {
            return {
                type: "rgb",
                value: C(T)
            };
        });
    }
    function B() {
        return f(e.rgbaColor, function() {
            return {
                type: "rgba",
                value: C(T)
            };
        });
    }
    function T() {
        return m(e.number)[1];
    }
    function x() {
        return h("%", e.percentageValue, 1) || U() || I();
    }
    function U() {
        return h("position-keyword", e.positionKeywords, 1);
    }
    function I() {
        return h("px", e.pixelValue, 1) || h("em", e.emValue, 1);
    }
    function h(a, u, c) {
        var d = m(u);
        if (d) return {
            type: a,
            value: d[c]
        };
    }
    function m(a) {
        var u, c;
        return c = /^[\n\r\t\s]+/.exec(t), c && E(c[0].length), u = a.exec(t), u && E(u[0].length), u;
    }
    function E(a) {
        t = t.substr(a);
    }
    return function(a) {
        return t = a.toString(), o();
    };
}();
var $44dfd4d8fe8f2605$var$ee = $44dfd4d8fe8f2605$var$v.parse;
$44dfd4d8fe8f2605$var$v.stringify;
var $44dfd4d8fe8f2605$var$R = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
}, $44dfd4d8fe8f2605$var$G = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
function $44dfd4d8fe8f2605$var$te(e) {
    var t, r = [], o = 1, n;
    if (typeof e == "string") {
        if ($44dfd4d8fe8f2605$var$R[e]) r = $44dfd4d8fe8f2605$var$R[e].slice(), n = "rgb";
        else if (e === "transparent") o = 0, n = "rgb", r = [
            0,
            0,
            0
        ];
        else if (/^#[A-Fa-f0-9]+$/.test(e)) {
            var i = e.slice(1), l = i.length, f = l <= 4;
            o = 1, f ? (r = [
                parseInt(i[0] + i[0], 16),
                parseInt(i[1] + i[1], 16),
                parseInt(i[2] + i[2], 16)
            ], l === 4 && (o = parseInt(i[3] + i[3], 16) / 255)) : (r = [
                parseInt(i[0] + i[1], 16),
                parseInt(i[2] + i[3], 16),
                parseInt(i[4] + i[5], 16)
            ], l === 8 && (o = parseInt(i[6] + i[7], 16) / 255)), r[0] || (r[0] = 0), r[1] || (r[1] = 0), r[2] || (r[2] = 0), n = "rgb";
        } else if (t = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(e)) {
            var s = t[1], p = s === "rgb", i = s.replace(/a$/, "");
            n = i;
            var l = i === "cmyk" ? 4 : i === "gray" ? 1 : 3;
            r = t[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(g, b) {
                if (/%$/.test(g)) return b === l ? parseFloat(g) / 100 : i === "rgb" ? parseFloat(g) * 255 / 100 : parseFloat(g);
                if (i[b] === "h") {
                    if (/deg$/.test(g)) return parseFloat(g);
                    if ($44dfd4d8fe8f2605$var$G[g] !== void 0) return $44dfd4d8fe8f2605$var$G[g];
                }
                return parseFloat(g);
            }), s === i && r.push(1), o = p || r[l] === void 0 ? 1 : r[l], r = r.slice(0, l);
        } else e.length > 10 && /[0-9](?:\s|\/)/.test(e) && (r = e.match(/([0-9]+)/g).map(function(w) {
            return parseFloat(w);
        }), n = e.match(/([a-z])/ig).join("").toLowerCase());
    } else isNaN(e) ? Array.isArray(e) || e.length ? (r = [
        e[0],
        e[1],
        e[2]
    ], n = "rgb", o = e.length === 4 ? e[3] : 1) : e instanceof Object && (e.r != null || e.red != null || e.R != null ? (n = "rgb", r = [
        e.r || e.red || e.R || 0,
        e.g || e.green || e.G || 0,
        e.b || e.blue || e.B || 0
    ]) : (n = "hsl", r = [
        e.h || e.hue || e.H || 0,
        e.s || e.saturation || e.S || 0,
        e.l || e.lightness || e.L || e.b || e.brightness
    ]), o = e.a || e.alpha || e.opacity || 1, e.opacity != null && (o /= 100)) : (n = "rgb", r = [
        e >>> 16,
        (e & 65280) >>> 8,
        e & 255
    ]);
    return {
        space: n,
        values: r,
        alpha: o
    };
}
var $44dfd4d8fe8f2605$var$A = {
    name: "rgb",
    min: [
        0,
        0,
        0
    ],
    max: [
        255,
        255,
        255
    ],
    channel: [
        "red",
        "green",
        "blue"
    ],
    alias: [
        "RGB"
    ]
}, $44dfd4d8fe8f2605$var$S = {
    name: "hsl",
    min: [
        0,
        0,
        0
    ],
    max: [
        360,
        100,
        100
    ],
    channel: [
        "hue",
        "saturation",
        "lightness"
    ],
    alias: [
        "HSL"
    ],
    rgb: function(e) {
        var t = e[0] / 360, r = e[1] / 100, o = e[2] / 100, n, i, l, f, s;
        if (r === 0) return s = o * 255, [
            s,
            s,
            s
        ];
        o < .5 ? i = o * (1 + r) : i = o + r - o * r, n = 2 * o - i, f = [
            0,
            0,
            0
        ];
        for(var p = 0; p < 3; p++)l = t + 1 / 3 * -(p - 1), l < 0 ? l++ : l > 1 && l--, 6 * l < 1 ? s = n + (i - n) * 6 * l : 2 * l < 1 ? s = i : 3 * l < 2 ? s = n + (i - n) * (2 / 3 - l) * 6 : s = n, f[p] = s * 255;
        return f;
    }
};
$44dfd4d8fe8f2605$var$A.hsl = function(e) {
    var t = e[0] / 255, r = e[1] / 255, o = e[2] / 255, n = Math.min(t, r, o), i = Math.max(t, r, o), l = i - n, f, s, p;
    return i === n ? f = 0 : t === i ? f = (r - o) / l : r === i ? f = 2 + (o - t) / l : o === i && (f = 4 + (t - r) / l), f = Math.min(f * 60, 360), f < 0 && (f += 360), p = (n + i) / 2, i === n ? s = 0 : p <= .5 ? s = l / (i + n) : s = l / (2 - i - n), [
        f,
        s * 100,
        p * 100
    ];
};
function $44dfd4d8fe8f2605$var$re(e) {
    Array.isArray(e) && e.raw && (e = String.raw(...arguments));
    var t, r = $44dfd4d8fe8f2605$var$te(e);
    if (!r.space) return [];
    const o = r.space[0] === "h" ? $44dfd4d8fe8f2605$var$S.min : $44dfd4d8fe8f2605$var$A.min, n = r.space[0] === "h" ? $44dfd4d8fe8f2605$var$S.max : $44dfd4d8fe8f2605$var$A.max;
    return t = Array(3), t[0] = Math.min(Math.max(r.values[0], o[0]), n[0]), t[1] = Math.min(Math.max(r.values[1], o[1]), n[1]), t[2] = Math.min(Math.max(r.values[2], o[2]), n[2]), r.space[0] === "h" && (t = $44dfd4d8fe8f2605$var$S.rgb(t)), t.push(Math.min(Math.max(r.alpha, 0), 1)), t;
}
function $44dfd4d8fe8f2605$var$L(e) {
    switch(typeof e){
        case "string":
            return $44dfd4d8fe8f2605$var$ne(e);
        case "number":
            return (0, $5d808cc4b6a3c326$exports).hex2rgb(e);
        default:
            return e;
    }
}
function $44dfd4d8fe8f2605$var$ne(e) {
    const t = $44dfd4d8fe8f2605$var$re(e);
    if (!t) throw new Error(`Unable to parse color "${e}" as RGBA.`);
    return [
        t[0] / 255,
        t[1] / 255,
        t[2] / 255,
        t[3]
    ];
}
function $44dfd4d8fe8f2605$var$ie(e) {
    const t = $44dfd4d8fe8f2605$var$ee($44dfd4d8fe8f2605$var$ge(e));
    if (t.length === 0) throw new Error("Invalid CSS gradient.");
    if (t.length !== 1) throw new Error("Unsupported CSS gradient (multiple gradients is not supported).");
    const r = t[0], o = $44dfd4d8fe8f2605$var$oe(r.type), n = $44dfd4d8fe8f2605$var$ae(r.colorStops), i = $44dfd4d8fe8f2605$var$ce(r.orientation);
    return {
        type: o,
        stops: n,
        angle: i
    };
}
function $44dfd4d8fe8f2605$var$oe(e) {
    const t = {
        "linear-gradient": 0,
        "radial-gradient": 1
    };
    if (!(e in t)) throw new Error(`Unsupported gradient type "${e}"`);
    return t[e];
}
function $44dfd4d8fe8f2605$var$ae(e) {
    const t = $44dfd4d8fe8f2605$var$ue(e), r = [];
    for(let o = 0; o < e.length; o++){
        const n = $44dfd4d8fe8f2605$var$le(e[o]);
        r.push({
            offset: t[o],
            color: n.slice(0, 3),
            alpha: n[3]
        });
    }
    return r;
}
function $44dfd4d8fe8f2605$var$le(e) {
    return $44dfd4d8fe8f2605$var$L($44dfd4d8fe8f2605$var$se(e));
}
function $44dfd4d8fe8f2605$var$se(e) {
    switch(e.type){
        case "hex":
            return `#${e.value}`;
        case "literal":
            return e.value;
        default:
            return `${e.type}(${e.value.join(",")})`;
    }
}
function $44dfd4d8fe8f2605$var$ue(e) {
    const t = [];
    for(let n = 0; n < e.length; n++){
        const i = e[n];
        let l = -1;
        i.type === "literal" && i.length && "type" in i.length && i.length.type === "%" && "value" in i.length && (l = parseFloat(i.length.value) / 100), t.push(l);
    }
    const r = (n)=>{
        for(let i = n; i < t.length; i++)if (t[i] !== -1) return {
            indexDelta: i - n,
            offset: t[i]
        };
        return {
            indexDelta: t.length - 1 - n,
            offset: 1
        };
    };
    let o = 0;
    for(let n = 0; n < t.length; n++){
        const i = t[n];
        if (i !== -1) o = i;
        else if (n === 0) t[n] = 0;
        else if (n + 1 === t.length) t[n] = 1;
        else {
            const l = r(n), f = (l.offset - o) / (1 + l.indexDelta);
            for(let s = 0; s <= l.indexDelta; s++)t[n + s] = o + (s + 1) * f;
            n += l.indexDelta, o = t[n];
        }
    }
    return t.map($44dfd4d8fe8f2605$var$fe);
}
function $44dfd4d8fe8f2605$var$fe(e) {
    return e.toString().length > 6 ? parseFloat(e.toString().substring(0, 6)) : e;
}
function $44dfd4d8fe8f2605$var$ce(e) {
    if (typeof e == "undefined") return 0;
    if ("type" in e && "value" in e) switch(e.type){
        case "angular":
            return parseFloat(e.value);
        case "directional":
            return $44dfd4d8fe8f2605$var$pe(e.value);
    }
    return 0;
}
function $44dfd4d8fe8f2605$var$pe(e) {
    const t = {
        left: 270,
        top: 0,
        bottom: 180,
        right: 90,
        "left top": 315,
        "top left": 315,
        "left bottom": 225,
        "bottom left": 225,
        "right top": 45,
        "top right": 45,
        "right bottom": 135,
        "bottom right": 135
    };
    if (!(e in t)) throw new Error(`Unsupported directional value "${e}"`);
    return t[e];
}
function $44dfd4d8fe8f2605$var$ge(e) {
    let t = e.replace(/\s{2,}/gu, " ");
    return t = t.replace(/;/g, ""), t = t.replace(/ ,/g, ","), t = t.replace(/\( /g, "("), t = t.replace(/ \)/g, ")"), t.trim();
}
var $44dfd4d8fe8f2605$var$he = Object.defineProperty, $44dfd4d8fe8f2605$var$me = Object.defineProperties, $44dfd4d8fe8f2605$var$de = Object.getOwnPropertyDescriptors, $44dfd4d8fe8f2605$var$N = Object.getOwnPropertySymbols, $44dfd4d8fe8f2605$var$ve = Object.prototype.hasOwnProperty, $44dfd4d8fe8f2605$var$ye = Object.prototype.propertyIsEnumerable, $44dfd4d8fe8f2605$var$z = (e, t, r)=>t in e ? $44dfd4d8fe8f2605$var$he(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $44dfd4d8fe8f2605$var$k = (e, t)=>{
    for(var r in t || (t = {}))$44dfd4d8fe8f2605$var$ve.call(t, r) && $44dfd4d8fe8f2605$var$z(e, r, t[r]);
    if ($44dfd4d8fe8f2605$var$N) for (var r of $44dfd4d8fe8f2605$var$N(t))$44dfd4d8fe8f2605$var$ye.call(t, r) && $44dfd4d8fe8f2605$var$z(e, r, t[r]);
    return e;
}, $44dfd4d8fe8f2605$var$be = (e, t)=>$44dfd4d8fe8f2605$var$me(e, $44dfd4d8fe8f2605$var$de(t));
const $44dfd4d8fe8f2605$var$D = 90;
function $44dfd4d8fe8f2605$var$Ce(e) {
    return [
        ...e
    ].sort((t, r)=>t.offset - r.offset);
}
const $44dfd4d8fe8f2605$var$P = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e){
        e && "css" in e && (e = $44dfd4d8fe8f2605$var$be($44dfd4d8fe8f2605$var$k({}, $44dfd4d8fe8f2605$var$ie(e.css || "")), {
            alpha: e.alpha,
            maxColors: e.maxColors
        }));
        const t = $44dfd4d8fe8f2605$var$k($44dfd4d8fe8f2605$var$k({}, $44dfd4d8fe8f2605$var$P.defaults), e);
        if (!t.stops || t.stops.length < 2) throw new Error("ColorGradientFilter requires at least 2 color stops.");
        super($44dfd4d8fe8f2605$var$W, $44dfd4d8fe8f2605$var$Q), this._stops = [], this.autoFit = !1, Object.assign(this, t);
    }
    get stops() {
        return this._stops;
    }
    set stops(e) {
        const t = $44dfd4d8fe8f2605$var$Ce(e), r = new Float32Array(t.length * 3), o = 0, n = 1, i = 2;
        for(let l = 0; l < t.length; l++){
            const f = $44dfd4d8fe8f2605$var$L(t[l].color), s = l * 3;
            r[s + o] = f[o], r[s + n] = f[n], r[s + i] = f[i];
        }
        this.uniforms.uColors = r, this.uniforms.uOffsets = t.map((l)=>l.offset), this.uniforms.uAlphas = t.map((l)=>l.alpha), this.uniforms.uNumStops = t.length, this._stops = t;
    }
    set type(e) {
        this.uniforms.uType = e;
    }
    get type() {
        return this.uniforms.uType;
    }
    set angle(e) {
        this.uniforms.uAngle = e - $44dfd4d8fe8f2605$var$D;
    }
    get angle() {
        return this.uniforms.uAngle + $44dfd4d8fe8f2605$var$D;
    }
    set alpha(e) {
        this.uniforms.uAlpha = e;
    }
    get alpha() {
        return this.uniforms.uAlpha;
    }
    set maxColors(e) {
        this.uniforms.uMaxColors = e;
    }
    get maxColors() {
        return this.uniforms.uMaxColors;
    }
};
let $44dfd4d8fe8f2605$export$e893609768979f4b = $44dfd4d8fe8f2605$var$P;
$44dfd4d8fe8f2605$export$e893609768979f4b.LINEAR = 0, $44dfd4d8fe8f2605$export$e893609768979f4b.RADIAL = 1, $44dfd4d8fe8f2605$export$e893609768979f4b.CONIC = 2, $44dfd4d8fe8f2605$export$e893609768979f4b.defaults = {
    type: $44dfd4d8fe8f2605$var$P.LINEAR,
    stops: [
        {
            offset: 0,
            color: 16711680,
            alpha: 1
        },
        {
            offset: 1,
            color: 255,
            alpha: 1
        }
    ],
    alpha: 1,
    angle: 90,
    maxColors: 0
};


/*!
 * @pixi/filter-color-map - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-color-map is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $63213bfb2a607a77$var$a = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $63213bfb2a607a77$var$c = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform sampler2D colorMap;
uniform float _mix;
uniform float _size;
uniform float _sliceSize;
uniform float _slicePixelSize;
uniform float _sliceInnerSize;
void main() {
    vec4 color = texture2D(uSampler, vTextureCoord.xy);

    vec4 adjusted;
    if (color.a > 0.0) {
        color.rgb /= color.a;
        float innerWidth = _size - 1.0;
        float zSlice0 = min(floor(color.b * innerWidth), innerWidth);
        float zSlice1 = min(zSlice0 + 1.0, innerWidth);
        float xOffset = _slicePixelSize * 0.5 + color.r * _sliceInnerSize;
        float s0 = xOffset + (zSlice0 * _sliceSize);
        float s1 = xOffset + (zSlice1 * _sliceSize);
        float yOffset = _sliceSize * 0.5 + color.g * (1.0 - _sliceSize);
        vec4 slice0Color = texture2D(colorMap, vec2(s0,yOffset));
        vec4 slice1Color = texture2D(colorMap, vec2(s1,yOffset));
        float zOffset = fract(color.b * innerWidth);
        adjusted = mix(slice0Color, slice1Color, zOffset);

        color.rgb *= color.a;
    }
    gl_FragColor = vec4(mix(color, adjusted, _mix).rgb, color.a);

}`;
class $63213bfb2a607a77$export$676635c5c496e2b5 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e, i = !1, t = 1){
        super($63213bfb2a607a77$var$a, $63213bfb2a607a77$var$c), this.mix = 1, this._size = 0, this._sliceSize = 0, this._slicePixelSize = 0, this._sliceInnerSize = 0, this._nearest = !1, this._scaleMode = null, this._colorMap = null, this._scaleMode = null, this.nearest = i, this.mix = t, this.colorMap = e;
    }
    apply(e, i, t, l) {
        this.uniforms._mix = this.mix, e.applyFilter(this, i, t, l);
    }
    get colorSize() {
        return this._size;
    }
    get colorMap() {
        return this._colorMap;
    }
    set colorMap(e) {
        !e || (e instanceof (0, $6ac4ad2139942545$export$5431306cf43de24a) || (e = (0, $6ac4ad2139942545$export$5431306cf43de24a).from(e)), e != null && e.baseTexture && (e.baseTexture.scaleMode = this._scaleMode, e.baseTexture.mipmap = (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF, this._size = e.height, this._sliceSize = 1 / this._size, this._slicePixelSize = this._sliceSize / this._size, this._sliceInnerSize = this._slicePixelSize * (this._size - 1), this.uniforms._size = this._size, this.uniforms._sliceSize = this._sliceSize, this.uniforms._slicePixelSize = this._slicePixelSize, this.uniforms._sliceInnerSize = this._sliceInnerSize, this.uniforms.colorMap = e), this._colorMap = e);
    }
    get nearest() {
        return this._nearest;
    }
    set nearest(e) {
        this._nearest = e, this._scaleMode = e ? (0, $551209d754b5b429$export$6b734c6a0bba8473).NEAREST : (0, $551209d754b5b429$export$6b734c6a0bba8473).LINEAR;
        const i = this._colorMap;
        i && i.baseTexture && (i.baseTexture._glTextures = {}, i.baseTexture.scaleMode = this._scaleMode, i.baseTexture.mipmap = (0, $551209d754b5b429$export$16f6fb5da874bbfd).OFF, i._updateID++, i.baseTexture.emit("update", i.baseTexture));
    }
    updateColorMap() {
        const e = this._colorMap;
        e && e.baseTexture && (e._updateID++, e.baseTexture.emit("update", e.baseTexture), this.colorMap = e);
    }
    destroy(e = !1) {
        this._colorMap && this._colorMap.destroy(e), super.destroy();
    }
}


/*!
 * @pixi/filter-color-overlay - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-color-overlay is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $bedb28910d2e8f1e$var$n = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $bedb28910d2e8f1e$var$a = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec3 color;
uniform float alpha;

void main(void) {
    vec4 currentColor = texture2D(uSampler, vTextureCoord);
    gl_FragColor = vec4(mix(currentColor.rgb, color.rgb, currentColor.a * alpha), currentColor.a);
}
`;
class $bedb28910d2e8f1e$export$d8402030d196095b extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(o = 0, r = 1){
        super($bedb28910d2e8f1e$var$n, $bedb28910d2e8f1e$var$a), this._color = 0, this._alpha = 1, this.uniforms.color = new Float32Array(3), this.color = o, this.alpha = r;
    }
    set color(o) {
        const r = this.uniforms.color;
        typeof o == "number" ? ((0, $5d808cc4b6a3c326$exports).hex2rgb(o, r), this._color = o) : (r[0] = o[0], r[1] = o[1], r[2] = o[2], this._color = (0, $5d808cc4b6a3c326$exports).rgb2hex(r));
    }
    get color() {
        return this._color;
    }
    set alpha(o) {
        this.uniforms.alpha = o, this._alpha = o;
    }
    get alpha() {
        return this._alpha;
    }
}


/*!
 * @pixi/filter-color-replace - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-color-replace is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $93705cebed5ec788$var$t = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $93705cebed5ec788$var$l = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec3 originalColor;
uniform vec3 newColor;
uniform float epsilon;
void main(void) {
    vec4 currentColor = texture2D(uSampler, vTextureCoord);
    vec3 colorDiff = originalColor - (currentColor.rgb / max(currentColor.a, 0.0000000001));
    float colorDistance = length(colorDiff);
    float doReplace = step(colorDistance, epsilon);
    gl_FragColor = vec4(mix(currentColor.rgb, (newColor + colorDiff) * currentColor.a, doReplace), currentColor.a);
}
`;
class $93705cebed5ec788$export$25638752278038b9 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(o = 16711680, r = 0, n = .4){
        super($93705cebed5ec788$var$t, $93705cebed5ec788$var$l), this._originalColor = 16711680, this._newColor = 0, this.uniforms.originalColor = new Float32Array(3), this.uniforms.newColor = new Float32Array(3), this.originalColor = o, this.newColor = r, this.epsilon = n;
    }
    set originalColor(o) {
        const r = this.uniforms.originalColor;
        typeof o == "number" ? ((0, $5d808cc4b6a3c326$exports).hex2rgb(o, r), this._originalColor = o) : (r[0] = o[0], r[1] = o[1], r[2] = o[2], this._originalColor = (0, $5d808cc4b6a3c326$exports).rgb2hex(r));
    }
    get originalColor() {
        return this._originalColor;
    }
    set newColor(o) {
        const r = this.uniforms.newColor;
        typeof o == "number" ? ((0, $5d808cc4b6a3c326$exports).hex2rgb(o, r), this._newColor = o) : (r[0] = o[0], r[1] = o[1], r[2] = o[2], this._newColor = (0, $5d808cc4b6a3c326$exports).rgb2hex(r));
    }
    get newColor() {
        return this._newColor;
    }
    set epsilon(o) {
        this.uniforms.epsilon = o;
    }
    get epsilon() {
        return this.uniforms.epsilon;
    }
}


/*!
 * @pixi/filter-convolution - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-convolution is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $e06293f6e249ff32$var$o = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $e06293f6e249ff32$var$x = `precision mediump float;

varying mediump vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec2 texelSize;
uniform float matrix[9];

void main(void)
{
   vec4 c11 = texture2D(uSampler, vTextureCoord - texelSize); // top left
   vec4 c12 = texture2D(uSampler, vec2(vTextureCoord.x, vTextureCoord.y - texelSize.y)); // top center
   vec4 c13 = texture2D(uSampler, vec2(vTextureCoord.x + texelSize.x, vTextureCoord.y - texelSize.y)); // top right

   vec4 c21 = texture2D(uSampler, vec2(vTextureCoord.x - texelSize.x, vTextureCoord.y)); // mid left
   vec4 c22 = texture2D(uSampler, vTextureCoord); // mid center
   vec4 c23 = texture2D(uSampler, vec2(vTextureCoord.x + texelSize.x, vTextureCoord.y)); // mid right

   vec4 c31 = texture2D(uSampler, vec2(vTextureCoord.x - texelSize.x, vTextureCoord.y + texelSize.y)); // bottom left
   vec4 c32 = texture2D(uSampler, vec2(vTextureCoord.x, vTextureCoord.y + texelSize.y)); // bottom center
   vec4 c33 = texture2D(uSampler, vTextureCoord + texelSize); // bottom right

   gl_FragColor =
       c11 * matrix[0] + c12 * matrix[1] + c13 * matrix[2] +
       c21 * matrix[3] + c22 * matrix[4] + c23 * matrix[5] +
       c31 * matrix[6] + c32 * matrix[7] + c33 * matrix[8];

   gl_FragColor.a = c22.a;
}
`;
class $e06293f6e249ff32$export$e566fb96646592af extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e, t = 200, r = 200){
        super($e06293f6e249ff32$var$o, $e06293f6e249ff32$var$x), this.uniforms.texelSize = new Float32Array(2), this.uniforms.matrix = new Float32Array(9), e !== void 0 && (this.matrix = e), this.width = t, this.height = r;
    }
    get matrix() {
        return this.uniforms.matrix;
    }
    set matrix(e) {
        e.forEach((t, r)=>{
            this.uniforms.matrix[r] = t;
        });
    }
    get width() {
        return 1 / this.uniforms.texelSize[0];
    }
    set width(e) {
        this.uniforms.texelSize[0] = 1 / e;
    }
    get height() {
        return 1 / this.uniforms.texelSize[1];
    }
    set height(e) {
        this.uniforms.texelSize[1] = 1 / e;
    }
}


/*!
 * @pixi/filter-cross-hatch - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-cross-hatch is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $7e5c83a5a868da9f$var$r = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $7e5c83a5a868da9f$var$o = `precision mediump float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void)
{
    float lum = length(texture2D(uSampler, vTextureCoord.xy).rgb);

    gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);

    if (lum < 1.00)
    {
        if (mod(gl_FragCoord.x + gl_FragCoord.y, 10.0) == 0.0)
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
        }
    }

    if (lum < 0.75)
    {
        if (mod(gl_FragCoord.x - gl_FragCoord.y, 10.0) == 0.0)
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
        }
    }

    if (lum < 0.50)
    {
        if (mod(gl_FragCoord.x + gl_FragCoord.y - 5.0, 10.0) == 0.0)
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
        }
    }

    if (lum < 0.3)
    {
        if (mod(gl_FragCoord.x - gl_FragCoord.y - 5.0, 10.0) == 0.0)
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
        }
    }
}
`;
class $7e5c83a5a868da9f$export$243c62fa1f37514d extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(){
        super($7e5c83a5a868da9f$var$r, $7e5c83a5a868da9f$var$o);
    }
}


/*!
 * @pixi/filter-crt - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-crt is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $0dc17b837d92cc17$var$a = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $0dc17b837d92cc17$var$g = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec4 filterArea;
uniform vec2 dimensions;

const float SQRT_2 = 1.414213;

const float light = 1.0;

uniform float curvature;
uniform float lineWidth;
uniform float lineContrast;
uniform bool verticalLine;
uniform float noise;
uniform float noiseSize;

uniform float vignetting;
uniform float vignettingAlpha;
uniform float vignettingBlur;

uniform float seed;
uniform float time;

float rand(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main(void)
{
    vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
    vec2 dir = vec2(vTextureCoord.xy * filterArea.xy / dimensions - vec2(0.5, 0.5));
    
    gl_FragColor = texture2D(uSampler, vTextureCoord);
    vec3 rgb = gl_FragColor.rgb;

    if (noise > 0.0 && noiseSize > 0.0)
    {
        pixelCoord.x = floor(pixelCoord.x / noiseSize);
        pixelCoord.y = floor(pixelCoord.y / noiseSize);
        float _noise = rand(pixelCoord * noiseSize * seed) - 0.5;
        rgb += _noise * noise;
    }

    if (lineWidth > 0.0)
    {
        float _c = curvature > 0. ? curvature : 1.;
        float k = curvature > 0. ?(length(dir * dir) * 0.25 * _c * _c + 0.935 * _c) : 1.;
        vec2 uv = dir * k;

        float v = (verticalLine ? uv.x * dimensions.x : uv.y * dimensions.y) * min(1.0, 2.0 / lineWidth ) / _c;
        float j = 1. + cos(v * 1.2 - time) * 0.5 * lineContrast;
        rgb *= j;
        float segment = verticalLine ? mod((dir.x + .5) * dimensions.x, 4.) : mod((dir.y + .5) * dimensions.y, 4.);
        rgb *= 0.99 + ceil(segment) * 0.015;
    }

    if (vignetting > 0.0)
    {
        float outter = SQRT_2 - vignetting * SQRT_2;
        float darker = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + vignettingBlur * SQRT_2), 0.0, 1.0);
        rgb *= darker + (1.0 - darker) * (1.0 - vignettingAlpha);
    }

    gl_FragColor.rgb = rgb;
}
`;
const $0dc17b837d92cc17$var$e = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(n){
        super($0dc17b837d92cc17$var$a, $0dc17b837d92cc17$var$g), this.time = 0, this.seed = 0, this.uniforms.dimensions = new Float32Array(2), Object.assign(this, $0dc17b837d92cc17$var$e.defaults, n);
    }
    apply(n, i, r, o) {
        const { width: s , height: l  } = i.filterFrame;
        this.uniforms.dimensions[0] = s, this.uniforms.dimensions[1] = l, this.uniforms.seed = this.seed, this.uniforms.time = this.time, n.applyFilter(this, i, r, o);
    }
    set curvature(n) {
        this.uniforms.curvature = n;
    }
    get curvature() {
        return this.uniforms.curvature;
    }
    set lineWidth(n) {
        this.uniforms.lineWidth = n;
    }
    get lineWidth() {
        return this.uniforms.lineWidth;
    }
    set lineContrast(n) {
        this.uniforms.lineContrast = n;
    }
    get lineContrast() {
        return this.uniforms.lineContrast;
    }
    set verticalLine(n) {
        this.uniforms.verticalLine = n;
    }
    get verticalLine() {
        return this.uniforms.verticalLine;
    }
    set noise(n) {
        this.uniforms.noise = n;
    }
    get noise() {
        return this.uniforms.noise;
    }
    set noiseSize(n) {
        this.uniforms.noiseSize = n;
    }
    get noiseSize() {
        return this.uniforms.noiseSize;
    }
    set vignetting(n) {
        this.uniforms.vignetting = n;
    }
    get vignetting() {
        return this.uniforms.vignetting;
    }
    set vignettingAlpha(n) {
        this.uniforms.vignettingAlpha = n;
    }
    get vignettingAlpha() {
        return this.uniforms.vignettingAlpha;
    }
    set vignettingBlur(n) {
        this.uniforms.vignettingBlur = n;
    }
    get vignettingBlur() {
        return this.uniforms.vignettingBlur;
    }
};
let $0dc17b837d92cc17$export$ae91753653e6e05 = $0dc17b837d92cc17$var$e;
$0dc17b837d92cc17$export$ae91753653e6e05.defaults = {
    curvature: 1,
    lineWidth: 1,
    lineContrast: .25,
    verticalLine: !1,
    noise: 0,
    noiseSize: 1,
    seed: 0,
    vignetting: .3,
    vignettingAlpha: 1,
    vignettingBlur: .3,
    time: 0
};


/*!
 * @pixi/filter-dot - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-dot is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8a264577a829b4da$var$t = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $8a264577a829b4da$var$a = `precision mediump float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform vec4 filterArea;
uniform sampler2D uSampler;

uniform float angle;
uniform float scale;
uniform bool grayscale;

float pattern()
{
   float s = sin(angle), c = cos(angle);
   vec2 tex = vTextureCoord * filterArea.xy;
   vec2 point = vec2(
       c * tex.x - s * tex.y,
       s * tex.x + c * tex.y
   ) * scale;
   return (sin(point.x) * sin(point.y)) * 4.0;
}

void main()
{
   vec4 color = texture2D(uSampler, vTextureCoord);
   vec3 colorRGB = vec3(color);

   if (grayscale)
   {
       colorRGB = vec3(color.r + color.g + color.b) / 3.0;
   }

   gl_FragColor = vec4(colorRGB * 10.0 - 5.0 + pattern(), color.a);
}
`;
class $8a264577a829b4da$export$7cf7dcd1ca793e20 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e = 1, n = 5, r = !0){
        super($8a264577a829b4da$var$t, $8a264577a829b4da$var$a), this.scale = e, this.angle = n, this.grayscale = r;
    }
    get scale() {
        return this.uniforms.scale;
    }
    set scale(e) {
        this.uniforms.scale = e;
    }
    get angle() {
        return this.uniforms.angle;
    }
    set angle(e) {
        this.uniforms.angle = e;
    }
    get grayscale() {
        return this.uniforms.grayscale;
    }
    set grayscale(e) {
        this.uniforms.grayscale = e;
    }
}


/*!
 * @pixi/filter-drop-shadow - v5.2.0
 * Compiled Tue, 28 Feb 2023 14:24:35 UTC
 *
 * @pixi/filter-drop-shadow is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 

var $e7e176903757e210$var$w = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $e7e176903757e210$var$O = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float alpha;
uniform vec3 color;

uniform vec2 shift;
uniform vec4 inputSize;

void main(void){
    vec4 sample = texture2D(uSampler, vTextureCoord - shift * inputSize.zw);

    // Premultiply alpha
    sample.rgb = color.rgb * sample.a;

    // alpha user alpha
    sample *= alpha;

    gl_FragColor = sample;
}`, $e7e176903757e210$var$P = Object.defineProperty, $e7e176903757e210$var$c = Object.getOwnPropertySymbols, $e7e176903757e210$var$T = Object.prototype.hasOwnProperty, $e7e176903757e210$var$z = Object.prototype.propertyIsEnumerable, $e7e176903757e210$var$_ = (t, e, i)=>e in t ? $e7e176903757e210$var$P(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : t[e] = i, $e7e176903757e210$var$b = (t, e)=>{
    for(var i in e || (e = {}))$e7e176903757e210$var$T.call(e, i) && $e7e176903757e210$var$_(t, i, e[i]);
    if ($e7e176903757e210$var$c) for (var i of $e7e176903757e210$var$c(e))$e7e176903757e210$var$z.call(e, i) && $e7e176903757e210$var$_(t, i, e[i]);
    return t;
};
const $e7e176903757e210$var$o = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(t){
        super(), this.angle = 45, this._distance = 5, this._resolution = (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).FILTER_RESOLUTION;
        const e = t ? $e7e176903757e210$var$b($e7e176903757e210$var$b({}, $e7e176903757e210$var$o.defaults), t) : $e7e176903757e210$var$o.defaults, { kernels: i , blur: l , quality: r , pixelSize: g , resolution: n  } = e;
        this._offset = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(this._updatePadding, this), this._tintFilter = new (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea)($e7e176903757e210$var$w, $e7e176903757e210$var$O), this._tintFilter.uniforms.color = new Float32Array(4), this._tintFilter.uniforms.shift = this._offset, this._tintFilter.resolution = n, this._blurFilter = i ? new (0, $950238d694024b6e$export$31164edf0fb20199)(i) : new (0, $950238d694024b6e$export$31164edf0fb20199)(l, r), this.pixelSize = g, this.resolution = n;
        const { shadowOnly: m , rotation: a , distance: u , offset: v , alpha: y , color: x  } = e;
        this.shadowOnly = m, a !== void 0 && u !== void 0 ? (this.rotation = a, this.distance = u) : this.offset = v, this.alpha = y, this.color = x;
    }
    apply(t, e, i, l) {
        const r = t.getFilterTexture();
        this._tintFilter.apply(t, e, r, 1), this._blurFilter.apply(t, r, i, l), this.shadowOnly !== !0 && t.applyFilter(this, e, i, 0), t.returnFilterTexture(r);
    }
    _updatePadding() {
        const t = Math.max(Math.abs(this._offset.x), Math.abs(this._offset.y));
        this.padding = t + this.blur * 2;
    }
    _updateShift() {
        this._tintFilter.uniforms.shift.set(this.distance * Math.cos(this.angle), this.distance * Math.sin(this.angle));
    }
    set offset(t) {
        this._offset.copyFrom(t), this._updatePadding();
    }
    get offset() {
        return this._offset;
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(t) {
        this._resolution = t, this._tintFilter && (this._tintFilter.resolution = t), this._blurFilter && (this._blurFilter.resolution = t);
    }
    get distance() {
        return this._distance;
    }
    set distance(t) {
        (0, $5d808cc4b6a3c326$exports).deprecation("5.3.0", "DropShadowFilter distance is deprecated, use offset"), this._distance = t, this._updatePadding(), this._updateShift();
    }
    get rotation() {
        return this.angle / (0, $07142e085c72c7cc$export$870617f62e3187f1);
    }
    set rotation(t) {
        (0, $5d808cc4b6a3c326$exports).deprecation("5.3.0", "DropShadowFilter rotation is deprecated, use offset"), this.angle = t * (0, $07142e085c72c7cc$export$870617f62e3187f1), this._updateShift();
    }
    get alpha() {
        return this._tintFilter.uniforms.alpha;
    }
    set alpha(t) {
        this._tintFilter.uniforms.alpha = t;
    }
    get color() {
        return (0, $5d808cc4b6a3c326$exports).rgb2hex(this._tintFilter.uniforms.color);
    }
    set color(t) {
        (0, $5d808cc4b6a3c326$exports).hex2rgb(t, this._tintFilter.uniforms.color);
    }
    get kernels() {
        return this._blurFilter.kernels;
    }
    set kernels(t) {
        this._blurFilter.kernels = t;
    }
    get blur() {
        return this._blurFilter.blur;
    }
    set blur(t) {
        this._blurFilter.blur = t, this._updatePadding();
    }
    get quality() {
        return this._blurFilter.quality;
    }
    set quality(t) {
        this._blurFilter.quality = t;
    }
    get pixelSize() {
        return this._blurFilter.pixelSize;
    }
    set pixelSize(t) {
        this._blurFilter.pixelSize = t;
    }
};
let $e7e176903757e210$export$57214e398098d4e3 = $e7e176903757e210$var$o;
$e7e176903757e210$export$57214e398098d4e3.defaults = {
    offset: {
        x: 4,
        y: 4
    },
    color: 0,
    alpha: .5,
    shadowOnly: !1,
    kernels: null,
    blur: 2,
    quality: 3,
    pixelSize: 1,
    resolution: (0, $fcbcf105ed644495$export$a5a6e0b888b2c992).FILTER_RESOLUTION
};


/*!
 * @pixi/filter-emboss - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-emboss is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $501a6c5ce7f174d9$var$t = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $501a6c5ce7f174d9$var$o = `precision mediump float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float strength;
uniform vec4 filterArea;


void main(void)
{
	vec2 onePixel = vec2(1.0 / filterArea);

	vec4 color;

	color.rgb = vec3(0.5);

	color -= texture2D(uSampler, vTextureCoord - onePixel) * strength;
	color += texture2D(uSampler, vTextureCoord + onePixel) * strength;

	color.rgb = vec3((color.r + color.g + color.b) / 3.0);

	float alpha = texture2D(uSampler, vTextureCoord).a;

	gl_FragColor = vec4(color.rgb * alpha, alpha);
}
`;
class $501a6c5ce7f174d9$export$564b6ccbc3bf408d extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(r = 5){
        super($501a6c5ce7f174d9$var$t, $501a6c5ce7f174d9$var$o), this.strength = r;
    }
    get strength() {
        return this.uniforms.strength;
    }
    set strength(r) {
        this.uniforms.strength = r;
    }
}


/*!
 * @pixi/filter-glitch - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-glitch is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $378738813fa02529$var$p = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $378738813fa02529$var$M = `// precision highp float;

varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec4 filterArea;
uniform vec4 filterClamp;
uniform vec2 dimensions;
uniform float aspect;

uniform sampler2D displacementMap;
uniform float offset;
uniform float sinDir;
uniform float cosDir;
uniform int fillMode;

uniform float seed;
uniform vec2 red;
uniform vec2 green;
uniform vec2 blue;

const int TRANSPARENT = 0;
const int ORIGINAL = 1;
const int LOOP = 2;
const int CLAMP = 3;
const int MIRROR = 4;

void main(void)
{
    vec2 coord = (vTextureCoord * filterArea.xy) / dimensions;

    if (coord.x > 1.0 || coord.y > 1.0) {
        return;
    }

    float cx = coord.x - 0.5;
    float cy = (coord.y - 0.5) * aspect;
    float ny = (-sinDir * cx + cosDir * cy) / aspect + 0.5;

    // displacementMap: repeat
    // ny = ny > 1.0 ? ny - 1.0 : (ny < 0.0 ? 1.0 + ny : ny);

    // displacementMap: mirror
    ny = ny > 1.0 ? 2.0 - ny : (ny < 0.0 ? -ny : ny);

    vec4 dc = texture2D(displacementMap, vec2(0.5, ny));

    float displacement = (dc.r - dc.g) * (offset / filterArea.x);

    coord = vTextureCoord + vec2(cosDir * displacement, sinDir * displacement * aspect);

    if (fillMode == CLAMP) {
        coord = clamp(coord, filterClamp.xy, filterClamp.zw);
    } else {
        if( coord.x > filterClamp.z ) {
            if (fillMode == TRANSPARENT) {
                discard;
            } else if (fillMode == LOOP) {
                coord.x -= filterClamp.z;
            } else if (fillMode == MIRROR) {
                coord.x = filterClamp.z * 2.0 - coord.x;
            }
        } else if( coord.x < filterClamp.x ) {
            if (fillMode == TRANSPARENT) {
                discard;
            } else if (fillMode == LOOP) {
                coord.x += filterClamp.z;
            } else if (fillMode == MIRROR) {
                coord.x *= -filterClamp.z;
            }
        }

        if( coord.y > filterClamp.w ) {
            if (fillMode == TRANSPARENT) {
                discard;
            } else if (fillMode == LOOP) {
                coord.y -= filterClamp.w;
            } else if (fillMode == MIRROR) {
                coord.y = filterClamp.w * 2.0 - coord.y;
            }
        } else if( coord.y < filterClamp.y ) {
            if (fillMode == TRANSPARENT) {
                discard;
            } else if (fillMode == LOOP) {
                coord.y += filterClamp.w;
            } else if (fillMode == MIRROR) {
                coord.y *= -filterClamp.w;
            }
        }
    }

    gl_FragColor.r = texture2D(uSampler, coord + red * (1.0 - seed * 0.4) / filterArea.xy).r;
    gl_FragColor.g = texture2D(uSampler, coord + green * (1.0 - seed * 0.3) / filterArea.xy).g;
    gl_FragColor.b = texture2D(uSampler, coord + blue * (1.0 - seed * 0.2) / filterArea.xy).b;
    gl_FragColor.a = texture2D(uSampler, coord).a;
}
`;
const $378738813fa02529$var$c = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e){
        super($378738813fa02529$var$p, $378738813fa02529$var$M), this.offset = 100, this.fillMode = $378738813fa02529$var$c.TRANSPARENT, this.average = !1, this.seed = 0, this.minSize = 8, this.sampleSize = 512, this._slices = 0, this._offsets = new Float32Array(1), this._sizes = new Float32Array(1), this._direction = -1, this.uniforms.dimensions = new Float32Array(2), this._canvas = document.createElement("canvas"), this._canvas.width = 4, this._canvas.height = this.sampleSize, this.texture = (0, $6ac4ad2139942545$export$5431306cf43de24a).from(this._canvas, {
            scaleMode: (0, $551209d754b5b429$export$6b734c6a0bba8473).NEAREST
        }), Object.assign(this, $378738813fa02529$var$c.defaults, e);
    }
    apply(e, s, i, t) {
        const { width: n , height: r  } = s.filterFrame;
        this.uniforms.dimensions[0] = n, this.uniforms.dimensions[1] = r, this.uniforms.aspect = r / n, this.uniforms.seed = this.seed, this.uniforms.offset = this.offset, this.uniforms.fillMode = this.fillMode, e.applyFilter(this, s, i, t);
    }
    _randomizeSizes() {
        const e = this._sizes, s = this._slices - 1, i = this.sampleSize, t = Math.min(this.minSize / i, .9 / this._slices);
        if (this.average) {
            const n = this._slices;
            let r = 1;
            for(let o = 0; o < s; o++){
                const a = r / (n - o), f = Math.max(a * (1 - Math.random() * .6), t);
                e[o] = f, r -= f;
            }
            e[s] = r;
        } else {
            let n = 1;
            const r = Math.sqrt(1 / this._slices);
            for(let o = 0; o < s; o++){
                const a = Math.max(r * n * Math.random(), t);
                e[o] = a, n -= a;
            }
            e[s] = n;
        }
        this.shuffle();
    }
    shuffle() {
        const e = this._sizes, s = this._slices - 1;
        for(let i = s; i > 0; i--){
            const t = Math.random() * i >> 0, n = e[i];
            e[i] = e[t], e[t] = n;
        }
    }
    _randomizeOffsets() {
        for(let e = 0; e < this._slices; e++)this._offsets[e] = Math.random() * (Math.random() < .5 ? -1 : 1);
    }
    refresh() {
        this._randomizeSizes(), this._randomizeOffsets(), this.redraw();
    }
    redraw() {
        const e = this.sampleSize, s = this.texture, i = this._canvas.getContext("2d");
        i.clearRect(0, 0, 8, e);
        let t, n = 0;
        for(let r = 0; r < this._slices; r++){
            t = Math.floor(this._offsets[r] * 256);
            const o = this._sizes[r] * e, a = t > 0 ? t : 0, f = t < 0 ? -t : 0;
            i.fillStyle = `rgba(${a}, ${f}, 0, 1)`, i.fillRect(0, n >> 0, e, o + 1 >> 0), n += o;
        }
        s.baseTexture.update(), this.uniforms.displacementMap = s;
    }
    set sizes(e) {
        const s = Math.min(this._slices, e.length);
        for(let i = 0; i < s; i++)this._sizes[i] = e[i];
    }
    get sizes() {
        return this._sizes;
    }
    set offsets(e) {
        const s = Math.min(this._slices, e.length);
        for(let i = 0; i < s; i++)this._offsets[i] = e[i];
    }
    get offsets() {
        return this._offsets;
    }
    get slices() {
        return this._slices;
    }
    set slices(e) {
        this._slices !== e && (this._slices = e, this.uniforms.slices = e, this._sizes = this.uniforms.slicesWidth = new Float32Array(e), this._offsets = this.uniforms.slicesOffset = new Float32Array(e), this.refresh());
    }
    get direction() {
        return this._direction;
    }
    set direction(e) {
        if (this._direction === e) return;
        this._direction = e;
        const s = e * (0, $07142e085c72c7cc$export$870617f62e3187f1);
        this.uniforms.sinDir = Math.sin(s), this.uniforms.cosDir = Math.cos(s);
    }
    get red() {
        return this.uniforms.red;
    }
    set red(e) {
        this.uniforms.red = e;
    }
    get green() {
        return this.uniforms.green;
    }
    set green(e) {
        this.uniforms.green = e;
    }
    get blue() {
        return this.uniforms.blue;
    }
    set blue(e) {
        this.uniforms.blue = e;
    }
    destroy() {
        var e;
        (e = this.texture) == null || e.destroy(!0), this.texture = this._canvas = this.red = this.green = this.blue = this._sizes = this._offsets = null;
    }
};
let $378738813fa02529$export$75cd31e528fd02b8 = $378738813fa02529$var$c;
$378738813fa02529$export$75cd31e528fd02b8.defaults = {
    slices: 5,
    offset: 100,
    direction: 0,
    fillMode: 0,
    average: !1,
    seed: 0,
    red: [
        0,
        0
    ],
    green: [
        0,
        0
    ],
    blue: [
        0,
        0
    ],
    minSize: 8,
    sampleSize: 512
}, $378738813fa02529$export$75cd31e528fd02b8.TRANSPARENT = 0, $378738813fa02529$export$75cd31e528fd02b8.ORIGINAL = 1, $378738813fa02529$export$75cd31e528fd02b8.LOOP = 2, $378738813fa02529$export$75cd31e528fd02b8.CLAMP = 3, $378738813fa02529$export$75cd31e528fd02b8.MIRROR = 4;


/*!
 * @pixi/filter-glow - v5.2.1
 * Compiled Fri, 24 Mar 2023 22:12:11 UTC
 *
 * @pixi/filter-glow is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $fb90597ba2996c28$var$f = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $fb90597ba2996c28$var$p = `varying vec2 vTextureCoord;
varying vec4 vColor;

uniform sampler2D uSampler;

uniform float outerStrength;
uniform float innerStrength;

uniform vec4 glowColor;

uniform vec4 filterArea;
uniform vec4 filterClamp;
uniform bool knockout;
uniform float alpha;

const float PI = 3.14159265358979323846264;

const float DIST = __DIST__;
const float ANGLE_STEP_SIZE = min(__ANGLE_STEP_SIZE__, PI * 2.0);
const float ANGLE_STEP_NUM = ceil(PI * 2.0 / ANGLE_STEP_SIZE);

const float MAX_TOTAL_ALPHA = ANGLE_STEP_NUM * DIST * (DIST + 1.0) / 2.0;

void main(void) {
    vec2 px = vec2(1.0 / filterArea.x, 1.0 / filterArea.y);

    float totalAlpha = 0.0;

    vec2 direction;
    vec2 displaced;
    vec4 curColor;

    for (float angle = 0.0; angle < PI * 2.0; angle += ANGLE_STEP_SIZE) {
       direction = vec2(cos(angle), sin(angle)) * px;

       for (float curDistance = 0.0; curDistance < DIST; curDistance++) {
           displaced = clamp(vTextureCoord + direction * 
                   (curDistance + 1.0), filterClamp.xy, filterClamp.zw);

           curColor = texture2D(uSampler, displaced);

           totalAlpha += (DIST - curDistance) * curColor.a;
       }
    }
    
    curColor = texture2D(uSampler, vTextureCoord);

    float alphaRatio = (totalAlpha / MAX_TOTAL_ALPHA);

    float innerGlowAlpha = (1.0 - alphaRatio) * innerStrength * curColor.a;
    float innerGlowStrength = min(1.0, innerGlowAlpha);
    
    vec4 innerColor = mix(curColor, glowColor, innerGlowStrength);

    float outerGlowAlpha = alphaRatio * outerStrength * (1. - curColor.a);
    float outerGlowStrength = min(1.0 - innerColor.a, outerGlowAlpha);

    if (knockout) {
      float resultAlpha = (outerGlowAlpha + innerGlowAlpha) * alpha;
      gl_FragColor = vec4(glowColor.rgb * resultAlpha, resultAlpha);
    }
    else {
      vec4 outerGlowColor = outerGlowStrength * glowColor.rgba * alpha;
      gl_FragColor = innerColor + outerGlowColor;
    }
}
`;
const $fb90597ba2996c28$var$e = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(n){
        const r = Object.assign({}, $fb90597ba2996c28$var$e.defaults, n), { outerStrength: a , innerStrength: i , color: u , knockout: c , quality: s , alpha: h  } = r, o = Math.round(r.distance);
        super($fb90597ba2996c28$var$f, $fb90597ba2996c28$var$p.replace(/__ANGLE_STEP_SIZE__/gi, `${(1 / s / o).toFixed(7)}`).replace(/__DIST__/gi, `${o.toFixed(0)}.0`)), this.uniforms.glowColor = new Float32Array([
            0,
            0,
            0,
            1
        ]), this.uniforms.alpha = 1, Object.assign(this, {
            color: u,
            outerStrength: a,
            innerStrength: i,
            padding: o,
            knockout: c,
            alpha: h
        });
    }
    get color() {
        return (0, $5d808cc4b6a3c326$exports).rgb2hex(this.uniforms.glowColor);
    }
    set color(n) {
        (0, $5d808cc4b6a3c326$exports).hex2rgb(n, this.uniforms.glowColor);
    }
    get outerStrength() {
        return this.uniforms.outerStrength;
    }
    set outerStrength(n) {
        this.uniforms.outerStrength = n;
    }
    get innerStrength() {
        return this.uniforms.innerStrength;
    }
    set innerStrength(n) {
        this.uniforms.innerStrength = n;
    }
    get knockout() {
        return this.uniforms.knockout;
    }
    set knockout(n) {
        this.uniforms.knockout = n;
    }
    get alpha() {
        return this.uniforms.alpha;
    }
    set alpha(n) {
        this.uniforms.alpha = n;
    }
};
let $fb90597ba2996c28$export$faabf7f2d3f0943e = $fb90597ba2996c28$var$e;
$fb90597ba2996c28$export$faabf7f2d3f0943e.defaults = {
    distance: 10,
    outerStrength: 4,
    innerStrength: 0,
    color: 16777215,
    quality: .1,
    knockout: !1,
    alpha: 1
};


/*!
 * @pixi/filter-godray - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-godray is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $b7a32ef02f997efb$var$v = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $b7a32ef02f997efb$var$f = `vec3 mod289(vec3 x)
{
    return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec4 mod289(vec4 x)
{
    return x - floor(x * (1.0 / 289.0)) * 289.0;
}
vec4 permute(vec4 x)
{
    return mod289(((x * 34.0) + 1.0) * x);
}
vec4 taylorInvSqrt(vec4 r)
{
    return 1.79284291400159 - 0.85373472095314 * r;
}
vec3 fade(vec3 t)
{
    return t * t * t * (t * (t * 6.0 - 15.0) + 10.0);
}
// Classic Perlin noise, periodic variant
float pnoise(vec3 P, vec3 rep)
{
    vec3 Pi0 = mod(floor(P), rep); // Integer part, modulo period
    vec3 Pi1 = mod(Pi0 + vec3(1.0), rep); // Integer part + 1, mod period
    Pi0 = mod289(Pi0);
    Pi1 = mod289(Pi1);
    vec3 Pf0 = fract(P); // Fractional part for interpolation
    vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0
    vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
    vec4 iy = vec4(Pi0.yy, Pi1.yy);
    vec4 iz0 = Pi0.zzzz;
    vec4 iz1 = Pi1.zzzz;
    vec4 ixy = permute(permute(ix) + iy);
    vec4 ixy0 = permute(ixy + iz0);
    vec4 ixy1 = permute(ixy + iz1);
    vec4 gx0 = ixy0 * (1.0 / 7.0);
    vec4 gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;
    gx0 = fract(gx0);
    vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
    vec4 sz0 = step(gz0, vec4(0.0));
    gx0 -= sz0 * (step(0.0, gx0) - 0.5);
    gy0 -= sz0 * (step(0.0, gy0) - 0.5);
    vec4 gx1 = ixy1 * (1.0 / 7.0);
    vec4 gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;
    gx1 = fract(gx1);
    vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
    vec4 sz1 = step(gz1, vec4(0.0));
    gx1 -= sz1 * (step(0.0, gx1) - 0.5);
    gy1 -= sz1 * (step(0.0, gy1) - 0.5);
    vec3 g000 = vec3(gx0.x, gy0.x, gz0.x);
    vec3 g100 = vec3(gx0.y, gy0.y, gz0.y);
    vec3 g010 = vec3(gx0.z, gy0.z, gz0.z);
    vec3 g110 = vec3(gx0.w, gy0.w, gz0.w);
    vec3 g001 = vec3(gx1.x, gy1.x, gz1.x);
    vec3 g101 = vec3(gx1.y, gy1.y, gz1.y);
    vec3 g011 = vec3(gx1.z, gy1.z, gz1.z);
    vec3 g111 = vec3(gx1.w, gy1.w, gz1.w);
    vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
    g000 *= norm0.x;
    g010 *= norm0.y;
    g100 *= norm0.z;
    g110 *= norm0.w;
    vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
    g001 *= norm1.x;
    g011 *= norm1.y;
    g101 *= norm1.z;
    g111 *= norm1.w;
    float n000 = dot(g000, Pf0);
    float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
    float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
    float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
    float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
    float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
    float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
    float n111 = dot(g111, Pf1);
    vec3 fade_xyz = fade(Pf0);
    vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
    vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
    float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x);
    return 2.2 * n_xyz;
}
float turb(vec3 P, vec3 rep, float lacunarity, float gain)
{
    float sum = 0.0;
    float sc = 1.0;
    float totalgain = 1.0;
    for (float i = 0.0; i < 6.0; i++)
    {
        sum += totalgain * pnoise(P * sc, rep);
        sc *= lacunarity;
        totalgain *= gain;
    }
    return abs(sum);
}
`, $b7a32ef02f997efb$var$x = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;
uniform vec2 dimensions;

uniform vec2 light;
uniform bool parallel;
uniform float aspect;

uniform float gain;
uniform float lacunarity;
uniform float time;
uniform float alpha;

\${perlin}

void main(void) {
    vec2 coord = vTextureCoord * filterArea.xy / dimensions.xy;

    float d;

    if (parallel) {
        float _cos = light.x;
        float _sin = light.y;
        d = (_cos * coord.x) + (_sin * coord.y * aspect);
    } else {
        float dx = coord.x - light.x / dimensions.x;
        float dy = (coord.y - light.y / dimensions.y) * aspect;
        float dis = sqrt(dx * dx + dy * dy) + 0.00001;
        d = dy / dis;
    }

    vec3 dir = vec3(d, d, 0.0);

    float noise = turb(dir + vec3(time, 0.0, 62.1 + time) * 0.05, vec3(480.0, 320.0, 480.0), lacunarity, gain);
    noise = mix(noise, 0.0, 0.3);
    //fade vertically.
    vec4 mist = vec4(noise, noise, noise, 1.0) * (1.0 - coord.y);
    mist.a = 1.0;
    // apply user alpha
    mist *= alpha;

    gl_FragColor = texture2D(uSampler, vTextureCoord) + mist;

}
`;
const $b7a32ef02f997efb$var$a = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e){
        super($b7a32ef02f997efb$var$v, $b7a32ef02f997efb$var$x.replace("${perlin}", $b7a32ef02f997efb$var$f)), this.parallel = !0, this.time = 0, this._angle = 0, this.uniforms.dimensions = new Float32Array(2);
        const n = Object.assign($b7a32ef02f997efb$var$a.defaults, e);
        this._angleLight = new (0, $88931fa1c0809be8$export$baf26146a414f24a), this.angle = n.angle, this.gain = n.gain, this.lacunarity = n.lacunarity, this.alpha = n.alpha, this.parallel = n.parallel, this.center = n.center, this.time = n.time;
    }
    apply(e, n, o, l) {
        const { width: t , height: i  } = n.filterFrame;
        this.uniforms.light = this.parallel ? this._angleLight : this.center, this.uniforms.parallel = this.parallel, this.uniforms.dimensions[0] = t, this.uniforms.dimensions[1] = i, this.uniforms.aspect = i / t, this.uniforms.time = this.time, this.uniforms.alpha = this.alpha, e.applyFilter(this, n, o, l);
    }
    get angle() {
        return this._angle;
    }
    set angle(e) {
        this._angle = e;
        const n = e * (0, $07142e085c72c7cc$export$870617f62e3187f1);
        this._angleLight.x = Math.cos(n), this._angleLight.y = Math.sin(n);
    }
    get gain() {
        return this.uniforms.gain;
    }
    set gain(e) {
        this.uniforms.gain = e;
    }
    get lacunarity() {
        return this.uniforms.lacunarity;
    }
    set lacunarity(e) {
        this.uniforms.lacunarity = e;
    }
    get alpha() {
        return this.uniforms.alpha;
    }
    set alpha(e) {
        this.uniforms.alpha = e;
    }
};
let $b7a32ef02f997efb$export$9f73ef882e89e91 = $b7a32ef02f997efb$var$a;
$b7a32ef02f997efb$export$9f73ef882e89e91.defaults = {
    angle: 30,
    gain: .5,
    lacunarity: 2.5,
    time: 0,
    parallel: !0,
    center: [
        0,
        0
    ],
    alpha: 1
};


/*!
 * @pixi/filter-grayscale - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-grayscale is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $dd85d2f190e1741f$var$o = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $dd85d2f190e1741f$var$r = `precision mediump float;

varying vec2 vTextureCoord;
uniform sampler2D uSampler;

// https://en.wikipedia.org/wiki/Luma_(video)
const vec3 weight = vec3(0.299, 0.587, 0.114);

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    gl_FragColor = vec4(
        vec3(color.r * weight.r + color.g * weight.g  + color.b * weight.b),
        color.a
    );
}
`;
class $dd85d2f190e1741f$export$cae29994b9b0c1a8 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(){
        super($dd85d2f190e1741f$var$o, $dd85d2f190e1741f$var$r);
    }
}


/*!
 * @pixi/filter-hsl-adjustment - v5.2.0
 * Compiled Tue, 28 Feb 2023 14:24:35 UTC
 *
 * @pixi/filter-hsl-adjustment is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $bfdbbb143275f753$var$i = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $bfdbbb143275f753$var$s = `precision mediump float;

varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float uHue;
uniform float uAlpha;
uniform bool uColorize;
uniform float uSaturation;
uniform float uLightness;

// https://en.wikipedia.org/wiki/Luma_(video)
const vec3 weight = vec3(0.299, 0.587, 0.114);

float getWeightedAverage(vec3 rgb) {
    return rgb.r * weight.r + rgb.g * weight.g + rgb.b * weight.b;
}

// https://gist.github.com/mairod/a75e7b44f68110e1576d77419d608786?permalink_comment_id=3195243#gistcomment-3195243
const vec3 k = vec3(0.57735, 0.57735, 0.57735);

vec3 hueShift(vec3 color, float angle) {
    float cosAngle = cos(angle);
    return vec3(
    color * cosAngle +
    cross(k, color) * sin(angle) +
    k * dot(k, color) * (1.0 - cosAngle)
    );
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    vec4 result = color;

    // colorize
    if (uColorize) {
        result.rgb = vec3(getWeightedAverage(result.rgb), 0., 0.);
    }

    // hue
    result.rgb = hueShift(result.rgb, uHue);

    // saturation
    // https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/huesaturation.js
    float average = (result.r + result.g + result.b) / 3.0;

    if (uSaturation > 0.) {
        result.rgb += (average - result.rgb) * (1. - 1. / (1.001 - uSaturation));
    } else {
        result.rgb -= (average - result.rgb) * uSaturation;
    }

    // lightness
    result.rgb = mix(result.rgb, vec3(ceil(uLightness)) * color.a, abs(uLightness));

    // alpha
    gl_FragColor = mix(color, result, uAlpha);
}
`;
const $bfdbbb143275f753$var$t = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e){
        super($bfdbbb143275f753$var$i, $bfdbbb143275f753$var$s), this._hue = 0;
        const r = Object.assign({}, $bfdbbb143275f753$var$t.defaults, e);
        Object.assign(this, r);
    }
    get hue() {
        return this._hue;
    }
    set hue(e) {
        this._hue = e, this.uniforms.uHue = this._hue * (Math.PI / 180);
    }
    get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(e) {
        this.uniforms.uAlpha = e;
    }
    get colorize() {
        return this.uniforms.uColorize;
    }
    set colorize(e) {
        this.uniforms.uColorize = e;
    }
    get lightness() {
        return this.uniforms.uLightness;
    }
    set lightness(e) {
        this.uniforms.uLightness = e;
    }
    get saturation() {
        return this.uniforms.uSaturation;
    }
    set saturation(e) {
        this.uniforms.uSaturation = e;
    }
};
let $bfdbbb143275f753$export$7ec1de72e805fe3e = $bfdbbb143275f753$var$t;
$bfdbbb143275f753$export$7ec1de72e805fe3e.defaults = {
    hue: 0,
    saturation: 0,
    lightness: 0,
    colorize: !1,
    alpha: 1
};



/*!
 * @pixi/filter-motion-blur - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-motion-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $d5b00c411543e9bd$var$a = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $d5b00c411543e9bd$var$c = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;

uniform vec2 uVelocity;
uniform int uKernelSize;
uniform float uOffset;

const int MAX_KERNEL_SIZE = 2048;

// Notice:
// the perfect way:
//    int kernelSize = min(uKernelSize, MAX_KERNELSIZE);
// BUT in real use-case , uKernelSize < MAX_KERNELSIZE almost always.
// So use uKernelSize directly.

void main(void)
{
    vec4 color = texture2D(uSampler, vTextureCoord);

    if (uKernelSize == 0)
    {
        gl_FragColor = color;
        return;
    }

    vec2 velocity = uVelocity / filterArea.xy;
    float offset = -uOffset / length(uVelocity) - 0.5;
    int k = uKernelSize - 1;

    for(int i = 0; i < MAX_KERNEL_SIZE - 1; i++) {
        if (i == k) {
            break;
        }
        vec2 bias = velocity * (float(i) / float(k) + offset);
        color += texture2D(uSampler, vTextureCoord + bias);
    }
    gl_FragColor = color / float(uKernelSize);
}
`;
class $d5b00c411543e9bd$export$d65c226804e2a98c extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e = [
        0,
        0
    ], t = 5, i = 0){
        super($d5b00c411543e9bd$var$a, $d5b00c411543e9bd$var$c), this.kernelSize = 5, this.uniforms.uVelocity = new Float32Array(2), this._velocity = new (0, $e3200063c3e77fce$export$3755aaad3fd42e52)(this.velocityChanged, this), this.setVelocity(e), this.kernelSize = t, this.offset = i;
    }
    apply(e, t, i, n) {
        const { x: o , y: r  } = this.velocity;
        this.uniforms.uKernelSize = o !== 0 || r !== 0 ? this.kernelSize : 0, e.applyFilter(this, t, i, n);
    }
    set velocity(e) {
        this.setVelocity(e);
    }
    get velocity() {
        return this._velocity;
    }
    setVelocity(e) {
        if (Array.isArray(e)) {
            const [t, i] = e;
            this._velocity.set(t, i);
        } else this._velocity.copyFrom(e);
    }
    velocityChanged() {
        this.uniforms.uVelocity[0] = this._velocity.x, this.uniforms.uVelocity[1] = this._velocity.y, this.padding = (Math.max(Math.abs(this._velocity.x), Math.abs(this._velocity.y)) >> 0) + 1;
    }
    set offset(e) {
        this.uniforms.uOffset = e;
    }
    get offset() {
        return this.uniforms.uOffset;
    }
}


/*!
 * @pixi/filter-multi-color-replace - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-multi-color-replace is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ebbd72eaf6809472$var$c = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $ebbd72eaf6809472$var$g = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform float epsilon;

const int MAX_COLORS = %maxColors%;

uniform vec3 originalColors[MAX_COLORS];
uniform vec3 targetColors[MAX_COLORS];

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord);

    float alpha = gl_FragColor.a;
    if (alpha < 0.0001)
    {
      return;
    }

    vec3 color = gl_FragColor.rgb / alpha;

    for(int i = 0; i < MAX_COLORS; i++)
    {
      vec3 origColor = originalColors[i];
      if (origColor.r < 0.0)
      {
        break;
      }
      vec3 colorDiff = origColor - color;
      if (length(colorDiff) < epsilon)
      {
        vec3 targetColor = targetColors[i];
        gl_FragColor = vec4((targetColor + colorDiff) * alpha, alpha);
        return;
      }
    }
}
`;
class $ebbd72eaf6809472$export$ad0913c096ecbd2f extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(o, i = .05, e = o.length){
        super($ebbd72eaf6809472$var$c, $ebbd72eaf6809472$var$g.replace(/%maxColors%/g, e.toFixed(0))), this._replacements = [], this._maxColors = 0, this.epsilon = i, this._maxColors = e, this.uniforms.originalColors = new Float32Array(e * 3), this.uniforms.targetColors = new Float32Array(e * 3), this.replacements = o;
    }
    set replacements(o) {
        const i = this.uniforms.originalColors, e = this.uniforms.targetColors, l = o.length;
        if (l > this._maxColors) throw new Error(`Length of replacements (${l}) exceeds the maximum colors length (${this._maxColors})`);
        i[l * 3] = -1;
        for(let r = 0; r < l; r++){
            const s = o[r];
            let n = s[0];
            typeof n == "number" ? n = (0, $5d808cc4b6a3c326$exports).hex2rgb(n) : s[0] = (0, $5d808cc4b6a3c326$exports).rgb2hex(n), i[r * 3] = n[0], i[r * 3 + 1] = n[1], i[r * 3 + 2] = n[2];
            let t = s[1];
            typeof t == "number" ? t = (0, $5d808cc4b6a3c326$exports).hex2rgb(t) : s[1] = (0, $5d808cc4b6a3c326$exports).rgb2hex(t), e[r * 3] = t[0], e[r * 3 + 1] = t[1], e[r * 3 + 2] = t[2];
        }
        this._replacements = o;
    }
    get replacements() {
        return this._replacements;
    }
    refresh() {
        this.replacements = this._replacements;
    }
    get maxColors() {
        return this._maxColors;
    }
    set epsilon(o) {
        this.uniforms.epsilon = o;
    }
    get epsilon() {
        return this.uniforms.epsilon;
    }
}


/*!
 * @pixi/filter-old-film - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-old-film is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $986f3e9d24b8f8c1$var$l = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $986f3e9d24b8f8c1$var$d = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;
uniform vec2 dimensions;

uniform float sepia;
uniform float noise;
uniform float noiseSize;
uniform float scratch;
uniform float scratchDensity;
uniform float scratchWidth;
uniform float vignetting;
uniform float vignettingAlpha;
uniform float vignettingBlur;
uniform float seed;

const float SQRT_2 = 1.414213;
const vec3 SEPIA_RGB = vec3(112.0 / 255.0, 66.0 / 255.0, 20.0 / 255.0);

float rand(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

vec3 Overlay(vec3 src, vec3 dst)
{
    // if (dst <= 0.5) then: 2 * src * dst
    // if (dst > 0.5) then: 1 - 2 * (1 - dst) * (1 - src)
    return vec3((dst.x <= 0.5) ? (2.0 * src.x * dst.x) : (1.0 - 2.0 * (1.0 - dst.x) * (1.0 - src.x)),
                (dst.y <= 0.5) ? (2.0 * src.y * dst.y) : (1.0 - 2.0 * (1.0 - dst.y) * (1.0 - src.y)),
                (dst.z <= 0.5) ? (2.0 * src.z * dst.z) : (1.0 - 2.0 * (1.0 - dst.z) * (1.0 - src.z)));
}


void main()
{
    gl_FragColor = texture2D(uSampler, vTextureCoord);
    vec3 color = gl_FragColor.rgb;

    if (sepia > 0.0)
    {
        float gray = (color.x + color.y + color.z) / 3.0;
        vec3 grayscale = vec3(gray);

        color = Overlay(SEPIA_RGB, grayscale);

        color = grayscale + sepia * (color - grayscale);
    }

    vec2 coord = vTextureCoord * filterArea.xy / dimensions.xy;

    if (vignetting > 0.0)
    {
        float outter = SQRT_2 - vignetting * SQRT_2;
        vec2 dir = vec2(vec2(0.5, 0.5) - coord);
        dir.y *= dimensions.y / dimensions.x;
        float darker = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + vignettingBlur * SQRT_2), 0.0, 1.0);
        color.rgb *= darker + (1.0 - darker) * (1.0 - vignettingAlpha);
    }

    if (scratchDensity > seed && scratch != 0.0)
    {
        float phase = seed * 256.0;
        float s = mod(floor(phase), 2.0);
        float dist = 1.0 / scratchDensity;
        float d = distance(coord, vec2(seed * dist, abs(s - seed * dist)));
        if (d < seed * 0.6 + 0.4)
        {
            highp float period = scratchDensity * 10.0;

            float xx = coord.x * period + phase;
            float aa = abs(mod(xx, 0.5) * 4.0);
            float bb = mod(floor(xx / 0.5), 2.0);
            float yy = (1.0 - bb) * aa + bb * (2.0 - aa);

            float kk = 2.0 * period;
            float dw = scratchWidth / dimensions.x * (0.75 + seed);
            float dh = dw * kk;

            float tine = (yy - (2.0 - dh));

            if (tine > 0.0) {
                float _sign = sign(scratch);

                tine = s * tine / period + scratch + 0.1;
                tine = clamp(tine + 1.0, 0.5 + _sign * 0.5, 1.5 + _sign * 0.5);

                color.rgb *= tine;
            }
        }
    }

    if (noise > 0.0 && noiseSize > 0.0)
    {
        vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
        pixelCoord.x = floor(pixelCoord.x / noiseSize);
        pixelCoord.y = floor(pixelCoord.y / noiseSize);
        // vec2 d = pixelCoord * noiseSize * vec2(1024.0 + seed * 512.0, 1024.0 - seed * 512.0);
        // float _noise = snoise(d) * 0.5;
        float _noise = rand(pixelCoord * noiseSize * seed) - 0.5;
        color += _noise * noise;
    }

    gl_FragColor.rgb = color;
}
`;
const $986f3e9d24b8f8c1$var$s = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(n, i = 0){
        super($986f3e9d24b8f8c1$var$l, $986f3e9d24b8f8c1$var$d), this.seed = 0, this.uniforms.dimensions = new Float32Array(2), typeof n == "number" ? (this.seed = n, n = void 0) : this.seed = i, Object.assign(this, $986f3e9d24b8f8c1$var$s.defaults, n);
    }
    apply(n, i, o, a) {
        var t, e;
        this.uniforms.dimensions[0] = (t = i.filterFrame) == null ? void 0 : t.width, this.uniforms.dimensions[1] = (e = i.filterFrame) == null ? void 0 : e.height, this.uniforms.seed = this.seed, n.applyFilter(this, i, o, a);
    }
    set sepia(n) {
        this.uniforms.sepia = n;
    }
    get sepia() {
        return this.uniforms.sepia;
    }
    set noise(n) {
        this.uniforms.noise = n;
    }
    get noise() {
        return this.uniforms.noise;
    }
    set noiseSize(n) {
        this.uniforms.noiseSize = n;
    }
    get noiseSize() {
        return this.uniforms.noiseSize;
    }
    set scratch(n) {
        this.uniforms.scratch = n;
    }
    get scratch() {
        return this.uniforms.scratch;
    }
    set scratchDensity(n) {
        this.uniforms.scratchDensity = n;
    }
    get scratchDensity() {
        return this.uniforms.scratchDensity;
    }
    set scratchWidth(n) {
        this.uniforms.scratchWidth = n;
    }
    get scratchWidth() {
        return this.uniforms.scratchWidth;
    }
    set vignetting(n) {
        this.uniforms.vignetting = n;
    }
    get vignetting() {
        return this.uniforms.vignetting;
    }
    set vignettingAlpha(n) {
        this.uniforms.vignettingAlpha = n;
    }
    get vignettingAlpha() {
        return this.uniforms.vignettingAlpha;
    }
    set vignettingBlur(n) {
        this.uniforms.vignettingBlur = n;
    }
    get vignettingBlur() {
        return this.uniforms.vignettingBlur;
    }
};
let $986f3e9d24b8f8c1$export$4ea6953a37e049ea = $986f3e9d24b8f8c1$var$s;
$986f3e9d24b8f8c1$export$4ea6953a37e049ea.defaults = {
    sepia: .3,
    noise: .3,
    noiseSize: 1,
    scratch: .5,
    scratchDensity: .3,
    scratchWidth: 1,
    vignetting: .3,
    vignettingAlpha: 1,
    vignettingBlur: .3
};


/*!
 * @pixi/filter-outline - v5.2.0
 * Compiled Tue, 28 Feb 2023 14:24:35 UTC
 *
 * @pixi/filter-outline is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $70c55735395b082a$var$u = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $70c55735395b082a$var$c = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterClamp;

uniform float uAlpha;
uniform vec2 uThickness;
uniform vec4 uColor;
uniform bool uKnockout;

const float DOUBLE_PI = 2. * 3.14159265358979323846264;
const float ANGLE_STEP = \${angleStep};

float outlineMaxAlphaAtPos(vec2 pos) {
    if (uThickness.x == 0. || uThickness.y == 0.) {
        return 0.;
    }

    vec4 displacedColor;
    vec2 displacedPos;
    float maxAlpha = 0.;

    for (float angle = 0.; angle <= DOUBLE_PI; angle += ANGLE_STEP) {
        displacedPos.x = vTextureCoord.x + uThickness.x * cos(angle);
        displacedPos.y = vTextureCoord.y + uThickness.y * sin(angle);
        displacedColor = texture2D(uSampler, clamp(displacedPos, filterClamp.xy, filterClamp.zw));
        maxAlpha = max(maxAlpha, displacedColor.a);
    }

    return maxAlpha;
}

void main(void) {
    vec4 sourceColor = texture2D(uSampler, vTextureCoord);
    vec4 contentColor = sourceColor * float(!uKnockout);
    float outlineAlpha = uAlpha * outlineMaxAlphaAtPos(vTextureCoord.xy) * (1.-sourceColor.a);
    vec4 outlineColor = vec4(vec3(uColor) * outlineAlpha, outlineAlpha);
    gl_FragColor = contentColor + outlineColor;
}
`;
const $70c55735395b082a$var$r = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(o = 1, t = 0, n = .1, e = 1, s = !1){
        super($70c55735395b082a$var$u, $70c55735395b082a$var$c.replace(/\$\{angleStep\}/, $70c55735395b082a$var$r.getAngleStep(n))), this._thickness = 1, this._alpha = 1, this._knockout = !1, this.uniforms.uThickness = new Float32Array([
            0,
            0
        ]), this.uniforms.uColor = new Float32Array([
            0,
            0,
            0,
            1
        ]), this.uniforms.uAlpha = e, this.uniforms.uKnockout = s, Object.assign(this, {
            thickness: o,
            color: t,
            quality: n,
            alpha: e,
            knockout: s
        });
    }
    static getAngleStep(o) {
        const t = Math.max(o * $70c55735395b082a$var$r.MAX_SAMPLES, $70c55735395b082a$var$r.MIN_SAMPLES);
        return (Math.PI * 2 / t).toFixed(7);
    }
    apply(o, t, n, e) {
        this.uniforms.uThickness[0] = this._thickness / t._frame.width, this.uniforms.uThickness[1] = this._thickness / t._frame.height, this.uniforms.uAlpha = this._alpha, this.uniforms.uKnockout = this._knockout, o.applyFilter(this, t, n, e);
    }
    get alpha() {
        return this._alpha;
    }
    set alpha(o) {
        this._alpha = o;
    }
    get color() {
        return (0, $5d808cc4b6a3c326$exports).rgb2hex(this.uniforms.uColor);
    }
    set color(o) {
        (0, $5d808cc4b6a3c326$exports).hex2rgb(o, this.uniforms.uColor);
    }
    get knockout() {
        return this._knockout;
    }
    set knockout(o) {
        this._knockout = o;
    }
    get thickness() {
        return this._thickness;
    }
    set thickness(o) {
        this._thickness = o, this.padding = o;
    }
};
let $70c55735395b082a$export$ea1238a366116160 = $70c55735395b082a$var$r;
$70c55735395b082a$export$ea1238a366116160.MIN_SAMPLES = 1, $70c55735395b082a$export$ea1238a366116160.MAX_SAMPLES = 100;


/*!
 * @pixi/filter-pixelate - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-pixelate is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $fcfe2b721c82698e$var$e = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $fcfe2b721c82698e$var$n = `precision mediump float;

varying vec2 vTextureCoord;

uniform vec2 size;
uniform sampler2D uSampler;

uniform vec4 filterArea;

vec2 mapCoord( vec2 coord )
{
    coord *= filterArea.xy;
    coord += filterArea.zw;

    return coord;
}

vec2 unmapCoord( vec2 coord )
{
    coord -= filterArea.zw;
    coord /= filterArea.xy;

    return coord;
}

vec2 pixelate(vec2 coord, vec2 size)
{
	return floor( coord / size ) * size;
}

void main(void)
{
    vec2 coord = mapCoord(vTextureCoord);

    coord = pixelate(coord, size);

    coord = unmapCoord(coord);

    gl_FragColor = texture2D(uSampler, coord);
}
`;
class $fcfe2b721c82698e$export$8ec99043c41c044 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(r = 10){
        super($fcfe2b721c82698e$var$e, $fcfe2b721c82698e$var$n), this.size = r;
    }
    get size() {
        return this.uniforms.size;
    }
    set size(r) {
        typeof r == "number" && (r = [
            r,
            r
        ]), this.uniforms.size = r;
    }
}


/*!
 * @pixi/filter-radial-blur - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-radial-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ec5e258bf559f6b7$var$a = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $ec5e258bf559f6b7$var$o = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;

uniform float uRadian;
uniform vec2 uCenter;
uniform float uRadius;
uniform int uKernelSize;

const int MAX_KERNEL_SIZE = 2048;

void main(void)
{
    vec4 color = texture2D(uSampler, vTextureCoord);

    if (uKernelSize == 0)
    {
        gl_FragColor = color;
        return;
    }

    float aspect = filterArea.y / filterArea.x;
    vec2 center = uCenter.xy / filterArea.xy;
    float gradient = uRadius / filterArea.x * 0.3;
    float radius = uRadius / filterArea.x - gradient * 0.5;
    int k = uKernelSize - 1;

    vec2 coord = vTextureCoord;
    vec2 dir = vec2(center - coord);
    float dist = length(vec2(dir.x, dir.y * aspect));

    float radianStep = uRadian;
    if (radius >= 0.0 && dist > radius) {
        float delta = dist - radius;
        float gap = gradient;
        float scale = 1.0 - abs(delta / gap);
        if (scale <= 0.0) {
            gl_FragColor = color;
            return;
        }
        radianStep *= scale;
    }
    radianStep /= float(k);

    float s = sin(radianStep);
    float c = cos(radianStep);
    mat2 rotationMatrix = mat2(vec2(c, -s), vec2(s, c));

    for(int i = 0; i < MAX_KERNEL_SIZE - 1; i++) {
        if (i == k) {
            break;
        }

        coord -= center;
        coord.y *= aspect;
        coord = rotationMatrix * coord;
        coord.y /= aspect;
        coord += center;

        vec4 sample = texture2D(uSampler, coord);

        // switch to pre-multiplied alpha to correctly blur transparent images
        // sample.rgb *= sample.a;

        color += sample;
    }

    gl_FragColor = color / float(uKernelSize);
}
`;
class $ec5e258bf559f6b7$export$365864b37518d56d extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(n = 0, e = [
        0,
        0
    ], r = 5, t = -1){
        super($ec5e258bf559f6b7$var$a, $ec5e258bf559f6b7$var$o), this._angle = 0, this.angle = n, this.center = e, this.kernelSize = r, this.radius = t;
    }
    apply(n, e, r, t) {
        this.uniforms.uKernelSize = this._angle !== 0 ? this.kernelSize : 0, n.applyFilter(this, e, r, t);
    }
    set angle(n) {
        this._angle = n, this.uniforms.uRadian = n * Math.PI / 180;
    }
    get angle() {
        return this._angle;
    }
    get center() {
        return this.uniforms.uCenter;
    }
    set center(n) {
        this.uniforms.uCenter = n;
    }
    get radius() {
        return this.uniforms.uRadius;
    }
    set radius(n) {
        (n < 0 || n === 1 / 0) && (n = -1), this.uniforms.uRadius = n;
    }
}


/*!
 * @pixi/filter-reflection - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-reflection is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $4644cfbb0604eba9$var$m = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $4644cfbb0604eba9$var$s = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec4 filterArea;
uniform vec4 filterClamp;
uniform vec2 dimensions;

uniform bool mirror;
uniform float boundary;
uniform vec2 amplitude;
uniform vec2 waveLength;
uniform vec2 alpha;
uniform float time;

float rand(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main(void)
{
    vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
    vec2 coord = pixelCoord / dimensions;

    if (coord.y < boundary) {
        gl_FragColor = texture2D(uSampler, vTextureCoord);
        return;
    }

    float k = (coord.y - boundary) / (1. - boundary + 0.0001);
    float areaY = boundary * dimensions.y / filterArea.y;
    float v = areaY + areaY - vTextureCoord.y;
    float y = mirror ? v : vTextureCoord.y;

    float _amplitude = ((amplitude.y - amplitude.x) * k + amplitude.x ) / filterArea.x;
    float _waveLength = ((waveLength.y - waveLength.x) * k + waveLength.x) / filterArea.y;
    float _alpha = (alpha.y - alpha.x) * k + alpha.x;

    float x = vTextureCoord.x + cos(v * 6.28 / _waveLength - time) * _amplitude;
    x = clamp(x, filterClamp.x, filterClamp.z);

    vec4 color = texture2D(uSampler, vec2(x, y));

    gl_FragColor = color * _alpha;
}
`;
const $4644cfbb0604eba9$var$i = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(r){
        super($4644cfbb0604eba9$var$m, $4644cfbb0604eba9$var$s), this.time = 0, this.uniforms.amplitude = new Float32Array(2), this.uniforms.waveLength = new Float32Array(2), this.uniforms.alpha = new Float32Array(2), this.uniforms.dimensions = new Float32Array(2), Object.assign(this, $4644cfbb0604eba9$var$i.defaults, r);
    }
    apply(r, e, a, u) {
        var n, t;
        this.uniforms.dimensions[0] = (n = e.filterFrame) == null ? void 0 : n.width, this.uniforms.dimensions[1] = (t = e.filterFrame) == null ? void 0 : t.height, this.uniforms.time = this.time, r.applyFilter(this, e, a, u);
    }
    set mirror(r) {
        this.uniforms.mirror = r;
    }
    get mirror() {
        return this.uniforms.mirror;
    }
    set boundary(r) {
        this.uniforms.boundary = r;
    }
    get boundary() {
        return this.uniforms.boundary;
    }
    set amplitude(r) {
        this.uniforms.amplitude[0] = r[0], this.uniforms.amplitude[1] = r[1];
    }
    get amplitude() {
        return this.uniforms.amplitude;
    }
    set waveLength(r) {
        this.uniforms.waveLength[0] = r[0], this.uniforms.waveLength[1] = r[1];
    }
    get waveLength() {
        return this.uniforms.waveLength;
    }
    set alpha(r) {
        this.uniforms.alpha[0] = r[0], this.uniforms.alpha[1] = r[1];
    }
    get alpha() {
        return this.uniforms.alpha;
    }
};
let $4644cfbb0604eba9$export$92cc156c1a64ee47 = $4644cfbb0604eba9$var$i;
$4644cfbb0604eba9$export$92cc156c1a64ee47.defaults = {
    mirror: !0,
    boundary: .5,
    amplitude: [
        0,
        20
    ],
    waveLength: [
        30,
        100
    ],
    alpha: [
        1,
        1
    ],
    time: 0
};


/*!
 * @pixi/filter-rgb-split - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-rgb-split is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $81b20ac943d2807d$var$o = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $81b20ac943d2807d$var$i = `precision mediump float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 filterArea;
uniform vec2 red;
uniform vec2 green;
uniform vec2 blue;

void main(void)
{
   gl_FragColor.r = texture2D(uSampler, vTextureCoord + red/filterArea.xy).r;
   gl_FragColor.g = texture2D(uSampler, vTextureCoord + green/filterArea.xy).g;
   gl_FragColor.b = texture2D(uSampler, vTextureCoord + blue/filterArea.xy).b;
   gl_FragColor.a = texture2D(uSampler, vTextureCoord).a;
}
`;
class $81b20ac943d2807d$export$4f8410d721b3e55e extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e = [
        -10,
        0
    ], r = [
        0,
        10
    ], t = [
        0,
        0
    ]){
        super($81b20ac943d2807d$var$o, $81b20ac943d2807d$var$i), this.red = e, this.green = r, this.blue = t;
    }
    get red() {
        return this.uniforms.red;
    }
    set red(e) {
        this.uniforms.red = e;
    }
    get green() {
        return this.uniforms.green;
    }
    set green(e) {
        this.uniforms.green = e;
    }
    get blue() {
        return this.uniforms.blue;
    }
    set blue(e) {
        this.uniforms.blue = e;
    }
}


/*!
 * @pixi/filter-shockwave - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-shockwave is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $01f5d1427c3b1398$var$s = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $01f5d1427c3b1398$var$f = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;
uniform vec4 filterClamp;

uniform vec2 center;

uniform float amplitude;
uniform float wavelength;
// uniform float power;
uniform float brightness;
uniform float speed;
uniform float radius;

uniform float time;

const float PI = 3.14159;

void main()
{
    float halfWavelength = wavelength * 0.5 / filterArea.x;
    float maxRadius = radius / filterArea.x;
    float currentRadius = time * speed / filterArea.x;

    float fade = 1.0;

    if (maxRadius > 0.0) {
        if (currentRadius > maxRadius) {
            gl_FragColor = texture2D(uSampler, vTextureCoord);
            return;
        }
        fade = 1.0 - pow(currentRadius / maxRadius, 2.0);
    }

    vec2 dir = vec2(vTextureCoord - center / filterArea.xy);
    dir.y *= filterArea.y / filterArea.x;
    float dist = length(dir);

    if (dist <= 0.0 || dist < currentRadius - halfWavelength || dist > currentRadius + halfWavelength) {
        gl_FragColor = texture2D(uSampler, vTextureCoord);
        return;
    }

    vec2 diffUV = normalize(dir);

    float diff = (dist - currentRadius) / halfWavelength;

    float p = 1.0 - pow(abs(diff), 2.0);

    // float powDiff = diff * pow(p, 2.0) * ( amplitude * fade );
    float powDiff = 1.25 * sin(diff * PI) * p * ( amplitude * fade );

    vec2 offset = diffUV * powDiff / filterArea.xy;

    // Do clamp :
    vec2 coord = vTextureCoord + offset;
    vec2 clampedCoord = clamp(coord, filterClamp.xy, filterClamp.zw);
    vec4 color = texture2D(uSampler, clampedCoord);
    if (coord != clampedCoord) {
        color *= max(0.0, 1.0 - length(coord - clampedCoord));
    }

    // No clamp :
    // gl_FragColor = texture2D(uSampler, vTextureCoord + offset);

    color.rgb *= 1.0 + (brightness - 1.0) * p * fade;

    gl_FragColor = color;
}
`;
const $01f5d1427c3b1398$var$n = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e = [
        0,
        0
    ], r, t = 0){
        super($01f5d1427c3b1398$var$s, $01f5d1427c3b1398$var$f), this.center = e, Object.assign(this, $01f5d1427c3b1398$var$n.defaults, r), this.time = t;
    }
    apply(e, r, t, o) {
        this.uniforms.time = this.time, e.applyFilter(this, r, t, o);
    }
    get center() {
        return this.uniforms.center;
    }
    set center(e) {
        this.uniforms.center = e;
    }
    get amplitude() {
        return this.uniforms.amplitude;
    }
    set amplitude(e) {
        this.uniforms.amplitude = e;
    }
    get wavelength() {
        return this.uniforms.wavelength;
    }
    set wavelength(e) {
        this.uniforms.wavelength = e;
    }
    get brightness() {
        return this.uniforms.brightness;
    }
    set brightness(e) {
        this.uniforms.brightness = e;
    }
    get speed() {
        return this.uniforms.speed;
    }
    set speed(e) {
        this.uniforms.speed = e;
    }
    get radius() {
        return this.uniforms.radius;
    }
    set radius(e) {
        this.uniforms.radius = e;
    }
};
let $01f5d1427c3b1398$export$4c9c000eb13436fd = $01f5d1427c3b1398$var$n;
$01f5d1427c3b1398$export$4c9c000eb13436fd.defaults = {
    amplitude: 30,
    wavelength: 160,
    brightness: 1,
    speed: 500,
    radius: -1
};


/*!
 * @pixi/filter-simple-lightmap - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-simple-lightmap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $b7bc9c1c0464ad79$var$l = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $b7bc9c1c0464ad79$var$u = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform sampler2D uLightmap;
uniform vec4 filterArea;
uniform vec2 dimensions;
uniform vec4 ambientColor;
void main() {
    vec4 diffuseColor = texture2D(uSampler, vTextureCoord);
    vec2 lightCoord = (vTextureCoord * filterArea.xy) / dimensions;
    vec4 light = texture2D(uLightmap, lightCoord);
    vec3 ambient = ambientColor.rgb * ambientColor.a;
    vec3 intensity = ambient + light.rgb;
    vec3 finalColor = diffuseColor.rgb * intensity;
    gl_FragColor = vec4(finalColor, diffuseColor.a);
}
`;
class $b7bc9c1c0464ad79$export$b228cfd61a4fbcd2 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(o, e = 0, i = 1){
        super($b7bc9c1c0464ad79$var$l, $b7bc9c1c0464ad79$var$u), this._color = 0, this.uniforms.dimensions = new Float32Array(2), this.uniforms.ambientColor = new Float32Array([
            0,
            0,
            0,
            i
        ]), this.texture = o, this.color = e;
    }
    apply(o, e, i, s) {
        var r, t;
        this.uniforms.dimensions[0] = (r = e.filterFrame) == null ? void 0 : r.width, this.uniforms.dimensions[1] = (t = e.filterFrame) == null ? void 0 : t.height, o.applyFilter(this, e, i, s);
    }
    get texture() {
        return this.uniforms.uLightmap;
    }
    set texture(o) {
        this.uniforms.uLightmap = o;
    }
    set color(o) {
        const e = this.uniforms.ambientColor;
        typeof o == "number" ? ((0, $5d808cc4b6a3c326$exports).hex2rgb(o, e), this._color = o) : (e[0] = o[0], e[1] = o[1], e[2] = o[2], e[3] = o[3], this._color = (0, $5d808cc4b6a3c326$exports).rgb2hex(e));
    }
    get color() {
        return this._color;
    }
    get alpha() {
        return this.uniforms.ambientColor[3];
    }
    set alpha(o) {
        this.uniforms.ambientColor[3] = o;
    }
}


/*!
 * @pixi/filter-tilt-shift - v5.2.0
 * Compiled Tue, 28 Feb 2023 14:24:35 UTC
 *
 * @pixi/filter-tilt-shift is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $4181ec7b9c379973$var$m = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $4181ec7b9c379973$var$c = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float blur;
uniform float gradientBlur;
uniform vec2 start;
uniform vec2 end;
uniform vec2 delta;
uniform vec2 texSize;

float random(vec3 scale, float seed)
{
    return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);
}

void main(void)
{
    vec4 color = vec4(0.0);
    float total = 0.0;

    float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);
    vec2 normal = normalize(vec2(start.y - end.y, end.x - start.x));
    float radius = smoothstep(0.0, 1.0, abs(dot(vTextureCoord * texSize - start, normal)) / gradientBlur) * blur;

    for (float t = -30.0; t <= 30.0; t++)
    {
        float percent = (t + offset - 0.5) / 30.0;
        float weight = 1.0 - abs(percent);
        vec4 sample = texture2D(uSampler, vTextureCoord + delta / texSize * percent * radius);
        sample.rgb *= sample.a;
        color += sample * weight;
        total += weight;
    }

    color /= total;
    color.rgb /= color.a + 0.00001;

    gl_FragColor = color;
}
`;
class $4181ec7b9c379973$export$f5de69891142c6a6 extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(t){
        var r, i;
        super($4181ec7b9c379973$var$m, $4181ec7b9c379973$var$c), this.uniforms.blur = t.blur, this.uniforms.gradientBlur = t.gradientBlur, this.uniforms.start = (r = t.start) != null ? r : new (0, $88931fa1c0809be8$export$baf26146a414f24a)(0, window.innerHeight / 2), this.uniforms.end = (i = t.end) != null ? i : new (0, $88931fa1c0809be8$export$baf26146a414f24a)(600, window.innerHeight / 2), this.uniforms.delta = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(30, 30), this.uniforms.texSize = new (0, $88931fa1c0809be8$export$baf26146a414f24a)(window.innerWidth, window.innerHeight), this.updateDelta();
    }
    updateDelta() {
        this.uniforms.delta.x = 0, this.uniforms.delta.y = 0;
    }
    get blur() {
        return this.uniforms.blur;
    }
    set blur(t) {
        this.uniforms.blur = t;
    }
    get gradientBlur() {
        return this.uniforms.gradientBlur;
    }
    set gradientBlur(t) {
        this.uniforms.gradientBlur = t;
    }
    get start() {
        return this.uniforms.start;
    }
    set start(t) {
        this.uniforms.start = t, this.updateDelta();
    }
    get end() {
        return this.uniforms.end;
    }
    set end(t) {
        this.uniforms.end = t, this.updateDelta();
    }
}
class $4181ec7b9c379973$export$33f55e54d2d55afa extends $4181ec7b9c379973$export$f5de69891142c6a6 {
    updateDelta() {
        const t = this.uniforms.end.x - this.uniforms.start.x, r = this.uniforms.end.y - this.uniforms.start.y, i = Math.sqrt(t * t + r * r);
        this.uniforms.delta.x = t / i, this.uniforms.delta.y = r / i;
    }
}
class $4181ec7b9c379973$export$332945d2bec52bf5 extends $4181ec7b9c379973$export$f5de69891142c6a6 {
    updateDelta() {
        const t = this.uniforms.end.x - this.uniforms.start.x, r = this.uniforms.end.y - this.uniforms.start.y, i = Math.sqrt(t * t + r * r);
        this.uniforms.delta.x = -r / i, this.uniforms.delta.y = t / i;
    }
}
const $4181ec7b9c379973$var$d = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(e, t, r, i){
        super(), typeof e == "number" && ((0, $5d808cc4b6a3c326$exports).deprecation("5.3.0", "TiltShiftFilter constructor arguments is deprecated, use options."), e = {
            blur: e,
            gradientBlur: t,
            start: r,
            end: i
        }), e = Object.assign({}, $4181ec7b9c379973$var$d.defaults, e), this.tiltShiftXFilter = new $4181ec7b9c379973$export$33f55e54d2d55afa(e), this.tiltShiftYFilter = new $4181ec7b9c379973$export$332945d2bec52bf5(e);
    }
    apply(e, t, r, i) {
        const s = e.getFilterTexture();
        this.tiltShiftXFilter.apply(e, t, s, 1), this.tiltShiftYFilter.apply(e, s, r, i), e.returnFilterTexture(s);
    }
    get blur() {
        return this.tiltShiftXFilter.blur;
    }
    set blur(e) {
        this.tiltShiftXFilter.blur = this.tiltShiftYFilter.blur = e;
    }
    get gradientBlur() {
        return this.tiltShiftXFilter.gradientBlur;
    }
    set gradientBlur(e) {
        this.tiltShiftXFilter.gradientBlur = this.tiltShiftYFilter.gradientBlur = e;
    }
    get start() {
        return this.tiltShiftXFilter.start;
    }
    set start(e) {
        this.tiltShiftXFilter.start = this.tiltShiftYFilter.start = e;
    }
    get end() {
        return this.tiltShiftXFilter.end;
    }
    set end(e) {
        this.tiltShiftXFilter.end = this.tiltShiftYFilter.end = e;
    }
};
let $4181ec7b9c379973$export$b40f9a78a0b88d5d = $4181ec7b9c379973$var$d;
$4181ec7b9c379973$export$b40f9a78a0b88d5d.defaults = {
    blur: 100,
    gradientBlur: 600,
    start: void 0,
    end: void 0
};


/*!
 * @pixi/filter-twist - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-twist is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $a07ec27f4182bd9e$var$i = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $a07ec27f4182bd9e$var$a = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float radius;
uniform float angle;
uniform vec2 offset;
uniform vec4 filterArea;

vec2 mapCoord( vec2 coord )
{
    coord *= filterArea.xy;
    coord += filterArea.zw;

    return coord;
}

vec2 unmapCoord( vec2 coord )
{
    coord -= filterArea.zw;
    coord /= filterArea.xy;

    return coord;
}

vec2 twist(vec2 coord)
{
    coord -= offset;

    float dist = length(coord);

    if (dist < radius)
    {
        float ratioDist = (radius - dist) / radius;
        float angleMod = ratioDist * ratioDist * angle;
        float s = sin(angleMod);
        float c = cos(angleMod);
        coord = vec2(coord.x * c - coord.y * s, coord.x * s + coord.y * c);
    }

    coord += offset;

    return coord;
}

void main(void)
{

    vec2 coord = mapCoord(vTextureCoord);

    coord = twist(coord);

    coord = unmapCoord(coord);

    gl_FragColor = texture2D(uSampler, coord );

}
`;
const $a07ec27f4182bd9e$var$n = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(o){
        super($a07ec27f4182bd9e$var$i, $a07ec27f4182bd9e$var$a), Object.assign(this, $a07ec27f4182bd9e$var$n.defaults, o);
    }
    get offset() {
        return this.uniforms.offset;
    }
    set offset(o) {
        this.uniforms.offset = o;
    }
    get radius() {
        return this.uniforms.radius;
    }
    set radius(o) {
        this.uniforms.radius = o;
    }
    get angle() {
        return this.uniforms.angle;
    }
    set angle(o) {
        this.uniforms.angle = o;
    }
};
let $a07ec27f4182bd9e$export$d9119bded5bc57d4 = $a07ec27f4182bd9e$var$n;
$a07ec27f4182bd9e$export$d9119bded5bc57d4.defaults = {
    radius: 200,
    angle: 4,
    padding: 20,
    offset: new (0, $88931fa1c0809be8$export$baf26146a414f24a)
};


/*!
 * @pixi/filter-zoom-blur - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-zoom-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $4d56bf4c72b06f4e$var$l = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $4d56bf4c72b06f4e$var$u = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;

uniform vec2 uCenter;
uniform float uStrength;
uniform float uInnerRadius;
uniform float uRadius;

const float MAX_KERNEL_SIZE = \${maxKernelSize};

// author: http://byteblacksmith.com/improvements-to-the-canonical-one-liner-glsl-rand-for-opengl-es-2-0/
highp float rand(vec2 co, float seed) {
    const highp float a = 12.9898, b = 78.233, c = 43758.5453;
    highp float dt = dot(co + seed, vec2(a, b)), sn = mod(dt, 3.14159);
    return fract(sin(sn) * c + seed);
}

void main() {

    float minGradient = uInnerRadius * 0.3;
    float innerRadius = (uInnerRadius + minGradient * 0.5) / filterArea.x;

    float gradient = uRadius * 0.3;
    float radius = (uRadius - gradient * 0.5) / filterArea.x;

    float countLimit = MAX_KERNEL_SIZE;

    vec2 dir = vec2(uCenter.xy / filterArea.xy - vTextureCoord);
    float dist = length(vec2(dir.x, dir.y * filterArea.y / filterArea.x));

    float strength = uStrength;

    float delta = 0.0;
    float gap;
    if (dist < innerRadius) {
        delta = innerRadius - dist;
        gap = minGradient;
    } else if (radius >= 0.0 && dist > radius) { // radius < 0 means it's infinity
        delta = dist - radius;
        gap = gradient;
    }

    if (delta > 0.0) {
        float normalCount = gap / filterArea.x;
        delta = (normalCount - delta) / normalCount;
        countLimit *= delta;
        strength *= delta;
        if (countLimit < 1.0)
        {
            gl_FragColor = texture2D(uSampler, vTextureCoord);
            return;
        }
    }

    // randomize the lookup values to hide the fixed number of samples
    float offset = rand(vTextureCoord, 0.0);

    float total = 0.0;
    vec4 color = vec4(0.0);

    dir *= strength;

    for (float t = 0.0; t < MAX_KERNEL_SIZE; t++) {
        float percent = (t + offset) / MAX_KERNEL_SIZE;
        float weight = 4.0 * (percent - percent * percent);
        vec2 p = vTextureCoord + dir * percent;
        vec4 sample = texture2D(uSampler, p);

        // switch to pre-multiplied alpha to correctly blur transparent images
        // sample.rgb *= sample.a;

        color += sample * weight;
        total += weight;

        if (t > countLimit){
            break;
        }
    }

    color /= total;
    // switch back from pre-multiplied alpha
    // color.rgb /= color.a + 0.00001;

    gl_FragColor = color;
}
`, $4d56bf4c72b06f4e$var$i = Object.getOwnPropertySymbols, $4d56bf4c72b06f4e$var$d = Object.prototype.hasOwnProperty, $4d56bf4c72b06f4e$var$f = Object.prototype.propertyIsEnumerable, $4d56bf4c72b06f4e$var$c = (n, t)=>{
    var r = {};
    for(var e in n)$4d56bf4c72b06f4e$var$d.call(n, e) && t.indexOf(e) < 0 && (r[e] = n[e]);
    if (n != null && $4d56bf4c72b06f4e$var$i) for (var e of $4d56bf4c72b06f4e$var$i(n))t.indexOf(e) < 0 && $4d56bf4c72b06f4e$var$f.call(n, e) && (r[e] = n[e]);
    return r;
};
const $4d56bf4c72b06f4e$var$a = class extends (0, $fa5f1d0edfe7960b$export$ec91da630f36d5ea) {
    constructor(n){
        const t = Object.assign($4d56bf4c72b06f4e$var$a.defaults, n), { maxKernelSize: r  } = t, e = $4d56bf4c72b06f4e$var$c(t, [
            "maxKernelSize"
        ]);
        super($4d56bf4c72b06f4e$var$l, $4d56bf4c72b06f4e$var$u.replace("${maxKernelSize}", r.toFixed(1))), Object.assign(this, e);
    }
    get center() {
        return this.uniforms.uCenter;
    }
    set center(n) {
        this.uniforms.uCenter = n;
    }
    get strength() {
        return this.uniforms.uStrength;
    }
    set strength(n) {
        this.uniforms.uStrength = n;
    }
    get innerRadius() {
        return this.uniforms.uInnerRadius;
    }
    set innerRadius(n) {
        this.uniforms.uInnerRadius = n;
    }
    get radius() {
        return this.uniforms.uRadius;
    }
    set radius(n) {
        (n < 0 || n === 1 / 0) && (n = -1), this.uniforms.uRadius = n;
    }
};
let $4d56bf4c72b06f4e$export$f0d024e48d4abe00 = $4d56bf4c72b06f4e$var$a;
$4d56bf4c72b06f4e$export$f0d024e48d4abe00.defaults = {
    strength: .1,
    center: [
        0,
        0
    ],
    innerRadius: 0,
    radius: -1,
    maxKernelSize: 32
};






class $6f09b6f1265022b1$export$1a9e28883b426177 extends (0, $25c340da2a552010$export$c990932bfb0dc07b) {
    constructor(createItemContainerPayload){
        const { nid: nid , x: x , y: y , spriteId: spriteId , uniqueContainerId: uniqueContainerId , containerName: containerName , owningPlayerNid: owningPlayerNid  } = createItemContainerPayload;
        super(x, y);
        this.position = new (0, $2104f92cbe769454$exports.Vector)(0, 0);
        this.RenderedEntity = new (0, $823fbc2c4ae841df$export$42a852a2b6b56249)();
        this.hitboxGraphics = new (0, $680a5efca7e434a6$export$29d3e417456abdad)();
        this.defaultFilter = new (0, $70c55735395b082a$export$ea1238a366116160)(2, 0x8fffac);
        this.interactingWithFilter = new (0, $70c55735395b082a$export$ea1238a366116160)(3, 0xffffff);
        this.animationSpeed = 1 / 9;
        if (owningPlayerNid === Game.Renderer.MyLocalNonPredictedEntity?.nid) // console.log("got container creat msg for my gravestone!");
        this.RenderedEntity.alpha = 0;
        else if (containerName !== "Loot Chest") {
            this.RenderedEntity.alpha = 0;
            setTimeout(()=>{
                this.RenderedEntity.alpha = 1;
            }, 750);
        }
        this.uniqueContainerId = uniqueContainerId;
        this.nid = nid;
        this.x = x;
        this.y = y;
        this.RenderedEntity.x = x;
        this.RenderedEntity.y = y;
        this.RenderedEntity.zIndex = y + 10;
        // console.log("Using container name on client:", containerName);
        let spriteAnimationName;
        if (containerName === "Loot Chest") spriteAnimationName = "objects/stuff_box";
        else if (containerName === "Loot Drop") spriteAnimationName = "objects/stuff_bag";
        else spriteAnimationName = spriteId;
        const spriteAnimation = Game.Loader.GetAnimation(spriteAnimationName);
        // console.log("Using sprite name on client:", spriteAnimation);
        this.spriteFrames = new Array();
        for(let i = 0; i < spriteAnimation.length; i++)this.spriteFrames.push((0, $6ac4ad2139942545$export$5431306cf43de24a).from(spriteAnimation[i]));
        this.promptText = new (0, $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6)((0, $4bbe42650164e1e5$export$625550452a3fa3ec)("loot_prompt"), {
            fontFamily: "alagardmedium",
            fontSize: 64,
            fill: 0xffffff
        });
        this.promptText.scale.set(0.15);
        this.promptText.anchor.set(0.5, 0.5);
        this.promptText.y -= 25;
        this.promptText.alpha = 0;
        this.RenderedEntity.addChild(this.promptText);
        this.itemContainerSprite = new (0, $bef80d21b8b0b6b2$export$dae599798687ad3c)(this.spriteFrames);
        this.itemContainerSprite.scale.set(1);
        this.itemContainerSprite.anchor.set(0.5, 0.5);
        this.itemContainerSprite.animationSpeed = this.animationSpeed;
        this.itemContainerSprite.play();
        this.itemContainerSprite.filters = [
            this.defaultFilter
        ];
        this.RenderedEntity.addChild(this.itemContainerSprite);
        if ((0, $29cfa5e220cdc813$export$26773e6fd5f813db).DEBUG.DRAW_ITEM_CONTAINER_COLLIDER) {
            this.hitboxGraphics.lineStyle(2, 0x00ff00);
            this.hitboxGraphics.position.set(0, 0);
            this.hitboxGraphics.drawCircle(this.x, this.y, (0, $29cfa5e220cdc813$export$26773e6fd5f813db).ITEM_CONTAINER_COLLIDER_RADIUS);
            this.RenderedEntity.addChild(this.hitboxGraphics);
        }
    }
    _displayInteractionPrompt() {
        this.itemContainerSprite.filters = [
            this.interactingWithFilter
        ];
        this.promptText.alpha = 1;
    // console.log("Showing interaction prompt");
    }
    _hideInteractionPrompt() {
        this.itemContainerSprite.filters = [
            this.defaultFilter
        ];
        this.promptText.alpha = 0;
    // console.log("Hiding interaction prompt");
    }
    _updateInteractiveState() {
        const myEntity = Game.Renderer.MyLocalNonPredictedEntity;
        // TODO: very hacky but it works :shrug:
        if (myEntity) {
            const distanceToPlayer = (0, $276f03d77ac4b507$export$b59117efbc9c7af)(myEntity.position.x, myEntity.position.y, this.x, this.y);
            if (distanceToPlayer <= (0, $29cfa5e220cdc813$export$26773e6fd5f813db).ITEM_CONTAINER_COLLIDER_RADIUS) {
                myEntity.InteractingWithContainerOfId = this.uniqueContainerId;
                this._displayInteractionPrompt();
            } else this._hideInteractionPrompt();
        }
    }
    Update(deltaTime) {
        this._updateInteractiveState();
    }
}







var $da9ac0c1e14a159e$export$c370bc722bf6d86a;
(function(DebugShape) {
    DebugShape[DebugShape["Circle"] = 0] = "Circle";
    DebugShape[DebugShape["Rectangle"] = 1] = "Rectangle";
    DebugShape[DebugShape["Line"] = 2] = "Line";
})($da9ac0c1e14a159e$export$c370bc722bf6d86a || ($da9ac0c1e14a159e$export$c370bc722bf6d86a = {}));
class $da9ac0c1e14a159e$export$5fe85d85b4815454 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.myEnitityIdentified = false;
        this.regions = [];
        this.duplicatePopUpDelayInSeconds = 10;
        this.lastPoppedRegion = "";
        this.regionPopUpMetadata = new Map();
    }
    getSystemName() {
        return "RegionPopUps";
    }
    Initialize() {
        this.LogInfo("Ready!");
        for(let i = 0; i < (0, $f4842134c1afe84a$export$f34f76252d01f8d0).objects.length; i++){
            const region = (0, $f4842134c1afe84a$export$f34f76252d01f8d0).objects[i];
            const bounds = {
                name: region.name,
                minX: region.x,
                minY: region.y,
                maxX: region.x + region.width,
                maxY: region.y + region.height
            };
            this.regions.push(bounds);
        }
        Game.ListenForEvent("Bootstrap::MyServerSideEntityIsFullyCreatedLocally", (event)=>{
            // @ts-ignore
            const { myEntity: myEntity  } = event;
            this.myEntityRef = myEntity;
            this.myEnitityIdentified = true;
        });
    }
    SetMyEntityRef(entity) {
        this.myEntityRef = entity;
        this.myEnitityIdentified = true;
    }
    _myEntityIsInRegionBounds(region) {
        const myEntityPosition = this.myEntityRef.position;
        return myEntityPosition.x >= region.minX && myEntityPosition.x <= region.maxX && myEntityPosition.y >= region.minY && myEntityPosition.y <= region.maxY;
    }
    _itsThisPlayersFirstTimeInRegion(region) {
        const metadataForRegion = this.regionPopUpMetadata.get(region.name);
        if (metadataForRegion === undefined) return true;
        return false;
    }
    _popRegionNotification(regionName) {
        const regionMetadata = this.regionPopUpMetadata.get(regionName);
        regionMetadata.accumulator = 0;
        (0, $9b9fb0750f8f8ccb$export$41e17486540c90b)(regionName);
        // PopToast({
        //     message: `You are now in ${regionName}`,
        //     status: ToastStatuses.NONE
        // });
        this.lastPoppedRegion = regionName;
        setTimeout(()=>{
            (0, $9b9fb0750f8f8ccb$export$293a1596637cb649)();
        }, 3000);
    }
    Update(deltaTime) {
        if (this.myEnitityIdentified === false) return;
        let playerIsInARegion = false;
        let regionNameToPop = "";
        this.regions.forEach((region)=>{
            if (this._myEntityIsInRegionBounds(region)) {
                playerIsInARegion = true;
                regionNameToPop = region.name;
                if (this._itsThisPlayersFirstTimeInRegion(region)) {
                    this.regionPopUpMetadata.set(region.name, {
                        accumulator: this.duplicatePopUpDelayInSeconds
                    });
                    const newMetadata = this.regionPopUpMetadata.get(region.name);
                    newMetadata.accumulator += deltaTime;
                } else {
                    const existingMetadata = this.regionPopUpMetadata.get(region.name);
                    // @ts-ignore
                    existingMetadata.accumulator += deltaTime;
                }
            }
        });
        if (playerIsInARegion === false) this.lastPoppedRegion = "";
        const regionMetadata = this.regionPopUpMetadata.get(regionNameToPop);
        const shouldPopRegionNotification = playerIsInARegion && this.lastPoppedRegion !== regionNameToPop && regionMetadata.accumulator >= this.duplicatePopUpDelayInSeconds;
        if (this.lastPoppedRegion !== regionNameToPop && regionMetadata.accumulator <= this.duplicatePopUpDelayInSeconds) this.lastPoppedRegion = regionNameToPop;
        if (shouldPopRegionNotification) this._popRegionNotification(regionNameToPop);
    }
    Cleanup() {}
}


/* eslint-disable @typescript-eslint/naming-convention */ 



class $bda5325c4b994c2a$export$bb42b09f0cf4f18a extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        this.rewardedAdParent = document.getElementById("rewardedad-parent");
    }
    getSystemName() {
        return "Rewards";
    }
    Initialize() {
        this.LogInfo("Ready!");
    }
    _adInPlayIsntReady() {
        // @ts-ignore
        return window.aiptag === undefined;
    }
    _crazyGamesIsntReady() {
        // @ts-ignore
        return window.CrazyGames === undefined;
    }
    async VideoRewardComplete() {
        // console.warn("@@@ SDK Calling InsuranceComplete with sdk...");
        console.warn(ThirdPartySDK);
        // console.warn("@@@ SDK reward play complete!");
        this.rewardedAdParent.style.display = "none";
    }
    async PreGame() {
        // console.warn("@@@ SDK Showing pre insurance video reward with SDK...");
        console.warn(ThirdPartySDK);
        if (ThirdPartySDK === "adinplay") {
            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).FindingMatch);
            Game.EmitEvent("GameLifecycle::RunStarted");
        } else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK requesting INSURANCE ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying INSURANCE before retrying...");
                setTimeout(async ()=>{
                    this.PreGame();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            const callbacks = {
                adFinished: ()=>{
                    // console.warn("@@@ SDK End rewarded ad (callback)");
                    this.VideoRewardComplete();
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).FindingMatch);
                    Game.EmitEvent("GameLifecycle::RunStarted");
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                adError: (__error)=>{
                    // console.warn("@@@ SDK Error rewarded ad (callback)", error);
                    this.VideoRewardComplete();
                    (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).FindingMatch);
                    Game.EmitEvent("GameLifecycle::RunStarted");
                },
                adStarted: ()=>{
                // console.warn("@@@ SDK Start rewarded ad (callback)");
                }
            };
            //@ts-ignore
            window.CrazyGames.SDK.ad.requestAd("midgame", callbacks);
        } else {
            (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).FindingMatch);
            Game.EmitEvent("GameLifecycle::RunStarted");
        }
    }
    async PreInsurance(slot) {
        // console.warn("@@@ SDK Showing pre insurance video reward with SDK...");
        console.warn(ThirdPartySDK);
        if (ThirdPartySDK === "adinplay") {
            if (this._adInPlayIsntReady()) {
                // console.warn("@@@ SDK adinplay sdk isnt ready, delaying INSURANCE before retrying...");
                setTimeout(async ()=>{
                    this.PreInsurance(slot);
                }, 25);
                return;
            }
            this.rewardedAdParent.style.display = "flex";
            (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)(slot);
            // @ts-ignore
            window.aiptag.cmd.player.push(function() {
                // console.warn("@@@ SDK starting INSURANCE!");
                // @ts-ignore
                window.aiptag.adplayer.startPreRoll();
            });
        } else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK requesting INSURANCE ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying INSURANCE before retrying...");
                setTimeout(async ()=>{
                    this.PreInsurance(slot);
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            const callbacks = {
                adFinished: ()=>{
                    // console.warn("@@@ SDK End rewarded ad (callback)");
                    this.VideoRewardComplete();
                    (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)(slot);
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                adError: (__error)=>{
                    // console.warn("@@@ SDK Error rewarded ad (callback)", error);
                    this.VideoRewardComplete();
                    (0, $4a3136d799878a30$export$6b89521c3f482608)({
                        status: (0, $4a3136d799878a30$export$67897bded358b5bc).ERROR,
                        message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)("adblock_detected_failed_to_insure")
                    });
                },
                adStarted: ()=>{
                // console.warn("@@@ SDK Start rewarded ad (callback)");
                }
            };
            //@ts-ignore
            window.CrazyGames.SDK.ad.requestAd("rewarded", callbacks);
        } else (0, $9b9fb0750f8f8ccb$export$43c525c16a9d313)(slot);
    }
    async LoadingStarted() {
        if (ThirdPartySDK === "adinplay") ;
        else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK loading started for crazygames ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying LoadingStarted before retrying...");
                setTimeout(async ()=>{
                    this.LoadingStarted();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            try {
                // @ts-ignore
                const result = await window.CrazyGames.SDK.game.sdkGameLoadingStart(); // result is always undefined for sdkGameLoadingStart/Stop
                console.log("Game loading start triggered", result);
            } catch (e) {
                console.log("Game loading start error", e);
            }
        }
    }
    async LoadingComplete() {
        if (ThirdPartySDK === "adinplay") ;
        else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK loading completed for crazygames ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying LoadingComplete before retrying...");
                setTimeout(async ()=>{
                    this.LoadingComplete();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            try {
                // @ts-ignore
                const result = await window.CrazyGames.SDK.game.sdkGameLoadingStop(); // result is always undefined for sdkGameLoadingStart/Stop
                console.log("Game loading completed triggered", result);
            } catch (e) {
                console.log("Game loading completed error", e);
            }
        }
    }
    async GameplayStarted() {
        if (ThirdPartySDK === "adinplay") ;
        else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK gameplay started for crazygames ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying GameplayStarted before retrying...");
                setTimeout(async ()=>{
                    this.GameplayStarted();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            try {
                // @ts-ignore
                const result = await window.CrazyGames.SDK.game.gameplayStart(); // result is always undefined for gameplayStart/Stop
                console.log("Gameplay start triggered", result);
            } catch (e) {
                console.log("Gameplay start error", e);
            }
        }
    }
    async GameplayEnded() {
        if (ThirdPartySDK === "adinplay") ;
        else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK gameplay ended for crazygames ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying GameplayEnded before retrying...");
                setTimeout(async ()=>{
                    this.GameplayEnded();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            try {
                // @ts-ignore
                const result = await window.CrazyGames.SDK.game.gameplayStop(); // result is always undefined for gameplayStart/Stop
                console.log("Gameplay start triggered", result);
            } catch (e) {
                console.log("Gameplay start error", e);
            }
        }
    }
    async ShowMainMenuLeft() {
        if (ThirdPartySDK === "adinplay") {
            if (this._adInPlayIsntReady()) {
                // console.warn("@@@ SDK adinplay sdk isnt ready, delaying ShowMainMenuLeft before retrying...");
                setTimeout(async ()=>{
                    this.ShowMainMenuLeft();
                }, 25);
                return;
            }
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;
            const screenSizeIsSufficientlyLarge = screenWidth >= 578 && screenHeight >= 605;
            if (screenSizeIsSufficientlyLarge) // @ts-ignore
            window.aiptag.cmd.display.push(function() {
                // @ts-ignore
                aipDisplayTag.display("pvpz-io_160x600_3");
            });
        } else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK requesting menu left banner ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying ShowMainMenuLeft before retrying...");
                setTimeout(async ()=>{
                    this.ShowMainMenuLeft();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            try {
                // @ts-ignore
                const result = await window.CrazyGames.SDK.banner.requestResponsiveBanner("pvpz-io_160x600_3");
            // console.warn("@@@ SDK End request responsive banner", result); // result is always undefined when requesting banners
            } catch (e) {
            // console.warn("@@@ SDK Error on request responsive banner", e);
            }
        }
    }
    async ShowMainMenuRight() {
        if (ThirdPartySDK === "adinplay") {
            // @ts-ignore
            if (this._adInPlayIsntReady()) {
                // console.warn("@@@ SDK adinplay sdk isnt ready, delaying ShowMainMenuRight before retrying...");
                setTimeout(async ()=>{
                    this.ShowMainMenuRight();
                }, 25);
                return;
            }
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;
            const screenSizeIsSufficientlyLarge = screenWidth >= 578 && screenHeight >= 605;
            if (screenSizeIsSufficientlyLarge) // @ts-ignore
            window.aiptag.cmd.display.push(function() {
                // @ts-ignore
                aipDisplayTag.display("pvpz-io_160x600_4");
            });
        } else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK requesting menu right banner ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying ShowMainMenuRight before retrying...");
                setTimeout(async ()=>{
                    this.ShowMainMenuRight();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            try {
                // @ts-ignore
                const result = await window.CrazyGames.SDK.banner.requestResponsiveBanner("pvpz-io_160x600_4");
            // console.warn("@@@ SDK End request responsive banner", result); // result is always undefined when requesting banners
            } catch (e) {
            // console.warn("@@@ SDK Error on request responsive banner", e);
            }
        }
    }
    async Congratulate() {}
    async ShowInGameLeft() {
        // console.warn("@@@ SDK Showing in game left with sdk...");
        console.warn(ThirdPartySDK);
        if (ThirdPartySDK === "adinplay") {
            if (this._adInPlayIsntReady()) {
                // console.warn("@@@ SDK adinplay sdk isnt ready, delaying ShowInGameLeft before retrying...");
                setTimeout(async ()=>{
                    this.ShowInGameLeft();
                }, 25);
                return;
            }
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;
            const screenSizeIsSufficientlyLarge = screenWidth >= 578 && screenHeight >= 605;
            if (screenSizeIsSufficientlyLarge) // @ts-ignore
            window.aiptag.cmd.display.push(function() {
                // @ts-ignore
                aipDisplayTag.display("pvpz-io_160x600_1");
            });
        } else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK requesting menu left banner ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying ShowInGameLeft before retrying...");
                setTimeout(async ()=>{
                    this.ShowInGameLeft();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            const screenHeight = window.innerHeight;
            const screenSizeIsSufficientlyLarge = screenHeight >= 601;
            try {
                if (screenSizeIsSufficientlyLarge) {
                    // @ts-ignore
                    const result = await window.CrazyGames.SDK.banner.requestResponsiveBanner("pvpz-io_160x600_1");
                // console.warn("@@@ SDK End request responsive banner", result); // result is always undefined when requesting banners
                }
            } catch (e) {
            // console.warn("@@@ SDK Error on request responsive banner", e);
            }
        }
    }
    async ShowInGameRight() {
        // console.warn("@@@ SDK Showing in game right with sdk...");
        console.warn(ThirdPartySDK);
        if (ThirdPartySDK === "adinplay") {
            if (this._adInPlayIsntReady()) {
                // console.warn("@@@ SDK adinplay sdk isnt ready, delaying ShowInGameRight before retrying...");
                setTimeout(async ()=>{
                    this.ShowInGameRight();
                }, 25);
                return;
            }
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;
            const screenSizeIsSufficientlyLarge = screenWidth >= 578 && screenHeight >= 605;
            if (screenSizeIsSufficientlyLarge) // @ts-ignore
            window.aiptag.cmd.display.push(function() {
                // @ts-ignore
                aipDisplayTag.display("pvpz-io_160x600_2");
            });
        } else if (ThirdPartySDK === "crazygames") {
            // console.warn("@@@ SDK requesting menu left banner ...");
            if (this._crazyGamesIsntReady()) {
                // console.warn("@@@ SDK crazygames sdk isnt ready, delaying ShowInGameRight before retrying...");
                setTimeout(async ()=>{
                    this.ShowInGameRight();
                }, 25);
                return;
            }
            // @ts-ignore
            window.CrazyGames.SDK.environment = "crazygames";
            const screenHeight = window.innerHeight;
            const screenSizeIsSufficientlyLarge = screenHeight >= 601;
            try {
                if (screenSizeIsSufficientlyLarge) {
                    // @ts-ignore
                    const result = await window.CrazyGames.SDK.banner.requestResponsiveBanner("pvpz-io_160x600_2");
                // console.warn("@@@ SDK End request responsive banner", result); // result is always undefined when requesting banners
                }
            } catch (e) {
            // console.warn("@@@ SDK Error on request responsive banner", e);
            }
        }
    }
    Update(__deltaTime) {}
    Cleanup() {}
}




// // @ts-ignore
// window.GameAnalytics = gameanalytics.GameAnalytics;
// gameanalytics.GameAnalytics("setEnabledInfoLog", true);
// gameanalytics.GameAnalytics("setEnabledVerboseLog", true);
// gameanalytics.GameAnalytics("setCustomDimension01", "web");
// gameanalytics.GameAnalytics("configureBuild", GAME_VERSION);
// gameanalytics.GameAnalytics("initialize", "e28f3b734b8af6d994e7cc0375ad51e2", "35c19802b12c713726dd7ac80e5642ab698fac01");
console.log("-- USING ENV VARS --");
console.log("development");
console.log("https://dev-api.trigonometryexplained.com");
console.log("https://discord.com/api/oauth2/authorize?client_id=1102622111014588427&redirect_uri=https%3A%2F%2Fdev-api.trigonometryexplained.com%2Fpvpz%2Fauth%2Fdiscord%2Fcallback&response_type=code&scope=email%20identify");
console.log("https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&response_type=code&redirect_uri=https://dev-api.trigonometryexplained.com/pvpz/auth/google/callback&client_id=986076822105-r63tqcbrrob73lich2svbbglhvu49v3h.apps.googleusercontent.com");
console.log("https://www.facebook.com/v16.0/dialog/oauth?client_id=1256171914985296&redirect_uri=https://dev-api.trigonometryexplained.com/pvpz/auth/facebook/callback&response_type=code&scope=email");
const $be0ca05914820fc6$var$gameContainer = document.getElementById("game-container");
const $be0ca05914820fc6$var$dragHandle = document.getElementById("drag-handle");
if ((0, $6ece21d96ecc593d$export$c85ba824665b708f).DEBUG.ENABLE_EASY_RESIZABLE_GAME_CONTAINER) {
    $be0ca05914820fc6$var$gameContainer.style.width = `${(0, $6ece21d96ecc593d$export$c85ba824665b708f).DEBUG.DEFAULT_GAME_VIEWPORT_WIDTH_IN_RESIZABLE_MODE}px`;
    $be0ca05914820fc6$var$gameContainer.style.height = `${(0, $6ece21d96ecc593d$export$c85ba824665b708f).DEBUG.DEFAULT_GAME_VIEWPORT_HEIGHT_IN_RESIZABLE_MODE}px`;
    $be0ca05914820fc6$var$gameContainer.style.borderRadius = "3px";
    $be0ca05914820fc6$var$dragHandle.style.display = "flex";
} else {
    $be0ca05914820fc6$var$gameContainer.style.height = "100%";
    $be0ca05914820fc6$var$gameContainer.style.width = "100%";
    $be0ca05914820fc6$var$gameContainer.style.border = "none";
    $be0ca05914820fc6$var$gameContainer.style.borderRadius = "0";
    $be0ca05914820fc6$var$dragHandle.style.display = "none";
}
globalThis.currentFrameNumber = 0;
class $be0ca05914820fc6$export$38bc80eba028b399 extends (0, $d5fe2eff33d101be$export$5d53140180d567a1) {
    constructor(){
        super();
        // state
        this.lastUpdateTime = 0;
        this.isRunning = false;
        this.currentFrame = 0;
        this.entities = new Set();
        this.myEntityNid = -1;
        this.setLogLevel((0, $5f41b2ce7dbc35bf$export$243e62d78d3b544d).VERBOSE);
        window.Game = this;
        // Set up root event dispatcher
        this.eventDispatcher = new (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports)))();
        // Construct each child system/manager
        this.identity = new (0, $0d9696dfcdfbca4b$export$21753bcb649b7783)();
        this.Renderer = new (0, $21f6279970269d97$export$f4e85fe081cb5cf0)();
        this.Input = new (0, $9bbbba98c8da0b07$export$ebed6576fc29bd3e)();
        this.Resizer = new (0, $831f1ac66545ac96$export$8a8d879dc6224ad5)();
        this.predictor = new (0, $fe9e2d3ae8505e4b$export$8ccb38c26a8ab5aa)();
        this.Netcode = new (0, $7a59c25e600d6438$export$44a6ae0ecea6459a)(this.predictor);
        this.Debug = new (0, $5193b59038b4228e$export$8c72b781155167e0)();
        this.ui = new (0, $0729739820ea5e30$export$618b19ebc933e619)();
        this.Collision = new (0, $63b908b83aafc686$export$52ef19685b59c674)();
        this.Loader = new (0, $faff1e9a6587b391$export$b6a607d5b0e013e9)();
        this.regionPopUpManager = new (0, $da9ac0c1e14a159e$export$5fe85d85b4815454)();
        this.Rewards = new (0, $bda5325c4b994c2a$export$bb42b09f0cf4f18a)();
        Game.ListenForEvent("GameLifecycle::RunStarted", ()=>{
            this.FindAndConnectToServer();
        });
        Game.ListenForEvent("Debug::SkipMenu", ()=>{
            this.FindAndConnectToServer();
        });
    }
    async FindAndConnectToServer() {
        const userType = this.identity.GetUserType();
        if (userType !== (0, $69a172d21320641e$export$8436e53e45ffe15b).Anonymous && userType !== (0, $69a172d21320641e$export$8436e53e45ffe15b).Registered) {
            (0, $9b9fb0750f8f8ccb$export$659811ec5a629f27)("Oops, something went wrong!");
            return;
        }
        try {
            const startRunResult = await (0, $155c80569fd4a71a$export$a9baae562ac2dc6a)(userType);
            if (startRunResult.runDepartureSuccessful) {
                const { connectionToken: connectionToken , serverAddress: serverAddress  } = startRunResult;
                const gameClientVersion = (0, $3dc337423aed9780$export$9badeb9b04b4b71c);
                this.InitializeGame(serverAddress, connectionToken, gameClientVersion);
            } else {
                console.log("run departure failed, you'd be abandoning your current run! do you want to do that???");
                (0, $9b9fb0750f8f8ccb$export$e72b59a15fc1f76)((0, $9b9fb0750f8f8ccb$export$b714373eb9ab036b).RunInProgress);
            }
        } catch (e) {
            setTimeout(()=>{
                if (e instanceof (0, $8ae692c0d811c501$export$c7df658ddd676e46)) (0, $9b9fb0750f8f8ccb$export$105985ba4db5af3f)("Servers Offline", "The servers are offline right now, we're releasing a new game patch! Check back in a few minutes.");
                else if (e instanceof (0, $8ae692c0d811c501$export$d43b4070434a7c5e)) (0, $9b9fb0750f8f8ccb$export$105985ba4db5af3f)("Servers Full", "The servers are full right now! Check back in a few minutes.");
                else {
                    console.error("Unknown API Error", e);
                    (0, $9b9fb0750f8f8ccb$export$105985ba4db5af3f)("Matchmaking Error", "Something went wrong starting your run! Check back in a few minutes.");
                }
            }, 3000);
        }
    }
    EmitEvent(eventName, payload = {}) {
        this.LogVerbose(`Emitting event: ${eventName}`);
        this.eventDispatcher.emit(eventName, payload);
    }
    ListenForEvent(eventName, callback) {
        this.eventDispatcher.on(eventName, callback);
    }
    StopListeningForEvent(eventName, callback) {
        this.eventDispatcher.off(eventName, callback);
    }
    Initialize() {
        throw new Error("Do not use!");
    }
    InitializeUI() {
        this.Loader.Initialize();
        this.identity.Initialize();
        this.Resizer.Initialize();
        this.Debug.Initialize();
        this.ui.Initialize();
        this.Rewards.Initialize();
    }
    InitializeGame(serverAddress, connectionToken, gameClientVersion) {
        this.Renderer.Initialize();
        this.Input.Initialize();
        this.Collision.Initialize();
        this.regionPopUpManager.Initialize();
        // Connect to the server!
        this.Netcode.Connect(serverAddress, connectionToken, gameClientVersion);
    }
    Cleanup() {
        throw new Error("Method not implemented.");
    }
    Start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.lastUpdateTime = performance.now();
        requestAnimationFrame((time)=>this.Update(time));
    }
    GetEntityByNid(nid) {
        for (const entity of this.entities){
            if (entity.nid === nid) return entity;
        }
    }
    LootItem(itemContainerId, item) {
        // console.warn(` @@@ Player is looting item ${Item[item]} out of container ${itemContainerId}`);
        this.Netcode.SendLootItemCommand(itemContainerId, item);
    }
    getSystemName() {
        return "Client";
    }
    Update(currentTime) {
        try {
            if (!this.isRunning) return;
            this.currentFrame++;
            globalThis.currentFrameNumber = this.currentFrame;
            const currentTimestamp = Date.now();
            const deltaTimeInMilliseconds = currentTime - this.lastUpdateTime;
            const deltaTimeInSeconds = deltaTimeInMilliseconds / 1000;
            this.lastUpdateTime = currentTime;
            for (const e of this.entities)e.Update(deltaTimeInSeconds, currentTimestamp);
            this.Renderer.Update(deltaTimeInSeconds);
            this.Netcode.Update(deltaTimeInSeconds);
            this.Input.Update(deltaTimeInSeconds);
            this.Debug.Update(deltaTimeInSeconds);
            this.predictor.Update(deltaTimeInSeconds, currentTimestamp);
            this.Resizer.Update(deltaTimeInMilliseconds);
            this.Collision.Update(deltaTimeInSeconds);
            this.regionPopUpManager.Update(deltaTimeInSeconds);
            requestAnimationFrame((time)=>this.Update(time));
        } catch (e) {
            console.error("Caught error in game client update loop!");
            console.error(e);
        }
    }
    SpectateKiller() {
        this.Netcode.SendSpectateKillerCommand();
    }
    ProcessMessage(message) {
        // this.LogInfo('Nengi server sent us a message:');
        // this.LogInfo('\n' + JSON.stringify(message, null, 2));
        switch(message.ntype){
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).IdentityMessage:
                this.myEntityNid = message.myId;
                this.LogInfo(`Self identified as nid: ${this.myEntityNid}`);
                Game.EmitEvent("Bootstrap::MyEntitiesNidIsKnown", message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlayPfxAtLocationMessage:
                const { x: x , y: y , scale: scale , pfxType: pfxType  } = message;
                Game.Renderer.PlayOneOffPfx(x, y, pfxType, scale, 1);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).LeaderboardStateMessage:
                const stateString = message.leaderboardState;
                (0, $9b9fb0750f8f8ccb$export$6a80ff18a0ca69a6)(stateString);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).YouDiedMessage:
                Game.Rewards.GameplayEnded();
                setTimeout(()=>{
                    const { killedBy: killedBy , runDurationInSeconds: runDurationInSeconds , goldLost: goldLost  } = message;
                    (0, $9b9fb0750f8f8ccb$export$8c55cea1fa2cfb67)(killedBy, runDurationInSeconds, goldLost);
                    setTimeout(()=>{
                        (0, $9b9fb0750f8f8ccb$export$7fe418107821b4c2)();
                    }, 5500);
                }, 2500);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlaceholderPingAckMessage:
                this.Netcode.ReceivedPingAck();
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).OpenedOrUpdatedItemContainerMessage:
                // console.log("got container msg:", message);
                (0, $9b9fb0750f8f8ccb$export$33937c63fbdea3c9)(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).SuccessfullyExtractedMessage:
                const { runDurationInSeconds: runDuration , goldEarned: goldEarned  } = message;
                Game.Rewards.GameplayEnded();
                setTimeout(()=>{
                    (0, $9b9fb0750f8f8ccb$export$428337d08d832f8d)(runDuration, goldEarned);
                    setTimeout(()=>{
                        (0, $9b9fb0750f8f8ccb$export$8b4f61df848724e7)();
                    }, 4000);
                }, 1250);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).DrawDebugShapeMessage:
                const { x: debugX , y: debugY , width: width , height: height , destX: destX , destY: destY , destroyAfterSeconds: destroyAfterSeconds , radius: radius , shape: shape  } = message;
                this.Debug.DrawDebugShape(debugX, debugY, shape, {
                    width: width,
                    height: height,
                    destX: destX,
                    destY: destY,
                    destroyAfterSeconds: destroyAfterSeconds,
                    radius: radius
                });
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PopToastOfArbitraryStringMessage:
                (0, $4a3136d799878a30$export$6b89521c3f482608)({
                    status: (0, $4a3136d799878a30$export$67897bded358b5bc).NONE,
                    message: (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(message.message)
                });
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).HideItemContainerMessage:
                (0, $9b9fb0750f8f8ccb$export$ed7d33d6afbe02b1)();
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).LoadoutFromServerMessage:
                (0, $9b9fb0750f8f8ccb$export$3995aacaa8581db8)(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ItemsLootedOnRunUpdatedMessage:
                (0, $9b9fb0750f8f8ccb$export$e73dafe305ab20de)(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ServerEventFeedBossSpawnMessage:
                this._processServerEventFeedBossSpawnMessage(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ServerEventFeedBossUnderAttackMessage:
                this._processServerEventFeedBossUnderAttackMessage(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ServerEventFeedExtractionStartedMessage:
                this._processServerEventFeedExtractionStartedMessage(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ServerEventFeedExtractionSuccessfulMessage:
                this._processServerEventFeedExtractionSuccessfulMessage(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ServerEventFeedPvPKillMessage:
                this._processServerEventFeedPvPKillMessage(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ServerEventFeedLootMessage:
                this._processServerEventFeedLootMessage(message);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).SpectateEntityOfNidMessage:
                const { nidOfEntityToFollow: nidOfEntityToFollow , entityName: entityName  } = message;
                (0, $9b9fb0750f8f8ccb$export$3bab0bc3cf5490e6)(entityName);
                const entity = this.GetEntityByNid(nidOfEntityToFollow);
                if (entity !== undefined) // @ts-ignore
                this.Renderer.StartFollowing(nidOfEntityToFollow, entity);
                break;
            default:
                this.LogWarning(`Unhandled message type: ${(0, $282dc2f79e0204c8$export$f7cab339749a57d7)[message.ntype]}!`);
                break;
        }
    }
    _processServerEventFeedBossUnderAttackMessage(message) {
        const { bossName: bossName , locationX: locationX , locationY: locationY  } = message;
        // console.warn("@@@ calling UI_AddServerEventToFeed for event type: BossAttack");
        (0, $9b9fb0750f8f8ccb$export$4311e1a2433001ae)({
            id: Math.floor(Math.random() * 10000),
            type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).BossAttack,
            bossName: bossName,
            locationX: locationX,
            locationY: locationY
        });
    }
    _processServerEventFeedExtractionStartedMessage(message) {
        const { playerName: playerName , locationX: locationX , locationY: locationY  } = message;
        // console.warn("@@@ calling UI_AddServerEventToFeed for event type: Extraction Started");
        (0, $9b9fb0750f8f8ccb$export$4311e1a2433001ae)({
            id: Math.floor(Math.random() * 10000),
            type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).ExtractionStarted,
            playerName: playerName,
            locationX: locationX,
            locationY: locationY
        });
    }
    _processServerEventFeedExtractionSuccessfulMessage(message) {
        const { playerName: playerName , locationX: locationX , locationY: locationY  } = message;
        // console.warn("@@@ calling UI_AddServerEventToFeed for event type: Extraction Successful");
        (0, $9b9fb0750f8f8ccb$export$4311e1a2433001ae)({
            id: Math.floor(Math.random() * 10000),
            type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).ExtractionSuccessful,
            playerName: playerName,
            locationX: locationX,
            locationY: locationY
        });
    }
    _processServerEventFeedPvPKillMessage(message) {
        const { killer: killer , victim: victim , locationX: locationX , locationY: locationY  } = message;
        // console.warn("@@@ calling UI_AddServerEventToFeed for event type: PvPKill");
        (0, $9b9fb0750f8f8ccb$export$4311e1a2433001ae)({
            id: Math.floor(Math.random() * 10000),
            type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).Kill,
            killer: killer,
            victim: victim,
            locationX: locationX,
            locationY: locationY
        });
    }
    _processServerEventFeedLootMessage(message) {
        const { playerName: playerName , rarity: rarity , locationX: locationX , locationY: locationY  } = message;
        // console.warn("@@@ calling UI_AddServerEventToFeed for event type: Loot");
        (0, $9b9fb0750f8f8ccb$export$4311e1a2433001ae)({
            id: Math.floor(Math.random() * 10000),
            type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).Loot,
            username: playerName,
            rarity: rarity,
            locationX: locationX,
            locationY: locationY
        });
    }
    _processServerEventFeedBossSpawnMessage(message) {
        const { bossName: bossName , locationX: locationX , locationY: locationY  } = message;
        // console.warn("@@@ calling UI_AddServerEventToFeed for event type: BossSpawn");
        (0, $9b9fb0750f8f8ccb$export$4311e1a2433001ae)({
            id: Math.floor(Math.random() * 10000),
            type: (0, $69a172d21320641e$export$3b9c5fedfb1fdc77).BossSpawn,
            bossName: bossName,
            locationX: locationX,
            locationY: locationY
        });
    }
    GetLocationNameFromXY(x, y) {
        let locationName = "region__wilderness";
        for(let i = 0; i < (0, $f4842134c1afe84a$export$f34f76252d01f8d0).objects.length; i++){
            const region = (0, $f4842134c1afe84a$export$f34f76252d01f8d0).objects[i];
            if (x >= region.x && x <= region.x + region.width && y >= region.y && y <= region.y + region.height) locationName = region.name;
        }
        return (0, $4bbe42650164e1e5$export$625550452a3fa3ec)(locationName);
    }
    _addPlayerEntity(createPlayerPayload) {
        const createdEntity = new (0, $9963602032b82d57$export$75d5526a7020db)(createPlayerPayload);
        this.Collision.AddEntity(createdEntity);
        return createdEntity;
    }
    _addProjectileEntity(createProjectilePayload) {
        const projectileIsOwnedByMyEntity = createProjectilePayload.owningEntityNid === this.myEntityNid;
        const createdEntity = new (0, $76f9cef755a397a1$export$722aee2580a3ce21)(createProjectilePayload, projectileIsOwnedByMyEntity, 1, 1, 1);
        return createdEntity;
    }
    _addDebugGridCellEntity(createDebugGridCellPayload) {
        return new (0, $143e9eb050e49bf0$export$bcbbb686a6fc093)(createDebugGridCellPayload);
    }
    _addAIEntity(createAIEntityPayload) {
        const createdEntity = new (0, $e182978755a91fde$export$960dc136cdb74743)(createAIEntityPayload);
        this.Collision.AddEntity(createdEntity);
        return createdEntity;
    }
    _addExtractionPointEntity(createExtractionPointPayload) {
        return new (0, $f2e4e53c05f9bf48$export$f3d3dada4f7adfe6)(createExtractionPointPayload);
    }
    _addItemContainerEntity(createItemContainerPayload) {
        const createdEntity = new (0, $6f09b6f1265022b1$export$1a9e28883b426177)(createItemContainerPayload);
        this.Collision.AddEntity(createdEntity);
        return createdEntity;
    }
    AddEntity(createEntityPayload) {
        let instantiatedEntity;
        switch(createEntityPayload.ntype){
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).PlayerEntity:
                instantiatedEntity = this._addPlayerEntity(createEntityPayload);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ProjectileEntity:
                instantiatedEntity = this._addProjectileEntity(createEntityPayload);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).DebugGridCellEntity:
                instantiatedEntity = this._addDebugGridCellEntity(createEntityPayload);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ExtractionPointEntity:
                instantiatedEntity = this._addExtractionPointEntity(createEntityPayload);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).AIEntity:
                instantiatedEntity = this._addAIEntity(createEntityPayload);
                break;
            case (0, $282dc2f79e0204c8$export$f7cab339749a57d7).ItemContainerEntity:
                instantiatedEntity = this._addItemContainerEntity(createEntityPayload);
                break;
            default:
                this.LogError("Server sent us an entity create for an entity of type: UNKNOWN");
                break;
        }
        if (instantiatedEntity === undefined) {
            this.LogError("instantiatedEntity is undefined, aborting entity creation");
            return;
        }
        this.Renderer.AddRenderedEntity(instantiatedEntity);
        this.entities.add(instantiatedEntity);
    }
    DeleteEntity(nid) {
        let foundEntity = undefined;
        for (const entity of this.entities)if (entity.nid === nid) foundEntity = entity;
        if (foundEntity === undefined) {
            this.LogError(`Received delete event for an entity that our client doesnt think exists??? ${nid}`);
            return;
        }
        if ("HitboxCollider" in foundEntity && "currentCollisionGridCell" in foundEntity) // console.warn('@@@ Found HitboxCollider and currentCollisionGridCell in entity, removing from collision system');
        // @ts-ignore TODO: hack
        // console.log("removingg entity from collision system", foundEntity);
        // @ts-ignore TODO: hack
        this.Collision.RemoveEntity(foundEntity);
        this.entities.delete(foundEntity);
        // @ts-ignore
        this.Renderer.RemoveRenderedEntity(foundEntity);
        // @ts-ignore
        foundEntity.RenderedEntity.destroy();
    }
    UpdateEntity(updateEntityPayload) {
        try {
            const { nid: nid , prop: prop , value: value  } = updateEntityPayload;
            let foundEntity = undefined;
            for (const entity of this.entities)if (entity.nid === nid) foundEntity = entity;
            if (foundEntity === undefined) {
                this.LogWarning(`Received update event for an entity that our client doesnt think exists??? ${nid}`);
                return;
            }
            // TODO this makes typescript unhappy but its necessary in this case right??
            // @ts-ignore
            foundEntity[prop] = value;
            // Selectively apply server-side updates to our local predicted player
            if ((0, $b68713d61a9875e5$export$2c4ca88fbca02fe7).ENABLE_PREDICTION) {
                if (nid === this.myEntityNid) {
                    const myEntity = this.predictor.GetPredictedEntity();
                    // TODO: hack, come up with hook system for non-predicted updates to our entity like this
                    if (myEntity !== undefined) {
                        if ((0, $684d742272b6c23f$export$69c0d78807786d95).WhitelistedReplicatedProperties.includes(prop)) // @ts-ignore
                        myEntity[prop] = value;
                    }
                }
            }
        } catch (e) {
            console.error("Caught error in update entity!");
            console.error(e);
        }
    }
}
new $be0ca05914820fc6$export$38bc80eba028b399();
Game.InitializeUI();
Game.Start();


//# sourceMappingURL=index.edfc9490.js.map
